
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6THZ6", function(module, exports) {

$parcel$export(module.exports, "Application", () => EN);

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $5059ff85b35ef8d7$require$Buffer = $6ZWSX.Buffer;
var ON = Object.create;
var Sg = Object.defineProperty;
var IN = Object.getOwnPropertyDescriptor;
var RN = Object.getOwnPropertyNames;
var LN = Object.getPrototypeOf, BN = Object.prototype.hasOwnProperty;
var NN = (n1, t, e)=>t in n1 ? Sg(n1, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : n1[t] = e;
var en = (n1, t)=>()=>(t || n1((t = {
            exports: {}
        }).exports, t), t.exports), FN = (n1, t)=>{
    for(var e in t)Sg(n1, e, {
        get: t[e],
        enumerable: !0
    });
}, kN = (n1, t, e, r)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let i of RN(t))!BN.call(n1, i) && i !== e && Sg(n1, i, {
        get: ()=>t[i],
        enumerable: !(r = IN(t, i)) || r.enumerable
    });
    return n1;
};
var Pi = (n1, t, e)=>(e = n1 != null ? ON(LN(n1)) : {}, kN(t || !n1 || !n1.__esModule ? Sg(e, "default", {
        value: n1,
        enumerable: !0
    }) : e, n1));
var Di = (n1, t, e)=>(NN(n1, typeof t != "symbol" ? t + "" : t, e), e);
var uO = en((B1, cO)=>{
    (function(n1, t) {
        typeof B1 == "object" ? cO.exports = t() : typeof define == "function" && define.amd ? define(t) : n1.Alea = t();
    })(B1, function() {
        "use strict";
        return n1.importState = function(e) {
            var r = new n1;
            return r.importState(e), r;
        }, n1;
        function n1() {
            return function(e) {
                var r = 0, i = 0, s = 0, o = 1;
                e.length == 0 && (e = [
                    +new Date
                ]);
                var a = t();
                r = a(" "), i = a(" "), s = a(" ");
                for(var l = 0; l < e.length; l++)r -= a(e[l]), r < 0 && (r += 1), i -= a(e[l]), i < 0 && (i += 1), s -= a(e[l]), s < 0 && (s += 1);
                a = null;
                var u = function() {
                    var c = 2091639 * r + o * 23283064365386963e-26;
                    return r = i, i = s, s = c - (o = c | 0);
                };
                return u.next = u, u.uint32 = function() {
                    return u() * 4294967296;
                }, u.fract53 = function() {
                    return u() + (u() * 2097152 | 0) * 11102230246251565e-32;
                }, u.version = "Alea 0.9", u.args = e, u.exportState = function() {
                    return [
                        r,
                        i,
                        s,
                        o
                    ];
                }, u.importState = function(c) {
                    r = +c[0] || 0, i = +c[1] || 0, s = +c[2] || 0, o = +c[3] || 0;
                }, u;
            }(Array.prototype.slice.call(arguments));
        }
        function t() {
            var e = 4022871197, r = function(i) {
                i = i.toString();
                for(var s = 0; s < i.length; s++){
                    e += i.charCodeAt(s);
                    var o = .02519603282416938 * e;
                    e = o >>> 0, o -= e, o *= e, e = o >>> 0, o -= e, e += o * 4294967296;
                }
                return (e >>> 0) * 23283064365386963e-26;
            };
            return r.version = "Mash 0.9", r;
        }
    });
});
var F1 = en((f0, pO)=>{
    (function(n1, t) {
        typeof f0 == "object" && typeof pO < "u" ? t(f0) : typeof define == "function" && define.amd ? define([
            "exports"
        ], t) : t((n1 = typeof globalThis < "u" ? globalThis : n1 || self).SVDJS = {});
    })(f0, function(n1) {
        "use strict";
        n1.SVD = function(t, e, r, i, s) {
            if (e = e === void 0 || e, r = r === void 0 || r, s = 1e-64 / (i = i || Math.pow(2, -52)), !t) throw new TypeError("Matrix a is not defined");
            var o, a, l, u, c, d, h, f, p, m, g, y, v = t[0].length, x = t.length;
            if (x < v) throw new TypeError("Invalid matrix: m < n");
            for(var S = [], w = [], A = [], E = e === "f" ? x : v, b = m = h = 0; b < x; b++)w[b] = new Array(E).fill(0);
            for(b = 0; b < v; b++)A[b] = new Array(v).fill(0);
            var T, M = new Array(v).fill(0);
            for(b = 0; b < x; b++)for(o = 0; o < v; o++)w[b][o] = t[b][o];
            for(b = 0; b < v; b++){
                for(S[b] = h, p = 0, l = b + 1, o = b; o < x; o++)p += Math.pow(w[o][b], 2);
                if (p < s) h = 0;
                else for(f = (d = w[b][b]) * (h = d < 0 ? Math.sqrt(p) : -Math.sqrt(p)) - p, w[b][b] = d - h, o = l; o < v; o++){
                    for(p = 0, a = b; a < x; a++)p += w[a][b] * w[a][o];
                    for(d = p / f, a = b; a < x; a++)w[a][o] = w[a][o] + d * w[a][b];
                }
                for(M[b] = h, p = 0, o = l; o < v; o++)p += Math.pow(w[b][o], 2);
                if (p < s) h = 0;
                else {
                    for(f = (d = w[b][b + 1]) * (h = d < 0 ? Math.sqrt(p) : -Math.sqrt(p)) - p, w[b][b + 1] = d - h, o = l; o < v; o++)S[o] = w[b][o] / f;
                    for(o = l; o < x; o++){
                        for(p = 0, a = l; a < v; a++)p += w[o][a] * w[b][a];
                        for(a = l; a < v; a++)w[o][a] = w[o][a] + p * S[a];
                    }
                }
                m < (g = Math.abs(M[b]) + Math.abs(S[b])) && (m = g);
            }
            if (r) for(b = v - 1; 0 <= b; b--){
                if (h !== 0) {
                    for(f = w[b][b + 1] * h, o = l; o < v; o++)A[o][b] = w[b][o] / f;
                    for(o = l; o < v; o++){
                        for(p = 0, a = l; a < v; a++)p += w[b][a] * A[a][o];
                        for(a = l; a < v; a++)A[a][o] = A[a][o] + p * A[a][b];
                    }
                }
                for(o = l; o < v; o++)A[b][o] = 0, A[o][b] = 0;
                A[b][b] = 1, h = S[b], l = b;
            }
            if (e) {
                if (e === "f") for(b = v; b < x; b++){
                    for(o = v; o < x; o++)w[b][o] = 0;
                    w[b][b] = 1;
                }
                for(b = v - 1; 0 <= b; b--){
                    for(l = b + 1, h = M[b], o = l; o < E; o++)w[b][o] = 0;
                    if (h !== 0) {
                        for(f = w[b][b] * h, o = l; o < E; o++){
                            for(p = 0, a = l; a < x; a++)p += w[a][b] * w[a][o];
                            for(d = p / f, a = b; a < x; a++)w[a][o] = w[a][o] + d * w[a][b];
                        }
                        for(o = b; o < x; o++)w[o][b] = w[o][b] / h;
                    } else for(o = b; o < x; o++)w[o][b] = 0;
                    w[b][b] = w[b][b] + 1;
                }
            }
            for(i *= m, a = v - 1; 0 <= a; a--)for(var C = 0; C < 50; C++){
                for(T = !1, l = a; 0 <= l; l--){
                    if (Math.abs(S[l]) <= i) {
                        T = !0;
                        break;
                    }
                    if (Math.abs(M[l - 1]) <= i) break;
                }
                if (!T) {
                    for(c = 0, u = l - (p = 1), b = l; b < a + 1 && (d = p * S[b], S[b] = c * S[b], !(Math.abs(d) <= i)); b++)if (h = M[b], M[b] = Math.sqrt(d * d + h * h), c = h / (f = M[b]), p = -d / f, e) for(o = 0; o < x; o++)g = w[o][u], y = w[o][b], w[o][u] = g * c + y * p, w[o][b] = -g * p + y * c;
                }
                if (y = M[a], l === a) {
                    if (y < 0 && (M[a] = -y, r)) for(o = 0; o < v; o++)A[o][a] = -A[o][a];
                    break;
                }
                for(m = M[l], d = (((g = M[a - 1]) - y) * (g + y) + ((h = S[a - 1]) - (f = S[a])) * (h + f)) / (2 * f * g), h = Math.sqrt(d * d + 1), d = ((m - y) * (m + y) + f * (g / (d < 0 ? d - h : d + h) - f)) / m, b = l + (p = c = 1); b < a + 1; b++){
                    if (h = S[b], g = M[b], f = p * h, h *= c, y = Math.sqrt(d * d + f * f), d = m * (c = d / (S[b - 1] = y)) + h * (p = f / y), h = -m * p + h * c, f = g * p, g *= c, r) for(o = 0; o < v; o++)m = A[o][b - 1], y = A[o][b], A[o][b - 1] = m * c + y * p, A[o][b] = -m * p + y * c;
                    if (y = Math.sqrt(d * d + f * f), d = (c = d / (M[b - 1] = y)) * h + (p = f / y) * g, m = -p * h + c * g, e) for(o = 0; o < x; o++)g = w[o][b - 1], y = w[o][b], w[o][b - 1] = g * c + y * p, w[o][b] = -g * p + y * c;
                }
                S[l] = 0, S[a] = d, M[a] = m;
            }
            for(b = 0; b < v; b++)M[b] < i && (M[b] = 0);
            return {
                u: w,
                q: M,
                v: A
            };
        }, n1.VERSION = "1.1.1", Object.defineProperty(n1, "__esModule", {
            value: !0
        });
    });
});
var UO = en((tA, rA)=>{
    (function(n1, t) {
        typeof tA == "object" && typeof rA < "u" ? rA.exports = t() : typeof define == "function" && define.amd ? define(t) : (n1 = n1 || self, n1.TinyQueue = t());
    })(tA, function() {
        "use strict";
        var n1 = function(r, i) {
            if (r === void 0 && (r = []), i === void 0 && (i = t), this.data = r, this.length = this.data.length, this.compare = i, this.length > 0) for(var s = (this.length >> 1) - 1; s >= 0; s--)this._down(s);
        };
        n1.prototype.push = function(r) {
            this.data.push(r), this.length++, this._up(this.length - 1);
        }, n1.prototype.pop = function() {
            if (this.length !== 0) {
                var r = this.data[0], i = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = i, this._down(0)), r;
            }
        }, n1.prototype.peek = function() {
            return this.data[0];
        }, n1.prototype._up = function(r) {
            for(var i = this, s = i.data, o = i.compare, a = s[r]; r > 0;){
                var l = r - 1 >> 1, u = s[l];
                if (o(a, u) >= 0) break;
                s[r] = u, r = l;
            }
            s[r] = a;
        }, n1.prototype._down = function(r) {
            for(var i = this, s = i.data, o = i.compare, a = this.length >> 1, l = s[r]; r < a;){
                var u = (r << 1) + 1, c = s[u], d = u + 1;
                if (d < this.length && o(s[d], c) < 0 && (u = d, c = s[d]), o(c, l) >= 0) break;
                s[r] = c, r = u;
            }
            s[r] = l;
        };
        function t(e, r) {
            return e < r ? -1 : e > r ? 1 : 0;
        }
        return n1;
    });
});
var jO = en((Sge, iA)=>{
    "use strict";
    var x0 = UO();
    x0.default && (x0 = x0.default);
    iA.exports = GO;
    iA.exports.default = GO;
    function GO(n1, t, e) {
        t = t || 1;
        for(var r, i, s, o, a = 0; a < n1[0].length; a++){
            var l = n1[0][a];
            (!a || l[0] < r) && (r = l[0]), (!a || l[1] < i) && (i = l[1]), (!a || l[0] > s) && (s = l[0]), (!a || l[1] > o) && (o = l[1]);
        }
        var u = s - r, c = o - i, d = Math.min(u, c), h = d / 2;
        if (d === 0) {
            var f = [
                r,
                i
            ];
            return f.distance = 0, f;
        }
        for(var p = new x0(void 0, $9), m = r; m < s; m += d)for(var g = i; g < o; g += d)p.push(new Dl(m + h, g + h, h, n1));
        var y = tY(n1), v = new Dl(r + u / 2, i + c / 2, 0, n1);
        v.d > y.d && (y = v);
        for(var x = p.length; p.length;){
            var S = p.pop();
            S.d > y.d && (y = S, e && console.log("found best %d after %d probes", Math.round(1e4 * S.d) / 1e4, x)), !(S.max - y.d <= t) && (h = S.h / 2, p.push(new Dl(S.x - h, S.y - h, h, n1)), p.push(new Dl(S.x + h, S.y - h, h, n1)), p.push(new Dl(S.x - h, S.y + h, h, n1)), p.push(new Dl(S.x + h, S.y + h, h, n1)), x += 4);
        }
        e && (console.log("num probes: " + x), console.log("best distance: " + y.d));
        var w = [
            y.x,
            y.y
        ];
        return w.distance = y.d, w;
    }
    function $9(n1, t) {
        return t.max - n1.max;
    }
    function Dl(n1, t, e, r) {
        this.x = n1, this.y = t, this.h = e, this.d = eY(n1, t, r), this.max = this.d + this.h * Math.SQRT2;
    }
    function eY(n1, t, e) {
        for(var r = !1, i = 1 / 0, s = 0; s < e.length; s++)for(var o = e[s], a = 0, l = o.length, u = l - 1; a < l; u = a++){
            var c = o[a], d = o[u];
            c[1] > t != d[1] > t && n1 < (d[0] - c[0]) * (t - c[1]) / (d[1] - c[1]) + c[0] && (r = !r), i = Math.min(i, rY(n1, t, c, d));
        }
        return i === 0 ? 0 : (r ? 1 : -1) * Math.sqrt(i);
    }
    function tY(n1) {
        for(var t = 0, e = 0, r = 0, i = n1[0], s = 0, o = i.length, a = o - 1; s < o; a = s++){
            var l = i[s], u = i[a], c = l[0] * u[1] - u[0] * l[1];
            e += (l[0] + u[0]) * c, r += (l[1] + u[1]) * c, t += c * 3;
        }
        return t === 0 ? new Dl(i[0][0], i[0][1], 0, n1) : new Dl(e / t, r / t, 0, n1);
    }
    function rY(n1, t, e, r) {
        var i = e[0], s = e[1], o = r[0] - i, a = r[1] - s;
        if (o !== 0 || a !== 0) {
            var l = ((n1 - i) * o + (t - s) * a) / (o * o + a * a);
            l > 1 ? (i = r[0], s = r[1]) : l > 0 && (i += o * l, s += a * l);
        }
        return o = n1 - i, a = t - s, o * o + a * a;
    }
});
var GI = en((H0, UI)=>{
    "use strict";
    Object.defineProperty(H0, "__esModule", {
        value: !0
    });
    H0.default = t7;
    function t7(n1) {
        if (n1 === null || n1 === !0 || n1 === !1) return NaN;
        var t = Number(n1);
        return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
    }
    UI.exports = H0.default;
});
var HI = en((W0, jI)=>{
    "use strict";
    Object.defineProperty(W0, "__esModule", {
        value: !0
    });
    W0.default = r7;
    function r7(n1) {
        var t = new Date(Date.UTC(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds()));
        return t.setUTCFullYear(n1.getFullYear()), n1.getTime() - t.getTime();
    }
    jI.exports = W0.default;
});
var eR = en((X0)=>{
    (function() {
        "use strict";
        var n1 = function() {
            this.init();
        };
        n1.prototype = {
            init: function() {
                var c = this || t;
                return c._counter = 1e3, c._html5AudioPool = [], c.html5PoolSize = 10, c._codecs = {}, c._howls = [], c._muted = !1, c._volume = 1, c._canPlayEvent = "canplaythrough", c._navigator = typeof window < "u" && window.navigator ? window.navigator : null, c.masterGain = null, c.noAudio = !1, c.usingWebAudio = !0, c.autoSuspend = !0, c.ctx = null, c.autoUnlock = !0, c._setup(), c;
            },
            volume: function(c) {
                var d = this || t;
                if (c = parseFloat(c), d.ctx || u(), typeof c < "u" && c >= 0 && c <= 1) {
                    if (d._volume = c, d._muted) return d;
                    d.usingWebAudio && d.masterGain.gain.setValueAtTime(c, t.ctx.currentTime);
                    for(var h = 0; h < d._howls.length; h++)if (!d._howls[h]._webAudio) for(var f = d._howls[h]._getSoundIds(), p = 0; p < f.length; p++){
                        var m = d._howls[h]._soundById(f[p]);
                        m && m._node && (m._node.volume = m._volume * c);
                    }
                    return d;
                }
                return d._volume;
            },
            mute: function(c) {
                var d = this || t;
                d.ctx || u(), d._muted = c, d.usingWebAudio && d.masterGain.gain.setValueAtTime(c ? 0 : d._volume, t.ctx.currentTime);
                for(var h = 0; h < d._howls.length; h++)if (!d._howls[h]._webAudio) for(var f = d._howls[h]._getSoundIds(), p = 0; p < f.length; p++){
                    var m = d._howls[h]._soundById(f[p]);
                    m && m._node && (m._node.muted = c ? !0 : m._muted);
                }
                return d;
            },
            stop: function() {
                for(var c = this || t, d = 0; d < c._howls.length; d++)c._howls[d].stop();
                return c;
            },
            unload: function() {
                for(var c = this || t, d = c._howls.length - 1; d >= 0; d--)c._howls[d].unload();
                return c.usingWebAudio && c.ctx && typeof c.ctx.close < "u" && (c.ctx.close(), c.ctx = null, u()), c;
            },
            codecs: function(c) {
                return (this || t)._codecs[c.replace(/^x-/, "")];
            },
            _setup: function() {
                var c = this || t;
                if (c.state = c.ctx && c.ctx.state || "suspended", c._autoSuspend(), !c.usingWebAudio) {
                    if (typeof Audio < "u") try {
                        var d = new Audio;
                        typeof d.oncanplaythrough > "u" && (c._canPlayEvent = "canplay");
                    } catch  {
                        c.noAudio = !0;
                    }
                    else c.noAudio = !0;
                }
                try {
                    var d = new Audio;
                    d.muted && (c.noAudio = !0);
                } catch  {}
                return c.noAudio || c._setupCodecs(), c;
            },
            _setupCodecs: function() {
                var c = this || t, d = null;
                try {
                    d = typeof Audio < "u" ? new Audio : null;
                } catch  {
                    return c;
                }
                if (!d || typeof d.canPlayType != "function") return c;
                var h = d.canPlayType("audio/mpeg;").replace(/^no$/, ""), f = c._navigator ? c._navigator.userAgent : "", p = f.match(/OPR\/([0-6].)/g), m = p && parseInt(p[0].split("/")[1], 10) < 33, g = f.indexOf("Safari") !== -1 && f.indexOf("Chrome") === -1, y = f.match(/Version\/(.*?) /), v = g && y && parseInt(y[1], 10) < 15;
                return c._codecs = {
                    mp3: !!(!m && (h || d.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                    mpeg: !!h,
                    opus: !!d.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                    ogg: !!d.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    oga: !!d.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    wav: !!(d.canPlayType('audio/wav; codecs="1"') || d.canPlayType("audio/wav")).replace(/^no$/, ""),
                    aac: !!d.canPlayType("audio/aac;").replace(/^no$/, ""),
                    caf: !!d.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                    m4a: !!(d.canPlayType("audio/x-m4a;") || d.canPlayType("audio/m4a;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    m4b: !!(d.canPlayType("audio/x-m4b;") || d.canPlayType("audio/m4b;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    mp4: !!(d.canPlayType("audio/x-mp4;") || d.canPlayType("audio/mp4;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    weba: !!(!v && d.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    webm: !!(!v && d.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    dolby: !!d.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                    flac: !!(d.canPlayType("audio/x-flac;") || d.canPlayType("audio/flac;")).replace(/^no$/, "")
                }, c;
            },
            _unlockAudio: function() {
                var c = this || t;
                if (!(c._audioUnlocked || !c.ctx)) {
                    c._audioUnlocked = !1, c.autoUnlock = !1, !c._mobileUnloaded && c.ctx.sampleRate !== 44100 && (c._mobileUnloaded = !0, c.unload()), c._scratchBuffer = c.ctx.createBuffer(1, 1, 22050);
                    var d = function(h) {
                        for(; c._html5AudioPool.length < c.html5PoolSize;)try {
                            var f = new Audio;
                            f._unlocked = !0, c._releaseHtml5Audio(f);
                        } catch  {
                            c.noAudio = !0;
                            break;
                        }
                        for(var p = 0; p < c._howls.length; p++)if (!c._howls[p]._webAudio) for(var m = c._howls[p]._getSoundIds(), g = 0; g < m.length; g++){
                            var y = c._howls[p]._soundById(m[g]);
                            y && y._node && !y._node._unlocked && (y._node._unlocked = !0, y._node.load());
                        }
                        c._autoResume();
                        var v = c.ctx.createBufferSource();
                        v.buffer = c._scratchBuffer, v.connect(c.ctx.destination), typeof v.start > "u" ? v.noteOn(0) : v.start(0), typeof c.ctx.resume == "function" && c.ctx.resume(), v.onended = function() {
                            v.disconnect(0), c._audioUnlocked = !0, document.removeEventListener("touchstart", d, !0), document.removeEventListener("touchend", d, !0), document.removeEventListener("click", d, !0), document.removeEventListener("keydown", d, !0);
                            for(var x = 0; x < c._howls.length; x++)c._howls[x]._emit("unlock");
                        };
                    };
                    return document.addEventListener("touchstart", d, !0), document.addEventListener("touchend", d, !0), document.addEventListener("click", d, !0), document.addEventListener("keydown", d, !0), c;
                }
            },
            _obtainHtml5Audio: function() {
                var c = this || t;
                if (c._html5AudioPool.length) return c._html5AudioPool.pop();
                var d = new Audio().play();
                return d && typeof Promise < "u" && (d instanceof Promise || typeof d.then == "function") && d.catch(function() {
                    console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
                }), new Audio;
            },
            _releaseHtml5Audio: function(c) {
                var d = this || t;
                return c._unlocked && d._html5AudioPool.push(c), d;
            },
            _autoSuspend: function() {
                var c = this;
                if (!(!c.autoSuspend || !c.ctx || typeof c.ctx.suspend > "u" || !t.usingWebAudio)) {
                    for(var d = 0; d < c._howls.length; d++)if (c._howls[d]._webAudio) {
                        for(var h = 0; h < c._howls[d]._sounds.length; h++)if (!c._howls[d]._sounds[h]._paused) return c;
                    }
                    return c._suspendTimer && clearTimeout(c._suspendTimer), c._suspendTimer = setTimeout(function() {
                        if (!!c.autoSuspend) {
                            c._suspendTimer = null, c.state = "suspending";
                            var f = function() {
                                c.state = "suspended", c._resumeAfterSuspend && (delete c._resumeAfterSuspend, c._autoResume());
                            };
                            c.ctx.suspend().then(f, f);
                        }
                    }, 3e4), c;
                }
            },
            _autoResume: function() {
                var c = this;
                if (!(!c.ctx || typeof c.ctx.resume > "u" || !t.usingWebAudio)) return c.state === "running" && c.ctx.state !== "interrupted" && c._suspendTimer ? (clearTimeout(c._suspendTimer), c._suspendTimer = null) : c.state === "suspended" || c.state === "running" && c.ctx.state === "interrupted" ? (c.ctx.resume().then(function() {
                    c.state = "running";
                    for(var d = 0; d < c._howls.length; d++)c._howls[d]._emit("resume");
                }), c._suspendTimer && (clearTimeout(c._suspendTimer), c._suspendTimer = null)) : c.state === "suspending" && (c._resumeAfterSuspend = !0), c;
            }
        };
        var t = new n1, e = function(c) {
            var d = this;
            if (!c.src || c.src.length === 0) {
                console.error("An array of source files must be passed with any new Howl.");
                return;
            }
            d.init(c);
        };
        e.prototype = {
            init: function(c) {
                var d = this;
                return t.ctx || u(), d._autoplay = c.autoplay || !1, d._format = typeof c.format != "string" ? c.format : [
                    c.format
                ], d._html5 = c.html5 || !1, d._muted = c.mute || !1, d._loop = c.loop || !1, d._pool = c.pool || 5, d._preload = typeof c.preload == "boolean" || c.preload === "metadata" ? c.preload : !0, d._rate = c.rate || 1, d._sprite = c.sprite || {}, d._src = typeof c.src != "string" ? c.src : [
                    c.src
                ], d._volume = c.volume !== void 0 ? c.volume : 1, d._xhr = {
                    method: c.xhr && c.xhr.method ? c.xhr.method : "GET",
                    headers: c.xhr && c.xhr.headers ? c.xhr.headers : null,
                    withCredentials: c.xhr && c.xhr.withCredentials ? c.xhr.withCredentials : !1
                }, d._duration = 0, d._state = "unloaded", d._sounds = [], d._endTimers = {}, d._queue = [], d._playLock = !1, d._onend = c.onend ? [
                    {
                        fn: c.onend
                    }
                ] : [], d._onfade = c.onfade ? [
                    {
                        fn: c.onfade
                    }
                ] : [], d._onload = c.onload ? [
                    {
                        fn: c.onload
                    }
                ] : [], d._onloaderror = c.onloaderror ? [
                    {
                        fn: c.onloaderror
                    }
                ] : [], d._onplayerror = c.onplayerror ? [
                    {
                        fn: c.onplayerror
                    }
                ] : [], d._onpause = c.onpause ? [
                    {
                        fn: c.onpause
                    }
                ] : [], d._onplay = c.onplay ? [
                    {
                        fn: c.onplay
                    }
                ] : [], d._onstop = c.onstop ? [
                    {
                        fn: c.onstop
                    }
                ] : [], d._onmute = c.onmute ? [
                    {
                        fn: c.onmute
                    }
                ] : [], d._onvolume = c.onvolume ? [
                    {
                        fn: c.onvolume
                    }
                ] : [], d._onrate = c.onrate ? [
                    {
                        fn: c.onrate
                    }
                ] : [], d._onseek = c.onseek ? [
                    {
                        fn: c.onseek
                    }
                ] : [], d._onunlock = c.onunlock ? [
                    {
                        fn: c.onunlock
                    }
                ] : [], d._onresume = [], d._webAudio = t.usingWebAudio && !d._html5, typeof t.ctx < "u" && t.ctx && t.autoUnlock && t._unlockAudio(), t._howls.push(d), d._autoplay && d._queue.push({
                    event: "play",
                    action: function() {
                        d.play();
                    }
                }), d._preload && d._preload !== "none" && d.load(), d;
            },
            load: function() {
                var c = this, d = null;
                if (t.noAudio) {
                    c._emit("loaderror", null, "No audio support.");
                    return;
                }
                typeof c._src == "string" && (c._src = [
                    c._src
                ]);
                for(var h = 0; h < c._src.length; h++){
                    var f, p;
                    if (c._format && c._format[h]) f = c._format[h];
                    else {
                        if (p = c._src[h], typeof p != "string") {
                            c._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                            continue;
                        }
                        f = /^data:audio\/([^;,]+);/i.exec(p), f || (f = /\.([^.]+)$/.exec(p.split("?", 1)[0])), f && (f = f[1].toLowerCase());
                    }
                    if (f || console.warn('No file extension was found. Consider using the "format" property or specify an extension.'), f && t.codecs(f)) {
                        d = c._src[h];
                        break;
                    }
                }
                if (!d) {
                    c._emit("loaderror", null, "No codec support for selected audio sources.");
                    return;
                }
                return c._src = d, c._state = "loading", window.location.protocol === "https:" && d.slice(0, 5) === "http:" && (c._html5 = !0, c._webAudio = !1), new r(c), c._webAudio && s(c), c;
            },
            play: function(c, d) {
                var h = this, f = null;
                if (typeof c == "number") f = c, c = null;
                else {
                    if (typeof c == "string" && h._state === "loaded" && !h._sprite[c]) return null;
                    if (typeof c > "u" && (c = "__default", !h._playLock)) {
                        for(var p = 0, m = 0; m < h._sounds.length; m++)h._sounds[m]._paused && !h._sounds[m]._ended && (p++, f = h._sounds[m]._id);
                        p === 1 ? c = null : f = null;
                    }
                }
                var g = f ? h._soundById(f) : h._inactiveSound();
                if (!g) return null;
                if (f && !c && (c = g._sprite || "__default"), h._state !== "loaded") {
                    g._sprite = c, g._ended = !1;
                    var y = g._id;
                    return h._queue.push({
                        event: "play",
                        action: function() {
                            h.play(y);
                        }
                    }), y;
                }
                if (f && !g._paused) return d || h._loadQueue("play"), g._id;
                h._webAudio && t._autoResume();
                var v = Math.max(0, g._seek > 0 ? g._seek : h._sprite[c][0] / 1e3), x = Math.max(0, (h._sprite[c][0] + h._sprite[c][1]) / 1e3 - v), S = x * 1e3 / Math.abs(g._rate), w = h._sprite[c][0] / 1e3, A = (h._sprite[c][0] + h._sprite[c][1]) / 1e3;
                g._sprite = c, g._ended = !1;
                var E = function() {
                    g._paused = !1, g._seek = v, g._start = w, g._stop = A, g._loop = !!(g._loop || h._sprite[c][2]);
                };
                if (v >= A) {
                    h._ended(g);
                    return;
                }
                var b = g._node;
                if (h._webAudio) {
                    var T = function() {
                        h._playLock = !1, E(), h._refreshBuffer(g);
                        var D = g._muted || h._muted ? 0 : g._volume;
                        b.gain.setValueAtTime(D, t.ctx.currentTime), g._playStart = t.ctx.currentTime, typeof b.bufferSource.start > "u" ? g._loop ? b.bufferSource.noteGrainOn(0, v, 86400) : b.bufferSource.noteGrainOn(0, v, x) : g._loop ? b.bufferSource.start(0, v, 86400) : b.bufferSource.start(0, v, x), S !== 1 / 0 && (h._endTimers[g._id] = setTimeout(h._ended.bind(h, g), S)), d || setTimeout(function() {
                            h._emit("play", g._id), h._loadQueue();
                        }, 0);
                    };
                    t.state === "running" && t.ctx.state !== "interrupted" ? T() : (h._playLock = !0, h.once("resume", T), h._clearTimer(g._id));
                } else {
                    var M = function() {
                        b.currentTime = v, b.muted = g._muted || h._muted || t._muted || b.muted, b.volume = g._volume * t.volume(), b.playbackRate = g._rate;
                        try {
                            var D = b.play();
                            if (D && typeof Promise < "u" && (D instanceof Promise || typeof D.then == "function") ? (h._playLock = !0, E(), D.then(function() {
                                h._playLock = !1, b._unlocked = !0, d ? h._loadQueue() : h._emit("play", g._id);
                            }).catch(function() {
                                h._playLock = !1, h._emit("playerror", g._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."), g._ended = !0, g._paused = !0;
                            })) : d || (h._playLock = !1, E(), h._emit("play", g._id)), b.playbackRate = g._rate, b.paused) {
                                h._emit("playerror", g._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                return;
                            }
                            c !== "__default" || g._loop ? h._endTimers[g._id] = setTimeout(h._ended.bind(h, g), S) : (h._endTimers[g._id] = function() {
                                h._ended(g), b.removeEventListener("ended", h._endTimers[g._id], !1);
                            }, b.addEventListener("ended", h._endTimers[g._id], !1));
                        } catch (O) {
                            h._emit("playerror", g._id, O);
                        }
                    };
                    b.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA" && (b.src = h._src, b.load());
                    var C = window && window.ejecta || !b.readyState && t._navigator.isCocoonJS;
                    if (b.readyState >= 3 || C) M();
                    else {
                        h._playLock = !0, h._state = "loading";
                        var P = function() {
                            h._state = "loaded", M(), b.removeEventListener(t._canPlayEvent, P, !1);
                        };
                        b.addEventListener(t._canPlayEvent, P, !1), h._clearTimer(g._id);
                    }
                }
                return g._id;
            },
            pause: function(c) {
                var d = this;
                if (d._state !== "loaded" || d._playLock) return d._queue.push({
                    event: "pause",
                    action: function() {
                        d.pause(c);
                    }
                }), d;
                for(var h = d._getSoundIds(c), f = 0; f < h.length; f++){
                    d._clearTimer(h[f]);
                    var p = d._soundById(h[f]);
                    if (p && !p._paused && (p._seek = d.seek(h[f]), p._rateSeek = 0, p._paused = !0, d._stopFade(h[f]), p._node)) {
                        if (d._webAudio) {
                            if (!p._node.bufferSource) continue;
                            typeof p._node.bufferSource.stop > "u" ? p._node.bufferSource.noteOff(0) : p._node.bufferSource.stop(0), d._cleanBuffer(p._node);
                        } else (!isNaN(p._node.duration) || p._node.duration === 1 / 0) && p._node.pause();
                    }
                    arguments[1] || d._emit("pause", p ? p._id : null);
                }
                return d;
            },
            stop: function(c, d) {
                var h = this;
                if (h._state !== "loaded" || h._playLock) return h._queue.push({
                    event: "stop",
                    action: function() {
                        h.stop(c);
                    }
                }), h;
                for(var f = h._getSoundIds(c), p = 0; p < f.length; p++){
                    h._clearTimer(f[p]);
                    var m = h._soundById(f[p]);
                    m && (m._seek = m._start || 0, m._rateSeek = 0, m._paused = !0, m._ended = !0, h._stopFade(f[p]), m._node && (h._webAudio ? m._node.bufferSource && (typeof m._node.bufferSource.stop > "u" ? m._node.bufferSource.noteOff(0) : m._node.bufferSource.stop(0), h._cleanBuffer(m._node)) : (!isNaN(m._node.duration) || m._node.duration === 1 / 0) && (m._node.currentTime = m._start || 0, m._node.pause(), m._node.duration === 1 / 0 && h._clearSound(m._node))), d || h._emit("stop", m._id));
                }
                return h;
            },
            mute: function(c, d) {
                var h = this;
                if (h._state !== "loaded" || h._playLock) return h._queue.push({
                    event: "mute",
                    action: function() {
                        h.mute(c, d);
                    }
                }), h;
                if (typeof d > "u") {
                    if (typeof c == "boolean") h._muted = c;
                    else return h._muted;
                }
                for(var f = h._getSoundIds(d), p = 0; p < f.length; p++){
                    var m = h._soundById(f[p]);
                    m && (m._muted = c, m._interval && h._stopFade(m._id), h._webAudio && m._node ? m._node.gain.setValueAtTime(c ? 0 : m._volume, t.ctx.currentTime) : m._node && (m._node.muted = t._muted ? !0 : c), h._emit("mute", m._id));
                }
                return h;
            },
            volume: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) return c._volume;
                if (d.length === 1 || d.length === 2 && typeof d[1] > "u") {
                    var p = c._getSoundIds(), m = p.indexOf(d[0]);
                    m >= 0 ? f = parseInt(d[0], 10) : h = parseFloat(d[0]);
                } else d.length >= 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                var g;
                if (typeof h < "u" && h >= 0 && h <= 1) {
                    if (c._state !== "loaded" || c._playLock) return c._queue.push({
                        event: "volume",
                        action: function() {
                            c.volume.apply(c, d);
                        }
                    }), c;
                    typeof f > "u" && (c._volume = h), f = c._getSoundIds(f);
                    for(var y = 0; y < f.length; y++)g = c._soundById(f[y]), g && (g._volume = h, d[2] || c._stopFade(f[y]), c._webAudio && g._node && !g._muted ? g._node.gain.setValueAtTime(h, t.ctx.currentTime) : g._node && !g._muted && (g._node.volume = h * t.volume()), c._emit("volume", g._id));
                } else return g = f ? c._soundById(f) : c._sounds[0], g ? g._volume : 0;
                return c;
            },
            fade: function(c, d, h, f) {
                var p = this;
                if (p._state !== "loaded" || p._playLock) return p._queue.push({
                    event: "fade",
                    action: function() {
                        p.fade(c, d, h, f);
                    }
                }), p;
                c = Math.min(Math.max(0, parseFloat(c)), 1), d = Math.min(Math.max(0, parseFloat(d)), 1), h = parseFloat(h), p.volume(c, f);
                for(var m = p._getSoundIds(f), g = 0; g < m.length; g++){
                    var y = p._soundById(m[g]);
                    if (y) {
                        if (f || p._stopFade(m[g]), p._webAudio && !y._muted) {
                            var v = t.ctx.currentTime, x = v + h / 1e3;
                            y._volume = c, y._node.gain.setValueAtTime(c, v), y._node.gain.linearRampToValueAtTime(d, x);
                        }
                        p._startFadeInterval(y, c, d, h, m[g], typeof f > "u");
                    }
                }
                return p;
            },
            _startFadeInterval: function(c, d, h, f, p, m) {
                var g = this, y = d, v = h - d, x = Math.abs(v / .01), S = Math.max(4, x > 0 ? f / x : f), w = Date.now();
                c._fadeTo = h, c._interval = setInterval(function() {
                    var A = (Date.now() - w) / f;
                    w = Date.now(), y += v * A, y = Math.round(y * 100) / 100, v < 0 ? y = Math.max(h, y) : y = Math.min(h, y), g._webAudio ? c._volume = y : g.volume(y, c._id, !0), m && (g._volume = y), (h < d && y <= h || h > d && y >= h) && (clearInterval(c._interval), c._interval = null, c._fadeTo = null, g.volume(h, c._id), g._emit("fade", c._id));
                }, S);
            },
            _stopFade: function(c) {
                var d = this, h = d._soundById(c);
                return h && h._interval && (d._webAudio && h._node.gain.cancelScheduledValues(t.ctx.currentTime), clearInterval(h._interval), h._interval = null, d.volume(h._fadeTo, c), h._fadeTo = null, d._emit("fade", c)), d;
            },
            loop: function() {
                var c = this, d = arguments, h, f, p;
                if (d.length === 0) return c._loop;
                if (d.length === 1) {
                    if (typeof d[0] == "boolean") h = d[0], c._loop = h;
                    else return p = c._soundById(parseInt(d[0], 10)), p ? p._loop : !1;
                } else d.length === 2 && (h = d[0], f = parseInt(d[1], 10));
                for(var m = c._getSoundIds(f), g = 0; g < m.length; g++)p = c._soundById(m[g]), p && (p._loop = h, c._webAudio && p._node && p._node.bufferSource && (p._node.bufferSource.loop = h, h && (p._node.bufferSource.loopStart = p._start || 0, p._node.bufferSource.loopEnd = p._stop, c.playing(m[g]) && (c.pause(m[g], !0), c.play(m[g], !0)))));
                return c;
            },
            rate: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) f = c._sounds[0]._id;
                else if (d.length === 1) {
                    var p = c._getSoundIds(), m = p.indexOf(d[0]);
                    m >= 0 ? f = parseInt(d[0], 10) : h = parseFloat(d[0]);
                } else d.length === 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                var g;
                if (typeof h == "number") {
                    if (c._state !== "loaded" || c._playLock) return c._queue.push({
                        event: "rate",
                        action: function() {
                            c.rate.apply(c, d);
                        }
                    }), c;
                    typeof f > "u" && (c._rate = h), f = c._getSoundIds(f);
                    for(var y = 0; y < f.length; y++)if (g = c._soundById(f[y]), g) {
                        c.playing(f[y]) && (g._rateSeek = c.seek(f[y]), g._playStart = c._webAudio ? t.ctx.currentTime : g._playStart), g._rate = h, c._webAudio && g._node && g._node.bufferSource ? g._node.bufferSource.playbackRate.setValueAtTime(h, t.ctx.currentTime) : g._node && (g._node.playbackRate = h);
                        var v = c.seek(f[y]), x = (c._sprite[g._sprite][0] + c._sprite[g._sprite][1]) / 1e3 - v, S = x * 1e3 / Math.abs(g._rate);
                        (c._endTimers[f[y]] || !g._paused) && (c._clearTimer(f[y]), c._endTimers[f[y]] = setTimeout(c._ended.bind(c, g), S)), c._emit("rate", g._id);
                    }
                } else return g = c._soundById(f), g ? g._rate : c._rate;
                return c;
            },
            seek: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) c._sounds.length && (f = c._sounds[0]._id);
                else if (d.length === 1) {
                    var p = c._getSoundIds(), m = p.indexOf(d[0]);
                    m >= 0 ? f = parseInt(d[0], 10) : c._sounds.length && (f = c._sounds[0]._id, h = parseFloat(d[0]));
                } else d.length === 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                if (typeof f > "u") return 0;
                if (typeof h == "number" && (c._state !== "loaded" || c._playLock)) return c._queue.push({
                    event: "seek",
                    action: function() {
                        c.seek.apply(c, d);
                    }
                }), c;
                var g = c._soundById(f);
                if (g) {
                    if (typeof h == "number" && h >= 0) {
                        var y = c.playing(f);
                        y && c.pause(f, !0), g._seek = h, g._ended = !1, c._clearTimer(f), !c._webAudio && g._node && !isNaN(g._node.duration) && (g._node.currentTime = h);
                        var v = function() {
                            y && c.play(f, !0), c._emit("seek", f);
                        };
                        if (y && !c._webAudio) {
                            var x = function() {
                                c._playLock ? setTimeout(x, 0) : v();
                            };
                            setTimeout(x, 0);
                        } else v();
                    } else if (c._webAudio) {
                        var S = c.playing(f) ? t.ctx.currentTime - g._playStart : 0, w = g._rateSeek ? g._rateSeek - g._seek : 0;
                        return g._seek + (w + S * Math.abs(g._rate));
                    } else return g._node.currentTime;
                }
                return c;
            },
            playing: function(c) {
                var d = this;
                if (typeof c == "number") {
                    var h = d._soundById(c);
                    return h ? !h._paused : !1;
                }
                for(var f = 0; f < d._sounds.length; f++)if (!d._sounds[f]._paused) return !0;
                return !1;
            },
            duration: function(c) {
                var d = this, h = d._duration, f = d._soundById(c);
                return f && (h = d._sprite[f._sprite][1] / 1e3), h;
            },
            state: function() {
                return this._state;
            },
            unload: function() {
                for(var c = this, d = c._sounds, h = 0; h < d.length; h++)d[h]._paused || c.stop(d[h]._id), c._webAudio || (c._clearSound(d[h]._node), d[h]._node.removeEventListener("error", d[h]._errorFn, !1), d[h]._node.removeEventListener(t._canPlayEvent, d[h]._loadFn, !1), d[h]._node.removeEventListener("ended", d[h]._endFn, !1), t._releaseHtml5Audio(d[h]._node)), delete d[h]._node, c._clearTimer(d[h]._id);
                var f = t._howls.indexOf(c);
                f >= 0 && t._howls.splice(f, 1);
                var p = !0;
                for(h = 0; h < t._howls.length; h++)if (t._howls[h]._src === c._src || c._src.indexOf(t._howls[h]._src) >= 0) {
                    p = !1;
                    break;
                }
                return i && p && delete i[c._src], t.noAudio = !1, c._state = "unloaded", c._sounds = [], c = null, null;
            },
            on: function(c, d, h, f) {
                var p = this, m = p["_on" + c];
                return typeof d == "function" && m.push(f ? {
                    id: h,
                    fn: d,
                    once: f
                } : {
                    id: h,
                    fn: d
                }), p;
            },
            off: function(c, d, h) {
                var f = this, p = f["_on" + c], m = 0;
                if (typeof d == "number" && (h = d, d = null), d || h) for(m = 0; m < p.length; m++){
                    var g = h === p[m].id;
                    if (d === p[m].fn && g || !d && g) {
                        p.splice(m, 1);
                        break;
                    }
                }
                else if (c) f["_on" + c] = [];
                else {
                    var y = Object.keys(f);
                    for(m = 0; m < y.length; m++)y[m].indexOf("_on") === 0 && Array.isArray(f[y[m]]) && (f[y[m]] = []);
                }
                return f;
            },
            once: function(c, d, h) {
                var f = this;
                return f.on(c, d, h, 1), f;
            },
            _emit: function(c, d, h) {
                for(var f = this, p = f["_on" + c], m = p.length - 1; m >= 0; m--)(!p[m].id || p[m].id === d || c === "load") && (setTimeout((function(g) {
                    g.call(this, d, h);
                }).bind(f, p[m].fn), 0), p[m].once && f.off(c, p[m].fn, p[m].id));
                return f._loadQueue(c), f;
            },
            _loadQueue: function(c) {
                var d = this;
                if (d._queue.length > 0) {
                    var h = d._queue[0];
                    h.event === c && (d._queue.shift(), d._loadQueue()), c || h.action();
                }
                return d;
            },
            _ended: function(c) {
                var d = this, h = c._sprite;
                if (!d._webAudio && c._node && !c._node.paused && !c._node.ended && c._node.currentTime < c._stop) return setTimeout(d._ended.bind(d, c), 100), d;
                var f = !!(c._loop || d._sprite[h][2]);
                if (d._emit("end", c._id), !d._webAudio && f && d.stop(c._id, !0).play(c._id), d._webAudio && f) {
                    d._emit("play", c._id), c._seek = c._start || 0, c._rateSeek = 0, c._playStart = t.ctx.currentTime;
                    var p = (c._stop - c._start) * 1e3 / Math.abs(c._rate);
                    d._endTimers[c._id] = setTimeout(d._ended.bind(d, c), p);
                }
                return d._webAudio && !f && (c._paused = !0, c._ended = !0, c._seek = c._start || 0, c._rateSeek = 0, d._clearTimer(c._id), d._cleanBuffer(c._node), t._autoSuspend()), !d._webAudio && !f && d.stop(c._id, !0), d;
            },
            _clearTimer: function(c) {
                var d = this;
                if (d._endTimers[c]) {
                    if (typeof d._endTimers[c] != "function") clearTimeout(d._endTimers[c]);
                    else {
                        var h = d._soundById(c);
                        h && h._node && h._node.removeEventListener("ended", d._endTimers[c], !1);
                    }
                    delete d._endTimers[c];
                }
                return d;
            },
            _soundById: function(c) {
                for(var d = this, h = 0; h < d._sounds.length; h++)if (c === d._sounds[h]._id) return d._sounds[h];
                return null;
            },
            _inactiveSound: function() {
                var c = this;
                c._drain();
                for(var d = 0; d < c._sounds.length; d++)if (c._sounds[d]._ended) return c._sounds[d].reset();
                return new r(c);
            },
            _drain: function() {
                var c = this, d = c._pool, h = 0, f = 0;
                if (!(c._sounds.length < d)) {
                    for(f = 0; f < c._sounds.length; f++)c._sounds[f]._ended && h++;
                    for(f = c._sounds.length - 1; f >= 0; f--){
                        if (h <= d) return;
                        c._sounds[f]._ended && (c._webAudio && c._sounds[f]._node && c._sounds[f]._node.disconnect(0), c._sounds.splice(f, 1), h--);
                    }
                }
            },
            _getSoundIds: function(c) {
                var d = this;
                if (typeof c > "u") {
                    for(var h = [], f = 0; f < d._sounds.length; f++)h.push(d._sounds[f]._id);
                    return h;
                } else return [
                    c
                ];
            },
            _refreshBuffer: function(c) {
                var d = this;
                return c._node.bufferSource = t.ctx.createBufferSource(), c._node.bufferSource.buffer = i[d._src], c._panner ? c._node.bufferSource.connect(c._panner) : c._node.bufferSource.connect(c._node), c._node.bufferSource.loop = c._loop, c._loop && (c._node.bufferSource.loopStart = c._start || 0, c._node.bufferSource.loopEnd = c._stop || 0), c._node.bufferSource.playbackRate.setValueAtTime(c._rate, t.ctx.currentTime), d;
            },
            _cleanBuffer: function(c) {
                var d = this, h = t._navigator && t._navigator.vendor.indexOf("Apple") >= 0;
                if (t._scratchBuffer && c.bufferSource && (c.bufferSource.onended = null, c.bufferSource.disconnect(0), h)) try {
                    c.bufferSource.buffer = t._scratchBuffer;
                } catch  {}
                return c.bufferSource = null, d;
            },
            _clearSound: function(c) {
                var d = /MSIE |Trident\//.test(t._navigator && t._navigator.userAgent);
                d || (c.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA");
            }
        };
        var r = function(c) {
            this._parent = c, this.init();
        };
        r.prototype = {
            init: function() {
                var c = this, d = c._parent;
                return c._muted = d._muted, c._loop = d._loop, c._volume = d._volume, c._rate = d._rate, c._seek = 0, c._paused = !0, c._ended = !0, c._sprite = "__default", c._id = ++t._counter, d._sounds.push(c), c.create(), c;
            },
            create: function() {
                var c = this, d = c._parent, h = t._muted || c._muted || c._parent._muted ? 0 : c._volume;
                return d._webAudio ? (c._node = typeof t.ctx.createGain > "u" ? t.ctx.createGainNode() : t.ctx.createGain(), c._node.gain.setValueAtTime(h, t.ctx.currentTime), c._node.paused = !0, c._node.connect(t.masterGain)) : t.noAudio || (c._node = t._obtainHtml5Audio(), c._errorFn = c._errorListener.bind(c), c._node.addEventListener("error", c._errorFn, !1), c._loadFn = c._loadListener.bind(c), c._node.addEventListener(t._canPlayEvent, c._loadFn, !1), c._endFn = c._endListener.bind(c), c._node.addEventListener("ended", c._endFn, !1), c._node.src = d._src, c._node.preload = d._preload === !0 ? "auto" : d._preload, c._node.volume = h * t.volume(), c._node.load()), c;
            },
            reset: function() {
                var c = this, d = c._parent;
                return c._muted = d._muted, c._loop = d._loop, c._volume = d._volume, c._rate = d._rate, c._seek = 0, c._rateSeek = 0, c._paused = !0, c._ended = !0, c._sprite = "__default", c._id = ++t._counter, c;
            },
            _errorListener: function() {
                var c = this;
                c._parent._emit("loaderror", c._id, c._node.error ? c._node.error.code : 0), c._node.removeEventListener("error", c._errorFn, !1);
            },
            _loadListener: function() {
                var c = this, d = c._parent;
                d._duration = Math.ceil(c._node.duration * 10) / 10, Object.keys(d._sprite).length === 0 && (d._sprite = {
                    __default: [
                        0,
                        d._duration * 1e3
                    ]
                }), d._state !== "loaded" && (d._state = "loaded", d._emit("load"), d._loadQueue()), c._node.removeEventListener(t._canPlayEvent, c._loadFn, !1);
            },
            _endListener: function() {
                var c = this, d = c._parent;
                d._duration === 1 / 0 && (d._duration = Math.ceil(c._node.duration * 10) / 10, d._sprite.__default[1] === 1 / 0 && (d._sprite.__default[1] = d._duration * 1e3), d._ended(c)), c._node.removeEventListener("ended", c._endFn, !1);
            }
        };
        var i = {}, s = function(c) {
            var d = c._src;
            if (i[d]) {
                c._duration = i[d].duration, l(c);
                return;
            }
            if (/^data:[^;]+;base64,/.test(d)) {
                for(var h = atob(d.split(",")[1]), f = new Uint8Array(h.length), p = 0; p < h.length; ++p)f[p] = h.charCodeAt(p);
                a(f.buffer, c);
            } else {
                var m = new XMLHttpRequest;
                m.open(c._xhr.method, d, !0), m.withCredentials = c._xhr.withCredentials, m.responseType = "arraybuffer", c._xhr.headers && Object.keys(c._xhr.headers).forEach(function(g) {
                    m.setRequestHeader(g, c._xhr.headers[g]);
                }), m.onload = function() {
                    var g = (m.status + "")[0];
                    if (g !== "0" && g !== "2" && g !== "3") {
                        c._emit("loaderror", null, "Failed loading audio file with status: " + m.status + ".");
                        return;
                    }
                    a(m.response, c);
                }, m.onerror = function() {
                    c._webAudio && (c._html5 = !0, c._webAudio = !1, c._sounds = [], delete i[d], c.load());
                }, o(m);
            }
        }, o = function(c) {
            try {
                c.send();
            } catch  {
                c.onerror();
            }
        }, a = function(c, d) {
            var h = function() {
                d._emit("loaderror", null, "Decoding audio data failed.");
            }, f = function(p) {
                p && d._sounds.length > 0 ? (i[d._src] = p, l(d, p)) : h();
            };
            typeof Promise < "u" && t.ctx.decodeAudioData.length === 1 ? t.ctx.decodeAudioData(c).then(f).catch(h) : t.ctx.decodeAudioData(c, f, h);
        }, l = function(c, d) {
            d && !c._duration && (c._duration = d.duration), Object.keys(c._sprite).length === 0 && (c._sprite = {
                __default: [
                    0,
                    c._duration * 1e3
                ]
            }), c._state !== "loaded" && (c._state = "loaded", c._emit("load"), c._loadQueue());
        }, u = function() {
            if (!!t.usingWebAudio) {
                try {
                    typeof AudioContext < "u" ? t.ctx = new AudioContext : typeof webkitAudioContext < "u" ? t.ctx = new webkitAudioContext : t.usingWebAudio = !1;
                } catch  {
                    t.usingWebAudio = !1;
                }
                t.ctx || (t.usingWebAudio = !1);
                var c = /iP(hone|od|ad)/.test(t._navigator && t._navigator.platform), d = t._navigator && t._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/), h = d ? parseInt(d[1], 10) : null;
                if (c && h && h < 9) {
                    var f = /safari/.test(t._navigator && t._navigator.userAgent.toLowerCase());
                    t._navigator && !f && (t.usingWebAudio = !1);
                }
                t.usingWebAudio && (t.masterGain = typeof t.ctx.createGain > "u" ? t.ctx.createGainNode() : t.ctx.createGain(), t.masterGain.gain.setValueAtTime(t._muted ? 0 : t._volume, t.ctx.currentTime), t.masterGain.connect(t.ctx.destination)), t._setup();
            }
        };
        typeof define == "function" && define.amd && define([], function() {
            return {
                Howler: t,
                Howl: e
            };
        }), typeof X0 < "u" && (X0.Howler = t, X0.Howl = e), typeof $parcel$global < "u" ? ($parcel$global.HowlerGlobal = n1, $parcel$global.Howler = t, $parcel$global.Howl = e, $parcel$global.Sound = r) : typeof window < "u" && (window.HowlerGlobal = n1, window.Howler = t, window.Howl = e, window.Sound = r);
    })();
    (function() {
        "use strict";
        HowlerGlobal.prototype._pos = [
            0,
            0,
            0
        ], HowlerGlobal.prototype._orientation = [
            0,
            0,
            -1,
            0,
            1,
            0
        ], HowlerGlobal.prototype.stereo = function(t) {
            var e = this;
            if (!e.ctx || !e.ctx.listener) return e;
            for(var r = e._howls.length - 1; r >= 0; r--)e._howls[r].stereo(t);
            return e;
        }, HowlerGlobal.prototype.pos = function(t, e, r) {
            var i = this;
            if (!i.ctx || !i.ctx.listener) return i;
            if (e = typeof e != "number" ? i._pos[1] : e, r = typeof r != "number" ? i._pos[2] : r, typeof t == "number") i._pos = [
                t,
                e,
                r
            ], typeof i.ctx.listener.positionX < "u" ? (i.ctx.listener.positionX.setTargetAtTime(i._pos[0], Howler.ctx.currentTime, .1), i.ctx.listener.positionY.setTargetAtTime(i._pos[1], Howler.ctx.currentTime, .1), i.ctx.listener.positionZ.setTargetAtTime(i._pos[2], Howler.ctx.currentTime, .1)) : i.ctx.listener.setPosition(i._pos[0], i._pos[1], i._pos[2]);
            else return i._pos;
            return i;
        }, HowlerGlobal.prototype.orientation = function(t, e, r, i, s, o) {
            var a = this;
            if (!a.ctx || !a.ctx.listener) return a;
            var l = a._orientation;
            if (e = typeof e != "number" ? l[1] : e, r = typeof r != "number" ? l[2] : r, i = typeof i != "number" ? l[3] : i, s = typeof s != "number" ? l[4] : s, o = typeof o != "number" ? l[5] : o, typeof t == "number") a._orientation = [
                t,
                e,
                r,
                i,
                s,
                o
            ], typeof a.ctx.listener.forwardX < "u" ? (a.ctx.listener.forwardX.setTargetAtTime(t, Howler.ctx.currentTime, .1), a.ctx.listener.forwardY.setTargetAtTime(e, Howler.ctx.currentTime, .1), a.ctx.listener.forwardZ.setTargetAtTime(r, Howler.ctx.currentTime, .1), a.ctx.listener.upX.setTargetAtTime(i, Howler.ctx.currentTime, .1), a.ctx.listener.upY.setTargetAtTime(s, Howler.ctx.currentTime, .1), a.ctx.listener.upZ.setTargetAtTime(o, Howler.ctx.currentTime, .1)) : a.ctx.listener.setOrientation(t, e, r, i, s, o);
            else return l;
            return a;
        }, Howl.prototype.init = function(t) {
            return function(e) {
                var r = this;
                return r._orientation = e.orientation || [
                    1,
                    0,
                    0
                ], r._stereo = e.stereo || null, r._pos = e.pos || null, r._pannerAttr = {
                    coneInnerAngle: typeof e.coneInnerAngle < "u" ? e.coneInnerAngle : 360,
                    coneOuterAngle: typeof e.coneOuterAngle < "u" ? e.coneOuterAngle : 360,
                    coneOuterGain: typeof e.coneOuterGain < "u" ? e.coneOuterGain : 0,
                    distanceModel: typeof e.distanceModel < "u" ? e.distanceModel : "inverse",
                    maxDistance: typeof e.maxDistance < "u" ? e.maxDistance : 1e4,
                    panningModel: typeof e.panningModel < "u" ? e.panningModel : "HRTF",
                    refDistance: typeof e.refDistance < "u" ? e.refDistance : 1,
                    rolloffFactor: typeof e.rolloffFactor < "u" ? e.rolloffFactor : 1
                }, r._onstereo = e.onstereo ? [
                    {
                        fn: e.onstereo
                    }
                ] : [], r._onpos = e.onpos ? [
                    {
                        fn: e.onpos
                    }
                ] : [], r._onorientation = e.onorientation ? [
                    {
                        fn: e.onorientation
                    }
                ] : [], t.call(this, e);
            };
        }(Howl.prototype.init), Howl.prototype.stereo = function(t, e) {
            var r = this;
            if (!r._webAudio) return r;
            if (r._state !== "loaded") return r._queue.push({
                event: "stereo",
                action: function() {
                    r.stereo(t, e);
                }
            }), r;
            var i = typeof Howler.ctx.createStereoPanner > "u" ? "spatial" : "stereo";
            if (typeof e > "u") {
                if (typeof t == "number") r._stereo = t, r._pos = [
                    t,
                    0,
                    0
                ];
                else return r._stereo;
            }
            for(var s = r._getSoundIds(e), o = 0; o < s.length; o++){
                var a = r._soundById(s[o]);
                if (a) {
                    if (typeof t == "number") a._stereo = t, a._pos = [
                        t,
                        0,
                        0
                    ], a._node && (a._pannerAttr.panningModel = "equalpower", (!a._panner || !a._panner.pan) && n1(a, i), i === "spatial" ? typeof a._panner.positionX < "u" ? (a._panner.positionX.setValueAtTime(t, Howler.ctx.currentTime), a._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime), a._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime)) : a._panner.setPosition(t, 0, 0) : a._panner.pan.setValueAtTime(t, Howler.ctx.currentTime)), r._emit("stereo", a._id);
                    else return a._stereo;
                }
            }
            return r;
        }, Howl.prototype.pos = function(t, e, r, i) {
            var s = this;
            if (!s._webAudio) return s;
            if (s._state !== "loaded") return s._queue.push({
                event: "pos",
                action: function() {
                    s.pos(t, e, r, i);
                }
            }), s;
            if (e = typeof e != "number" ? 0 : e, r = typeof r != "number" ? -0.5 : r, typeof i > "u") {
                if (typeof t == "number") s._pos = [
                    t,
                    e,
                    r
                ];
                else return s._pos;
            }
            for(var o = s._getSoundIds(i), a = 0; a < o.length; a++){
                var l = s._soundById(o[a]);
                if (l) {
                    if (typeof t == "number") l._pos = [
                        t,
                        e,
                        r
                    ], l._node && ((!l._panner || l._panner.pan) && n1(l, "spatial"), typeof l._panner.positionX < "u" ? (l._panner.positionX.setValueAtTime(t, Howler.ctx.currentTime), l._panner.positionY.setValueAtTime(e, Howler.ctx.currentTime), l._panner.positionZ.setValueAtTime(r, Howler.ctx.currentTime)) : l._panner.setPosition(t, e, r)), s._emit("pos", l._id);
                    else return l._pos;
                }
            }
            return s;
        }, Howl.prototype.orientation = function(t, e, r, i) {
            var s = this;
            if (!s._webAudio) return s;
            if (s._state !== "loaded") return s._queue.push({
                event: "orientation",
                action: function() {
                    s.orientation(t, e, r, i);
                }
            }), s;
            if (e = typeof e != "number" ? s._orientation[1] : e, r = typeof r != "number" ? s._orientation[2] : r, typeof i > "u") {
                if (typeof t == "number") s._orientation = [
                    t,
                    e,
                    r
                ];
                else return s._orientation;
            }
            for(var o = s._getSoundIds(i), a = 0; a < o.length; a++){
                var l = s._soundById(o[a]);
                if (l) {
                    if (typeof t == "number") l._orientation = [
                        t,
                        e,
                        r
                    ], l._node && (l._panner || (l._pos || (l._pos = s._pos || [
                        0,
                        0,
                        -0.5
                    ]), n1(l, "spatial")), typeof l._panner.orientationX < "u" ? (l._panner.orientationX.setValueAtTime(t, Howler.ctx.currentTime), l._panner.orientationY.setValueAtTime(e, Howler.ctx.currentTime), l._panner.orientationZ.setValueAtTime(r, Howler.ctx.currentTime)) : l._panner.setOrientation(t, e, r)), s._emit("orientation", l._id);
                    else return l._orientation;
                }
            }
            return s;
        }, Howl.prototype.pannerAttr = function() {
            var t = this, e = arguments, r, i, s;
            if (!t._webAudio) return t;
            if (e.length === 0) return t._pannerAttr;
            if (e.length === 1) {
                if (typeof e[0] == "object") r = e[0], typeof i > "u" && (r.pannerAttr || (r.pannerAttr = {
                    coneInnerAngle: r.coneInnerAngle,
                    coneOuterAngle: r.coneOuterAngle,
                    coneOuterGain: r.coneOuterGain,
                    distanceModel: r.distanceModel,
                    maxDistance: r.maxDistance,
                    refDistance: r.refDistance,
                    rolloffFactor: r.rolloffFactor,
                    panningModel: r.panningModel
                }), t._pannerAttr = {
                    coneInnerAngle: typeof r.pannerAttr.coneInnerAngle < "u" ? r.pannerAttr.coneInnerAngle : t._coneInnerAngle,
                    coneOuterAngle: typeof r.pannerAttr.coneOuterAngle < "u" ? r.pannerAttr.coneOuterAngle : t._coneOuterAngle,
                    coneOuterGain: typeof r.pannerAttr.coneOuterGain < "u" ? r.pannerAttr.coneOuterGain : t._coneOuterGain,
                    distanceModel: typeof r.pannerAttr.distanceModel < "u" ? r.pannerAttr.distanceModel : t._distanceModel,
                    maxDistance: typeof r.pannerAttr.maxDistance < "u" ? r.pannerAttr.maxDistance : t._maxDistance,
                    refDistance: typeof r.pannerAttr.refDistance < "u" ? r.pannerAttr.refDistance : t._refDistance,
                    rolloffFactor: typeof r.pannerAttr.rolloffFactor < "u" ? r.pannerAttr.rolloffFactor : t._rolloffFactor,
                    panningModel: typeof r.pannerAttr.panningModel < "u" ? r.pannerAttr.panningModel : t._panningModel
                });
                else return s = t._soundById(parseInt(e[0], 10)), s ? s._pannerAttr : t._pannerAttr;
            } else e.length === 2 && (r = e[0], i = parseInt(e[1], 10));
            for(var o = t._getSoundIds(i), a = 0; a < o.length; a++)if (s = t._soundById(o[a]), s) {
                var l = s._pannerAttr;
                l = {
                    coneInnerAngle: typeof r.coneInnerAngle < "u" ? r.coneInnerAngle : l.coneInnerAngle,
                    coneOuterAngle: typeof r.coneOuterAngle < "u" ? r.coneOuterAngle : l.coneOuterAngle,
                    coneOuterGain: typeof r.coneOuterGain < "u" ? r.coneOuterGain : l.coneOuterGain,
                    distanceModel: typeof r.distanceModel < "u" ? r.distanceModel : l.distanceModel,
                    maxDistance: typeof r.maxDistance < "u" ? r.maxDistance : l.maxDistance,
                    refDistance: typeof r.refDistance < "u" ? r.refDistance : l.refDistance,
                    rolloffFactor: typeof r.rolloffFactor < "u" ? r.rolloffFactor : l.rolloffFactor,
                    panningModel: typeof r.panningModel < "u" ? r.panningModel : l.panningModel
                };
                var u = s._panner;
                u ? (u.coneInnerAngle = l.coneInnerAngle, u.coneOuterAngle = l.coneOuterAngle, u.coneOuterGain = l.coneOuterGain, u.distanceModel = l.distanceModel, u.maxDistance = l.maxDistance, u.refDistance = l.refDistance, u.rolloffFactor = l.rolloffFactor, u.panningModel = l.panningModel) : (s._pos || (s._pos = t._pos || [
                    0,
                    0,
                    -0.5
                ]), n1(s, "spatial"));
            }
            return t;
        }, Sound.prototype.init = function(t) {
            return function() {
                var e = this, r = e._parent;
                e._orientation = r._orientation, e._stereo = r._stereo, e._pos = r._pos, e._pannerAttr = r._pannerAttr, t.call(this), e._stereo ? r.stereo(e._stereo) : e._pos && r.pos(e._pos[0], e._pos[1], e._pos[2], e._id);
            };
        }(Sound.prototype.init), Sound.prototype.reset = function(t) {
            return function() {
                var e = this, r = e._parent;
                return e._orientation = r._orientation, e._stereo = r._stereo, e._pos = r._pos, e._pannerAttr = r._pannerAttr, e._stereo ? r.stereo(e._stereo) : e._pos ? r.pos(e._pos[0], e._pos[1], e._pos[2], e._id) : e._panner && (e._panner.disconnect(0), e._panner = void 0, r._refreshBuffer(e)), t.call(this);
            };
        }(Sound.prototype.reset);
        var n1 = function(t, e) {
            e = e || "spatial", e === "spatial" ? (t._panner = Howler.ctx.createPanner(), t._panner.coneInnerAngle = t._pannerAttr.coneInnerAngle, t._panner.coneOuterAngle = t._pannerAttr.coneOuterAngle, t._panner.coneOuterGain = t._pannerAttr.coneOuterGain, t._panner.distanceModel = t._pannerAttr.distanceModel, t._panner.maxDistance = t._pannerAttr.maxDistance, t._panner.refDistance = t._pannerAttr.refDistance, t._panner.rolloffFactor = t._pannerAttr.rolloffFactor, t._panner.panningModel = t._pannerAttr.panningModel, typeof t._panner.positionX < "u" ? (t._panner.positionX.setValueAtTime(t._pos[0], Howler.ctx.currentTime), t._panner.positionY.setValueAtTime(t._pos[1], Howler.ctx.currentTime), t._panner.positionZ.setValueAtTime(t._pos[2], Howler.ctx.currentTime)) : t._panner.setPosition(t._pos[0], t._pos[1], t._pos[2]), typeof t._panner.orientationX < "u" ? (t._panner.orientationX.setValueAtTime(t._orientation[0], Howler.ctx.currentTime), t._panner.orientationY.setValueAtTime(t._orientation[1], Howler.ctx.currentTime), t._panner.orientationZ.setValueAtTime(t._orientation[2], Howler.ctx.currentTime)) : t._panner.setOrientation(t._orientation[0], t._orientation[1], t._orientation[2])) : (t._panner = Howler.ctx.createStereoPanner(), t._panner.pan.setValueAtTime(t._stereo, Howler.ctx.currentTime)), t._panner.connect(t._node), t._paused || t._parent.pause(t._id, !0).play(t._id, !0);
        };
    })();
});
var iL = en((Yke, rL)=>{
    "use strict";
    function zQ(n1) {
        for(var t = new Array(n1), e = 0; e < n1; ++e)t[e] = e;
        return t;
    }
    rL.exports = zQ;
});
var oL = en((Xke, sL)=>{
    sL.exports = function(n1) {
        return n1 != null && (nL(n1) || VQ(n1) || !!n1._isBuffer);
    };
    function nL(n1) {
        return !!n1.constructor && typeof n1.constructor.isBuffer == "function" && n1.constructor.isBuffer(n1);
    }
    function VQ(n1) {
        return typeof n1.readFloatLE == "function" && typeof n1.slice == "function" && nL(n1.slice(0, 0));
    }
});
var Tf = en((Qke, aL)=>{
    var UQ = iL(), GQ = oL(), jQ = typeof Float64Array < "u";
    function HQ(n1, t) {
        return n1[0] - t[0];
    }
    function WQ() {
        var n1 = this.stride, t = new Array(n1.length), e;
        for(e = 0; e < t.length; ++e)t[e] = [
            Math.abs(n1[e]),
            e
        ];
        t.sort(HQ);
        var r = new Array(t.length);
        for(e = 0; e < r.length; ++e)r[e] = t[e][1];
        return r;
    }
    function qQ(n1, t) {
        var e = [
            "View",
            t,
            "d",
            n1
        ].join("");
        t < 0 && (e = "View_Nil" + n1);
        var r = n1 === "generic";
        if (t === -1) {
            var i = "function " + e + "(a){this.data=a;};var proto=" + e + ".prototype;proto.dtype='" + n1 + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + e + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + e + "(a){return new " + e + "(a);}", m = new Function(i);
            return m();
        } else if (t === 0) {
            var i = "function " + e + "(a,d) {this.data = a;this.offset = d};var proto=" + e + ".prototype;proto.dtype='" + n1 + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + e + "_copy() {return new " + e + "(this.data,this.offset)};proto.pick=function " + e + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + e + "_get(){return " + (r ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + e + "_set(v){return " + (r ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + e + "(a,b,c,d){return new " + e + "(a,d)}", m = new Function("TrivialArray", i);
            return m(Ux[n1][0]);
        }
        var i = [
            "'use strict'"
        ], s = UQ(t), o = s.map(function(g) {
            return "i" + g;
        }), a = "this.offset+" + s.map(function(g) {
            return "this.stride[" + g + "]*i" + g;
        }).join("+"), l = s.map(function(g) {
            return "b" + g;
        }).join(","), u = s.map(function(g) {
            return "c" + g;
        }).join(",");
        i.push("function " + e + "(a," + l + "," + u + ",d){this.data=a", "this.shape=[" + l + "]", "this.stride=[" + u + "]", "this.offset=d|0}", "var proto=" + e + ".prototype", "proto.dtype='" + n1 + "'", "proto.dimension=" + t), i.push("Object.defineProperty(proto,'size',{get:function " + e + "_size(){return " + s.map(function(g) {
            return "this.shape[" + g + "]";
        }).join("*"), "}})"), t === 1 ? i.push("proto.order=[0]") : (i.push("Object.defineProperty(proto,'order',{get:"), t < 4 ? (i.push("function " + e + "_order(){"), t === 2 ? i.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})") : t === 3 && i.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})")) : i.push("ORDER})")), i.push("proto.set=function " + e + "_set(" + o.join(",") + ",v){"), r ? i.push("return this.data.set(" + a + ",v)}") : i.push("return this.data[" + a + "]=v}"), i.push("proto.get=function " + e + "_get(" + o.join(",") + "){"), r ? i.push("return this.data.get(" + a + ")}") : i.push("return this.data[" + a + "]}"), i.push("proto.index=function " + e + "_index(", o.join(), "){return " + a + "}"), i.push("proto.hi=function " + e + "_hi(" + o.join(",") + "){return new " + e + "(this.data," + s.map(function(g) {
            return [
                "(typeof i",
                g,
                "!=='number'||i",
                g,
                "<0)?this.shape[",
                g,
                "]:i",
                g,
                "|0"
            ].join("");
        }).join(",") + "," + s.map(function(g) {
            return "this.stride[" + g + "]";
        }).join(",") + ",this.offset)}");
        var c = s.map(function(g) {
            return "a" + g + "=this.shape[" + g + "]";
        }), d = s.map(function(g) {
            return "c" + g + "=this.stride[" + g + "]";
        });
        i.push("proto.lo=function " + e + "_lo(" + o.join(",") + "){var b=this.offset,d=0," + c.join(",") + "," + d.join(","));
        for(var h = 0; h < t; ++h)i.push("if(typeof i" + h + "==='number'&&i" + h + ">=0){d=i" + h + "|0;b+=c" + h + "*d;a" + h + "-=d}");
        i.push("return new " + e + "(this.data," + s.map(function(g) {
            return "a" + g;
        }).join(",") + "," + s.map(function(g) {
            return "c" + g;
        }).join(",") + ",b)}"), i.push("proto.step=function " + e + "_step(" + o.join(",") + "){var " + s.map(function(g) {
            return "a" + g + "=this.shape[" + g + "]";
        }).join(",") + "," + s.map(function(g) {
            return "b" + g + "=this.stride[" + g + "]";
        }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");
        for(var h = 0; h < t; ++h)i.push("if(typeof i" + h + "==='number'){d=i" + h + "|0;if(d<0){c+=b" + h + "*(a" + h + "-1);a" + h + "=ceil(-a" + h + "/d)}else{a" + h + "=ceil(a" + h + "/d)}b" + h + "*=d}");
        i.push("return new " + e + "(this.data," + s.map(function(g) {
            return "a" + g;
        }).join(",") + "," + s.map(function(g) {
            return "b" + g;
        }).join(",") + ",c)}");
        for(var f = new Array(t), p = new Array(t), h = 0; h < t; ++h)f[h] = "a[i" + h + "]", p[h] = "b[i" + h + "]";
        i.push("proto.transpose=function " + e + "_transpose(" + o + "){" + o.map(function(g, y) {
            return g + "=(" + g + "===undefined?" + y + ":" + g + "|0)";
        }).join(";"), "var a=this.shape,b=this.stride;return new " + e + "(this.data," + f.join(",") + "," + p.join(",") + ",this.offset)}"), i.push("proto.pick=function " + e + "_pick(" + o + "){var a=[],b=[],c=this.offset");
        for(var h = 0; h < t; ++h)i.push("if(typeof i" + h + "==='number'&&i" + h + ">=0){c=(c+this.stride[" + h + "]*i" + h + ")|0}else{a.push(this.shape[" + h + "]);b.push(this.stride[" + h + "])}");
        i.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}"), i.push("return function construct_" + e + "(data,shape,stride,offset){return new " + e + "(data," + s.map(function(g) {
            return "shape[" + g + "]";
        }).join(",") + "," + s.map(function(g) {
            return "stride[" + g + "]";
        }).join(",") + ",offset)}");
        var m = new Function("CTOR_LIST", "ORDER", i.join(`
`));
        return m(Ux[n1], WQ);
    }
    function YQ(n1) {
        if (GQ(n1)) return "buffer";
        if (jQ) switch(Object.prototype.toString.call(n1)){
            case "[object Float64Array]":
                return "float64";
            case "[object Float32Array]":
                return "float32";
            case "[object Int8Array]":
                return "int8";
            case "[object Int16Array]":
                return "int16";
            case "[object Int32Array]":
                return "int32";
            case "[object Uint8Array]":
                return "uint8";
            case "[object Uint16Array]":
                return "uint16";
            case "[object Uint32Array]":
                return "uint32";
            case "[object Uint8ClampedArray]":
                return "uint8_clamped";
            case "[object BigInt64Array]":
                return "bigint64";
            case "[object BigUint64Array]":
                return "biguint64";
        }
        return Array.isArray(n1) ? "array" : "generic";
    }
    var Ux = {
        float32: [],
        float64: [],
        int8: [],
        int16: [],
        int32: [],
        uint8: [],
        uint16: [],
        uint32: [],
        array: [],
        uint8_clamped: [],
        bigint64: [],
        biguint64: [],
        buffer: [],
        generic: []
    };
    function XQ(n1, t, e, r) {
        if (n1 === void 0) {
            var u = Ux.array[0];
            return u([]);
        } else typeof n1 == "number" && (n1 = [
            n1
        ]);
        t === void 0 && (t = [
            n1.length
        ]);
        var i = t.length;
        if (e === void 0) {
            e = new Array(i);
            for(var s = i - 1, o = 1; s >= 0; --s)e[s] = o, o *= t[s];
        }
        if (r === void 0) {
            r = 0;
            for(var s = 0; s < i; ++s)e[s] < 0 && (r -= (t[s] - 1) * e[s]);
        }
        for(var a = YQ(n1), l = Ux[a]; l.length <= i + 1;)l.push(qQ(a, l.length - 1));
        var u = l[i + 1];
        return u(n1, t, e, r);
    }
    aL.exports = XQ;
});
var cL = en((Kke, lL)=>{
    "use strict";
    function QQ(n1, t) {
        for(var e = 1, r = n1.length, i = n1[0], s = n1[0], o = 1; o < r; ++o)if (s = i, i = n1[o], t(i, s)) {
            if (o === e) {
                e++;
                continue;
            }
            n1[e++] = i;
        }
        return n1.length = e, n1;
    }
    function KQ(n1) {
        for(var t = 1, e = n1.length, r = n1[0], i = n1[0], s = 1; s < e; ++s, i = r)if (i = r, r = n1[s], r !== i) {
            if (s === t) {
                t++;
                continue;
            }
            n1[t++] = r;
        }
        return n1.length = t, n1;
    }
    function ZQ(n1, t, e) {
        return n1.length === 0 ? n1 : t ? (e || n1.sort(t), QQ(n1, t)) : (e || n1.sort(), KQ(n1));
    }
    lL.exports = ZQ;
});
var hL = en((Zke, dL)=>{
    "use strict";
    var JQ = cL();
    function uL(n1, t, e) {
        var r = n1.length, i = t.arrayArgs.length, s = t.indexArgs.length > 0, o = [], a = [], l = 0, u = 0, c, d;
        for(c = 0; c < r; ++c)a.push([
            "i",
            c,
            "=0"
        ].join(""));
        for(d = 0; d < i; ++d)for(c = 0; c < r; ++c)u = l, l = n1[c], c === 0 ? a.push([
            "d",
            d,
            "s",
            c,
            "=t",
            d,
            "p",
            l
        ].join("")) : a.push([
            "d",
            d,
            "s",
            c,
            "=(t",
            d,
            "p",
            l,
            "-s",
            u,
            "*t",
            d,
            "p",
            u,
            ")"
        ].join(""));
        for(a.length > 0 && o.push("var " + a.join(",")), c = r - 1; c >= 0; --c)l = n1[c], o.push([
            "for(i",
            c,
            "=0;i",
            c,
            "<s",
            l,
            ";++i",
            c,
            "){"
        ].join(""));
        for(o.push(e), c = 0; c < r; ++c){
            for(u = l, l = n1[c], d = 0; d < i; ++d)o.push([
                "p",
                d,
                "+=d",
                d,
                "s",
                c
            ].join(""));
            s && (c > 0 && o.push([
                "index[",
                u,
                "]-=s",
                u
            ].join("")), o.push([
                "++index[",
                l,
                "]"
            ].join(""))), o.push("}");
        }
        return o.join(`
`);
    }
    function $Q(n1, t, e, r) {
        for(var i = t.length, s = e.arrayArgs.length, o = e.blockSize, a = e.indexArgs.length > 0, l = [], u = 0; u < s; ++u)l.push([
            "var offset",
            u,
            "=p",
            u
        ].join(""));
        for(var u = n1; u < i; ++u)l.push([
            "for(var j" + u + "=SS[",
            t[u],
            "]|0;j",
            u,
            ">0;){"
        ].join("")), l.push([
            "if(j",
            u,
            "<",
            o,
            "){"
        ].join("")), l.push([
            "s",
            t[u],
            "=j",
            u
        ].join("")), l.push([
            "j",
            u,
            "=0"
        ].join("")), l.push([
            "}else{s",
            t[u],
            "=",
            o
        ].join("")), l.push([
            "j",
            u,
            "-=",
            o,
            "}"
        ].join("")), a && l.push([
            "index[",
            t[u],
            "]=j",
            u
        ].join(""));
        for(var u = 0; u < s; ++u){
            for(var c = [
                "offset" + u
            ], d = n1; d < i; ++d)c.push([
                "j",
                d,
                "*t",
                u,
                "p",
                t[d]
            ].join(""));
            l.push([
                "p",
                u,
                "=(",
                c.join("+"),
                ")"
            ].join(""));
        }
        l.push(uL(t, e, r));
        for(var u = n1; u < i; ++u)l.push("}");
        return l.join(`
`);
    }
    function eK(n1) {
        for(var t = 0, e = n1[0].length; t < e;){
            for(var r = 1; r < n1.length; ++r)if (n1[r][t] !== n1[0][t]) return t;
            ++t;
        }
        return t;
    }
    function R_(n1, t, e) {
        for(var r = n1.body, i = [], s = [], o = 0; o < n1.args.length; ++o){
            var a = n1.args[o];
            if (!(a.count <= 0)) {
                var l = new RegExp(a.name, "g"), u = "", c = t.arrayArgs.indexOf(o);
                switch(t.argTypes[o]){
                    case "offset":
                        var d = t.offsetArgIndex.indexOf(o), h = t.offsetArgs[d];
                        c = h.array, u = "+q" + d;
                    case "array":
                        u = "p" + c + u;
                        var f = "l" + o, p = "a" + c;
                        if (t.arrayBlockIndices[c] === 0) a.count === 1 ? e[c] === "generic" ? a.lvalue ? (i.push([
                            "var ",
                            f,
                            "=",
                            p,
                            ".get(",
                            u,
                            ")"
                        ].join("")), r = r.replace(l, f), s.push([
                            p,
                            ".set(",
                            u,
                            ",",
                            f,
                            ")"
                        ].join(""))) : r = r.replace(l, [
                            p,
                            ".get(",
                            u,
                            ")"
                        ].join("")) : r = r.replace(l, [
                            p,
                            "[",
                            u,
                            "]"
                        ].join("")) : e[c] === "generic" ? (i.push([
                            "var ",
                            f,
                            "=",
                            p,
                            ".get(",
                            u,
                            ")"
                        ].join("")), r = r.replace(l, f), a.lvalue && s.push([
                            p,
                            ".set(",
                            u,
                            ",",
                            f,
                            ")"
                        ].join(""))) : (i.push([
                            "var ",
                            f,
                            "=",
                            p,
                            "[",
                            u,
                            "]"
                        ].join("")), r = r.replace(l, f), a.lvalue && s.push([
                            p,
                            "[",
                            u,
                            "]=",
                            f
                        ].join("")));
                        else {
                            for(var m = [
                                a.name
                            ], g = [
                                u
                            ], y = 0; y < Math.abs(t.arrayBlockIndices[c]); y++)m.push("\\s*\\[([^\\]]+)\\]"), g.push("$" + (y + 1) + "*t" + c + "b" + y);
                            if (l = new RegExp(m.join(""), "g"), u = g.join("+"), e[c] === "generic") throw new Error("cwise: Generic arrays not supported in combination with blocks!");
                            r = r.replace(l, [
                                p,
                                "[",
                                u,
                                "]"
                            ].join(""));
                        }
                        break;
                    case "scalar":
                        r = r.replace(l, "Y" + t.scalarArgs.indexOf(o));
                        break;
                    case "index":
                        r = r.replace(l, "index");
                        break;
                    case "shape":
                        r = r.replace(l, "shape");
                        break;
                }
            }
        }
        return [
            i.join(`
`),
            r,
            s.join(`
`)
        ].join(`
`).trim();
    }
    function tK(n1) {
        for(var t = new Array(n1.length), e = !0, r = 0; r < n1.length; ++r){
            var i = n1[r], s = i.match(/\d+/);
            s ? s = s[0] : s = "", i.charAt(0) === 0 ? t[r] = "u" + i.charAt(1) + s : t[r] = i.charAt(0) + s, r > 0 && (e = e && t[r] === t[r - 1]);
        }
        return e ? t[0] : t.join("");
    }
    function rK(n1, t) {
        for(var e = t[1].length - Math.abs(n1.arrayBlockIndices[0]) | 0, r = new Array(n1.arrayArgs.length), i = new Array(n1.arrayArgs.length), s = 0; s < n1.arrayArgs.length; ++s)i[s] = t[2 * s], r[s] = t[2 * s + 1];
        for(var o = [], a = [], l = [], u = [], c = [], s = 0; s < n1.arrayArgs.length; ++s){
            n1.arrayBlockIndices[s] < 0 ? (l.push(0), u.push(e), o.push(e), a.push(e + n1.arrayBlockIndices[s])) : (l.push(n1.arrayBlockIndices[s]), u.push(n1.arrayBlockIndices[s] + e), o.push(0), a.push(n1.arrayBlockIndices[s]));
            for(var d = [], h = 0; h < r[s].length; h++)l[s] <= r[s][h] && r[s][h] < u[s] && d.push(r[s][h] - l[s]);
            c.push(d);
        }
        for(var f = [
            "SS"
        ], p = [
            "'use strict'"
        ], m = [], h = 0; h < e; ++h)m.push([
            "s",
            h,
            "=SS[",
            h,
            "]"
        ].join(""));
        for(var s = 0; s < n1.arrayArgs.length; ++s){
            f.push("a" + s), f.push("t" + s), f.push("p" + s);
            for(var h = 0; h < e; ++h)m.push([
                "t",
                s,
                "p",
                h,
                "=t",
                s,
                "[",
                l[s] + h,
                "]"
            ].join(""));
            for(var h = 0; h < Math.abs(n1.arrayBlockIndices[s]); ++h)m.push([
                "t",
                s,
                "b",
                h,
                "=t",
                s,
                "[",
                o[s] + h,
                "]"
            ].join(""));
        }
        for(var s = 0; s < n1.scalarArgs.length; ++s)f.push("Y" + s);
        if (n1.shapeArgs.length > 0 && m.push("shape=SS.slice(0)"), n1.indexArgs.length > 0) {
            for(var g = new Array(e), s = 0; s < e; ++s)g[s] = "0";
            m.push([
                "index=[",
                g.join(","),
                "]"
            ].join(""));
        }
        for(var s = 0; s < n1.offsetArgs.length; ++s){
            for(var y = n1.offsetArgs[s], v = [], h = 0; h < y.offset.length; ++h)y.offset[h] !== 0 && (y.offset[h] === 1 ? v.push([
                "t",
                y.array,
                "p",
                h
            ].join("")) : v.push([
                y.offset[h],
                "*t",
                y.array,
                "p",
                h
            ].join("")));
            v.length === 0 ? m.push("q" + s + "=0") : m.push([
                "q",
                s,
                "=",
                v.join("+")
            ].join(""));
        }
        var x = JQ([].concat(n1.pre.thisVars).concat(n1.body.thisVars).concat(n1.post.thisVars));
        m = m.concat(x), m.length > 0 && p.push("var " + m.join(","));
        for(var s = 0; s < n1.arrayArgs.length; ++s)p.push("p" + s + "|=0");
        n1.pre.body.length > 3 && p.push(R_(n1.pre, n1, i));
        var S = R_(n1.body, n1, i), w = eK(c);
        w < e ? p.push($Q(w, c[0], n1, S)) : p.push(uL(c[0], n1, S)), n1.post.body.length > 3 && p.push(R_(n1.post, n1, i)), n1.debug && console.log("-----Generated cwise routine for ", t, `:
` + p.join(`
`) + `
----------`);
        var A = [
            n1.funcName || "unnamed",
            "_cwise_loop_",
            r[0].join("s"),
            "m",
            w,
            tK(i)
        ].join(""), E = new Function([
            "function ",
            A,
            "(",
            f.join(","),
            "){",
            p.join(`
`),
            "} return ",
            A
        ].join(""));
        return E();
    }
    dL.exports = rK;
});
var pL = en((Jke, fL)=>{
    "use strict";
    var iK = hL();
    function nK(n1) {
        var t = [
            "'use strict'",
            "var CACHED={}"
        ], e = [], r = n1.funcName + "_cwise_thunk";
        t.push([
            "return function ",
            r,
            "(",
            n1.shimArgs.join(","),
            "){"
        ].join(""));
        for(var i = [], s = [], o = [
            [
                "array",
                n1.arrayArgs[0],
                ".shape.slice(",
                Math.max(0, n1.arrayBlockIndices[0]),
                n1.arrayBlockIndices[0] < 0 ? "," + n1.arrayBlockIndices[0] + ")" : ")"
            ].join("")
        ], a = [], l = [], u = 0; u < n1.arrayArgs.length; ++u){
            var c = n1.arrayArgs[u];
            e.push([
                "t",
                c,
                "=array",
                c,
                ".dtype,",
                "r",
                c,
                "=array",
                c,
                ".order"
            ].join("")), i.push("t" + c), i.push("r" + c), s.push("t" + c), s.push("r" + c + ".join()"), o.push("array" + c + ".data"), o.push("array" + c + ".stride"), o.push("array" + c + ".offset|0"), u > 0 && (a.push("array" + n1.arrayArgs[0] + ".shape.length===array" + c + ".shape.length+" + (Math.abs(n1.arrayBlockIndices[0]) - Math.abs(n1.arrayBlockIndices[u]))), l.push("array" + n1.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, n1.arrayBlockIndices[0]) + "]===array" + c + ".shape[shapeIndex+" + Math.max(0, n1.arrayBlockIndices[u]) + "]"));
        }
        n1.arrayArgs.length > 1 && (t.push("if (!(" + a.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')"), t.push("for(var shapeIndex=array" + n1.arrayArgs[0] + ".shape.length-" + Math.abs(n1.arrayBlockIndices[0]) + "; shapeIndex-->0;) {"), t.push("if (!(" + l.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')"), t.push("}"));
        for(var u = 0; u < n1.scalarArgs.length; ++u)o.push("scalar" + n1.scalarArgs[u]);
        e.push([
            "type=[",
            s.join(","),
            "].join()"
        ].join("")), e.push("proc=CACHED[type]"), t.push("var " + e.join(",")), t.push([
            "if(!proc){",
            "CACHED[type]=proc=compile([",
            i.join(","),
            "])}",
            "return proc(",
            o.join(","),
            ")}"
        ].join("")), n1.debug && console.log(`-----Generated thunk:
` + t.join(`
`) + `
----------`);
        var d = new Function("compile", t.join(`
`));
        return d(iK.bind(void 0, n1));
    }
    fL.exports = nK;
});
var gL = en(($ke, mL)=>{
    "use strict";
    var sK = pL();
    function oK() {
        this.argTypes = [], this.shimArgs = [], this.arrayArgs = [], this.arrayBlockIndices = [], this.scalarArgs = [], this.offsetArgs = [], this.offsetArgIndex = [], this.indexArgs = [], this.shapeArgs = [], this.funcName = "", this.pre = null, this.body = null, this.post = null, this.debug = !1;
    }
    function aK(n1) {
        var t = new oK;
        t.pre = n1.pre, t.body = n1.body, t.post = n1.post;
        var e = n1.args.slice(0);
        t.argTypes = e;
        for(var r = 0; r < e.length; ++r){
            var i = e[r];
            if (i === "array" || typeof i == "object" && i.blockIndices) {
                if (t.argTypes[r] = "array", t.arrayArgs.push(r), t.arrayBlockIndices.push(i.blockIndices ? i.blockIndices : 0), t.shimArgs.push("array" + r), r < t.pre.args.length && t.pre.args[r].count > 0) throw new Error("cwise: pre() block may not reference array args");
                if (r < t.post.args.length && t.post.args[r].count > 0) throw new Error("cwise: post() block may not reference array args");
            } else if (i === "scalar") t.scalarArgs.push(r), t.shimArgs.push("scalar" + r);
            else if (i === "index") {
                if (t.indexArgs.push(r), r < t.pre.args.length && t.pre.args[r].count > 0) throw new Error("cwise: pre() block may not reference array index");
                if (r < t.body.args.length && t.body.args[r].lvalue) throw new Error("cwise: body() block may not write to array index");
                if (r < t.post.args.length && t.post.args[r].count > 0) throw new Error("cwise: post() block may not reference array index");
            } else if (i === "shape") {
                if (t.shapeArgs.push(r), r < t.pre.args.length && t.pre.args[r].lvalue) throw new Error("cwise: pre() block may not write to array shape");
                if (r < t.body.args.length && t.body.args[r].lvalue) throw new Error("cwise: body() block may not write to array shape");
                if (r < t.post.args.length && t.post.args[r].lvalue) throw new Error("cwise: post() block may not write to array shape");
            } else if (typeof i == "object" && i.offset) t.argTypes[r] = "offset", t.offsetArgs.push({
                array: i.array,
                offset: i.offset
            }), t.offsetArgIndex.push(r);
            else throw new Error("cwise: Unknown argument type " + e[r]);
        }
        if (t.arrayArgs.length <= 0) throw new Error("cwise: No array arguments specified");
        if (t.pre.args.length > e.length) throw new Error("cwise: Too many arguments in pre() block");
        if (t.body.args.length > e.length) throw new Error("cwise: Too many arguments in body() block");
        if (t.post.args.length > e.length) throw new Error("cwise: Too many arguments in post() block");
        return t.debug = !!n1.printCode || !!n1.debug, t.funcName = n1.funcName || "cwise", t.blockSize = n1.blockSize || 64, sK(t);
    }
    mL.exports = aK;
});
var Mf = en((At)=>{
    "use strict";
    var Fn = gL(), Gx = {
        body: "",
        args: [],
        thisVars: [],
        localVars: []
    };
    function L_(n1) {
        if (!n1) return Gx;
        for(var t = 0; t < n1.args.length; ++t){
            var e = n1.args[t];
            t === 0 ? n1.args[t] = {
                name: e,
                lvalue: !0,
                rvalue: !!n1.rvalue,
                count: n1.count || 1
            } : n1.args[t] = {
                name: e,
                lvalue: !1,
                rvalue: !0,
                count: 1
            };
        }
        return n1.thisVars || (n1.thisVars = []), n1.localVars || (n1.localVars = []), n1;
    }
    function lK(n1) {
        return Fn({
            args: n1.args,
            pre: L_(n1.pre),
            body: L_(n1.body),
            post: L_(n1.proc),
            funcName: n1.funcName
        });
    }
    function Br(n1) {
        for(var t = [], e = 0; e < n1.args.length; ++e)t.push("a" + e);
        var r = new Function("P", [
            "return function ",
            n1.funcName,
            "_ndarrayops(",
            t.join(","),
            ") {P(",
            t.join(","),
            ");return a0}"
        ].join(""));
        return r(lK(n1));
    }
    var yL = {
        add: "+",
        sub: "-",
        mul: "*",
        div: "/",
        mod: "%",
        band: "&",
        bor: "|",
        bxor: "^",
        lshift: "<<",
        rshift: ">>",
        rrshift: ">>>"
    };
    (function() {
        for(var n1 in yL){
            var t = yL[n1];
            At[n1] = Br({
                args: [
                    "array",
                    "array",
                    "array"
                ],
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=b" + t + "c"
                },
                funcName: n1
            }), At[n1 + "eq"] = Br({
                args: [
                    "array",
                    "array"
                ],
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a" + t + "=b"
                },
                rvalue: !0,
                funcName: n1 + "eq"
            }), At[n1 + "s"] = Br({
                args: [
                    "array",
                    "array",
                    "scalar"
                ],
                body: {
                    args: [
                        "a",
                        "b",
                        "s"
                    ],
                    body: "a=b" + t + "s"
                },
                funcName: n1 + "s"
            }), At[n1 + "seq"] = Br({
                args: [
                    "array",
                    "scalar"
                ],
                body: {
                    args: [
                        "a",
                        "s"
                    ],
                    body: "a" + t + "=s"
                },
                rvalue: !0,
                funcName: n1 + "seq"
            });
        }
    })();
    var vL = {
        not: "!",
        bnot: "~",
        neg: "-",
        recip: "1.0/"
    };
    (function() {
        for(var n1 in vL){
            var t = vL[n1];
            At[n1] = Br({
                args: [
                    "array",
                    "array"
                ],
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=" + t + "b"
                },
                funcName: n1
            }), At[n1 + "eq"] = Br({
                args: [
                    "array"
                ],
                body: {
                    args: [
                        "a"
                    ],
                    body: "a=" + t + "a"
                },
                rvalue: !0,
                count: 2,
                funcName: n1 + "eq"
            });
        }
    })();
    var xL = {
        and: "&&",
        or: "||",
        eq: "===",
        neq: "!==",
        lt: "<",
        gt: ">",
        leq: "<=",
        geq: ">="
    };
    (function() {
        for(var n1 in xL){
            var t = xL[n1];
            At[n1] = Br({
                args: [
                    "array",
                    "array",
                    "array"
                ],
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=b" + t + "c"
                },
                funcName: n1
            }), At[n1 + "s"] = Br({
                args: [
                    "array",
                    "array",
                    "scalar"
                ],
                body: {
                    args: [
                        "a",
                        "b",
                        "s"
                    ],
                    body: "a=b" + t + "s"
                },
                funcName: n1 + "s"
            }), At[n1 + "eq"] = Br({
                args: [
                    "array",
                    "array"
                ],
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=a" + t + "b"
                },
                rvalue: !0,
                count: 2,
                funcName: n1 + "eq"
            }), At[n1 + "seq"] = Br({
                args: [
                    "array",
                    "scalar"
                ],
                body: {
                    args: [
                        "a",
                        "s"
                    ],
                    body: "a=a" + t + "s"
                },
                rvalue: !0,
                count: 2,
                funcName: n1 + "seq"
            });
        }
    })();
    var bL = [
        "abs",
        "acos",
        "asin",
        "atan",
        "ceil",
        "cos",
        "exp",
        "floor",
        "log",
        "round",
        "sin",
        "sqrt",
        "tan"
    ];
    (function() {
        for(var n1 = 0; n1 < bL.length; ++n1){
            var t = bL[n1];
            At[t] = Br({
                args: [
                    "array",
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=this_f(b)",
                    thisVars: [
                        "this_f"
                    ]
                },
                funcName: t
            }), At[t + "eq"] = Br({
                args: [
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a"
                    ],
                    body: "a=this_f(a)",
                    thisVars: [
                        "this_f"
                    ]
                },
                rvalue: !0,
                count: 2,
                funcName: t + "eq"
            });
        }
    })();
    var SL = [
        "max",
        "min",
        "atan2",
        "pow"
    ];
    (function() {
        for(var n1 = 0; n1 < SL.length; ++n1){
            var t = SL[n1];
            At[t] = Br({
                args: [
                    "array",
                    "array",
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=this_f(b,c)",
                    thisVars: [
                        "this_f"
                    ]
                },
                funcName: t
            }), At[t + "s"] = Br({
                args: [
                    "array",
                    "array",
                    "scalar"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=this_f(b,c)",
                    thisVars: [
                        "this_f"
                    ]
                },
                funcName: t + "s"
            }), At[t + "eq"] = Br({
                args: [
                    "array",
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=this_f(a,b)",
                    thisVars: [
                        "this_f"
                    ]
                },
                rvalue: !0,
                count: 2,
                funcName: t + "eq"
            }), At[t + "seq"] = Br({
                args: [
                    "array",
                    "scalar"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=this_f(a,b)",
                    thisVars: [
                        "this_f"
                    ]
                },
                rvalue: !0,
                count: 2,
                funcName: t + "seq"
            });
        }
    })();
    var wL = [
        "atan2",
        "pow"
    ];
    (function() {
        for(var n1 = 0; n1 < wL.length; ++n1){
            var t = wL[n1];
            At[t + "op"] = Br({
                args: [
                    "array",
                    "array",
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=this_f(c,b)",
                    thisVars: [
                        "this_f"
                    ]
                },
                funcName: t + "op"
            }), At[t + "ops"] = Br({
                args: [
                    "array",
                    "array",
                    "scalar"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b",
                        "c"
                    ],
                    body: "a=this_f(c,b)",
                    thisVars: [
                        "this_f"
                    ]
                },
                funcName: t + "ops"
            }), At[t + "opeq"] = Br({
                args: [
                    "array",
                    "array"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=this_f(b,a)",
                    thisVars: [
                        "this_f"
                    ]
                },
                rvalue: !0,
                count: 2,
                funcName: t + "opeq"
            }), At[t + "opseq"] = Br({
                args: [
                    "array",
                    "scalar"
                ],
                pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: [
                        "this_f"
                    ]
                },
                body: {
                    args: [
                        "a",
                        "b"
                    ],
                    body: "a=this_f(b,a)",
                    thisVars: [
                        "this_f"
                    ]
                },
                rvalue: !0,
                count: 2,
                funcName: t + "opseq"
            });
        }
    })();
    At.any = Fn({
        args: [
            "array"
        ],
        pre: Gx,
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            body: "if(a){return true}",
            localVars: [],
            thisVars: []
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [],
            body: "return false"
        },
        funcName: "any"
    });
    At.all = Fn({
        args: [
            "array"
        ],
        pre: Gx,
        body: {
            args: [
                {
                    name: "x",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            body: "if(!x){return false}",
            localVars: [],
            thisVars: []
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [],
            body: "return true"
        },
        funcName: "all"
    });
    At.sum = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=0"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            body: "this_s+=a",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return this_s"
        },
        funcName: "sum"
    });
    At.prod = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=1"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            body: "this_s*=a",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return this_s"
        },
        funcName: "prod"
    });
    At.norm2squared = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=0"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            body: "this_s+=a*a",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return this_s"
        },
        funcName: "norm2squared"
    });
    At.norm2 = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=0"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            body: "this_s+=a*a",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return Math.sqrt(this_s)"
        },
        funcName: "norm2"
    });
    At.norminf = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=0"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 4
                }
            ],
            body: "if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return this_s"
        },
        funcName: "norminf"
    });
    At.norm1 = Fn({
        args: [
            "array"
        ],
        pre: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "this_s=0"
        },
        body: {
            args: [
                {
                    name: "a",
                    lvalue: !1,
                    rvalue: !0,
                    count: 3
                }
            ],
            body: "this_s+=a<0?-a:a",
            localVars: [],
            thisVars: [
                "this_s"
            ]
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [
                "this_s"
            ],
            body: "return this_s"
        },
        funcName: "norm1"
    });
    At.sup = Fn({
        args: [
            "array"
        ],
        pre: {
            body: "this_h=-Infinity",
            args: [],
            thisVars: [
                "this_h"
            ],
            localVars: []
        },
        body: {
            body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
            args: [
                {
                    name: "_inline_1_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            thisVars: [
                "this_h"
            ],
            localVars: []
        },
        post: {
            body: "return this_h",
            args: [],
            thisVars: [
                "this_h"
            ],
            localVars: []
        }
    });
    At.inf = Fn({
        args: [
            "array"
        ],
        pre: {
            body: "this_h=Infinity",
            args: [],
            thisVars: [
                "this_h"
            ],
            localVars: []
        },
        body: {
            body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
            args: [
                {
                    name: "_inline_1_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            thisVars: [
                "this_h"
            ],
            localVars: []
        },
        post: {
            body: "return this_h",
            args: [],
            thisVars: [
                "this_h"
            ],
            localVars: []
        }
    });
    At.argmin = Fn({
        args: [
            "index",
            "array",
            "shape"
        ],
        pre: {
            body: "{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
            args: [
                {
                    name: "_inline_0_arg0_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                },
                {
                    name: "_inline_0_arg1_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                },
                {
                    name: "_inline_0_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            thisVars: [
                "this_i",
                "this_v"
            ],
            localVars: []
        },
        body: {
            body: "{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
            args: [
                {
                    name: "_inline_1_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                },
                {
                    name: "_inline_1_arg1_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            thisVars: [
                "this_i",
                "this_v"
            ],
            localVars: [
                "_inline_1_k"
            ]
        },
        post: {
            body: "{return this_i}",
            args: [],
            thisVars: [
                "this_i"
            ],
            localVars: []
        }
    });
    At.argmax = Fn({
        args: [
            "index",
            "array",
            "shape"
        ],
        pre: {
            body: "{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
            args: [
                {
                    name: "_inline_0_arg0_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                },
                {
                    name: "_inline_0_arg1_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                },
                {
                    name: "_inline_0_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            thisVars: [
                "this_i",
                "this_v"
            ],
            localVars: []
        },
        body: {
            body: "{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
            args: [
                {
                    name: "_inline_1_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                },
                {
                    name: "_inline_1_arg1_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 2
                }
            ],
            thisVars: [
                "this_i",
                "this_v"
            ],
            localVars: [
                "_inline_1_k"
            ]
        },
        post: {
            body: "{return this_i}",
            args: [],
            thisVars: [
                "this_i"
            ],
            localVars: []
        }
    });
    At.random = Br({
        args: [
            "array"
        ],
        pre: {
            args: [],
            body: "this_f=Math.random",
            thisVars: [
                "this_f"
            ]
        },
        body: {
            args: [
                "a"
            ],
            body: "a=this_f()",
            thisVars: [
                "this_f"
            ]
        },
        funcName: "random"
    });
    At.assign = Br({
        args: [
            "array",
            "array"
        ],
        body: {
            args: [
                "a",
                "b"
            ],
            body: "a=b"
        },
        funcName: "assign"
    });
    At.assigns = Br({
        args: [
            "array",
            "scalar"
        ],
        body: {
            args: [
                "a",
                "b"
            ],
            body: "a=b"
        },
        funcName: "assigns"
    });
    At.equals = Fn({
        args: [
            "array",
            "array"
        ],
        pre: Gx,
        body: {
            args: [
                {
                    name: "x",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                },
                {
                    name: "y",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                }
            ],
            body: "if(x!==y){return false}",
            localVars: [],
            thisVars: []
        },
        post: {
            args: [],
            localVars: [],
            thisVars: [],
            body: "return true"
        },
        funcName: "equals"
    });
});
var _N = en((x8e, AN)=>{
    AN.exports = function(t, e) {
        for(var r = t.split("."), i = e.split("."), s = 0; s < 3; s++){
            var o = Number(r[s]), a = Number(i[s]);
            if (o > a) return 1;
            if (a > o) return -1;
            if (!isNaN(o) && isNaN(a)) return 1;
            if (isNaN(o) && !isNaN(a)) return -1;
        }
        return 0;
    };
});
var aa = "149";
var qn = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, zN = 0, HE = 1, VN = 2;
var Ty = 1, UN = 2, ep = 3, jn = 0, ai = 1, qi = 2;
var Wt = 0, qa = 1, WE = 2, qE = 3, YE = 4, GN = 5, Au = 100, jN = 101, HN = 102, XE = 103, QE = 104, WN = 200, qN = 201, YN = 202, XN = 203, wM = 204, AM = 205, QN = 206, KN = 207, ZN = 208, JN = 209, $N = 210, eF = 0, tF = 1, rF = 2, wS = 3, iF = 4, nF = 5, sF = 6, oF = 7, _M = 0, aF = 1, lF = 2, Os = 0, cF = 1, uF = 2, dF = 3, hF = 4, fF = 5, EM = 300, Xa = 301, Qa = 302, AS = 303, _S = 304, Qu = 306, Is = 1e3, Ut = 1001, ES = 1002, Et = 1003, KE = 1004;
var zb = 1005;
var Qe = 1006, pF = 1007;
var dc = 1008;
var br = 1009, mF = 1010, gF = 1011, TM = 1012, yF = 1013, Ds = 1014, dr = 1015, sa = 1016, vF = 1017, xF = 1018, Ya = 1020, bF = 1021, Fr = 1023, SF = 1024, wF = 1025, cc = 1026, Ka = 1027, AF = 1028, _F = 1029, Ku = 1030, EF = 1031, nw = 1033, Vb = 33776, Ub = 33777, Gb = 33778, jb = 33779, ZE = 35840, JE = 35841, $E = 35842, eT = 35843, TF = 36196, tT = 37492, rT = 37496, iT = 37808, nT = 37809, sT = 37810, oT = 37811, aT = 37812, lT = 37813, cT = 37814, uT = 37815, dT = 37816, hT = 37817, fT = 37818, pT = 37819, mT = 37820, gT = 37821, Hb = 36492, MF = 36283, yT = 36284, vT = 36285, xT = 36286, sw = 2200, ow = 2201, Ap = 2202, Zg = 2300, Jg = 2301, Wb = 2302, _u = 2400, Eu = 2401, $g = 2402, aw = 2500, CF = 2501;
var dn = 3e3, tt = 3001, Ii = 3200, lw = 3201, PF = 0, DF = 1;
var ao = "srgb", ap = "srgb-linear";
var qb = 7680;
var OF = 519, TS = 35044, MM = 35048;
var bT = "300 es", MS = 1035, ir = class {
    addEventListener(t, e) {
        this._listeners === void 0 && (this._listeners = {});
        let r = this._listeners;
        r[t] === void 0 && (r[t] = []), r[t].indexOf(e) === -1 && r[t].push(e);
    }
    hasEventListener(t, e) {
        if (this._listeners === void 0) return !1;
        let r = this._listeners;
        return r[t] !== void 0 && r[t].indexOf(e) !== -1;
    }
    removeEventListener(t, e) {
        if (this._listeners === void 0) return;
        let i = this._listeners[t];
        if (i !== void 0) {
            let s = i.indexOf(e);
            s !== -1 && i.splice(s, 1);
        }
    }
    dispatchEvent(t) {
        if (this._listeners === void 0) return;
        let r = this._listeners[t.type];
        if (r !== void 0) {
            t.target = this;
            let i = r.slice(0);
            for(let s = 0, o = i.length; s < o; s++)i[s].call(this, t);
            t.target = null;
        }
    }
}, tn = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
], ST = 1234567, rp = Math.PI / 180, lp = 180 / Math.PI;
function rs() {
    let n1 = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
    return (tn[n1 & 255] + tn[n1 >> 8 & 255] + tn[n1 >> 16 & 255] + tn[n1 >> 24 & 255] + "-" + tn[t & 255] + tn[t >> 8 & 255] + "-" + tn[t >> 16 & 15 | 64] + tn[t >> 24 & 255] + "-" + tn[e & 63 | 128] + tn[e >> 8 & 255] + "-" + tn[e >> 16 & 255] + tn[e >> 24 & 255] + tn[r & 255] + tn[r >> 8 & 255] + tn[r >> 16 & 255] + tn[r >> 24 & 255]).toLowerCase();
}
function oi(n1, t, e) {
    return Math.max(t, Math.min(e, n1));
}
function cw(n1, t) {
    return (n1 % t + t) % t;
}
function IF(n1, t, e, r, i) {
    return r + (n1 - t) * (i - r) / (e - t);
}
function RF(n1, t, e) {
    return n1 !== t ? (e - n1) / (t - n1) : 0;
}
function ip(n1, t, e) {
    return (1 - e) * n1 + e * t;
}
function LF(n1, t, e, r) {
    return ip(n1, t, 1 - Math.exp(-e * r));
}
function BF(n1, t = 1) {
    return t - Math.abs(cw(n1, t * 2) - t);
}
function NF(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * (3 - 2 * n1));
}
function FF(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * n1 * (n1 * (n1 * 6 - 15) + 10));
}
function kF(n1, t) {
    return n1 + Math.floor(Math.random() * (t - n1 + 1));
}
function zF(n1, t) {
    return n1 + Math.random() * (t - n1);
}
function VF(n1) {
    return n1 * (.5 - Math.random());
}
function UF(n1) {
    n1 !== void 0 && (ST = n1);
    let t = ST += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function GF(n1) {
    return n1 * rp;
}
function jF(n1) {
    return n1 * lp;
}
function CS(n1) {
    return (n1 & n1 - 1) === 0 && n1 !== 0;
}
function CM(n1) {
    return Math.pow(2, Math.ceil(Math.log(n1) / Math.LN2));
}
function ey(n1) {
    return Math.pow(2, Math.floor(Math.log(n1) / Math.LN2));
}
function HF(n1, t, e, r, i) {
    let s = Math.cos, o = Math.sin, a = s(e / 2), l = o(e / 2), u = s((t + r) / 2), c = o((t + r) / 2), d = s((t - r) / 2), h = o((t - r) / 2), f = s((r - t) / 2), p = o((r - t) / 2);
    switch(i){
        case "XYX":
            n1.set(a * c, l * d, l * h, a * u);
            break;
        case "YZY":
            n1.set(l * h, a * c, l * d, a * u);
            break;
        case "ZXZ":
            n1.set(l * d, l * h, a * c, a * u);
            break;
        case "XZX":
            n1.set(a * c, l * p, l * f, a * u);
            break;
        case "YXY":
            n1.set(l * f, a * c, l * p, a * u);
            break;
        case "ZYZ":
            n1.set(l * p, l * f, a * c, a * u);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
    }
}
function na(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return n1 / 65535;
        case Uint8Array:
            return n1 / 255;
        case Int16Array:
            return Math.max(n1 / 32767, -1);
        case Int8Array:
            return Math.max(n1 / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function ur(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return Math.round(n1 * 65535);
        case Uint8Array:
            return Math.round(n1 * 255);
        case Int16Array:
            return Math.round(n1 * 32767);
        case Int8Array:
            return Math.round(n1 * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
var Se = Object.freeze({
    __proto__: null,
    DEG2RAD: rp,
    RAD2DEG: lp,
    ceilPowerOfTwo: CM,
    clamp: oi,
    damp: LF,
    degToRad: GF,
    denormalize: na,
    euclideanModulo: cw,
    floorPowerOfTwo: ey,
    generateUUID: rs,
    inverseLerp: RF,
    isPowerOfTwo: CS,
    lerp: ip,
    mapLinear: IF,
    normalize: ur,
    pingpong: BF,
    radToDeg: jF,
    randFloat: zF,
    randFloatSpread: VF,
    randInt: kF,
    seededRandom: UF,
    setQuaternionFromProperEuler: HF,
    smootherstep: FF,
    smoothstep: NF
}), N = class {
    constructor(t = 0, e = 0){
        N.prototype.isVector2 = !0, this.x = t, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t) {
        this.x = t;
    }
    get height() {
        return this.y;
    }
    set height(t) {
        this.y = t;
    }
    set(t, e) {
        return this.x = t, this.y = e, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = t.elements;
        return this.x = i[0] * e + i[3] * r + i[6], this.y = i[1] * e + i[4] * r + i[7], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y;
        return e * e + r * r;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this;
    }
    rotateAround(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s = this.x - t.x, o = this.y - t.y;
        return this.x = s * r - o * i + t.x, this.y = s * i + o * r + t.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}, Qt = class {
    constructor(){
        Qt.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s, o, a, l, u) {
        let c = this.elements;
        return c[0] = t, c[1] = i, c[2] = a, c[3] = e, c[4] = s, c[5] = l, c[6] = r, c[7] = o, c[8] = u, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t) {
        let e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s = this.elements, o = r[0], a = r[3], l = r[6], u = r[1], c = r[4], d = r[7], h = r[2], f = r[5], p = r[8], m = i[0], g = i[3], y = i[6], v = i[1], x = i[4], S = i[7], w = i[2], A = i[5], E = i[8];
        return s[0] = o * m + a * v + l * w, s[3] = o * g + a * x + l * A, s[6] = o * y + a * S + l * E, s[1] = u * m + c * v + d * w, s[4] = u * g + c * x + d * A, s[7] = u * y + c * S + d * E, s[2] = h * m + f * v + p * w, s[5] = h * g + f * x + p * A, s[8] = h * y + f * S + p * E, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8];
        return e * o * c - e * a * u - r * s * c + r * a * l + i * s * u - i * o * l;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], d = c * o - a * u, h = a * l - c * s, f = u * s - o * l, p = e * d + r * h + i * f;
        if (p === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let m = 1 / p;
        return t[0] = d * m, t[1] = (i * u - c * r) * m, t[2] = (a * r - i * o) * m, t[3] = h * m, t[4] = (c * e - i * l) * m, t[5] = (i * s - a * e) * m, t[6] = f * m, t[7] = (r * l - u * e) * m, t[8] = (o * e - r * s) * m, this;
    }
    transpose() {
        let t, e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
    getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
    }
    transposeIntoArray(t) {
        let e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
    setUvTransform(t, e, r, i, s, o, a) {
        let l = Math.cos(s), u = Math.sin(s);
        return this.set(r * l, r * u, -r * (l * o + u * a) + o + t, -i * u, i * l, -i * (-u * o + l * a) + a + e, 0, 0, 1), this;
    }
    scale(t, e) {
        return this.premultiply(Yb.makeScale(t, e)), this;
    }
    rotate(t) {
        return this.premultiply(Yb.makeRotation(-t)), this;
    }
    translate(t, e) {
        return this.premultiply(Yb.makeTranslation(t, e)), this;
    }
    makeTranslation(t, e) {
        return this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
    }
    makeRotation(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, r, e, 0, 0, 0, 1), this;
    }
    makeScale(t, e) {
        return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 9; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 9; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}, Yb = new Qt;
function PM(n1) {
    for(let t = n1.length - 1; t >= 0; --t)if (n1[t] >= 65535) return !0;
    return !1;
}
var WF = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function wg(n1, t) {
    return new WF[n1](t);
}
function cp(n1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", n1);
}
function uc(n1) {
    return n1 < .04045 ? n1 * .0773993808 : Math.pow(n1 * .9478672986 + .0521327014, 2.4);
}
function Kg(n1) {
    return n1 < .0031308 ? n1 * 12.92 : 1.055 * Math.pow(n1, .41666) - .055;
}
var Xb = {
    [ao]: {
        [ap]: uc
    },
    [ap]: {
        [ao]: Kg
    }
}, ln = {
    legacyMode: !0,
    get workingColorSpace () {
        return ap;
    },
    set workingColorSpace (n){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(n1, t, e) {
        if (this.legacyMode || t === e || !t || !e) return n1;
        if (Xb[t] && Xb[t][e] !== void 0) {
            let r = Xb[t][e];
            return n1.r = r(n1.r), n1.g = r(n1.g), n1.b = r(n1.b), n1;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(n1, t) {
        return this.convert(n1, this.workingColorSpace, t);
    },
    toWorkingColorSpace: function(n1, t) {
        return this.convert(n1, t, this.workingColorSpace);
    }
}, DM = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, mi = {
    r: 0,
    g: 0,
    b: 0
}, Ms = {
    h: 0,
    s: 0,
    l: 0
}, Ag = {
    h: 0,
    s: 0,
    l: 0
};
function Qb(n1, t, e) {
    return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? n1 + (t - n1) * 6 * e : e < 0.5 ? t : e < 2 / 3 ? n1 + (t - n1) * 6 * (2 / 3 - e) : n1;
}
function _g(n1, t) {
    return t.r = n1.r, t.g = n1.g, t.b = n1.b, t;
}
var Le = class {
    constructor(t, e, r){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, e === void 0 && r === void 0 ? this.set(t) : this.setRGB(t, e, r);
    }
    set(t) {
        return t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t), this;
    }
    setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
    }
    setHex(t, e = ao) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, ln.toWorkingColorSpace(this, e), this;
    }
    setRGB(t, e, r, i = ln.workingColorSpace) {
        return this.r = t, this.g = e, this.b = r, ln.toWorkingColorSpace(this, i), this;
    }
    setHSL(t, e, r, i = ln.workingColorSpace) {
        if (t = cw(t, 1), e = oi(e, 0, 1), r = oi(r, 0, 1), e === 0) this.r = this.g = this.b = r;
        else {
            let s = r <= .5 ? r * (1 + e) : r + e - r * e, o = 2 * r - s;
            this.r = Qb(o, s, t + 1 / 3), this.g = Qb(o, s, t), this.b = Qb(o, s, t - 1 / 3);
        }
        return ln.toWorkingColorSpace(this, i), this;
    }
    setStyle(t, e = ao) {
        function r(s) {
            s !== void 0 && parseFloat(s) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
        }
        let i;
        if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(s[1], 10)) / 255, this.g = Math.min(255, parseInt(s[2], 10)) / 255, this.b = Math.min(255, parseInt(s[3], 10)) / 255, ln.toWorkingColorSpace(this, e), r(s[4]), this;
                    if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(s[1], 10)) / 100, this.g = Math.min(100, parseInt(s[2], 10)) / 100, this.b = Math.min(100, parseInt(s[3], 10)) / 100, ln.toWorkingColorSpace(this, e), r(s[4]), this;
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) {
                        let l = parseFloat(s[1]) / 360, u = parseFloat(s[2]) / 100, c = parseFloat(s[3]) / 100;
                        return r(s[4]), this.setHSL(l, u, c, e);
                    }
                    break;
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
            let s = i[1], o = s.length;
            if (o === 3) return this.r = parseInt(s.charAt(0) + s.charAt(0), 16) / 255, this.g = parseInt(s.charAt(1) + s.charAt(1), 16) / 255, this.b = parseInt(s.charAt(2) + s.charAt(2), 16) / 255, ln.toWorkingColorSpace(this, e), this;
            if (o === 6) return this.r = parseInt(s.charAt(0) + s.charAt(1), 16) / 255, this.g = parseInt(s.charAt(2) + s.charAt(3), 16) / 255, this.b = parseInt(s.charAt(4) + s.charAt(5), 16) / 255, ln.toWorkingColorSpace(this, e), this;
        }
        return t && t.length > 0 ? this.setColorName(t, e) : this;
    }
    setColorName(t, e = ao) {
        let r = DM[t.toLowerCase()];
        return r !== void 0 ? this.setHex(r, e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
    copySRGBToLinear(t) {
        return this.r = uc(t.r), this.g = uc(t.g), this.b = uc(t.b), this;
    }
    copyLinearToSRGB(t) {
        return this.r = Kg(t.r), this.g = Kg(t.g), this.b = Kg(t.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t = ao) {
        return ln.fromWorkingColorSpace(_g(this, mi), t), oi(mi.r * 255, 0, 255) << 16 ^ oi(mi.g * 255, 0, 255) << 8 ^ oi(mi.b * 255, 0, 255) << 0;
    }
    getHexString(t = ao) {
        return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
    getHSL(t, e = ln.workingColorSpace) {
        ln.fromWorkingColorSpace(_g(this, mi), e);
        let r = mi.r, i = mi.g, s = mi.b, o = Math.max(r, i, s), a = Math.min(r, i, s), l, u, c = (a + o) / 2;
        if (a === o) l = 0, u = 0;
        else {
            let d = o - a;
            switch(u = c <= .5 ? d / (o + a) : d / (2 - o - a), o){
                case r:
                    l = (i - s) / d + (i < s ? 6 : 0);
                    break;
                case i:
                    l = (s - r) / d + 2;
                    break;
                case s:
                    l = (r - i) / d + 4;
                    break;
            }
            l /= 6;
        }
        return t.h = l, t.s = u, t.l = c, t;
    }
    getRGB(t, e = ln.workingColorSpace) {
        return ln.fromWorkingColorSpace(_g(this, mi), e), t.r = mi.r, t.g = mi.g, t.b = mi.b, t;
    }
    getStyle(t = ao) {
        return ln.fromWorkingColorSpace(_g(this, mi), t), t !== ao ? `color(${t} ${mi.r} ${mi.g} ${mi.b})` : `rgb(${mi.r * 255 | 0},${mi.g * 255 | 0},${mi.b * 255 | 0})`;
    }
    offsetHSL(t, e, r) {
        return this.getHSL(Ms), Ms.h += t, Ms.s += e, Ms.l += r, this.setHSL(Ms.h, Ms.s, Ms.l), this;
    }
    add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
    addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
    addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
    }
    sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
    multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
    multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
    }
    lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
    lerpColors(t, e, r) {
        return this.r = t.r + (e.r - t.r) * r, this.g = t.g + (e.g - t.g) * r, this.b = t.b + (e.b - t.b) * r, this;
    }
    lerpHSL(t, e) {
        this.getHSL(Ms), t.getHSL(Ag);
        let r = ip(Ms.h, Ag.h, e), i = ip(Ms.s, Ag.s, e), s = ip(Ms.l, Ag.l, e);
        return this.setHSL(r, i, s), this;
    }
    equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
    }
    fromArray(t, e = 0) {
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
    fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
};
Le.NAMES = DM;
var cu, ty = class {
    static getDataURL(t) {
        if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u") return t.src;
        let e;
        if (t instanceof HTMLCanvasElement) e = t;
        else {
            cu === void 0 && (cu = cp("canvas")), cu.width = t.width, cu.height = t.height;
            let r = cu.getContext("2d");
            t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0, t.width, t.height), e = cu;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t) {
        if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
            let e = cp("canvas");
            e.width = t.width, e.height = t.height;
            let r = e.getContext("2d");
            r.drawImage(t, 0, 0, t.width, t.height);
            let i = r.getImageData(0, 0, t.width, t.height), s = i.data;
            for(let o = 0; o < s.length; o++)s[o] = uc(s[o] / 255) * 255;
            return r.putImageData(i, 0, 0), e;
        } else if (t.data) {
            let e = t.data.slice(0);
            for(let r = 0; r < e.length; r++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[r] = Math.floor(uc(e[r] / 255) * 255) : e[r] = uc(e[r]);
            return {
                data: e,
                width: t.width,
                height: t.height
            };
        } else return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
}, ry = class {
    constructor(t = null){
        this.isSource = !0, this.uuid = rs(), this.data = t, this.version = 0;
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.images[this.uuid] !== void 0) return t.images[this.uuid];
        let r = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (i !== null) {
            let s;
            if (Array.isArray(i)) {
                s = [];
                for(let o = 0, a = i.length; o < a; o++)i[o].isDataTexture ? s.push(Kb(i[o].image)) : s.push(Kb(i[o]));
            } else s = Kb(i);
            r.url = s;
        }
        return e || (t.images[this.uuid] = r), r;
    }
};
function Kb(n1) {
    return typeof HTMLImageElement < "u" && n1 instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && n1 instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && n1 instanceof ImageBitmap ? ty.getDataURL(n1) : n1.data ? {
        data: Array.from(n1.data),
        width: n1.width,
        height: n1.height,
        type: n1.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
var qF = 0, qt = class extends ir {
    constructor(t = qt.DEFAULT_IMAGE, e = qt.DEFAULT_MAPPING, r = Ut, i = Ut, s = Qe, o = dc, a = Fr, l = br, u = qt.DEFAULT_ANISOTROPY, c = dn){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: qF++
        }), this.uuid = rs(), this.name = "", this.source = new ry(t), this.mipmaps = [], this.mapping = e, this.wrapS = r, this.wrapT = i, this.magFilter = s, this.minFilter = o, this.anisotropy = u, this.format = a, this.internalFormat = null, this.type = l, this.offset = new N(0, 0), this.repeat = new N(1, 1), this.center = new N(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Qt, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = c, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
        return this.source.data;
    }
    set image(t) {
        this.source.data = t;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.textures[this.uuid] !== void 0) return t.textures[this.uuid];
        let r = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (r.userData = this.userData), e || (t.textures[this.uuid] = r), r;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t) {
        if (this.mapping !== EM) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch(this.wrapS){
            case Is:
                t.x = t.x - Math.floor(t.x);
                break;
            case Ut:
                t.x = t.x < 0 ? 0 : 1;
                break;
            case ES:
                Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
                break;
        }
        if (t.y < 0 || t.y > 1) switch(this.wrapT){
            case Is:
                t.y = t.y - Math.floor(t.y);
                break;
            case Ut:
                t.y = t.y < 0 ? 0 : 1;
                break;
            case ES:
                Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
                break;
        }
        return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
        t === !0 && (this.version++, this.source.needsUpdate = !0);
    }
};
qt.DEFAULT_IMAGE = null;
qt.DEFAULT_MAPPING = EM;
qt.DEFAULT_ANISOTROPY = 1;
var He = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        He.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = r, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(t) {
        this.z = t;
    }
    get height() {
        return this.w;
    }
    set height(t) {
        this.w = t;
    }
    set(t, e, r, i) {
        return this.x = t, this.y = e, this.z = r, this.w = i, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setW(t) {
        return this.w = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s = this.w, o = t.elements;
        return this.x = o[0] * e + o[4] * r + o[8] * i + o[12] * s, this.y = o[1] * e + o[5] * r + o[9] * i + o[13] * s, this.z = o[2] * e + o[6] * r + o[10] * i + o[14] * s, this.w = o[3] * e + o[7] * r + o[11] * i + o[15] * s, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        let e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t) {
        let e, r, i, s, l = t.elements, u = l[0], c = l[4], d = l[8], h = l[1], f = l[5], p = l[9], m = l[2], g = l[6], y = l[10];
        if (Math.abs(c - h) < .01 && Math.abs(d - m) < .01 && Math.abs(p - g) < .01) {
            if (Math.abs(c + h) < .1 && Math.abs(d + m) < .1 && Math.abs(p + g) < .1 && Math.abs(u + f + y - 3) < .1) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            let x = (u + 1) / 2, S = (f + 1) / 2, w = (y + 1) / 2, A = (c + h) / 4, E = (d + m) / 4, b = (p + g) / 4;
            return x > S && x > w ? x < .01 ? (r = 0, i = .707106781, s = .707106781) : (r = Math.sqrt(x), i = A / r, s = E / r) : S > w ? S < .01 ? (r = .707106781, i = 0, s = .707106781) : (i = Math.sqrt(S), r = A / i, s = b / i) : w < .01 ? (r = .707106781, i = .707106781, s = 0) : (s = Math.sqrt(w), r = E / s, i = b / s), this.set(r, i, s, e), this;
        }
        let v = Math.sqrt((g - p) * (g - p) + (d - m) * (d - m) + (h - c) * (h - c));
        return Math.abs(v) < .001 && (v = 1), this.x = (g - p) / v, this.y = (d - m) / v, this.z = (h - c) / v, this.w = Math.acos((u + f + y - 1) / 2), this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this.w = t.w + (e.w - t.w) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}, at = class extends ir {
    constructor(t = 1, e = 1, r = {}){
        super(), this.isWebGLRenderTarget = !0, this.width = t, this.height = e, this.depth = 1, this.scissor = new He(0, 0, t, e), this.scissorTest = !1, this.viewport = new He(0, 0, t, e);
        let i = {
            width: t,
            height: e,
            depth: 1
        };
        this.texture = new qt(i, r.mapping, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = r.generateMipmaps !== void 0 ? r.generateMipmaps : !1, this.texture.internalFormat = r.internalFormat !== void 0 ? r.internalFormat : null, this.texture.minFilter = r.minFilter !== void 0 ? r.minFilter : Qe, this.depthBuffer = r.depthBuffer !== void 0 ? r.depthBuffer : !0, this.stencilBuffer = r.stencilBuffer !== void 0 ? r.stencilBuffer : !1, this.depthTexture = r.depthTexture !== void 0 ? r.depthTexture : null, this.samples = r.samples !== void 0 ? r.samples : 0;
    }
    setSize(t, e, r = 1) {
        (this.width !== t || this.height !== e || this.depth !== r) && (this.width = t, this.height = e, this.depth = r, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = r, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0;
        let e = Object.assign({}, t.texture.image);
        return this.texture.source = new ry(e), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, iy = class extends qt {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = Et, this.minFilter = Et, this.wrapR = Ut, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var ny = class extends qt {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = Et, this.minFilter = Et, this.wrapR = Ut, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var sy = class extends at {
    constructor(t = 1, e = 1, r = 1, i = {}){
        super(t, e, i), this.isWebGLMultipleRenderTargets = !0;
        let s = this.texture;
        this.texture = [];
        for(let o = 0; o < r; o++)this.texture[o] = s.clone(), this.texture[o].isRenderTargetTexture = !0;
    }
    setSize(t, e, r = 1) {
        if (this.width !== t || this.height !== e || this.depth !== r) {
            this.width = t, this.height = e, this.depth = r;
            for(let i = 0, s = this.texture.length; i < s; i++)this.texture[i].image.width = t, this.texture[i].image.height = e, this.texture[i].image.depth = r;
            this.dispose();
        }
        return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
    copy(t) {
        this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.texture.length = 0;
        for(let e = 0, r = t.texture.length; e < r; e++)this.texture[e] = t.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
        return this;
    }
}, je = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        this.isQuaternion = !0, this._x = t, this._y = e, this._z = r, this._w = i;
    }
    static slerpFlat(t, e, r, i, s, o, a) {
        let l = r[i + 0], u = r[i + 1], c = r[i + 2], d = r[i + 3], h = s[o + 0], f = s[o + 1], p = s[o + 2], m = s[o + 3];
        if (a === 0) {
            t[e + 0] = l, t[e + 1] = u, t[e + 2] = c, t[e + 3] = d;
            return;
        }
        if (a === 1) {
            t[e + 0] = h, t[e + 1] = f, t[e + 2] = p, t[e + 3] = m;
            return;
        }
        if (d !== m || l !== h || u !== f || c !== p) {
            let g = 1 - a, y = l * h + u * f + c * p + d * m, v = y >= 0 ? 1 : -1, x = 1 - y * y;
            if (x > Number.EPSILON) {
                let w = Math.sqrt(x), A = Math.atan2(w, y * v);
                g = Math.sin(g * A) / w, a = Math.sin(a * A) / w;
            }
            let S = a * v;
            if (l = l * g + h * S, u = u * g + f * S, c = c * g + p * S, d = d * g + m * S, g === 1 - a) {
                let w = 1 / Math.sqrt(l * l + u * u + c * c + d * d);
                l *= w, u *= w, c *= w, d *= w;
            }
        }
        t[e] = l, t[e + 1] = u, t[e + 2] = c, t[e + 3] = d;
    }
    static multiplyQuaternionsFlat(t, e, r, i, s, o) {
        let a = r[i], l = r[i + 1], u = r[i + 2], c = r[i + 3], d = s[o], h = s[o + 1], f = s[o + 2], p = s[o + 3];
        return t[e] = a * p + c * d + l * f - u * h, t[e + 1] = l * p + c * h + u * d - a * f, t[e + 2] = u * p + c * f + a * h - l * d, t[e + 3] = c * p - a * d - l * h - u * f, t;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t) {
        this._w = t, this._onChangeCallback();
    }
    set(t, e, r, i) {
        return this._x = t, this._y = e, this._z = r, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
    setFromEuler(t, e) {
        let r = t._x, i = t._y, s = t._z, o = t._order, a = Math.cos, l = Math.sin, u = a(r / 2), c = a(i / 2), d = a(s / 2), h = l(r / 2), f = l(i / 2), p = l(s / 2);
        switch(o){
            case "XYZ":
                this._x = h * c * d + u * f * p, this._y = u * f * d - h * c * p, this._z = u * c * p + h * f * d, this._w = u * c * d - h * f * p;
                break;
            case "YXZ":
                this._x = h * c * d + u * f * p, this._y = u * f * d - h * c * p, this._z = u * c * p - h * f * d, this._w = u * c * d + h * f * p;
                break;
            case "ZXY":
                this._x = h * c * d - u * f * p, this._y = u * f * d + h * c * p, this._z = u * c * p + h * f * d, this._w = u * c * d - h * f * p;
                break;
            case "ZYX":
                this._x = h * c * d - u * f * p, this._y = u * f * d + h * c * p, this._z = u * c * p - h * f * d, this._w = u * c * d + h * f * p;
                break;
            case "YZX":
                this._x = h * c * d + u * f * p, this._y = u * f * d + h * c * p, this._z = u * c * p - h * f * d, this._w = u * c * d - h * f * p;
                break;
            case "XZY":
                this._x = h * c * d - u * f * p, this._y = u * f * d - h * c * p, this._z = u * c * p + h * f * d, this._w = u * c * d + h * f * p;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
        }
        return e !== !1 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t, e) {
        let r = e / 2, i = Math.sin(r);
        return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(r), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t) {
        let e = t.elements, r = e[0], i = e[4], s = e[8], o = e[1], a = e[5], l = e[9], u = e[2], c = e[6], d = e[10], h = r + a + d;
        if (h > 0) {
            let f = .5 / Math.sqrt(h + 1);
            this._w = .25 / f, this._x = (c - l) * f, this._y = (s - u) * f, this._z = (o - i) * f;
        } else if (r > a && r > d) {
            let f = 2 * Math.sqrt(1 + r - a - d);
            this._w = (c - l) / f, this._x = .25 * f, this._y = (i + o) / f, this._z = (s + u) / f;
        } else if (a > d) {
            let f = 2 * Math.sqrt(1 + a - r - d);
            this._w = (s - u) / f, this._x = (i + o) / f, this._y = .25 * f, this._z = (l + c) / f;
        } else {
            let f = 2 * Math.sqrt(1 + d - r - a);
            this._w = (o - i) / f, this._x = (s + u) / f, this._y = (l + c) / f, this._z = .25 * f;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t, e) {
        let r = t.dot(e) + 1;
        return r < Number.EPSILON ? (r = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = r)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = r), this.normalize();
    }
    angleTo(t) {
        return 2 * Math.acos(Math.abs(oi(this.dot(t), -1, 1)));
    }
    rotateTowards(t, e) {
        let r = this.angleTo(t);
        if (r === 0) return this;
        let i = Math.min(1, e / r);
        return this.slerp(t, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t = this.length();
        return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
    multiply(t) {
        return this.multiplyQuaternions(this, t);
    }
    premultiply(t) {
        return this.multiplyQuaternions(t, this);
    }
    multiplyQuaternions(t, e) {
        let r = t._x, i = t._y, s = t._z, o = t._w, a = e._x, l = e._y, u = e._z, c = e._w;
        return this._x = r * c + o * a + i * u - s * l, this._y = i * c + o * l + s * a - r * u, this._z = s * c + o * u + r * l - i * a, this._w = o * c - r * a - i * l - s * u, this._onChangeCallback(), this;
    }
    slerp(t, e) {
        if (e === 0) return this;
        if (e === 1) return this.copy(t);
        let r = this._x, i = this._y, s = this._z, o = this._w, a = o * t._w + r * t._x + i * t._y + s * t._z;
        if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = o, this._x = r, this._y = i, this._z = s, this;
        let l = 1 - a * a;
        if (l <= Number.EPSILON) {
            let f = 1 - e;
            return this._w = f * o + e * this._w, this._x = f * r + e * this._x, this._y = f * i + e * this._y, this._z = f * s + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }
        let u = Math.sqrt(l), c = Math.atan2(u, a), d = Math.sin((1 - e) * c) / u, h = Math.sin(e * c) / u;
        return this._w = o * d + this._w * h, this._x = r * d + this._x * h, this._y = i * d + this._y * h, this._z = s * d + this._z * h, this._onChangeCallback(), this;
    }
    slerpQuaternions(t, e, r) {
        return this.copy(t).slerp(e, r);
    }
    random() {
        let t = Math.random(), e = Math.sqrt(1 - t), r = Math.sqrt(t), i = 2 * Math.PI * Math.random(), s = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), r * Math.sin(s), r * Math.cos(s), e * Math.sin(i));
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
    fromArray(t, e = 0) {
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
    fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}, _ = class {
    constructor(t = 0, e = 0, r = 0){
        _.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = r;
    }
    set(t, e, r) {
        return r === void 0 && (r = this.z), this.x = t, this.y = e, this.z = r, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
    }
    multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
    applyEuler(t) {
        return this.applyQuaternion(wT.setFromEuler(t));
    }
    applyAxisAngle(t, e) {
        return this.applyQuaternion(wT.setFromAxisAngle(t, e));
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[3] * r + s[6] * i, this.y = s[1] * e + s[4] * r + s[7] * i, this.z = s[2] * e + s[5] * r + s[8] * i, this;
    }
    applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements, o = 1 / (s[3] * e + s[7] * r + s[11] * i + s[15]);
        return this.x = (s[0] * e + s[4] * r + s[8] * i + s[12]) * o, this.y = (s[1] * e + s[5] * r + s[9] * i + s[13]) * o, this.z = (s[2] * e + s[6] * r + s[10] * i + s[14]) * o, this;
    }
    applyQuaternion(t) {
        let e = this.x, r = this.y, i = this.z, s = t.x, o = t.y, a = t.z, l = t.w, u = l * e + o * i - a * r, c = l * r + a * e - s * i, d = l * i + s * r - o * e, h = -s * e - o * r - a * i;
        return this.x = u * l + h * -s + c * -a - d * -o, this.y = c * l + h * -o + d * -s - u * -a, this.z = d * l + h * -a + u * -o - c * -s, this;
    }
    project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
    unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
    transformDirection(t) {
        let e = this.x, r = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[4] * r + s[8] * i, this.y = s[1] * e + s[5] * r + s[9] * i, this.z = s[2] * e + s[6] * r + s[10] * i, this.normalize();
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this;
    }
    cross(t) {
        return this.crossVectors(this, t);
    }
    crossVectors(t, e) {
        let r = t.x, i = t.y, s = t.z, o = e.x, a = e.y, l = e.z;
        return this.x = i * l - s * a, this.y = s * o - r * l, this.z = r * a - i * o, this;
    }
    projectOnVector(t) {
        let e = t.lengthSq();
        if (e === 0) return this.set(0, 0, 0);
        let r = t.dot(this) / e;
        return this.copy(t).multiplyScalar(r);
    }
    projectOnPlane(t) {
        return Zb.copy(this).projectOnVector(t), this.sub(Zb);
    }
    reflect(t) {
        return this.sub(Zb.copy(t).multiplyScalar(2 * this.dot(t)));
    }
    angleTo(t) {
        let e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (e === 0) return Math.PI / 2;
        let r = this.dot(t) / e;
        return Math.acos(oi(r, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y, i = this.z - t.z;
        return e * e + r * r + i * i;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
    setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
    setFromSphericalCoords(t, e, r) {
        let i = Math.sin(e) * t;
        return this.x = i * Math.sin(r), this.y = Math.cos(e) * t, this.z = i * Math.cos(r), this;
    }
    setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
    setFromCylindricalCoords(t, e, r) {
        return this.x = t * Math.sin(e), this.y = r, this.z = t * Math.cos(e), this;
    }
    setFromMatrixPosition(t) {
        let e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t) {
        let e = this.setFromMatrixColumn(t, 0).length(), r = this.setFromMatrixColumn(t, 1).length(), i = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = r, this.z = i, this;
    }
    setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, e * 4);
    }
    setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, e * 3);
    }
    setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        let t = (Math.random() - .5) * 2, e = Math.random() * Math.PI * 2, r = Math.sqrt(1 - t ** 2);
        return this.x = r * Math.cos(e), this.y = r * Math.sin(e), this.z = t, this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}, Zb = new _, wT = new je, Bt = class {
    constructor(t = new _(1 / 0, 1 / 0, 1 / 0), e = new _(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, u = t.length; l < u; l += 3){
            let c = t[l], d = t[l + 1], h = t[l + 2];
            c < e && (e = c), d < r && (r = d), h < i && (i = h), c > s && (s = c), d > o && (o = d), h > a && (a = h);
        }
        return this.min.set(e, r, i), this.max.set(s, o, a), this;
    }
    setFromBufferAttribute(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, u = t.count; l < u; l++){
            let c = t.getX(l), d = t.getY(l), h = t.getZ(l);
            c < e && (e = c), d < r && (r = d), h < i && (i = h), c > s && (s = c), d > o && (o = d), h > a && (a = h);
        }
        return this.min.set(e, r, i), this.max.set(s, o, a), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = nc.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    setFromObject(t, e = !1) {
        return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
        t.updateWorldMatrix(!1, !1);
        let r = t.geometry;
        if (r !== void 0) {
            if (e && r.attributes != null && r.attributes.position !== void 0) {
                let s = r.attributes.position;
                for(let o = 0, a = s.count; o < a; o++)nc.fromBufferAttribute(s, o).applyMatrix4(t.matrixWorld), this.expandByPoint(nc);
            } else r.boundingBox === null && r.computeBoundingBox(), Jb.copy(r.boundingBox), Jb.applyMatrix4(t.matrixWorld), this.union(Jb);
        }
        let i = t.children;
        for(let s = 0, o = i.length; s < o; s++)this.expandByObject(i[s], e);
        return this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
    intersectsSphere(t) {
        return this.clampPoint(t.center, nc), nc.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
        let e, r;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, r = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, r = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, r += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, r += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, r += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, r += t.normal.z * this.min.z), e <= -t.constant && r >= -t.constant;
    }
    intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter(Wf), Eg.subVectors(this.max, Wf), uu.subVectors(t.a, Wf), du.subVectors(t.b, Wf), hu.subVectors(t.c, Wf), Ua.subVectors(du, uu), Ga.subVectors(hu, du), sc.subVectors(uu, hu);
        let e = [
            0,
            -Ua.z,
            Ua.y,
            0,
            -Ga.z,
            Ga.y,
            0,
            -sc.z,
            sc.y,
            Ua.z,
            0,
            -Ua.x,
            Ga.z,
            0,
            -Ga.x,
            sc.z,
            0,
            -sc.x,
            -Ua.y,
            Ua.x,
            0,
            -Ga.y,
            Ga.x,
            0,
            -sc.y,
            sc.x,
            0
        ];
        return !$b(e, uu, du, hu, Eg) || (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !$b(e, uu, du, hu, Eg)) ? !1 : (Tg.crossVectors(Ua, Ga), e = [
            Tg.x,
            Tg.y,
            Tg.z
        ], $b(e, uu, du, hu, Eg));
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return nc.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    getBoundingSphere(t) {
        return this.getCenter(t.center), t.radius = this.getSize(nc).length() * .5, t;
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
        return this.isEmpty() ? this : (Zo[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), Zo[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), Zo[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), Zo[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), Zo[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), Zo[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), Zo[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), Zo[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(Zo), this);
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, Zo = [
    new _,
    new _,
    new _,
    new _,
    new _,
    new _,
    new _,
    new _
], nc = new _, Jb = new Bt, uu = new _, du = new _, hu = new _, Ua = new _, Ga = new _, sc = new _, Wf = new _, Eg = new _, Tg = new _, oc = new _;
function $b(n1, t, e, r, i) {
    for(let s = 0, o = n1.length - 3; s <= o; s += 3){
        oc.fromArray(n1, s);
        let a = i.x * Math.abs(oc.x) + i.y * Math.abs(oc.y) + i.z * Math.abs(oc.z), l = t.dot(oc), u = e.dot(oc), c = r.dot(oc);
        if (Math.max(-Math.max(l, u, c), Math.min(l, u, c)) > a) return !1;
    }
    return !0;
}
var YF = new Bt, qf = new _, eS = new _, Er = class {
    constructor(t = new _, e = -1){
        this.center = t, this.radius = e;
    }
    set(t, e) {
        return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
        let r = this.center;
        e !== void 0 ? r.copy(e) : YF.setFromPoints(t).getCenter(r);
        let i = 0;
        for(let s = 0, o = t.length; s < o; s++)i = Math.max(i, r.distanceToSquared(t[s]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
        let e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
        return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
        let r = this.center.distanceToSquared(t);
        return e.copy(t), r > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
        return this.center.add(t), this;
    }
    expandByPoint(t) {
        if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
        qf.subVectors(t, this.center);
        let e = qf.lengthSq();
        if (e > this.radius * this.radius) {
            let r = Math.sqrt(e), i = (r - this.radius) * .5;
            this.center.addScaledVector(qf, i / r), this.radius += i;
        }
        return this;
    }
    union(t) {
        return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (eS.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(qf.copy(t.center).add(eS)), this.expandByPoint(qf.copy(t.center).sub(eS))), this);
    }
    equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, Jo = new _, tS = new _, Mg = new _, ja = new _, rS = new _, Cg = new _, iS = new _, Rs = class {
    constructor(t = new _, e = new _(0, 0, -1)){
        this.origin = t, this.direction = e;
    }
    set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
        return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
        return this.origin.copy(this.at(t, Jo)), this;
    }
    closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        let r = e.dot(this.direction);
        return r < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(r).add(this.origin);
    }
    distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
        let e = Jo.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : (Jo.copy(this.direction).multiplyScalar(e).add(this.origin), Jo.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, r, i) {
        tS.copy(t).add(e).multiplyScalar(.5), Mg.copy(e).sub(t).normalize(), ja.copy(this.origin).sub(tS);
        let s = t.distanceTo(e) * .5, o = -this.direction.dot(Mg), a = ja.dot(this.direction), l = -ja.dot(Mg), u = ja.lengthSq(), c = Math.abs(1 - o * o), d, h, f, p;
        if (c > 0) {
            if (d = o * l - a, h = o * a - l, p = s * c, d >= 0) {
                if (h >= -p) {
                    if (h <= p) {
                        let m = 1 / c;
                        d *= m, h *= m, f = d * (d + o * h + 2 * a) + h * (o * d + h + 2 * l) + u;
                    } else h = s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
                } else h = -s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
            } else h <= -p ? (d = Math.max(0, -(-o * s + a)), h = d > 0 ? -s : Math.min(Math.max(-s, -l), s), f = -d * d + h * (h + 2 * l) + u) : h <= p ? (d = 0, h = Math.min(Math.max(-s, -l), s), f = h * (h + 2 * l) + u) : (d = Math.max(0, -(o * s + a)), h = d > 0 ? s : Math.min(Math.max(-s, -l), s), f = -d * d + h * (h + 2 * l) + u);
        } else h = o > 0 ? -s : s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
        return r && r.copy(this.direction).multiplyScalar(d).add(this.origin), i && i.copy(Mg).multiplyScalar(h).add(tS), f;
    }
    intersectSphere(t, e) {
        Jo.subVectors(t.center, this.origin);
        let r = Jo.dot(this.direction), i = Jo.dot(Jo) - r * r, s = t.radius * t.radius;
        if (i > s) return null;
        let o = Math.sqrt(s - i), a = r - o, l = r + o;
        return a < 0 && l < 0 ? null : a < 0 ? this.at(l, e) : this.at(a, e);
    }
    intersectsSphere(t) {
        return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
        let e = t.normal.dot(this.direction);
        if (e === 0) return t.distanceToPoint(this.origin) === 0 ? 0 : null;
        let r = -(this.origin.dot(t.normal) + t.constant) / e;
        return r >= 0 ? r : null;
    }
    intersectPlane(t, e) {
        let r = this.distanceToPlane(t);
        return r === null ? null : this.at(r, e);
    }
    intersectsPlane(t) {
        let e = t.distanceToPoint(this.origin);
        return e === 0 || t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
        let r, i, s, o, a, l, u = 1 / this.direction.x, c = 1 / this.direction.y, d = 1 / this.direction.z, h = this.origin;
        return u >= 0 ? (r = (t.min.x - h.x) * u, i = (t.max.x - h.x) * u) : (r = (t.max.x - h.x) * u, i = (t.min.x - h.x) * u), c >= 0 ? (s = (t.min.y - h.y) * c, o = (t.max.y - h.y) * c) : (s = (t.max.y - h.y) * c, o = (t.min.y - h.y) * c), r > o || s > i || ((s > r || isNaN(r)) && (r = s), (o < i || isNaN(i)) && (i = o), d >= 0 ? (a = (t.min.z - h.z) * d, l = (t.max.z - h.z) * d) : (a = (t.max.z - h.z) * d, l = (t.min.z - h.z) * d), r > l || a > i) || ((a > r || r !== r) && (r = a), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(r >= 0 ? r : i, e);
    }
    intersectsBox(t) {
        return this.intersectBox(t, Jo) !== null;
    }
    intersectTriangle(t, e, r, i, s) {
        rS.subVectors(e, t), Cg.subVectors(r, t), iS.crossVectors(rS, Cg);
        let o = this.direction.dot(iS), a;
        if (o > 0) {
            if (i) return null;
            a = 1;
        } else if (o < 0) a = -1, o = -o;
        else return null;
        ja.subVectors(this.origin, t);
        let l = a * this.direction.dot(Cg.crossVectors(ja, Cg));
        if (l < 0) return null;
        let u = a * this.direction.dot(rS.cross(ja));
        if (u < 0 || l + u > o) return null;
        let c = -a * ja.dot(iS);
        return c < 0 ? null : this.at(c / o, s);
    }
    applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, te = class {
    constructor(){
        te.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s, o, a, l, u, c, d, h, f, p, m, g) {
        let y = this.elements;
        return y[0] = t, y[4] = e, y[8] = r, y[12] = i, y[1] = s, y[5] = o, y[9] = a, y[13] = l, y[2] = u, y[6] = c, y[10] = d, y[14] = h, y[3] = f, y[7] = p, y[11] = m, y[15] = g, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return new te().fromArray(this.elements);
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], this;
    }
    copyPosition(t) {
        let e = this.elements, r = t.elements;
        return e[12] = r[12], e[13] = r[13], e[14] = r[14], this;
    }
    setFromMatrix3(t) {
        let e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t, e, r) {
        return this.set(t.x, e.x, r.x, 0, t.y, e.y, r.y, 0, t.z, e.z, r.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t) {
        let e = this.elements, r = t.elements, i = 1 / fu.setFromMatrixColumn(t, 0).length(), s = 1 / fu.setFromMatrixColumn(t, 1).length(), o = 1 / fu.setFromMatrixColumn(t, 2).length();
        return e[0] = r[0] * i, e[1] = r[1] * i, e[2] = r[2] * i, e[3] = 0, e[4] = r[4] * s, e[5] = r[5] * s, e[6] = r[6] * s, e[7] = 0, e[8] = r[8] * o, e[9] = r[9] * o, e[10] = r[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t) {
        let e = this.elements, r = t.x, i = t.y, s = t.z, o = Math.cos(r), a = Math.sin(r), l = Math.cos(i), u = Math.sin(i), c = Math.cos(s), d = Math.sin(s);
        if (t.order === "XYZ") {
            let h = o * c, f = o * d, p = a * c, m = a * d;
            e[0] = l * c, e[4] = -l * d, e[8] = u, e[1] = f + p * u, e[5] = h - m * u, e[9] = -a * l, e[2] = m - h * u, e[6] = p + f * u, e[10] = o * l;
        } else if (t.order === "YXZ") {
            let h = l * c, f = l * d, p = u * c, m = u * d;
            e[0] = h + m * a, e[4] = p * a - f, e[8] = o * u, e[1] = o * d, e[5] = o * c, e[9] = -a, e[2] = f * a - p, e[6] = m + h * a, e[10] = o * l;
        } else if (t.order === "ZXY") {
            let h = l * c, f = l * d, p = u * c, m = u * d;
            e[0] = h - m * a, e[4] = -o * d, e[8] = p + f * a, e[1] = f + p * a, e[5] = o * c, e[9] = m - h * a, e[2] = -o * u, e[6] = a, e[10] = o * l;
        } else if (t.order === "ZYX") {
            let h = o * c, f = o * d, p = a * c, m = a * d;
            e[0] = l * c, e[4] = p * u - f, e[8] = h * u + m, e[1] = l * d, e[5] = m * u + h, e[9] = f * u - p, e[2] = -u, e[6] = a * l, e[10] = o * l;
        } else if (t.order === "YZX") {
            let h = o * l, f = o * u, p = a * l, m = a * u;
            e[0] = l * c, e[4] = m - h * d, e[8] = p * d + f, e[1] = d, e[5] = o * c, e[9] = -a * c, e[2] = -u * c, e[6] = f * d + p, e[10] = h - m * d;
        } else if (t.order === "XZY") {
            let h = o * l, f = o * u, p = a * l, m = a * u;
            e[0] = l * c, e[4] = -d, e[8] = u * c, e[1] = h * d + m, e[5] = o * c, e[9] = f * d - p, e[2] = p * d - f, e[6] = a * c, e[10] = m * d + h;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t) {
        return this.compose(XF, t, QF);
    }
    lookAt(t, e, r) {
        let i = this.elements;
        return Un.subVectors(t, e), Un.lengthSq() === 0 && (Un.z = 1), Un.normalize(), Ha.crossVectors(r, Un), Ha.lengthSq() === 0 && (Math.abs(r.z) === 1 ? Un.x += 1e-4 : Un.z += 1e-4, Un.normalize(), Ha.crossVectors(r, Un)), Ha.normalize(), Pg.crossVectors(Un, Ha), i[0] = Ha.x, i[4] = Pg.x, i[8] = Un.x, i[1] = Ha.y, i[5] = Pg.y, i[9] = Un.y, i[2] = Ha.z, i[6] = Pg.z, i[10] = Un.z, this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s = this.elements, o = r[0], a = r[4], l = r[8], u = r[12], c = r[1], d = r[5], h = r[9], f = r[13], p = r[2], m = r[6], g = r[10], y = r[14], v = r[3], x = r[7], S = r[11], w = r[15], A = i[0], E = i[4], b = i[8], T = i[12], M = i[1], C = i[5], P = i[9], D = i[13], O = i[2], I = i[6], z = i[10], B = i[14], V = i[3], U = i[7], j = i[11], W = i[15];
        return s[0] = o * A + a * M + l * O + u * V, s[4] = o * E + a * C + l * I + u * U, s[8] = o * b + a * P + l * z + u * j, s[12] = o * T + a * D + l * B + u * W, s[1] = c * A + d * M + h * O + f * V, s[5] = c * E + d * C + h * I + f * U, s[9] = c * b + d * P + h * z + f * j, s[13] = c * T + d * D + h * B + f * W, s[2] = p * A + m * M + g * O + y * V, s[6] = p * E + m * C + g * I + y * U, s[10] = p * b + m * P + g * z + y * j, s[14] = p * T + m * D + g * B + y * W, s[3] = v * A + x * M + S * O + w * V, s[7] = v * E + x * C + S * I + w * U, s[11] = v * b + x * P + S * z + w * j, s[15] = v * T + x * D + S * B + w * W, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[4], i = t[8], s = t[12], o = t[1], a = t[5], l = t[9], u = t[13], c = t[2], d = t[6], h = t[10], f = t[14], p = t[3], m = t[7], g = t[11], y = t[15];
        return p * (+s * l * d - i * u * d - s * a * h + r * u * h + i * a * f - r * l * f) + m * (+e * l * f - e * u * h + s * o * h - i * o * f + i * u * c - s * l * c) + g * (+e * u * d - e * a * f - s * o * d + r * o * f + s * a * c - r * u * c) + y * (-i * a * c - e * l * d + e * a * h + i * o * d - r * o * h + r * l * c);
    }
    transpose() {
        let t = this.elements, e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
    setPosition(t, e, r) {
        let i = this.elements;
        return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = r), this;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], d = t[9], h = t[10], f = t[11], p = t[12], m = t[13], g = t[14], y = t[15], v = d * g * u - m * h * u + m * l * f - a * g * f - d * l * y + a * h * y, x = p * h * u - c * g * u - p * l * f + o * g * f + c * l * y - o * h * y, S = c * m * u - p * d * u + p * a * f - o * m * f - c * a * y + o * d * y, w = p * d * l - c * m * l - p * a * h + o * m * h + c * a * g - o * d * g, A = e * v + r * x + i * S + s * w;
        if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        let E = 1 / A;
        return t[0] = v * E, t[1] = (m * h * s - d * g * s - m * i * f + r * g * f + d * i * y - r * h * y) * E, t[2] = (a * g * s - m * l * s + m * i * u - r * g * u - a * i * y + r * l * y) * E, t[3] = (d * l * s - a * h * s - d * i * u + r * h * u + a * i * f - r * l * f) * E, t[4] = x * E, t[5] = (c * g * s - p * h * s + p * i * f - e * g * f - c * i * y + e * h * y) * E, t[6] = (p * l * s - o * g * s - p * i * u + e * g * u + o * i * y - e * l * y) * E, t[7] = (o * h * s - c * l * s + c * i * u - e * h * u - o * i * f + e * l * f) * E, t[8] = S * E, t[9] = (p * d * s - c * m * s - p * r * f + e * m * f + c * r * y - e * d * y) * E, t[10] = (o * m * s - p * a * s + p * r * u - e * m * u - o * r * y + e * a * y) * E, t[11] = (c * a * s - o * d * s - c * r * u + e * d * u + o * r * f - e * a * f) * E, t[12] = w * E, t[13] = (c * m * i - p * d * i + p * r * h - e * m * h - c * r * g + e * d * g) * E, t[14] = (p * a * i - o * m * i - p * r * l + e * m * l + o * r * g - e * a * g) * E, t[15] = (o * d * i - c * a * i + c * r * l - e * d * l - o * r * h + e * a * h) * E, this;
    }
    scale(t) {
        let e = this.elements, r = t.x, i = t.y, s = t.z;
        return e[0] *= r, e[4] *= i, e[8] *= s, e[1] *= r, e[5] *= i, e[9] *= s, e[2] *= r, e[6] *= i, e[10] *= s, e[3] *= r, e[7] *= i, e[11] *= s, this;
    }
    getMaxScaleOnAxis() {
        let t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], r = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, r, i));
    }
    makeTranslation(t, e, r) {
        return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, r, 0, 0, 0, 1), this;
    }
    makeRotationX(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -r, 0, 0, r, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, 0, r, 0, 0, 1, 0, 0, -r, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, 0, r, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s = 1 - r, o = t.x, a = t.y, l = t.z, u = s * o, c = s * a;
        return this.set(u * o + r, u * a - i * l, u * l + i * a, 0, u * a + i * l, c * a + r, c * l - i * o, 0, u * l - i * a, c * l + i * o, s * l * l + r, 0, 0, 0, 0, 1), this;
    }
    makeScale(t, e, r) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1), this;
    }
    makeShear(t, e, r, i, s, o) {
        return this.set(1, r, s, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t, e, r) {
        let i = this.elements, s = e._x, o = e._y, a = e._z, l = e._w, u = s + s, c = o + o, d = a + a, h = s * u, f = s * c, p = s * d, m = o * c, g = o * d, y = a * d, v = l * u, x = l * c, S = l * d, w = r.x, A = r.y, E = r.z;
        return i[0] = (1 - (m + y)) * w, i[1] = (f + S) * w, i[2] = (p - x) * w, i[3] = 0, i[4] = (f - S) * A, i[5] = (1 - (h + y)) * A, i[6] = (g + v) * A, i[7] = 0, i[8] = (p + x) * E, i[9] = (g - v) * E, i[10] = (1 - (h + m)) * E, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
    decompose(t, e, r) {
        let i = this.elements, s = fu.set(i[0], i[1], i[2]).length(), o = fu.set(i[4], i[5], i[6]).length(), a = fu.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (s = -s), t.x = i[12], t.y = i[13], t.z = i[14], Cs.copy(this);
        let u = 1 / s, c = 1 / o, d = 1 / a;
        return Cs.elements[0] *= u, Cs.elements[1] *= u, Cs.elements[2] *= u, Cs.elements[4] *= c, Cs.elements[5] *= c, Cs.elements[6] *= c, Cs.elements[8] *= d, Cs.elements[9] *= d, Cs.elements[10] *= d, e.setFromRotationMatrix(Cs), r.x = s, r.y = o, r.z = a, this;
    }
    makePerspective(t, e, r, i, s, o) {
        let a = this.elements, l = 2 * s / (e - t), u = 2 * s / (r - i), c = (e + t) / (e - t), d = (r + i) / (r - i), h = -(o + s) / (o - s), f = -2 * o * s / (o - s);
        return a[0] = l, a[4] = 0, a[8] = c, a[12] = 0, a[1] = 0, a[5] = u, a[9] = d, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = h, a[14] = f, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
    makeOrthographic(t, e, r, i, s, o) {
        let a = this.elements, l = 1 / (e - t), u = 1 / (r - i), c = 1 / (o - s), d = (e + t) * l, h = (r + i) * u, f = (o + s) * c;
        return a[0] = 2 * l, a[4] = 0, a[8] = 0, a[12] = -d, a[1] = 0, a[5] = 2 * u, a[9] = 0, a[13] = -h, a[2] = 0, a[6] = 0, a[10] = -2 * c, a[14] = -f, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 16; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 16; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t[e + 9] = r[9], t[e + 10] = r[10], t[e + 11] = r[11], t[e + 12] = r[12], t[e + 13] = r[13], t[e + 14] = r[14], t[e + 15] = r[15], t;
    }
}, fu = new _, Cs = new te, XF = new _(0, 0, 0), QF = new _(1, 1, 1), Ha = new _, Pg = new _, Un = new _, AT = new te, _T = new je, Kt = class {
    constructor(t = 0, e = 0, r = 0, i = Kt.DEFAULT_ORDER){
        this.isEuler = !0, this._x = t, this._y = e, this._z = r, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t) {
        this._order = t, this._onChangeCallback();
    }
    set(t, e, r, i = this._order) {
        return this._x = t, this._y = e, this._z = r, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, r = !0) {
        let i = t.elements, s = i[0], o = i[4], a = i[8], l = i[1], u = i[5], c = i[9], d = i[2], h = i[6], f = i[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin(oi(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-c, f), this._z = Math.atan2(-o, s)) : (this._x = Math.atan2(h, u), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-oi(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(a, f), this._z = Math.atan2(l, u)) : (this._y = Math.atan2(-d, s), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin(oi(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-d, f), this._z = Math.atan2(-o, u)) : (this._y = 0, this._z = Math.atan2(l, s));
                break;
            case "ZYX":
                this._y = Math.asin(-oi(d, -1, 1)), Math.abs(d) < .9999999 ? (this._x = Math.atan2(h, f), this._z = Math.atan2(l, s)) : (this._x = 0, this._z = Math.atan2(-o, u));
                break;
            case "YZX":
                this._z = Math.asin(oi(l, -1, 1)), Math.abs(l) < .9999999 ? (this._x = Math.atan2(-c, u), this._y = Math.atan2(-d, s)) : (this._x = 0, this._y = Math.atan2(a, f));
                break;
            case "XZY":
                this._z = Math.asin(-oi(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(h, u), this._y = Math.atan2(a, s)) : (this._x = Math.atan2(-c, f), this._y = 0);
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, r === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, r) {
        return AT.makeRotationFromQuaternion(t), this.setFromRotationMatrix(AT, e, r);
    }
    setFromVector3(t, e = this._order) {
        return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
        return _T.setFromEuler(this), this.setFromQuaternion(_T, t);
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
};
Kt.DEFAULT_ORDER = "XYZ";
var up = class {
    constructor(){
        this.mask = 1;
    }
    set(t) {
        this.mask = (1 << t | 0) >>> 0;
    }
    enable(t) {
        this.mask |= 1 << t | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t) {
        this.mask ^= 1 << t | 0;
    }
    disable(t) {
        this.mask &= ~(1 << t | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t) {
        return (this.mask & t.mask) !== 0;
    }
    isEnabled(t) {
        return (this.mask & (1 << t | 0)) !== 0;
    }
}, KF = 0, ET = new _, pu = new je, $o = new te, Dg = new _, Yf = new _, ZF = new _, JF = new je, TT = new _(1, 0, 0), MT = new _(0, 1, 0), CT = new _(0, 0, 1), $F = {
    type: "added"
}, PT = {
    type: "removed"
}, mt = class extends ir {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: KF++
        }), this.uuid = rs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = mt.DEFAULT_UP.clone();
        let t = new _, e = new Kt, r = new je, i = new _(1, 1, 1);
        function s() {
            r.setFromEuler(e, !1);
        }
        function o() {
            e.setFromQuaternion(r, void 0, !1);
        }
        e._onChange(s), r._onChange(o), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: r
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new te
            },
            normalMatrix: {
                value: new Qt
            }
        }), this.matrix = new te, this.matrixWorld = new te, this.matrixAutoUpdate = mt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = mt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new up, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
        return pu.setFromAxisAngle(t, e), this.quaternion.multiply(pu), this;
    }
    rotateOnWorldAxis(t, e) {
        return pu.setFromAxisAngle(t, e), this.quaternion.premultiply(pu), this;
    }
    rotateX(t) {
        return this.rotateOnAxis(TT, t);
    }
    rotateY(t) {
        return this.rotateOnAxis(MT, t);
    }
    rotateZ(t) {
        return this.rotateOnAxis(CT, t);
    }
    translateOnAxis(t, e) {
        return ET.copy(t).applyQuaternion(this.quaternion), this.position.add(ET.multiplyScalar(e)), this;
    }
    translateX(t) {
        return this.translateOnAxis(TT, t);
    }
    translateY(t) {
        return this.translateOnAxis(MT, t);
    }
    translateZ(t) {
        return this.translateOnAxis(CT, t);
    }
    localToWorld(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4($o.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, r) {
        t.isVector3 ? Dg.copy(t) : Dg.set(t, e, r);
        let i = this.parent;
        this.updateWorldMatrix(!0, !1), Yf.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $o.lookAt(Yf, Dg, this.up) : $o.lookAt(Dg, Yf, this.up), this.quaternion.setFromRotationMatrix($o), i && ($o.extractRotation(i.matrixWorld), pu.setFromRotationMatrix($o), this.quaternion.premultiply(pu.invert()));
    }
    add(t) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.add(arguments[e]);
            return this;
        }
        return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.parent !== null && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent($F)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
        if (arguments.length > 1) {
            for(let r = 0; r < arguments.length; r++)this.remove(arguments[r]);
            return this;
        }
        let e = this.children.indexOf(t);
        return e !== -1 && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(PT)), this;
    }
    removeFromParent() {
        let t = this.parent;
        return t !== null && t.remove(this), this;
    }
    clear() {
        for(let t = 0; t < this.children.length; t++){
            let e = this.children[t];
            e.parent = null, e.dispatchEvent(PT);
        }
        return this.children.length = 0, this;
    }
    attach(t) {
        return this.updateWorldMatrix(!0, !1), $o.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), $o.multiply(t.parent.matrixWorld)), t.applyMatrix4($o), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t) {
        return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
        return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
        if (this[t] === e) return this;
        for(let r = 0, i = this.children.length; r < i; r++){
            let o = this.children[r].getObjectByProperty(t, e);
            if (o !== void 0) return o;
        }
    }
    getObjectsByProperty(t, e) {
        let r = [];
        this[t] === e && r.push(this);
        for(let i = 0, s = this.children.length; i < s; i++){
            let o = this.children[i].getObjectsByProperty(t, e);
            o.length > 0 && (r = r.concat(o));
        }
        return r;
    }
    getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Yf, t, ZF), t;
    }
    getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Yf, JF, t), t;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverse(t);
    }
    traverseVisible(t) {
        if (this.visible === !1) return;
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverseVisible(t);
    }
    traverseAncestors(t) {
        let e = this.parent;
        e !== null && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++){
            let s = e[r];
            (s.matrixWorldAutoUpdate === !0 || t === !0) && s.updateMatrixWorld(t);
        }
    }
    updateWorldMatrix(t, e) {
        let r = this.parent;
        if (t === !0 && r !== null && r.matrixWorldAutoUpdate === !0 && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), e === !0) {
            let i = this.children;
            for(let s = 0, o = i.length; s < o; s++){
                let a = i[s];
                a.matrixWorldAutoUpdate === !0 && a.updateWorldMatrix(!1, !0);
            }
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string", r = {};
        e && (t = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, r.metadata = {
            version: 4.5,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        let i = {};
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON()));
        function s(a, l) {
            return a[l.uuid] === void 0 && (a[l.uuid] = l.toJSON(t)), l.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(t).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = s(t.geometries, this.geometry);
            let a = this.geometry.parameters;
            if (a !== void 0 && a.shapes !== void 0) {
                let l = a.shapes;
                if (Array.isArray(l)) for(let u = 0, c = l.length; u < c; u++){
                    let d = l[u];
                    s(t.shapes, d);
                }
                else s(t.shapes, l);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                let a = [];
                for(let l = 0, u = this.material.length; l < u; l++)a.push(s(t.materials, this.material[l]));
                i.material = a;
            } else i.material = s(t.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let a = 0; a < this.children.length; a++)i.children.push(this.children[a].toJSON(t).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let a = 0; a < this.animations.length; a++){
                let l = this.animations[a];
                i.animations.push(s(t.animations, l));
            }
        }
        if (e) {
            let a = o(t.geometries), l = o(t.materials), u = o(t.textures), c = o(t.images), d = o(t.shapes), h = o(t.skeletons), f = o(t.animations), p = o(t.nodes);
            a.length > 0 && (r.geometries = a), l.length > 0 && (r.materials = l), u.length > 0 && (r.textures = u), c.length > 0 && (r.images = c), d.length > 0 && (r.shapes = d), h.length > 0 && (r.skeletons = h), f.length > 0 && (r.animations = f), p.length > 0 && (r.nodes = p);
        }
        return r.object = i, r;
        function o(a) {
            let l = [];
            for(let u in a){
                let c = a[u];
                delete c.metadata, l.push(c);
            }
            return l;
        }
    }
    clone(t) {
        return new this.constructor().copy(this, t);
    }
    copy(t, e = !0) {
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), e === !0) for(let r = 0; r < t.children.length; r++){
            let i = t.children[r];
            this.add(i.clone());
        }
        return this;
    }
};
mt.DEFAULT_UP = new _(0, 1, 0);
mt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
mt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var Ps = new _, ea = new _, nS = new _, ta = new _, mu = new _, gu = new _, DT = new _, sS = new _, oS = new _, aS = new _, vr = class {
    constructor(t = new _, e = new _, r = new _){
        this.a = t, this.b = e, this.c = r;
    }
    static getNormal(t, e, r, i) {
        i.subVectors(r, e), Ps.subVectors(t, e), i.cross(Ps);
        let s = i.lengthSq();
        return s > 0 ? i.multiplyScalar(1 / Math.sqrt(s)) : i.set(0, 0, 0);
    }
    static getBarycoord(t, e, r, i, s) {
        Ps.subVectors(i, e), ea.subVectors(r, e), nS.subVectors(t, e);
        let o = Ps.dot(Ps), a = Ps.dot(ea), l = Ps.dot(nS), u = ea.dot(ea), c = ea.dot(nS), d = o * u - a * a;
        if (d === 0) return s.set(-2, -1, -1);
        let h = 1 / d, f = (u * l - a * c) * h, p = (o * c - a * l) * h;
        return s.set(1 - f - p, p, f);
    }
    static containsPoint(t, e, r, i) {
        return this.getBarycoord(t, e, r, i, ta), ta.x >= 0 && ta.y >= 0 && ta.x + ta.y <= 1;
    }
    static getUV(t, e, r, i, s, o, a, l) {
        return this.getBarycoord(t, e, r, i, ta), l.set(0, 0), l.addScaledVector(s, ta.x), l.addScaledVector(o, ta.y), l.addScaledVector(a, ta.z), l;
    }
    static isFrontFacing(t, e, r, i) {
        return Ps.subVectors(r, e), ea.subVectors(t, e), Ps.cross(ea).dot(i) < 0;
    }
    set(t, e, r) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(r), this;
    }
    setFromPointsAndIndices(t, e, r, i) {
        return this.a.copy(t[e]), this.b.copy(t[r]), this.c.copy(t[i]), this;
    }
    setFromAttributeAndIndices(t, e, r, i) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, r), this.c.fromBufferAttribute(t, i), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
        return Ps.subVectors(this.c, this.b), ea.subVectors(this.a, this.b), Ps.cross(ea).length() * .5;
    }
    getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
        return vr.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
        return vr.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getUV(t, e, r, i, s) {
        return vr.getUV(t, this.a, this.b, this.c, e, r, i, s);
    }
    containsPoint(t) {
        return vr.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
        return vr.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
        return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
        let r = this.a, i = this.b, s = this.c, o, a;
        mu.subVectors(i, r), gu.subVectors(s, r), sS.subVectors(t, r);
        let l = mu.dot(sS), u = gu.dot(sS);
        if (l <= 0 && u <= 0) return e.copy(r);
        oS.subVectors(t, i);
        let c = mu.dot(oS), d = gu.dot(oS);
        if (c >= 0 && d <= c) return e.copy(i);
        let h = l * d - c * u;
        if (h <= 0 && l >= 0 && c <= 0) return o = l / (l - c), e.copy(r).addScaledVector(mu, o);
        aS.subVectors(t, s);
        let f = mu.dot(aS), p = gu.dot(aS);
        if (p >= 0 && f <= p) return e.copy(s);
        let m = f * u - l * p;
        if (m <= 0 && u >= 0 && p <= 0) return a = u / (u - p), e.copy(r).addScaledVector(gu, a);
        let g = c * p - f * d;
        if (g <= 0 && d - c >= 0 && f - p >= 0) return DT.subVectors(s, i), a = (d - c) / (d - c + (f - p)), e.copy(i).addScaledVector(DT, a);
        let y = 1 / (g + m + h);
        return o = m * y, a = h * y, e.copy(r).addScaledVector(mu, o).addScaledVector(gu, a);
    }
    equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
}, ek = 0, hc = class extends ir {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: ek++
        }), this.uuid = rs(), this.name = "", this.type = "Material", this.blending = qa, this.side = jn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = wM, this.blendDst = AM, this.blendEquation = Au, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = wS, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = OF, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = qb, this.stencilZFail = qb, this.stencilZPass = qb, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t) {
        if (t !== void 0) for(let e in t){
            let r = t[e];
            if (r === void 0) {
                console.warn("THREE.Material: '" + e + "' parameter is undefined.");
                continue;
            }
            let i = this[e];
            if (i === void 0) {
                console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
                continue;
            }
            i && i.isColor ? i.set(r) : i && i.isVector3 && r && r.isVector3 ? i.copy(r) : this[e] = r;
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        e && (t = {
            textures: {},
            images: {}
        });
        let r = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(t).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(t).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(t).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(t).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(t).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== qa && (r.blending = this.blending), this.side !== jn && (r.side = this.side), this.vertexColors && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = this.transparent), r.depthFunc = this.depthFunc, r.depthTest = this.depthTest, r.depthWrite = this.depthWrite, r.colorWrite = this.colorWrite, r.stencilWrite = this.stencilWrite, r.stencilWriteMask = this.stencilWriteMask, r.stencilFunc = this.stencilFunc, r.stencilRef = this.stencilRef, r.stencilFuncMask = this.stencilFuncMask, r.stencilFail = this.stencilFail, r.stencilZFail = this.stencilZFail, r.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (r.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = this.premultipliedAlpha), this.forceSinglePass === !0 && (r.forceSinglePass = this.forceSinglePass), this.wireframe === !0 && (r.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = this.flatShading), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), Object.keys(this.userData).length > 0 && (r.userData = this.userData);
        function i(s) {
            let o = [];
            for(let a in s){
                let l = s[a];
                delete l.metadata, o.push(l);
            }
            return o;
        }
        if (e) {
            let s = i(t.textures), o = i(t.images);
            s.length > 0 && (r.textures = s), o.length > 0 && (r.images = o);
        }
        return r;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        let e = t.clippingPlanes, r = null;
        if (e !== null) {
            let i = e.length;
            r = new Array(i);
            for(let s = 0; s !== i; ++s)r[s] = e[s].clone();
        }
        return this.clippingPlanes = r, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
}, Ls = class extends hc {
    constructor(t){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Le(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = _M, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}, si = new _, Og = new N, Ge = class {
    constructor(t, e, r = !1){
        if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = t !== void 0 ? t.length / e : 0, this.normalized = r, this.usage = TS, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.itemSize, r *= e.itemSize;
        for(let i = 0, s = this.itemSize; i < s; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    copyArray(t) {
        return this.array.set(t), this;
    }
    applyMatrix3(t) {
        if (this.itemSize === 2) for(let e = 0, r = this.count; e < r; e++)Og.fromBufferAttribute(this, e), Og.applyMatrix3(t), this.setXY(e, Og.x, Og.y);
        else if (this.itemSize === 3) for(let e = 0, r = this.count; e < r; e++)si.fromBufferAttribute(this, e), si.applyMatrix3(t), this.setXYZ(e, si.x, si.y, si.z);
        return this;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.count; e < r; e++)si.fromBufferAttribute(this, e), si.applyMatrix4(t), this.setXYZ(e, si.x, si.y, si.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)si.fromBufferAttribute(this, e), si.applyNormalMatrix(t), this.setXYZ(e, si.x, si.y, si.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)si.fromBufferAttribute(this, e), si.transformDirection(t), this.setXYZ(e, si.x, si.y, si.z);
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    getX(t) {
        let e = this.array[t * this.itemSize];
        return this.normalized && (e = na(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
        let e = this.array[t * this.itemSize + 1];
        return this.normalized && (e = na(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
        let e = this.array[t * this.itemSize + 2];
        return this.normalized && (e = na(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
        let e = this.array[t * this.itemSize + 3];
        return this.normalized && (e = na(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, r) {
        return t *= this.itemSize, this.normalized && (e = ur(e, this.array), r = ur(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t *= this.itemSize, this.normalized && (e = ur(e, this.array), r = ur(r, this.array), i = ur(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s) {
        return t *= this.itemSize, this.normalized && (e = ur(e, this.array), r = ur(r, this.array), i = ur(i, this.array), s = ur(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this.array[t + 3] = s, this;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        let t = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (t.name = this.name), this.usage !== TS && (t.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (t.updateRange = this.updateRange), t;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
};
var oy = class extends Ge {
    constructor(t, e, r){
        super(new Uint16Array(t), e, r);
    }
};
var co = class extends Ge {
    constructor(t, e, r){
        super(new Uint32Array(t), e, r);
    }
};
var be = class extends Ge {
    constructor(t, e, r){
        super(new Float32Array(t), e, r);
    }
};
var tk = 0, es = new te, lS = new mt, yu = new _, Gn = new Bt, Xf = new Bt, Oi = new _, we = class extends ir {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: tk++
        }), this.uuid = rs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t) {
        return Array.isArray(t) ? this.index = new (PM(t) ? co : oy)(t, 1) : this.index = t, this;
    }
    getAttribute(t) {
        return this.attributes[t];
    }
    setAttribute(t, e) {
        return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
        return delete this.attributes[t], this;
    }
    hasAttribute(t) {
        return this.attributes[t] !== void 0;
    }
    addGroup(t, e, r = 0) {
        this.groups.push({
            start: t,
            count: e,
            materialIndex: r
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
        let e = this.attributes.position;
        e !== void 0 && (e.applyMatrix4(t), e.needsUpdate = !0);
        let r = this.attributes.normal;
        if (r !== void 0) {
            let s = new Qt().getNormalMatrix(t);
            r.applyNormalMatrix(s), r.needsUpdate = !0;
        }
        let i = this.attributes.tangent;
        return i !== void 0 && (i.transformDirection(t), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
        return es.makeRotationFromQuaternion(t), this.applyMatrix4(es), this;
    }
    rotateX(t) {
        return es.makeRotationX(t), this.applyMatrix4(es), this;
    }
    rotateY(t) {
        return es.makeRotationY(t), this.applyMatrix4(es), this;
    }
    rotateZ(t) {
        return es.makeRotationZ(t), this.applyMatrix4(es), this;
    }
    translate(t, e, r) {
        return es.makeTranslation(t, e, r), this.applyMatrix4(es), this;
    }
    scale(t, e, r) {
        return es.makeScale(t, e, r), this.applyMatrix4(es), this;
    }
    lookAt(t) {
        return lS.lookAt(t), lS.updateMatrix(), this.applyMatrix4(lS.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(yu).negate(), this.translate(yu.x, yu.y, yu.z), this;
    }
    setFromPoints(t) {
        let e = [];
        for(let r = 0, i = t.length; r < i; r++){
            let s = t[r];
            e.push(s.x, s.y, s.z || 0);
        }
        return this.setAttribute("position", new be(e, 3)), this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Bt);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(new _(-1 / 0, -1 / 0, -1 / 0), new _(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (t !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(t), e) for(let r = 0, i = e.length; r < i; r++){
                let s = e[r];
                Gn.setFromBufferAttribute(s), this.morphTargetsRelative ? (Oi.addVectors(this.boundingBox.min, Gn.min), this.boundingBox.expandByPoint(Oi), Oi.addVectors(this.boundingBox.max, Gn.max), this.boundingBox.expandByPoint(Oi)) : (this.boundingBox.expandByPoint(Gn.min), this.boundingBox.expandByPoint(Gn.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Er);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new _, 1 / 0);
            return;
        }
        if (t) {
            let r = this.boundingSphere.center;
            if (Gn.setFromBufferAttribute(t), e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s];
                Xf.setFromBufferAttribute(a), this.morphTargetsRelative ? (Oi.addVectors(Gn.min, Xf.min), Gn.expandByPoint(Oi), Oi.addVectors(Gn.max, Xf.max), Gn.expandByPoint(Oi)) : (Gn.expandByPoint(Xf.min), Gn.expandByPoint(Xf.max));
            }
            Gn.getCenter(r);
            let i = 0;
            for(let s = 0, o = t.count; s < o; s++)Oi.fromBufferAttribute(t, s), i = Math.max(i, r.distanceToSquared(Oi));
            if (e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s], l = this.morphTargetsRelative;
                for(let u = 0, c = a.count; u < c; u++)Oi.fromBufferAttribute(a, u), l && (yu.fromBufferAttribute(t, u), Oi.add(yu)), i = Math.max(i, r.distanceToSquared(Oi));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        let t = this.index, e = this.attributes;
        if (t === null || e.position === void 0 || e.normal === void 0 || e.uv === void 0) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        let r = t.array, i = e.position.array, s = e.normal.array, o = e.uv.array, a = i.length / 3;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Ge(new Float32Array(4 * a), 4));
        let l = this.getAttribute("tangent").array, u = [], c = [];
        for(let M = 0; M < a; M++)u[M] = new _, c[M] = new _;
        let d = new _, h = new _, f = new _, p = new N, m = new N, g = new N, y = new _, v = new _;
        function x(M, C, P) {
            d.fromArray(i, M * 3), h.fromArray(i, C * 3), f.fromArray(i, P * 3), p.fromArray(o, M * 2), m.fromArray(o, C * 2), g.fromArray(o, P * 2), h.sub(d), f.sub(d), m.sub(p), g.sub(p);
            let D = 1 / (m.x * g.y - g.x * m.y);
            !isFinite(D) || (y.copy(h).multiplyScalar(g.y).addScaledVector(f, -m.y).multiplyScalar(D), v.copy(f).multiplyScalar(m.x).addScaledVector(h, -g.x).multiplyScalar(D), u[M].add(y), u[C].add(y), u[P].add(y), c[M].add(v), c[C].add(v), c[P].add(v));
        }
        let S = this.groups;
        S.length === 0 && (S = [
            {
                start: 0,
                count: r.length
            }
        ]);
        for(let M = 0, C = S.length; M < C; ++M){
            let P = S[M], D = P.start, O = P.count;
            for(let I = D, z = D + O; I < z; I += 3)x(r[I + 0], r[I + 1], r[I + 2]);
        }
        let w = new _, A = new _, E = new _, b = new _;
        function T(M) {
            E.fromArray(s, M * 3), b.copy(E);
            let C = u[M];
            w.copy(C), w.sub(E.multiplyScalar(E.dot(C))).normalize(), A.crossVectors(b, C);
            let D = A.dot(c[M]) < 0 ? -1 : 1;
            l[M * 4] = w.x, l[M * 4 + 1] = w.y, l[M * 4 + 2] = w.z, l[M * 4 + 3] = D;
        }
        for(let M = 0, C = S.length; M < C; ++M){
            let P = S[M], D = P.start, O = P.count;
            for(let I = D, z = D + O; I < z; I += 3)T(r[I + 0]), T(r[I + 1]), T(r[I + 2]);
        }
    }
    computeVertexNormals() {
        let t = this.index, e = this.getAttribute("position");
        if (e !== void 0) {
            let r = this.getAttribute("normal");
            if (r === void 0) r = new Ge(new Float32Array(e.count * 3), 3), this.setAttribute("normal", r);
            else for(let h = 0, f = r.count; h < f; h++)r.setXYZ(h, 0, 0, 0);
            let i = new _, s = new _, o = new _, a = new _, l = new _, u = new _, c = new _, d = new _;
            if (t) for(let h = 0, f = t.count; h < f; h += 3){
                let p = t.getX(h + 0), m = t.getX(h + 1), g = t.getX(h + 2);
                i.fromBufferAttribute(e, p), s.fromBufferAttribute(e, m), o.fromBufferAttribute(e, g), c.subVectors(o, s), d.subVectors(i, s), c.cross(d), a.fromBufferAttribute(r, p), l.fromBufferAttribute(r, m), u.fromBufferAttribute(r, g), a.add(c), l.add(c), u.add(c), r.setXYZ(p, a.x, a.y, a.z), r.setXYZ(m, l.x, l.y, l.z), r.setXYZ(g, u.x, u.y, u.z);
            }
            else for(let h = 0, f = e.count; h < f; h += 3)i.fromBufferAttribute(e, h + 0), s.fromBufferAttribute(e, h + 1), o.fromBufferAttribute(e, h + 2), c.subVectors(o, s), d.subVectors(i, s), c.cross(d), r.setXYZ(h + 0, c.x, c.y, c.z), r.setXYZ(h + 1, c.x, c.y, c.z), r.setXYZ(h + 2, c.x, c.y, c.z);
            this.normalizeNormals(), r.needsUpdate = !0;
        }
    }
    merge() {
        return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead."), this;
    }
    normalizeNormals() {
        let t = this.attributes.normal;
        for(let e = 0, r = t.count; e < r; e++)Oi.fromBufferAttribute(t, e), Oi.normalize(), t.setXYZ(e, Oi.x, Oi.y, Oi.z);
    }
    toNonIndexed() {
        function t(a, l) {
            let u = a.array, c = a.itemSize, d = a.normalized, h = new u.constructor(l.length * c), f = 0, p = 0;
            for(let m = 0, g = l.length; m < g; m++){
                a.isInterleavedBufferAttribute ? f = l[m] * a.data.stride + a.offset : f = l[m] * c;
                for(let y = 0; y < c; y++)h[p++] = u[f++];
            }
            return new Ge(h, c, d);
        }
        if (this.index === null) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        let e = new we, r = this.index.array, i = this.attributes;
        for(let a in i){
            let l = i[a], u = t(l, r);
            e.setAttribute(a, u);
        }
        let s = this.morphAttributes;
        for(let a in s){
            let l = [], u = s[a];
            for(let c = 0, d = u.length; c < d; c++){
                let h = u[c], f = t(h, r);
                l.push(f);
            }
            e.morphAttributes[a] = l;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        let o = this.groups;
        for(let a = 0, l = o.length; a < l; a++){
            let u = o[a];
            e.addGroup(u.start, u.count, u.materialIndex);
        }
        return e;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
            let l = this.parameters;
            for(let u in l)l[u] !== void 0 && (t[u] = l[u]);
            return t;
        }
        t.data = {
            attributes: {}
        };
        let e = this.index;
        e !== null && (t.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        let r = this.attributes;
        for(let l in r){
            let u = r[l];
            t.data.attributes[l] = u.toJSON(t.data);
        }
        let i = {}, s = !1;
        for(let l in this.morphAttributes){
            let u = this.morphAttributes[l], c = [];
            for(let d = 0, h = u.length; d < h; d++){
                let f = u[d];
                c.push(f.toJSON(t.data));
            }
            c.length > 0 && (i[l] = c, s = !0);
        }
        s && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
        let o = this.groups;
        o.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(o)));
        let a = this.boundingSphere;
        return a !== null && (t.data.boundingSphere = {
            center: a.center.toArray(),
            radius: a.radius
        }), t;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        let e = {};
        this.name = t.name;
        let r = t.index;
        r !== null && this.setIndex(r.clone(e));
        let i = t.attributes;
        for(let u in i){
            let c = i[u];
            this.setAttribute(u, c.clone(e));
        }
        let s = t.morphAttributes;
        for(let u in s){
            let c = [], d = s[u];
            for(let h = 0, f = d.length; h < f; h++)c.push(d[h].clone(e));
            this.morphAttributes[u] = c;
        }
        this.morphTargetsRelative = t.morphTargetsRelative;
        let o = t.groups;
        for(let u = 0, c = o.length; u < c; u++){
            let d = o[u];
            this.addGroup(d.start, d.count, d.materialIndex);
        }
        let a = t.boundingBox;
        a !== null && (this.boundingBox = a.clone());
        let l = t.boundingSphere;
        return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, t.parameters !== void 0 && (this.parameters = Object.assign({}, t.parameters)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, OT = new te, vu = new Rs, cS = new Er, Qf = new _, Kf = new _, Zf = new _, uS = new _, Ig = new _, Rg = new N, Lg = new N, Bg = new N, dS = new _, Ng = new _, rr = class extends mt {
    constructor(t = new we, e = new Ls){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
    getVertexPosition(t, e) {
        let r = this.geometry, i = r.attributes.position, s = r.morphAttributes.position, o = r.morphTargetsRelative;
        e.fromBufferAttribute(i, t);
        let a = this.morphTargetInfluences;
        if (s && a) {
            Ig.set(0, 0, 0);
            for(let l = 0, u = s.length; l < u; l++){
                let c = a[l], d = s[l];
                c !== 0 && (uS.fromBufferAttribute(d, t), o ? Ig.addScaledVector(uS, c) : Ig.addScaledVector(uS.sub(e), c));
            }
            e.add(Ig);
        }
        return this.isSkinnedMesh && this.boneTransform(t, e), e;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.material, s = this.matrixWorld;
        if (i === void 0 || (r.boundingSphere === null && r.computeBoundingSphere(), cS.copy(r.boundingSphere), cS.applyMatrix4(s), t.ray.intersectsSphere(cS) === !1) || (OT.copy(s).invert(), vu.copy(t.ray).applyMatrix4(OT), r.boundingBox !== null && vu.intersectsBox(r.boundingBox) === !1)) return;
        let o, a = r.index, l = r.attributes.position, u = r.attributes.uv, c = r.attributes.uv2, d = r.groups, h = r.drawRange;
        if (a !== null) {
            if (Array.isArray(i)) for(let f = 0, p = d.length; f < p; f++){
                let m = d[f], g = i[m.materialIndex], y = Math.max(m.start, h.start), v = Math.min(a.count, Math.min(m.start + m.count, h.start + h.count));
                for(let x = y, S = v; x < S; x += 3){
                    let w = a.getX(x), A = a.getX(x + 1), E = a.getX(x + 2);
                    o = Fg(this, g, t, vu, u, c, w, A, E), o && (o.faceIndex = Math.floor(x / 3), o.face.materialIndex = m.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, h.start), p = Math.min(a.count, h.start + h.count);
                for(let m = f, g = p; m < g; m += 3){
                    let y = a.getX(m), v = a.getX(m + 1), x = a.getX(m + 2);
                    o = Fg(this, i, t, vu, u, c, y, v, x), o && (o.faceIndex = Math.floor(m / 3), e.push(o));
                }
            }
        } else if (l !== void 0) {
            if (Array.isArray(i)) for(let f = 0, p = d.length; f < p; f++){
                let m = d[f], g = i[m.materialIndex], y = Math.max(m.start, h.start), v = Math.min(l.count, Math.min(m.start + m.count, h.start + h.count));
                for(let x = y, S = v; x < S; x += 3){
                    let w = x, A = x + 1, E = x + 2;
                    o = Fg(this, g, t, vu, u, c, w, A, E), o && (o.faceIndex = Math.floor(x / 3), o.face.materialIndex = m.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, h.start), p = Math.min(l.count, h.start + h.count);
                for(let m = f, g = p; m < g; m += 3){
                    let y = m, v = m + 1, x = m + 2;
                    o = Fg(this, i, t, vu, u, c, y, v, x), o && (o.faceIndex = Math.floor(m / 3), e.push(o));
                }
            }
        }
    }
};
function rk(n1, t, e, r, i, s, o, a) {
    let l;
    if (t.side === ai ? l = r.intersectTriangle(o, s, i, !0, a) : l = r.intersectTriangle(i, s, o, t.side === jn, a), l === null) return null;
    Ng.copy(a), Ng.applyMatrix4(n1.matrixWorld);
    let u = e.ray.origin.distanceTo(Ng);
    return u < e.near || u > e.far ? null : {
        distance: u,
        point: Ng.clone(),
        object: n1
    };
}
function Fg(n1, t, e, r, i, s, o, a, l) {
    n1.getVertexPosition(o, Qf), n1.getVertexPosition(a, Kf), n1.getVertexPosition(l, Zf);
    let u = rk(n1, t, e, r, Qf, Kf, Zf, dS);
    if (u) {
        i && (Rg.fromBufferAttribute(i, o), Lg.fromBufferAttribute(i, a), Bg.fromBufferAttribute(i, l), u.uv = vr.getUV(dS, Qf, Kf, Zf, Rg, Lg, Bg, new N)), s && (Rg.fromBufferAttribute(s, o), Lg.fromBufferAttribute(s, a), Bg.fromBufferAttribute(s, l), u.uv2 = vr.getUV(dS, Qf, Kf, Zf, Rg, Lg, Bg, new N));
        let c = {
            a: o,
            b: a,
            c: l,
            normal: new _,
            materialIndex: 0
        };
        vr.getNormal(Qf, Kf, Zf, c.normal), u.face = c;
    }
    return u;
}
var li = class extends we {
    constructor(t = 1, e = 1, r = 1, i = 1, s = 1, o = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t,
            height: e,
            depth: r,
            widthSegments: i,
            heightSegments: s,
            depthSegments: o
        };
        let a = this;
        i = Math.floor(i), s = Math.floor(s), o = Math.floor(o);
        let l = [], u = [], c = [], d = [], h = 0, f = 0;
        p("z", "y", "x", -1, -1, r, e, t, o, s, 0), p("z", "y", "x", 1, -1, r, e, -t, o, s, 1), p("x", "z", "y", 1, 1, t, r, e, i, o, 2), p("x", "z", "y", 1, -1, t, r, -e, i, o, 3), p("x", "y", "z", 1, -1, t, e, r, i, s, 4), p("x", "y", "z", -1, -1, t, e, -r, i, s, 5), this.setIndex(l), this.setAttribute("position", new be(u, 3)), this.setAttribute("normal", new be(c, 3)), this.setAttribute("uv", new be(d, 2));
        function p(m, g, y, v, x, S, w, A, E, b, T) {
            let M = S / E, C = w / b, P = S / 2, D = w / 2, O = A / 2, I = E + 1, z = b + 1, B = 0, V = 0, U = new _;
            for(let j = 0; j < z; j++){
                let W = j * C - D;
                for(let k = 0; k < I; k++){
                    let H = k * M - P;
                    U[m] = H * v, U[g] = W * x, U[y] = O, u.push(U.x, U.y, U.z), U[m] = 0, U[g] = 0, U[y] = A > 0 ? 1 : -1, c.push(U.x, U.y, U.z), d.push(k / E), d.push(1 - j / b), B += 1;
                }
            }
            for(let j = 0; j < b; j++)for(let W = 0; W < E; W++){
                let k = h + W + I * j, H = h + W + I * (j + 1), X = h + (W + 1) + I * (j + 1), q = h + (W + 1) + I * j;
                l.push(k, H, q), l.push(H, X, q), V += 6;
            }
            a.addGroup(f, V, T), f += V, h += B;
        }
    }
    static fromJSON(t) {
        return new li(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
};
function Pu(n1) {
    let t = {};
    for(let e in n1){
        t[e] = {};
        for(let r in n1[e]){
            let i = n1[e][r];
            i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? t[e][r] = i.clone() : Array.isArray(i) ? t[e][r] = i.slice() : t[e][r] = i;
        }
    }
    return t;
}
function un(n1) {
    let t = {};
    for(let e = 0; e < n1.length; e++){
        let r = Pu(n1[e]);
        for(let i in r)t[i] = r[i];
    }
    return t;
}
function ik(n1) {
    let t = [];
    for(let e = 0; e < n1.length; e++)t.push(n1[e].clone());
    return t;
}
function OM(n1) {
    return n1.getRenderTarget() === null && n1.outputEncoding === tt ? ao : ap;
}
var Ns = {
    clone: Pu,
    merge: un
}, nk = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, sk = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`, rt = class extends hc {
    constructor(t){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = nk, this.fragmentShader = sk, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = Pu(t.uniforms), this.uniformsGroups = ik(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(let i in this.uniforms){
            let o = this.uniforms[i].value;
            o && o.isTexture ? e.uniforms[i] = {
                type: "t",
                value: o.toJSON(t).uuid
            } : o && o.isColor ? e.uniforms[i] = {
                type: "c",
                value: o.getHex()
            } : o && o.isVector2 ? e.uniforms[i] = {
                type: "v2",
                value: o.toArray()
            } : o && o.isVector3 ? e.uniforms[i] = {
                type: "v3",
                value: o.toArray()
            } : o && o.isVector4 ? e.uniforms[i] = {
                type: "v4",
                value: o.toArray()
            } : o && o.isMatrix3 ? e.uniforms[i] = {
                type: "m3",
                value: o.toArray()
            } : o && o.isMatrix4 ? e.uniforms[i] = {
                type: "m4",
                value: o.toArray()
            } : e.uniforms[i] = {
                value: o
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        let r = {};
        for(let i in this.extensions)this.extensions[i] === !0 && (r[i] = !0);
        return Object.keys(r).length > 0 && (e.extensions = r), e;
    }
}, Hn = class extends mt {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new te, this.projectionMatrix = new te, this.projectionMatrixInverse = new te;
    }
    copy(t, e) {
        return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t, e) {
        super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, Wr = class extends Hn {
    constructor(t = 50, e = 1, r = .1, i = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = r, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
    setFocalLength(t) {
        let e = .5 * this.getFilmHeight() / t;
        this.fov = lp * 2 * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        let t = Math.tan(rp * .5 * this.fov);
        return .5 * this.getFilmHeight() / t;
    }
    getEffectiveFOV() {
        return lp * 2 * Math.atan(Math.tan(rp * .5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    setViewOffset(t, e, r, i, s, o) {
        this.aspect = t / e, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = this.near, e = t * Math.tan(rp * .5 * this.fov) / this.zoom, r = 2 * e, i = this.aspect * r, s = -0.5 * i, o = this.view;
        if (this.view !== null && this.view.enabled) {
            let l = o.fullWidth, u = o.fullHeight;
            s += o.offsetX * i / l, e -= o.offsetY * r / u, i *= o.width / l, r *= o.height / u;
        }
        let a = this.filmOffset;
        a !== 0 && (s += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + i, e, e - r, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, this.view !== null && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}, xu = -90, bu = 1, PS = class extends mt {
    constructor(t, e, r){
        super(), this.type = "CubeCamera", this.renderTarget = r;
        let i = new Wr(xu, bu, t, e);
        i.layers = this.layers, i.up.set(0, 1, 0), i.lookAt(1, 0, 0), this.add(i);
        let s = new Wr(xu, bu, t, e);
        s.layers = this.layers, s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), this.add(s);
        let o = new Wr(xu, bu, t, e);
        o.layers = this.layers, o.up.set(0, 0, -1), o.lookAt(0, 1, 0), this.add(o);
        let a = new Wr(xu, bu, t, e);
        a.layers = this.layers, a.up.set(0, 0, 1), a.lookAt(0, -1, 0), this.add(a);
        let l = new Wr(xu, bu, t, e);
        l.layers = this.layers, l.up.set(0, 1, 0), l.lookAt(0, 0, 1), this.add(l);
        let u = new Wr(xu, bu, t, e);
        u.layers = this.layers, u.up.set(0, 1, 0), u.lookAt(0, 0, -1), this.add(u);
    }
    update(t, e) {
        this.parent === null && this.updateMatrixWorld();
        let r = this.renderTarget, [i, s, o, a, l, u] = this.children, c = t.getRenderTarget(), d = t.toneMapping, h = t.xr.enabled;
        t.toneMapping = Os, t.xr.enabled = !1;
        let f = r.texture.generateMipmaps;
        r.texture.generateMipmaps = !1, t.setRenderTarget(r, 0), t.render(e, i), t.setRenderTarget(r, 1), t.render(e, s), t.setRenderTarget(r, 2), t.render(e, o), t.setRenderTarget(r, 3), t.render(e, a), t.setRenderTarget(r, 4), t.render(e, l), r.texture.generateMipmaps = f, t.setRenderTarget(r, 5), t.render(e, u), t.setRenderTarget(c), t.toneMapping = d, t.xr.enabled = h, r.texture.needsPMREMUpdate = !0;
    }
}, Du = class extends qt {
    constructor(t, e, r, i, s, o, a, l, u, c){
        t = t !== void 0 ? t : [], e = e !== void 0 ? e : Xa, super(t, e, r, i, s, o, a, l, u, c), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t) {
        this.image = t;
    }
}, DS = class extends at {
    constructor(t = 1, e = {}){
        super(t, t, e), this.isWebGLCubeRenderTarget = !0;
        let r = {
            width: t,
            height: t,
            depth: 1
        }, i = [
            r,
            r,
            r,
            r,
            r,
            r
        ];
        this.texture = new Du(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = e.generateMipmaps !== void 0 ? e.generateMipmaps : !1, this.texture.minFilter = e.minFilter !== void 0 ? e.minFilter : Qe;
    }
    fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        let r = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, i = new li(5, 5, 5), s = new rt({
            name: "CubemapFromEquirect",
            uniforms: Pu(r.uniforms),
            vertexShader: r.vertexShader,
            fragmentShader: r.fragmentShader,
            side: ai,
            blending: Wt
        });
        s.uniforms.tEquirect.value = e;
        let o = new rr(i, s), a = e.minFilter;
        return e.minFilter === dc && (e.minFilter = Qe), new PS(1, 10, this).update(t, o), e.minFilter = a, o.geometry.dispose(), o.material.dispose(), this;
    }
    clear(t, e, r, i) {
        let s = t.getRenderTarget();
        for(let o = 0; o < 6; o++)t.setRenderTarget(this, o), t.clear(e, r, i);
        t.setRenderTarget(s);
    }
}, hS = new _, ok = new _, ak = new Qt, qr = class {
    constructor(t = new _(1, 0, 0), e = 0){
        this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, r, i) {
        return this.normal.set(t, e, r), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, r) {
        let i = hS.subVectors(r, e).cross(ok.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
    copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
        let t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
    intersectLine(t, e) {
        let r = t.delta(hS), i = this.normal.dot(r);
        if (i === 0) return this.distanceToPoint(t.start) === 0 ? e.copy(t.start) : null;
        let s = -(t.start.dot(this.normal) + this.constant) / i;
        return s < 0 || s > 1 ? null : e.copy(r).multiplyScalar(s).add(t.start);
    }
    intersectsLine(t) {
        let e = this.distanceToPoint(t.start), r = this.distanceToPoint(t.end);
        return e < 0 && r > 0 || r < 0 && e > 0;
    }
    intersectsBox(t) {
        return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
        return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
        let r = e || ak.getNormalMatrix(t), i = this.coplanarPoint(hS).applyMatrix4(t), s = this.normal.applyMatrix3(r).normalize();
        return this.constant = -i.dot(s), this;
    }
    translate(t) {
        return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, Su = new Er, kg = new _, dp = class {
    constructor(t = new qr, e = new qr, r = new qr, i = new qr, s = new qr, o = new qr){
        this.planes = [
            t,
            e,
            r,
            i,
            s,
            o
        ];
    }
    set(t, e, r, i, s, o) {
        let a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(r), a[3].copy(i), a[4].copy(s), a[5].copy(o), this;
    }
    copy(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)e[r].copy(t.planes[r]);
        return this;
    }
    setFromProjectionMatrix(t) {
        let e = this.planes, r = t.elements, i = r[0], s = r[1], o = r[2], a = r[3], l = r[4], u = r[5], c = r[6], d = r[7], h = r[8], f = r[9], p = r[10], m = r[11], g = r[12], y = r[13], v = r[14], x = r[15];
        return e[0].setComponents(a - i, d - l, m - h, x - g).normalize(), e[1].setComponents(a + i, d + l, m + h, x + g).normalize(), e[2].setComponents(a + s, d + u, m + f, x + y).normalize(), e[3].setComponents(a - s, d - u, m - f, x - y).normalize(), e[4].setComponents(a - o, d - c, m - p, x - v).normalize(), e[5].setComponents(a + o, d + c, m + p, x + v).normalize(), this;
    }
    intersectsObject(t) {
        let e = t.geometry;
        return e.boundingSphere === null && e.computeBoundingSphere(), Su.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(Su);
    }
    intersectsSprite(t) {
        return Su.center.set(0, 0, 0), Su.radius = .7071067811865476, Su.applyMatrix4(t.matrixWorld), this.intersectsSphere(Su);
    }
    intersectsSphere(t) {
        let e = this.planes, r = t.center, i = -t.radius;
        for(let s = 0; s < 6; s++)if (e[s].distanceToPoint(r) < i) return !1;
        return !0;
    }
    intersectsBox(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++){
            let i = e[r];
            if (kg.x = i.normal.x > 0 ? t.max.x : t.min.x, kg.y = i.normal.y > 0 ? t.max.y : t.min.y, kg.z = i.normal.z > 0 ? t.max.z : t.min.z, i.distanceToPoint(kg) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)if (e[r].distanceToPoint(t) < 0) return !1;
        return !0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
function IM() {
    let n1 = null, t = !1, e = null, r = null;
    function i(s, o) {
        e(s, o), r = n1.requestAnimationFrame(i);
    }
    return {
        start: function() {
            t !== !0 && e !== null && (r = n1.requestAnimationFrame(i), t = !0);
        },
        stop: function() {
            n1.cancelAnimationFrame(r), t = !1;
        },
        setAnimationLoop: function(s) {
            e = s;
        },
        setContext: function(s) {
            n1 = s;
        }
    };
}
function lk(n1, t) {
    let e = t.isWebGL2, r = new WeakMap;
    function i(u, c) {
        let d = u.array, h = u.usage, f = n1.createBuffer();
        n1.bindBuffer(c, f), n1.bufferData(c, d, h), u.onUploadCallback();
        let p;
        if (d instanceof Float32Array) p = 5126;
        else if (d instanceof Uint16Array) {
            if (u.isFloat16BufferAttribute) {
                if (e) p = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else p = 5123;
        } else if (d instanceof Int16Array) p = 5122;
        else if (d instanceof Uint32Array) p = 5125;
        else if (d instanceof Int32Array) p = 5124;
        else if (d instanceof Int8Array) p = 5120;
        else if (d instanceof Uint8Array) p = 5121;
        else if (d instanceof Uint8ClampedArray) p = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + d);
        return {
            buffer: f,
            type: p,
            bytesPerElement: d.BYTES_PER_ELEMENT,
            version: u.version
        };
    }
    function s(u, c, d) {
        let h = c.array, f = c.updateRange;
        n1.bindBuffer(d, u), f.count === -1 ? n1.bufferSubData(d, 0, h) : (e ? n1.bufferSubData(d, f.offset * h.BYTES_PER_ELEMENT, h, f.offset, f.count) : n1.bufferSubData(d, f.offset * h.BYTES_PER_ELEMENT, h.subarray(f.offset, f.offset + f.count)), f.count = -1), c.onUploadCallback();
    }
    function o(u) {
        return u.isInterleavedBufferAttribute && (u = u.data), r.get(u);
    }
    function a(u) {
        u.isInterleavedBufferAttribute && (u = u.data);
        let c = r.get(u);
        c && (n1.deleteBuffer(c.buffer), r.delete(u));
    }
    function l(u, c) {
        if (u.isGLBufferAttribute) {
            let h = r.get(u);
            (!h || h.version < u.version) && r.set(u, {
                buffer: u.buffer,
                type: u.type,
                bytesPerElement: u.elementSize,
                version: u.version
            });
            return;
        }
        u.isInterleavedBufferAttribute && (u = u.data);
        let d = r.get(u);
        d === void 0 ? r.set(u, i(u, c)) : d.version < u.version && (s(d.buffer, u, c), d.version = u.version);
    }
    return {
        get: o,
        remove: a,
        update: l
    };
}
var hn = class extends we {
    constructor(t = 1, e = 1, r = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t,
            height: e,
            widthSegments: r,
            heightSegments: i
        };
        let s = t / 2, o = e / 2, a = Math.floor(r), l = Math.floor(i), u = a + 1, c = l + 1, d = t / a, h = e / l, f = [], p = [], m = [], g = [];
        for(let y = 0; y < c; y++){
            let v = y * h - o;
            for(let x = 0; x < u; x++){
                let S = x * d - s;
                p.push(S, -v, 0), m.push(0, 0, 1), g.push(x / a), g.push(1 - y / l);
            }
        }
        for(let y = 0; y < l; y++)for(let v = 0; v < a; v++){
            let x = v + u * y, S = v + u * (y + 1), w = v + 1 + u * (y + 1), A = v + 1 + u * y;
            f.push(x, S, A), f.push(S, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new be(p, 3)), this.setAttribute("normal", new be(m, 3)), this.setAttribute("uv", new be(g, 2));
    }
    static fromJSON(t) {
        return new hn(t.width, t.height, t.widthSegments, t.heightSegments);
    }
}, ck = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, uk = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, dk = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, hk = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, fk = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, pk = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, mk = "vec3 transformed = vec3( position );", gk = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, yk = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
	vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, vk = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, xk = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, bk = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, Sk = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, wk = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, Ak = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, _k = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, Ek = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, Tk = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, Mk = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, Ck = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, Pk = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, Dk = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, Ok = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, Ik = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, Rk = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, Lk = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, Bk = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Nk = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, Fk = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, kk = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, zk = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Vk = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, Uk = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Gk = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, jk = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, Hk = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, Wk = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, qk = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, Yk = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, Xk = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Qk = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Kk = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, Zk = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Jk = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, $k = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, ez = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, tz = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, rz = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, iz = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, nz = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, sz = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, oz = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, az = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, lz = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, cz = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, uz = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, dz = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, hz = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, fz = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, pz = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, mz = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, gz = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, yz = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, vz = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, xz = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, bz = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, Sz = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, wz = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, Az = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, _z = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Ez = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Tz = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, Mz = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, Cz = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, Pz = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, Dz = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, Oz = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, Iz = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, Rz = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, Lz = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, Bz = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Nz = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, Fz = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, kz = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, zz = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, Vz = `#if NUM_SPOT_LIGHT_COORDS > 0
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, Uz = `#if NUM_SPOT_LIGHT_COORDS > 0
  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, Gz = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, jz = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, Hz = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, Wz = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, qz = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Yz = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, Xz = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, Qz = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Kz = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, Zz = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, Jz = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
#endif`, $z = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, eV = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, tV = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, rV = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, iV = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, nV = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, sV = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, oV = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`, aV = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, lV = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, cV = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, uV = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, dV = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, hV = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, fV = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, pV = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, mV = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, gV = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, yV = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, vV = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, xV = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, bV = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, SV = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, wV = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, AV = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, _V = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, EV = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, TV = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, MV = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, CV = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, PV = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, DV = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, OV = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, IV = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, RV = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, LV = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, BV = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, NV = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, FV = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, kV = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, zV = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, VV = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, ht = {
    alphamap_fragment: ck,
    alphamap_pars_fragment: uk,
    alphatest_fragment: dk,
    alphatest_pars_fragment: hk,
    aomap_fragment: fk,
    aomap_pars_fragment: pk,
    begin_vertex: mk,
    beginnormal_vertex: gk,
    bsdfs: yk,
    iridescence_fragment: vk,
    bumpmap_pars_fragment: xk,
    clipping_planes_fragment: bk,
    clipping_planes_pars_fragment: Sk,
    clipping_planes_pars_vertex: wk,
    clipping_planes_vertex: Ak,
    color_fragment: _k,
    color_pars_fragment: Ek,
    color_pars_vertex: Tk,
    color_vertex: Mk,
    common: Ck,
    cube_uv_reflection_fragment: Pk,
    defaultnormal_vertex: Dk,
    displacementmap_pars_vertex: Ok,
    displacementmap_vertex: Ik,
    emissivemap_fragment: Rk,
    emissivemap_pars_fragment: Lk,
    encodings_fragment: Bk,
    encodings_pars_fragment: Nk,
    envmap_fragment: Fk,
    envmap_common_pars_fragment: kk,
    envmap_pars_fragment: zk,
    envmap_pars_vertex: Vk,
    envmap_physical_pars_fragment: Jk,
    envmap_vertex: Uk,
    fog_vertex: Gk,
    fog_pars_vertex: jk,
    fog_fragment: Hk,
    fog_pars_fragment: Wk,
    gradientmap_pars_fragment: qk,
    lightmap_fragment: Yk,
    lightmap_pars_fragment: Xk,
    lights_lambert_fragment: Qk,
    lights_lambert_pars_fragment: Kk,
    lights_pars_begin: Zk,
    lights_toon_fragment: $k,
    lights_toon_pars_fragment: ez,
    lights_phong_fragment: tz,
    lights_phong_pars_fragment: rz,
    lights_physical_fragment: iz,
    lights_physical_pars_fragment: nz,
    lights_fragment_begin: sz,
    lights_fragment_maps: oz,
    lights_fragment_end: az,
    logdepthbuf_fragment: lz,
    logdepthbuf_pars_fragment: cz,
    logdepthbuf_pars_vertex: uz,
    logdepthbuf_vertex: dz,
    map_fragment: hz,
    map_pars_fragment: fz,
    map_particle_fragment: pz,
    map_particle_pars_fragment: mz,
    metalnessmap_fragment: gz,
    metalnessmap_pars_fragment: yz,
    morphcolor_vertex: vz,
    morphnormal_vertex: xz,
    morphtarget_pars_vertex: bz,
    morphtarget_vertex: Sz,
    normal_fragment_begin: wz,
    normal_fragment_maps: Az,
    normal_pars_fragment: _z,
    normal_pars_vertex: Ez,
    normal_vertex: Tz,
    normalmap_pars_fragment: Mz,
    clearcoat_normal_fragment_begin: Cz,
    clearcoat_normal_fragment_maps: Pz,
    clearcoat_pars_fragment: Dz,
    iridescence_pars_fragment: Oz,
    output_fragment: Iz,
    packing: Rz,
    premultiplied_alpha_fragment: Lz,
    project_vertex: Bz,
    dithering_fragment: Nz,
    dithering_pars_fragment: Fz,
    roughnessmap_fragment: kz,
    roughnessmap_pars_fragment: zz,
    shadowmap_pars_fragment: Vz,
    shadowmap_pars_vertex: Uz,
    shadowmap_vertex: Gz,
    shadowmask_pars_fragment: jz,
    skinbase_vertex: Hz,
    skinning_pars_vertex: Wz,
    skinning_vertex: qz,
    skinnormal_vertex: Yz,
    specularmap_fragment: Xz,
    specularmap_pars_fragment: Qz,
    tonemapping_fragment: Kz,
    tonemapping_pars_fragment: Zz,
    transmission_fragment: Jz,
    transmission_pars_fragment: $z,
    uv_pars_fragment: eV,
    uv_pars_vertex: tV,
    uv_vertex: rV,
    uv2_pars_fragment: iV,
    uv2_pars_vertex: nV,
    uv2_vertex: sV,
    worldpos_vertex: oV,
    background_vert: aV,
    background_frag: lV,
    backgroundCube_vert: cV,
    backgroundCube_frag: uV,
    cube_vert: dV,
    cube_frag: hV,
    depth_vert: fV,
    depth_frag: pV,
    distanceRGBA_vert: mV,
    distanceRGBA_frag: gV,
    equirect_vert: yV,
    equirect_frag: vV,
    linedashed_vert: xV,
    linedashed_frag: bV,
    meshbasic_vert: SV,
    meshbasic_frag: wV,
    meshlambert_vert: AV,
    meshlambert_frag: _V,
    meshmatcap_vert: EV,
    meshmatcap_frag: TV,
    meshnormal_vert: MV,
    meshnormal_frag: CV,
    meshphong_vert: PV,
    meshphong_frag: DV,
    meshphysical_vert: OV,
    meshphysical_frag: IV,
    meshtoon_vert: RV,
    meshtoon_frag: LV,
    points_vert: BV,
    points_frag: NV,
    shadow_vert: FV,
    shadow_frag: kV,
    sprite_vert: zV,
    sprite_frag: VV
}, Ae = {
    common: {
        diffuse: {
            value: new Le(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new Qt
        },
        uv2Transform: {
            value: new Qt
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new N(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new Le(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new Le(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Qt
        }
    },
    sprite: {
        diffuse: {
            value: new Le(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new N(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Qt
        }
    }
}, lo = {
    basic: {
        uniforms: un([
            Ae.common,
            Ae.specularmap,
            Ae.envmap,
            Ae.aomap,
            Ae.lightmap,
            Ae.fog
        ]),
        vertexShader: ht.meshbasic_vert,
        fragmentShader: ht.meshbasic_frag
    },
    lambert: {
        uniforms: un([
            Ae.common,
            Ae.specularmap,
            Ae.envmap,
            Ae.aomap,
            Ae.lightmap,
            Ae.emissivemap,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            Ae.fog,
            Ae.lights,
            {
                emissive: {
                    value: new Le(0)
                }
            }
        ]),
        vertexShader: ht.meshlambert_vert,
        fragmentShader: ht.meshlambert_frag
    },
    phong: {
        uniforms: un([
            Ae.common,
            Ae.specularmap,
            Ae.envmap,
            Ae.aomap,
            Ae.lightmap,
            Ae.emissivemap,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            Ae.fog,
            Ae.lights,
            {
                emissive: {
                    value: new Le(0)
                },
                specular: {
                    value: new Le(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: ht.meshphong_vert,
        fragmentShader: ht.meshphong_frag
    },
    standard: {
        uniforms: un([
            Ae.common,
            Ae.envmap,
            Ae.aomap,
            Ae.lightmap,
            Ae.emissivemap,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            Ae.roughnessmap,
            Ae.metalnessmap,
            Ae.fog,
            Ae.lights,
            {
                emissive: {
                    value: new Le(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: ht.meshphysical_vert,
        fragmentShader: ht.meshphysical_frag
    },
    toon: {
        uniforms: un([
            Ae.common,
            Ae.aomap,
            Ae.lightmap,
            Ae.emissivemap,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            Ae.gradientmap,
            Ae.fog,
            Ae.lights,
            {
                emissive: {
                    value: new Le(0)
                }
            }
        ]),
        vertexShader: ht.meshtoon_vert,
        fragmentShader: ht.meshtoon_frag
    },
    matcap: {
        uniforms: un([
            Ae.common,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            Ae.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: ht.meshmatcap_vert,
        fragmentShader: ht.meshmatcap_frag
    },
    points: {
        uniforms: un([
            Ae.points,
            Ae.fog
        ]),
        vertexShader: ht.points_vert,
        fragmentShader: ht.points_frag
    },
    dashed: {
        uniforms: un([
            Ae.common,
            Ae.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: ht.linedashed_vert,
        fragmentShader: ht.linedashed_frag
    },
    depth: {
        uniforms: un([
            Ae.common,
            Ae.displacementmap
        ]),
        vertexShader: ht.depth_vert,
        fragmentShader: ht.depth_frag
    },
    normal: {
        uniforms: un([
            Ae.common,
            Ae.bumpmap,
            Ae.normalmap,
            Ae.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: ht.meshnormal_vert,
        fragmentShader: ht.meshnormal_frag
    },
    sprite: {
        uniforms: un([
            Ae.sprite,
            Ae.fog
        ]),
        vertexShader: ht.sprite_vert,
        fragmentShader: ht.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new Qt
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: ht.background_vert,
        fragmentShader: ht.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: ht.backgroundCube_vert,
        fragmentShader: ht.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: ht.cube_vert,
        fragmentShader: ht.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: ht.equirect_vert,
        fragmentShader: ht.equirect_frag
    },
    distanceRGBA: {
        uniforms: un([
            Ae.common,
            Ae.displacementmap,
            {
                referencePosition: {
                    value: new _
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: ht.distanceRGBA_vert,
        fragmentShader: ht.distanceRGBA_frag
    },
    shadow: {
        uniforms: un([
            Ae.lights,
            Ae.fog,
            {
                color: {
                    value: new Le(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: ht.shadow_vert,
        fragmentShader: ht.shadow_frag
    }
};
lo.physical = {
    uniforms: un([
        lo.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new N(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new Le(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new N
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new Le(0)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new Le(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: ht.meshphysical_vert,
    fragmentShader: ht.meshphysical_frag
};
var zg = {
    r: 0,
    b: 0,
    g: 0
};
function UV(n1, t, e, r, i, s, o) {
    let a = new Le(0), l = s === !0 ? 0 : 1, u, c, d = null, h = 0, f = null;
    function p(g, y) {
        let v = !1, x = y.isScene === !0 ? y.background : null;
        x && x.isTexture && (x = (y.backgroundBlurriness > 0 ? e : t).get(x));
        let S = n1.xr, w = S.getSession && S.getSession();
        w && w.environmentBlendMode === "additive" && (x = null), x === null ? m(a, l) : x && x.isColor && (m(x, 1), v = !0), (n1.autoClear || v) && n1.clear(n1.autoClearColor, n1.autoClearDepth, n1.autoClearStencil), x && (x.isCubeTexture || x.mapping === Qu) ? (c === void 0 && (c = new rr(new li(1, 1, 1), new rt({
            name: "BackgroundCubeMaterial",
            uniforms: Pu(lo.backgroundCube.uniforms),
            vertexShader: lo.backgroundCube.vertexShader,
            fragmentShader: lo.backgroundCube.fragmentShader,
            side: ai,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(A, E, b) {
            this.matrixWorld.copyPosition(b.matrixWorld);
        }, Object.defineProperty(c.material, "envMap", {
            get: function() {
                return this.uniforms.envMap.value;
            }
        }), i.update(c)), c.material.uniforms.envMap.value = x, c.material.uniforms.flipEnvMap.value = x.isCubeTexture && x.isRenderTargetTexture === !1 ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = y.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, c.material.toneMapped = x.encoding !== tt, (d !== x || h !== x.version || f !== n1.toneMapping) && (c.material.needsUpdate = !0, d = x, h = x.version, f = n1.toneMapping), c.layers.enableAll(), g.unshift(c, c.geometry, c.material, 0, 0, null)) : x && x.isTexture && (u === void 0 && (u = new rr(new hn(2, 2), new rt({
            name: "BackgroundMaterial",
            uniforms: Pu(lo.background.uniforms),
            vertexShader: lo.background.vertexShader,
            fragmentShader: lo.background.fragmentShader,
            side: jn,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), u.geometry.deleteAttribute("normal"), Object.defineProperty(u.material, "map", {
            get: function() {
                return this.uniforms.t2D.value;
            }
        }), i.update(u)), u.material.uniforms.t2D.value = x, u.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, u.material.toneMapped = x.encoding !== tt, x.matrixAutoUpdate === !0 && x.updateMatrix(), u.material.uniforms.uvTransform.value.copy(x.matrix), (d !== x || h !== x.version || f !== n1.toneMapping) && (u.material.needsUpdate = !0, d = x, h = x.version, f = n1.toneMapping), u.layers.enableAll(), g.unshift(u, u.geometry, u.material, 0, 0, null));
    }
    function m(g, y) {
        g.getRGB(zg, OM(n1)), r.buffers.color.setClear(zg.r, zg.g, zg.b, y, o);
    }
    return {
        getClearColor: function() {
            return a;
        },
        setClearColor: function(g, y = 1) {
            a.set(g), l = y, m(a, l);
        },
        getClearAlpha: function() {
            return l;
        },
        setClearAlpha: function(g) {
            l = g, m(a, l);
        },
        render: p
    };
}
function GV(n1, t, e, r) {
    let i = n1.getParameter(34921), s = r.isWebGL2 ? null : t.get("OES_vertex_array_object"), o = r.isWebGL2 || s !== null, a = {}, l = g(null), u = l, c = !1;
    function d(O, I, z, B, V) {
        let U = !1;
        if (o) {
            let j = m(B, z, I);
            u !== j && (u = j, f(u.object)), U = y(O, B, z, V), U && v(O, B, z, V);
        } else {
            let j = I.wireframe === !0;
            (u.geometry !== B.id || u.program !== z.id || u.wireframe !== j) && (u.geometry = B.id, u.program = z.id, u.wireframe = j, U = !0);
        }
        V !== null && e.update(V, 34963), (U || c) && (c = !1, b(O, I, z, B), V !== null && n1.bindBuffer(34963, e.get(V).buffer));
    }
    function h() {
        return r.isWebGL2 ? n1.createVertexArray() : s.createVertexArrayOES();
    }
    function f(O) {
        return r.isWebGL2 ? n1.bindVertexArray(O) : s.bindVertexArrayOES(O);
    }
    function p(O) {
        return r.isWebGL2 ? n1.deleteVertexArray(O) : s.deleteVertexArrayOES(O);
    }
    function m(O, I, z) {
        let B = z.wireframe === !0, V = a[O.id];
        V === void 0 && (V = {}, a[O.id] = V);
        let U = V[I.id];
        U === void 0 && (U = {}, V[I.id] = U);
        let j = U[B];
        return j === void 0 && (j = g(h()), U[B] = j), j;
    }
    function g(O) {
        let I = [], z = [], B = [];
        for(let V = 0; V < i; V++)I[V] = 0, z[V] = 0, B[V] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: I,
            enabledAttributes: z,
            attributeDivisors: B,
            object: O,
            attributes: {},
            index: null
        };
    }
    function y(O, I, z, B) {
        let V = u.attributes, U = I.attributes, j = 0, W = z.getAttributes();
        for(let k in W)if (W[k].location >= 0) {
            let X = V[k], q = U[k];
            if (q === void 0 && (k === "instanceMatrix" && O.instanceMatrix && (q = O.instanceMatrix), k === "instanceColor" && O.instanceColor && (q = O.instanceColor)), X === void 0 || X.attribute !== q || q && X.data !== q.data) return !0;
            j++;
        }
        return u.attributesNum !== j || u.index !== B;
    }
    function v(O, I, z, B) {
        let V = {}, U = I.attributes, j = 0, W = z.getAttributes();
        for(let k in W)if (W[k].location >= 0) {
            let X = U[k];
            X === void 0 && (k === "instanceMatrix" && O.instanceMatrix && (X = O.instanceMatrix), k === "instanceColor" && O.instanceColor && (X = O.instanceColor));
            let q = {};
            q.attribute = X, X && X.data && (q.data = X.data), V[k] = q, j++;
        }
        u.attributes = V, u.attributesNum = j, u.index = B;
    }
    function x() {
        let O = u.newAttributes;
        for(let I = 0, z = O.length; I < z; I++)O[I] = 0;
    }
    function S(O) {
        w(O, 0);
    }
    function w(O, I) {
        let z = u.newAttributes, B = u.enabledAttributes, V = u.attributeDivisors;
        z[O] = 1, B[O] === 0 && (n1.enableVertexAttribArray(O), B[O] = 1), V[O] !== I && ((r.isWebGL2 ? n1 : t.get("ANGLE_instanced_arrays"))[r.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](O, I), V[O] = I);
    }
    function A() {
        let O = u.newAttributes, I = u.enabledAttributes;
        for(let z = 0, B = I.length; z < B; z++)I[z] !== O[z] && (n1.disableVertexAttribArray(z), I[z] = 0);
    }
    function E(O, I, z, B, V, U) {
        r.isWebGL2 === !0 && (z === 5124 || z === 5125) ? n1.vertexAttribIPointer(O, I, z, V, U) : n1.vertexAttribPointer(O, I, z, B, V, U);
    }
    function b(O, I, z, B) {
        if (r.isWebGL2 === !1 && (O.isInstancedMesh || B.isInstancedBufferGeometry) && t.get("ANGLE_instanced_arrays") === null) return;
        x();
        let V = B.attributes, U = z.getAttributes(), j = I.defaultAttributeValues;
        for(let W in U){
            let k = U[W];
            if (k.location >= 0) {
                let H = V[W];
                if (H === void 0 && (W === "instanceMatrix" && O.instanceMatrix && (H = O.instanceMatrix), W === "instanceColor" && O.instanceColor && (H = O.instanceColor)), H !== void 0) {
                    let X = H.normalized, q = H.itemSize, G = e.get(H);
                    if (G === void 0) continue;
                    let J = G.buffer, Z = G.type, K = G.bytesPerElement;
                    if (H.isInterleavedBufferAttribute) {
                        let Y = H.data, ye = Y.stride, fe = H.offset;
                        if (Y.isInstancedInterleavedBuffer) {
                            for(let oe = 0; oe < k.locationSize; oe++)w(k.location + oe, Y.meshPerAttribute);
                            O.isInstancedMesh !== !0 && B._maxInstanceCount === void 0 && (B._maxInstanceCount = Y.meshPerAttribute * Y.count);
                        } else for(let oe = 0; oe < k.locationSize; oe++)S(k.location + oe);
                        n1.bindBuffer(34962, J);
                        for(let oe = 0; oe < k.locationSize; oe++)E(k.location + oe, q / k.locationSize, Z, X, ye * K, (fe + q / k.locationSize * oe) * K);
                    } else {
                        if (H.isInstancedBufferAttribute) {
                            for(let Y = 0; Y < k.locationSize; Y++)w(k.location + Y, H.meshPerAttribute);
                            O.isInstancedMesh !== !0 && B._maxInstanceCount === void 0 && (B._maxInstanceCount = H.meshPerAttribute * H.count);
                        } else for(let Y = 0; Y < k.locationSize; Y++)S(k.location + Y);
                        n1.bindBuffer(34962, J);
                        for(let Y = 0; Y < k.locationSize; Y++)E(k.location + Y, q / k.locationSize, Z, X, q * K, q / k.locationSize * Y * K);
                    }
                } else if (j !== void 0) {
                    let X = j[W];
                    if (X !== void 0) switch(X.length){
                        case 2:
                            n1.vertexAttrib2fv(k.location, X);
                            break;
                        case 3:
                            n1.vertexAttrib3fv(k.location, X);
                            break;
                        case 4:
                            n1.vertexAttrib4fv(k.location, X);
                            break;
                        default:
                            n1.vertexAttrib1fv(k.location, X);
                    }
                }
            }
        }
        A();
    }
    function T() {
        P();
        for(let O in a){
            let I = a[O];
            for(let z in I){
                let B = I[z];
                for(let V in B)p(B[V].object), delete B[V];
                delete I[z];
            }
            delete a[O];
        }
    }
    function M(O) {
        if (a[O.id] === void 0) return;
        let I = a[O.id];
        for(let z in I){
            let B = I[z];
            for(let V in B)p(B[V].object), delete B[V];
            delete I[z];
        }
        delete a[O.id];
    }
    function C(O) {
        for(let I in a){
            let z = a[I];
            if (z[O.id] === void 0) continue;
            let B = z[O.id];
            for(let V in B)p(B[V].object), delete B[V];
            delete z[O.id];
        }
    }
    function P() {
        D(), c = !0, u !== l && (u = l, f(u.object));
    }
    function D() {
        l.geometry = null, l.program = null, l.wireframe = !1;
    }
    return {
        setup: d,
        reset: P,
        resetDefaultState: D,
        dispose: T,
        releaseStatesOfGeometry: M,
        releaseStatesOfProgram: C,
        initAttributes: x,
        enableAttribute: S,
        disableUnusedAttributes: A
    };
}
function jV(n1, t, e, r) {
    let i = r.isWebGL2, s;
    function o(u) {
        s = u;
    }
    function a(u, c) {
        n1.drawArrays(s, u, c), e.update(c, s, 1);
    }
    function l(u, c, d) {
        if (d === 0) return;
        let h, f;
        if (i) h = n1, f = "drawArraysInstanced";
        else if (h = t.get("ANGLE_instanced_arrays"), f = "drawArraysInstancedANGLE", h === null) {
            console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        h[f](s, u, c, d), e.update(c, s, d);
    }
    this.setMode = o, this.render = a, this.renderInstances = l;
}
function HV(n1, t, e) {
    let r;
    function i() {
        if (r !== void 0) return r;
        if (t.has("EXT_texture_filter_anisotropic") === !0) {
            let E = t.get("EXT_texture_filter_anisotropic");
            r = n1.getParameter(E.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else r = 0;
        return r;
    }
    function s(E) {
        if (E === "highp") {
            if (n1.getShaderPrecisionFormat(35633, 36338).precision > 0 && n1.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            E = "mediump";
        }
        return E === "mediump" && n1.getShaderPrecisionFormat(35633, 36337).precision > 0 && n1.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }
    let o = typeof WebGL2RenderingContext < "u" && n1 instanceof WebGL2RenderingContext, a = e.precision !== void 0 ? e.precision : "highp", l = s(a);
    l !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", l, "instead."), a = l);
    let u = o || t.has("WEBGL_draw_buffers"), c = e.logarithmicDepthBuffer === !0, d = n1.getParameter(34930), h = n1.getParameter(35660), f = n1.getParameter(3379), p = n1.getParameter(34076), m = n1.getParameter(34921), g = n1.getParameter(36347), y = n1.getParameter(36348), v = n1.getParameter(36349), x = h > 0, S = o || t.has("OES_texture_float"), w = x && S, A = o ? n1.getParameter(36183) : 0;
    return {
        isWebGL2: o,
        drawBuffers: u,
        getMaxAnisotropy: i,
        getMaxPrecision: s,
        precision: a,
        logarithmicDepthBuffer: c,
        maxTextures: d,
        maxVertexTextures: h,
        maxTextureSize: f,
        maxCubemapSize: p,
        maxAttributes: m,
        maxVertexUniforms: g,
        maxVaryings: y,
        maxFragmentUniforms: v,
        vertexTextures: x,
        floatFragmentTextures: S,
        floatVertexTextures: w,
        maxSamples: A
    };
}
function WV(n1) {
    let t = this, e = null, r = 0, i = !1, s = !1, o = new qr, a = new Qt, l = {
        value: null,
        needsUpdate: !1
    };
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(d, h) {
        let f = d.length !== 0 || h || r !== 0 || i;
        return i = h, r = d.length, f;
    }, this.beginShadows = function() {
        s = !0, c(null);
    }, this.endShadows = function() {
        s = !1;
    }, this.setGlobalState = function(d, h) {
        e = c(d, h, 0);
    }, this.setState = function(d, h, f) {
        let p = d.clippingPlanes, m = d.clipIntersection, g = d.clipShadows, y = n1.get(d);
        if (!i || p === null || p.length === 0 || s && !g) s ? c(null) : u();
        else {
            let v = s ? 0 : r, x = v * 4, S = y.clippingState || null;
            l.value = S, S = c(p, h, x, f);
            for(let w = 0; w !== x; ++w)S[w] = e[w];
            y.clippingState = S, this.numIntersection = m ? this.numPlanes : 0, this.numPlanes += v;
        }
    };
    function u() {
        l.value !== e && (l.value = e, l.needsUpdate = r > 0), t.numPlanes = r, t.numIntersection = 0;
    }
    function c(d, h, f, p) {
        let m = d !== null ? d.length : 0, g = null;
        if (m !== 0) {
            if (g = l.value, p !== !0 || g === null) {
                let y = f + m * 4, v = h.matrixWorldInverse;
                a.getNormalMatrix(v), (g === null || g.length < y) && (g = new Float32Array(y));
                for(let x = 0, S = f; x !== m; ++x, S += 4)o.copy(d[x]).applyMatrix4(v, a), o.normal.toArray(g, S), g[S + 3] = o.constant;
            }
            l.value = g, l.needsUpdate = !0;
        }
        return t.numPlanes = m, t.numIntersection = 0, g;
    }
}
function qV(n1) {
    let t = new WeakMap;
    function e(o, a) {
        return a === AS ? o.mapping = Xa : a === _S && (o.mapping = Qa), o;
    }
    function r(o) {
        if (o && o.isTexture && o.isRenderTargetTexture === !1) {
            let a = o.mapping;
            if (a === AS || a === _S) {
                if (t.has(o)) {
                    let l = t.get(o).texture;
                    return e(l, o.mapping);
                } else {
                    let l = o.image;
                    if (l && l.height > 0) {
                        let u = new DS(l.height / 2);
                        return u.fromEquirectangularTexture(n1, o), t.set(o, u), o.addEventListener("dispose", i), e(u.texture, o.mapping);
                    } else return null;
                }
            }
        }
        return o;
    }
    function i(o) {
        let a = o.target;
        a.removeEventListener("dispose", i);
        let l = t.get(a);
        l !== void 0 && (t.delete(a), l.dispose());
    }
    function s() {
        t = new WeakMap;
    }
    return {
        get: r,
        dispose: s
    };
}
var Ou = class extends Hn {
    constructor(t = -1, e = 1, r = 1, i = -1, s = .1, o = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = r, this.bottom = i, this.near = s, this.far = o, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
    }
    setViewOffset(t, e, r, i, s, o) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), r = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2, s = r - t, o = r + t, a = i + e, l = i - e;
        if (this.view !== null && this.view.enabled) {
            let u = (this.right - this.left) / this.view.fullWidth / this.zoom, c = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            s += u * this.view.offsetX, o = s + u * this.view.width, a -= c * this.view.offsetY, l = a - c * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(s, o, a, l, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, this.view !== null && (e.object.view = Object.assign({}, this.view)), e;
    }
}, Tu = 4, IT = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], lc = 20, fS = new Ou, RT = new Le, pS = null, ac = (1 + Math.sqrt(5)) / 2, wu = 1 / ac, LT = [
    new _(1, 1, 1),
    new _(-1, 1, 1),
    new _(1, 1, -1),
    new _(-1, 1, -1),
    new _(0, ac, wu),
    new _(0, ac, -wu),
    new _(wu, 0, ac),
    new _(-wu, 0, ac),
    new _(ac, wu, 0),
    new _(-ac, wu, 0)
], ay = class {
    constructor(t){
        this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t, e = 0, r = .1, i = 100) {
        pS = this._renderer.getRenderTarget(), this._setSize(256);
        let s = this._allocateTargets();
        return s.depthBuffer = !0, this._sceneToCubeUV(t, r, i, s), e > 0 && this._blur(s, 0, 0, e), this._applyPMREM(s), this._cleanup(s), s;
    }
    fromEquirectangular(t, e = null) {
        return this._fromTexture(t, e);
    }
    fromCubemap(t, e = null) {
        return this._fromTexture(t, e);
    }
    compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = FT(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = NT(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
    }
    _setSize(t) {
        this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let t = 0; t < this._lodPlanes.length; t++)this._lodPlanes[t].dispose();
    }
    _cleanup(t) {
        this._renderer.setRenderTarget(pS), t.scissorTest = !1, Vg(t, 0, 0, t.width, t.height);
    }
    _fromTexture(t, e) {
        t.mapping === Xa || t.mapping === Qa ? this._setSize(t.image.length === 0 ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), pS = this._renderer.getRenderTarget();
        let r = e || this._allocateTargets();
        return this._textureToCubeUV(t, r), this._applyPMREM(r), this._cleanup(r), r;
    }
    _allocateTargets() {
        let t = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, r = {
            magFilter: Qe,
            minFilter: Qe,
            generateMipmaps: !1,
            type: sa,
            format: Fr,
            encoding: dn,
            depthBuffer: !1
        }, i = BT(t, e, r);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== e) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = BT(t, e, r);
            let { _lodMax: s } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = YV(s)), this._blurMaterial = XV(s, t, e);
        }
        return i;
    }
    _compileMaterial(t) {
        let e = new rr(this._lodPlanes[0], t);
        this._renderer.compile(e, fS);
    }
    _sceneToCubeUV(t, e, r, i) {
        let a = new Wr(90, 1, e, r), l = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], u = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], c = this._renderer, d = c.autoClear, h = c.toneMapping;
        c.getClearColor(RT), c.toneMapping = Os, c.autoClear = !1;
        let f = new Ls({
            name: "PMREM.Background",
            side: ai,
            depthWrite: !1,
            depthTest: !1
        }), p = new rr(new li, f), m = !1, g = t.background;
        g ? g.isColor && (f.color.copy(g), t.background = null, m = !0) : (f.color.copy(RT), m = !0);
        for(let y = 0; y < 6; y++){
            let v = y % 3;
            v === 0 ? (a.up.set(0, l[y], 0), a.lookAt(u[y], 0, 0)) : v === 1 ? (a.up.set(0, 0, l[y]), a.lookAt(0, u[y], 0)) : (a.up.set(0, l[y], 0), a.lookAt(0, 0, u[y]));
            let x = this._cubeSize;
            Vg(i, v * x, y > 2 ? x : 0, x, x), c.setRenderTarget(i), m && c.render(p, a), c.render(t, a);
        }
        p.geometry.dispose(), p.material.dispose(), c.toneMapping = h, c.autoClear = d, t.background = g;
    }
    _textureToCubeUV(t, e) {
        let r = this._renderer, i = t.mapping === Xa || t.mapping === Qa;
        i ? (this._cubemapMaterial === null && (this._cubemapMaterial = FT()), this._cubemapMaterial.uniforms.flipEnvMap.value = t.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = NT());
        let s = i ? this._cubemapMaterial : this._equirectMaterial, o = new rr(this._lodPlanes[0], s), a = s.uniforms;
        a.envMap.value = t;
        let l = this._cubeSize;
        Vg(e, 0, 0, 3 * l, 2 * l), r.setRenderTarget(e), r.render(o, fS);
    }
    _applyPMREM(t) {
        let e = this._renderer, r = e.autoClear;
        e.autoClear = !1;
        for(let i = 1; i < this._lodPlanes.length; i++){
            let s = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]), o = LT[(i - 1) % LT.length];
            this._blur(t, i - 1, i, s, o);
        }
        e.autoClear = r;
    }
    _blur(t, e, r, i, s) {
        let o = this._pingPongRenderTarget;
        this._halfBlur(t, o, e, r, i, "latitudinal", s), this._halfBlur(o, t, r, r, i, "longitudinal", s);
    }
    _halfBlur(t, e, r, i, s, o, a) {
        let l = this._renderer, u = this._blurMaterial;
        o !== "latitudinal" && o !== "longitudinal" && console.error("blur direction must be either latitudinal or longitudinal!");
        let c = 3, d = new rr(this._lodPlanes[i], u), h = u.uniforms, f = this._sizeLods[r] - 1, p = isFinite(s) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * lc - 1), m = s / p, g = isFinite(s) ? 1 + Math.floor(c * m) : lc;
        g > lc && console.warn(`sigmaRadians, ${s}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${lc}`);
        let y = [], v = 0;
        for(let E = 0; E < lc; ++E){
            let b = E / m, T = Math.exp(-b * b / 2);
            y.push(T), E === 0 ? v += T : E < g && (v += 2 * T);
        }
        for(let E = 0; E < y.length; E++)y[E] = y[E] / v;
        h.envMap.value = t.texture, h.samples.value = g, h.weights.value = y, h.latitudinal.value = o === "latitudinal", a && (h.poleAxis.value = a);
        let { _lodMax: x } = this;
        h.dTheta.value = p, h.mipInt.value = x - r;
        let S = this._sizeLods[i], w = 3 * S * (i > x - Tu ? i - x + Tu : 0), A = 4 * (this._cubeSize - S);
        Vg(e, w, A, 3 * S, 2 * S), l.setRenderTarget(e), l.render(d, fS);
    }
};
function YV(n1) {
    let t = [], e = [], r = [], i = n1, s = n1 - Tu + 1 + IT.length;
    for(let o = 0; o < s; o++){
        let a = Math.pow(2, i);
        e.push(a);
        let l = 1 / a;
        o > n1 - Tu ? l = IT[o - n1 + Tu - 1] : o === 0 && (l = 0), r.push(l);
        let u = 1 / (a - 2), c = -u, d = 1 + u, h = [
            c,
            c,
            d,
            c,
            d,
            d,
            c,
            c,
            d,
            d,
            c,
            d
        ], f = 6, p = 6, m = 3, g = 2, y = 1, v = new Float32Array(m * p * f), x = new Float32Array(g * p * f), S = new Float32Array(y * p * f);
        for(let A = 0; A < f; A++){
            let E = A % 3 * 2 / 3 - 1, b = A > 2 ? 0 : -1, T = [
                E,
                b,
                0,
                E + 2 / 3,
                b,
                0,
                E + 2 / 3,
                b + 1,
                0,
                E,
                b,
                0,
                E + 2 / 3,
                b + 1,
                0,
                E,
                b + 1,
                0
            ];
            v.set(T, m * p * A), x.set(h, g * p * A);
            let M = [
                A,
                A,
                A,
                A,
                A,
                A
            ];
            S.set(M, y * p * A);
        }
        let w = new we;
        w.setAttribute("position", new Ge(v, m)), w.setAttribute("uv", new Ge(x, g)), w.setAttribute("faceIndex", new Ge(S, y)), t.push(w), i > Tu && i--;
    }
    return {
        lodPlanes: t,
        sizeLods: e,
        sigmas: r
    };
}
function BT(n1, t, e) {
    let r = new at(n1, t, e);
    return r.texture.mapping = Qu, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function Vg(n1, t, e, r, i) {
    n1.viewport.set(t, e, r, i), n1.scissor.set(t, e, r, i);
}
function XV(n1, t, e) {
    let r = new Float32Array(lc), i = new _(0, 1, 0);
    return new rt({
        name: "SphericalGaussianBlur",
        defines: {
            n: lc,
            CUBEUV_TEXEL_WIDTH: 1 / t,
            CUBEUV_TEXEL_HEIGHT: 1 / e,
            CUBEUV_MAX_MIP: `${n1}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: r
            },
            latitudinal: {
                value: !1
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: i
            }
        },
        vertexShader: uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: Wt,
        depthTest: !1,
        depthWrite: !1
    });
}
function NT() {
    return new rt({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: Wt,
        depthTest: !1,
        depthWrite: !1
    });
}
function FT() {
    return new rt({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: uw(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: Wt,
        depthTest: !1,
        depthWrite: !1
    });
}
function uw() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function QV(n1) {
    let t = new WeakMap, e = null;
    function r(a) {
        if (a && a.isTexture) {
            let l = a.mapping, u = l === AS || l === _S, c = l === Xa || l === Qa;
            if (u || c) {
                if (a.isRenderTargetTexture && a.needsPMREMUpdate === !0) {
                    a.needsPMREMUpdate = !1;
                    let d = t.get(a);
                    return e === null && (e = new ay(n1)), d = u ? e.fromEquirectangular(a, d) : e.fromCubemap(a, d), t.set(a, d), d.texture;
                } else {
                    if (t.has(a)) return t.get(a).texture;
                    {
                        let d = a.image;
                        if (u && d && d.height > 0 || c && d && i(d)) {
                            e === null && (e = new ay(n1));
                            let h = u ? e.fromEquirectangular(a) : e.fromCubemap(a);
                            return t.set(a, h), a.addEventListener("dispose", s), h.texture;
                        } else return null;
                    }
                }
            }
        }
        return a;
    }
    function i(a) {
        let l = 0, u = 6;
        for(let c = 0; c < u; c++)a[c] !== void 0 && l++;
        return l === u;
    }
    function s(a) {
        let l = a.target;
        l.removeEventListener("dispose", s);
        let u = t.get(l);
        u !== void 0 && (t.delete(l), u.dispose());
    }
    function o() {
        t = new WeakMap, e !== null && (e.dispose(), e = null);
    }
    return {
        get: r,
        dispose: o
    };
}
function KV(n1) {
    let t = {};
    function e(r) {
        if (t[r] !== void 0) return t[r];
        let i;
        switch(r){
            case "WEBGL_depth_texture":
                i = n1.getExtension("WEBGL_depth_texture") || n1.getExtension("MOZ_WEBGL_depth_texture") || n1.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                i = n1.getExtension("EXT_texture_filter_anisotropic") || n1.getExtension("MOZ_EXT_texture_filter_anisotropic") || n1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                i = n1.getExtension("WEBGL_compressed_texture_s3tc") || n1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                i = n1.getExtension("WEBGL_compressed_texture_pvrtc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                i = n1.getExtension(r);
        }
        return t[r] = i, i;
    }
    return {
        has: function(r) {
            return e(r) !== null;
        },
        init: function(r) {
            r.isWebGL2 ? e("EXT_color_buffer_float") : (e("WEBGL_depth_texture"), e("OES_texture_float"), e("OES_texture_half_float"), e("OES_texture_half_float_linear"), e("OES_standard_derivatives"), e("OES_element_index_uint"), e("OES_vertex_array_object"), e("ANGLE_instanced_arrays")), e("OES_texture_float_linear"), e("EXT_color_buffer_half_float"), e("WEBGL_multisampled_render_to_texture");
        },
        get: function(r) {
            let i = e(r);
            return i === null && console.warn("THREE.WebGLRenderer: " + r + " extension not supported."), i;
        }
    };
}
function ZV(n1, t, e, r) {
    let i = {}, s = new WeakMap;
    function o(d) {
        let h = d.target;
        h.index !== null && t.remove(h.index);
        for(let p in h.attributes)t.remove(h.attributes[p]);
        h.removeEventListener("dispose", o), delete i[h.id];
        let f = s.get(h);
        f && (t.remove(f), s.delete(h)), r.releaseStatesOfGeometry(h), h.isInstancedBufferGeometry === !0 && delete h._maxInstanceCount, e.memory.geometries--;
    }
    function a(d, h) {
        return i[h.id] === !0 || (h.addEventListener("dispose", o), i[h.id] = !0, e.memory.geometries++), h;
    }
    function l(d) {
        let h = d.attributes;
        for(let p in h)t.update(h[p], 34962);
        let f = d.morphAttributes;
        for(let p in f){
            let m = f[p];
            for(let g = 0, y = m.length; g < y; g++)t.update(m[g], 34962);
        }
    }
    function u(d) {
        let h = [], f = d.index, p = d.attributes.position, m = 0;
        if (f !== null) {
            let v = f.array;
            m = f.version;
            for(let x = 0, S = v.length; x < S; x += 3){
                let w = v[x + 0], A = v[x + 1], E = v[x + 2];
                h.push(w, A, A, E, E, w);
            }
        } else {
            let v = p.array;
            m = p.version;
            for(let x = 0, S = v.length / 3 - 1; x < S; x += 3){
                let w = x + 0, A = x + 1, E = x + 2;
                h.push(w, A, A, E, E, w);
            }
        }
        let g = new (PM(h) ? co : oy)(h, 1);
        g.version = m;
        let y = s.get(d);
        y && t.remove(y), s.set(d, g);
    }
    function c(d) {
        let h = s.get(d);
        if (h) {
            let f = d.index;
            f !== null && h.version < f.version && u(d);
        } else u(d);
        return s.get(d);
    }
    return {
        get: a,
        update: l,
        getWireframeAttribute: c
    };
}
function JV(n1, t, e, r) {
    let i = r.isWebGL2, s;
    function o(h) {
        s = h;
    }
    let a, l;
    function u(h) {
        a = h.type, l = h.bytesPerElement;
    }
    function c(h, f) {
        n1.drawElements(s, f, a, h * l), e.update(f, s, 1);
    }
    function d(h, f, p) {
        if (p === 0) return;
        let m, g;
        if (i) m = n1, g = "drawElementsInstanced";
        else if (m = t.get("ANGLE_instanced_arrays"), g = "drawElementsInstancedANGLE", m === null) {
            console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        m[g](s, f, a, h * l, p), e.update(f, s, p);
    }
    this.setMode = o, this.setIndex = u, this.render = c, this.renderInstances = d;
}
function $V(n1) {
    let t = {
        geometries: 0,
        textures: 0
    }, e = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function r(s, o, a) {
        switch(e.calls++, o){
            case 4:
                e.triangles += a * (s / 3);
                break;
            case 1:
                e.lines += a * (s / 2);
                break;
            case 3:
                e.lines += a * (s - 1);
                break;
            case 2:
                e.lines += a * s;
                break;
            case 0:
                e.points += a * s;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", o);
                break;
        }
    }
    function i() {
        e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    }
    return {
        memory: t,
        render: e,
        programs: null,
        autoReset: !0,
        reset: i,
        update: r
    };
}
function eU(n1, t) {
    return n1[0] - t[0];
}
function tU(n1, t) {
    return Math.abs(t[1]) - Math.abs(n1[1]);
}
function rU(n1, t, e) {
    let r = {}, i = new Float32Array(8), s = new WeakMap, o = new He, a = [];
    for(let u = 0; u < 8; u++)a[u] = [
        u,
        0
    ];
    function l(u, c, d, h) {
        let f = u.morphTargetInfluences;
        if (t.isWebGL2 === !0) {
            let p = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, m = p !== void 0 ? p.length : 0, g = s.get(c);
            if (g === void 0 || g.count !== m) {
                let I = function() {
                    D.dispose(), s.delete(c), c.removeEventListener("dispose", I);
                };
                g !== void 0 && g.texture.dispose();
                let x = c.morphAttributes.position !== void 0, S = c.morphAttributes.normal !== void 0, w = c.morphAttributes.color !== void 0, A = c.morphAttributes.position || [], E = c.morphAttributes.normal || [], b = c.morphAttributes.color || [], T = 0;
                x === !0 && (T = 1), S === !0 && (T = 2), w === !0 && (T = 3);
                let M = c.attributes.position.count * T, C = 1;
                M > t.maxTextureSize && (C = Math.ceil(M / t.maxTextureSize), M = t.maxTextureSize);
                let P = new Float32Array(M * C * 4 * m), D = new iy(P, M, C, m);
                D.type = dr, D.needsUpdate = !0;
                let O = T * 4;
                for(let z = 0; z < m; z++){
                    let B = A[z], V = E[z], U = b[z], j = M * C * 4 * z;
                    for(let W = 0; W < B.count; W++){
                        let k = W * O;
                        x === !0 && (o.fromBufferAttribute(B, W), P[j + k + 0] = o.x, P[j + k + 1] = o.y, P[j + k + 2] = o.z, P[j + k + 3] = 0), S === !0 && (o.fromBufferAttribute(V, W), P[j + k + 4] = o.x, P[j + k + 5] = o.y, P[j + k + 6] = o.z, P[j + k + 7] = 0), w === !0 && (o.fromBufferAttribute(U, W), P[j + k + 8] = o.x, P[j + k + 9] = o.y, P[j + k + 10] = o.z, P[j + k + 11] = U.itemSize === 4 ? o.w : 1);
                    }
                }
                g = {
                    count: m,
                    texture: D,
                    size: new N(M, C)
                }, s.set(c, g), c.addEventListener("dispose", I);
            }
            let y = 0;
            for(let x = 0; x < f.length; x++)y += f[x];
            let v = c.morphTargetsRelative ? 1 : 1 - y;
            h.getUniforms().setValue(n1, "morphTargetBaseInfluence", v), h.getUniforms().setValue(n1, "morphTargetInfluences", f), h.getUniforms().setValue(n1, "morphTargetsTexture", g.texture, e), h.getUniforms().setValue(n1, "morphTargetsTextureSize", g.size);
        } else {
            let p = f === void 0 ? 0 : f.length, m = r[c.id];
            if (m === void 0 || m.length !== p) {
                m = [];
                for(let S = 0; S < p; S++)m[S] = [
                    S,
                    0
                ];
                r[c.id] = m;
            }
            for(let S = 0; S < p; S++){
                let w = m[S];
                w[0] = S, w[1] = f[S];
            }
            m.sort(tU);
            for(let S = 0; S < 8; S++)S < p && m[S][1] ? (a[S][0] = m[S][0], a[S][1] = m[S][1]) : (a[S][0] = Number.MAX_SAFE_INTEGER, a[S][1] = 0);
            a.sort(eU);
            let g = c.morphAttributes.position, y = c.morphAttributes.normal, v = 0;
            for(let S = 0; S < 8; S++){
                let w = a[S], A = w[0], E = w[1];
                A !== Number.MAX_SAFE_INTEGER && E ? (g && c.getAttribute("morphTarget" + S) !== g[A] && c.setAttribute("morphTarget" + S, g[A]), y && c.getAttribute("morphNormal" + S) !== y[A] && c.setAttribute("morphNormal" + S, y[A]), i[S] = E, v += E) : (g && c.hasAttribute("morphTarget" + S) === !0 && c.deleteAttribute("morphTarget" + S), y && c.hasAttribute("morphNormal" + S) === !0 && c.deleteAttribute("morphNormal" + S), i[S] = 0);
            }
            let x = c.morphTargetsRelative ? 1 : 1 - v;
            h.getUniforms().setValue(n1, "morphTargetBaseInfluence", x), h.getUniforms().setValue(n1, "morphTargetInfluences", i);
        }
    }
    return {
        update: l
    };
}
function iU(n1, t, e, r) {
    let i = new WeakMap;
    function s(l) {
        let u = r.render.frame, c = l.geometry, d = t.get(l, c);
        return i.get(d) !== u && (t.update(d), i.set(d, u)), l.isInstancedMesh && (l.hasEventListener("dispose", a) === !1 && l.addEventListener("dispose", a), e.update(l.instanceMatrix, 34962), l.instanceColor !== null && e.update(l.instanceColor, 34962)), d;
    }
    function o() {
        i = new WeakMap;
    }
    function a(l) {
        let u = l.target;
        u.removeEventListener("dispose", a), e.remove(u.instanceMatrix), u.instanceColor !== null && e.remove(u.instanceColor);
    }
    return {
        update: s,
        dispose: o
    };
}
var RM = new qt, LM = new iy, BM = new ny, NM = new Du, kT = [], zT = [], VT = new Float32Array(16), UT = new Float32Array(9), GT = new Float32Array(4);
function Zu(n1, t, e) {
    let r = n1[0];
    if (r <= 0 || r > 0) return n1;
    let i = t * e, s = kT[i];
    if (s === void 0 && (s = new Float32Array(i), kT[i] = s), t !== 0) {
        r.toArray(s, 0);
        for(let o = 1, a = 0; o !== t; ++o)a += e, n1[o].toArray(s, a);
    }
    return s;
}
function gi(n1, t) {
    if (n1.length !== t.length) return !1;
    for(let e = 0, r = n1.length; e < r; e++)if (n1[e] !== t[e]) return !1;
    return !0;
}
function yi(n1, t) {
    for(let e = 0, r = t.length; e < r; e++)n1[e] = t[e];
}
function My(n1, t) {
    let e = zT[t];
    e === void 0 && (e = new Int32Array(t), zT[t] = e);
    for(let r = 0; r !== t; ++r)e[r] = n1.allocateTextureUnit();
    return e;
}
function nU(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1f(this.addr, t), e[0] = t);
}
function sU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2f(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (gi(e, t)) return;
        n1.uniform2fv(this.addr, t), yi(e, t);
    }
}
function oU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3f(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else if (t.r !== void 0) (e[0] !== t.r || e[1] !== t.g || e[2] !== t.b) && (n1.uniform3f(this.addr, t.r, t.g, t.b), e[0] = t.r, e[1] = t.g, e[2] = t.b);
    else {
        if (gi(e, t)) return;
        n1.uniform3fv(this.addr, t), yi(e, t);
    }
}
function aU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4f(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (gi(e, t)) return;
        n1.uniform4fv(this.addr, t), yi(e, t);
    }
}
function lU(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (gi(e, t)) return;
        n1.uniformMatrix2fv(this.addr, !1, t), yi(e, t);
    } else {
        if (gi(e, r)) return;
        GT.set(r), n1.uniformMatrix2fv(this.addr, !1, GT), yi(e, r);
    }
}
function cU(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (gi(e, t)) return;
        n1.uniformMatrix3fv(this.addr, !1, t), yi(e, t);
    } else {
        if (gi(e, r)) return;
        UT.set(r), n1.uniformMatrix3fv(this.addr, !1, UT), yi(e, r);
    }
}
function uU(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (gi(e, t)) return;
        n1.uniformMatrix4fv(this.addr, !1, t), yi(e, t);
    } else {
        if (gi(e, r)) return;
        VT.set(r), n1.uniformMatrix4fv(this.addr, !1, VT), yi(e, r);
    }
}
function dU(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1i(this.addr, t), e[0] = t);
}
function hU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2i(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (gi(e, t)) return;
        n1.uniform2iv(this.addr, t), yi(e, t);
    }
}
function fU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3i(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (gi(e, t)) return;
        n1.uniform3iv(this.addr, t), yi(e, t);
    }
}
function pU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4i(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (gi(e, t)) return;
        n1.uniform4iv(this.addr, t), yi(e, t);
    }
}
function mU(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1ui(this.addr, t), e[0] = t);
}
function gU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2ui(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (gi(e, t)) return;
        n1.uniform2uiv(this.addr, t), yi(e, t);
    }
}
function yU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3ui(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (gi(e, t)) return;
        n1.uniform3uiv(this.addr, t), yi(e, t);
    }
}
function vU(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (gi(e, t)) return;
        n1.uniform4uiv(this.addr, t), yi(e, t);
    }
}
function xU(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2D(t || RM, i);
}
function bU(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture3D(t || BM, i);
}
function SU(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTextureCube(t || NM, i);
}
function wU(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2DArray(t || LM, i);
}
function AU(n1) {
    switch(n1){
        case 5126:
            return nU;
        case 35664:
            return sU;
        case 35665:
            return oU;
        case 35666:
            return aU;
        case 35674:
            return lU;
        case 35675:
            return cU;
        case 35676:
            return uU;
        case 5124:
        case 35670:
            return dU;
        case 35667:
        case 35671:
            return hU;
        case 35668:
        case 35672:
            return fU;
        case 35669:
        case 35673:
            return pU;
        case 5125:
            return mU;
        case 36294:
            return gU;
        case 36295:
            return yU;
        case 36296:
            return vU;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return xU;
        case 35679:
        case 36299:
        case 36307:
            return bU;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return SU;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return wU;
    }
}
function _U(n1, t) {
    n1.uniform1fv(this.addr, t);
}
function EU(n1, t) {
    let e = Zu(t, this.size, 2);
    n1.uniform2fv(this.addr, e);
}
function TU(n1, t) {
    let e = Zu(t, this.size, 3);
    n1.uniform3fv(this.addr, e);
}
function MU(n1, t) {
    let e = Zu(t, this.size, 4);
    n1.uniform4fv(this.addr, e);
}
function CU(n1, t) {
    let e = Zu(t, this.size, 4);
    n1.uniformMatrix2fv(this.addr, !1, e);
}
function PU(n1, t) {
    let e = Zu(t, this.size, 9);
    n1.uniformMatrix3fv(this.addr, !1, e);
}
function DU(n1, t) {
    let e = Zu(t, this.size, 16);
    n1.uniformMatrix4fv(this.addr, !1, e);
}
function OU(n1, t) {
    n1.uniform1iv(this.addr, t);
}
function IU(n1, t) {
    n1.uniform2iv(this.addr, t);
}
function RU(n1, t) {
    n1.uniform3iv(this.addr, t);
}
function LU(n1, t) {
    n1.uniform4iv(this.addr, t);
}
function BU(n1, t) {
    n1.uniform1uiv(this.addr, t);
}
function NU(n1, t) {
    n1.uniform2uiv(this.addr, t);
}
function FU(n1, t) {
    n1.uniform3uiv(this.addr, t);
}
function kU(n1, t) {
    n1.uniform4uiv(this.addr, t);
}
function zU(n1, t, e) {
    let r = this.cache, i = t.length, s = My(e, i);
    gi(r, s) || (n1.uniform1iv(this.addr, s), yi(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture2D(t[o] || RM, s[o]);
}
function VU(n1, t, e) {
    let r = this.cache, i = t.length, s = My(e, i);
    gi(r, s) || (n1.uniform1iv(this.addr, s), yi(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture3D(t[o] || BM, s[o]);
}
function UU(n1, t, e) {
    let r = this.cache, i = t.length, s = My(e, i);
    gi(r, s) || (n1.uniform1iv(this.addr, s), yi(r, s));
    for(let o = 0; o !== i; ++o)e.setTextureCube(t[o] || NM, s[o]);
}
function GU(n1, t, e) {
    let r = this.cache, i = t.length, s = My(e, i);
    gi(r, s) || (n1.uniform1iv(this.addr, s), yi(r, s));
    for(let o = 0; o !== i; ++o)e.setTexture2DArray(t[o] || LM, s[o]);
}
function jU(n1) {
    switch(n1){
        case 5126:
            return _U;
        case 35664:
            return EU;
        case 35665:
            return TU;
        case 35666:
            return MU;
        case 35674:
            return CU;
        case 35675:
            return PU;
        case 35676:
            return DU;
        case 5124:
        case 35670:
            return OU;
        case 35667:
        case 35671:
            return IU;
        case 35668:
        case 35672:
            return RU;
        case 35669:
        case 35673:
            return LU;
        case 5125:
            return BU;
        case 36294:
            return NU;
        case 36295:
            return FU;
        case 36296:
            return kU;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return zU;
        case 35679:
        case 36299:
        case 36307:
            return VU;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return UU;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return GU;
    }
}
var OS = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.setValue = AU(e.type);
    }
}, IS = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.size = e.size, this.setValue = jU(e.type);
    }
}, RS = class {
    constructor(t){
        this.id = t, this.seq = [], this.map = {};
    }
    setValue(t, e, r) {
        let i = this.seq;
        for(let s = 0, o = i.length; s !== o; ++s){
            let a = i[s];
            a.setValue(t, e[a.id], r);
        }
    }
}, mS = /(\w+)(\])?(\[|\.)?/g;
function jT(n1, t) {
    n1.seq.push(t), n1.map[t.id] = t;
}
function HU(n1, t, e) {
    let r = n1.name, i = r.length;
    for(mS.lastIndex = 0;;){
        let s = mS.exec(r), o = mS.lastIndex, a = s[1], l = s[2] === "]", u = s[3];
        if (l && (a = a | 0), u === void 0 || u === "[" && o + 2 === i) {
            jT(e, u === void 0 ? new OS(a, n1, t) : new IS(a, n1, t));
            break;
        } else {
            let d = e.map[a];
            d === void 0 && (d = new RS(a), jT(e, d)), e = d;
        }
    }
}
var Cu = class {
    constructor(t, e){
        this.seq = [], this.map = {};
        let r = t.getProgramParameter(e, 35718);
        for(let i = 0; i < r; ++i){
            let s = t.getActiveUniform(e, i), o = t.getUniformLocation(e, s.name);
            HU(s, o, this);
        }
    }
    setValue(t, e, r, i) {
        let s = this.map[e];
        s !== void 0 && s.setValue(t, r, i);
    }
    setOptional(t, e, r) {
        let i = e[r];
        i !== void 0 && this.setValue(t, r, i);
    }
    static upload(t, e, r, i) {
        for(let s = 0, o = e.length; s !== o; ++s){
            let a = e[s], l = r[a.id];
            l.needsUpdate !== !1 && a.setValue(t, l.value, i);
        }
    }
    static seqWithValue(t, e) {
        let r = [];
        for(let i = 0, s = t.length; i !== s; ++i){
            let o = t[i];
            o.id in e && r.push(o);
        }
        return r;
    }
};
function HT(n1, t, e) {
    let r = n1.createShader(t);
    return n1.shaderSource(r, e), n1.compileShader(r), r;
}
var WU = 0;
function qU(n1, t) {
    let e = n1.split(`
`), r = [], i = Math.max(t - 6, 0), s = Math.min(t + 6, e.length);
    for(let o = i; o < s; o++){
        let a = o + 1;
        r.push(`${a === t ? ">" : " "} ${a}: ${e[o]}`);
    }
    return r.join(`
`);
}
function YU(n1) {
    switch(n1){
        case dn:
            return [
                "Linear",
                "( value )"
            ];
        case tt:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            return console.warn("THREE.WebGLProgram: Unsupported encoding:", n1), [
                "Linear",
                "( value )"
            ];
    }
}
function WT(n1, t, e) {
    let r = n1.getShaderParameter(t, 35713), i = n1.getShaderInfoLog(t).trim();
    if (r && i === "") return "";
    let s = /ERROR: 0:(\d+)/.exec(i);
    if (s) {
        let o = parseInt(s[1]);
        return e.toUpperCase() + `

` + i + `

` + qU(n1.getShaderSource(t), o);
    } else return i;
}
function XU(n1, t) {
    let e = YU(t);
    return "vec4 " + n1 + "( vec4 value ) { return LinearTo" + e[0] + e[1] + "; }";
}
function QU(n1, t) {
    let e;
    switch(t){
        case cF:
            e = "Linear";
            break;
        case uF:
            e = "Reinhard";
            break;
        case dF:
            e = "OptimizedCineon";
            break;
        case hF:
            e = "ACESFilmic";
            break;
        case fF:
            e = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), e = "Linear";
    }
    return "vec3 " + n1 + "( vec3 color ) { return " + e + "ToneMapping( color ); }";
}
function KU(n1) {
    return [
        n1.extensionDerivatives || !!n1.envMapCubeUVHeight || n1.bumpMap || n1.tangentSpaceNormalMap || n1.clearcoatNormalMap || n1.flatShading || n1.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (n1.extensionFragDepth || n1.logarithmicDepthBuffer) && n1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        n1.extensionDrawBuffers && n1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (n1.extensionShaderTextureLOD || n1.envMap || n1.transmission) && n1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ].filter(tp).join(`
`);
}
function ZU(n1) {
    let t = [];
    for(let e in n1){
        let r = n1[e];
        r !== !1 && t.push("#define " + e + " " + r);
    }
    return t.join(`
`);
}
function JU(n1, t) {
    let e = {}, r = n1.getProgramParameter(t, 35721);
    for(let i = 0; i < r; i++){
        let s = n1.getActiveAttrib(t, i), o = s.name, a = 1;
        s.type === 35674 && (a = 2), s.type === 35675 && (a = 3), s.type === 35676 && (a = 4), e[o] = {
            type: s.type,
            location: n1.getAttribLocation(t, o),
            locationSize: a
        };
    }
    return e;
}
function tp(n1) {
    return n1 !== "";
}
function qT(n1, t) {
    let e = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return n1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, e).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function YT(n1, t) {
    return n1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var $U = /^[ \t]*#include +<([\w\d./]+)>/gm;
function LS(n1) {
    return n1.replace($U, eG);
}
function eG(n1, t) {
    let e = ht[t];
    if (e === void 0) throw new Error("Can not resolve #include <" + t + ">");
    return LS(e);
}
var tG = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function XT(n1) {
    return n1.replace(tG, rG);
}
function rG(n1, t, e, r) {
    let i = "";
    for(let s = parseInt(t); s < parseInt(e); s++)i += r.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
    return i;
}
function QT(n1) {
    let t = "precision " + n1.precision + ` float;
precision ` + n1.precision + " int;";
    return n1.precision === "highp" ? t += `
#define HIGH_PRECISION` : n1.precision === "mediump" ? t += `
#define MEDIUM_PRECISION` : n1.precision === "lowp" && (t += `
#define LOW_PRECISION`), t;
}
function iG(n1) {
    let t = "SHADOWMAP_TYPE_BASIC";
    return n1.shadowMapType === Ty ? t = "SHADOWMAP_TYPE_PCF" : n1.shadowMapType === UN ? t = "SHADOWMAP_TYPE_PCF_SOFT" : n1.shadowMapType === ep && (t = "SHADOWMAP_TYPE_VSM"), t;
}
function nG(n1) {
    let t = "ENVMAP_TYPE_CUBE";
    if (n1.envMap) switch(n1.envMapMode){
        case Xa:
        case Qa:
            t = "ENVMAP_TYPE_CUBE";
            break;
        case Qu:
            t = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return t;
}
function sG(n1) {
    let t = "ENVMAP_MODE_REFLECTION";
    if (n1.envMap) switch(n1.envMapMode){
        case Qa:
            t = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return t;
}
function oG(n1) {
    let t = "ENVMAP_BLENDING_NONE";
    if (n1.envMap) switch(n1.combine){
        case _M:
            t = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case aF:
            t = "ENVMAP_BLENDING_MIX";
            break;
        case lF:
            t = "ENVMAP_BLENDING_ADD";
            break;
    }
    return t;
}
function aG(n1) {
    let t = n1.envMapCubeUVHeight;
    if (t === null) return null;
    let e = Math.log2(t) - 2, r = 1 / t;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)),
        texelHeight: r,
        maxMip: e
    };
}
function lG(n1, t, e, r) {
    let i = n1.getContext(), s = e.defines, o = e.vertexShader, a = e.fragmentShader, l = iG(e), u = nG(e), c = sG(e), d = oG(e), h = aG(e), f = e.isWebGL2 ? "" : KU(e), p = ZU(s), m = i.createProgram(), g, y, v = e.glslVersion ? "#version " + e.glslVersion + `
` : "";
    e.isRawShaderMaterial ? (g = [
        p
    ].filter(tp).join(`
`), g.length > 0 && (g += `
`), y = [
        f,
        p
    ].filter(tp).join(`
`), y.length > 0 && (y += `
`)) : (g = [
        QT(e),
        "#define SHADER_NAME " + e.shaderName,
        p,
        e.instancing ? "#define USE_INSTANCING" : "",
        e.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        e.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + c : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.displacementMap && e.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.skinning ? "#define USE_SKINNING" : "",
        e.morphTargets ? "#define USE_MORPHTARGETS" : "",
        e.morphNormals && e.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        e.morphColors && e.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + e.morphTextureStride : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_COUNT " + e.morphTargetsCount : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
        "	attribute vec3 morphTarget0;",
        "	attribute vec3 morphTarget1;",
        "	attribute vec3 morphTarget2;",
        "	attribute vec3 morphTarget3;",
        "	#ifdef USE_MORPHNORMALS",
        "		attribute vec3 morphNormal0;",
        "		attribute vec3 morphNormal1;",
        "		attribute vec3 morphNormal2;",
        "		attribute vec3 morphNormal3;",
        "	#else",
        "		attribute vec3 morphTarget4;",
        "		attribute vec3 morphTarget5;",
        "		attribute vec3 morphTarget6;",
        "		attribute vec3 morphTarget7;",
        "	#endif",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`
    ].filter(tp).join(`
`), y = [
        f,
        QT(e),
        "#define SHADER_NAME " + e.shaderName,
        p,
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.matcap ? "#define USE_MATCAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + u : "",
        e.envMap ? "#define " + c : "",
        e.envMap ? "#define " + d : "",
        h ? "#define CUBEUV_TEXEL_WIDTH " + h.texelWidth : "",
        h ? "#define CUBEUV_TEXEL_HEIGHT " + h.texelHeight : "",
        h ? "#define CUBEUV_MAX_MIP " + h.maxMip + ".0" : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoat ? "#define USE_CLEARCOAT" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescence ? "#define USE_IRIDESCENCE" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.alphaTest ? "#define USE_ALPHATEST" : "",
        e.sheen ? "#define USE_SHEEN" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors || e.instancingColor ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.gradientMap ? "#define USE_GRADIENTMAP" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        e.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        e.toneMapping !== Os ? "#define TONE_MAPPING" : "",
        e.toneMapping !== Os ? ht.tonemapping_pars_fragment : "",
        e.toneMapping !== Os ? QU("toneMapping", e.toneMapping) : "",
        e.dithering ? "#define DITHERING" : "",
        e.opaque ? "#define OPAQUE" : "",
        ht.encodings_pars_fragment,
        XU("linearToOutputTexel", e.outputEncoding),
        e.useDepthPacking ? "#define DEPTH_PACKING " + e.depthPacking : "",
        `
`
    ].filter(tp).join(`
`)), o = LS(o), o = qT(o, e), o = YT(o, e), a = LS(a), a = qT(a, e), a = YT(a, e), o = XT(o), a = XT(a), e.isWebGL2 && e.isRawShaderMaterial !== !0 && (v = `#version 300 es
`, g = [
        "precision mediump sampler2DArray;",
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join(`
`) + `
` + g, y = [
        "#define varying in",
        e.glslVersion === bT ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        e.glslVersion === bT ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join(`
`) + `
` + y);
    let x = v + g + o, S = v + y + a, w = HT(i, 35633, x), A = HT(i, 35632, S);
    if (i.attachShader(m, w), i.attachShader(m, A), e.index0AttributeName !== void 0 ? i.bindAttribLocation(m, 0, e.index0AttributeName) : e.morphTargets === !0 && i.bindAttribLocation(m, 0, "position"), i.linkProgram(m), n1.debug.checkShaderErrors) {
        let T = i.getProgramInfoLog(m).trim(), M = i.getShaderInfoLog(w).trim(), C = i.getShaderInfoLog(A).trim(), P = !0, D = !0;
        if (i.getProgramParameter(m, 35714) === !1) {
            P = !1;
            let O = WT(i, w, "vertex"), I = WT(i, A, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(m, 35715) + `

Program Info Log: ` + T + `
` + O + `
` + I);
        } else T !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", T) : (M === "" || C === "") && (D = !1);
        D && (this.diagnostics = {
            runnable: P,
            programLog: T,
            vertexShader: {
                log: M,
                prefix: g
            },
            fragmentShader: {
                log: C,
                prefix: y
            }
        });
    }
    i.deleteShader(w), i.deleteShader(A);
    let E;
    this.getUniforms = function() {
        return E === void 0 && (E = new Cu(i, m)), E;
    };
    let b;
    return this.getAttributes = function() {
        return b === void 0 && (b = JU(i, m)), b;
    }, this.destroy = function() {
        r.releaseStatesOfProgram(this), i.deleteProgram(m), this.program = void 0;
    }, this.name = e.shaderName, this.id = WU++, this.cacheKey = t, this.usedTimes = 1, this.program = m, this.vertexShader = w, this.fragmentShader = A, this;
}
var cG = 0, BS = class {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(t) {
        let e = t.vertexShader, r = t.fragmentShader, i = this._getShaderStage(e), s = this._getShaderStage(r), o = this._getShaderCacheForMaterial(t);
        return o.has(i) === !1 && (o.add(i), i.usedTimes++), o.has(s) === !1 && (o.add(s), s.usedTimes++), this;
    }
    remove(t) {
        let e = this.materialCache.get(t);
        for (let r of e)r.usedTimes--, r.usedTimes === 0 && this.shaderCache.delete(r.code);
        return this.materialCache.delete(t), this;
    }
    getVertexShaderID(t) {
        return this._getShaderStage(t.vertexShader).id;
    }
    getFragmentShaderID(t) {
        return this._getShaderStage(t.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t) {
        let e = this.materialCache, r = e.get(t);
        return r === void 0 && (r = new Set, e.set(t, r)), r;
    }
    _getShaderStage(t) {
        let e = this.shaderCache, r = e.get(t);
        return r === void 0 && (r = new NS(t), e.set(t, r)), r;
    }
}, NS = class {
    constructor(t){
        this.id = cG++, this.code = t, this.usedTimes = 0;
    }
};
function uG(n1, t, e, r, i, s, o) {
    let a = new up, l = new BS, u = [], c = i.isWebGL2, d = i.logarithmicDepthBuffer, h = i.vertexTextures, f = i.precision, p = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function m(b, T, M, C, P) {
        let D = C.fog, O = P.geometry, I = b.isMeshStandardMaterial ? C.environment : null, z = (b.isMeshStandardMaterial ? e : t).get(b.envMap || I), B = !!z && z.mapping === Qu ? z.image.height : null, V = p[b.type];
        b.precision !== null && (f = i.getMaxPrecision(b.precision), f !== b.precision && console.warn("THREE.WebGLProgram.getParameters:", b.precision, "not supported, using", f, "instead."));
        let U = O.morphAttributes.position || O.morphAttributes.normal || O.morphAttributes.color, j = U !== void 0 ? U.length : 0, W = 0;
        O.morphAttributes.position !== void 0 && (W = 1), O.morphAttributes.normal !== void 0 && (W = 2), O.morphAttributes.color !== void 0 && (W = 3);
        let k, H, X, q;
        if (V) {
            let ye = lo[V];
            k = ye.vertexShader, H = ye.fragmentShader;
        } else k = b.vertexShader, H = b.fragmentShader, l.update(b), X = l.getVertexShaderID(b), q = l.getFragmentShaderID(b);
        let G = n1.getRenderTarget(), J = b.alphaTest > 0, Z = b.clearcoat > 0, K = b.iridescence > 0;
        return {
            isWebGL2: c,
            shaderID: V,
            shaderName: b.type,
            vertexShader: k,
            fragmentShader: H,
            defines: b.defines,
            customVertexShaderID: X,
            customFragmentShaderID: q,
            isRawShaderMaterial: b.isRawShaderMaterial === !0,
            glslVersion: b.glslVersion,
            precision: f,
            instancing: P.isInstancedMesh === !0,
            instancingColor: P.isInstancedMesh === !0 && P.instanceColor !== null,
            supportsVertexTextures: h,
            outputEncoding: G === null ? n1.outputEncoding : G.isXRRenderTarget === !0 ? G.texture.encoding : dn,
            map: !!b.map,
            matcap: !!b.matcap,
            envMap: !!z,
            envMapMode: z && z.mapping,
            envMapCubeUVHeight: B,
            lightMap: !!b.lightMap,
            aoMap: !!b.aoMap,
            emissiveMap: !!b.emissiveMap,
            bumpMap: !!b.bumpMap,
            normalMap: !!b.normalMap,
            objectSpaceNormalMap: b.normalMapType === DF,
            tangentSpaceNormalMap: b.normalMapType === PF,
            decodeVideoTexture: !!b.map && b.map.isVideoTexture === !0 && b.map.encoding === tt,
            clearcoat: Z,
            clearcoatMap: Z && !!b.clearcoatMap,
            clearcoatRoughnessMap: Z && !!b.clearcoatRoughnessMap,
            clearcoatNormalMap: Z && !!b.clearcoatNormalMap,
            iridescence: K,
            iridescenceMap: K && !!b.iridescenceMap,
            iridescenceThicknessMap: K && !!b.iridescenceThicknessMap,
            displacementMap: !!b.displacementMap,
            roughnessMap: !!b.roughnessMap,
            metalnessMap: !!b.metalnessMap,
            specularMap: !!b.specularMap,
            specularIntensityMap: !!b.specularIntensityMap,
            specularColorMap: !!b.specularColorMap,
            opaque: b.transparent === !1 && b.blending === qa,
            alphaMap: !!b.alphaMap,
            alphaTest: J,
            gradientMap: !!b.gradientMap,
            sheen: b.sheen > 0,
            sheenColorMap: !!b.sheenColorMap,
            sheenRoughnessMap: !!b.sheenRoughnessMap,
            transmission: b.transmission > 0,
            transmissionMap: !!b.transmissionMap,
            thicknessMap: !!b.thicknessMap,
            combine: b.combine,
            vertexTangents: !!b.normalMap && !!O.attributes.tangent,
            vertexColors: b.vertexColors,
            vertexAlphas: b.vertexColors === !0 && !!O.attributes.color && O.attributes.color.itemSize === 4,
            vertexUvs: !!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatMap || !!b.clearcoatRoughnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || !!b.displacementMap || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || !!b.sheenColorMap || !!b.sheenRoughnessMap,
            uvsVertexOnly: !(!!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || b.transmission > 0 || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || b.sheen > 0 || !!b.sheenColorMap || !!b.sheenRoughnessMap) && !!b.displacementMap,
            fog: !!D,
            useFog: b.fog === !0,
            fogExp2: D && D.isFogExp2,
            flatShading: !!b.flatShading,
            sizeAttenuation: b.sizeAttenuation,
            logarithmicDepthBuffer: d,
            skinning: P.isSkinnedMesh === !0,
            morphTargets: O.morphAttributes.position !== void 0,
            morphNormals: O.morphAttributes.normal !== void 0,
            morphColors: O.morphAttributes.color !== void 0,
            morphTargetsCount: j,
            morphTextureStride: W,
            numDirLights: T.directional.length,
            numPointLights: T.point.length,
            numSpotLights: T.spot.length,
            numSpotLightMaps: T.spotLightMap.length,
            numRectAreaLights: T.rectArea.length,
            numHemiLights: T.hemi.length,
            numDirLightShadows: T.directionalShadowMap.length,
            numPointLightShadows: T.pointShadowMap.length,
            numSpotLightShadows: T.spotShadowMap.length,
            numSpotLightShadowsWithMaps: T.numSpotLightShadowsWithMaps,
            numClippingPlanes: o.numPlanes,
            numClipIntersection: o.numIntersection,
            dithering: b.dithering,
            shadowMapEnabled: n1.shadowMap.enabled && M.length > 0,
            shadowMapType: n1.shadowMap.type,
            toneMapping: b.toneMapped ? n1.toneMapping : Os,
            physicallyCorrectLights: n1.physicallyCorrectLights,
            premultipliedAlpha: b.premultipliedAlpha,
            doubleSided: b.side === qi,
            flipSided: b.side === ai,
            useDepthPacking: !!b.depthPacking,
            depthPacking: b.depthPacking || 0,
            index0AttributeName: b.index0AttributeName,
            extensionDerivatives: b.extensions && b.extensions.derivatives,
            extensionFragDepth: b.extensions && b.extensions.fragDepth,
            extensionDrawBuffers: b.extensions && b.extensions.drawBuffers,
            extensionShaderTextureLOD: b.extensions && b.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: c || r.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: c || r.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: c || r.has("EXT_shader_texture_lod"),
            customProgramCacheKey: b.customProgramCacheKey()
        };
    }
    function g(b) {
        let T = [];
        if (b.shaderID ? T.push(b.shaderID) : (T.push(b.customVertexShaderID), T.push(b.customFragmentShaderID)), b.defines !== void 0) for(let M in b.defines)T.push(M), T.push(b.defines[M]);
        return b.isRawShaderMaterial === !1 && (y(T, b), v(T, b), T.push(n1.outputEncoding)), T.push(b.customProgramCacheKey), T.join();
    }
    function y(b, T) {
        b.push(T.precision), b.push(T.outputEncoding), b.push(T.envMapMode), b.push(T.envMapCubeUVHeight), b.push(T.combine), b.push(T.vertexUvs), b.push(T.fogExp2), b.push(T.sizeAttenuation), b.push(T.morphTargetsCount), b.push(T.morphAttributeCount), b.push(T.numDirLights), b.push(T.numPointLights), b.push(T.numSpotLights), b.push(T.numSpotLightMaps), b.push(T.numHemiLights), b.push(T.numRectAreaLights), b.push(T.numDirLightShadows), b.push(T.numPointLightShadows), b.push(T.numSpotLightShadows), b.push(T.numSpotLightShadowsWithMaps), b.push(T.shadowMapType), b.push(T.toneMapping), b.push(T.numClippingPlanes), b.push(T.numClipIntersection), b.push(T.depthPacking);
    }
    function v(b, T) {
        a.disableAll(), T.isWebGL2 && a.enable(0), T.supportsVertexTextures && a.enable(1), T.instancing && a.enable(2), T.instancingColor && a.enable(3), T.map && a.enable(4), T.matcap && a.enable(5), T.envMap && a.enable(6), T.lightMap && a.enable(7), T.aoMap && a.enable(8), T.emissiveMap && a.enable(9), T.bumpMap && a.enable(10), T.normalMap && a.enable(11), T.objectSpaceNormalMap && a.enable(12), T.tangentSpaceNormalMap && a.enable(13), T.clearcoat && a.enable(14), T.clearcoatMap && a.enable(15), T.clearcoatRoughnessMap && a.enable(16), T.clearcoatNormalMap && a.enable(17), T.iridescence && a.enable(18), T.iridescenceMap && a.enable(19), T.iridescenceThicknessMap && a.enable(20), T.displacementMap && a.enable(21), T.specularMap && a.enable(22), T.roughnessMap && a.enable(23), T.metalnessMap && a.enable(24), T.gradientMap && a.enable(25), T.alphaMap && a.enable(26), T.alphaTest && a.enable(27), T.vertexColors && a.enable(28), T.vertexAlphas && a.enable(29), T.vertexUvs && a.enable(30), T.vertexTangents && a.enable(31), T.uvsVertexOnly && a.enable(32), b.push(a.mask), a.disableAll(), T.fog && a.enable(0), T.useFog && a.enable(1), T.flatShading && a.enable(2), T.logarithmicDepthBuffer && a.enable(3), T.skinning && a.enable(4), T.morphTargets && a.enable(5), T.morphNormals && a.enable(6), T.morphColors && a.enable(7), T.premultipliedAlpha && a.enable(8), T.shadowMapEnabled && a.enable(9), T.physicallyCorrectLights && a.enable(10), T.doubleSided && a.enable(11), T.flipSided && a.enable(12), T.useDepthPacking && a.enable(13), T.dithering && a.enable(14), T.specularIntensityMap && a.enable(15), T.specularColorMap && a.enable(16), T.transmission && a.enable(17), T.transmissionMap && a.enable(18), T.thicknessMap && a.enable(19), T.sheen && a.enable(20), T.sheenColorMap && a.enable(21), T.sheenRoughnessMap && a.enable(22), T.decodeVideoTexture && a.enable(23), T.opaque && a.enable(24), b.push(a.mask);
    }
    function x(b) {
        let T = p[b.type], M;
        if (T) {
            let C = lo[T];
            M = Ns.clone(C.uniforms);
        } else M = b.uniforms;
        return M;
    }
    function S(b, T) {
        let M;
        for(let C = 0, P = u.length; C < P; C++){
            let D = u[C];
            if (D.cacheKey === T) {
                M = D, ++M.usedTimes;
                break;
            }
        }
        return M === void 0 && (M = new lG(n1, T, b, s), u.push(M)), M;
    }
    function w(b) {
        if (--b.usedTimes === 0) {
            let T = u.indexOf(b);
            u[T] = u[u.length - 1], u.pop(), b.destroy();
        }
    }
    function A(b) {
        l.remove(b);
    }
    function E() {
        l.dispose();
    }
    return {
        getParameters: m,
        getProgramCacheKey: g,
        getUniforms: x,
        acquireProgram: S,
        releaseProgram: w,
        releaseShaderCache: A,
        programs: u,
        dispose: E
    };
}
function dG() {
    let n1 = new WeakMap;
    function t(s) {
        let o = n1.get(s);
        return o === void 0 && (o = {}, n1.set(s, o)), o;
    }
    function e(s) {
        n1.delete(s);
    }
    function r(s, o, a) {
        n1.get(s)[o] = a;
    }
    function i() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        remove: e,
        update: r,
        dispose: i
    };
}
function hG(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.material.id !== t.material.id ? n1.material.id - t.material.id : n1.z !== t.z ? n1.z - t.z : n1.id - t.id;
}
function KT(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.z !== t.z ? t.z - n1.z : n1.id - t.id;
}
function ZT() {
    let n1 = [], t = 0, e = [], r = [], i = [];
    function s() {
        t = 0, e.length = 0, r.length = 0, i.length = 0;
    }
    function o(d, h, f, p, m, g) {
        let y = n1[t];
        return y === void 0 ? (y = {
            id: d.id,
            object: d,
            geometry: h,
            material: f,
            groupOrder: p,
            renderOrder: d.renderOrder,
            z: m,
            group: g
        }, n1[t] = y) : (y.id = d.id, y.object = d, y.geometry = h, y.material = f, y.groupOrder = p, y.renderOrder = d.renderOrder, y.z = m, y.group = g), t++, y;
    }
    function a(d, h, f, p, m, g) {
        let y = o(d, h, f, p, m, g);
        f.transmission > 0 ? r.push(y) : f.transparent === !0 ? i.push(y) : e.push(y);
    }
    function l(d, h, f, p, m, g) {
        let y = o(d, h, f, p, m, g);
        f.transmission > 0 ? r.unshift(y) : f.transparent === !0 ? i.unshift(y) : e.unshift(y);
    }
    function u(d, h) {
        e.length > 1 && e.sort(d || hG), r.length > 1 && r.sort(h || KT), i.length > 1 && i.sort(h || KT);
    }
    function c() {
        for(let d = t, h = n1.length; d < h; d++){
            let f = n1[d];
            if (f.id === null) break;
            f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
        }
    }
    return {
        opaque: e,
        transmissive: r,
        transparent: i,
        init: s,
        push: a,
        unshift: l,
        finish: c,
        sort: u
    };
}
function fG() {
    let n1 = new WeakMap;
    function t(r, i) {
        let s = n1.get(r), o;
        return s === void 0 ? (o = new ZT, n1.set(r, [
            o
        ])) : i >= s.length ? (o = new ZT, s.push(o)) : o = s[i], o;
    }
    function e() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        dispose: e
    };
}
function pG() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        direction: new _,
                        color: new Le
                    };
                    break;
                case "SpotLight":
                    e = {
                        position: new _,
                        direction: new _,
                        color: new Le,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    e = {
                        position: new _,
                        color: new Le,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    e = {
                        direction: new _,
                        skyColor: new Le,
                        groundColor: new Le
                    };
                    break;
                case "RectAreaLight":
                    e = {
                        color: new Le,
                        position: new _,
                        halfWidth: new _,
                        halfHeight: new _
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
function mG() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new N
                    };
                    break;
                case "SpotLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new N
                    };
                    break;
                case "PointLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new N,
                        shadowCameraNear: 1,
                        shadowCameraFar: 1e3
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
var gG = 0;
function yG(n1, t) {
    return (t.castShadow ? 2 : 0) - (n1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (n1.map ? 1 : 0);
}
function vG(n1, t) {
    let e = new pG, r = mG(), i = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let c = 0; c < 9; c++)i.probe.push(new _);
    let s = new _, o = new te, a = new te;
    function l(c, d) {
        let h = 0, f = 0, p = 0;
        for(let C = 0; C < 9; C++)i.probe[C].set(0, 0, 0);
        let m = 0, g = 0, y = 0, v = 0, x = 0, S = 0, w = 0, A = 0, E = 0, b = 0;
        c.sort(yG);
        let T = d !== !0 ? Math.PI : 1;
        for(let C = 0, P = c.length; C < P; C++){
            let D = c[C], O = D.color, I = D.intensity, z = D.distance, B = D.shadow && D.shadow.map ? D.shadow.map.texture : null;
            if (D.isAmbientLight) h += O.r * I * T, f += O.g * I * T, p += O.b * I * T;
            else if (D.isLightProbe) for(let V = 0; V < 9; V++)i.probe[V].addScaledVector(D.sh.coefficients[V], I);
            else if (D.isDirectionalLight) {
                let V = e.get(D);
                if (V.color.copy(D.color).multiplyScalar(D.intensity * T), D.castShadow) {
                    let U = D.shadow, j = r.get(D);
                    j.shadowBias = U.bias, j.shadowNormalBias = U.normalBias, j.shadowRadius = U.radius, j.shadowMapSize = U.mapSize, i.directionalShadow[m] = j, i.directionalShadowMap[m] = B, i.directionalShadowMatrix[m] = D.shadow.matrix, S++;
                }
                i.directional[m] = V, m++;
            } else if (D.isSpotLight) {
                let V = e.get(D);
                V.position.setFromMatrixPosition(D.matrixWorld), V.color.copy(O).multiplyScalar(I * T), V.distance = z, V.coneCos = Math.cos(D.angle), V.penumbraCos = Math.cos(D.angle * (1 - D.penumbra)), V.decay = D.decay, i.spot[y] = V;
                let U = D.shadow;
                if (D.map && (i.spotLightMap[E] = D.map, E++, U.updateMatrices(D), D.castShadow && b++), i.spotLightMatrix[y] = U.matrix, D.castShadow) {
                    let j = r.get(D);
                    j.shadowBias = U.bias, j.shadowNormalBias = U.normalBias, j.shadowRadius = U.radius, j.shadowMapSize = U.mapSize, i.spotShadow[y] = j, i.spotShadowMap[y] = B, A++;
                }
                y++;
            } else if (D.isRectAreaLight) {
                let V = e.get(D);
                V.color.copy(O).multiplyScalar(I), V.halfWidth.set(D.width * .5, 0, 0), V.halfHeight.set(0, D.height * .5, 0), i.rectArea[v] = V, v++;
            } else if (D.isPointLight) {
                let V = e.get(D);
                if (V.color.copy(D.color).multiplyScalar(D.intensity * T), V.distance = D.distance, V.decay = D.decay, D.castShadow) {
                    let U = D.shadow, j = r.get(D);
                    j.shadowBias = U.bias, j.shadowNormalBias = U.normalBias, j.shadowRadius = U.radius, j.shadowMapSize = U.mapSize, j.shadowCameraNear = U.camera.near, j.shadowCameraFar = U.camera.far, i.pointShadow[g] = j, i.pointShadowMap[g] = B, i.pointShadowMatrix[g] = D.shadow.matrix, w++;
                }
                i.point[g] = V, g++;
            } else if (D.isHemisphereLight) {
                let V = e.get(D);
                V.skyColor.copy(D.color).multiplyScalar(I * T), V.groundColor.copy(D.groundColor).multiplyScalar(I * T), i.hemi[x] = V, x++;
            }
        }
        v > 0 && (t.isWebGL2 || n1.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = Ae.LTC_FLOAT_1, i.rectAreaLTC2 = Ae.LTC_FLOAT_2) : n1.has("OES_texture_half_float_linear") === !0 ? (i.rectAreaLTC1 = Ae.LTC_HALF_1, i.rectAreaLTC2 = Ae.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), i.ambient[0] = h, i.ambient[1] = f, i.ambient[2] = p;
        let M = i.hash;
        (M.directionalLength !== m || M.pointLength !== g || M.spotLength !== y || M.rectAreaLength !== v || M.hemiLength !== x || M.numDirectionalShadows !== S || M.numPointShadows !== w || M.numSpotShadows !== A || M.numSpotMaps !== E) && (i.directional.length = m, i.spot.length = y, i.rectArea.length = v, i.point.length = g, i.hemi.length = x, i.directionalShadow.length = S, i.directionalShadowMap.length = S, i.pointShadow.length = w, i.pointShadowMap.length = w, i.spotShadow.length = A, i.spotShadowMap.length = A, i.directionalShadowMatrix.length = S, i.pointShadowMatrix.length = w, i.spotLightMatrix.length = A + E - b, i.spotLightMap.length = E, i.numSpotLightShadowsWithMaps = b, M.directionalLength = m, M.pointLength = g, M.spotLength = y, M.rectAreaLength = v, M.hemiLength = x, M.numDirectionalShadows = S, M.numPointShadows = w, M.numSpotShadows = A, M.numSpotMaps = E, i.version = gG++);
    }
    function u(c, d) {
        let h = 0, f = 0, p = 0, m = 0, g = 0, y = d.matrixWorldInverse;
        for(let v = 0, x = c.length; v < x; v++){
            let S = c[v];
            if (S.isDirectionalLight) {
                let w = i.directional[h];
                w.direction.setFromMatrixPosition(S.matrixWorld), s.setFromMatrixPosition(S.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(y), h++;
            } else if (S.isSpotLight) {
                let w = i.spot[p];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), w.direction.setFromMatrixPosition(S.matrixWorld), s.setFromMatrixPosition(S.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(y), p++;
            } else if (S.isRectAreaLight) {
                let w = i.rectArea[m];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), a.identity(), o.copy(S.matrixWorld), o.premultiply(y), a.extractRotation(o), w.halfWidth.set(S.width * .5, 0, 0), w.halfHeight.set(0, S.height * .5, 0), w.halfWidth.applyMatrix4(a), w.halfHeight.applyMatrix4(a), m++;
            } else if (S.isPointLight) {
                let w = i.point[f];
                w.position.setFromMatrixPosition(S.matrixWorld), w.position.applyMatrix4(y), f++;
            } else if (S.isHemisphereLight) {
                let w = i.hemi[g];
                w.direction.setFromMatrixPosition(S.matrixWorld), w.direction.transformDirection(y), g++;
            }
        }
    }
    return {
        setup: l,
        setupView: u,
        state: i
    };
}
function JT(n1, t) {
    let e = new vG(n1, t), r = [], i = [];
    function s() {
        r.length = 0, i.length = 0;
    }
    function o(d) {
        r.push(d);
    }
    function a(d) {
        i.push(d);
    }
    function l(d) {
        e.setup(r, d);
    }
    function u(d) {
        e.setupView(r, d);
    }
    return {
        init: s,
        state: {
            lightsArray: r,
            shadowsArray: i,
            lights: e
        },
        setupLights: l,
        setupLightsView: u,
        pushLight: o,
        pushShadow: a
    };
}
function xG(n1, t) {
    let e = new WeakMap;
    function r(s, o = 0) {
        let a = e.get(s), l;
        return a === void 0 ? (l = new JT(n1, t), e.set(s, [
            l
        ])) : o >= a.length ? (l = new JT(n1, t), a.push(l)) : l = a[o], l;
    }
    function i() {
        e = new WeakMap;
    }
    return {
        get: r,
        dispose: i
    };
}
var hp = class extends hc {
    constructor(t){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Ii, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
}, FS = class extends hc {
    constructor(t){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new _, this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
}, bG = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, SG = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function wG(n1, t, e) {
    let r = new dp, i = new N, s = new N, o = new He, a = new hp({
        depthPacking: lw
    }), l = new FS, u = {}, c = e.maxTextureSize, d = {
        [jn]: ai,
        [ai]: jn,
        [qi]: qi
    }, h = new rt({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new N
            },
            radius: {
                value: 4
            }
        },
        vertexShader: bG,
        fragmentShader: SG
    }), f = h.clone();
    f.defines.HORIZONTAL_PASS = 1;
    let p = new we;
    p.setAttribute("position", new Ge(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    let m = new rr(p, h), g = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = Ty, this.render = function(S, w, A) {
        if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || S.length === 0) return;
        let E = n1.getRenderTarget(), b = n1.getActiveCubeFace(), T = n1.getActiveMipmapLevel(), M = n1.state;
        M.setBlending(Wt), M.buffers.color.setClear(1, 1, 1, 1), M.buffers.depth.setTest(!0), M.setScissorTest(!1);
        for(let C = 0, P = S.length; C < P; C++){
            let D = S[C], O = D.shadow;
            if (O === void 0) {
                console.warn("THREE.WebGLShadowMap:", D, "has no shadow.");
                continue;
            }
            if (O.autoUpdate === !1 && O.needsUpdate === !1) continue;
            i.copy(O.mapSize);
            let I = O.getFrameExtents();
            if (i.multiply(I), s.copy(O.mapSize), (i.x > c || i.y > c) && (i.x > c && (s.x = Math.floor(c / I.x), i.x = s.x * I.x, O.mapSize.x = s.x), i.y > c && (s.y = Math.floor(c / I.y), i.y = s.y * I.y, O.mapSize.y = s.y)), O.map === null) {
                let B = this.type !== ep ? {
                    minFilter: Et,
                    magFilter: Et
                } : {};
                O.map = new at(i.x, i.y, B), O.map.texture.name = D.name + ".shadowMap", O.camera.updateProjectionMatrix();
            }
            n1.setRenderTarget(O.map), n1.clear();
            let z = O.getViewportCount();
            for(let B = 0; B < z; B++){
                let V = O.getViewport(B);
                o.set(s.x * V.x, s.y * V.y, s.x * V.z, s.y * V.w), M.viewport(o), O.updateMatrices(D, B), r = O.getFrustum(), x(w, A, O.camera, D, this.type);
            }
            O.isPointLightShadow !== !0 && this.type === ep && y(O, A), O.needsUpdate = !1;
        }
        g.needsUpdate = !1, n1.setRenderTarget(E, b, T);
    };
    function y(S, w) {
        let A = t.update(m);
        h.defines.VSM_SAMPLES !== S.blurSamples && (h.defines.VSM_SAMPLES = S.blurSamples, f.defines.VSM_SAMPLES = S.blurSamples, h.needsUpdate = !0, f.needsUpdate = !0), S.mapPass === null && (S.mapPass = new at(i.x, i.y)), h.uniforms.shadow_pass.value = S.map.texture, h.uniforms.resolution.value = S.mapSize, h.uniforms.radius.value = S.radius, n1.setRenderTarget(S.mapPass), n1.clear(), n1.renderBufferDirect(w, null, A, h, m, null), f.uniforms.shadow_pass.value = S.mapPass.texture, f.uniforms.resolution.value = S.mapSize, f.uniforms.radius.value = S.radius, n1.setRenderTarget(S.map), n1.clear(), n1.renderBufferDirect(w, null, A, f, m, null);
    }
    function v(S, w, A, E, b, T) {
        let M = null, C = A.isPointLight === !0 ? S.customDistanceMaterial : S.customDepthMaterial;
        if (C !== void 0) M = C;
        else if (M = A.isPointLight === !0 ? l : a, n1.localClippingEnabled && w.clipShadows === !0 && Array.isArray(w.clippingPlanes) && w.clippingPlanes.length !== 0 || w.displacementMap && w.displacementScale !== 0 || w.alphaMap && w.alphaTest > 0 || w.map && w.alphaTest > 0) {
            let P = M.uuid, D = w.uuid, O = u[P];
            O === void 0 && (O = {}, u[P] = O);
            let I = O[D];
            I === void 0 && (I = M.clone(), O[D] = I), M = I;
        }
        return M.visible = w.visible, M.wireframe = w.wireframe, T === ep ? M.side = w.shadowSide !== null ? w.shadowSide : w.side : M.side = w.shadowSide !== null ? w.shadowSide : d[w.side], M.alphaMap = w.alphaMap, M.alphaTest = w.alphaTest, M.map = w.map, M.clipShadows = w.clipShadows, M.clippingPlanes = w.clippingPlanes, M.clipIntersection = w.clipIntersection, M.displacementMap = w.displacementMap, M.displacementScale = w.displacementScale, M.displacementBias = w.displacementBias, M.wireframeLinewidth = w.wireframeLinewidth, M.linewidth = w.linewidth, A.isPointLight === !0 && M.isMeshDistanceMaterial === !0 && (M.referencePosition.setFromMatrixPosition(A.matrixWorld), M.nearDistance = E, M.farDistance = b), M;
    }
    function x(S, w, A, E, b) {
        if (S.visible === !1) return;
        if (S.layers.test(w.layers) && (S.isMesh || S.isLine || S.isPoints) && (S.castShadow || S.receiveShadow && b === ep) && (!S.frustumCulled || r.intersectsObject(S))) {
            S.modelViewMatrix.multiplyMatrices(A.matrixWorldInverse, S.matrixWorld);
            let C = t.update(S), P = S.material;
            if (Array.isArray(P)) {
                let D = C.groups;
                for(let O = 0, I = D.length; O < I; O++){
                    let z = D[O], B = P[z.materialIndex];
                    if (B && B.visible) {
                        let V = v(S, B, E, A.near, A.far, b);
                        n1.renderBufferDirect(A, null, C, V, S, z);
                    }
                }
            } else if (P.visible) {
                let D = v(S, P, E, A.near, A.far, b);
                n1.renderBufferDirect(A, null, C, D, S, null);
            }
        }
        let M = S.children;
        for(let C = 0, P = M.length; C < P; C++)x(M[C], w, A, E, b);
    }
}
function AG(n1, t, e) {
    let r = e.isWebGL2;
    function i() {
        let Q = !1, ce = new He, ve = null, ze = new He(0, 0, 0, 0);
        return {
            setMask: function(Fe) {
                ve !== Fe && !Q && (n1.colorMask(Fe, Fe, Fe, Fe), ve = Fe);
            },
            setLocked: function(Fe) {
                Q = Fe;
            },
            setClear: function(Fe, Ot, ri, jr, ec) {
                ec === !0 && (Fe *= jr, Ot *= jr, ri *= jr), ce.set(Fe, Ot, ri, jr), ze.equals(ce) === !1 && (n1.clearColor(Fe, Ot, ri, jr), ze.copy(ce));
            },
            reset: function() {
                Q = !1, ve = null, ze.set(-1, 0, 0, 0);
            }
        };
    }
    function s() {
        let Q = !1, ce = null, ve = null, ze = null;
        return {
            setTest: function(Fe) {
                Fe ? J(2929) : Z(2929);
            },
            setMask: function(Fe) {
                ce !== Fe && !Q && (n1.depthMask(Fe), ce = Fe);
            },
            setFunc: function(Fe) {
                if (ve !== Fe) {
                    switch(Fe){
                        case eF:
                            n1.depthFunc(512);
                            break;
                        case tF:
                            n1.depthFunc(519);
                            break;
                        case rF:
                            n1.depthFunc(513);
                            break;
                        case wS:
                            n1.depthFunc(515);
                            break;
                        case iF:
                            n1.depthFunc(514);
                            break;
                        case nF:
                            n1.depthFunc(518);
                            break;
                        case sF:
                            n1.depthFunc(516);
                            break;
                        case oF:
                            n1.depthFunc(517);
                            break;
                        default:
                            n1.depthFunc(515);
                    }
                    ve = Fe;
                }
            },
            setLocked: function(Fe) {
                Q = Fe;
            },
            setClear: function(Fe) {
                ze !== Fe && (n1.clearDepth(Fe), ze = Fe);
            },
            reset: function() {
                Q = !1, ce = null, ve = null, ze = null;
            }
        };
    }
    function o() {
        let Q = !1, ce = null, ve = null, ze = null, Fe = null, Ot = null, ri = null, jr = null, ec = null;
        return {
            setTest: function(_r) {
                Q || (_r ? J(2960) : Z(2960));
            },
            setMask: function(_r) {
                ce !== _r && !Q && (n1.stencilMask(_r), ce = _r);
            },
            setFunc: function(_r, Qo, $n) {
                (ve !== _r || ze !== Qo || Fe !== $n) && (n1.stencilFunc(_r, Qo, $n), ve = _r, ze = Qo, Fe = $n);
            },
            setOp: function(_r, Qo, $n) {
                (Ot !== _r || ri !== Qo || jr !== $n) && (n1.stencilOp(_r, Qo, $n), Ot = _r, ri = Qo, jr = $n);
            },
            setLocked: function(_r) {
                Q = _r;
            },
            setClear: function(_r) {
                ec !== _r && (n1.clearStencil(_r), ec = _r);
            },
            reset: function() {
                Q = !1, ce = null, ve = null, ze = null, Fe = null, Ot = null, ri = null, jr = null, ec = null;
            }
        };
    }
    let a = new i, l = new s, u = new o, c = new WeakMap, d = new WeakMap, h = {}, f = {}, p = new WeakMap, m = [], g = null, y = !1, v = null, x = null, S = null, w = null, A = null, E = null, b = null, T = !1, M = null, C = null, P = null, D = null, O = null, I = n1.getParameter(35661), z = !1, B = 0, V = n1.getParameter(7938);
    V.indexOf("WebGL") !== -1 ? (B = parseFloat(/^WebGL (\d)/.exec(V)[1]), z = B >= 1) : V.indexOf("OpenGL ES") !== -1 && (B = parseFloat(/^OpenGL ES (\d)/.exec(V)[1]), z = B >= 2);
    let U = null, j = {}, W = n1.getParameter(3088), k = n1.getParameter(2978), H = new He().fromArray(W), X = new He().fromArray(k);
    function q(Q, ce, ve) {
        let ze = new Uint8Array(4), Fe = n1.createTexture();
        n1.bindTexture(Q, Fe), n1.texParameteri(Q, 10241, 9728), n1.texParameteri(Q, 10240, 9728);
        for(let Ot = 0; Ot < ve; Ot++)n1.texImage2D(ce + Ot, 0, 6408, 1, 1, 0, 6408, 5121, ze);
        return Fe;
    }
    let G = {};
    G[3553] = q(3553, 3553, 1), G[34067] = q(34067, 34069, 6), a.setClear(0, 0, 0, 1), l.setClear(1), u.setClear(0), J(2929), l.setFunc(wS), Ie(!1), Oe(HE), J(2884), _e(Wt);
    function J(Q) {
        h[Q] !== !0 && (n1.enable(Q), h[Q] = !0);
    }
    function Z(Q) {
        h[Q] !== !1 && (n1.disable(Q), h[Q] = !1);
    }
    function K(Q, ce) {
        return f[Q] !== ce ? (n1.bindFramebuffer(Q, ce), f[Q] = ce, r && (Q === 36009 && (f[36160] = ce), Q === 36160 && (f[36009] = ce)), !0) : !1;
    }
    function Y(Q, ce) {
        let ve = m, ze = !1;
        if (Q) {
            if (ve = p.get(ce), ve === void 0 && (ve = [], p.set(ce, ve)), Q.isWebGLMultipleRenderTargets) {
                let Fe = Q.texture;
                if (ve.length !== Fe.length || ve[0] !== 36064) {
                    for(let Ot = 0, ri = Fe.length; Ot < ri; Ot++)ve[Ot] = 36064 + Ot;
                    ve.length = Fe.length, ze = !0;
                }
            } else ve[0] !== 36064 && (ve[0] = 36064, ze = !0);
        } else ve[0] !== 1029 && (ve[0] = 1029, ze = !0);
        ze && (e.isWebGL2 ? n1.drawBuffers(ve) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(ve));
    }
    function ye(Q) {
        return g !== Q ? (n1.useProgram(Q), g = Q, !0) : !1;
    }
    let fe = {
        [Au]: 32774,
        [jN]: 32778,
        [HN]: 32779
    };
    if (r) fe[XE] = 32775, fe[QE] = 32776;
    else {
        let Q = t.get("EXT_blend_minmax");
        Q !== null && (fe[XE] = Q.MIN_EXT, fe[QE] = Q.MAX_EXT);
    }
    let oe = {
        [WN]: 0,
        [qN]: 1,
        [YN]: 768,
        [wM]: 770,
        [$N]: 776,
        [ZN]: 774,
        [QN]: 772,
        [XN]: 769,
        [AM]: 771,
        [JN]: 775,
        [KN]: 773
    };
    function _e(Q, ce, ve, ze, Fe, Ot, ri, jr) {
        if (Q === Wt) {
            y === !0 && (Z(3042), y = !1);
            return;
        }
        if (y === !1 && (J(3042), y = !0), Q !== GN) {
            if (Q !== v || jr !== T) {
                if ((x !== Au || A !== Au) && (n1.blendEquation(32774), x = Au, A = Au), jr) switch(Q){
                    case qa:
                        n1.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case WE:
                        n1.blendFunc(1, 1);
                        break;
                    case qE:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case YE:
                        n1.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Q);
                        break;
                }
                else switch(Q){
                    case qa:
                        n1.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case WE:
                        n1.blendFunc(770, 1);
                        break;
                    case qE:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case YE:
                        n1.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Q);
                        break;
                }
                S = null, w = null, E = null, b = null, v = Q, T = jr;
            }
            return;
        }
        Fe = Fe || ce, Ot = Ot || ve, ri = ri || ze, (ce !== x || Fe !== A) && (n1.blendEquationSeparate(fe[ce], fe[Fe]), x = ce, A = Fe), (ve !== S || ze !== w || Ot !== E || ri !== b) && (n1.blendFuncSeparate(oe[ve], oe[ze], oe[Ot], oe[ri]), S = ve, w = ze, E = Ot, b = ri), v = Q, T = !1;
    }
    function xe(Q, ce) {
        Q.side === qi ? Z(2884) : J(2884);
        let ve = Q.side === ai;
        ce && (ve = !ve), Ie(ve), Q.blending === qa && Q.transparent === !1 ? _e(Wt) : _e(Q.blending, Q.blendEquation, Q.blendSrc, Q.blendDst, Q.blendEquationAlpha, Q.blendSrcAlpha, Q.blendDstAlpha, Q.premultipliedAlpha), l.setFunc(Q.depthFunc), l.setTest(Q.depthTest), l.setMask(Q.depthWrite), a.setMask(Q.colorWrite);
        let ze = Q.stencilWrite;
        u.setTest(ze), ze && (u.setMask(Q.stencilWriteMask), u.setFunc(Q.stencilFunc, Q.stencilRef, Q.stencilFuncMask), u.setOp(Q.stencilFail, Q.stencilZFail, Q.stencilZPass)), Te(Q.polygonOffset, Q.polygonOffsetFactor, Q.polygonOffsetUnits), Q.alphaToCoverage === !0 ? J(32926) : Z(32926);
    }
    function Ie(Q) {
        M !== Q && (Q ? n1.frontFace(2304) : n1.frontFace(2305), M = Q);
    }
    function Oe(Q) {
        Q !== zN ? (J(2884), Q !== C && (Q === HE ? n1.cullFace(1029) : Q === VN ? n1.cullFace(1028) : n1.cullFace(1032))) : Z(2884), C = Q;
    }
    function Pe(Q) {
        Q !== P && (z && n1.lineWidth(Q), P = Q);
    }
    function Te(Q, ce, ve) {
        Q ? (J(32823), (D !== ce || O !== ve) && (n1.polygonOffset(ce, ve), D = ce, O = ve)) : Z(32823);
    }
    function Ve(Q) {
        Q ? J(3089) : Z(3089);
    }
    function Ue(Q) {
        Q === void 0 && (Q = 33984 + I - 1), U !== Q && (n1.activeTexture(Q), U = Q);
    }
    function L(Q, ce, ve) {
        ve === void 0 && (U === null ? ve = 33984 + I - 1 : ve = U);
        let ze = j[ve];
        ze === void 0 && (ze = {
            type: void 0,
            texture: void 0
        }, j[ve] = ze), (ze.type !== Q || ze.texture !== ce) && (U !== ve && (n1.activeTexture(ve), U = ve), n1.bindTexture(Q, ce || G[Q]), ze.type = Q, ze.texture = ce);
    }
    function R() {
        let Q = j[U];
        Q !== void 0 && Q.type !== void 0 && (n1.bindTexture(Q.type, null), Q.type = void 0, Q.texture = void 0);
    }
    function ie() {
        try {
            n1.compressedTexImage2D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function ue() {
        try {
            n1.compressedTexImage3D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function me() {
        try {
            n1.texSubImage2D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function De() {
        try {
            n1.texSubImage3D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Me() {
        try {
            n1.compressedTexSubImage2D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Ee() {
        try {
            n1.compressedTexSubImage3D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function le() {
        try {
            n1.texStorage2D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Je() {
        try {
            n1.texStorage3D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function ke() {
        try {
            n1.texImage2D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Be() {
        try {
            n1.texImage3D.apply(n1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function qe(Q) {
        H.equals(Q) === !1 && (n1.scissor(Q.x, Q.y, Q.z, Q.w), H.copy(Q));
    }
    function et(Q) {
        X.equals(Q) === !1 && (n1.viewport(Q.x, Q.y, Q.z, Q.w), X.copy(Q));
    }
    function Dt(Q, ce) {
        let ve = d.get(ce);
        ve === void 0 && (ve = new WeakMap, d.set(ce, ve));
        let ze = ve.get(Q);
        ze === void 0 && (ze = n1.getUniformBlockIndex(ce, Q.name), ve.set(Q, ze));
    }
    function yr(Q, ce) {
        let ze = d.get(ce).get(Q);
        c.get(ce) !== ze && (n1.uniformBlockBinding(ce, ze, Q.__bindingPointIndex), c.set(ce, ze));
    }
    function ti() {
        n1.disable(3042), n1.disable(2884), n1.disable(2929), n1.disable(32823), n1.disable(3089), n1.disable(2960), n1.disable(32926), n1.blendEquation(32774), n1.blendFunc(1, 0), n1.blendFuncSeparate(1, 0, 1, 0), n1.colorMask(!0, !0, !0, !0), n1.clearColor(0, 0, 0, 0), n1.depthMask(!0), n1.depthFunc(513), n1.clearDepth(1), n1.stencilMask(4294967295), n1.stencilFunc(519, 0, 4294967295), n1.stencilOp(7680, 7680, 7680), n1.clearStencil(0), n1.cullFace(1029), n1.frontFace(2305), n1.polygonOffset(0, 0), n1.activeTexture(33984), n1.bindFramebuffer(36160, null), r === !0 && (n1.bindFramebuffer(36009, null), n1.bindFramebuffer(36008, null)), n1.useProgram(null), n1.lineWidth(1), n1.scissor(0, 0, n1.canvas.width, n1.canvas.height), n1.viewport(0, 0, n1.canvas.width, n1.canvas.height), h = {}, U = null, j = {}, f = {}, p = new WeakMap, m = [], g = null, y = !1, v = null, x = null, S = null, w = null, A = null, E = null, b = null, T = !1, M = null, C = null, P = null, D = null, O = null, H.set(0, 0, n1.canvas.width, n1.canvas.height), X.set(0, 0, n1.canvas.width, n1.canvas.height), a.reset(), l.reset(), u.reset();
    }
    return {
        buffers: {
            color: a,
            depth: l,
            stencil: u
        },
        enable: J,
        disable: Z,
        bindFramebuffer: K,
        drawBuffers: Y,
        useProgram: ye,
        setBlending: _e,
        setMaterial: xe,
        setFlipSided: Ie,
        setCullFace: Oe,
        setLineWidth: Pe,
        setPolygonOffset: Te,
        setScissorTest: Ve,
        activeTexture: Ue,
        bindTexture: L,
        unbindTexture: R,
        compressedTexImage2D: ie,
        compressedTexImage3D: ue,
        texImage2D: ke,
        texImage3D: Be,
        updateUBOMapping: Dt,
        uniformBlockBinding: yr,
        texStorage2D: le,
        texStorage3D: Je,
        texSubImage2D: me,
        texSubImage3D: De,
        compressedTexSubImage2D: Me,
        compressedTexSubImage3D: Ee,
        scissor: qe,
        viewport: et,
        reset: ti
    };
}
function _G(n1, t, e, r, i, s, o) {
    let a = i.isWebGL2, l = i.maxTextures, u = i.maxCubemapSize, c = i.maxTextureSize, d = i.maxSamples, h = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, f = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), p = new WeakMap, m, g = new WeakMap, y = !1;
    try {
        y = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch  {}
    function v(L, R) {
        return y ? new OffscreenCanvas(L, R) : cp("canvas");
    }
    function x(L, R, ie, ue) {
        let me = 1;
        if ((L.width > ue || L.height > ue) && (me = ue / Math.max(L.width, L.height)), me < 1 || R === !0) {
            if (typeof HTMLImageElement < "u" && L instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && L instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && L instanceof ImageBitmap) {
                let De = R ? ey : Math.floor, Me = De(me * L.width), Ee = De(me * L.height);
                m === void 0 && (m = v(Me, Ee));
                let le = ie ? v(Me, Ee) : m;
                return le.width = Me, le.height = Ee, le.getContext("2d").drawImage(L, 0, 0, Me, Ee), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + L.width + "x" + L.height + ") to (" + Me + "x" + Ee + ")."), le;
            } else return "data" in L && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + L.width + "x" + L.height + ")."), L;
        }
        return L;
    }
    function S(L) {
        return CS(L.width) && CS(L.height);
    }
    function w(L) {
        return a ? !1 : L.wrapS !== Ut || L.wrapT !== Ut || L.minFilter !== Et && L.minFilter !== Qe;
    }
    function A(L, R) {
        return L.generateMipmaps && R && L.minFilter !== Et && L.minFilter !== Qe;
    }
    function E(L) {
        n1.generateMipmap(L);
    }
    function b(L, R, ie, ue, me = !1) {
        if (a === !1) return R;
        if (L !== null) {
            if (n1[L] !== void 0) return n1[L];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + L + "'");
        }
        let De = R;
        return R === 6403 && (ie === 5126 && (De = 33326), ie === 5131 && (De = 33325), ie === 5121 && (De = 33321)), R === 33319 && (ie === 5126 && (De = 33328), ie === 5131 && (De = 33327), ie === 5121 && (De = 33323)), R === 6408 && (ie === 5126 && (De = 34836), ie === 5131 && (De = 34842), ie === 5121 && (De = ue === tt && me === !1 ? 35907 : 32856), ie === 32819 && (De = 32854), ie === 32820 && (De = 32855)), (De === 33325 || De === 33326 || De === 33327 || De === 33328 || De === 34842 || De === 34836) && t.get("EXT_color_buffer_float"), De;
    }
    function T(L, R, ie) {
        return A(L, ie) === !0 || L.isFramebufferTexture && L.minFilter !== Et && L.minFilter !== Qe ? Math.log2(Math.max(R.width, R.height)) + 1 : L.mipmaps !== void 0 && L.mipmaps.length > 0 ? L.mipmaps.length : L.isCompressedTexture && Array.isArray(L.image) ? R.mipmaps.length : 1;
    }
    function M(L) {
        return L === Et || L === KE || L === zb ? 9728 : 9729;
    }
    function C(L) {
        let R = L.target;
        R.removeEventListener("dispose", C), D(R), R.isVideoTexture && p.delete(R);
    }
    function P(L) {
        let R = L.target;
        R.removeEventListener("dispose", P), I(R);
    }
    function D(L) {
        let R = r.get(L);
        if (R.__webglInit === void 0) return;
        let ie = L.source, ue = g.get(ie);
        if (ue) {
            let me = ue[R.__cacheKey];
            me.usedTimes--, me.usedTimes === 0 && O(L), Object.keys(ue).length === 0 && g.delete(ie);
        }
        r.remove(L);
    }
    function O(L) {
        let R = r.get(L);
        n1.deleteTexture(R.__webglTexture);
        let ie = L.source, ue = g.get(ie);
        delete ue[R.__cacheKey], o.memory.textures--;
    }
    function I(L) {
        let R = L.texture, ie = r.get(L), ue = r.get(R);
        if (ue.__webglTexture !== void 0 && (n1.deleteTexture(ue.__webglTexture), o.memory.textures--), L.depthTexture && L.depthTexture.dispose(), L.isWebGLCubeRenderTarget) for(let me = 0; me < 6; me++)n1.deleteFramebuffer(ie.__webglFramebuffer[me]), ie.__webglDepthbuffer && n1.deleteRenderbuffer(ie.__webglDepthbuffer[me]);
        else {
            if (n1.deleteFramebuffer(ie.__webglFramebuffer), ie.__webglDepthbuffer && n1.deleteRenderbuffer(ie.__webglDepthbuffer), ie.__webglMultisampledFramebuffer && n1.deleteFramebuffer(ie.__webglMultisampledFramebuffer), ie.__webglColorRenderbuffer) for(let me = 0; me < ie.__webglColorRenderbuffer.length; me++)ie.__webglColorRenderbuffer[me] && n1.deleteRenderbuffer(ie.__webglColorRenderbuffer[me]);
            ie.__webglDepthRenderbuffer && n1.deleteRenderbuffer(ie.__webglDepthRenderbuffer);
        }
        if (L.isWebGLMultipleRenderTargets) for(let me = 0, De = R.length; me < De; me++){
            let Me = r.get(R[me]);
            Me.__webglTexture && (n1.deleteTexture(Me.__webglTexture), o.memory.textures--), r.remove(R[me]);
        }
        r.remove(R), r.remove(L);
    }
    let z = 0;
    function B() {
        z = 0;
    }
    function V() {
        let L = z;
        return L >= l && console.warn("THREE.WebGLTextures: Trying to use " + L + " texture units while this GPU supports only " + l), z += 1, L;
    }
    function U(L) {
        let R = [];
        return R.push(L.wrapS), R.push(L.wrapT), R.push(L.wrapR || 0), R.push(L.magFilter), R.push(L.minFilter), R.push(L.anisotropy), R.push(L.internalFormat), R.push(L.format), R.push(L.type), R.push(L.generateMipmaps), R.push(L.premultiplyAlpha), R.push(L.flipY), R.push(L.unpackAlignment), R.push(L.encoding), R.join();
    }
    function j(L, R) {
        let ie = r.get(L);
        if (L.isVideoTexture && Ve(L), L.isRenderTargetTexture === !1 && L.version > 0 && ie.__version !== L.version) {
            let ue = L.image;
            if (ue === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (ue.complete === !1) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                Z(ie, L, R);
                return;
            }
        }
        e.bindTexture(3553, ie.__webglTexture, 33984 + R);
    }
    function W(L, R) {
        let ie = r.get(L);
        if (L.version > 0 && ie.__version !== L.version) {
            Z(ie, L, R);
            return;
        }
        e.bindTexture(35866, ie.__webglTexture, 33984 + R);
    }
    function k(L, R) {
        let ie = r.get(L);
        if (L.version > 0 && ie.__version !== L.version) {
            Z(ie, L, R);
            return;
        }
        e.bindTexture(32879, ie.__webglTexture, 33984 + R);
    }
    function H(L, R) {
        let ie = r.get(L);
        if (L.version > 0 && ie.__version !== L.version) {
            K(ie, L, R);
            return;
        }
        e.bindTexture(34067, ie.__webglTexture, 33984 + R);
    }
    let X = {
        [Is]: 10497,
        [Ut]: 33071,
        [ES]: 33648
    }, q = {
        [Et]: 9728,
        [KE]: 9984,
        [zb]: 9986,
        [Qe]: 9729,
        [pF]: 9985,
        [dc]: 9987
    };
    function G(L, R, ie) {
        if (ie ? (n1.texParameteri(L, 10242, X[R.wrapS]), n1.texParameteri(L, 10243, X[R.wrapT]), (L === 32879 || L === 35866) && n1.texParameteri(L, 32882, X[R.wrapR]), n1.texParameteri(L, 10240, q[R.magFilter]), n1.texParameteri(L, 10241, q[R.minFilter])) : (n1.texParameteri(L, 10242, 33071), n1.texParameteri(L, 10243, 33071), (L === 32879 || L === 35866) && n1.texParameteri(L, 32882, 33071), (R.wrapS !== Ut || R.wrapT !== Ut) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), n1.texParameteri(L, 10240, M(R.magFilter)), n1.texParameteri(L, 10241, M(R.minFilter)), R.minFilter !== Et && R.minFilter !== Qe && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), t.has("EXT_texture_filter_anisotropic") === !0) {
            let ue = t.get("EXT_texture_filter_anisotropic");
            if (R.magFilter === Et || R.minFilter !== zb && R.minFilter !== dc || R.type === dr && t.has("OES_texture_float_linear") === !1 || a === !1 && R.type === sa && t.has("OES_texture_half_float_linear") === !1) return;
            (R.anisotropy > 1 || r.get(R).__currentAnisotropy) && (n1.texParameterf(L, ue.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(R.anisotropy, i.getMaxAnisotropy())), r.get(R).__currentAnisotropy = R.anisotropy);
        }
    }
    function J(L, R) {
        let ie = !1;
        L.__webglInit === void 0 && (L.__webglInit = !0, R.addEventListener("dispose", C));
        let ue = R.source, me = g.get(ue);
        me === void 0 && (me = {}, g.set(ue, me));
        let De = U(R);
        if (De !== L.__cacheKey) {
            me[De] === void 0 && (me[De] = {
                texture: n1.createTexture(),
                usedTimes: 0
            }, o.memory.textures++, ie = !0), me[De].usedTimes++;
            let Me = me[L.__cacheKey];
            Me !== void 0 && (me[L.__cacheKey].usedTimes--, Me.usedTimes === 0 && O(R)), L.__cacheKey = De, L.__webglTexture = me[De].texture;
        }
        return ie;
    }
    function Z(L, R, ie) {
        let ue = 3553;
        (R.isDataArrayTexture || R.isCompressedArrayTexture) && (ue = 35866), R.isData3DTexture && (ue = 32879);
        let me = J(L, R), De = R.source;
        e.bindTexture(ue, L.__webglTexture, 33984 + ie);
        let Me = r.get(De);
        if (De.version !== Me.__version || me === !0) {
            e.activeTexture(33984 + ie), n1.pixelStorei(37440, R.flipY), n1.pixelStorei(37441, R.premultiplyAlpha), n1.pixelStorei(3317, R.unpackAlignment), n1.pixelStorei(37443, 0);
            let Ee = w(R) && S(R.image) === !1, le = x(R.image, Ee, !1, c);
            le = Ue(R, le);
            let Je = S(le) || a, ke = s.convert(R.format, R.encoding), Be = s.convert(R.type), qe = b(R.internalFormat, ke, Be, R.encoding, R.isVideoTexture);
            G(ue, R, Je);
            let et, Dt = R.mipmaps, yr = a && R.isVideoTexture !== !0, ti = Me.__version === void 0 || me === !0, Q = T(R, le, Je);
            if (R.isDepthTexture) qe = 6402, a ? R.type === dr ? qe = 36012 : R.type === Ds ? qe = 33190 : R.type === Ya ? qe = 35056 : qe = 33189 : R.type === dr && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), R.format === cc && qe === 6402 && R.type !== TM && R.type !== Ds && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), R.type = Ds, Be = s.convert(R.type)), R.format === Ka && qe === 6402 && (qe = 34041, R.type !== Ya && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), R.type = Ya, Be = s.convert(R.type))), ti && (yr ? e.texStorage2D(3553, 1, qe, le.width, le.height) : e.texImage2D(3553, 0, qe, le.width, le.height, 0, ke, Be, null));
            else if (R.isDataTexture) {
                if (Dt.length > 0 && Je) {
                    yr && ti && e.texStorage2D(3553, Q, qe, Dt[0].width, Dt[0].height);
                    for(let ce = 0, ve = Dt.length; ce < ve; ce++)et = Dt[ce], yr ? e.texSubImage2D(3553, ce, 0, 0, et.width, et.height, ke, Be, et.data) : e.texImage2D(3553, ce, qe, et.width, et.height, 0, ke, Be, et.data);
                    R.generateMipmaps = !1;
                } else yr ? (ti && e.texStorage2D(3553, Q, qe, le.width, le.height), e.texSubImage2D(3553, 0, 0, 0, le.width, le.height, ke, Be, le.data)) : e.texImage2D(3553, 0, qe, le.width, le.height, 0, ke, Be, le.data);
            } else if (R.isCompressedTexture) {
                if (R.isCompressedArrayTexture) {
                    yr && ti && e.texStorage3D(35866, Q, qe, Dt[0].width, Dt[0].height, le.depth);
                    for(let ce = 0, ve = Dt.length; ce < ve; ce++)et = Dt[ce], R.format !== Fr ? ke !== null ? yr ? e.compressedTexSubImage3D(35866, ce, 0, 0, 0, et.width, et.height, le.depth, ke, et.data, 0, 0) : e.compressedTexImage3D(35866, ce, qe, et.width, et.height, le.depth, 0, et.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : yr ? e.texSubImage3D(35866, ce, 0, 0, 0, et.width, et.height, le.depth, ke, Be, et.data) : e.texImage3D(35866, ce, qe, et.width, et.height, le.depth, 0, ke, Be, et.data);
                } else {
                    yr && ti && e.texStorage2D(3553, Q, qe, Dt[0].width, Dt[0].height);
                    for(let ce = 0, ve = Dt.length; ce < ve; ce++)et = Dt[ce], R.format !== Fr ? ke !== null ? yr ? e.compressedTexSubImage2D(3553, ce, 0, 0, et.width, et.height, ke, et.data) : e.compressedTexImage2D(3553, ce, qe, et.width, et.height, 0, et.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : yr ? e.texSubImage2D(3553, ce, 0, 0, et.width, et.height, ke, Be, et.data) : e.texImage2D(3553, ce, qe, et.width, et.height, 0, ke, Be, et.data);
                }
            } else if (R.isDataArrayTexture) yr ? (ti && e.texStorage3D(35866, Q, qe, le.width, le.height, le.depth), e.texSubImage3D(35866, 0, 0, 0, 0, le.width, le.height, le.depth, ke, Be, le.data)) : e.texImage3D(35866, 0, qe, le.width, le.height, le.depth, 0, ke, Be, le.data);
            else if (R.isData3DTexture) yr ? (ti && e.texStorage3D(32879, Q, qe, le.width, le.height, le.depth), e.texSubImage3D(32879, 0, 0, 0, 0, le.width, le.height, le.depth, ke, Be, le.data)) : e.texImage3D(32879, 0, qe, le.width, le.height, le.depth, 0, ke, Be, le.data);
            else if (R.isFramebufferTexture) {
                if (ti) {
                    if (yr) e.texStorage2D(3553, Q, qe, le.width, le.height);
                    else {
                        let ce = le.width, ve = le.height;
                        for(let ze = 0; ze < Q; ze++)e.texImage2D(3553, ze, qe, ce, ve, 0, ke, Be, null), ce >>= 1, ve >>= 1;
                    }
                }
            } else if (Dt.length > 0 && Je) {
                yr && ti && e.texStorage2D(3553, Q, qe, Dt[0].width, Dt[0].height);
                for(let ce = 0, ve = Dt.length; ce < ve; ce++)et = Dt[ce], yr ? e.texSubImage2D(3553, ce, 0, 0, ke, Be, et) : e.texImage2D(3553, ce, qe, ke, Be, et);
                R.generateMipmaps = !1;
            } else yr ? (ti && e.texStorage2D(3553, Q, qe, le.width, le.height), e.texSubImage2D(3553, 0, 0, 0, ke, Be, le)) : e.texImage2D(3553, 0, qe, ke, Be, le);
            A(R, Je) && E(ue), Me.__version = De.version, R.onUpdate && R.onUpdate(R);
        }
        L.__version = R.version;
    }
    function K(L, R, ie) {
        if (R.image.length !== 6) return;
        let ue = J(L, R), me = R.source;
        e.bindTexture(34067, L.__webglTexture, 33984 + ie);
        let De = r.get(me);
        if (me.version !== De.__version || ue === !0) {
            e.activeTexture(33984 + ie), n1.pixelStorei(37440, R.flipY), n1.pixelStorei(37441, R.premultiplyAlpha), n1.pixelStorei(3317, R.unpackAlignment), n1.pixelStorei(37443, 0);
            let Me = R.isCompressedTexture || R.image[0].isCompressedTexture, Ee = R.image[0] && R.image[0].isDataTexture, le = [];
            for(let ce = 0; ce < 6; ce++)!Me && !Ee ? le[ce] = x(R.image[ce], !1, !0, u) : le[ce] = Ee ? R.image[ce].image : R.image[ce], le[ce] = Ue(R, le[ce]);
            let Je = le[0], ke = S(Je) || a, Be = s.convert(R.format, R.encoding), qe = s.convert(R.type), et = b(R.internalFormat, Be, qe, R.encoding), Dt = a && R.isVideoTexture !== !0, yr = De.__version === void 0 || ue === !0, ti = T(R, Je, ke);
            G(34067, R, ke);
            let Q;
            if (Me) {
                Dt && yr && e.texStorage2D(34067, ti, et, Je.width, Je.height);
                for(let ce = 0; ce < 6; ce++){
                    Q = le[ce].mipmaps;
                    for(let ve = 0; ve < Q.length; ve++){
                        let ze = Q[ve];
                        R.format !== Fr ? Be !== null ? Dt ? e.compressedTexSubImage2D(34069 + ce, ve, 0, 0, ze.width, ze.height, Be, ze.data) : e.compressedTexImage2D(34069 + ce, ve, et, ze.width, ze.height, 0, ze.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Dt ? e.texSubImage2D(34069 + ce, ve, 0, 0, ze.width, ze.height, Be, qe, ze.data) : e.texImage2D(34069 + ce, ve, et, ze.width, ze.height, 0, Be, qe, ze.data);
                    }
                }
            } else {
                Q = R.mipmaps, Dt && yr && (Q.length > 0 && ti++, e.texStorage2D(34067, ti, et, le[0].width, le[0].height));
                for(let ce = 0; ce < 6; ce++)if (Ee) {
                    Dt ? e.texSubImage2D(34069 + ce, 0, 0, 0, le[ce].width, le[ce].height, Be, qe, le[ce].data) : e.texImage2D(34069 + ce, 0, et, le[ce].width, le[ce].height, 0, Be, qe, le[ce].data);
                    for(let ve = 0; ve < Q.length; ve++){
                        let Fe = Q[ve].image[ce].image;
                        Dt ? e.texSubImage2D(34069 + ce, ve + 1, 0, 0, Fe.width, Fe.height, Be, qe, Fe.data) : e.texImage2D(34069 + ce, ve + 1, et, Fe.width, Fe.height, 0, Be, qe, Fe.data);
                    }
                } else {
                    Dt ? e.texSubImage2D(34069 + ce, 0, 0, 0, Be, qe, le[ce]) : e.texImage2D(34069 + ce, 0, et, Be, qe, le[ce]);
                    for(let ve = 0; ve < Q.length; ve++){
                        let ze = Q[ve];
                        Dt ? e.texSubImage2D(34069 + ce, ve + 1, 0, 0, Be, qe, ze.image[ce]) : e.texImage2D(34069 + ce, ve + 1, et, Be, qe, ze.image[ce]);
                    }
                }
            }
            A(R, ke) && E(34067), De.__version = me.version, R.onUpdate && R.onUpdate(R);
        }
        L.__version = R.version;
    }
    function Y(L, R, ie, ue, me) {
        let De = s.convert(ie.format, ie.encoding), Me = s.convert(ie.type), Ee = b(ie.internalFormat, De, Me, ie.encoding);
        r.get(R).__hasExternalTextures || (me === 32879 || me === 35866 ? e.texImage3D(me, 0, Ee, R.width, R.height, R.depth, 0, De, Me, null) : e.texImage2D(me, 0, Ee, R.width, R.height, 0, De, Me, null)), e.bindFramebuffer(36160, L), Te(R) ? h.framebufferTexture2DMultisampleEXT(36160, ue, me, r.get(ie).__webglTexture, 0, Pe(R)) : (me === 3553 || me >= 34069 && me <= 34074) && n1.framebufferTexture2D(36160, ue, me, r.get(ie).__webglTexture, 0), e.bindFramebuffer(36160, null);
    }
    function ye(L, R, ie) {
        if (n1.bindRenderbuffer(36161, L), R.depthBuffer && !R.stencilBuffer) {
            let ue = 33189;
            if (ie || Te(R)) {
                let me = R.depthTexture;
                me && me.isDepthTexture && (me.type === dr ? ue = 36012 : me.type === Ds && (ue = 33190));
                let De = Pe(R);
                Te(R) ? h.renderbufferStorageMultisampleEXT(36161, De, ue, R.width, R.height) : n1.renderbufferStorageMultisample(36161, De, ue, R.width, R.height);
            } else n1.renderbufferStorage(36161, ue, R.width, R.height);
            n1.framebufferRenderbuffer(36160, 36096, 36161, L);
        } else if (R.depthBuffer && R.stencilBuffer) {
            let ue = Pe(R);
            ie && Te(R) === !1 ? n1.renderbufferStorageMultisample(36161, ue, 35056, R.width, R.height) : Te(R) ? h.renderbufferStorageMultisampleEXT(36161, ue, 35056, R.width, R.height) : n1.renderbufferStorage(36161, 34041, R.width, R.height), n1.framebufferRenderbuffer(36160, 33306, 36161, L);
        } else {
            let ue = R.isWebGLMultipleRenderTargets === !0 ? R.texture : [
                R.texture
            ];
            for(let me = 0; me < ue.length; me++){
                let De = ue[me], Me = s.convert(De.format, De.encoding), Ee = s.convert(De.type), le = b(De.internalFormat, Me, Ee, De.encoding), Je = Pe(R);
                ie && Te(R) === !1 ? n1.renderbufferStorageMultisample(36161, Je, le, R.width, R.height) : Te(R) ? h.renderbufferStorageMultisampleEXT(36161, Je, le, R.width, R.height) : n1.renderbufferStorage(36161, le, R.width, R.height);
            }
        }
        n1.bindRenderbuffer(36161, null);
    }
    function fe(L, R) {
        if (R && R.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (e.bindFramebuffer(36160, L), !(R.depthTexture && R.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        (!r.get(R.depthTexture).__webglTexture || R.depthTexture.image.width !== R.width || R.depthTexture.image.height !== R.height) && (R.depthTexture.image.width = R.width, R.depthTexture.image.height = R.height, R.depthTexture.needsUpdate = !0), j(R.depthTexture, 0);
        let ue = r.get(R.depthTexture).__webglTexture, me = Pe(R);
        if (R.depthTexture.format === cc) Te(R) ? h.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, ue, 0, me) : n1.framebufferTexture2D(36160, 36096, 3553, ue, 0);
        else if (R.depthTexture.format === Ka) Te(R) ? h.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, ue, 0, me) : n1.framebufferTexture2D(36160, 33306, 3553, ue, 0);
        else throw new Error("Unknown depthTexture format");
    }
    function oe(L) {
        let R = r.get(L), ie = L.isWebGLCubeRenderTarget === !0;
        if (L.depthTexture && !R.__autoAllocateDepthBuffer) {
            if (ie) throw new Error("target.depthTexture not supported in Cube render targets");
            fe(R.__webglFramebuffer, L);
        } else if (ie) {
            R.__webglDepthbuffer = [];
            for(let ue = 0; ue < 6; ue++)e.bindFramebuffer(36160, R.__webglFramebuffer[ue]), R.__webglDepthbuffer[ue] = n1.createRenderbuffer(), ye(R.__webglDepthbuffer[ue], L, !1);
        } else e.bindFramebuffer(36160, R.__webglFramebuffer), R.__webglDepthbuffer = n1.createRenderbuffer(), ye(R.__webglDepthbuffer, L, !1);
        e.bindFramebuffer(36160, null);
    }
    function _e(L, R, ie) {
        let ue = r.get(L);
        R !== void 0 && Y(ue.__webglFramebuffer, L, L.texture, 36064, 3553), ie !== void 0 && oe(L);
    }
    function xe(L) {
        let R = L.texture, ie = r.get(L), ue = r.get(R);
        L.addEventListener("dispose", P), L.isWebGLMultipleRenderTargets !== !0 && (ue.__webglTexture === void 0 && (ue.__webglTexture = n1.createTexture()), ue.__version = R.version, o.memory.textures++);
        let me = L.isWebGLCubeRenderTarget === !0, De = L.isWebGLMultipleRenderTargets === !0, Me = S(L) || a;
        if (me) {
            ie.__webglFramebuffer = [];
            for(let Ee = 0; Ee < 6; Ee++)ie.__webglFramebuffer[Ee] = n1.createFramebuffer();
        } else {
            if (ie.__webglFramebuffer = n1.createFramebuffer(), De) {
                if (i.drawBuffers) {
                    let Ee = L.texture;
                    for(let le = 0, Je = Ee.length; le < Je; le++){
                        let ke = r.get(Ee[le]);
                        ke.__webglTexture === void 0 && (ke.__webglTexture = n1.createTexture(), o.memory.textures++);
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (a && L.samples > 0 && Te(L) === !1) {
                let Ee = De ? R : [
                    R
                ];
                ie.__webglMultisampledFramebuffer = n1.createFramebuffer(), ie.__webglColorRenderbuffer = [], e.bindFramebuffer(36160, ie.__webglMultisampledFramebuffer);
                for(let le = 0; le < Ee.length; le++){
                    let Je = Ee[le];
                    ie.__webglColorRenderbuffer[le] = n1.createRenderbuffer(), n1.bindRenderbuffer(36161, ie.__webglColorRenderbuffer[le]);
                    let ke = s.convert(Je.format, Je.encoding), Be = s.convert(Je.type), qe = b(Je.internalFormat, ke, Be, Je.encoding, L.isXRRenderTarget === !0), et = Pe(L);
                    n1.renderbufferStorageMultisample(36161, et, qe, L.width, L.height), n1.framebufferRenderbuffer(36160, 36064 + le, 36161, ie.__webglColorRenderbuffer[le]);
                }
                n1.bindRenderbuffer(36161, null), L.depthBuffer && (ie.__webglDepthRenderbuffer = n1.createRenderbuffer(), ye(ie.__webglDepthRenderbuffer, L, !0)), e.bindFramebuffer(36160, null);
            }
        }
        if (me) {
            e.bindTexture(34067, ue.__webglTexture), G(34067, R, Me);
            for(let Ee = 0; Ee < 6; Ee++)Y(ie.__webglFramebuffer[Ee], L, R, 36064, 34069 + Ee);
            A(R, Me) && E(34067), e.unbindTexture();
        } else if (De) {
            let Ee = L.texture;
            for(let le = 0, Je = Ee.length; le < Je; le++){
                let ke = Ee[le], Be = r.get(ke);
                e.bindTexture(3553, Be.__webglTexture), G(3553, ke, Me), Y(ie.__webglFramebuffer, L, ke, 36064 + le, 3553), A(ke, Me) && E(3553);
            }
            e.unbindTexture();
        } else {
            let Ee = 3553;
            (L.isWebGL3DRenderTarget || L.isWebGLArrayRenderTarget) && (a ? Ee = L.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), e.bindTexture(Ee, ue.__webglTexture), G(Ee, R, Me), Y(ie.__webglFramebuffer, L, R, 36064, Ee), A(R, Me) && E(Ee), e.unbindTexture();
        }
        L.depthBuffer && oe(L);
    }
    function Ie(L) {
        let R = S(L) || a, ie = L.isWebGLMultipleRenderTargets === !0 ? L.texture : [
            L.texture
        ];
        for(let ue = 0, me = ie.length; ue < me; ue++){
            let De = ie[ue];
            if (A(De, R)) {
                let Me = L.isWebGLCubeRenderTarget ? 34067 : 3553, Ee = r.get(De).__webglTexture;
                e.bindTexture(Me, Ee), E(Me), e.unbindTexture();
            }
        }
    }
    function Oe(L) {
        if (a && L.samples > 0 && Te(L) === !1) {
            let R = L.isWebGLMultipleRenderTargets ? L.texture : [
                L.texture
            ], ie = L.width, ue = L.height, me = 16384, De = [], Me = L.stencilBuffer ? 33306 : 36096, Ee = r.get(L), le = L.isWebGLMultipleRenderTargets === !0;
            if (le) for(let Je = 0; Je < R.length; Je++)e.bindFramebuffer(36160, Ee.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + Je, 36161, null), e.bindFramebuffer(36160, Ee.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + Je, 3553, null, 0);
            e.bindFramebuffer(36008, Ee.__webglMultisampledFramebuffer), e.bindFramebuffer(36009, Ee.__webglFramebuffer);
            for(let Je = 0; Je < R.length; Je++){
                De.push(36064 + Je), L.depthBuffer && De.push(Me);
                let ke = Ee.__ignoreDepthValues !== void 0 ? Ee.__ignoreDepthValues : !1;
                if (ke === !1 && (L.depthBuffer && (me |= 256), L.stencilBuffer && (me |= 1024)), le && n1.framebufferRenderbuffer(36008, 36064, 36161, Ee.__webglColorRenderbuffer[Je]), ke === !0 && (n1.invalidateFramebuffer(36008, [
                    Me
                ]), n1.invalidateFramebuffer(36009, [
                    Me
                ])), le) {
                    let Be = r.get(R[Je]).__webglTexture;
                    n1.framebufferTexture2D(36009, 36064, 3553, Be, 0);
                }
                n1.blitFramebuffer(0, 0, ie, ue, 0, 0, ie, ue, me, 9728), f && n1.invalidateFramebuffer(36008, De);
            }
            if (e.bindFramebuffer(36008, null), e.bindFramebuffer(36009, null), le) for(let Je = 0; Je < R.length; Je++){
                e.bindFramebuffer(36160, Ee.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + Je, 36161, Ee.__webglColorRenderbuffer[Je]);
                let ke = r.get(R[Je]).__webglTexture;
                e.bindFramebuffer(36160, Ee.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + Je, 3553, ke, 0);
            }
            e.bindFramebuffer(36009, Ee.__webglMultisampledFramebuffer);
        }
    }
    function Pe(L) {
        return Math.min(d, L.samples);
    }
    function Te(L) {
        let R = r.get(L);
        return a && L.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && R.__useRenderToTexture !== !1;
    }
    function Ve(L) {
        let R = o.render.frame;
        p.get(L) !== R && (p.set(L, R), L.update());
    }
    function Ue(L, R) {
        let ie = L.encoding, ue = L.format, me = L.type;
        return L.isCompressedTexture === !0 || L.isVideoTexture === !0 || L.format === MS || ie !== dn && (ie === tt ? a === !1 ? t.has("EXT_sRGB") === !0 && ue === Fr ? (L.format = MS, L.minFilter = Qe, L.generateMipmaps = !1) : R = ty.sRGBToLinear(R) : (ue !== Fr || me !== br) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", ie)), R;
    }
    this.allocateTextureUnit = V, this.resetTextureUnits = B, this.setTexture2D = j, this.setTexture2DArray = W, this.setTexture3D = k, this.setTextureCube = H, this.rebindTextures = _e, this.setupRenderTarget = xe, this.updateRenderTargetMipmap = Ie, this.updateMultisampleRenderTarget = Oe, this.setupDepthRenderbuffer = oe, this.setupFrameBufferTexture = Y, this.useMultisampledRTT = Te;
}
function EG(n1, t, e) {
    let r = e.isWebGL2;
    function i(s, o = null) {
        let a;
        if (s === br) return 5121;
        if (s === vF) return 32819;
        if (s === xF) return 32820;
        if (s === mF) return 5120;
        if (s === gF) return 5122;
        if (s === TM) return 5123;
        if (s === yF) return 5124;
        if (s === Ds) return 5125;
        if (s === dr) return 5126;
        if (s === sa) return r ? 5131 : (a = t.get("OES_texture_half_float"), a !== null ? a.HALF_FLOAT_OES : null);
        if (s === bF) return 6406;
        if (s === Fr) return 6408;
        if (s === SF) return 6409;
        if (s === wF) return 6410;
        if (s === cc) return 6402;
        if (s === Ka) return 34041;
        if (s === MS) return a = t.get("EXT_sRGB"), a !== null ? a.SRGB_ALPHA_EXT : null;
        if (s === AF) return 6403;
        if (s === _F) return 36244;
        if (s === Ku) return 33319;
        if (s === EF) return 33320;
        if (s === nw) return 36249;
        if (s === Vb || s === Ub || s === Gb || s === jb) {
            if (o === tt) {
                if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), a !== null) {
                    if (s === Vb) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (s === Ub) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (s === Gb) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (s === jb) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (a = t.get("WEBGL_compressed_texture_s3tc"), a !== null) {
                if (s === Vb) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (s === Ub) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (s === Gb) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (s === jb) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (s === ZE || s === JE || s === $E || s === eT) {
            if (a = t.get("WEBGL_compressed_texture_pvrtc"), a !== null) {
                if (s === ZE) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (s === JE) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (s === $E) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (s === eT) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (s === TF) return a = t.get("WEBGL_compressed_texture_etc1"), a !== null ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
        if (s === tT || s === rT) {
            if (a = t.get("WEBGL_compressed_texture_etc"), a !== null) {
                if (s === tT) return o === tt ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (s === rT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (s === iT || s === nT || s === sT || s === oT || s === aT || s === lT || s === cT || s === uT || s === dT || s === hT || s === fT || s === pT || s === mT || s === gT) {
            if (a = t.get("WEBGL_compressed_texture_astc"), a !== null) {
                if (s === iT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (s === nT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (s === sT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (s === oT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (s === aT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (s === lT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (s === cT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (s === uT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (s === dT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (s === hT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (s === fT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (s === pT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (s === mT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (s === gT) return o === tt ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (s === Hb) {
            if (a = t.get("EXT_texture_compression_bptc"), a !== null) {
                if (s === Hb) return o === tt ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        if (s === MF || s === yT || s === vT || s === xT) {
            if (a = t.get("EXT_texture_compression_rgtc"), a !== null) {
                if (s === Hb) return a.COMPRESSED_RED_RGTC1_EXT;
                if (s === yT) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (s === vT) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (s === xT) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return s === Ya ? r ? 34042 : (a = t.get("WEBGL_depth_texture"), a !== null ? a.UNSIGNED_INT_24_8_WEBGL : null) : n1[s] !== void 0 ? n1[s] : null;
    }
    return {
        convert: i
    };
}
var kS = class extends Wr {
    constructor(t = []){
        super(), this.isArrayCamera = !0, this.cameras = t;
    }
}, ts = class extends mt {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}, TG = {
    type: "move"
}, np = class {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return this._hand === null && (this._hand = new ts, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new ts, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new _, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new _), this._targetRay;
    }
    getGripSpace() {
        return this._grip === null && (this._grip = new ts, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new _, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new _), this._grip;
    }
    dispatchEvent(t) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(t), this._grip !== null && this._grip.dispatchEvent(t), this._hand !== null && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
        if (t && t.hand) {
            let e = this._hand;
            if (e) for (let r of t.hand.values())this._getHandJoint(e, r);
        }
        return this.dispatchEvent({
            type: "connected",
            data: t
        }), this;
    }
    disconnect(t) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    update(t, e, r) {
        let i = null, s = null, o = null, a = this._targetRay, l = this._grip, u = this._hand;
        if (t && e.session.visibilityState !== "visible-blurred") {
            if (u && t.hand) {
                o = !0;
                for (let m of t.hand.values()){
                    let g = e.getJointPose(m, r), y = this._getHandJoint(u, m);
                    g !== null && (y.matrix.fromArray(g.transform.matrix), y.matrix.decompose(y.position, y.rotation, y.scale), y.jointRadius = g.radius), y.visible = g !== null;
                }
                let c = u.joints["index-finger-tip"], d = u.joints["thumb-tip"], h = c.position.distanceTo(d.position), f = .02, p = .005;
                u.inputState.pinching && h > f + p ? (u.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t.handedness,
                    target: this
                })) : !u.inputState.pinching && h <= f - p && (u.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t.handedness,
                    target: this
                }));
            } else l !== null && t.gripSpace && (s = e.getPose(t.gripSpace, r), s !== null && (l.matrix.fromArray(s.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), s.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s.linearVelocity)) : l.hasLinearVelocity = !1, s.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s.angularVelocity)) : l.hasAngularVelocity = !1));
            a !== null && (i = e.getPose(t.targetRaySpace, r), i === null && s !== null && (i = s), i !== null && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(TG)));
        }
        return a !== null && (a.visible = i !== null), l !== null && (l.visible = s !== null), u !== null && (u.visible = o !== null), this;
    }
    _getHandJoint(t, e) {
        if (t.joints[e.jointName] === void 0) {
            let r = new ts;
            r.matrixAutoUpdate = !1, r.visible = !1, t.joints[e.jointName] = r, t.add(r);
        }
        return t.joints[e.jointName];
    }
}, is = class extends qt {
    constructor(t, e, r, i, s, o, a, l, u, c){
        if (c = c !== void 0 ? c : cc, c !== cc && c !== Ka) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        r === void 0 && c === cc && (r = Ds), r === void 0 && c === Ka && (r = Ya), super(null, i, s, o, a, l, c, r, u), this.isDepthTexture = !0, this.image = {
            width: t,
            height: e
        }, this.magFilter = a !== void 0 ? a : Et, this.minFilter = l !== void 0 ? l : Et, this.flipY = !1, this.generateMipmaps = !1;
    }
}, zS = class extends ir {
    constructor(t, e){
        super();
        let r = this, i = null, s = 1, o = null, a = "local-floor", l = 1, u = null, c = null, d = null, h = null, f = null, p = null, m = e.getContextAttributes(), g = null, y = null, v = [], x = [], S = new Set, w = new Map, A = new Wr;
        A.layers.enable(1), A.viewport = new He;
        let E = new Wr;
        E.layers.enable(2), E.viewport = new He;
        let b = [
            A,
            E
        ], T = new kS;
        T.layers.enable(1), T.layers.enable(2);
        let M = null, C = null;
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(k) {
            let H = v[k];
            return H === void 0 && (H = new np, v[k] = H), H.getTargetRaySpace();
        }, this.getControllerGrip = function(k) {
            let H = v[k];
            return H === void 0 && (H = new np, v[k] = H), H.getGripSpace();
        }, this.getHand = function(k) {
            let H = v[k];
            return H === void 0 && (H = new np, v[k] = H), H.getHandSpace();
        };
        function P(k) {
            let H = x.indexOf(k.inputSource);
            if (H === -1) return;
            let X = v[H];
            X !== void 0 && X.dispatchEvent({
                type: k.type,
                data: k.inputSource
            });
        }
        function D() {
            i.removeEventListener("select", P), i.removeEventListener("selectstart", P), i.removeEventListener("selectend", P), i.removeEventListener("squeeze", P), i.removeEventListener("squeezestart", P), i.removeEventListener("squeezeend", P), i.removeEventListener("end", D), i.removeEventListener("inputsourceschange", O);
            for(let k = 0; k < v.length; k++){
                let H = x[k];
                H !== null && (x[k] = null, v[k].disconnect(H));
            }
            M = null, C = null, t.setRenderTarget(g), f = null, h = null, d = null, i = null, y = null, W.stop(), r.isPresenting = !1, r.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(k) {
            s = k, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(k) {
            a = k, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return u || o;
        }, this.setReferenceSpace = function(k) {
            u = k;
        }, this.getBaseLayer = function() {
            return h !== null ? h : f;
        }, this.getBinding = function() {
            return d;
        }, this.getFrame = function() {
            return p;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(k) {
            if (i = k, i !== null) {
                if (g = t.getRenderTarget(), i.addEventListener("select", P), i.addEventListener("selectstart", P), i.addEventListener("selectend", P), i.addEventListener("squeeze", P), i.addEventListener("squeezestart", P), i.addEventListener("squeezeend", P), i.addEventListener("end", D), i.addEventListener("inputsourceschange", O), m.xrCompatible !== !0 && await e.makeXRCompatible(), i.renderState.layers === void 0 || t.capabilities.isWebGL2 === !1) {
                    let H = {
                        antialias: i.renderState.layers === void 0 ? m.antialias : !0,
                        alpha: m.alpha,
                        depth: m.depth,
                        stencil: m.stencil,
                        framebufferScaleFactor: s
                    };
                    f = new XRWebGLLayer(i, e, H), i.updateRenderState({
                        baseLayer: f
                    }), y = new at(f.framebufferWidth, f.framebufferHeight, {
                        format: Fr,
                        type: br,
                        encoding: t.outputEncoding,
                        stencilBuffer: m.stencil
                    });
                } else {
                    let H = null, X = null, q = null;
                    m.depth && (q = m.stencil ? 35056 : 33190, H = m.stencil ? Ka : cc, X = m.stencil ? Ya : Ds);
                    let G = {
                        colorFormat: 32856,
                        depthFormat: q,
                        scaleFactor: s
                    };
                    d = new XRWebGLBinding(i, e), h = d.createProjectionLayer(G), i.updateRenderState({
                        layers: [
                            h
                        ]
                    }), y = new at(h.textureWidth, h.textureHeight, {
                        format: Fr,
                        type: br,
                        depthTexture: new is(h.textureWidth, h.textureHeight, X, void 0, void 0, void 0, void 0, void 0, void 0, H),
                        stencilBuffer: m.stencil,
                        encoding: t.outputEncoding,
                        samples: m.antialias ? 4 : 0
                    });
                    let J = t.properties.get(y);
                    J.__ignoreDepthValues = h.ignoreDepthValues;
                }
                y.isXRRenderTarget = !0, this.setFoveation(l), u = null, o = await i.requestReferenceSpace(a), W.setContext(i), W.start(), r.isPresenting = !0, r.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function O(k) {
            for(let H = 0; H < k.removed.length; H++){
                let X = k.removed[H], q = x.indexOf(X);
                q >= 0 && (x[q] = null, v[q].disconnect(X));
            }
            for(let H = 0; H < k.added.length; H++){
                let X = k.added[H], q = x.indexOf(X);
                if (q === -1) {
                    for(let J = 0; J < v.length; J++)if (J >= x.length) {
                        x.push(X), q = J;
                        break;
                    } else if (x[J] === null) {
                        x[J] = X, q = J;
                        break;
                    }
                    if (q === -1) break;
                }
                let G = v[q];
                G && G.connect(X);
            }
        }
        let I = new _, z = new _;
        function B(k, H, X) {
            I.setFromMatrixPosition(H.matrixWorld), z.setFromMatrixPosition(X.matrixWorld);
            let q = I.distanceTo(z), G = H.projectionMatrix.elements, J = X.projectionMatrix.elements, Z = G[14] / (G[10] - 1), K = G[14] / (G[10] + 1), Y = (G[9] + 1) / G[5], ye = (G[9] - 1) / G[5], fe = (G[8] - 1) / G[0], oe = (J[8] + 1) / J[0], _e = Z * fe, xe = Z * oe, Ie = q / (-fe + oe), Oe = Ie * -fe;
            H.matrixWorld.decompose(k.position, k.quaternion, k.scale), k.translateX(Oe), k.translateZ(Ie), k.matrixWorld.compose(k.position, k.quaternion, k.scale), k.matrixWorldInverse.copy(k.matrixWorld).invert();
            let Pe = Z + Ie, Te = K + Ie, Ve = _e - Oe, Ue = xe + (q - Oe), L = Y * K / Te * Pe, R = ye * K / Te * Pe;
            k.projectionMatrix.makePerspective(Ve, Ue, L, R, Pe, Te);
        }
        function V(k, H) {
            H === null ? k.matrixWorld.copy(k.matrix) : k.matrixWorld.multiplyMatrices(H.matrixWorld, k.matrix), k.matrixWorldInverse.copy(k.matrixWorld).invert();
        }
        this.updateCamera = function(k) {
            if (i === null) return;
            T.near = E.near = A.near = k.near, T.far = E.far = A.far = k.far, (M !== T.near || C !== T.far) && (i.updateRenderState({
                depthNear: T.near,
                depthFar: T.far
            }), M = T.near, C = T.far);
            let H = k.parent, X = T.cameras;
            V(T, H);
            for(let G = 0; G < X.length; G++)V(X[G], H);
            T.matrixWorld.decompose(T.position, T.quaternion, T.scale), k.matrix.copy(T.matrix), k.matrix.decompose(k.position, k.quaternion, k.scale);
            let q = k.children;
            for(let G = 0, J = q.length; G < J; G++)q[G].updateMatrixWorld(!0);
            X.length === 2 ? B(T, A, E) : T.projectionMatrix.copy(A.projectionMatrix);
        }, this.getCamera = function() {
            return T;
        }, this.getFoveation = function() {
            if (!(h === null && f === null)) return l;
        }, this.setFoveation = function(k) {
            l = k, h !== null && (h.fixedFoveation = k), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = k);
        }, this.getPlanes = function() {
            return S;
        };
        let U = null;
        function j(k, H) {
            if (c = H.getViewerPose(u || o), p = H, c !== null) {
                let X = c.views;
                f !== null && (t.setRenderTargetFramebuffer(y, f.framebuffer), t.setRenderTarget(y));
                let q = !1;
                X.length !== T.cameras.length && (T.cameras.length = 0, q = !0);
                for(let G = 0; G < X.length; G++){
                    let J = X[G], Z = null;
                    if (f !== null) Z = f.getViewport(J);
                    else {
                        let Y = d.getViewSubImage(h, J);
                        Z = Y.viewport, G === 0 && (t.setRenderTargetTextures(y, Y.colorTexture, h.ignoreDepthValues ? void 0 : Y.depthStencilTexture), t.setRenderTarget(y));
                    }
                    let K = b[G];
                    K === void 0 && (K = new Wr, K.layers.enable(G), K.viewport = new He, b[G] = K), K.matrix.fromArray(J.transform.matrix), K.projectionMatrix.fromArray(J.projectionMatrix), K.viewport.set(Z.x, Z.y, Z.width, Z.height), G === 0 && T.matrix.copy(K.matrix), q === !0 && T.cameras.push(K);
                }
            }
            for(let X = 0; X < v.length; X++){
                let q = x[X], G = v[X];
                q !== null && G !== void 0 && G.update(q, H, u || o);
            }
            if (U && U(k, H), H.detectedPlanes) {
                r.dispatchEvent({
                    type: "planesdetected",
                    data: H.detectedPlanes
                });
                let X = null;
                for (let q of S)H.detectedPlanes.has(q) || (X === null && (X = []), X.push(q));
                if (X !== null) for (let q of X)S.delete(q), w.delete(q), r.dispatchEvent({
                    type: "planeremoved",
                    data: q
                });
                for (let q of H.detectedPlanes)if (!S.has(q)) S.add(q), w.set(q, H.lastChangedTime), r.dispatchEvent({
                    type: "planeadded",
                    data: q
                });
                else {
                    let G = w.get(q);
                    q.lastChangedTime > G && (w.set(q, q.lastChangedTime), r.dispatchEvent({
                        type: "planechanged",
                        data: q
                    }));
                }
            }
            p = null;
        }
        let W = new IM;
        W.setAnimationLoop(j), this.setAnimationLoop = function(k) {
            U = k;
        }, this.dispose = function() {};
    }
};
function MG(n1, t) {
    function e(m, g) {
        g.color.getRGB(m.fogColor.value, OM(n1)), g.isFog ? (m.fogNear.value = g.near, m.fogFar.value = g.far) : g.isFogExp2 && (m.fogDensity.value = g.density);
    }
    function r(m, g, y, v, x) {
        g.isMeshBasicMaterial || g.isMeshLambertMaterial ? i(m, g) : g.isMeshToonMaterial ? (i(m, g), c(m, g)) : g.isMeshPhongMaterial ? (i(m, g), u(m, g)) : g.isMeshStandardMaterial ? (i(m, g), d(m, g), g.isMeshPhysicalMaterial && h(m, g, x)) : g.isMeshMatcapMaterial ? (i(m, g), f(m, g)) : g.isMeshDepthMaterial ? i(m, g) : g.isMeshDistanceMaterial ? (i(m, g), p(m, g)) : g.isMeshNormalMaterial ? i(m, g) : g.isLineBasicMaterial ? (s(m, g), g.isLineDashedMaterial && o(m, g)) : g.isPointsMaterial ? a(m, g, y, v) : g.isSpriteMaterial ? l(m, g) : g.isShadowMaterial ? (m.color.value.copy(g.color), m.opacity.value = g.opacity) : g.isShaderMaterial && (g.uniformsNeedUpdate = !1);
    }
    function i(m, g) {
        m.opacity.value = g.opacity, g.color && m.diffuse.value.copy(g.color), g.emissive && m.emissive.value.copy(g.emissive).multiplyScalar(g.emissiveIntensity), g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.bumpMap && (m.bumpMap.value = g.bumpMap, m.bumpScale.value = g.bumpScale, g.side === ai && (m.bumpScale.value *= -1)), g.displacementMap && (m.displacementMap.value = g.displacementMap, m.displacementScale.value = g.displacementScale, m.displacementBias.value = g.displacementBias), g.emissiveMap && (m.emissiveMap.value = g.emissiveMap), g.normalMap && (m.normalMap.value = g.normalMap, m.normalScale.value.copy(g.normalScale), g.side === ai && m.normalScale.value.negate()), g.specularMap && (m.specularMap.value = g.specularMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let y = t.get(g).envMap;
        if (y && (m.envMap.value = y, m.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = g.reflectivity, m.ior.value = g.ior, m.refractionRatio.value = g.refractionRatio), g.lightMap) {
            m.lightMap.value = g.lightMap;
            let S = n1.physicallyCorrectLights !== !0 ? Math.PI : 1;
            m.lightMapIntensity.value = g.lightMapIntensity * S;
        }
        g.aoMap && (m.aoMap.value = g.aoMap, m.aoMapIntensity.value = g.aoMapIntensity);
        let v;
        g.map ? v = g.map : g.specularMap ? v = g.specularMap : g.displacementMap ? v = g.displacementMap : g.normalMap ? v = g.normalMap : g.bumpMap ? v = g.bumpMap : g.roughnessMap ? v = g.roughnessMap : g.metalnessMap ? v = g.metalnessMap : g.alphaMap ? v = g.alphaMap : g.emissiveMap ? v = g.emissiveMap : g.clearcoatMap ? v = g.clearcoatMap : g.clearcoatNormalMap ? v = g.clearcoatNormalMap : g.clearcoatRoughnessMap ? v = g.clearcoatRoughnessMap : g.iridescenceMap ? v = g.iridescenceMap : g.iridescenceThicknessMap ? v = g.iridescenceThicknessMap : g.specularIntensityMap ? v = g.specularIntensityMap : g.specularColorMap ? v = g.specularColorMap : g.transmissionMap ? v = g.transmissionMap : g.thicknessMap ? v = g.thicknessMap : g.sheenColorMap ? v = g.sheenColorMap : g.sheenRoughnessMap && (v = g.sheenRoughnessMap), v !== void 0 && (v.isWebGLRenderTarget && (v = v.texture), v.matrixAutoUpdate === !0 && v.updateMatrix(), m.uvTransform.value.copy(v.matrix));
        let x;
        g.aoMap ? x = g.aoMap : g.lightMap && (x = g.lightMap), x !== void 0 && (x.isWebGLRenderTarget && (x = x.texture), x.matrixAutoUpdate === !0 && x.updateMatrix(), m.uv2Transform.value.copy(x.matrix));
    }
    function s(m, g) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity;
    }
    function o(m, g) {
        m.dashSize.value = g.dashSize, m.totalSize.value = g.dashSize + g.gapSize, m.scale.value = g.scale;
    }
    function a(m, g, y, v) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.size.value = g.size * y, m.scale.value = v * .5, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let x;
        g.map ? x = g.map : g.alphaMap && (x = g.alphaMap), x !== void 0 && (x.matrixAutoUpdate === !0 && x.updateMatrix(), m.uvTransform.value.copy(x.matrix));
    }
    function l(m, g) {
        m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.rotation.value = g.rotation, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
        let y;
        g.map ? y = g.map : g.alphaMap && (y = g.alphaMap), y !== void 0 && (y.matrixAutoUpdate === !0 && y.updateMatrix(), m.uvTransform.value.copy(y.matrix));
    }
    function u(m, g) {
        m.specular.value.copy(g.specular), m.shininess.value = Math.max(g.shininess, 1e-4);
    }
    function c(m, g) {
        g.gradientMap && (m.gradientMap.value = g.gradientMap);
    }
    function d(m, g) {
        m.roughness.value = g.roughness, m.metalness.value = g.metalness, g.roughnessMap && (m.roughnessMap.value = g.roughnessMap), g.metalnessMap && (m.metalnessMap.value = g.metalnessMap), t.get(g).envMap && (m.envMapIntensity.value = g.envMapIntensity);
    }
    function h(m, g, y) {
        m.ior.value = g.ior, g.sheen > 0 && (m.sheenColor.value.copy(g.sheenColor).multiplyScalar(g.sheen), m.sheenRoughness.value = g.sheenRoughness, g.sheenColorMap && (m.sheenColorMap.value = g.sheenColorMap), g.sheenRoughnessMap && (m.sheenRoughnessMap.value = g.sheenRoughnessMap)), g.clearcoat > 0 && (m.clearcoat.value = g.clearcoat, m.clearcoatRoughness.value = g.clearcoatRoughness, g.clearcoatMap && (m.clearcoatMap.value = g.clearcoatMap), g.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = g.clearcoatRoughnessMap), g.clearcoatNormalMap && (m.clearcoatNormalScale.value.copy(g.clearcoatNormalScale), m.clearcoatNormalMap.value = g.clearcoatNormalMap, g.side === ai && m.clearcoatNormalScale.value.negate())), g.iridescence > 0 && (m.iridescence.value = g.iridescence, m.iridescenceIOR.value = g.iridescenceIOR, m.iridescenceThicknessMinimum.value = g.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = g.iridescenceThicknessRange[1], g.iridescenceMap && (m.iridescenceMap.value = g.iridescenceMap), g.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = g.iridescenceThicknessMap)), g.transmission > 0 && (m.transmission.value = g.transmission, m.transmissionSamplerMap.value = y.texture, m.transmissionSamplerSize.value.set(y.width, y.height), g.transmissionMap && (m.transmissionMap.value = g.transmissionMap), m.thickness.value = g.thickness, g.thicknessMap && (m.thicknessMap.value = g.thicknessMap), m.attenuationDistance.value = g.attenuationDistance, m.attenuationColor.value.copy(g.attenuationColor)), m.specularIntensity.value = g.specularIntensity, m.specularColor.value.copy(g.specularColor), g.specularIntensityMap && (m.specularIntensityMap.value = g.specularIntensityMap), g.specularColorMap && (m.specularColorMap.value = g.specularColorMap);
    }
    function f(m, g) {
        g.matcap && (m.matcap.value = g.matcap);
    }
    function p(m, g) {
        m.referencePosition.value.copy(g.referencePosition), m.nearDistance.value = g.nearDistance, m.farDistance.value = g.farDistance;
    }
    return {
        refreshFogUniforms: e,
        refreshMaterialUniforms: r
    };
}
function CG(n1, t, e, r) {
    let i = {}, s = {}, o = [], a = e.isWebGL2 ? n1.getParameter(35375) : 0;
    function l(v, x) {
        let S = x.program;
        r.uniformBlockBinding(v, S);
    }
    function u(v, x) {
        let S = i[v.id];
        S === void 0 && (p(v), S = c(v), i[v.id] = S, v.addEventListener("dispose", g));
        let w = x.program;
        r.updateUBOMapping(v, w);
        let A = t.render.frame;
        s[v.id] !== A && (h(v), s[v.id] = A);
    }
    function c(v) {
        let x = d();
        v.__bindingPointIndex = x;
        let S = n1.createBuffer(), w = v.__size, A = v.usage;
        return n1.bindBuffer(35345, S), n1.bufferData(35345, w, A), n1.bindBuffer(35345, null), n1.bindBufferBase(35345, x, S), S;
    }
    function d() {
        for(let v = 0; v < a; v++)if (o.indexOf(v) === -1) return o.push(v), v;
        return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function h(v) {
        let x = i[v.id], S = v.uniforms, w = v.__cache;
        n1.bindBuffer(35345, x);
        for(let A = 0, E = S.length; A < E; A++){
            let b = S[A];
            if (f(b, A, w) === !0) {
                let T = b.__offset, M = Array.isArray(b.value) ? b.value : [
                    b.value
                ], C = 0;
                for(let P = 0; P < M.length; P++){
                    let D = M[P], O = m(D);
                    typeof D == "number" ? (b.__data[0] = D, n1.bufferSubData(35345, T + C, b.__data)) : D.isMatrix3 ? (b.__data[0] = D.elements[0], b.__data[1] = D.elements[1], b.__data[2] = D.elements[2], b.__data[3] = D.elements[0], b.__data[4] = D.elements[3], b.__data[5] = D.elements[4], b.__data[6] = D.elements[5], b.__data[7] = D.elements[0], b.__data[8] = D.elements[6], b.__data[9] = D.elements[7], b.__data[10] = D.elements[8], b.__data[11] = D.elements[0]) : (D.toArray(b.__data, C), C += O.storage / Float32Array.BYTES_PER_ELEMENT);
                }
                n1.bufferSubData(35345, T, b.__data);
            }
        }
        n1.bindBuffer(35345, null);
    }
    function f(v, x, S) {
        let w = v.value;
        if (S[x] === void 0) {
            if (typeof w == "number") S[x] = w;
            else {
                let A = Array.isArray(w) ? w : [
                    w
                ], E = [];
                for(let b = 0; b < A.length; b++)E.push(A[b].clone());
                S[x] = E;
            }
            return !0;
        } else if (typeof w == "number") {
            if (S[x] !== w) return S[x] = w, !0;
        } else {
            let A = Array.isArray(S[x]) ? S[x] : [
                S[x]
            ], E = Array.isArray(w) ? w : [
                w
            ];
            for(let b = 0; b < A.length; b++){
                let T = A[b];
                if (T.equals(E[b]) === !1) return T.copy(E[b]), !0;
            }
        }
        return !1;
    }
    function p(v) {
        let x = v.uniforms, S = 0, w = 16, A = 0;
        for(let E = 0, b = x.length; E < b; E++){
            let T = x[E], M = {
                boundary: 0,
                storage: 0
            }, C = Array.isArray(T.value) ? T.value : [
                T.value
            ];
            for(let P = 0, D = C.length; P < D; P++){
                let O = C[P], I = m(O);
                M.boundary += I.boundary, M.storage += I.storage;
            }
            if (T.__data = new Float32Array(M.storage / Float32Array.BYTES_PER_ELEMENT), T.__offset = S, E > 0) {
                A = S % w;
                let P = w - A;
                A !== 0 && P - M.boundary < 0 && (S += w - A, T.__offset = S);
            }
            S += M.storage;
        }
        return A = S % w, A > 0 && (S += w - A), v.__size = S, v.__cache = {}, this;
    }
    function m(v) {
        let x = {
            boundary: 0,
            storage: 0
        };
        return typeof v == "number" ? (x.boundary = 4, x.storage = 4) : v.isVector2 ? (x.boundary = 8, x.storage = 8) : v.isVector3 || v.isColor ? (x.boundary = 16, x.storage = 12) : v.isVector4 ? (x.boundary = 16, x.storage = 16) : v.isMatrix3 ? (x.boundary = 48, x.storage = 48) : v.isMatrix4 ? (x.boundary = 64, x.storage = 64) : v.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", v), x;
    }
    function g(v) {
        let x = v.target;
        x.removeEventListener("dispose", g);
        let S = o.indexOf(x.__bindingPointIndex);
        o.splice(S, 1), n1.deleteBuffer(i[x.id]), delete i[x.id], delete s[x.id];
    }
    function y() {
        for(let v in i)n1.deleteBuffer(i[v]);
        o = [], i = {}, s = {};
    }
    return {
        bind: l,
        update: u,
        dispose: y
    };
}
function PG() {
    let n1 = cp("canvas");
    return n1.style.display = "block", n1;
}
function dw(n1 = {}) {
    this.isWebGLRenderer = !0;
    let t = n1.canvas !== void 0 ? n1.canvas : PG(), e = n1.context !== void 0 ? n1.context : null, r = n1.depth !== void 0 ? n1.depth : !0, i = n1.stencil !== void 0 ? n1.stencil : !0, s = n1.antialias !== void 0 ? n1.antialias : !1, o = n1.premultipliedAlpha !== void 0 ? n1.premultipliedAlpha : !0, a = n1.preserveDrawingBuffer !== void 0 ? n1.preserveDrawingBuffer : !1, l = n1.powerPreference !== void 0 ? n1.powerPreference : "default", u = n1.failIfMajorPerformanceCaveat !== void 0 ? n1.failIfMajorPerformanceCaveat : !1, c;
    e !== null ? c = e.getContextAttributes().alpha : c = n1.alpha !== void 0 ? n1.alpha : !1;
    let d = null, h = null, f = [], p = [];
    this.domElement = t, this.debug = {
        checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = dn, this.physicallyCorrectLights = !1, this.toneMapping = Os, this.toneMappingExposure = 1;
    let m = this, g = !1, y = 0, v = 0, x = null, S = -1, w = null, A = new He, E = new He, b = null, T = t.width, M = t.height, C = 1, P = null, D = null, O = new He(0, 0, T, M), I = new He(0, 0, T, M), z = !1, B = new dp, V = !1, U = !1, j = null, W = new te, k = new N, H = new _, X = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
    };
    function q() {
        return x === null ? C : 1;
    }
    let G = e;
    function J(F, re) {
        for(let de = 0; de < F.length; de++){
            let ee = F[de], pe = t.getContext(ee, re);
            if (pe !== null) return pe;
        }
        return null;
    }
    try {
        let F = {
            alpha: !0,
            depth: r,
            stencil: i,
            antialias: s,
            premultipliedAlpha: o,
            preserveDrawingBuffer: a,
            powerPreference: l,
            failIfMajorPerformanceCaveat: u
        };
        if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${aa}`), t.addEventListener("webglcontextlost", qe, !1), t.addEventListener("webglcontextrestored", et, !1), t.addEventListener("webglcontextcreationerror", Dt, !1), G === null) {
            let re = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (m.isWebGL1Renderer === !0 && re.shift(), G = J(re, F), G === null) throw J(re) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
        }
        G.getShaderPrecisionFormat === void 0 && (G.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        });
    } catch (F) {
        throw console.error("THREE.WebGLRenderer: " + F.message), F;
    }
    let Z, K, Y, ye, fe, oe, _e, xe, Ie, Oe, Pe, Te, Ve, Ue, L, R, ie, ue, me, De, Me, Ee, le, Je;
    function ke() {
        Z = new KV(G), K = new HV(G, Z, n1), Z.init(K), Ee = new EG(G, Z, K), Y = new AG(G, Z, K), ye = new $V, fe = new dG, oe = new _G(G, Z, Y, fe, K, Ee, ye), _e = new qV(m), xe = new QV(m), Ie = new lk(G, K), le = new GV(G, Z, Ie, K), Oe = new ZV(G, Ie, ye, le), Pe = new iU(G, Oe, Ie, ye), me = new rU(G, K, oe), R = new WV(fe), Te = new uG(m, _e, xe, Z, K, le, R), Ve = new MG(m, fe), Ue = new fG, L = new xG(Z, K), ue = new UV(m, _e, xe, Y, Pe, c, o), ie = new wG(m, Pe, K), Je = new CG(G, ye, K, Y), De = new jV(G, Z, ye, K), Me = new JV(G, Z, ye, K), ye.programs = Te.programs, m.capabilities = K, m.extensions = Z, m.properties = fe, m.renderLists = Ue, m.shadowMap = ie, m.state = Y, m.info = ye;
    }
    ke();
    let Be = new zS(m, G);
    this.xr = Be, this.getContext = function() {
        return G;
    }, this.getContextAttributes = function() {
        return G.getContextAttributes();
    }, this.forceContextLoss = function() {
        let F = Z.get("WEBGL_lose_context");
        F && F.loseContext();
    }, this.forceContextRestore = function() {
        let F = Z.get("WEBGL_lose_context");
        F && F.restoreContext();
    }, this.getPixelRatio = function() {
        return C;
    }, this.setPixelRatio = function(F) {
        F !== void 0 && (C = F, this.setSize(T, M, !1));
    }, this.getSize = function(F) {
        return F.set(T, M);
    }, this.setSize = function(F, re, de) {
        if (Be.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        T = F, M = re, t.width = Math.floor(F * C), t.height = Math.floor(re * C), de !== !1 && (t.style.width = F + "px", t.style.height = re + "px"), this.setViewport(0, 0, F, re);
    }, this.getDrawingBufferSize = function(F) {
        return F.set(T * C, M * C).floor();
    }, this.setDrawingBufferSize = function(F, re, de) {
        T = F, M = re, C = de, t.width = Math.floor(F * de), t.height = Math.floor(re * de), this.setViewport(0, 0, F, re);
    }, this.getCurrentViewport = function(F) {
        return F.copy(A);
    }, this.getViewport = function(F) {
        return F.copy(O);
    }, this.setViewport = function(F, re, de, ee) {
        F.isVector4 ? O.set(F.x, F.y, F.z, F.w) : O.set(F, re, de, ee), Y.viewport(A.copy(O).multiplyScalar(C).floor());
    }, this.getScissor = function(F) {
        return F.copy(I);
    }, this.setScissor = function(F, re, de, ee) {
        F.isVector4 ? I.set(F.x, F.y, F.z, F.w) : I.set(F, re, de, ee), Y.scissor(E.copy(I).multiplyScalar(C).floor());
    }, this.getScissorTest = function() {
        return z;
    }, this.setScissorTest = function(F) {
        Y.setScissorTest(z = F);
    }, this.setOpaqueSort = function(F) {
        P = F;
    }, this.setTransparentSort = function(F) {
        D = F;
    }, this.getClearColor = function(F) {
        return F.copy(ue.getClearColor());
    }, this.setClearColor = function() {
        ue.setClearColor.apply(ue, arguments);
    }, this.getClearAlpha = function() {
        return ue.getClearAlpha();
    }, this.setClearAlpha = function() {
        ue.setClearAlpha.apply(ue, arguments);
    }, this.clear = function(F = !0, re = !0, de = !0) {
        let ee = 0;
        F && (ee |= 16384), re && (ee |= 256), de && (ee |= 1024), G.clear(ee);
    }, this.clearColor = function() {
        this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
        this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
        this.clear(!1, !1, !0);
    }, this.dispose = function() {
        t.removeEventListener("webglcontextlost", qe, !1), t.removeEventListener("webglcontextrestored", et, !1), t.removeEventListener("webglcontextcreationerror", Dt, !1), Ue.dispose(), L.dispose(), fe.dispose(), _e.dispose(), xe.dispose(), Pe.dispose(), le.dispose(), Je.dispose(), Te.dispose(), Be.dispose(), Be.removeEventListener("sessionstart", ze), Be.removeEventListener("sessionend", Fe), j && (j.dispose(), j = null), Ot.stop();
    };
    function qe(F) {
        F.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
    }
    function et() {
        console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
        let F = ye.autoReset, re = ie.enabled, de = ie.autoUpdate, ee = ie.needsUpdate, pe = ie.type;
        ke(), ye.autoReset = F, ie.enabled = re, ie.autoUpdate = de, ie.needsUpdate = ee, ie.type = pe;
    }
    function Dt(F) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", F.statusMessage);
    }
    function yr(F) {
        let re = F.target;
        re.removeEventListener("dispose", yr), ti(re);
    }
    function ti(F) {
        Q(F), fe.remove(F);
    }
    function Q(F) {
        let re = fe.get(F).programs;
        re !== void 0 && (re.forEach(function(de) {
            Te.releaseProgram(de);
        }), F.isShaderMaterial && Te.releaseShaderCache(F));
    }
    this.renderBufferDirect = function(F, re, de, ee, pe, ot) {
        re === null && (re = X);
        let ft = pe.isMesh && pe.matrixWorld.determinant() < 0, vt = MN(F, re, de, ee, pe);
        Y.setMaterial(ee, ft);
        let St = de.index, Vt = 1;
        ee.wireframe === !0 && (St = Oe.getWireframeAttribute(de), Vt = 2);
        let It = de.drawRange, Rt = de.attributes.position, ii = It.start * Vt, zn = (It.start + It.count) * Vt;
        ot !== null && (ii = Math.max(ii, ot.start * Vt), zn = Math.min(zn, (ot.start + ot.count) * Vt)), St !== null ? (ii = Math.max(ii, 0), zn = Math.min(zn, St.count)) : Rt != null && (ii = Math.max(ii, 0), zn = Math.min(zn, Rt.count));
        let Ko = zn - ii;
        if (Ko < 0 || Ko === 1 / 0) return;
        le.setup(pe, ee, vt, de, St);
        let tc, ni = De;
        if (St !== null && (tc = Ie.get(St), ni = Me, ni.setIndex(tc)), pe.isMesh) ee.wireframe === !0 ? (Y.setLineWidth(ee.wireframeLinewidth * q()), ni.setMode(1)) : ni.setMode(4);
        else if (pe.isLine) {
            let Lt = ee.linewidth;
            Lt === void 0 && (Lt = 1), Y.setLineWidth(Lt * q()), pe.isLineSegments ? ni.setMode(1) : pe.isLineLoop ? ni.setMode(2) : ni.setMode(3);
        } else pe.isPoints ? ni.setMode(0) : pe.isSprite && ni.setMode(4);
        if (pe.isInstancedMesh) ni.renderInstances(ii, Ko, pe.count);
        else if (de.isInstancedBufferGeometry) {
            let Lt = de._maxInstanceCount !== void 0 ? de._maxInstanceCount : 1 / 0, Bb = Math.min(de.instanceCount, Lt);
            ni.renderInstances(ii, Ko, Bb);
        } else ni.render(ii, Ko);
    }, this.compile = function(F, re) {
        function de(ee, pe, ot) {
            ee.transparent === !0 && ee.side === qi && ee.forceSinglePass === !1 ? (ee.side = ai, ee.needsUpdate = !0, $n(ee, pe, ot), ee.side = jn, ee.needsUpdate = !0, $n(ee, pe, ot), ee.side = qi) : $n(ee, pe, ot);
        }
        h = L.get(F), h.init(), p.push(h), F.traverseVisible(function(ee) {
            ee.isLight && ee.layers.test(re.layers) && (h.pushLight(ee), ee.castShadow && h.pushShadow(ee));
        }), h.setupLights(m.physicallyCorrectLights), F.traverse(function(ee) {
            let pe = ee.material;
            if (pe) {
                if (Array.isArray(pe)) for(let ot = 0; ot < pe.length; ot++){
                    let ft = pe[ot];
                    de(ft, F, ee);
                }
                else de(pe, F, ee);
            }
        }), p.pop(), h = null;
    };
    let ce = null;
    function ve(F) {
        ce && ce(F);
    }
    function ze() {
        Ot.stop();
    }
    function Fe() {
        Ot.start();
    }
    let Ot = new IM;
    Ot.setAnimationLoop(ve), typeof self < "u" && Ot.setContext(self), this.setAnimationLoop = function(F) {
        ce = F, Be.setAnimationLoop(F), F === null ? Ot.stop() : Ot.start();
    }, Be.addEventListener("sessionstart", ze), Be.addEventListener("sessionend", Fe), this.render = function(F, re) {
        if (re !== void 0 && re.isCamera !== !0) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (g === !0) return;
        F.matrixWorldAutoUpdate === !0 && F.updateMatrixWorld(), re.parent === null && re.matrixWorldAutoUpdate === !0 && re.updateMatrixWorld(), Be.enabled === !0 && Be.isPresenting === !0 && (Be.cameraAutoUpdate === !0 && Be.updateCamera(re), re = Be.getCamera()), F.isScene === !0 && F.onBeforeRender(m, F, re, x), h = L.get(F, p.length), h.init(), p.push(h), W.multiplyMatrices(re.projectionMatrix, re.matrixWorldInverse), B.setFromProjectionMatrix(W), U = this.localClippingEnabled, V = R.init(this.clippingPlanes, U), d = Ue.get(F, f.length), d.init(), f.push(d), ri(F, re, 0, m.sortObjects), d.finish(), m.sortObjects === !0 && d.sort(P, D), V === !0 && R.beginShadows();
        let de = h.state.shadowsArray;
        if (ie.render(de, F, re), V === !0 && R.endShadows(), this.info.autoReset === !0 && this.info.reset(), ue.render(d, F), h.setupLights(m.physicallyCorrectLights), re.isArrayCamera) {
            let ee = re.cameras;
            for(let pe = 0, ot = ee.length; pe < ot; pe++){
                let ft = ee[pe];
                jr(d, F, ft, ft.viewport);
            }
        } else jr(d, F, re);
        x !== null && (oe.updateMultisampleRenderTarget(x), oe.updateRenderTargetMipmap(x)), F.isScene === !0 && F.onAfterRender(m, F, re), le.resetDefaultState(), S = -1, w = null, p.pop(), p.length > 0 ? h = p[p.length - 1] : h = null, f.pop(), f.length > 0 ? d = f[f.length - 1] : d = null;
    };
    function ri(F, re, de, ee) {
        if (F.visible === !1) return;
        if (F.layers.test(re.layers)) {
            if (F.isGroup) de = F.renderOrder;
            else if (F.isLOD) F.autoUpdate === !0 && F.update(re);
            else if (F.isLight) h.pushLight(F), F.castShadow && h.pushShadow(F);
            else if (F.isSprite) {
                if (!F.frustumCulled || B.intersectsSprite(F)) {
                    ee && H.setFromMatrixPosition(F.matrixWorld).applyMatrix4(W);
                    let ft = Pe.update(F), vt = F.material;
                    vt.visible && d.push(F, ft, vt, de, H.z, null);
                }
            } else if ((F.isMesh || F.isLine || F.isPoints) && (F.isSkinnedMesh && F.skeleton.frame !== ye.render.frame && (F.skeleton.update(), F.skeleton.frame = ye.render.frame), !F.frustumCulled || B.intersectsObject(F))) {
                ee && H.setFromMatrixPosition(F.matrixWorld).applyMatrix4(W);
                let ft = Pe.update(F), vt = F.material;
                if (Array.isArray(vt)) {
                    let St = ft.groups;
                    for(let Vt = 0, It = St.length; Vt < It; Vt++){
                        let Rt = St[Vt], ii = vt[Rt.materialIndex];
                        ii && ii.visible && d.push(F, ft, ii, de, H.z, Rt);
                    }
                } else vt.visible && d.push(F, ft, vt, de, H.z, null);
            }
        }
        let ot = F.children;
        for(let ft = 0, vt = ot.length; ft < vt; ft++)ri(ot[ft], re, de, ee);
    }
    function jr(F, re, de, ee) {
        let pe = F.opaque, ot = F.transmissive, ft = F.transparent;
        h.setupLightsView(de), V === !0 && R.setGlobalState(m.clippingPlanes, de), ot.length > 0 && ec(pe, re, de), ee && Y.viewport(A.copy(ee)), pe.length > 0 && _r(pe, re, de), ot.length > 0 && _r(ot, re, de), ft.length > 0 && _r(ft, re, de), Y.buffers.depth.setTest(!0), Y.buffers.depth.setMask(!0), Y.buffers.color.setMask(!0), Y.setPolygonOffset(!1);
    }
    function ec(F, re, de) {
        let ee = K.isWebGL2;
        j === null && (j = new at(1, 1, {
            generateMipmaps: !0,
            type: Z.has("EXT_color_buffer_half_float") ? sa : br,
            minFilter: dc,
            samples: ee && s === !0 ? 4 : 0
        })), m.getDrawingBufferSize(k), ee ? j.setSize(k.x, k.y) : j.setSize(ey(k.x), ey(k.y));
        let pe = m.getRenderTarget();
        m.setRenderTarget(j), m.clear();
        let ot = m.toneMapping;
        m.toneMapping = Os, _r(F, re, de), m.toneMapping = ot, oe.updateMultisampleRenderTarget(j), oe.updateRenderTargetMipmap(j), m.setRenderTarget(pe);
    }
    function _r(F, re, de) {
        let ee = re.isScene === !0 ? re.overrideMaterial : null;
        for(let pe = 0, ot = F.length; pe < ot; pe++){
            let ft = F[pe], vt = ft.object, St = ft.geometry, Vt = ee === null ? ft.material : ee, It = ft.group;
            vt.layers.test(de.layers) && Qo(vt, re, de, St, Vt, It);
        }
    }
    function Qo(F, re, de, ee, pe, ot) {
        F.onBeforeRender(m, re, de, ee, pe, ot), F.modelViewMatrix.multiplyMatrices(de.matrixWorldInverse, F.matrixWorld), F.normalMatrix.getNormalMatrix(F.modelViewMatrix), pe.onBeforeRender(m, re, de, ee, F, ot), pe.transparent === !0 && pe.side === qi && pe.forceSinglePass === !1 ? (pe.side = ai, pe.needsUpdate = !0, m.renderBufferDirect(de, re, ee, pe, F, ot), pe.side = jn, pe.needsUpdate = !0, m.renderBufferDirect(de, re, ee, pe, F, ot), pe.side = qi) : m.renderBufferDirect(de, re, ee, pe, F, ot), F.onAfterRender(m, re, de, ee, pe, ot);
    }
    function $n(F, re, de) {
        re.isScene !== !0 && (re = X);
        let ee = fe.get(F), pe = h.state.lights, ot = h.state.shadowsArray, ft = pe.state.version, vt = Te.getParameters(F, pe.state, ot, re, de), St = Te.getProgramCacheKey(vt), Vt = ee.programs;
        ee.environment = F.isMeshStandardMaterial ? re.environment : null, ee.fog = re.fog, ee.envMap = (F.isMeshStandardMaterial ? xe : _e).get(F.envMap || ee.environment), Vt === void 0 && (F.addEventListener("dispose", yr), Vt = new Map, ee.programs = Vt);
        let It = Vt.get(St);
        if (It !== void 0) {
            if (ee.currentProgram === It && ee.lightsStateVersion === ft) return UE(F, vt), It;
        } else vt.uniforms = Te.getUniforms(F), F.onBuild(de, vt, m), F.onBeforeCompile(vt, m), It = Te.acquireProgram(vt, St), Vt.set(St, It), ee.uniforms = vt.uniforms;
        let Rt = ee.uniforms;
        (!F.isShaderMaterial && !F.isRawShaderMaterial || F.clipping === !0) && (Rt.clippingPlanes = R.uniform), UE(F, vt), ee.needsLights = PN(F), ee.lightsStateVersion = ft, ee.needsLights && (Rt.ambientLightColor.value = pe.state.ambient, Rt.lightProbe.value = pe.state.probe, Rt.directionalLights.value = pe.state.directional, Rt.directionalLightShadows.value = pe.state.directionalShadow, Rt.spotLights.value = pe.state.spot, Rt.spotLightShadows.value = pe.state.spotShadow, Rt.rectAreaLights.value = pe.state.rectArea, Rt.ltc_1.value = pe.state.rectAreaLTC1, Rt.ltc_2.value = pe.state.rectAreaLTC2, Rt.pointLights.value = pe.state.point, Rt.pointLightShadows.value = pe.state.pointShadow, Rt.hemisphereLights.value = pe.state.hemi, Rt.directionalShadowMap.value = pe.state.directionalShadowMap, Rt.directionalShadowMatrix.value = pe.state.directionalShadowMatrix, Rt.spotShadowMap.value = pe.state.spotShadowMap, Rt.spotLightMatrix.value = pe.state.spotLightMatrix, Rt.spotLightMap.value = pe.state.spotLightMap, Rt.pointShadowMap.value = pe.state.pointShadowMap, Rt.pointShadowMatrix.value = pe.state.pointShadowMatrix);
        let ii = It.getUniforms(), zn = Cu.seqWithValue(ii.seq, Rt);
        return ee.currentProgram = It, ee.uniformsList = zn, It;
    }
    function UE(F, re) {
        let de = fe.get(F);
        de.outputEncoding = re.outputEncoding, de.instancing = re.instancing, de.skinning = re.skinning, de.morphTargets = re.morphTargets, de.morphNormals = re.morphNormals, de.morphColors = re.morphColors, de.morphTargetsCount = re.morphTargetsCount, de.numClippingPlanes = re.numClippingPlanes, de.numIntersection = re.numClipIntersection, de.vertexAlphas = re.vertexAlphas, de.vertexTangents = re.vertexTangents, de.toneMapping = re.toneMapping;
    }
    function MN(F, re, de, ee, pe) {
        re.isScene !== !0 && (re = X), oe.resetTextureUnits();
        let ot = re.fog, ft = ee.isMeshStandardMaterial ? re.environment : null, vt = x === null ? m.outputEncoding : x.isXRRenderTarget === !0 ? x.texture.encoding : dn, St = (ee.isMeshStandardMaterial ? xe : _e).get(ee.envMap || ft), Vt = ee.vertexColors === !0 && !!de.attributes.color && de.attributes.color.itemSize === 4, It = !!ee.normalMap && !!de.attributes.tangent, Rt = !!de.morphAttributes.position, ii = !!de.morphAttributes.normal, zn = !!de.morphAttributes.color, Ko = ee.toneMapped ? m.toneMapping : Os, tc = de.morphAttributes.position || de.morphAttributes.normal || de.morphAttributes.color, ni = tc !== void 0 ? tc.length : 0, Lt = fe.get(ee), Bb = h.state.lights;
        if (V === !0 && (U === !0 || F !== w)) {
            let Vn = F === w && ee.id === S;
            R.setState(ee, F, Vn);
        }
        let Ci = !1;
        ee.version === Lt.__version ? (Lt.needsLights && Lt.lightsStateVersion !== Bb.state.version || Lt.outputEncoding !== vt || pe.isInstancedMesh && Lt.instancing === !1 || !pe.isInstancedMesh && Lt.instancing === !0 || pe.isSkinnedMesh && Lt.skinning === !1 || !pe.isSkinnedMesh && Lt.skinning === !0 || Lt.envMap !== St || ee.fog === !0 && Lt.fog !== ot || Lt.numClippingPlanes !== void 0 && (Lt.numClippingPlanes !== R.numPlanes || Lt.numIntersection !== R.numIntersection) || Lt.vertexAlphas !== Vt || Lt.vertexTangents !== It || Lt.morphTargets !== Rt || Lt.morphNormals !== ii || Lt.morphColors !== zn || Lt.toneMapping !== Ko || K.isWebGL2 === !0 && Lt.morphTargetsCount !== ni) && (Ci = !0) : (Ci = !0, Lt.__version = ee.version);
        let rc = Lt.currentProgram;
        Ci === !0 && (rc = $n(ee, re, pe));
        let GE = !1, Hf = !1, Nb = !1, Wi = rc.getUniforms(), ic = Lt.uniforms;
        if (Y.useProgram(rc.program) && (GE = !0, Hf = !0, Nb = !0), ee.id !== S && (S = ee.id, Hf = !0), GE || w !== F) {
            if (Wi.setValue(G, "projectionMatrix", F.projectionMatrix), K.logarithmicDepthBuffer && Wi.setValue(G, "logDepthBufFC", 2 / (Math.log(F.far + 1) / Math.LN2)), w !== F && (w = F, Hf = !0, Nb = !0), ee.isShaderMaterial || ee.isMeshPhongMaterial || ee.isMeshToonMaterial || ee.isMeshStandardMaterial || ee.envMap) {
                let Vn = Wi.map.cameraPosition;
                Vn !== void 0 && Vn.setValue(G, H.setFromMatrixPosition(F.matrixWorld));
            }
            (ee.isMeshPhongMaterial || ee.isMeshToonMaterial || ee.isMeshLambertMaterial || ee.isMeshBasicMaterial || ee.isMeshStandardMaterial || ee.isShaderMaterial) && Wi.setValue(G, "isOrthographic", F.isOrthographicCamera === !0), (ee.isMeshPhongMaterial || ee.isMeshToonMaterial || ee.isMeshLambertMaterial || ee.isMeshBasicMaterial || ee.isMeshStandardMaterial || ee.isShaderMaterial || ee.isShadowMaterial || pe.isSkinnedMesh) && Wi.setValue(G, "viewMatrix", F.matrixWorldInverse);
        }
        if (pe.isSkinnedMesh) {
            Wi.setOptional(G, pe, "bindMatrix"), Wi.setOptional(G, pe, "bindMatrixInverse");
            let Vn = pe.skeleton;
            Vn && (K.floatVertexTextures ? (Vn.boneTexture === null && Vn.computeBoneTexture(), Wi.setValue(G, "boneTexture", Vn.boneTexture, oe), Wi.setValue(G, "boneTextureSize", Vn.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
        }
        let Fb = de.morphAttributes;
        if ((Fb.position !== void 0 || Fb.normal !== void 0 || Fb.color !== void 0 && K.isWebGL2 === !0) && me.update(pe, de, ee, rc), (Hf || Lt.receiveShadow !== pe.receiveShadow) && (Lt.receiveShadow = pe.receiveShadow, Wi.setValue(G, "receiveShadow", pe.receiveShadow)), ee.isMeshGouraudMaterial && ee.envMap !== null && (ic.envMap.value = St, ic.flipEnvMap.value = St.isCubeTexture && St.isRenderTargetTexture === !1 ? -1 : 1), Hf && (Wi.setValue(G, "toneMappingExposure", m.toneMappingExposure), Lt.needsLights && CN(ic, Nb), ot && ee.fog === !0 && Ve.refreshFogUniforms(ic, ot), Ve.refreshMaterialUniforms(ic, ee, C, M, j), Cu.upload(G, Lt.uniformsList, ic, oe)), ee.isShaderMaterial && ee.uniformsNeedUpdate === !0 && (Cu.upload(G, Lt.uniformsList, ic, oe), ee.uniformsNeedUpdate = !1), ee.isSpriteMaterial && Wi.setValue(G, "center", pe.center), Wi.setValue(G, "modelViewMatrix", pe.modelViewMatrix), Wi.setValue(G, "normalMatrix", pe.normalMatrix), Wi.setValue(G, "modelMatrix", pe.matrixWorld), pe.previousModelViewMatrix && Wi.setValue(G, "previousModelViewMatrix", pe.previousModelViewMatrix), F.previousProjectionMatrix && Wi.setValue(G, "previousProjectionMatrix", F.previousProjectionMatrix), ee.isShaderMaterial || ee.isRawShaderMaterial) {
            let Vn = ee.uniformsGroups;
            for(let kb = 0, DN = Vn.length; kb < DN; kb++)if (K.isWebGL2) {
                let jE = Vn[kb];
                Je.update(jE, rc), Je.bind(jE, rc);
            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
        }
        return rc;
    }
    function CN(F, re) {
        F.ambientLightColor.needsUpdate = re, F.lightProbe.needsUpdate = re, F.directionalLights.needsUpdate = re, F.directionalLightShadows.needsUpdate = re, F.pointLights.needsUpdate = re, F.pointLightShadows.needsUpdate = re, F.spotLights.needsUpdate = re, F.spotLightShadows.needsUpdate = re, F.rectAreaLights.needsUpdate = re, F.hemisphereLights.needsUpdate = re;
    }
    function PN(F) {
        return F.isMeshLambertMaterial || F.isMeshToonMaterial || F.isMeshPhongMaterial || F.isMeshStandardMaterial || F.isShadowMaterial || F.isShaderMaterial && F.lights === !0;
    }
    this.getActiveCubeFace = function() {
        return y;
    }, this.getActiveMipmapLevel = function() {
        return v;
    }, this.getRenderTarget = function() {
        return x;
    }, this.setRenderTargetTextures = function(F, re, de) {
        fe.get(F.texture).__webglTexture = re, fe.get(F.depthTexture).__webglTexture = de;
        let ee = fe.get(F);
        ee.__hasExternalTextures = !0, ee.__hasExternalTextures && (ee.__autoAllocateDepthBuffer = de === void 0, ee.__autoAllocateDepthBuffer || Z.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), ee.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(F, re) {
        let de = fe.get(F);
        de.__webglFramebuffer = re, de.__useDefaultFramebuffer = re === void 0;
    }, this.setRenderTarget = function(F, re = 0, de = 0) {
        x = F, y = re, v = de;
        let ee = !0, pe = null, ot = !1, ft = !1;
        if (F) {
            let St = fe.get(F);
            St.__useDefaultFramebuffer !== void 0 ? (Y.bindFramebuffer(36160, null), ee = !1) : St.__webglFramebuffer === void 0 ? oe.setupRenderTarget(F) : St.__hasExternalTextures && oe.rebindTextures(F, fe.get(F.texture).__webglTexture, fe.get(F.depthTexture).__webglTexture);
            let Vt = F.texture;
            (Vt.isData3DTexture || Vt.isDataArrayTexture || Vt.isCompressedArrayTexture) && (ft = !0);
            let It = fe.get(F).__webglFramebuffer;
            F.isWebGLCubeRenderTarget ? (pe = It[re], ot = !0) : K.isWebGL2 && F.samples > 0 && oe.useMultisampledRTT(F) === !1 ? pe = fe.get(F).__webglMultisampledFramebuffer : pe = It, A.copy(F.viewport), E.copy(F.scissor), b = F.scissorTest;
        } else A.copy(O).multiplyScalar(C).floor(), E.copy(I).multiplyScalar(C).floor(), b = z;
        if (Y.bindFramebuffer(36160, pe) && K.drawBuffers && ee && Y.drawBuffers(F, pe), Y.viewport(A), Y.scissor(E), Y.setScissorTest(b), ot) {
            let St = fe.get(F.texture);
            G.framebufferTexture2D(36160, 36064, 34069 + re, St.__webglTexture, de);
        } else if (ft) {
            let St = fe.get(F.texture), Vt = re || 0;
            G.framebufferTextureLayer(36160, 36064, St.__webglTexture, de || 0, Vt);
        }
        S = -1;
    }, this.readRenderTargetPixels = function(F, re, de, ee, pe, ot, ft) {
        if (!(F && F.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let vt = fe.get(F).__webglFramebuffer;
        if (F.isWebGLCubeRenderTarget && ft !== void 0 && (vt = vt[ft]), vt) {
            Y.bindFramebuffer(36160, vt);
            try {
                let St = F.texture, Vt = St.format, It = St.type;
                if (Vt !== Fr && Ee.convert(Vt) !== G.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                let Rt = It === sa && (Z.has("EXT_color_buffer_half_float") || K.isWebGL2 && Z.has("EXT_color_buffer_float"));
                if (It !== br && Ee.convert(It) !== G.getParameter(35738) && !(It === dr && (K.isWebGL2 || Z.has("OES_texture_float") || Z.has("WEBGL_color_buffer_float"))) && !Rt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                re >= 0 && re <= F.width - ee && de >= 0 && de <= F.height - pe && G.readPixels(re, de, ee, pe, Ee.convert(Vt), Ee.convert(It), ot);
            } finally{
                let St = x !== null ? fe.get(x).__webglFramebuffer : null;
                Y.bindFramebuffer(36160, St);
            }
        }
    }, this.copyFramebufferToTexture = function(F, re, de = 0) {
        let ee = Math.pow(2, -de), pe = Math.floor(re.image.width * ee), ot = Math.floor(re.image.height * ee);
        oe.setTexture2D(re, 0), G.copyTexSubImage2D(3553, de, 0, 0, F.x, F.y, pe, ot), Y.unbindTexture();
    }, this.copyTextureToTexture = function(F, re, de, ee = 0) {
        let pe = re.image.width, ot = re.image.height, ft = Ee.convert(de.format), vt = Ee.convert(de.type);
        oe.setTexture2D(de, 0), G.pixelStorei(37440, de.flipY), G.pixelStorei(37441, de.premultiplyAlpha), G.pixelStorei(3317, de.unpackAlignment), re.isDataTexture ? G.texSubImage2D(3553, ee, F.x, F.y, pe, ot, ft, vt, re.image.data) : re.isCompressedTexture ? G.compressedTexSubImage2D(3553, ee, F.x, F.y, re.mipmaps[0].width, re.mipmaps[0].height, ft, re.mipmaps[0].data) : G.texSubImage2D(3553, ee, F.x, F.y, ft, vt, re.image), ee === 0 && de.generateMipmaps && G.generateMipmap(3553), Y.unbindTexture();
    }, this.copyTextureToTexture3D = function(F, re, de, ee, pe = 0) {
        if (m.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        let ot = F.max.x - F.min.x + 1, ft = F.max.y - F.min.y + 1, vt = F.max.z - F.min.z + 1, St = Ee.convert(ee.format), Vt = Ee.convert(ee.type), It;
        if (ee.isData3DTexture) oe.setTexture3D(ee, 0), It = 32879;
        else if (ee.isDataArrayTexture) oe.setTexture2DArray(ee, 0), It = 35866;
        else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        G.pixelStorei(37440, ee.flipY), G.pixelStorei(37441, ee.premultiplyAlpha), G.pixelStorei(3317, ee.unpackAlignment);
        let Rt = G.getParameter(3314), ii = G.getParameter(32878), zn = G.getParameter(3316), Ko = G.getParameter(3315), tc = G.getParameter(32877), ni = de.isCompressedTexture ? de.mipmaps[0] : de.image;
        G.pixelStorei(3314, ni.width), G.pixelStorei(32878, ni.height), G.pixelStorei(3316, F.min.x), G.pixelStorei(3315, F.min.y), G.pixelStorei(32877, F.min.z), de.isDataTexture || de.isData3DTexture ? G.texSubImage3D(It, pe, re.x, re.y, re.z, ot, ft, vt, St, Vt, ni.data) : de.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), G.compressedTexSubImage3D(It, pe, re.x, re.y, re.z, ot, ft, vt, St, ni.data)) : G.texSubImage3D(It, pe, re.x, re.y, re.z, ot, ft, vt, St, Vt, ni), G.pixelStorei(3314, Rt), G.pixelStorei(32878, ii), G.pixelStorei(3316, zn), G.pixelStorei(3315, Ko), G.pixelStorei(32877, tc), pe === 0 && ee.generateMipmaps && G.generateMipmap(It), Y.unbindTexture();
    }, this.initTexture = function(F) {
        F.isCubeTexture ? oe.setTextureCube(F, 0) : F.isData3DTexture ? oe.setTexture3D(F, 0) : F.isDataArrayTexture || F.isCompressedArrayTexture ? oe.setTexture2DArray(F, 0) : oe.setTexture2D(F, 0), Y.unbindTexture();
    }, this.resetState = function() {
        y = 0, v = 0, x = null, Y.reset(), le.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
var VS = class extends dw {
};
VS.prototype.isWebGL1Renderer = !0;
var Iu = class {
    constructor(t, e = 1, r = 1e3){
        this.isFog = !0, this.name = "", this.color = new Le(t), this.near = e, this.far = r;
    }
    clone() {
        return new Iu(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}, vi = class extends mt {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t, e) {
        return super.copy(t, e), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return this.fog !== null && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (e.object.backgroundIntensity = this.backgroundIntensity), e;
    }
    get autoUpdate() {
        return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
    }
    set autoUpdate(t) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = t;
    }
}, ly = class {
    constructor(t, e){
        this.isInterleavedBuffer = !0, this.array = t, this.stride = e, this.count = t !== void 0 ? t.length / e : 0, this.usage = TS, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0, this.uuid = rs();
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.stride, r *= e.stride;
        for(let i = 0, s = this.stride; i < s; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    clone(t) {
        t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = rs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        let e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), r = new this.constructor(e, this.stride);
        return r.setUsage(this.usage), r;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    toJSON(t) {
        return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = rs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}, cn = new _, fc = class {
    constructor(t, e, r, i = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = e, this.offset = r, this.normalized = i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t) {
        this.data.needsUpdate = t;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.data.count; e < r; e++)cn.fromBufferAttribute(this, e), cn.applyMatrix4(t), this.setXYZ(e, cn.x, cn.y, cn.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)cn.fromBufferAttribute(this, e), cn.applyNormalMatrix(t), this.setXYZ(e, cn.x, cn.y, cn.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)cn.fromBufferAttribute(this, e), cn.transformDirection(t), this.setXYZ(e, cn.x, cn.y, cn.z);
        return this;
    }
    setX(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.data.array[t * this.data.stride + this.offset] = e, this;
    }
    setY(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t, e) {
        return this.normalized && (e = ur(e, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t) {
        let e = this.data.array[t * this.data.stride + this.offset];
        return this.normalized && (e = na(e, this.array)), e;
    }
    getY(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 1];
        return this.normalized && (e = na(e, this.array)), e;
    }
    getZ(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 2];
        return this.normalized && (e = na(e, this.array)), e;
    }
    getW(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 3];
        return this.normalized && (e = na(e, this.array)), e;
    }
    setXY(t, e, r) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = ur(e, this.array), r = ur(r, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = ur(e, this.array), r = ur(r, this.array), i = ur(i, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = ur(e, this.array), r = ur(r, this.array), i = ur(i, this.array), s = ur(s, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this.data.array[t + 3] = s, this;
    }
    clone(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return new Ge(new this.array.constructor(e), this.itemSize, this.normalized);
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new fc(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: e,
                normalized: this.normalized
            };
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
};
var fp = class extends mt {
    constructor(){
        super(), this.isBone = !0, this.type = "Bone";
    }
}, ci = class extends qt {
    constructor(t = null, e = 1, r = 1, i, s, o, a, l, u = Et, c = Et, d, h){
        super(null, o, a, l, u, c, i, s, d, h), this.isDataTexture = !0, this.image = {
            data: t,
            width: e,
            height: r
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}, $T = new te, DG = new te, Za = class {
    constructor(t = [], e = []){
        this.uuid = rs(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
    }
    init() {
        let t = this.bones, e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(t.length * 16), e.length === 0) this.calculateInverses();
        else if (t.length !== e.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let r = 0, i = this.bones.length; r < i; r++)this.boneInverses.push(new te);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = new te;
            this.bones[t] && r.copy(this.bones[t].matrixWorld).invert(), this.boneInverses.push(r);
        }
    }
    pose() {
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && r.matrixWorld.copy(this.boneInverses[t]).invert();
        }
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && (r.parent && r.parent.isBone ? (r.matrix.copy(r.parent.matrixWorld).invert(), r.matrix.multiply(r.matrixWorld)) : r.matrix.copy(r.matrixWorld), r.matrix.decompose(r.position, r.quaternion, r.scale));
        }
    }
    update() {
        let t = this.bones, e = this.boneInverses, r = this.boneMatrices, i = this.boneTexture;
        for(let s = 0, o = t.length; s < o; s++){
            let a = t[s] ? t[s].matrixWorld : DG;
            $T.multiplyMatrices(a, e[s]), $T.toArray(r, s * 16);
        }
        i !== null && (i.needsUpdate = !0);
    }
    clone() {
        return new Za(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let t = Math.sqrt(this.bones.length * 4);
        t = CM(t), t = Math.max(t, 4);
        let e = new Float32Array(t * t * 4);
        e.set(this.boneMatrices);
        let r = new ci(e, t, t, Fr, dr);
        return r.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = r, this.boneTextureSize = t, this;
    }
    getBoneByName(t) {
        for(let e = 0, r = this.bones.length; e < r; e++){
            let i = this.bones[e];
            if (i.name === t) return i;
        }
    }
    dispose() {
        this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(t, e) {
        this.uuid = t.uuid;
        for(let r = 0, i = t.bones.length; r < i; r++){
            let s = t.bones[r], o = e[s];
            o === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", s), o = new fp), this.bones.push(o), this.boneInverses.push(new te().fromArray(t.boneInverses[r]));
        }
        return this.init(), this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        t.uuid = this.uuid;
        let e = this.bones, r = this.boneInverses;
        for(let i = 0, s = e.length; i < s; i++){
            let o = e[i];
            t.bones.push(o.uuid);
            let a = r[i];
            t.boneInverses.push(a.toArray());
        }
        return t;
    }
}, uo = class extends Ge {
    constructor(t, e, r, i = 1){
        super(t, e, r), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
}, eM = new te, tM = new te, Ug = [], OG = new te, Jf = new rr, cy = class extends rr {
    constructor(t, e, r){
        super(t, e), this.isInstancedMesh = !0, this.instanceMatrix = new uo(new Float32Array(r * 16), 16), this.instanceColor = null, this.count = r, this.frustumCulled = !1;
        for(let i = 0; i < r; i++)this.setMatrixAt(i, OG);
    }
    copy(t, e) {
        return super.copy(t, e), this.instanceMatrix.copy(t.instanceMatrix), t.instanceColor !== null && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
    }
    getColorAt(t, e) {
        e.fromArray(this.instanceColor.array, t * 3);
    }
    getMatrixAt(t, e) {
        e.fromArray(this.instanceMatrix.array, t * 16);
    }
    raycast(t, e) {
        let r = this.matrixWorld, i = this.count;
        if (Jf.geometry = this.geometry, Jf.material = this.material, Jf.material !== void 0) for(let s = 0; s < i; s++){
            this.getMatrixAt(s, eM), tM.multiplyMatrices(r, eM), Jf.matrixWorld = tM, Jf.raycast(t, Ug);
            for(let o = 0, a = Ug.length; o < a; o++){
                let l = Ug[o];
                l.instanceId = s, l.object = this, e.push(l);
            }
            Ug.length = 0;
        }
    }
    setColorAt(t, e) {
        this.instanceColor === null && (this.instanceColor = new uo(new Float32Array(this.instanceMatrix.count * 3), 3)), e.toArray(this.instanceColor.array, t * 3);
    }
    setMatrixAt(t, e) {
        e.toArray(this.instanceMatrix.array, t * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, ns = class extends hc {
    constructor(t){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Le(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
    }
}, rM = new _, iM = new _, nM = new te, gS = new Rs, Gg = new Er, pc = class extends mt {
    constructor(t = new we, e = new ns){
        super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [
                0
            ];
            for(let i = 1, s = e.count; i < s; i++)rM.fromBufferAttribute(e, i - 1), iM.fromBufferAttribute(e, i), r[i] = r[i - 1], r[i] += rM.distanceTo(iM);
            t.setAttribute("lineDistance", new be(r, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.matrixWorld, s = t.params.Line.threshold, o = r.drawRange;
        if (r.boundingSphere === null && r.computeBoundingSphere(), Gg.copy(r.boundingSphere), Gg.applyMatrix4(i), Gg.radius += s, t.ray.intersectsSphere(Gg) === !1) return;
        nM.copy(i).invert(), gS.copy(t.ray).applyMatrix4(nM);
        let a = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = a * a, u = new _, c = new _, d = new _, h = new _, f = this.isLineSegments ? 2 : 1, p = r.index, g = r.attributes.position;
        if (p !== null) {
            let y = Math.max(0, o.start), v = Math.min(p.count, o.start + o.count);
            for(let x = y, S = v - 1; x < S; x += f){
                let w = p.getX(x), A = p.getX(x + 1);
                if (u.fromBufferAttribute(g, w), c.fromBufferAttribute(g, A), gS.distanceSqToSegment(u, c, h, d) > l) continue;
                h.applyMatrix4(this.matrixWorld);
                let b = t.ray.origin.distanceTo(h);
                b < t.near || b > t.far || e.push({
                    distance: b,
                    point: d.clone().applyMatrix4(this.matrixWorld),
                    index: x,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            let y = Math.max(0, o.start), v = Math.min(g.count, o.start + o.count);
            for(let x = y, S = v - 1; x < S; x += f){
                if (u.fromBufferAttribute(g, x), c.fromBufferAttribute(g, x + 1), gS.distanceSqToSegment(u, c, h, d) > l) continue;
                h.applyMatrix4(this.matrixWorld);
                let A = t.ray.origin.distanceTo(h);
                A < t.near || A > t.far || e.push({
                    distance: A,
                    point: d.clone().applyMatrix4(this.matrixWorld),
                    index: x,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
}, sM = new _, oM = new _, Ja = class extends pc {
    constructor(t, e){
        super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [];
            for(let i = 0, s = e.count; i < s; i += 2)sM.fromBufferAttribute(e, i), oM.fromBufferAttribute(e, i + 1), r[i] = i === 0 ? 0 : r[i - 1], r[i + 1] = r[i] + sM.distanceTo(oM);
            t.setAttribute("lineDistance", new be(r, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
};
var uy = class extends qt {
    constructor(t, e, r, i, s, o, a, l, u){
        super(t, e, r, i, s, o, a, l, u), this.isVideoTexture = !0, this.minFilter = o !== void 0 ? o : Qe, this.magFilter = s !== void 0 ? s : Qe, this.generateMipmaps = !1;
        let c = this;
        function d() {
            c.needsUpdate = !0, t.requestVideoFrameCallback(d);
        }
        "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(d);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        let t = this.image;
        "requestVideoFrameCallback" in t === !1 && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
};
var dy = class extends qt {
    constructor(t, e, r, i, s, o, a, l, u){
        super(t, e, r, i, s, o, a, l, u), this.isCanvasTexture = !0, this.needsUpdate = !0;
    }
}, ss = class {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200;
    }
    getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
    getPointAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getPoint(r, e);
    }
    getPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return e;
    }
    getSpacedPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPointAt(r / t));
        return e;
    }
    getLength() {
        let t = this.getLengths();
        return t[t.length - 1];
    }
    getLengths(t = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        let e = [], r, i = this.getPoint(0), s = 0;
        e.push(0);
        for(let o = 1; o <= t; o++)r = this.getPoint(o / t), s += r.distanceTo(i), e.push(s), i = r;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t, e) {
        let r = this.getLengths(), i = 0, s = r.length, o;
        e ? o = e : o = t * r[s - 1];
        let a = 0, l = s - 1, u;
        for(; a <= l;)if (i = Math.floor(a + (l - a) / 2), u = r[i] - o, u < 0) a = i + 1;
        else if (u > 0) l = i - 1;
        else {
            l = i;
            break;
        }
        if (i = l, r[i] === o) return i / (s - 1);
        let c = r[i], h = r[i + 1] - c, f = (o - c) / h;
        return (i + f) / (s - 1);
    }
    getTangent(t, e) {
        let i = t - 1e-4, s = t + 1e-4;
        i < 0 && (i = 0), s > 1 && (s = 1);
        let o = this.getPoint(i), a = this.getPoint(s), l = e || (o.isVector2 ? new N : new _);
        return l.copy(a).sub(o).normalize(), l;
    }
    getTangentAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getTangent(r, e);
    }
    computeFrenetFrames(t, e) {
        let r = new _, i = [], s = [], o = [], a = new _, l = new te;
        for(let f = 0; f <= t; f++){
            let p = f / t;
            i[f] = this.getTangentAt(p, new _);
        }
        s[0] = new _, o[0] = new _;
        let u = Number.MAX_VALUE, c = Math.abs(i[0].x), d = Math.abs(i[0].y), h = Math.abs(i[0].z);
        c <= u && (u = c, r.set(1, 0, 0)), d <= u && (u = d, r.set(0, 1, 0)), h <= u && r.set(0, 0, 1), a.crossVectors(i[0], r).normalize(), s[0].crossVectors(i[0], a), o[0].crossVectors(i[0], s[0]);
        for(let f = 1; f <= t; f++){
            if (s[f] = s[f - 1].clone(), o[f] = o[f - 1].clone(), a.crossVectors(i[f - 1], i[f]), a.length() > Number.EPSILON) {
                a.normalize();
                let p = Math.acos(oi(i[f - 1].dot(i[f]), -1, 1));
                s[f].applyMatrix4(l.makeRotationAxis(a, p));
            }
            o[f].crossVectors(i[f], s[f]);
        }
        if (e === !0) {
            let f = Math.acos(oi(s[0].dot(s[t]), -1, 1));
            f /= t, i[0].dot(a.crossVectors(s[0], s[t])) > 0 && (f = -f);
            for(let p = 1; p <= t; p++)s[p].applyMatrix4(l.makeRotationAxis(i[p], f * p)), o[p].crossVectors(i[p], s[p]);
        }
        return {
            tangents: i,
            normals: s,
            binormals: o
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
    fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
}, mc = class extends ss {
    constructor(t = 0, e = 0, r = 1, i = 1, s = 0, o = Math.PI * 2, a = !1, l = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = r, this.yRadius = i, this.aStartAngle = s, this.aEndAngle = o, this.aClockwise = a, this.aRotation = l;
    }
    getPoint(t, e) {
        let r = e || new N, i = Math.PI * 2, s = this.aEndAngle - this.aStartAngle, o = Math.abs(s) < Number.EPSILON;
        for(; s < 0;)s += i;
        for(; s > i;)s -= i;
        s < Number.EPSILON && (o ? s = 0 : s = i), this.aClockwise === !0 && !o && (s === i ? s = -i : s = s - i);
        let a = this.aStartAngle + t * s, l = this.aX + this.xRadius * Math.cos(a), u = this.aY + this.yRadius * Math.sin(a);
        if (this.aRotation !== 0) {
            let c = Math.cos(this.aRotation), d = Math.sin(this.aRotation), h = l - this.aX, f = u - this.aY;
            l = h * c - f * d + this.aX, u = h * d + f * c + this.aY;
        }
        return r.set(l, u);
    }
    copy(t) {
        return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
}, US = class extends mc {
    constructor(t, e, r, i, s, o){
        super(t, e, r, r, i, s, o), this.isArcCurve = !0, this.type = "ArcCurve";
    }
};
function hw() {
    let n1 = 0, t = 0, e = 0, r = 0;
    function i(s, o, a, l) {
        n1 = s, t = a, e = -3 * s + 3 * o - 2 * a - l, r = 2 * s - 2 * o + a + l;
    }
    return {
        initCatmullRom: function(s, o, a, l, u) {
            i(o, a, u * (a - s), u * (l - o));
        },
        initNonuniformCatmullRom: function(s, o, a, l, u, c, d) {
            let h = (o - s) / u - (a - s) / (u + c) + (a - o) / c, f = (a - o) / c - (l - o) / (c + d) + (l - a) / d;
            h *= c, f *= c, i(o, a, h, f);
        },
        calc: function(s) {
            let o = s * s, a = o * s;
            return n1 + t * s + e * o + r * a;
        }
    };
}
var jg = new _, yS = new hw, vS = new hw, xS = new hw, GS = class extends ss {
    constructor(t = [], e = !1, r = "centripetal", i = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = r, this.tension = i;
    }
    getPoint(t, e = new _) {
        let r = e, i = this.points, s = i.length, o = (s - (this.closed ? 0 : 1)) * t, a = Math.floor(o), l = o - a;
        this.closed ? a += a > 0 ? 0 : (Math.floor(Math.abs(a) / s) + 1) * s : l === 0 && a === s - 1 && (a = s - 2, l = 1);
        let u, c;
        this.closed || a > 0 ? u = i[(a - 1) % s] : (jg.subVectors(i[0], i[1]).add(i[0]), u = jg);
        let d = i[a % s], h = i[(a + 1) % s];
        if (this.closed || a + 2 < s ? c = i[(a + 2) % s] : (jg.subVectors(i[s - 1], i[s - 2]).add(i[s - 1]), c = jg), this.curveType === "centripetal" || this.curveType === "chordal") {
            let f = this.curveType === "chordal" ? .5 : .25, p = Math.pow(u.distanceToSquared(d), f), m = Math.pow(d.distanceToSquared(h), f), g = Math.pow(h.distanceToSquared(c), f);
            m < 1e-4 && (m = 1), p < 1e-4 && (p = m), g < 1e-4 && (g = m), yS.initNonuniformCatmullRom(u.x, d.x, h.x, c.x, p, m, g), vS.initNonuniformCatmullRom(u.y, d.y, h.y, c.y, p, m, g), xS.initNonuniformCatmullRom(u.z, d.z, h.z, c.z, p, m, g);
        } else this.curveType === "catmullrom" && (yS.initCatmullRom(u.x, d.x, h.x, c.x, this.tension), vS.initCatmullRom(u.y, d.y, h.y, c.y, this.tension), xS.initCatmullRom(u.z, d.z, h.z, c.z, this.tension));
        return r.set(yS.calc(l), vS.calc(l), xS.calc(l)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new _().fromArray(i));
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
};
function aM(n1, t, e, r, i) {
    let s = (r - t) * .5, o = (i - e) * .5, a = n1 * n1, l = n1 * a;
    return (2 * e - 2 * r + s + o) * l + (-3 * e + 3 * r - 2 * s - o) * a + s * n1 + e;
}
function IG(n1, t) {
    let e = 1 - n1;
    return e * e * t;
}
function RG(n1, t) {
    return 2 * (1 - n1) * n1 * t;
}
function LG(n1, t) {
    return n1 * n1 * t;
}
function sp(n1, t, e, r) {
    return IG(n1, t) + RG(n1, e) + LG(n1, r);
}
function BG(n1, t) {
    let e = 1 - n1;
    return e * e * e * t;
}
function NG(n1, t) {
    let e = 1 - n1;
    return 3 * e * e * n1 * t;
}
function FG(n1, t) {
    return 3 * (1 - n1) * n1 * n1 * t;
}
function kG(n1, t) {
    return n1 * n1 * n1 * t;
}
function op(n1, t, e, r, i) {
    return BG(n1, t) + NG(n1, e) + FG(n1, r) + kG(n1, i);
}
var rn = class extends ss {
    constructor(t = new N, e = new N, r = new N, i = new N){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new N) {
        let r = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return r.set(op(t, i.x, s.x, o.x, a.x), op(t, i.y, s.y, o.y, a.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, gc = class extends ss {
    constructor(t = new _, e = new _, r = new _, i = new _){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new _) {
        let r = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return r.set(op(t, i.x, s.x, o.x, a.x), op(t, i.y, s.y, o.y, a.y), op(t, i.z, s.z, o.z, a.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, nn = class extends ss {
    constructor(t = new N, e = new N){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new N) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e) {
        let r = e || new N;
        return r.copy(this.v2).sub(this.v1).normalize(), r;
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, pp = class extends ss {
    constructor(t = new _, e = new _){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new _) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, Wn = class extends ss {
    constructor(t = new N, e = new N, r = new N){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new N) {
        let r = e, i = this.v0, s = this.v1, o = this.v2;
        return r.set(sp(t, i.x, s.x, o.x), sp(t, i.y, s.y, o.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, jS = class extends ss {
    constructor(t = new _, e = new _, r = new _){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new _) {
        let r = e, i = this.v0, s = this.v1, o = this.v2;
        return r.set(sp(t, i.x, s.x, o.x), sp(t, i.y, s.y, o.y), sp(t, i.z, s.z, o.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, Ru = class extends ss {
    constructor(t = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
    }
    getPoint(t, e = new N) {
        let r = e, i = this.points, s = (i.length - 1) * t, o = Math.floor(s), a = s - o, l = i[o === 0 ? o : o - 1], u = i[o], c = i[o > i.length - 2 ? i.length - 1 : o + 1], d = i[o > i.length - 3 ? i.length - 1 : o + 2];
        return r.set(aM(a, l.x, u.x, c.x, d.x), aM(a, l.y, u.y, c.y, d.y)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new N().fromArray(i));
        }
        return this;
    }
}, zG = Object.freeze({
    __proto__: null,
    ArcCurve: US,
    CatmullRomCurve3: GS,
    CubicBezierCurve: rn,
    CubicBezierCurve3: gc,
    EllipseCurve: mc,
    LineCurve: nn,
    LineCurve3: pp,
    QuadraticBezierCurve: Wn,
    QuadraticBezierCurve3: jS,
    SplineCurve: Ru
}), mp = class extends ss {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
        this.curves.push(t);
    }
    closePath() {
        let t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        t.equals(e) || this.curves.push(new nn(e, t));
    }
    getPoint(t, e) {
        let r = t * this.getLength(), i = this.getCurveLengths(), s = 0;
        for(; s < i.length;){
            if (i[s] >= r) {
                let o = i[s] - r, a = this.curves[s], l = a.getLength(), u = l === 0 ? 0 : 1 - o / l;
                return a.getPointAt(u, e);
            }
            s++;
        }
        return null;
    }
    getLength() {
        let t = this.getCurveLengths();
        return t[t.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        let t = [], e = 0;
        for(let r = 0, i = this.curves.length; r < i; r++)e += this.curves[r].getLength(), t.push(e);
        return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
        let e = [], r;
        for(let i = 0, s = this.curves; i < s.length; i++){
            let o = s[i], a = o.isEllipseCurve ? t * 2 : o.isLineCurve || o.isLineCurve3 ? 1 : o.isSplineCurve ? t * o.points.length : t, l = o.getPoints(a);
            for(let u = 0; u < l.length; u++){
                let c = l[u];
                r && r.equals(c) || (e.push(c), r = c);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t) {
        super.copy(t), this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(i.clone());
        }
        return this.autoClose = t.autoClose, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.autoClose = this.autoClose, t.curves = [];
        for(let e = 0, r = this.curves.length; e < r; e++){
            let i = this.curves[e];
            t.curves.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(new zG[i.type]().fromJSON(i));
        }
        return this;
    }
}, yc = class extends mp {
    constructor(t){
        super(), this.type = "Path", this.currentPoint = new N, t && this.setFromPoints(t);
    }
    setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);
        for(let e = 1, r = t.length; e < r; e++)this.lineTo(t[e].x, t[e].y);
        return this;
    }
    moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
    }
    lineTo(t, e) {
        let r = new nn(this.currentPoint.clone(), new N(t, e));
        return this.curves.push(r), this.currentPoint.set(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        let s = new Wn(this.currentPoint.clone(), new N(t, e), new N(r, i));
        return this.curves.push(s), this.currentPoint.set(r, i), this;
    }
    bezierCurveTo(t, e, r, i, s, o) {
        let a = new rn(this.currentPoint.clone(), new N(t, e), new N(r, i), new N(s, o));
        return this.curves.push(a), this.currentPoint.set(s, o), this;
    }
    splineThru(t) {
        let e = [
            this.currentPoint.clone()
        ].concat(t), r = new Ru(e);
        return this.curves.push(r), this.currentPoint.copy(t[t.length - 1]), this;
    }
    arc(t, e, r, i, s, o) {
        let a = this.currentPoint.x, l = this.currentPoint.y;
        return this.absarc(t + a, e + l, r, i, s, o), this;
    }
    absarc(t, e, r, i, s, o) {
        return this.absellipse(t, e, r, r, i, s, o), this;
    }
    ellipse(t, e, r, i, s, o, a, l) {
        let u = this.currentPoint.x, c = this.currentPoint.y;
        return this.absellipse(t + u, e + c, r, i, s, o, a, l), this;
    }
    absellipse(t, e, r, i, s, o, a, l) {
        let u = new mc(t, e, r, i, s, o, a, l);
        if (this.curves.length > 0) {
            let d = u.getPoint(0);
            d.equals(this.currentPoint) || this.lineTo(d.x, d.y);
        }
        this.curves.push(u);
        let c = u.getPoint(1);
        return this.currentPoint.copy(c), this;
    }
    copy(t) {
        return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.currentPoint = this.currentPoint.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
    }
}, Lu = class extends we {
    constructor(t = [
        new N(0, -0.5),
        new N(.5, 0),
        new N(0, .5)
    ], e = 12, r = 0, i = Math.PI * 2){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: t,
            segments: e,
            phiStart: r,
            phiLength: i
        }, e = Math.floor(e), i = oi(i, 0, Math.PI * 2);
        let s = [], o = [], a = [], l = [], u = [], c = 1 / e, d = new _, h = new N, f = new _, p = new _, m = new _, g = 0, y = 0;
        for(let v = 0; v <= t.length - 1; v++)switch(v){
            case 0:
                g = t[v + 1].x - t[v].x, y = t[v + 1].y - t[v].y, f.x = y * 1, f.y = -g, f.z = y * 0, m.copy(f), f.normalize(), l.push(f.x, f.y, f.z);
                break;
            case t.length - 1:
                l.push(m.x, m.y, m.z);
                break;
            default:
                g = t[v + 1].x - t[v].x, y = t[v + 1].y - t[v].y, f.x = y * 1, f.y = -g, f.z = y * 0, p.copy(f), f.x += m.x, f.y += m.y, f.z += m.z, f.normalize(), l.push(f.x, f.y, f.z), m.copy(p);
        }
        for(let v = 0; v <= e; v++){
            let x = r + v * c * i, S = Math.sin(x), w = Math.cos(x);
            for(let A = 0; A <= t.length - 1; A++){
                d.x = t[A].x * S, d.y = t[A].y, d.z = t[A].x * w, o.push(d.x, d.y, d.z), h.x = v / e, h.y = A / (t.length - 1), a.push(h.x, h.y);
                let E = l[3 * A + 0] * S, b = l[3 * A + 1], T = l[3 * A + 0] * w;
                u.push(E, b, T);
            }
        }
        for(let v = 0; v < e; v++)for(let x = 0; x < t.length - 1; x++){
            let S = x + v * t.length, w = S, A = S + t.length, E = S + t.length + 1, b = S + 1;
            s.push(w, A, b), s.push(E, b, A);
        }
        this.setIndex(s), this.setAttribute("position", new be(o, 3)), this.setAttribute("uv", new be(a, 2)), this.setAttribute("normal", new be(u, 3));
    }
    static fromJSON(t) {
        return new Lu(t.points, t.segments, t.phiStart, t.phiLength);
    }
};
var vc = class extends we {
    constructor(t = 1, e = 1, r = 1, i = 32, s = 1, o = !1, a = 0, l = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: t,
            radiusBottom: e,
            height: r,
            radialSegments: i,
            heightSegments: s,
            openEnded: o,
            thetaStart: a,
            thetaLength: l
        };
        let u = this;
        i = Math.floor(i), s = Math.floor(s);
        let c = [], d = [], h = [], f = [], p = 0, m = [], g = r / 2, y = 0;
        v(), o === !1 && (t > 0 && x(!0), e > 0 && x(!1)), this.setIndex(c), this.setAttribute("position", new be(d, 3)), this.setAttribute("normal", new be(h, 3)), this.setAttribute("uv", new be(f, 2));
        function v() {
            let S = new _, w = new _, A = 0, E = (e - t) / r;
            for(let b = 0; b <= s; b++){
                let T = [], M = b / s, C = M * (e - t) + t;
                for(let P = 0; P <= i; P++){
                    let D = P / i, O = D * l + a, I = Math.sin(O), z = Math.cos(O);
                    w.x = C * I, w.y = -M * r + g, w.z = C * z, d.push(w.x, w.y, w.z), S.set(I, E, z).normalize(), h.push(S.x, S.y, S.z), f.push(D, 1 - M), T.push(p++);
                }
                m.push(T);
            }
            for(let b = 0; b < i; b++)for(let T = 0; T < s; T++){
                let M = m[T][b], C = m[T + 1][b], P = m[T + 1][b + 1], D = m[T][b + 1];
                c.push(M, C, D), c.push(C, P, D), A += 6;
            }
            u.addGroup(y, A, 0), y += A;
        }
        function x(S) {
            let w = p, A = new N, E = new _, b = 0, T = S === !0 ? t : e, M = S === !0 ? 1 : -1;
            for(let P = 1; P <= i; P++)d.push(0, g * M, 0), h.push(0, M, 0), f.push(.5, .5), p++;
            let C = p;
            for(let P = 0; P <= i; P++){
                let O = P / i * l + a, I = Math.cos(O), z = Math.sin(O);
                E.x = T * z, E.y = g * M, E.z = T * I, d.push(E.x, E.y, E.z), h.push(0, M, 0), A.x = I * .5 + .5, A.y = z * .5 * M + .5, f.push(A.x, A.y), p++;
            }
            for(let P = 0; P < i; P++){
                let D = w + P, O = C + P;
                S === !0 ? c.push(O, O + 1, D) : c.push(O + 1, O, D), b += 3;
            }
            u.addGroup(y, b, S === !0 ? 1 : 2), y += b;
        }
    }
    static fromJSON(t) {
        return new vc(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, $a = class extends vc {
    constructor(t = 1, e = 1, r = 32, i = 1, s = !1, o = 0, a = Math.PI * 2){
        super(0, t, e, r, i, s, o, a), this.type = "ConeGeometry", this.parameters = {
            radius: t,
            height: e,
            radialSegments: r,
            heightSegments: i,
            openEnded: s,
            thetaStart: o,
            thetaLength: a
        };
    }
    static fromJSON(t) {
        return new $a(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, Bu = class extends we {
    constructor(t = [], e = [], r = 1, i = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: t,
            indices: e,
            radius: r,
            detail: i
        };
        let s = [], o = [];
        a(i), u(r), c(), this.setAttribute("position", new be(s, 3)), this.setAttribute("normal", new be(s.slice(), 3)), this.setAttribute("uv", new be(o, 2)), i === 0 ? this.computeVertexNormals() : this.normalizeNormals();
        function a(v) {
            let x = new _, S = new _, w = new _;
            for(let A = 0; A < e.length; A += 3)f(e[A + 0], x), f(e[A + 1], S), f(e[A + 2], w), l(x, S, w, v);
        }
        function l(v, x, S, w) {
            let A = w + 1, E = [];
            for(let b = 0; b <= A; b++){
                E[b] = [];
                let T = v.clone().lerp(S, b / A), M = x.clone().lerp(S, b / A), C = A - b;
                for(let P = 0; P <= C; P++)P === 0 && b === A ? E[b][P] = T : E[b][P] = T.clone().lerp(M, P / C);
            }
            for(let b = 0; b < A; b++)for(let T = 0; T < 2 * (A - b) - 1; T++){
                let M = Math.floor(T / 2);
                T % 2 === 0 ? (h(E[b][M + 1]), h(E[b + 1][M]), h(E[b][M])) : (h(E[b][M + 1]), h(E[b + 1][M + 1]), h(E[b + 1][M]));
            }
        }
        function u(v) {
            let x = new _;
            for(let S = 0; S < s.length; S += 3)x.x = s[S + 0], x.y = s[S + 1], x.z = s[S + 2], x.normalize().multiplyScalar(v), s[S + 0] = x.x, s[S + 1] = x.y, s[S + 2] = x.z;
        }
        function c() {
            let v = new _;
            for(let x = 0; x < s.length; x += 3){
                v.x = s[x + 0], v.y = s[x + 1], v.z = s[x + 2];
                let S = g(v) / 2 / Math.PI + .5, w = y(v) / Math.PI + .5;
                o.push(S, 1 - w);
            }
            p(), d();
        }
        function d() {
            for(let v = 0; v < o.length; v += 6){
                let x = o[v + 0], S = o[v + 2], w = o[v + 4], A = Math.max(x, S, w), E = Math.min(x, S, w);
                A > .9 && E < .1 && (x < .2 && (o[v + 0] += 1), S < .2 && (o[v + 2] += 1), w < .2 && (o[v + 4] += 1));
            }
        }
        function h(v) {
            s.push(v.x, v.y, v.z);
        }
        function f(v, x) {
            let S = v * 3;
            x.x = t[S + 0], x.y = t[S + 1], x.z = t[S + 2];
        }
        function p() {
            let v = new _, x = new _, S = new _, w = new _, A = new N, E = new N, b = new N;
            for(let T = 0, M = 0; T < s.length; T += 9, M += 6){
                v.set(s[T + 0], s[T + 1], s[T + 2]), x.set(s[T + 3], s[T + 4], s[T + 5]), S.set(s[T + 6], s[T + 7], s[T + 8]), A.set(o[M + 0], o[M + 1]), E.set(o[M + 2], o[M + 3]), b.set(o[M + 4], o[M + 5]), w.copy(v).add(x).add(S).divideScalar(3);
                let C = g(w);
                m(A, M + 0, v, C), m(E, M + 2, x, C), m(b, M + 4, S, C);
            }
        }
        function m(v, x, S, w) {
            w < 0 && v.x === 1 && (o[x] = v.x - 1), S.x === 0 && S.z === 0 && (o[x] = w / 2 / Math.PI + .5);
        }
        function g(v) {
            return Math.atan2(v.z, -v.x);
        }
        function y(v) {
            return Math.atan2(-v.y, Math.sqrt(v.x * v.x + v.z * v.z));
        }
    }
    static fromJSON(t) {
        return new Bu(t.vertices, t.indices, t.radius, t.details);
    }
}, Nu = class extends Bu {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = 1 / r, s = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            0,
            -r,
            0,
            -i,
            r,
            0,
            -i,
            -r,
            0,
            i,
            r,
            0,
            i
        ], o = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(s, o, t, e), this.type = "DodecahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new Nu(t.radius, t.detail);
    }
};
var oa = class extends yc {
    constructor(t){
        super(t), this.uuid = rs(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t) {
        let e = [];
        for(let r = 0, i = this.holes.length; r < i; r++)e[r] = this.holes[r].getPoints(t);
        return e;
    }
    extractPoints(t) {
        return {
            shape: this.getPoints(t),
            holes: this.getPointsHoles(t)
        };
    }
    copy(t) {
        super.copy(t), this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.uuid = this.uuid, t.holes = [];
        for(let e = 0, r = this.holes.length; e < r; e++){
            let i = this.holes[e];
            t.holes.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(new yc().fromJSON(i));
        }
        return this;
    }
}, VG = {
    triangulate: function(n1, t, e = 2) {
        let r = t && t.length, i = r ? t[0] * e : n1.length, s = FM(n1, 0, i, e, !0), o = [];
        if (!s || s.next === s.prev) return o;
        let a, l, u, c, d, h, f;
        if (r && (s = WG(n1, t, s, e)), n1.length > 80 * e) {
            a = u = n1[0], l = c = n1[1];
            for(let p = e; p < i; p += e)d = n1[p], h = n1[p + 1], d < a && (a = d), h < l && (l = h), d > u && (u = d), h > c && (c = h);
            f = Math.max(u - a, c - l), f = f !== 0 ? 32767 / f : 0;
        }
        return gp(s, o, e, a, l, f, 0), o;
    }
};
function FM(n1, t, e, r, i) {
    let s, o;
    if (i === r4(n1, t, e, r) > 0) for(s = t; s < e; s += r)o = lM(s, n1[s], n1[s + 1], o);
    else for(s = e - r; s >= t; s -= r)o = lM(s, n1[s], n1[s + 1], o);
    return o && Cy(o, o.next) && (vp(o), o = o.next), o;
}
function xc(n1, t) {
    if (!n1) return n1;
    t || (t = n1);
    let e = n1, r;
    do if (r = !1, !e.steiner && (Cy(e, e.next) || Or(e.prev, e, e.next) === 0)) {
        if (vp(e), e = t = e.prev, e === e.next) break;
        r = !0;
    } else e = e.next;
    while (r || e !== t);
    return t;
}
function gp(n1, t, e, r, i, s, o) {
    if (!n1) return;
    !o && s && KG(n1, r, i, s);
    let a = n1, l, u;
    for(; n1.prev !== n1.next;){
        if (l = n1.prev, u = n1.next, s ? GG(n1, r, i, s) : UG(n1)) {
            t.push(l.i / e | 0), t.push(n1.i / e | 0), t.push(u.i / e | 0), vp(n1), n1 = u.next, a = u.next;
            continue;
        }
        if (n1 = u, n1 === a) {
            o ? o === 1 ? (n1 = jG(xc(n1), t, e), gp(n1, t, e, r, i, s, 2)) : o === 2 && HG(n1, t, e, r, i, s) : gp(xc(n1), t, e, r, i, s, 1);
            break;
        }
    }
}
function UG(n1) {
    let t = n1.prev, e = n1, r = n1.next;
    if (Or(t, e, r) >= 0) return !1;
    let i = t.x, s = e.x, o = r.x, a = t.y, l = e.y, u = r.y, c = i < s ? i < o ? i : o : s < o ? s : o, d = a < l ? a < u ? a : u : l < u ? l : u, h = i > s ? i > o ? i : o : s > o ? s : o, f = a > l ? a > u ? a : u : l > u ? l : u, p = r.next;
    for(; p !== t;){
        if (p.x >= c && p.x <= h && p.y >= d && p.y <= f && Mu(i, a, s, l, o, u, p.x, p.y) && Or(p.prev, p, p.next) >= 0) return !1;
        p = p.next;
    }
    return !0;
}
function GG(n1, t, e, r) {
    let i = n1.prev, s = n1, o = n1.next;
    if (Or(i, s, o) >= 0) return !1;
    let a = i.x, l = s.x, u = o.x, c = i.y, d = s.y, h = o.y, f = a < l ? a < u ? a : u : l < u ? l : u, p = c < d ? c < h ? c : h : d < h ? d : h, m = a > l ? a > u ? a : u : l > u ? l : u, g = c > d ? c > h ? c : h : d > h ? d : h, y = HS(f, p, t, e, r), v = HS(m, g, t, e, r), x = n1.prevZ, S = n1.nextZ;
    for(; x && x.z >= y && S && S.z <= v;){
        if (x.x >= f && x.x <= m && x.y >= p && x.y <= g && x !== i && x !== o && Mu(a, c, l, d, u, h, x.x, x.y) && Or(x.prev, x, x.next) >= 0 || (x = x.prevZ, S.x >= f && S.x <= m && S.y >= p && S.y <= g && S !== i && S !== o && Mu(a, c, l, d, u, h, S.x, S.y) && Or(S.prev, S, S.next) >= 0)) return !1;
        S = S.nextZ;
    }
    for(; x && x.z >= y;){
        if (x.x >= f && x.x <= m && x.y >= p && x.y <= g && x !== i && x !== o && Mu(a, c, l, d, u, h, x.x, x.y) && Or(x.prev, x, x.next) >= 0) return !1;
        x = x.prevZ;
    }
    for(; S && S.z <= v;){
        if (S.x >= f && S.x <= m && S.y >= p && S.y <= g && S !== i && S !== o && Mu(a, c, l, d, u, h, S.x, S.y) && Or(S.prev, S, S.next) >= 0) return !1;
        S = S.nextZ;
    }
    return !0;
}
function jG(n1, t, e) {
    let r = n1;
    do {
        let i = r.prev, s = r.next.next;
        !Cy(i, s) && kM(i, r, r.next, s) && yp(i, s) && yp(s, i) && (t.push(i.i / e | 0), t.push(r.i / e | 0), t.push(s.i / e | 0), vp(r), vp(r.next), r = n1 = s), r = r.next;
    }while (r !== n1);
    return xc(r);
}
function HG(n1, t, e, r, i, s) {
    let o = n1;
    do {
        let a = o.next.next;
        for(; a !== o.prev;){
            if (o.i !== a.i && $G(o, a)) {
                let l = zM(o, a);
                o = xc(o, o.next), l = xc(l, l.next), gp(o, t, e, r, i, s, 0), gp(l, t, e, r, i, s, 0);
                return;
            }
            a = a.next;
        }
        o = o.next;
    }while (o !== n1);
}
function WG(n1, t, e, r) {
    let i = [], s, o, a, l, u;
    for(s = 0, o = t.length; s < o; s++)a = t[s] * r, l = s < o - 1 ? t[s + 1] * r : n1.length, u = FM(n1, a, l, r, !1), u === u.next && (u.steiner = !0), i.push(JG(u));
    for(i.sort(qG), s = 0; s < i.length; s++)e = YG(i[s], e);
    return e;
}
function qG(n1, t) {
    return n1.x - t.x;
}
function YG(n1, t) {
    let e = XG(n1, t);
    if (!e) return t;
    let r = zM(e, n1);
    return xc(r, r.next), xc(e, e.next);
}
function XG(n1, t) {
    let e = t, r = -1 / 0, i, s = n1.x, o = n1.y;
    do {
        if (o <= e.y && o >= e.next.y && e.next.y !== e.y) {
            let h = e.x + (o - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
            if (h <= s && h > r && (r = h, i = e.x < e.next.x ? e : e.next, h === s)) return i;
        }
        e = e.next;
    }while (e !== t);
    if (!i) return null;
    let a = i, l = i.x, u = i.y, c = 1 / 0, d;
    e = i;
    do s >= e.x && e.x >= l && s !== e.x && Mu(o < u ? s : r, o, l, u, o < u ? r : s, o, e.x, e.y) && (d = Math.abs(o - e.y) / (s - e.x), yp(e, n1) && (d < c || d === c && (e.x > i.x || e.x === i.x && QG(i, e))) && (i = e, c = d)), e = e.next;
    while (e !== a);
    return i;
}
function QG(n1, t) {
    return Or(n1.prev, n1, t.prev) < 0 && Or(t.next, n1, n1.next) < 0;
}
function KG(n1, t, e, r) {
    let i = n1;
    do i.z === 0 && (i.z = HS(i.x, i.y, t, e, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
    while (i !== n1);
    i.prevZ.nextZ = null, i.prevZ = null, ZG(i);
}
function ZG(n1) {
    let t, e, r, i, s, o, a, l, u = 1;
    do {
        for(e = n1, n1 = null, s = null, o = 0; e;){
            for(o++, r = e, a = 0, t = 0; t < u && (a++, r = r.nextZ, !!r); t++);
            for(l = u; a > 0 || l > 0 && r;)a !== 0 && (l === 0 || !r || e.z <= r.z) ? (i = e, e = e.nextZ, a--) : (i = r, r = r.nextZ, l--), s ? s.nextZ = i : n1 = i, i.prevZ = s, s = i;
            e = r;
        }
        s.nextZ = null, u *= 2;
    }while (o > 1);
    return n1;
}
function HS(n1, t, e, r, i) {
    return n1 = (n1 - e) * i | 0, t = (t - r) * i | 0, n1 = (n1 | n1 << 8) & 16711935, n1 = (n1 | n1 << 4) & 252645135, n1 = (n1 | n1 << 2) & 858993459, n1 = (n1 | n1 << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, n1 | t << 1;
}
function JG(n1) {
    let t = n1, e = n1;
    do (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
    while (t !== n1);
    return e;
}
function Mu(n1, t, e, r, i, s, o, a) {
    return (i - o) * (t - a) >= (n1 - o) * (s - a) && (n1 - o) * (r - a) >= (e - o) * (t - a) && (e - o) * (s - a) >= (i - o) * (r - a);
}
function $G(n1, t) {
    return n1.next.i !== t.i && n1.prev.i !== t.i && !e4(n1, t) && (yp(n1, t) && yp(t, n1) && t4(n1, t) && (Or(n1.prev, n1, t.prev) || Or(n1, t.prev, t)) || Cy(n1, t) && Or(n1.prev, n1, n1.next) > 0 && Or(t.prev, t, t.next) > 0);
}
function Or(n1, t, e) {
    return (t.y - n1.y) * (e.x - t.x) - (t.x - n1.x) * (e.y - t.y);
}
function Cy(n1, t) {
    return n1.x === t.x && n1.y === t.y;
}
function kM(n1, t, e, r) {
    let i = Wg(Or(n1, t, e)), s = Wg(Or(n1, t, r)), o = Wg(Or(e, r, n1)), a = Wg(Or(e, r, t));
    return !!(i !== s && o !== a || i === 0 && Hg(n1, e, t) || s === 0 && Hg(n1, r, t) || o === 0 && Hg(e, n1, r) || a === 0 && Hg(e, t, r));
}
function Hg(n1, t, e) {
    return t.x <= Math.max(n1.x, e.x) && t.x >= Math.min(n1.x, e.x) && t.y <= Math.max(n1.y, e.y) && t.y >= Math.min(n1.y, e.y);
}
function Wg(n1) {
    return n1 > 0 ? 1 : n1 < 0 ? -1 : 0;
}
function e4(n1, t) {
    let e = n1;
    do {
        if (e.i !== n1.i && e.next.i !== n1.i && e.i !== t.i && e.next.i !== t.i && kM(e, e.next, n1, t)) return !0;
        e = e.next;
    }while (e !== n1);
    return !1;
}
function yp(n1, t) {
    return Or(n1.prev, n1, n1.next) < 0 ? Or(n1, t, n1.next) >= 0 && Or(n1, n1.prev, t) >= 0 : Or(n1, t, n1.prev) < 0 || Or(n1, n1.next, t) < 0;
}
function t4(n1, t) {
    let e = n1, r = !1, i = (n1.x + t.x) / 2, s = (n1.y + t.y) / 2;
    do e.y > s != e.next.y > s && e.next.y !== e.y && i < (e.next.x - e.x) * (s - e.y) / (e.next.y - e.y) + e.x && (r = !r), e = e.next;
    while (e !== n1);
    return r;
}
function zM(n1, t) {
    let e = new WS(n1.i, n1.x, n1.y), r = new WS(t.i, t.x, t.y), i = n1.next, s = t.prev;
    return n1.next = t, t.prev = n1, e.next = i, i.prev = e, r.next = e, e.prev = r, s.next = r, r.prev = s, r;
}
function lM(n1, t, e, r) {
    let i = new WS(n1, t, e);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function vp(n1) {
    n1.next.prev = n1.prev, n1.prev.next = n1.next, n1.prevZ && (n1.prevZ.nextZ = n1.nextZ), n1.nextZ && (n1.nextZ.prevZ = n1.prevZ);
}
function WS(n1, t, e) {
    this.i = n1, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function r4(n1, t, e, r) {
    let i = 0;
    for(let s = t, o = e - r; s < e; s += r)i += (n1[o] - n1[s]) * (n1[s + 1] + n1[o + 1]), o = s;
    return i;
}
var Fu = class {
    static area(t) {
        let e = t.length, r = 0;
        for(let i = e - 1, s = 0; s < e; i = s++)r += t[i].x * t[s].y - t[s].x * t[i].y;
        return r * .5;
    }
    static isClockWise(t) {
        return Fu.area(t) < 0;
    }
    static triangulateShape(t, e) {
        let r = [], i = [], s = [];
        cM(t), uM(r, t);
        let o = t.length;
        e.forEach(cM);
        for(let l = 0; l < e.length; l++)i.push(o), o += e[l].length, uM(r, e[l]);
        let a = VG.triangulate(r, i);
        for(let l = 0; l < a.length; l += 3)s.push(a.slice(l, l + 3));
        return s;
    }
};
function cM(n1) {
    let t = n1.length;
    t > 2 && n1[t - 1].equals(n1[0]) && n1.pop();
}
function uM(n1, t) {
    for(let e = 0; e < t.length; e++)n1.push(t[e].x), n1.push(t[e].y);
}
var ku = class extends Bu {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = [
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            0,
            0,
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            r,
            0,
            -1,
            r,
            0,
            1,
            -r,
            0,
            -1,
            -r,
            0,
            1
        ], s = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(i, s, t, e), this.type = "IcosahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new ku(t.radius, t.detail);
    }
};
var Bs = class extends we {
    constructor(t = 1, e = 32, r = 16, i = 0, s = Math.PI * 2, o = 0, a = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: t,
            widthSegments: e,
            heightSegments: r,
            phiStart: i,
            phiLength: s,
            thetaStart: o,
            thetaLength: a
        }, e = Math.max(3, Math.floor(e)), r = Math.max(2, Math.floor(r));
        let l = Math.min(o + a, Math.PI), u = 0, c = [], d = new _, h = new _, f = [], p = [], m = [], g = [];
        for(let y = 0; y <= r; y++){
            let v = [], x = y / r, S = 0;
            y == 0 && o == 0 ? S = .5 / e : y == r && l == Math.PI && (S = -0.5 / e);
            for(let w = 0; w <= e; w++){
                let A = w / e;
                d.x = -t * Math.cos(i + A * s) * Math.sin(o + x * a), d.y = t * Math.cos(o + x * a), d.z = t * Math.sin(i + A * s) * Math.sin(o + x * a), p.push(d.x, d.y, d.z), h.copy(d).normalize(), m.push(h.x, h.y, h.z), g.push(A + S, 1 - x), v.push(u++);
            }
            c.push(v);
        }
        for(let y = 0; y < r; y++)for(let v = 0; v < e; v++){
            let x = c[y][v + 1], S = c[y][v], w = c[y + 1][v], A = c[y + 1][v + 1];
            (y !== 0 || o > 0) && f.push(x, S, A), (y !== r - 1 || l < Math.PI) && f.push(S, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new be(p, 3)), this.setAttribute("normal", new be(m, 3)), this.setAttribute("uv", new be(g, 2));
    }
    static fromJSON(t) {
        return new Bs(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
    }
};
var zu = class extends we {
    constructor(t = 1, e = .4, r = 12, i = 48, s = Math.PI * 2){
        super(), this.type = "TorusGeometry", this.parameters = {
            radius: t,
            tube: e,
            radialSegments: r,
            tubularSegments: i,
            arc: s
        }, r = Math.floor(r), i = Math.floor(i);
        let o = [], a = [], l = [], u = [], c = new _, d = new _, h = new _;
        for(let f = 0; f <= r; f++)for(let p = 0; p <= i; p++){
            let m = p / i * s, g = f / r * Math.PI * 2;
            d.x = (t + e * Math.cos(g)) * Math.cos(m), d.y = (t + e * Math.cos(g)) * Math.sin(m), d.z = e * Math.sin(g), a.push(d.x, d.y, d.z), c.x = t * Math.cos(m), c.y = t * Math.sin(m), h.subVectors(d, c).normalize(), l.push(h.x, h.y, h.z), u.push(p / i), u.push(f / r);
        }
        for(let f = 1; f <= r; f++)for(let p = 1; p <= i; p++){
            let m = (i + 1) * f + p - 1, g = (i + 1) * (f - 1) + p - 1, y = (i + 1) * (f - 1) + p, v = (i + 1) * f + p;
            o.push(m, g, v), o.push(g, y, v);
        }
        this.setIndex(o), this.setAttribute("position", new be(a, 3)), this.setAttribute("normal", new be(l, 3)), this.setAttribute("uv", new be(u, 2));
    }
    static fromJSON(t) {
        return new zu(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
    }
}, Vu = class extends we {
    constructor(t = 1, e = .4, r = 64, i = 8, s = 2, o = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: t,
            tube: e,
            tubularSegments: r,
            radialSegments: i,
            p: s,
            q: o
        }, r = Math.floor(r), i = Math.floor(i);
        let a = [], l = [], u = [], c = [], d = new _, h = new _, f = new _, p = new _, m = new _, g = new _, y = new _;
        for(let x = 0; x <= r; ++x){
            let S = x / r * s * Math.PI * 2;
            v(S, s, o, t, f), v(S + .01, s, o, t, p), g.subVectors(p, f), y.addVectors(p, f), m.crossVectors(g, y), y.crossVectors(m, g), m.normalize(), y.normalize();
            for(let w = 0; w <= i; ++w){
                let A = w / i * Math.PI * 2, E = -e * Math.cos(A), b = e * Math.sin(A);
                d.x = f.x + (E * y.x + b * m.x), d.y = f.y + (E * y.y + b * m.y), d.z = f.z + (E * y.z + b * m.z), l.push(d.x, d.y, d.z), h.subVectors(d, f).normalize(), u.push(h.x, h.y, h.z), c.push(x / r), c.push(w / i);
            }
        }
        for(let x = 1; x <= r; x++)for(let S = 1; S <= i; S++){
            let w = (i + 1) * (x - 1) + (S - 1), A = (i + 1) * x + (S - 1), E = (i + 1) * x + S, b = (i + 1) * (x - 1) + S;
            a.push(w, A, b), a.push(A, E, b);
        }
        this.setIndex(a), this.setAttribute("position", new be(l, 3)), this.setAttribute("normal", new be(u, 3)), this.setAttribute("uv", new be(c, 2));
        function v(x, S, w, A, E) {
            let b = Math.cos(x), T = Math.sin(x), M = w / S * x, C = Math.cos(M);
            E.x = A * (2 + C) * .5 * b, E.y = A * (2 + C) * T * .5, E.z = A * Math.sin(M) * .5;
        }
    }
    static fromJSON(t) {
        return new Vu(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
    }
};
function Wa(n1, t, e) {
    return VM(n1) ? new n1.constructor(n1.subarray(t, e !== void 0 ? e : n1.length)) : n1.slice(t, e);
}
function qg(n1, t, e) {
    return !n1 || !e && n1.constructor === t ? n1 : typeof t.BYTES_PER_ELEMENT == "number" ? new t(n1) : Array.prototype.slice.call(n1);
}
function VM(n1) {
    return ArrayBuffer.isView(n1) && !(n1 instanceof DataView);
}
function i4(n1) {
    function t(i, s) {
        return n1[i] - n1[s];
    }
    let e = n1.length, r = new Array(e);
    for(let i = 0; i !== e; ++i)r[i] = i;
    return r.sort(t), r;
}
function dM(n1, t, e) {
    let r = n1.length, i = new n1.constructor(r);
    for(let s = 0, o = 0; o !== r; ++s){
        let a = e[s] * t;
        for(let l = 0; l !== t; ++l)i[o++] = n1[a + l];
    }
    return i;
}
function UM(n1, t, e, r) {
    let i = 1, s = n1[0];
    for(; s !== void 0 && s[r] === void 0;)s = n1[i++];
    if (s === void 0) return;
    let o = s[r];
    if (o !== void 0) {
        if (Array.isArray(o)) do o = s[r], o !== void 0 && (t.push(s.time), e.push.apply(e, o)), s = n1[i++];
        while (s !== void 0);
        else if (o.toArray !== void 0) do o = s[r], o !== void 0 && (t.push(s.time), o.toArray(e, e.length)), s = n1[i++];
        while (s !== void 0);
        else do o = s[r], o !== void 0 && (t.push(s.time), e.push(o)), s = n1[i++];
        while (s !== void 0);
    }
}
var Uu = class {
    constructor(t, e, r, i){
        this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new e.constructor(r), this.sampleValues = e, this.valueSize = r, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t) {
        let e = this.parameterPositions, r = this._cachedIndex, i = e[r], s = e[r - 1];
        e: {
            t: {
                let o;
                r: {
                    i: if (!(t < i)) {
                        for(let a = r + 2;;){
                            if (i === void 0) {
                                if (t < s) break i;
                                return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
                            }
                            if (r === a) break;
                            if (s = i, i = e[++r], t < i) break t;
                        }
                        o = e.length;
                        break r;
                    }
                    if (!(t >= s)) {
                        let a = e[1];
                        t < a && (r = 2, s = a);
                        for(let l = r - 2;;){
                            if (s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (r === l) break;
                            if (i = s, s = e[--r - 1], t >= s) break t;
                        }
                        o = r, r = 0;
                        break r;
                    }
                    break e;
                }
                for(; r < o;){
                    let a = r + o >>> 1;
                    t < e[a] ? o = a : r = a + 1;
                }
                if (i = e[r], s = e[r - 1], s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (i === void 0) return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
            }
            this._cachedIndex = r, this.intervalChanged_(r, s, i);
        }
        return this.interpolate_(r, s, t, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t) {
        let e = this.resultBuffer, r = this.sampleValues, i = this.valueSize, s = t * i;
        for(let o = 0; o !== i; ++o)e[o] = r[s + o];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}, qS = class extends Uu {
    constructor(t, e, r, i){
        super(t, e, r, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: _u,
            endingEnd: _u
        };
    }
    intervalChanged_(t, e, r) {
        let i = this.parameterPositions, s = t - 2, o = t + 1, a = i[s], l = i[o];
        if (a === void 0) switch(this.getSettings_().endingStart){
            case Eu:
                s = t, a = 2 * e - r;
                break;
            case $g:
                s = i.length - 2, a = e + i[s] - i[s + 1];
                break;
            default:
                s = t, a = r;
        }
        if (l === void 0) switch(this.getSettings_().endingEnd){
            case Eu:
                o = t, l = 2 * r - e;
                break;
            case $g:
                o = 1, l = r + i[1] - i[0];
                break;
            default:
                o = t - 1, l = e;
        }
        let u = (r - e) * .5, c = this.valueSize;
        this._weightPrev = u / (e - a), this._weightNext = u / (l - r), this._offsetPrev = s * c, this._offsetNext = o * c;
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, u = l - a, c = this._offsetPrev, d = this._offsetNext, h = this._weightPrev, f = this._weightNext, p = (r - e) / (i - e), m = p * p, g = m * p, y = -h * g + 2 * h * m - h * p, v = (1 + h) * g + (-1.5 - 2 * h) * m + (-0.5 + h) * p + 1, x = (-1 - f) * g + (1.5 + f) * m + .5 * p, S = f * g - f * m;
        for(let w = 0; w !== a; ++w)s[w] = y * o[c + w] + v * o[u + w] + x * o[l + w] + S * o[d + w];
        return s;
    }
}, hy = class extends Uu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, u = l - a, c = (r - e) / (i - e), d = 1 - c;
        for(let h = 0; h !== a; ++h)s[h] = o[u + h] * d + o[l + h] * c;
        return s;
    }
}, YS = class extends Uu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t) {
        return this.copySampleValue_(t - 1);
    }
}, os = class {
    constructor(t, e, r, i){
        if (t === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (e === void 0 || e.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
        this.name = t, this.times = qg(e, this.TimeBufferType), this.values = qg(r, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(t) {
        let e = t.constructor, r;
        if (e.toJSON !== this.toJSON) r = e.toJSON(t);
        else {
            r = {
                name: t.name,
                times: qg(t.times, Array),
                values: qg(t.values, Array)
            };
            let i = t.getInterpolation();
            i !== t.DefaultInterpolation && (r.interpolation = i);
        }
        return r.type = t.ValueTypeName, r;
    }
    InterpolantFactoryMethodDiscrete(t) {
        return new YS(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodLinear(t) {
        return new hy(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodSmooth(t) {
        return new qS(this.times, this.values, this.getValueSize(), t);
    }
    setInterpolation(t) {
        let e;
        switch(t){
            case Zg:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case Jg:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case Wb:
                e = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (e === void 0) {
            let r = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === void 0) {
                if (t !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(r);
            }
            return console.warn("THREE.KeyframeTrack:", r), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return Zg;
            case this.InterpolantFactoryMethodLinear:
                return Jg;
            case this.InterpolantFactoryMethodSmooth:
                return Wb;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t) {
        if (t !== 0) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] += t;
        }
        return this;
    }
    scale(t) {
        if (t !== 1) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] *= t;
        }
        return this;
    }
    trim(t, e) {
        let r = this.times, i = r.length, s = 0, o = i - 1;
        for(; s !== i && r[s] < t;)++s;
        for(; o !== -1 && r[o] > e;)--o;
        if (++o, s !== 0 || o !== i) {
            s >= o && (o = Math.max(o, 1), s = o - 1);
            let a = this.getValueSize();
            this.times = Wa(r, s, o), this.values = Wa(this.values, s * a, o * a);
        }
        return this;
    }
    validate() {
        let t = !0, e = this.getValueSize();
        e - Math.floor(e) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
        let r = this.times, i = this.values, s = r.length;
        s === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
        let o = null;
        for(let a = 0; a !== s; a++){
            let l = r[a];
            if (typeof l == "number" && isNaN(l)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, a, l), t = !1;
                break;
            }
            if (o !== null && o > l) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, a, l, o), t = !1;
                break;
            }
            o = l;
        }
        if (i !== void 0 && VM(i)) for(let a = 0, l = i.length; a !== l; ++a){
            let u = i[a];
            if (isNaN(u)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, a, u), t = !1;
                break;
            }
        }
        return t;
    }
    optimize() {
        let t = Wa(this.times), e = Wa(this.values), r = this.getValueSize(), i = this.getInterpolation() === Wb, s = t.length - 1, o = 1;
        for(let a = 1; a < s; ++a){
            let l = !1, u = t[a], c = t[a + 1];
            if (u !== c && (a !== 1 || u !== t[0])) {
                if (i) l = !0;
                else {
                    let d = a * r, h = d - r, f = d + r;
                    for(let p = 0; p !== r; ++p){
                        let m = e[d + p];
                        if (m !== e[h + p] || m !== e[f + p]) {
                            l = !0;
                            break;
                        }
                    }
                }
            }
            if (l) {
                if (a !== o) {
                    t[o] = t[a];
                    let d = a * r, h = o * r;
                    for(let f = 0; f !== r; ++f)e[h + f] = e[d + f];
                }
                ++o;
            }
        }
        if (s > 0) {
            t[o] = t[s];
            for(let a = s * r, l = o * r, u = 0; u !== r; ++u)e[l + u] = e[a + u];
            ++o;
        }
        return o !== t.length ? (this.times = Wa(t, 0, o), this.values = Wa(e, 0, o * r)) : (this.times = t, this.values = e), this;
    }
    clone() {
        let t = Wa(this.times, 0), e = Wa(this.values, 0), r = this.constructor, i = new r(this.name, t, e);
        return i.createInterpolant = this.createInterpolant, i;
    }
};
os.prototype.TimeBufferType = Float32Array;
os.prototype.ValueBufferType = Float32Array;
os.prototype.DefaultInterpolation = Jg;
var el = class extends os {
};
el.prototype.ValueTypeName = "bool";
el.prototype.ValueBufferType = Array;
el.prototype.DefaultInterpolation = Zg;
el.prototype.InterpolantFactoryMethodLinear = void 0;
el.prototype.InterpolantFactoryMethodSmooth = void 0;
var fy = class extends os {
};
fy.prototype.ValueTypeName = "color";
var Gu = class extends os {
};
Gu.prototype.ValueTypeName = "number";
var XS = class extends Uu {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = (r - e) / (i - e), u = t * a;
        for(let c = u + a; u !== c; u += 4)je.slerpFlat(s, 0, o, u - a, o, u, l);
        return s;
    }
}, bc = class extends os {
    InterpolantFactoryMethodLinear(t) {
        return new XS(this.times, this.values, this.getValueSize(), t);
    }
};
bc.prototype.ValueTypeName = "quaternion";
bc.prototype.DefaultInterpolation = Jg;
bc.prototype.InterpolantFactoryMethodSmooth = void 0;
var tl = class extends os {
};
tl.prototype.ValueTypeName = "string";
tl.prototype.ValueBufferType = Array;
tl.prototype.DefaultInterpolation = Zg;
tl.prototype.InterpolantFactoryMethodLinear = void 0;
tl.prototype.InterpolantFactoryMethodSmooth = void 0;
var ju = class extends os {
};
ju.prototype.ValueTypeName = "vector";
var Hu = class {
    constructor(t, e = -1, r, i = aw){
        this.name = t, this.tracks = r, this.duration = e, this.blendMode = i, this.uuid = rs(), this.duration < 0 && this.resetDuration();
    }
    static parse(t) {
        let e = [], r = t.tracks, i = 1 / (t.fps || 1);
        for(let o = 0, a = r.length; o !== a; ++o)e.push(s4(r[o]).scale(i));
        let s = new this(t.name, t.duration, e, t.blendMode);
        return s.uuid = t.uuid, s;
    }
    static toJSON(t) {
        let e = [], r = t.tracks, i = {
            name: t.name,
            duration: t.duration,
            tracks: e,
            uuid: t.uuid,
            blendMode: t.blendMode
        };
        for(let s = 0, o = r.length; s !== o; ++s)e.push(os.toJSON(r[s]));
        return i;
    }
    static CreateFromMorphTargetSequence(t, e, r, i) {
        let s = e.length, o = [];
        for(let a = 0; a < s; a++){
            let l = [], u = [];
            l.push((a + s - 1) % s, a, (a + 1) % s), u.push(0, 1, 0);
            let c = i4(l);
            l = dM(l, 1, c), u = dM(u, 1, c), !i && l[0] === 0 && (l.push(s), u.push(u[0])), o.push(new Gu(".morphTargetInfluences[" + e[a].name + "]", l, u).scale(1 / r));
        }
        return new this(t, -1, o);
    }
    static findByName(t, e) {
        let r = t;
        if (!Array.isArray(t)) {
            let i = t;
            r = i.geometry && i.geometry.animations || i.animations;
        }
        for(let i = 0; i < r.length; i++)if (r[i].name === e) return r[i];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(t, e, r) {
        let i = {}, s = /^([\w-]*?)([\d]+)$/;
        for(let a = 0, l = t.length; a < l; a++){
            let u = t[a], c = u.name.match(s);
            if (c && c.length > 1) {
                let d = c[1], h = i[d];
                h || (i[d] = h = []), h.push(u);
            }
        }
        let o = [];
        for(let a in i)o.push(this.CreateFromMorphTargetSequence(a, i[a], e, r));
        return o;
    }
    static parseAnimation(t, e) {
        if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
        let r = function(d, h, f, p, m) {
            if (f.length !== 0) {
                let g = [], y = [];
                UM(f, g, y, p), g.length !== 0 && m.push(new d(h, g, y));
            }
        }, i = [], s = t.name || "default", o = t.fps || 30, a = t.blendMode, l = t.length || -1, u = t.hierarchy || [];
        for(let d = 0; d < u.length; d++){
            let h = u[d].keys;
            if (!(!h || h.length === 0)) {
                if (h[0].morphTargets) {
                    let f = {}, p;
                    for(p = 0; p < h.length; p++)if (h[p].morphTargets) for(let m = 0; m < h[p].morphTargets.length; m++)f[h[p].morphTargets[m]] = -1;
                    for(let m in f){
                        let g = [], y = [];
                        for(let v = 0; v !== h[p].morphTargets.length; ++v){
                            let x = h[p];
                            g.push(x.time), y.push(x.morphTarget === m ? 1 : 0);
                        }
                        i.push(new Gu(".morphTargetInfluence[" + m + "]", g, y));
                    }
                    l = f.length * o;
                } else {
                    let f = ".bones[" + e[d].name + "]";
                    r(ju, f + ".position", h, "pos", i), r(bc, f + ".quaternion", h, "rot", i), r(ju, f + ".scale", h, "scl", i);
                }
            }
        }
        return i.length === 0 ? null : new this(s, l, i, a);
    }
    resetDuration() {
        let t = this.tracks, e = 0;
        for(let r = 0, i = t.length; r !== i; ++r){
            let s = this.tracks[r];
            e = Math.max(e, s.times[s.times.length - 1]);
        }
        return this.duration = e, this;
    }
    trim() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].trim(0, this.duration);
        return this;
    }
    validate() {
        let t = !0;
        for(let e = 0; e < this.tracks.length; e++)t = t && this.tracks[e].validate();
        return t;
    }
    optimize() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].optimize();
        return this;
    }
    clone() {
        let t = [];
        for(let e = 0; e < this.tracks.length; e++)t.push(this.tracks[e].clone());
        return new this.constructor(this.name, this.duration, t, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
};
function n4(n1) {
    switch(n1.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return Gu;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return ju;
        case "color":
            return fy;
        case "quaternion":
            return bc;
        case "bool":
        case "boolean":
            return el;
        case "string":
            return tl;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + n1);
}
function s4(n1) {
    if (n1.type === void 0) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    let t = n4(n1.type);
    if (n1.times === void 0) {
        let e = [], r = [];
        UM(n1.keys, e, r, "value"), n1.times = e, n1.values = r;
    }
    return t.parse !== void 0 ? t.parse(n1) : new t(n1.name, n1.times, n1.values, n1.interpolation);
}
var py = {
    enabled: !1,
    files: {},
    add: function(n1, t) {
        this.enabled !== !1 && (this.files[n1] = t);
    },
    get: function(n1) {
        if (this.enabled !== !1) return this.files[n1];
    },
    remove: function(n1) {
        delete this.files[n1];
    },
    clear: function() {
        this.files = {};
    }
}, xp = class {
    constructor(t, e, r){
        let i = this, s = !1, o = 0, a = 0, l, u = [];
        this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = r, this.itemStart = function(c) {
            a++, s === !1 && i.onStart !== void 0 && i.onStart(c, o, a), s = !0;
        }, this.itemEnd = function(c) {
            o++, i.onProgress !== void 0 && i.onProgress(c, o, a), o === a && (s = !1, i.onLoad !== void 0 && i.onLoad());
        }, this.itemError = function(c) {
            i.onError !== void 0 && i.onError(c);
        }, this.resolveURL = function(c) {
            return l ? l(c) : c;
        }, this.setURLModifier = function(c) {
            return l = c, this;
        }, this.addHandler = function(c, d) {
            return u.push(c, d), this;
        }, this.removeHandler = function(c) {
            let d = u.indexOf(c);
            return d !== -1 && u.splice(d, 2), this;
        }, this.getHandler = function(c) {
            for(let d = 0, h = u.length; d < h; d += 2){
                let f = u[d], p = u[d + 1];
                if (f.global && (f.lastIndex = 0), f.test(c)) return p;
            }
            return null;
        };
    }
}, o4 = new xp, rl = class {
    constructor(t){
        this.manager = t !== void 0 ? t : o4, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
        let r = this;
        return new Promise(function(i, s) {
            r.load(t, i, e, s);
        });
    }
    parse() {}
    setCrossOrigin(t) {
        return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
        return this.withCredentials = t, this;
    }
    setPath(t) {
        return this.path = t, this;
    }
    setResourcePath(t) {
        return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
        return this.requestHeader = t, this;
    }
}, ra = {}, QS = class extends Error {
    constructor(t, e){
        super(t), this.response = e;
    }
}, Wu = class extends rl {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        t === void 0 && (t = ""), this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s = py.get(t);
        if (s !== void 0) return this.manager.itemStart(t), setTimeout(()=>{
            e && e(s), this.manager.itemEnd(t);
        }, 0), s;
        if (ra[t] !== void 0) {
            ra[t].push({
                onLoad: e,
                onProgress: r,
                onError: i
            });
            return;
        }
        ra[t] = [], ra[t].push({
            onLoad: e,
            onProgress: r,
            onError: i
        });
        let o = new Request(t, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        }), a = this.mimeType, l = this.responseType;
        fetch(o).then((u)=>{
            if (u.status === 200 || u.status === 0) {
                if (u.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || u.body === void 0 || u.body.getReader === void 0) return u;
                let c = ra[t], d = u.body.getReader(), h = u.headers.get("Content-Length") || u.headers.get("X-File-Size"), f = h ? parseInt(h) : 0, p = f !== 0, m = 0, g = new ReadableStream({
                    start (y) {
                        v();
                        function v() {
                            d.read().then(({ done: x, value: S })=>{
                                if (x) y.close();
                                else {
                                    m += S.byteLength;
                                    let w = new ProgressEvent("progress", {
                                        lengthComputable: p,
                                        loaded: m,
                                        total: f
                                    });
                                    for(let A = 0, E = c.length; A < E; A++){
                                        let b = c[A];
                                        b.onProgress && b.onProgress(w);
                                    }
                                    y.enqueue(S), v();
                                }
                            });
                        }
                    }
                });
                return new Response(g);
            } else throw new QS(`fetch for "${u.url}" responded with ${u.status}: ${u.statusText}`, u);
        }).then((u)=>{
            switch(l){
                case "arraybuffer":
                    return u.arrayBuffer();
                case "blob":
                    return u.blob();
                case "document":
                    return u.text().then((c)=>new DOMParser().parseFromString(c, a));
                case "json":
                    return u.json();
                default:
                    if (a === void 0) return u.text();
                    {
                        let d = /charset="?([^;"\s]*)"?/i.exec(a), h = d && d[1] ? d[1].toLowerCase() : void 0, f = new TextDecoder(h);
                        return u.arrayBuffer().then((p)=>f.decode(p));
                    }
            }
        }).then((u)=>{
            py.add(t, u);
            let c = ra[t];
            delete ra[t];
            for(let d = 0, h = c.length; d < h; d++){
                let f = c[d];
                f.onLoad && f.onLoad(u);
            }
        }).catch((u)=>{
            let c = ra[t];
            if (c === void 0) throw this.manager.itemError(t), u;
            delete ra[t];
            for(let d = 0, h = c.length; d < h; d++){
                let f = c[d];
                f.onError && f.onError(u);
            }
            this.manager.itemError(t);
        }).finally(()=>{
            this.manager.itemEnd(t);
        }), this.manager.itemStart(t);
    }
    setResponseType(t) {
        return this.responseType = t, this;
    }
    setMimeType(t) {
        return this.mimeType = t, this;
    }
};
var KS = class extends rl {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s = this, o = py.get(t);
        if (o !== void 0) return s.manager.itemStart(t), setTimeout(function() {
            e && e(o), s.manager.itemEnd(t);
        }, 0), o;
        let a = cp("img");
        function l() {
            c(), py.add(t, this), e && e(this), s.manager.itemEnd(t);
        }
        function u(d) {
            c(), i && i(d), s.manager.itemError(t), s.manager.itemEnd(t);
        }
        function c() {
            a.removeEventListener("load", l, !1), a.removeEventListener("error", u, !1);
        }
        return a.addEventListener("load", l, !1), a.addEventListener("error", u, !1), t.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (a.crossOrigin = this.crossOrigin), s.manager.itemStart(t), a.src = t, a;
    }
};
var my = class extends rl {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s = new qt, o = new KS(this.manager);
        return o.setCrossOrigin(this.crossOrigin), o.setPath(this.path), o.load(t, function(a) {
            s.image = a, s.needsUpdate = !0, e !== void 0 && e(s);
        }, r, i), s;
    }
}, il = class extends mt {
    constructor(t, e = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new Le(t), this.intensity = e;
    }
    dispose() {}
    copy(t, e) {
        return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, this.groundColor !== void 0 && (e.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (e.object.distance = this.distance), this.angle !== void 0 && (e.object.angle = this.angle), this.decay !== void 0 && (e.object.decay = this.decay), this.penumbra !== void 0 && (e.object.penumbra = this.penumbra), this.shadow !== void 0 && (e.object.shadow = this.shadow.toJSON()), e;
    }
}, gy = class extends il {
    constructor(t, e, r){
        super(t, r), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(mt.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Le(e);
    }
    copy(t, e) {
        return super.copy(t, e), this.groundColor.copy(t.groundColor), this;
    }
}, bS = new te, hM = new _, fM = new _, bp = class {
    constructor(t){
        this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new N(512, 512), this.map = null, this.mapPass = null, this.matrix = new te, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new dp, this._frameExtents = new N(1, 1), this._viewportCount = 1, this._viewports = [
            new He(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t) {
        let e = this.camera, r = this.matrix;
        hM.setFromMatrixPosition(t.matrixWorld), e.position.copy(hM), fM.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(fM), e.updateMatrixWorld(), bS.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(bS), r.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), r.multiply(bS);
    }
    getViewport(t) {
        return this._viewports[t];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
        return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        let t = {};
        return this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
}, ZS = class extends bp {
    constructor(){
        super(new Wr(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
    }
    updateMatrices(t) {
        let e = this.camera, r = lp * 2 * t.angle * this.focus, i = this.mapSize.width / this.mapSize.height, s = t.distance || e.far;
        (r !== e.fov || i !== e.aspect || s !== e.far) && (e.fov = r, e.aspect = i, e.far = s, e.updateProjectionMatrix()), super.updateMatrices(t);
    }
    copy(t) {
        return super.copy(t), this.focus = t.focus, this;
    }
}, yy = class extends il {
    constructor(t, e, r = 0, i = Math.PI / 3, s = 0, o = 2){
        super(t, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(mt.DEFAULT_UP), this.updateMatrix(), this.target = new mt, this.distance = r, this.angle = i, this.penumbra = s, this.decay = o, this.map = null, this.shadow = new ZS;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}, pM = new te, $f = new _, SS = new _, JS = class extends bp {
    constructor(){
        super(new Wr(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new N(4, 2), this._viewportCount = 6, this._viewports = [
            new He(2, 1, 1, 1),
            new He(0, 1, 1, 1),
            new He(3, 1, 1, 1),
            new He(1, 1, 1, 1),
            new He(3, 0, 1, 1),
            new He(1, 0, 1, 1)
        ], this._cubeDirections = [
            new _(1, 0, 0),
            new _(-1, 0, 0),
            new _(0, 0, 1),
            new _(0, 0, -1),
            new _(0, 1, 0),
            new _(0, -1, 0)
        ], this._cubeUps = [
            new _(0, 1, 0),
            new _(0, 1, 0),
            new _(0, 1, 0),
            new _(0, 1, 0),
            new _(0, 0, 1),
            new _(0, 0, -1)
        ];
    }
    updateMatrices(t, e = 0) {
        let r = this.camera, i = this.matrix, s = t.distance || r.far;
        s !== r.far && (r.far = s, r.updateProjectionMatrix()), $f.setFromMatrixPosition(t.matrixWorld), r.position.copy($f), SS.copy(r.position), SS.add(this._cubeDirections[e]), r.up.copy(this._cubeUps[e]), r.lookAt(SS), r.updateMatrixWorld(), i.makeTranslation(-$f.x, -$f.y, -$f.z), pM.multiplyMatrices(r.projectionMatrix, r.matrixWorldInverse), this._frustum.setFromProjectionMatrix(pM);
    }
}, vy = class extends il {
    constructor(t, e, r = 0, i = 2){
        super(t, e), this.isPointLight = !0, this.type = "PointLight", this.distance = r, this.decay = i, this.shadow = new JS;
    }
    get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(t) {
        this.intensity = t / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
}, $S = class extends bp {
    constructor(){
        super(new Ou(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}, xy = class extends il {
    constructor(t, e){
        super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(mt.DEFAULT_UP), this.updateMatrix(), this.target = new mt, this.shadow = new $S;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t) {
        return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
};
var Sp = class extends we {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t) {
        return super.copy(t), this.instanceCount = t.instanceCount, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
}, qu = class extends rl {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s = this, o = new Wu(s.manager);
        o.setPath(s.path), o.setRequestHeader(s.requestHeader), o.setWithCredentials(s.withCredentials), o.load(t, function(a) {
            try {
                e(s.parse(JSON.parse(a)));
            } catch (l) {
                i ? i(l) : console.error(l), s.manager.itemError(t);
            }
        }, r, i);
    }
    parse(t) {
        let e = {}, r = {};
        function i(f, p) {
            if (e[p] !== void 0) return e[p];
            let g = f.interleavedBuffers[p], y = s(f, g.buffer), v = wg(g.type, y), x = new ly(v, g.stride);
            return x.uuid = g.uuid, e[p] = x, x;
        }
        function s(f, p) {
            if (r[p] !== void 0) return r[p];
            let g = f.arrayBuffers[p], y = new Uint32Array(g).buffer;
            return r[p] = y, y;
        }
        let o = t.isInstancedBufferGeometry ? new Sp : new we, a = t.data.index;
        if (a !== void 0) {
            let f = wg(a.type, a.array);
            o.setIndex(new Ge(f, 1));
        }
        let l = t.data.attributes;
        for(let f in l){
            let p = l[f], m;
            if (p.isInterleavedBufferAttribute) {
                let g = i(t.data, p.data);
                m = new fc(g, p.itemSize, p.offset, p.normalized);
            } else {
                let g = wg(p.type, p.array), y = p.isInstancedBufferAttribute ? uo : Ge;
                m = new y(g, p.itemSize, p.normalized);
            }
            p.name !== void 0 && (m.name = p.name), p.usage !== void 0 && m.setUsage(p.usage), p.updateRange !== void 0 && (m.updateRange.offset = p.updateRange.offset, m.updateRange.count = p.updateRange.count), o.setAttribute(f, m);
        }
        let u = t.data.morphAttributes;
        if (u) for(let f in u){
            let p = u[f], m = [];
            for(let g = 0, y = p.length; g < y; g++){
                let v = p[g], x;
                if (v.isInterleavedBufferAttribute) {
                    let S = i(t.data, v.data);
                    x = new fc(S, v.itemSize, v.offset, v.normalized);
                } else {
                    let S = wg(v.type, v.array);
                    x = new Ge(S, v.itemSize, v.normalized);
                }
                v.name !== void 0 && (x.name = v.name), m.push(x);
            }
            o.morphAttributes[f] = m;
        }
        t.data.morphTargetsRelative && (o.morphTargetsRelative = !0);
        let d = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (d !== void 0) for(let f = 0, p = d.length; f !== p; ++f){
            let m = d[f];
            o.addGroup(m.start, m.count, m.materialIndex);
        }
        let h = t.data.boundingSphere;
        if (h !== void 0) {
            let f = new _;
            h.center !== void 0 && f.fromArray(h.center), o.boundingSphere = new Er(f, h.radius);
        }
        return t.name && (o.name = t.name), t.userData && (o.userData = t.userData), o;
    }
};
var by = class {
    constructor(t = !0){
        this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = mM(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            let e = mM();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return t;
    }
};
function mM() {
    return (typeof performance > "u" ? Date : performance).now();
}
var ew = class {
    constructor(t, e, r){
        this.binding = t, this.valueSize = r;
        let i, s, o;
        switch(e){
            case "quaternion":
                i = this._slerp, s = this._slerpAdditive, o = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(r * 6), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                i = this._select, s = this._select, o = this._setAdditiveIdentityOther, this.buffer = new Array(r * 5);
                break;
            default:
                i = this._lerp, s = this._lerpAdditive, o = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(r * 5);
        }
        this._mixBufferRegion = i, this._mixBufferRegionAdditive = s, this._setIdentity = o, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(t, e) {
        let r = this.buffer, i = this.valueSize, s = t * i + i, o = this.cumulativeWeight;
        if (o === 0) {
            for(let a = 0; a !== i; ++a)r[s + a] = r[a];
            o = e;
        } else {
            o += e;
            let a = e / o;
            this._mixBufferRegion(r, s, 0, a, i);
        }
        this.cumulativeWeight = o;
    }
    accumulateAdditive(t) {
        let e = this.buffer, r = this.valueSize, i = r * this._addIndex;
        this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, r), this.cumulativeWeightAdditive += t;
    }
    apply(t) {
        let e = this.valueSize, r = this.buffer, i = t * e + e, s = this.cumulativeWeight, o = this.cumulativeWeightAdditive, a = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, s < 1) {
            let l = e * this._origIndex;
            this._mixBufferRegion(r, i, l, 1 - s, e);
        }
        o > 0 && this._mixBufferRegionAdditive(r, i, this._addIndex * e, 1, e);
        for(let l = e, u = e + e; l !== u; ++l)if (r[l] !== r[l + e]) {
            a.setValue(r, i);
            break;
        }
    }
    saveOriginalState() {
        let t = this.binding, e = this.buffer, r = this.valueSize, i = r * this._origIndex;
        t.getValue(e, i);
        for(let s = r, o = i; s !== o; ++s)e[s] = e[i + s % r];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        let t = this.valueSize * 3;
        this.binding.setValue(this.buffer, t);
    }
    _setAdditiveIdentityNumeric() {
        let t = this._addIndex * this.valueSize, e = t + this.valueSize;
        for(let r = t; r < e; r++)this.buffer[r] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        let t = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
        for(let r = 0; r < this.valueSize; r++)this.buffer[e + r] = this.buffer[t + r];
    }
    _select(t, e, r, i, s) {
        if (i >= .5) for(let o = 0; o !== s; ++o)t[e + o] = t[r + o];
    }
    _slerp(t, e, r, i) {
        je.slerpFlat(t, e, t, e, t, r, i);
    }
    _slerpAdditive(t, e, r, i, s) {
        let o = this._workIndex * s;
        je.multiplyQuaternionsFlat(t, o, t, e, t, r), je.slerpFlat(t, e, t, e, t, o, i);
    }
    _lerp(t, e, r, i, s) {
        let o = 1 - i;
        for(let a = 0; a !== s; ++a){
            let l = e + a;
            t[l] = t[l] * o + t[r + a] * i;
        }
    }
    _lerpAdditive(t, e, r, i, s) {
        for(let o = 0; o !== s; ++o){
            let a = e + o;
            t[a] = t[a] + t[r + o] * i;
        }
    }
}, fw = "\\[\\]\\.:\\/", a4 = new RegExp("[" + fw + "]", "g"), pw = "[^" + fw + "]", l4 = "[^" + fw.replace("\\.", "") + "]", c4 = /((?:WC+[\/:])*)/.source.replace("WC", pw), u4 = /(WCOD+)?/.source.replace("WCOD", l4), d4 = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", pw), h4 = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", pw), f4 = new RegExp("^" + c4 + u4 + d4 + h4 + "$"), p4 = [
    "material",
    "materials",
    "bones",
    "map"
], tw = class {
    constructor(t, e, r){
        let i = r || Ht.parseTrackName(e);
        this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }
    getValue(t, e) {
        this.bind();
        let r = this._targetGroup.nCachedObjects_, i = this._bindings[r];
        i !== void 0 && i.getValue(t, e);
    }
    setValue(t, e) {
        let r = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, s = r.length; i !== s; ++i)r[i].setValue(t, e);
    }
    bind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].bind();
    }
    unbind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].unbind();
    }
}, Ht = class {
    constructor(t, e, r){
        this.path = e, this.parsedPath = r || Ht.parseTrackName(e), this.node = Ht.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t, e, r) {
        return t && t.isAnimationObjectGroup ? new Ht.Composite(t, e, r) : new Ht(t, e, r);
    }
    static sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace(a4, "");
    }
    static parseTrackName(t) {
        let e = f4.exec(t);
        if (e === null) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        let r = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, i = r.nodeName && r.nodeName.lastIndexOf(".");
        if (i !== void 0 && i !== -1) {
            let s = r.nodeName.substring(i + 1);
            p4.indexOf(s) !== -1 && (r.nodeName = r.nodeName.substring(0, i), r.objectName = s);
        }
        if (r.propertyName === null || r.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return r;
    }
    static findNode(t, e) {
        if (e === void 0 || e === "" || e === "." || e === -1 || e === t.name || e === t.uuid) return t;
        if (t.skeleton) {
            let r = t.skeleton.getBoneByName(e);
            if (r !== void 0) return r;
        }
        if (t.children) {
            let r = function(s) {
                for(let o = 0; o < s.length; o++){
                    let a = s[o];
                    if (a.name === e || a.uuid === e) return a;
                    let l = r(a.children);
                    if (l) return l;
                }
                return null;
            }, i = r(t.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)t[e++] = r[i];
    }
    _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
    }
    _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
    }
    _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
    }
    _setValue_array_setNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s = r.length; i !== s; ++i)r[i] = t[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
    }
    _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
    }
    _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
    }
    bind() {
        let t = this.node, e = this.parsedPath, r = e.objectName, i = e.propertyName, s = e.propertyIndex;
        if (t || (t = Ht.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (r) {
            let u = e.objectIndex;
            switch(r){
                case "materials":
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    t = t.material.materials;
                    break;
                case "bones":
                    if (!t.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    t = t.skeleton.bones;
                    for(let c = 0; c < t.length; c++)if (t[c].name === u) {
                        u = c;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in t) {
                        t = t.map;
                        break;
                    }
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    t = t.material.map;
                    break;
                default:
                    if (t[r] === void 0) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    t = t[r];
            }
            if (u !== void 0) {
                if (t[u] === void 0) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
                    return;
                }
                t = t[u];
            }
        }
        let o = t[i];
        if (o === void 0) {
            let u = e.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + u + "." + i + " but it wasn't found.", t);
            return;
        }
        let a = this.Versioning.None;
        this.targetObject = t, t.needsUpdate !== void 0 ? a = this.Versioning.NeedsUpdate : t.matrixWorldNeedsUpdate !== void 0 && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let l = this.BindingType.Direct;
        if (s !== void 0) {
            if (i === "morphTargetInfluences") {
                if (!t.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!t.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                t.morphTargetDictionary[s] !== void 0 && (s = t.morphTargetDictionary[s]);
            }
            l = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = s;
        } else o.fromArray !== void 0 && o.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (l = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
};
Ht.Composite = tw;
Ht.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
Ht.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
Ht.prototype.GetterByBindingType = [
    Ht.prototype._getValue_direct,
    Ht.prototype._getValue_array,
    Ht.prototype._getValue_arrayElement,
    Ht.prototype._getValue_toArray
];
Ht.prototype.SetterByBindingTypeAndVersioning = [
    [
        Ht.prototype._setValue_direct,
        Ht.prototype._setValue_direct_setNeedsUpdate,
        Ht.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        Ht.prototype._setValue_array,
        Ht.prototype._setValue_array_setNeedsUpdate,
        Ht.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        Ht.prototype._setValue_arrayElement,
        Ht.prototype._setValue_arrayElement_setNeedsUpdate,
        Ht.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        Ht.prototype._setValue_fromArray,
        Ht.prototype._setValue_fromArray_setNeedsUpdate,
        Ht.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
var rw = class {
    constructor(t, e, r = null, i = e.blendMode){
        this._mixer = t, this._clip = e, this._localRoot = r, this.blendMode = i;
        let s = e.tracks, o = s.length, a = new Array(o), l = {
            endingStart: _u,
            endingEnd: _u
        };
        for(let u = 0; u !== o; ++u){
            let c = s[u].createInterpolant(null);
            a[u] = c, c.settings = l;
        }
        this._interpolantSettings = l, this._interpolants = a, this._propertyBindings = new Array(o), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = ow, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(t) {
        return this._startTime = t, this;
    }
    setLoop(t, e) {
        return this.loop = t, this.repetitions = e, this;
    }
    setEffectiveWeight(t) {
        return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(t) {
        return this._scheduleFading(t, 0, 1);
    }
    fadeOut(t) {
        return this._scheduleFading(t, 1, 0);
    }
    crossFadeFrom(t, e, r) {
        if (t.fadeOut(e), this.fadeIn(e), r) {
            let i = this._clip.duration, s = t._clip.duration, o = s / i, a = i / s;
            t.warp(1, o, e), this.warp(a, 1, e);
        }
        return this;
    }
    crossFadeTo(t, e, r) {
        return t.crossFadeFrom(this, e, r);
    }
    stopFading() {
        let t = this._weightInterpolant;
        return t !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    setEffectiveTimeScale(t) {
        return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(t) {
        return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
    syncWith(t) {
        return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
    halt(t) {
        return this.warp(this._effectiveTimeScale, 0, t);
    }
    warp(t, e, r) {
        let i = this._mixer, s = i.time, o = this.timeScale, a = this._timeScaleInterpolant;
        a === null && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
        let l = a.parameterPositions, u = a.sampleValues;
        return l[0] = s, l[1] = s + r, u[0] = t / o, u[1] = e / o, this;
    }
    stopWarping() {
        let t = this._timeScaleInterpolant;
        return t !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(t, e, r, i) {
        if (!this.enabled) {
            this._updateWeight(t);
            return;
        }
        let s = this._startTime;
        if (s !== null) {
            let l = (t - s) * r;
            l < 0 || r === 0 ? e = 0 : (this._startTime = null, e = r * l);
        }
        e *= this._updateTimeScale(t);
        let o = this._updateTime(e), a = this._updateWeight(t);
        if (a > 0) {
            let l = this._interpolants, u = this._propertyBindings;
            switch(this.blendMode){
                case CF:
                    for(let c = 0, d = l.length; c !== d; ++c)l[c].evaluate(o), u[c].accumulateAdditive(a);
                    break;
                case aw:
                default:
                    for(let c = 0, d = l.length; c !== d; ++c)l[c].evaluate(o), u[c].accumulate(i, a);
            }
        }
    }
    _updateWeight(t) {
        let e = 0;
        if (this.enabled) {
            e = this.weight;
            let r = this._weightInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopFading(), i === 0 && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = e, e;
    }
    _updateTimeScale(t) {
        let e = 0;
        if (!this.paused) {
            e = this.timeScale;
            let r = this._timeScaleInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopWarping(), e === 0 ? this.paused = !0 : this.timeScale = e);
            }
        }
        return this._effectiveTimeScale = e, e;
    }
    _updateTime(t) {
        let e = this._clip.duration, r = this.loop, i = this.time + t, s = this._loopCount, o = r === Ap;
        if (t === 0) return s === -1 ? i : o && (s & 1) === 1 ? e - i : i;
        if (r === sw) {
            s === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            e: {
                if (i >= e) i = e;
                else if (i < 0) i = 0;
                else {
                    this.time = i;
                    break e;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t < 0 ? -1 : 1
                });
            }
        } else {
            if (s === -1 && (t >= 0 ? (s = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= e || i < 0) {
                let a = Math.floor(i / e);
                i -= e * a, s += Math.abs(a);
                let l = this.repetitions - s;
                if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t > 0 ? 1 : -1
                });
                else {
                    if (l === 1) {
                        let u = t < 0;
                        this._setEndings(u, !u, o);
                    } else this._setEndings(!1, !1, o);
                    this._loopCount = s, this.time = i, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: a
                    });
                }
            } else this.time = i;
            if (o && (s & 1) === 1) return e - i;
        }
        return i;
    }
    _setEndings(t, e, r) {
        let i = this._interpolantSettings;
        r ? (i.endingStart = Eu, i.endingEnd = Eu) : (t ? i.endingStart = this.zeroSlopeAtStart ? Eu : _u : i.endingStart = $g, e ? i.endingEnd = this.zeroSlopeAtEnd ? Eu : _u : i.endingEnd = $g);
    }
    _scheduleFading(t, e, r) {
        let i = this._mixer, s = i.time, o = this._weightInterpolant;
        o === null && (o = i._lendControlInterpolant(), this._weightInterpolant = o);
        let a = o.parameterPositions, l = o.sampleValues;
        return a[0] = s, l[0] = e, a[1] = s + t, l[1] = r, this;
    }
}, m4 = new Float32Array(1), Sy = class extends ir {
    constructor(t){
        super(), this._root = t, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(t, e) {
        let r = t._localRoot || this._root, i = t._clip.tracks, s = i.length, o = t._propertyBindings, a = t._interpolants, l = r.uuid, u = this._bindingsByRootAndName, c = u[l];
        c === void 0 && (c = {}, u[l] = c);
        for(let d = 0; d !== s; ++d){
            let h = i[d], f = h.name, p = c[f];
            if (p !== void 0) ++p.referenceCount, o[d] = p;
            else {
                if (p = o[d], p !== void 0) {
                    p._cacheIndex === null && (++p.referenceCount, this._addInactiveBinding(p, l, f));
                    continue;
                }
                let m = e && e._propertyBindings[d].binding.parsedPath;
                p = new ew(Ht.create(r, f, m), h.ValueTypeName, h.getValueSize()), ++p.referenceCount, this._addInactiveBinding(p, l, f), o[d] = p;
            }
            a[d].resultBuffer = p.buffer;
        }
    }
    _activateAction(t) {
        if (!this._isActiveAction(t)) {
            if (t._cacheIndex === null) {
                let r = (t._localRoot || this._root).uuid, i = t._clip.uuid, s = this._actionsByClip[i];
                this._bindAction(t, s && s.knownActions[0]), this._addInactiveAction(t, i, r);
            }
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s = e[r];
                s.useCount++ === 0 && (this._lendBinding(s), s.saveOriginalState());
            }
            this._lendAction(t);
        }
    }
    _deactivateAction(t) {
        if (this._isActiveAction(t)) {
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s = e[r];
                --s.useCount === 0 && (s.restoreOriginalState(), this._takeBackBinding(s));
            }
            this._takeBackAction(t);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        let t = this;
        this.stats = {
            actions: {
                get total () {
                    return t._actions.length;
                },
                get inUse () {
                    return t._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return t._bindings.length;
                },
                get inUse () {
                    return t._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return t._controlInterpolants.length;
                },
                get inUse () {
                    return t._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(t) {
        let e = t._cacheIndex;
        return e !== null && e < this._nActiveActions;
    }
    _addInactiveAction(t, e, r) {
        let i = this._actions, s = this._actionsByClip, o = s[e];
        if (o === void 0) o = {
            knownActions: [
                t
            ],
            actionByRoot: {}
        }, t._byClipCacheIndex = 0, s[e] = o;
        else {
            let a = o.knownActions;
            t._byClipCacheIndex = a.length, a.push(t);
        }
        t._cacheIndex = i.length, i.push(t), o.actionByRoot[r] = t;
    }
    _removeInactiveAction(t) {
        let e = this._actions, r = e[e.length - 1], i = t._cacheIndex;
        r._cacheIndex = i, e[i] = r, e.pop(), t._cacheIndex = null;
        let s = t._clip.uuid, o = this._actionsByClip, a = o[s], l = a.knownActions, u = l[l.length - 1], c = t._byClipCacheIndex;
        u._byClipCacheIndex = c, l[c] = u, l.pop(), t._byClipCacheIndex = null;
        let d = a.actionByRoot, h = (t._localRoot || this._root).uuid;
        delete d[h], l.length === 0 && delete o[s], this._removeInactiveBindingsForAction(t);
    }
    _removeInactiveBindingsForAction(t) {
        let e = t._propertyBindings;
        for(let r = 0, i = e.length; r !== i; ++r){
            let s = e[r];
            --s.referenceCount === 0 && this._removeInactiveBinding(s);
        }
    }
    _lendAction(t) {
        let e = this._actions, r = t._cacheIndex, i = this._nActiveActions++, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _takeBackAction(t) {
        let e = this._actions, r = t._cacheIndex, i = --this._nActiveActions, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _addInactiveBinding(t, e, r) {
        let i = this._bindingsByRootAndName, s = this._bindings, o = i[e];
        o === void 0 && (o = {}, i[e] = o), o[r] = t, t._cacheIndex = s.length, s.push(t);
    }
    _removeInactiveBinding(t) {
        let e = this._bindings, r = t.binding, i = r.rootNode.uuid, s = r.path, o = this._bindingsByRootAndName, a = o[i], l = e[e.length - 1], u = t._cacheIndex;
        l._cacheIndex = u, e[u] = l, e.pop(), delete a[s], Object.keys(a).length === 0 && delete o[i];
    }
    _lendBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = this._nActiveBindings++, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _takeBackBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = --this._nActiveBindings, s = e[i];
        t._cacheIndex = i, e[i] = t, s._cacheIndex = r, e[r] = s;
    }
    _lendControlInterpolant() {
        let t = this._controlInterpolants, e = this._nActiveControlInterpolants++, r = t[e];
        return r === void 0 && (r = new hy(new Float32Array(2), new Float32Array(2), 1, m4), r.__cacheIndex = e, t[e] = r), r;
    }
    _takeBackControlInterpolant(t) {
        let e = this._controlInterpolants, r = t.__cacheIndex, i = --this._nActiveControlInterpolants, s = e[i];
        t.__cacheIndex = i, e[i] = t, s.__cacheIndex = r, e[r] = s;
    }
    clipAction(t, e, r) {
        let i = e || this._root, s = i.uuid, o = typeof t == "string" ? Hu.findByName(i, t) : t, a = o !== null ? o.uuid : t, l = this._actionsByClip[a], u = null;
        if (r === void 0 && (o !== null ? r = o.blendMode : r = aw), l !== void 0) {
            let d = l.actionByRoot[s];
            if (d !== void 0 && d.blendMode === r) return d;
            u = l.knownActions[0], o === null && (o = u._clip);
        }
        if (o === null) return null;
        let c = new rw(this, o, e, r);
        return this._bindAction(c, u), this._addInactiveAction(c, a, s), c;
    }
    existingAction(t, e) {
        let r = e || this._root, i = r.uuid, s = typeof t == "string" ? Hu.findByName(r, t) : t, o = s ? s.uuid : t, a = this._actionsByClip[o];
        return a !== void 0 && a.actionByRoot[i] || null;
    }
    stopAllAction() {
        let t = this._actions, e = this._nActiveActions;
        for(let r = e - 1; r >= 0; --r)t[r].stop();
        return this;
    }
    update(t) {
        t *= this.timeScale;
        let e = this._actions, r = this._nActiveActions, i = this.time += t, s = Math.sign(t), o = this._accuIndex ^= 1;
        for(let u = 0; u !== r; ++u)e[u]._update(i, t, s, o);
        let a = this._bindings, l = this._nActiveBindings;
        for(let u = 0; u !== l; ++u)a[u].apply(o);
        return this;
    }
    setTime(t) {
        this.time = 0;
        for(let e = 0; e < this._actions.length; e++)this._actions[e].time = 0;
        return this.update(t);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(t) {
        let e = this._actions, r = t.uuid, i = this._actionsByClip, s = i[r];
        if (s !== void 0) {
            let o = s.knownActions;
            for(let a = 0, l = o.length; a !== l; ++a){
                let u = o[a];
                this._deactivateAction(u);
                let c = u._cacheIndex, d = e[e.length - 1];
                u._cacheIndex = null, u._byClipCacheIndex = null, d._cacheIndex = c, e[c] = d, e.pop(), this._removeInactiveBindingsForAction(u);
            }
            delete i[r];
        }
    }
    uncacheRoot(t) {
        let e = t.uuid, r = this._actionsByClip;
        for(let o in r){
            let a = r[o].actionByRoot, l = a[e];
            l !== void 0 && (this._deactivateAction(l), this._removeInactiveAction(l));
        }
        let i = this._bindingsByRootAndName, s = i[e];
        if (s !== void 0) for(let o in s){
            let a = s[o];
            a.restoreOriginalState(), this._removeInactiveBinding(a);
        }
    }
    uncacheAction(t, e) {
        let r = this.existingAction(t, e);
        r !== null && (this._deactivateAction(r), this._removeInactiveAction(r));
    }
}, se = class {
    constructor(t){
        this.value = t;
    }
    clone() {
        return new se(this.value.clone === void 0 ? this.value : this.value.clone());
    }
};
var Yu = class {
    constructor(t, e, r = 0, i = 1 / 0){
        this.ray = new Rs(t, e), this.near = r, this.far = i, this.camera = null, this.layers = new up, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t, e) {
        this.ray.set(t, e);
    }
    setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t, e = !0, r = []) {
        return iw(t, this, r, e), r.sort(gM), r;
    }
    intersectObjects(t, e = !0, r = []) {
        for(let i = 0, s = t.length; i < s; i++)iw(t[i], this, r, e);
        return r.sort(gM), r;
    }
};
function gM(n1, t) {
    return n1.distance - t.distance;
}
function iw(n1, t, e, r) {
    if (n1.layers.test(t.layers) && n1.raycast(t, e), r === !0) {
        let i = n1.children;
        for(let s = 0, o = i.length; s < o; s++)iw(i[s], t, e, !0);
    }
}
var wp = class {
    constructor(t = 1, e = 0, r = 0){
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    set(t, e, r) {
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
    makeSafe() {
        return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, r) {
        return this.radius = Math.sqrt(t * t + e * e + r * r), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, r), this.phi = Math.acos(oi(e / this.radius, -1, 1))), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
var yM = new N, Xu = class {
    constructor(t = new N(1 / 0, 1 / 0), e = new N(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = yM.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return yM.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, vM = new _, Yg = new _, xi = class {
    constructor(t = new _, e = new _){
        this.start = t, this.end = e;
    }
    set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
    }
    copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
    }
    getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(t) {
        return t.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(t, e) {
        vM.subVectors(t, this.start), Yg.subVectors(this.end, this.start);
        let r = Yg.dot(Yg), s = Yg.dot(vM) / r;
        return e && (s = oi(s, 0, 1)), s;
    }
    closestPointToPoint(t, e, r) {
        let i = this.closestPointToPointParameter(t, e);
        return this.delta(r).multiplyScalar(i).add(this.start);
    }
    applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }
    equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, xM = new _, wy = class extends mt {
    constructor(t, e){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
        let r = new we, i = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let o = 0, a = 1, l = 32; o < l; o++, a++){
            let u = o / l * Math.PI * 2, c = a / l * Math.PI * 2;
            i.push(Math.cos(u), Math.sin(u), 1, Math.cos(c), Math.sin(c), 1);
        }
        r.setAttribute("position", new be(i, 3));
        let s = new ns({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new Ja(r, s), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
        let t = this.light.distance ? this.light.distance : 1e3, e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), xM.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(xM), this.color !== void 0 ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
};
var Ay = class extends rr {
    constructor(t, e, r){
        let i = new Bs(e, 4, 2), s = new Ls({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        });
        super(i, s), this.light = t, this.color = r, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.color !== void 0 ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
};
var bM = new _, Xg = new _, SM = new _, _y = class extends mt {
    constructor(t, e, r){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = r, this.type = "DirectionalLightHelper", e === void 0 && (e = 1);
        let i = new we;
        i.setAttribute("position", new be([
            -e,
            e,
            0,
            e,
            e,
            0,
            e,
            -e,
            0,
            -e,
            -e,
            0,
            -e,
            e,
            0
        ], 3));
        let s = new ns({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new pc(i, s), this.add(this.lightPlane), i = new we, i.setAttribute("position", new be([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new pc(i, s), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), bM.setFromMatrixPosition(this.light.matrixWorld), Xg.setFromMatrixPosition(this.light.target.matrixWorld), SM.subVectors(Xg, bM), this.lightPlane.lookAt(Xg), this.color !== void 0 ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(Xg), this.targetLine.scale.z = SM.length();
    }
}, Qg = new _, Nr = new Hn, nl = class extends Ja {
    constructor(t){
        let e = new we, r = new ns({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), i = [], s = [], o = {};
        a("n1", "n2"), a("n2", "n4"), a("n4", "n3"), a("n3", "n1"), a("f1", "f2"), a("f2", "f4"), a("f4", "f3"), a("f3", "f1"), a("n1", "f1"), a("n2", "f2"), a("n3", "f3"), a("n4", "f4"), a("p", "n1"), a("p", "n2"), a("p", "n3"), a("p", "n4"), a("u1", "u2"), a("u2", "u3"), a("u3", "u1"), a("c", "t"), a("p", "c"), a("cn1", "cn2"), a("cn3", "cn4"), a("cf1", "cf2"), a("cf3", "cf4");
        function a(p, m) {
            l(p), l(m);
        }
        function l(p) {
            i.push(0, 0, 0), s.push(0, 0, 0), o[p] === void 0 && (o[p] = []), o[p].push(i.length / 3 - 1);
        }
        e.setAttribute("position", new be(i, 3)), e.setAttribute("color", new be(s, 3)), super(e, r), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = o, this.update();
        let u = new Le(16755200), c = new Le(16711680), d = new Le(43775), h = new Le(16777215), f = new Le(3355443);
        this.setColors(u, c, d, h, f);
    }
    setColors(t, e, r, i, s) {
        let a = this.geometry.getAttribute("color");
        a.setXYZ(0, t.r, t.g, t.b), a.setXYZ(1, t.r, t.g, t.b), a.setXYZ(2, t.r, t.g, t.b), a.setXYZ(3, t.r, t.g, t.b), a.setXYZ(4, t.r, t.g, t.b), a.setXYZ(5, t.r, t.g, t.b), a.setXYZ(6, t.r, t.g, t.b), a.setXYZ(7, t.r, t.g, t.b), a.setXYZ(8, t.r, t.g, t.b), a.setXYZ(9, t.r, t.g, t.b), a.setXYZ(10, t.r, t.g, t.b), a.setXYZ(11, t.r, t.g, t.b), a.setXYZ(12, t.r, t.g, t.b), a.setXYZ(13, t.r, t.g, t.b), a.setXYZ(14, t.r, t.g, t.b), a.setXYZ(15, t.r, t.g, t.b), a.setXYZ(16, t.r, t.g, t.b), a.setXYZ(17, t.r, t.g, t.b), a.setXYZ(18, t.r, t.g, t.b), a.setXYZ(19, t.r, t.g, t.b), a.setXYZ(20, t.r, t.g, t.b), a.setXYZ(21, t.r, t.g, t.b), a.setXYZ(22, t.r, t.g, t.b), a.setXYZ(23, t.r, t.g, t.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, r.r, r.g, r.b), a.setXYZ(33, r.r, r.g, r.b), a.setXYZ(34, r.r, r.g, r.b), a.setXYZ(35, r.r, r.g, r.b), a.setXYZ(36, r.r, r.g, r.b), a.setXYZ(37, r.r, r.g, r.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, s.r, s.g, s.b), a.setXYZ(41, s.r, s.g, s.b), a.setXYZ(42, s.r, s.g, s.b), a.setXYZ(43, s.r, s.g, s.b), a.setXYZ(44, s.r, s.g, s.b), a.setXYZ(45, s.r, s.g, s.b), a.setXYZ(46, s.r, s.g, s.b), a.setXYZ(47, s.r, s.g, s.b), a.setXYZ(48, s.r, s.g, s.b), a.setXYZ(49, s.r, s.g, s.b), a.needsUpdate = !0;
    }
    update() {
        let t = this.geometry, e = this.pointMap, r = 1, i = 1;
        Nr.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), Hr("c", e, t, Nr, 0, 0, -1), Hr("t", e, t, Nr, 0, 0, 1), Hr("n1", e, t, Nr, -r, -i, -1), Hr("n2", e, t, Nr, r, -i, -1), Hr("n3", e, t, Nr, -r, i, -1), Hr("n4", e, t, Nr, r, i, -1), Hr("f1", e, t, Nr, -r, -i, 1), Hr("f2", e, t, Nr, r, -i, 1), Hr("f3", e, t, Nr, -r, i, 1), Hr("f4", e, t, Nr, r, i, 1), Hr("u1", e, t, Nr, r * .7, i * 1.1, -1), Hr("u2", e, t, Nr, -r * .7, i * 1.1, -1), Hr("u3", e, t, Nr, 0, i * 2, -1), Hr("cf1", e, t, Nr, -r, 0, 1), Hr("cf2", e, t, Nr, r, 0, 1), Hr("cf3", e, t, Nr, 0, -i, 1), Hr("cf4", e, t, Nr, 0, i, 1), Hr("cn1", e, t, Nr, -r, 0, -1), Hr("cn2", e, t, Nr, r, 0, -1), Hr("cn3", e, t, Nr, 0, -i, -1), Hr("cn4", e, t, Nr, 0, i, -1), t.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function Hr(n1, t, e, r, i, s, o) {
    Qg.set(i, s, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let u = 0, c = a.length; u < c; u++)l.setXYZ(a[u], Qg.x, Qg.y, Qg.z);
    }
}
var sl = class extends Ja {
    constructor(t, e = 16776960){
        let r = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], s = new we;
        s.setIndex(new Ge(r, 1)), s.setAttribute("position", new be(i, 3)), super(s, new ns({
            color: e,
            toneMapped: !1
        })), this.box = t, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(t) {
        let e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var Ey = class extends Ja {
    constructor(t = 1){
        let e = [
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t
        ], r = [
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], i = new we;
        i.setAttribute("position", new be(e, 3)), i.setAttribute("color", new be(r, 3));
        let s = new ns({
            vertexColors: !0,
            toneMapped: !1
        });
        super(i, s), this.type = "AxesHelper";
    }
    setColors(t, e, r) {
        let i = new Le, s = this.geometry.attributes.color.array;
        return i.set(t), i.toArray(s, 0), i.toArray(s, 3), i.set(e), i.toArray(s, 6), i.toArray(s, 9), i.set(r), i.toArray(s, 12), i.toArray(s, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var ia = g4();
function g4() {
    let n1 = new ArrayBuffer(4), t = new Float32Array(n1), e = new Uint32Array(n1), r = new Uint32Array(512), i = new Uint32Array(512);
    for(let l = 0; l < 256; ++l){
        let u = l - 127;
        u < -27 ? (r[l] = 0, r[l | 256] = 32768, i[l] = 24, i[l | 256] = 24) : u < -14 ? (r[l] = 1024 >> -u - 14, r[l | 256] = 1024 >> -u - 14 | 32768, i[l] = -u - 1, i[l | 256] = -u - 1) : u <= 15 ? (r[l] = u + 15 << 10, r[l | 256] = u + 15 << 10 | 32768, i[l] = 13, i[l | 256] = 13) : u < 128 ? (r[l] = 31744, r[l | 256] = 64512, i[l] = 24, i[l | 256] = 24) : (r[l] = 31744, r[l | 256] = 64512, i[l] = 13, i[l | 256] = 13);
    }
    let s = new Uint32Array(2048), o = new Uint32Array(64), a = new Uint32Array(64);
    for(let l = 1; l < 1024; ++l){
        let u = l << 13, c = 0;
        for(; (u & 8388608) === 0;)u <<= 1, c -= 8388608;
        u &= -8388609, c += 947912704, s[l] = u | c;
    }
    for(let l = 1024; l < 2048; ++l)s[l] = 939524096 + (l - 1024 << 13);
    for(let l = 1; l < 31; ++l)o[l] = l << 23;
    o[31] = 1199570944, o[32] = 2147483648;
    for(let l = 33; l < 63; ++l)o[l] = 2147483648 + (l - 32 << 23);
    o[63] = 3347054592;
    for(let l = 1; l < 64; ++l)l !== 32 && (a[l] = 1024);
    return {
        floatView: t,
        uint32View: e,
        baseTable: r,
        shiftTable: i,
        mantissaTable: s,
        exponentTable: o,
        offsetTable: a
    };
}
function y4(n1) {
    Math.abs(n1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), n1 = oi(n1, -65504, 65504), ia.floatView[0] = n1;
    let t = ia.uint32View[0], e = t >> 23 & 511;
    return ia.baseTable[e] + ((t & 8388607) >> ia.shiftTable[e]);
}
function v4(n1) {
    let t = n1 >> 10;
    return ia.uint32View[0] = ia.mantissaTable[ia.offsetTable[t] + (n1 & 1023)] + ia.exponentTable[t], ia.floatView[0];
}
var GM = Object.freeze({
    __proto__: null,
    fromHalfFloat: v4,
    toHalfFloat: y4
});
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: aa
    }
}));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = aa);
var Ju = ".", _p = Symbol("target"), mw = Symbol("unsubscribe");
function Ep(n1) {
    return n1 instanceof Date || n1 instanceof Set || n1 instanceof Map || n1 instanceof WeakSet || n1 instanceof WeakMap || ArrayBuffer.isView(n1);
}
function jM(n1) {
    return (typeof n1 == "object" ? n1 === null : typeof n1 != "function") || n1 instanceof RegExp;
}
var Yn = Array.isArray;
function Sc(n1) {
    return typeof n1 == "symbol";
}
var x4 = {
    after: (n1, t)=>Yn(n1) ? n1.slice(t.length) : t === "" ? n1 : n1.slice(t.length + 1),
    concat: (n1, t)=>Yn(n1) ? (n1 = [
            ...n1
        ], t && n1.push(t), n1) : t && t.toString !== void 0 ? (n1 !== "" && (n1 += Ju), Sc(t) ? n1 + t.toString() : n1 + t) : n1,
    initial: (n1)=>{
        if (Yn(n1)) return n1.slice(0, -1);
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(Ju);
        return t === -1 ? "" : n1.slice(0, t);
    },
    last: (n1)=>{
        if (Yn(n1)) return n1[n1.length - 1] || "";
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(Ju);
        return t === -1 ? n1 : n1.slice(t + 1);
    },
    walk: (n1, t)=>{
        if (Yn(n1)) for (let e of n1)t(e);
        else if (n1 !== "") {
            let e = 0, r = n1.indexOf(Ju);
            if (r === -1) t(n1);
            else for(; e < n1.length;)r === -1 && (r = n1.length), t(n1.slice(e, r)), e = r + 1, r = n1.indexOf(Ju, e);
        }
    },
    get (n1, t) {
        return this.walk(t, (e)=>{
            n1 && (n1 = n1[e]);
        }), n1;
    }
}, fn = x4;
function gw(n1) {
    return typeof n1 == "object" && typeof n1.next == "function";
}
function yw(n1, t, e, r, i) {
    let s = n1.next;
    if (t.name === "entries") n1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value[0] = i(o.value[0], t, o.value[0], r), o.value[1] = i(o.value[1], t, o.value[0], r)), o;
    };
    else if (t.name === "values") {
        let o = e[_p].keys();
        n1.next = function() {
            let a = s.call(this);
            return a.done === !1 && (a.value = i(a.value, t, o.next().value, r)), a;
        };
    } else n1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value = i(o.value, t, o.value, r)), o;
    };
    return n1;
}
function Py(n1, t, e) {
    return n1.isUnsubscribed || t.ignoreSymbols && Sc(e) || t.ignoreUnderscores && e.charAt(0) === "_" || "ignoreKeys" in t && t.ignoreKeys.includes(e);
}
var Tp = class {
    constructor(t){
        this._equals = t, this._proxyCache = new WeakMap, this._pathCache = new WeakMap, this.isUnsubscribed = !1;
    }
    _getDescriptorCache() {
        return this._descriptorCache === void 0 && (this._descriptorCache = new WeakMap), this._descriptorCache;
    }
    _getProperties(t) {
        let e = this._getDescriptorCache(), r = e.get(t);
        return r === void 0 && (r = {}, e.set(t, r)), r;
    }
    _getOwnPropertyDescriptor(t, e) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(t, e);
        let r = this._getProperties(t), i = r[e];
        return i === void 0 && (i = Reflect.getOwnPropertyDescriptor(t, e), r[e] = i), i;
    }
    getProxy(t, e, r, i) {
        if (this.isUnsubscribed) return t;
        let s = t[i], o = s || t;
        this._pathCache.set(o, e);
        let a = this._proxyCache.get(o);
        return a === void 0 && (a = s === void 0 ? new Proxy(t, r) : t, this._proxyCache.set(o, a)), a;
    }
    getPath(t) {
        return this.isUnsubscribed ? void 0 : this._pathCache.get(t);
    }
    isDetached(t, e) {
        return !Object.is(t, fn.get(e, this.getPath(t)));
    }
    defineProperty(t, e, r) {
        return Reflect.defineProperty(t, e, r) ? (this.isUnsubscribed || (this._getProperties(t)[e] = r), !0) : !1;
    }
    setProperty(t, e, r, i, s) {
        if (!this._equals(s, r) || !(e in t)) {
            let o = this._getOwnPropertyDescriptor(t, e);
            return o !== void 0 && "set" in o ? Reflect.set(t, e, r, i) : Reflect.set(t, e, r);
        }
        return !0;
    }
    deleteProperty(t, e, r) {
        if (Reflect.deleteProperty(t, e)) {
            if (!this.isUnsubscribed) {
                let i = this._getDescriptorCache().get(t);
                i && (delete i[e], this._pathCache.delete(r));
            }
            return !0;
        }
        return !1;
    }
    isSameDescriptor(t, e, r) {
        let i = this._getOwnPropertyDescriptor(e, r);
        return t !== void 0 && i !== void 0 && Object.is(t.value, i.value) && (t.writable || !1) === (i.writable || !1) && (t.enumerable || !1) === (i.enumerable || !1) && (t.configurable || !1) === (i.configurable || !1) && t.get === i.get && t.set === i.set;
    }
    isGetInvariant(t, e) {
        let r = this._getOwnPropertyDescriptor(t, e);
        return r !== void 0 && r.configurable !== !0 && r.writable !== !0;
    }
    unsubscribe() {
        this._descriptorCache = null, this._pathCache = null, this._proxyCache = null, this.isUnsubscribed = !0;
    }
};
function $u(n1) {
    return toString.call(n1) === "[object Object]";
}
function ed() {
    return !0;
}
function ol(n1, t) {
    return n1.length !== t.length || n1.some((e, r)=>t[r] !== e);
}
var Dy = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
]);
var b4 = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf"
]), vw = {
    push: ed,
    pop: ed,
    shift: ed,
    unshift: ed,
    copyWithin: ol,
    reverse: ol,
    sort: ol,
    splice: ol,
    flat: ol,
    fill: ol
}, HM = new Set([
    ...Dy,
    ...b4,
    ...Object.keys(vw)
]);
function td(n1, t) {
    if (n1.size !== t.size) return !0;
    for (let e of n1)if (!t.has(e)) return !0;
    return !1;
}
var xw = [
    "keys",
    "values",
    "entries"
], bw = new Set([
    "has",
    "toString"
]), Sw = {
    add: td,
    clear: td,
    delete: td,
    forEach: td
}, WM = new Set([
    ...bw,
    ...Object.keys(Sw),
    ...xw
]);
function rd(n1, t) {
    if (n1.size !== t.size) return !0;
    let e;
    for (let [r, i] of n1)if (e = t.get(r), e !== i || e === void 0 && !t.has(r)) return !0;
    return !1;
}
var S4 = new Set([
    ...bw,
    "get"
]), ww = {
    set: rd,
    clear: rd,
    delete: rd,
    forEach: rd
}, qM = new Set([
    ...S4,
    ...Object.keys(ww),
    ...xw
]);
var Ri = class {
    constructor(t, e, r, i){
        this._path = e, this._isChanged = !1, this._clonedCache = new Set, this._hasOnValidate = i, this._changes = i ? [] : null, this.clone = e === void 0 ? t : this._shallowClone(t);
    }
    static isHandledMethod(t) {
        return Dy.has(t);
    }
    _shallowClone(t) {
        let e = t;
        if ($u(t)) e = {
            ...t
        };
        else if (Yn(t)) e = [
            ...t
        ];
        else if (t instanceof Date) e = new Date(t);
        else if (t instanceof Set) e = new Set([
            ...t
        ].map((r)=>this._shallowClone(r)));
        else if (t instanceof Map) {
            e = new Map;
            for (let [r, i] of t.entries())e.set(r, this._shallowClone(i));
        }
        return this._clonedCache.add(e), e;
    }
    preferredThisArg(t, e, r, i) {
        return t ? (Yn(i) ? this._onIsChanged = vw[e] : i instanceof Set ? this._onIsChanged = Sw[e] : i instanceof Map && (this._onIsChanged = ww[e]), i) : r;
    }
    update(t, e, r) {
        let i = fn.after(t, this._path);
        if (e !== "length") {
            let s = this.clone;
            fn.walk(i, (o)=>{
                s && s[o] && (this._clonedCache.has(s[o]) || (s[o] = this._shallowClone(s[o])), s = s[o]);
            }), this._hasOnValidate && this._changes.push({
                path: i,
                property: e,
                previous: r
            }), s && s[e] && (s[e] = r);
        }
        this._isChanged = !0;
    }
    undo(t) {
        let e;
        for(let r = this._changes.length - 1; r !== -1; r--)e = this._changes[r], fn.get(t, e.path)[e.property] = e.previous;
    }
    isChanged(t) {
        return this._onIsChanged === void 0 ? this._isChanged : this._onIsChanged(this.clone, t);
    }
};
var id = class extends Ri {
    static isHandledMethod(t) {
        return HM.has(t);
    }
};
var Mp = class extends Ri {
    undo(t) {
        t.setTime(this.clone.getTime());
    }
    isChanged(t, e) {
        return !e(this.clone.valueOf(), t.valueOf());
    }
};
var nd = class extends Ri {
    static isHandledMethod(t) {
        return WM.has(t);
    }
    undo(t) {
        for (let e of this.clone)t.add(e);
        for (let e of t)this.clone.has(e) || t.delete(e);
    }
};
var sd = class extends Ri {
    static isHandledMethod(t) {
        return qM.has(t);
    }
    undo(t) {
        for (let [e, r] of this.clone.entries())t.set(e, r);
        for (let e of t.keys())this.clone.has(e) || t.delete(e);
    }
};
var Cp = class extends Ri {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._arg1 = r[0], this._weakValue = t.has(this._arg1);
    }
    isChanged(t) {
        return this._weakValue !== t.has(this._arg1);
    }
    undo(t) {
        this._weakValue && !t.has(this._arg1) ? t.add(this._arg1) : t.delete(this._arg1);
    }
};
var Pp = class extends Ri {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._weakKey = r[0], this._weakHas = t.has(this._weakKey), this._weakValue = t.get(this._weakKey);
    }
    isChanged(t) {
        return this._weakValue !== t.get(this._weakKey);
    }
    undo(t) {
        let e = t.has(this._weakKey);
        this._weakHas && !e ? t.set(this._weakKey, this._weakValue) : !this._weakHas && e ? t.delete(this._weakKey) : this._weakValue !== t.get(this._weakKey) && t.set(this._weakKey, this._weakValue);
    }
};
var Fs = class {
    constructor(t){
        this._stack = [], this._hasOnValidate = t;
    }
    static isHandledType(t) {
        return $u(t) || Yn(t) || Ep(t);
    }
    static isHandledMethod(t, e) {
        return $u(t) ? Ri.isHandledMethod(e) : Yn(t) ? id.isHandledMethod(e) : t instanceof Set ? nd.isHandledMethod(e) : t instanceof Map ? sd.isHandledMethod(e) : Ep(t);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(t, e, r) {
        let i = Ri;
        Yn(t) ? i = id : t instanceof Date ? i = Mp : t instanceof Set ? i = nd : t instanceof Map ? i = sd : t instanceof WeakSet ? i = Cp : t instanceof WeakMap && (i = Pp), this._stack.push(new i(t, e, r, this._hasOnValidate));
    }
    update(t, e, r) {
        this._stack[this._stack.length - 1].update(t, e, r);
    }
    preferredThisArg(t, e, r) {
        let { name: i } = t, s = Fs.isHandledMethod(r, i);
        return this._stack[this._stack.length - 1].preferredThisArg(s, i, e, r);
    }
    isChanged(t, e, r) {
        return this._stack[this._stack.length - 1].isChanged(t, e, r);
    }
    undo(t) {
        this._previousClone !== void 0 && this._previousClone.undo(t);
    }
    stop() {
        return this._previousClone = this._stack.pop(), this._previousClone.clone;
    }
};
var w4 = {
    equals: Object.is,
    isShallow: !1,
    pathAsArray: !1,
    ignoreSymbols: !1,
    ignoreUnderscores: !1,
    ignoreDetached: !1,
    details: !1
}, Aw = (n1, t, e = {})=>{
    e = {
        ...w4,
        ...e
    };
    let r = Symbol("ProxyTarget"), { equals: i, isShallow: s, ignoreDetached: o, details: a } = e, l = new Tp(i), u = typeof e.onValidate == "function", c = new Fs(u), d = (v, x, S, w, A)=>!u || c.isCloning || e.onValidate(fn.concat(l.getPath(v), x), S, w, A) === !0, h = (v, x, S, w)=>{
        !Py(l, e, x) && !(o && l.isDetached(v, n1)) && f(l.getPath(v), x, S, w);
    }, f = (v, x, S, w, A)=>{
        c.isCloning ? c.update(v, x, w) : t(fn.concat(v, x), S, w, A);
    }, p = (v)=>v && (v[r] || v), m = (v, x, S, w)=>jM(v) || S === "constructor" || s && !Fs.isHandledMethod(x, S) || Py(l, e, S) || l.isGetInvariant(x, S) || o && l.isDetached(x, n1) ? v : (w === void 0 && (w = l.getPath(x)), l.getProxy(v, fn.concat(w, S), g, r)), g = {
        get (v, x, S) {
            if (Sc(x)) {
                if (x === r || x === _p) return v;
                if (x === mw && !l.isUnsubscribed && l.getPath(v).length === 0) return l.unsubscribe(), v;
            }
            let w = Ep(v) ? Reflect.get(v, x) : Reflect.get(v, x, S);
            return m(w, v, x);
        },
        set (v, x, S, w) {
            S = p(S);
            let A = v[r] || v, E = A[x];
            if (i(E, S) && x in v) return !0;
            let b = d(v, x, S, E);
            return b && l.setProperty(A, x, S, w, E) ? (h(v, x, v[x], E), !0) : !b;
        },
        defineProperty (v, x, S) {
            if (!l.isSameDescriptor(S, v, x)) {
                let w = v[x];
                d(v, x, S.value, w) && l.defineProperty(v, x, S, w) && h(v, x, S.value, w);
            }
            return !0;
        },
        deleteProperty (v, x) {
            if (!Reflect.has(v, x)) return !0;
            let S = Reflect.get(v, x), w = d(v, x, void 0, S);
            return w && l.deleteProperty(v, x, S) ? (h(v, x, void 0, S), !0) : !w;
        },
        apply (v, x, S) {
            let w = x[r] || x;
            if (l.isUnsubscribed) return Reflect.apply(v, w, S);
            if ((a === !1 || a !== !0 && !a.includes(v.name)) && Fs.isHandledType(w)) {
                let A = fn.initial(l.getPath(v)), E = Fs.isHandledMethod(w, v.name);
                c.start(w, A, S);
                let b = Reflect.apply(v, c.preferredThisArg(v, x, w), E ? S.map((C)=>p(C)) : S), T = c.isChanged(w, i), M = c.stop();
                if (Fs.isHandledType(b) && E && (x instanceof Map && v.name === "get" && (A = fn.concat(A, S[0])), b = l.getProxy(b, A, g)), T) {
                    let C = {
                        name: v.name,
                        args: S,
                        result: b
                    }, P = c.isCloning ? fn.initial(A) : A, D = c.isCloning ? fn.last(A) : "";
                    d(fn.get(n1, P), D, w, M, C) ? f(P, D, w, M, C) : c.undo(w);
                }
                return (x instanceof Map || x instanceof Set) && gw(b) ? yw(b, v, x, A, m) : b;
            }
            return Reflect.apply(v, x, S);
        }
    }, y = l.getProxy(n1, e.pathAsArray ? [] : "", g);
    return t = t.bind(y), u && (e.onValidate = e.onValidate.bind(y)), y;
};
Aw.target = (n1)=>n1 && n1[_p] || n1;
Aw.unsubscribe = (n1)=>n1[mw] || n1;
var _w = Aw;
var A4 = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, Oy = A4;
var _4 = typeof self == "object" && self && self.Object === Object && self, E4 = Oy || _4 || Function("return this")(), kr = E4;
var T4 = kr.Symbol, Li = T4;
var YM = Object.prototype, M4 = YM.hasOwnProperty, C4 = YM.toString, Dp = Li ? Li.toStringTag : void 0;
function P4(n1) {
    var t = M4.call(n1, Dp), e = n1[Dp];
    try {
        n1[Dp] = void 0;
        var r = !0;
    } catch  {}
    var i = C4.call(n1);
    return r && (t ? n1[Dp] = e : delete n1[Dp]), i;
}
var XM = P4;
var D4 = Object.prototype, O4 = D4.toString;
function I4(n1) {
    return O4.call(n1);
}
var QM = I4;
var R4 = "[object Null]", L4 = "[object Undefined]", KM = Li ? Li.toStringTag : void 0;
function B4(n1) {
    return n1 == null ? n1 === void 0 ? L4 : R4 : KM && KM in Object(n1) ? XM(n1) : QM(n1);
}
var Xn = B4;
function N4(n1) {
    return n1 != null && typeof n1 == "object";
}
var Yi = N4;
var F4 = "[object Symbol]";
function k4(n1) {
    return typeof n1 == "symbol" || Yi(n1) && Xn(n1) == F4;
}
var al = k4;
function z4(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = Array(r); ++e < r;)i[e] = t(n1[e], e, n1);
    return i;
}
var Iy = z4;
var V4 = Array.isArray, bi = V4;
var U4 = 1 / 0, ZM = Li ? Li.prototype : void 0, JM = ZM ? ZM.toString : void 0;
function $M(n1) {
    if (typeof n1 == "string") return n1;
    if (bi(n1)) return Iy(n1, $M) + "";
    if (al(n1)) return JM ? JM.call(n1) : "";
    var t = n1 + "";
    return t == "0" && 1 / n1 == -U4 ? "-0" : t;
}
var eC = $M;
var G4 = /\s/;
function j4(n1) {
    for(var t = n1.length; t-- && G4.test(n1.charAt(t)););
    return t;
}
var tC = j4;
var H4 = /^\s+/;
function W4(n1) {
    return n1 && n1.slice(0, tC(n1) + 1).replace(H4, "");
}
var rC = W4;
function q4(n1) {
    var t = typeof n1;
    return n1 != null && (t == "object" || t == "function");
}
var ui = q4;
var iC = 0 / 0, Y4 = /^[-+]0x[0-9a-f]+$/i, X4 = /^0b[01]+$/i, Q4 = /^0o[0-7]+$/i, K4 = parseInt;
function Z4(n1) {
    if (typeof n1 == "number") return n1;
    if (al(n1)) return iC;
    if (ui(n1)) {
        var t = typeof n1.valueOf == "function" ? n1.valueOf() : n1;
        n1 = ui(t) ? t + "" : t;
    }
    if (typeof n1 != "string") return n1 === 0 ? n1 : +n1;
    n1 = rC(n1);
    var e = X4.test(n1);
    return e || Q4.test(n1) ? K4(n1.slice(2), e ? 2 : 8) : Y4.test(n1) ? iC : +n1;
}
var Ew = Z4;
function J4(n1) {
    return n1;
}
var nC = J4;
var $4 = "[object AsyncFunction]", ej = "[object Function]", tj = "[object GeneratorFunction]", rj = "[object Proxy]";
function ij(n1) {
    if (!ui(n1)) return !1;
    var t = Xn(n1);
    return t == ej || t == tj || t == $4 || t == rj;
}
var Ry = ij;
var nj = kr["__core-js_shared__"], Ly = nj;
var sC = function() {
    var n1 = /[^.]+$/.exec(Ly && Ly.keys && Ly.keys.IE_PROTO || "");
    return n1 ? "Symbol(src)_1." + n1 : "";
}();
function sj(n1) {
    return !!sC && sC in n1;
}
var oC = sj;
var oj = Function.prototype, aj = oj.toString;
function lj(n1) {
    if (n1 != null) {
        try {
            return aj.call(n1);
        } catch  {}
        try {
            return n1 + "";
        } catch  {}
    }
    return "";
}
var la = lj;
var cj = /[\\^$.*+?()[\]{}|]/g, uj = /^\[object .+?Constructor\]$/, dj = Function.prototype, hj = Object.prototype, fj = dj.toString, pj = hj.hasOwnProperty, mj = RegExp("^" + fj.call(pj).replace(cj, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function gj(n1) {
    if (!ui(n1) || oC(n1)) return !1;
    var t = Ry(n1) ? mj : uj;
    return t.test(la(n1));
}
var aC = gj;
function yj(n1, t) {
    return n1?.[t];
}
var lC = yj;
function vj(n1, t) {
    var e = lC(n1, t);
    return aC(e) ? e : void 0;
}
var En = vj;
var xj = En(kr, "WeakMap"), By = xj;
var cC = Object.create, bj = function() {
    function n1() {}
    return function(t) {
        if (!ui(t)) return {};
        if (cC) return cC(t);
        n1.prototype = t;
        var e = new n1;
        return n1.prototype = void 0, e;
    };
}(), uC = bj;
function Sj(n1, t, e) {
    switch(e.length){
        case 0:
            return n1.call(t);
        case 1:
            return n1.call(t, e[0]);
        case 2:
            return n1.call(t, e[0], e[1]);
        case 3:
            return n1.call(t, e[0], e[1], e[2]);
    }
    return n1.apply(t, e);
}
var dC = Sj;
function wj(n1, t) {
    var e = -1, r = n1.length;
    for(t || (t = Array(r)); ++e < r;)t[e] = n1[e];
    return t;
}
var hC = wj;
var Aj = 800, _j = 16, Ej = Date.now;
function Tj(n1) {
    var t = 0, e = 0;
    return function() {
        var r = Ej(), i = _j - (r - e);
        if (e = r, i > 0) {
            if (++t >= Aj) return arguments[0];
        } else t = 0;
        return n1.apply(void 0, arguments);
    };
}
var fC = Tj;
function Mj(n1) {
    return function() {
        return n1;
    };
}
var pC = Mj;
var Cj = function() {
    try {
        var n1 = En(Object, "defineProperty");
        return n1({}, "", {}), n1;
    } catch  {}
}(), od = Cj;
var Pj = od ? function(n1, t) {
    return od(n1, "toString", {
        configurable: !0,
        enumerable: !1,
        value: pC(t),
        writable: !0
    });
} : nC, mC = Pj;
var Dj = fC(mC), gC = Dj;
function Oj(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r && t(n1[e], e, n1) !== !1;);
    return n1;
}
var yC = Oj;
var Ij = 9007199254740991, Rj = /^(?:0|[1-9]\d*)$/;
function Lj(n1, t) {
    var e = typeof n1;
    return t = t ?? Ij, !!t && (e == "number" || e != "symbol" && Rj.test(n1)) && n1 > -1 && n1 % 1 == 0 && n1 < t;
}
var ad = Lj;
function Bj(n1, t, e) {
    t == "__proto__" && od ? od(n1, t, {
        configurable: !0,
        enumerable: !0,
        value: e,
        writable: !0
    }) : n1[t] = e;
}
var Ny = Bj;
function Nj(n1, t) {
    return n1 === t || n1 !== n1 && t !== t;
}
var ld = Nj;
var Fj = Object.prototype, kj = Fj.hasOwnProperty;
function zj(n1, t, e) {
    var r = n1[t];
    (!(kj.call(n1, t) && ld(r, e)) || e === void 0 && !(t in n1)) && Ny(n1, t, e);
}
var cd = zj;
function Vj(n1, t, e, r) {
    var i = !e;
    e || (e = {});
    for(var s = -1, o = t.length; ++s < o;){
        var a = t[s], l = r ? r(e[a], n1[a], a, e, n1) : void 0;
        l === void 0 && (l = n1[a]), i ? Ny(e, a, l) : cd(e, a, l);
    }
    return e;
}
var ho = Vj;
var vC = Math.max;
function Uj(n1, t, e) {
    return t = vC(t === void 0 ? n1.length - 1 : t, 0), function() {
        for(var r = arguments, i = -1, s = vC(r.length - t, 0), o = Array(s); ++i < s;)o[i] = r[t + i];
        i = -1;
        for(var a = Array(t + 1); ++i < t;)a[i] = r[i];
        return a[t] = e(o), dC(n1, this, a);
    };
}
var xC = Uj;
var Gj = 9007199254740991;
function jj(n1) {
    return typeof n1 == "number" && n1 > -1 && n1 % 1 == 0 && n1 <= Gj;
}
var ud = jj;
function Hj(n1) {
    return n1 != null && ud(n1.length) && !Ry(n1);
}
var Fy = Hj;
var Wj = Object.prototype;
function qj(n1) {
    var t = n1 && n1.constructor, e = typeof t == "function" && t.prototype || Wj;
    return n1 === e;
}
var dd = qj;
function Yj(n1, t) {
    for(var e = -1, r = Array(n1); ++e < n1;)r[e] = t(e);
    return r;
}
var bC = Yj;
var Xj = "[object Arguments]";
function Qj(n1) {
    return Yi(n1) && Xn(n1) == Xj;
}
var Tw = Qj;
var SC = Object.prototype, Kj = SC.hasOwnProperty, Zj = SC.propertyIsEnumerable, Jj = Tw(function() {
    return arguments;
}()) ? Tw : function(n1) {
    return Yi(n1) && Kj.call(n1, "callee") && !Zj.call(n1, "callee");
}, hd = Jj;
function $j() {
    return !1;
}
var wC = $j;
var EC = exports && !exports.nodeType && exports, AC = EC && true && module && !module.nodeType && module, eH = AC && AC.exports === EC, _C = eH ? kr.Buffer : void 0, tH = _C ? _C.isBuffer : void 0, rH = tH || wC, wc = rH;
var iH = "[object Arguments]", nH = "[object Array]", sH = "[object Boolean]", oH = "[object Date]", aH = "[object Error]", lH = "[object Function]", cH = "[object Map]", uH = "[object Number]", dH = "[object Object]", hH = "[object RegExp]", fH = "[object Set]", pH = "[object String]", mH = "[object WeakMap]", gH = "[object ArrayBuffer]", yH = "[object DataView]", vH = "[object Float32Array]", xH = "[object Float64Array]", bH = "[object Int8Array]", SH = "[object Int16Array]", wH = "[object Int32Array]", AH = "[object Uint8Array]", _H = "[object Uint8ClampedArray]", EH = "[object Uint16Array]", TH = "[object Uint32Array]", Sr = {};
Sr[vH] = Sr[xH] = Sr[bH] = Sr[SH] = Sr[wH] = Sr[AH] = Sr[_H] = Sr[EH] = Sr[TH] = !0;
Sr[iH] = Sr[nH] = Sr[gH] = Sr[sH] = Sr[yH] = Sr[oH] = Sr[aH] = Sr[lH] = Sr[cH] = Sr[uH] = Sr[dH] = Sr[hH] = Sr[fH] = Sr[pH] = Sr[mH] = !1;
function MH(n1) {
    return Yi(n1) && ud(n1.length) && !!Sr[Xn(n1)];
}
var TC = MH;
function CH(n1) {
    return function(t) {
        return n1(t);
    };
}
var fd = CH;
var MC = exports && !exports.nodeType && exports, Op = MC && true && module && !module.nodeType && module, PH = Op && Op.exports === MC, Mw = PH && Oy.process, DH = function() {
    try {
        var n1 = Op && Op.require && Op.require("util").types;
        return n1 || Mw && Mw.binding && Mw.binding("util");
    } catch  {}
}(), ca = DH;
var CC = ca && ca.isTypedArray, OH = CC ? fd(CC) : TC, ky = OH;
var IH = Object.prototype, RH = IH.hasOwnProperty;
function LH(n1, t) {
    var e = bi(n1), r = !e && hd(n1), i = !e && !r && wc(n1), s = !e && !r && !i && ky(n1), o = e || r || i || s, a = o ? bC(n1.length, String) : [], l = a.length;
    for(var u in n1)(t || RH.call(n1, u)) && !(o && (u == "length" || i && (u == "offset" || u == "parent") || s && (u == "buffer" || u == "byteLength" || u == "byteOffset") || ad(u, l))) && a.push(u);
    return a;
}
var zy = LH;
function BH(n1, t) {
    return function(e) {
        return n1(t(e));
    };
}
var Vy = BH;
var NH = Vy(Object.keys, Object), PC = NH;
var FH = Object.prototype, kH = FH.hasOwnProperty;
function zH(n1) {
    if (!dd(n1)) return PC(n1);
    var t = [];
    for(var e in Object(n1))kH.call(n1, e) && e != "constructor" && t.push(e);
    return t;
}
var DC = zH;
function VH(n1) {
    return Fy(n1) ? zy(n1) : DC(n1);
}
var pd = VH;
function UH(n1) {
    var t = [];
    if (n1 != null) for(var e in Object(n1))t.push(e);
    return t;
}
var OC = UH;
var GH = Object.prototype, jH = GH.hasOwnProperty;
function HH(n1) {
    if (!ui(n1)) return OC(n1);
    var t = dd(n1), e = [];
    for(var r in n1)r == "constructor" && (t || !jH.call(n1, r)) || e.push(r);
    return e;
}
var IC = HH;
function WH(n1) {
    return Fy(n1) ? zy(n1, !0) : IC(n1);
}
var as = WH;
var qH = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, YH = /^\w*$/;
function XH(n1, t) {
    if (bi(n1)) return !1;
    var e = typeof n1;
    return e == "number" || e == "symbol" || e == "boolean" || n1 == null || al(n1) ? !0 : YH.test(n1) || !qH.test(n1) || t != null && n1 in Object(t);
}
var RC = XH;
var QH = En(Object, "create"), ua = QH;
function KH() {
    this.__data__ = ua ? ua(null) : {}, this.size = 0;
}
var LC = KH;
function ZH(n1) {
    var t = this.has(n1) && delete this.__data__[n1];
    return this.size -= t ? 1 : 0, t;
}
var BC = ZH;
var JH = "__lodash_hash_undefined__", $H = Object.prototype, e5 = $H.hasOwnProperty;
function t5(n1) {
    var t = this.__data__;
    if (ua) {
        var e = t[n1];
        return e === JH ? void 0 : e;
    }
    return e5.call(t, n1) ? t[n1] : void 0;
}
var NC = t5;
var r5 = Object.prototype, i5 = r5.hasOwnProperty;
function n5(n1) {
    var t = this.__data__;
    return ua ? t[n1] !== void 0 : i5.call(t, n1);
}
var FC = n5;
var s5 = "__lodash_hash_undefined__";
function o5(n1, t) {
    var e = this.__data__;
    return this.size += this.has(n1) ? 0 : 1, e[n1] = ua && t === void 0 ? s5 : t, this;
}
var kC = o5;
function md(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
md.prototype.clear = LC;
md.prototype.delete = BC;
md.prototype.get = NC;
md.prototype.has = FC;
md.prototype.set = kC;
var Cw = md;
function a5() {
    this.__data__ = [], this.size = 0;
}
var zC = a5;
function l5(n1, t) {
    for(var e = n1.length; e--;)if (ld(n1[e][0], t)) return e;
    return -1;
}
var ll = l5;
var c5 = Array.prototype, u5 = c5.splice;
function d5(n1) {
    var t = this.__data__, e = ll(t, n1);
    if (e < 0) return !1;
    var r = t.length - 1;
    return e == r ? t.pop() : u5.call(t, e, 1), --this.size, !0;
}
var VC = d5;
function h5(n1) {
    var t = this.__data__, e = ll(t, n1);
    return e < 0 ? void 0 : t[e][1];
}
var UC = h5;
function f5(n1) {
    return ll(this.__data__, n1) > -1;
}
var GC = f5;
function p5(n1, t) {
    var e = this.__data__, r = ll(e, n1);
    return r < 0 ? (++this.size, e.push([
        n1,
        t
    ])) : e[r][1] = t, this;
}
var jC = p5;
function gd(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
gd.prototype.clear = zC;
gd.prototype.delete = VC;
gd.prototype.get = UC;
gd.prototype.has = GC;
gd.prototype.set = jC;
var cl = gd;
var m5 = En(kr, "Map"), ul = m5;
function g5() {
    this.size = 0, this.__data__ = {
        hash: new Cw,
        map: new (ul || cl),
        string: new Cw
    };
}
var HC = g5;
function y5(n1) {
    var t = typeof n1;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n1 !== "__proto__" : n1 === null;
}
var WC = y5;
function v5(n1, t) {
    var e = n1.__data__;
    return WC(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var dl = v5;
function x5(n1) {
    var t = dl(this, n1).delete(n1);
    return this.size -= t ? 1 : 0, t;
}
var qC = x5;
function b5(n1) {
    return dl(this, n1).get(n1);
}
var YC = b5;
function S5(n1) {
    return dl(this, n1).has(n1);
}
var XC = S5;
function w5(n1, t) {
    var e = dl(this, n1), r = e.size;
    return e.set(n1, t), this.size += e.size == r ? 0 : 1, this;
}
var QC = w5;
function yd(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
yd.prototype.clear = HC;
yd.prototype.delete = qC;
yd.prototype.get = YC;
yd.prototype.has = XC;
yd.prototype.set = QC;
var Ac = yd;
var A5 = "Expected a function";
function Pw(n1, t) {
    if (typeof n1 != "function" || t != null && typeof t != "function") throw new TypeError(A5);
    var e = function() {
        var r = arguments, i = t ? t.apply(this, r) : r[0], s = e.cache;
        if (s.has(i)) return s.get(i);
        var o = n1.apply(this, r);
        return e.cache = s.set(i, o) || s, o;
    };
    return e.cache = new (Pw.Cache || Ac), e;
}
Pw.Cache = Ac;
var KC = Pw;
var _5 = 500;
function E5(n1) {
    var t = KC(n1, function(r) {
        return e.size === _5 && e.clear(), r;
    }), e = t.cache;
    return t;
}
var ZC = E5;
var T5 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, M5 = /\\(\\)?/g, C5 = ZC(function(n1) {
    var t = [];
    return n1.charCodeAt(0) === 46 && t.push(""), n1.replace(T5, function(e, r, i, s) {
        t.push(i ? s.replace(M5, "$1") : r || e);
    }), t;
}), JC = C5;
function P5(n1) {
    return n1 == null ? "" : eC(n1);
}
var $C = P5;
function D5(n1, t) {
    return bi(n1) ? n1 : RC(n1, t) ? [
        n1
    ] : JC($C(n1));
}
var ls = D5;
var O5 = 1 / 0;
function I5(n1) {
    if (typeof n1 == "string" || al(n1)) return n1;
    var t = n1 + "";
    return t == "0" && 1 / n1 == -O5 ? "-0" : t;
}
var hl = I5;
function R5(n1, t) {
    t = ls(t, n1);
    for(var e = 0, r = t.length; n1 != null && e < r;)n1 = n1[hl(t[e++])];
    return e && e == r ? n1 : void 0;
}
var Uy = R5;
function L5(n1, t) {
    for(var e = -1, r = t.length, i = n1.length; ++e < r;)n1[i + e] = t[e];
    return n1;
}
var vd = L5;
var eP = Li ? Li.isConcatSpreadable : void 0;
function B5(n1) {
    return bi(n1) || hd(n1) || !!(eP && n1 && n1[eP]);
}
var tP = B5;
function rP(n1, t, e, r, i) {
    var s = -1, o = n1.length;
    for(e || (e = tP), i || (i = []); ++s < o;){
        var a = n1[s];
        t > 0 && e(a) ? t > 1 ? rP(a, t - 1, e, r, i) : vd(i, a) : r || (i[i.length] = a);
    }
    return i;
}
var iP = rP;
function N5(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? iP(n1, 1) : [];
}
var nP = N5;
function F5(n1) {
    return gC(xC(n1, void 0, nP), n1 + "");
}
var Gy = F5;
var k5 = Vy(Object.getPrototypeOf, Object), xd = k5;
var z5 = "[object Object]", V5 = Function.prototype, U5 = Object.prototype, sP = V5.toString, G5 = U5.hasOwnProperty, j5 = sP.call(Object);
function H5(n1) {
    if (!Yi(n1) || Xn(n1) != z5) return !1;
    var t = xd(n1);
    if (t === null) return !0;
    var e = G5.call(t, "constructor") && t.constructor;
    return typeof e == "function" && e instanceof e && sP.call(e) == j5;
}
var oP = H5;
function W5(n1, t, e) {
    var r = -1, i = n1.length;
    t < 0 && (t = -t > i ? 0 : i + t), e = e > i ? i : e, e < 0 && (e += i), i = t > e ? 0 : e - t >>> 0, t >>>= 0;
    for(var s = Array(i); ++r < i;)s[r] = n1[r + t];
    return s;
}
var aP = W5;
function q5() {
    this.__data__ = new cl, this.size = 0;
}
var lP = q5;
function Y5(n1) {
    var t = this.__data__, e = t.delete(n1);
    return this.size = t.size, e;
}
var cP = Y5;
function X5(n1) {
    return this.__data__.get(n1);
}
var uP = X5;
function Q5(n1) {
    return this.__data__.has(n1);
}
var dP = Q5;
var K5 = 200;
function Z5(n1, t) {
    var e = this.__data__;
    if (e instanceof cl) {
        var r = e.__data__;
        if (!ul || r.length < K5 - 1) return r.push([
            n1,
            t
        ]), this.size = ++e.size, this;
        e = this.__data__ = new Ac(r);
    }
    return e.set(n1, t), this.size = e.size, this;
}
var hP = Z5;
function bd(n1) {
    var t = this.__data__ = new cl(n1);
    this.size = t.size;
}
bd.prototype.clear = lP;
bd.prototype.delete = cP;
bd.prototype.get = uP;
bd.prototype.has = dP;
bd.prototype.set = hP;
var Sd = bd;
function J5(n1, t) {
    return n1 && ho(t, pd(t), n1);
}
var fP = J5;
function $5(n1, t) {
    return n1 && ho(t, as(t), n1);
}
var pP = $5;
var vP = exports && !exports.nodeType && exports, mP = vP && true && module && !module.nodeType && module, eW = mP && mP.exports === vP, gP = eW ? kr.Buffer : void 0, yP = gP ? gP.allocUnsafe : void 0;
function tW(n1, t) {
    if (t) return n1.slice();
    var e = n1.length, r = yP ? yP(e) : new n1.constructor(e);
    return n1.copy(r), r;
}
var xP = tW;
function rW(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = 0, s = []; ++e < r;){
        var o = n1[e];
        t(o, e, n1) && (s[i++] = o);
    }
    return s;
}
var bP = rW;
function iW() {
    return [];
}
var jy = iW;
var nW = Object.prototype, sW = nW.propertyIsEnumerable, SP = Object.getOwnPropertySymbols, oW = SP ? function(n1) {
    return n1 == null ? [] : (n1 = Object(n1), bP(SP(n1), function(t) {
        return sW.call(n1, t);
    }));
} : jy, wd = oW;
function aW(n1, t) {
    return ho(n1, wd(n1), t);
}
var wP = aW;
var lW = Object.getOwnPropertySymbols, cW = lW ? function(n1) {
    for(var t = []; n1;)vd(t, wd(n1)), n1 = xd(n1);
    return t;
} : jy, Hy = cW;
function uW(n1, t) {
    return ho(n1, Hy(n1), t);
}
var AP = uW;
function dW(n1, t, e) {
    var r = t(n1);
    return bi(n1) ? r : vd(r, e(n1));
}
var Wy = dW;
function hW(n1) {
    return Wy(n1, pd, wd);
}
var Ip = hW;
function fW(n1) {
    return Wy(n1, as, Hy);
}
var qy = fW;
var pW = En(kr, "DataView"), Yy = pW;
var mW = En(kr, "Promise"), Xy = mW;
var gW = En(kr, "Set"), Qy = gW;
var _P = "[object Map]", yW = "[object Object]", EP = "[object Promise]", TP = "[object Set]", MP = "[object WeakMap]", CP = "[object DataView]", vW = la(Yy), xW = la(ul), bW = la(Xy), SW = la(Qy), wW = la(By), _c = Xn;
(Yy && _c(new Yy(new ArrayBuffer(1))) != CP || ul && _c(new ul) != _P || Xy && _c(Xy.resolve()) != EP || Qy && _c(new Qy) != TP || By && _c(new By) != MP) && (_c = function(n1) {
    var t = Xn(n1), e = t == yW ? n1.constructor : void 0, r = e ? la(e) : "";
    if (r) switch(r){
        case vW:
            return CP;
        case xW:
            return _P;
        case bW:
            return EP;
        case SW:
            return TP;
        case wW:
            return MP;
    }
    return t;
});
var da = _c;
var AW = Object.prototype, _W = AW.hasOwnProperty;
function EW(n1) {
    var t = n1.length, e = new n1.constructor(t);
    return t && typeof n1[0] == "string" && _W.call(n1, "index") && (e.index = n1.index, e.input = n1.input), e;
}
var PP = EW;
var TW = kr.Uint8Array, Ad = TW;
function MW(n1) {
    var t = new n1.constructor(n1.byteLength);
    return new Ad(t).set(new Ad(n1)), t;
}
var _d = MW;
function CW(n1, t) {
    var e = t ? _d(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.byteLength);
}
var DP = CW;
var PW = /\w*$/;
function DW(n1) {
    var t = new n1.constructor(n1.source, PW.exec(n1));
    return t.lastIndex = n1.lastIndex, t;
}
var OP = DW;
var IP = Li ? Li.prototype : void 0, RP = IP ? IP.valueOf : void 0;
function OW(n1) {
    return RP ? Object(RP.call(n1)) : {};
}
var LP = OW;
function IW(n1, t) {
    var e = t ? _d(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.length);
}
var BP = IW;
var RW = "[object Boolean]", LW = "[object Date]", BW = "[object Map]", NW = "[object Number]", FW = "[object RegExp]", kW = "[object Set]", zW = "[object String]", VW = "[object Symbol]", UW = "[object ArrayBuffer]", GW = "[object DataView]", jW = "[object Float32Array]", HW = "[object Float64Array]", WW = "[object Int8Array]", qW = "[object Int16Array]", YW = "[object Int32Array]", XW = "[object Uint8Array]", QW = "[object Uint8ClampedArray]", KW = "[object Uint16Array]", ZW = "[object Uint32Array]";
function JW(n1, t, e) {
    var r = n1.constructor;
    switch(t){
        case UW:
            return _d(n1);
        case RW:
        case LW:
            return new r(+n1);
        case GW:
            return DP(n1, e);
        case jW:
        case HW:
        case WW:
        case qW:
        case YW:
        case XW:
        case QW:
        case KW:
        case ZW:
            return BP(n1, e);
        case BW:
            return new r;
        case NW:
        case zW:
            return new r(n1);
        case FW:
            return OP(n1);
        case kW:
            return new r;
        case VW:
            return LP(n1);
    }
}
var NP = JW;
function $W(n1) {
    return typeof n1.constructor == "function" && !dd(n1) ? uC(xd(n1)) : {};
}
var FP = $W;
var e6 = "[object Map]";
function t6(n1) {
    return Yi(n1) && da(n1) == e6;
}
var kP = t6;
var zP = ca && ca.isMap, r6 = zP ? fd(zP) : kP, VP = r6;
var i6 = "[object Set]";
function n6(n1) {
    return Yi(n1) && da(n1) == i6;
}
var UP = n6;
var GP = ca && ca.isSet, s6 = GP ? fd(GP) : UP, jP = s6;
var o6 = 1, a6 = 2, l6 = 4, HP = "[object Arguments]", c6 = "[object Array]", u6 = "[object Boolean]", d6 = "[object Date]", h6 = "[object Error]", WP = "[object Function]", f6 = "[object GeneratorFunction]", p6 = "[object Map]", m6 = "[object Number]", qP = "[object Object]", g6 = "[object RegExp]", y6 = "[object Set]", v6 = "[object String]", x6 = "[object Symbol]", b6 = "[object WeakMap]", S6 = "[object ArrayBuffer]", w6 = "[object DataView]", A6 = "[object Float32Array]", _6 = "[object Float64Array]", E6 = "[object Int8Array]", T6 = "[object Int16Array]", M6 = "[object Int32Array]", C6 = "[object Uint8Array]", P6 = "[object Uint8ClampedArray]", D6 = "[object Uint16Array]", O6 = "[object Uint32Array]", xr = {};
xr[HP] = xr[c6] = xr[S6] = xr[w6] = xr[u6] = xr[d6] = xr[A6] = xr[_6] = xr[E6] = xr[T6] = xr[M6] = xr[p6] = xr[m6] = xr[qP] = xr[g6] = xr[y6] = xr[v6] = xr[x6] = xr[C6] = xr[P6] = xr[D6] = xr[O6] = !0;
xr[h6] = xr[WP] = xr[b6] = !1;
function Ky(n1, t, e, r, i, s) {
    var o, a = t & o6, l = t & a6, u = t & l6;
    if (e && (o = i ? e(n1, r, i, s) : e(n1)), o !== void 0) return o;
    if (!ui(n1)) return n1;
    var c = bi(n1);
    if (c) {
        if (o = PP(n1), !a) return hC(n1, o);
    } else {
        var d = da(n1), h = d == WP || d == f6;
        if (wc(n1)) return xP(n1, a);
        if (d == qP || d == HP || h && !i) {
            if (o = l || h ? {} : FP(n1), !a) return l ? AP(n1, pP(o, n1)) : wP(n1, fP(o, n1));
        } else {
            if (!xr[d]) return i ? n1 : {};
            o = NP(n1, d, a);
        }
    }
    s || (s = new Sd);
    var f = s.get(n1);
    if (f) return f;
    s.set(n1, o), jP(n1) ? n1.forEach(function(g) {
        o.add(Ky(g, t, e, g, n1, s));
    }) : VP(n1) && n1.forEach(function(g, y) {
        o.set(y, Ky(g, t, e, y, n1, s));
    });
    var p = u ? l ? qy : Ip : l ? as : pd, m = c ? void 0 : p(n1);
    return yC(m || n1, function(g, y) {
        m && (y = g, g = n1[y]), cd(o, y, Ky(g, t, e, y, n1, s));
    }), o;
}
var Zy = Ky;
var I6 = 1, R6 = 4;
function L6(n1) {
    return Zy(n1, I6 | R6);
}
var ha = L6;
var B6 = "__lodash_hash_undefined__";
function N6(n1) {
    return this.__data__.set(n1, B6), this;
}
var YP = N6;
function F6(n1) {
    return this.__data__.has(n1);
}
var XP = F6;
function Jy(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.__data__ = new Ac; ++t < e;)this.add(n1[t]);
}
Jy.prototype.add = Jy.prototype.push = YP;
Jy.prototype.has = XP;
var QP = Jy;
function k6(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r;)if (t(n1[e], e, n1)) return !0;
    return !1;
}
var KP = k6;
function z6(n1, t) {
    return n1.has(t);
}
var ZP = z6;
var V6 = 1, U6 = 2;
function G6(n1, t, e, r, i, s) {
    var o = e & V6, a = n1.length, l = t.length;
    if (a != l && !(o && l > a)) return !1;
    var u = s.get(n1), c = s.get(t);
    if (u && c) return u == t && c == n1;
    var d = -1, h = !0, f = e & U6 ? new QP : void 0;
    for(s.set(n1, t), s.set(t, n1); ++d < a;){
        var p = n1[d], m = t[d];
        if (r) var g = o ? r(m, p, d, t, n1, s) : r(p, m, d, n1, t, s);
        if (g !== void 0) {
            if (g) continue;
            h = !1;
            break;
        }
        if (f) {
            if (!KP(t, function(y, v) {
                if (!ZP(f, v) && (p === y || i(p, y, e, r, s))) return f.push(v);
            })) {
                h = !1;
                break;
            }
        } else if (!(p === m || i(p, m, e, r, s))) {
            h = !1;
            break;
        }
    }
    return s.delete(n1), s.delete(t), h;
}
var $y = G6;
function j6(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r, i) {
        e[++t] = [
            i,
            r
        ];
    }), e;
}
var JP = j6;
function H6(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r) {
        e[++t] = r;
    }), e;
}
var $P = H6;
var W6 = 1, q6 = 2, Y6 = "[object Boolean]", X6 = "[object Date]", Q6 = "[object Error]", K6 = "[object Map]", Z6 = "[object Number]", J6 = "[object RegExp]", $6 = "[object Set]", e8 = "[object String]", t8 = "[object Symbol]", r8 = "[object ArrayBuffer]", i8 = "[object DataView]", e2 = Li ? Li.prototype : void 0, Dw = e2 ? e2.valueOf : void 0;
function n8(n1, t, e, r, i, s, o) {
    switch(e){
        case i8:
            if (n1.byteLength != t.byteLength || n1.byteOffset != t.byteOffset) return !1;
            n1 = n1.buffer, t = t.buffer;
        case r8:
            return !(n1.byteLength != t.byteLength || !s(new Ad(n1), new Ad(t)));
        case Y6:
        case X6:
        case Z6:
            return ld(+n1, +t);
        case Q6:
            return n1.name == t.name && n1.message == t.message;
        case J6:
        case e8:
            return n1 == t + "";
        case K6:
            var a = JP;
        case $6:
            var l = r & W6;
            if (a || (a = $P), n1.size != t.size && !l) return !1;
            var u = o.get(n1);
            if (u) return u == t;
            r |= q6, o.set(n1, t);
            var c = $y(a(n1), a(t), r, i, s, o);
            return o.delete(n1), c;
        case t8:
            if (Dw) return Dw.call(n1) == Dw.call(t);
    }
    return !1;
}
var t2 = n8;
var s8 = 1, o8 = Object.prototype, a8 = o8.hasOwnProperty;
function l8(n1, t, e, r, i, s) {
    var o = e & s8, a = Ip(n1), l = a.length, u = Ip(t), c = u.length;
    if (l != c && !o) return !1;
    for(var d = l; d--;){
        var h = a[d];
        if (!(o ? h in t : a8.call(t, h))) return !1;
    }
    var f = s.get(n1), p = s.get(t);
    if (f && p) return f == t && p == n1;
    var m = !0;
    s.set(n1, t), s.set(t, n1);
    for(var g = o; ++d < l;){
        h = a[d];
        var y = n1[h], v = t[h];
        if (r) var x = o ? r(v, y, h, t, n1, s) : r(y, v, h, n1, t, s);
        if (!(x === void 0 ? y === v || i(y, v, e, r, s) : x)) {
            m = !1;
            break;
        }
        g || (g = h == "constructor");
    }
    if (m && !g) {
        var S = n1.constructor, w = t.constructor;
        S != w && "constructor" in n1 && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof w == "function" && w instanceof w) && (m = !1);
    }
    return s.delete(n1), s.delete(t), m;
}
var r2 = l8;
var c8 = 1, i2 = "[object Arguments]", n2 = "[object Array]", ev = "[object Object]", u8 = Object.prototype, s2 = u8.hasOwnProperty;
function d8(n1, t, e, r, i, s) {
    var o = bi(n1), a = bi(t), l = o ? n2 : da(n1), u = a ? n2 : da(t);
    l = l == i2 ? ev : l, u = u == i2 ? ev : u;
    var c = l == ev, d = u == ev, h = l == u;
    if (h && wc(n1)) {
        if (!wc(t)) return !1;
        o = !0, c = !1;
    }
    if (h && !c) return s || (s = new Sd), o || ky(n1) ? $y(n1, t, e, r, i, s) : t2(n1, t, l, e, r, i, s);
    if (!(e & c8)) {
        var f = c && s2.call(n1, "__wrapped__"), p = d && s2.call(t, "__wrapped__");
        if (f || p) {
            var m = f ? n1.value() : n1, g = p ? t.value() : t;
            return s || (s = new Sd), i(m, g, e, r, s);
        }
    }
    return h ? (s || (s = new Sd), r2(n1, t, e, r, i, s)) : !1;
}
var o2 = d8;
function a2(n1, t, e, r, i) {
    return n1 === t ? !0 : n1 == null || t == null || !Yi(n1) && !Yi(t) ? n1 !== n1 && t !== t : o2(n1, t, e, r, a2, i);
}
var l2 = a2;
function h8(n1, t) {
    return n1 != null && t in Object(n1);
}
var c2 = h8;
function f8(n1, t, e) {
    t = ls(t, n1);
    for(var r = -1, i = t.length, s = !1; ++r < i;){
        var o = hl(t[r]);
        if (!(s = n1 != null && e(n1, o))) break;
        n1 = n1[o];
    }
    return s || ++r != i ? s : (i = n1 == null ? 0 : n1.length, !!i && ud(i) && ad(o, i) && (bi(n1) || hd(n1)));
}
var u2 = f8;
function p8(n1, t) {
    return n1 != null && u2(n1, t, c2);
}
var d2 = p8;
var m8 = function() {
    return kr.Date.now();
}, tv = m8;
var g8 = "Expected a function", y8 = Math.max, v8 = Math.min;
function x8(n1, t, e) {
    var r, i, s, o, a, l, u = 0, c = !1, d = !1, h = !0;
    if (typeof n1 != "function") throw new TypeError(g8);
    t = Ew(t) || 0, ui(e) && (c = !!e.leading, d = "maxWait" in e, s = d ? y8(Ew(e.maxWait) || 0, t) : s, h = "trailing" in e ? !!e.trailing : h);
    function f(A) {
        var E = r, b = i;
        return r = i = void 0, u = A, o = n1.apply(b, E), o;
    }
    function p(A) {
        return u = A, a = setTimeout(y, t), c ? f(A) : o;
    }
    function m(A) {
        var E = A - l, b = A - u, T = t - E;
        return d ? v8(T, s - b) : T;
    }
    function g(A) {
        var E = A - l, b = A - u;
        return l === void 0 || E >= t || E < 0 || d && b >= s;
    }
    function y() {
        var A = tv();
        if (g(A)) return v(A);
        a = setTimeout(y, m(A));
    }
    function v(A) {
        return a = void 0, h && r ? f(A) : (r = i = void 0, o);
    }
    function x() {
        a !== void 0 && clearTimeout(a), u = 0, r = l = i = a = void 0;
    }
    function S() {
        return a === void 0 ? o : v(tv());
    }
    function w() {
        var A = tv(), E = g(A);
        if (r = arguments, i = this, l = A, E) {
            if (a === void 0) return p(l);
            if (d) return clearTimeout(a), a = setTimeout(y, t), f(l);
        }
        return a === void 0 && (a = setTimeout(y, t)), o;
    }
    return w.cancel = x, w.flush = S, w;
}
var Ec = x8;
function b8(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? n1[t - 1] : void 0;
}
var h2 = b8;
function S8(n1, t) {
    return t.length < 2 ? n1 : Uy(n1, aP(t, 0, -1));
}
var f2 = S8;
function w8(n1, t) {
    return l2(n1, t);
}
var Rp = w8;
function A8(n1, t) {
    return t = ls(t, n1), n1 = f2(n1, t), n1 == null || delete n1[hl(h2(t))];
}
var p2 = A8;
function _8(n1) {
    return oP(n1) ? void 0 : n1;
}
var m2 = _8;
var E8 = 1, T8 = 2, M8 = 4, C8 = Gy(function(n1, t) {
    var e = {};
    if (n1 == null) return e;
    var r = !1;
    t = Iy(t, function(s) {
        return s = ls(s, n1), r || (r = s.length > 1), s;
    }), ho(n1, qy(n1), e), r && (e = Zy(e, E8 | T8 | M8, m2));
    for(var i = t.length; i--;)p2(e, t[i]);
    return e;
}), Ed = C8;
function P8(n1, t, e, r) {
    if (!ui(n1)) return n1;
    t = ls(t, n1);
    for(var i = -1, s = t.length, o = s - 1, a = n1; a != null && ++i < s;){
        var l = hl(t[i]), u = e;
        if (l === "__proto__" || l === "constructor" || l === "prototype") return n1;
        if (i != o) {
            var c = a[l];
            u = r ? r(c, l, a) : void 0, u === void 0 && (u = ui(c) ? c : ad(t[i + 1]) ? [] : {});
        }
        cd(a, l, u), a = a[l];
    }
    return n1;
}
var g2 = P8;
function D8(n1, t, e) {
    for(var r = -1, i = t.length, s = {}; ++r < i;){
        var o = t[r], a = Uy(n1, o);
        e(a, o) && g2(s, ls(o, n1), a);
    }
    return s;
}
var y2 = D8;
function O8(n1, t) {
    return y2(n1, t, function(e, r) {
        return d2(n1, r);
    });
}
var v2 = O8;
var I8 = Gy(function(n1, t) {
    return n1 == null ? {} : v2(n1, t);
}), Qn = I8;
var R8 = "Expected a function";
function L8(n1, t, e) {
    var r = !0, i = !0;
    if (typeof n1 != "function") throw new TypeError(R8);
    return ui(e) && (r = "leading" in e ? !!e.leading : r, i = "trailing" in e ? !!e.trailing : i), Ec(n1, t, {
        leading: r,
        maxWait: t,
        trailing: i
    });
}
var Ow = L8;
function rv(n1) {
    for (let t of Object.keys(n1))n1[t] === void 0 && delete n1[t];
    return n1;
}
function pn(n1, t) {
    return Object.setPrototypeOf(n1, t), n1;
}
var B8 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes(" electron/"), N8 = ()=>typeof window > "u" ? !1 : window.navigator.platform.toUpperCase().includes("MAC"), F8 = ()=>typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(window.navigator.userAgent) || Td && "ontouchend" in document, k8 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1, z8 = ()=>typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0, V8 = ()=>{
    if (typeof window > "u") return !1;
    let n1 = navigator.userAgent, t = navigator.vendor;
    return /Safari/i.test(n1) && /Apple Computer/.test(t);
}, U8 = ()=>{
    if (typeof window > "u") return null;
    let t = navigator.userAgent.match(/Version\/(\d+\.\d)/);
    return t && t[1];
}, G8 = ()=>{
    if (typeof window > "u") return;
    let t = new URLSearchParams(window.location.search).get("desktop-app-version");
    return t ? (window.localStorage.setItem("desktop-app-version", t), t) : window.localStorage.getItem("desktop-app-version") ?? "0.0.6";
}, j8 = B8(), Sle = j8 ? G8() : void 0, Td = N8(), Md = F8(), x2 = k8(), Si = z8(), Iw = V8(), Rw = Number(U8());
function iv(n1) {
    return Array.isArray(n1) ? n1 : [
        n1
    ];
}
function nv(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
function Lp(n1) {
    return Td ? n1.metaKey : n1.ctrlKey;
}
function b2(n1) {
    return n1.wheelDeltaY === 0 || n1.deltaY === 0 ? Td && n1.shiftKey && Math.abs(n1.wheelDeltaX) >= 120 ? !1 : n1.wheelDeltaX ? n1.wheelDeltaX === -3 * n1.deltaX || n1.wheelDeltaX === -3 * window.devicePixelRatio * n1.deltaX : n1.deltaMode === 0 : n1.wheelDeltaY ? n1.wheelDeltaY === -3 * n1.deltaY || n1.wheelDeltaY === -3 * window.devicePixelRatio * n1.deltaY : n1.deltaMode === 0;
}
var Ye = [], ov = {}, Bp = {}, sv = {};
function S2(n1) {
    Ye.includes(n1) || Ye.push(n1);
}
function Cd(n1) {
    delete ov[n1.pointerId];
    for(let t = 0; t < Ye.length; t++)if (Ye[t].pointerId === n1.pointerId) {
        Ye.splice(t, 1);
        break;
    }
}
function w2() {
    Ye.splice(0, Ye.length);
}
function av(n1) {
    if (n1.pointerType !== "touch") return;
    let t = ov[n1.pointerId];
    t === void 0 && (t = {
        x: 0,
        y: 0
    }, ov[n1.pointerId] = t), t.x = n1.pageX, t.y = n1.pageY;
}
function lv(n1) {
    let t = n1.pointerId === Ye[0].pointerId ? Ye[1] : Ye[0];
    return ov[t.pointerId];
}
function A2(n1) {
    Bp[n1.key] = !0, sv[n1.key] = sv[n1.key] === void 0 ? 1 : sv[n1.key] + 1;
}
function _2(n1) {
    if (Td && Bp.Meta) for(let t in Bp)Bp[t] = !1;
    else Bp[n1.key] = !1;
    sv = {};
}
function E2(n1) {
    n1.addEventListener("pointerdown", S2, !0), n1.addEventListener("pointerdown", av, !0), n1.addEventListener("pointermove", av, !0), n1.addEventListener("pointerup", Cd, !0), n1.addEventListener("pointercancel", Cd, !0), n1.addEventListener("pointerleave", Cd, !0), window.addEventListener("keydown", A2, !0), window.addEventListener("keyup", _2, !0);
}
function T2(n1) {
    n1.removeEventListener("pointerdown", S2, !0), n1.removeEventListener("pointerdown", av, !0), n1.removeEventListener("pointermove", av, !0), n1.removeEventListener("pointerup", Cd, !0), n1.removeEventListener("pointercancel", Cd, !0), n1.removeEventListener("pointerleave", Cd, !0), window.removeEventListener("keydown", A2, !0), window.removeEventListener("keyup", _2, !0);
}
var M2, C2 = new Promise((n1)=>{
    M2 = n1;
});
var cv;

function P2() {
    if (cv) return cv;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/navmesh-wasm@1.0.16/build", i = (parcelRequire("8b5hF")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/navmesh.wasm`).then((u)=>u.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        M2(l);
    }
    return cv = n1(), cv;
}
var D2, O2 = new Promise((n1)=>{
    D2 = n1;
});
var uv;

function I2() {
    if (uv) return uv;
    async function n1() {
        let e = await (parcelRequire("lUNnT"));
        await e.init(), D2(e);
    }
    return uv = n1(), uv;
}
var Ke = class {
    modifyById(t, e) {
        let r = this;
        if (r[t] === void 0) throw new Error("not expected");
        {
            let s = {
                ...r,
                [t]: e
            };
            return Object.setPrototypeOf(s, Ke.prototype), s;
        }
    }
    add(t, e) {
        return this.runOp({
            type: 1,
            id: t,
            data: e
        })?.data ?? this;
    }
    runOp(t) {
        let e = this;
        if (t.type === 1) {
            let r = e[t.id], i;
            r === void 0 ? i = {
                type: 2,
                id: t.id
            } : i = {
                type: 1,
                id: t.id,
                data: r
            };
            let { id: s, data: o } = t, a = {
                ...e,
                [s]: o
            };
            return Object.setPrototypeOf(a, Ke.prototype), {
                data: a,
                actual: t,
                reverse: i
            };
        } else if (t.type === 2) {
            let { id: r } = t, i = e[r];
            if (i === void 0) return null;
            {
                let s = {
                    ...e
                };
                return Object.setPrototypeOf(s, Ke.prototype), delete s[r], {
                    data: s,
                    actual: t,
                    reverse: {
                        type: 1,
                        id: r,
                        data: i
                    }
                };
            }
        }
        return null;
    }
};
function Np(n1) {
    if (n1.deepFreeze !== void 0) {
        n1.deepFreeze(n1);
        return;
    }
    let t = Object.getOwnPropertyNames(n1);
    for (let e of t){
        let r = n1[e];
        r && typeof r == "object" && Np(r);
    }
    return Object.freeze(n1);
}
function R2(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
var Pd = class extends Error {
};
function dv(n1) {
    let t = {
        ...n1
    };
    return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
}
function fo(n1, t, e) {
    if (n1 === void 0 ? t === void 0 ? (n1 = 0, t = 10) : n1 = t - 10 : t === void 0 && (t = n1 + 10), n1 > t) {
        let s = n1;
        n1 = t, t = s;
    }
    let r = [], i = 1 / (e + 1);
    for(let s = 0; s < e; s++){
        let o = n1 + (t - n1) * (s + .75 + Math.random() * .5) * i;
        r.push(o);
    }
    return r;
}
function Dd(n1) {
    return n1 instanceof Uint8Array || n1 instanceof Uint16Array || n1 instanceof Uint32Array || n1 instanceof Int8Array || n1 instanceof Int16Array || n1 instanceof Int32Array || n1 instanceof Float32Array || n1 instanceof Float64Array;
}
function L2() {
    return typeof $hPtJY < "u";
}
function B2(n1, t) {
    for (let e of n1)t(e.id, e.data) !== !0 && B2(e.children, t);
}
function N2(n1, t) {
    if (t(n1.id, n1.data) !== !0) for (let e of n1.children)N2(e, t);
}
var ar = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, ar.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)Np(this[e]), e++;
    }
    fillCaches0(e, r) {
        this.objCaches.set(e.id, e), this.parentCaches.set(e.id, r);
        for (let i of e.children)this.fillCaches0(i, e.id);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, this.parentCaches = new Map;
            for (let e of this)this.fillCaches0(e, null);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    nonExistOrDescendantOf(e, r) {
        if (!this.has(e)) return !0;
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    rootAcestor(e) {
        for(; e;){
            let r = this.parent(e);
            if (r) e = r;
            else return e;
        }
        return e;
    }
    isDescendantOf(e, r) {
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    data(e) {
        return this.get(e)?.data;
    }
    has(e) {
        return this.childrenOf(e) !== void 0;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    childrenOf(e) {
        return e === null ? this : this.get(e)?.children;
    }
    traverseFrom(e, r) {
        if (e === null) this.traverse(r);
        else {
            let i = this.get(e);
            i && N2(i, r);
        }
    }
    traverse(e) {
        B2(this, e);
    }
    totalSize() {
        return this.fillCaches(), this.objCaches.size;
    }
    parent(e) {
        return this.fillCaches(), this.parentCaches.get(e);
    }
    childrenArray(e) {
        return e === null ? this : this.get(e).children;
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this.parent(e), o = this.childrenArray(s), a = o.findIndex((c)=>c.id === e);
            if (a < 0) throw new Error("not expected");
            let l = o[a];
            return o = [
                ...o
            ], o[a] = {
                ...l,
                data: r
            }, this.modifyArrayBy(s, o);
        }
    }
    modifyArrayBy(e, r) {
        let i = e, s = r;
        for(; i !== null;){
            let a = s, l = i;
            if (i = this.parent(i), i === void 0) throw new Error;
            s = this.childrenArray(i);
            let u = s.findIndex((c)=>c.id === l);
            if (u < 0) throw new Error;
            s = [
                ...s
            ], s[u] = {
                ...s[u],
                children: a
            };
        }
        Object.setPrototypeOf(s, ar.prototype);
        let o = s;
        return o.fillCaches(), o;
    }
    runOp(e) {
        switch(e.type){
            case 7:
                return this.addOp(e);
            case 8:
                return this.deleteOp(e);
            case 9:
                return this.moveOp(e);
        }
        return null;
    }
    checkDuplicatedIdRec({ id: e, children: r }) {
        if (this.get(e) !== void 0) return !0;
        for (let i of r)if (this.checkDuplicatedIdRec(i)) return !0;
        return !1;
    }
    addOp(e) {
        let { parent: r, fi: i, id: s, data: o, children: a } = e;
        if (r !== null && this.get(r) === void 0) return null;
        if (this.checkDuplicatedIdRec(e)) return null;
        {
            let l = r, u = this.childrenArray(l), c = {
                fi: i,
                id: s,
                data: o,
                children: a
            };
            return u = [
                ...u,
                c
            ], u.sort((h, f)=>h.fi - f.fi), e.localIndex = u.indexOf(c), {
                data: this.modifyArrayBy(l, u),
                actual: e,
                reverse: {
                    type: 8,
                    id: s
                }
            };
        }
    }
    deleteOp(e) {
        let { id: r } = e;
        if (this.get(r) === null) return null;
        {
            let i = this.parent(r);
            if (i === void 0) return null;
            let s = this.childrenArray(i), o = s.findIndex((u)=>u.id === r);
            e.localIndex = o, s = [
                ...s
            ];
            let a = s.splice(o, 1)[0];
            return {
                data: this.modifyArrayBy(i, s),
                actual: e,
                reverse: {
                    type: 7,
                    ...a,
                    parent: i
                }
            };
        }
    }
    moveOp(e) {
        let { parent: r, fi: i, id: s } = e;
        if (r !== null && this.get(r) === void 0) return this.deleteOp({
            type: 8,
            id: s
        });
        if (r !== null) {
            let f = r;
            for(; f !== null;){
                if (f === void 0) throw new Error;
                if (f === s) throw new Pd("cyclic tree");
                f = this.parent(f);
            }
        }
        let o = this.parent(s);
        if (o === void 0) return null;
        let a = o, l = this.childrenArray(o), u = l.findIndex((f)=>f.id === s);
        l = [
            ...l
        ];
        let c = l.splice(u, 1)[0], d = this.modifyArrayBy(o, l);
        o = r, l = d.childrenArray(o);
        let h = c.fi;
        return c = {
            ...c,
            fi: i
        }, l = [
            ...l,
            c
        ], l.sort((f, p)=>f.fi - p.fi), e.localIndex = l.indexOf(c), d = d.modifyArrayBy(o, l), {
            data: d,
            actual: e,
            reverse: {
                type: 9,
                parent: a,
                fi: h,
                id: s
            }
        };
    }
    previous(e, r) {
        if (r === null) {
            let s = this.childrenArray(e);
            return s.length === 0 ? null : s[s.length - 1].id;
        }
        let i = null;
        for (let s of this.childrenArray(e)){
            if (s.id === r) return i;
            i = s.id;
        }
        return null;
    }
    traverseSortNext(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s = i.findIndex((o)=>o.id === e) + 1;
            if (s < i.length) return i[s].id;
            if (r) return this.traverseSortNext(r);
        }
    }
    sortNext(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? r[0].id : this.traverseSortNext(e);
    }
    traverseSortPrevious(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? this.traverseSortPrevious(r[r.length - 1].id) : e;
    }
    sortPrevious(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s = i.findIndex((o)=>o.id === e) - 1;
            return s >= 0 ? this.traverseSortPrevious(i[s].id) : r;
        }
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && r.push({
                ...i,
                ...s
            });
        }
        r.sort((i, s)=>R2(i.sortKey, s.sortKey));
        for (let i of r)delete i.sortKey;
        return r;
    }
    getWithSortKey(e) {
        var r = e;
        let i = [], s = this.get(r), o = s;
        if (s !== void 0) {
            for(; r;)i.splice(0, 0, s.fi), r = this.parent(r), r !== null && (s = this.get(r));
            return {
                ...o,
                sortKey: i
            };
        }
    }
    insertBeforeHelper(e, r, i) {
        return this.insertAfterHelper(e, this.previous(e, r), i);
    }
    insertAfterHelper(e, r, i) {
        let s = this.childrenArray(e);
        if (r === null) {
            if (s.length === 0) return fo(0, i, i);
            {
                let o = s[0].fi;
                return fo(o - i, o, i);
            }
        } else {
            let o = this.get(r);
            if (o === void 0 || this.parent(r) !== e) throw new Error("illegal args");
            let a = s.find((l)=>l.fi > o.fi);
            if (a === void 0) {
                let l = s[s.length - 1].fi;
                return fo(l, l + i, i);
            } else return fo(o.fi, a.fi, i);
        }
    }
};
var Od;
((t)=>{
    function n1(e, r) {
        if (r.type !== 0) return null;
        if (Array.isArray(e)) {
            let i = r.props, s = {}, o = [
                ...e
            ], a = !1;
            if (i) for (let l of Object.keys(i)){
                let u = parseInt(l);
                if (isNaN(u)) throw new Error("wrong index");
                s[l] = o[u], o[u] = i[l], a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        } else {
            let i = r.props, s = {}, o = {
                ...e
            }, a = !1;
            if (i) for (let l of Object.keys(i)){
                s[l] = o[l];
                let u = i[l];
                u === void 0 ? delete o[l] : o[l] = u, a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        }
    }
    t.runOp = n1;
})(Od || (Od = {}));
var Re = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, Re.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)Np(this[e]), e++;
    }
    fillCaches0(e) {
        this.objCaches.set(e.id, e);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, Object.getOwnPropertyDescriptor(this, "objCaches").enumerable = !1;
            for (let e of this)this.fillCaches0(e);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    data(e) {
        return this.get(e)?.data;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this, o = s.findIndex((u)=>u.id === e);
            if (o < 0) throw new Error("not expected");
            let a = s[o];
            return s = [
                ...s
            ], s[o] = {
                ...a,
                data: r
            }, this.modifyArrayBy(s);
        }
    }
    modifyArrayBy(e) {
        Object.setPrototypeOf(e, Re.prototype);
        let r = e;
        return L2() || r.fillCaches(), r;
    }
    runOp(e) {
        switch(e.type){
            case 4:
                return this.addOp(e);
            case 5:
                return this.deleteOp(e);
            case 6:
                return this.moveOp(e);
        }
        return null;
    }
    addOp(e) {
        let { fi: r, id: i, data: s } = e, o = this, a = {
            fi: r,
            id: i,
            data: s
        };
        return o = [
            ...o,
            a
        ], o.sort((u, c)=>u.fi - c.fi), e.localIndex = o.indexOf(a), {
            data: this.modifyArrayBy(o),
            actual: e,
            reverse: {
                type: 5,
                id: i
            }
        };
    }
    deleteOp(e) {
        let { id: r } = e, i = this, s = i.findIndex((l)=>l.id === r);
        if (s === -1) return null;
        e.localIndex = s, i = [
            ...i
        ];
        let o = i.splice(s, 1)[0];
        return {
            data: this.modifyArrayBy(i),
            actual: e,
            reverse: {
                type: 4,
                ...o
            }
        };
    }
    moveOp(e) {
        let { fi: r, id: i } = e, s = this;
        s = [
            ...s
        ];
        let o = s.findIndex((c)=>c.id === i);
        if (o === -1) return null;
        let a = s[o].fi, l = {
            ...s[o],
            fi: r
        };
        return s[o] = l, s.sort((c, d)=>c.fi - d.fi), e.localIndex = s.indexOf(l), {
            data: this.modifyArrayBy(s),
            actual: e,
            reverse: {
                type: 6,
                fi: a,
                id: i
            }
        };
    }
    previous(e) {
        if (e === null) return this.length === 0 ? null : this[this.length - 1].id;
        let r = null;
        for (let i of this){
            if (i.id === e) return r;
            r = i.id;
        }
        return null;
    }
    insertBeforeHelper(e, r) {
        return this.insertAfterHelper(this.previous(e), r);
    }
    insertAfterHelper(e, r) {
        let i = this;
        if (e === null) {
            if (i.length === 0) return fo(0, r, r);
            {
                let s = i[0].fi;
                return fo(s - r, s, r);
            }
        } else {
            let s = this.get(e);
            if (s === void 0) throw new Error("illegal args");
            let o = i.find((a)=>a.fi > s.fi);
            if (o === void 0) {
                let a = i[i.length - 1].fi;
                return fo(a, a + r, r);
            } else return fo(s.fi, o.fi, r);
        }
    }
};
function Id(n1) {
    return n1 && typeof n1 == "object" && n1 instanceof lr;
}
var lr = class {
    unusedFunOverridesTable(t) {}
    runOp(t) {
        let e = [], r = this, i = 0, s = {};
        for(; i < t.path.length;){
            if (e.push(r), r = r === void 0 ? void 0 : r[t.path[i]], r !== void 0 && !Id(r)) return null;
            i += 1;
        }
        r = r ? dv(r) : new lr;
        for (let [l, u] of Object.entries(t.props)){
            let c = r[l];
            s[l] = c, u === void 0 ? delete r[l] : r[l] = u;
        }
        for(; i > 0;){
            if (Object.keys(r).length === 0) {
                let l = e[i - 1];
                l && (r = dv(l), delete r[t.path[i - 1]]);
            } else {
                let l = e[i - 1];
                if (l) {
                    let u = dv(l);
                    u[t.path[i - 1]] = r, r = u;
                } else {
                    let u = new lr;
                    u[t.path[i - 1]] = r, r = u;
                }
            }
            i -= 1;
        }
        let o = Object.setPrototypeOf(r, lr.prototype), a = {
            ...t,
            props: s
        };
        return {
            data: o,
            actual: t,
            reverse: a
        };
    }
}, po;
((r)=>{
    function n1(i, s) {
        return Fp(i, s) ?? i;
    }
    r.apply = n1;
    function t(i, s) {
        return Bw(i, s);
    }
    r.merge = t;
    function e(i, s) {
        let o = 0, a = s.path, l = i;
        for(; o < a.length && l !== void 0;){
            if (l = Tr.zoomOnce(l, a[o]), l === void 0) return s;
            if (!Id(l)) return;
            o += 1;
        }
        if (l === void 0) return s;
        if (!!Id(l)) {
            if (s.type === 0) {
                let u = {
                    ...s.props
                };
                for (let c of Object.keys(l))delete u[c];
                return {
                    ...s,
                    props: u
                };
            } else if (s.type === 1 || s.type === 4 || s.type === 7) {
                let u = Lw([
                    s
                ], l);
                return u ? (console.log(u), u) : s;
            } else return s;
        }
    }
    r.filterOp = e;
})(po || (po = {}));
function Lw(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s = i.id, o = Fp(i.data, t[s]);
        if (e = e || o !== void 0, o === void 0 && (o = i.data), i.children) {
            let a = Lw(i.children, t);
            return a !== void 0 ? e = !0 : a = i.children, {
                ...i,
                id: s,
                data: o,
                children: a
            };
        } else return {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return r;
}
function H8(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s = i.id, o = Fp(i.data, t[s]);
        return e = e || o !== void 0, o === void 0 && (o = i.data), {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
}
function Fp(n1, t) {
    if (!Id(t)) return t;
    if (n1 instanceof ar) {
        let e = Lw(n1, t);
        return e !== void 0 && Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e;
    } else {
        if (n1 instanceof Re) return H8(n1, t);
        if (Array.isArray(n1)) {
            let e = !1, r = n1.map((i, s)=>{
                let o = Fp(i, t[s]);
                return e = e || o !== void 0, o === void 0 && (o = i), o;
            });
            return e ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else {
            if (n1 instanceof lr) return Bw(n1, t);
            if (n1 && typeof n1 == "object") {
                let e = {}, r = !1;
                for (let [i, s] of Object.entries(n1)){
                    let o = Fp(s, t[i]);
                    r = r || o !== void 0, o === void 0 && (o = s), e[i] = o;
                }
                return r ? (Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e) : void 0;
            }
        }
    }
}
function Bw(n1, t) {
    if (n1 === void 0) return t;
    if (t === void 0) return n1;
    if (!Id(t)) return t;
    if (!Id(n1)) return po.apply(n1, t);
    let e = new Set;
    for (let i of Object.keys(n1))e.add(i);
    for (let i of Object.keys(t))e.add(i);
    let r = new lr;
    for (let i of e){
        let s = Bw(n1 === void 0 ? void 0 : n1[i], t === void 0 ? void 0 : t[i]);
        r[i] = s;
    }
    return r;
}
function F2(n1, t) {
    let e = {
        cur: [],
        result: [],
        len: 0
    };
    return n1 = kp(n1, t, e) ?? n1, [
        n1,
        e.result
    ];
}
function hv(n1, t) {
    return n1 === null ? null : (n1.cur[n1.len] = t, n1.len += 1, n1);
}
function fv(n1) {
    n1 && (n1.len -= 1);
}
function W8(n1) {
    if (n1 === null) return null;
    n1.result.push(n1.cur.slice(0, n1.len));
}
function k2(n1, t, e) {
    let r = !1, i = n1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = kp(s.data, t, hv(e, o));
        fv(e), r = r || l !== void 0, l === void 0 && (l = s.data);
        let u = k2(s.children, t, e);
        return u !== void 0 ? r = !0 : u = s.children, {
            ...s,
            id: o,
            data: l,
            children: u
        };
    });
    if (r) return i;
}
function q8(n1, t, e) {
    let r = !1, i = n1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = kp(s.data, t, hv(e, o));
        return fv(e), r = r || l !== void 0, l === void 0 && (l = s.data), {
            ...s,
            id: o,
            data: l
        };
    });
    if (r) return Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i;
}
function kp(n1, t, e) {
    if (n1 instanceof ar) {
        let r = k2(n1, t, e);
        return r !== void 0 && Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
    } else {
        if (n1 instanceof Re) return q8(n1, t, e);
        if (Array.isArray(n1)) {
            let r = !1, i = n1.map((s, o)=>{
                let a = kp(s, t, hv(e, o));
                return fv(e), r = r || a !== void 0, a === void 0 && (a = s), a;
            });
            return r ? (Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i) : void 0;
        } else if (n1 && typeof n1 == "object" && !Dd(n1)) {
            let r = {}, i = !1;
            for (let [s, o] of Object.entries(n1))if (s !== "name") {
                let a = t[s];
                if (typeof a == "string") {
                    if (e !== null) throw new Error("not supported");
                    i = !0, s = a;
                }
                let l = kp(o, t, hv(e, s));
                fv(e), i = i || l !== void 0, l === void 0 && (l = o), r[s] = l;
            } else r[s] = o;
            return i ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else if (typeof n1 == "string") {
            let r = t[n1];
            return r !== void 0 && W8(e), r;
        } else return;
    }
}
var Rd;
((t)=>{
    function n1(e, r) {
        let i = Tr.zoom(r, e.path);
        if (typeof i == "object") {
            let s = {};
            for (let o of Object.keys(e.props))s[o] = i[o];
            return {
                ...e,
                props: s
            };
        } else return {
            ...e,
            props: {}
        };
    }
    t.replaceProps = n1;
})(Rd || (Rd = {}));
var Mr;
((a)=>{
    function n1(l, u) {
        return {
            ...l,
            path: l.path.slice(u)
        };
    }
    a.drop = n1;
    function t(l, u) {
        return e(l, u)?.data ?? l;
    }
    a.applySimple = t;
    function e(l, u) {
        let c = u.path;
        for(var d = [];;){
            let h;
            if (l instanceof lr && u.type === 0 && (h = l.runOp({
                ...u,
                path: c.slice(d.length)
            }), h === null && (h = void 0)), h === void 0 && d.length === c.length && (l instanceof ar || l instanceof Re || l instanceof Ke ? h = l.runOp(u) : h = Od.runOp(l, u)), h !== void 0) {
                if (h !== null) {
                    let m = h.data;
                    for(let g = d.length - 1; g >= 0; g--){
                        let y = c[g], v = d[g];
                        if (v instanceof ar) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = v.modifyById(y, m);
                        } else if (v instanceof Re) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = v.modifyById(y, m);
                        } else if (v instanceof Ke) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            m = v.modifyById(y, m);
                        } else if (v instanceof lr) {
                            let x = {
                                ...v,
                                [y]: m
                            };
                            m = Object.setPrototypeOf(x, lr.prototype);
                        } else if (typeof v == "object") {
                            if (Array.isArray(v)) {
                                if (typeof y == "string" && (y = parseInt(y), isNaN(y))) throw new Error("Invalid path");
                                let x = m;
                                m = [
                                    ...v
                                ], m[y] = x;
                            } else m = {
                                ...v,
                                [y]: m
                            };
                        } else return null;
                    }
                    return {
                        data: m,
                        actual: {
                            ...h.actual,
                            path: c
                        },
                        reverse: {
                            ...h.reverse,
                            path: c
                        }
                    };
                } else return null;
            }
            let f = c[d.length], p;
            if (l instanceof ar) {
                if (typeof f == "number") throw new Error("");
                p = l.get(f)?.data;
            } else if (l instanceof Re) {
                if (typeof f == "number") throw new Error("");
                p = l.get(f)?.data;
            } else l !== null && (p = l[f]);
            if (p !== void 0) d.push(l), l = p;
            else return null;
        }
    }
    a.apply = e;
    function r(l, u) {
        for(let c = 0; c < l.length && c < u.length; c++)if (l[c] !== u[c]) return !0;
        return !1;
    }
    a.pathDisjoint = r;
    function i(l, u) {
        if (l.length !== u.length) return !1;
        for(let c = 0; c < l.length; c++)if (l[c] !== u[c]) return !1;
        return !0;
    }
    a.pathEq = i;
    function s(l, u) {
        return r(l.path, u.path);
    }
    a.commutative = s;
    function o(l, u) {
        return l.type === 0 && u.type === 0 && i(l.path, u.path) ? Object.keys(l.props).every((c)=>u.props[c] !== void 0) : !1;
    }
    a.subsumed = o;
})(Mr || (Mr = {}));
var zp;
((l)=>{
    function n1() {
        return [];
    }
    l.empty = n1;
    function t(u, c) {
        let d = [];
        for (let h of u){
            let [f, ...p] = h.path;
            f === c && d.push({
                ...h,
                path: p
            });
        }
        return d;
    }
    l.removePrefix = t;
    function e(u, c) {
        return u.map((d)=>({
                ...d,
                path: [
                    c,
                    ...d.path
                ]
            }));
    }
    l.addPrefix = e;
    function r(u, c) {
        return [
            ...u,
            ...c
        ];
    }
    l.concat = r;
    function i(u, c) {
        return [
            ...u.filter((h)=>!c.some((f)=>Mr.subsumed(h, f))),
            ...c
        ];
    }
    l.compress = i;
    function s(u, c) {
        return u.every((d)=>c.every((h)=>Mr.commutative(d, h)));
    }
    l.commutative = s;
    function o(u, c) {
        for (let d of c){
            let h = a(u, d);
            h !== null && (u = h.data);
        }
        return u;
    }
    l.applyAll = o;
    function a(u, c) {
        var d = u;
        let h = [], f = [];
        for (let p of c)try {
            if (p.type === 3 || p.type === 5 && p.path[p.path.length - 1] === "variables") {
                let m, g, y;
                if (p.type === 3 ? (m = Tr.zoom(d, [
                    ...p.path,
                    p.id
                ]), y = Mr.apply(d, {
                    ...p,
                    type: 2
                })) : (m = Tr.zoom(d, [
                    ...p.path,
                    p.id,
                    "value"
                ]), y = Mr.apply(d, p)), y !== null) {
                    d = y.data;
                    let [v, x] = F2(d, {
                        [p.id]: m
                    });
                    d = v;
                    for(let S = 0; S < x.length; S++){
                        let w = x[S], A = w.pop();
                        if (typeof A == "number") {
                            let E = [
                                A
                            ];
                            for(let T = S + 1; T < x.length; T++){
                                let M = x[T], C = M[M.length - 1];
                                if (typeof C == "number" && Tr.equal(w, M.slice(0, M.length - 1))) E.push(C), x.splice(T, 1);
                                else break;
                            }
                            let b = Tr.zoom(d, w);
                            g = b.map((T, M)=>E.includes(M) ? p.id : T), m = b, A = w.pop();
                        } else {
                            if (A === "alphaOverride" || A === "alpha") {
                                m /= 100;
                                let E = m, b = Tr.zoom(d, w.slice(0, w.length - 2)), T = b.layers.map((M)=>M.id === w[w.length - 1] ? {
                                        ...M,
                                        data: {
                                            ...M.data,
                                            [A]: E
                                        }
                                    } : M);
                                Object.setPrototypeOf(T, Object.getPrototypeOf(b.layers)), b.layers = T;
                            }
                            g = p.id;
                        }
                        h.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: m
                            }
                        }), f.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: g
                            }
                        });
                    }
                    f.push(y.reverse), h.push(y.actual);
                }
            } else {
                let m = Mr.apply(d, p);
                m !== null && (h.push(m.actual), d = m.data, f.push(m.reverse));
            }
        } catch (m) {
            if (m instanceof Pd) return null;
            throw m;
        }
        return {
            data: d,
            actual: h,
            reverse: f.reverse()
        };
    }
    l.apply = a;
})(zp || (zp = {}));
var z2 = Symbol(), Y8 = Symbol(), mv = Symbol(), Tc = class {
    reportOp(t, e, r = []) {
        let i = this;
        if (e === null) return;
        i._current = e.data;
        let s = r;
        for(; !(i instanceof pv);){
            let o = i._path, a = i._current;
            if (o !== "" && s.splice(0, 0, o), i = i._parent, i === null) return;
            i.update(o, a);
        }
        i.push(s, t, e.actual, e.reverse);
    }
    deleteChildren(t) {
        if (this._children) {
            let e = this._children[t];
            if (e) {
                let r = e[mv];
                r && r(), delete this._children[t];
            }
        }
    }
}, Fw = class extends Tc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        if (Array.isArray(this._current)) {
            if (typeof t == "string" && (t = parseInt(t), isNaN(t))) throw new Error("Invalid path");
            this._current = [
                ...this._current
            ], this._current[t] = e;
        } else this._current = {
            ...this._current,
            [t]: e
        };
    }
    runOp(t) {
        this.reportOp(t, Od.runOp(this._current, t), t.path);
    }
}, kw = class extends Tc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        this._current = {
            ...this._current,
            [t]: e
        }, Object.setPrototypeOf(this._current, Ke.prototype);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
}, V2 = {
    get (n1, t) {
        if (t === mv) return ()=>{
            n1._parent = null;
        };
        if (t === z2) return n1._current;
        if (t === Y8) return n1;
        let { _current: e, _children: r } = n1;
        if (t === "push" && Array.isArray(e)) throw new Error("not supported to expand array");
        let i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e[t], o = gv(n1, t, s);
        return o !== s ? (r === void 0 && (r = {}, n1._children = r), r[t] = o, o) : s;
    },
    has (n1, t) {
        return t in n1._current;
    },
    ownKeys (n1) {
        return Reflect.ownKeys(n1._current);
    },
    defineProperty () {
        throw Error("not supported");
    },
    getPrototypeOf (n1) {
        return Object.getPrototypeOf(n1._current);
    },
    setPrototypeOf () {
        throw Error("not supported");
    },
    getOwnPropertyDescriptor (n1, t) {
        let e = n1._current, r = Reflect.getOwnPropertyDescriptor(e, t);
        return r && {
            writable: !0,
            configurable: !0,
            enumerable: r.enumerable,
            value: e[t]
        };
    }
}, X8 = {
    ...V2,
    set (n1, t, e) {
        let r = {
            type: 0,
            props: {
                [t]: Cr(e) ?? e
            }
        };
        return n1.deleteChildren(t), n1.runOp(r), !0;
    },
    deleteProperty (n1, t) {
        let e = {
            type: 0,
            props: {
                [t]: void 0
            }
        };
        return n1.deleteChildren(t), n1.runOp(e), !0;
    }
}, Q8 = {
    ...V2,
    set (n1, t, e) {
        return e === void 0 ? this.deleteProperty(n1, t) : (n1.deleteChildren(t), n1.runOp({
            type: 1,
            id: t,
            data: e
        })), !0;
    },
    deleteProperty (n1, t) {
        return n1.runOp({
            type: 2,
            id: t
        }), !0;
    }
}, Ld = class extends Tc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[mv] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    randomId() {
        return this._current.randomId();
    }
    isDescendantOf(t, e) {
        return this._current.isDescendantOf(t, e);
    }
    childrenOf(t) {
        return this._current.childrenOf(t);
    }
    traverse(t) {
        return this._current.traverse(t);
    }
    get(t) {
        return this._current.get(t);
    }
    parent(t) {
        return this._current.parent(t);
    }
    traverse(t) {
        this._current.traverse((e, r)=>{
            t(e, this.data(e));
        });
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = gv(this, t, s);
        return o !== s ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s;
    }
    add(t, e, r, i, s) {
        this.runOp({
            type: 7,
            parent: t,
            fi: e,
            id: r,
            data: i,
            children: s
        });
    }
    move(t, e, r) {
        this.runOp({
            type: 9,
            parent: t,
            fi: e,
            id: r
        });
    }
    insertAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    insertBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    moveAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.move(t, i[s], o);
        }
    }
    moveBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s = 0; s < r.length; s++){
            let o = r[s];
            this.move(t, i[s], o);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 8,
            id: t
        });
    }
    sortNext(t) {
        return this._current.sortNext(t);
    }
    sortPrevious(t) {
        return this._current.sortPrevious(t);
    }
    getAllSorted(t) {
        return this._current.getAllSorted(t);
    }
}, Bd = class extends Tc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[mv] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    get length() {
        return this._current.length;
    }
    forEach(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id, s = this._current[r].fi;
            t(this.data(this._current[r].id), i, s);
        }
    }
    find(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id;
            if (t(this.data(i), i)) return this.get(i);
        }
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    randomId() {
        return this._current.randomId();
    }
    get(t) {
        return {
            ...this._current.get(t),
            data: this.data(t)
        };
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = gv(this, t, s);
        return o !== s ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s;
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    add(t, e, r) {
        this.runOp({
            type: 4,
            fi: t,
            id: e,
            data: r
        });
    }
    move(t, e) {
        this.runOp({
            type: 6,
            fi: t,
            id: e
        });
    }
    insertAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(r[i], s.id, s.data);
        }
    }
    insertBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(r[i], s.id, s.data);
        }
    }
    moveAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(r[i], s);
        }
    }
    moveBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(r[i], s);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 5,
            id: t
        });
    }
};
function Nw(n1, t, e) {
    if (n1.length > 0) {
        let r = n1[n1.length - 1];
        if (r.type === 0 && t.type === 0 && Tr.equal(r.path, e)) {
            Object.assign(r.props, t.props);
            return;
        }
    }
    n1.push({
        ...t,
        path: e
    });
}
var pv = class extends Tc {
    constructor(t){
        super(), this.ts = [], this.actual = [], this.reverse = [], this._current = t;
    }
    update(t, e) {
        if (t !== "") throw new Error("");
        this._current = e;
    }
    push(t, e, r, i) {
        Nw(this.ts, e, t), Nw(this.actual, r, t), Nw(this.reverse, i, t);
    }
    result() {
        return {
            data: this._current,
            ts: this.ts,
            actual: this.actual,
            reverse: this.reverse.reverse()
        };
    }
};
function gv(n1, t, e) {
    return e instanceof ar ? new Ld(n1, t, e) : e instanceof Re ? new Bd(n1, t, e) : e instanceof Ke ? new Proxy(new kw(n1, t, e), Q8) : e !== null && typeof e == "object" ? Dd(e) ? e : new Proxy(new Fw(n1, t, e), X8) : e;
}
function zw(n1) {
    let t = new pv(n1);
    return [
        gv(t, "", n1),
        t
    ];
}
function fl(n1, t) {
    let [e, r] = zw(n1);
    return t(e), r.result();
}
function Cr(n1) {
    return n1 instanceof Ld || n1 instanceof Bd ? n1._current : n1 !== null && typeof n1 == "object" ? n1[z2] : n1;
}
var Tr;
((i)=>{
    function n1(s, o) {
        if (o.length === s.length) for(var a = 0; a < s.length;){
            if (s[a] !== o[a]) return !1;
            a += 1;
        }
        else return !1;
        return !0;
    }
    i.equal = n1;
    function t(s, o, a) {
        let l = r(a, s);
        if (l !== void 0 && typeof l == "object" && l !== null) {
            let u = {
                ...o
            };
            return Object.keys(l).forEach((c)=>{
                delete u[c];
            }), u;
        } else return o;
    }
    i.removeOverridden = t;
    function e(s, o) {
        if ((s instanceof ar || s instanceof Ld) && typeof o == "string") return s.data(o);
        if ((s instanceof Re || s instanceof Bd) && typeof o == "string") return s.data(o);
        if (typeof o == "number" && Array.isArray(s)) return s[o];
        if (typeof o == "string" && typeof s == "object" && s !== null) return s[o];
    }
    i.zoomOnce = e;
    function r(s, o, a = 0) {
        for(; a < o.length && s !== void 0;)s = e(s, o[a]), a += 1;
        return s;
    }
    i.zoom = r;
})(Tr || (Tr = {}));
function U2(n1, t) {
    let e = [];
    if (t.length === n1.length) for(var r = 0; r < n1.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
function wt(n1, t) {
    let e = [];
    if (t.length <= n1.length) for(var r = 0; r < t.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
var yv = class {
}, Vp = class extends yv {
    constructor(e){
        super();
        this.id = e;
    }
}, Up = class extends yv {
    constructor(e){
        super();
        this.data = e;
    }
};
var Uw;
try {
    Uw = new TextDecoder;
} catch  {}
var Ne, ml, $ = 0;
var Q2 = [], Gw = Q2, jw = 0, Tn = {}, Gt, pl, cs = 0, mo = 0, Kn, fa, mn = [], Zt, G2 = {
    useRecords: !1,
    mapsAsObjects: !0
}, Gp = class {
}, Ww = new Gp;
Ww.name = "MessagePack 0xC1";
var Nd = !1, go = class {
    constructor(t){
        t && (t.useRecords === !1 && t.mapsAsObjects === void 0 && (t.mapsAsObjects = !0), t.structures ? t.structures.sharedLength = t.structures.length : t.getStructures && ((t.structures = []).uninitialized = !0, t.structures.sharedLength = 0)), Object.assign(this, t);
    }
    unpack(t, e) {
        if (Ne) return eD(()=>(xv(), this ? this.unpack(t, e) : go.prototype.unpack.call(G2, t, e)));
        ml = e > -1 ? e : t.length, $ = 0, jw = 0, mo = 0, pl = null, Gw = Q2, Kn = null, Ne = t;
        try {
            Zt = t.dataView || (t.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength));
        } catch (r) {
            throw Ne = null, t instanceof Uint8Array ? r : new Error("Source must be a Uint8Array or Buffer but was a " + (t && typeof t == "object" ? t.constructor.name : typeof t));
        }
        if (this instanceof go) {
            if (Tn = this, this.structures) return Gt = this.structures, vv();
            (!Gt || Gt.length > 0) && (Gt = []);
        } else Tn = G2, (!Gt || Gt.length > 0) && (Gt = []);
        return vv();
    }
    unpackMultiple(t, e) {
        let r, i = 0;
        try {
            Nd = !0;
            let s = t.length, o = this ? this.unpack(t, s) : wv.unpack(t, s);
            if (e) {
                for(e(o); $ < s;)if (i = $, e(vv()) === !1) return;
            } else {
                for(r = [
                    o
                ]; $ < s;)i = $, r.push(vv());
                return r;
            }
        } catch (s) {
            throw s.lastPosition = i, s.values = r, s;
        } finally{
            Nd = !1, xv();
        }
    }
    _mergeStructures(t, e) {
        t = t || [];
        for(let r = 0, i = t.length; r < i; r++){
            let s = t[r];
            s && (s.isShared = !0, r >= 32 && (s.highByte = r - 32 >> 5));
        }
        t.sharedLength = t.length;
        for(let r in e || [])if (r >= 0) {
            let i = t[r], s = e[r];
            s && (i && ((t.restoreStructures || (t.restoreStructures = []))[r] = i), t[r] = s);
        }
        return this.structures = t;
    }
    decode(t, e) {
        return this.unpack(t, e);
    }
};
function vv() {
    try {
        if (!Tn.trusted && !Nd) {
            let t = Gt.sharedLength || 0;
            t < Gt.length && (Gt.length = t);
        }
        let n1 = zr();
        if ($ == ml) Gt.restoreStructures && j2(), Gt = null, Ne = null, fa && (fa = null);
        else if ($ > ml) {
            let t = new Error("Unexpected end of MessagePack data");
            throw t.incomplete = !0, t;
        } else if (!Nd) throw new Error("Data read, but end of buffer not reached");
        return n1;
    } catch (n1) {
        throw Gt.restoreStructures && j2(), xv(), (n1 instanceof RangeError || n1.message.startsWith("Unexpected end of buffer")) && (n1.incomplete = !0), n1;
    }
}
function j2() {
    for(let n1 in Gt.restoreStructures)Gt[n1] = Gt.restoreStructures[n1];
    Gt.restoreStructures = null;
}
function zr() {
    let n1 = Ne[$++];
    if (n1 < 160) {
        if (n1 < 128) {
            if (n1 < 64) return n1;
            {
                let t = Gt[n1 & 63] || Tn.getStructures && K2()[n1 & 63];
                return t ? (t.read || (t.read = qw(t, n1 & 63)), t.read()) : n1;
            }
        } else if (n1 < 144) {
            if (n1 -= 128, Tn.mapsAsObjects) {
                let t = {};
                for(let e = 0; e < n1; e++)t[J2()] = zr();
                return t;
            } else {
                let t = new Map;
                for(let e = 0; e < n1; e++)t.set(zr(), zr());
                return t;
            }
        } else {
            n1 -= 144;
            let t = new Array(n1);
            for(let e = 0; e < n1; e++)t[e] = zr();
            return t;
        }
    } else if (n1 < 192) {
        let t = n1 - 160;
        if (mo >= $) return pl.slice($ - cs, ($ += t) - cs);
        if (mo == 0 && ml < 140) {
            let e = t < 16 ? Yw(t) : Z2(t);
            if (e != null) return e;
        }
        return Hw(t);
    } else {
        let t;
        switch(n1){
            case 192:
                return null;
            case 193:
                return Kn ? (t = zr(), t > 0 ? Kn[1].slice(Kn.position1, Kn.position1 += t) : Kn[0].slice(Kn.position0, Kn.position0 -= t)) : Ww;
            case 194:
                return !1;
            case 195:
                return !0;
            case 196:
                return Vw(Ne[$++]);
            case 197:
                return t = Zt.getUint16($), $ += 2, Vw(t);
            case 198:
                return t = Zt.getUint32($), $ += 4, Vw(t);
            case 199:
                return Mc(Ne[$++]);
            case 200:
                return t = Zt.getUint16($), $ += 2, Mc(t);
            case 201:
                return t = Zt.getUint32($), $ += 4, Mc(t);
            case 202:
                if (t = Zt.getFloat32($), Tn.useFloat32 > 2) {
                    let e = Sv[(Ne[$] & 127) << 1 | Ne[$ + 1] >> 7];
                    return $ += 4, (e * t + (t > 0 ? .5 : -0.5) >> 0) / e;
                }
                return $ += 4, t;
            case 203:
                return t = Zt.getFloat64($), $ += 8, t;
            case 204:
                return Ne[$++];
            case 205:
                return t = Zt.getUint16($), $ += 2, t;
            case 206:
                return t = Zt.getUint32($), $ += 4, t;
            case 207:
                return Tn.int64AsNumber ? (t = Zt.getUint32($) * 4294967296, t += Zt.getUint32($ + 4)) : t = Zt.getBigUint64($), $ += 8, t;
            case 208:
                return Zt.getInt8($++);
            case 209:
                return t = Zt.getInt16($), $ += 2, t;
            case 210:
                return t = Zt.getInt32($), $ += 4, t;
            case 211:
                return Tn.int64AsNumber ? (t = Zt.getInt32($) * 4294967296, t += Zt.getUint32($ + 4)) : t = Zt.getBigInt64($), $ += 8, t;
            case 212:
                if (t = Ne[$++], t == 114) return X2(Ne[$++] & 63);
                {
                    let e = mn[t];
                    if (e) return e.read ? ($++, e.read(zr())) : e.noBuffer ? ($++, e()) : e(Ne.subarray($, ++$));
                    throw new Error("Unknown extension " + t);
                }
            case 213:
                return t = Ne[$], t == 114 ? ($++, X2(Ne[$++] & 63, Ne[$++])) : Mc(2);
            case 214:
                return Mc(4);
            case 215:
                return Mc(8);
            case 216:
                return Mc(16);
            case 217:
                return t = Ne[$++], mo >= $ ? pl.slice($ - cs, ($ += t) - cs) : Z8(t);
            case 218:
                return t = Zt.getUint16($), $ += 2, mo >= $ ? pl.slice($ - cs, ($ += t) - cs) : J8(t);
            case 219:
                return t = Zt.getUint32($), $ += 4, mo >= $ ? pl.slice($ - cs, ($ += t) - cs) : $8(t);
            case 220:
                return t = Zt.getUint16($), $ += 2, W2(t);
            case 221:
                return t = Zt.getUint32($), $ += 4, W2(t);
            case 222:
                return t = Zt.getUint16($), $ += 2, q2(t);
            case 223:
                return t = Zt.getUint32($), $ += 4, q2(t);
            default:
                if (n1 >= 224) return n1 - 256;
                if (n1 === void 0) {
                    let e = new Error("Unexpected end of MessagePack data");
                    throw e.incomplete = !0, e;
                }
                throw new Error("Unknown MessagePack token " + n1);
        }
    }
}
var K8 = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function qw(n1, t) {
    function e() {
        if (e.count++ > 2) {
            let i = n1.read = new Function("r", "return function(){return {" + n1.map((s)=>K8.test(s) ? s + ":r()" : "[" + JSON.stringify(s) + "]:r()").join(",") + "}}")(zr);
            return n1.highByte === 0 && (n1.read = H2(t, n1.read)), i();
        }
        let r = {};
        for(let i = 0, s = n1.length; i < s; i++){
            let o = n1[i];
            r[o] = zr();
        }
        return r;
    }
    return e.count = 0, n1.highByte === 0 ? H2(t, e) : e;
}
var H2 = (n1, t)=>function() {
        let e = Ne[$++];
        if (e === 0) return t();
        let r = n1 < 32 ? -(n1 + (e << 5)) : n1 + (e << 5), i = Gt[r] || K2()[r];
        if (!i) throw new Error("Record id is not defined for " + r);
        return i.read || (i.read = qw(i, n1)), i.read();
    };
function K2() {
    let n1 = eD(()=>(Ne = null, Tn.getStructures()));
    return Gt = Tn._mergeStructures(n1, Gt);
}
var Hw = bv, Z8 = bv, J8 = bv, $8 = bv;
function bv(n1) {
    let t;
    if (n1 < 16 && (t = Yw(n1))) return t;
    if (n1 > 64 && Uw) return Uw.decode(Ne.subarray($, $ += n1));
    let e = $ + n1, r = [];
    for(t = ""; $ < e;){
        let i = Ne[$++];
        if ((i & 128) === 0) r.push(i);
        else if ((i & 224) === 192) {
            let s = Ne[$++] & 63;
            r.push((i & 31) << 6 | s);
        } else if ((i & 240) === 224) {
            let s = Ne[$++] & 63, o = Ne[$++] & 63;
            r.push((i & 31) << 12 | s << 6 | o);
        } else if ((i & 248) === 240) {
            let s = Ne[$++] & 63, o = Ne[$++] & 63, a = Ne[$++] & 63, l = (i & 7) << 18 | s << 12 | o << 6 | a;
            l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | l & 1023), r.push(l);
        } else r.push(i);
        r.length >= 4096 && (t += Bi.apply(String, r), r.length = 0);
    }
    return r.length > 0 && (t += Bi.apply(String, r)), t;
}
function W2(n1) {
    let t = new Array(n1);
    for(let e = 0; e < n1; e++)t[e] = zr();
    return t;
}
function q2(n1) {
    if (Tn.mapsAsObjects) {
        let t = {};
        for(let e = 0; e < n1; e++)t[J2()] = zr();
        return t;
    } else {
        let t = new Map;
        for(let e = 0; e < n1; e++)t.set(zr(), zr());
        return t;
    }
}
var Bi = String.fromCharCode;
function Z2(n1) {
    let t = $, e = new Array(n1);
    for(let r = 0; r < n1; r++){
        let i = Ne[$++];
        if ((i & 128) > 0) {
            $ = t;
            return;
        }
        e[r] = i;
    }
    return Bi.apply(String, e);
}
function Yw(n1) {
    if (n1 < 4) {
        if (n1 < 2) {
            if (n1 === 0) return "";
            {
                let t = Ne[$++];
                if ((t & 128) > 1) {
                    $ -= 1;
                    return;
                }
                return Bi(t);
            }
        } else {
            let t = Ne[$++], e = Ne[$++];
            if ((t & 128) > 0 || (e & 128) > 0) {
                $ -= 2;
                return;
            }
            if (n1 < 3) return Bi(t, e);
            let r = Ne[$++];
            if ((r & 128) > 0) {
                $ -= 3;
                return;
            }
            return Bi(t, e, r);
        }
    } else {
        let t = Ne[$++], e = Ne[$++], r = Ne[$++], i = Ne[$++];
        if ((t & 128) > 0 || (e & 128) > 0 || (r & 128) > 0 || (i & 128) > 0) {
            $ -= 4;
            return;
        }
        if (n1 < 6) {
            if (n1 === 4) return Bi(t, e, r, i);
            {
                let s = Ne[$++];
                if ((s & 128) > 0) {
                    $ -= 5;
                    return;
                }
                return Bi(t, e, r, i, s);
            }
        } else if (n1 < 8) {
            let s = Ne[$++], o = Ne[$++];
            if ((s & 128) > 0 || (o & 128) > 0) {
                $ -= 6;
                return;
            }
            if (n1 < 7) return Bi(t, e, r, i, s, o);
            let a = Ne[$++];
            if ((a & 128) > 0) {
                $ -= 7;
                return;
            }
            return Bi(t, e, r, i, s, o, a);
        } else {
            let s = Ne[$++], o = Ne[$++], a = Ne[$++], l = Ne[$++];
            if ((s & 128) > 0 || (o & 128) > 0 || (a & 128) > 0 || (l & 128) > 0) {
                $ -= 8;
                return;
            }
            if (n1 < 10) {
                if (n1 === 8) return Bi(t, e, r, i, s, o, a, l);
                {
                    let u = Ne[$++];
                    if ((u & 128) > 0) {
                        $ -= 9;
                        return;
                    }
                    return Bi(t, e, r, i, s, o, a, l, u);
                }
            } else if (n1 < 12) {
                let u = Ne[$++], c = Ne[$++];
                if ((u & 128) > 0 || (c & 128) > 0) {
                    $ -= 10;
                    return;
                }
                if (n1 < 11) return Bi(t, e, r, i, s, o, a, l, u, c);
                let d = Ne[$++];
                if ((d & 128) > 0) {
                    $ -= 11;
                    return;
                }
                return Bi(t, e, r, i, s, o, a, l, u, c, d);
            } else {
                let u = Ne[$++], c = Ne[$++], d = Ne[$++], h = Ne[$++];
                if ((u & 128) > 0 || (c & 128) > 0 || (d & 128) > 0 || (h & 128) > 0) {
                    $ -= 12;
                    return;
                }
                if (n1 < 14) {
                    if (n1 === 12) return Bi(t, e, r, i, s, o, a, l, u, c, d, h);
                    {
                        let f = Ne[$++];
                        if ((f & 128) > 0) {
                            $ -= 13;
                            return;
                        }
                        return Bi(t, e, r, i, s, o, a, l, u, c, d, h, f);
                    }
                } else {
                    let f = Ne[$++], p = Ne[$++];
                    if ((f & 128) > 0 || (p & 128) > 0) {
                        $ -= 14;
                        return;
                    }
                    if (n1 < 15) return Bi(t, e, r, i, s, o, a, l, u, c, d, h, f, p);
                    let m = Ne[$++];
                    if ((m & 128) > 0) {
                        $ -= 15;
                        return;
                    }
                    return Bi(t, e, r, i, s, o, a, l, u, c, d, h, f, p, m);
                }
            }
        }
    }
}
function Vw(n1) {
    return Tn.copyBuffers ? Uint8Array.prototype.slice.call(Ne, $, $ += n1) : Ne.subarray($, $ += n1);
}
function Mc(n1) {
    let t = Ne[$++];
    if (mn[t]) return mn[t](Ne.subarray($, $ += n1));
    throw new Error("Unknown extension type " + t);
}
var Y2 = new Array(4096);
function J2() {
    let n1 = Ne[$++];
    if (n1 >= 160 && n1 < 192) {
        if (n1 = n1 - 160, mo >= $) return pl.slice($ - cs, ($ += n1) - cs);
        if (!(mo == 0 && ml < 180)) return Hw(n1);
    } else return $--, zr();
    let t = (n1 << 5 ^ (n1 > 1 ? Zt.getUint16($) : n1 > 0 ? Ne[$] : 0)) & 4095, e = Y2[t], r = $, i = $ + n1 - 3, s, o = 0;
    if (e && e.bytes == n1) {
        for(; r < i;){
            if (s = Zt.getUint32(r), s != e[o++]) {
                r = 1879048192;
                break;
            }
            r += 4;
        }
        for(i += 3; r < i;)if (s = Ne[r++], s != e[o++]) {
            r = 1879048192;
            break;
        }
        if (r === i) return $ = r, e.string;
        i -= 3, r = $;
    }
    for(e = [], Y2[t] = e, e.bytes = n1; r < i;)s = Zt.getUint32(r), e.push(s), r += 4;
    for(i += 3; r < i;)s = Ne[r++], e.push(s);
    let a = n1 < 16 ? Yw(n1) : Z2(n1);
    return a != null ? e.string = a : e.string = Hw(n1);
}
var X2 = (n1, t)=>{
    var e = zr();
    let r = n1;
    t !== void 0 && (n1 = n1 < 32 ? -((t << 5) + n1) : (t << 5) + n1, e.highByte = t);
    let i = Gt[n1];
    return i && i.isShared && ((Gt.restoreStructures || (Gt.restoreStructures = []))[n1] = i), Gt[n1] = e, e.read = qw(e, r), e.read();
}, $2 = typeof self == "object" ? self : $parcel$global;
mn[0] = ()=>{};
mn[0].noBuffer = !0;
mn[101] = ()=>{
    let n1 = zr();
    return ($2[n1[0]] || Error)(n1[1]);
};
mn[105] = (n1)=>{
    let t = Zt.getUint32($ - 4);
    fa || (fa = new Map);
    let e = Ne[$], r;
    e >= 144 && e < 160 || e == 220 || e == 221 ? r = [] : r = {};
    let i = {
        target: r
    };
    fa.set(t, i);
    let s = zr();
    return i.used ? Object.assign(r, s) : (i.target = s, s);
};
mn[112] = (n1)=>{
    let t = Zt.getUint32($ - 4), e = fa.get(t);
    return e.used = !0, e.target;
};
mn[115] = ()=>new Set(zr());
var Xw = [
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64",
    "BigInt64",
    "BigUint64"
].map((n1)=>n1 + "Array");
mn[116] = (n1)=>{
    let t = n1[0], e = Xw[t];
    if (!e) throw new Error("Could not find typed array for code " + t);
    return new $2[e](Uint8Array.prototype.slice.call(n1, 1).buffer);
};
mn[120] = ()=>{
    let n1 = zr();
    return new RegExp(n1[0], n1[1]);
};
mn[98] = (n1)=>{
    let t = (n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3], e = $;
    $ += t - 4, Kn = [
        zr(),
        zr()
    ], Kn.position0 = 0, Kn.position1 = 0;
    let r = $;
    $ = e;
    try {
        return zr();
    } finally{
        $ = r;
    }
};
mn[255] = (n1)=>n1.length == 4 ? new Date((n1[0] * 16777216 + (n1[1] << 16) + (n1[2] << 8) + n1[3]) * 1e3) : n1.length == 8 ? new Date(((n1[0] << 22) + (n1[1] << 14) + (n1[2] << 6) + (n1[3] >> 2)) / 1e6 + ((n1[3] & 3) * 4294967296 + n1[4] * 16777216 + (n1[5] << 16) + (n1[6] << 8) + n1[7]) * 1e3) : n1.length == 12 ? new Date(((n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3]) / 1e6 + ((n1[4] & 128 ? -281474976710656 : 0) + n1[6] * 1099511627776 + n1[7] * 4294967296 + n1[8] * 16777216 + (n1[9] << 16) + (n1[10] << 8) + n1[11]) * 1e3) : new Date("invalid");
function eD(n1) {
    let t = ml, e = $, r = jw, i = cs, s = mo, o = pl, a = Gw, l = fa, u = Kn, c = new Uint8Array(Ne.slice(0, ml)), d = Gt, h = Gt.slice(0, Gt.length), f = Tn, p = Nd, m = n1();
    return ml = t, $ = e, jw = r, cs = i, mo = s, pl = o, Gw = a, fa = l, Kn = u, Ne = c, Nd = p, Gt = d, Gt.splice(0, Gt.length, ...h), Tn = f, Zt = new DataView(Ne.buffer, Ne.byteOffset, Ne.byteLength), m;
}
function xv() {
    Ne = null, fa = null, Gt = null;
}
function tD(n1) {
    n1.unpack ? mn[n1.type] = n1.unpack : mn[n1.type] = n1;
}
var Sv = new Array(147);
for(let n1 = 0; n1 < 256; n1++)Sv[n1] = +("1e" + Math.floor(45.15 - n1 * .30103));
var wv = new go({
    useRecords: !1
}), eq = wv.unpack, tq = wv.unpackMultiple, rq = wv.unpack, Av = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
}, iq = new Float32Array(1), Ice = new Uint8Array(iq.buffer, 0, 4);
var _v;
try {
    _v = new TextEncoder;
} catch  {}
var Ev, Kw, Tv = typeof $5059ff85b35ef8d7$require$Buffer < "u", Qw = Tv ? $5059ff85b35ef8d7$require$Buffer.allocUnsafeSlow : Uint8Array, sD = Tv ? $5059ff85b35ef8d7$require$Buffer : Uint8Array, rD = Tv ? 4294967296 : 2144337920, he, Yr, ne = 0, yo, vo = null, nq = /[\u0080-\uFFFF]/, jp = Symbol("record-id"), Cc = class extends go {
    constructor(t){
        super(t), this.offset = 0;
        let e, r, i, s, o, a, l = 0, u = sD.prototype.utf8Write ? function(b, T, M) {
            return he.utf8Write(b, T, M);
        } : _v && _v.encodeInto ? function(b, T) {
            return _v.encodeInto(b, he.subarray(T)).written;
        } : !1, c = this;
        t || (t = {});
        let d = t && t.sequential, h = t.structures || t.saveStructures, f = t.maxSharedStructures;
        if (f == null && (f = h ? 32 : 0), f > 8160) throw new Error("Maximum maxSharedStructure is 8160");
        let p = t.maxOwnStructures;
        p == null && (p = h ? 32 : 64), d && !t.saveStructures && (this.structures = []);
        let m = f > 32 || p + f > 64, g = f + 64, y = f + p + 64;
        if (y > 8256) throw new Error("Maximum maxSharedStructure + maxOwnStructure is 8192");
        let v = [], x = 0, S = 0;
        this.pack = this.encode = function(b, T) {
            if (he || (he = new Qw(8192), Yr = new DataView(he.buffer, 0, 8192), ne = 0), yo = he.length - 10, yo - ne < 2048 ? (he = new Qw(he.length), Yr = new DataView(he.buffer, 0, he.length), yo = he.length - 10, ne = 0) : ne = ne + 7 & 2147483640, r = ne, a = c.structuredClone ? new Map : null, c.bundleStrings ? (vo = [
                "",
                ""
            ], he[ne++] = 214, he[ne++] = 98, vo.position = ne - r, ne += 4) : vo = null, i = c.structures, i) {
                i.uninitialized && (i = c._mergeStructures(c.getStructures()));
                let M = i.sharedLength || 0;
                if (M > f) throw new Error("Shared structures is larger than maximum shared structures, try increasing maxSharedStructures to " + i.sharedLength);
                if (!i.transitions) {
                    i.transitions = Object.create(null);
                    for(let C = 0; C < M; C++){
                        let P = i[C];
                        if (!P) continue;
                        let D, O = i.transitions;
                        for(let I = 0, z = P.length; I < z; I++){
                            let B = P[I];
                            D = O[B], D || (D = O[B] = Object.create(null)), O = D;
                        }
                        O[jp] = C + 64;
                    }
                    l = M;
                }
                d || (i.nextId = M + 64);
            }
            s && (s = !1), o = i || [];
            try {
                if (w(b), vo) {
                    Yr.setUint32(vo.position + r, ne - vo.position - r);
                    let M = vo;
                    vo = null, w(M[0]), w(M[1]);
                }
                if (c.offset = ne, a && a.idsToInsert) {
                    ne += a.idsToInsert.length * 6, ne > yo && E(ne), c.offset = ne;
                    let M = oq(he.subarray(r, ne), a.idsToInsert);
                    return a = null, M;
                }
                return T & aD ? (he.start = r, he.end = ne, he) : he.subarray(r, ne);
            } finally{
                if (i) {
                    if (S < 10 && S++, x > 1e4) i.transitions = null, S = 0, x = 0, v.length > 0 && (v = []);
                    else if (v.length > 0 && !d) {
                        for(let M = 0, C = v.length; M < C; M++)v[M][jp] = 0;
                        v = [];
                    }
                    if (s && c.saveStructures) {
                        let M = i.sharedLength || f;
                        i.length > M && (i = i.slice(0, M));
                        let C = he.subarray(r, ne);
                        return c.saveStructures(i, l) === !1 ? (c._mergeStructures(c.getStructures()), c.pack(b)) : (l = M, C);
                    }
                }
                T & fq && (ne = r);
            }
        };
        let w = (b)=>{
            ne > yo && (he = E(ne));
            var T = typeof b, M;
            if (T === "string") {
                let C = b.length;
                if (vo && C >= 8 && C < 4096) {
                    let O = nq.test(b);
                    vo[O ? 0 : 1] += b, he[ne++] = 193, w(O ? -C : C);
                    return;
                }
                let P;
                C < 32 ? P = 1 : C < 256 ? P = 2 : C < 65536 ? P = 3 : P = 5;
                let D = C * 3;
                if (ne + D > yo && (he = E(ne + D)), C < 64 || !u) {
                    let O, I, z, B = ne + P;
                    for(O = 0; O < C; O++)I = b.charCodeAt(O), I < 128 ? he[B++] = I : I < 2048 ? (he[B++] = I >> 6 | 192, he[B++] = I & 63 | 128) : (I & 64512) === 55296 && ((z = b.charCodeAt(O + 1)) & 64512) === 56320 ? (I = 65536 + ((I & 1023) << 10) + (z & 1023), O++, he[B++] = I >> 18 | 240, he[B++] = I >> 12 & 63 | 128, he[B++] = I >> 6 & 63 | 128, he[B++] = I & 63 | 128) : (he[B++] = I >> 12 | 224, he[B++] = I >> 6 & 63 | 128, he[B++] = I & 63 | 128);
                    M = B - ne - P;
                } else M = u(b, ne + P, D);
                M < 32 ? he[ne++] = 160 | M : M < 256 ? (P < 2 && he.copyWithin(ne + 2, ne + 1, ne + 1 + M), he[ne++] = 217, he[ne++] = M) : M < 65536 ? (P < 3 && he.copyWithin(ne + 3, ne + 2, ne + 2 + M), he[ne++] = 218, he[ne++] = M >> 8, he[ne++] = M & 255) : (P < 5 && he.copyWithin(ne + 5, ne + 3, ne + 3 + M), he[ne++] = 219, Yr.setUint32(ne, M), ne += 4), ne += M;
            } else if (T === "number") {
                if (b >>> 0 === b) b < 64 ? he[ne++] = b : b < 256 ? (he[ne++] = 204, he[ne++] = b) : b < 65536 ? (he[ne++] = 205, he[ne++] = b >> 8, he[ne++] = b & 255) : (he[ne++] = 206, Yr.setUint32(ne, b), ne += 4);
                else if (b >> 0 === b) b >= -32 ? he[ne++] = 256 + b : b >= -128 ? (he[ne++] = 208, he[ne++] = b + 256) : b >= -32768 ? (he[ne++] = 209, Yr.setInt16(ne, b), ne += 2) : (he[ne++] = 210, Yr.setInt32(ne, b), ne += 4);
                else {
                    let C;
                    if ((C = this.useFloat32) > 0 && b < 4294967296 && b >= -2147483648) {
                        he[ne++] = 202, Yr.setFloat32(ne, b);
                        let P;
                        if (C < 4 || (P = b * Sv[(he[ne] & 127) << 1 | he[ne + 1] >> 7]) >> 0 === P) {
                            ne += 4;
                            return;
                        } else ne--;
                    }
                    he[ne++] = 203, Yr.setFloat64(ne, b), ne += 8;
                }
            } else if (T === "object") {
                if (!b) he[ne++] = 192;
                else {
                    if (a) {
                        let P = a.get(b);
                        if (P) {
                            if (!P.id) {
                                let D = a.idsToInsert || (a.idsToInsert = []);
                                P.id = D.push(P);
                            }
                            he[ne++] = 214, he[ne++] = 112, Yr.setUint32(ne, P.id), ne += 4;
                            return;
                        } else a.set(b, {
                            offset: ne - r
                        });
                    }
                    let C = b.constructor;
                    if (C === Object) A(b, !0);
                    else if (C === Array) {
                        M = b.length, M < 16 ? he[ne++] = 144 | M : M < 65536 ? (he[ne++] = 220, he[ne++] = M >> 8, he[ne++] = M & 255) : (he[ne++] = 221, Yr.setUint32(ne, M), ne += 4);
                        for(let P = 0; P < M; P++)w(b[P]);
                    } else if (C === Map) {
                        M = b.size, M < 16 ? he[ne++] = 128 | M : M < 65536 ? (he[ne++] = 222, he[ne++] = M >> 8, he[ne++] = M & 255) : (he[ne++] = 223, Yr.setUint32(ne, M), ne += 4);
                        for (let [P, D] of b)w(P), w(D);
                    } else {
                        for(let P = 0, D = Ev.length; P < D; P++){
                            let O = Kw[P];
                            if (b instanceof O) {
                                let I = Ev[P];
                                if (I.write) {
                                    I.type && (he[ne++] = 212, he[ne++] = I.type, he[ne++] = 0), w(I.write.call(this, b));
                                    return;
                                }
                                let z = he, B = Yr, V = ne;
                                he = null;
                                let U;
                                try {
                                    U = I.pack.call(this, b, (j)=>(he = z, z = null, ne += j, ne > yo && E(ne), {
                                            target: he,
                                            targetView: Yr,
                                            position: ne - j
                                        }), w);
                                } finally{
                                    z && (he = z, Yr = B, ne = V, yo = he.length - 10);
                                }
                                U && (U.length + ne > yo && E(U.length + ne), ne = sq(U, he, ne, I.type));
                                return;
                            }
                        }
                        A(b, !b.hasOwnProperty);
                    }
                }
            } else if (T === "boolean") he[ne++] = b ? 195 : 194;
            else if (T === "bigint") {
                if (b < BigInt(1) << BigInt(63) && b >= -(BigInt(1) << BigInt(63))) he[ne++] = 211, Yr.setBigInt64(ne, b);
                else if (b < BigInt(1) << BigInt(64) && b > 0) he[ne++] = 207, Yr.setBigUint64(ne, b);
                else if (this.largeBigIntToFloat) he[ne++] = 203, Yr.setFloat64(ne, Number(b));
                else throw new RangeError(b + " was too large to fit in MessagePack 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                ne += 8;
            } else if (T === "undefined") this.encodeUndefinedAsNil ? he[ne++] = 192 : (he[ne++] = 212, he[ne++] = 0, he[ne++] = 0);
            else if (T === "function") w(this.writeFunction && this.writeFunction());
            else throw new Error("Unknown type: " + T);
        }, A = this.useRecords === !1 ? this.variableMapSize ? (b)=>{
            let T = Object.keys(b), M = T.length;
            M < 16 ? he[ne++] = 128 | M : M < 65536 ? (he[ne++] = 222, he[ne++] = M >> 8, he[ne++] = M & 255) : (he[ne++] = 223, Yr.setUint32(ne, M), ne += 4);
            let C;
            for(let P = 0; P < M; P++)w(C = T[P]), w(b[C]);
        } : (b, T)=>{
            he[ne++] = 222;
            let M = ne - r;
            ne += 2;
            let C = 0;
            for(let P in b)(T || b.hasOwnProperty(P)) && (w(P), w(b[P]), C++);
            he[M++ + r] = C >> 8, he[M + r] = C & 255;
        } : (b)=>{
            let T = Object.keys(b), M, C = o.transitions || (o.transitions = Object.create(null)), P = 0;
            for(let O = 0, I = T.length; O < I; O++){
                let z = T[O];
                M = C[z], M || (M = C[z] = Object.create(null), P++), C = M;
            }
            let D = C[jp];
            if (D) D >= 96 && m ? (he[ne++] = ((D -= 96) & 31) + 96, he[ne++] = D >> 5) : he[ne++] = D;
            else {
                D = o.nextId, D || (D = 64), D < g && this.shouldShareStructure && !this.shouldShareStructure(T) ? (D = o.nextOwnId, D < y || (D = g), o.nextOwnId = D + 1) : (D >= y && (D = g), o.nextId = D + 1);
                let O = T.highByte = D >= 96 && m ? D - 96 >> 5 : -1;
                C[jp] = D, o[D - 64] = T, D < g ? (T.isShared = !0, o.sharedLength = D - 63, s = !0, O >= 0 ? (he[ne++] = (D & 31) + 96, he[ne++] = O) : he[ne++] = D) : (O >= 0 ? (he[ne++] = 213, he[ne++] = 114, he[ne++] = (D & 31) + 96, he[ne++] = O) : (he[ne++] = 212, he[ne++] = 114, he[ne++] = D), P && (x += S * P), v.length >= p && (v.shift()[jp] = 0), v.push(C), w(T));
            }
            for(let O = 0, I = T.length; O < I; O++)w(b[T[O]]);
        }, E = (b)=>{
            let T;
            if (b > 16777216) {
                if (b - r > rD) throw new Error("Packed buffer would be larger than maximum buffer size");
                T = Math.min(rD, Math.round(Math.max((b - r) * (b > 67108864 ? 1.25 : 2), 4194304) / 4096) * 4096);
            } else T = (Math.max(b - r << 2, he.length - 1) >> 12) + 1 << 12;
            let M = new Qw(T);
            return Yr = new DataView(M.buffer, 0, T), he.copy ? he.copy(M, 0, r, b) : M.set(he.slice(r, b)), ne -= r, r = 0, yo = M.length - 10, he = M;
        };
    }
    useBuffer(t) {
        he = t, Yr = new DataView(he.buffer, he.byteOffset, he.byteLength), ne = 0;
    }
};
Kw = [
    Date,
    Set,
    Error,
    RegExp,
    ArrayBuffer,
    Object.getPrototypeOf(Uint8Array.prototype).constructor,
    Gp
];
Ev = [
    {
        pack (n1, t, e) {
            let r = n1.getTime() / 1e3;
            if ((this.useTimestamp32 || n1.getMilliseconds() === 0) && r >= 0 && r < 4294967296) {
                let { target: i, targetView: s, position: o } = t(6);
                i[o++] = 214, i[o++] = 255, s.setUint32(o, r);
            } else if (r > 0 && r < 17179869184) {
                let { target: i, targetView: s, position: o } = t(10);
                i[o++] = 215, i[o++] = 255, s.setUint32(o, n1.getMilliseconds() * 4e6 + (r / 1e3 / 4294967296 >> 0)), s.setUint32(o + 4, r);
            } else if (isNaN(r)) {
                if (this.onInvalidDate) return t(0), e(this.onInvalidDate());
                let { target: i, targetView: s, position: o } = t(3);
                i[o++] = 212, i[o++] = 255, i[o++] = 255;
            } else {
                let { target: i, targetView: s, position: o } = t(15);
                i[o++] = 199, i[o++] = 12, i[o++] = 255, s.setUint32(o, n1.getMilliseconds() * 1e6), s.setBigInt64(o + 4, BigInt(Math.floor(r)));
            }
        }
    },
    {
        pack (n1, t, e) {
            let r = Array.from(n1), { target: i, position: s } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (i[s++] = 212, i[s++] = 115, i[s++] = 0), e(r);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 101, r[i++] = 0), e([
                n1.name,
                n1.message
            ]);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 120, r[i++] = 0), e([
                n1.source,
                n1.flags
            ]);
        }
    },
    {
        pack (n1, t) {
            this.structuredClone ? iD(n1, 16, t) : nD(Tv ? $5059ff85b35ef8d7$require$Buffer.from(n1) : new Uint8Array(n1), t);
        }
    },
    {
        pack (n1, t) {
            let e = n1.constructor;
            e !== sD && this.structuredClone ? iD(n1, Xw.indexOf(e.name), t) : nD(n1, t);
        }
    },
    {
        pack (n1, t) {
            let { target: e, position: r } = t(1);
            e[r] = 193;
        }
    }
];
function iD(n1, t, e, r) {
    let i = n1.byteLength;
    if (i + 1 < 256) {
        var { target: s, position: o } = e(4 + i);
        s[o++] = 199, s[o++] = i + 1;
    } else if (i + 1 < 65536) {
        var { target: s, position: o } = e(5 + i);
        s[o++] = 200, s[o++] = i + 1 >> 8, s[o++] = i + 1 & 255;
    } else {
        var { target: s, position: o, targetView: a } = e(7 + i);
        s[o++] = 201, a.setUint32(o, i + 1), o += 4;
    }
    s[o++] = 116, s[o++] = t, s.set(new Uint8Array(n1.buffer, n1.byteOffset, n1.byteLength), o);
}
function nD(n1, t) {
    let e = n1.byteLength;
    var r, i;
    if (e < 256) {
        var { target: r, position: i } = t(e + 2);
        r[i++] = 196, r[i++] = e;
    } else if (e < 65536) {
        var { target: r, position: i } = t(e + 3);
        r[i++] = 197, r[i++] = e >> 8, r[i++] = e & 255;
    } else {
        var { target: r, position: i, targetView: s } = t(e + 5);
        r[i++] = 198, s.setUint32(i, e), i += 4;
    }
    r.set(n1, i);
}
function sq(n1, t, e, r) {
    let i = n1.length;
    switch(i){
        case 1:
            t[e++] = 212;
            break;
        case 2:
            t[e++] = 213;
            break;
        case 4:
            t[e++] = 214;
            break;
        case 8:
            t[e++] = 215;
            break;
        case 16:
            t[e++] = 216;
            break;
        default:
            i < 256 ? (t[e++] = 199, t[e++] = i) : i < 65536 ? (t[e++] = 200, t[e++] = i >> 8, t[e++] = i & 255) : (t[e++] = 201, t[e++] = i >> 24, t[e++] = i >> 16 & 255, t[e++] = i >> 8 & 255, t[e++] = i & 255);
    }
    return t[e++] = r, t.set(n1, e), e += i, e;
}
function oq(n1, t) {
    let e, r = t.length * 6, i = n1.length - r;
    for(t.sort((s, o)=>s.offset > o.offset ? 1 : -1); e = t.pop();){
        let s = e.offset, o = e.id;
        n1.copyWithin(s + r, s, i), r -= 6;
        let a = s + r;
        n1[a++] = 214, n1[a++] = 105, n1[a++] = o >> 24, n1[a++] = o >> 16 & 255, n1[a++] = o >> 8 & 255, n1[a++] = o & 255, i = s;
    }
    return n1;
}
function gl(n1) {
    if (n1.Class) {
        if (!n1.pack && !n1.write) throw new Error("Extension has no pack or write function");
        if (n1.pack && !n1.type) throw new Error("Extension has no type (numeric code to identify the extension)");
        Kw.unshift(n1.Class), Ev.unshift(n1);
    }
    tD(n1);
}
var oD = new Cc({
    useRecords: !1
}), aq = oD.pack, lq = oD.pack;
var { NEVER: cq, ALWAYS: uq, DECIMAL_ROUND: dq, DECIMAL_FIT: hq } = Av, aD = 512, fq = 1024;
var lD = new Cc({
    structuredClone: !0
});
gl({
    Class: Ke.prototype.constructor,
    type: 1,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, Ke.prototype), n1;
    }
});
gl({
    Class: Re.prototype.constructor,
    type: 2,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, Re.prototype), n1;
    }
});
gl({
    Class: ar.prototype.constructor,
    type: 3,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, ar.prototype), n1;
    }
});
gl({
    Class: Vp.prototype.constructor,
    type: 4,
    write (n1) {
        return n1.id;
    },
    read (n1) {
        return new Vp(n1);
    }
});
gl({
    Class: Up.prototype.constructor,
    type: 5,
    write (n1) {
        return n1.data;
    },
    read (n1) {
        return new Up(n1);
    }
});
gl({
    Class: lr.prototype.constructor,
    type: 6,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, lr.prototype), n1;
    }
});
function pq(n1) {
    var t = 0;
    if (n1.length === 0) return t;
    for(let e = 0; e < n1.length; e++){
        let r = n1[e];
        t = (t << 5) - t + r, t = t & t;
    }
    return t;
}
function Zw(n1) {
    if (Dd(n1)) return n1;
    if (Array.isArray(n1)) return n1.map(Zw);
    if (typeof n1 == "object" && n1 !== null) {
        let t = {};
        for (let e of Object.keys(n1).sort())t[e] = Zw(n1[e]);
        return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
    } else return n1;
}
var Mv;
((r)=>{
    function n1(i) {
        return lD.pack(i);
    }
    r.serialize = n1;
    function t(i) {
        return lD.unpack(i);
    }
    r.deserialize = t;
    function e(i) {
        return pq(n1(Zw(i))).toString();
    }
    r.checksum = e;
})(Mv || (Mv = {}));
var cD;
((e)=>{
    function n1(r) {
        return r.type === "Conditional" ? r.condition.type === "Distance" ? "Distance" : "StateChange" : r.type;
    }
    e.toEventUIType = n1;
    function t(r) {
        return r === "Distance" || r === "StateChange" ? "Conditional" : r;
    }
    e.fromEventUIType = t;
})(cD || (cD = {}));
var gn = {
    ["LookAt"]: [],
    ["Follow"]: [
        "Create"
    ],
    ["DragDrop"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["MouseHover"]: [
        "Transition",
        "Animation",
        "Particles",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["Scroll"]: [
        "Transition",
        "Animation",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["Start"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["Conditional"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["MouseDown"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["MouseUp"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["MousePress"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["KeyDown"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["KeyUp"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["KeyPress"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["GameControl"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Create",
        "Conditional"
    ],
    ["Collision"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["Trigger"]: [
        "Transition",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["Resize"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ],
    ["VariableChange"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional"
    ]
}, uD;
((e)=>{
    function n1(r) {
        return r.type === "MouseDown" || r.type === "MouseUp" || r.type === "MousePress" || r.type === "KeyDown" || r.type === "KeyUp" || r.type === "KeyPress";
    }
    e.is = n1;
    function t(r) {
        return r === "MouseDown" || r === "MouseUp" || r === "MousePress" ? {
            type: r,
            mode: "Object",
            disabled: !1,
            runMode: "Once",
            actions: new Re
        } : {
            type: r,
            disabled: !1,
            key: void 0,
            runMode: "Once",
            actions: new Re
        };
    }
    e.defaultData = t;
})(uD || (uD = {}));
var Cv;
((e)=>{
    function n1(r) {
        return {
            type: "Property",
            value: [
                r ?? null,
                "position",
                "x"
            ]
        };
    }
    e.propertyDefaultData = n1, e.valueDefaultData = {
        type: "Literal",
        value: 0
    };
})(Cv || (Cv = {}));
var Jw;
((r)=>{
    function n1(i) {
        return {
            type: "Comparison",
            operator: "==",
            lOperand: Cv.propertyDefaultData(i),
            rOperand: {
                ...Cv.valueDefaultData
            }
        };
    }
    r.comparisonDefaultData = n1;
    function t(i) {
        return {
            type: "Distance",
            toObject: i ?? null,
            fromObject: i ?? null,
            distance: 200
        };
    }
    r.distanceDefaultData = t;
    function e(i, s) {
        return {
            type: "State",
            object: i ?? null,
            state: s ?? null
        };
    }
    r.stateDefaultData = e;
})(Jw || (Jw = {}));
var dD;
((e)=>{
    function n1(r) {
        return r.type === "Conditional";
    }
    e.is = n1;
    function t(r) {
        return {
            type: "Conditional",
            disabled: !1,
            inActions: new Re,
            outActions: new Re,
            condition: Jw.distanceDefaultData(r)
        };
    }
    e.defaultData = t;
})(dD || (dD = {}));
var hD;
((t)=>t.defaultData = {
        type: "DragDrop",
        cursor: "hand",
        disabled: !1,
        dampingFactor: 1,
        objects: [],
        snapTo: "center",
        snapSurfaceMode: "bbox",
        snapSurfaceOffset: 0,
        dropOn: "all",
        autoOrient: !0,
        dropDestinations: [],
        plane: "adaptive",
        planeMode: "locked",
        referenceFrame: "global",
        limits: [
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0
        ],
        drop: !1,
        resetOnSnapFail: !1,
        snapSpeed: 20,
        resetSpeed: 20,
        dragDropActions: {
            drag: new Re,
            drop: new Re
        }
    })(hD || (hD = {}));
var Pv;
((t)=>t.defaultData = {
        type: "Follow",
        disabled: !1,
        maxDelta: 0,
        dampingFactor: 1,
        target: "cursor",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledTranslation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5,
        actions: new Re
    })(Pv || (Pv = {}));
var Dv;
((t)=>t.defaultData = {
        type: "LookAt",
        disabled: !1,
        distance: 1e3,
        dampingFactor: 1,
        target: "cursor",
        tilt: "up",
        axis: "z",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5
    })(Dv || (Dv = {}));
var fD;
((e)=>{
    function n1(r) {
        return r.type === "MouseHover";
    }
    e.is = n1;
    function t() {
        return {
            type: "MouseHover",
            disabled: !1,
            actions: new Re
        };
    }
    e.defaultData = t;
})(fD || (fD = {}));
var pD;
((e)=>{
    function n1(r) {
        return r.type === "Scroll";
    }
    e.is = n1;
    function t() {
        return {
            type: "Scroll",
            disabled: !1,
            steps: 100,
            trigger: "load",
            startFrom: "enter",
            enterAnchor: "top",
            startOffset: 0,
            endAfter: 400,
            actions: new Re
        };
    }
    e.defaultData = t;
})(pD || (pD = {}));
var mD;
((e)=>{
    function n1(r) {
        return r.type === "Start";
    }
    e.is = n1;
    function t() {
        return {
            type: "Start",
            disabled: !1,
            actions: new Re
        };
    }
    e.defaultData = t;
})(mD || (mD = {}));
var gD;
((e)=>{
    function n1(r) {
        return r.type === "Collision";
    }
    e.is = n1;
    function t() {
        return {
            type: "Collision",
            disabled: !1,
            runMode: "Once",
            target: "character",
            actions: new Re
        };
    }
    e.defaultData = t;
})(gD || (gD = {}));
var yD;
((e)=>{
    function n1(r) {
        return r.type === "Trigger";
    }
    e.is = n1;
    function t(r, i) {
        return {
            type: "Trigger",
            disabled: !1,
            runMode: "Once",
            target: "all",
            triggeringObjects: [],
            actions: new Re,
            triggerZone: "box",
            position: i.toArray(),
            rotation: [
                0,
                0,
                0
            ],
            size: r.toArray(),
            radius: r.length() / 2,
            helperVisible: !0
        };
    }
    e.defaultData = t;
})(yD || (yD = {}));
var Ov;
((o)=>{
    o.defaultSizes = {
        mobile: [
            480,
            480
        ],
        tablet: [
            768,
            768
        ],
        desktop: [
            1200,
            1200
        ],
        custom: [
            769,
            1200
        ]
    };
    function t(a) {
        return a.type === "Resize";
    }
    o.is = t;
    function e(a) {
        return typeof a == "string" ? a : "custom";
    }
    o.sizeToDevice = e;
    function r(a) {
        return typeof a == "string" ? [
            ...o.defaultSizes[a]
        ] : [
            ...a
        ];
    }
    o.deviceToSize = r;
    function i() {
        let a = {
            size: "mobile",
            operator: "<",
            actions: new Re
        }, l = {
            size: "tablet",
            operator: "<",
            actions: new Re
        }, u = {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new Re
        }, c = new Re;
        return c.push({
            id: Se.generateUUID(),
            fi: 0,
            data: a
        }, {
            id: Se.generateUUID(),
            fi: 1,
            data: l
        }, {
            id: Se.generateUUID(),
            fi: 2,
            data: u
        }), {
            type: "Resize",
            disabled: !1,
            orientation: "horizontal",
            breakpoints: c
        };
    }
    o.defaultData = i;
    function s() {
        return {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new Re
        };
    }
    o.defaultBreakpointData = s;
})(Ov || (Ov = {}));
var Iv;
((r)=>{
    r.propertyPaths = {
        Position: [
            "position"
        ],
        "Position X": [
            "position",
            "x"
        ],
        "Position Y": [
            "position",
            "y"
        ],
        "Position Z": [
            "position",
            "z"
        ],
        Rotation: [
            "rotation"
        ],
        "Rotation X": [
            "rotation",
            "x"
        ],
        "Rotation Y": [
            "rotation",
            "y"
        ],
        "Rotation Z": [
            "rotation",
            "z"
        ],
        Scale: [
            "scale"
        ],
        "Scale X": [
            "scale",
            "x"
        ],
        "Scale Y": [
            "scale",
            "y"
        ],
        "Scale Z": [
            "scale",
            "z"
        ],
        Width: [
            "width"
        ],
        Height: [
            "height"
        ],
        Depth: [
            "depth"
        ],
        "Mouse Position X": [
            "mouse",
            "x"
        ],
        "Mouse Position Y": [
            "mouse",
            "y"
        ],
        "Mouse Pressed": [
            "mouse",
            "pressed"
        ],
        "Screen Width": [
            "mouse",
            "width"
        ],
        "Screen Height": [
            "mouse",
            "height"
        ],
        "Hit Position X": [
            "raycast",
            "x"
        ],
        "Hit Position Y": [
            "raycast",
            "y"
        ],
        "Hit Position Z": [
            "raycast",
            "z"
        ],
        "Hit Object Position X": [
            "raycast",
            "objX"
        ],
        "Hit Object Position Y": [
            "raycast",
            "objY"
        ],
        "Hit Object Position Z": [
            "raycast",
            "objZ"
        ]
    };
    function t(i) {
        return i.type === "VariableChange";
    }
    r.is = t;
    function e() {
        return {
            disabled: !1,
            type: "VariableChange",
            actions: new Re,
            variableId: "",
            objectId: null,
            property: "Position X"
        };
    }
    r.defaultData = e;
})(Iv || (Iv = {}));
var us = "personal camera", vl = "a218fcc3-276b-49b9-b485-49037fd14f5f", bD = 2960946, Xr = 5526619;
var xo;
((d)=>{
    function n1(h, f) {
        return h[0] === f[0] && h[1] === f[1];
    }
    d.isEqual = n1;
    function t(h, f, p) {
        return [
            h[0] + (f[0] - h[0]) * p,
            h[1] + (f[1] - h[1]) * p
        ];
    }
    d.lerp = t;
    function e(h, f) {
        return [
            h[0] + f[0],
            h[1] + f[1]
        ];
    }
    d.add = e;
    function r(h, f) {
        return [
            h[0] - f[0],
            h[1] - f[1]
        ];
    }
    d.sub = r;
    function i(h, f) {
        return Math.pow(f[0] - h[0], 2) + Math.pow(f[1] - h[1], 2);
    }
    d.distanceSquared = i;
    function s(h, f) {
        return Math.sqrt(i(h, f));
    }
    d.distance = s;
    function o(h, f) {
        return h[0] * f[0] + h[1] * f[1];
    }
    d.dot = o;
    function a(h, f) {
        return [
            h[0] * f,
            h[1] * f
        ];
    }
    d.scalarMultiply = a;
    function l(h, f, p) {
        let m = d.sub(f, h), g = d.sub(p, h), y = d.dot(m, g) / d.dot(m, m), v = d.scalarMultiply(m, y);
        return d.add(h, v);
    }
    d.projectionOnto = l;
    function u(h, f, p) {
        return s(h, l(h, f, p));
    }
    d.projectionOntoDistance = u;
    function c(h, f) {
        return [
            (h[0] + f[0]) * .5,
            (h[1] + f[1]) * .5
        ];
    }
    d.center = c;
})(xo || (xo = {}));
var bo;
((a)=>{
    function n1(l, u) {
        return l[0] === u[0] && l[1] === u[1] && l[2] === u[2];
    }
    a.isEqual = n1;
    function t(l, u) {
        return [
            l[0] + u[0],
            l[1] + u[1],
            l[2] + u[2]
        ];
    }
    a.add = t;
    function e(l, u) {
        return [
            l[0] - u[0],
            l[1] - u[1],
            l[2] - u[2]
        ];
    }
    a.sub = e;
    function r(l, u) {
        return [
            l[0] / u[0],
            l[1] / u[1],
            l[2] / u[2]
        ];
    }
    a.div = r;
    function i(l, u) {
        return [
            l[0] * u[0],
            l[1] * u[1],
            l[2] * u[2]
        ];
    }
    a.mul = i;
    function s(l, u) {
        return Math.hypot(l[0] - u[0], l[1] - u[1], l[2] - u[2]);
    }
    a.dist = s;
    function o(l, u, c) {
        return [
            l[0] + (u[0] - l[0]) * c,
            l[1] + (u[1] - l[1]) * c,
            l[2] + (u[2] - l[2]) * c
        ];
    }
    a.lerp = o;
})(bo || (bo = {}));
var Hp;
((e)=>{
    function n1(r, i) {
        return r[0] === i[0] && r[1] === i[1] && r[2] === i[2] && r[3] === i[3];
    }
    e.isEqual = n1;
    function t(r, i, s) {
        return [
            r[0] + (i[0] - r[0]) * s,
            r[1] + (i[1] - r[1]) * s,
            r[2] + (i[2] - r[2]) * s,
            r[3] + (i[3] - r[3]) * s
        ];
    }
    e.lerp = t;
})(Hp || (Hp = {}));
var yl;
((i)=>{
    i.identity = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    function t(s, o) {
        for(let a = 0; a < 16; a++)if (s[a] !== o[a]) return !1;
        return !0;
    }
    i.isEqual = t;
    function e(s) {
        return s ?? i.identity;
    }
    i.simplify = e;
    function r(s, o) {
        let a = o.slice(0);
        for(var l = 0, u = o.length; l < u; l += 3){
            let c = s[3] * o[l] + s[7] * o[l + 1] + s[11] * o[l + 2] + s[15];
            a[l] = (s[0] * o[l] + s[4] * o[l + 1] + s[8] * o[l + 2] + s[12]) / c, a[l + 1] = (s[1] * o[l] + s[5] * o[l + 1] + s[9] * o[l + 2] + s[13]) / c, a[l + 2] = (s[2] * o[l] + s[6] * o[l + 1] + s[10] * o[l + 2] + s[14]) / c;
        }
        return a;
    }
    i.applyMatrix4 = r;
})(yl || (yl = {}));
var Ni;
((c)=>{
    function n1(d) {
        return typeof d == "object" && typeof d.r == "number" && typeof d.g == "number" && typeof d.b == "number";
    }
    c.isRGB = n1, c.white = {
        r: 1,
        g: 1,
        b: 1
    }, c.red = {
        r: 1,
        g: 0,
        b: 0
    }, c.black = {
        r: 0,
        g: 0,
        b: 0
    };
    function i(d) {
        return {
            r: Math.round(d.r * 255),
            g: Math.round(d.g * 255),
            b: Math.round(d.b * 255),
            a: 1
        };
    }
    c.toRgb255a1 = i;
    function s(d) {
        return {
            r: d.r,
            g: d.g,
            b: d.b
        };
    }
    c.clone = s;
    function o(d) {
        return d = Math.floor(d), {
            r: (d >> 16 & 255) / 255,
            g: (d >> 8 & 255) / 255,
            b: (d & 255) / 255
        };
    }
    c.fromHex = o;
    function a(d) {
        return Math.round(d.r * 255) * 65536 + Math.round(d.g * 255) * 256 + Math.round(d.b * 255);
    }
    c.toHex = a;
    function l(d, h) {
        return d.r === h.r && d.g === h.g && d.b === h.b;
    }
    c.equals = l;
    function u(d, h, f) {
        return {
            r: d.r + (h.r - d.r) * f,
            g: d.g + (h.g - d.g) * f,
            b: d.b + (h.b - d.b) * f
        };
    }
    c.lerp = u;
})(Ni || (Ni = {}));
var pt;
((l)=>{
    l.white = {
        ...Ni.white,
        a: 1
    }, l.transparent = {
        ...Ni.white,
        a: 0
    };
    function e(u) {
        return {
            r: u[0],
            g: u[1],
            b: u[2],
            a: u[3]
        };
    }
    l.from0to1 = e;
    function r(u, c) {
        return {
            ...Ni.fromHex(u),
            a: c
        };
    }
    l.fromHexAndA = r;
    function i(u) {
        return {
            r: Math.round(u.r * 255),
            g: Math.round(u.g * 255),
            b: Math.round(u.b * 255),
            a: u.a
        };
    }
    l.toRgb255a1 = i;
    function s(u, c) {
        return Ni.equals(u, c) && u.a === c.a;
    }
    l.equals = s;
    function o(u, c, d) {
        return {
            r: u.r + (c.r - u.r) * d,
            g: u.g + (c.g - u.g) * d,
            b: u.b + (c.b - u.b) * d,
            a: u.a + (c.a - u.a) * d
        };
    }
    l.lerp = o;
    function a({ r: u, g: c, b: d, a: h } = l.white) {
        return `rgba(${u * 255}, ${c * 255}, ${d * 255}, ${h})`;
    }
    l.toStyle = a;
})(pt || (pt = {}));
var Rv;
((t)=>t.identity = {
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ],
        scale: [
            1,
            1,
            1
        ]
    })(Rv || (Rv = {}));
var vD;
((t)=>t.defaultData = {
        mass: 1,
        stiffness: 80,
        damping: 10,
        velocity: 0
    })(vD || (vD = {}));
var xD;
((t)=>t.defaultData = {
        control1: [
            .5,
            0
        ],
        control2: [
            .5,
            1
        ]
    })(xD || (xD = {}));
var pa;
((s)=>(s.linear = [
        0,
        0,
        1,
        1
    ], s.ease = [
        .25,
        .1,
        .25,
        1
    ], s.easeIn = [
        .42,
        0,
        1,
        1
    ], s.easeOut = [
        0,
        0,
        .58,
        1
    ], s.easeInOut = [
        .42,
        0,
        .58,
        1
    ]))(pa || (pa = {}));
function $w(n1) {
    return typeof n1 == "string" && n1.length === 36 ? /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(n1) : !1;
}
var ks;
((e)=>{
    e.all = [
        "PerspectiveCamera",
        "OrthographicCamera"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(ks || (ks = {}));
var xl;
((i)=>{
    i.DefaultUp = [
        0,
        1,
        0
    ], i.DefaultTargetOffset = 1e3, i.defaultData = {
        far: 1e5,
        type: "OrthographicCamera",
        perspective: {
            near: 70,
            fov: 45,
            zoom: 1
        },
        orthographic: {
            near: -100000,
            zoom: 1
        },
        up: i.DefaultUp,
        isUpVectorFlipped: !1,
        targetOffset: i.DefaultTargetOffset
    };
    function r(s) {
        return s.type === "PerspectiveCamera" ? s.perspective.zoom : s.orthographic.zoom;
    }
    i.getZoom = r;
})(xl || (xl = {}));
var So;
((e)=>{
    function n2(r, i = .1) {
        return {
            disabled: !1,
            type: "linear",
            hideBase: !1,
            count: 3,
            radial: {
                radius: Math.max(r[0], r[1]) * 2,
                start: 0,
                end: 360,
                alignment: !1,
                axis: "y",
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ]
            },
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            linear: {
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    r[0] + r[0] * i,
                    0,
                    0
                ]
            },
            grid: {
                count: [
                    2,
                    2,
                    2
                ],
                size: r.map((s)=>s * (1 + i)),
                useCenter: !0
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        };
    }
    e.defaultData = n2;
    function t(r, i) {
        let s = {
            ...r
        };
        if (e1.forEach((o)=>{
            Object.assign(s, {
                [o]: i[o] ?? r[o]
            });
        }), s.radial = {
            ...r.radial
        }, i.radial) {
            let o = r.radial, a = i.radial;
            t1.forEach((l)=>{
                Object.assign(s.radial, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.linear = {
            ...r.linear
        }, i.linear) {
            let o = r.linear, a = i.linear;
            r1.forEach((l)=>{
                Object.assign(s.linear, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.grid = {
            ...r.grid
        }, i.grid) {
            let o = r.grid, a = i.grid;
            i1.forEach((l)=>{
                Object.assign(s.grid, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.toObject = {
            ...r.toObject
        }, i.toObject) {
            let o = r.toObject, a = i.toObject;
            n1.forEach((l)=>{
                Object.assign(s.toObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.randomnessObject = {
            ...r.randomnessObject
        }, i.randomnessObject) {
            let o = r.randomnessObject, a = i.randomnessObject;
            s1.forEach((l)=>{
                Object.assign(s.randomnessObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        return s;
    }
    e.merge = t;
})(So || (So = {}));
var Lv;
((r)=>{
    r.defaultData = {
        radial: {},
        linear: {},
        grid: {},
        toObject: {},
        randomnessObject: {}
    };
    let t = [
        "radial",
        "linear",
        "grid",
        "toObject",
        "randomnessObject"
    ];
    function e(i, s) {
        let o = [];
        i.count !== void 0 && o.push({
            type: 0,
            path: s,
            props: {
                count: i.count
            }
        });
        for (let a of t){
            let l = i[a];
            l && Object.keys(l).length > 0 && o.push({
                type: 0,
                path: [
                    ...s,
                    a
                ],
                props: l
            });
        }
        return o;
    }
    r.toOps = e;
})(Lv || (Lv = {}));
var e1 = [
    "count"
], t1 = [
    "radius",
    "start",
    "end",
    "position",
    "scale",
    "rotation"
], r1 = [
    "position",
    "scale",
    "rotation"
], i1 = [
    "count",
    "size"
], n1 = [
    "count",
    "position",
    "scale",
    "rotation"
], s1 = [
    "strength",
    "scale",
    "rotation",
    "position",
    "movement",
    "seed",
    "freqScale"
];
var Bv;
((e)=>{
    e.all = [
        "PointLight",
        "SpotLight",
        "DirectionalLight",
        "HemisphereLight"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(Bv || (Bv = {}));
var Nv;
((e)=>{
    function n1(r) {
        return t(r);
    }
    e.defaultData = n1;
    function t(r) {
        if (r === "PointLight") return {
            type: r,
            color: pt.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            shadowResolution: 1024,
            shadowRadius: 1,
            penumbraSize: .5,
            depth: 1e5
        };
        if (r === "SpotLight") return {
            type: r,
            color: pt.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            penumbra: 0,
            angle: 30 / 180 * Math.PI,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        if (r === "DirectionalLight") return {
            type: r,
            color: pt.white,
            intensity: 1,
            shadows: !0,
            size: 2e3,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        throw new Error("not implemented");
    }
})(Nv || (Nv = {}));
var Fd;
((r)=>(r.defaultShapeData = {
        type: "PlaneEmitterShape",
        size: [
            100,
            100,
            100
        ]
    }, r.defaultCollisionData = {
        colliderEntityId: null,
        collisionBounce: .75
    }, r.defaultData = {
        renderMaterial: {
            type: "particleMaterial",
            color: {
                r: 1,
                g: .2,
                b: .545,
                a: 1
            },
            color2: {
                r: .945,
                g: .714,
                b: .184,
                a: 1
            },
            coloring: "gradient",
            ease: "linearFadeOut",
            easeSize: "linearFadeOut",
            transparent: !0,
            size: [
                40,
                40
            ],
            texture: "pt_default_particle",
            spriteRotation: [
                0,
                0
            ]
        },
        birthRatePerSec: 50,
        gravity: 1,
        noiseStrength: 0,
        noiseScale: 0,
        noiseSeed: 1,
        noiseType: "curl",
        randomRotation: 0,
        randomScale: .2,
        randomMass: .5,
        rootObjectType: "instancedMesh",
        life: 1,
        direction: [
            0,
            0,
            0
        ],
        directionMode: "axis",
        speed: 10,
        shape: r.defaultShapeData,
        autoPlay: !0,
        emitTimeDelay: 0,
        emitTimeCycle: "infinity",
        emitTimeLoopDelayStart: "end",
        emitTimeDuration: 1,
        ...r.defaultCollisionData
    }))(Fd || (Fd = {}));
var bl;
((t)=>t.defaultData = {
        enabled: "visibility",
        fusedBody: !0,
        rigidBody: "positioned",
        density: 1,
        pointMass: 0,
        gravityScale: 1,
        friction: .5,
        damping: 0,
        restitution: .2,
        colliderType: "convex",
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        enabledTranslation: [
            !0,
            !0,
            !0
        ]
    })(bl || (bl = {}));
var o1;
((e)=>{
    e.defaultData = {
        castShadow: !0,
        receiveShadow: !0
    };
    function t(r, i) {
        return r.castShadow === i.castShadow && r.receiveShadow === i.receiveShadow;
    }
    e.equals = t;
})(o1 || (o1 = {}));
var a1;
((e)=>{
    e.defaultData = {
        flatShading: !1,
        wireframe: !1,
        side: 0
    };
    function t(r, i) {
        return r.flatShading === i.flatShading && r.side === i.side && r.wireframe === i.wireframe;
    }
    e.equals = t;
})(a1 || (a1 = {}));
var Fv;
((t)=>t.defaultData = {
        ...a1.defaultData,
        ...o1.defaultData
    })(Fv || (Fv = {}));
var SD;
((t)=>{
    function n1(e, r) {
        let i = [];
        if ("material" in e) {
            let s = typeof e.material == "string" ? r.materials[e.material] ?? r.lib.materials[e.material]?.asset : e.material;
            s && i.push(s);
        } else if ("materials" in e) for (let s of e.materials){
            let o = typeof s == "string" ? r.materials[s] ?? r.lib.materials[s]?.asset : s;
            o && i.push(o);
        }
        return i;
    }
    t.getMaterialData = n1;
})(SD || (SD = {}));
var kd;
((e)=>(e.defaultVideo = {
        data: "",
        thumb: "/_assets/_videos/catThumb.png",
        type: "video",
        name: "Cat video"
    }, e.maxSize = 3e7))(kd || (kd = {}));
var wD;
((t)=>{
    function n1(e) {
        return e === "texture" || e === "video" || e === "color" || e === "depth" || e === "normal" || e === "gradient" || e === "noise" || e === "fresnel" || e === "rainbow" || e === "toon" || e === "outline" || e === "particle" || e === "transmission" || e === "matcap" || e === "displace" || e === "pattern" || e === "light";
    }
    t.is = n1;
})(wD || (wD = {}));
function _D(n1) {
    return n1.type !== "displace";
}
var AD;
((t)=>{
    function n1(e) {
        return e === "phong" || e === "toon" || e === "lambert" || e === "physical";
    }
    t.is = n1;
})(AD || (AD = {}));
var kv = [
    "mode",
    "gradientType",
    "noiseType",
    "displacementType",
    "projection",
    "cnormal",
    "crop",
    "axis",
    "side"
], ED = [
    "wrapping",
    "image",
    "video",
    "name"
], Ir;
((i)=>{
    function n1(s, o) {
        let { texture: a, ...l } = o;
        if (Object.assign(s, l), a) {
            let u = s.texture;
            u && Object.assign(u, a);
        }
    }
    i.patch = n1;
    function t(s, o) {
        return s === "light" && o ? e(o) : r(s);
    }
    i.defaultData = t;
    function e(s) {
        let o = {
            mode: 0,
            isMask: !1,
            visible: !0,
            bumpMap: void 0,
            bumpMapIntensity: 5,
            roughnessMap: void 0,
            alphaOverride: 1
        };
        switch(s){
            case "phong":
                return {
                    ...o,
                    category: "phong",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 5,
                    type: "light",
                    visible: !0,
                    mode: 0,
                    occlusion: !0,
                    alpha: .6
                };
            case "toon":
                return {
                    ...o,
                    category: "toon",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 10,
                    type: "light",
                    alpha: 1
                };
            case "lambert":
                return {
                    ...o,
                    category: "lambert",
                    emissive: {
                        r: 0,
                        g: 0,
                        b: 0
                    },
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
            case "physical":
                return {
                    ...o,
                    category: "physical",
                    roughness: .2,
                    metalness: .2,
                    reflectivity: .2,
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
        }
    }
    function r(s) {
        let o = {
            alpha: 1,
            mode: 0,
            isMask: !1,
            visible: !0
        };
        switch(s){
            case "texture":
                return {
                    ...o,
                    type: "texture",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        image: "image_0",
                        wrapping: 1e3,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    },
                    crop: !1
                };
            case "video":
                return {
                    ...o,
                    type: "video",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        video: kd.defaultVideo,
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    },
                    crop: !1
                };
            case "color":
                return {
                    ...o,
                    type: "color",
                    color: Ni.fromHex(Xr)
                };
            case "depth":
                return {
                    ...o,
                    type: "depth",
                    gradientType: 1,
                    smooth: !1,
                    isVector: !0,
                    isWorldSpace: !1,
                    origin: [
                        0,
                        0,
                        0
                    ],
                    direction: [
                        1,
                        0,
                        0
                    ],
                    colors: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1
                    ],
                    near: 50,
                    far: 200
                };
            case "normal":
                return {
                    ...o,
                    type: "normal",
                    cnormal: [
                        1,
                        1,
                        1
                    ]
                };
            case "gradient":
                return {
                    ...o,
                    type: "gradient",
                    gradientType: 0,
                    smooth: !1,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 2,
                    angle: 0,
                    offset: [
                        0,
                        0
                    ],
                    morph: [
                        0,
                        0
                    ]
                };
            case "noise":
                return {
                    ...o,
                    type: "noise",
                    size: [
                        100,
                        100,
                        100
                    ],
                    noiseType: 0,
                    scale: 1,
                    move: 1,
                    colorA: {
                        ...Ni.fromHex(6710886),
                        a: 1
                    },
                    colorB: {
                        ...Ni.fromHex(6710886),
                        a: 1
                    },
                    colorC: {
                        ...Ni.fromHex(16777215),
                        a: 1
                    },
                    colorD: {
                        ...Ni.fromHex(16777215),
                        a: 1
                    },
                    distortion: [
                        1,
                        1
                    ],
                    fA: [
                        1.7,
                        9.2
                    ],
                    fB: [
                        8.3,
                        2.8
                    ],
                    voronoiStyle: 0,
                    highCut: 1,
                    lowCut: 0,
                    smoothness: .3,
                    seed: 0,
                    quality: 1
                };
            case "fresnel":
                return {
                    ...o,
                    type: "fresnel",
                    color: pt.fromHexAndA(16777215, 1),
                    bias: .1,
                    scale: 1,
                    intensity: 2,
                    factor: 1
                };
            case "rainbow":
                return {
                    ...o,
                    type: "rainbow",
                    filmThickness: 30,
                    movement: 0,
                    wavelengths: [
                        0,
                        0,
                        0
                    ],
                    noiseStrength: 0,
                    noiseScale: 1,
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "toon":
                return {
                    ...o,
                    type: "toon",
                    positioning: 2,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        .475,
                        .525,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 4,
                    source: [
                        0,
                        1e3,
                        0
                    ],
                    isWorldSpace: !0,
                    noiseStrength: 0,
                    noiseScale: 1,
                    shadowColor: pt.fromHexAndA(0, 0),
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "outline":
                return {
                    ...o,
                    type: "outline",
                    outlineColor: pt.fromHexAndA(0, 1),
                    contourColor: pt.fromHexAndA(0, 1),
                    outlineWidth: 2,
                    contourWidth: 5,
                    outlineThreshold: .4,
                    contourThreshold: 0,
                    outlineSmoothing: 0,
                    contourFrequency: 10,
                    contourDirection: [
                        0,
                        1,
                        0
                    ],
                    positionalLines: !1,
                    compensation: !0
                };
            case "matcap":
                return {
                    ...o,
                    type: "matcap",
                    texture: {
                        image: "matcap_0",
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    }
                };
            case "transmission":
                return {
                    ...o,
                    type: "transmission",
                    thickness: 10,
                    ior: 1.5,
                    roughness: 1
                };
            case "displace":
                return {
                    visible: !0,
                    type: "displace",
                    displacementType: "noise",
                    noiseType: 0,
                    scale: 10,
                    movement: 1,
                    offset: [
                        0,
                        0,
                        0
                    ],
                    intensity: 8,
                    voronoiStyle: 0,
                    smoothness: .3,
                    seed: 0,
                    highCut: 1,
                    lowCut: 0,
                    quality: 1
                };
            case "pattern":
                return {
                    ...o,
                    type: "pattern",
                    style: 0,
                    projection: 0,
                    axis: "y",
                    blending: 0,
                    offset: [
                        0,
                        0
                    ],
                    colorA: {
                        ...Ni.fromHex(0),
                        a: 1
                    },
                    colorB: {
                        ...Ni.fromHex(16777215),
                        a: 1
                    },
                    frequency: [
                        10,
                        10
                    ],
                    size: .5,
                    variation: 0,
                    smoothness: .5,
                    zigzag: 0,
                    rotation: 0,
                    vertical: [
                        0,
                        1
                    ],
                    horizontal: [
                        0,
                        1
                    ],
                    sides: 6
                };
        }
    }
})(Ir || (Ir = {}));
var Qr;
((u)=>{
    function n1(c) {
        return !c.layers.some((h)=>h.data.type === "texture" && h.data.projection !== 0 || h.data.type === "depth" && !h.data.isWorldSpace || h.data.type === "noise" || h.data.type === "displace");
    }
    u.isMergable = n1;
    function t(c) {
        let d = "";
        return c.layers.forEach((h)=>{
            Object.entries(h.data).forEach(([f, p])=>{
                d += `${f}${p}`, Array.isArray(p) ? p.forEach((m)=>d += `${m}`) : typeof p == "object" ? Object.values(p).forEach((m)=>{
                    typeof m == "number" ? d += `${m.toFixed(4)}` : d += `${m}`;
                }) : d += `${p}`;
            });
        }), d;
    }
    u.getHash = t;
    function e() {
        return {
            layers: new Re
        };
    }
    u.defaultEmptyData = e;
    function r(c = "layer1", d = "layer2") {
        return s("phong", c, d);
    }
    u.defaultData = r;
    function i(c, d) {
        return {
            ...c,
            name: d
        };
    }
    u.withName = i;
    function s(c, d = "layer1", h = "layer2") {
        let f = new Re;
        return f.push({
            fi: 0,
            data: Ir.defaultData("light", c),
            id: d
        }), f.push({
            fi: 1,
            data: Ir.defaultData("color"),
            id: h
        }), {
            layers: f
        };
    }
    u.defaultTwoLayerData = s;
    function o(c) {
        let d = Ir.defaultData("texture");
        c && Object.assign(d.texture, {
            image: c
        });
        let h = new Re;
        return h.push({
            fi: 0,
            data: d,
            id: "layer1"
        }), h.push({
            fi: 1,
            data: {
                ...Ir.defaultData("transmission"),
                alpha: 1
            },
            id: "layer2"
        }), h.push({
            fi: 2,
            data: {
                ...Ir.defaultData("light", "lambert"),
                alpha: 0
            },
            id: "layer3"
        }), {
            layers: h
        };
    }
    u.defaultUIObjectMaterial = o;
    function a(c, d = "phong", h = "layer1", f = "layer2") {
        let p = Ir.defaultData("texture");
        Object.assign(p.texture, {
            image: c
        });
        let m = new Re;
        return m.push({
            fi: 0,
            data: p,
            id: h
        }), m.push({
            fi: 1,
            data: Ir.defaultData("light", d),
            id: f
        }), {
            layers: m
        };
    }
    u.defaultTwoLayerTextureData = a;
    function l(c, d = "phong", h = "layer1", f = "layer2") {
        let p = Ir.defaultData("video");
        Object.assign(p.texture, {
            video: c
        });
        let m = new Re;
        return m.push({
            fi: 0,
            data: p,
            id: h
        }), m.push({
            fi: 1,
            data: Ir.defaultData("light", d),
            id: f
        }), {
            layers: m
        };
    }
    u.defaultTwoLayerVideoTextureData = l;
})(Qr || (Qr = {}));
var zd;
((t)=>{
    function n1() {
        return {
            points: new Re,
            roundness: 0,
            shapeHoles: [],
            isClosed: !1
        };
    }
    t.defaultData = n1;
})(zd || (zd = {}));
var Vd;
((t)=>{
    function n1() {
        return {
            points: new Re,
            lastInsertionPlane: null,
            subdivisions: 12,
            isClosed: !1
        };
    }
    t.defaultData = n1;
})(Vd || (Vd = {}));
var l1 = {
    type: "Ellipse",
    width: 50,
    height: 50,
    spikes: 16,
    angle: 360,
    innerRadius: 0
};
var zv;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return c1.forEach((s)=>{
            Object.assign(i, {
                [s]: r[s] ?? e[s]
            });
        }), i;
    }
    t.merge = n1;
})(zv || (zv = {}));
var Vv = {
    shape: l1,
    depth: 1,
    offset: 0,
    bevel: 50,
    bevelSides: 6,
    angle: 0,
    twist: 0,
    startScale: 1,
    endScale: 1,
    capType: "flat"
}, c1 = [
    "depth",
    "offset",
    "angle",
    "twist",
    "startScale",
    "endScale"
];
var Wp;
((e)=>{
    function n1(r) {
        return r === "PolygonGeometry" || r === "RectangleGeometry" || r === "StarGeometry" || r === "TriangleGeometry" || r === "EllipseGeometry" || r === "UIGeometry";
    }
    e.is2DParametricMesh = n1;
    function t(r) {
        return r === "PolygonGeometry" || r === "PolygonGeometry" || r === "RectangleGeometry" || r === "StarGeometry" || r === "TriangleGeometry" || r === "EllipseGeometry" || r === "PathGeometry" || r === "VectorGeometry" || r === "ConeGeometry" || r === "CubeGeometry" || r === "CylinderGeometry" || r === "DodecahedronGeometry" || r === "HelixGeometry" || r === "IcosahedronGeometry" || r === "LatheGeometry" || r === "PyramidGeometry" || r === "SphereGeometry" || r === "PlaneGeometry" || r === "BackdropGeometry" || r === "TorusGeometry" || r === "TorusKnotGeometry" || r === "BooleanGeometry" || r === "TextGeometry";
    }
    e.isParametricMesh = t;
})(Wp || (Wp = {}));
var Uv;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return Object.assign(i, r), i.type === "PathGeometry" && "extrusion" in r && r.extrusion && (i.extrusion = {
            ...e.extrusion
        }, Object.assign(i.extrusion, zv.merge(i.extrusion, r.extrusion))), i;
    }
    t.merge = n1;
})(Uv || (Uv = {}));
var Sl;
((t)=>{
    function n1(e) {
        if (e === "RectangleGeometry") return {
            width: 320,
            height: 320,
            type: e,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "UIGeometry") return {
            type: e,
            frame: "",
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            width: 1,
            height: 1
        };
        if (e === "PathGeometry") return {
            type: e,
            width: 1,
            height: 1,
            depth: 1,
            path: Vd.defaultData(),
            extrusion: Vv
        };
        if (e === "VectorGeometry") return {
            width: 1,
            height: 1,
            type: e,
            subdivisions: 12,
            shape: zd.defaultData(),
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "BooleanGeometry") return {
            type: e,
            operation: 2,
            width: 0,
            height: 0,
            depth: 0,
            phongAngle: 35
        };
        if (e === "TextGeometry") return {
            type: e,
            width: 100,
            height: 100,
            depth: 0,
            horizontalAlign: 1,
            verticalAlign: 1,
            fontSize: 16,
            lineHeight: 1.2,
            letterSpacing: 0,
            text: {
                textValue: ""
            },
            textTransform: 1,
            font: "Roboto_regular",
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "SphereGeometry") return {
            type: "SphereGeometry",
            width: 100,
            height: 100,
            depth: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        };
        throw new Error("not implemented");
    }
    t.defaultData = n1;
})(Sl || (Sl = {}));
var u1 = [
    "width",
    "height",
    "depth"
];
var Gv;
((t)=>t.defaultData = {
        enabled: !1,
        useBackgroundColor: !1,
        color: Ni.white,
        near: .1,
        far: 2e3
    })(Gv || (Gv = {}));
var Ud;
((e)=>{
    let n1 = {
        opacity: 1,
        blendFunction: 13,
        enabled: !1
    };
    e.defaultData = {
        enabled: !1,
        pixelation: {
            ...n1,
            blendFunction: 16,
            granularity: 15
        },
        bloom: {
            ...n1,
            blendFunction: 16,
            intensity: 1,
            blurScale: 1,
            luminanceThreshold: .25,
            luminanceSmoothing: .025,
            kernelSize: 3
        },
        chromaticAberration: {
            ...n1,
            offset: [
                2,
                2
            ]
        },
        vignette: {
            ...n1,
            darkness: 1,
            offset: 0
        },
        hueSaturation: {
            ...n1,
            hue: 3,
            saturation: 0
        },
        brightnessContrast: {
            ...n1,
            brightness: .25,
            contrast: 0
        },
        depthOfField: {
            ...n1,
            focalLength: 2,
            focusDistance: 2,
            bokehScale: 2
        },
        noise: {
            ...n1,
            blendFunction: 16
        }
    };
})(Ud || (Ud = {}));
var d1;
((t)=>t.defaultData = {
        softShadowQuality: "low"
    })(d1 || (d1 = {}));
var h1;
((t)=>t.defaultData = {
        enabled: !0,
        color: {
            r: .8274509803921568,
            g: .8274509803921568,
            b: .8274509803921568
        },
        intensity: .75
    })(h1 || (h1 = {}));
var f1;
((t)=>t.defaultData = {
        occlusion: !1,
        aoFullRes: !1,
        radius: 256,
        bias: .5,
        aoColor: {
            r: .19607843137254902,
            g: .19607843137254902,
            b: .19607843137254902
        }
    })(f1 || (f1 = {}));
var wl;
((t)=>t.defaultData = {
        usePhysics: !1,
        gravity: -10
    })(wl || (wl = {}));
var p1;
((t)=>t.defaultData = {
        playCamera: us,
        gameControlObject: null
    })(p1 || (p1 = {}));
var jv;
((t)=>t.defaultData = {
        backgroundColor: pt.fromHexAndA(bD, 1),
        postprocessing: Ud.defaultData,
        fog: Gv.defaultData,
        globalPhysics: wl.defaultData,
        ambient: h1.defaultData,
        ao: f1.defaultData,
        shadow: d1.defaultData,
        publish: p1.defaultData
    })(jv || (jv = {}));
var Hv;
((t)=>t.defaultData = {
        colliderType: "box",
        size: [
            100,
            100,
            100
        ],
        colliderHelperVisible: !0,
        forceType: "collider",
        forceRange: "global",
        forceIntensity: .5,
        forceDambing: .95
    })(Hv || (Hv = {}));
var TD;
((e)=>{
    function n1(r) {
        return r === "Component" || r === "Instance";
    }
    e.isComponentRelated = n1;
    function t(r) {
        return r === "Empty" || r === "Instance";
    }
    e.isEmptyOrComponent = t;
})(TD || (TD = {}));
var Gd;
((i)=>{
    i.identity = {
        ...Rv.identity,
        hiddenMatrix: yl.identity
    };
    function t(s) {
        return {
            position: s.position,
            rotation: s.rotation,
            scale: s.scale,
            hiddenMatrix: s.hiddenMatrix
        };
    }
    i.fromObject = t;
    function e(s, o) {
        return {
            position: o?.position || s.position,
            rotation: o?.rotation || s.rotation,
            scale: o?.scale || s.scale,
            hiddenMatrix: o?.hiddenMatrix || s.hiddenMatrix
        };
    }
    i.merge = e;
    function r(s, o) {
        return rv({
            position: bo.isEqual(s.position, o.position) ? void 0 : o.position,
            rotation: bo.isEqual(s.rotation, o.rotation) ? void 0 : o.rotation,
            scale: bo.isEqual(s.scale, o.scale) ? null : o.scale,
            hiddenMatrix: yl.isEqual(s.hiddenMatrix, o.hiddenMatrix) ? void 0 : o.hiddenMatrix
        });
    }
    i.diff = r;
})(Gd || (Gd = {}));
var wi;
((t)=>t.defaultData = {
        states: new Re,
        events: new Re,
        visible: !0,
        raycastLock: !1,
        physics: bl.defaultData,
        pathSnapping: {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        },
        ...Gd.identity,
        cloner: null
    })(wi || (wi = {}));
var Wv;
((t)=>t.defaultData = {
        type: "Empty",
        ...wi.defaultData
    })(Wv || (Wv = {}));
var MD;
((t)=>t.defaultData = {
        type: "ParticleCollider",
        ...Hv.defaultData,
        ...wi.defaultData
    })(MD || (MD = {}));
var CD;
((t)=>t.defaultData = {
        type: "Component",
        ...wi.defaultData
    })(CD || (CD = {}));
var PD;
((t)=>t.defaultData = {
        type: "Particle",
        ...wi.defaultData,
        ...Fd.defaultData
    })(PD || (PD = {}));
var Pc;
((t)=>t.defaultData = {
        type: "Mesh",
        ...wi.defaultData,
        ...Fv.defaultData
    })(Pc || (Pc = {}));
var Dc;
((t)=>t.defaultData = {
        ...wi.defaultData,
        ...Gd.identity,
        position: [
            0,
            0,
            xl.DefaultTargetOffset
        ],
        ...xl.defaultData
    })(Dc || (Dc = {}));
var qv;
((e)=>{
    function n1(r) {
        return {
            ...wi.defaultData,
            ...Nv.defaultData(r)
        };
    }
    e.defaultData = n1, e.defaultDirectionalLightData = {
        ...e.defaultData("DirectionalLight"),
        position: [
            200,
            300,
            300
        ],
        name: "Directional Light",
        intensity: .7
    };
})(qv || (qv = {}));
var jd;
((e)=>{
    function n1(r, i, s = 0) {
        for(; s < i.length;){
            let o = r ? r[i[s]] : void 0;
            if (i.length === s + 1) return o;
            if (o) r = o.descendants, s += 1;
            else return;
        }
    }
    e.resolveWithDes = n1;
    function t(r, i, s = 0) {
        let o = n1(r, i, s);
        if (o) {
            let a = Object.keys(o);
            if (a.length === 1 && a[0] === "descendants") return;
        }
        return o;
    }
    e.resolve = t;
})(jd || (jd = {}));
var wo;
((s)=>{
    s.rootOverrideProps = [
        "physics",
        "events"
    ], s.compositeNonOptionalOverrideProps = [
        "geometry"
    ], s.compositeEntireOverrideOverrideProps = [
        "material"
    ];
    function r(o, a) {
        return {
            ...wi.defaultData,
            ...a,
            component: o,
            overrides: new lr,
            physics: void 0,
            events: void 0,
            type: "Instance"
        };
    }
    s.ofComponent = r;
    function i(o) {
        let a = Gd.fromObject(o.data);
        return r(o.id, a);
    }
    s.fromComponentData = i;
})(wo || (wo = {}));
var ma;
((e)=>{
    e.defaultData = {
        type: "Page",
        ...wi.defaultData,
        physics: {
            ...bl.defaultData,
            fusedBody: !1
        },
        ...jv.defaultData,
        camera: Dc.defaultData
    };
    function t(r) {
        return r.uiScene !== void 0;
    }
    e.isUIPage = t;
})(ma || (ma = {}));
var Yv;
((s)=>(s.defaultCamera = {
        position: [
            0,
            0,
            1e3
        ],
        scale: [
            1,
            1,
            1
        ],
        rotation: [
            0,
            0,
            0
        ],
        hiddenMatrix: yl.identity,
        name: "Play Camera",
        visible: !0,
        raycastLock: !1,
        physics: bl.defaultData,
        states: new Re,
        events: new Re,
        cloner: null,
        pathSnapping: {
            pathId: null,
            orientation: "tangential",
            slide: 0,
            offset: 0
        },
        ...xl.defaultData
    }, s.KeysByResetCategory = {
        States: [
            "states"
        ],
        Events: [
            "events"
        ],
        Material: [
            "material",
            "materials"
        ],
        Geometry: [
            "geometry"
        ],
        Position: [
            "position"
        ],
        Rotation: [
            "rotation"
        ],
        Scale: [
            "scale"
        ],
        Transform: [
            "position",
            "scale",
            "rotation",
            "hiddenMatrix"
        ],
        Name: [
            "name"
        ],
        Visibility: [
            "visible",
            "raycastLock",
            "flatShading",
            "wireframe",
            "side"
        ],
        Shadows: [
            "castShadow",
            "receiveShadow"
        ],
        Cloner: [
            "cloner"
        ],
        Physics: [
            "physics"
        ]
    }, s.defaultMeshObject = {
        name: "Rectangle",
        ...wi.defaultData,
        ...Pc.defaultData,
        geometry: Sl.defaultData("RectangleGeometry"),
        material: Qr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, s.defaultBooleanObject = {
        name: "Boolean",
        ...wi.defaultData,
        ...Pc.defaultData,
        geometry: Sl.defaultData("BooleanGeometry"),
        material: Qr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, s.defaultTextObject = {
        name: "Text",
        ...wi.defaultData,
        ...Pc.defaultData,
        geometry: Sl.defaultData("TextGeometry"),
        material: Qr.defaultTwoLayerData("phong", "layer1", "layer2")
    }))(Yv || (Yv = {}));
var ga;
((i)=>{
    function n1(s, o) {
        let a = {
            name: o
        };
        return s.type === "Mesh" ? (a.geometry = {}, "material" in s && (a.material = {
            layers: new lr
        }), "materials" in s && (a.materials = s.materials.map((l)=>({
                layers: new lr
            })))) : ks.is(s.type) && (a.perspective = {}, a.orthographic = {}), a;
    }
    i.newEmpty = n1;
    function t(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        return "material" in a && "material" in o && o.material && (a.material = fl(a.material, (l)=>{
            if (typeof l != "string") for (let [u, c] of Object.entries(o.material.layers)){
                let d = l.layers.data(u);
                d && Ir.patch(d, c);
            }
        }).data), a.materials && o.materials && (a.materials = fl(a.materials, (l)=>{
            for(let u = 0; u < a.materials.length; u++){
                let c = o.materials[u];
                if (typeof c != "string") for (let [d, h] of Object.entries(c.layers)){
                    let f = l[u]?.layers?.data(d);
                    f && Ir.patch(f, h);
                }
            }
        }).data), a;
    }
    function e(s, o) {
        let a, l = [], u = {
            orthographic: 0,
            perspective: 0,
            geometry: 0
        };
        function c(d, h) {
            for (let [f, p] of Object.entries(h.layers)){
                let { texture: m, ...g } = p;
                if (m !== void 0 && Object.keys(m).length > 0) {
                    let y = {
                        path: [
                            ...d,
                            "layers",
                            f,
                            "texture"
                        ],
                        props: m,
                        type: 0
                    };
                    l.push(y);
                }
                if (Object.keys(g).length > 0) {
                    let y = {
                        path: [
                            ...d,
                            "layers",
                            f
                        ],
                        props: g,
                        type: 0
                    };
                    l.push(y);
                }
            }
        }
        for (let [d, h] of Object.entries(o))if (d !== "name") {
            if (d === "cloner") l.push(...Lv.toOps(h, [
                "cloner"
            ]));
            else if (d === "pathSnapping") l.push({
                path: [
                    d
                ],
                props: {
                    slide: h.slide,
                    offset: h.offset
                },
                type: 0
            });
            else if (d === "material") c([
                "material"
            ], h);
            else if (d === "materials") for (let [f, p] of Object.entries(h))c([
                "materials",
                f
            ], p);
            else if (u[d] === 0) {
                if (d === "geometry" && h.extrusion !== void 0) {
                    let f = {
                        path: [
                            d,
                            "extrusion"
                        ],
                        props: h.extrusion,
                        type: 0
                    };
                    l.push(f), h = {
                        ...h
                    }, delete h.extrusion;
                }
                if (Object.keys(h).length > 0) {
                    let f = {
                        path: [
                            d
                        ],
                        props: h,
                        type: 0
                    };
                    l.push(f);
                }
            } else a === void 0 && (a = {
                path: [],
                props: {},
                type: 0
            }, l.push(a)), a.props[d] = h;
        }
        return l;
    }
    i.toOps = e;
    function r(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        if (Object.assign(a, Gd.merge(a, o)), Object.assign(a, {
            pathSnapping: Object.assign({}, a.pathSnapping, {
                slide: o.pathSnapping?.slide ?? a.pathSnapping?.slide ?? 0,
                offset: o.pathSnapping?.offset ?? a.pathSnapping?.offset ?? 0
            })
        }), ks.is(s.type)) {
            a.orthographic = {
                ...a.orthographic
            }, a.perspective = {
                ...a.perspective
            };
            let l = o;
            l.orthographic?.zoom !== void 0 && (a.orthographic.zoom = l.orthographic.zoom), l.perspective?.zoom !== void 0 && (a.perspective.zoom = l.perspective.zoom), l.isUpVectorFlipped !== void 0 && (a.isUpVectorFlipped = l.isUpVectorFlipped), l.targetOffset !== void 0 && (a.targetOffset = l.targetOffset);
        } else if (s.type === "Mesh") "geometry" in o && Object.assign(a, {
            geometry: Uv.merge(a.geometry, o.geometry)
        }), (o.material || o.materials) && (a = t(a, o)), a.cloner && "cloner" in o && Object.assign(a, {
            cloner: So.merge(a.cloner, o.cloner)
        });
        else if (s.type === "Empty") a.cloner && "cloner" in o && Object.assign(a, {
            cloner: So.merge(a.cloner, o.cloner)
        });
        else if (Bv.is(s.type)) {
            let l = o;
            l.intensity !== void 0 && (a.intensity = l.intensity), l.color !== void 0 && (typeof l.color == "string" ? a.color = l.color : a.color = Ni.clone(l.color));
        }
        return a;
    }
    i.patch = r;
})(ga || (ga = {}));
var Hd;
((t)=>t.defaultData = {
        enablePan: !0,
        enableZoom: !0,
        enableRotate: !0,
        enableDamping: !0,
        rotationLimitsMode: 0,
        rotationVerticalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationHorizontalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationSoftLimit: 2,
        panLimitsMode: 0,
        panVerticalOffset: {
            min: 250,
            max: 250
        },
        panHorizontalOffset: {
            min: 250,
            max: 250
        },
        panSoftLimit: 2,
        zoomLimitsEnabled: !1,
        zoomLimits: {
            min: .1,
            max: 2
        },
        autoRotate: !1,
        autoRotateSpeed: 2,
        autoRotateClockwise: !0,
        hoverRotatePanMode: 0,
        hoverRotatePanStrength: 20,
        hoverRotateDamping: .125,
        isTouchZoom: !0,
        orbitTouches: 2,
        panTouches: 3,
        resetHoverEffectOnPointerLeave: !0
    })(Hd || (Hd = {}));
var zs;
((t)=>t.defaultData = {
        orbitControls: Hd.defaultData,
        playPage: vl,
        withBackground: !0,
        preventScroll: !1,
        preventTouchScroll: !1,
        hideCursor: !1,
        mouseEventTarget: "canvas",
        joystickSizeAndXYOffset: Array(12).fill(0).map((e, r)=>{
            let i = 0, s = 0;
            return r < 5 ? s = -30 : r < 10 && (s = 30), r === 0 || r === 10 || r === 5 ? i = 30 : (r === 4 || r === 11 || r === 9) && (i = -30), [
                120,
                [
                    i,
                    s
                ],
                "show"
            ];
        }),
        settings: {
            image: {
                format: "jpg",
                ratio: 1
            },
            video: {
                format: "mp4",
                imageFormat: "jpg",
                fps: 30,
                mbps: 80,
                ratio: Math.max(1, typeof window < "u" ? Math.floor(window.devicePixelRatio) : 1),
                stopMode: "manual",
                duration: 5e3
            },
            web: {
                logo: !0,
                compress: !0,
                preset: 1,
                preload: !0,
                hint: !1
            }
        },
        stopRaycast: !0,
        hdTransmission: !1
    })(zs || (zs = {}));
var m1;
((t)=>t.defaultData = {
        id: "basic",
        label: "Basic",
        style: "None",
        prompt: ""
    })(m1 || (m1 = {}));
var g1;
((t)=>t.defaultData = {
        weather: 0,
        shadows: 0,
        lightOrigin: 0,
        temperature: 0,
        sun: 0,
        camera: 0,
        environment: 0,
        particles: 0,
        nature: 0,
        floor: 0
    })(g1 || (g1 = {}));
var ya;
((e)=>(e.defaultData = ()=>({
            mode: "line-art-both",
            prompt: "",
            negativePrompt: "",
            style: {
                ...m1.defaultData
            },
            isRandomSeed: !0,
            seed: e.generateSeed(),
            guessMode: !1,
            advanced: !1,
            steps: 20,
            guidanceScale: 7.5,
            controlNetScale: 1,
            modifiers: g1.defaultData
        }), e.generateSeed = ()=>Math.round(Math.random() * 1e5)))(ya || (ya = {}));
var Al;
((e)=>{
    function n1(r) {
        return r.find((i)=>i.data.type === "Page" && i.data.globalPhysics.usePhysics) !== void 0;
    }
    e.physicsEnabled = n1;
    function t(r, i, s) {
        r.scene.objects.traverseFrom(i, (o, a)=>{
            if (a.type === "Instance") {
                let l = Wd.getComponentData(r, a.component)?.data;
                l && s(o, a, l.events);
            } else s(o, a, a.events);
        });
    }
    e.traverseModuleInstances = t;
})(Al || (Al = {}));
var va;
((l)=>{
    l.TRASH_CAN_ID = "830a2708-8ed9-49cf-a68e-085299892222";
    function t(u = {
        withLight: !0,
        withSquare: !0
    }) {
        let c = [], d = Yv.defaultMeshObject;
        u.withLight === !0 && c.push({
            fi: -1,
            data: qv.defaultDirectionalLightData,
            id: "830a2708-8ed9-49cf-a68e-085299899103",
            children: []
        }), u.withSquare === !0 && c.push({
            fi: 1,
            id: "7ba78968-2a55-48f2-b14c-5191da3e075e",
            data: d,
            children: []
        });
        let h = new ar;
        return h.push({
            fi: 1,
            id: vl,
            data: {
                ...ma.defaultData,
                name: "Scene 1"
            },
            children: c
        }), h;
    }
    l.defaultData = {
        objects: t(),
        publish: zs.defaultData,
        styles: ya.defaultData()
    }, l.emptyDataWithoutPage = function() {
        return {
            objects: new ar,
            publish: zs.defaultData,
            styles: ya.defaultData()
        };
    }, l.emptyDataWithPage = function(u) {
        return {
            objects: t(u),
            publish: zs.defaultData,
            styles: ya.defaultData()
        };
    }, l.emptyData = function() {
        return {
            objects: new ar,
            publish: {
                ...zs.defaultData
            },
            styles: ya.defaultData()
        };
    };
    function o(u) {
        return {
            ...l.defaultData,
            objects: pn(u, ar.prototype)
        };
    }
    l.withObjs = o;
    function a(u, c) {
        return o([
            {
                id: u,
                data: c,
                children: [],
                fi: 0
            }
        ]);
    }
    l.withObj = a;
})(va || (va = {}));
var qd;
((t)=>t.defaultData = {
        preset: "fullscreen",
        allowResponsive: !1,
        size: [
            512,
            512
        ],
        coords: [
            0,
            0
        ],
        sceneScale: 1,
        color: {
            r: 0,
            g: 0,
            b: 0,
            a: .5
        }
    })(qd || (qd = {}));
var Yd;
((t)=>t.emptyImage = {
        data: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=",
        name: "empty"
    })(Yd || (Yd = {}));
var Fi;
((s)=>{
    function n1(o) {
        return o.textValue !== void 0;
    }
    s.isTextValue = n1;
    function t(o) {
        return typeof o == "number";
    }
    s.isNumber = t;
    function e(o) {
        return typeof o == "boolean";
    }
    s.isBoolean = e;
    function r(o) {
        return n1(o) ? "string" : e(o) ? "boolean" : "number";
    }
    s.typeOfVariable = r;
    function i(o) {
        return s.isTextValue(o) ? Array.isArray(o.textValue) ? o.textValue.map((a)=>a.toString().padStart(o.padding ?? 2, "0")).join(o.deliminator ?? ":") + (o.suffix !== void 0 ? " " + o.suffix : "") : o.textValue.toString() : s.isBoolean(o) ? o ? "True" : "False" : s.isNumber(o) ? parseFloat(o.toFixed(3)).toString() : o.toString();
    }
    s.getDisplayedValue = i;
})(Fi || (Fi = {}));
var y1;
((t)=>t.all = [
        "images",
        "videos",
        "colors",
        "audios",
        "particles",
        "fonts",
        "materials",
        "variables"
    ])(y1 || (y1 = {}));
var DD;
((t)=>t.all = [
        ...y1.all,
        "components"
    ])(DD || (DD = {}));
var OD;
((t)=>{
    function n1() {
        return {
            images: new Ke,
            videos: new Ke,
            colors: new Ke,
            audios: new Ke,
            particles: new Ke,
            fonts: new Ke,
            materials: new Ke,
            components: new Ke,
            variables: new Ke
        };
    }
    t.defaultData = n1;
})(OD || (OD = {}));
var xa;
((t)=>{
    function n1() {
        return {
            images: new Ke,
            videos: new Ke,
            colors: new Ke,
            audios: new Ke,
            particles: new Ke,
            fonts: new Ke,
            materials: new Ke,
            components: new Ke,
            variables: new Ke
        };
    }
    t.defaultData = n1;
})(xa || (xa = {}));
var yn;
((s)=>{
    function n1() {
        let o = {};
        return o["89b10010-844c-11ec-a8a3-0242ac120002"] = {
            r: .5,
            g: .5,
            b: .5,
            a: 1,
            name: "Default Color"
        }, pn(o, Ke.prototype);
    }
    s.defaultColors = n1;
    function t(o) {
        let a = {};
        return o?.withAITexture && (a["a1b10010-844c-a8a3-11ec-0242ac2011ec"] = {
            ...Yd.emptyImage,
            name: "AI generated image"
        }), pn(a, Ke.prototype);
    }
    s.defaultImages = t;
    function e() {
        return {
            catelogs: new Ke,
            materials: new Ke,
            images: new Ke,
            videos: new Ke,
            colors: new Ke,
            audios: new Ke,
            particles: new Ke,
            fonts: new Ke,
            variables: new Re,
            lib: xa.defaultData()
        };
    }
    s.emptyData = e;
    function r(o) {
        switch(o){
            case "number":
                return {
                    value: 0,
                    name: "Number"
                };
            case "boolean":
                return {
                    value: !1,
                    name: "Boolean"
                };
            case "string":
                return {
                    value: {
                        textValue: "String value"
                    },
                    name: "String"
                };
            case "time":
                let a = [
                    0,
                    0,
                    0
                ];
                return {
                    name: "Time",
                    value: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    dynamicVariableType: "time",
                    format: "HH:mm:ss",
                    format12h24h: "12ampm",
                    timeZone: null,
                    hasEnd: !1,
                    endValue: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    autoStart: !0,
                    repeat: !1
                };
            case "counter":
                return {
                    name: "Counter",
                    value: 0,
                    dynamicVariableType: "counter",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    randomStart: !1,
                    range: [
                        0,
                        100
                    ],
                    decimals: 0
                };
            case "random":
                return {
                    name: "Random",
                    value: 0,
                    dynamicVariableType: "random",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    isStatic: !1,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    min: 0,
                    max: 100,
                    decimals: 0
                };
            default:
                console.error("Unknown variable type", o);
        }
    }
    s.defaultVariables = r;
    function i(o, a) {
        if (a.format === "HH:mm:ss") {
            let l = Math.floor(o / 3600), u = Math.floor((o - l * 3600) / 60), c = Math.round(o - l * 3600 - u * 60);
            return {
                textValue: [
                    l,
                    u,
                    c
                ]
            };
        } else if (a.format === "mm:ss") {
            let l = Math.floor(o / 60), u = Math.round(o - l * 60);
            return {
                textValue: [
                    l,
                    u
                ]
            };
        } else return a.format === "number" ? o = Math.round(o) : o = Math.round(o * 1e3) / 1e3, o;
    }
    s.getFormattedTimerTime = i;
})(yn || (yn = {}));
var Xd;
((t)=>t.list = [
        "idle",
        "move",
        "jump",
        "run"
    ])(Xd || (Xd = {}));
var Qd;
((e)=>(e.defaultColliderData = {
        type: "capsule",
        height: 200,
        radius: 50,
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ]
    }, e.defaultDataThirdPerson = {
        moveMode: "walk",
        forwardDirection: "+z",
        speedTranslate: 1e3,
        speedRotate: 100,
        runMultiplier: 2,
        rotationMode: "normal",
        rotBy: "keys",
        rotByTouch: "drag",
        delayPos: [
            .3,
            .3
        ],
        delayRot: [
            .3,
            .3
        ],
        keyAssignments: [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "\u25B2"
            ],
            [
                "rotPosY",
                "\u25C0"
            ],
            [
                "rotNegX",
                "\u25BC"
            ],
            [
                "rotNegY",
                "\u25B6"
            ],
            [
                "jump",
                "Space"
            ],
            [
                "run",
                "\u21E7"
            ],
            [
                "none",
                "Ctrl"
            ]
        ],
        touchControl: !0,
        joystickPosLoc: 5,
        joystickRotLoc: 11,
        jumpTouchButtonLoc: 9,
        collider: e.defaultColliderData,
        colliderHelperVisible: !0,
        collisionEnabled: !0,
        jumpPower: 100,
        resetYPosition: 3e3,
        alignToGround: !1,
        autoOrientMove: !0,
        orientWith: "camera",
        orientMode: "radial",
        delayPosCamera: .3,
        delayRotCamera: .3,
        camera: "",
        cameraXAxis: "Limit",
        cameraYAxis: "Free",
        cameraRotXLimits: [
            0,
            Math.PI / 2
        ],
        cameraRotYLimits: [
            -Math.PI / 2,
            Math.PI / 2
        ],
        gameActions: {
            idle: new Re,
            move: new Re,
            jump: new Re,
            run: new Re
        },
        navmesh: {
            enabled: !1,
            ch: 6,
            cs: 6,
            walkableClimb: 5,
            walkableHeight: 1,
            walkableRadius: 0,
            zones: "all",
            objects: [],
            helperVisible: !0,
            destinationHelperRadius: 0,
            destinationHelperColor: pt.fromHexAndA(3728051, 1)
        }
    }))(Qd || (Qd = {}));
function ID(n1) {
    n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colorA !== void 0) {
            let e = t.colorA, r = t.colorB, i = [
                [
                    e.r,
                    e.g,
                    e.b,
                    e.a
                ],
                [
                    r.r,
                    r.g,
                    r.b,
                    r.a
                ]
            ], s = [
                0,
                1
            ];
            for(let a = 2; a < 10; a++)i.push(i[1]), s.push(1);
            let o = {
                ...Qn(Cr(t), "type", "visible", "isVector", "isWorldSpace", "origin", "alpha", "mode"),
                near: Math.max(0, t.near),
                far: Math.max(0, t.far),
                colors: i,
                steps: s,
                num: 2,
                direction: [
                    1,
                    0,
                    0
                ],
                smooth: !1,
                gradientType: 1
            };
            Object.assign(t, o);
        } else if (t.type === "depth" && t.gradientType === 1 && (t.near < 0 || t.far < 0)) {
            let e = {
                ...Cr(t),
                near: Math.max(t.near, 0),
                far: Math.max(t.far, 0)
            };
            Object.assign(t, e);
        }
    });
}
function ba(n1, t) {
    Object.values(n1.shared.materials).forEach((e)=>t(e));
}
function Sa(n1, t) {
    n1.scene.objects.traverse((e, r)=>{
        "materials" in r ? r.materials.forEach((i, s)=>{
            i === void 0 && (r.materials[s] = Qr.defaultData(), i = r.materials[s]), typeof i != "string" && t(i);
        }) : "material" in r ? typeof r.material != "string" && (r.material === void 0 && (r.material = Qr.defaultData()), t(r.material)) : r.type === "Mesh" && (r.material === void 0 && (r.material = Qr.defaultData()), t(r.material)), "overrides" in r && Object.values(r.overrides).forEach((i)=>{
            i.material && typeof i.material != "string" && Object.getPrototypeOf(i.material) !== lr.prototype && t(i.material);
        });
    });
}
function gq(n1) {
    Object.assign(n1.scene.publish, {
        orbitControls: {
            ...Hd.defaultData,
            ...Cr(n1.scene.publish.orbitControls)
        }
    });
}
function yq(n1) {
    Object.assign(n1.scene.publish.settings, {
        video: {
            ...zs.defaultData.settings.video,
            ...Cr(n1.scene.publish.settings.video)
        }
    });
}
function vq(n1) {
    function t(e) {
        if (e.layers) {
            for (let r of Object.values(e.layers))if (r) {
                for (let [i, s] of Object.entries(r))if ((kv.includes(i) || typeof s == "boolean") && delete r[i], i === "texture") for (let [o, a] of Object.entries(s))(ED.includes(o) || typeof a == "boolean") && delete s[o];
            }
        }
    }
    n1.scene.objects.traverse((e, r)=>{
        r.states.forEach((i)=>{
            let s = i;
            s.material ? t(s.material) : s.materials && s.materials.forEach((o)=>{
                t(o);
            });
        });
    });
}
function xq(n1) {
    n1.scene.publish.withBackground = !0;
}
function bq(n1) {
    n1.scene.publish.settings.web = {
        compress: !0,
        preload: !0,
        preset: 1,
        logo: !0,
        hint: !1
    };
}
function Sq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.cloner;
        r && (r.radial.scale = r.radial.scale.map((i)=>i + 1), r.linear.scale = r.linear.scale.map((i)=>i + 1));
    });
}
function wq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && (r.type === "DodecahedronGeometry" || r.type === "IcosahedronGeometry") && (r.detail = Math.round(r.detail));
    });
}
function Aq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = n1.scene.objects.unproxy().parent(t);
        if (r) {
            let i = Cr(n1.scene.objects.data(r));
            i && i.type === "Mesh" && i.geometry.type === "BooleanGeometry" && e.type === "Mesh" && (e.visible = Cr(e).booleanExclude !== !0);
        }
    });
}
function _q(n1) {
    n1.scene.objects.traverse((t, e)=>{
        if (e.type === "Mesh") {
            let r = e;
            e.geometry.type === "NonParametricGeometry" ? r.material !== void 0 && delete r.material : r.materials !== void 0 && delete r.materials;
        }
    });
}
function Eq(n1) {
    function t(r) {
        Object.setPrototypeOf(r, lr.prototype), r.texture && Object.setPrototypeOf(r.texture, lr.prototype);
    }
    function e(r) {
        Object.setPrototypeOf(r, lr.prototype);
        for(let i in r)t(r[i]);
    }
    n1.scene.objects.traverse((r, i)=>{
        i.states.forEach((s)=>{
            let o = s;
            if (o.material) {
                let a = Cr(o.material).layers;
                e(a), o.material.layers = a;
            }
            if (o.materials) for(let a = 0; a < o.materials.length; a++){
                let l = o.materials[a], u = Cr(l).layers;
                e(u), l.layers = u;
            }
        });
    });
}
function RD(n1) {
    n1.layers === void 0 && Object.assign(n1, Qr.defaultTwoLayerData("lambert"));
}
function v1(n1) {
    !n1.layers || n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colors.length === 10) {
            let e = [
                ...t.colors
            ];
            e.push(t.colors[9]);
            let r = [
                ...t.steps
            ];
            r.push(t.steps[9]);
            let i = {
                ...Cr(t),
                colors: e,
                steps: r
            };
            Object.assign(t, i);
        }
    });
}
function Tq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && (e.geometry.type === "BooleanGeometry" || e.geometry.type === "SubdivGeometry") && (e.geometry.phongAngle = 35);
    });
}
function LD(n1) {
    n1.scene.objects.traverse((t, e)=>{
        "materials" in e ? e.materials.forEach((r)=>{
            typeof r != "string" && v1(r);
        }) : "material" in e && typeof e.material != "string" && v1(e.material);
    }), Object.values(n1.shared.materials).forEach((t)=>v1(t));
}
function Mq(n1) {
    n1.scene.environment.ambientLight.softShadows = !1, n1.scene.environment.ambientLight.softShadowQuality = "low", n1.scene.objects.traverse((t, e)=>{
        (e.type === "DirectionalLight" || e.type === "SpotLight") && (e.shadowResolution = 1024, e.shadowRadius = 1, e.depth = 1e5);
    }), n1.shared.penumbraSize = new Array(5).fill(.5);
}
function Cq(n1) {
    n1.shared.audios = pn({}, Ke.prototype);
}
function Pq(n1) {
    n1.shared.videos = pn({}, Ke.prototype);
}
function Dq(n1) {
    let t = n1.shared.materials;
    Object.entries(t).forEach(([e, r])=>{
        if (!r.layers) {
            let i = {
                name: "Untitled Material",
                layers: [
                    {
                        fi: 0,
                        data: {
                            type: "light",
                            category: "phong",
                            alpha: .6,
                            visible: !0,
                            mode: 0,
                            specular: {
                                r: .2,
                                g: .2,
                                b: .2
                            },
                            shininess: 5
                        },
                        id: "layer1"
                    },
                    {
                        fi: 1,
                        data: {
                            type: "color",
                            alpha: 1,
                            visible: !0,
                            mode: 0,
                            color: {
                                r: .2823529411764706,
                                g: .2823529411764706,
                                b: .30196078431372547
                            }
                        },
                        id: "layer2"
                    }
                ]
            };
            Object.assign(t, {
                [e]: i
            });
        }
    });
}
function Oq(n1) {
    Object.entries(Cr(n1.shared.images)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.images[r];
    }), Object.entries(Cr(n1.shared.audios)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.audios[r];
    });
}
function Iq(n1) {
    n1.scene.publish.settings.web.preload = !1;
}
function BD(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "depth" && t.num !== void 0 && (t.colors = t.colors.slice(0, t.num), t.steps = t.steps.slice(0, t.num), delete t.num);
    });
}
function ND(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        _D(t) && t.isMask === void 0 && (t.isMask = !1), (t.type === "texture" || t.type === "video") && t.blending === void 0 && (t.blending = 0), (t.type === "noise" || t.type === "displace" && t.displacementType === "noise") && (t.voronoiStyle === void 0 && (t.voronoiStyle = 0), t.highCut === void 0 && (t.highCut = 1), t.lowCut === void 0 && (t.lowCut = 0), t.smoothness === void 0 && (t.smoothness = .3), t.seed === void 0 && (t.seed = 0), t.quality === void 0 && (t.quality = 1));
    });
}
function Rq(n1) {
    n1.shared.fonts = pn({}, Ke.prototype);
}
function Lq(n1) {
    return n1.replace(".typeface", "").replace(/optimer/gi, "open sans").replace("space_mono", "space mono").replace(/alma_mono/gi, "varela round").replace(/droid_sans_mono/gi, "noto sans mono").replace(/droid_sans|gentilis|gnomon_(simple|foreground)|helvetiker/gi, "roboto").replace(/droid_serif/gi, "roboto slab").replace("_sans", " sans").replace("crimson_text", "crimson text").replace("medium_medium", "medium").replace("fatface_fatface", "fatface").replace("100hairline", "thin").replace("200thin", "extralight").replace("300light", "light").replace("500medium", "medium").replace("600semi", "semibold").replace("800heavy", "extrabold").replace("900black", "black").replace(/bodoni_(11|16|24|36|48|72|96)([^_])/gi, "bodoni_$1_$2").replace(/bodoni_(11|16|24|36|48|72|96)/gi, "bodoni moda").replace(/(thin|hairline)(_regular)?/gi, "100").replace(/(extra|ultra)light(_regular)?/gi, "200").replace(/light(_regular)?/gi, "300").replace(/_book|_normal|_roman/gi, "_regular").replace(/medium(_regular)?/gi, "500").replace(/(semi|demi)bold(_regular)?/gi, "600").replace(/(extra|ultra)bold(_regular)?/gi, "800").replace(/bold(_regular)?/gi, "700").replace(/(black|heavy|fatface)(_regular)?/gi, "900").replace(/([1-9]00)_italic/gi, "$1italic").replace(/regularitalic/gi, "italic").replace(/regularitalic/gi, "italic").split(" ").map((e)=>e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function Bq(n1) {
    let t = [];
    n1.scene.objects.traverse((e, r)=>{
        let i = r;
        if (i.type === "TextFrame") {
            let s = Qr.defaultTwoLayerData("phong"), o = typeof i.color == "string" ? n1.shared.colors[i.color] : i.color;
            s.layers[1].data.color = {
                r: o.r,
                g: o.g,
                b: o.b
            }, s.layers[1].data.alpha = i.alpha;
            let a = Lq(i.font);
            n1.shared.fonts[a] === void 0 && (n1.shared.fonts[a] = {
                name: a
            });
            let l = {
                name: i.name,
                ...wi.defaultData,
                ...Pc.defaultData,
                flatShading: !1,
                wireframe: !1,
                geometry: {
                    ...Sl.defaultData("TextGeometry"),
                    width: i.width,
                    height: i.height,
                    font: a,
                    depth: 0,
                    horizontalAlign: i.horizontalAlign,
                    verticalAlign: i.verticalAlign,
                    fontSize: i.fontSize * 1.40625,
                    lineHeight: i.lineHeight / 1.40625,
                    letterSpacing: i.letterSpacing - 1,
                    text: i.text,
                    textTransform: i.textTransform,
                    extrudeBevelSize: 0,
                    extrudeBevelSegments: 1
                },
                material: s,
                states: Cr(i.states),
                events: Cr(i.events),
                visible: i.visible,
                raycastLock: i.raycastLock,
                position: i.position,
                rotation: i.rotation,
                scale: i.scale,
                hiddenMatrix: i.hiddenMatrix
            }, u = Cr(n1.scene.objects).parent(e);
            n1.scene.objects.insertAfter(u ?? null, e, [
                {
                    id: e + "new",
                    data: l,
                    children: []
                }
            ]), t.push(e);
        }
    }), t.forEach((e)=>{
        n1.scene.objects.delete(e);
    });
}
function Nq(n1) {
    let t = {
        0: "MouseDown",
        1: "MouseUp",
        2: "MouseHover",
        5: "KeyDown",
        6: "KeyUp",
        7: "Start",
        9: "LookAt",
        10: "Follow",
        11: "Scroll",
        12: "Audio",
        13: "GameControl"
    };
    n1.scene.objects.traverse((e, r)=>{
        r.events.forEach((i)=>{
            if (!!t[Number(i.type)]) {
                if (Object.assign(i, {
                    type: t[Number(i.type)]
                }), i.type === "Audio" && "audioEvent" in i && (Object.assign(i, {
                    playAudio: i.audioEvent
                }), delete i.audioEvent), i.type === "GameControl") Object.assign(i, {
                    gameActions: {
                        idle: new Re,
                        move: new Re,
                        jump: new Re
                    }
                });
                else {
                    let s = new Re;
                    Object.assign(i, {
                        actions: s
                    }), (i.type === "MouseDown" || i.type === "MouseUp" || i.type === "KeyDown" || i.type === "KeyUp") && "url" in i && s.push({
                        fi: 0,
                        id: Se.generateUUID(),
                        data: {
                            type: "Link",
                            url: i.url,
                            delay: 0
                        }
                    }), "targets" in i && (i.targets.forEach((o, a, l)=>{
                        let u = {
                            state: void 0,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            duration: 0,
                            easing: 4
                        }, c = {
                            easing: o.easing,
                            duration: o.duration
                        };
                        o.easing === 6 ? Object.assign(c, Qn(o, "mass", "stiffness", "damping", "velocity")) : o.easing === 5 && Object.assign(c, {
                            control1: {
                                ...o.control1
                            },
                            control2: {
                                ...o.control2
                            }
                        });
                        let d = {
                            repeat: o.repeat ? -1 : 0,
                            delay: o.delay,
                            delayDirection: o.delayDirection,
                            direction: o.cycle && o.rewind ? "pingpong-rewind" : o.cycle ? "pingpong" : "normal"
                        }, h = {
                            state: o.state,
                            ...d,
                            ...c
                        }, f = {
                            allowSlerp: !0,
                            type: "Transition",
                            object: o.object,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            tweens: new Re({
                                fi: 0,
                                id: Se.generateUUID(),
                                data: u
                            }, {
                                fi: 1,
                                id: Se.generateUUID(),
                                data: h
                            })
                        };
                        s.push({
                            fi: l,
                            id: a,
                            data: f
                        });
                    }), delete i.targets);
                }
            }
        });
    });
}
function Fq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        function r(i, s) {
            let o = new Re, a = [];
            if (e.events.forEach((l, u, c)=>{
                if (l.type === "Audio" && l.trigger === s) {
                    let d;
                    a.push(u), l.interaction === "play" ? d = {
                        ...Qn(l, "interaction", "audio", "delay", "volume", "loop"),
                        triggerAfter: "after" in l ? l.after : void 0,
                        toggle: "after" in l ? l.toggle : void 0,
                        type: "Audio"
                    } : (l.interaction === "pause" || l.interaction === "stop") && (d = {
                        ...Qn(l, "interaction", "delay", "object", "playAudio"),
                        type: "Audio"
                    }), d && o.push({
                        fi: c,
                        id: u,
                        data: d
                    });
                }
            }), a.forEach((l)=>e.events.delete(l)), o.length) {
                let l = e.events.find((u)=>u.type === i)?.data;
                l ? "actions" in l && l.actions.insertBefore(null, o) : e.events.insertBefore(null, [
                    {
                        id: Se.generateUUID(),
                        data: {
                            type: i,
                            actions: o
                        }
                    }
                ]);
            }
        }
        r("Start", "start"), r("MouseDown", "mouseDown"), r("MouseUp", "mouseUp"), r("KeyDown", "keyDown"), r("KeyUp", "keyUp");
    });
}
function FD(n1) {
    let t = n1.layers.find((e)=>e.type === "light")?.data;
    if (t?.category === "basic") {
        let e = Ir.defaultData("light", "phong"), r = t;
        Object.assign(r, e), r.visible = !1;
    }
}
function kD(n1) {
    ba(n1, FD), Sa(n1, FD);
}
function kq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "SubdivGeometry" && (e.geometry.scaleBaked || (e.geometry.scaleBaked = [
            1,
            1,
            1
        ]));
    });
}
function zq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        (e.type === "Empty" || e.type === "Mesh") && e.cloner && !e.cloner.randomnessObject && !e.cloner.toObject && !e.cloner.randomness && (e.cloner = {
            ...e.cloner,
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        });
    });
}
function Vq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "NonParametricGeometry" && !("material" in e) && !("materials" in e) && (e.material = Qr.defaultTwoLayerData("phong"));
    });
}
function Uq(n1) {
    n1.scene.publish.orbitControls.autoZoom === void 0 && (n1.scene.publish.orbitControls.autoZoom = !1), n1.scene.objects.traverse((t, e)=>{
        (e.type === "OrthographicCamera" || e.type === "PerspectiveCamera") && (e.orthographic.autoZoom === void 0 && (e.orthographic.autoZoom = !1), e.orthographic.autoZoomFrustumSize === void 0 && (e.orthographic.autoZoomFrustumSize = 790));
    });
}
function Gq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.pathSnapping === void 0 && (e.pathSnapping = {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        }), e.pathSnapping.offset === void 0 && (e.pathSnapping.offset = 0);
    });
}
function jq(n1) {
    n1.scene.publish.mouseEventTarget === void 0 && (n1.scene.publish.mouseEventTarget = "canvas"), n1.scene.publish.settings.web.hint === void 0 && (n1.scene.publish.settings.web.hint = !1);
}
function Hq(n1) {
    let { video: t } = n1.scene.publish.settings;
    t.format === "gif" && t.fps > 48 && (t.fps = 15);
}
function Wq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.resetYPosition = Math.abs(r.resetYPosition - e.position[1]));
        });
    });
}
function qq(n1) {
    let t = n1.scene.environment.usePhysics;
    n1.scene.objects.traverse((e, r)=>{
        t && r.physics === null ? r.collision = !1 : r.collision = "visibility";
    });
}
function Yq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.navmesh = Qd.defaultDataThirdPerson.navmesh);
        });
    });
}
function Xq(n1) {
    n1.scene.styles || (n1.scene.styles = ya.defaultData());
}
function zD(n1) {
    n1.layers.forEach((t)=>{
        t.type === "light" && t.category !== "toon" && t.occlusion === void 0 && (t.occlusion = !0);
    });
}
function Qq(n1) {
    n1.scene.environment.ambientLight.occlusion === void 0 && (n1.scene.environment.ambientLight.occlusion = !1), n1.scene.environment.ambientLight.aoFullRes === void 0 && (n1.scene.environment.ambientLight.aoFullRes = !1), n1.scene.environment.ambientLight.radius === void 0 && (n1.scene.environment.ambientLight.radius = 256), n1.scene.environment.ambientLight.bias === void 0 && (n1.scene.environment.ambientLight.bias = .5), n1.scene.environment.ambientLight.aoColor === void 0 && (n1.scene.environment.ambientLight.aoColor = {
        r: .19607843137254902,
        g: .19607843137254902,
        b: .19607843137254902
    }), Sa(n1, zD), ba(n1, zD);
}
function Kq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && Object.assign(r.gameActions, {
                run: new Re
            });
        });
    });
}
function Zq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.keyAssignments = [
                ...r.keyAssignments,
                [
                    "run",
                    "\u21E7"
                ],
                [
                    "none",
                    "Ctrl"
                ]
            ]);
        });
    });
}
function VD(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.bumpMapIntensity === void 0 && (t.bumpMapIntensity = 5);
    });
}
function UD(n1, t) {
    if (t < 1 && (Sa(n1, ID), ba(n1, ID), n1.schema = 1), t < 2 && (gq(n1), n1.schema = 2), t < 3 && (vq(n1), n1.schema = 3), t < 4 && (xq(n1), n1.schema = 4), t < 5 && (bq(n1), n1.schema = 5), t < 6 && (Sq(n1), n1.schema = 6), t < 7 && (wq(n1), n1.schema = 7), t < 8 && (n1.schema = 8), t < 9 && (LD(n1), n1.schema = 9), t < 10 && (Tq(n1), n1.schema = 10), t < 11 && (Mq(n1), n1.schema = 11), t < 12 && (LD(n1), n1.schema = 12), t < 13 && (Cq(n1), n1.schema = 13), t < 14 && (Dq(n1), n1.schema = 14), t < 15 && (Oq(n1), n1.schema = 15), t < 16 && (Iq(n1), n1.schema = 16), t < 17 && (Sa(n1, BD), ba(n1, BD), n1.schema = 17), t < 18 && (Sa(n1, RD), ba(n1, RD), n1.schema = 18), t < 19 && (yq(n1), n1.schema = 19), t < 20 && (Rq(n1), Bq(n1), n1.schema = 20), t < 21 && (Nq(n1), Fq(n1), n1.schema = 21), t < 22 && (kD(n1), n1.schema = 22), t < 23 && (kq(n1), n1.schema = 23), t < 24 && (zq(n1), n1.schema = 24), (t < 25 || n1.shared.videos === void 0) && (Pq(n1), t < 25 && (n1.schema = 25)), t < 26 && (Aq(n1), n1.schema = 26), t < 27 && (_q(n1), n1.schema = 27), t < 28 && (kD(n1), n1.schema = 28), t < 29 && (Eq(n1), n1.schema = 29), t < 30 && (Vq(n1), n1.schema = 30), t < 31 && (Uq(n1), n1.schema = 31), t < 33 && (Gq(n1), n1.schema = 33), t < 34 && (jq(n1), n1.schema = 34), t < 35 && (Hq(n1), n1.schema = 35), t < 36 && (Wq(n1), n1.schema = 36), t < 37 && (qq(n1), n1.schema = 37), t < 38 && (Sa(n1, ND), ba(n1, ND), n1.schema = 38), t < 39 && (Yq(n1), n1.schema = 39), t < 40 && (Xq(n1), n1.schema = 40), t < 41 && (Qq(n1), n1.schema = 41), t < 42 && (Kq(n1), n1.schema = 42), t < 43 && (Zq(n1), n1.schema = 43), t < 99) {
        Sa(n1, VD), ba(n1, VD), n1.scene.publish.playCamera === null && (n1.scene.publish.playCamera = us);
        let e = Cr(n1.scene.objects), r = n1.scene.objects;
        n1.scene.publish.playPage = vl, r.insertBefore(null, null, [
            {
                id: vl,
                data: {
                    ...ma.defaultData,
                    backgroundColor: n1.scene.backgroundColor,
                    fog: n1.scene.fog,
                    postprocessing: n1.scene.postprocessing,
                    ao: Qn(n1.scene.environment.ambientLight, "occlusion", "aoFullRes", "radius", "bias", "aoColor"),
                    publish: {
                        playCamera: n1.scene.publish.playCamera,
                        gameControlObject: n1.scene.publish.gameControlObject
                    },
                    shadow: Qn(n1.scene.environment.ambientLight, "softShadowQuality"),
                    globalPhysics: {
                        ...wl.defaultData,
                        ...Qn(n1.scene.environment, "usePhysics", "gravity")
                    },
                    camera: Cr(n1.scene.ownerCamera) ?? ma.defaultData.camera,
                    name: "Scene"
                },
                children: []
            }
        ]);
        for (let o of e)o.id !== va.TRASH_CAN_ID && r.move(vl, o.fi, o.id);
        let i = 0, s = 0;
        n1.shared.penumbraSize && n1.scene.objects.traverse((o, a)=>{
            a.type === "DirectionalLight" ? (a.penumbraSize = n1.shared.penumbraSize[Math.min(i, 2)], i += 1) : a.type === "SpotLight" && (a.penumbraSize = n1.shared.penumbraSize[3 + Math.min(s, 1)], s += 1), (a.physics === void 0 || a.physics === null) && a.type !== "Instance" && (a.physics = {}, Object.assign(a.physics, bl.defaultData)), a.physics !== void 0 && a.physics !== null && (a.physics.enabled = a.collision ?? "visibility", delete a.collision);
        }), n1.schema = 99;
    }
}
function GD(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.alphaOverride === void 0 && (t.alphaOverride = 1);
    });
}
function Jq(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && r.type === "PathGeometry" && (r.extrusion.capType = "flat", r.extrusion.bevel = 50, r.extrusion.bevelSides = 6, r.extrusion.shape.type === "Custom" && (r.extrusion.shape.shapeQuality = "low"));
    });
}
function $q(n1) {
    Array.isArray(Cr(n1.events)) && n1.events?.forEach((t)=>{
        "disabled" in t || (t.disabled = !1), (t.type === "MouseDown" || t.type === "MouseUp" || t.type === "MousePress") && (t.mode = t.mode || "Object");
    });
}
var Kd = 180 / Math.PI;
function jD(n1) {
    n1.rotation = n1.rotation.slice(0, 3).map((t)=>t * Kd);
}
function HD(n1) {
    jD(n1), n1.type === "Page" && jD(n1.camera), n1.states?.forEach((e)=>{
        e.rotation === void 0 || e.rotation === null || (e.rotation = e.rotation.slice(0, 3).map((r)=>r * Kd));
    });
    let t = n1.geometry;
    t && t.type === "SphereGeometry" && (t.thetaLength = (t.thetaLength ?? 180) * Kd), t && t.type === "TorusGeometry" && (t.arc = t.arc * Kd), t && t.type === "PathGeometry" && (t.extrusion.angle *= Kd, t.extrusion.twist *= Kd), n1.type === "Mesh" && n1.geometry.type === "TextGeometry" && (n1.geometry.text = {
        textValue: n1.geometry.text
    }), Array.isArray(Cr(n1.events)) && n1.events?.forEach((e)=>{
        (e.type === "MouseDown" || e.type === "MouseUp" || e.type === "MousePress" || e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress" || e.type === "Collision" || e.type === "Trigger") && (e.runMode = e.toggle ? "Toggle" : "Repeat");
    });
}
function e9(n1) {
    n1.shared.variables = pn({}, Ke.prototype);
}
function t9(n1) {
    let t = Cr(n1.shared.variables);
    n1.shared.variables = pn(Object.entries(t ?? {}).map(([e, r], i)=>({
            fi: i,
            id: e,
            data: r
        })), Re.prototype);
}
var Ao = 111;
function WD(n1, t) {
    t(n1.data);
    for (let e of n1.children)WD(e, t);
}
function r9(n1) {
    let t = n1.schema ?? 104;
    t !== Ao && t < 105 && (WD(n1.asset, HD), n1.schema = 105);
}
function i9(n1) {
    n1.shared.particles = pn({}, Ke.prototype), n1.shared.lib && (n1.shared.lib.particles = xa.defaultData().particles);
}
function n9(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Particle" && typeof e.renderMaterial.size == "number" && Object.assign(e.renderMaterial, {
            size: [
                e.renderMaterial.size,
                e.renderMaterial.size
            ]
        });
    });
}
function Xv(n1) {
    let t = n1.schema ?? 0;
    if (t !== Ao) {
        console.warn("updating from ", t, "to ", Ao), UD(n1, t), t < 100 && (n1.scene.publish.joystickSizeAndXYOffset === void 0 && (n1.scene.publish.joystickSizeAndXYOffset = zs.defaultData.joystickSizeAndXYOffset), n1.schema = 100), t < 101 && (Sa(n1, GD), ba(n1, GD), n1.schema = 101), t < 102 && (Jq(n1), n1.schema = 102), t < 104 && (n1.shared.catelogs = new Ke, n1.shared.lib = xa.defaultData(), n1.schema = 104), t < 105 && (e9(n1), n1.scene.objects.traverse((e, r)=>{
            HD(r);
        }), n1.schema = 105);
        for (let e of Object.values(n1.shared.lib.components))r9(e);
        t < 106 && (t9(n1), n1.schema = 106), t < 107 && (n1.shared.lib.variables = xa.defaultData().variables, n1.schema = 107), t < 109 && (i9(n1), n1.schema = 109), t < 110 && (n9(n1), n1.schema = 110), t < 111 && (n1.scene.objects.traverse((e, r)=>{
            $q(r);
        }), n1.schema = 111);
    }
}
var Wd;
((l)=>{
    l.defaultData = {
        schema: Ao,
        scene: va.defaultData,
        frames: new Ke().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", qd.defaultData),
        shared: {
            ...yn.emptyData(),
            colors: yn.defaultColors()
        }
    }, l.emptyDataForImports = function(u) {
        let c = va.emptyDataWithPage(u);
        return {
            schema: Ao,
            scene: c,
            frames: new Ke().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", qd.defaultData),
            shared: {
                ...yn.emptyData(),
                colors: yn.defaultColors(),
                images: yn.defaultImages(u)
            }
        };
    }, l.emptyData = function() {
        return {
            schema: Ao,
            scene: va.emptyDataWithPage(),
            frames: new Ke().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", qd.defaultData),
            shared: yn.emptyData()
        };
    }, l.clipboard2dData = function() {
        return {
            schema: Ao,
            scene: va.emptyData(),
            frames: new Ke,
            shared: yn.emptyData()
        };
    }, l.collabHelper = {
        ...zp,
        updateSchema (u) {
            return (u.schema ?? 0) < Ao ? fl(u, Xv) : (u.schema ?? 0) - Ao;
        }
    };
    function s(u) {
        let c = l.collabHelper.updateSchema(u);
        return typeof c == "number" ? c === 0 ? u : null : c.data;
    }
    l.updateSchemaDirectly = s;
    function o(u) {
        return {
            ...u,
            shared: {
                ...u.shared,
                lib: xa.defaultData()
            }
        };
    }
    l.withoutLib = o;
    function a(u, c) {
        let d = u.scene.objects.get(c);
        if (d && d.data.type === "Component") return d;
        {
            let h = u.shared.lib.components[c];
            if (h) return h.asset;
        }
    }
    l.getComponentData = a;
})(Wd || (Wd = {}));
var qD;
((t)=>{
    function n1(e) {
        return !0;
    }
    t.is = n1;
})(qD || (qD = {}));
var Qv;
((r)=>{
    r.defaultData = {
        position: [
            0,
            0
        ],
        scale: [
            1,
            1
        ],
        rotation: 0
    };
    function t(i, s) {
        return {
            position: s?.position ?? i.position,
            rotation: s?.rotation ?? i.rotation,
            scale: s?.scale ?? i.scale
        };
    }
    r.merge = t;
    function e(i, s) {
        return rv({
            position: xo.isEqual(i.position, s.position) ? void 0 : s.position,
            rotation: i.rotation === s.rotation ? void 0 : s.rotation,
            scale: xo.isEqual(i.scale, s.scale) ? void 0 : s.scale
        });
    }
    r.diff = e;
})(Qv || (Qv = {}));
var x1;
((t)=>t.defaultData = {
        horizontalConstraint: 0,
        verticalConstraint: 0
    })(x1 || (x1 = {}));
var Kv;
((t)=>t.defaultData = {
        opacity: 1,
        fill: {
            color: pt.white,
            enabled: !0
        },
        stroke: {
            color: pt.from0to1([
                0,
                0,
                0,
                1
            ]),
            thickness: 1,
            enabled: !1,
            mode: "inside"
        },
        layerBlur: {
            radius: 2,
            enabled: !1
        },
        backgroundBlur: {
            radius: 2,
            enabled: !1
        },
        dropShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: pt.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        },
        innerShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: pt.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        }
    })(Kv || (Kv = {}));
var wa;
((s)=>{
    function n1(o, a) {
        return {
            name: a
        };
    }
    s.newEmpty = n1;
    function t(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        }, u = [
            "width",
            "height",
            "cornerRadius"
        ];
        for (let c of u)c in l && c in a && a[c] !== void 0 && Object.assign(l, {
            [c]: a[c]
        });
        return l;
    }
    function e(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return "fill" in l && "fill" in a && a.fill !== void 0 && Object.assign(l, {
            fill: {
                ...l.fill,
                ...a.fill
            }
        }), "stroke" in l && "stroke" in a && a.stroke !== void 0 && Object.assign(l, {
            stroke: {
                ...l.stroke,
                ...a.stroke
            }
        }), "layerBlur" in l && "layerBlur" in a && a.layerBlur !== void 0 && Object.assign(l, {
            layerBlur: {
                ...l.layerBlur,
                ...a.layerBlur
            }
        }), "backgroundBlur" in l && "backgroundBlur" in a && a.backgroundBlur !== void 0 && Object.assign(l, {
            backgroundBlur: {
                ...l.backgroundBlur,
                ...a.backgroundBlur
            }
        }), "dropShadow" in l && "dropShadow" in a && a.dropShadow !== void 0 && Object.assign(l, {
            dropShadow: {
                ...l.dropShadow,
                ...a.dropShadow
            }
        }), "innerShadow" in l && "innerShadow" in a && a.innerShadow !== void 0 && Object.assign(l, {
            innerShadow: {
                ...l.innerShadow,
                ...a.innerShadow
            }
        }), l;
    }
    function r(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return Object.assign(l, Qv.merge(l, a)), l = t(l, a), l = e(l, a), l;
    }
    s.patch = r;
    function i(o, a) {
        let l, u = [];
        for (let [c, d] of Object.entries(a))c !== "name" && (l === void 0 && (l = {
            path: [],
            props: {},
            type: 0
        }, u.push(l)), l.props[c] = d);
        return u;
    }
    s.toOps = i;
})(wa || (wa = {}));
var qp;
((t)=>t.defaultData = {
        ...Qv.defaultData,
        ...x1.defaultData,
        states: new Re,
        events: new Re,
        visible: !0,
        raycastLock: !1
    })(qp || (qp = {}));
var Yp;
((t)=>t.defaultData = {
        ...qp.defaultData,
        ...Kv.defaultData
    })(Yp || (Yp = {}));
var Zv;
((t)=>t.defaultData = {
        cornerRadius: [
            0,
            0,
            0,
            0
        ]
    })(Zv || (Zv = {}));
var b1;
((t)=>t.defaultData = {
        ...Yp.defaultData,
        type: "ellipse2d",
        width: 100,
        height: 100,
        name: "Ellipse"
    })(b1 || (b1 = {}));
var Zd;
((t)=>t.defaultData = {
        ...Yp.defaultData,
        ...Zv.defaultData,
        type: "rectangle2d",
        width: 100,
        height: 100,
        name: "Rectangle"
    })(Zd || (Zd = {}));
var S1;
((t)=>t.defaultData = {
        ...Yp.defaultData,
        type: "text2d",
        width: 100,
        height: 100,
        fontSize: 12,
        lineHeight: 1.2,
        letterSpacing: 0,
        text: {
            textValue: "Hello world"
        },
        horizontalAlign: 1,
        verticalAlign: 1,
        textTransform: 1,
        font: "Roboto_regular",
        name: "Text"
    })(S1 || (S1 = {}));
var YD;
((t)=>{
    function n1(e) {
        return e.type === "ellipse2d" || e.type === "rectangle2d" || e.type === "text2d" || e.type === "vector2d";
    }
    t.is = n1;
})(YD || (YD = {}));
var Xp;
((t)=>t.defaultData = {
        ...qp.defaultData,
        name: "Group",
        type: "group2d"
    })(Xp || (Xp = {}));
var w1;
((t)=>t.defaultData = {
        ...qp.defaultData,
        ...Zv.defaultData,
        ...Kv.defaultData,
        name: "Frame",
        type: "frame2d",
        width: 200,
        height: 200,
        fill: {
            color: pt.fromHexAndA(Xr, 1),
            enabled: !0
        },
        stroke: {
            color: pt.fromHexAndA(0, 1),
            thickness: 1,
            enabled: !1,
            mode: "inside"
        },
        backgroundBlur: {
            radius: 2,
            enabled: !1
        },
        layerBlur: {
            radius: 2,
            enabled: !1
        }
    })(w1 || (w1 = {}));
var Aa;
((i)=>{
    function n1(s) {
        switch(s){
            case "rectangle2d":
                return {
                    ...Zd.defaultData
                };
            case "ellipse2d":
                return {
                    ...b1.defaultData
                };
            case "text2d":
                return {
                    ...S1.defaultData
                };
            case "vector2d":
                return {
                    ...Zd.defaultData
                };
            case "frame2d":
                return {
                    ...w1.defaultData
                };
            case "group2d":
                return {
                    ...Xp.defaultData
                };
        }
    }
    i.defaultData = n1;
    function t(s) {
        return "width" in s && "height" in s ? [
            typeof s.width == "number" ? s.width * .5 : 0,
            typeof s.height == "number" ? s.height * .5 : 0
        ] : [
            0,
            0
        ];
    }
    i.getPivot = t;
    function e(s) {
        return s.type === "rectangle2d" || s.type === "ellipse2d" || s.type === "text2d" || s.type === "frame2d";
    }
    i.isResizeable = e;
    function r(s) {
        return s.type === "rectangle2d" || s.type === "frame2d";
    }
    i.hasCorners = r;
})(Aa || (Aa = {}));
var Jv;
((e)=>(e.defaultData = {
        name: "UI",
        type: "scene2d",
        objects: new ar
    }, e.emptyData = function() {
        return {
            type: "scene2d",
            objects: new ar
        };
    }))(Jv || (Jv = {}));
function Vs(n1, t = !1) {
    let e = n1[0].index !== null, r = new Set(Object.keys(n1[0].attributes)), i = new Set(Object.keys(n1[0].morphAttributes)), s = {}, o = {}, a = n1[0].morphTargetsRelative, l = new we, u = 0;
    for(let c = 0; c < n1.length; ++c){
        let d = n1[c], h = 0;
        if (e !== (d.index !== null)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
        for(let f in d.attributes){
            if (!r.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + '. All geometries must have compatible attributes; make sure "' + f + '" attribute exists among all geometries, or in none of them.'), null;
            s[f] === void 0 && (s[f] = []), s[f].push(d.attributes[f]), h++;
        }
        if (h !== r.size) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". Make sure all geometries have the same number of attributes."), null;
        if (a !== d.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
        for(let f in d.morphAttributes){
            if (!i.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ".  .morphAttributes must be consistent throughout all geometries."), null;
            o[f] === void 0 && (o[f] = []), o[f].push(d.morphAttributes[f]);
        }
        if (t) {
            let f;
            if (e) f = d.index.count;
            else if (d.attributes.position !== void 0) f = d.attributes.position.count;
            else return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". The geometry must have either an index or a position attribute"), null;
            l.addGroup(u, f, c), u += f;
        }
    }
    if (e) {
        let c = 0, d = [];
        for(let h = 0; h < n1.length; ++h){
            let f = n1[h].index;
            for(let p = 0; p < f.count; ++p)d.push(f.getX(p) + c);
            c += n1[h].attributes.position.count;
        }
        l.setIndex(d);
    }
    for(let c in s){
        let d = XD(s[c]);
        if (!d) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + c + " attribute."), null;
        l.setAttribute(c, d);
    }
    for(let c in o){
        let d = o[c][0].length;
        if (d === 0) break;
        l.morphAttributes = l.morphAttributes || {}, l.morphAttributes[c] = [];
        for(let h = 0; h < d; ++h){
            let f = [];
            for(let m = 0; m < o[c].length; ++m)f.push(o[c][m][h]);
            let p = XD(f);
            if (!p) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + c + " morphAttribute."), null;
            l.morphAttributes[c].push(p);
        }
    }
    return l;
}
function XD(n1) {
    let t, e, r, i = 0;
    for(let a = 0; a < n1.length; ++a){
        let l = n1[a];
        if (l.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported."), null;
        if (t === void 0 && (t = l.array.constructor), t !== l.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
        if (e === void 0 && (e = l.itemSize), e !== l.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
        if (r === void 0 && (r = l.normalized), r !== l.normalized) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
        i += l.array.length;
    }
    let s = new t(i), o = 0;
    for(let a = 0; a < n1.length; ++a)s.set(n1[a].array, o), o += n1[a].array.length;
    return new Ge(s, e, r);
}
var QD = Math.pow(2, -24);
var Oc = class {
    constructor(){}
};
function hs(n1, t, e) {
    return e.min.x = t[n1], e.min.y = t[n1 + 1], e.min.z = t[n1 + 2], e.max.x = t[n1 + 3], e.max.y = t[n1 + 4], e.max.z = t[n1 + 5], e;
}
function A1(n1) {
    let t = -1, e = -1 / 0;
    for(let r = 0; r < 3; r++){
        let i = n1[r + 3] - n1[r];
        i > e && (e = i, t = r);
    }
    return t;
}
function _1(n1, t) {
    t.set(n1);
}
function E1(n1, t, e) {
    let r, i;
    for(let s = 0; s < 3; s++){
        let o = s + 3;
        r = n1[s], i = t[s], e[s] = r < i ? r : i, r = n1[o], i = t[o], e[o] = r > i ? r : i;
    }
}
function Qp(n1, t, e) {
    for(let r = 0; r < 3; r++){
        let i = t[n1 + 2 * r], s = t[n1 + 2 * r + 1], o = i - s, a = i + s;
        o < e[r] && (e[r] = o), a > e[r + 3] && (e[r + 3] = a);
    }
}
function Jd(n1) {
    let t = n1[3] - n1[0], e = n1[4] - n1[1], r = n1[5] - n1[2];
    return 2 * (t * e + e * r + r * t);
}
function a9(n1, t) {
    if (!n1.index) {
        let e = n1.attributes.position.count, r = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, i;
        e > 65535 ? i = new Uint32Array(new r(4 * e)) : i = new Uint16Array(new r(2 * e)), n1.setIndex(new Ge(i, 1));
        for(let s = 0; s < e; s++)i[s] = s;
    }
}
function l9(n1) {
    if (!n1.groups || !n1.groups.length) return [
        {
            offset: 0,
            count: n1.index.count / 3
        }
    ];
    let t = [], e = new Set;
    for (let i of n1.groups)e.add(i.start), e.add(i.start + i.count);
    let r = Array.from(e.values()).sort((i, s)=>i - s);
    for(let i = 0; i < r.length - 1; i++){
        let s = r[i], o = r[i + 1];
        t.push({
            offset: s / 3,
            count: (o - s) / 3
        });
    }
    return t;
}
function M1(n1, t, e, r, i = null) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, u = -1 / 0, c = -1 / 0, d = 1 / 0, h = 1 / 0, f = 1 / 0, p = -1 / 0, m = -1 / 0, g = -1 / 0, y = i !== null;
    for(let v = t * 6, x = (t + e) * 6; v < x; v += 6){
        let S = n1[v + 0], w = n1[v + 1], A = S - w, E = S + w;
        A < s && (s = A), E > l && (l = E), y && S < d && (d = S), y && S > p && (p = S);
        let b = n1[v + 2], T = n1[v + 3], M = b - T, C = b + T;
        M < o && (o = M), C > u && (u = C), y && b < h && (h = b), y && b > m && (m = b);
        let P = n1[v + 4], D = n1[v + 5], O = P - D, I = P + D;
        O < a && (a = O), I > c && (c = I), y && P < f && (f = P), y && P > g && (g = P);
    }
    r[0] = s, r[1] = o, r[2] = a, r[3] = l, r[4] = u, r[5] = c, y && (i[0] = d, i[1] = h, i[2] = f, i[3] = p, i[4] = m, i[5] = g);
}
function c9(n1, t, e, r) {
    let i = 1 / 0, s = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0, u = -1 / 0;
    for(let c = t * 6, d = (t + e) * 6; c < d; c += 6){
        let h = n1[c + 0];
        h < i && (i = h), h > a && (a = h);
        let f = n1[c + 2];
        f < s && (s = f), f > l && (l = f);
        let p = n1[c + 4];
        p < o && (o = p), p > u && (u = p);
    }
    r[0] = i, r[1] = s, r[2] = o, r[3] = a, r[4] = l, r[5] = u;
}
function u9(n1, t, e, r, i) {
    let s = e, o = e + r - 1, a = i.pos, l = i.axis * 2;
    for(;;){
        for(; s <= o && t[s * 6 + l] < a;)s++;
        for(; s <= o && t[o * 6 + l] >= a;)o--;
        if (s < o) {
            for(let u = 0; u < 3; u++){
                let c = n1[s * 3 + u];
                n1[s * 3 + u] = n1[o * 3 + u], n1[o * 3 + u] = c;
                let d = t[s * 6 + u * 2 + 0];
                t[s * 6 + u * 2 + 0] = t[o * 6 + u * 2 + 0], t[o * 6 + u * 2 + 0] = d;
                let h = t[s * 6 + u * 2 + 1];
                t[s * 6 + u * 2 + 1] = t[o * 6 + u * 2 + 1], t[o * 6 + u * 2 + 1] = h;
            }
            s++, o--;
        } else return s;
    }
}
var _a = 32, d9 = (n1, t)=>n1.candidate - t.candidate, _l = new Array(_a).fill().map(()=>({
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    })), $v = new Float32Array(6);
function h9(n1, t, e, r, i, s) {
    let o = -1, a = 0;
    if (s === 0) o = A1(t), o !== -1 && (a = (t[o] + t[o + 3]) / 2);
    else if (s === 1) o = A1(n1), o !== -1 && (a = f9(e, r, i, o));
    else if (s === 2) {
        let l = Jd(n1), u = 1.25 * i, c = r * 6, d = (r + i) * 6;
        for(let h = 0; h < 3; h++){
            let f = t[h], g = (t[h + 3] - f) / _a;
            if (i < _a / 4) {
                let y = [
                    ..._l
                ];
                y.length = i;
                let v = 0;
                for(let S = c; S < d; S += 6, v++){
                    let w = y[v];
                    w.candidate = e[S + 2 * h], w.count = 0;
                    let { bounds: A, leftCacheBounds: E, rightCacheBounds: b } = w;
                    for(let T = 0; T < 3; T++)b[T] = 1 / 0, b[T + 3] = -1 / 0, E[T] = 1 / 0, E[T + 3] = -1 / 0, A[T] = 1 / 0, A[T + 3] = -1 / 0;
                    Qp(S, e, A);
                }
                y.sort(d9);
                let x = i;
                for(let S = 0; S < x; S++){
                    let w = y[S];
                    for(; S + 1 < x && y[S + 1].candidate === w.candidate;)y.splice(S + 1, 1), x--;
                }
                for(let S = c; S < d; S += 6){
                    let w = e[S + 2 * h];
                    for(let A = 0; A < x; A++){
                        let E = y[A];
                        w >= E.candidate ? Qp(S, e, E.rightCacheBounds) : (Qp(S, e, E.leftCacheBounds), E.count++);
                    }
                }
                for(let S = 0; S < x; S++){
                    let w = y[S], A = w.count, E = i - w.count, b = w.leftCacheBounds, T = w.rightCacheBounds, M = 0;
                    A !== 0 && (M = Jd(b) / l);
                    let C = 0;
                    E !== 0 && (C = Jd(T) / l);
                    let P = 1 + 1.25 * (M * A + C * E);
                    P < u && (o = h, u = P, a = w.candidate);
                }
            } else {
                for(let x = 0; x < _a; x++){
                    let S = _l[x];
                    S.count = 0, S.candidate = f + g + x * g;
                    let w = S.bounds;
                    for(let A = 0; A < 3; A++)w[A] = 1 / 0, w[A + 3] = -1 / 0;
                }
                for(let x = c; x < d; x += 6){
                    let A = ~~((e[x + 2 * h] - f) / g);
                    A >= _a && (A = _a - 1);
                    let E = _l[A];
                    E.count++, Qp(x, e, E.bounds);
                }
                let y = _l[_a - 1];
                _1(y.bounds, y.rightCacheBounds);
                for(let x = _a - 2; x >= 0; x--){
                    let S = _l[x], w = _l[x + 1];
                    E1(S.bounds, w.rightCacheBounds, S.rightCacheBounds);
                }
                let v = 0;
                for(let x = 0; x < _a - 1; x++){
                    let S = _l[x], w = S.count, A = S.bounds, b = _l[x + 1].rightCacheBounds;
                    w !== 0 && (v === 0 ? _1(A, $v) : E1(A, $v, $v)), v += w;
                    let T = 0, M = 0;
                    v !== 0 && (T = Jd($v) / l);
                    let C = i - v;
                    C !== 0 && (M = Jd(b) / l);
                    let P = 1 + 1.25 * (T * v + M * C);
                    P < u && (o = h, u = P, a = S.candidate);
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${s} used.`);
    return {
        axis: o,
        pos: a
    };
}
function f9(n1, t, e, r) {
    let i = 0;
    for(let s = t, o = t + e; s < o; s++)i += n1[s * 6 + r * 2];
    return i / e;
}
function p9(n1, t) {
    let e = n1.attributes.position, r = n1.index.array, i = r.length / 3, s = new Float32Array(i * 6), o = e.normalized, a = e.array, l = e.offset || 0, u = 3;
    e.isInterleavedBufferAttribute && (u = e.data.stride);
    let c = [
        "getX",
        "getY",
        "getZ"
    ];
    for(let d = 0; d < i; d++){
        let h = d * 3, f = d * 6, p, m, g;
        o ? (p = r[h + 0], m = r[h + 1], g = r[h + 2]) : (p = r[h + 0] * u + l, m = r[h + 1] * u + l, g = r[h + 2] * u + l);
        for(let y = 0; y < 3; y++){
            let v, x, S;
            o ? (v = e[c[y]](p), x = e[c[y]](m), S = e[c[y]](g)) : (v = a[p + y], x = a[m + y], S = a[g + y]);
            let w = v;
            x < w && (w = x), S < w && (w = S);
            let A = v;
            x > A && (A = x), S > A && (A = S);
            let E = (A - w) / 2, b = y * 2;
            s[f + b + 0] = w + E, s[f + b + 1] = E + (Math.abs(w) + E) * QD, w < t[y] && (t[y] = w), A > t[y + 3] && (t[y + 3] = A);
        }
    }
    return s;
}
function m9(n1, t) {
    function e(y) {
        h && h(y / f);
    }
    function r(y, v, x, S = null, w = 0) {
        if (!p && w >= l && (p = !0, u && (console.warn(`MeshBVH: Max depth of ${l} reached when generating BVH. Consider increasing maxDepth.`), console.warn(n1))), x <= c || w >= l) return e(v + x), y.offset = v, y.count = x, y;
        let A = h9(y.boundingData, S, o, v, x, d);
        if (A.axis === -1) return e(v + x), y.offset = v, y.count = x, y;
        let E = u9(a, o, v, x, A);
        if (E === v || E === v + x) e(v + x), y.offset = v, y.count = x;
        else {
            y.splitAxis = A.axis;
            let b = new Oc, T = v, M = E - v;
            y.left = b, b.boundingData = new Float32Array(6), M1(o, T, M, b.boundingData, s), r(b, T, M, s, w + 1);
            let C = new Oc, P = E, D = x - M;
            y.right = C, C.boundingData = new Float32Array(6), M1(o, P, D, C.boundingData, s), r(C, P, D, s, w + 1);
        }
        return y;
    }
    a9(n1, t);
    let i = new Float32Array(6), s = new Float32Array(6), o = p9(n1, i), a = n1.index.array, l = t.maxDepth, u = t.verbose, c = t.maxLeafTris, d = t.strategy, h = t.onProgress, f = n1.index.count / 3, p = !1, m = [], g = l9(n1);
    if (g.length === 1) {
        let y = g[0], v = new Oc;
        v.boundingData = i, c9(o, y.offset, y.count, s), r(v, y.offset, y.count, s), m.push(v);
    } else for (let y of g){
        let v = new Oc;
        v.boundingData = new Float32Array(6), M1(o, y.offset, y.count, v.boundingData, s), r(v, y.offset, y.count, s), m.push(v);
    }
    return m;
}
function JD(n1, t) {
    let e = m9(n1, t), r, i, s, o = [], a = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    for(let c = 0; c < e.length; c++){
        let d = e[c], h = l(d), f = new a(32 * h);
        r = new Float32Array(f), i = new Uint32Array(f), s = new Uint16Array(f), u(0, d), o.push(f);
    }
    return o;
    function l(c) {
        return c.count ? 1 : 1 + l(c.left) + l(c.right);
    }
    function u(c, d) {
        let h = c / 4, f = c / 2, p = !!d.count, m = d.boundingData;
        for(let g = 0; g < 6; g++)r[h + g] = m[g];
        if (p) {
            let g = d.offset, y = d.count;
            return i[h + 6] = g, s[f + 14] = y, s[f + 15] = 65535, c + 32;
        } else {
            let g = d.left, y = d.right, v = d.splitAxis, x;
            if (x = u(c + 32, g), x / 4 > Math.pow(2, 32)) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
            return i[h + 6] = x / 4, x = u(x, y), i[h + 7] = v, x;
        }
    }
}
var Mn = class {
    constructor(){
        this.min = 1 / 0, this.max = -1 / 0;
    }
    setFromPointsField(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s = 0, o = t.length; s < o; s++){
            let l = t[s][e];
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    setFromPoints(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s = 0, o = e.length; s < o; s++){
            let a = e[s], l = t.dot(a);
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    isSeparated(t) {
        return this.min > t.max || t.min > this.max;
    }
};
Mn.prototype.setFromBox = function() {
    let n1 = new _;
    return function(e, r) {
        let i = r.min, s = r.max, o = 1 / 0, a = -1 / 0;
        for(let l = 0; l <= 1; l++)for(let u = 0; u <= 1; u++)for(let c = 0; c <= 1; c++){
            n1.x = i.x * l + s.x * (1 - l), n1.y = i.y * u + s.y * (1 - u), n1.z = i.z * c + s.z * (1 - c);
            let d = e.dot(n1);
            o = Math.min(d, o), a = Math.max(d, a);
        }
        this.min = o, this.max = a;
    };
}();
var jfe = function() {
    let n1 = new Mn;
    return function(e, r) {
        let i = e.points, s = e.satAxes, o = e.satBounds, a = r.points, l = r.satAxes, u = r.satBounds;
        for(let c = 0; c < 3; c++){
            let d = o[c], h = s[c];
            if (n1.setFromPoints(h, a), d.isSeparated(n1)) return !1;
        }
        for(let c = 0; c < 3; c++){
            let d = u[c], h = l[c];
            if (n1.setFromPoints(h, i), d.isSeparated(n1)) return !1;
        }
    };
}();
var g9 = function() {
    let n1 = new _, t = new _, e = new _;
    return function(i, s, o) {
        let a = i.start, l = n1, u = s.start, c = t;
        e.subVectors(a, u), n1.subVectors(i.end, i.start), t.subVectors(s.end, s.start);
        let d = e.dot(c), h = c.dot(l), f = c.dot(c), p = e.dot(l), g = l.dot(l) * f - h * h, y, v;
        g !== 0 ? y = (d * h - p * f) / g : y = 0, v = (d + y * h) / f, o.x = y, o.y = v;
    };
}(), Kp = function() {
    let n1 = new N, t = new _, e = new _;
    return function(i, s, o, a) {
        g9(i, s, n1);
        let l = n1.x, u = n1.y;
        if (l >= 0 && l <= 1 && u >= 0 && u <= 1) {
            i.at(l, o), s.at(u, a);
            return;
        } else if (l >= 0 && l <= 1) {
            u < 0 ? s.at(0, a) : s.at(1, a), i.closestPointToPoint(a, !0, o);
            return;
        } else if (u >= 0 && u <= 1) {
            l < 0 ? i.at(0, o) : i.at(1, o), s.closestPointToPoint(o, !0, a);
            return;
        } else {
            let c;
            l < 0 ? c = i.start : c = i.end;
            let d;
            u < 0 ? d = s.start : d = s.end;
            let h = t, f = e;
            if (i.closestPointToPoint(d, !0, t), s.closestPointToPoint(c, !0, e), h.distanceToSquared(d) <= f.distanceToSquared(c)) {
                o.copy(h), a.copy(d);
                return;
            } else {
                o.copy(c), a.copy(f);
                return;
            }
        }
    };
}(), $D = function() {
    let n1 = new _, t = new _, e = new qr, r = new xi;
    return function(s, o) {
        let { radius: a, center: l } = s, { a: u, b: c, c: d } = o;
        if (r.start = u, r.end = c, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a || (r.start = u, r.end = d, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a) || (r.start = c, r.end = d, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a)) return !0;
        let m = o.getPlane(e);
        if (Math.abs(m.distanceToPoint(l)) <= a) {
            let y = m.projectPoint(l, t);
            if (o.containsPoint(y)) return !0;
        }
        return !1;
    };
}();
var y9 = 1e-15;
function $d(n1) {
    return Math.abs(n1) < y9;
}
var Cn = class extends vr {
    constructor(...t){
        super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(()=>new _), this.satBounds = new Array(4).fill().map(()=>new Mn), this.points = [
            this.a,
            this.b,
            this.c
        ], this.sphere = new Er, this.plane = new qr, this.needsUpdate = !0;
    }
    intersectsSphere(t) {
        return $D(t, this);
    }
    update() {
        let t = this.a, e = this.b, r = this.c, i = this.points, s = this.satAxes, o = this.satBounds, a = s[0], l = o[0];
        this.getNormal(a), l.setFromPoints(a, i);
        let u = s[1], c = o[1];
        u.subVectors(t, e), c.setFromPoints(u, i);
        let d = s[2], h = o[2];
        d.subVectors(e, r), h.setFromPoints(d, i);
        let f = s[3], p = o[3];
        f.subVectors(r, t), p.setFromPoints(f, i), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(a, t), this.needsUpdate = !1;
    }
};
Cn.prototype.closestPointToSegment = function() {
    let n1 = new _, t = new _, e = new xi;
    return function(i, s = null, o = null) {
        let { start: a, end: l } = i, u = this.points, c, d = 1 / 0;
        for(let h = 0; h < 3; h++){
            let f = (h + 1) % 3;
            e.start.copy(u[h]), e.end.copy(u[f]), Kp(e, i, n1, t), c = n1.distanceToSquared(t), c < d && (d = c, s && s.copy(n1), o && o.copy(t));
        }
        return this.closestPointToPoint(a, n1), c = a.distanceToSquared(n1), c < d && (d = c, s && s.copy(n1), o && o.copy(a)), this.closestPointToPoint(l, n1), c = l.distanceToSquared(n1), c < d && (d = c, s && s.copy(n1), o && o.copy(l)), Math.sqrt(d);
    };
}();
Cn.prototype.intersectsTriangle = function() {
    let n1 = new Cn, t = new Array(3), e = new Array(3), r = new Mn, i = new Mn, s = new _, o = new _, a = new _, l = new _, u = new xi, c = new xi, d = new xi;
    return function(f, p = null, m = !1) {
        this.needsUpdate && this.update(), f.isExtendedTriangle ? f.needsUpdate && f.update() : (n1.copy(f), n1.update(), f = n1);
        let g = this.plane, y = f.plane;
        if (Math.abs(g.normal.dot(y.normal)) > 1 - 1e-10) {
            let v = this.satBounds, x = this.satAxes;
            e[0] = f.a, e[1] = f.b, e[2] = f.c;
            for(let A = 0; A < 4; A++){
                let E = v[A], b = x[A];
                if (r.setFromPoints(b, e), E.isSeparated(r)) return !1;
            }
            let S = f.satBounds, w = f.satAxes;
            t[0] = this.a, t[1] = this.b, t[2] = this.c;
            for(let A = 0; A < 4; A++){
                let E = S[A], b = w[A];
                if (r.setFromPoints(b, t), E.isSeparated(r)) return !1;
            }
            for(let A = 0; A < 4; A++){
                let E = x[A];
                for(let b = 0; b < 4; b++){
                    let T = w[b];
                    if (s.crossVectors(E, T), r.setFromPoints(s, t), i.setFromPoints(s, e), r.isSeparated(i)) return !1;
                }
            }
            return p && (m || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), p.start.set(0, 0, 0), p.end.set(0, 0, 0)), !0;
        } else {
            let v = this.points, x = !1, S = 0;
            for(let O = 0; O < 3; O++){
                let I = v[O], z = v[(O + 1) % 3];
                u.start.copy(I), u.end.copy(z), u.delta(o);
                let B = x ? c.start : c.end, V = $d(y.distanceToPoint(I));
                if ($d(y.normal.dot(o)) && V) {
                    c.copy(u), S = 2;
                    break;
                }
                if ((y.intersectLine(u, B) || V) && !$d(B.distanceTo(z))) {
                    if (S++, x) break;
                    x = !0;
                }
            }
            if (S === 1 && f.containsPoint(c.end)) return p && (p.start.copy(c.end), p.end.copy(c.end)), !0;
            if (S !== 2) return !1;
            let w = f.points, A = !1, E = 0;
            for(let O = 0; O < 3; O++){
                let I = w[O], z = w[(O + 1) % 3];
                u.start.copy(I), u.end.copy(z), u.delta(a);
                let B = A ? d.start : d.end, V = $d(g.distanceToPoint(I));
                if ($d(g.normal.dot(a)) && V) {
                    d.copy(u), E = 2;
                    break;
                }
                if ((g.intersectLine(u, B) || V) && !$d(B.distanceTo(z))) {
                    if (E++, A) break;
                    A = !0;
                }
            }
            if (E === 1 && this.containsPoint(d.end)) return p && (p.start.copy(d.end), p.end.copy(d.end)), !0;
            if (E !== 2) return !1;
            if (c.delta(o), d.delta(a), o.dot(a) < 0) {
                let O = d.start;
                d.start = d.end, d.end = O;
            }
            let b = c.start.dot(o), T = c.end.dot(o), M = d.start.dot(o), C = d.end.dot(o), P = T < M, D = b < C;
            return b !== C && M !== T && P === D ? !1 : (p && (l.subVectors(c.start, d.start), l.dot(o) > 0 ? p.start.copy(c.start) : p.start.copy(d.start), l.subVectors(c.end, d.end), l.dot(o) < 0 ? p.end.copy(c.end) : p.end.copy(d.end)), !0);
        }
    };
}();
Cn.prototype.distanceToPoint = function() {
    let n1 = new _;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
Cn.prototype.distanceToTriangle = function() {
    let n1 = new _, t = new _, e = [
        "a",
        "b",
        "c"
    ], r = new xi, i = new xi;
    return function(o, a = null, l = null) {
        let u = a || l ? r : null;
        if (this.intersectsTriangle(o, u)) return (a || l) && (a && u.getCenter(a), l && u.getCenter(l)), 0;
        let c = 1 / 0;
        for(let d = 0; d < 3; d++){
            let h, f = e[d], p = o[f];
            this.closestPointToPoint(p, n1), h = p.distanceToSquared(n1), h < c && (c = h, a && a.copy(n1), l && l.copy(p));
            let m = this[f];
            o.closestPointToPoint(m, n1), h = m.distanceToSquared(n1), h < c && (c = h, a && a.copy(m), l && l.copy(n1));
        }
        for(let d = 0; d < 3; d++){
            let h = e[d], f = e[(d + 1) % 3];
            r.set(this[h], this[f]);
            for(let p = 0; p < 3; p++){
                let m = e[p], g = e[(p + 1) % 3];
                i.set(o[m], o[g]), Kp(r, i, n1, t);
                let y = n1.distanceToSquared(t);
                y < c && (c = y, a && a.copy(n1), l && l.copy(t));
            }
        }
        return Math.sqrt(c);
    };
}();
var Pn = class {
    constructor(t, e, r){
        this.isOrientedBox = !0, this.min = new _, this.max = new _, this.matrix = new te, this.invMatrix = new te, this.points = new Array(8).fill().map(()=>new _), this.satAxes = new Array(3).fill().map(()=>new _), this.satBounds = new Array(3).fill().map(()=>new Mn), this.alignedSatBounds = new Array(3).fill().map(()=>new Mn), this.needsUpdate = !1, t && this.min.copy(t), e && this.max.copy(e), r && this.matrix.copy(r);
    }
    set(t, e, r) {
        this.min.copy(t), this.max.copy(e), this.matrix.copy(r), this.needsUpdate = !0;
    }
    copy(t) {
        this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
    }
};
Pn.prototype.update = function() {
    return function() {
        let t = this.matrix, e = this.min, r = this.max, i = this.points;
        for(let u = 0; u <= 1; u++)for(let c = 0; c <= 1; c++)for(let d = 0; d <= 1; d++){
            let h = 1 * u | 2 * c | 4 * d, f = i[h];
            f.x = u ? r.x : e.x, f.y = c ? r.y : e.y, f.z = d ? r.z : e.z, f.applyMatrix4(t);
        }
        let s = this.satBounds, o = this.satAxes, a = i[0];
        for(let u = 0; u < 3; u++){
            let c = o[u], d = s[u], h = 1 << u, f = i[h];
            c.subVectors(a, f), d.setFromPoints(c, i);
        }
        let l = this.alignedSatBounds;
        l[0].setFromPointsField(i, "x"), l[1].setFromPointsField(i, "y"), l[2].setFromPointsField(i, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
    };
}();
Pn.prototype.intersectsBox = function() {
    let n1 = new Mn;
    return function(e) {
        this.needsUpdate && this.update();
        let r = e.min, i = e.max, s = this.satBounds, o = this.satAxes, a = this.alignedSatBounds;
        if (n1.min = r.x, n1.max = i.x, a[0].isSeparated(n1) || (n1.min = r.y, n1.max = i.y, a[1].isSeparated(n1)) || (n1.min = r.z, n1.max = i.z, a[2].isSeparated(n1))) return !1;
        for(let l = 0; l < 3; l++){
            let u = o[l], c = s[l];
            if (n1.setFromBox(u, e), c.isSeparated(n1)) return !1;
        }
        return !0;
    };
}();
Pn.prototype.intersectsTriangle = function() {
    let n1 = new Cn, t = new Array(3), e = new Mn, r = new Mn, i = new _;
    return function(o) {
        this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (n1.copy(o), n1.update(), o = n1);
        let a = this.satBounds, l = this.satAxes;
        t[0] = o.a, t[1] = o.b, t[2] = o.c;
        for(let h = 0; h < 3; h++){
            let f = a[h], p = l[h];
            if (e.setFromPoints(p, t), f.isSeparated(e)) return !1;
        }
        let u = o.satBounds, c = o.satAxes, d = this.points;
        for(let h = 0; h < 3; h++){
            let f = u[h], p = c[h];
            if (e.setFromPoints(p, d), f.isSeparated(e)) return !1;
        }
        for(let h = 0; h < 3; h++){
            let f = l[h];
            for(let p = 0; p < 4; p++){
                let m = c[p];
                if (i.crossVectors(f, m), e.setFromPoints(i, t), r.setFromPoints(i, d), e.isSeparated(r)) return !1;
            }
        }
        return !0;
    };
}();
Pn.prototype.closestPointToPoint = function() {
    return function(t, e) {
        return this.needsUpdate && this.update(), e.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), e;
    };
}();
Pn.prototype.distanceToPoint = function() {
    let n1 = new _;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
Pn.prototype.distanceToBox = function() {
    let n1 = [
        "x",
        "y",
        "z"
    ], t = new Array(12).fill().map(()=>new xi), e = new Array(12).fill().map(()=>new xi), r = new _, i = new _;
    return function(o, a = 0, l = null, u = null) {
        if (this.needsUpdate && this.update(), this.intersectsBox(o)) return (l || u) && (o.getCenter(i), this.closestPointToPoint(i, r), o.closestPointToPoint(r, i), l && l.copy(r), u && u.copy(i)), 0;
        let c = a * a, d = o.min, h = o.max, f = this.points, p = 1 / 0;
        for(let g = 0; g < 8; g++){
            let y = f[g];
            i.copy(y).clamp(d, h);
            let v = y.distanceToSquared(i);
            if (v < p && (p = v, l && l.copy(y), u && u.copy(i), v < c)) return Math.sqrt(v);
        }
        let m = 0;
        for(let g = 0; g < 3; g++)for(let y = 0; y <= 1; y++)for(let v = 0; v <= 1; v++){
            let x = (g + 1) % 3, S = (g + 2) % 3, w = y << x | v << S, A = 1 << g | y << x | v << S, E = f[w], b = f[A];
            t[m].set(E, b);
            let M = n1[g], C = n1[x], P = n1[S], D = e[m], O = D.start, I = D.end;
            O[M] = d[M], O[C] = y ? d[C] : h[C], O[P] = v ? d[P] : h[C], I[M] = h[M], I[C] = y ? d[C] : h[C], I[P] = v ? d[P] : h[C], m++;
        }
        for(let g = 0; g <= 1; g++)for(let y = 0; y <= 1; y++)for(let v = 0; v <= 1; v++){
            i.x = g ? h.x : d.x, i.y = y ? h.y : d.y, i.z = v ? h.z : d.z, this.closestPointToPoint(i, r);
            let x = i.distanceToSquared(r);
            if (x < p && (p = x, l && l.copy(r), u && u.copy(i), x < c)) return Math.sqrt(x);
        }
        for(let g = 0; g < 12; g++){
            let y = t[g];
            for(let v = 0; v < 12; v++){
                let x = e[v];
                Kp(y, x, r, i);
                let S = r.distanceToSquared(i);
                if (S < p && (p = S, l && l.copy(r), u && u.copy(i), S < c)) return Math.sqrt(S);
            }
        }
        return Math.sqrt(p);
    };
}();
var eh = new _, th = new _, rh = new _, t0 = new N, r0 = new N, i0 = new N, eO = new _, tO = new _, rO = new _, n0 = new _;
function v9(n1, t, e, r, i, s) {
    let o;
    return s === ai ? o = n1.intersectTriangle(r, e, t, !0, i) : o = n1.intersectTriangle(t, e, r, s !== qi, i), o === null ? null : {
        distance: n1.origin.distanceTo(i),
        point: i.clone()
    };
}
function x9(n1, t, e, r, i, s, o, a, l) {
    eh.fromBufferAttribute(t, s), th.fromBufferAttribute(t, o), rh.fromBufferAttribute(t, a);
    let u = v9(n1, eh, th, rh, n0, l);
    if (u) {
        r && (t0.fromBufferAttribute(r, s), r0.fromBufferAttribute(r, o), i0.fromBufferAttribute(r, a), u.uv = vr.getInterpolation(n0, eh, th, rh, t0, r0, i0, new N)), i && (t0.fromBufferAttribute(i, s), r0.fromBufferAttribute(i, o), i0.fromBufferAttribute(i, a), u.uv1 = vr.getInterpolation(n0, eh, th, rh, t0, r0, i0, new N)), e && (eO.fromBufferAttribute(e, s), tO.fromBufferAttribute(e, o), rO.fromBufferAttribute(e, a), u.normal = vr.getInterpolation(n0, eh, th, rh, eO, tO, rO, new _), u.normal.dot(n1.direction) > 0 && u.normal.multiplyScalar(-1));
        let c = {
            a: s,
            b: o,
            c: a,
            normal: new _,
            materialIndex: 0
        };
        vr.getNormal(eh, th, rh, c.normal), u.face = c, u.faceIndex = s;
    }
    return u;
}
function P1(n1, t, e, r, i) {
    let s = r * 3, o = n1.index.getX(s), a = n1.index.getX(s + 1), l = n1.index.getX(s + 2), { position: u, normal: c, uv: d, uv1: h } = n1.attributes, f = x9(e, u, c, d, h, o, a, l, t);
    return f ? (f.faceIndex = r, i && i.push(f), f) : null;
}
function iO(n1, t, e, r, i, s) {
    for(let o = r, a = r + i; o < a; o++)P1(n1, t, e, o, s);
}
function nO(n1, t, e, r, i) {
    let s = 1 / 0, o = null;
    for(let a = r, l = r + i; a < l; a++){
        let u = P1(n1, t, e, a);
        u && u.distance < s && (o = u, s = u.distance);
    }
    return o;
}
function fs(n1, t, e, r) {
    let i = n1.a, s = n1.b, o = n1.c, a = t, l = t + 1, u = t + 2;
    e && (a = e.getX(t), l = e.getX(t + 1), u = e.getX(t + 2)), i.x = r.getX(a), i.y = r.getY(a), i.z = r.getZ(a), s.x = r.getX(l), s.y = r.getY(l), s.z = r.getZ(l), o.x = r.getX(u), o.y = r.getY(u), o.z = r.getZ(u);
}
function D1(n1, t, e, r, i, s, o) {
    let a = e.index, l = e.attributes.position;
    for(let u = n1, c = t + n1; u < c; u++)if (fs(o, u * 3, a, l), o.needsUpdate = !0, r(o, u, i, s)) return !0;
    return !1;
}
var ih = class {
    constructor(t){
        this._getNewPrimitive = t, this._primitives = [];
    }
    getPrimitive() {
        let t = this._primitives;
        return t.length === 0 ? this._getNewPrimitive() : t.pop();
    }
    releasePrimitive(t) {
        this._primitives.push(t);
    }
};
function Ea(n1, t) {
    return t[n1 + 15] === 65535;
}
function Ic(n1, t) {
    return t[n1 + 6];
}
function nh(n1, t) {
    return t[n1 + 14];
}
function sh(n1) {
    return n1 + 8;
}
function oh(n1, t) {
    return t[n1 + 6];
}
function sO(n1, t) {
    return t[n1 + 7];
}
var ah = new Bt, o0 = new _, S9 = [
    "x",
    "y",
    "z"
];
function a0(n1, t, e, r, i) {
    let s = n1 * 2, o = lh, a = El, l = Tl;
    if (Ea(s, a)) {
        let c = Ic(n1, l), d = nh(s, a);
        iO(t, e, r, c, d, i);
    } else {
        let c = sh(n1);
        c0(c, o, r, o0) && a0(c, t, e, r, i);
        let d = oh(n1, l);
        c0(d, o, r, o0) && a0(d, t, e, r, i);
    }
}
function l0(n1, t, e, r) {
    let i = n1 * 2, s = lh, o = El, a = Tl;
    if (Ea(i, o)) {
        let u = Ic(n1, a), c = nh(i, o);
        return nO(t, e, r, u, c);
    } else {
        let u = sO(n1, a), c = S9[u], h = r.direction[c] >= 0, f, p;
        h ? (f = sh(n1), p = oh(n1, a)) : (f = oh(n1, a), p = sh(n1));
        let g = c0(f, s, r, o0) ? l0(f, t, e, r) : null;
        if (g) {
            let x = g.point[c];
            if (h ? x <= s[p + u] : x >= s[p + u + 3]) return g;
        }
        let v = c0(p, s, r, o0) ? l0(p, t, e, r) : null;
        return g && v ? g.distance <= v.distance ? g : v : g || v || null;
    }
}
var oO = function() {
    let n1, t, e = [], r = new ih(()=>new Bt);
    return function(...o) {
        n1 = r.getPrimitive(), t = r.getPrimitive(), e.push(n1, t);
        let a = i(...o);
        r.releasePrimitive(n1), r.releasePrimitive(t), e.pop(), e.pop();
        let l = e.length;
        return l > 0 && (t = e[l - 1], n1 = e[l - 2]), a;
    };
    function i(s, o, a, l, u = null, c = 0, d = 0) {
        function h(x) {
            let S = x * 2, w = El, A = Tl;
            for(; !Ea(S, w);)x = sh(x), S = x * 2;
            return Ic(x, A);
        }
        function f(x) {
            let S = x * 2, w = El, A = Tl;
            for(; !Ea(S, w);)x = oh(x, A), S = x * 2;
            return Ic(x, A) + nh(S, w);
        }
        let p = s * 2, m = lh, g = El, y = Tl;
        if (Ea(p, g)) {
            let x = Ic(s, y), S = nh(p, g);
            return hs(s, m, n1), l(x, S, !1, d, c + s, n1);
        } else {
            let x = sh(s), S = oh(s, y), w = x, A = S, E, b, T, M;
            if (u && (T = n1, M = t, hs(w, m, T), hs(A, m, M), E = u(T), b = u(M), b < E)) {
                w = S, A = x;
                let B = E;
                E = b, b = B, T = M;
            }
            T || (T = n1, hs(w, m, T));
            let C = Ea(w * 2, g), P = a(T, C, E, d + 1, c + w), D;
            if (P === 2) {
                let B = h(w), U = f(w) - B;
                D = l(B, U, !0, d + 1, c + w, T);
            } else D = P && i(w, o, a, l, u, c, d + 1);
            if (D) return !0;
            M = t, hs(A, m, M);
            let O = Ea(A * 2, g), I = a(M, O, b, d + 1, c + A), z;
            if (I === 2) {
                let B = h(A), U = f(A) - B;
                z = l(B, U, !0, d + 1, c + A, M);
            } else z = I && i(A, o, a, l, u, c, d + 1);
            return !!z;
        }
    }
}(), aO = function() {
    let n1 = new Cn, t = new Cn, e = new te, r = new Pn, i = new Pn;
    return function s(o, a, l, u, c = null) {
        let d = o * 2, h = lh, f = El, p = Tl;
        if (c === null && (l.boundingBox || l.computeBoundingBox(), r.set(l.boundingBox.min, l.boundingBox.max, u), c = r), Ea(d, f)) {
            let g = a, y = g.index, v = g.attributes.position, x = l.index, S = l.attributes.position, w = Ic(o, p), A = nh(d, f);
            if (e.copy(u).invert(), l.boundsTree) return hs(o, h, i), i.matrix.copy(e), i.needsUpdate = !0, l.boundsTree.shapecast({
                intersectsBounds: (b)=>i.intersectsBox(b),
                intersectsTriangle: (b)=>{
                    b.a.applyMatrix4(u), b.b.applyMatrix4(u), b.c.applyMatrix4(u), b.needsUpdate = !0;
                    for(let T = w * 3, M = (A + w) * 3; T < M; T += 3)if (fs(t, T, y, v), t.needsUpdate = !0, b.intersectsTriangle(t)) return !0;
                    return !1;
                }
            });
            for(let E = w * 3, b = A + w * 3; E < b; E += 3){
                fs(n1, E, y, v), n1.a.applyMatrix4(e), n1.b.applyMatrix4(e), n1.c.applyMatrix4(e), n1.needsUpdate = !0;
                for(let T = 0, M = x.count; T < M; T += 3)if (fs(t, T, x, S), t.needsUpdate = !0, n1.intersectsTriangle(t)) return !0;
            }
        } else {
            let g = o + 8, y = p[o + 6];
            return hs(g, h, ah), !!(c.intersectsBox(ah) && s(g, a, l, u, c) || (hs(y, h, ah), c.intersectsBox(ah) && s(y, a, l, u, c)));
        }
    };
}();
function c0(n1, t, e, r) {
    return hs(n1, t, ah), e.intersectBox(ah, r);
}
var O1 = [], s0, lh, El, Tl;
function ch(n1) {
    s0 && O1.push(s0), s0 = n1, lh = new Float32Array(n1), El = new Uint16Array(n1), Tl = new Uint32Array(n1);
}
function Zp() {
    s0 = null, lh = null, El = null, Tl = null, O1.length && ch(O1.pop());
}
var I1 = Symbol("skip tree generation"), R1 = new Bt, L1 = new Bt, uh = new te, Rc = new Pn, Jp = new Pn, $p = new _, u0 = new _, w9 = new _, A9 = new _, _9 = new _, lO = new Bt, _o = new ih(()=>new Cn), Eo = class {
    static serialize(t, e = {}) {
        if (e.isBufferGeometry) return console.warn("MeshBVH.serialize: The arguments for the function have changed. See documentation for new signature."), Eo.serialize(arguments[0], {
            cloneBuffers: arguments[2] === void 0 ? !0 : arguments[2]
        });
        e = {
            cloneBuffers: !0,
            ...e
        };
        let r = t.geometry, i = t._roots, s = r.getIndex(), o;
        return e.cloneBuffers ? o = {
            roots: i.map((a)=>a.slice()),
            index: s.array.slice()
        } : o = {
            roots: i,
            index: s.array
        }, o;
    }
    static deserialize(t, e, r = {}) {
        if (typeof r == "boolean") return console.warn("MeshBVH.deserialize: The arguments for the function have changed. See documentation for new signature."), Eo.deserialize(arguments[0], arguments[1], {
            setIndex: arguments[2] === void 0 ? !0 : arguments[2]
        });
        r = {
            setIndex: !0,
            ...r
        };
        let { index: i, roots: s } = t, o = new Eo(e, {
            ...r,
            [I1]: !0
        });
        if (o._roots = s, r.setIndex) {
            let a = e.getIndex();
            if (a === null) {
                let l = new Ge(t.index, 1, !1);
                e.setIndex(l);
            } else a.array !== i && (a.array.set(i), a.needsUpdate = !0);
        }
        return o;
    }
    constructor(t, e = {}){
        if (t.isBufferGeometry) {
            if (t.index && t.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        } else throw new Error("MeshBVH: Only BufferGeometries are supported.");
        if (e = Object.assign({
            strategy: 0,
            maxDepth: 40,
            maxLeafTris: 10,
            verbose: !0,
            useSharedArrayBuffer: !1,
            setBoundingBox: !0,
            onProgress: null,
            [I1]: !1
        }, e), e.useSharedArrayBuffer && typeof SharedArrayBuffer > "u") throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        this._roots = null, e[I1] || (this._roots = JD(t, e), !t.boundingBox && e.setBoundingBox && (t.boundingBox = this.getBoundingBox(new Bt))), this.geometry = t;
    }
    refit(t = null) {
        t && Array.isArray(t) && (t = new Set(t));
        let e = this.geometry, r = e.index.array, i = e.attributes.position, s, o, a, l, u = 0, c = this._roots;
        for(let h = 0, f = c.length; h < f; h++)s = c[h], o = new Uint32Array(s), a = new Uint16Array(s), l = new Float32Array(s), d(0, u), u += s.byteLength;
        function d(h, f, p = !1) {
            let m = h * 2;
            if (a[m + 15] === 65535) {
                let y = o[h + 6], v = a[m + 14], x = 1 / 0, S = 1 / 0, w = 1 / 0, A = -1 / 0, E = -1 / 0, b = -1 / 0;
                for(let T = 3 * y, M = 3 * (y + v); T < M; T++){
                    let C = r[T], P = i.getX(C), D = i.getY(C), O = i.getZ(C);
                    P < x && (x = P), P > A && (A = P), D < S && (S = D), D > E && (E = D), O < w && (w = O), O > b && (b = O);
                }
                return l[h + 0] !== x || l[h + 1] !== S || l[h + 2] !== w || l[h + 3] !== A || l[h + 4] !== E || l[h + 5] !== b ? (l[h + 0] = x, l[h + 1] = S, l[h + 2] = w, l[h + 3] = A, l[h + 4] = E, l[h + 5] = b, !0) : !1;
            } else {
                let y = h + 8, v = o[h + 6], x = y + f, S = v + f, w = p, A = !1, E = !1;
                t ? w || (A = t.has(x), E = t.has(S), w = !A && !E) : (A = !0, E = !0);
                let b = w || A, T = w || E, M = !1;
                b && (M = d(y, f, w));
                let C = !1;
                T && (C = d(v, f, w));
                let P = M || C;
                if (P) for(let D = 0; D < 3; D++){
                    let O = y + D, I = v + D, z = l[O], B = l[O + 3], V = l[I], U = l[I + 3];
                    l[h + D] = z < V ? z : V, l[h + D + 3] = B > U ? B : U;
                }
                return P;
            }
        }
    }
    traverse(t, e = 0) {
        let r = this._roots[e], i = new Uint32Array(r), s = new Uint16Array(r);
        o(0);
        function o(a, l = 0) {
            let u = a * 2, c = s[u + 15] === 65535;
            if (c) {
                let d = i[a + 6], h = s[u + 14];
                t(l, c, new Float32Array(r, a * 4, 6), d, h);
            } else {
                let d = a + 8, h = i[a + 6], f = i[a + 7];
                t(l, c, new Float32Array(r, a * 4, 6), f) || (o(d, l + 1), o(h, l + 1));
            }
        }
    }
    raycast(t, e = jn) {
        let r = this._roots, i = this.geometry, s = [], o = e.isMaterial, a = Array.isArray(e), l = i.groups, u = o ? e.side : e;
        for(let c = 0, d = r.length; c < d; c++){
            let h = a ? e[l[c].materialIndex].side : u, f = s.length;
            if (ch(r[c]), a0(0, i, h, t, s), Zp(), a) {
                let p = l[c].materialIndex;
                for(let m = f, g = s.length; m < g; m++)s[m].face.materialIndex = p;
            }
        }
        return s;
    }
    raycastFirst(t, e = jn) {
        let r = this._roots, i = this.geometry, s = e.isMaterial, o = Array.isArray(e), a = null, l = i.groups, u = s ? e.side : e;
        for(let c = 0, d = r.length; c < d; c++){
            let h = o ? e[l[c].materialIndex].side : u;
            ch(r[c]);
            let f = l0(0, i, h, t);
            Zp(), f != null && (a == null || f.distance < a.distance) && (a = f, o && (f.face.materialIndex = l[c].materialIndex));
        }
        return a;
    }
    intersectsGeometry(t, e) {
        let r = this.geometry, i = !1;
        for (let s of this._roots)if (ch(s), i = aO(0, r, t, e), Zp(), i) break;
        return i;
    }
    shapecast(t, e, r) {
        let i = this.geometry;
        if (t instanceof Function) {
            if (e) {
                let h = e;
                e = (f, p, m, g)=>{
                    let y = p * 3;
                    return h(f, y, y + 1, y + 2, m, g);
                };
            }
            t = {
                boundsTraverseOrder: r,
                intersectsBounds: t,
                intersectsTriangle: e,
                intersectsRange: null
            }, console.warn("MeshBVH: Shapecast function signature has changed and now takes an object of callbacks as a second argument. See docs for new signature.");
        }
        let s = _o.getPrimitive(), { boundsTraverseOrder: o, intersectsBounds: a, intersectsRange: l, intersectsTriangle: u } = t;
        if (l && u) {
            let h = l;
            l = (f, p, m, g, y)=>h(f, p, m, g, y) ? !0 : D1(f, p, i, u, m, g, s);
        } else l || (u ? l = (h, f, p, m)=>D1(h, f, i, u, p, m, s) : l = (h, f, p)=>p);
        let c = !1, d = 0;
        for (let h of this._roots){
            if (ch(h), c = oO(0, i, a, l, o, d), Zp(), c) break;
            d += h.byteLength;
        }
        return _o.releasePrimitive(s), c;
    }
    bvhcast(t, e, r) {
        let { intersectsRanges: i, intersectsTriangles: s } = r, o = this.geometry.index, a = this.geometry.attributes.position, l = t.geometry.index, u = t.geometry.attributes.position;
        uh.copy(e).invert();
        let c = _o.getPrimitive(), d = _o.getPrimitive();
        if (s) {
            let f = function(p, m, g, y, v, x, S, w) {
                for(let A = g, E = g + y; A < E; A++){
                    fs(d, A * 3, l, u), d.a.applyMatrix4(e), d.b.applyMatrix4(e), d.c.applyMatrix4(e), d.needsUpdate = !0;
                    for(let b = p, T = p + m; b < T; b++)if (fs(c, b * 3, o, a), c.needsUpdate = !0, s(c, d, b, A, v, x, S, w)) return !0;
                }
                return !1;
            };
            if (i) {
                let p = i;
                i = function(m, g, y, v, x, S, w, A) {
                    return p(m, g, y, v, x, S, w, A) ? !0 : f(m, g, y, v, x, S, w, A);
                };
            } else i = f;
        }
        t.getBoundingBox(L1), L1.applyMatrix4(e);
        let h = this.shapecast({
            intersectsBounds: (f)=>L1.intersectsBox(f),
            intersectsRange: (f, p, m, g, y, v)=>(R1.copy(v), R1.applyMatrix4(uh), t.shapecast({
                    intersectsBounds: (x)=>R1.intersectsBox(x),
                    intersectsRange: (x, S, w, A, E)=>i(f, p, x, S, g, y, A, E)
                }))
        });
        return _o.releasePrimitive(c), _o.releasePrimitive(d), h;
    }
    intersectsBox(t, e) {
        return Rc.set(t.min, t.max, e), Rc.needsUpdate = !0, this.shapecast({
            intersectsBounds: (r)=>Rc.intersectsBox(r),
            intersectsTriangle: (r)=>Rc.intersectsTriangle(r)
        });
    }
    intersectsSphere(t) {
        return this.shapecast({
            intersectsBounds: (e)=>t.intersectsBox(e),
            intersectsTriangle: (e)=>e.intersectsSphere(t)
        });
    }
    closestPointToGeometry(t, e, r = {}, i = {}, s = 0, o = 1 / 0) {
        t.boundingBox || t.computeBoundingBox(), Rc.set(t.boundingBox.min, t.boundingBox.max, e), Rc.needsUpdate = !0;
        let a = this.geometry, l = a.attributes.position, u = a.index, c = t.attributes.position, d = t.index, h = _o.getPrimitive(), f = _o.getPrimitive(), p = u0, m = w9, g = null, y = null;
        i && (g = A9, y = _9);
        let v = 1 / 0, x = null, S = null;
        return uh.copy(e).invert(), Jp.matrix.copy(uh), this.shapecast({
            boundsTraverseOrder: (w)=>Rc.distanceToBox(w),
            intersectsBounds: (w, A, E)=>E < v && E < o ? (A && (Jp.min.copy(w.min), Jp.max.copy(w.max), Jp.needsUpdate = !0), !0) : !1,
            intersectsRange: (w, A)=>{
                if (t.boundsTree) return t.boundsTree.shapecast({
                    boundsTraverseOrder: (E)=>Jp.distanceToBox(E),
                    intersectsBounds: (E, b, T)=>T < v && T < o,
                    intersectsRange: (E, b)=>{
                        for(let T = E * 3, M = (E + b) * 3; T < M; T += 3){
                            fs(f, T, d, c), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                            for(let C = w * 3, P = (w + A) * 3; C < P; C += 3){
                                fs(h, C, u, l), h.needsUpdate = !0;
                                let D = h.distanceToTriangle(f, p, g);
                                if (D < v && (m.copy(p), y && y.copy(g), v = D, x = C / 3, S = T / 3), D < s) return !0;
                            }
                        }
                    }
                });
                {
                    let E = d ? d.count : c.count;
                    for(let b = 0, T = E; b < T; b += 3){
                        fs(f, b, d, c), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                        for(let M = w * 3, C = (w + A) * 3; M < C; M += 3){
                            fs(h, M, u, l), h.needsUpdate = !0;
                            let P = h.distanceToTriangle(f, p, g);
                            if (P < v && (m.copy(p), y && y.copy(g), v = P, x = M / 3, S = b / 3), P < s) return !0;
                        }
                    }
                }
            }
        }), _o.releasePrimitive(h), _o.releasePrimitive(f), v === 1 / 0 ? null : (r.point ? r.point.copy(m) : r.point = m.clone(), r.distance = v, r.faceIndex = x, i && (i.point ? i.point.copy(y) : i.point = y.clone(), i.point.applyMatrix4(uh), m.applyMatrix4(uh), i.distance = m.sub(i.point).length(), i.faceIndex = S), r);
    }
    closestPointToPoint(t, e = {}, r = 0, i = 1 / 0) {
        let s = r * r, o = i * i, a = 1 / 0, l = null;
        if (this.shapecast({
            boundsTraverseOrder: (c)=>($p.copy(t).clamp(c.min, c.max), $p.distanceToSquared(t)),
            intersectsBounds: (c, d, h)=>h < a && h < o,
            intersectsTriangle: (c, d)=>{
                c.closestPointToPoint(t, $p);
                let h = t.distanceToSquared($p);
                return h < a && (u0.copy($p), a = h, l = d), h < s;
            }
        }), a === 1 / 0) return null;
        let u = Math.sqrt(a);
        return e.point ? e.point.copy(u0) : e.point = u0.clone(), e.distance = u, e.faceIndex = l, e;
    }
    getBoundingBox(t) {
        return t.makeEmpty(), this._roots.forEach((r)=>{
            hs(0, new Float32Array(r), lO), t.union(lO);
        }), t;
    }
};
var rf = Pi(uO());
var E9 = .5 * (Math.sqrt(3) - 1), em = (3 - Math.sqrt(3)) / 6, T9 = 1 / 3, To = 1 / 6, Npe = (Math.sqrt(5) - 1) / 4, Fpe = (5 - Math.sqrt(5)) / 20, tm = (n1)=>Math.floor(n1) | 0, dO = new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]), N1 = new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
function d0(n1 = Math.random) {
    let t = fO(n1), e = new Float64Array(t).map((i)=>dO[i % 12 * 2]), r = new Float64Array(t).map((i)=>dO[i % 12 * 2 + 1]);
    return function(s, o) {
        let a = 0, l = 0, u = 0, c = (s + o) * E9, d = tm(s + c), h = tm(o + c), f = (d + h) * em, p = d - f, m = h - f, g = s - p, y = o - m, v, x;
        g > y ? (v = 1, x = 0) : (v = 0, x = 1);
        let S = g - v + em, w = y - x + em, A = g - 1 + 2 * em, E = y - 1 + 2 * em, b = d & 255, T = h & 255, M = .5 - g * g - y * y;
        if (M >= 0) {
            let D = b + t[T], O = e[D], I = r[D];
            M *= M, a = M * M * (O * g + I * y);
        }
        let C = .5 - S * S - w * w;
        if (C >= 0) {
            let D = b + v + t[T + x], O = e[D], I = r[D];
            C *= C, l = C * C * (O * S + I * w);
        }
        let P = .5 - A * A - E * E;
        if (P >= 0) {
            let D = b + 1 + t[T + 1], O = e[D], I = r[D];
            P *= P, u = P * P * (O * A + I * E);
        }
        return 70 * (a + l + u);
    };
}
function hO(n1 = Math.random) {
    let t = fO(n1), e = new Float64Array(t).map((s)=>N1[s % 12 * 3]), r = new Float64Array(t).map((s)=>N1[s % 12 * 3 + 1]), i = new Float64Array(t).map((s)=>N1[s % 12 * 3 + 2]);
    return function(o, a, l) {
        let u, c, d, h, f = (o + a + l) * T9, p = tm(o + f), m = tm(a + f), g = tm(l + f), y = (p + m + g) * To, v = p - y, x = m - y, S = g - y, w = o - v, A = a - x, E = l - S, b, T, M, C, P, D;
        w >= A ? A >= E ? (b = 1, T = 0, M = 0, C = 1, P = 1, D = 0) : w >= E ? (b = 1, T = 0, M = 0, C = 1, P = 0, D = 1) : (b = 0, T = 0, M = 1, C = 1, P = 0, D = 1) : A < E ? (b = 0, T = 0, M = 1, C = 0, P = 1, D = 1) : w < E ? (b = 0, T = 1, M = 0, C = 0, P = 1, D = 1) : (b = 0, T = 1, M = 0, C = 1, P = 1, D = 0);
        let O = w - b + To, I = A - T + To, z = E - M + To, B = w - C + 2 * To, V = A - P + 2 * To, U = E - D + 2 * To, j = w - 1 + 3 * To, W = A - 1 + 3 * To, k = E - 1 + 3 * To, H = p & 255, X = m & 255, q = g & 255, G = .6 - w * w - A * A - E * E;
        if (G < 0) u = 0;
        else {
            let Y = H + t[X + t[q]];
            G *= G, u = G * G * (e[Y] * w + r[Y] * A + i[Y] * E);
        }
        let J = .6 - O * O - I * I - z * z;
        if (J < 0) c = 0;
        else {
            let Y = H + b + t[X + T + t[q + M]];
            J *= J, c = J * J * (e[Y] * O + r[Y] * I + i[Y] * z);
        }
        let Z = .6 - B * B - V * V - U * U;
        if (Z < 0) d = 0;
        else {
            let Y = H + C + t[X + P + t[q + D]];
            Z *= Z, d = Z * Z * (e[Y] * B + r[Y] * V + i[Y] * U);
        }
        let K = .6 - j * j - W * W - k * k;
        if (K < 0) h = 0;
        else {
            let Y = H + 1 + t[X + 1 + t[q + 1]];
            K *= K, h = K * K * (e[Y] * j + r[Y] * W + i[Y] * k);
        }
        return 32 * (u + c + d + h);
    };
}
function fO(n1) {
    let e = new Uint8Array(512);
    for(let r = 0; r < 256; r++)e[r] = r;
    for(let r = 0; r < 255; r++){
        let i = r + ~~(n1() * (256 - r)), s = e[r];
        e[r] = e[i], e[i] = s;
    }
    for(let r = 256; r < 512; r++)e[r] = e[r - 256];
    return e;
}
var Us = new vr, h0 = class {
    constructor(t){
        this.weightAttribute = null;
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.distribution = null;
    }
    build() {
        let t = this.positionAttribute, e = new Float32Array(t.count / 3);
        for(let i = 0; i < t.count; i += 3){
            let s = 1;
            Us.a.fromBufferAttribute(t, i), Us.b.fromBufferAttribute(t, i + 1), Us.c.fromBufferAttribute(t, i + 2), s *= Us.getArea(), e[i / 3] = s;
        }
        this.distribution = new Float32Array(t.count / 3);
        let r = 0;
        for(let i = 0; i < e.length; i++)r += e[i], this.distribution[i] = r;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e) {
        if (this.distribution) {
            let r = this.distribution[this.distribution.length - 1], i = this.binarySearch(this.randomFunction() * r);
            return this.sampleFace(i, t, e);
        }
    }
    binarySearch(t) {
        if (!this.distribution) return 0;
        let e = this.distribution, r = 0, i = e.length - 1, s = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s;
    }
    sampleFace(t, e, r) {
        let i = this.randomFunction(), s = this.randomFunction();
        return i + s > 1 && (i = 1 - i, s = 1 - s), Us.a.fromBufferAttribute(this.positionAttribute, t * 3), Us.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), Us.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(Us.a, i).addScaledVector(Us.b, s).addScaledVector(Us.c, 1 - (i + s)), Us.getNormal(r), this;
    }
};
var mO = Pi(F1()), M9 = new te, C9 = new te, P9 = new te, dh;
((t)=>{
    function n1(e) {
        return e && e.__isSPEObject;
    }
    t.is = n1;
})(dh || (dh = {}));
var hh = (n1)=>class extends n1 {
        constructor(){
            super(...arguments);
            this.previousModelViewMatrix = new te;
            this.copyPreviousMatrix = !0;
            this.hiddenMatrix = new te;
            this.matrixWorldRigid = new te;
            this.shearScale = new te;
            this.shearScaleInv = new te;
        }
        get __isSPEObject() {
            return !0;
        }
        isDescendantOf(r) {
            r instanceof mt && (r = r.uuid);
            let i = this;
            for(; i.parent;){
                if (i.parent.uuid === r) return !0;
                i = i.parent;
            }
            return !1;
        }
        updateMatrixWorld(r) {
            this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || r) && (this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, r = !0);
            for (let i of this.children)i.updateMatrixWorld(r);
        }
        updateWorldMatrix(r, i) {
            let s = this.parent;
            if (r && s !== null && s.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), i) for (let o of this.children)o.updateWorldMatrix(!1, !0);
        }
        traverseChildren(r, i = 0) {
            for (let s of this.children)dh.is(s) && s.traverseObject(r, i + 1);
        }
        traverseObject(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)dh.is(o) && o.traverseObject(r, i + 1);
        }
        updateMatrixWorldSVD() {
            let r = this.matrixWorld.elements, i = [
                [
                    r[0],
                    r[4],
                    r[8]
                ],
                [
                    r[1],
                    r[5],
                    r[9]
                ],
                [
                    r[2],
                    r[6],
                    r[10]
                ]
            ], { u: s, v: o, q: a } = (0, mO.SVD)(i), l = M9.set(s[0][0], s[0][1], s[0][2], 0, s[1][0], s[1][1], s[1][2], 0, s[2][0], s[2][1], s[2][2], 0, 0, 0, 0, 1), u = C9.set(o[0][0], o[0][1], o[0][2], 0, o[1][0], o[1][1], o[1][2], 0, o[2][0], o[2][1], o[2][2], 0, 0, 0, 0, 1), c = P9.copy(u).transpose();
            this.shearScale.makeScale(a[0], a[1], a[2]).multiply(c).premultiply(u), this.shearScaleInv.copy(this.shearScale).invert(), this.matrixWorldRigid.multiplyMatrices(l, c).copyPosition(this.matrixWorld), a.every((d)=>Math.abs(a[0] - d) < .01) ? this.hasNonUniformScale = !1 : this.hasNonUniformScale = !0;
        }
        attach(r, i) {
            this.updateWorldMatrix(!0, !1);
            let s = new te().copy(this.matrixWorld).invert();
            return r.parent !== null && (r.parent.updateWorldMatrix(!0, !1), s.multiply(r.parent.matrixWorld)), "hiddenMatrix" in r && r.hiddenMatrix instanceof te ? r.hiddenMatrix.premultiply(s) : r.applyMatrix4(s), r.updateWorldMatrix(!1, !1), this.add(r), i !== void 0 && (this.children.pop(), this.children.splice(i, 0, r)), this;
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.hasNonUniformScale = r.hasNonUniformScale, this;
        }
        onAfterRender(r, i, s, o, a, l) {
            this.copyPreviousMatrix && this.previousModelViewMatrix.copy(this.modelViewMatrix);
        }
    };
var k1 = class extends hh(mt) {
}, D9 = (n1)=>n1.type === "Mesh", Pr = class extends k1 {
    constructor(e){
        super();
        this.object = e;
        this.matrixAutoUpdate = !1, this.hasNonUniformScale = e.hasNonUniformScale;
    }
    raycast(e, r) {}
    expand() {
        let e = 0, r = this.object.entityChildren(e);
        for(; r;){
            let i = this.children[e];
            i?.object !== r && (i && this.remove(i), i = new Pr(r), this.add(i), this.children.splice(e, 0, this.children.pop()), i.matrixWorldNeedsUpdate = !0, i.matrixAutoUpdate = !1, i.matrix = r.matrix, i.hiddenMatrix = r.hiddenMatrix), i.expand(), e += 1, r = this.object.entityChildren(e);
        }
        for(; this.children.length > e;)this.remove(this.children[e]);
    }
    get visible() {
        return this.playModeVisible !== void 0 ? this.playModeVisible : this.object.visible || this.object.dataPatched.visible && this.object.dataPatched.cloner?.hideBase === !0;
    }
    set visible(e) {}
    get castShadow() {
        return this.object.castShadow;
    }
    set castShadow(e) {}
    get receiveShadow() {
        return this.object.receiveShadow;
    }
    set receiveShadow(e) {}
    get isMesh() {
        return D9(this.object);
    }
    get isLight() {
        return this.object.isLight;
    }
    get layers() {
        return this.object.layers;
    }
    set layers(e) {}
    get isCamera() {
        return !1;
    }
    get geometry() {
        if (this.object.geometry) return this.object.geometry;
    }
    get material() {
        if (this.object.material) return this.object.material;
    }
};
var Lc = new _, Bc = new _, fh = new te, yO = [
    new _(-1, 1, 1),
    new _(-1, -1, 1),
    new _(1, -1, 1),
    new _(1, 1, 1),
    new _(-1, 1, -1),
    new _(-1, -1, -1),
    new _(1, -1, -1),
    new _(1, 1, -1)
], O9 = [
    [
        0,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        6
    ],
    [
        4,
        7
    ],
    [
        0,
        1
    ],
    [
        3,
        2
    ],
    [
        7,
        6
    ],
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        5
    ],
    [
        2,
        6
    ],
    [
        3,
        7
    ]
], I9 = [
    [
        0,
        2
    ],
    [
        7,
        5
    ],
    [
        4,
        1
    ],
    [
        3,
        6
    ],
    [
        4,
        3
    ],
    [
        1,
        6
    ]
], gO = (n1, t, e)=>{
    n1.updateEntityBoxSize(Lc, Bc), fh.copy(t).multiply(n1.matrixWorld), Bc.x === 0 && Bc.y === 0 && Bc.z === 0 ? e.push(new _(Lc.x, Lc.y, Lc.z).applyMatrix4(fh)) : yO.forEach((r)=>{
        e.push(r.clone().multiply(Bc).add(Lc).applyMatrix4(fh));
    });
}, rm = class extends Bt {
    constructor(){
        super(...arguments);
        this.matrix = new te;
        this.vertices = [];
        this.faces = [];
        this.edges = [];
        this.centerEdges = [];
    }
    copy(e) {
        return super.copy(e), this.matrix.copy(e.matrix), this.vertices = e.vertices.map((r)=>r.clone()), this.faces = e.faces.map((r)=>r.clone()), this.edges = e.edges.map((r)=>r.clone()), this.centerEdges = e.centerEdges.map((r)=>r.clone()), this;
    }
    setFromObjectSize(e, r = !1) {
        e.updateWorldMatrix(!1, r), this.makeEmpty(), this.matrix.copy(e.matrixWorld);
        let i = new te().copy(e.matrixWorld).invert();
        return this.expandByObjectSize(e, i, r);
    }
    expandByObjectSize(e, r, i = !1) {
        let s = [];
        return i === !0 ? e.traverseEntity((o)=>{
            if (o.visible || o.cloner && o.data.visible) {
                if (!("geometry" in o)) {
                    s.push(new _);
                    return;
                }
                gO(o, r, s);
            }
        }) : gO(e, r, s), this.setFromPoints(s);
    }
    getCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(this.matrix), e;
    }
    getPositionToCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(fh.copy(this.matrix).setPosition(0, 0, 0)), e;
    }
    computeVertices() {
        this.getSize(Bc).multiplyScalar(.5), this.getCenter(Lc), fh.copy(this.matrix).setPosition(Lc), this.vertices = yO.map((e)=>e.clone().multiply(Bc).applyMatrix4(fh));
    }
    computeEdges() {
        this.vertices.length > 0 && this.computeVertices(), this.edges = O9.map(([e, r])=>new xi(this.vertices[e], this.vertices[r])), this.centerEdges = this.edges.map((e)=>e.getCenter(new _));
    }
    computeFaces() {
        this.vertices.length > 0 && this.computeVertices(), this.faces = I9.map(([e, r])=>this.vertices[e].clone().add(this.vertices[r]).multiplyScalar(.5));
    }
};
var Gs = {
    Cloner: ()=>{},
    changeEntityProptotype: ()=>{},
    createEntity: ()=>{}
};
var V1 = class extends mp {
    constructor(){
        super();
    }
    getPoints(t = 12) {
        let e = [], r, i = this.getCurveLengths(), o = i[i.length - 1] / i.length;
        for(let a = 0, l = this.curves; a < l.length; a++){
            let u = l[a], c = a === 0 ? i[a] : i[a] - i[a - 1], d = Math.ceil(t * c / o), h = u.getPoints(d);
            for(let f = 0; f < h.length; f++){
                let p = h[f];
                r && r.equals(p) || (e.push(p), r = p);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
};
var U1 = .001;
function G1(n1, t, e) {
    return t.clone().sub(n1).cross(t.clone().sub(e)).length() <= U1;
}
function z1(n1, t) {
    let e = new _(...n1.position), r = new _(...n1.controlNext.position), i = new _(...t.controlPrevious.position), s = new _(...t.position);
    return G1(e, r, s) && G1(e, i, s);
}
function p0(n1) {
    let t = n1.points.map((c)=>new _(...c.data.position)), e = [
        n1.points[0]
    ], r = new _(...e[0].data.position);
    for(let c = 0; c < n1.points.length - 1; c++)G1(r, t[c], t[c + 1]) || (e.push(n1.points[c]), r = t[c]);
    e.push(n1.points[n1.points.length - 1]);
    let i = n1.isClosed, s = e.length - (i ? 0 : 1), o = e.length, a = [];
    for(let c = 0; c < o; c++){
        let d = e[c].data, h = new _(...d.position), f = new _(...d.controlPrevious.position), p = new _(...d.controlNext.position), m = {
            position: h,
            baseRoundness: d.roundness,
            controlPrevious: f,
            controlNext: p
        };
        if (d.roundness === 0 || !n1.isClosed && (c === 0 || c === o - 1)) {
            a[c] = {
                ...m,
                removedLength: 0
            };
            continue;
        }
        let g = i && c == 0 ? o - 1 : c - 1, y = i && c == o - 1 ? 0 : c + 1, v = e[g].data, x = e[y].data, S = new _(...v.position), w = new _(...x.position), A = S.clone().sub(h).normalize(), E = w.clone().sub(h).normalize();
        Object.assign(m, {
            prevDir: A,
            nextDir: E
        });
        let b = z1(v, d), T = z1(d, x);
        if (!b || !T) a[c] = {
            ...m,
            removedLength: 0
        };
        else {
            let M = A.clone().add(E).normalize(), C = M.clone().cross(A).length() / A.dot(M);
            a[c] = {
                ...m,
                tan: C,
                removedLength: d.roundness / C
            };
        }
    }
    for(let c = 0; c < s; c++){
        let d = c, h = i && c === o - 1 ? 0 : c + 1, f = a[d], p = a[h];
        if (f.removedLength !== 0 || p.removedLength !== 0) {
            let m = f.position.distanceTo(p.position);
            f.removedLength = Math.min(f.removedLength, m / 2), p.removedLength = Math.min(p.removedLength, m / 2);
        }
    }
    let l = [];
    for(let c = 0; c < s; c++){
        let d = c, h = i && c === o - 1 ? 0 : c + 1, f = a[d], p = a[h], m = null;
        if (!z1(e[d].data, e[h].data)) f.position.distanceTo(p.position) > U1 && (m = new gc(f.position, f.controlNext, p.controlPrevious, p.position));
        else {
            let g = f.position.clone(), y = p.position.clone();
            (f.removedLength !== 0 || p.removedLength !== 0) && (f.nextDir && g.add(f.nextDir.clone().setLength(f.removedLength)), p.prevDir && y.add(p.prevDir.clone().setLength(p.removedLength))), g.distanceTo(y) > U1 && (m = new gc(g, g.clone().lerp(y, .3), y.clone().lerp(g, .3), y));
        }
        l[2 * c + 1] = m;
    }
    for(let c = 0; c < o; c++){
        let d = a[c];
        if (d.removedLength === 0) {
            l[2 * c] = null;
            continue;
        }
        let h = d.position, f = d.prevDir.clone().multiplyScalar(d.removedLength).add(h), p = d.nextDir.clone().multiplyScalar(d.removedLength).add(h), m = d.tan * d.removedLength, g = d.prevDir.clone().add(d.nextDir).normalize(), y = f.clone().lerp(p, .5), v = f.distanceTo(p) / 2, x = g.clone().multiplyScalar(Math.sqrt(Math.pow(m, 2) - Math.pow(v, 2))).add(y), S = g.clone().multiplyScalar(-m).add(x), w = h.distanceTo(S) / h.distanceTo(y), A = d.prevDir.clone().multiplyScalar(w * h.distanceTo(f)).add(h), E = A.clone().lerp(S, 2), b = f.clone().lerp(A, 4 / 3), T = p.clone().lerp(E, 4 / 3);
        l[2 * c] = new gc(f, b, T, p);
    }
    let u = new V1;
    return l.forEach((c)=>{
        c && u.add(c);
    }), u;
}
var ut;
((t)=>{
    function n1(e) {
        return e && e.__isEntity;
    }
    t.is = n1;
})(ut || (ut = {}));
var Mo = (n1)=>ut.is(n1), R9 = {
    type: "completeState",
    isfromEntity: !0
}, L9 = [
    "x",
    "y",
    "z"
], j1 = new _, B9 = new _().set(0, 1, 0), ph = (n1)=>class extends hh(n1) {
        constructor(){
            super(...arguments);
            this.raycastLock = !1;
            this.scaleLock = !1;
            this.disposed = !1;
            this.stateSelection = null;
            this.destroyedInAction = !1;
            this.instances = [];
            this.prevState = null;
            this.currentState = null;
            this.reversibleToState = null;
            this.currentTransitionEvent = null;
            this.previousAction = null;
            this._singleBBox = new rm;
            this._recursiveBBox = new rm;
            this.singleBBoxNeedsUpdate = !0;
            this.recursiveBBoxNeedsUpdate = !0;
            this._needApplyPathSnapping = !0;
            this.attachedPaths = new Set;
        }
        get __isEntity() {
            return !0;
        }
        entityChildren(r) {
            let i = this.children[r];
            if (ut.is(i)) return i;
        }
        entityChildrenCount() {
            let r = this.children.length;
            for(; r--;)if (ut.is(this.children[r])) return r + 1;
            return 0;
        }
        get isConcreteEntity() {
            return typeof this.identity == "string";
        }
        get isVirtualEntity() {
            return typeof this.identity != "string";
        }
        get isInstanceRoot() {
            return this.isConcreteEntity && this.data.type === "Instance";
        }
        nearestInstanceSelfOrParent() {
            let r = this;
            for(; r.data.type !== "Instance";){
                let i = r.parent;
                if (ut.is(i)) r = i;
                else return;
            }
            return r;
        }
        forInstancesRec(r) {
            this.instances.forEach((i)=>{
                i.disposed || r(i), i.forInstancesRec(r);
            });
        }
        super_Entity(r, i) {
            typeof r == "string" && (this.uuid = r), this.identity = r, this.data = i, this.matrixAutoUpdate = !1, this.dataPatched = this.data;
        }
        changeSelectedState(r, i, s = !1) {
            if (!(this.data.states.length === 0 && !s)) {
                for (let o of this.data.states)ga.toOps(this.data, o.data).forEach((l)=>{
                    let u = Rd.replaceProps(l, this.data);
                    this.dataPatched = this.data, this.updateByPatchedOp(u, this.data, i);
                });
                if (r !== null) {
                    let o = this.data.states.data(r);
                    o && (this.dataPatched = ga.patch(this.data, o), ga.toOps(this.data, o).forEach((l)=>{
                        this.updateByPatchedOp(l, this.dataPatched, i);
                    }));
                }
                s && this.updateTransformState(this.dataPatched, i), this.stateSelection = r, this.updatePathSnapping(this.dataPatched.pathSnapping);
            }
        }
        get singleBBox() {
            return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges(), this._singleBBox.computeFaces()), this._singleBBox;
        }
        get recursiveBBox() {
            return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges(), this._recursiveBBox.computeFaces()), this._recursiveBBox;
        }
        updateEntityBoxSize(r, i) {
            r.setScalar(0), i.setScalar(0);
        }
        resetBBoxNeedsUpdateSelf() {
            this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
        }
        resetBBoxNeedsUpdate() {
            this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((r)=>{
                Mo(r) && r.resetBBoxNeedsUpdateSelf();
            }), this.traverseEntity((r)=>{
                r.resetBBoxNeedsUpdateSelf();
            });
        }
        find(r) {
            let i;
            return this.traverseEntity((s)=>{
                s.uuid === r && (i = s);
            }), i;
        }
        traverseSortNextHelper() {
            let r = this.parent;
            if (r) {
                let i = r.children, s = i.indexOf(this) + 1;
                if (ut.is(i[s])) return i[s];
                if (ut.is(r)) return r.traverseSortNextHelper();
            }
        }
        sortNext() {
            let r = this.children;
            return this.children.length > 0 && ut.is(this.children[0]) ? r[0] : this.traverseSortNextHelper();
        }
        goUp(r) {
            let i = this;
            for(; r > 0 && i !== null;)i = i.parent, r -= 1;
            return i;
        }
        hasAnccestorOrSelf(r) {
            return this === r || this.hasAnccestor(r);
        }
        hasAnccestor(r) {
            let i = this.parent;
            for(; i;){
                if (r === i) return !0;
                i = i.parent;
            }
            return !1;
        }
        countToAccestor(r) {
            let i = 0, s = this;
            for(; s !== r;){
                if (s === null) return -1;
                s = s.parent, i += 1;
            }
            return i;
        }
        forEachEntity(r) {
            for (let i of this.children)Mo(i) && r(i);
        }
        traverseEntityAncestors(r) {
            this.traverseAncestors((i)=>{
                ut.is(i) && r(i);
            });
        }
        traverseConcreteEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Mo(o) && o.isConcreteEntity && o.traverseEntity(r, i + 1);
        }
        traverseEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Mo(o) && o.traverseEntity(r, i + 1);
        }
        traverseVisibleEntity(r) {
            r(this);
            for (let i of this.children)Mo(i) && i.visible && i.traverseVisibleEntity(r);
        }
        updateMatrix() {
            super.updateMatrix(), this.cloner && this.cloner.onObjUpdateMatrix(), this.dispatchEvent({
                type: "updateMatrix"
            });
        }
        updateMatrixWorld(r) {
            super.updateMatrixWorld(r), this.dispatchEvent({
                type: "updateMatrixWorld"
            });
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.dataPatched = r.dataPatched, this.raycastLock = r.raycastLock, this.scaleLock = r.scaleLock, this.hiddenMatrix.copy(r.hiddenMatrix), this;
        }
        hasEntityChild() {
            return this.children.some((r)=>Mo(r));
        }
        isAncestorOf(r) {
            if (this.uuid === r) return !1;
            let i = !1;
            return this.traverseEntity((s)=>{
                s.uuid === r && (i = !0);
            }), i;
        }
        toObjectTransformState(r = []) {
            this.updateWorldMatrix(!0, !1);
            let i = {
                position: this.position.toArray(),
                rotation: [
                    this.rotation.x * Se.RAD2DEG,
                    this.rotation.y * Se.RAD2DEG,
                    this.rotation.z * Se.RAD2DEG
                ],
                scale: this.scale.toArray(),
                hiddenMatrix: this.hiddenMatrix.toArray()
            };
            return Ed(i, r);
        }
        getTransformValues(r, i, s) {
            return i[r].map((o, a)=>s?.shared.getVariable(o, [
                    this.uuid,
                    r,
                    L9[a]
                ]) ?? o);
        }
        updateTransformState(r, i) {
            let s = !1;
            return r.position && (this.position.fromArray(this.getTransformValues("position", r, i)), s = !0), r.rotation && (j1.fromArray(this.getTransformValues("rotation", r, i)).multiplyScalar(Se.DEG2RAD), this.rotation.setFromVector3(j1), s = !0), r.scale && (this.scale.fromArray(this.getTransformValues("scale", r, i)), s = !0), r.hiddenMatrix !== void 0 && (s = !0, this.hiddenMatrix.fromArray(r.hiddenMatrix ?? yl.identity)), s && (this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((o)=>{
                o.invalidateClonerTransform(this);
            })), r.position && r.rotation && r.scale && r.hiddenMatrix !== void 0 && this.updateWorldMatrix(!1, !0), s;
        }
        onVariableUpdate(r = !1) {
            if (r) {
                this.resetBBoxNeedsUpdate();
                return;
            }
            this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((i)=>{
                i.invalidateClonerTransform(this);
            });
        }
        dispose() {
            this.disposed = !0, this.cloner && (this.cloner.removeFromParent(), this.cloner = void 0);
        }
        disposeChildrenRecursively() {
            for (let r of this.children)ut.is(r) && r.disposeRecursively();
        }
        disposeRecursively() {
            this.dispose(), this.children.forEach((r)=>{
                ut.is(r) && r.disposeRecursively();
            });
        }
        toState(r = []) {
            let i = {
                name: this.name,
                visible: this.visible,
                raycastLock: this.raycastLock,
                ...this.toObjectTransformState(r)
            };
            return Ed(i, r);
        }
        updateByObjUpdateOp(r, i) {
            r !== void 0 && this.updateByOp({
                type: 0,
                props: r,
                path: []
            }, {
                ...this.data,
                ...r
            }, i, !1);
        }
        updateByOp(r, i, s, o) {
            let a = this.data;
            this.data = i;
            let l = r, u = wt(r.path, [
                "states",
                "*"
            ]);
            if (u !== null) {
                if (r.type === 0) {
                    let [c] = u;
                    if (this?.stateSelection === c) {
                        let d = {
                            ...r.props
                        };
                        if (delete d.name, Object.values(r.props).some((h)=>h === void 0)) {
                            let h = this.data;
                            if (h !== void 0) {
                                let f = Tr.zoom(h, r.path.slice(2));
                                if (f) for(let p in r.props)r.props[p] === void 0 && p in f && (d[p] = f[p]);
                            }
                        }
                        l = {
                            ...r,
                            props: d,
                            path: r.path.slice(2)
                        };
                    }
                }
            } else if (r.type === 0) {
                let c = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
                if (c !== void 0) {
                    if (r.props.name !== void 0 && c.name) {
                        let { name: h, ...f } = c;
                        c = f;
                    }
                    if (r.props.material !== void 0 && "material" in c) {
                        let { material: h, ...f } = c;
                        c = f;
                    }
                    let d = Tr.removeOverridden(r.path, r.props, c);
                    l = {
                        ...r,
                        props: d
                    };
                }
            }
            if (this.updateByPatchedOpBase(l, ga.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), s), wt(r.path, [
                "overrides"
            ])) {
                let c = [], d = [
                    ...r.path
                ];
                for(c.push(d[1]), d.splice(0, 2); d.length > 0 && d[0] === "descendants";)c.push(d[1]), d.splice(0, 2);
                if (c[c.length - 1] === void 0) {
                    if (r.type === 0) for (let h of Object.keys(r.props)){
                        c[c.length - 1] = h;
                        let f = s.scene.findInstance([
                            this.uuid,
                            ...c
                        ]);
                        f && (f.overrideData = r.props[h], f.updateState(po.apply(f.component.data, f.overrideData), s));
                    }
                } else {
                    let h = s.scene.findInstance([
                        this.uuid,
                        ...c
                    ]);
                    if (h) {
                        let f = Tr.zoom(h.component.data, d);
                        if (r = {
                            ...r,
                            path: d
                        }, r.type === 0) {
                            let p = r.props;
                            if (f) for (let [m, g] of Object.entries(r.props))g === void 0 && (p === r.props && (p = {
                                ...r.props
                            }), p[m] = f[m]);
                            r = {
                                ...r,
                                props: p
                            };
                        }
                        h.overrideData = jd.resolve(i.overrides, c), h.updateByOp(r, Mr.applySimple(h.data, r), s, !1);
                    }
                }
            } else if (this.instances.length > 0) {
                let c;
                if (r.path.length === 0 && r.type === 0) {
                    let d;
                    for (let h of wo.rootOverrideProps)h in r.props && (d === void 0 && (d = {}), d[h] = r.props[h]);
                    d && (c = {
                        ...r,
                        props: d
                    });
                } else for (let d of wo.rootOverrideProps)if (wt(r.path, [
                    d
                ])) {
                    c = r;
                    break;
                }
                c !== void 0 && this.instances.forEach((d)=>{
                    if (d.isInstanceRoot) {
                        let h = po.filterOp(d.overrideData, c);
                        h && d.updateByOp(h, Mr.applySimple(d.data, h), s, !0);
                    }
                }), this.instances.forEach((d)=>{
                    if (!d.isInstanceRoot) {
                        let h = po.filterOp(d.overrideData, r);
                        if (h) {
                            let f;
                            a === d.data && r === h ? f = i : f = Mr.applySimple(d.data, h), d.updateByOp(h, f, s, !0);
                        }
                    }
                });
            }
        }
        updateByPatchedOpBase(r, i, s) {
            if (this.dataPatched = i, r.path.length === 0 && r.type === 0) r.props.type !== void 0 && !ks.is(r.props.type) && Gs.changeEntityProptotype(this, i, s);
            else if (r.path.length === 1 && r.path[0] === "geometry" && r.type === 0 && "type" in r.props) {
                Gs.changeEntityProptotype(this, i, s);
                for (let o of this.children)ut.is(o) && o.updateVisible(s.scene);
            }
            this.updateByPatchedOp(r, i, s);
        }
        updateByPatchedOp(r, i, s) {
            if (r.path.length === 0 && r.type === 0 && this.updateState(r.props, s), wt(r.path, [
                "pathSnapping"
            ]) !== null && this.updatePathSnapping(i.pathSnapping), wt(r.path, [
                "cloner"
            ]) !== null) {
                let o = Mr.drop(r, 1);
                o.path.length === 0 && o.type === 0 && o.props.disabled === !0 ? this.setFromClonerState(null, s) : this.cloner ? this.cloner.updateState(i.cloner, s.scene) : (this.setFromClonerState(i.cloner, s), this.expandCloner(s.scene)), this.updateVisible(s.scene);
            }
        }
        updatePathSnapping(r = this.dataPatched.pathSnapping) {
            this._updatedPathSnapping = r, this._needApplyPathSnapping = !0;
        }
        get updatedPathSnapping() {
            return this._updatedPathSnapping;
        }
        applyPathSnapping(r) {
            let i = this._updatedPathSnapping?.pathId ?? this.dataPatched.pathSnapping.pathId, s = this._updatedPathSnapping?.slide ?? this.dataPatched.pathSnapping.slide ?? 0, o = this._updatedPathSnapping?.offset ?? this.dataPatched.pathSnapping.offset ?? 0, a = this._updatedPathSnapping?.orientation ?? this.dataPatched.pathSnapping.orientation;
            if (i === null) return;
            let l = r.find(i);
            if (!l || this._needApplyPathSnapping === !1) return;
            this._needApplyPathSnapping = !1;
            let u = l.data;
            if (u.geometry.path.points.length <= 1) return;
            let c = p0(u.geometry.path), d = (s + o) % 1;
            s + o === 1 && d === 0 && (d = 1);
            let h = c.getPointAt(d);
            if (h === null) return;
            let f = this.parent ? this.parent?.matrixWorld : new te;
            l.updateMatrixWorld();
            let p = new te().multiplyMatrices(f.clone().invert(), l.matrixWorld);
            h.applyMatrix4(p);
            let m = {
                position: h.toArray(),
                rotation: u.rotation
            };
            if (a === "tangential") {
                let g = new te().extractRotation(l.matrixWorld), y = c.getTangentAt(d).applyMatrix4(g).add(h), v = new te().lookAt(h, y, B9), x = j1.setFromEuler(new Kt().setFromRotationMatrix(v)).multiplyScalar(Se.RAD2DEG);
                m = {
                    ...m,
                    rotation: x.toArray()
                };
            }
            this.updateTransformState(m), this.traverseEntity((g)=>{
                g._cameraType && g.dispatchEvent(R9);
            });
        }
        updateVisible(r) {
            if (this.visible = this.dataPatched.visible && (!this.dataPatched.cloner || (this.dataPatched.cloner.disabled ?? !1) || this.dataPatched.cloner?.hideBase !== !0), !r) return;
            let i = !1;
            this.traverseEntity((s)=>{
                if (s.data.type === "Splat") return i = !0, !0;
            }), i && r.reloadSplats();
        }
        updateState_Entity(r, i) {
            r.name !== void 0 && (this.name = r.name), r.raycastLock !== void 0 && (this.raycastLock = r.raycastLock), r.visible !== void 0 && (this.updateVisible(i?.scene), this.resetBBoxNeedsUpdate()), i && "cloner" in r && r.cloner !== void 0 && (this.setFromClonerState(r.cloner, i), this.updateVisible(i.scene)), this.updateTransformState(r, i);
        }
        get attachedSurfaceCloners() {
            return this.children.filter((r)=>r instanceof Gs.Cloner && r.parameters.type === "toObject");
        }
        setFromClonerState(r, i) {
            this.disposed || (r === null || r.disabled ? (this.cloner && this.cloner.removeFromParent(), this.cloner = void 0) : this.cloner === void 0 ? (this.cloner = new Gs.Cloner(this, r), i.scene.addPendingExpandCloner(this)) : this.cloner.updateState(r, i.scene));
        }
        expandCloner(r) {
            !this.disposed && this.cloner && this.cloner.expandClones(r);
        }
        invalidateClonerTransform(r) {
            this.cloner && this.cloner.invalidateTransform(r);
        }
        requestRender() {
            this.dispatchEvent({
                type: "requestRender"
            });
        }
    };
var m0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 64,
            heightSegments: 1,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadius: 8,
            cornerSegments: 8,
            hollow: 0
        }, n1.parameters);
        e.thetaLength = Se.clamp(e.thetaLength, 0, 360);
        let r = e.width / 2, i = e.radiusTop ?? r, s = e.radiusBottom ?? r;
        return i === s ? (i = r, s = r) : i > s ? (i = r, s = s * r / i) : (i = i * r / s, s = r), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                radiusTop: i,
                radiusBottom: s
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s, openEnded: o, thetaStart: a, thetaLength: l, radiusTop: u, radiusBottom: c, cornerRadius: d, cornerSegments: h, hollow: f } = n1.parameters, p;
        return l === 0 ? (p = new we, p.setAttribute("position", new be([], 3))) : d || f ? p = new im(u, c, r, i, s, o, a, l * Math.PI / 180, d, d, h, f) : p = new vc(u, c, r, i, s, o, a, l * Math.PI / 180), p.scale(1, 1, e / t), Object.assign(p, {
            userData: {
                ...n1,
                type: "CylinderGeometry"
            }
        });
    }
};
function Ml(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function vO(n1) {
    return new N(n1.y, -n1.x);
}
var im = class extends we {
    constructor(t, e, r, i, s, o, a, l, u, c, d, h, f = !1){
        super(), this.type = "RoundedCylinderBufferGeometry", t = t !== void 0 ? t : 1, e = e !== void 0 ? e : 1, r = r || 1, i = Math.floor(i) || 8, s = Math.floor(s) || 1, o = o !== void 0 ? o : !1, a = a !== void 0 ? a : 0, l = l !== void 0 ? l : Math.PI * 2, o && (u = 0, c = 0);
        let p = [], m = [], g = [], y = [], v = 0, x = r / 2, S = new _, w = new _;
        f && t == 0 && (t = u), f && e == 0 && (e = c);
        let A = new N(t, x), E = new N(e, -x), b = null, T = null, M = null, C = null, P = A.clone().sub(E), D = 0, O = 0, I = 0;
        h > 0 && (D = Math.min(t, e) * (1 - h), O = t - D, I = e - D);
        let z = A.clone();
        z.x -= D;
        let B = Math.PI - P.angle(), V = P.angle(), U = Math.tan(V / 2), j = Math.tan(B / 2), W = U + j, k = h ? W : j, H = h ? W : U;
        if (u = Math.min(u, (t - O) / k, P.length() / W), c = Math.min(c, (e - I) / H, P.length() / W), u > 0) {
            let K = u / U;
            b = A.clone().sub(new N(K, u)), h && (M = b.clone(), M.x -= D - W * u), A.sub(P.clone().setLength(K));
        }
        if (c > 0) {
            let K = c / j;
            T = E.clone().sub(new N(K, -c)), E.add(P.clone().setLength(K)), h && (C = T.clone(), C.x -= D - W * c, z.sub(P.clone().setLength(K)));
        }
        P = A.clone().sub(E);
        let X = P.length() < .5, q = [];
        for(let K = 0; K <= i; K++){
            let Y = [], ye = K / i, fe = ye * l + a, oe = new N(Math.sin(fe), Math.cos(fe));
            C && T ? (G(Y, ye, oe, B, c, C, -1, !0), G(Y, ye, oe, V, c, T, -1, !1)) : T ? (J(Y, oe, T.x, 0, -1), G(Y, ye, oe, V, c, T, -1, !1)) : o || J(Y, oe, e, I, -1);
            let _e = vO(P).normalize();
            if (Ml(_e, oe, S), !X) for(let xe = 0; xe <= s; xe++){
                let Ie = xe / s, Oe = P.clone().multiplyScalar(Ie).add(E);
                Ml(Oe, oe, w), m.push(w.x, w.y, w.z), g.push(S.x, S.y, S.z), y.push(ye, .5 + w.y / r), Y.push(v++);
            }
            if (M && b ? (G(Y, ye, oe, B, u, b, 1, !1), G(Y, ye, oe, V, u, M, 1, !0)) : b ? (G(Y, ye, oe, B, u, b, 1, !1), J(Y, oe, b.x, 0, 1)) : o || J(Y, oe, t, O, 1), h && !X) {
                let xe = vO(P).multiplyScalar(-1).normalize();
                Ml(xe, oe, S);
                for(let Ie = 0; Ie <= s; Ie++){
                    let Oe = Ie / s, Pe = P.clone().multiplyScalar(-Oe).add(z);
                    Ml(Pe, oe, w), m.push(w.x, w.y, w.z), g.push(S.x, S.y, S.z), y.push(ye, .5 + w.y / r), Y.push(v++);
                }
            }
            h && !o && Y.push(Y[0]), q.push(Y);
        }
        for(let K = 0; K < q.length - 1; K++)for(let Y = 0; Y < q[0].length - 1; Y++){
            if (o && h && Y == s) continue;
            let ye = q[K][Y], fe = q[K + 1][Y], oe = q[K + 1][Y + 1], _e = q[K][Y + 1], xe = m[oe * 3 + 0], Ie = m[oe * 3 + 2];
            p.push(ye, fe, _e), (xe != 0 || Ie != 0) && p.push(fe, oe, _e);
        }
        l < Math.PI * 2 && (Z(-1, q[0], a), Z(1, q[q.length - 1], a + l)), this.setIndex(p), this.setAttribute("position", new be(m, 3)), this.setAttribute("normal", new be(g, 3)), this.setAttribute("uv", new be(y, 2));
        function G(K, Y, ye, fe, oe, _e, xe, Ie) {
            for(let Oe = 0; Oe < d + 1; Oe++){
                let Pe = Oe / d, Te = xe < 0 ? Pe : 1 - Pe;
                Ie && (Te -= 1), Te *= fe;
                let Ve = new N(Math.sin(Te), Math.cos(Te) * xe), Ue = Ve.clone().multiplyScalar(oe).add(_e);
                Ml(Ue, ye, w), m.push(w.x, w.y, w.z), Ml(Ve, ye, S), g.push(S.x, S.y, S.z), y.push(Y, .5 + w.y / r), K.push(v++);
            }
        }
        function J(K, Y, ye, fe, oe) {
            let _e = new _, xe = new N, Ie = [
                ye,
                fe
            ];
            oe < 0 && Ie.reverse();
            for (let Oe of Ie)xe.set(Oe, x * oe), Ml(xe, Y, _e), m.push(_e.x, _e.y, _e.z), g.push(0, oe, 0), y.push(.5, .5), K.push(v++);
        }
        function Z(K, Y, ye) {
            let fe = new N(Math.sin(ye), Math.cos(ye)), oe = new N(-Math.cos(ye), Math.sin(ye)), _e = new _, xe = K < 0 ? (Pe, Te, Ve)=>p.push(Pe, Te, Ve) : (Pe, Te, Ve)=>p.push(Pe, Ve, Te), Ie = new N((t + e + O + I) / 4, 0);
            Ml(Ie, fe, _e), m.push(_e.x, _e.y, _e.z), g.push(oe.x, 0, oe.y), y.push(.5, .5);
            let Oe = v++;
            for (let Pe of Y){
                let Te = m.slice(Pe * 3, Pe * 3 + 3);
                m.push(...Te), g.push(oe.x, 0, oe.y);
                let Ve = y.slice(Pe * 2, Pe * 2 + 2);
                y.push(...Ve), v++;
            }
            for(let Pe = Oe + 1; Pe < v - 1; Pe++)xe(Oe, Pe, Pe + 1);
            xe(Oe, v - 1, Oe + 1);
        }
    }
};
var xO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            heightSegments: 8,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadiusTop: 8,
            cornerRadiusBottom: 8,
            cornerSegments: 8
        }, n1.parameters);
        return e.thetaLength = Se.clamp(e.thetaLength, 0, 360), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s, openEnded: o, thetaStart: a, thetaLength: l, cornerRadiusTop: u, cornerRadiusBottom: c, cornerSegments: d } = n1.parameters, h;
        return l === 0 ? (h = new we, h.setAttribute("position", new be([], 3))) : u > 0 || c > 0 || l < 360 ? h = new im(0, t / 2, r, i, s, o, a, l * Math.PI / 180, u, c, d, 0, !0) : h = new $a(t / 2, r, i, s, o), h.scale(1, 1, e / t), Object.assign(h, {
            userData: {
                ...n1,
                type: "ConeGeometry"
            }
        });
    }
};
var bO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 1,
            heightSegments: 1,
            depthSegments: 1,
            cornerRadius: 8,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, widthSegments: i, heightSegments: s, depthSegments: o, cornerRadius: a, cornerSegments: l } = n1.parameters, u;
        return a == 0 ? u = new li(t, e, r, i, s, o) : u = new W1(t, e, r, i, s, o, a, l), Object.assign(u, {
            userData: {
                ...n1,
                type: "CubeGeometry"
            }
        });
    }
}, H1 = Math.PI / 2, W1 = class extends we {
    constructor(t = 1, e = 1, r = 1, i = 1, s = 1, o = 1, a = 0, l = 4){
        super(), this.type = "BoxGeometry";
        let u = this;
        i = Math.floor(i), s = Math.floor(s), o = Math.floor(o), l = Math.floor(l), a = Math.min(a, t / 2, e / 2, r / 2);
        let c = [], d = [], h = [], f = [], p = 0, m = 0;
        g("z", "y", "x", -1, -1, r, e, t, o, s, 0), g("z", "y", "x", 1, -1, r, e, -t, o, s, 1), g("x", "z", "y", 1, 1, t, r, e, i, o, 2), g("x", "z", "y", 1, -1, t, r, -e, i, o, 3), g("x", "y", "z", 1, -1, t, e, r, i, s, 4), g("x", "y", "z", -1, -1, t, e, -r, i, s, 5), a > 0 && (y("z", "y", "x", -1, -1, 1, r, e, t, o, 0), y("z", "y", "x", 1, -1, -1, r, e, t, o, 1), y("z", "y", "x", -1, 1, -1, r, e, t, o, 1), y("z", "y", "x", 1, 1, 1, r, e, t, o, 0), y("x", "y", "z", -1, -1, -1, t, e, r, i, 0), y("x", "y", "z", 1, -1, 1, t, e, r, i, 1), y("x", "y", "z", -1, 1, 1, t, e, r, i, 0), y("x", "y", "z", 1, 1, -1, t, e, r, i, 1), y("y", "x", "z", -1, -1, 1, e, t, r, s, 0), y("y", "x", "z", 1, -1, -1, e, t, r, s, 1), y("y", "x", "z", 1, 1, 1, e, t, r, s, 1), y("y", "x", "z", -1, 1, -1, e, t, r, s, 0), v(1, 1, 1), v(-1, 1, 1), v(1, -1, 1), v(-1, -1, 1), v(1, 1, -1), v(-1, 1, -1), v(1, -1, -1), v(-1, -1, -1)), this.setIndex(c), this.setAttribute("position", new be(d, 3)), this.setAttribute("normal", new be(h, 3)), this.setAttribute("uv", new be(f, 2));
        function g(x, S, w, A, E, b, T, M, C, P, D) {
            let O = (b - 2 * a) / C, I = (T - 2 * a) / P, z = b / 2 - a, B = T / 2 - a, V = M / 2, U = C + 1, j = P + 1, W = 0, k = 0, H = new _;
            for(let X = 0; X < j; X++){
                let q = X * I - B;
                for(let G = 0; G < U; G++){
                    let J = G * O - z;
                    H[x] = J * A, H[S] = q * E, H[w] = V, d.push(H.x, H.y, H.z), H[x] = 0, H[S] = 0, H[w] = M > 0 ? 1 : -1, h.push(H.x, H.y, H.z), f.push(G / C), f.push(1 - X / P), W += 1;
                }
            }
            for(let X = 0; X < P; X++)for(let q = 0; q < C; q++){
                let G = p + q + U * X, J = p + q + U * (X + 1), Z = p + (q + 1) + U * (X + 1), K = p + (q + 1) + U * X;
                c.push(G, J, K), c.push(J, Z, K), k += 6;
            }
            u.addGroup(m, k, D), m += k, p += W;
        }
        function y(x, S, w, A, E, b, T, M, C, P, D) {
            let O = (T - 2 * a) / P, I = T / 2 - a, z = M / 2 - a, B = C / 2, V = P + 1, U = 0, j = 0, W = new _, k = new _;
            for(let H = 0; H < l + 1; H++){
                let X = H / l * H1, q = Math.sin(X) * a, G = (1 - Math.cos(X)) * a, J = Math.sin(X), Z = Math.cos(X);
                W[S] = (z + q) * E, W[w] = (B - G) * b, k[x] = 0, k[S] = J * Math.sign(W[S]), k[w] = Z * Math.sign(W[w]);
                for(let K = 0; K < V; K++){
                    let Y = K * O - I;
                    W[x] = Y * A, d.push(W.x, W.y, W.z), h.push(k.x, k.y, k.z), f.push(K / P), f.push(0), U += 1;
                }
            }
            for(let H = 0; H < l; H++)for(let X = 0; X < P; X++){
                let q = p + X + V * H, G = p + X + V * (H + 1), J = p + (X + 1) + V * (H + 1), Z = p + (X + 1) + V * H;
                c.push(q, G, Z), c.push(G, J, Z), j += 6;
            }
            u.addGroup(m, j, D), m += j, p += U;
        }
        function v(x, S, w) {
            let A = new _, E = new _(t / 2, e / 2, r / 2);
            E.subScalar(a);
            let b = [], T = x * S * w > 0 ? (C, P, D)=>c.push(C, P, D) : (C, P, D)=>c.push(C, D, P);
            for(let C = 0; C <= l; C++){
                let P = [], D = H1 * (1 - C / l), O = Math.cos(D), I = Math.sin(D), z = 0;
                for(let B = 0; B <= C; B++){
                    let V = Math.cos(z), U = Math.sin(z);
                    A.x = O * V, A.y = I, A.z = O * U;
                    let j = E.clone().addScaledVector(A, a);
                    d.push(x * j.x, S * j.y, w * j.z), h.push(x * A.x, S * A.y, w * A.z), f.push(0, 0), P.push(p++), z += H1 / C;
                }
                b.push(P);
            }
            let M = b.length - 1;
            for(let C = 0; C < M; C++){
                let P = b[C], D = b[C + 1], O = P.length - 1;
                T(P[0], D[1], D[0]);
                for(let I = 1; I <= O; I++)T(P[I - 1], P[I], D[I]), T(P[I], D[I + 1], D[I]);
            }
        }
    }
};
var Cl = class extends we {
    constructor(t = [], e = [], r = "", i = 1, s = .2, o = 4){
        super(), this.type = "PolyhedronGeometryRound";
        let a = [], l = [], u = [];
        c(), d(), this.setAttribute("position", new be(a, 3)), this.setAttribute("normal", new be(u, 3)), this.setAttribute("uv", new be(l, 2));
        return;
        function c() {
            s = Math.min(1 - 1e-5, s), s == 0 && (o = 0);
            let f = {
                IcosahedronGeometry: 5,
                DodecahedronGeometry: 3,
                HexahedronGeometry: 3,
                OctahedronGeometry: 4,
                TetrahedronGeometry: 3
            }[r], p = new _, m = p.clone(), g = new vr, y = s * i, v = i - y, x = o + 1, S = new _, w = (U, j)=>S.subVectors(U, j).normalize(), A = (U, j)=>Array(U).fill(void 0).map(j), E = A(t.length / 3, (U, j)=>new _().fromArray(t, j * 3).setLength(i)), b = [], T = 1e6;
            for(let U = 0; U < E.length; U++){
                let j = E[U], W = [], k, H, X, q = 1e10, G = -1;
                for(; (G = e.indexOf(U, G + 1)) != -1;){
                    let Y = G - G % 3;
                    k = e[Y + (G + 1) % 3], H = e[Y + (G + 2) % 3], X = j.distanceToSquared(E[k]), q = Math.min(q, X), W.push([
                        k,
                        H,
                        X
                    ]);
                }
                q += 1e-6;
                let J = [], Z = 0, K = W.length;
                for(let Y = 0; Y < K; Y++){
                    [k, H, X] = W[Z];
                    let ye = b[k]?.includes(U) == !0;
                    X <= q && J.push(k + +ye * T), Z = W.findIndex((fe)=>fe[0] == H);
                }
                b.push(J);
            }
            let M = [];
            {
                let U = 0, j = 0, W, k, H = f == 3;
                for(let X = 0; X <= o; X++){
                    W = X * (X + 1) / 2, k = (X + 1) * (X + 2) / 2;
                    for(let q = 0; q < o - X; q++)[U, j] = [
                        W + q + X + 2,
                        k + q + X + 3
                    ], M.push(W, k, ...H ? [
                        j,
                        W
                    ] : [
                        U,
                        k
                    ], j, U), [W, k] = [
                        U,
                        j
                    ];
                    M.push(W, k, W + o + 2);
                }
            }
            let C = p.clone(), P = p.clone(), D = p.clone(), O = p.clone(), I = p.clone(), z = [], B = A(E.length, ()=>A(f, ()=>p.clone()));
            for(let U = 0; U < E.length; U++){
                p.copy(E[U]).normalize(), C.copy(p).multiplyScalar(v);
                let j = b[U];
                for(let J = 0; J < j.length; J++){
                    let Z = j[J], K = j[(J + 1) % f];
                    g.setFromPointsAndIndices(E, U, Z % T, K % T), g.b.sub(g.a).setLength(1e10).add(g.a), g.c.sub(g.a).setLength(1e10).add(g.a), g.closestPointToPoint(C, B[U][J]);
                }
                let W = [], k = [], H = [], X = new _;
                o == 0 && [
                    ...B[U]
                ].reduce((J, Z)=>J.add(Z), X).multiplyScalar(1 / f);
                for(let J = 0; J < f; J++){
                    let Z = [], K = (J - 1 + f) % f, Y = B[U][K], ye = B[U][J];
                    p.copy(Y).sub(C), m.copy(ye).sub(C);
                    let fe = C.angleTo(p), oe = p.angleTo(m), _e = Math.cos(fe) * y;
                    o == 0 ? P.copy(X) : P.copy(C).setLength(v + _e), k.push(_e);
                    let xe = [
                        P,
                        Y,
                        ye
                    ];
                    for(let Ie = 0; Ie < 2; Ie++){
                        let Oe = xe[Ie], Pe = xe[Ie + 1];
                        O.subVectors(Oe, C), I.subVectors(Pe, C), D.crossVectors(O, I).normalize();
                        for(let Te = 0; Te < x; Te++){
                            let Ve = [
                                fe,
                                oe
                            ][Ie] * Te / x;
                            p.copy(O).applyAxisAngle(D, Ve).add(C), W.push(p.clone()), Ie && (w(p, C), Z.push([
                                Te == 0 ? Oe : p.clone(),
                                S.clone()
                            ]));
                        }
                        Ie && (w(Pe, C), Z.push([
                            Pe,
                            S.clone()
                        ]));
                    }
                    H.push(Z);
                }
                z.push(H);
                let q = 2 * x, G = 2;
                for(let J = 0; J < f; J++){
                    let Z = q * J, K = q * ((J + 1) % f), Y = [
                        W[Z]
                    ];
                    for(let fe = 1; fe < x; fe++){
                        O = W[Z + fe], I = W[K + fe], Y.push(O);
                        for(let oe = 1, _e = fe - G + 1; oe <= _e; oe++)p.lerpVectors(O, I, oe / (_e + 1)), p.sub(C).setLength(k[J]).add(C), Y.push(p.clone());
                        Y.push(I);
                    }
                    for(let fe = 0; fe < x; fe++)Y.push(W[fe + x + Z]);
                    Y.push(W[K + x]);
                    let ye = M.map((fe)=>Y[fe]);
                    a.push(...ye.map((fe)=>[
                            fe.x,
                            fe.y,
                            fe.z
                        ]).flat()), u.push(...ye.map((fe)=>(w(fe, C), [
                            S.x,
                            S.y,
                            S.z
                        ])).flat());
                }
            }
            let V = [];
            for(let U = 0; U < b.length; U++)for(let j = 0; j < f; j++){
                let W = b[U][j];
                if (W < T) {
                    let k = b[W].findIndex((q)=>q % T == U), H = z[U][j], X = z[W][k];
                    for(let q = 0; q < x; q++){
                        let G = H[q], J = X[x - q], Z = H[q + 1], K = X[x - (q + 1)];
                        [
                            G,
                            J,
                            Z,
                            Z,
                            J,
                            K
                        ].forEach((Y)=>{
                            a.push(Y[0].x, Y[0].y, Y[0].z), u.push(Y[1].x, Y[1].y, Y[1].z);
                        });
                    }
                    V.push(H[0][0], X[x][0], H[x][0], X[0][0]);
                }
            }
            for(; V.length;){
                let U, j, W, k;
                [U, j] = V.splice(0, 2);
                let H = [
                    U
                ];
                for(; U != j;)H.push(j), W = V.indexOf(j), k = W % 2, j = V.splice(W - k, 2)[1 - k];
                S.subVectors(H[0], H[1]).cross(p.subVectors(H[0], H[2])).normalize();
                let X = S.dot(H[0]) < 0;
                X && S.negate();
                for(let q = 1; q <= H.length - 2; q++)[
                    H[q + +X],
                    H[q + 1 - +X],
                    H[0]
                ].forEach((G)=>{
                    a.push(G.x, G.y, G.z), u.push(S.x, S.y, S.z);
                });
            }
        }
        function d() {
            let h = new _;
            for(let E = 0; E < a.length; E += 3){
                h.x = a[E + 0], h.y = a[E + 1], h.z = a[E + 2];
                let b = w(h) / 2 / Math.PI + .5, T = A(h) / Math.PI + .5;
                l.push(b, 1 - T);
            }
            let f = new _, p = new _, m = new _, g = new _, y = new N, v = new N, x = new N, S = (E, b, T, M)=>{
                M < 0 && E.x === 1 && (l[b] = E.x - 1), T.x === 0 && T.z === 0 && (l[b] = M / 2 / Math.PI + .5);
            };
            for(let E = 0, b = 0; E < a.length; E += 9, b += 6){
                f.set(a[E + 0], a[E + 1], a[E + 2]), p.set(a[E + 3], a[E + 4], a[E + 5]), m.set(a[E + 6], a[E + 7], a[E + 8]), y.set(l[b + 0], l[b + 1]), v.set(l[b + 2], l[b + 3]), x.set(l[b + 4], l[b + 5]), g.copy(f).add(p).add(m).divideScalar(3);
                let T = w(g);
                S(y, b + 0, f, T), S(v, b + 2, p, T), S(x, b + 4, m, T);
            }
            for(let E = 0; E < l.length; E += 6){
                let b = l[E + 0], T = l[E + 2], M = l[E + 4], C = Math.max(b, T, M), P = Math.min(b, T, M);
                C > .9 && P < .1 && (b < .2 && (l[E + 0] += 1), T < .2 && (l[E + 2] += 1), M < .2 && (l[E + 4] += 1));
            }
            function w(E) {
                return Math.atan2(E.z, -E.x);
            }
            function A(E) {
                return Math.atan2(-E.y, Math.sqrt(E.x * E.x + E.z * E.z));
            }
        }
    }
    static fromJSON(t) {
        return new Cl(t.vertices, t.indices, t.radius, t.corner, t.cornerSides);
    }
};
var SO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s, cornerSides: o } = n1.parameters, a = i === 0 && s !== 0 ? new nm(t * .5, s, o) : new Nu(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "DodecahedronGeometry"
            }
        });
    }
}, nm = class extends Cl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = 1 / i, o = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            0,
            -i,
            0,
            -s,
            i,
            0,
            -s,
            -i,
            0,
            s,
            i,
            0,
            s
        ], a = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ], l = "DodecahedronGeometry";
        super(o, a, l, t, e, r), this.type = l;
    }
    static fromJSON(t) {
        return new nm(t.radius, t.corner, t.cornerSides);
    }
};
var sm = 1e-12, mh = class {
    constructor(t){
        this.position = new N;
        this.startPosition = new N;
        this.uuid = Se.generateUUID();
        this.position = t.clone();
    }
    start() {
        this.reset();
    }
    reset() {
        this.startPosition.copy(this.position);
    }
    applyOffset(t) {
        this.position.copy(this.startPosition).add(t);
    }
    copy(t) {
        return this.position.copy(t.position), this.startPosition.copy(t.startPosition), this;
    }
    clone() {
        return new mh(this.position).copy(this);
    }
    toJSON() {
        return [
            this.position.x,
            this.position.y
        ];
    }
}, gh = class extends mh {
    constructor(e){
        super(e.position);
        this.parent = e;
    }
    copy(e) {
        return super.copy(e), this;
    }
    clone() {
        return new gh(this.parent).copy(this);
    }
}, js = class extends mh {
    constructor(e, r){
        super(r);
        this.controls = [];
        this.roundness = 0;
        this.areControlsDirectionsMirrored = !0;
        this.uuid = e, this.controls.push(new gh(this), new gh(this));
    }
    static create(e, r) {
        let i = new js(e, new N(...r.position));
        return i.controls[0].position.set(...r.controlPrevious.position), i.controls[1].position.set(...r.controlNext.position), i.roundness = r.roundness, i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored, i;
    }
    getOppositeControl(e) {
        let r = this.controls.indexOf(e);
        return r === 0 ? this.controls[1] : r === 1 ? this.controls[0] : null;
    }
    applyOffsetToControls(e, r = 1) {
        for(let i = 0, s = this.controls.length; i < s; i++){
            let o = this.controls[i];
            this.position.distanceTo(o.position) <= r ? o.position.copy(this.position) : o.applyOffset(e);
        }
    }
    controlsMoved() {
        return !(this.position.equals(this.controls[0].position) && this.position.equals(this.controls[1].position));
    }
    copy(e) {
        return super.copy(e), this.controls[0].copy(e.controls[0]), this.controls[1].copy(e.controls[1]), this.roundness = e.roundness, this.uuid = e.uuid, this;
    }
    clone() {
        return new js(this.uuid, this.position).copy(this);
    }
    toJSON() {
        return super.toJSON().concat(this.controls[0].toJSON(), this.controls[1].toJSON(), [
            this.roundness
        ]);
    }
    computeTangents() {
        let e = this.curveBefore?.getTangentAt(1), r = this.curveAfter?.getTangentAt(0);
        return [
            e,
            r
        ];
    }
    computeNormals(e = new N, r = new N) {
        let [i, s] = this.computeTangents();
        return i && s && (wO(i, e), wO(s, r)), [
            e,
            r
        ];
    }
    computeTangent(e = new N) {
        let [r, i] = this.computeTangents();
        return r && i && e.copy(r).add(i).normalize(), e;
    }
    computeNormal(e = new N) {
        let [r, i] = this.computeNormals();
        return e.copy(r).add(i).normalize(), e;
    }
};
function wO(n1, t = new N) {
    let e = n1.length();
    return t.set(-n1.y / e, n1.x / e);
}
var Y1 = (n1)=>n1, yh = new N, g0 = new N, N9 = new N, F9 = new N, k9 = new N, z9 = new N, _O = new _, EO = new _;
function TO(n1) {
    let t = new N;
    t.addVectors(n1.v0, yh.subVectors(n1.v1, n1.v0).multiplyScalar(2 / 3));
    let e = new N;
    return e.addVectors(n1.v2, g0.subVectors(n1.v1, n1.v2).multiplyScalar(2 / 3)), new rn(n1.v0, t, e, n1.v2);
}
function om(n1, t, e = Number.EPSILON) {
    return Math.abs(n1 - t) < e;
}
function V9(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function U9(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function X1(n1, t, e) {
    let r = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), i = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)), s = Math.sqrt(Math.pow(e.x - n1.x, 2) + Math.pow(e.y - n1.y, 2));
    return Math.acos((i * i + r * r - s * s) / (2 * i * r));
}
function MO(n1, t, e) {
    return AO(n1, t) && AO(t, e) && q1(n1.position, t.position, e.position);
}
function q1(n1, t, e) {
    return yh.copy(t).sub(n1).cross(g0.copy(e).sub(n1)) === 0;
}
function CO(n1, t, e, r, i) {
    let s = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), o = (n1.y + t.y) / 2, a = (n1.x + t.x) / 2, l = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (n1.y - t.y) / s, u = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (t.x - n1.x) / s;
    return r.set(a + l, o + u), i.set(a - l, o - u), [
        r,
        i
    ];
}
function PO(n1, t, e) {
    let r = n1.distanceTo(e), i = t.distanceTo(e);
    return r < i ? t : n1;
}
function DO(n1, t, e, r, i, s) {
    let o = t.x - n1.x, a = t.y - n1.y, l = e.x - n1.x, u = e.y - n1.y, c = Math.sqrt((o + l) * (o + l) + (a + u) * (a + u)), d;
    return X1(t, n1, e) > Math.PI && (c *= -1), om(u, a) ? d = (a + u) * (r / c - .5) * 8 / 3 / (o - l) : d = (o + l) * (r / c - .5) * 8 / 3 / (u - a), i.set(t.x - d * a, t.y + d * o), s.set(e.x + d * u, e.y - d * l), [
        i,
        s
    ];
}
function Q1(n1, t) {
    return n1.position.equals(n1.controls[1].position) && t.position.equals(t.controls[0].position);
}
function AO(n1, t) {
    return q1(n1.position, n1.controls[1].position, t.position) && q1(n1.position, t.controls[0].position, t.position);
}
function OO(n1, t, e, r, i = .5) {
    let s = yh.subVectors(t, n1).multiplyScalar(i).add(n1), o = g0.subVectors(e, t).multiplyScalar(i).add(t), a = N9.subVectors(r, e).multiplyScalar(i).add(e), l = s, u = F9.subVectors(o, s).multiplyScalar(i).add(s), c = k9.subVectors(a, o).multiplyScalar(i).add(o), d = a, h = z9.subVectors(c, u).multiplyScalar(i).add(u);
    return [
        n1.x,
        n1.y,
        l.x,
        l.y,
        u.x,
        u.y,
        h.x,
        h.y,
        c.x,
        c.y,
        d.x,
        d.y,
        r.x,
        r.y
    ];
}
function IO(n1, t, e = 12, r = !0) {
    let i = EO.set(0, 0, 0), s, o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        let u = Y1(t[l]), c = yh, d = Pl(u, e);
        a.push(d);
        for(let h = 0; h <= d; h++)if (u instanceof rn || u instanceof Wn || u instanceof nn) {
            if (u.getPoint(h / d, c), i.set(c.x, c.y, 0), s !== void 0 && U9(s, i)) continue;
            s === void 0 && (s = _O), s.copy(i), n1.setXYZ(o, i.x, i.y, i.z), o++;
        }
    }
    return r && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), n1;
}
function RO(n1, t, e, r = 12, i = !0) {
    let s = EO.set(0, 0, 0), o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        if (e[l] === !1) continue;
        let u, c = Y1(t[l]), d = yh, h = Pl(c, r);
        a.push(h);
        for(let f = 0; f <= h; f++)if (c instanceof rn || c instanceof Wn || c instanceof nn) {
            if (c.getPoint(f / h, d), s.set(d.x, d.y, 0), u?.equals(s)) continue;
            u === void 0 ? u = _O : (n1.setXYZ(o, u.x, u.y, u.z), o++, n1.setXYZ(o, s.x, s.y, s.z), o++), u.copy(s);
        }
    }
    return i && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), a;
}
function K1(n1, t = 12, e = !1) {
    let r = [];
    for(let i = 0, s = n1.length; i < s; i++){
        let o = n1[i], a = 0;
        if (e && o.roundedCurveCorner !== void 0) {
            let l = Pl(o.roundedCurveCorner, t) * .5;
            i > 0 && (r[i - 1] += l), a += l;
        }
        o.curveAfter !== void 0 && (a += Pl(o.curveAfter, t)), r.push(a);
    }
    return n1.length > 0 && e && n1[0].roundedCurveCorner !== void 0 && (r[n1.length - 1] += Pl(n1[0].roundedCurveCorner, t) * .5), r;
}
function Pl(n1, t = 12) {
    return n1 && n1 instanceof mc ? t * 2 : n1 && (n1 instanceof nn || n1 instanceof pp) ? 1 : n1 && n1 instanceof Ru ? t * n1.points.length : t;
}
function LO(n1, t, e = 12, r = !0) {
    let i, s = 0;
    for(let o = 0; o < t.length; o++){
        let a = Y1(t[o]), l = Pl(a, e), u = yh;
        for(let c = 0; c <= l; c++)if (a instanceof rn || a instanceof Wn || a instanceof nn) {
            if (a.getPoint(c / l, u), i !== void 0 && V9(i, u, sm)) continue;
            i === void 0 && (i = g0), i.copy(u), n1.push(u.x, u.y), s++;
        }
    }
    return om(n1[0], n1[n1.length - 2], sm) && om(n1[1], n1[n1.length - 1], sm) && (n1.pop(), n1.pop()), r && s > 1 && !(om(n1[s - 1], n1[1], sm) && om(n1[s - 2], n1[0], sm)) && (n1.push(n1[0], n1[1]), s++), n1;
}
var Z1 = new N, G9 = new N, j9 = new N, H9 = new N, W9 = new N, q9 = new N, kt = class extends oa {
    constructor(e = 100, r = 100){
        super();
        this.points = [];
        this.shapeHoles = [];
        this.plane = new qr(new _(0, 0, -1));
        this.subdivision = 0;
        this.controlSnapDistance = 4;
        this.pointIDs = 0;
        this.isMesh2D = !1;
        this.isText = !1;
        this._roundness = 0;
        this.isClosed = !1;
        this.useCubicForRoundedCorners = !0;
        this.uuid = Se.generateUUID();
        this.needsUpdate = !1;
        this.roundedCurves = [];
        this._width = e, this._height = r;
    }
    static createFromState(e, r, i) {
        let s = new kt;
        return s.isClosed = e.isClosed, s.points = e.points.map((o)=>js.create(o.id, o.data)), typeof e.roundness == "number" && (s.roundness = e.roundness), s.shapeHoles = e.shapeHoles.map((o)=>kt.createFromState(o)), r !== void 0 && i !== void 0 && s.applySize(r, i), s.update(), s;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get roundness() {
        return this._roundness;
    }
    set roundness(e) {
        if (this._roundness !== e) {
            this._roundness = e;
            for(let r = 0, i = this.points.length; r < i; r++)this.points[r].roundness = e;
            this.needsUpdate = !0;
        }
    }
    getPointsIndexesByIds(e) {
        return e.map((r)=>this.getPointIndexById(r)).filter((r)=>r >= 0);
    }
    getPointIndexById(e) {
        let r = this.points.length, i = this.points.findIndex((s)=>s.uuid === e);
        if (i < 0) {
            let s = r;
            for(let o = 0, a = this.shapeHoles.length; o < a; o++){
                let l = this.shapeHoles[o], u = l.points.length, c = l.getPointIndexById(e);
                if (c < 0) s += u;
                else return c + s;
            }
        }
        return i;
    }
    getLineIndexById(e) {
        return this.getPointIndexById(e);
    }
    getBezierPoint(e) {
        if (e <= this.points.length - 1) return this.points[e];
        if (this.shapeHoles.length > 0) {
            let r = this.points.length;
            for(let i = 0, s = this.shapeHoles.length; i < s; i++){
                let o = this.shapeHoles[i], a = e - r;
                if (a <= o.points.length - 1) return o.points[a];
                r += o.points.length;
            }
        }
        throw new Error("This shape does not have a point for this index: " + e);
    }
    getBezierPointIndex(e) {
        let r = this.points.indexOf(e);
        if (r >= 0) return r;
        if (r = this.points.length, this.shapeHoles.length > 0) for(let i = 0, s = this.shapeHoles.length; i < s; i++){
            let o = this.shapeHoles[i], a = o.points.indexOf(e);
            if (a >= 0) return r + a;
            r += o.points.length;
        }
        return -1;
    }
    getAllPoints() {
        let e = [].concat(...this.shapeHoles.map((r)=>r.points));
        return [
            ...this.points,
            ...e
        ];
    }
    applySize(e, r) {
        e === 0 && (e = .001), r === 0 && (r = .001), this._width = e, this._height = r;
    }
    applyScale(e, r) {
        let i = Z1.set(e, r);
        for(let s = 0, o = this.points.length; s < o; s++){
            let a = this.points[s];
            a.position.multiply(i), a.controls[0].position.multiply(i), a.controls[1].position.multiply(i);
        }
        for(let s = 0, o = this.shapeHoles.length; s < o; s++)this.shapeHoles[s].applyScale(e, r);
        this._update();
    }
    createPoint(e, r = 0, i = Se.generateUUID()) {
        let s;
        e instanceof N ? s = e : s = new N(e, r);
        let o = new js(i, s);
        return o.roundness = this.roundness, o;
    }
    addPoint(e) {
        this.points.push(e), this.needsUpdate = !0;
    }
    addPointAt(e, r) {
        this.points.splice(r, 0, e), this.needsUpdate = !0;
    }
    getPointByUuid(e) {
        for(let r = 0, i = this.points.length; r < i; r++){
            let s = this.points[r];
            if (s.uuid === e) return s;
        }
        for(let r = 0, i = this.shapeHoles.length; r < i; r++){
            let o = this.shapeHoles[r].getPointByUuid(e);
            if (o) return o;
        }
    }
    getFirstPoint() {
        return this.points[0];
    }
    getLastPoint() {
        return this.points[this.points.length - 1];
    }
    removePoint(e) {
        let r = this.points.indexOf(e);
        r >= 0 && this.points.splice(r, 1), this.needsUpdate = !0;
    }
    removePointById(e) {
        let r = this.points.find((i)=>i.uuid === e);
        r && this.removePoint(r);
    }
    update() {
        for(let e = 0, r = this.shapeHoles.length; e < r; e++)this.shapeHoles[e].update();
        this._update();
    }
    extractShapePointsToBuffer(e, r = 12, i = !1) {
        this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r);
        let s = i ? this.roundedCurveDivisions : this.curveDivisions;
        return IO(e, i ? this.roundedCurves : this.curves, r, this.autoClose), s.reduce((o, a)=>o + a, 0) + 1;
    }
    computeCurveDivisions(e = 12) {
        return this.curveDivisions = K1(this.points, e, !1), this.roundedCurveDivisions = K1(this.points, e, !0), this.curveDivisions;
    }
    extractFilteredShapePointsToBuffer(e, r, i = 12) {
        return RO(e, this.curves, r, i, this.autoClose).reduce((o, a)=>o + a, 0) * 2;
    }
    extractShapePointsToFlatArray(e, r = 12) {
        return this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r), LO(e, this.roundedCurves, r, this.autoClose);
    }
    getCurveIndexFromVertexId(e, r = !1) {
        let i = 0;
        this.curveDivisions === void 0 && this.computeCurveDivisions(this.subdivision);
        let s = r ? this.roundedCurveDivisions : this.curveDivisions, o = 0;
        r && this.points[0].roundedCurveCorner !== void 0 && (o = Pl(this.points[0].roundedCurveCorner, this.subdivision) * .5);
        let a = e - o;
        a < 0 && (a += s.reduce((l, u)=>l + u, 0));
        for(let l = 0, u = s.length; l < u; l++){
            let c = s[l];
            if (a < i + c) return [
                l,
                (a - i + 1) / c
            ];
            i += c;
        }
        return [
            0,
            1
        ];
    }
    getCurveT(e, r, i) {
        let s = this.points[e], o = this.points[e >= this.points.length - 1 ? 0 : e + 1], a = this.curveDivisions, l = a[e];
        if (Q1(s, o)) {
            let d = s.position.distanceTo(o.position);
            return s.position.distanceTo(Z1.set(i.x, i.y)) / d;
        }
        let u = 0;
        for(let d = 0; d < e; d++)u += a[d];
        return (r - u) / l;
    }
    dispose() {}
    _applyCurveForPoint(e, r) {
        Q1(r, e) ? this.lineTo(e.position.x, e.position.y) : this.bezierCurveTo(r.controls[1].position.x, r.controls[1].position.y, e.controls[0].position.x, e.controls[0].position.y, e.position.x, e.position.y);
        let i = this.curves[this.curves.length - 1];
        e.curveBefore = i, r.curveAfter = i;
        let s = i.clone();
        e.roundedCurveBefore = s, r.roundedCurveAfter = s, e.roundedCurveCorner = void 0, this.roundedCurves.push(s);
    }
    _update() {
        if (this.curves = [], this.roundedCurves = [], !this.points.length) return;
        for(let r = 0, i = this.points.length; r < i; r++){
            let s = this.points[r];
            if (r === 0) this.moveTo(s.position.x, s.position.y);
            else {
                let o = this.points[r - 1];
                this._applyCurveForPoint(s, o);
            }
        }
        let e = this.getLastPoint();
        if (e?.curveAfter && (e.curveAfter = void 0), this.isClosed) {
            let r = this.points[0], i = this.points[this.points.length - 1];
            this._applyCurveForPoint(r, i);
        }
        if (this.points.length > 2) {
            let r = 0;
            for(let i = 0, s = this.points.length; i < s; i++){
                let o = this.points[i], a = this.points[i - 1] ?? this.points[this.points.length - 1], l = this.points[i + 1] ?? this.points[0], u = o.roundness, c = a && l && MO(a, o, l);
                if (!o.controlsMoved() && u > 0 && !c) {
                    let d = o.curveBefore, h = o.curveAfter;
                    if (d === void 0 || h === void 0) continue;
                    let f = o.roundedCurveBefore, p = o.roundedCurveAfter, m = d.getLength(), g = h.getLength(), y = Math.min(u, m * .499), v = Math.min(u, g * .499), x = Math.min(y, v), S = 1 - x / m, w = x / g, A = d.getPointAt(S, Z1), E = h.getPointAt(w, G9);
                    this._subSplitCurve(d, f, S, A, void 0), this._subSplitCurve(h, p, w, void 0, E);
                    let b;
                    if (this.useCubicForRoundedCorners) {
                        let T = X1(A, o.position, E) / 2, M = Math.tan(T) * A.distanceTo(o.position), [C, P] = CO(A, E, M, j9, H9), D = PO(C, P, o.position), [O, I] = DO(D, A, E, M, W9, q9);
                        b = new rn(A.clone(), O.clone(), I.clone(), E.clone());
                    } else b = new Wn(A.clone(), o.position.clone(), E.clone());
                    o.roundedCurveCorner = b, this.roundedCurves.splice(i + r, 0, b), r++;
                }
            }
        }
    }
    _subSplitCurve(e, r, i, s, o) {
        if (e instanceof nn) s !== void 0 && r.v2.copy(s), o !== void 0 && r.v1.copy(o);
        else {
            let a = e, l = r, u = a.getUtoTmapping(i, 0), c = OO(a.v0, a.v1, a.v2, a.v3, u);
            return s !== void 0 && (l.v0.set(c[0], c[1]), l.v1.set(c[2], c[3]), l.v2.set(c[4], c[5]), l.v3.set(c[6], c[7])), o !== void 0 && (l.v0.set(c[6], c[7]), l.v1.set(c[8], c[9]), l.v2.set(c[10], c[11]), l.v3.set(c[12], c[13])), l;
        }
        return r;
    }
    clone() {
        let e = new kt(this._width, this._height);
        return e.points = this.points.map((r)=>r.clone()), e.isClosed = this.isClosed, e.roundness = this.roundness, e.isMesh2D = this.isMesh2D, e.shapeHoles = this.shapeHoles.map((r)=>r.clone()), e;
    }
    toJSON() {
        return {
            points: this.points.reduce((e, r)=>e.concat(r.toJSON()), []),
            shapeHoles: this.shapeHoles.map((e)=>e.toJSON()),
            isClosed: this.isClosed,
            roundness: this.roundness
        };
    }
    fromJSON(e) {
        this.points = [], this.pointIDs = 0;
        let r = e.points.length / 7;
        for(let i = 0; i < r; i++){
            let s = i * 7, o = e.points[s + 0], a = e.points[s + 1], l = e.points[s + 2], u = e.points[s + 3], c = e.points[s + 4], d = e.points[s + 5], h = e.points[s + 6], f = new js(Se.generateUUID(), new N(o, a));
            f.controls[0].position.set(l, u), f.controls[1].position.set(c, d), f.roundness = h, this.points.push(f);
        }
        return this.shapeHoles = e.shapeHoles?.length ? e.shapeHoles.map((i)=>{
            let s = new kt;
            return s.fromJSON(i), s;
        }) : [], this.isClosed = e.isClosed, this._roundness = e.roundness, this._update(), this;
    }
    fromShape(e, r = !1) {
        this.isText = r;
        let i = (o, a)=>{
            a instanceof rn && a.v3.equals(o.position) && o.controls[0].position.copy(a.v2);
        }, s = (o)=>{
            let a = [], l, u;
            for(l = 0, u = o.length; l < u; l++)o[l] instanceof Wn && (o[l] = TO(o[l]));
            for(l = 0, u = o.length; l < u; l++){
                let h = o[l], f = l > 0 ? o[l - 1] : null, p;
                h instanceof rn ? (p = this.createPoint(h.v0), p.controls[1].position.copy(h.v1)) : h instanceof nn && (p = this.createPoint(h.v1)), p !== void 0 && (f !== null && i(p, f), a.push(p));
            }
            let c = o[o.length - 1], d = !1;
            return c instanceof rn ? c.v3.equals(a[0].position) && (a[0].controls[0].position.copy(c.v2), d = !0) : c instanceof nn && c.v2.equals(a[0].position) && (d = !0), this.isClosed = d, a;
        };
        return this.points = s(e.curves), e instanceof oa && (this.shapeHoles = e.holes.map((o)=>{
            let a = new kt;
            return a.fromShape(o), a;
        })), this.update(), this;
    }
    updatePoint(e, r) {
        let i = this.getPointByUuid(e);
        i && (r.position !== void 0 && i.position.fromArray(r.position), r.roundness !== void 0 && (i.roundness = r.roundness), r.areControlsDirectionsMirrored !== void 0 && (i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored), this.needsUpdate = !0);
    }
    updatePreviousControl(e, r) {
        let s = this.getPointByUuid(e)?.controls[0];
        s && (r.position && s.position.fromArray(r.position), this.needsUpdate = !0);
    }
    updateNextControl(e, r) {
        let s = this.getPointByUuid(e)?.controls[1];
        s && (r.position && s.position.fromArray(r.position), this.needsUpdate = !0);
    }
};
var $1 = Math.PI * 2;
function J1({ x: n1, y: t }, e, r, i, s) {
    return {
        x: n1 * e + i,
        y: t * r + s
    };
}
function Y9(n1, t) {
    let e = t === 1.5707963267948966 ? .551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), r = Math.cos(n1), i = Math.sin(n1), s = Math.cos(n1 + t), o = Math.sin(n1 + t);
    return [
        {
            x: r - i * e,
            y: i + r * e
        },
        {
            x: s + o * e,
            y: o - s * e
        },
        {
            x: s,
            y: o
        }
    ];
}
function BO(n1, t, e, r) {
    let i = n1 * r - t * e < 0 ? -1 : 1, s = Math.min(1, Math.max(-1, n1 * e + t * r));
    return i * Math.acos(s);
}
function X9(n1, t, e, r, i, s, o, a, l, u) {
    let c = Math.pow(i, 2), d = Math.pow(s, 2), h = Math.pow(o, 2), f = Math.pow(a, 2), p = c * d - c * f - d * h;
    p < 0 && (p = 0), p /= c * f + d * h, p = Math.sqrt(p) * (l === u ? -1 : 1);
    let m = p * i / s * a, g = p * -s / i * o, y = m + (n1 + e) / 2, v = g + (t + r) / 2, x = (o - m) / i, S = (a - g) / s, w = (-o - m) / i, A = (-a - g) / s, E = BO(1, 0, x, S), b = BO(x, S, w, A);
    return !u && b > 0 && (b -= $1), u && b < 0 && (b += $1), {
        centerx: y,
        centery: v,
        ang1: E,
        ang2: b
    };
}
function NO({ px: n1, py: t, cx: e, cy: r, rx: i, ry: s, largeArcFlag: o, sweepFlag: a }) {
    let l = [];
    if (i === 0 || s === 0) return [];
    let u = (n1 - e) / 2, c = (t - r) / 2;
    if (u === 0 && c === 0) return [];
    i = Math.abs(i), s = Math.abs(s);
    let d = Math.pow(u, 2) / Math.pow(i, 2) + Math.pow(c, 2) / Math.pow(s, 2);
    d > 1 && (i *= Math.sqrt(d), s *= Math.sqrt(d));
    let h = X9(n1, t, e, r, i, s, u, c, o, a), { ang1: f, ang2: p } = h, { centerx: m, centery: g } = h, y = Math.abs(p) / ($1 / 4);
    Math.abs(1 - y) < 1e-7 && (y = 1);
    let v = Math.max(Math.ceil(y), 1);
    p /= v;
    for(let x = 0; x < v; x++)l.push(Y9(f, p)), f += p;
    return l.map((x)=>{
        let { x: S, y: w } = J1(x[0], i, s, m, g), { x: A, y: E } = J1(x[1], i, s, m, g), { x: b, y: T } = J1(x[2], i, s, m, g);
        return {
            x1: S,
            y1: w,
            x2: A,
            y2: E,
            x: b,
            y: T
        };
    });
}
var Mt;
(function(n1) {
    n1[n1.ODD = 0] = "ODD", n1[n1.NONZERO = 1] = "NONZERO", n1[n1.POSITIVE = 2] = "POSITIVE", n1[n1.NEGATIVE = 3] = "NEGATIVE", n1[n1.ABS_GEQ_TWO = 4] = "ABS_GEQ_TWO";
})(Mt || (Mt = {}));
var Rr;
(function(n1) {
    n1[n1.POLYGONS = 0] = "POLYGONS", n1[n1.CONNECTED_POLYGONS = 1] = "CONNECTED_POLYGONS", n1[n1.BOUNDARY_CONTOURS = 2] = "BOUNDARY_CONTOURS";
})(Rr || (Rr = {}));
function nt(n1, t) {
    if (!n1) throw t || "Assertion Failed!";
}
var $e = function() {
    function n1() {}
    return n1.vertEq = function(t, e) {
        return t.s === e.s && t.t === e.t;
    }, n1.vertLeq = function(t, e) {
        return t.s < e.s || t.s === e.s && t.t <= e.t;
    }, n1.transLeq = function(t, e) {
        return t.t < e.t || t.t === e.t && t.s <= e.s;
    }, n1.edgeGoesLeft = function(t) {
        return n1.vertLeq(t.Dst, t.Org);
    }, n1.edgeGoesRight = function(t) {
        return n1.vertLeq(t.Org, t.Dst);
    }, n1.vertL1dist = function(t, e) {
        return Math.abs(t.s - e.s) + Math.abs(t.t - e.t);
    }, n1.edgeEval = function(t, e, r) {
        nt(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s = r.s - e.s;
        return i + s > 0 ? i < s ? e.t - t.t + (t.t - r.t) * (i / (i + s)) : e.t - r.t + (r.t - t.t) * (s / (i + s)) : 0;
    }, n1.edgeSign = function(t, e, r) {
        nt(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s = r.s - e.s;
        return i + s > 0 ? (e.t - r.t) * i + (e.t - t.t) * s : 0;
    }, n1.transEval = function(t, e, r) {
        nt(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s = r.t - e.t;
        return i + s > 0 ? i < s ? e.s - t.s + (t.s - r.s) * (i / (i + s)) : e.s - r.s + (r.s - t.s) * (s / (i + s)) : 0;
    }, n1.transSign = function(t, e, r) {
        nt(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s = r.t - e.t;
        return i + s > 0 ? (e.s - r.s) * i + (e.s - t.s) * s : 0;
    }, n1.vertCCW = function(t, e, r) {
        return t.s * (e.t - r.t) + e.s * (r.t - t.t) + r.s * (t.t - e.t) >= 0;
    }, n1.interpolate = function(t, e, r, i) {
        return t = t < 0 ? 0 : t, r = r < 0 ? 0 : r, t <= r ? r === 0 ? (e + i) / 2 : e + (i - e) * (t / (t + r)) : i + (e - i) * (r / (t + r));
    }, n1.intersect = function(t, e, r, i, s) {
        var o, a, l;
        n1.vertLeq(t, e) || (l = t, t = e, e = l), n1.vertLeq(r, i) || (l = r, r = i, i = l), n1.vertLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.vertLeq(r, e) ? n1.vertLeq(e, i) ? (o = n1.edgeEval(t, r, e), a = n1.edgeEval(r, e, i), o + a < 0 && (o = -o, a = -a), s.s = n1.interpolate(o, r.s, a, e.s)) : (o = n1.edgeSign(t, r, e), a = -n1.edgeSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.s = n1.interpolate(o, r.s, a, i.s)) : s.s = (r.s + e.s) / 2, n1.transLeq(t, e) || (l = t, t = e, e = l), n1.transLeq(r, i) || (l = r, r = i, i = l), n1.transLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.transLeq(r, e) ? n1.transLeq(e, i) ? (o = n1.transEval(t, r, e), a = n1.transEval(r, e, i), o + a < 0 && (o = -o, a = -a), s.t = n1.interpolate(o, r.t, a, e.t)) : (o = n1.transSign(t, r, e), a = -n1.transSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.t = n1.interpolate(o, r.t, a, i.t)) : s.t = (r.t + e.t) / 2;
    }, n1;
}(), am = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.trail = null, this.n = 0, this.marked = !1, this.inside = !1;
    }
    return n1;
}(), y0 = function() {
    function n1(t) {
        this.side = t, this.next = null, this.Org = null, this.Sym = null, this.Onext = null, this.Lnext = null, this.Lface = null, this.activeRegion = null, this.winding = 0;
    }
    return Object.defineProperty(n1.prototype, "Rface", {
        get: function() {
            return this.Sym.Lface;
        },
        set: function(t) {
            this.Sym.Lface = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dst", {
        get: function() {
            return this.Sym.Org;
        },
        set: function(t) {
            this.Sym.Org = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Oprev", {
        get: function() {
            return this.Sym.Lnext;
        },
        set: function(t) {
            this.Sym.Lnext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Lprev", {
        get: function() {
            return this.Onext.Sym;
        },
        set: function(t) {
            this.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dprev", {
        get: function() {
            return this.Lnext.Sym;
        },
        set: function(t) {
            this.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rprev", {
        get: function() {
            return this.Sym.Onext;
        },
        set: function(t) {
            this.Sym.Onext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dnext", {
        get: function() {
            return this.Sym.Onext.Sym;
        },
        set: function(t) {
            this.Sym.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rnext", {
        get: function() {
            return this.Sym.Lnext.Sym;
        },
        set: function(t) {
            this.Sym.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), n1;
}(), vh = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.coords = [
            0,
            0,
            0
        ], this.s = 0, this.t = 0, this.pqHandle = 0, this.n = 0, this.idx = 0;
    }
    return n1;
}(), FO = function() {
    function n1() {
        var t = new vh, e = new am, r = new y0(0), i = new y0(1);
        t.next = t.prev = t, t.anEdge = null, e.next = e.prev = e, r.next = r, r.Sym = i, i.next = i, i.Sym = r, this.vHead = t, this.fHead = e, this.eHead = r, this.eHeadSym = i;
    }
    return n1.prototype.makeEdge_ = function(t) {
        var e = new y0(0), r = new y0(1);
        t.Sym.side < t.side && (t = t.Sym);
        var i = t.Sym.next;
        return r.next = i, i.Sym.next = e, e.next = t, t.Sym.next = r, e.Sym = r, e.Onext = e, e.Lnext = r, e.Org = null, e.Lface = null, e.winding = 0, e.activeRegion = null, r.Sym = e, r.Onext = r, r.Lnext = e, r.Org = null, r.Lface = null, r.winding = 0, r.activeRegion = null, e;
    }, n1.prototype.splice_ = function(t, e) {
        var r = t.Onext, i = e.Onext;
        r.Sym.Lnext = e, i.Sym.Lnext = t, t.Onext = i, e.Onext = r;
    }, n1.prototype.makeVertex_ = function(t, e, r) {
        var i = t;
        nt(i, "Vertex can't be null!");
        var s = r.prev;
        i.prev = s, s.next = i, i.next = r, r.prev = i, i.anEdge = e;
        var o = e;
        do o.Org = i, o = o.Onext;
        while (o !== e);
    }, n1.prototype.makeFace_ = function(t, e, r) {
        var i = t;
        nt(i, "Face can't be null");
        var s = r.prev;
        i.prev = s, s.next = i, i.next = r, r.prev = i, i.anEdge = e, i.trail = null, i.marked = !1, i.inside = r.inside;
        var o = e;
        do o.Lface = i, o = o.Lnext;
        while (o !== e);
    }, n1.prototype.killEdge_ = function(t) {
        t.Sym.side < t.side && (t = t.Sym);
        var e = t.next, r = t.Sym.next;
        e.Sym.next = r, r.Sym.next = e;
    }, n1.prototype.killVertex_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Org = e, i = i.Onext;
        while (i !== r);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, n1.prototype.killFace_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Lface = e, i = i.Lnext;
        while (i !== r);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, n1.prototype.makeEdge = function() {
        var t = new vh, e = new vh, r = new am, i = this.makeEdge_(this.eHead);
        return this.makeVertex_(t, i, this.vHead), this.makeVertex_(e, i.Sym, this.vHead), this.makeFace_(r, i, this.fHead), i;
    }, n1.prototype.splice = function(t, e) {
        var r = !1, i = !1;
        if (t !== e) {
            if (e.Org !== t.Org && (i = !0, this.killVertex_(e.Org, t.Org)), e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(e, t), !i) {
                var s = new vh;
                this.makeVertex_(s, e, t.Org), t.Org.anEdge = t;
            }
            if (!r) {
                var o = new am;
                this.makeFace_(o, e, t.Lface), t.Lface.anEdge = t;
            }
        }
    }, n1.prototype.delete = function(t) {
        var e = t.Sym, r = !1;
        if (t.Lface !== t.Rface && (r = !0, this.killFace_(t.Lface, t.Rface)), t.Onext === t) this.killVertex_(t.Org, null);
        else if (t.Rface.anEdge = t.Oprev, t.Org.anEdge = t.Onext, this.splice_(t, t.Oprev), !r) {
            var i = new am;
            this.makeFace_(i, t, t.Lface);
        }
        e.Onext === e ? (this.killVertex_(e.Org, null), this.killFace_(e.Lface, null)) : (t.Lface.anEdge = e.Oprev, e.Org.anEdge = e.Onext, this.splice_(e, e.Oprev)), this.killEdge_(t);
    }, n1.prototype.addEdgeVertex = function(t) {
        var e = this.makeEdge_(t), r = e.Sym;
        this.splice_(e, t.Lnext), e.Org = t.Dst;
        var i = new vh;
        return this.makeVertex_(i, r, e.Org), e.Lface = r.Lface = t.Lface, e;
    }, n1.prototype.splitEdge = function(t) {
        var e = this.addEdgeVertex(t), r = e.Sym;
        return this.splice_(t.Sym, t.Sym.Oprev), this.splice_(t.Sym, r), t.Dst = r.Org, r.Dst.anEdge = r.Sym, r.Rface = t.Rface, r.winding = t.winding, r.Sym.winding = t.Sym.winding, r.idx = t.idx, r.Sym.idx = t.Sym.idx, r;
    }, n1.prototype.connect = function(t, e) {
        var r = !1, i = this.makeEdge_(t), s = i.Sym;
        if (e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(i, t.Lnext), this.splice_(s, e), i.Org = t.Dst, s.Org = e.Org, i.Lface = s.Lface = t.Lface, t.Lface.anEdge = s, !r) {
            var o = new am;
            this.makeFace_(o, i, t.Lface);
        }
        return i;
    }, n1.prototype.zapFace = function(t) {
        var e = t.anEdge, r, i, s, o, a;
        i = e.Lnext;
        do r = i, i = r.Lnext, r.Lface = null, r.Rface === null && (r.Onext === r ? this.killVertex_(r.Org, null) : (r.Org.anEdge = r.Onext, this.splice_(r, r.Oprev)), s = r.Sym, s.Onext === s ? this.killVertex_(s.Org, null) : (s.Org.anEdge = s.Onext, this.splice_(s, s.Oprev)), this.killEdge_(r));
        while (r != e);
        o = t.prev, a = t.next, a.prev = o, o.next = a;
    }, n1.prototype.countFaceVerts_ = function(t) {
        var e = t.anEdge, r = 0;
        do r++, e = e.Lnext;
        while (e !== t.anEdge);
        return r;
    }, n1.prototype.mergeConvexFaces = function(t) {
        var e, r, i, s, o, a, l;
        for(e = this.fHead.next; e !== this.fHead; e = e.next)if (!!e.inside) for(r = e.anEdge, o = r.Org; i = r.Lnext, s = r.Sym, s && s.Lface && s.Lface.inside && (a = this.countFaceVerts_(e), l = this.countFaceVerts_(s.Lface), a + l - 2 <= t && $e.vertCCW(r.Lprev.Org, r.Org, s.Lnext.Lnext.Org) && $e.vertCCW(s.Lprev.Org, s.Org, r.Lnext.Lnext.Org) && (i = s.Lnext, this.delete(s), r = null, s = null)), !(r && r.Lnext.Org === o);)r = i;
        return !0;
    }, n1.prototype.check = function() {
        var t = this.fHead, e = this.vHead, r = this.eHead, i, s, o, a, l, u;
        for(s = t, s = t; (i = s.next) !== t; s = i){
            nt(i.prev === s), l = i.anEdge;
            do nt(l.Sym !== l), nt(l.Sym.Sym === l), nt(l.Lnext.Onext.Sym === l), nt(l.Onext.Sym.Lnext === l), nt(l.Lface === i), l = l.Lnext;
            while (l !== i.anEdge);
        }
        for(nt(i.prev === s && i.anEdge === null), a = e, a = e; (o = a.next) !== e; a = o){
            nt(o.prev === a), l = o.anEdge;
            do nt(l.Sym !== l), nt(l.Sym.Sym === l), nt(l.Lnext.Onext.Sym === l), nt(l.Onext.Sym.Lnext === l), nt(l.Org === o), l = l.Onext;
            while (l !== o.anEdge);
        }
        for(nt(o.prev === a && o.anEdge === null), u = r, u = r; (l = u.next) !== r; u = l)nt(l.Sym.next === u.Sym), nt(l.Sym !== l), nt(l.Sym.Sym === l), nt(l.Org !== null), nt(l.Dst !== null), nt(l.Lnext.Onext.Sym === l), nt(l.Onext.Sym.Lnext === l);
        nt(l.Sym.next === u.Sym && l.Sym === this.eHeadSym && l.Sym.Sym === l && l.Org === null && l.Dst === null && l.Lface === null && l.Rface === null);
    }, n1;
}(), kO = function() {
    function n1() {
        this.handle = null;
    }
    return n1;
}(), zO = function() {
    function n1() {
        this.key = null, this.node = 0;
    }
    return n1;
}(), Q9 = function() {
    function n1(t, e) {
        this.leq = e, this.max = 0, this.nodes = [], this.handles = [], this.initialized = !1, this.freeList = 0, this.size = 0, this.max = t, this.nodes = [], this.handles = [];
        for(var r = 0; r < t + 1; r++)this.nodes[r] = new kO, this.handles[r] = new zO;
        this.initialized = !1, this.nodes[1].handle = 1, this.handles[1].key = null;
    }
    return n1.prototype.floatDown_ = function(t) {
        var e = this.nodes, r = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t << 1, o < this.size && this.leq(r[e[o + 1].handle].key, r[e[o].handle].key) && ++o, nt(o <= this.max), s = e[o].handle, o > this.size || this.leq(r[i].key, r[s].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s, r[s].node = t, t = o;
        }
    }, n1.prototype.floatUp_ = function(t) {
        var e = this.nodes, r = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t >> 1, s = e[o].handle, o === 0 || this.leq(r[s].key, r[i].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s, r[s].node = t, t = o;
        }
    }, n1.prototype.init = function() {
        for(var t = this.size; t >= 1; --t)this.floatDown_(t);
        this.initialized = !0;
    }, n1.prototype.min = function() {
        return this.handles[this.nodes[1].handle].key;
    }, n1.prototype.insert = function(t) {
        var e, r;
        if (e = ++this.size, e * 2 > this.max) {
            this.max *= 2;
            var i, s;
            for(s = this.nodes.length, this.nodes.length = this.max + 1, i = s; i < this.nodes.length; i++)this.nodes[i] = new kO;
            for(s = this.handles.length, this.handles.length = this.max + 1, i = s; i < this.handles.length; i++)this.handles[i] = new zO;
        }
        return this.freeList === 0 ? r = e : (r = this.freeList, this.freeList = this.handles[r].node), this.nodes[e].handle = r, this.handles[r].node = e, this.handles[r].key = t, this.initialized && this.floatUp_(e), r;
    }, n1.prototype.extractMin = function() {
        var t = this.nodes, e = this.handles, r = t[1].handle, i = e[r].key;
        return this.size > 0 && (t[1].handle = t[this.size].handle, e[t[1].handle].node = 1, e[r].key = null, e[r].node = this.freeList, this.freeList = r, --this.size, this.size > 0 && this.floatDown_(1)), i;
    }, n1.prototype.delete = function(t) {
        var e = this.nodes, r = this.handles, i;
        nt(t >= 1 && t <= this.max && r[t].key !== null), i = r[t].node, e[i].handle = e[this.size].handle, r[e[i].handle].node = i, --this.size, i <= this.size && (i <= 1 || this.leq(r[e[i >> 1].handle].key, r[e[i].handle].key) ? this.floatDown_(i) : this.floatUp_(i)), r[t].key = null, r[t].node = this.freeList, this.freeList = t;
    }, n1;
}(), eA = function() {
    function n1() {
        this.eUp = null, this.nodeUp = null, this.windingNumber = 0, this.inside = !1, this.sentinel = !1, this.dirty = !1, this.fixUpperEdge = !1;
    }
    return n1;
}(), VO = function() {
    function n1() {
        this.key = null, this.next = null, this.prev = null;
    }
    return n1;
}(), K9 = function() {
    function n1(t, e) {
        this.frame = t, this.leq = e, this.head = new VO, this.head.next = this.head, this.head.prev = this.head;
    }
    return n1.prototype.min = function() {
        return this.head.next;
    }, n1.prototype.max = function() {
        return this.head.prev;
    }, n1.prototype.insert = function(t) {
        return this.insertBefore(this.head, t);
    }, n1.prototype.search = function(t) {
        var e = this.head;
        do e = e.next;
        while (e.key !== null && !this.leq(this.frame, t, e.key));
        return e;
    }, n1.prototype.insertBefore = function(t, e) {
        do t = t.prev;
        while (t.key !== null && !this.leq(this.frame, t.key, e));
        var r = new VO;
        return r.key = e, r.next = t.next, t.next.prev = r, r.prev = t, t.next = r, r;
    }, n1.prototype.delete = function(t) {
        t.next.prev = t.prev, t.prev.next = t.next;
    }, n1;
}(), Z9 = function() {
    function n1() {}
    return n1.regionBelow = function(t) {
        return t.nodeUp.prev.key;
    }, n1.regionAbove = function(t) {
        return t.nodeUp.next.key;
    }, n1.debugEvent = function(t) {}, n1.addWinding = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.edgeLeq = function(t, e, r) {
        var i = t.event, s = e.eUp, o = r.eUp;
        if (s.Dst === i) return o.Dst === i ? $e.vertLeq(s.Org, o.Org) ? $e.edgeSign(o.Dst, s.Org, o.Org) <= 0 : $e.edgeSign(s.Dst, o.Org, s.Org) >= 0 : $e.edgeSign(o.Dst, i, o.Org) <= 0;
        if (o.Dst === i) return $e.edgeSign(s.Dst, i, s.Org) >= 0;
        var a = $e.edgeEval(s.Dst, i, s.Org), l = $e.edgeEval(o.Dst, i, o.Org);
        return a >= l;
    }, n1.deleteRegion = function(t, e) {
        e.fixUpperEdge && nt(e.eUp.winding === 0), e.eUp.activeRegion = null, t.dict.delete(e.nodeUp);
    }, n1.fixUpperEdge = function(t, e, r) {
        nt(e.fixUpperEdge), t.mesh.delete(e.eUp), e.fixUpperEdge = !1, e.eUp = r, r.activeRegion = e;
    }, n1.topLeftRegion = function(t, e) {
        var r = e.eUp.Org, i;
        do e = n1.regionAbove(e);
        while (e.eUp.Org === r);
        if (e.fixUpperEdge) {
            if (i = t.mesh.connect(n1.regionBelow(e).eUp.Sym, e.eUp.Lnext), i === null) return null;
            n1.fixUpperEdge(t, e, i), e = n1.regionAbove(e);
        }
        return e;
    }, n1.topRightRegion = function(t) {
        var e = t.eUp.Dst;
        do t = n1.regionAbove(t);
        while (t.eUp.Dst === e);
        return t;
    }, n1.addRegionBelow = function(t, e, r) {
        var i = new eA;
        return i.eUp = r, i.nodeUp = t.dict.insertBefore(e.nodeUp, i), i.fixUpperEdge = !1, i.sentinel = !1, i.dirty = !1, r.activeRegion = i, i;
    }, n1.isWindingInside = function(t, e) {
        switch(t.windingRule){
            case Mt.ODD:
                return (e & 1) !== 0;
            case Mt.NONZERO:
                return e !== 0;
            case Mt.POSITIVE:
                return e > 0;
            case Mt.NEGATIVE:
                return e < 0;
            case Mt.ABS_GEQ_TWO:
                return e >= 2 || e <= -2;
        }
        throw new Error("Invalid winding rulle");
    }, n1.computeWinding = function(t, e) {
        e.windingNumber = n1.regionAbove(e).windingNumber + e.eUp.winding, e.inside = n1.isWindingInside(t, e.windingNumber);
    }, n1.finishRegion = function(t, e) {
        var r = e.eUp, i = r.Lface;
        i.inside = e.inside, i.anEdge = r, n1.deleteRegion(t, e);
    }, n1.finishLeftRegions = function(t, e, r) {
        for(var i, s = null, o = e, a = e.eUp; o !== r;){
            if (o.fixUpperEdge = !1, s = n1.regionBelow(o), i = s.eUp, i.Org != a.Org) {
                if (!s.fixUpperEdge) {
                    n1.finishRegion(t, o);
                    break;
                }
                i = t.mesh.connect(a.Lprev, i.Sym), n1.fixUpperEdge(t, s, i);
            }
            a.Onext !== i && (t.mesh.splice(i.Oprev, i), t.mesh.splice(a, i)), n1.finishRegion(t, o), a = s.eUp, o = s;
        }
        return a;
    }, n1.addRightEdges = function(t, e, r, i, s, o) {
        var a, l, u, c, d = !0;
        u = r;
        do nt($e.vertLeq(u.Org, u.Dst)), n1.addRegionBelow(t, e, u.Sym), u = u.Onext;
        while (u !== i);
        for(s === null && (s = n1.regionBelow(e).eUp.Rprev), l = e, c = s; a = n1.regionBelow(l), u = a.eUp.Sym, u.Org === c.Org;)u.Onext !== c && (t.mesh.splice(u.Oprev, u), t.mesh.splice(c.Oprev, u)), a.windingNumber = l.windingNumber - u.winding, a.inside = n1.isWindingInside(t, a.windingNumber), l.dirty = !0, !d && n1.checkForRightSplice(t, l) && (n1.addWinding(u, c), n1.deleteRegion(t, l), t.mesh.delete(c)), d = !1, l = a, c = u;
        l.dirty = !0, nt(l.windingNumber - u.winding === a.windingNumber), o && n1.walkDirtyRegions(t, l);
    }, n1.spliceMergeVertices = function(t, e, r) {
        t.mesh.splice(e, r);
    }, n1.vertexWeights = function(t, e, r) {
        var i = $e.vertL1dist(e, t), s = $e.vertL1dist(r, t), o = .5 * s / (i + s), a = .5 * i / (i + s);
        t.coords[0] += o * e.coords[0] + a * r.coords[0], t.coords[1] += o * e.coords[1] + a * r.coords[1], t.coords[2] += o * e.coords[2] + a * r.coords[2];
    }, n1.getIntersectData = function(t, e, r, i, s, o) {
        e.coords[0] = e.coords[1] = e.coords[2] = 0, e.idx = -1, n1.vertexWeights(e, r, i), n1.vertexWeights(e, s, o);
    }, n1.checkForRightSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp;
        if ($e.vertLeq(i.Org, s.Org)) {
            if ($e.edgeSign(s.Dst, i.Org, s.Org) > 0) return !1;
            $e.vertEq(i.Org, s.Org) ? i.Org !== s.Org && (t.pq.delete(i.Org.pqHandle), n1.spliceMergeVertices(t, s.Oprev, i)) : (t.mesh.splitEdge(s.Sym), t.mesh.splice(i, s.Oprev), e.dirty = r.dirty = !0);
        } else {
            if ($e.edgeSign(i.Dst, s.Org, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Oprev, i);
        }
        return !0;
    }, n1.checkForLeftSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp, o;
        if (nt(!$e.vertEq(i.Dst, s.Dst)), $e.vertLeq(i.Dst, s.Dst)) {
            if ($e.edgeSign(i.Dst, s.Dst, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, o = t.mesh.splitEdge(i), t.mesh.splice(s.Sym, o), o.Lface.inside = e.inside;
        } else {
            if ($e.edgeSign(s.Dst, i.Dst, s.Org) > 0) return !1;
            e.dirty = r.dirty = !0, o = t.mesh.splitEdge(s), t.mesh.splice(i.Lnext, s.Sym), o.Rface.inside = e.inside;
        }
        return !0;
    }, n1.checkForIntersect = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s = r.eUp, o = i.Org, a = s.Org, l = i.Dst, u = s.Dst, c, d, h = new vh, f, p;
        if (nt(!$e.vertEq(u, l)), nt($e.edgeSign(l, t.event, o) <= 0), nt($e.edgeSign(u, t.event, a) >= 0), nt(o !== t.event && a !== t.event), nt(!e.fixUpperEdge && !r.fixUpperEdge), o === a || (c = Math.min(o.t, l.t), d = Math.max(a.t, u.t), c > d)) return !1;
        if ($e.vertLeq(o, a)) {
            if ($e.edgeSign(u, o, a) > 0) return !1;
        } else if ($e.edgeSign(l, a, o) < 0) return !1;
        return n1.debugEvent(t), $e.intersect(l, o, u, a, h), nt(Math.min(o.t, l.t) <= h.t), nt(h.t <= Math.max(a.t, u.t)), nt(Math.min(u.s, l.s) <= h.s), nt(h.s <= Math.max(a.s, o.s)), $e.vertLeq(h, t.event) && (h.s = t.event.s, h.t = t.event.t), f = $e.vertLeq(o, a) ? o : a, $e.vertLeq(f, h) && (h.s = f.s, h.t = f.t), $e.vertEq(h, o) || $e.vertEq(h, a) ? (n1.checkForRightSplice(t, e), !1) : !$e.vertEq(l, t.event) && $e.edgeSign(l, t.event, h) >= 0 || !$e.vertEq(u, t.event) && $e.edgeSign(u, t.event, h) <= 0 ? u === t.event ? (t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Sym, i), e = n1.topLeftRegion(t, e), i = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), r), n1.addRightEdges(t, e, i.Oprev, i, i, !0), !0) : l === t.event ? (t.mesh.splitEdge(s.Sym), t.mesh.splice(i.Lnext, s.Oprev), r = e, e = n1.topRightRegion(e), p = n1.regionBelow(e).eUp.Rprev, r.eUp = s.Oprev, s = n1.finishLeftRegions(t, r, null), n1.addRightEdges(t, e, s.Onext, i.Rprev, p, !0), !0) : ($e.edgeSign(l, t.event, h) >= 0 && (n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), i.Org.s = t.event.s, i.Org.t = t.event.t), $e.edgeSign(u, t.event, h) <= 0 && (e.dirty = r.dirty = !0, t.mesh.splitEdge(s.Sym), s.Org.s = t.event.s, s.Org.t = t.event.t), !1) : (t.mesh.splitEdge(i.Sym), t.mesh.splitEdge(s.Sym), t.mesh.splice(s.Oprev, i), i.Org.s = h.s, i.Org.t = h.t, i.Org.pqHandle = t.pq.insert(i.Org), n1.getIntersectData(t, i.Org, o, l, a, u), n1.regionAbove(e).dirty = e.dirty = r.dirty = !0, !1);
    }, n1.walkDirtyRegions = function(t, e) {
        for(var r = n1.regionBelow(e), i, s;;){
            for(; r.dirty;)e = r, r = n1.regionBelow(r);
            if (!e.dirty && (r = e, e = n1.regionAbove(e), e === null || !e.dirty)) return;
            if (e.dirty = !1, i = e.eUp, s = r.eUp, i.Dst !== s.Dst && n1.checkForLeftSplice(t, e) && (r.fixUpperEdge ? (n1.deleteRegion(t, r), t.mesh.delete(s), r = n1.regionBelow(e), s = r.eUp) : e.fixUpperEdge && (n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r), i = e.eUp)), i.Org !== s.Org) {
                if (i.Dst !== s.Dst && !e.fixUpperEdge && !r.fixUpperEdge && (i.Dst === t.event || s.Dst === t.event)) {
                    if (n1.checkForIntersect(t, e)) return;
                } else n1.checkForRightSplice(t, e);
            }
            i.Org === s.Org && i.Dst === s.Dst && (n1.addWinding(s, i), n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r));
        }
    }, n1.connectRightVertex = function(t, e, r) {
        var i, s = r.Onext, o = n1.regionBelow(e), a = e.eUp, l = o.eUp, u = !1;
        if (a.Dst !== l.Dst && n1.checkForIntersect(t, e), $e.vertEq(a.Org, t.event) && (t.mesh.splice(s.Oprev, a), e = n1.topLeftRegion(t, e), s = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), o), u = !0), $e.vertEq(l.Org, t.event) && (t.mesh.splice(r, l.Oprev), r = n1.finishLeftRegions(t, o, null), u = !0), u) {
            n1.addRightEdges(t, e, r.Onext, s, s, !0);
            return;
        }
        $e.vertLeq(l.Org, a.Org) ? i = l.Oprev : i = a, i = t.mesh.connect(r.Lprev, i), n1.addRightEdges(t, e, i, i.Onext, i.Onext, !1), i.Sym.activeRegion.fixUpperEdge = !0, n1.walkDirtyRegions(t, e);
    }, n1.connectLeftDegenerate = function(t, e, r) {
        var i, s, o, a, l;
        if (i = e.eUp, $e.vertEq(i.Org, r)) {
            nt(!1), n1.spliceMergeVertices(t, i, r.anEdge);
            return;
        }
        if (!$e.vertEq(i.Dst, r)) {
            t.mesh.splitEdge(i.Sym), e.fixUpperEdge && (t.mesh.delete(i.Onext), e.fixUpperEdge = !1), t.mesh.splice(r.anEdge, i), n1.sweepEvent(t, r);
            return;
        }
        nt(!1), e = n1.topRightRegion(e), l = n1.regionBelow(e), o = l.eUp.Sym, s = a = o.Onext, l.fixUpperEdge && (nt(s !== o), n1.deleteRegion(t, l), t.mesh.delete(o), o = s.Oprev), t.mesh.splice(r.anEdge, o), $e.edgeGoesLeft(s) || (s = null), n1.addRightEdges(t, e, o.Onext, a, s, !0);
    }, n1.connectLeftVertex = function(t, e) {
        var r, i, s, o, a, l, u = new eA;
        if (u.eUp = e.anEdge.Sym, r = t.dict.search(u).key, i = n1.regionBelow(r), !!i) {
            if (o = r.eUp, a = i.eUp, $e.edgeSign(o.Dst, e, o.Org) === 0) {
                n1.connectLeftDegenerate(t, r, e);
                return;
            }
            if (s = $e.vertLeq(a.Dst, o.Dst) ? r : i, r.inside || s.fixUpperEdge) {
                if (s === r) l = t.mesh.connect(e.anEdge.Sym, o.Lnext);
                else {
                    var c = t.mesh.connect(a.Dnext, e.anEdge);
                    l = c.Sym;
                }
                s.fixUpperEdge ? n1.fixUpperEdge(t, s, l) : n1.computeWinding(t, n1.addRegionBelow(t, r, l)), n1.sweepEvent(t, e);
            } else n1.addRightEdges(t, r, e.anEdge, e.anEdge, null, !0);
        }
    }, n1.sweepEvent = function(t, e) {
        t.event = e, n1.debugEvent(t);
        for(var r = e.anEdge; r.activeRegion === null;)if (r = r.Onext, r === e.anEdge) {
            n1.connectLeftVertex(t, e);
            return;
        }
        var i = n1.topLeftRegion(t, r.activeRegion);
        nt(i !== null);
        var s = n1.regionBelow(i), o = s.eUp, a = n1.finishLeftRegions(t, s, null);
        a.Onext === o ? n1.connectRightVertex(t, i, a) : n1.addRightEdges(t, i, a.Onext, o, o, !0);
    }, n1.addSentinel = function(t, e, r, i) {
        var s = new eA, o = t.mesh.makeEdge();
        o.Org.s = r, o.Org.t = i, o.Dst.s = e, o.Dst.t = i, t.event = o.Dst, s.eUp = o, s.windingNumber = 0, s.inside = !1, s.fixUpperEdge = !1, s.sentinel = !0, s.dirty = !1, s.nodeUp = t.dict.insert(s);
    }, n1.initEdgeDict = function(t) {
        t.dict = new K9(t, n1.edgeLeq);
        var e = t.bmax[0] - t.bmin[0], r = t.bmax[1] - t.bmin[1], i = t.bmin[0] - e, s = t.bmax[0] + e, o = t.bmin[1] - r, a = t.bmax[1] + r;
        n1.addSentinel(t, i, s, o), n1.addSentinel(t, i, s, a);
    }, n1.doneEdgeDict = function(t) {
        for(var e, r = 0; (e = t.dict.min().key) !== null;)e.sentinel || (nt(e.fixUpperEdge), nt(++r === 1)), nt(e.windingNumber === 0), n1.deleteRegion(t, e);
    }, n1.removeDegenerateEdges = function(t) {
        var e, r, i, s = t.mesh.eHead;
        for(e = s.next; e !== s; e = r)r = e.next, i = e.Lnext, $e.vertEq(e.Org, e.Dst) && e.Lnext.Lnext !== e && (n1.spliceMergeVertices(t, i, e), t.mesh.delete(e), e = i, i = e.Lnext), i.Lnext === e && (i !== e && ((i === r || i === r.Sym) && (r = r.next), t.mesh.delete(i)), (e === r || e === r.Sym) && (r = r.next), t.mesh.delete(e));
    }, n1.initPriorityQ = function(t) {
        var e, r, i, s = 0;
        for(i = t.mesh.vHead, r = i.next; r !== i; r = r.next)s++;
        for(s += 8, e = t.pq = new Q9(s, $e.vertLeq), i = t.mesh.vHead, r = i.next; r !== i; r = r.next)r.pqHandle = e.insert(r);
        return r !== i ? !1 : (e.init(), !0);
    }, n1.donePriorityQ = function(t) {
        t.pq = null;
    }, n1.removeDegenerateFaces = function(t, e) {
        var r, i, s;
        for(r = e.fHead.next; r !== e.fHead; r = i)i = r.next, s = r.anEdge, nt(s.Lnext !== s), s.Lnext.Lnext === s && (n1.addWinding(s.Onext, s), t.mesh.delete(s));
        return !0;
    }, n1.computeInterior = function(t, e) {
        e === void 0 && (e = !0);
        var r, i;
        if (n1.removeDegenerateEdges(t), !n1.initPriorityQ(t)) return !1;
        for(n1.initEdgeDict(t); (r = t.pq.extractMin()) !== null;){
            for(; i = t.pq.min(), !(i === null || !$e.vertEq(i, r));)i = t.pq.extractMin(), n1.spliceMergeVertices(t, r.anEdge, i.anEdge);
            n1.sweepEvent(t, r);
        }
        return t.event = t.dict.min().key.eUp.Org, n1.debugEvent(t), n1.doneEdgeDict(t), n1.donePriorityQ(t), n1.removeDegenerateFaces(t, t.mesh) ? (e && t.mesh.check(), !0) : !1;
    }, n1;
}(), J9 = function() {
    function n1() {
        this.mesh = new FO, this.normal = [
            0,
            0,
            0
        ], this.sUnit = [
            0,
            0,
            0
        ], this.tUnit = [
            0,
            0,
            0
        ], this.bmin = [
            0,
            0
        ], this.bmax = [
            0,
            0
        ], this.windingRule = Mt.ODD, this.dict = null, this.pq = null, this.event = null, this.vertexIndexCounter = 0, this.vertices = [], this.vertexIndices = [], this.vertexCount = 0, this.elements = [], this.elementCount = 0;
    }
    return n1.prototype.dot_ = function(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }, n1.prototype.normalize_ = function(t) {
        var e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2];
        if (!e) throw "Zero-size vector!";
        e = Math.sqrt(e), t[0] /= e, t[1] /= e, t[2] /= e;
    }, n1.prototype.longAxis_ = function(t) {
        var e = 0;
        return Math.abs(t[1]) > Math.abs(t[0]) && (e = 1), Math.abs(t[2]) > Math.abs(t[e]) && (e = 2), e;
    }, n1.prototype.computeNormal_ = function(t) {
        var e, r, i, s, o, a, l = [
            0,
            0,
            0
        ], u = [
            0,
            0,
            0
        ], c = [
            0,
            0,
            0
        ], d = [
            0,
            0,
            0
        ], h = [
            0,
            0,
            0
        ], f = [
            null,
            null,
            null
        ], p = [
            null,
            null,
            null
        ], m = this.mesh.vHead;
        e = m.next;
        for(var g = 0; g < 3; ++g)s = e.coords[g], u[g] = s, p[g] = e, l[g] = s, f[g] = e;
        for(e = m.next; e !== m; e = e.next)for(var y = 0; y < 3; ++y)s = e.coords[y], s < u[y] && (u[y] = s, p[y] = e), s > l[y] && (l[y] = s, f[y] = e);
        var v = 0;
        if (l[1] - u[1] > l[0] - u[0] && (v = 1), l[2] - u[2] > l[v] - u[v] && (v = 2), u[v] >= l[v]) {
            t[0] = 0, t[1] = 0, t[2] = 1;
            return;
        }
        for(a = 0, r = p[v], i = f[v], c[0] = r.coords[0] - i.coords[0], c[1] = r.coords[1] - i.coords[1], c[2] = r.coords[2] - i.coords[2], e = m.next; e !== m; e = e.next)d[0] = e.coords[0] - i.coords[0], d[1] = e.coords[1] - i.coords[1], d[2] = e.coords[2] - i.coords[2], h[0] = c[1] * d[2] - c[2] * d[1], h[1] = c[2] * d[0] - c[0] * d[2], h[2] = c[0] * d[1] - c[1] * d[0], o = h[0] * h[0] + h[1] * h[1] + h[2] * h[2], o > a && (a = o, t[0] = h[0], t[1] = h[1], t[2] = h[2]);
        a <= 0 && (t[0] = t[1] = t[2] = 0, t[this.longAxis_(c)] = 1);
    }, n1.prototype.checkOrientation_ = function() {
        for(var t = this.mesh.fHead, e, r = this.mesh.vHead, i, s = 0, o = t.next; o !== t; o = o.next)if (i = o.anEdge, !(i.winding <= 0)) do s += (i.Org.s - i.Dst.s) * (i.Org.t + i.Dst.t), i = i.Lnext;
        while (i !== o.anEdge);
        if (s < 0) {
            for(e = r.next; e !== r; e = e.next)e.t = -e.t;
            this.tUnit[0] = -this.tUnit[0], this.tUnit[1] = -this.tUnit[1], this.tUnit[2] = -this.tUnit[2];
        }
    }, n1.prototype.projectPolygon_ = function() {
        var t = this.mesh.vHead, e = [
            0,
            0,
            0
        ], r, i, s = !1;
        e[0] = this.normal[0], e[1] = this.normal[1], e[2] = this.normal[2], !e[0] && !e[1] && !e[2] && (this.computeNormal_(e), s = !0), r = this.sUnit, i = this.tUnit;
        var o = this.longAxis_(e);
        r[o] = 0, r[(o + 1) % 3] = 1, r[(o + 2) % 3] = 0, i[o] = 0, i[(o + 1) % 3] = 0, i[(o + 2) % 3] = e[o] > 0 ? 1 : -1;
        for(var a = t.next; a !== t; a = a.next)a.s = this.dot_(a.coords, r), a.t = this.dot_(a.coords, i);
        s && this.checkOrientation_();
        for(var l = !0, u = t.next; u !== t; u = u.next)l ? (this.bmin[0] = this.bmax[0] = u.s, this.bmin[1] = this.bmax[1] = u.t, l = !1) : (u.s < this.bmin[0] && (this.bmin[0] = u.s), u.s > this.bmax[0] && (this.bmax[0] = u.s), u.t < this.bmin[1] && (this.bmin[1] = u.t), u.t > this.bmax[1] && (this.bmax[1] = u.t));
    }, n1.prototype.addWinding_ = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.prototype.tessellateMonoRegion_ = function(t, e) {
        var r, i;
        if (r = e.anEdge, !(r.Lnext !== r && r.Lnext.Lnext !== r)) throw "Mono region invalid";
        for(; $e.vertLeq(r.Dst, r.Org); r = r.Lprev);
        for(; $e.vertLeq(r.Org, r.Dst); r = r.Lnext);
        i = r.Lprev;
        for(var s = void 0; r.Lnext !== i;)if ($e.vertLeq(r.Dst, i.Org)) {
            for(; i.Lnext !== r && ($e.edgeGoesLeft(i.Lnext) || $e.edgeSign(i.Org, i.Dst, i.Lnext.Dst) <= 0);)s = t.connect(i.Lnext, i), i = s.Sym;
            i = i.Lprev;
        } else {
            for(; i.Lnext !== r && ($e.edgeGoesRight(r.Lprev) || $e.edgeSign(r.Dst, r.Org, r.Lprev.Org) >= 0);)s = t.connect(r, r.Lprev), r = s.Sym;
            r = r.Lnext;
        }
        if (i.Lnext === r) throw "Mono region invalid";
        for(; i.Lnext.Lnext !== r;)s = t.connect(i.Lnext, i), i = s.Sym;
        return !0;
    }, n1.prototype.tessellateInterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)if (e = r.next, r.inside && !this.tessellateMonoRegion_(t, r)) return !1;
        return !0;
    }, n1.prototype.discardExterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)e = r.next, r.inside || t.zapFace(r);
    }, n1.prototype.setWindingNumber_ = function(t, e, r) {
        for(var i, s = t.eHead.next; s !== t.eHead; s = i)i = s.next, s.Rface.inside !== s.Lface.inside ? s.winding = s.Lface.inside ? e : -e : r ? t.delete(s) : s.winding = 0;
    }, n1.prototype.getNeighbourFace_ = function(t) {
        return !t.Rface || !t.Rface.inside ? -1 : t.Rface.n;
    }, n1.prototype.outputPolymesh_ = function(t, e, r, i) {
        var s, o = 0, a = 0, l;
        r > 3 && t.mergeConvexFaces(r);
        for(var u = t.vHead.next; u !== t.vHead; u = u.next)u.n = -1;
        for(var c = t.fHead.next; c !== t.fHead; c = c.next)if (c.n = -1, !!c.inside) {
            s = c.anEdge, l = 0;
            do {
                var u = s.Org;
                u.n === -1 && (u.n = a, a++), l++, s = s.Lnext;
            }while (s !== c.anEdge);
            if (l > r) throw "Face vertex greater that support polygon";
            c.n = o, ++o;
        }
        this.elementCount = o, e === Rr.CONNECTED_POLYGONS && (o *= 2), this.elements = [], this.elements.length = o * r, this.vertexCount = a, this.vertices = [], this.vertices.length = a * i, this.vertexIndices = [], this.vertexIndices.length = a;
        for(var u = t.vHead.next; u !== t.vHead; u = u.next)if (u.n !== -1) {
            var d = u.n * i;
            this.vertices[d + 0] = u.coords[0], this.vertices[d + 1] = u.coords[1], i > 2 && (this.vertices[d + 2] = u.coords[2]), this.vertexIndices[u.n] = u.idx;
        }
        for(var h = 0, c = t.fHead.next; c !== t.fHead; c = c.next)if (!!c.inside) {
            s = c.anEdge, l = 0;
            do {
                var u = s.Org;
                this.elements[h++] = u.n, l++, s = s.Lnext;
            }while (s !== c.anEdge);
            for(var f = l; f < r; ++f)this.elements[h++] = -1;
            if (e === Rr.CONNECTED_POLYGONS) {
                s = c.anEdge;
                do this.elements[h++] = this.getNeighbourFace_(s), s = s.Lnext;
                while (s !== c.anEdge);
                for(var p = l; p < r; ++p)this.elements[h++] = -1;
            }
        }
    }, n1.prototype.outputContours_ = function(t, e) {
        var r, i, s = 0, o = 0;
        this.vertexCount = 0, this.elementCount = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            i = r = a.anEdge;
            do this.vertexCount++, r = r.Lnext;
            while (r !== i);
            this.elementCount++;
        }
        this.elements = [], this.elements.length = this.elementCount * 2, this.vertices = [], this.vertices.length = this.vertexCount * e, this.vertexIndices = [], this.vertexIndices.length = this.vertexCount;
        var l = 0, u = 0, c = 0;
        s = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            o = 0, i = r = a.anEdge;
            do this.vertices[l++] = r.Org.coords[0], this.vertices[l++] = r.Org.coords[1], e > 2 && (this.vertices[l++] = r.Org.coords[2]), this.vertexIndices[u++] = this.vertexIdCallback ? this.vertexIdCallback(r) : r.Org.idx, o++, r = r.Lnext;
            while (r !== i);
            this.elements[c++] = s, this.elements[c++] = o, s += o;
        }
    }, n1.prototype.addContour = function(t, e) {
        this.mesh === null && (this.mesh = new FO), t < 2 && (t = 2), t > 3 && (t = 3);
        for(var r = null, i = 0; i < e.length; i += t)r === null ? (r = this.mesh.makeEdge(), this.mesh.splice(r, r.Sym)) : (this.mesh.splitEdge(r), r = r.Lnext), r.Org.coords[0] = e[i + 0], r.Org.coords[1] = e[i + 1], t > 2 ? r.Org.coords[2] = e[i + 2] : r.Org.coords[2] = 0, r.Org.idx = this.vertexIndexCounter++, this.edgeCreateCallback && this.edgeCreateCallback(r), r.winding = 1, r.Sym.winding = -1;
    }, n1.prototype.tesselate = function(t, e, r, i, s, o) {
        if (t === void 0 && (t = Mt.ODD), e === void 0 && (e = Rr.POLYGONS), o === void 0 && (o = !0), this.vertices = [], this.elements = [], this.vertexIndices = [], this.vertexIndexCounter = 0, s && (this.normal[0] = s[0], this.normal[1] = s[1], this.normal[2] = s[2]), this.windingRule = t, i < 2 && (i = 2), i > 3 && (i = 3), !this.mesh) return !1;
        this.projectPolygon_(), Z9.computeInterior(this, o);
        var a = this.mesh;
        return e === Rr.BOUNDARY_CONTOURS ? this.setWindingNumber_(a, 1, !0) : this.tessellateInterior_(a), o && a.check(), e === Rr.BOUNDARY_CONTOURS ? this.outputContours_(a, i) : this.outputPolymesh_(a, e, r, i), !0;
    }, n1;
}();
function Hs(n1) {
    var t = n1.windingRule, e = t === void 0 ? Mt.ODD : t, r = n1.elementType, i = r === void 0 ? Rr.POLYGONS : r, s = n1.polySize, o = s === void 0 ? 3 : s, a = n1.vertexSize, l = a === void 0 ? 2 : a, u = n1.normal, c = u === void 0 ? [
        0,
        0,
        1
    ] : u, d = n1.contours, h = d === void 0 ? [] : d, f = n1.strict, p = f === void 0 ? !0 : f, m = n1.debug, g = m === void 0 ? !1 : m;
    if (!h && p) throw new Error("Contours can't be empty");
    if (!!h) {
        var y = new J9;
        n1.edgeCreateCallback && (y.edgeCreateCallback = n1.edgeCreateCallback), n1.vertexIdCallback && (y.vertexIdCallback = n1.vertexIdCallback);
        for(var v = 0; v < h.length; v++)y.addContour(l || 2, h[v]);
        return y.tesselate(e, i, o, l, c, p), {
            vertices: y.vertices,
            vertexIndices: y.vertexIndices,
            vertexCount: y.vertexCount,
            elements: y.elements,
            elementCount: y.elementCount,
            mesh: g ? y.mesh : void 0
        };
    }
}
var dge = Mt.ODD, hge = Mt.NONZERO, fge = Mt.POSITIVE, pge = Mt.NEGATIVE, mge = Mt.ABS_GEQ_TWO, gge = Rr.POLYGONS, yge = Rr.CONNECTED_POLYGONS, vge = Rr.BOUNDARY_CONTOURS;
var v0 = class {
    constructor(t = 256, e = !1){
        this.capacity = t, this.size = 0, this.debug = e, this.debug && console.log(`allocating with cap ${t}`);
        let r = t * v0.eSize;
        this.buffer = new ArrayBuffer(r);
        let i = Float32Array.BYTES_PER_ELEMENT, s = 0;
        this.positions = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.normals = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.uvs = new Float32Array(this.buffer, s * i, 2 * t);
    }
    realloc(t, e = !1) {
        if (t < this.size) throw Error("cannot shrink buffer");
        if (t <= this.capacity && !e) return;
        this.debug && console.log(`resizing from ${this.capacity} \u2192 ${t}`);
        let r = t * v0.eSize, i = new ArrayBuffer(r), s = Float32Array.BYTES_PER_ELEMENT, o = 0, a = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let l = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let u = new Float32Array(i, o * s, 2 * t);
        e ? (a.set(this.positions.subarray(0, this.size * 3)), l.set(this.normals.subarray(0, this.size * 3)), u.set(this.uvs.subarray(0, this.size * 2))) : (a.set(this.positions), l.set(this.normals), u.set(this.uvs)), this.buffer = i, this.positions = a, this.normals = l, this.uvs = u, this.capacity = t;
    }
    get(t = 1) {
        let e = this.size + t;
        if (e > this.capacity) {
            let i = this.capacity;
            for(; e > i;)i *= 2;
            this.realloc(i);
        }
        let r = this.size;
        return this.size = e, r;
    }
    reserve(t) {
        let e = this.size + t;
        e > this.capacity && this.realloc(e);
    }
    shrink() {
        this.debug && console.log(`shrinking ${this.capacity} \u2192 ${this.size}`), this.realloc(this.size, !0);
    }
}, lm = v0;
lm.eSize = 8 * Float32Array.BYTES_PER_ELEMENT;
var HO = Pi(jO()), cm = {
    vertices: [
        160,
        160,
        -160,
        160,
        -160,
        -160,
        160,
        -160
    ],
    vertexIndices: [
        1,
        0,
        3,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        4
    ],
    elementCount: 1,
    mesh: void 0
}, sA = {
    vertices: [],
    vertexIndices: [],
    vertexCount: 0,
    elements: [],
    elementCount: 0,
    mesh: void 0
}, oA = {
    vertices: [
        -160,
        160,
        160,
        -160,
        160,
        160,
        -160,
        -160
    ],
    vertexIndices: [
        1,
        3,
        0,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        1,
        2,
        1,
        0,
        3
    ],
    elementCount: 2,
    mesh: void 0
}, nA = (n1, t)=>([e, r])=>(r < e && (r += t), (n1 >= e ? n1 : n1 + t) <= r), Ol = class extends we {
    constructor(e, r, i = 0, s = 12, o = 3, a = Mt.ODD, l = !1){
        super();
        this.forPathBevel = l;
        this.type = "ShapeGeometry";
        this.vertexCache = {};
        this._shape = e, this._depth = r, this._curveSegments = s, this._bevelSegmentsInput = o;
        let u = this._shape.extractShapePointsToFlatArray([], s), c = this._shape.shapeHoles.map((C)=>{
            let P = C.extractShapePointsToFlatArray([], s), D = [];
            for(let O = P.length - 1; O >= 1; O -= 2){
                let I = P[O - 1], z = P[O - 0];
                D.push(I, z);
            }
            return D;
        }), d = [], h = [];
        for(let C = 0; C < u.length; C += 2)h.push([
            u[C],
            u[C + 1]
        ]);
        d.push(h);
        for(let C = 0; C < c.length; C++){
            let P = c[C], D = [];
            for(let O = 0; O < P.length; O += 2)D.push([
                P[O],
                P[O + 1]
            ]);
            d.push(D);
        }
        let f;
        e.isText ? f = new Xu().setFromPoints(e.points.map((P)=>P.position)).getSize(new N).length() * .1 : d[0].length === 0 ? f = i : f = (0, HO.default)(d).distance, i <= 0 ? (this._bevel = 0, this._bevelSegments = 0) : (this._bevel = Math.min(i, f, r / 2), this._bevelSegments = Math.floor(o));
        let p;
        try {
            p = Hs({
                windingRule: a,
                elementType: Rr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    u
                ]
            });
        } catch  {
            p = cm;
        }
        let m;
        try {
            m = Hs({
                windingRule: Mt.ODD,
                elementType: Rr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...c
                ]
            });
        } catch  {
            m = sA;
        }
        if (!p) throw new Error("error generating geometry");
        let g = p.elementCount;
        if (m) {
            p.elementCount += m.elementCount;
            for(let C = 0; C < m.elements.length; C++){
                let P = m.elements[C], D = C % 2 === 0 ? p.vertexCount : 0;
                p.elements.push(P + D);
            }
            for(let C = 0; C < m.vertexIndices.length; C++){
                let P = m.vertexIndices[C], D = p.vertexCount;
                p.vertexIndices.push(P + D);
            }
            for(let C = 0; C < m.vertices.length; C++){
                let P = m.vertices[C];
                p.vertices.push(P);
            }
        }
        let y = 1 / 0, v = -1 / 0, x = 1 / 0, S = -1 / 0;
        for(let C = 0, P = p.vertexCount; C < P; C++){
            let D = C * 2, O = p.vertices[D + 0], I = p.vertices[D + 1];
            O < y && (y = O), O > v && (v = O), I < x && (x = I), I > S && (S = I);
        }
        this._minX = y, this._minY = x, this._width = v - y, this._height = S - x, this._buffer = new lm(this._computeBufferEstimatedSize(p));
        let w = [], A = [];
        for(let C = p.elementCount - 1; C >= 0; C--){
            let P = C >= g, D = C * 2, O = p.elements[D + 0], I = p.elements[D + 1], z = O + I, B = {
                start: O,
                count: I,
                normals: [],
                continuous: [],
                concave: []
            }, V = O, U = z - 1, j = O + 1, W = this._shape.roundedCurves.length;
            do {
                let G = V - O, J = p.vertices[U * 2 + 0], Z = p.vertices[U * 2 + 1], K = p.vertices[V * 2 + 0], Y = p.vertices[V * 2 + 1], ye = p.vertices[j * 2 + 0], fe = p.vertices[j * 2 + 1], oe = K - J, _e = Y - Z, xe = Math.sqrt(oe * oe + _e * _e);
                oe /= xe, _e /= xe;
                let Ie = K - ye, Oe = Y - fe, Pe = Math.sqrt(Ie * Ie + Oe * Oe);
                Ie /= Pe, Oe /= Pe, B.normals[G * 2 + 0] = -Oe, B.normals[G * 2 + 1] = Ie, B.concave[G] = oe * Oe - _e * Ie > 0;
                let Te = p.vertexIndices[V];
                if (Array.isArray(Te)) B.continuous[G] = !1;
                else {
                    let [Ve, Ue] = this._shape.getCurveIndexFromVertexId(Te - 1, !0);
                    if (Ue > 0 && Ue < 1) B.continuous[G] = !0;
                    else {
                        let L = Ue === 1 ? Ve + 1 : Ve - 1;
                        L = (L + W) % W;
                        let R = Ue === 1 ? 0 : 1, ie = this._shape.roundedCurves[Ve].getTangent(Ue), ue = this._shape.roundedCurves[L].getTangent(R);
                        B.continuous[G] = ie.dot(ue) > .95;
                    }
                }
                P && (B.normals[G * 2 + 0] *= -1, B.normals[G * 2 + 1] *= -1), [U, V, j] = [
                    V,
                    j,
                    j + 1
                ], j >= z && (j -= I);
            }while (j !== O + 1);
            let k = [];
            k.push({
                bevelI: 0,
                angle: 0,
                size: 0,
                boundary: {
                    vertices: p.vertices.slice(O * 2, z * 2),
                    vertexCount: I,
                    vertexIndices: new Array(I).fill(!0).map((G, J)=>[
                            J,
                            J
                        ]),
                    elements: [
                        0,
                        I
                    ],
                    elementCount: 1,
                    mesh: null
                },
                reverseMap: [],
                insetPoints: p.vertices.slice(O * 2, z * 2)
            });
            let H = 0;
            for(let G = 1; G <= this._bevelSegments; G++){
                let J = G / this._bevelSegments * Math.PI / 2, Z = (1 - Math.cos(J)) * this._bevel, K = [], Y = [], ye = [], fe = [], oe = 0;
                for(let xe = 0; xe < I; xe++){
                    let Ie = xe * 2, Oe = (xe - 1 + I) % I * 2, Pe = p.vertices[B.start * 2 + Ie + 0], Te = p.vertices[B.start * 2 + Ie + 1], Ve = -B.normals[Oe + 0] * Z, Ue = -B.normals[Oe + 1] * Z, L = -B.normals[Ie + 0] * Z, R = -B.normals[Ie + 1] * Z;
                    if (B.concave[xe] || !B.concave[xe] && P) {
                        let ie = Math.atan2(Ue, Ve), ue = Math.atan2(R, L);
                        ue > ie && (ue -= Math.PI * 2);
                        let me = ue - ie;
                        if (B.continuous[xe] || P) {
                            let De = ie + me / 2, Me = Math.cos(De) * Z, Ee = Math.sin(De) * Z;
                            K[2 * oe + 0] = Pe + Me * (P ? -1 : 1), K[2 * oe + 1] = Te + Ee * (P ? -1 : 1), fe[oe] = xe, oe++;
                        } else {
                            let De = Math.max(1, Math.floor(s / 4 * Math.abs(me) / Math.PI));
                            for(let Me = 0; Me <= De; Me++){
                                let Ee = ie + me * (Me / De), le = Math.cos(Ee) * Z, Je = Math.sin(Ee) * Z;
                                K[2 * oe + 0] = Pe + le, K[2 * oe + 1] = Te + Je, fe[oe] = xe, oe++;
                            }
                        }
                    } else K[2 * oe + 0] = Pe + Ve, K[2 * oe + 1] = Te + Ue, fe[oe] = xe, Y[xe] = oe, oe++, K[2 * oe + 0] = Pe, K[2 * oe + 1] = Te, fe[oe] = xe, oe++, K[2 * oe + 0] = Pe + L, K[2 * oe + 1] = Te + R, fe[oe] = xe, ye[xe] = oe, oe++;
                }
                let _e = Hs({
                    windingRule: Mt.POSITIVE,
                    elementType: Rr.BOUNDARY_CONTOURS,
                    vertexSize: 2,
                    strict: !0,
                    contours: [
                        K
                    ],
                    edgeCreateCallback: (xe)=>{
                        let Oe = xe.Org.idx, Pe = fe[Oe], Te = fe[(Oe + 1) % fe.length];
                        xe.idx = [
                            Pe,
                            Te
                        ], xe.Sym.idx = [
                            Te,
                            Pe
                        ];
                    },
                    vertexIdCallback: (xe)=>{
                        let Ie = xe.Lprev.idx;
                        return [
                            Ie ? Ie[1] : 0,
                            xe.idx ? xe.idx[0] : 0
                        ];
                    }
                });
                if (!_e) throw console.log("Error"), new Error(`error generating bevel geometry for ${G}'th loop`);
                if (!_e.vertexCount) {
                    let xe = (G - 1) / this._bevelSegments * Math.PI / 2;
                    H = (1 - Math.sin(xe)) * this._bevel;
                    break;
                }
                for(let xe = 0; xe < _e.vertexIndices.length; xe++){
                    let [Ie, Oe] = _e.vertexIndices[xe];
                    if (Ie === Oe) continue;
                    let Pe = Oe;
                    Oe < Ie && (Pe += I);
                    for(let Te = Ie; Te < Pe; Te++){
                        let Ve = Te % I, Ue = (Te + 1) % I;
                        if (!B.continuous[Ve] || !B.continuous[Ue]) {
                            _e.vertexIndices[xe] = [
                                Ie,
                                Ve
                            ], _e.vertexIndices.splice(xe + 1, 0, [
                                Ue,
                                Oe
                            ]), _e.vertices.splice((xe + 1) * 2, 0, _e.vertices[xe * 2], _e.vertices[xe * 2 + 1]);
                            break;
                        }
                    }
                }
                k.push({
                    bevelI: G,
                    angle: J,
                    size: Z,
                    boundary: _e,
                    reverseMap: fe,
                    insetPoints: K
                });
            }
            let X = (G, J, Z)=>{
                let K = 0, Y = G.boundary.vertexIndices.length;
                for(; K < Y && Z(G.boundary.vertexIndices[J]);)J = (J + 1) % Y, K++;
                return K;
            }, q = w.length;
            for(let G = 1; G < k.length; G++){
                let J = k[G - 1], Z = k[G], K = J.boundary.vertexIndices.length, Y = Z.boundary.vertexIndices.length;
                if (!K || !Y) break;
                let ye = B.concave.length, fe = 0, oe = nA(fe, I);
                for(; !J.boundary.vertexIndices.filter(oe).length || !Z.boundary.vertexIndices.filter(oe).length;)fe++, oe = nA(fe, I);
                let _e = J.boundary.vertexIndices.findIndex(oe), xe = Z.boundary.vertexIndices.findIndex(oe);
                do _e = (_e + 1) % K;
                while (oe(J.boundary.vertexIndices[_e]));
                do xe = (xe + 1) % Y;
                while (oe(Z.boundary.vertexIndices[xe]));
                fe = (fe + 1) % I;
                let Ie = fe, Oe = 0, Pe = this._buildBevelVert(B, J, (_e - 1 + K) % K, void 0, Oe), Te = this._buildBevelVert(B, Z, (xe - 1 + Y) % Y, void 0, Oe), Ve = Pe, Ue = Te, L, R, ie = !1;
                do {
                    Oe = (fe || ye) / ye, oe = nA(fe, I);
                    let ue = X(J, _e, oe), me = X(Z, xe, oe), De = ie;
                    if (ie = !1, ue && !me) {
                        for(let Me = 0; Me < ue; Me++)L = this._buildBevelVert(B, J, (_e + Me) % K, Me / (ue - 1), Oe), w.push(Ve.topN, L.topP, Ue.topN), l === !1 && w.push(L.bottomP, Ve.bottomN, Ue.bottomN), Ve = L;
                        ie = !0;
                    } else if (!ue && me) for(let Me = 0; Me < me; Me++)R = this._buildBevelVert(B, Z, (xe + Me) % Y, Me / (me - 1), Oe), w.push(Ue.topN, Ve.topP, R.topP), l === !1 && w.push(Ve.bottomP, Ue.bottomN, R.bottomP), Ue = R;
                    else if (ue && me) {
                        if (L = this._buildBevelVert(B, J, _e, 0, Oe), R = this._buildBevelVert(B, Z, xe, 0, Oe), De ? (w.push(Ve.topN, R.topP, Ue.topN), w.push(Ve.topN, L.topP, R.topP), l === !1 && (w.push(R.bottomP, Ve.bottomN, Ue.bottomN), w.push(R.bottomP, L.bottomP, Ve.bottomN))) : (w.push(Ue.topN, Ve.topN, L.topP), w.push(Ue.topN, L.topP, R.topP), l === !1 && (w.push(L.bottomP, Ve.bottomN, Ue.bottomN), w.push(L.bottomP, Ue.bottomN, R.bottomP))), Ve = L, Ue = R, ue === me) for(let Me = 1; Me < ue; Me++)L = this._buildBevelVert(B, J, (_e + Me) % K, Me / (ue - 1), Oe), R = this._buildBevelVert(B, Z, (xe + Me) % Y, Me / (me - 1), Oe), w.push(Ve.topN, L.topP, Ue.topN), w.push(Ue.topN, L.topP, R.topP), l === !1 && (w.push(L.bottomP, Ve.bottomN, Ue.bottomN), w.push(L.bottomP, Ue.bottomN, R.bottomP)), Ve = L, Ue = R;
                        else if (ue > me) {
                            let Me = ue / me, Ee = 0;
                            for(let le = 1; le < ue; le++)L = this._buildBevelVert(B, J, (_e + le) % K, le / (ue - 1), Oe), w.push(Ve.topN, L.topP, Ue.topN), l === !1 && w.push(L.bottomP, Ve.bottomN, Ue.bottomN), Ve = L, le > (Ee + 1) * Me && (Ee++, R = this._buildBevelVert(B, Z, (xe + Ee) % Y, Ee / (me - 1), Oe), w.push(Ue.topN, L.topP, R.topP), l === !1 && w.push(L.bottomP, Ue.bottomN, R.bottomP), Ue = R);
                        } else {
                            let Me = me / ue, Ee = 0;
                            for(let le = 1; le < me; le++)R = this._buildBevelVert(B, Z, (xe + le) % Y, le / (me - 1), Oe), w.push(Ue.topN, L.topP, R.topP), l === !1 && w.push(L.bottomP, Ue.bottomN, R.bottomP), Ue = R, le > (Ee + 1) * Me && (Ee++, L = this._buildBevelVert(B, J, (_e + Ee) % K, Ee / (ue - 1), Oe), w.push(Ve.topN, L.topP, Ue.topN), l === !1 && w.push(L.bottomP, Ve.bottomN, Ue.bottomN), Ve = L);
                        }
                    }
                    _e = (_e + ue) % K, xe = (xe + me) % Y, fe = (fe + 1) % ye;
                }while (fe !== Ie);
            }
            if (l === !1 && this._depth > this._bevel * 2 && this._buildWall(k, B, w), P) {
                let G = [];
                for(let J = w.length - 1; J >= q + 2; J -= 3){
                    let Z = w[J - 2], K = w[J - 1], Y = w[J - 0];
                    G.push(Y, K, Z);
                }
                w.splice(q, w.length - q, ...G);
            }
            if (P) {
                let G = [];
                for(let J = k[k.length - 1].boundary.vertices.length - 1; J >= 1; J -= 2){
                    let Z = k[k.length - 1].boundary.vertices[J - 1], K = k[k.length - 1].boundary.vertices[J - 0];
                    G.push(Z, K);
                }
                A.push(G);
            }
            if (!P) {
                let G = k[k.length - 1], J;
                try {
                    J = Hs({
                        windingRule: k.length > 1 ? Mt.POSITIVE : Mt.ODD,
                        elementType: Rr.POLYGONS,
                        vertexSize: 2,
                        strict: !0,
                        contours: [
                            G.insetPoints,
                            ...A
                        ]
                    });
                } catch  {
                    J = oA;
                }
                if (!J) throw new Error("Error generating geometry for surface");
                c.length === 0 && this._bevel < f && Object.assign(this, {
                    useNgonForTopBottomFaceDuringBake: !0
                });
                for(let Z = 0; Z < J.elementCount * 3; Z += 3){
                    let K = this._buildSurfaceVert(J, J.elements[Z + 0], H), Y = this._buildSurfaceVert(J, J.elements[Z + 1], H), ye = this._buildSurfaceVert(J, J.elements[Z + 2], H);
                    w.push(K.top, Y.top, ye.top), l === !1 && w.push(ye.bottom, Y.bottom, K.bottom);
                }
            }
            this.vertexCache = {};
        }
        this._buffer.shrink();
        let E = new Ge(Uint32Array.from(w), 1), b = new Ge(this._buffer.positions, 3), T = new Ge(this._buffer.normals, 3), M = new Ge(this._buffer.uvs, 2);
        b.needsUpdate = !0, T.needsUpdate = !0, M.needsUpdate = !0, E.needsUpdate = !0, this.setAttribute("position", b), this.setAttribute("normal", T), this.setAttribute("uv", M), this.setIndex(E);
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s, o), u = this._buildBevelVert(r, s, (o + 1) % a);
            i.push(u.topP, l.topN, l.bottomN), i.push(u.topP, l.bottomN, u.bottomP);
        }
    }
    _buildSurfaceVert(e, r, i) {
        let s = r.toString();
        if (s in this.vertexCache) return this.vertexCache[s];
        let o = e.vertices[r * 2 + 0], a = e.vertices[r * 2 + 1], l = (o - this._minX) / this._width, u = (a - this._minY) / this._height;
        this.forPathBevel && (u = 1);
        let c = this._buffer.get(this.forPathBevel ? 1 : 2), d = c * 3, h = c * 2, f = {
            top: c + 0,
            bottom: c + 1
        };
        return this._buffer.positions[d + 0] = o, this._buffer.positions[d + 1] = a, this._buffer.positions[d + 2] = this.forPathBevel ? this._bevel : this._depth - i, this._buffer.normals[d + 0] = 0, this._buffer.normals[d + 1] = 0, this._buffer.normals[d + 2] = 1, this._buffer.uvs[h + 0] = l, this._buffer.uvs[h + 1] = u, this.forPathBevel === !1 && (this._buffer.positions[d + 3] = o, this._buffer.positions[d + 4] = a, this._buffer.positions[d + 5] = i, this._buffer.normals[d + 3] = 0, this._buffer.normals[d + 4] = 0, this._buffer.normals[d + 5] = -1, this._buffer.uvs[h + 2] = l, this._buffer.uvs[h + 3] = u), this.vertexCache[s] = f, f;
    }
    _buildBevelVert(e, r, i, s = 1, o) {
        let a = `${r.bevelI}:${i}`;
        if (a in this.vertexCache && o !== 0 && o !== 1 && (!o || o === this.vertexCache[a].pathBevelUCoord)) return this.vertexCache[a];
        let [l, u] = r.boundary.vertexIndices[i], c, d, h, f;
        l !== u ? (d = l, c = u, f = !1, h = e.continuous[d] && e.continuous[c]) : (c = l, d = (c - 1 + e.count) % e.count, f = e.concave[c] && r.bevelI > 0, h = e.continuous[c] || f);
        let p = Math.cos(r.angle), m = Math.sin(r.angle), g = i * 2, y = c * 2, v = d * 2, x = r.boundary.vertices[g + 0], S = r.boundary.vertices[g + 1], w = (1 - m) * this._bevel, A = (x - this._minX) / this._width, E = (S - this._minY) / this._height;
        this.forPathBevel && (o !== void 0 && (A = o), E = 1);
        let b = e.normals[y + 0], T = e.normals[y + 1], M = e.normals[v + 0], C = e.normals[v + 1];
        if (f) {
            let z = M - b, B = C - T;
            b = b + z * (1 - s), T = T + B * (1 - s);
            let V = Math.sqrt(b * b + T * T);
            b /= V, T /= V;
        }
        let P = this.forPathBevel ? this._buffer.get(h ? 1 : 2) : this._buffer.get(h ? 2 : 4), D = P * 3, O = P * 2, I = {
            i: i,
            fi: c,
            topP: P + 0,
            topN: P + 0,
            bottomP: P + 1,
            bottomN: P + 1,
            pathBevelUCoord: o
        };
        return this._buffer.positions[D + 0] = x, this._buffer.positions[D + 1] = S, this._buffer.positions[D + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[D + 0] = b * p, this._buffer.normals[D + 1] = T * p, this._buffer.normals[D + 2] = m, this._buffer.uvs[O + 0] = A, this._buffer.uvs[O + 1] = E, this.forPathBevel === !1 && (this._buffer.positions[D + 3] = x, this._buffer.positions[D + 4] = S, this._buffer.positions[D + 5] = w, this._buffer.normals[D + 3] = b * p, this._buffer.normals[D + 4] = T * p, this._buffer.normals[D + 5] = -m, this._buffer.uvs[O + 2] = E, this._buffer.uvs[O + 3] = A), h || (this.forPathBevel ? (P += 1, D += 3, O += 2) : (P += 2, D += 6, O += 4), I.topP = P + 0, I.bottomP = P + 1, this._buffer.positions[D + 0] = x, this._buffer.positions[D + 1] = S, this._buffer.positions[D + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[D + 0] = M * p, this._buffer.normals[D + 1] = C * p, this._buffer.normals[D + 2] = m, this._buffer.uvs[O + 0] = A, this._buffer.uvs[O + 1] = E, this.forPathBevel === !1 && (this._buffer.positions[D + 3] = x, this._buffer.positions[D + 4] = S, this._buffer.positions[D + 5] = w, this._buffer.normals[D + 3] = M * p, this._buffer.normals[D + 4] = C * p, this._buffer.normals[D + 5] = -m, this._buffer.uvs[O + 2] = E, this._buffer.uvs[O + 3] = A)), this.vertexCache[a] = I, I;
    }
    clone() {
        let e = new Ol(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = ha(this.userData), e;
    }
};
var xh = class extends we {
    constructor(e, r = 12, i = {}){
        super();
        this.type = "ShapeGeometry";
        this.windingRule = Mt.ODD;
        this.elementType = Rr.POLYGONS;
        this.polySize = 3;
        this.vertexSize = 2;
        this.strict = !0;
        this._shape = e, this._curveSegments = r, this._triangulationOptions = Object.assign({
            windingRule: Mt.ODD,
            elementType: Rr.POLYGONS,
            polySize: 3,
            vertexSize: 2,
            strict: !0
        }, i);
        let s = this._shape.extractShapePointsToFlatArray([], this._curveSegments), o = this._shape.shapeHoles.map((p)=>p.extractShapePointsToFlatArray([], this._curveSegments)), a, l = !0, u = !0, c, d;
        for(let p = 0, m = s.length / 2; p < m; p++){
            let g = p * 2, y = s[g + 0], v = s[g + 1];
            if (c !== void 0 && y !== c && (l = !1), d !== void 0 && v !== d && (u = !1), c = y, d = v, !l && !u) break;
        }
        if (!l && !u) try {
            a = Hs({
                contours: [
                    s,
                    ...o
                ],
                windingRule: this._triangulationOptions.windingRule,
                elementType: this._triangulationOptions.elementType,
                polySize: this._triangulationOptions.polySize,
                vertexSize: this._triangulationOptions.vertexSize,
                strict: this._triangulationOptions.strict
            });
        } catch  {
            a = cm;
        }
        let h = a?.vertexCount ?? 1, f = a?.elementCount ?? 1;
        if (this._positionAttribute = new Ge(new Float32Array(h * 3), 3), this._normalAttribute = new Ge(new Float32Array(h * 3), 3), this._uvAttribute = new Ge(new Float32Array(h * 2), 2), this._indexAttribute = new Ge(new Uint32Array(f * 3), 1), a) {
            let p = 1 / 0, m = -1 / 0, g = 1 / 0, y = -1 / 0;
            for(let S = 0, w = h; S < w; S++){
                let A = S * 2, E = a.vertices[A + 0], b = a.vertices[A + 1];
                E < p && (p = E), E > m && (m = E), b < g && (g = b), b > y && (y = b);
            }
            let v = m - p, x = y - g;
            for(let S = 0, w = h; S < w; S++){
                let A = S * 2, E = a.vertices[A + 0], b = a.vertices[A + 1], T = (E - p) / v, M = (b - g) / x;
                this._positionAttribute.setXYZ(S, E, b, 0), this._normalAttribute.setXYZ(S, 0, 0, 1), this._uvAttribute.setXY(S, T, M);
            }
            for(let S = 0, w = f; S < w; S++){
                let A = S * 3, E = a.elements[A + 0], b = a.elements[A + 1], T = a.elements[A + 2];
                this._indexAttribute.setX(A + 0, E), this._indexAttribute.setX(A + 1, b), this._indexAttribute.setX(A + 2, T);
            }
        }
        this.setAttribute("position", this._positionAttribute), this.setAttribute("normal", this._normalAttribute), this.setAttribute("uv", this._uvAttribute), this.setIndex(this._indexAttribute), this.setDrawRange(0, (a?.elementCount ?? 1) * 3);
    }
    clone() {
        let e = new xh(this._shape, this._curveSegments);
        return e.userData = ha(this.userData), e;
    }
};
var bh = class extends Ol {
    constructor(e, r, i = 0, s = 12, o = 3, a = Mt.ODD){
        super(e, r, i, s, o, a);
        this.type = "ShapeGeometry";
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s, o), u = this._buildBevelVert(r, s, (o + 1) % a);
            i.push(u.topP, l.topN, l.bottomN), i.push(u.topP, l.bottomN, u.bottomP);
        }
    }
    clone() {
        let e = new bh(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = ha(this.userData), e;
    }
};
var Dn = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            subdivisions: 40,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3,
            windingRule: Mt.ODD
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = n1.shape ?? t?.shape, a = o?.roundness ?? e.roundness;
        o !== void 0 && (o instanceof kt ? (o.width !== r || o.height !== i) && o.applySize(r, i) : o = new kt(r, i).fromJSON(o), n1.parameters?.roundness !== void 0 && n1.parameters?.roundness > 0 && o.update());
        let l = o ?? new kt(r, i);
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                roundness: a
            }),
            shape: l
        };
    }
    static build(n1) {
        let { depth: t, extrudeBevelSize: e, extrudeBevelSegments: r, subdivisions: i, roundness: s, windingRule: o } = n1.parameters;
        n1.shape.roundness = s;
        let a;
        return t <= 0 ? a = new xh(n1.shape, i, {
            windingRule: o
        }) : a = new bh(n1.shape, t, e, i, r, o), Object.assign(a, {
            userData: {
                ...n1,
                type: "VectorGeometry"
            }
        });
    }
};
var qO = Math.PI * 2, wh = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 64,
            angle: 360,
            innerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return e.angle = Se.clamp(e.angle, 0, 360), {
            shape: n1.shape && n1.shape instanceof kt ? n1.shape : new kt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, angle: i, innerRadius: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, u = n1.shape, c = t * .5, d = e * .5, h = iY(u, c, d, i * Math.PI / 180, r, s);
        u.isClosed = !0, u.update();
        let f;
        return i === 0 ? (f = new we, f.setAttribute("position", new be([], 3))) : f = Dn.create({
            shape: u,
            parameters: {
                subdivisions: h,
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        }), Object.assign(f, {
            userData: {
                ...n1,
                type: "EllipseGeometry"
            }
        });
    }
};
function iY(n1, t, e, r, i, s) {
    if (r >= qO) return i > 30 || i % 4 === 0 ? (sY(n1, t, e, s), Math.round(i / 4)) : WO(n1, r, i, t, e, s);
    r = Math.max(r, .001);
    let o = {
        x: 0,
        y: e
    }, a = r + Math.PI * .5, l = {
        x: Math.cos(a) * t,
        y: Math.sin(a) * e
    }, u = NO({
        px: o.x,
        py: o.y,
        cx: l.x,
        cy: l.y,
        rx: t,
        ry: e,
        largeArcFlag: r > Math.PI,
        sweepFlag: !0
    });
    return i > 30 || i % u.length === 0 ? nY(n1, o.x, o.y, u, i, t, e, s) : WO(n1, r, i, t, e, s);
}
function nY(n1, t, e, r, i, s, o, a) {
    let l = Math.round(i / r.length);
    n1.addPoint(Sh(t, e));
    for(let u = 0, c = r.length; u < c; u++){
        let d = r[u], h = n1.points[u], f = Sh(d.x, d.y);
        h.controls[1].position.set(d.x1, d.y1), f.controls[0].position.set(d.x2, d.y2), n1.addPoint(f);
    }
    return a > 0 ? YO(n1, s, o, a) : n1.addPoint(Sh(0, 0)), l;
}
function WO(n1, t, e, r, i, s) {
    let o = -t / e;
    for(let a = 0; a <= e; a++){
        let l = o * a, u = Math.sin(l) * r, c = Math.cos(l) * i;
        n1.addPoint(Sh(u, c));
    }
    return t < qO ? s > 0 ? YO(n1, r, i, s) : n1.addPoint(Sh(0, 0)) : (n1.removePoint(n1.points[n1.points.length - 1]), s > 0 && XO(n1, r, i, s)), 1;
}
function sY(n1, t, e, r = 0, i = 0, s = 0) {
    let o = .5522847498, a = t * o, l = e * o;
    n1.addPoint(b0(i - t, s, i - t, s - l, i - t, s + l)), n1.addPoint(b0(i, s + e, i - a, s + e, i + a, s + e)), n1.addPoint(b0(i + t, s, i + t, s + l, i + t, s - l)), n1.addPoint(b0(i, s - e, i + a, s - e, i - a, s - e)), r > 0 && XO(n1, t, e, r);
}
function Sh(n1, t) {
    return new js(Se.generateUUID(), new N(n1, t));
}
function b0(n1, t, e, r, i, s) {
    let o = Sh(n1, t);
    return o.controls[0].position.set(e, r), o.controls[1].position.set(i, s), o;
}
function YO(n1, t, e, r) {
    QO(n1, t, e, r).forEach((s)=>n1.addPoint(s));
}
function XO(n1, t, e, r) {
    let i = QO(n1, t, e, r), s = new kt;
    i.forEach((o)=>s.addPoint(o)), s.isClosed = !0, n1.shapeHoles.push(s);
}
function QO(n1, t, e, r) {
    let i = r * t / 100, s = i * (Math.abs(e) / Math.abs(t)), o = new N(i / t, s / e), a = n1.points.map((l)=>{
        let u = l.clone();
        return u.uuid = Se.generateUUID(), u;
    }).reverse();
    return a.forEach((l)=>{
        l.position.multiply(o);
        let u = l.controls[0].position.clone().multiply(o), c = l.controls[1].position.clone().multiply(o);
        l.controls[0].position.copy(c), l.controls[1].position.copy(u);
    }), a;
}
var KO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            revolutions: 2,
            segments: 40,
            pathRadius: 10,
            pathType: 0,
            pathSegments: 30,
            cornerRadius: 30,
            cornerSegments: 4
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? r), s = Math.abs(e.depth ?? r), o = Math.abs(Math.min(r, s)) / 2;
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                radius: o,
                segments: Math.round(e.segments),
                pathSegments: Math.round(e.pathSegments),
                cornerSegments: Math.round(e.cornerSegments)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radius: i, revolutions: s, segments: o, pathRadius: a, pathType: l, pathSegments: u, cornerRadius: c, cornerSegments: d } = n1.parameters, h = new um(!1, t, e, r, i, s, o, a, l, u, c, d);
        return Object.assign(h, {
            userData: {
                ...n1,
                type: "HelixGeometry"
            }
        });
    }
}, aA = new co([
    0,
    0,
    0
], 1), um = class extends we {
    constructor(t = !0, e = 1, r = 1, i = 1, s = 1, o = 1, a = 1, l = 1, u = 1, c = 1, d = 1, h = 1){
        if (super(), o === 0) return;
        let f = t && o === 1;
        f && (h = 0), d > 100 && (d = 100), d === 0 && (h = 0);
        let p = ()=>new _, m = new _, g = p(), y = p(), v = p(), x, S, w, A, E, b, T, M, C = p(), P = p(), D = p(), O = p(), I = p(), z = p(), B = p(), V = p(), U = r - 2 * l + .001, j = U / o, W = Math.ceil(a * o), k = W + 1, H = U / W, X = -U / 2, q = c + 1, G = 2 * Math.PI / c, J = Math.PI / 2 / h, Z = .01, K = Math.min((1 - d / 100) * l, l - Z), Y = l - K, ye = 0, fe = 2, oe = h * fe + fe, _e = q * oe / fe, xe = _e + q * k, Ie = Math.max(0, q * (k + oe)), [Oe, Pe, Te] = [
            3,
            3,
            2
        ].map((ke)=>Array(Ie * ke).fill(0)), Ve = [], Ue = s - l;
        function L(ke, Be) {
            let qe = Math.PI / 2;
            b = Be * H, M = 2 * Math.PI * (b % j) / j + qe, b += X, T = Math.sin(M) * Ue, E = Math.cos(M) * Ue, t ? ke.set(E, T, b) : ke.set(E, b, T);
        }
        L(m, -0.0000000001), L(g, 0), C.copy(m), L(m, 1);
        let R = m.distanceTo(g), ie = f ? 0 : Y + K, ue = R * W + 2 * ie, me = K, De = ue - ie;
        for(let ke = 0; ke <= W; ke++){
            L(y, ke), V.subVectors(y, C).normalize(), C.copy(y), z.copy(y).setComponent(+t + 1, 0).normalize(), B.crossVectors(V, z).normalize();
            let Be = ke === 0, qe = ke === W, et = Be ? 3 * Math.PI / 2 : J, Dt = Be ? me : De, yr = Be ? q : xe, ti = Be ? 0 : Ie - q, Q = V.clone().multiplyScalar(Be ? -Y : Y).add(y), ce = V.clone().multiplyScalar(Be ? -1 : 1).normalize();
            for(let ve = 0; ve < q; ve++){
                let ze = ve * G;
                if (P.addVectors(m.copy(z).multiplyScalar(l * Math.cos(ze)), g.copy(B).multiplyScalar(l * Math.sin(ze))), D.copy(P).normalize(), Be || qe) {
                    f || (ye = ti + ve, [
                        0,
                        1,
                        2
                    ].forEach((Fe)=>{
                        Oe[ye * 3 + Fe] = Q.getComponent(Fe), Pe[ye * 3 + Fe] = ce.getComponent(Fe);
                    }), Te[ye * 2] = +qe, Te[ye * 2 + 1] = ve / c), g.copy(D).multiplyScalar(K), v.addVectors(y, g);
                    for(let Fe = 0; Fe < h; Fe++){
                        let Ot = Fe * J + et;
                        O.addVectors(m.copy(V).multiplyScalar(Y * Math.sin(Ot)), g.copy(D).multiplyScalar(Y * Math.cos(Ot))), I.copy(O).normalize(), g.addVectors(v, O), O.normalize(), ye = yr + Fe * q + ve, [
                            0,
                            1,
                            2
                        ].forEach((jr)=>{
                            Oe[ye * 3 + jr] = g.getComponent(jr), Pe[ye * 3 + jr] = I.getComponent(jr);
                        });
                        let ri = +Be + Math.sin(Ot);
                        Te[ye * 2] = (Dt + Y * ri) / ue, Te[ye * 2 + 1] = ve / c;
                    }
                }
                g.addVectors(y, P), ye = _e + ke * q + ve, [
                    0,
                    1,
                    2
                ].forEach((Fe)=>{
                    Oe[ye * 3 + Fe] = g.getComponent(Fe), Pe[ye * 3 + Fe] = D.getComponent(Fe);
                }), Te[ye * 2] = (ie + ke * R) / ue, Te[ye * 2 + 1] = ve / c;
            }
        }
        let Me = k + 2 * h + fe, Ee = 1, [le, Je] = [
            +f,
            Me - 1
        ];
        for(let ke = le; ke <= Je - 1; ke++){
            let Be = f && ke === Je - 1;
            for(let qe = 0; qe < q - 1; qe++)x = ke * q + qe, S = x + 1, w = (Be ? qe : x) + q, A = (Be ? qe + 1 : S) + q, ke === 0 ? Ve.push(S, A, w) : ke === Me - 2 ? Ve.push(x, S, w) : Ve.push(x, S, w, S, A, w);
        }
        this.setIndex(Ve), this.setAttribute("position", new be(Oe, 3)), this.setAttribute("normal", new be(Pe, 3)), this.setAttribute("uv", new be(Te, 2));
    }
    getClosedTorusIndicesForBooleanOrSubdiv() {
        let t = this.userData.parameters, e = Math.ceil(t.tubularSegments), r = t.radialSegments + 1, i = Array.from(this.getIndex().array), s, o, a, l, u = 6 * (e - 1) * t.radialSegments, c = e, d = c === e;
        for(let h = 0; h < t.radialSegments; h++)s = c * r + h, o = s + 1, a = (d ? h : s) + r, l = (d ? h + 1 : o) + r, i[u++] = s, i[u++] = o, i[u++] = a, i[u++] = o, i[u++] = l, i[u++] = a;
        return i.length = u, aA.array = i, aA.count = i.length, aA;
    }
};
var ZO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s, cornerSides: o } = n1.parameters, a = i === 0 && s !== 0 ? new dm(t * .5, s, o) : new ku(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "IcosahedronGeometry"
            }
        });
    }
}, dm = class extends Cl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = [
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            0,
            0,
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            i,
            0,
            -1,
            i,
            0,
            1,
            -i,
            0,
            -1,
            -i,
            0,
            1
        ], o = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ], a = "IcosahedronGeometry";
        super(s, o, a, t, e, r), this.type = a;
    }
    static fromJSON(t) {
        return new dm(t.radius, t.corner, t.cornerSides);
    }
};
var JO = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        (n1.parameters?.points ?? []).forEach((r)=>{
            Array.isArray(r) && (r.x = r[0], r.y = r[1]);
        });
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            segments: 64,
            verticalSegments: 64,
            points: [
                {
                    x: 0,
                    y: -50,
                    id: 0
                },
                {
                    x: 50,
                    y: -50,
                    id: 1
                },
                {
                    x: 50,
                    y: 50,
                    id: 2
                },
                {
                    x: 0,
                    y: 50,
                    id: 3
                }
            ]
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { points: t, segments: e, verticalSegments: r } = n1.parameters, i = new oa;
        i.moveTo(t[0].x, t[0].y), i.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y);
        let s = new Lu(i.extractPoints(r).shape, e);
        return s.rotateZ(Math.PI), Object.assign(s, {
            userData: {
                ...n1,
                type: "LatheGeometry"
            }
        });
    }
};
var Co = new te, lA = new mt, S0 = new _, Il = class extends ir {
    constructor(){
        super(), this.uuid = Se.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    applyMatrix4(t) {
        let e = new Qt().getNormalMatrix(t);
        for(let r = 0, i = this.vertices.length; r < i; r++)this.vertices[r].applyMatrix4(t);
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r];
            s.normal.applyMatrix3(e).normalize();
            for(let o = 0, a = s.vertexNormals.length; o < a; o++)s.vertexNormals[o].applyMatrix3(e).normalize();
        }
        return this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
    }
    rotateX(t) {
        return Co.makeRotationX(t), this.applyMatrix4(Co), this;
    }
    rotateY(t) {
        return Co.makeRotationY(t), this.applyMatrix4(Co), this;
    }
    rotateZ(t) {
        return Co.makeRotationZ(t), this.applyMatrix4(Co), this;
    }
    translate(t, e, r) {
        return Co.makeTranslation(t, e, r), this.applyMatrix4(Co), this;
    }
    scale(t, e, r) {
        return Co.makeScale(t, e, r), this.applyMatrix4(Co), this;
    }
    lookAt(t) {
        return lA.lookAt(t), lA.updateMatrix(), this.applyMatrix4(lA.matrix), this;
    }
    fromBufferGeometry(t) {
        let e = this, r = t.index !== null ? t.index : void 0, i = t.attributes;
        if (i.position === void 0) return console.error("THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion."), this;
        let s = i.position, o = i.normal, a = i.color, l = i.uv, u = i.uv2;
        u !== void 0 && (this.faceVertexUvs[1] = []);
        for(let h = 0; h < s.count; h++)e.vertices.push(new _().fromBufferAttribute(s, h)), a !== void 0 && e.colors.push(new Le().fromBufferAttribute(a, h));
        function c(h, f, p, m) {
            let g = a === void 0 ? [] : [
                e.colors[h].clone(),
                e.colors[f].clone(),
                e.colors[p].clone()
            ], y = o === void 0 ? [] : [
                new _().fromBufferAttribute(o, h),
                new _().fromBufferAttribute(o, f),
                new _().fromBufferAttribute(o, p)
            ], v = new Ah(h, f, p, y, g, m);
            e.faces.push(v), l !== void 0 && e.faceVertexUvs[0].push([
                new N().fromBufferAttribute(l, h),
                new N().fromBufferAttribute(l, f),
                new N().fromBufferAttribute(l, p)
            ]), u !== void 0 && e.faceVertexUvs[1].push([
                new N().fromBufferAttribute(u, h),
                new N().fromBufferAttribute(u, f),
                new N().fromBufferAttribute(u, p)
            ]);
        }
        let d = t.groups;
        if (d.length > 0) for(let h = 0; h < d.length; h++){
            let f = d[h], p = f.start, m = f.count;
            for(let g = p, y = p + m; g < y; g += 3)r !== void 0 ? c(r.getX(g), r.getX(g + 1), r.getX(g + 2), f.materialIndex) : c(g, g + 1, g + 2, f.materialIndex);
        }
        else if (r !== void 0) for(let h = 0; h < r.count; h += 3)c(r.getX(h), r.getX(h + 1), r.getX(h + 2));
        else for(let h = 0; h < s.count; h += 3)c(h, h + 1, h + 2);
        return this.computeFaceNormals(), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(S0).negate(), this.translate(S0.x, S0.y, S0.z), this;
    }
    normalize() {
        this.computeBoundingSphere();
        let t = this.boundingSphere.center, e = this.boundingSphere.radius, r = e === 0 ? 1 : 1 / e, i = new te;
        return i.set(r, 0, 0, -r * t.x, 0, r, 0, -r * t.y, 0, 0, r, -r * t.z, 0, 0, 0, 1), this.applyMatrix4(i), this;
    }
    computeFaceNormals() {
        let t = new _, e = new _;
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r], o = this.vertices[s.a], a = this.vertices[s.b], l = this.vertices[s.c];
            t.subVectors(l, a), e.subVectors(o, a), t.cross(e), t.normalize(), s.normal.copy(t);
        }
    }
    computeVertexNormals(t = !0) {
        let e = new Array(this.vertices.length);
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r] = new _;
        if (t) {
            let r = new _, i = new _;
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = this.vertices[a.a], u = this.vertices[a.b], c = this.vertices[a.c];
                r.subVectors(c, u), i.subVectors(l, u), r.cross(i), e[a.a].add(r), e[a.b].add(r), e[a.c].add(r);
            }
        } else {
            this.computeFaceNormals();
            for(let r = 0, i = this.faces.length; r < i; r++){
                let s = this.faces[r];
                e[s.a].add(s.normal), e[s.b].add(s.normal), e[s.c].add(s.normal);
            }
        }
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r].normalize();
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s = this.faces[r], o = s.vertexNormals;
            o.length === 3 ? (o[0].copy(e[s.a]), o[1].copy(e[s.b]), o[2].copy(e[s.c])) : (o[0] = e[s.a].clone(), o[1] = e[s.b].clone(), o[2] = e[s.c].clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeFlatVertexNormals() {
        this.computeFaceNormals();
        for(let t = 0, e = this.faces.length; t < e; t++){
            let r = this.faces[t], i = r.vertexNormals;
            i.length === 3 ? (i[0].copy(r.normal), i[1].copy(r.normal), i[2].copy(r.normal)) : (i[0] = r.normal.clone(), i[1] = r.normal.clone(), i[2] = r.normal.clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeMorphNormals() {
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []);
            for(let s = 0, o = i.vertexNormals.length; s < o; s++)i.__originalVertexNormals[s] ? i.__originalVertexNormals[s].copy(i.vertexNormals[s]) : i.__originalVertexNormals[s] = i.vertexNormals[s].clone();
        }
        let t = new Il;
        t.faces = this.faces;
        for(let e = 0, r = this.morphTargets.length; e < r; e++){
            if (!this.morphNormals[e]) {
                this.morphNormals[e] = {}, this.morphNormals[e].faceNormals = [], this.morphNormals[e].vertexNormals = [];
                let s = this.morphNormals[e].faceNormals, o = this.morphNormals[e].vertexNormals;
                for(let a = 0, l = this.faces.length; a < l; a++){
                    let u = new _, c = {
                        a: new _,
                        b: new _,
                        c: new _
                    };
                    s.push(u), o.push(c);
                }
            }
            let i = this.morphNormals[e];
            t.vertices = this.morphTargets[e].vertices, t.computeFaceNormals(), t.computeVertexNormals();
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = i.faceNormals[s], u = i.vertexNormals[s];
                l.copy(a.normal), u.a.copy(a.vertexNormals[0]), u.b.copy(a.vertexNormals[1]), u.c.copy(a.vertexNormals[2]);
            }
        }
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
        }
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Bt), this.boundingBox.setFromPoints(this.vertices);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Er), this.boundingSphere.setFromPoints(this.vertices);
    }
    merge(t, e, r = 0) {
        if (!(t && t.isGeometry)) {
            console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t);
            return;
        }
        let i, s = this.vertices.length, o = this.vertices, a = t.vertices, l = this.faces, u = t.faces, c = this.colors, d = t.colors;
        e !== void 0 && (i = new Qt().getNormalMatrix(e));
        for(let h = 0, f = a.length; h < f; h++){
            let m = a[h].clone();
            e !== void 0 && m.applyMatrix4(e), o.push(m);
        }
        for(let h = 0, f = d.length; h < f; h++)c.push(d[h].clone());
        for(let h = 0, f = u.length; h < f; h++){
            let p = u[h], m, g, y = p.vertexNormals, v = p.vertexColors, x = new Ah(p.a + s, p.b + s, p.c + s);
            x.normal.copy(p.normal), i !== void 0 && x.normal.applyMatrix3(i).normalize();
            for(let S = 0, w = y.length; S < w; S++)m = y[S].clone(), i !== void 0 && m.applyMatrix3(i).normalize(), x.vertexNormals.push(m);
            x.color.copy(p.color);
            for(let S = 0, w = v.length; S < w; S++)g = v[S], x.vertexColors.push(g.clone());
            x.materialIndex = p.materialIndex + r, l.push(x);
        }
        for(let h = 0, f = t.faceVertexUvs.length; h < f; h++){
            let p = t.faceVertexUvs[h];
            this.faceVertexUvs[h] === void 0 && (this.faceVertexUvs[h] = []);
            for(let m = 0, g = p.length; m < g; m++){
                let y = p[m], v = [];
                for(let x = 0, S = y.length; x < S; x++)v.push(y[x].clone());
                this.faceVertexUvs[h].push(v);
            }
        }
    }
    mergeMesh(t) {
        if (!(t && t.isMesh)) {
            console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t);
            return;
        }
        t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix);
    }
    mergeVertices(t = 4) {
        let e = {}, r = [], i = [], s = Math.pow(10, t);
        for(let l = 0, u = this.vertices.length; l < u; l++){
            let c = this.vertices[l], d = Math.round(c.x * s) + "_" + Math.round(c.y * s) + "_" + Math.round(c.z * s);
            e[d] === void 0 ? (e[d] = l, r.push(this.vertices[l]), i[l] = r.length - 1) : i[l] = i[e[d]];
        }
        let o = [];
        for(let l = 0, u = this.faces.length; l < u; l++){
            let c = this.faces[l];
            c.a = i[c.a], c.b = i[c.b], c.c = i[c.c];
            let d = [
                c.a,
                c.b,
                c.c
            ];
            for(let h = 0; h < 3; h++)if (d[h] === d[(h + 1) % 3]) {
                o.push(l);
                break;
            }
        }
        for(let l = o.length - 1; l >= 0; l--){
            let u = o[l];
            this.faces.splice(u, 1);
            for(let c = 0, d = this.faceVertexUvs.length; c < d; c++)this.faceVertexUvs[c].splice(u, 1);
        }
        let a = this.vertices.length - r.length;
        return this.vertices = r, a;
    }
    setFromPoints(t) {
        this.vertices = [];
        for(let e = 0, r = t.length; e < r; e++){
            let i = t[e];
            this.vertices.push(new _(i.x, i.y, i.z || 0));
        }
        return this;
    }
    sortFacesByMaterialIndex() {
        let t = this.faces, e = t.length;
        for(let l = 0; l < e; l++)t[l]._id = l;
        function r(l, u) {
            return l.materialIndex - u.materialIndex;
        }
        t.sort(r);
        let i = this.faceVertexUvs[0], s = this.faceVertexUvs[1], o, a;
        i && i.length === e && (o = []), s && s.length === e && (a = []);
        for(let l = 0; l < e; l++){
            let u = t[l]._id;
            o && o.push(i[u]), a && a.push(s[u]);
        }
        o && (this.faceVertexUvs[0] = o), a && (this.faceVertexUvs[1] = a);
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Geometry",
                generator: "Geometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), this.parameters !== void 0) {
            let p = this.parameters;
            for(let m in p)p[m] !== void 0 && (t[m] = p[m]);
            return t;
        }
        let e = [];
        for(let p = 0; p < this.vertices.length; p++){
            let m = this.vertices[p];
            e.push(m.x, m.y, m.z);
        }
        let r = [], i = [], s = {}, o = [], a = {}, l = [], u = {};
        for(let p = 0; p < this.faces.length; p++){
            let m = this.faces[p], g = !0, y = !1, v = this.faceVertexUvs[0][p] !== void 0, x = m.normal.length() > 0, S = m.vertexNormals.length > 0, w = m.color.r !== 1 || m.color.g !== 1 || m.color.b !== 1, A = m.vertexColors.length > 0, E = 0;
            if (E = c(E, 0, 0), E = c(E, 1, g), E = c(E, 2, y), E = c(E, 3, v), E = c(E, 4, x), E = c(E, 5, S), E = c(E, 6, w), E = c(E, 7, A), r.push(E), r.push(m.a, m.b, m.c), r.push(m.materialIndex), v) {
                let b = this.faceVertexUvs[0][p];
                r.push(f(b[0]), f(b[1]), f(b[2]));
            }
            if (x && r.push(d(m.normal)), S) {
                let b = m.vertexNormals;
                r.push(d(b[0]), d(b[1]), d(b[2]));
            }
            if (w && r.push(h(m.color)), A) {
                let b = m.vertexColors;
                r.push(h(b[0]), h(b[1]), h(b[2]));
            }
        }
        function c(p, m, g) {
            return g ? p | 1 << m : p & ~(1 << m);
        }
        function d(p) {
            let m = p.x.toString() + p.y.toString() + p.z.toString();
            return s[m] !== void 0 || (s[m] = i.length / 3, i.push(p.x, p.y, p.z)), s[m];
        }
        function h(p) {
            let m = p.r.toString() + p.g.toString() + p.b.toString();
            return a[m] !== void 0 || (a[m] = o.length, o.push(p.getHex())), a[m];
        }
        function f(p) {
            let m = p.x.toString() + p.y.toString();
            return u[m] !== void 0 || (u[m] = l.length / 2, l.push(p.x, p.y)), u[m];
        }
        return t.data = {}, t.data.vertices = e, t.data.normals = i, o.length > 0 && (t.data.colors = o), l.length > 0 && (t.data.uvs = [
            l
        ]), t.data.faces = r, t;
    }
    clone() {
        return new Il().copy(this);
    }
    copy(t) {
        this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;
        let e = t.vertices;
        for(let h = 0, f = e.length; h < f; h++)this.vertices.push(e[h].clone());
        let r = t.colors;
        for(let h = 0, f = r.length; h < f; h++)this.colors.push(r[h].clone());
        let i = t.faces;
        for(let h = 0, f = i.length; h < f; h++)this.faces.push(i[h].clone());
        for(let h = 0, f = t.faceVertexUvs.length; h < f; h++){
            let p = t.faceVertexUvs[h];
            this.faceVertexUvs[h] === void 0 && (this.faceVertexUvs[h] = []);
            for(let m = 0, g = p.length; m < g; m++){
                let y = p[m], v = [];
                for(let x = 0, S = y.length; x < S; x++){
                    let w = y[x];
                    v.push(w.clone());
                }
                this.faceVertexUvs[h].push(v);
            }
        }
        let s = t.morphTargets;
        for(let h = 0, f = s.length; h < f; h++){
            let p = {};
            if (p.name = s[h].name, s[h].vertices !== void 0) {
                p.vertices = [];
                for(let m = 0, g = s[h].vertices.length; m < g; m++)p.vertices.push(s[h].vertices[m].clone());
            }
            if (s[h].normals !== void 0) {
                p.normals = [];
                for(let m = 0, g = s[h].normals.length; m < g; m++)p.normals.push(s[h].normals[m].clone());
            }
            this.morphTargets.push(p);
        }
        let o = t.morphNormals;
        for(let h = 0, f = o.length; h < f; h++){
            let p = {};
            if (o[h].vertexNormals !== void 0) {
                p.vertexNormals = [];
                for(let m = 0, g = o[h].vertexNormals.length; m < g; m++){
                    let y = o[h].vertexNormals[m], v = {};
                    v.a = y.a.clone(), v.b = y.b.clone(), v.c = y.c.clone(), p.vertexNormals.push(v);
                }
            }
            if (o[h].faceNormals !== void 0) {
                p.faceNormals = [];
                for(let m = 0, g = o[h].faceNormals.length; m < g; m++)p.faceNormals.push(o[h].faceNormals[m].clone());
            }
            this.morphNormals.push(p);
        }
        let a = t.skinWeights;
        for(let h = 0, f = a.length; h < f; h++)this.skinWeights.push(a[h].clone());
        let l = t.skinIndices;
        for(let h = 0, f = l.length; h < f; h++)this.skinIndices.push(l[h].clone());
        let u = t.lineDistances;
        for(let h = 0, f = u.length; h < f; h++)this.lineDistances.push(u[h]);
        let c = t.boundingBox;
        c !== null && (this.boundingBox = c.clone());
        let d = t.boundingSphere;
        return d !== null && (this.boundingSphere = d.clone()), this.elementsNeedUpdate = t.elementsNeedUpdate, this.verticesNeedUpdate = t.verticesNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    }
    toBufferGeometry() {
        let t = new cA().fromGeometry(this), e = new we, r = new Float32Array(t.vertices.length * 3);
        if (e.setAttribute("position", w0.call(new Ge(r, 3), t.vertices)), t.normals.length > 0) {
            let i = new Float32Array(t.normals.length * 3);
            e.setAttribute("normal", w0.call(new Ge(i, 3), t.normals));
        }
        if (t.colors.length > 0) {
            let i = new Float32Array(t.colors.length * 3);
            e.setAttribute("color", $O.call(new Ge(i, 3), t.colors));
        }
        if (t.uvs.length > 0) {
            let i = new Float32Array(t.uvs.length * 2);
            e.setAttribute("uv", eI.call(new Ge(i, 2), t.uvs));
        }
        if (t.uvs2.length > 0) {
            let i = new Float32Array(t.uvs2.length * 2);
            e.setAttribute("uv2", eI.call(new Ge(i, 2), t.uvs2));
        }
        e.groups = t.groups;
        for(let i in t.morphTargets){
            let s = [], o = t.morphTargets[i];
            for(let a = 0, l = o.length; a < l; a++){
                let u = o[a], c = new be(u.data.length * 3, 3);
                c.name = u.name, s.push(w0.call(c, u.data));
            }
            e.morphAttributes[i] = s;
        }
        if (t.skinIndices.length > 0) {
            let i = new be(t.skinIndices.length * 4, 4);
            e.setAttribute("skinIndex", tI.call(i, t.skinIndices));
        }
        if (t.skinWeights.length > 0) {
            let i = new be(t.skinWeights.length * 4, 4);
            e.setAttribute("skinWeight", tI.call(i, t.skinWeights));
        }
        return t.boundingSphere !== null && (e.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (e.boundingBox = t.boundingBox.clone()), e;
    }
    computeTangents() {
        console.error("THREE.Geometry: .computeTangents() has been removed.");
    }
    computeLineDistances() {
        console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.");
    }
    applyMatrix(t) {
        return console.warn("THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    static createBufferGeometryFromObject(t) {
        let e = new we, r = t.geometry;
        if (t.isPoints || t.isLine) {
            let i = new be(r.vertices.length * 3, 3), s = new be(r.colors.length * 3, 3);
            if (e.setAttribute("position", w0.call(i, r.vertices)), e.setAttribute("color", $O.call(s, r.colors)), r.lineDistances && r.lineDistances.length === r.vertices.length) {
                let o = new be(r.lineDistances.length, 1);
                e.setAttribute("lineDistance", oY.call(o, r.lineDistances));
            }
            r.boundingSphere !== null && (e.boundingSphere = r.boundingSphere.clone()), r.boundingBox !== null && (e.boundingBox = r.boundingBox.clone());
        } else t.isMesh && (e = r.toBufferGeometry());
        return e;
    }
};
Il.prototype.isGeometry = !0;
var cA = class {
    constructor(){
        this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    computeGroups(t) {
        let e = [], r, i, s, o = t.faces;
        for(i = 0; i < o.length; i++){
            let a = o[i];
            a.materialIndex !== s && (s = a.materialIndex, r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), r = {
                start: i * 3,
                materialIndex: s
            });
        }
        r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), this.groups = e;
    }
    fromGeometry(t) {
        let e = t.faces, r = t.vertices, i = t.faceVertexUvs, s = i[0] && i[0].length > 0, o = i[1] && i[1].length > 0, a = t.morphTargets, l = a.length, u;
        if (l > 0) {
            u = [];
            for(let y = 0; y < l; y++)u[y] = {
                name: a[y].name,
                data: []
            };
            this.morphTargets.position = u;
        }
        let c = t.morphNormals, d = c.length, h;
        if (d > 0) {
            h = [];
            for(let y = 0; y < d; y++)h[y] = {
                name: c[y].name,
                data: []
            };
            this.morphTargets.normal = h;
        }
        let f = t.skinIndices, p = t.skinWeights, m = f.length === r.length, g = p.length === r.length;
        r.length > 0 && e.length === 0 && console.error("THREE.DirectGeometry: Faceless geometries are not supported.");
        for(let y = 0; y < e.length; y++){
            let v = e[y];
            this.vertices.push(r[v.a], r[v.b], r[v.c]);
            let x = v.vertexNormals;
            if (x.length === 3) this.normals.push(x[0], x[1], x[2]);
            else {
                let w = v.normal;
                this.normals.push(w, w, w);
            }
            let S = v.vertexColors;
            if (S.length === 3) this.colors.push(S[0], S[1], S[2]);
            else {
                let w = v.color;
                this.colors.push(w, w, w);
            }
            if (s === !0) {
                let w = i[0][y];
                w !== void 0 ? this.uvs.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", y), this.uvs.push(new N, new N, new N));
            }
            if (o === !0) {
                let w = i[1][y];
                w !== void 0 ? this.uvs2.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", y), this.uvs2.push(new N, new N, new N));
            }
            for(let w = 0; w < l; w++){
                let A = a[w].vertices;
                u[w].data.push(A[v.a], A[v.b], A[v.c]);
            }
            for(let w = 0; w < d; w++){
                let A = c[w].vertexNormals[y];
                h[w].data.push(A.a, A.b, A.c);
            }
            m && this.skinIndices.push(f[v.a], f[v.b], f[v.c]), g && this.skinWeights.push(p[v.a], p[v.b], p[v.c]);
        }
        return this.computeGroups(t), this.verticesNeedUpdate = t.verticesNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), this;
    }
}, Ah = class {
    constructor(t, e, r, i, s, o = 0){
        this.a = t, this.b = e, this.c = r, this.normal = i && i.isVector3 ? i : new _, this.vertexNormals = Array.isArray(i) ? i : [], this.color = s && s.isColor ? s : new Le, this.vertexColors = Array.isArray(s) ? s : [], this.materialIndex = o;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.a = t.a, this.b = t.b, this.c = t.c, this.normal.copy(t.normal), this.color.copy(t.color), this.materialIndex = t.materialIndex;
        for(let e = 0, r = t.vertexNormals.length; e < r; e++)this.vertexNormals[e] = t.vertexNormals[e].clone();
        for(let e = 0, r = t.vertexColors.length; e < r; e++)this.vertexColors[e] = t.vertexColors[e].clone();
        return this;
    }
};
function oY(n1) {
    return this.array.set(n1), this;
}
function $O(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", r), s = new Le), t[e++] = s.r, t[e++] = s.g, t[e++] = s.b;
    }
    return this;
}
function eI(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", r), s = new N), t[e++] = s.x, t[e++] = s.y;
    }
    return this;
}
function w0(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", r), s = new _), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z;
    }
    return this;
}
function tI(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s = n1[r];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", r), s = new He), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z, t[e++] = s.w;
    }
    return this;
}
var aY = [
    "a",
    "b",
    "c"
];
function lY(n1, t) {
    switch(t){
        case "c":
            return n1.c;
        case "b":
            return n1.b;
        case "a":
        default:
            return n1.a;
    }
}
function uA(n1, t, e) {
    let r = Math.min(n1, t), i = Math.max(n1, t), s = r + "_" + i;
    return e.get(s);
}
function dA(n1, t, e, r, i, s) {
    let o = Math.min(n1, t), a = Math.max(n1, t), l = o + "_" + a, u;
    if (r.has(l)) u = r.get(l);
    else {
        let c = e[o], d = e[a];
        u = {
            a: c,
            b: d,
            newEdge: null,
            faces: []
        }, r.set(l, u);
    }
    u.faces.push(i), s[n1].edges.push(u), s[t].edges.push(u);
}
function cY(n1, t, e, r) {
    let i, s, o;
    for(i = 0, s = n1.length; i < s; i++)e[i] = {
        edges: []
    };
    for(i = 0, s = t.length; i < s; i++)o = t[i], dA(o.a, o.b, n1, r, o, e), dA(o.b, o.c, n1, r, o, e), dA(o.c, o.a, n1, r, o, e);
}
function A0(n1, t, e, r, i) {
    n1.push(new Ah(t, e, r, void 0, void 0, i));
}
function _h(n1, t) {
    return Math.abs(t - n1) / 2 + Math.min(n1, t);
}
function _0(n1, t, e, r) {
    n1.push([
        t.clone(),
        e.clone(),
        r.clone()
    ]);
}
var E0 = class {
    constructor(t = 1){
        this.subdivisions = t;
    }
    modify(t) {
        t instanceof we ? t = new Il().fromBufferGeometry(t) : t = t.clone(), t.mergeVertices();
        let e = this.subdivisions;
        for(; e-- > 0;)this._smooth(t);
        return t.computeFaceNormals(), t.computeVertexNormals(), t;
    }
    _smooth(t) {
        let e = new _, r, i, s, o, a, l = t.vertices, u = t.faces, c = t.faceVertexUvs[0], d = c !== void 0 && c.length > 0, h = [], f = new Map;
        cY(l, u, h, f);
        let p = [], m, g, y, v, x, S, w;
        for (let Z of Array.from(f.keys())){
            for(g = f.get(Z), y = new _, x = 3 / 8, S = 1 / 8, w = g.faces.length, w != 2 && (x = .5, S = 0, w), y.addVectors(g.a, g.b).multiplyScalar(x), e.set(0, 0, 0), o = 0; o < w; o++){
                for(v = g.faces[o], a = 0; a < 3 && (m = l[lY(v, aY[a])], !(m !== g.a && m !== g.b)); a++);
                m && e.add(m);
            }
            e.multiplyScalar(S), y.add(e), g.newEdge = p.length, p.push(y);
        }
        let A, E, b, T, M, C, P, D = [];
        for(i = 0, s = l.length; i < s; i++){
            for(C = l[i], M = h[i].edges, r = M.length, r == 3 ? A = 3 / 16 : r > 3 && (A = 3 / (8 * r)), E = 1 - r * Number(A), b = A, r <= 2 && (r == 2 ? (E = 3 / 4, b = 1 / 8) : r == 1 || r), P = C.clone().multiplyScalar(E), e.set(0, 0, 0), o = 0; o < r; o++)T = M[o], m = T.a !== C ? T.a : T.b, e.add(m);
            e.multiplyScalar(Number(b)), P.add(e), D.push(P);
        }
        let O = D.concat(p), I = D.length, z, B, V, U = [], j = [], W, k, H, X, q = new N, G = new N, J = new N;
        for(i = 0, s = u.length; i < s; i++)v = u[i], z = Number(uA(v.a, v.b, f).newEdge) + I, B = Number(uA(v.b, v.c, f).newEdge) + I, V = Number(uA(v.c, v.a, f).newEdge) + I, A0(U, z, B, V, v.materialIndex), A0(U, v.a, z, V, v.materialIndex), A0(U, v.b, B, z, v.materialIndex), A0(U, v.c, V, B, v.materialIndex), d && (W = c[i], k = W[0], H = W[1], X = W[2], q.set(_h(k.x, H.x), _h(k.y, H.y)), G.set(_h(H.x, X.x), _h(H.y, X.y)), J.set(_h(k.x, X.x), _h(k.y, X.y)), _0(j, q, G, J), _0(j, k, q, J), _0(j, H, G, q), _0(j, X, J, G));
        t.vertices = O, t.faces = U, d && (t.faceVertexUvs[0] = j);
    }
};
var Ai = new _, rI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = n1.geometry ?? t?.geometry ?? new we().copy(new li(100, 100, 100)), r;
        t === void 0 ? (e.computeBoundingBox(), e.boundingBox.getSize(Ai), r = {
            width: Ai.x,
            height: Ai.y,
            depth: Ai.z,
            subdivisions: 0
        }) : r = t.parameters;
        let i = {
            ...r,
            ...n1.parameters
        };
        return {
            parameters: {
                width: Math.abs(i.width),
                height: Math.abs(i.height),
                depth: Math.abs(i.depth),
                subdivisions: Math.abs(i.subdivisions)
            },
            geometry: e
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, subdivisions: i } = n1.parameters, s = n1.geometry ?? new we().copy(new li(100, 100, 100)), o = s.userData.parameters;
        o === void 0 ? (s.computeBoundingBox(), s.boundingBox.getSize(Ai)) : Ai.set(o.width, o.height, o.depth), (t !== Ai.x || e !== Ai.y || r !== Ai.z) && s.scale(Ai.x === 0 ? 1 : t / Ai.x, Ai.y === 0 ? 1 : e / Ai.y, Ai.z === 0 ? 1 : r / Ai.z);
        let a = s.originalGeometry;
        try {
            i > 0 ? (a === void 0 || o?.subdivisions !== i) && (a === void 0 && (a = s), s = new E0(i).modify(a).toBufferGeometry()) : (a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals());
        } catch  {
            a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals();
        }
        return a !== void 0 && Object.assign(s, {
            originalGeometry: a
        }), delete n1.geometry, Object.assign(s, {
            userData: {
                ...n1,
                type: "NonParametricGeometry"
            }
        });
    }
    static loadFromUrl(n1, t, e) {
        new qu(e).load(n1, (i)=>{
            let s = this.normalizeInputs({
                geometry: i
            });
            i.boundingBox.getSize(Ai);
            let o = 100 / Ai.x;
            Object.assign(s.parameters, {
                width: 100,
                height: Ai.y * o,
                depth: Ai.z * o
            }), t(this.build(s));
        });
    }
};
var T0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof kt ? n1.shape : new kt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, cornerRadius: i, depth: s, extrudeBevelSize: o, extrudeBevelSegments: a } = n1.parameters, l = n1.shape, u = t * .5, c = e * .5, d = 0, h = 0, f = 2 * Math.PI / r;
        for(let m = 0; m < r; m++){
            let g = f * m, y = d + Math.sin(g) * u, v = h + Math.cos(g) * c;
            l.addPoint(l.createPoint(y, v));
        }
        l.isClosed = !0;
        for(let m = 0, g = l.points.length; m < g; m++)l.points[m].roundness = i;
        l.roundness = i, l.update();
        let p = Dn.create({
            shape: l,
            parameters: {
                roundness: i,
                depth: s,
                extrudeBevelSize: o,
                extrudeBevelSegments: a
            }
        });
        return Object.assign(p, {
            userData: {
                ...n1,
                type: "PolygonGeometry"
            }
        });
    }
};
var iI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 4,
            heightSegments: 1,
            cornerRadius: 0,
            cornerSegments: 8,
            openEnded: !1
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, heightSegments: s, openEnded: o, cornerRadius: a, cornerSegments: l } = n1.parameters, u = new fA(t * .5, e, i, s, o, a, l);
        return u.scale(1, 1, r / t), Object.assign(u, {
            userData: {
                ...n1,
                type: "PyramidGeometry"
            }
        });
    }
};
function hm(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function hA(n1, t, e, r, i, s) {
    let o = t.clone().sub(n1), a = e.clone().sub(n1), l = o.angleTo(a);
    if (o.normalize(), a.normalize(), r === i) {
        let u = o.add(a).normalize();
        s.copy(n1).addScaledVector(u, r / Math.sin(l / 2));
    } else {
        let u = o.angleTo(a);
        s.copy(n1), s.addScaledVector(o, i / Math.sin(u)), s.addScaledVector(a, r / Math.sin(u));
    }
}
function uY(n1, t, e) {
    let r = n1.clone().sub(t), i = e.clone().sub(t);
    return r.projectOnVector(i), r.add(t);
}
var fA = class extends we {
    constructor(t = .5, e = 1, r = 4, i = 1, s = !1, o = 0, a = 4){
        super(), r = Math.floor(Math.max(3, r)), i = Math.floor(i), a = Math.floor(a);
        let l = [], u = [], c = [], d = [], h = 0, f = e / 2, p = Math.PI / r, m = t * Math.cos(Math.PI / r), g = 2 * Math.PI / r, y = (r - 2) * Math.PI / r, v = Math.PI - y, x = new _(0, -f, 0), S = new _(0, f, 0), w = new N(t, -f), A = new N(m, -f), E = new N(0, S.y).sub(A), b = new N(0, S.y).sub(w), T = new N(E.y, -E.x).normalize(), M = new N(b.y, -b.x).normalize(), P = t * Math.cos(Math.PI / r) * Math.tan((Math.PI - E.angle()) / 2) - 1e-8;
        o = Math.min(o, P);
        let D;
        {
            let j = new _(T.x, T.y, 0), W = new _(Math.cos(g) * j.x, j.y, Math.sin(g) * j.x);
            D = j.angleTo(W);
        }
        let O = o / Math.tan((Math.PI - E.angle()) / 2), I = o / Math.tan((Math.PI - D) / 2), z = new _;
        if (!s) {
            u.push(x.x, x.y, x.z), c.push(0, -1, 0), d.push(0, 0);
            let j = h++, W = [], k = w.clone(), H = O / Math.cos(Math.PI / r);
            k.x -= H;
            for(let X = 0; X < r; X++){
                let q = X / r * Math.PI * 2 + p, G = new N(Math.sin(q), Math.cos(q));
                hm(k, G, z), u.push(z.x, z.y, z.z), c.push(0, -1, 0), d.push(0, 0), W.push(h++);
            }
            for(let X = 0; X < W.length; X++)l.push(W[X], j, W[(X + 1) % W.length]);
        }
        let B = [];
        {
            let j = new _, W = new _, k = new _, H = new _, X = new _, q = new _;
            for(let G = 0; G < r; G++){
                let J = G / r * Math.PI * 2 + p, Z = (G + .5) / r * Math.PI * 2 + p, K = (G + 1) / r * Math.PI * 2 + p, Y = new N(Math.sin(J), Math.cos(J)), ye = new N(Math.sin(Z), Math.cos(Z)), fe = new N(Math.sin(K), Math.cos(K));
                hm(w, Y, W), hm(w, fe, k), hm(T, ye, j), hA(S, W, k, I, I, H), u.push(H.x, H.y, H.z), hA(W, S, k, I, O, X), u.push(X.x, X.y, X.z), hA(k, W, S, O, I, q), u.push(q.x, q.y, q.z), c.push(j.x, j.y, j.z), c.push(j.x, j.y, j.z), c.push(j.x, j.y, j.z), d.push(0, 0), d.push(0, 0), d.push(0, 0);
                let oe = h++, _e = h++, xe = h++;
                if (l.push(oe, _e, xe), o > 0) {
                    {
                        let Pe = W.clone().add(k).multiplyScalar(.5), Te = S.clone().sub(Pe).normalize(), Ue = x.clone().sub(Pe).normalize().add(Te).normalize().multiplyScalar(-1), L = q.clone().sub(X);
                        V(Pe, L, Ue, E.angle());
                    }
                    let Ie, Oe;
                    {
                        let Pe = new _;
                        hm(M, fe, Pe);
                        let Te = q.clone().add(H).multiplyScalar(.5);
                        Te = uY(Te, k, S);
                        let Ve = q.clone().sub(H);
                        [Ie, Oe] = V(Te, Ve, Pe, D, H.y);
                    }
                    {
                        let Pe = Ie, Te = Pe.clone().setY(0).normalize(), Ve = new _(0, -1, 0), Ue = Te.clone().cross(Ve);
                        U(Pe, Te, Ve, Ue);
                    }
                    B.concat(Oe);
                    {
                        let Pe = E.angle(), Te = Math.PI - Pe, Ve = S.clone();
                        Ve.y -= o / Math.sin(Pe - Math.PI / 2);
                        let Ue = new _, L = [];
                        for(let ie = 0; ie < a; ie++){
                            let ue = [], me = Math.PI / 2 - Te * ie / a, De = Math.cos(me), Me = Math.sin(me), Ee = Z;
                            for(let le = 0; le <= ie; le++){
                                let Je = Math.cos(Ee), ke = Math.sin(Ee);
                                j.x = De * ke, j.y = Me, j.z = De * Je, Ue.copy(Ve).addScaledVector(j, o), u.push(Ue.x, Ue.y, Ue.z), c.push(j.x, j.y, j.z), d.push(0, 0), ue.push(h++), Ee += Math.PI * 2 / ie / r;
                            }
                            L.push(ue);
                        }
                        Oe.reverse(), L.push(Oe);
                        let R = L.length - 1;
                        for(let ie = 0; ie < R; ie++){
                            let ue = L[ie], me = L[ie + 1], De = ue.length - 1;
                            l.push(me[1], ue[0], me[0]);
                            for(let Me = 1; Me <= De; Me++)l.push(ue[Me], ue[Me - 1], me[Me]), l.push(me[Me + 1], ue[Me], me[Me]);
                        }
                    }
                }
            }
        }
        this.setIndex(l), this.setAttribute("position", new be(u, 3)), this.setAttribute("normal", new be(c, 3)), this.setAttribute("uv", new be(d, 2));
        function V(j, W, k, H, X) {
            let q = -H / 2, G = (Math.PI - H) / 2, J = W.clone().normalize().cross(k);
            j.addScaledVector(k, -o / Math.sin(G));
            let Z = new _, K = new _, Y = 1, ye = h, fe = [];
            for(let oe = 0; oe <= a; oe++){
                let _e = q + oe / a * H;
                K.set(0, 0, 0), K.addScaledVector(J, Math.sin(_e)), K.addScaledVector(k, Math.cos(_e));
                for(let xe = 0; xe <= Y; xe++){
                    let Ie = xe / Y - .5;
                    if (Z.copy(j), Z.addScaledVector(W, Ie), Z.addScaledVector(K, o), X != null) {
                        let Oe = Math.max(0, Z.y - X);
                        Z.addScaledVector(W, -Oe / W.y);
                    }
                    u.push(Z.x, Z.y, Z.z), c.push(K.x, K.y, K.z), d.push(0, 0), xe === 0 && fe.push(h), h++;
                }
            }
            for(let oe = 0; oe < a; oe++)for(let _e = 0; _e < Y; _e++){
                let xe = ye + _e + (Y + 1) * oe, Ie = xe + (Y + 1), Oe = Ie + 1, Pe = xe + 1;
                l.push(xe, Ie, Pe), l.push(Ie, Oe, Pe);
            }
            return [
                j.clone().addScaledVector(W, .5),
                fe
            ];
        }
        function U(j, W, k, H) {
            let X = Math.PI / 2, q = b.angle() - X, G = [], J = new _, Z = new _;
            for(let Y = 0; Y <= a; Y++){
                let ye = [], fe = Y / a;
                for(let oe = 0; oe <= Y; oe++){
                    let xe = ((Y ? oe / Y : 0) - .5) * v, Ie = Math.cos(xe), Oe = Math.sin(xe), Pe = Math.atan(Math.tan(q) * Ie), Te = (X + Pe) * fe, Ve = Math.cos(Te), Ue = Math.sin(Te);
                    J.set(0, 0, 0), J.addScaledVector(W, Ue * Ie), J.addScaledVector(k, Ve), J.addScaledVector(H, Ue * Oe), Z.copy(j).addScaledVector(J, o), u.push(Z.x, Z.y, Z.z), c.push(J.x, J.y, J.z), d.push(0, 0), ye.push(h++);
                }
                G.push(ye);
            }
            let K = G.length - 1;
            for(let Y = 0; Y < K; Y++){
                let ye = G[Y], fe = G[Y + 1], oe = ye.length - 1;
                l.push(ye[0], fe[1], fe[0]);
                for(let _e = 1; _e <= oe; _e++)l.push(ye[_e - 1], ye[_e], fe[_e]), l.push(ye[_e], fe[_e + 1], fe[_e]);
            }
        }
    }
};
var Eh = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters), r = Object.assign(t?.ui ?? {
            enabledIndieCorners: !1
        }, n1.ui);
        return {
            shape: n1.shape && n1.shape instanceof kt ? n1.shape : new kt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            }),
            ui: r
        };
    }
    static build(n1) {
        let t = n1.shape, { width: e, height: r, cornerRadius: i, cornerType: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, u = {
            x: e * .5,
            y: r * .5
        }, c = {
            x: -u.x,
            y: -u.y
        }, d = {
            x: u.x,
            y: u.y
        };
        function h(S, w, A) {
            return w > e && A > r ? Math.min(S * e / w, S * r / A) : w > e ? S * e / w : A > r ? S * r / A : S;
        }
        let f = [];
        f[0] = i[0] === 0 ? 0 : h(i[0], i[0] + i[3], i[0] + i[1]), f[1] = i[1] === 0 ? 0 : h(i[1], i[1] + i[2], i[1] + i[0]), f[2] = i[2] === 0 ? 0 : h(i[2], i[2] + i[1], i[2] + i[3]), f[3] = i[3] === 0 ? 0 : h(i[3], i[3] + i[0], i[3] + i[2]);
        let p = c.x, m = d.x, g = d.y, y = c.y;
        t.addPoint(t.createPoint(p, g)), t.addPoint(t.createPoint(m, g)), t.addPoint(t.createPoint(m, y)), t.addPoint(t.createPoint(p, y)), t.isClosed = !0;
        let v = !0;
        for(let S = 0, w = t.points.length; S < w; S++)t.points[S].roundness = f[S], S > 0 && f[S] !== f[S - 1] && (v = !1);
        v && (t.roundness = f[0]), t.useCubicForRoundedCorners = s !== 1, t.update();
        let x = Dn.create({
            shape: t,
            parameters: {
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        });
        return Object.assign(x, {
            userData: {
                ...n1,
                type: "RectangleGeometry"
            }
        });
    }
};
var nI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        }, n1.parameters);
        return e.thetaLength = Se.clamp(e.thetaLength, 0, 180), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, depth: r = t, widthSegments: i = 64, heightSegments: s = 64, phiStart: o, phiLength: a, thetaStart: l, thetaLength: u } = n1.parameters, c;
        return u === 0 ? (c = new we, c.setAttribute("position", new be([], 3))) : c = new Bs(.5 * t, i, s, o, a, l, u * Se.DEG2RAD), c.scale(1, e / t, r / t), Object.assign(c, {
            userData: {
                ...n1,
                type: "SphereGeometry"
            }
        });
    }
};
var sI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            widthSegments: 8,
            heightSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: 0
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, widthSegments: r = 8, heightSegments: i = 8 } = n1.parameters, s = new hn(t, e, r, i);
        return s.scale(1, 1, 1), Object.assign(s, {
            userData: {
                ...n1,
                type: "PlaneGeometry"
            }
        });
    }
};
var oI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            angle: 90,
            cornerRadius: 24,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, angle: i, cornerRadius: s, cornerSegments: o } = n1.parameters, a = new pA(t, e, r, i, s, o);
        return Object.assign(a, {
            userData: {
                ...n1,
                type: "BackdropGeometry"
            }
        });
    }
}, pA = class extends we {
    constructor(t = 1, e = 1, r = 1, i = 90, s = 10, o = 24){
        super(), this.type = "BackdropGeometry";
        let a = [], l = [], u = [], c = .001;
        s == 0 && (o = 1), o = Math.max(1, Math.floor(o)), s = Math.min(s, 100), i = Math.min(180 - c, i), i *= Math.PI / 180;
        let d = [], h = Math.PI / 2, f = (Z = 0, K = 0, Y = 0)=>new _(Z, K, Y), p = f(), m = f(), [g, y, v] = [
            e / 2,
            t / 2,
            r / 2
        ], x = -y, S = +y, [w, A, E] = [
            f(x, -g, +v),
            f(x, -g, -v),
            f(x, +g, -v)
        ], b = (Z, K = !1)=>Math.sin(Z - Math.PI / (1 + +K)), T = (Z, K = !1)=>Math.cos(Z - Math.PI / (1 + +K));
        E.y = Math.sin(i) * e - g;
        let M = Math.cos(i) * e - v, C = w.z - c;
        i <= h ? (E.z = Math.min(M, C), E.z == C && (E.y -= (M - C) / Math.tan(h - i))) : A.z = Math.min(A.z - M - v, w.z - c), p.subVectors(w, A), m.subVectors(E, A);
        let P = Math.min(p.length(), m.length()) * s / 100, D = P * Math.tan(i / 2), O = P / Math.cos(i / 2), I = p.clone().normalize().add(m.normalize()).setLength(O).add(A);
        p.set(0, b(i, !0), T(i, !0)), d.push([
            E,
            p.clone()
        ]);
        let z = (Math.PI - i) / o;
        for(let Z = 0; Z <= o; Z++){
            let K = h + i + Z * z;
            p.set(0, Math.sin(K) * D, Math.cos(K) * D), p.add(I), m.set(0, b(K), T(K)), d.push([
                p.clone(),
                m.clone()
            ]);
        }
        d.push([
            w,
            f(0, 1, 0)
        ]);
        let B = Math.sin(z / 2) * D * 2, V = d.length - 1, U = d[0][0].distanceTo(d[1][0]), j = d[V - 1][0].distanceTo(d[V][0]), W = U + B * o + j;
        d[0].push(1);
        for(let Z = 0; Z <= o; Z++)d[Z + 1].push(1 - (U + Z * B) / W);
        d[V].push(0);
        let [k, H, X] = d[0], q, G, J;
        for(let Z = 1; Z < d.length; Z++)[q, G, J] = d[Z], a.push(x, k.y, k.z, x, q.y, q.z, S, k.y, k.z, S, k.y, k.z, x, q.y, q.z, S, q.y, q.z), l.push(0, H.y, H.z, 0, G.y, G.z, 0, H.y, H.z, 0, H.y, H.z, 0, G.y, G.z, 0, G.y, G.z), u.push(0, X, 0, J, 1, X, 1, X, 0, J, 1, J), [k, H, X] = [
            q,
            G,
            J
        ];
        this.setAttribute("position", new be(a, 3)), this.setAttribute("normal", new be(l, 3)), this.setAttribute("uv", new be(u, 2));
    }
};
var M0 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            innerRadiusPercent: 38.19,
            spikes: 5,
            cornerRadius: 0,
            angle: 360,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof kt ? n1.shape : new kt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, innerRadiusPercent: r, spikes: i, cornerRadius: s, angle: o, depth: a, extrudeBevelSize: l, extrudeBevelSegments: u } = n1.parameters, c = n1.shape, d = t * .5, h = e * .5, f = 0, p = 0, m = o * Math.PI / 360 / i, g = Math.PI / 2 * -3, y = d * r / 100, v = h * r / 100;
        if (i === 3 && r === 50) {
            m = 2 * Math.PI / i;
            for(let S = 0; S < i; S++){
                let w = m * S, A = f + Math.sin(w) * d, E = p + Math.cos(w) * h;
                c.addPoint(c.createPoint(A, E));
            }
        } else for(let S = 0; S < i; S++){
            let w = f + Math.cos(g) * d, A = p + Math.sin(g) * h;
            c.addPoint(c.createPoint(w, A)), g += m, w = f + Math.cos(g) * y, A = p + Math.sin(g) * v, c.addPoint(c.createPoint(w, A)), g += m;
        }
        c.isClosed = !0;
        for(let S = 0, w = c.points.length; S < w; S++)c.points[S].roundness = s;
        c.roundness = s, c.update();
        let x = Dn.create({
            shape: c,
            parameters: {
                roundness: s,
                depth: a,
                extrudeBevelSize: l,
                extrudeBevelSegments: u
            }
        });
        return Object.assign(x, {
            userData: {
                ...n1,
                type: "StarGeometry"
            }
        });
    }
};
var aI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e } = n1.parameters, r = new hn(t, e);
        return Object.assign(r, {
            userData: {
                ...n1,
                type: "TextFrameGeometry"
            }
        });
    }
};
var lI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            tubularSegments: 64,
            arc: 360,
            cornerRadius: 30,
            cornerSegments: 8
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.round(Math.abs(e.depth ?? e.width * .25));
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, tubularSegments: s, arc: o, cornerRadius: a, cornerSegments: l } = n1.parameters, u = dY(t, e, r, t * .5, o, s, 0, 0, i, a, l);
        return u.scale(1, e / t, 1), Object.assign(u, {
            userData: {
                ...n1,
                type: "TorusGeometry"
            }
        });
    }
};
function dY(n1, t, e, r, i, s, o, a, l, u, c) {
    [t, e] = [
        e,
        t
    ], o = t / 2;
    let d = Se.clamp(i / 360, 0, 1);
    if (d === 0) {
        let h = new we;
        return h.setAttribute("position", new be([], 3)), h;
    }
    return d === 1 && (u = 0), new um(!0, n1, t, e, r, d, s, o, a, l, u, c);
}
var cI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            tubularSegments: 64,
            radialSegments: 32,
            p: 2,
            q: 3
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                tube: e.tube ?? e.width * .125
            })
        };
    }
    static build(n1) {
        let { width: t, tube: e, tubularSegments: r, radialSegments: i, p: s, q: o } = n1.parameters, a = t * .5;
        a !== e && (a -= e);
        let l = new Vu(a, e, r, i, s, o);
        return Object.assign(l, {
            userData: {
                ...n1,
                type: "TorusKnotGeometry"
            }
        });
    }
};
var uI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1,
            isRect: !1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof kt ? n1.shape : new kt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width * (e.isRect ? 1 : Math.sqrt(3) / 2)),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e, cornerRadius: r, depth: i, extrudeBevelSize: s, extrudeBevelSegments: o, isRect: a } = n1.parameters, l = n1.shape, u = t * .5, c = e * .5;
        a ? (l.addPoint(l.createPoint(-u, c)), l.addPoint(l.createPoint(u, -c)), l.addPoint(l.createPoint(-u, -c))) : (l.addPoint(l.createPoint(0, c)), l.addPoint(l.createPoint(u, -c)), l.addPoint(l.createPoint(-u, -c))), l.isClosed = !0;
        for(let h = 0, f = l.points.length; h < f; h++)l.points[h].roundness = r;
        l.roundness = r, l.update();
        let d = Dn.create({
            shape: l,
            parameters: {
                roundness: r,
                depth: i,
                extrudeBevelSize: s,
                extrudeBevelSegments: o
            }
        });
        return Object.assign(d, {
            userData: {
                ...n1,
                type: "TriangleGeometry"
            }
        });
    }
};
function dI(n1, t) {
    let e = 2 * Math.PI;
    return (n1 % e + e) % e === (t % e + e) % e;
}
var mA = class {
    add(t, e, r) {
        if (typeof arguments[0] != "string") for(let i in arguments[0])this.add(i, arguments[0][i], arguments[1]);
        else (Array.isArray(t) ? t : [
            t
        ]).forEach(function(i) {
            this[i] = this[i] || [], e && this[i][r ? "unshift" : "push"](e);
        }, this);
    }
    run(t, e) {
        this[t] = this[t] || [], this[t].forEach(function(r) {
            r.call(e && e.context ? e.context : e, e);
        });
    }
}, gA = class {
    constructor(t){
        this.jsep = t, this.registered = {};
    }
    register(...t) {
        t.forEach((e)=>{
            if (typeof e != "object" || !e.name || !e.init) throw new Error("Invalid JSEP plugin format");
            this.registered[e.name] || (e.init(this.jsep), this.registered[e.name] = e);
        });
    }
}, ae = class {
    static get version() {
        return "1.3.8";
    }
    static toString() {
        return "JavaScript Expression Parser (JSEP) v" + ae.version;
    }
    static addUnaryOp(t) {
        return ae.max_unop_len = Math.max(t.length, ae.max_unop_len), ae.unary_ops[t] = 1, ae;
    }
    static addBinaryOp(t, e, r) {
        return ae.max_binop_len = Math.max(t.length, ae.max_binop_len), ae.binary_ops[t] = e, r ? ae.right_associative.add(t) : ae.right_associative.delete(t), ae;
    }
    static addIdentifierChar(t) {
        return ae.additional_identifier_chars.add(t), ae;
    }
    static addLiteral(t, e) {
        return ae.literals[t] = e, ae;
    }
    static removeUnaryOp(t) {
        return delete ae.unary_ops[t], t.length === ae.max_unop_len && (ae.max_unop_len = ae.getMaxKeyLen(ae.unary_ops)), ae;
    }
    static removeAllUnaryOps() {
        return ae.unary_ops = {}, ae.max_unop_len = 0, ae;
    }
    static removeIdentifierChar(t) {
        return ae.additional_identifier_chars.delete(t), ae;
    }
    static removeBinaryOp(t) {
        return delete ae.binary_ops[t], t.length === ae.max_binop_len && (ae.max_binop_len = ae.getMaxKeyLen(ae.binary_ops)), ae.right_associative.delete(t), ae;
    }
    static removeAllBinaryOps() {
        return ae.binary_ops = {}, ae.max_binop_len = 0, ae;
    }
    static removeLiteral(t) {
        return delete ae.literals[t], ae;
    }
    static removeAllLiterals() {
        return ae.literals = {}, ae;
    }
    get char() {
        return this.expr.charAt(this.index);
    }
    get code() {
        return this.expr.charCodeAt(this.index);
    }
    constructor(t){
        this.expr = t, this.index = 0;
    }
    static parse(t) {
        return new ae(t).parse();
    }
    static getMaxKeyLen(t) {
        return Math.max(0, ...Object.keys(t).map((e)=>e.length));
    }
    static isDecimalDigit(t) {
        return t >= 48 && t <= 57;
    }
    static binaryPrecedence(t) {
        return ae.binary_ops[t] || 0;
    }
    static isIdentifierStart(t) {
        return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 && !ae.binary_ops[String.fromCharCode(t)] || ae.additional_identifier_chars.has(String.fromCharCode(t));
    }
    static isIdentifierPart(t) {
        return ae.isIdentifierStart(t) || ae.isDecimalDigit(t);
    }
    throwError(t) {
        let e = new Error(t + " at character " + this.index);
        throw e.index = this.index, e.description = t, e;
    }
    runHook(t, e) {
        if (ae.hooks[t]) {
            let r = {
                context: this,
                node: e
            };
            return ae.hooks.run(t, r), r.node;
        }
        return e;
    }
    searchHook(t) {
        if (ae.hooks[t]) {
            let e = {
                context: this
            };
            return ae.hooks[t].find(function(r) {
                return r.call(e.context, e), e.node;
            }), e.node;
        }
    }
    gobbleSpaces() {
        let t = this.code;
        for(; t === ae.SPACE_CODE || t === ae.TAB_CODE || t === ae.LF_CODE || t === ae.CR_CODE;)t = this.expr.charCodeAt(++this.index);
        this.runHook("gobble-spaces");
    }
    parse() {
        this.runHook("before-all");
        let t = this.gobbleExpressions(), e = t.length === 1 ? t[0] : {
            type: ae.COMPOUND,
            body: t
        };
        return this.runHook("after-all", e);
    }
    gobbleExpressions(t) {
        let e = [], r, i;
        for(; this.index < this.expr.length;)if (r = this.code, r === ae.SEMCOL_CODE || r === ae.COMMA_CODE) this.index++;
        else if (i = this.gobbleExpression()) e.push(i);
        else if (this.index < this.expr.length) {
            if (r === t) break;
            this.throwError('Unexpected "' + this.char + '"');
        }
        return e;
    }
    gobbleExpression() {
        let t = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
        return this.gobbleSpaces(), this.runHook("after-expression", t);
    }
    gobbleBinaryOp() {
        this.gobbleSpaces();
        let t = this.expr.substr(this.index, ae.max_binop_len), e = t.length;
        for(; e > 0;){
            if (ae.binary_ops.hasOwnProperty(t) && (!ae.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !ae.isIdentifierPart(this.expr.charCodeAt(this.index + t.length)))) return this.index += e, t;
            t = t.substr(0, --e);
        }
        return !1;
    }
    gobbleBinaryExpression() {
        let t, e, r, i, s, o, a, l, u;
        if (o = this.gobbleToken(), !o || (e = this.gobbleBinaryOp(), !e)) return o;
        for(s = {
            value: e,
            prec: ae.binaryPrecedence(e),
            right_a: ae.right_associative.has(e)
        }, a = this.gobbleToken(), a || this.throwError("Expected expression after " + e), i = [
            o,
            s,
            a
        ]; e = this.gobbleBinaryOp();){
            if (r = ae.binaryPrecedence(e), r === 0) {
                this.index -= e.length;
                break;
            }
            s = {
                value: e,
                prec: r,
                right_a: ae.right_associative.has(e)
            }, u = e;
            let c = (d)=>s.right_a && d.right_a ? r > d.prec : r <= d.prec;
            for(; i.length > 2 && c(i[i.length - 2]);)a = i.pop(), e = i.pop().value, o = i.pop(), t = {
                type: ae.BINARY_EXP,
                operator: e,
                left: o,
                right: a
            }, i.push(t);
            t = this.gobbleToken(), t || this.throwError("Expected expression after " + u), i.push(s, t);
        }
        for(l = i.length - 1, t = i[l]; l > 1;)t = {
            type: ae.BINARY_EXP,
            operator: i[l - 1].value,
            left: i[l - 2],
            right: t
        }, l -= 2;
        return t;
    }
    gobbleToken() {
        let t, e, r, i;
        if (this.gobbleSpaces(), i = this.searchHook("gobble-token"), i) return this.runHook("after-token", i);
        if (t = this.code, ae.isDecimalDigit(t) || t === ae.PERIOD_CODE) return this.gobbleNumericLiteral();
        if (t === ae.SQUOTE_CODE || t === ae.DQUOTE_CODE) i = this.gobbleStringLiteral();
        else if (t === ae.OBRACK_CODE) i = this.gobbleArray();
        else {
            for(e = this.expr.substr(this.index, ae.max_unop_len), r = e.length; r > 0;){
                if (ae.unary_ops.hasOwnProperty(e) && (!ae.isIdentifierStart(this.code) || this.index + e.length < this.expr.length && !ae.isIdentifierPart(this.expr.charCodeAt(this.index + e.length)))) {
                    this.index += r;
                    let s = this.gobbleToken();
                    return s || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
                        type: ae.UNARY_EXP,
                        operator: e,
                        argument: s,
                        prefix: !0
                    });
                }
                e = e.substr(0, --r);
            }
            ae.isIdentifierStart(t) ? (i = this.gobbleIdentifier(), ae.literals.hasOwnProperty(i.name) ? i = {
                type: ae.LITERAL,
                value: ae.literals[i.name],
                raw: i.name
            } : i.name === ae.this_str && (i = {
                type: ae.THIS_EXP
            })) : t === ae.OPAREN_CODE && (i = this.gobbleGroup());
        }
        return i ? (i = this.gobbleTokenProperty(i), this.runHook("after-token", i)) : this.runHook("after-token", !1);
    }
    gobbleTokenProperty(t) {
        this.gobbleSpaces();
        let e = this.code;
        for(; e === ae.PERIOD_CODE || e === ae.OBRACK_CODE || e === ae.OPAREN_CODE || e === ae.QUMARK_CODE;){
            let r;
            if (e === ae.QUMARK_CODE) {
                if (this.expr.charCodeAt(this.index + 1) !== ae.PERIOD_CODE) break;
                r = !0, this.index += 2, this.gobbleSpaces(), e = this.code;
            }
            this.index++, e === ae.OBRACK_CODE ? (t = {
                type: ae.MEMBER_EXP,
                computed: !0,
                object: t,
                property: this.gobbleExpression()
            }, this.gobbleSpaces(), e = this.code, e !== ae.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : e === ae.OPAREN_CODE ? t = {
                type: ae.CALL_EXP,
                arguments: this.gobbleArguments(ae.CPAREN_CODE),
                callee: t
            } : (e === ae.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), t = {
                type: ae.MEMBER_EXP,
                computed: !1,
                object: t,
                property: this.gobbleIdentifier()
            }), r && (t.optional = !0), this.gobbleSpaces(), e = this.code;
        }
        return t;
    }
    gobbleNumericLiteral() {
        let t = "", e, r;
        for(; ae.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (this.code === ae.PERIOD_CODE) for(t += this.expr.charAt(this.index++); ae.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (e = this.char, e === "e" || e === "E") {
            for(t += this.expr.charAt(this.index++), e = this.char, (e === "+" || e === "-") && (t += this.expr.charAt(this.index++)); ae.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
            ae.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + t + this.char + ")");
        }
        return r = this.code, ae.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + t + this.char + ")") : (r === ae.PERIOD_CODE || t.length === 1 && t.charCodeAt(0) === ae.PERIOD_CODE) && this.throwError("Unexpected period"), {
            type: ae.LITERAL,
            value: parseFloat(t),
            raw: t
        };
    }
    gobbleStringLiteral() {
        let t = "", e = this.index, r = this.expr.charAt(this.index++), i = !1;
        for(; this.index < this.expr.length;){
            let s = this.expr.charAt(this.index++);
            if (s === r) {
                i = !0;
                break;
            } else if (s === "\\") switch(s = this.expr.charAt(this.index++), s){
                case "n":
                    t += `
`;
                    break;
                case "r":
                    t += "\r";
                    break;
                case "t":
                    t += "	";
                    break;
                case "b":
                    t += "\b";
                    break;
                case "f":
                    t += "\f";
                    break;
                case "v":
                    t += "\v";
                    break;
                default:
                    t += s;
            }
            else t += s;
        }
        return i || this.throwError('Unclosed quote after "' + t + '"'), {
            type: ae.LITERAL,
            value: t,
            raw: this.expr.substring(e, this.index)
        };
    }
    gobbleIdentifier() {
        let t = this.code, e = this.index;
        for(ae.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (t = this.code, ae.isIdentifierPart(t));)this.index++;
        return {
            type: ae.IDENTIFIER,
            name: this.expr.slice(e, this.index)
        };
    }
    gobbleArguments(t) {
        let e = [], r = !1, i = 0;
        for(; this.index < this.expr.length;){
            this.gobbleSpaces();
            let s = this.code;
            if (s === t) {
                r = !0, this.index++, t === ae.CPAREN_CODE && i && i >= e.length && this.throwError("Unexpected token " + String.fromCharCode(t));
                break;
            } else if (s === ae.COMMA_CODE) {
                if (this.index++, i++, i !== e.length) {
                    if (t === ae.CPAREN_CODE) this.throwError("Unexpected token ,");
                    else if (t === ae.CBRACK_CODE) for(let o = e.length; o < i; o++)e.push(null);
                }
            } else if (e.length !== i && i !== 0) this.throwError("Expected comma");
            else {
                let o = this.gobbleExpression();
                (!o || o.type === ae.COMPOUND) && this.throwError("Expected comma"), e.push(o);
            }
        }
        return r || this.throwError("Expected " + String.fromCharCode(t)), e;
    }
    gobbleGroup() {
        this.index++;
        let t = this.gobbleExpressions(ae.CPAREN_CODE);
        if (this.code === ae.CPAREN_CODE) return this.index++, t.length === 1 ? t[0] : t.length ? {
            type: ae.SEQUENCE_EXP,
            expressions: t
        } : !1;
        this.throwError("Unclosed (");
    }
    gobbleArray() {
        return this.index++, {
            type: ae.ARRAY_EXP,
            elements: this.gobbleArguments(ae.CBRACK_CODE)
        };
    }
}, hY = new mA;
Object.assign(ae, {
    hooks: hY,
    plugins: new gA(ae),
    COMPOUND: "Compound",
    SEQUENCE_EXP: "SequenceExpression",
    IDENTIFIER: "Identifier",
    MEMBER_EXP: "MemberExpression",
    LITERAL: "Literal",
    THIS_EXP: "ThisExpression",
    CALL_EXP: "CallExpression",
    UNARY_EXP: "UnaryExpression",
    BINARY_EXP: "BinaryExpression",
    ARRAY_EXP: "ArrayExpression",
    TAB_CODE: 9,
    LF_CODE: 10,
    CR_CODE: 13,
    SPACE_CODE: 32,
    PERIOD_CODE: 46,
    COMMA_CODE: 44,
    SQUOTE_CODE: 39,
    DQUOTE_CODE: 34,
    OPAREN_CODE: 40,
    CPAREN_CODE: 41,
    OBRACK_CODE: 91,
    CBRACK_CODE: 93,
    QUMARK_CODE: 63,
    SEMCOL_CODE: 59,
    COLON_CODE: 58,
    unary_ops: {
        "-": 1,
        "!": 1,
        "~": 1,
        "+": 1
    },
    binary_ops: {
        "||": 1,
        "&&": 2,
        "|": 3,
        "^": 4,
        "&": 5,
        "==": 6,
        "!=": 6,
        "===": 6,
        "!==": 6,
        "<": 7,
        ">": 7,
        "<=": 7,
        ">=": 7,
        "<<": 8,
        ">>": 8,
        ">>>": 8,
        "+": 9,
        "-": 9,
        "*": 10,
        "/": 10,
        "%": 10
    },
    right_associative: new Set,
    additional_identifier_chars: new Set([
        "$",
        "_"
    ]),
    literals: {
        true: !0,
        false: !1,
        null: null
    },
    this_str: "this"
});
ae.max_unop_len = ae.getMaxKeyLen(ae.unary_ops);
ae.max_binop_len = ae.getMaxKeyLen(ae.binary_ops);
var Nc = (n1)=>new ae(n1).parse(), fY = Object.getOwnPropertyNames(ae);
fY.forEach((n1)=>{
    Nc[n1] === void 0 && n1 !== "prototype" && (Nc[n1] = ae[n1]);
});
Nc.Jsep = ae;
var pY = "ConditionalExpression", mY = {
    name: "ternary",
    init (n1) {
        n1.hooks.add("after-expression", function(e) {
            if (e.node && this.code === n1.QUMARK_CODE) {
                this.index++;
                let r = e.node, i = this.gobbleExpression();
                if (i || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === n1.COLON_CODE) {
                    this.index++;
                    let s = this.gobbleExpression();
                    if (s || this.throwError("Expected expression"), e.node = {
                        type: pY,
                        test: r,
                        consequent: i,
                        alternate: s
                    }, r.operator && n1.binary_ops[r.operator] <= .9) {
                        let o = r;
                        for(; o.right.operator && n1.binary_ops[o.right.operator] <= .9;)o = o.right;
                        e.node.test = o.right, o.right = e.node, e.node = r;
                    }
                } else this.throwError("Expected :");
            }
        });
    }
};
Nc.plugins.register(mY);
var gY = [
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "==",
    "!=",
    ">",
    "<",
    ">=",
    "<=",
    "and",
    "or",
    "!",
    "%",
    "^",
    ","
], yY = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "."
], vY = [
    "sin",
    "cos",
    "tan",
    "asin",
    "acos",
    "atan",
    "atan2",
    "sqrt",
    "abs",
    "log",
    "exp",
    "floor",
    "ceil",
    "round",
    "min",
    "max",
    "random"
];
function xY(n1) {
    return typeof n1 != "string" ? !1 : !isNaN(n1) && !isNaN(parseFloat(n1));
}
Nc.addBinaryOp("^", 11, !0);
function C0(n1, t, e = "number") {
    let r = "";
    for(let o = 0; o < n1.length; o++){
        let a = n1[o];
        if ("id" in a) {
            let l = n1[o - 1];
            if (o > 0 && "id" in l) {
                console.error("Two variables in a row", n1);
                return;
            }
            let u = t.getVariable(a.id), c = Fi.getDisplayedValue(u);
            e === "number" && Fi.isTextValue(u) && Array.isArray(u.textValue) && u.textValue.length === 1 ? c = parseFloat(c).toString() : e === "boolean" && Fi.isBoolean(u) ? c = u ? "true" : "false" : e === "boolean" && Fi.isTextValue(u) && !Array.isArray(u.textValue) && (c = '"' + c + '"'), r += c;
            continue;
        } else if (e === "string") {
            a.name !== '"' && a.name !== "+" && (r += a.name), a.name === "+" && r[r.length - 1] === "\\" && (r = r.slice(0, -1) + a.name);
            continue;
        }
        if (a.name === "and") {
            r += "&&";
            continue;
        }
        if (a.name === "or") {
            r += "||";
            continue;
        }
        if (a.name === "True") {
            r += "true";
            continue;
        }
        if (a.name === "False") {
            r += "false";
            continue;
        }
        if (e === "boolean" && !xY(a.name) && !yY.includes(a.name) && !gY.includes(a.name) && !vY.includes(a.name.replace(/\($/g, ""))) {
            r += '"' + a.name + '"';
            continue;
        }
        r += a.name;
    }
    if (e === "string") return r;
    if (n1.length === 0) {
        if (e === "number") return 0;
        if (e === "boolean") return !1;
    }
    let i;
    try {
        i = Nc(r);
    } catch (o) {
        console.error(r, o);
        return;
    }
    let s;
    try {
        s = Nt(i);
    } catch (o) {
        console.error(r, i, o);
    }
    return s;
}
function Nt(n1) {
    switch(n1.type){
        case "BinaryExpression":
            switch(n1.operator){
                case "==":
                    return Number(Nt(n1.left) === Nt(n1.right));
                case "!=":
                    return Number(Nt(n1.left) !== Nt(n1.right));
                case ">":
                    return Number(Nt(n1.left) > Nt(n1.right));
                case ">=":
                    return Number(Nt(n1.left) >= Nt(n1.right));
                case "<":
                    return Number(Nt(n1.left) < Nt(n1.right));
                case "<=":
                    return Number(Nt(n1.left) <= Nt(n1.right));
                case "+":
                    return Nt(n1.left) + Nt(n1.right);
                case "-":
                    return Nt(n1.left) - Nt(n1.right);
                case "*":
                    return Nt(n1.left) * Nt(n1.right);
                case "/":
                    return Nt(n1.left) / Nt(n1.right);
                case "%":
                    return Nt(n1.left) % Nt(n1.right);
                case "&&":
                    return Nt(n1.left) && Nt(n1.right);
                case "||":
                    return Nt(n1.left) || Nt(n1.right);
                case "^":
                    return Math.pow(Nt(n1.left), Nt(n1.right));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "UnaryExpression":
            switch(n1.operator){
                case "-":
                    return -Nt(n1.argument);
                case "!":
                    return Number(!Nt(n1.argument));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "Identifier":
            throw new Error("Unknown identifier: " + n1.name);
        case "Literal":
            return n1.value;
        case "CallExpression":
            if (n1.callee.type === "Identifier") {
                if (n1.callee.name === "random") {
                    let t = 0, e = 1;
                    if (n1.arguments.length >= 1) try {
                        t = Nt(n1.arguments[0]);
                    } catch (r) {
                        console.warn(r);
                    }
                    if (n1.arguments.length >= 2) try {
                        e = Nt(n1.arguments[1]);
                    } catch (r) {
                        console.warn(r);
                    }
                    return t = Math.min(e, t), e = Math.max(e, t), t + Math.random() * (e - t);
                }
                return Math[n1.callee.name].apply(null, n1.arguments.map(Nt));
            } else throw new Error("Unknown node");
        default:
            throw new Error("Unknown node type: " + n1.type);
    }
}
var bY = new te, SY = new te;
function wY(n1, t, e) {
    let r = [
        new _,
        new _,
        new _
    ], i = [
        new _,
        new _,
        new _
    ];
    return n1.extractBasis(r[0], r[1], r[2]), t.extractBasis(i[0], i[1], i[2]), r.forEach((s, o)=>{
        let a = i[o], l = Se.lerp(s.length(), a.length(), e);
        s.lerp(a, e).setLength(l);
    }), new te().makeBasis(r[0], r[1], r[2]);
}
var hI = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            height: 100,
            depth: 1,
            subdivisions: 12,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = t?.shapeData ?? wh.create({
            parameters: l1
        }).userData.shape;
        return {
            path: n1.path ?? Vd.defaultData(),
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s,
                extrusion: {
                    ...Vv,
                    ...e.extrusion
                }
            }),
            shapeData: o
        };
    }
    static build(n1) {
        if (n1.path.points.length >= 2) {
            let e = new yA(n1);
            return Object.assign(e, {
                userData: {
                    ...n1,
                    type: "PathGeometry"
                }
            });
        } else return Object.assign(new we, {
            userData: {
                ...n1,
                type: "PathGeometry"
            }
        });
    }
}, yA = class extends we {
    constructor(e){
        super();
        this.type = "PathExtrusionGeometry", this.inputs = e, this.build();
    }
    _isGeometryClosed() {
        return this.inputs.path.isClosed && this.inputs.parameters.extrusion.depth === 1;
    }
    _isOpenEnded() {
        let e = this.inputs.parameters.extrusion;
        return !(this.inputs.path.isClosed && e.depth === 1) || !dI(e.twist, 0) || e.startScale !== e.endScale;
    }
    build() {
        let e = this._extractPathPoints();
        if (e.length < 2) return;
        let r = this._computeBasisMatrices(e), { depth: i, offset: s } = this.inputs.parameters.extrusion;
        i = Math.max(0, Math.min(i, 1)), s = Math.max(0, Math.min(s, 1));
        let o = this.inputs.path.isClosed ? e.length : e.length - 1, a = Math.floor(s * o), l = this.inputs.path.isClosed ? Math.ceil((i + s) * o) : Math.ceil(Math.min(1, i + s) * o), u = Math.min(Math.max(2, l - a + 1), o + 2), c = [], d = [];
        for(let U = 0; U < u; U++){
            let j = this.inputs.path.isClosed ? (U + a) % e.length : Math.min(U + a, e.length - 1);
            c.push(e[j].clone()), d.push(r[j].clone());
        }
        let h = (U, j, W)=>{
            c[U] = c[U].clone().lerp(c[j], W), d[U] = wY(d[U], d[j], W);
        }, f = 0, p = s * o % 1;
        (!this.inputs.path.isClosed || i <= 1) && (p || s === 0) && (f = p, h(0, 1, f));
        let m = 0, g = (s + i) * o % 1;
        if ((this.inputs.path.isClosed && i <= 1 || !this.inputs.path.isClosed && s + i < 1) && g && (m = g, h(c.length - 1, c.length - 2, 1 - m)), i === 0) {
            let U = c.length - 1;
            c[U].copy(c[0]), d[U].copy(d[0]);
        }
        this._applyPathModifiers(d, f, m);
        let { bevel: y, bevelSides: v } = this.inputs.parameters.extrusion, x = y > 0 ? this.inputs.parameters.extrusion.capType : "flat", S = 5;
        this.inputs.parameters.extrusion.shape.type === "Custom" && (S = this.inputs.parameters.extrusion.shape.shapeQuality === "low" ? 5 : 12);
        let { regions: w, infos: A, vertices: E } = this._computeShapePoints(S), b = 0, T;
        x === "round" && (T = new Ol(this.inputs.shapeData, 2 * y, y, S, v, void 0, !0), b = T.getAttribute("position").count);
        let M = 0, C = 0;
        A.sort((U, j)=>U.start - j.start), A.forEach((U)=>{
            U.verticesStart = M, U.verticesCount = U.continuous.reduce((j, W, k)=>j + (k === 0 || !W ? 2 : 1), 0), C += U.verticesCount, M = C;
        });
        let P = C * u, D, O = 0;
        if (this._isOpenEnded() && x === "flat") {
            try {
                D = Hs({
                    windingRule: Mt.ODD,
                    elementType: Rr.POLYGONS,
                    polySize: 3,
                    vertexSize: 2,
                    strict: !0,
                    contours: w
                });
            } catch  {
                D = oA;
            }
            O = D.vertexCount;
        }
        let I = P + 2 * O + b * 2, z = P + 2 * O, B = {
            positions: new Float32Array(I * 3),
            normals: new Float32Array(I * 3),
            uvs: new Float32Array(I * 2)
        }, V = [];
        if (A.forEach((U)=>{
            this._extrudeRegion(U, E, d, c, B, V, this._isGeometryClosed() && !this._isOpenEnded());
        }), D && (this._closeEnd(D, P, V, B, d[0], c[0], !1), this._closeEnd(D, P + O, V, B, d[d.length - 1], c[c.length - 1], !0)), T) {
            B.positions.set(T.getAttribute("position").array, z * 3), B.normals.set(T.getAttribute("normal").array, z * 3), B.uvs.set(T.getAttribute("uv").array, z * 2);
            let U = V.length;
            V.push(...T.getIndex().array.map((k)=>k + z)), z += b, B.positions.set(T.getAttribute("position").array, z * 3), B.normals.set(T.getAttribute("normal").array, z * 3), B.uvs.set(T.getAttribute("uv").array, z * 2);
            let j = V.length;
            V.push(...T.getIndex().array.map((k)=>k + z)), this.setAttribute("position", new Ge(B.positions, 3)), this.setAttribute("normal", new Ge(B.normals, 3)), this.setAttribute("uv", new Ge(B.uvs, 2)), this.setIndex(V);
            let W = bY;
            W.copy(d[d.length - 1]).setPosition(c[c.length - 1]), this.applyMatrix4OnRange(W, z, I), W.copy(d[0]).setPosition(c[0]).multiply(SY.makeScale(1, 1, -1)), this.applyMatrix4OnRange(W, z - b, z), this.reverseIndicesOnRange(U, j);
        } else this.setAttribute("position", new Ge(B.positions, 3)), this.setAttribute("normal", new Ge(B.normals, 3)), this.setAttribute("uv", new Ge(B.uvs, 2)), this.setIndex(V);
    }
    _extractPathPoints() {
        let r = p0(this.inputs.path).getPoints(this.inputs.path.subdivisions);
        if (r.length < 2) return [];
        let i = [
            r[0]
        ];
        return r.forEach((o)=>{
            i[i.length - 1].distanceToSquared(o) > .001 && i.push(o);
        }), this.inputs.path.isClosed && i[i.length - 1].distanceTo(i[0]) < .001 && i.pop(), i;
    }
    _computeBasisMatrices(e) {
        let r = [], i = e.length, s = this.inputs.path.isClosed, o = new _, a = new _, l = new _, u = new _, c = new _(0, 1, 0);
        for(let g = 0; g < i; g++){
            let y = e[g], v;
            g === 0 ? v = s ? e[e.length - 2] : y.clone().multiplyScalar(2).sub(e[1]) : v = e[g - 1];
            let x;
            g === i - 1 ? x = s ? e[1] : y.clone().multiplyScalar(2).sub(e[g - 1]) : x = e[g + 1];
            let S = y.clone().sub(v).normalize(), w = x.clone().sub(y).normalize(), A = S.clone().add(w).normalize();
            l.copy(A), g === 0 && (A.equals(c) || A.clone().negate().equals(c)) && c.set(0, 0, 1);
            let E = c.clone().cross(A).normalize(), b = A.clone().cross(E).normalize();
            c.copy(b), u.copy(E), g === 0 && (o.copy(b), a.copy(A));
            let T = new te().makeBasis(E, b, A);
            r.push(T);
        }
        let d = s ? a : l, h = s ? o : new _(0, 1, 0), f = d.clone().cross(u).normalize(), p = Math.acos(h.dot(f));
        if (isNaN(p)) return r;
        let m = h.clone().cross(f);
        d.dot(m) > 0 && (p *= -1);
        for(let g = 1; g < r.length; g++){
            let y = new te().makeRotationZ(p * g / r.length);
            r[g].multiply(y);
        }
        return r;
    }
    _applyPathModifiers(e, r, i) {
        let s = e.length, { angle: o, twist: a, startScale: l, endScale: u } = this.inputs.parameters.extrusion, c = new te, d = new te;
        return e.forEach((h, f)=>{
            let p = f === 0 ? 0 : f === s - 1 ? 1 : (f - r) / (s - (i === 0 ? 0 : 1) - (r + (1 - i)));
            c.makeRotationZ(Se.lerp(o, o + a, p) * Se.DEG2RAD);
            let m = Se.lerp(l, u, p);
            d.makeScale(m, m, m), h.multiply(c).multiply(d);
        }), e;
    }
    _computeShapePoints(e = 12, r = Mt.ODD) {
        let i = this.inputs.shapeData, s = i.extractShapePointsToFlatArray([], e), o = i.shapeHoles.map((m)=>{
            let g = m.extractShapePointsToFlatArray([], e), y = [];
            for(let v = g.length - 1; v >= 1; v -= 2){
                let x = g[v - 1], S = g[v - 0];
                y.push(x, S);
            }
            return y;
        }), a;
        try {
            a = Hs({
                windingRule: r,
                elementType: Rr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    s
                ]
            });
        } catch  {
            a = cm;
        }
        let l;
        try {
            l = Hs({
                windingRule: Mt.ODD,
                elementType: Rr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...o
                ]
            });
        } catch  {
            l = sA;
        }
        if (!a) throw new Error("error generating geometry");
        let u = a.elementCount;
        if (l) {
            a.elementCount += l.elementCount;
            for(let m = 0; m < l.elements.length; m++){
                let g = l.elements[m], y = m % 2 === 0 ? a.vertexCount : 0;
                a.elements.push(g + y);
            }
            for(let m = 0; m < l.vertexIndices.length; m++){
                let g = l.vertexIndices[m], y = a.vertexCount;
                a.vertexIndices.push(g + y);
            }
            for(let m = 0; m < l.vertices.length; m++){
                let g = l.vertices[m];
                a.vertices.push(g);
            }
        }
        let c = 1 / 0, d = -1 / 0, h = 1 / 0, f = -1 / 0;
        for(let m = 0, g = a.vertexCount; m < g; m++){
            let y = m * 2, v = a.vertices[y + 0], x = a.vertices[y + 1];
            v < c && (c = v), v > d && (d = v), x < h && (h = x), x > f && (f = x);
        }
        let p = [];
        for(let m = a.elementCount - 1; m >= 0; m--){
            let g = m >= u, y = m * 2, v = a.elements[y + 0], x = a.elements[y + 1], S = v + x, w = {
                start: v,
                count: x,
                normals: [],
                isHole: g,
                continuous: [],
                verticesStart: 0,
                verticesCount: 0
            };
            p.push(w);
            let A = v, E = S - 1, b = v + 1, T = i.roundedCurves.length;
            do {
                let M = A - v, C = a.vertices[E * 2 + 0], P = a.vertices[E * 2 + 1], D = a.vertices[A * 2 + 0], O = a.vertices[A * 2 + 1], I = a.vertices[b * 2 + 0], z = a.vertices[b * 2 + 1], B = D - C, V = O - P, U = Math.sqrt(B * B + V * V);
                B /= U, V /= U;
                let j = D - I, W = O - z, k = Math.sqrt(j * j + W * W);
                j /= k, W /= k, w.normals[M * 2 + 0] = -W, w.normals[M * 2 + 1] = j;
                let H = a.vertexIndices[A];
                if (Array.isArray(H)) w.continuous[M] = !1;
                else {
                    let [X, q] = i.getCurveIndexFromVertexId(H - 1, !0);
                    if (q > 0 && q < 1) w.continuous[M] = !0;
                    else {
                        let G = q === 1 ? X + 1 : X - 1;
                        G = (G + T) % T;
                        let J = q === 1 ? 0 : 1, Z = i.roundedCurves[X].getTangent(q), K = i.roundedCurves[G].getTangent(J);
                        w.continuous[M] = Z.dot(K) > .95;
                    }
                }
                g && (w.normals[M * 2 + 0] *= -1, w.normals[M * 2 + 1] *= -1), [E, A, b] = [
                    A,
                    b,
                    b + 1
                ], b >= S && (b -= x);
            }while (b !== v + 1);
        }
        return {
            regions: [
                s,
                ...o
            ],
            infos: p,
            vertices: a.vertices
        };
    }
    _insertVertex(e, r, i, s, o) {
        let a = r * 2, l = r * 3;
        e.positions[l + 0] = i.x, e.positions[l + 1] = i.y, e.positions[l + 2] = i.z, e.normals[l + 0] = s.x, e.normals[l + 1] = s.y, e.normals[l + 2] = s.z, e.uvs[a + 0] = o.x, e.uvs[a + 1] = o.y;
    }
    _extrudeRegion(e, r, i, s, o, a, l) {
        let u = new _, c = new _, d = new _, h = new _, f = new N;
        i.forEach((m, g)=>{
            let y = s[g], v = e.verticesStart * i.length + e.verticesCount * g;
            for(let x = 0; x < e.count; x++){
                let S = (e.start + x) * 2;
                if (u.set(r[S + 0], r[S + 1], 0), d.copy(u).applyMatrix4(m).add(y), e.continuous[x]) h.set(e.normals[x * 2 + 0], e.normals[x * 2 + 1], 0);
                else {
                    let w = x === 0 ? (e.start + e.count - 1) * 2 : S - 2;
                    c.set(r[w + 0], r[w + 1], 0), h.copy(u).sub(c), h.set(-h.y, h.x, 0), e.isHole || h.negate();
                }
                if (h.applyMatrix4(m).normalize(), f.set(x === 0 ? 1 : x / e.count, g / (i.length - 1)), this._insertVertex(o, v, d, h, f), v++, !e.continuous[x] || x === 0) {
                    if (x === 0) h.set(e.normals[x * 2 + 0], e.normals[x * 2 + 1], 0), f.set(0, g / (i.length - 1));
                    else {
                        let w = x === e.count - 1 ? e.start * 2 : S + 2;
                        c.set(r[w + 0], r[w + 1], 0), h.copy(c).sub(u), h.set(-h.y, h.x, 0), e.isHole || h.negate();
                    }
                    h.applyMatrix4(m).normalize(), this._insertVertex(o, v, d, h, f), v++;
                }
            }
        });
        let p = i.length - 1;
        for(let m = 0; m < p; m++){
            let g = e.verticesStart * i.length + e.verticesCount * m, y = e.verticesStart * i.length + e.verticesCount * (m + 1), v = 0;
            for(let x = 0; x < e.count; x++){
                (!e.continuous[x] || x === 0) && v++;
                let S = x === e.count - 1 ? 0 : v + 1, w = g + v, A = g + S, E = y + S, b = y + v;
                e.isHole ? a.push(w, E, A, w, b, E) : a.push(w, A, E, w, E, b), v++;
            }
        }
    }
    _closeEnd(e, r, i, s, o, a, l) {
        let u = e.vertexCount, c = new _(0, 0, l ? -1 : 1).applyMatrix4(o), d = new _, h = new N;
        for(let p = 0; p < u; p++){
            let m = 2 * p;
            d.set(e.vertices[m + 0], e.vertices[m + 1], 0).applyMatrix4(o).add(a), this._insertVertex(s, r + p, d, c, h);
        }
        let f = e.elements;
        for(let p = 0; p < e.elementCount; p++){
            let m = 3 * p, g = f[m + 0] + r, y = f[m + (l ? 1 : 2)] + r, v = f[m + (l ? 2 : 1)] + r;
            i.push(g, y, v);
        }
    }
    applyMatrix4OnRange(e, r, i) {
        let s = e.elements, o = new Qt().getNormalMatrix(e).elements, a, l, u, c, d = this.attributes.position, h = this.attributes.normal;
        if (!d || !h) return;
        let f = d.array, p = h.array, m = d.itemSize;
        for(let g = r * m, y = i * m; g < y; g += m){
            if (g === r) debugger;
            a = f[g + 0], l = f[g + 1], u = f[g + 2], c = 1 / (s[3] * a + s[7] * l + s[11] * u + s[15]), f[g + 0] = (s[0] * a + s[4] * l + s[8] * u + s[12]) * c, f[g + 1] = (s[1] * a + s[5] * l + s[9] * u + s[13]) * c, f[g + 2] = (s[2] * a + s[6] * l + s[10] * u + s[14]) * c, a = p[g + 0], l = p[g + 1], u = p[g + 2], p[g + 0] = o[0] * a + o[3] * l + o[6] * u, p[g + 1] = o[1] * a + o[4] * l + o[7] * u, p[g + 2] = o[2] * a + o[5] * l + o[8] * u;
        }
        d.needsUpdate = !0, h.needsUpdate = !0;
    }
    reverseIndicesOnRange(e, r) {
        let i = this.index;
        if (i) {
            for(let s = e; s < r; s += 3){
                let o = i.getX(s), a = i.getX(s + 1), l = i.getX(s + 2);
                i.setXYZ(s, l, a, o);
            }
            i.needsUpdate = !0;
        }
    }
};
function fI() {
    let n1 = new we;
    return n1.setAttribute("position", new Ge(new Float32Array([]), 3)), n1.setIndex(new Ge(new Uint16Array([]), 1)), n1;
}
var _Y = fI().attributes, EY = 12, TY = 1, Th = class extends we {
    constructor(e, r){
        super();
        this.charWidths = [];
        this.charCoords = [];
        this.wrappedText = [];
        this.isLowResolution = !1;
        this.vectorShapes = [];
        Object.assign(this.attributes, _Y), this.userData = {
            parameters: e,
            type: "TextGeometry"
        };
        let i = r.getFont(e.font);
        i?.isLoaded ? (this.font = i, this.update(e)) : this.updateFont(e.font, r).then(()=>{
            this.update(e), r?.requestRender();
        });
    }
    async updateFont(e, r) {
        let i = r.getFont(e);
        i && (this.font = i, await i.loadingPromise);
    }
    update(e) {
        let r = this.font;
        if (this.userData = {
            parameters: e,
            type: "TextGeometry"
        }, !r?.isLoaded) {
            console.warn("Cannot update text because its font is not loaded");
            return;
        }
        let { width: i, height: s, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l, text: u, textTransform: c } = e, d = Fi.getDisplayedValue(u), h = c === 2 ? d.toUpperCase() : c === 3 ? d.toLowerCase() : d, f = MY(e, r, h), { shapes: p, charWidths: m, charCoords: g } = r.generateShapes(f, e), y = (typeof i == "number" ? i : 1) * .5, v = (typeof s == "number" ? s : 1) * .5, x = p.map((A)=>new kt().fromShape(A, !0));
        this.vectorShapes = x;
        let S = x.map((A)=>Dn.create({
                shape: A,
                parameters: {
                    depth: o,
                    extrudeBevelSegments: l,
                    extrudeBevelSize: a,
                    windingRule: o <= 0 ? Mt.NONZERO : Mt.ODD,
                    subdivisions: this.isLowResolution && o > 0 ? TY : EY
                }
            })), w = S.length ? Vs(S) : fI();
        w.translate(-y, v, 0), this.dispose(), this.wrappedText = f, this.charCoords = g, this.charWidths = m, this.deleteAttribute("extrudeNormal"), Object.entries(w.attributes).forEach(([A, E])=>{
            this.setAttribute(A, E);
        }), this.setIndex(w.index), this.computeBoundingSphere();
    }
    clone() {
        let e = pn(new we, Th.prototype);
        return e.copy(this), console.log("CloneGeometry", this, e), e;
    }
    copy(e) {
        return Object.entries(e.attributes).forEach(([r, i])=>{
            this.setAttribute(r, i);
        }), this.setIndex(e.index), this.userData = {
            parameters: {
                ...e.userData.parameters
            },
            type: "TextGeometry"
        }, this;
    }
    async setText(e) {
        this.font && await this.font.loadingPromise, await this.update({
            ...this.userData.parameters,
            text: e
        });
    }
    get text() {
        return this.userData.parameters.text ?? "";
    }
};
function MY(n1, t, e) {
    let r = [
        ""
    ], i = "";
    for (let s of e)i += s, s === " " || s === `
` ? (r[r.length - 1] += i, i = "", s === `
` && r.push("")) : t.getTextWidth(r[r.length - 1] + i, n1) > n1.width && (r[r.length - 1].length && r.push(""), t.getTextWidth(r[r.length - 1] + i, n1) > n1.width && (i.length === 1 ? (r[r.length - 1] += i, i = "") : (r[r.length - 1] += i.slice(0, -1), i = i[i.length - 1], r.push(""))));
    return r[r.length - 1] += i, r;
}
var mI, D0 = new Promise((n1)=>{
    mI = n1;
}), pI = !1;
var P0;

function gI() {
    if (pI) return;
    if (P0) return P0;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/modelling-wasm@1.0.16/build", i = (parcelRequire("9CTrk")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/process.wasm`).then((u)=>u.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        mI(l), pI = !0;
    }
    return P0 = n1(), P0;
}
var CY = [
    "font"
];
function Ta(n1, t, e, r) {
    let i, s, o;
    n1.type === "PathGeometry" ? (s = JSON.parse(JSON.stringify(n1)), o = [
        [],
        [
            "extrusion"
        ]
    ]) : (s = {
        ...n1
    }, o = [
        []
    ]);
    for (let u of o){
        let c = s;
        for (let d of u)c = c[d];
        for(i in c){
            let d = c[i];
            $w(d) && !CY.includes(i) && (c[i] = t.getVariable(d, [
                r.uuid,
                "geometry",
                ...u,
                i
            ]), $w(c[i]) && (c[i] = 1));
        }
    }
    let a = {
        parameters: s,
        type: s.type
    };
    if (s.type === "PathGeometry") a.path = s.path;
    else if (s.type === "VectorGeometry") {
        let u = kt.createFromState(s.shape, s.width, s.height);
        a.shape = u;
    } else if (s.type === "NonParametricGeometry") s.data.groups && s.data.groups?.forEach((u)=>u.materialIndex = Math.max(u.materialIndex ?? 0, 0)), a.geometry = new qu().parse(s);
    else if (s.type === "SubdivGeometry") {
        let u = new Kr(s, e);
        return u.data = n1, u;
    } else {
        if (s.type === "TextGeometry") return new Th(s, t);
        if (s.type === "UIGeometry") return Eh.create({
            parameters: {
                width: s.width,
                height: s.height,
                cornerRadius: s.cornerRadius,
                cornerType: s.cornerType
            }
        });
    }
    let l;
    try {
        l = vA(a);
    } catch (u) {
        console.error(u);
    }
    if (!l) {
        let u = kt.createFromState(zd.defaultData(), 100, 100);
        a.shape = u, l = vA(a);
    }
    return l;
}
var PY = new te;
function fm(n1, t, e, r) {
    let i = n1.position.array, s = n1.normal.array, o = PY.makeScale(t, e, r).invert().elements, a, l, u;
    for(var c = 0, d = i.length; c < d; c += 3)i[c] *= t, i[c + 1] *= e, i[c + 2] *= r, a = s[c], l = s[c + 1], u = s[c + 2], s[c] = o[0] * a + o[4] * l + o[8] * u, s[c + 1] = o[1] * a + o[5] * l + o[9] * u, s[c + 2] = o[2] * a + o[6] * l + o[10] * u;
    n1.position.needsUpdate = !0, n1.normal.needsUpdate = !0;
}
var O0 = new Bt, Mh = new _, it;
D0.then((n1)=>{
    it = n1;
});
var yI = new Float32Array([
    10,
    10,
    0,
    -10,
    10,
    0,
    -10,
    -10,
    0,
    10,
    -10,
    0
]), vI = new Uint32Array([
    0,
    1,
    2,
    3
]), xI = new Uint8Array([
    4
]), Kr = class extends we {
    constructor(e, r){
        super();
        this.data = e;
        this.flatShading = r;
        this.subdivPointer = 0;
        this.rebuild(), this.freeSubdivPointer();
    }
    mutateDirectlyScaleBaked(e, r) {
        this.freeSubdivPointer();
        let i = this.data.scaleBaked, s = bo.div(r, i);
        this.subdividedGeometry && fm(this.subdividedGeometry.attributes, ...s), this.originalGeometry && fm(this.originalGeometry.attributes, ...s), this.data = e;
        let o = this.userData.parameters;
        this.userData.parameters = {
            width: o.width * s[0],
            height: o.height * s[1],
            depth: o.depth * s[2]
        }, this.originalGeometry.boundingSphere.center.multiply(Mh.fromArray(s));
        let a = Mh.set(o.width, o.height, o.depth).length();
        this.originalGeometry.boundingSphere.radius = a / 2;
    }
    ensureSubdivPointer() {
        return this.subdivPointer === 0 && this.rebuild(), this.subdivPointer;
    }
    rebuild() {
        let e, r, i;
        try {
            ({ originalGeometry: e, subdividedGeometry: r, subdivPointer: i } = Kr.build(this.data, void 0, !this.flatShading, void 0));
        } catch  {
            e = new li(100, 100, 100), i = 0;
        }
        this.subdivPointer = i, this.originalGeometry = e, this.subdividedGeometry = r ?? void 0;
        let s = this.subdividedGeometry ?? this.originalGeometry;
        Object.assign(this, s), this.calcBoundingBox();
    }
    freeSubdivPointer() {
        this.subdivPointer && (Kr.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0);
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Er, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        O0.setFromBufferAttribute(r), O0.getCenter(i), e.boundingSphere.radius = i.distanceTo(O0.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), O0.getSize(Mh);
        let s = {
            width: Mh.x,
            height: Mh.y,
            depth: Mh.z
        };
        return this.userData.parameters = s, s;
    }
    static build(e, r, i, s) {
        let o, a, l, u = e?.phongAngle ?? 35;
        i === !1 && (u = -1), r && (it.free_bvh(r), it.free_subdivision_surface(r));
        try {
            o = Kr.allocate(e, s);
        } catch (c) {
            console.error(c, e), o = Kr.allocate({
                positionWASM: yI,
                indexWASM: vI,
                verticesPerFaceWASM: xI
            }, s);
        }
        if (it.set_destination_refinement_level(o, 0), a = Kr.buildLevel(o, !0, u), e.subdivisions > 0) try {
            it.set_destination_refinement_level(o, e.subdivisions), l = Kr.buildLevel(o, !1, u);
        } catch  {
            try {
                it.set_destination_refinement_level(o, e.subdivisions - 1), l = Kr.buildLevel(o, !1, u);
            } catch  {
                l = null;
            }
        }
        else l = null;
        return {
            subdivPointer: o,
            originalGeometry: a,
            subdividedGeometry: l
        };
    }
    static primitiveToQuads(e, r, i) {
        e.widthSegments > 16 && (e.widthSegments = 16), e.heightSegments > 16 && (e.heightSegments = 16), e.depthSegments > 16 && (e.depthSegments = 16), e.radialSegments > 16 && (e.radialSegments = 16), e.type === "DodecahedronGeometry" && (e.detail = 0);
        let s = e.shape !== void 0 || e.path !== void 0 ? r.geometry : Ta(e, i, !1), o;
        e.type === "TorusGeometry" && e.arc === Math.PI * 2 ? o = s.getClosedTorusIndicesForBooleanOrSubdiv() : o = s.getIndex();
        let a, l, u, c;
        ({ positions: a, triIndices: c } = Fc(s.getAttribute("position"), o));
        let d;
        if (e.type === "CylinderGeometry" && e.cornerRadius === 0 && e.hollow === 0 && e.openEnded === !1) {
            let h = e.radialSegments * e.heightSegments * 6, f = h + e.radialSegments * 3;
            d = [
                h,
                f
            ];
        }
        return { indices: l, verticesPerFace: u } = wA(a, c, s, d), {
            positions: a,
            indices: l,
            verticesPerFace: u
        };
    }
    static allocate(e, r) {
        let i, s, o, a = [], l = [];
        e.positionWASM && e.positionWASM.length > 0 ? (i = e.positionWASM, s = e.indexWASM, o = e.verticesPerFaceWASM) : (i = yI, s = vI, o = xI);
        let u = i.length, c = s.length, d = o.length, h = i.length + a.length + l.length, f = s.length + o.length, p = h * Float32Array.BYTES_PER_ELEMENT + f * Uint32Array.BYTES_PER_ELEMENT, m = h * Float32Array.BYTES_PER_ELEMENT, g = f * Uint32Array.BYTES_PER_ELEMENT, y = it._malloc(p), v = new Float32Array(it.HEAPF32.buffer, y, h), x = new Uint32Array(it.HEAPU32.buffer, y + m, f);
        v.set(i, 0), v.set(a, i.length), v.set(l, i.length + a.length), x.set(s, 0), x.set(o, s.length);
        let S;
        e?.scaleBaked?.some((A)=>A !== 1) && (S = new te().makeScale(...e.scaleBaked)), r && (S ? S.premultiply(r) : S = r);
        let w = S ? it.alloc_subdivision_surface2(y, u, y + m, c, y + m + s.length * Uint32Array.BYTES_PER_ELEMENT, d, S.elements) : it.alloc_subdivision_surface(y, u, y + m, c, y + m + s.length * Uint32Array.BYTES_PER_ELEMENT, d);
        return it._free(y), w;
    }
    static buildLevel(e, r, i, s, o) {
        let a = o ? it.get_mesh_data2(e, r ? it.Level.CONTROL : it.Level.REFINED, i, o.elements) : it.get_mesh_data(e, r ? it.Level.CONTROL : it.Level.REFINED, i), l = 8, u = it.HEAPU32.subarray(a >> 2, (a >> 2) + l), c = u.subarray(4, 8), d = 0, h = it.HEAPU32[u[d] >> 2], f = it.HEAPF32.subarray(h >> 2, (h >> 2) + c[d]);
        d++;
        let p = it.HEAPU32[u[d] >> 2], m = it.HEAPF32.subarray(p >> 2, (p >> 2) + c[d]);
        d++;
        let g = it.HEAPU32[u[d] >> 2], y = it.HEAPU32.subarray(g >> 2, (g >> 2) + c[d]);
        d++;
        let v = it.HEAPU32[u[d] >> 2], x = it.HEAPU32.subarray(v >> 2, (v >> 2) + c[d]);
        if (d++, s === void 0) {
            let S = new we;
            if (S.setIndex(new co(x, 1)), S.setAttribute("position", new be(f, 3)), S.setAttribute("normal", new be(m, 3)), r) {
                S.setAttribute("faceMap", new co(y, 1));
                let w = new Float32Array(m.length / 3 * 4).fill(0);
                S.setAttribute("color", new Ge(w, 4));
            }
            return it.free_mesh_data(a), S.userData.type = "SubdivGeometry", S;
        }
        s.getAttribute("position").copyArray(f), s.getAttribute("normal").copyArray(m), s.attributes.position.needsUpdate = !0, s.attributes.normal.needsUpdate = !0, it.free_mesh_data(a);
    }
    static freeSubdivPointer(e) {
        it.free_bvh(e), it.free_subdivision_surface(e);
    }
    static buildControlCageWireframe(e, r, i) {
        let s = it.get_wireframe_data_for_base_level(e), o = 4, a = it.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 4), u = 0, c = it.HEAPU32[a[u] >> 2], d = it.HEAPF32.subarray(c >> 2, (c >> 2) + l[u]);
        u++;
        let h = it.HEAPU32[a[u] >> 2], f = it.HEAPU32.subarray(h >> 2, (h >> 2) + l[u]);
        if (r === void 0) {
            let p = new we;
            p.setAttribute("position", new be(d, 3));
            let m = new Float32Array(d.length);
            for(let g = 0, y = d.length; g < y;)m[g++] = i.r, m[g++] = i.g, m[g++] = i.b;
            return p.setAttribute("color", new Ge(m, 3)), p.setIndex(new co(f, 1)), it.free_wireframe_data_for_base_level(s), p;
        }
        r.getAttribute("position").copyArray(d), r.attributes.position.needsUpdate = !0, it.free_wireframe_data_for_base_level(s);
    }
    static updateCollabMesh(e, r, i) {
        let s = r === 0;
        s || it.set_destination_refinement_level(e, r);
        let o = i ? it.get_topological_data2(e, s ? it.Level.CONTROL : it.Level.REFINED, i.elements) : it.get_topological_data(e, s ? it.Level.CONTROL : it.Level.REFINED), a = 6, l = it.HEAPU32.subarray(o >> 2, (o >> 2) + a), u = l.subarray(3, 6), c = 0, d = it.HEAPU32[l[c] >> 2], h = new Float32Array(it.HEAPF32.subarray(d >> 2, (d >> 2) + u[c]));
        c++;
        let f = it.HEAPU32[l[c] >> 2], p = new Uint32Array(it.HEAPU32.subarray(f >> 2, (f >> 2) + u[c]));
        c++;
        let m = it.HEAPU32[l[c] >> 2], g = new Uint8Array(it.HEAPU32.subarray(m >> 2, (m >> 2) + u[c]));
        return it.free_topological_data(o), {
            positions: h,
            indices: p,
            verticesPerFace: g
        };
    }
};
var bI = [
    "getX",
    "getY",
    "getZ"
];
function Fc(n1, t) {
    let e = {}, r = t ? t.count : n1.count, i = 0, s = [], o = [], a = 1e4;
    for(let u = 0; u < r; u++){
        let c = t ? t.getX(u) : u, d = "";
        for(let h = 0; h < 3; h++)d += `${~~(n1[bI[h]](c) * a)},`;
        if (d in e) s.push(e[d]);
        else {
            for(let h = 0; h < 3; h++)o.push(n1[bI[h]](c));
            e[d] = i, s.push(i), i++;
        }
    }
    let l = [];
    for(let u = 0; u < s.length; u += 3)s[u] === s[u + 1] || s[u] === s[u + 2] || s[u + 1] === s[u + 2] || l.push(s[u], s[u + 1], s[u + 2]);
    return {
        positions: o,
        triIndices: l
    };
}
var I0 = new _, xA = new _, bA = new _, SA = new _;
function wA(n1, t, e, r) {
    let i = [], s = [];
    if (e.userData.shape !== void 0 && e.userData.parameters.depth === 0 && e.userData.shape.shapeHoles.length === 0) {
        let l = e.userData.shape.extractShapePointsToFlatArray([]), u = e.userData.parameters.spikes;
        if (e.userData.type === "EllipseGeometry" && u <= 24 && u % 4 === 0 && e.userData.parameters.angle >= 360) {
            let h = l.length / 2 / u;
            l = l.filter((f, p)=>Math.floor(p / 2) % h === 0);
        }
        let c = 0;
        for(let h = 0; h < l.length; h += 2)c += (l[h] - l[(h === 0 ? l.length : h) - 2]) * (l[h + 1] + l[(h === 0 ? l.length : h) - 1]);
        n1.length = 0;
        let d = 0;
        if (c < 0) for(let h = 0; h < l.length; h += 2)n1.push(l[h], l[h + 1], 0), i.push(d++);
        else for(let h = l.length - 2; h >= 0; h -= 2)n1.push(l[h], l[h + 1], 0), i.push(d++);
        return s.push(d), {
            indices: i,
            verticesPerFace: s
        };
    }
    let o = new Float32Array([
        e.userData.parameters.depth
    ])[0], a = 0;
    for(; a < t.length;){
        if (e.useNgonForTopBottomFaceDuringBake) {
            let l = 0;
            if ((n1[t[a] * 3 + 2] === o || n1[t[a] * 3 + 2] === 0) && l++, (n1[t[a + 1] * 3 + 2] === o || n1[t[a + 1] * 3 + 2] === 0) && l++, (n1[t[a + 2] * 3 + 2] === o || n1[t[a + 2] * 3 + 2] === 0) && l++, l === 3) break;
        }
        if (t[a + 1] === t[a + 3] && t[a + 2] === t[a + 5] || t[a + 0] === t[a + 3] && t[a + 2] === t[a + 4]) {
            I0.set(n1[t[a] * 3], n1[t[a] * 3 + 1], n1[t[a] * 3 + 2]), xA.set(n1[t[a + 1] * 3], n1[t[a + 1] * 3 + 1], n1[t[a + 1] * 3 + 2]), bA.set(n1[t[a + 4] * 3], n1[t[a + 4] * 3 + 1], n1[t[a + 4] * 3 + 2]), SA.set(n1[t[a + 5] * 3], n1[t[a + 5] * 3 + 1], n1[t[a + 5] * 3 + 2]), xA.sub(I0).normalize(), bA.sub(I0).normalize(), SA.sub(I0).normalize();
            let l = xA.cross(bA).dot(SA);
            Math.abs(l) > .005 || r && r.some((u, c)=>c % 2 === 1 ? !1 : a >= r[c] && a < r[c + 1]) ? (i.push(t[a], t[a + 1], t[a + 2]), s.push(3), a += 3) : (i.push(t[a], t[a + 1], t[a + 4], t[a + 5]), s.push(4), a += 6);
        } else i.push(t[a], t[a + 1], t[a + 2]), s.push(3), a += 3;
    }
    if (e.useNgonForTopBottomFaceDuringBake) {
        let l = [], u = [], c = 0;
        for(let d = 0, h = 0; d < n1.length; d += 3, h++)n1[d + 2] === 0 && (l.push(h), c++), n1[d + 2] === o && u.push(h);
        if (e.userData.parameters.extrudeBevelSize === 0) {
            let d = u[0];
            u[0] = u[1], u[1] = d;
        }
        l.reverse(), i.push(...l, ...u), s.push(c, c);
    }
    return {
        indices: i,
        verticesPerFace: s
    };
}
var ps = {};
FN(ps, {
    calcBoolean: ()=>IY,
    calcBooleanTopological: ()=>OY,
    freeMeshSet: ()=>NY,
    getMeshSet: ()=>RY,
    hasOpenEdges: ()=>LY,
    transformMeshSet: ()=>BY
});
var SI, wI = new Promise((n1)=>{
    SI = n1;
});
var R0;

function AI() {
    if (R0) return R0;
    async function n1() {
        let e = "https://unpkg.com/@splinetool/boolean-wasm@1.0.16/build", i = (parcelRequire("1Jpra")), [s, o] = await Promise.all([
            i,
            fetch(`${e}/boolean.wasm`).then((u)=>u.arrayBuffer())
        ]), a = s.default, l = await a({
            wasmBinary: o
        });
        SI(l);
    }
    return R0 = n1(), R0;
}
var gt, Ch;
wI.then((n1)=>gt = n1);
function DY(n1, t, e) {
    let r, i;
    n1.userData.parameters.type === "TorusGeometry" && n1.userData.parameters.arc === Math.PI * 2 ? i = n1.getClosedTorusIndicesForBooleanOrSubdiv() : i = n1.getIndex();
    let { positions: s, triIndices: o } = Fc(n1.getAttribute("position"), i), a;
    if (t && e) {
        let { indices: l, verticesPerFace: u } = wA(s, o, n1);
        a = u.length, r = [];
        for(let c = 0, d = 0; c < a; c++){
            r.push(u[c]);
            for(let h = 0; h < u[c]; h++)r.push(l[d++]);
        }
    } else {
        let l = o.length;
        r = Array(l + l / 3), a = 0;
        for(let u = 0, c = 0; c < r.length;)r[c++] = 3, a++, r[c++] = o[u++], r[c++] = o[u++], r[c++] = o[u++];
    }
    return {
        positions: s,
        faceIndices: r,
        nFaces: a
    };
}
function _I(n1) {
    let t = n1.length, e = t * Uint32Array.BYTES_PER_ELEMENT, r = t * Float32Array.BYTES_PER_ELEMENT, i = Number.isInteger(n1[0]) ? e : r, s = gt._malloc(i);
    return (Number.isInteger(n1[0]) ? new Uint32Array(gt.HEAPU32.buffer, s, t) : new Float32Array(gt.HEAPF32.buffer, s, t)).set(n1, 0), s;
}
function EI(n1) {
    switch(n1){
        case 0:
            return gt.OP.UNION;
        case 1:
            return gt.OP.INTERSECTION;
        case 2:
            return gt.OP.A_MINUS_B;
        case 3:
            return gt.OP.B_MINUS_A;
        case 4:
            return gt.OP.SYMMETRIC_DIFFERENCE;
        case 5:
            return gt.OP.ALL;
        default:
            throw new Error("Unknown boolean operation " + n1);
    }
}
function OY(n1, t) {
    Ch === void 0 && (Ch = gt.init_csg());
    let e = _I(n1), r = gt.csg_calc_topological(Ch, e, n1.length, EI(t));
    gt._free(e);
    let i = 6, s = gt.HEAPU32.subarray(r >> 2, (r >> 2) + i), o = s.subarray(3, 6), a = 0, l = gt.HEAPU32[s[a] >> 2], u = new Float32Array(gt.HEAPF32.subarray(l >> 2, (l >> 2) + o[a]));
    a++;
    let c = gt.HEAPU32[s[a] >> 2], d = new Uint32Array(gt.HEAPU32.subarray(c >> 2, (c >> 2) + o[a]));
    a++;
    let h = gt.HEAPU32[s[a] >> 2], f = new Uint8Array(gt.HEAPU32.subarray(h >> 2, (h >> 2) + o[a]));
    return gt.free_mesh_data(r), {
        positions: u,
        indices: d,
        verticesPerFace: f
    };
}
function IY(n1, t, e, r) {
    Ch === void 0 && (Ch = gt.init_csg());
    let i = _I(n1), s = gt.csg_calc(Ch, i, n1.length, r, EI(t));
    gt._free(i);
    let o = 5, a = gt.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 5), u = 0, c = gt.HEAPU32[a[u] >> 2], d = gt.HEAPF32.subarray(c >> 2, (c >> 2) + l[u]);
    u++;
    let h = gt.HEAPU32[a[u] >> 2], f = gt.HEAPF32.subarray(h >> 2, (h >> 2) + l[u]);
    u++;
    let p = l[u];
    e.setAttribute("position", new be(d, 3)), e.setAttribute("normal", new be(f, 3));
    let m = gt.HEAPF32.subarray((s >> 2) + 5, (s >> 2) + 5 + 6);
    return e.boundingSphere === null && (e.boundingSphere = new Er), e.boundingSphere.radius = -1, e.userData.parameters = {
        width: m[3] * 2,
        height: m[4] * 2,
        depth: m[5] * 2
    }, gt.free_mesh_data(s), p;
}
function RY(n1, t, e) {
    if (gt === void 0) return -1;
    let r, i, s;
    if (t && n1.userData.positions !== void 0) {
        let y = n1.userData;
        s = y.verticesPerFace.length, r = y.positions, i = Array(y.verticesPerFace.reduce((v, x)=>v + x, 0) + s);
        for(let v = 0, x = 0, S = 0; v < y.verticesPerFace.length; v++){
            i[S++] = y.verticesPerFace[v];
            for(let w = 0; w < y.verticesPerFace[v]; w++)i[S++] = y.indices[x++];
        }
    } else ({ positions: r, faceIndices: i, nFaces: s } = DY(n1, t, e));
    let o = r.length, a = i.length, l = r.length, u = i.length, c = l * Float32Array.BYTES_PER_ELEMENT + u * Uint32Array.BYTES_PER_ELEMENT, d = l * Float32Array.BYTES_PER_ELEMENT, h = u * Uint32Array.BYTES_PER_ELEMENT, f = gt._malloc(c), p = new Float32Array(gt.HEAPF32.buffer, f, l), m = new Uint32Array(gt.HEAPU32.buffer, f + d, u);
    p.set(r, 0), m.set(i, 0);
    let g = gt.get_csg_mesh(f, o, f + d, a, s);
    return gt._free(f), g;
}
function LY(n1) {
    return gt.has_open_edges(n1);
}
function BY(n1, t) {
    gt.transform_csg_mesh(n1, t.elements);
}
function NY(n1) {
    gt.free_csg_mesh(n1);
}
var FY = {
    ConeGeometry: xO,
    CubeGeometry: bO,
    CylinderGeometry: m0,
    DodecahedronGeometry: SO,
    EllipseGeometry: wh,
    HelixGeometry: KO,
    IcosahedronGeometry: ZO,
    LatheGeometry: JO,
    NonParametricGeometry: rI,
    PolygonGeometry: T0,
    PyramidGeometry: iI,
    RectangleGeometry: Eh,
    SphereGeometry: nI,
    PlaneGeometry: sI,
    BackdropGeometry: oI,
    StarGeometry: M0,
    TextFrameGeometry: aI,
    TorusGeometry: lI,
    TorusKnotGeometry: cI,
    TriangleGeometry: uI,
    PathGeometry: hI,
    VectorGeometry: Dn
}, vA = (n1)=>FY[n1.type].create(n1);
function Ph(n1) {
    return n1 !== null && "booleanOp" in n1;
}
var Dh = class extends ph(rr) {
    constructor(){
        super(...arguments);
        this.booleanMeshSetAddress = -1;
        this.booleanWasTransformed = !1;
        this.booleanMatrixInvOld = new te;
    }
    updateVisible(e) {
        super.updateVisible(e), this.visible = !Ph(this.parent) && this.visible, Ph(this.parent) && this.parent.invalidateDownstreamBooleanData();
    }
    freeBooleanPointer() {
        this.booleanMeshSetAddress !== -1 && (ps.freeMeshSet(this.booleanMeshSetAddress), this.booleanMeshSetAddress = -1);
    }
    invalidateDownstreamBooleanData(e = !1) {
        return e ? this.booleanWasTransformed = !0 : this.freeBooleanPointer(), Ph(this.parent) ? this.parent.invalidateDownstreamBooleanData() : this;
    }
    invalidateUpstreamBooleanData() {
        this.freeBooleanPointer();
        for (let e of this.children)e instanceof Dh && (e.freeBooleanPointer(), Ph(e) && e.invalidateUpstreamBooleanData());
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return i && Ph(this.parent) && this.invalidateDownstreamBooleanData(!0), i;
    }
    onVariableUpdate(e = !1) {
        super.onVariableUpdate(e), Ph(this.parent) && this.invalidateDownstreamBooleanData(!0);
    }
};
var L0 = new Bt;
function pm(n1, t = 0, e = n1.count, r, i) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, u = -1 / 0, c = -1 / 0;
    for(let d = t; d < e; d++){
        let h = n1.getX(d), f = n1.getY(d), p = n1.getZ(d);
        h < s && (s = h), f < o && (o = f), p < a && (a = p), h > l && (l = h), f > u && (u = f), p > c && (c = p);
    }
    L0.min.set(s, o, a), L0.max.set(l, u, c), L0.getCenter(r), L0.getSize(i).multiplyScalar(.5);
}
var kY = new we, zY = new Ls, nr = class extends Dh {
    constructor(t, e){
        super(kY, zY), this.super_Entity(t, e);
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? pm(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var mm = class {
    constructor(t){
        t = t ?? {}, this.name = t.name, this.type = t.type, this.node = t.node, this.size = t.size, this.needsUpdate = t.needsUpdate;
    }
    get value() {
        return this.node.value;
    }
    set value(t) {
        this.node.value = t;
    }
};
var ki = class {
    constructor(t){
        this.hashProperties = void 0;
        this.isNode = !0;
        this.shortcuts = {};
        this.uuid = Se.generateUUID(), this.type = t, this.name = "";
    }
    analyze(t, e) {
        e = e ?? {}, t.analyzing = !0, this.build(t.addFlow(e.slot, e.cache, e.context), "v4"), t.clearVertexNodeCode(), t.clearFragmentNodeCode(), t.removeFlow(), t.analyzing = !1;
    }
    analyzeAndFlow(t, e, r) {
        return r = r ?? {}, this.analyze(t, r), this.flow(t, e, r);
    }
    flow(t, e, r) {
        r = r ?? {}, t.addFlow(r.slot, r.cache, r.context);
        let i = {
            result: this.build(t, e),
            code: t.clearNodeCode(),
            extra: t.context.extra
        };
        return t.removeFlow(), i;
    }
    build(t, e, r) {
        e = e ?? this.getType(t, e);
        let i = t.getNodeData(r ?? this);
        return t.analyzing && this.appendDepsNode(t, i, e), t.nodes.indexOf(this) === -1 && t.nodes.push(this), this.updateFrame !== void 0 && t.updaters.indexOf(this) === -1 && t.updaters.push(this), this.generate(t, e, r);
    }
    updateFrame(t) {}
    generateReadonly(t, e, r, i, s, o) {
        return "";
    }
    generate(t, e, r, i, s) {
        return "";
    }
    parse(t, e, r, i) {}
    appendDepsNode(t, e, r) {
        e.deps = (e.deps || 0) + 1;
        let i = t.getTypeLength(r);
        (i > (e.outputMax || 0) || this.getType(t, r)) && (e.outputMax = i, e.output = r);
    }
    setName(t) {
        this.name = t;
    }
    getName() {
        return this.name;
    }
    getType(t, e) {
        return e === "sampler2D" || e === "samplerCube" ? e : this.type;
    }
    getHash() {
        let t = "{", e, r;
        for(e in this)r = this[e], r instanceof ki && (t += '"' + e + '":' + r.getHash() + ",");
        if (this.hashProperties) for(let i = 0; i < this.hashProperties.length; i++)e = this.hashProperties[i], r = this[e], t += '"' + e + '":"' + String(r) + '",';
        return t += '"id":"' + this.uuid + '"}', t;
    }
};
var AA = class {
    constructor(){
        this.nodes = {};
        this.keywords = {};
    }
    add(t) {
        this.nodes[t.name] = t;
    }
    addKeyword(t, e, r) {
        r = r !== void 0 ? r : !0, this.keywords[t] = {
            callback: e,
            cache: r
        };
    }
    remove(t) {
        delete this.nodes[t.name];
    }
    removeKeyword(t) {
        delete this.keywords[t];
    }
    get(t) {
        return this.nodes[t];
    }
    getKeyword(t, e) {
        return this.keywords[t].callback(e);
    }
    getKeywordData(t) {
        return this.keywords[t];
    }
    contains(t) {
        return this.nodes[t] !== void 0;
    }
    containsKeyword(t) {
        return this.keywords[t] !== void 0;
    }
}, _i = new AA;
var Xe = class extends ki {
    constructor(e, r){
        super(e);
        this.scope = "";
        r = r ?? {}, this.shared = r.shared !== void 0 ? r.shared : !0, this.unique = r.unique !== void 0 ? r.unique : !1;
    }
    build(e, r, i, s) {
        if (r = r ?? this.getType(e), this.getShared(e, r)) {
            let o = this.getUnique(e, r);
            o && this.uuid === void 0 && (this.uuid = Se.generateUUID()), i = e.getUUID(i ?? this.getUUID(), !o);
            let a = e.getNodeData(i), l = a.output || this.getType(e);
            if (e.analyzing) return (a.deps || 0) > 0 || this.getLabel() ? (this.appendDepsNode(e, a, r), this.generate(e, r, i)) : super.build(e, r, i);
            if (o) return a.name = a.name || super.build(e, r, i), a.name;
            if (!this.getLabel() && (!this.getShared(e, l) || e.context.ignoreCache || a.deps === 1)) return super.build(e, r, i);
            i = this.getUUID(!1);
            let u = this.getTemp(e, i);
            if (u) return e.format(u, l, r);
            {
                u = super.generate(e, r, i, a.output, s);
                let c = this.generate(e, l, i);
                return e.addNodeCode(u + " = " + c + ";"), e.format(u, l, r);
            }
        }
        return super.build(e, r, i);
    }
    getShared(e, r) {
        return r !== "sampler2D" && r !== "samplerCube" && this.shared;
    }
    getUnique(e, r) {
        return this.unique;
    }
    setLabel(e) {
        return this.label = e, this;
    }
    getLabel() {
        return this.label;
    }
    getUUID(e) {
        let r = this.uuid;
        return typeof this.scope == "string" && (r = this.scope + "-" + r), r;
    }
    getTemp(e, r) {
        r = r || this.uuid;
        let i = e.getVars()[r];
        return i ? i.name : void 0;
    }
    generate(e, r, i, s, o) {
        return this.getShared(e, r) || console.error("TempNode is not shared"), i = i ?? this.uuid, e.getTempVar(i, s ?? this.getType(e), o, this.getLabel()).name;
    }
};
var Jt = class extends Xe {
    constructor(e, r){
        r = r ?? {}, r.shared = r.shared !== void 0 ? r.shared : !1;
        super(e, r);
        this.readonly = !1;
    }
    setReadonly(e) {
        return this.readonly = e, this.hashProperties = this.readonly ? [
            "value"
        ] : void 0, this;
    }
    getReadonly() {
        return this.readonly;
    }
    generate(e, r, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i);
        return this.getReadonly() && this.generateReadonly !== void 0 ? this.generateReadonly(e, r, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, r));
    }
};
var Lr = class extends Jt {
    constructor(e = 0, r){
        super("v2");
        this.nodeType = "Vector2";
        this.value = e instanceof N ? e : new N(e, r);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec2(" + this.value.x + ", " + this.value.y + ")", s, r);
    }
};
var Xi = class extends Jt {
    constructor(e = 0, r, i){
        super("v3");
        this.nodeType = "Vector3";
        this.value = e instanceof _ ? e : new _(e, r, i);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    get z() {
        return this.value.z;
    }
    set z(e) {
        this.value.z = e;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec3(" + this.value.x + ", " + this.value.y + ", " + this.value.z + ")", s, r);
    }
};
var cr = class extends Le {
    constructor(e, r, i, s){
        super(e, r, i);
        this.isColorA = !0;
        this.a = s;
    }
    setRGBA(e, r, i, s) {
        super.setRGB(e, r, i), this.a = s;
    }
    copy(e) {
        return super.copy(e), this.a = "a" in e ? e.a : 1, this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
    equals(e) {
        return super.equals(e) && this.a === e.a;
    }
    setStyle(e, r = "srgb") {
        let i;
        if (e === "transparent") return this.setRGBA(0, 0, 0, 0), this;
        if (i = /^((?:rgb|hsl)a?)\(([^)]*)\)/.exec(e)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "rgba" ? parseFloat(s[4]) : 1, super.setStyle(e, r);
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "hsla" ? parseFloat(s[4]) : 1, super.setStyle(e, r);
                    break;
            }
        }
        return super.setStyle(e, r);
    }
    get x() {
        return this.r;
    }
    get y() {
        return this.g;
    }
    get z() {
        return this.b;
    }
    get w() {
        return this.a;
    }
    set x(e) {
        this.r = e;
    }
    set y(e) {
        this.g = e;
    }
    set z(e) {
        this.b = e;
    }
    set w(e) {
        this.a = e;
    }
};
var On = class extends Jt {
    constructor(e){
        super("v4");
        this.nodeType = "Vector4";
        this.value = e instanceof cr ? e : new cr(e.r, e.g, e.b, e.a);
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec4(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ", " + this.value.a + ")", s, r);
    }
};
var VY = /^\s*([a-z_0-9]+)\s([a-z_0-9]+)\s*\((.*?)\)/i, TI = /[a-z_0-9]+/gi, ge = class extends Xe {
    constructor(e, r, i, s, o){
        super(o);
        this.src = "";
        this.nodeType = "Function";
        this.useKeywords = !0;
        this.includes = [];
        this.extensions = {};
        this.keywords = {};
        this.isMethod = o === void 0, this.isInterface = !1, this.parse(e, r, i, s);
    }
    getShared(e, r) {
        return !this.isMethod;
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    getInputByName(e) {
        if (this.inputs) {
            let r = this.inputs.length;
            for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
        }
    }
    getIncludeByName(e) {
        if (this.includes) {
            let r = this.includes.length;
            for(; r--;)if (this.includes[r].name === e) return this.includes[r];
        }
    }
    generate(e, r, i, s, o) {
        let a, l = 0, u = this.src;
        if (this.includes) for(let d = 0; d < this.includes.length; d++)e.include(this.includes[d], this);
        for(let d in this.extensions)e.extensions[d] = !0;
        let c = [];
        for(; a = TI.exec(this.src);)c.push(a);
        for(let d = 0; d < c.length; d++){
            let h = c[d], f = h[0], p = this.isMethod ? !this.getInputByName(f) : !0, m = f;
            if (this.keywords[f] || this.useKeywords && p && _i.containsKeyword(f)) {
                let g = this.keywords[f];
                if (!g) {
                    let y = _i.getKeywordData(f);
                    y.cache && (g = e.keywords[f]), g = g || _i.getKeyword(f, e), y.cache && (e.keywords[f] = g);
                }
                m = g.build(e);
            }
            f !== m && u[h.index + l - 1] !== "." && (u = u.substring(0, h.index + l) + m + u.substring(h.index + f.length + l), l += m.length - f.length), this.getIncludeByName(m) === void 0 && _i.contains(m) && e.include(_i.get(m));
        }
        return r === "source" ? u : this.isMethod ? (this.isInterface || e.include(this, void 0, u), this.name) : e.format("( " + u + " )", this.getType(e), r);
    }
    parse(e, r, i, s) {
        if (this.src = e || "", this.includes = r ?? [], this.extensions = i ?? {}, this.keywords = s ?? {}, this.isMethod) {
            let o = VY.exec(this.src);
            if (this.inputs = [], o && o.length == 4) {
                this.type = o[1], this.name = o[2];
                let a = o[3].match(TI);
                if (a) {
                    let l = 0;
                    for(; l < a.length;){
                        let u = a[l++], c;
                        u === "in" || u === "out" || u === "inout" ? c = a[l++] : (c = u, u = "");
                        let d = a[l++];
                        this.inputs.push({
                            name: d,
                            type: c,
                            qualifier: u
                        });
                    }
                }
                this.isInterface = this.src.indexOf("{") === -1;
            } else this.type = "", this.name = "";
        }
    }
};
var UY = /^([a-z_0-9]+)\s([a-z_0-9]+)\s?\=?\s?(.*?)(\;|$)/i, _A = class extends Xe {
    constructor(e = "", r){
        super();
        this.src = "";
        this.useDefine = !1;
        this.nodeType = "Const";
        this.parse(e || _A.PI, void 0, void 0, void 0, r);
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    parse(e, r, i, s, o) {
        this.src = e || "";
        let a, l, u = "", c = UY.exec(e);
        this.useDefine = o ?? this.src.charAt(0) === "#", c && c.length > 1 ? (l = c[1], a = c[2], u = c[3]) : (a = this.src, l = "f"), this.name = a, this.type = l, this.value = u;
    }
    build(e, r) {
        if (r === "source") {
            if (this.value) return this.useDefine ? "#define " + this.name + " " + this.value : "const " + this.type + " " + this.name + " = " + this.value + ";";
            if (this.useDefine) return this.src;
        }
        return e.include(this), e.format(this.name, this.getType(e), r);
    }
    generate(e, r, i, s, o) {
        return e.format(this.name, this.getType(e), r);
    }
}, Ft = _A;
Ft.PI = "PI", Ft.PI2 = "PI2", Ft.RECIPROCAL_PI = "RECIPROCAL_PI", Ft.RECIPROCAL_PI2 = "RECIPROCAL_PI2", Ft.LOG2 = "LOG2", Ft.EPSILON = "EPSILON";
var GY = new RegExp(`^structs*([a-z_0-9]+)s*{s*((.|
)*?)}`, "gim"), jY = new RegExp("s*(w*?)s*(w*?)(=|;)", "gim"), Oh = class extends Xe {
    constructor(e = ""){
        super();
        this.inputs = [];
        this.src = "";
        this.nodeType = "Struct";
        this.parse(e);
    }
    getType(e) {
        return e.getTypeByFormat(this.name);
    }
    getInputByName(e) {
        let r = this.inputs.length;
        for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
    }
    generate(e, r, i, s, o) {
        return r === "source" ? this.src + ";" : e.format("( " + this.src + " )", this.getType(e), r);
    }
    parse(e = "") {
        this.src = e, this.inputs = [];
        let r = GY.exec(e);
        if (r) {
            let i = r[2], s;
            for(; s = jY.exec(i);)this.inputs.push({
                type: s[1],
                name: s[2]
            });
            this.name = r[1];
        } else this.name = "";
        this.type = this.name;
    }
};
var Ih = class extends Xe {
    constructor(e){
        super("v2", {
            shared: !1
        });
        this.nodeType = "UV";
        this.index = e ?? 0;
    }
    generate(e, r) {
        e.requires.uv[this.index] = !0;
        let i = this.index > 0 ? this.index + 1 : "", s = e.isShader("vertex") ? "uv" + i : "vUv" + i;
        return e.format(s, this.getType(e), r);
    }
};
_i.addKeyword("uv", function() {
    return new Ih;
});
_i.addKeyword("uv2", function() {
    return new Ih(1);
});
var kc = class extends Xe {
    constructor(e, r){
        super("v4");
        this.nodeType = "ColorSpace";
        this.input = e, this.method = r ?? kc.LINEAR_TO_LINEAR, this.hashProperties = [
            "method"
        ];
    }
    static getEncodingComponents(e) {
        switch(e){
            case dn:
                return [
                    "Linear"
                ];
            case tt:
                return [
                    "sRGB"
                ];
            default:
                return [];
        }
    }
    generate(e, r) {
        let i = this.input.build(e, "v4"), s = this.getType(e), o = kc.Nodes[this.method], a = e.include(o);
        if (a === kc.LINEAR_TO_LINEAR) return e.format(i, s, r);
        if (o.inputs?.length === 2) {
            let l = this.factor.build(e, "f");
            return e.format(a + "( " + i + ", " + l + " )", s, r);
        } else return e.format(a + "( " + i + " )", s, r);
    }
    fromEncoding(e) {
        let r = kc.getEncodingComponents(e);
        this.method = "LinearTo" + r[0], this.factor = r[1];
    }
    fromDecoding(e) {
        let r = kc.getEncodingComponents(e);
        this.method = r[0] + "ToLinear", this.factor = r[1];
    }
}, vn = kc;
vn.Nodes = {
    LinearToLinear: new ge([
        "vec4 LinearToLinear( in vec4 value ) {",
        "	return value;",
        "}"
    ].join(`
`)),
    sRGBToLinear: new ge([
        "vec4 sRGBToLinear( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );",
        "}"
    ].join(`
`)),
    LinearTosRGB: new ge([
        "vec4 LinearTosRGB( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );",
        "}"
    ].join(`
`))
}, vn.LINEAR_TO_LINEAR = "LinearToLinear", vn.SRGB_TO_LINEAR = "sRGBToLinear", vn.LINEAR_TO_SRGB = "LinearTosRGB";
var zt = class extends ge {
    constructor(e = "", r, i, s, o){
        super(e, o, s, i, r);
        this.nodeType = "Expression";
    }
};
var xn = class extends Jt {
    constructor(e = new qt, r, i, s){
        super("v4", {
            shared: !0
        });
        this.nodeType = "Texture";
        this.value = e, this.uv = r ?? new Ih, this.bias = i, this.project = s !== void 0 ? s : !1;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "t");
    }
    generate(e, r) {
        if (r === "sampler2D") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s = this.uv.build(e, this.project ? "v4" : "v2"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a, l;
        this.project ? a = "texture2DProj" : a = o ? "tex2DBias" : "tex2D", o ? l = a + "( " + i + ", " + s + ", " + o + " )" : l = a + "( " + i + ", " + s + " )";
        let u = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, c = this.getType(e);
        return e.addContext(u), this.colorSpace = this.colorSpace ?? new vn(new zt("", c)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(l), l = this.colorSpace.build(e, c), e.removeContext(), e.format(l, c, r);
    }
};
var Ce = class extends Jt {
    constructor(e){
        super("f");
        this.nodeType = "Float";
        this.value = e ?? 0;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format(this.value + (this.value % 1 ? "" : ".0"), s, r);
    }
};
var gm = class extends Xe {
    constructor(e, r){
        super();
        this.inputs = [];
        this.nodeType = "FunctionCall";
        this.value = e, this.inputs = r ?? [];
    }
    getFunction() {
        return this.value;
    }
    getType(e) {
        return this.value.getType(e);
    }
    generate(e, r, i, s, o) {
        s = this.getType(e);
        let a = this.value, l = a.build(e, r) + "( ", u = [];
        if (a.inputs) {
            for(let c = 0; c < a.inputs.length; c++){
                let d = a.inputs[c], h = this.inputs[c] || this.inputs[d.name];
                u.push(h.build(e, e.getTypeByFormat(d.type)));
            }
            l += u.join(", ") + " )";
        }
        return e.format(l, s, r);
    }
};
var EA = class extends Xe {
    constructor(e, r, i = EA.ADD){
        super();
        this.nodeType = "Operator";
        this.type = e.type, this.a = e, this.b = r, this.op = i;
    }
    getType(e) {
        let r = this.a.getType(e), i = this.b.getType(e);
        return e.isTypeMatrix(r) ? "v4" : e.getTypeLength(i) > e.getTypeLength(r) ? i : r;
    }
    generate(e, r) {
        let i = this.getType(e);
        this.type = i;
        let s = this.a.build(e, i), o = this.b.build(e, i);
        return e.format("( " + s + " " + this.op + " " + o + " )", i, r);
    }
}, zi = EA;
zi.ADD = "+", zi.SUB = "-", zi.MUL = "*", zi.DIV = "/";
var $t = class extends Xe {
    constructor(e, r = $t.ABS, i, s){
        super();
        this.nodeType = "Math";
        this.a = e, typeof r != "string" ? this.b = r : s = r, typeof i != "string" ? this.c = i : s = i, this.method = s, this.hashProperties = [
            "method"
        ];
    }
    getNumInputs(e) {
        switch(this.method){
            case $t.MIX:
            case $t.CLAMP:
            case $t.REFRACT:
            case $t.SMOOTHSTEP:
            case $t.FACEFORWARD:
                return 3;
            case $t.MIN:
            case $t.MAX:
            case $t.MOD:
            case $t.STEP:
            case $t.REFLECT:
            case $t.DISTANCE:
            case $t.DOT:
            case $t.CROSS:
            case $t.POW:
                return 2;
            default:
                return 1;
        }
    }
    getInputType(e) {
        let r = e.getTypeLength(this.a.getType(e)), i = this.b ? e.getTypeLength(this.b.getType(e)) : 0, s = this.c ? e.getTypeLength(this.c.getType(e)) : 0;
        return r > i && r > s ? this.a.getType(e) : i > s ? this.b.getType(e) : this.c.getType(e);
    }
    getType(e) {
        switch(this.method){
            case $t.LENGTH:
            case $t.DISTANCE:
            case $t.DOT:
                return "f";
            case $t.CROSS:
                return "v3";
        }
        return this.getInputType(e);
    }
    generate(e, r) {
        let i, s, o, a = this.a ? e.getTypeLength(this.a.getType(e)) : 0, l = this.b ? e.getTypeLength(this.b.getType(e)) : 0, u = this.c ? e.getTypeLength(this.c.getType(e)) : 0, c = this.getInputType(e), d = this.getType(e);
        switch(this.type = d, this.method){
            case $t.NEGATE:
                return e.format("( -" + this.a.build(e, c) + " )", c, r);
            case $t.INVERT:
                return e.format("( 1.0 - " + this.a.build(e, c) + " )", c, r);
            case $t.CROSS:
                i = this.a.build(e, "v3"), s = this.b.build(e, "v3");
                break;
            case $t.STEP:
                i = this.a.build(e, a === 1 ? "f" : c), s = this.b.build(e, c);
                break;
            case $t.MIN:
            case $t.MAX:
            case $t.MOD:
                i = this.a.build(e, c), s = this.b.build(e, l === 1 ? "f" : c);
                break;
            case $t.REFRACT:
                i = this.a.build(e, c), s = this.b.build(e, c), o = this.c.build(e, "f");
                break;
            case $t.MIX:
                i = this.a.build(e, c), s = this.b.build(e, c), o = this.c.build(e, u === 1 ? "f" : c);
                break;
            default:
                i = this.a.build(e, c), this.b && (s = this.b.build(e, c)), this.c && (o = this.c.build(e, c));
                break;
        }
        let h = [];
        h.push(i), s && h.push(s), o && h.push(o);
        let f = this.getNumInputs(e);
        if (h.length !== f) throw Error(`Arguments not match used in "${this.method}". Require ${f}, currently ${h.length}.`);
        return e.format(this.method + "( " + h.join(", ") + " )", d, r);
    }
}, lt = $t;
lt.RAD = "radians", lt.DEG = "degrees", lt.EXP = "exp", lt.EXP2 = "exp2", lt.LOG = "log", lt.LOG2 = "log2", lt.SQRT = "sqrt", lt.INV_SQRT = "inversesqrt", lt.FLOOR = "floor", lt.CEIL = "ceil", lt.NORMALIZE = "normalize", lt.FRACT = "fract", lt.SATURATE = "saturate", lt.SIN = "sin", lt.COS = "cos", lt.TAN = "tan", lt.ASIN = "asin", lt.ACOS = "acos", lt.ARCTAN = "atan", lt.ABS = "abs", lt.SIGN = "sign", lt.LENGTH = "length", lt.NEGATE = "negate", lt.INVERT = "invert", lt.MIN = "min", lt.MAX = "max", lt.MOD = "mod", lt.STEP = "step", lt.REFLECT = "reflect", lt.DISTANCE = "distance", lt.DOT = "dot", lt.CROSS = "cross", lt.POW = "pow", lt.MIX = "mix", lt.CLAMP = "clamp", lt.REFRACT = "refract", lt.SMOOTHSTEP = "smoothstep", lt.FACEFORWARD = "faceforward";
var Rh = class extends Xe {
    constructor(e, r, i){
        super("v4");
        this.nodeType = "TextureCubeUV";
        this.value = e, this.uv = r, this.bias = i;
    }
    bilinearCubeUV(e, r, i, s) {
        let o = new gm(Rh.Nodes.bilinearCubeUV, [
            r,
            i,
            s
        ]);
        this.colorSpaceTL = this.colorSpaceTL ?? new vn(new zt("", "v4")), this.colorSpaceTL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTL.input.parse(o.build(e) + ".tl"), this.colorSpaceTR = this.colorSpaceTR ?? new vn(new zt("", "v4")), this.colorSpaceTR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTR.input.parse(o.build(e) + ".tr"), this.colorSpaceBL = this.colorSpaceBL ?? new vn(new zt("", "v4")), this.colorSpaceBL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBL.input.parse(o.build(e) + ".bl"), this.colorSpaceBR = this.colorSpaceBR ?? new vn(new zt("", "v4")), this.colorSpaceBR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBR.input.parse(o.build(e) + ".br");
        let a = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        };
        e.addContext(a), this.colorSpaceTLExp = new zt(this.colorSpaceTL.build(e, "v4"), "v4"), this.colorSpaceTRExp = new zt(this.colorSpaceTR.build(e, "v4"), "v4"), this.colorSpaceBLExp = new zt(this.colorSpaceBL.build(e, "v4"), "v4"), this.colorSpaceBRExp = new zt(this.colorSpaceBR.build(e, "v4"), "v4"), e.removeContext();
        let l = new zt("mix( mix( cubeUV_TL, cubeUV_TR, cubeUV.f.x ), mix( cubeUV_BL, cubeUV_BR, cubeUV.f.x ), cubeUV.f.y )", "v4");
        return l.keywords.cubeUV_TL = this.colorSpaceTLExp, l.keywords.cubeUV_TR = this.colorSpaceTRExp, l.keywords.cubeUV_BL = this.colorSpaceBLExp, l.keywords.cubeUV_BR = this.colorSpaceBRExp, l.keywords.cubeUV = o, l;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = this.uv, s = this.bias || e.context.roughness, o = new gm(Rh.Nodes.roughnessToMip, [
                s
            ]), a = new lt(o, Rh.Nodes.m0, Rh.Nodes.cubeUV_maxMipLevel, lt.CLAMP), l = new lt(a, lt.FLOOR), u = new lt(a, lt.FRACT), c = this.bilinearCubeUV(e, this.value, i, l), d = this.bilinearCubeUV(e, this.value, i, new zi(l, new Ce(1).setReadonly(!0), zi.ADD)), h = new lt(c, d, u, lt.MIX);
            return e.format(h.build(e), "v4", r);
        } else return console.warn("TextureCubeUVNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r);
    }
}, Lh = Rh;
Lh.Nodes = function() {
    let e = new Oh(`struct TextureCubeUVData {
			vec4 tl;
			vec4 tr;
			vec4 br;
			vec4 bl;
			vec2 f;
		}`), r = new Ft("float cubeUV_maxMipLevel 8.0", !0), i = new Ft("float cubeUV_minMipLevel 4.0", !0), s = new Ft("float cubeUV_maxTileSize 256.0", !0), o = new Ft("float cubeUV_minTileSize 16.0", !0), a = new ge(`float getFace(vec3 direction) {
				vec3 absDirection = abs(direction);
				float face = -1.0;
				if (absDirection.x > absDirection.z) {
					if (absDirection.x > absDirection.y)
						face = direction.x > 0.0 ? 0.0 : 3.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				} else {
					if (absDirection.z > absDirection.y)
						face = direction.z > 0.0 ? 2.0 : 5.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				}
				return face;
		}`);
    a.useKeywords = !1;
    let l = new ge(`vec2 getUV(vec3 direction, float face) {
				vec2 uv;
				if (face == 0.0) {
					uv = vec2(direction.z, direction.y) / abs(direction.x); // pos x
				} else if (face == 1.0) {
					uv = vec2(-direction.x, -direction.z) / abs(direction.y); // pos y
				} else if (face == 2.0) {
					uv = vec2(-direction.x, direction.y) / abs(direction.z); // pos z
				} else if (face == 3.0) {
					uv = vec2(-direction.z, direction.y) / abs(direction.x); // neg x
				} else if (face == 4.0) {
					uv = vec2(-direction.x, direction.z) / abs(direction.y); // neg y
				} else {
					uv = vec2(direction.x, direction.y) / abs(direction.z); // neg z
				}
				return 0.5 * (uv + 1.0);
		}`);
    l.useKeywords = !1;
    let u = new ge(`TextureCubeUVData bilinearCubeUV(sampler2D envMap, vec3 direction, float mipInt) {
			float face = getFace(direction);
			float filterInt = max(cubeUV_minMipLevel - mipInt, 0.0);
			mipInt = max(mipInt, cubeUV_minMipLevel);
			float faceSize = exp2(mipInt);
			float texelSize = 1.0 / (3.0 * cubeUV_maxTileSize);
			vec2 uv = getUV(direction, face) * (faceSize - 1.0);
			vec2 f = fract(uv);
			uv += 0.5 - f;
			if (face > 2.0) {
				uv.y += faceSize;
				face -= 3.0;
			}
			uv.x += face * faceSize;
			if(mipInt < cubeUV_maxMipLevel){
				uv.y += 2.0 * cubeUV_maxTileSize;
			}
			uv.y += filterInt * 2.0 * cubeUV_minTileSize;
			uv.x += 3.0 * max(0.0, cubeUV_maxTileSize - 2.0 * faceSize);
			uv *= texelSize;
			vec4 tl = texture2D(envMap, uv);
			uv.x += texelSize;
			vec4 tr = texture2D(envMap, uv);
			uv.y += texelSize;
			vec4 br = texture2D(envMap, uv);
			uv.x -= texelSize;
			vec4 bl = texture2D(envMap, uv);
			return TextureCubeUVData( tl, tr, br, bl, f );
		}`, [
        e,
        a,
        l,
        r,
        i,
        s,
        o
    ]);
    u.useKeywords = !1;
    let c = new Ft("float r0 1.0", !0), d = new Ft("float v0 0.339", !0), h = new Ft("float m0 -2.0", !0), f = new Ft("float r1 0.8", !0), p = new Ft("float v1 0.276", !0), m = new Ft("float m1 -1.0", !0), g = new Ft("float r4 0.4", !0), y = new Ft("float v4 0.046", !0), v = new Ft("float m4 2.0", !0), x = new Ft("float r5 0.305", !0), S = new Ft("float v5 0.016", !0), w = new Ft("float m5 3.0", !0), A = new Ft("float r6 0.21", !0), E = new Ft("float v6 0.0038", !0), b = new Ft("float m6 4.0", !0), T = [
        c,
        d,
        h,
        f,
        p,
        m,
        g,
        y,
        v,
        x,
        S,
        w,
        A,
        E,
        b
    ], M = new ge(`float roughnessToMip(float roughness) {
			float mip = 0.0;
			if (roughness >= r1) {
				mip = (r0 - roughness) * (m1 - m0) / (r0 - r1) + m0;
			} else if (roughness >= r4) {
				mip = (r1 - roughness) * (m4 - m1) / (r1 - r4) + m1;
			} else if (roughness >= r5) {
				mip = (r4 - roughness) * (m5 - m4) / (r4 - r5) + m4;
			} else if (roughness >= r6) {
				mip = (r5 - roughness) * (m6 - m5) / (r5 - r6) + m5;
			} else {
				mip = -2.0 * log2(1.16 * roughness);// 1.16 = 1.79^0.25
			}
			return mip;
		}`, T);
    return {
        bilinearCubeUV: u,
        roughnessToMip: M,
        m0: h,
        cubeUV_maxMipLevel: r
    };
}();
var zc = class extends Xe {
    constructor(e){
        super("v3");
        this.nodeType = "Normal";
        this.scope = e ?? zc.VIEW;
    }
    getShared() {
        return this.scope === zc.WORLD;
    }
    build(e, r, i, s) {
        let o = e.context[this.scope + "Normal"];
        return o ? o.build(e, r, i, s) : super.build(e, r, i);
    }
    generate(e, r, i, s, o) {
        let a;
        switch(this.scope){
            case zc.VIEW:
                e.isShader("vertex") ? a = "transformedNormal" : a = "geometryNormal";
                break;
            case zc.LOCAL:
                e.isShader("vertex") ? a = "objectNormal" : (e.requires.normal = !0, a = "vObjectNormal");
                break;
            case zc.WORLD:
                e.isShader("vertex") ? a = "inverseTransformDirection( transformedNormal, viewMatrix ).xyz" : (e.requires.worldNormal = !0, a = "vWNormal");
                break;
        }
        return e.format(a, this.getType(e), r);
    }
}, Vi = zc;
Vi.LOCAL = "local", Vi.WORLD = "world", Vi.VIEW = "view", Vi.NORMAL = "normal";
_i.addKeyword("viewNormal", function() {
    return new Vi(Vi.VIEW);
});
_i.addKeyword("localNormal", function() {
    return new Vi(Vi.NORMAL);
});
_i.addKeyword("worldNormal", function() {
    return new Vi(Vi.WORLD);
});
var Po = class extends Xe {
    constructor(e){
        super("v3");
        this.nodeType = "Position";
        this.scope = e ?? Po.LOCAL;
    }
    getType() {
        switch(this.scope){
            case Po.PROJECTION:
                return "v4";
        }
        return this.type;
    }
    getShader() {
        switch(this.scope){
            case Po.LOCAL:
            case Po.WORLD:
                return !1;
        }
        return !0;
    }
    generate(e, r, i, s, o) {
        let a;
        switch(this.scope){
            case Po.LOCAL:
                e.isShader("vertex") ? a = "transformed" : (e.requires.position = !0, a = "vPosition");
                break;
            case Po.WORLD:
                if (e.isShader("vertex")) return "( modelMatrix * vec4( transformed, 1.0 ) ).xyz";
                e.requires.worldPosition = !0, a = "vWPosition";
                break;
            case Po.VIEW:
                a = e.isShader("vertex") ? "-mvPosition.xyz" : "vViewPosition";
                break;
            case Po.PROJECTION:
                a = e.isShader("vertex") ? "( projectionMatrix * modelViewMatrix * vec4( position, 1.0 ) )" : "vec4( 0.0 )";
                break;
        }
        return e.format(a, this.getType(), r);
    }
}, In = Po;
In.LOCAL = "local", In.WORLD = "world", In.VIEW = "view", In.PROJECTION = "projection";
_i.addKeyword("position", function() {
    return new In;
});
_i.addKeyword("worldPosition", function() {
    return new In(In.WORLD);
});
_i.addKeyword("viewPosition", function() {
    return new In(In.VIEW);
});
var Ws = class extends Xe {
    constructor(e){
        super("v3");
        this.nodeType = "Reflect";
        this.scope = e ?? Ws.CUBE;
    }
    getUnique(e) {
        return !e.context.viewNormal;
    }
    getType() {
        switch(this.scope){
            case Ws.SPHERE:
                return "v2";
        }
        return this.type;
    }
    generate(e, r) {
        let i = this.getUnique(e);
        if (e.isShader("fragment")) {
            let s;
            switch(this.scope){
                case Ws.VECTOR:
                    {
                        let o = new Vi(Vi.VIEW), a = e.context.roughness, l = o.build(e, "v3"), u = new In(In.VIEW).build(e, "v3"), c = a ? a.build(e, "f") : void 0, d = `reflect( -normalize( ${u} ), ${l} )`;
                        c && (d = `normalize( mix( ${d}, ${l}, ${c} * ${c} ) )`);
                        let h = `inverseTransformDirection( ${d}, viewMatrix )`;
                        i ? (e.addNodeCode(`vec3 reflectVec = ${h};`), s = "reflectVec") : s = h;
                        break;
                    }
                case Ws.CUBE:
                    {
                        let o = new Ws(Ws.VECTOR).build(e, "v3"), a = "vec3( -" + o + ".x, " + o + ".yz )";
                        i ? (e.addNodeCode(`vec3 reflectCubeVec = ${a};`), s = "reflectCubeVec") : s = a;
                        break;
                    }
                case Ws.SPHERE:
                    {
                        let a = "normalize( ( viewMatrix * vec4( " + new Ws(Ws.VECTOR).build(e, "v3") + ", 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) ).xy * 0.5 + 0.5";
                        i ? (e.addNodeCode(`vec2 reflectSphereVec = ${a};`), s = "reflectSphereVec") : s = a;
                        break;
                    }
            }
            return e.format(s, this.getType(), r);
        } else return console.warn("ReflectNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.type, r);
    }
}, Do = Ws;
Do.CUBE = "cube", Do.SPHERE = "sphere", Do.VECTOR = "vector";
var B0 = class extends Xe {
    constructor(e = new xn, r, i){
        super("v4");
        this.nodeType = "TextureCube";
        this.value = e, this.radianceNode = new Lh(this.value, r ?? new Do(Do.VECTOR), i), this.irradianceNode = new Lh(this.value, new Vi(Vi.WORLD), new Ce(1).setReadonly(!0));
    }
    generate(e, r) {
        return e.isShader("fragment") ? (e.require("irradiance"), e.context.bias && e.context.bias.setTexture(this.value), (e.slot === "irradiance" ? this.irradianceNode : this.radianceNode).build(e, r)) : (console.warn("TextureCubeNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r));
    }
};
var N0 = class extends Jt {
    constructor(e = new Du, r, i){
        super("v4", {
            shared: !0
        });
        this.nodeType = "CubeTexture";
        this.value = e, this.uv = r ?? new Do, this.bias = i;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "tc");
    }
    generate(e, r) {
        if (r === "samplerCube") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s = this.uv?.build(e, "v3"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a;
        o ? a = "texCubeBias( " + i + ", " + s + ", " + o + " )" : a = "texCube( " + i + ", " + s + " )";
        let l = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, u = this.getType(e);
        return e.addContext(l), this.colorSpace = this.colorSpace ?? new vn(new zt("", u)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(a), a = this.colorSpace.build(e, u), e.removeContext(), e.format(a, u, r);
    }
};
var MI = `
uniform int frameIndex;
uniform vec2 resolution;
uniform mat4 previousModelViewMatrix;
uniform mat4 previousProjectionMatrix;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;
`, CI = `
layout(location = 1) out vec4 gVelocity;

uniform int frameIndex;
uniform vec2 resolution;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;

const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

vec2 vogelDiskSample(int sampleIndex, int sampleCount, float angle) {
  const float goldenAngle = 2.399963f; // radians
  float r = sqrt(float(sampleIndex) + 0.5f) / sqrt(float(sampleCount));
  float theta = float(sampleIndex) * goldenAngle + angle;
  float sine = sin(theta);
  float cosine = cos(theta);
  return vec2(cosine, sine) * r;
}

// Derived from the interleaved gradient function from Jimenez 2014 http:goo.gl/eomGso
float getNoiseInterleavedGradient(vec2 screenPos) {
    vec3 magic = vec3(0.06711056f, 0.00583715f, 52.9829189f);
    return fract(magic.z * fract(dot(screenPos, magic.xy)));
}

`, PI = `
// TODO: This could be generated CPU side and passed to the shader every frame
const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

// TODO: Pass correct view size
vec2 offset = haltonSequence[frameIndex];
offset.x /= resolution.x;
offset.y /= resolution.y;

vec4 currentPosition = gl_Position;
vec4 currentPositionJittered = currentPosition + (vec4(offset.x, offset.y, 0.0, 0.0) * currentPosition.w);

// We want to calculate the velocity with unjittered positions
// so that things that are not moving get a velocity = 0
vCurrentPosition = currentPosition;
vPreviousPosition = previousProjectionMatrix * previousModelViewMatrix * vec4(transformed, 1.0);
#ifdef OUTLINE_COMPENSATION
vPreviousPosition.xy += OUTLINE_COMPENSATION;
#endif
gl_Position = currentPositionJittered;

`, DI = `
vec2 oldPos = vPreviousPosition.xy;
    oldPos /= vPreviousPosition.w;
    oldPos.xy = (oldPos.xy+1.)/2.0;

vec2 newPos = vCurrentPosition.xy;
    newPos /= vCurrentPosition.w;
    newPos.xy = (newPos.xy+1.)/2.0;

vec2 velocity = (newPos - oldPos);

// Discard fully transparent pixels 
if (gl_FragColor.a <= 0.0) discard;

gVelocity = vec4(velocity, 0.0, 1.0);
`, OI = `
layout(location = 1) out vec4 gVelocity;
`, II = `
    // Discard fully transparent pixels 
    if (gl_FragColor.a <= 0.0) discard;

    gVelocity = vec4(0.0, 0.0, 0.0, 1.0);
`;
var RI = [
    "x",
    "y",
    "z",
    "w"
], HY = [
    "float",
    "vec2",
    "vec3",
    "vec4"
], WY = {
    float: "f",
    vec2: "v2",
    vec3: "v3",
    vec4: "v4",
    mat4: "v4",
    int: "i",
    bool: "b",
    "float[]": "f[]",
    "vec4[]": "v4[]"
}, qY = {
    t: "sampler2D",
    tc: "samplerCube",
    b: "bool",
    i: "int",
    f: "float",
    c: "vec3",
    v2: "vec2",
    v3: "vec3",
    v4: "vec4",
    m3: "mat3",
    m4: "mat4",
    "f[]": "float[]",
    "v4[]": "vec4[]"
}, Bh = class {
    constructor(){
        this.includes = {
            consts: {},
            functions: {},
            structs: {}
        };
        this.cache = "";
        this.slot = "";
        this.shader = "";
        this.context = {};
        this.needsJitter = !0;
        this.getIncludesCode = function() {
            function t(e, r) {
                return e.deps.length - r.deps.length;
            }
            return function(r, i) {
                let s = this.getIncludes(r, i);
                if (!s) return "";
                let o = "";
                s = s.sort(t);
                for(let a = 0; a < s.length; a++)s[a].src && (o += s[a].src + `
`);
                return o;
            };
        }();
        this.slots = [], this.caches = [], this.contexts = [], this.keywords = {}, this.nodeData = {}, this.fragmentVariables = {}, this.fragmentParsVariables = {}, this.vertexParsVariables = {}, this.requires = {
            uv: [],
            color: [],
            transparent: !1,
            irradiance: !1,
            position: !1,
            worldPosition: !1,
            normal: !1,
            worldNormal: !1,
            vWorldViewDir: !1,
            modelMatrix: !1,
            viewMatrix: !1,
            projectionMatrix: !1
        }, this.includes = {
            consts: [],
            functions: [],
            structs: []
        }, this.attributes = {}, this.prefixCode = [
            "#ifdef TEXTURE_LOD_EXT",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCubeLodEXT(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2DLodEXT(a, b, c)",
            "#else",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCube(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2D(a, b, c)",
            "#endif",
            `
			// NOTE: Include Spline's blending modes. This could be part of BlendNode
			#define SPE_BLENDING_NORMAL 0
			#define SPE_BLENDING_MULTIPLY 1
			#define SPE_BLENDING_SCREEN 2
			#define SPE_BLENDING_OVERLAY 3

			vec3 spe_normalBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, b, alpha );
			}

			vec3 spe_multiplyBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, a * b, alpha );
			}

			vec3 spe_screenBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = 1.0 - ( 1.0 - a ) * ( 1.0 - b );
				return mix( a, tmp, alpha );
			}

			vec3 spe_overlayBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = mix( 1. - 2. * (1. - a) * (1. - b), 2. * a * b, step( a, vec3(.5) ) );
				return clamp( mix( a, tmp, alpha ), 0.0, 1.0 );
			}

			vec3 spe_blend( vec3 a, vec3 b, float alpha, int mode ) {
				if ( mode == SPE_BLENDING_NORMAL ) return spe_normalBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_MULTIPLY ) return spe_multiplyBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_SCREEN ) return spe_screenBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_OVERLAY ) return spe_overlayBlend( a, b, alpha );
				return vec3( 1.0 );
			}
			`,
            "#include <packing>",
            "#include <common>"
        ].join(`
`), this.parsCode = {
            vertex: [
                "float neighbor_offset = 0.0001;",
                ""
            ].join(`
`),
            fragment: [
                "float accumAlpha = 0.0;",
                `void accumulateAlpha(float alpha) {
					accumAlpha += (1.0 - accumAlpha) * alpha;
				}`,
                ""
            ].join(`
`)
        }, this.code = {
            vertex: "",
            fragment: ""
        }, this.nodeCode = {
            vertex: "",
            fragment: ""
        }, this.resultCode = {
            vertex: "",
            fragment: ""
        }, this.finalCode = {
            vertex: "",
            fragment: ""
        }, this.inputs = {
            uniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            arrayUniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            vars: {
                varying: [],
                vertex: [],
                fragment: []
            }
        }, this.defines = {}, this.uniforms = {}, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.updaters = [], this.nodes = [], this.analyzing = !1;
    }
    build(t, e) {
        this.addVertexParsCode(MI), this.addFragmentParsCode(CI), this.buildShader("vertex", t), this.buildShader("fragment", e);
        for(let r = 0; r < this.requires.uv.length; r++)if (this.requires.uv[r]) {
            let i = r > 0 ? r + 1 : "";
            this.addVaryCode("varying vec2 vUv" + i + ";"), r > 0 && this.addVertexParsCode("attribute vec2 uv" + i + ";"), this.addVertexFinalCode("vUv" + i + " = uv" + i + ";");
        }
        return this.requires.color[0] && (this.addVaryCode("varying vec4 vColor;"), this.addVertexParsCode("attribute vec4 color;"), this.addVertexFinalCode("vColor = color;")), this.requires.color[1] && (this.addVaryCode("varying vec4 vColor2;"), this.addVertexParsCode("attribute vec4 color2;"), this.addVertexFinalCode("vColor2 = color2;")), this.requires.position && (this.addVaryCode("varying vec3 vPosition;"), this.addVertexFinalCode("vPosition = transformed;")), this.requires.worldPosition, this.requires.normal && (this.addVaryCode("varying vec3 vObjectNormal;"), this.addVertexFinalCode("vObjectNormal = normal;")), this.requires.modelMatrix && this.addFragmentParsCode("uniform mat4 modelMatrix;"), this.requires.viewMatrix && this.addFragmentParsCode("uniform mat4 viewMatrix;"), this.requires.projectionMatrix && this.addFragmentParsCode("uniform mat4 projectionMatrix;"), this.requires.worldNormal && (this.addVaryCode("varying vec3 vWNormal;"), this.addVertexFinalCode("vWNormal = inverseTransformDirection( transformedNormal, viewMatrix ).xyz;")), this.requires.vWorldViewDir && (this.addVaryCode("varying vec3 vWorldViewDir;"), this.addVertexFinalCode("vWorldViewDir = isPerspectiveMatrix( projectionMatrix ) ?  ( (modelMatrix * vec4(position, 1.0)).xyz - cameraPosition ) : vec3( -viewMatrix[0][2], -viewMatrix[1][2], -viewMatrix[2][2] );")), this.needsJitter && (this.addVertexFinalCode(PI), this.addFragmentFinalCode(DI)), this;
    }
    buildShader(t, e) {
        this.resultCode[t] = e.build(this.setShader(t), "v4");
    }
    setMaterial(t, e) {
        return this.defines = {}, this;
    }
    addFlow(t, e, r) {
        return this.addSlot(t).addCache(e).addContext(r);
    }
    removeFlow() {
        return this.removeSlot().removeCache().removeContext();
    }
    addCache(t) {
        return this.cache = t ?? "", this.caches.push(this.cache), this;
    }
    removeCache() {
        return this.caches.pop(), this.cache = this.caches[this.caches.length - 1] || "", this;
    }
    addContext(t) {
        return this.context = Object.assign({}, this.context, t), this.context.extra = this.context.extra || {}, this.contexts.push(this.context), this;
    }
    removeContext() {
        return this.contexts.pop(), this.context = this.contexts[this.contexts.length - 1] || {}, this;
    }
    addSlot(t) {
        return this.slot = t || "", this.slots.push(this.slot), this;
    }
    removeSlot() {
        return this.slots.pop(), this.slot = this.slots[this.slots.length - 1] || "", this;
    }
    addFragmentVariable(t, e) {
        this.fragmentVariables[t] === void 0 && (this.addFragmentCode(`${e} ${t};`), this.fragmentVariables[t] = "");
    }
    addFragmentParsVariable(t, e) {
        this.fragmentParsVariables[t] === void 0 && (this.addFragmentParsCode(`${e} ${t};`), this.fragmentParsVariables[t] = "");
    }
    addVertexParsVariable(t, e) {
        this.vertexParsVariables[t] === void 0 && (this.addVertexParsCode(`${e} ${t};`), this.vertexParsVariables[t] = "");
    }
    addVertexCode(t) {
        this.addCode(t, "vertex");
    }
    addFragmentCode(t) {
        this.addCode(t, "fragment");
    }
    addCode(t, e) {
        this.code[e ?? this.shader] += t + `
`;
    }
    addVertexNodeCode(t) {
        this.addNodeCode(t, "vertex");
    }
    addFragmentNodeCode(t) {
        this.addNodeCode(t, "fragment");
    }
    addNodeCode(t, e) {
        this.nodeCode[e ?? this.shader] += t + `
`;
    }
    clearNodeCode(t) {
        t = t ?? this.shader;
        let e = this.nodeCode[t];
        return this.nodeCode[t] = "", e;
    }
    clearVertexNodeCode() {
        return this.clearNodeCode("vertex");
    }
    clearFragmentNodeCode() {
        return this.clearNodeCode("fragment");
    }
    addVertexFinalCode(t) {
        this.addFinalCode(t, "vertex");
    }
    addFragmentFinalCode(t) {
        this.addFinalCode(t, "fragment");
    }
    addFinalCode(t, e) {
        this.finalCode[e ?? this.shader] += t + `
`;
    }
    addVertexParsCode(t) {
        this.addParsCode(t, "vertex");
    }
    addFragmentParsCode(t) {
        this.addParsCode(t, "fragment");
    }
    addParsCode(t, e) {
        this.parsCode[e ?? this.shader] += t + `
`;
    }
    addVaryCode(t) {
        this.addVertexParsCode(t), this.addFragmentParsCode(t);
    }
    isCache(t) {
        return this.caches.indexOf(t) !== -1;
    }
    isSlot(t) {
        return this.slots.indexOf(t) !== -1;
    }
    define(t, e) {
        this.defines[t] = e === void 0 ? 1 : e;
    }
    require(t) {
        this.requires[t] = !0;
    }
    isDefined(t) {
        return this.defines[t] !== void 0;
    }
    getVar(t, e, r, i = "varying", s = "V", o = "") {
        let a = this.getVars(i), l = a[t];
        if (!l) {
            let u = a.length;
            l = {
                name: r || "node" + s + u + (o ? "_" + o : ""),
                type: e
            }, a.push(l), a[t] = l;
        }
        return l;
    }
    getTempVar(t, e, r, i) {
        return this.getVar(t, e, r, this.shader, "T", i);
    }
    getAttribute(t, e) {
        if (!this.attributes[t]) {
            let r = this.getVar(t, e);
            this.addVertexParsCode("attribute " + e + " " + t + ";"), this.addVertexFinalCode(r.name + " = " + t + ";"), this.attributes[t] = {
                varying: r,
                name: t,
                type: e
            };
        }
        return this.attributes[t];
    }
    getCode(t) {
        return [
            this.prefixCode,
            this.parsCode[t],
            this.getVarListCode(this.getVars("varying"), "varying"),
            this.getVarListCode(this.inputs.uniforms[t], "uniform"),
            this.getVarListCode(this.inputs.arrayUniforms[t], "uniform"),
            this.getIncludesCode("consts", t),
            this.getIncludesCode("structs", t),
            this.getIncludesCode("functions", t),
            "void main() {",
            this.getVarListCode(this.getVars(t)),
            this.code[t],
            this.resultCode[t],
            this.finalCode[t],
            "}"
        ].join(`
`);
    }
    getVarListCode(t, e) {
        e = e ?? "";
        let r = "";
        for(let i = 0, s = t.length; i < s; ++i){
            let o = t[i], a = o.type, l = o.name, u = o.size, c = this.getFormatByType(a);
            if (c === void 0) throw new Error("Node pars " + c + " not found.");
            c.includes("[]") ? r += e + " " + c.substring(0, c.length - 2) + " " + l + `[${u}];
` : r += e + " " + c + " " + l + `;
`;
        }
        return r;
    }
    getVars(t) {
        return this.inputs.vars[t ?? this.shader];
    }
    getNodeData(t) {
        let e = t instanceof ki ? t.uuid : t;
        return this.nodeData[e] = this.nodeData[e] || {};
    }
    createUniform(t, e, r, i, s, o) {
        if (e.includes("[]")) {
            let a = this.inputs.arrayUniforms, l = a.list.length, u = new mm({
                type: e,
                size: r.size,
                name: i || "nodeUA" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s
            });
            return a.list.push(u), a[t].push(u), a[t][u.name] = u, this.uniforms[u.name] = u, u;
        } else {
            let a = this.inputs.uniforms, l = a.list.length, u = new mm({
                type: e,
                name: i || "nodeU" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s
            });
            return a.list.push(u), a[t].push(u), a[t][u.name] = u, this.uniforms[u.name] = u, u;
        }
    }
    createVertexUniform(t, e, r, i, s) {
        return this.createUniform("vertex", t, e, r, i, s);
    }
    createFragmentUniform(t, e, r, i, s) {
        return this.createUniform("fragment", t, e, r, i, s);
    }
    include(t, e, r) {
        let i;
        if (t = typeof t == "string" ? _i.get(t) : t, this.context.include === !1) return t.name;
        t instanceof ge ? i = this.includes.functions : t instanceof Ft ? i = this.includes.consts : t instanceof Oh && (i = this.includes.structs);
        let s = i[this.shader] = i[this.shader] || [];
        if (t) {
            let o = s[t.name];
            if (o || (o = s[t.name] = {
                node: t,
                deps: []
            }, s.push(o), o.src = t.build(this, "source")), t instanceof ge && e && s[e.name] && s[e.name].deps.indexOf(t) === -1 && (s[e.name].deps.push(t), t.includes?.length)) {
                let a = 0;
                do this.include(t.includes[a++], e);
                while (a < t.includes.length);
            }
            return r && (o.src = r), t.name;
        } else throw new Error("Include not found.");
    }
    colorToVectorProperties(t) {
        return t.replace("r", "x").replace("g", "y").replace("b", "z").replace("a", "w");
    }
    colorToVector(t) {
        return t.replace(/c/g, "v3");
    }
    getIncludes(t, e) {
        return this.includes[t][e || this.shader];
    }
    getConstructorFromLength(t) {
        return HY[t - 1];
    }
    isTypeMatrix(t) {
        return /^m/.test(t);
    }
    getTypeLength(t) {
        return t === "f" ? 1 : parseInt(this.colorToVector(t).substr(1));
    }
    getTypeFromLength(t) {
        return t === 1 ? "f" : "v" + t;
    }
    findNode(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r?.isNode) return r;
        }
    }
    resolve(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r !== void 0) {
                if (r.isNode) return r;
                if (r.isTexture) switch(r.mapping){
                    case Xa:
                    case Qa:
                        return new N0(r);
                    case Qu:
                        return new B0(new xn(r));
                    default:
                        return new xn(r);
                }
                else {
                    if (r.isVector2) return new Lr(r);
                    if (r.isVector3) return new Xi(r);
                    if (r.isVector4) return new On(r);
                }
            }
        }
    }
    format(t, e, r) {
        switch(this.colorToVector(r + " <- " + e)){
            case "f <- v2":
                return t + ".x";
            case "f <- v3":
                return t + ".x";
            case "f <- v4":
                return t + ".x";
            case "f <- i":
            case "f <- b":
                return "float( " + t + " )";
            case "v2 <- f":
                return "vec2( " + t + " )";
            case "v2 <- v3":
                return t + ".xy";
            case "v2 <- v4":
                return t + ".xy";
            case "v2 <- i":
            case "v2 <- b":
                return "vec2( float( " + t + " ) )";
            case "v3 <- f":
                return "vec3( " + t + " )";
            case "v3 <- v2":
                return "vec3( " + t + ", 0.0 )";
            case "v3 <- v4":
                return t + ".xyz";
            case "v3 <- i":
            case "v3 <- b":
                return "vec2( float( " + t + " ) )";
            case "v4 <- f":
                return "vec4( " + t + " )";
            case "v4 <- v2":
                return "vec4( " + t + ", 0.0, 1.0 )";
            case "v4 <- v3":
                return "vec4( " + t + ", 1.0 )";
            case "v4 <- i":
            case "v4 <- b":
                return "vec4( float( " + t + " ) )";
            case "i <- f":
            case "i <- b":
                return "int( " + t + " )";
            case "i <- v2":
                return "int( " + t + ".x )";
            case "i <- v3":
                return "int( " + t + ".x )";
            case "i <- v4":
                return "int( " + t + ".x )";
            case "b <- f":
                return "( " + t + " != 0.0 )";
            case "b <- v2":
                return "( " + t + " != vec2( 0.0 ) )";
            case "b <- v3":
                return "( " + t + " != vec3( 0.0 ) )";
            case "b <- v4":
                return "( " + t + " != vec4( 0.0 ) )";
            case "b <- i":
                return "( " + t + " != 0 )";
        }
        return t;
    }
    getTypeByFormat(t) {
        return WY[t] || t;
    }
    getFormatByType(t) {
        return qY[t] || t;
    }
    getUUID(t, e) {
        return e = e !== void 0 ? e : !0, e && this.cache && (t = this.cache + "-" + t), t;
    }
    getElementByIndex(t) {
        return RI[t];
    }
    getIndexByElement(t) {
        return RI.indexOf(t);
    }
    isShader(t) {
        return this.shader === t;
    }
    setShader(t) {
        return this.shader = t, this;
    }
    mergeDefines(t) {
        for(let e in t)this.defines[e] = t[e];
        return this.defines;
    }
    mergeUniform(t) {
        for(let e in t)this.uniforms[e] = t[e];
        return this.uniforms;
    }
    getTextureEncodingFromMap(t) {
        let e;
        return t ? t.isTexture && (e = t.encoding) : e = dn, e === dn && this.context.gamma && (e = tt), e;
    }
};
var Yt = class extends Jt {
    constructor(e = 0, r, i, s){
        super("c");
        this.nodeType = "Color";
        this.value = e instanceof cr ? e : new cr(e || 0, r, i, s);
    }
    setRGBA(e) {
        this.value.setRGBA(e.r, e.g, e.b, e.a);
    }
    generate(e, r, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i), u = this.getReadonly() && this.generateReadonly !== void 0;
        if (this.alpha) {
            let c = this.alpha.build(e, "f");
            e.addFragmentNodeCode(`accumAlpha += ( 1.0 - accumAlpha ) * ${c};`);
        }
        return u ? this.generateReadonly(e, r, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, r));
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("vec3(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ")", s, r);
    }
};
var xt = class extends Jt {
    constructor(e){
        super("i");
        this.nodeType = "Int";
        this.value = Math.floor(e ?? 0);
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format(this.value.toString(), s, r);
    }
};
var Vr = class extends Jt {
    constructor(e){
        super("b");
        this.nodeType = "Bool";
        this.value = e ?? !1;
    }
    generateReadonly(e, r, i, s) {
        return e.format(this.value ? "true" : "false", s, r);
    }
};
var qs = class extends Jt {
    constructor(e = 1, r){
        super("f[]");
        this.nodeType = "FloatArray";
        this.size = e, this.value = Array.isArray(r) ? r : typeof r == "number" ? new Array(e).fill(r) : new Array(e).fill(0);
    }
};
var Rl = class extends Jt {
};
var F0 = class extends Rl {
    constructor(e){
        super("v3");
        this.image = e;
        this._value = new _;
    }
    get value() {
        return this._value.x = this.image.isVideo ? this.image.img.videoWidth ?? 0 : this.image.img.width, this._value.y = this.image.isVideo ? this.image.img.videoHeight ?? 0 : this.image.img.height, this._value;
    }
};
var Vc = class extends Rl {
    constructor(e, r){
        super("t");
        this.image = e;
        this.wrap = r;
    }
    get value() {
        return this.image.getTexture(this.wrap);
    }
};
var Nh = class extends Jt {
    constructor(e){
        super("m3");
        this.nodeType = "Matrix3";
        this.value = e ?? new Qt;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("mat3(" + this.value.elements.join(", ") + ")", s, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
var Qi = class extends Jt {
    constructor(e){
        super("m4");
        this.nodeType = "Matrix4";
        this.value = e ?? new te;
    }
    generateReadonly(e, r, i, s, o, a) {
        return e.format("mat4(" + this.value.elements.join(", ") + ")", s, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
function LI(n1, t, e) {
    n1.setUvTransform(e[0], e[1], t[0], t[1], 0, 0, 0);
}
var k0 = class extends Nh {
    constructor(e, r){
        super(new Qt);
        this.repeat = e;
        this.offset = r;
        LI(this.value, e, r);
    }
    updateMatrix() {
        LI(this.value, this.repeat, this.offset);
    }
};
var Ys = class extends Jt {
    constructor(e = 1, r){
        super("v4[]");
        this.nodeType = "Vector4Array";
        this.size = e, this.value = Array.isArray(r) ? r : r instanceof He ? new Array(e).fill(r) : new Array(e).fill(new He(0));
    }
};
var Fh = class extends Xe {
    constructor(e, r, i, s){
        super("v3");
        this.nodeType = "Blend";
        this.a = e, this.b = r, this.alpha = i, this.mode = s;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = [];
            return i.push(this.a.build(e, "c")), i.push(this.b.build(e, "c")), i.push(this.alpha.build(e, "f")), i.push(this.mode.build(e, "i")), e.format("spe_blend(" + i.join(",") + ")", this.getType(e), r);
        } else return console.warn("BlendNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var TA = class extends Xe {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomColor";
        this.color = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(TA.Nodes.customColor);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.color.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.build(e, "v3")})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomColorNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Uc = TA;
Uc.Nodes = function() {
    return {
        customColor: new ge(`vec3 customColor(vec3 color, float mask, float alpha, out float calpha) {
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color;
			}`)
    };
}();
var MA = class extends Xe {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomNormal";
        this.cnormal = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(MA.Nodes.customNormal);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.cnormal.build(e, "v3")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomNormalNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, kh = MA;
kh.Nodes = function() {
    return {
        customNormal: new ge(`vec3 customNormal(vec3 cnormal, vec3 norm, float mask, float alpha, out float calpha) {
				vec3 normal = packNormalToRGB( norm ).rgb;
				normal *= step( vec3(0.5), cnormal );

				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * lalpha;

				return normal;
			}`)
    };
}();
var zh = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h, f){
        super("v3");
        this.nodeType = "CustomTexture";
        this.texture = e, this.textureSize = r, this.crop = i, this.projection = s, this.axis = o, this.side = a, this.size = l, this.blending = u, this.mat = c, this.isMask = f, this.alpha = d, this.mode = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        e.require("position"), e.require("normal"), e.require("uv"), e.requires.uv = [
            !0
        ], e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0;
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s;
        switch(this.projection.value){
            case 3:
                s = e.include(zh.Nodes.cylindrical);
                break;
            case 2:
                s = e.include(zh.Nodes.spherical);
                break;
            case 1:
                let a = [
                    "vec3(1.0, 0.0, 0.0)",
                    "vec3(0.0, 1.0, 0.0)",
                    "vec3(0.0, 0.0, 1.0)"
                ][this.axis.value], l = [
                    "zy",
                    "xz",
                    "xy"
                ][this.axis.value], u = new ge(`
		vec3 ${i}_planarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 projected = (1. + (position.${l})) / 2.;
				vec2 uvs = ( mat * vec3( (projected * 2. - 1.) / (size * .5), 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				${this.side.value === 2 ? "" : `lalpha *= step(0.0, ${this.side.value === 1 ? "-1.0 * " : ""}dot(vObjectNormal, ${a}));`}

				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`);
                s = e.include(u);
                break;
            case 4:
                s = e.include(zh.Nodes.triplanar);
                break;
            default:
                s = e.include(zh.Nodes.uv);
                break;
        }
        e.addFragmentVariable(this.calpha, "float");
        let o = [];
        if (o.push("normal"), o.push(this.texture.generate(e, "t")), o.push(this.textureSize.build(e, "v2")), o.push(this.crop.build(e, "f")), o.push(this.mat.build(e, "mat3")), o.push(this.size.build(e, "v2")), o.push(this.blending.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), this.projection.value === 4) {
            let a = `${i}_writeUvs`, l = a + "0", u = a + "1", c = a + "2", d = `${i}_triplanarWeights`;
            e.addFragmentVariable(l, "vec2"), e.addFragmentVariable(u, "vec2"), e.addFragmentVariable(c, "vec2"), e.addFragmentVariable(d, "vec3"), o.push(l), o.push(u), o.push(c), o.push(d);
        } else {
            let a = `${i}_writeUvs`;
            e.addFragmentVariable(a, "vec2"), o.push(a);
        }
        return e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
    }
}, Ll = zh;
Ll.Nodes = function() {
    let e = new ge(`
vec3 cylindricalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(position);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float scaledHeight = position.y / (size.y * 0.5);
                float v =  (scaledHeight / 2.) + .5;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;

				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), r = new ge(`
vec3 sphericalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(vPosition);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float v = 0.5 + asin(posN.y) / 3.1415;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;
				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), i = new ge(`vec3 uvTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 uvs = ( mat * vec3( vUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;

				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`), s = new ge(`vec3 triplanarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUvs0, out vec2 writeUvs1, out vec2 writeUvs2, out vec3 writeWeights) {
				vec3 p = position;
				vec2 uv0 = (1.0 + p.xy) / 2.0;     
				vec2 uv1 = (1.0 + p.zy) / 2.0;		
				vec2 uv2 = (1.0 + p.xz) / 2.0;		
	
				uv0 = (mat * vec3((uv0 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv1 = (mat * vec3((uv1 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv2 = (mat * vec3((uv2 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;

				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));

				// Write out all sets of UVs that we generated
				writeUvs0 = uv0;
				writeUvs1 = uv1;
				writeUvs2 = uv2;
				writeWeights = weights;

				// Derivatives for LOD
				vec2 df0 = fwidth(uv0);
				vec2 df1 = fwidth(uv1);
				vec2 df2 = fwidth(uv2);
				if (df0.x > 0.5) df0.x = 0.0;
				if (df1.x > 0.5) df1.x = 0.0;
				if (df2.x > 0.5) df2.x = 0.0;

				#ifdef GL_EXT_shader_texture_lod
                	vec4 tmp = 
						texture2DLodEXT(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						texture2DLodEXT(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						texture2DLodEXT(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#else
                	vec4 tmp = 
						textureLod(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						textureLod(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						textureLod(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;

				// Apply cropping across all 3 planes
				if ( crop > 0.5 ) {
					if ( uv0.x < 0.0 || uv0.x > 1.0 || uv0.y < 0.0 || uv0.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv1.x < 0.0 || uv1.x > 1.0 || uv1.y < 0.0 || uv1.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv2.x < 0.0 || uv2.x > 1.0 || uv2.y < 0.0 || uv2.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;//n * 0.5 + 0.5;
			}			
			`);
    return {
        cylindrical: e,
        spherical: r,
        uv: i,
        triplanar: s
    };
}();
var Vh = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h, f){
        super("v3");
        this.nodeType = "Depth";
        this.gradientType = e, this.smooth = r, this.near = i, this.far = s, this.isVector = o, this.isWorldSpace = a, this.origin = l, this.direction = u, this.colors = c, this.steps = d, this.isMask = f, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s = new ge(`vec3 ${i}_sdepth(float near, float far, vec3 origin, vec3 direction, vec4 colors[${i}_MAX_COLORS], float steps[${i}_MAX_COLORS], bool isMask, float mask, float alpha, out float calpha) {
               vec4 color = colors[0];
               #ifdef ${i}_IS_VECTOR
                   #ifdef ${i}_LINEAR
                       #ifdef ${i}_WORLDSPACE
                       float depth = vectorLinearWorldSpaceDepth(direction, origin, near, far);
                       #else
                       float depth = vectorLinearObjectSpaceDepth(direction, origin, near, far);
                       #endif
                   #else
                       #ifdef ${i}_WORLDSPACE
                           float depth = vectorSphericalWorldSpaceDepth(origin, near, far);
                       #else
                           float depth = vectorSphericalObjectSpaceDepth(origin, near, far);
                       #endif
                   #endif
               #else
                   float dist = length(vWPosition - cameraPosition);
			       float depth = ( dist - near ) / ( far - near );
               #endif


              float p;
              #ifdef ${i}_SMOOTH
				for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
						p = clamp( ( depth - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}
              #else
                for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
                   p = clamp(( depth - steps[i - 1] ) / ( steps[i] - steps[i - 1] ), 0.0, 1.0);
                   color = mix(color, colors[i], p);
                 }
              #endif

               float lalpha = alpha * color.a * mask;
               calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
			   accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
			   
               return color.rgb;
			}`, [
            Vh.Nodes.vectorLinearWorldSpaceDepth,
            Vh.Nodes.vectorLinearObjectSpaceDepth,
            Vh.Nodes.vectorSphericalObjectSpaceDepth,
            Vh.Nodes.vectorSphericalWorldSpaceDepth
        ]);
        if (e.isShader("fragment")) {
            e.define(`${i}_MAX_COLORS`, this.colors.value.length), this.smooth.value && e.define(`${i}_SMOOTH`), this.isVector.value > .5 && e.define(`${i}_IS_VECTOR`), this.gradientType.value === 0 && e.define(`${i}_LINEAR`), this.isWorldSpace.value > .5 && e.define(`${i}_WORLDSPACE`), e.require("worldPosition"), e.addFragmentVariable(this.calpha, "float");
            let o = e.include(s), a = [];
            return a.push(this.near.build(e, "f")), a.push(this.far.build(e, "f")), a.push(this.origin.build(e, "v3")), a.push(this.direction.build(e, "v3")), a.push(this.colors.build(e, "v4[]")), a.push(this.steps.build(e, "f[]")), a.push(this.isMask.build(e, "b")), a.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), a.push(this.alpha.build(e, "f")), a.push(this.calpha), e.format(o + "(" + a.join(",") + ")", this.getType(e), r);
        } else return console.warn("DepthNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Uh = Vh;
Uh.Nodes = function() {
    let e = new ge(`float vectorLinearWorldSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(vWPosition.x - origin.x) + n.y*(vWPosition.y - origin.y) + n.z*(vWPosition.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), r = new ge(`float vectorLinearObjectSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(position.x - origin.x) + n.y*(position.y - origin.y) + n.z*(position.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), i = new ge(`float vectorSphericalWorldSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(vWPosition - origin);
               return ( dist - near ) / ( far - near );
            }`), s = new ge(`float vectorSphericalObjectSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(position - origin);
               return ( dist - near ) / ( far - near );
            }`);
    return {
        vectorLinearWorldSpaceDepth: e,
        vectorLinearObjectSpaceDepth: r,
        vectorSphericalWorldSpaceDepth: i,
        vectorSphericalObjectSpaceDepth: s
    };
}();
var ym = class extends Xe {
    constructor(e, r, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Fresnel";
        this.color = e, this.bias = r, this.scale = i, this.intensity = s, this.factor = o, this.isMask = u, this.alpha = a, this.mode = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = new ge(`vec3 fresnel(vec3 color, float bias, float scale, float intensity, float factor, bool isMask, float mask, float alpha, int mode, out float calpha) {
					float fresnel = bias + scale * pow( abs( factor + dot( normalize( vWorldViewDir ), normalize( vWNormal ) ) ), intensity );

					float lalpha = clamp(fresnel, 0.0, 1.0) * alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return color;
				}`), s = e.include(i), o = [];
            return o.push(this.color.build(e, "c")), o.push(this.bias.build(e, "f")), o.push(this.scale.build(e, "f")), o.push(this.intensity.build(e, "f")), o.push(this.factor.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("FresnelNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var CA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c){
        super("v3");
        this.nodeType = "Gradient";
        this.gradientType = e, this.smooth = r, this.colors = i, this.steps = s, this.offset = o, this.morph = a, this.angle = l, this.isMask = c, this.alpha = u, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.define("GRAD_MAX", 10), e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(CA.Nodes.gradient), s = [];
            return s.push(this.gradientType.build(e, "i")), s.push(this.smooth.build(e, "b")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.offset.build(e, "v2")), s.push(this.morph.build(e, "v2")), s.push(this.angle.build(e, "f")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("GradientNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Gh = CA;
Gh.Nodes = function() {
    return {
        gradient: new ge(`vec3 gradient(int gradientType, bool smoothed, vec4 colors[GRAD_MAX], float steps[GRAD_MAX], vec2 offset, vec2 morph, float angle, bool isMask, float mask, float alpha, out float calpha) {
				vec4 color = colors[0];
				vec2 m = morph / vUv.xy;
				vec2 rot = vec2( 0.5 + m.x, m.y );
				vec2 dt = vec2(
					cos( angle ) * rot.x - sin( angle ) * rot.y,
					sin( angle ) * rot.x + cos( angle ) * rot.y
				);
				vec2 pt = ( vUv - 0.5 + offset ) / 2.0 + dt / 2.0;
				float t = dot( pt, dt ) / dot( dt, dt );
				if ( gradientType == 1 ) {
					t = distance (
						( vUv + morph ) * 3.0,
						( vUv + offset ) + 1.0
					) + angle;
				} else if ( gradientType == 2 ) {
					float polar = atan(
						vUv.x + morph.x - 0.5 + offset.x,
						vUv.y + morph.y - 0.5 + offset.y
					) * -1.0;
					t = fract( ( angle / PI / -2.0 ) + 0.5 * ( polar / PI ) );
				}

				float p;
				if (smoothed) {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}

				} else {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], p);
					}
				}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
				
				return color.xyz;
			}`)
    };
}();
var PA = class extends Xe {
    constructor(e, r, i, s){
        super("v3");
        this.nodeType = "Matcap";
        this.texture = e, this.isMask = s, this.alpha = r, this.mode = i, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = e.include(PA.Nodes.matcap);
            e.require("normal"), e.requires.normal = !0;
            let s = [];
            return s.push(this.texture.generate(e, "t")), s.push("normal"), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.mode.build(e, "i")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("MatcapNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, jh = PA;
jh.Nodes = function() {
    return {
        matcap: new ge(`vec3 matcap(sampler2D matcapTex, vec3 normal, bool isMask, float mask, float alpha, int mode, out float calpha) {
					vec3 viewDir = normalize( vViewPosition );
					vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
					vec3 y = cross( viewDir, x );
					vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5; // 0.495 to remove artifacts caused by undersized matcap disks
					vec4 matcapColor = texture2D( matcapTex, uv );

					float lalpha = alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
					
					return matcapColor.rgb;
            	}`)
    };
}();
var vm = ((o)=>(o.SIMPLEX = "simplex3d", o.SIMPLEX_FRACTAL = "simplex3dFractal", o.ASHIMA = "simplexAshima", o.FBM = "fbm", o.PERLIN = "perlin", o.VORONOI = "voronoi", o))(vm || {}), Ui = function() {
    let t = new ge(`vec3 random3(vec3 c) {
			float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
			vec3 r;
			r.z = fract(512.0*j);
			j *= .125;
			r.x = fract(512.0*j);
			j *= .125;
			r.y = fract(512.0*j);
			return r-0.5;
		}`), e = new ge(`float simplex3d(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 vec3 x = p - s + dot(s, vec3(G3));
			 
			 vec3 e = step(vec3(0.0), x - x.yzx);
			 vec3 i1 = e*(1.0 - e.zxy);
			 vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 vec3 x1 = x - i1 + G3;
			 vec3 x2 = x - i2 + 2.0*G3;
			 vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(s), x);
			 d.y = dot(random3(s + i1), x1);
			 d.z = dot(random3(s + i2), x2);
			 d.w = dot(random3(s + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    e.keywords.F3 = new Ft("float F3 0.3333333"), e.keywords.G3 = new Ft("float G3 0.1666667");
    let r = new ge(`float simplex3dFractal(vec3 m) {
			mat3 rot1 = mat3(-0.37, 0.36, 0.85,-0.14,-0.93, 0.34,0.92, 0.01,0.4);
			mat3 rot2 = mat3(-0.55,-0.39, 0.74, 0.33,-0.91,-0.24,0.77, 0.12,0.63);
			mat3 rot3 = mat3(-0.71, 0.52,-0.47,-0.08,-0.72,-0.68,-0.7,-0.45,0.56);
			return 0.5333333 * simplex3d(m * rot1)
				 + 0.2666667 * simplex3d(2.0 * m * rot2)
				 + 0.1333333 * simplex3d(4.0 * m * rot3)
				 + 0.0666667 * simplex3d(8.0 * m);
		}`, [
        e
    ]), i = new ge("vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}"), s = new ge("vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}"), o = new ge(`float simplexAshima(vec3 v) {
		  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
		  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
		  vec3 i  = floor(v + dot(v, C.yyy) );
		  vec3 x0 =   v - i + dot(i, C.xxx) ;
		  vec3 g = step(x0.yzx, x0.xyz);
		  vec3 l = 1.0 - g;
		  vec3 i1 = min( g.xyz, l.zxy );
		  vec3 i2 = max( g.xyz, l.zxy );
		  vec3 x1 = x0 - i1 + 1.0 * C.xxx;
		  vec3 x2 = x0 - i2 + 2.0 * C.xxx;
		  vec3 x3 = x0 - 1. + 3.0 * C.xxx;
		  i = mod(i, 289.0 ); 
		  vec4 p = permute( permute( permute( 
					 i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
				   + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
				   + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
		  float n_ = 1.0/7.0; // N=7
		  vec3  ns = n_ * D.wyz - D.xzx;
		  vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)
		  vec4 x_ = floor(j * ns.z);
		  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
		  vec4 x = x_ *ns.x + ns.yyyy;
		  vec4 y = y_ *ns.x + ns.yyyy;
		  vec4 h = 1.0 - abs(x) - abs(y);
		  vec4 b0 = vec4( x.xy, y.xy );
		  vec4 b1 = vec4( x.zw, y.zw );
		  vec4 s0 = floor(b0)*2.0 + 1.0;
		  vec4 s1 = floor(b1)*2.0 + 1.0;
		  vec4 sh = -step(h, vec4(0.0));
		  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
		  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
		  vec3 p0 = vec3(a0.xy,h.x);
		  vec3 p1 = vec3(a0.zw,h.y);
		  vec3 p2 = vec3(a1.xy,h.z);
		  vec3 p3 = vec3(a1.zw,h.w);
		  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
		  p0 *= norm.x;
		  p1 *= norm.y;
		  p2 *= norm.z;
		  p3 *= norm.w;
		  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
		  m = m * m;
		  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
										dot(p2,x2), dot(p3,x3) ) );
		}`, [
        i,
        s
    ]), a = new ge("vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}"), l = new ge("vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}", [
        a
    ]), u = new ge(`float noise(vec3 p){
			vec3 a = floor(p);
			vec3 d = p - a;
			d = d * d * (3.0 - 2.0 * d);
			vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
			vec4 k1 = perm(b.xyxy);
			vec4 k2 = perm(k1.xyxy + b.zzww);
			vec4 c = k2 + a.zzzz;
			vec4 k3 = perm(c);
			vec4 k4 = perm(c + 1.0);
			vec4 o1 = fract(k3 * (1.0 / 41.0));
			vec4 o2 = fract(k4 * (1.0 / 41.0));
			vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
			vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);
			return o4.y * d.y + o4.x * (1.0 - d.y);
		}`, [
        l
    ]), c = new ge(`float fbm(vec3 x) {
			float v = 0.0;
			float a = 0.5;
			vec3 shift = vec3(100);
			for (int i = 0; i < NUM_OCTAVES; ++i) {
				v += a * noise(x);
				x = x * 2.0 + shift;
				a *= 0.5;
			}
			return v;
		}`, [
        u
    ]);
    c.keywords.NUM_OCTAVES = new Ft(`int NUM_OCTAVES ${5}`);
    let d = new ge("vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}"), h = new ge(`float perlin(vec3 P){
		  vec3 Pi0 = floor(P);
		  vec3 Pi1 = Pi0 + vec3(1.0);
		  Pi0 = mod(Pi0, 289.0);
		  Pi1 = mod(Pi1, 289.0);
		  vec3 Pf0 = fract(P);
		  vec3 Pf1 = Pf0 - vec3(1.0);
		  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
		  vec4 iy = vec4(Pi0.yy, Pi1.yy);
		  vec4 iz0 = Pi0.zzzz;
		  vec4 iz1 = Pi1.zzzz;
		  vec4 ixy = permute(permute(ix) + iy);
		  vec4 ixy0 = permute(ixy + iz0);
		  vec4 ixy1 = permute(ixy + iz1);
		  vec4 gx0 = ixy0 / 7.0;
		  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
		  gx0 = fract(gx0);
		  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
		  vec4 sz0 = step(gz0, vec4(0.0));
		  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
		  gy0 -= sz0 * (step(0.0, gy0) - 0.5);
		  vec4 gx1 = ixy1 / 7.0;
		  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
		  gx1 = fract(gx1);
		  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
		  vec4 sz1 = step(gz1, vec4(0.0));
		  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
		  gy1 -= sz1 * (step(0.0, gy1) - 0.5);
		  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
		  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
		  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
		  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
		  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
		  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
		  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
		  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
		  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
		  g000 *= norm0.x;
		  g010 *= norm0.y;
		  g100 *= norm0.z;
		  g110 *= norm0.w;
		  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
		  g001 *= norm1.x;
		  g011 *= norm1.y;
		  g101 *= norm1.z;
		  g111 *= norm1.w;
		  float n000 = dot(g000, Pf0);
		  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
		  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
		  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
		  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
		  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
		  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
		  float n111 = dot(g111, Pf1);
		  vec3 fade_xyz = fade(Pf0);
		  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
		  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
		  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
		  return 2.2 * n_xyz;
		}`, [
        i,
        s,
        d
    ]), f = new ge(`float hashwithoutsine13(vec3 p3)
		{
			p3  = fract(p3 * .1031);
			p3 += dot(p3, p3.yzx + 33.33);
			return fract((p3.x + p3.y) * p3.z);
		}`), p = new ge(`vec3 hashwithoutsine33(vec3 p3)
		{
			p3 = fract(p3 * vec3(.1031, .1030, .0973));
			p3 += dot(p3, p3.yxz+33.33);
			return fract((p3.xxy + p3.yxx)*p3.zyx);
		}`), m = new ge(`float metric(in vec3 p)
		{
			// L2 
			return length(p);

			// Chebyshev 
			// vec3 a = abs(p);
			// return max(a.x, max(a.y, a.z));
		}`), g = new ge(`float smin( float a, float b, float k )
		{
			float h = smoothstep(0.0, 1.0, 0.5 + 0.5 * (b - a) / k);
			float correction = k * h * (1.0 - h);
			return mix(b, a, h) - correction;
		}`), y = new ge(`float smax( float a, float b, float k )
		{
			float h = smoothstep(1.0, 0.0, 0.5 + 0.5 * (a - b) / k);
			float correction = k * h * (1.0 - h);
			return mix(a, b, h) + correction;
		}`), v = new ge(`float remap(float value, float input_min, float input_max, float output_min, float output_max) {
			// Compute width of each interval
			float input_width = input_max - input_min;
			float output_width = output_max - output_min;
		
			// Convert input range into a 0-1 range 
			float scaled = (value - input_min) / input_width;
		
			// Convert the 0-1 range into a value in output range
			return output_min + (scaled * output_width);
		}`), x = new ge(`float voronoi(in vec3 x, in int style, in float smoothness, in float seed, in int quality) 
		{
			// Integer and fractional parts of this point's coordinates
			ivec3 p = ivec3(floor(x));
			vec3 f = fract(x);

			// Different variables that we will use to construct noise:
			//
			// f1: distance to the closest feature point
			// f2: distance to the second closest feature point
			// e: distance to the closest edge (cell boundary)
			//
			// We also compute "smooth" versions of all of the above quantites, essentially
			// replacing "hard" minimums with "smooth" minimums (described by IQ)
			float f1_smooth = 8.0;
			float f1 = 8.0;
			float f2_smooth = 8.0;
			float f2 = 8.0;
			float e_smooth = 8.0;
			float e = 8.0;

			// Variables stored from closest cell
			ivec3 mb;
			vec3 mr; 

			int steps = quality;
			
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				ivec3 b = ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d = length(r);
				
				f1_smooth = smin(d, f1_smooth, smoothness);

				// Store un-smoothed distances too 
				if (d < f1) 
				{
					f2 = f1;
					f1 = d;

					mb = ivec3(x, y, z);
					mr = r;
				} 
				else if (d < f2) 
				{
					f2 = d;
				}
			}	
			
			float id = hashwithoutsine13(vec3(p + mb) + seed);

			// Second pass for edge distance  
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				// Start search at the cell that contains the closest point to "x" (found in 1st pass)
				ivec3 b = mb + ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d1 = dot(0.5 * (mr + r), (r - mr)); 				// IQ normalizes "r - mr" but that breaks things for the smooth version?
				float d2 = dot(0.5 * (mr + r), normalize(r - mr));

				e_smooth = smin(d1, e_smooth, smoothness);

				e = min(e, d2);

				// Also compute a smooth version of F2 in this pass
				{
					ivec3 b = ivec3(x, y, z);
					if (b != mb) 
					{
						vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
						float d = length(r);

						f2_smooth = smin(d, f2_smooth, smoothness);
					}
				}
			}

			// Different visualization modes 
			if (style == 0) 
			{
				return f1_smooth;
			}
			if (style == 1) 
			{
				return f2_smooth;
			}
			if (style == 2) 
			{
				return f2_smooth - f1_smooth;
				
				// "Pebbles" also cool
				//return step(0.2, f2_smooth - f1_smooth);
			}
			if (style == 3) 
			{
				// This one is really good for rock / stone effects
				float a = f1; 
				float b = f2;
				float k = 3.0;
				float h = max(k - abs(a - b), 0.0) / k;
				float final = min(a, b) - h * h * k * (1.0 / 4.0);
				return final;
			}
			if (style == 4) 
			{
				// Some random adjustments to make this style stand out more 
				return exp(5.0 * e_smooth);
			}
			if (style == 5) 
			{
				return pow(f1_smooth, 3.0);
			}
			if (style == 6) 
			{				
				const float eps = 0.0125;

				// Thicker lines as the user increases the smoothness slider
				float thickness = smoothness * 0.25 + eps;

				// Blurrier lines as the user increases the smoothness slider
				float blur = pow(smoothness, 3.0) * 0.25 + eps;

				return smoothstep(
					thickness - thickness * blur, 
					thickness + thickness * blur, 
					e
				);
			}
			if (style == 7) 
			{
				return hashwithoutsine13(vec3(p + mb) + seed);
			}
		}
	`, [
        f,
        p,
        m,
        g,
        y,
        v
    ]);
    return {
        simplex: e,
        simplexFractal: r,
        simplexAshima: o,
        fbm: c,
        perlin: h,
        voronoi: x
    };
}();
var Hh = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h, f, p, m, g, y, v, x, S){
        super("v3");
        this.nodeType = "Noise";
        this.scale = e, this.size = r, this.move = i, this.fA = s, this.fB = o, this.distortion = a, this.colorA = l, this.colorB = u, this.colorC = c, this.colorD = d, this.noiseType = f, this.voronoiStyle = m, this.highCut = g, this.lowCut = y, this.smoothness = v, this.seed = x, this.quality = S, this.isMask = p, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r, i, s, o) {
        e.require("uv"), e.requires.uv = [
            !0
        ], e.addFragmentVariable(this.calpha, "float");
        let a = Object.values(vm)[this.noiseType.value], l = a == "voronoi" ? `
		float v = ${a}(st + move, voronoiStyle, smoothness, seed, quality);

		// Apply clipping to colors
		v = remap(v, lowCut, highCut, 0.0, 1.0);
		v = smax(v, 0.0, smoothness * 0.25);
		v = smin(v, 1.0, smoothness * 0.25);

		// Note that the voronoi mode only uses colors "A" and "C" from the UI 
		vec4 color = mix(colorA, colorC, v); 
		` : `
		vec3 q = vec3(${a}(st),
					   ${a}(st + vec3(1.0)),
					   ${a}(st + vec3(1.0)));
		vec3 r = vec3(${a}(st + vec3(distortion, 1.0) * q + vec3(fA, 1.0) + move),
					  ${a}(st + vec3(distortion, 1.0) * q + vec3(fB, 1.0) + move), 
					  ${a}(st * q));
		float f = ${a}(st + r);
		vec4 color;
		color = mix(colorA, colorB, clamp((f * f) * 4.0, 0.0, 1.0));
		color = mix(color, colorC, clamp(length(q), 0.0, 1.0));
		color = mix(color, colorD, clamp(length(r.x), 0.0, 1.0));
		`, u = new ge(`vec3 ${a}customNoise(float scale, vec3 size, float move, vec2 fA, vec2 fB, vec2 distortion, vec4 colorA, vec4 colorB, vec4 colorC, vec4 colorD, int voronoiStyle, float highCut, float lowCut, float smoothness, float seed, int quality, bool isMask, float mask, float alpha, out float calpha) 
			{
                // Prevent scale of zero 
				scale = max(abs(scale), 0.001);

				vec3 st = position / size;
				st /= scale;

				${l}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return clamp(color, 0.0, 1.0).rgb;
			}`, [
            Ui.simplex,
            Ui.simplexFractal,
            Ui.simplexAshima,
            Ui.fbm,
            Ui.perlin,
            Ui.voronoi
        ]), c = e.include(u), d = [];
        return d.push(this.scale.build(e, "f")), d.push(this.size.build(e, "v3")), d.push(this.move.build(e, "f")), d.push(this.fA.build(e, "v2")), d.push(this.fB.build(e, "v2")), d.push(this.distortion.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.colorC.build(e, "v4")), d.push(this.colorD.build(e, "v4")), d.push(this.voronoiStyle.build(e, "i")), d.push(this.highCut.build(e, "f")), d.push(this.lowCut.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.seed.build(e, "f")), d.push(this.quality.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(c + "(" + d.join(",") + ")", this.getType(e), r);
    }
};
Hh.numOctaves = 5;
var DA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h, f, p, m, g, y){
        super("v3");
        this.nodeType = "Outline";
        this.firstTime = !0, this.outlineColor = e, this.contourColor = r, this.outlineWidth = i, this.contourWidth = s, this.contourThreshold = o, this.outlineThreshold = a, this.contourFrequency = l, this.outlineSmoothing = u, this.contourDirection = c, this.positionalLines = d, this.compensation = h, this.resolution = f, this.normalMap = p, this.depthMap = m, this.pixelRatio = g, this.alpha = y, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`;
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.extensions.derivatives = !0, this.compensation.value && e.define("OUTLINE_COMPENSATION", `${i}_offset`), this.firstTime) {
            let s = this.outlineWidth.build(e, "f"), o = this.resolution.build(e, "v2"), a = this.compensation.build(e, "b"), l = this.pixelRatio.build(e, "f");
            e.addVertexParsVariable("randomColor", "attribute vec3"), e.addVertexParsVariable("extrudeNormal", "attribute vec3"), e.addVertexParsVariable(s, "uniform float"), e.addVertexParsVariable(o, "uniform vec2"), e.addVertexParsVariable(a, "uniform bool"), e.addVertexParsVariable(l, "uniform float"), e.addVertexParsVariable("vID", "flat out float"), e.addFragmentParsVariable("vID", "flat in float"), e.addVertexFinalCode(`
                vID = randomColor.r;
                vec2 ${i}_offset = vec2(0.0);
                if (${a}) {
                    vec4 ${i}_clipPosition = projectionMatrix * (modelViewMatrix * vec4(position, 1.0));
                    // NOTE: For certain shapes, like spheres, we get incorrect extrusion when the
                    // normals face the camera directly. So we hackily fix this by offsetting the normal
                    // by a tiny amount.
                    vec3 ${i}_clipNormal = mat3(projectionMatrix) * (mat3(modelViewMatrix) * extrudeNormal) + 0.0000001;
                    ${i}_offset = normalize(${i}_clipNormal.xy) / ${o} * (${s} / 2.0) * ${i}_clipPosition.w * 2.0 * ${l};
                    ${i}_clipPosition.xy += ${i}_offset;
                    // TODO(MAX): To handle multiple outline layers, we only want to extrude
                    // if this offset is the biggest of all the potential offsets
                    gl_Position = ${i}_clipPosition;
                }
            `);
        }
        if (e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let s = e.include(DA.Nodes.outline), o = [];
            return o.push(this.outlineColor.build(e, "c")), o.push(this.contourColor.build(e, "c")), o.push(this.outlineWidth.build(e, "f")), o.push(this.contourWidth.build(e, "f")), o.push(this.contourThreshold.build(e, "f")), o.push(this.outlineThreshold.build(e, "f")), o.push(this.contourFrequency.build(e, "f")), o.push(this.outlineSmoothing.build(e, "f")), o.push(this.contourDirection.build(e, "v3")), o.push(this.positionalLines.build(e, "b")), o.push(this.resolution.build(e, "v2")), o.push(this.normalMap.getTexture(e, "t")), o.push(this.depthMap.getTexture(e, "t")), o.push(this.pixelRatio.build(e, "f")), o.push(this.compensation.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.calpha), this.firstTime = !this.firstTime, e.format(s + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("OutlineNode is not compatible with " + e.shader + " shader."), "";
    }
}, Wh = DA;
Wh.Nodes = function() {
    let e = new ge(`
float sobelSample(sampler2D t, sampler2D d, vec2 uv, vec2 resolution, float outlineWidth, float pixelRatio)
{
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    vec2 texelSize = (vec2(1.0) / resolution);
    vec2 offsetSize = texelSize * outlineWidth * pixelRatio;

    vec2 uvSamples[9];
    vec4 normalSamples[9];

	uvSamples[0] = uv + vec2( -offsetSize.x, -offsetSize.y) + (vogelDiskSample(0, 9, temporalAngle) * texelSize);
	uvSamples[1] = uv + vec2(0.0, -offsetSize.y) + (vogelDiskSample(1, 9, temporalAngle) * texelSize);
	uvSamples[2] = uv + vec2(  offsetSize.x, -offsetSize.y) + (vogelDiskSample(2, 9, temporalAngle) * texelSize);
	uvSamples[3] = uv + vec2( -offsetSize.x, 0.0) + (vogelDiskSample(3, 9, temporalAngle) * texelSize);
	uvSamples[4] = uv;
	uvSamples[5] = uv + vec2(  offsetSize.x, 0.0) + (vogelDiskSample(5, 9, temporalAngle) * texelSize);
	uvSamples[6] = uv + vec2( -offsetSize.x, offsetSize.y) + (vogelDiskSample(6, 9, temporalAngle) * texelSize);
	uvSamples[7] = uv + vec2(0.0, offsetSize.y) + (vogelDiskSample(7, 9, temporalAngle) * texelSize);
	uvSamples[8] = uv + vec2(  offsetSize.x, offsetSize.y) + (vogelDiskSample(8, 9, temporalAngle) * texelSize);


    normalSamples[0] = texture2D(t, uvSamples[0]);
    normalSamples[1] = texture2D(t, uvSamples[1]);
    normalSamples[2] = texture2D(t, uvSamples[2]);
    normalSamples[3] = texture2D(t, uvSamples[3]);
    normalSamples[4] = texture2D(t, uvSamples[4]);
    normalSamples[5] = texture2D(t, uvSamples[5]);
    normalSamples[6] = texture2D(t, uvSamples[6]);
    normalSamples[7] = texture2D(t, uvSamples[7]);
    normalSamples[8] = texture2D(t, uvSamples[8]);

    float depthBias = 0.0001;
    // TODO(MAX): Can we somehow reduce the number of conditionals here with MATH?!
    if (normalSamples[0].a != vID && normalSamples[0].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[0]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[1].a != vID && normalSamples[1].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[1]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[2].a != vID && normalSamples[2].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[2]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[3].a != vID && normalSamples[3].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[3]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }


    if (normalSamples[4].a != vID && normalSamples[4].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[4]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[5].a != vID && normalSamples[5].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[5]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[6].a != vID && normalSamples[6].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[6]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[7].a != vID && normalSamples[7].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[7]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[8].a != vID && normalSamples[8].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[8]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    vec3 sobel_edge_h = normalSamples[2].rgb + (2.0*normalSamples[5].rgb) + normalSamples[8].rgb - (normalSamples[0].rgb + (2.0*normalSamples[3].rgb) + normalSamples[6].rgb);
  	vec3 sobel_edge_v = normalSamples[0].rgb + (2.0*normalSamples[1].rgb) + normalSamples[2].rgb - (normalSamples[6].rgb + (2.0*normalSamples[7].rgb) + normalSamples[8].rgb);

    float edgeNormal = sqrt(dot(sobel_edge_h, sobel_edge_h) + dot(sobel_edge_v, sobel_edge_v));
    return edgeNormal;
}
`);
    return {
        outline: new ge(`vec3 outline(vec3 outlineColor, vec3 contourColor, float outlineWidth, float contourWidth, float outlineThreshold, float contourThreshold, float outlineSmoothing, float contourFrequency, vec3 contourDirection, bool positionalLines, vec2 resolution, sampler2D normalMap, sampler2D depthMap, float pixelRatio, bool compensation, float mask, float alpha, out float calpha) {
                vec3 result = outlineColor;
                float resultAlpha = 0.0;

                vec3 N = normalize(vWNormal);
                vec2 nuv = (gl_FragCoord.xy / resolution);
                float sobelSample = compensation ? sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth / 2., pixelRatio) : sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth, pixelRatio);
                resultAlpha = smoothstep(outlineThreshold - outlineSmoothing, outlineThreshold + outlineSmoothing, sobelSample);

                //resultAlpha = 1.0;
                //result = vec3(sobelSample);

                float t = 1.0 - contourThreshold;
                if(positionalLines) {
                    vec3 NDir = position * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float f  = fract(NT * contourFrequency * 0.01);
                    float df = fwidth(NT * contourFrequency);

                    float g = smoothstep(df * (contourWidth * 0.01), df * (contourWidth * 0.01 * 2.0), f);
                    if (g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0;
                    }
                 }
                 else {
                    vec3 NDir = N * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float df = fwidth(NT * contourThreshold);
                    float f = sin(NT * 1.0 * contourFrequency);
                    float g = smoothstep(0.0, df * contourWidth, 1.0 - f);

                    if (df > (t * 0.5) && g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0 - g;
                    }
                 }

                 float lalpha = alpha * resultAlpha * mask;
                 calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
                 accumAlpha += ( 1.0 - accumAlpha ) * lalpha;
				 
                 return result;
             }`, [
            e
        ])
    };
}();
var Oo = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h, f, p, m, g, y, v, x){
        super("v3");
        this.nodeType = "Pattern";
        this.style = e, this.projection = r, this.axis = i, this.blending = s, this.offset = o, this.colorA = a, this.colorB = l, this.frequency = u, this.size = c, this.variation = d, this.smoothness = h, this.zigzag = f, this.rotation = p, this.vertical = m, this.horizontal = g, this.sides = y, this.isMask = x, this.alpha = v, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.require("position"), e.require("uv"), e.requires.uv = [
                !0
            ], e.require("normal"), e.requires.normal = !0, e.addFragmentVariable(this.calpha, "float");
            let i;
            switch(this.style.value){
                case 0:
                    i = "circle";
                    break;
                case 1:
                    i = "ring";
                    break;
                case 2:
                    i = "polygon";
                    break;
                case 3:
                    i = "xcross";
                    break;
                case 4:
                    i = "diamond";
                    break;
                case 5:
                    i = "checkerboard";
                    break;
                case 6:
                    i = "line";
                    break;
                case 7:
                    i = "wave";
                    break;
                default:
                    i = "circle";
                    break;
            }
            let s = `g${this.uuid.toString().replace(/-/g, "")}`, o = new ge(`float hashwithoutsine12(vec2 p)
				{
					vec3 p3 = fract(vec3(p.xyx) * .1031);
					p3 += dot(p3, p3.yzx + 33.33);
					return fract((p3.x + p3.y) * p3.z);
				}`), a = new ge(`vec2 rotate_uv(in vec2 uv, float a, bool repeat) 
				{
					const float mid = 0.5;
					float radians = a * (PI / 180.0);
					vec2 rotated = vec2(
						cos(radians) * (uv.x - mid) + sin(radians) * (uv.y - mid) + mid,
						cos(radians) * (uv.y - mid) - sin(radians) * (uv.x - mid) + mid
					);
					return repeat ? fract(rotated): rotated;
				}`), l = "";
            if (this.projection.value === 4) {
                let h = this.style.value === 2 ? `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = this.style.value === 2 ? `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, p = this.style.value === 2 ? `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation)`;
                l = `
				vec3 p = position;
				float factor = 0.0125;
				vec2 uv0 = fract(p.xy * factor);
				vec2 uv1 = fract(p.zy * factor);
				vec2 uv2 = fract(p.xz * factor);
				
				uv0 = rotate_uv(uv0 + offset, rotation, true);
				uv1 = rotate_uv(uv1 + offset, rotation, true);
				uv2 = rotate_uv(uv2 + offset, rotation, true);
	
				float d0 = ${h};
				float d1 = ${f};
				float d2 = ${p};
				
				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));
				d0 *= weights.z;
				d1 *= weights.x;
				d2 *= weights.y;
				float draw = d0 + d1 + d2;
	
				vec2 custom_uv = uv0 * weights.z + uv1 * weights.x + uv2 * weights.y;
				`;
            } else {
                let h = this.style.value === 2 ? `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = "";
                this.axis.value === 0 ? f = `float radius = length(p);
					float theta = atan(p.y, p.z);
					float phi = acos(p.x / radius);` : this.axis.value === 1 ? f = `float radius = length(p);
					float theta = atan(p.x, p.z);
					float phi = acos(p.y / radius);` : (this.axis.value, f = `float radius = length(p);
					float theta = atan(p.y, p.x);
					float phi = acos(p.z / radius);`);
                let p = "";
                switch(this.projection.value){
                    case 0:
                        p = "custom_uv = vUv.st;";
                        break;
                    case 1:
                        break;
                    case 2:
                        p = `
							vec3 p = position;
							${f}
							custom_uv = vec2(theta, phi);
							custom_uv /= PI;
							`;
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
                l = `
				vec2 custom_uv;
				${p}
	
				custom_uv += offset;
				custom_uv = fract(custom_uv);
				custom_uv = rotate_uv(custom_uv, rotation, true);
	
				float draw = ${h};
				`;
            }
            let u = new ge(`vec3 ${s}_pattern(vec3 normal, float blending, int style, vec2 offset, vec4 colorA, vec4 colorB, vec2 frequency, float size, float variation, float smoothness, float zigzag, float rotation, vec2 vertical, vec2 horizontal, int sides, bool isMask, float mask, float alpha, out float calpha) {
					const float TWO_PI = PI * 2.0;
					float smoothness_remapped = pow(smoothness, 5.0);	

					${l}

					// Construct final output color
					vec4 color = mix(colorA, colorB, draw);
					color.a = clamp(color.a, 0.0, 1.0);

					// Apply cuts
					color.a *= 
						step(vertical.x, custom_uv.y) * 
						step(custom_uv.y, vertical.y);
					color.a *= 
						step(horizontal.x, abs(custom_uv.x)) * 
						step(abs(custom_uv.x), horizontal.y);

					// Accumulate alpha 
					float lalpha = alpha * clamp(color.a, 0.0, 1.0) * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return clamp(color, 0.0, 1.0).rgb;
				}`, [
                a,
                o,
                Oo.DrawFunctions.circle,
                Oo.DrawFunctions.ring,
                Oo.DrawFunctions.polygon,
                Oo.DrawFunctions.cross,
                Oo.DrawFunctions.diamond,
                Oo.DrawFunctions.checkerboard,
                Oo.DrawFunctions.line,
                Oo.DrawFunctions.wave
            ]), c = e.include(u), d = [];
            return d.push("normal"), d.push(this.blending.build(e, "f")), d.push(this.style.build(e, "i")), d.push(this.offset.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.frequency.build(e, "v2")), d.push(this.size.build(e, "f")), d.push(this.variation.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.zigzag.build(e, "f")), d.push(this.rotation.build(e, "f")), d.push(this.vertical.build(e, "v2")), d.push(this.horizontal.build(e, "v2")), d.push(this.sides.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(c + "(" + d.join(",") + ")", this.getType(e), r);
        } else return console.warn("PatterNode is not compatible with " + e.shader + " shader."), e.format("vec3(0.0)", this.getType(e), r);
    }
}, qh = Oo;
qh.DrawFunctions = function() {
    let e = new ge(`float hashwithoutsine12(vec2 p) {
				vec3 p3 = fract(vec3(p.xyx) * 0.1031);
				p3 += dot(p3, p3.yzx + 33.33);
				return fract((p3.x + p3.y) * p3.z);
			}`), r = new ge(`vec2 tile_and_center(in vec2 uv, in vec2 frequency, in float variation, in float zigzag, in float rotation) {
                // Create tiles in UV-space
                uv *= frequency;

                // Integer coords
                vec2 i = floor(uv);

                // Offset every other row based on zigzag param, then compute fractional coords
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = fract(uv);

				// Rotate the tile itself:
				// const float mid = 0.5;
				// f = vec2(
				// 	cos(rotation) * (f.x - mid) + sin(rotation) * (f.y - mid) + mid,
				// 	cos(rotation) * (f.y - mid) - sin(rotation) * (f.x - mid) + mid
				// );
				// f = fract(f);

                f = f * 2.0 - 1.0;

				// Recompute integer coords after shifting - then, random value per tile 
				i = floor(uv);
				float rand = (hashwithoutsine12(i) * 5.0 + 1.0);
				float jitter = mix(1.0, rand, variation);
				f *= jitter;

                return f;
            }`, [
        e
    ]), i = new ge(`float circle(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(
                    -smoothness, 
                     smoothness, 
                     length(f) - size
                );
            }`, [
        r
    ]), s = new ge(`float ring(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);

				float d = length(f);
                const float inner_width = 0.5;

                float outer = smoothstep(-smoothness, smoothness, d - size);
                float inner = smoothstep(-smoothness, smoothness, d - size * inner_width);
				return outer + (1.0 - inner);   
            }`, [
        r
    ]), o = new ge(`float sdf_ngon(in vec2 p, in float r, in int n) {
                float an = (PI * 2.0) / float(n);
                float he = r * tan(0.5 * an);
                
                // Rotate to first sector
                p = -p.yx; 
                float bn = an * floor((atan(p.y, p.x) + 0.5 * an) / an);
                vec2  cs = vec2(cos(bn), sin(bn));
                p = mat2(cs.x, -cs.y, cs.y, cs.x)*p;
            
                // Side of polygon
                return length(p - vec2(r, clamp(p.y, -he, he))) * sign(p.x - r);
            }
            
            float polygon(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation, in int sides) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_ngon(f, size, sides));
            }`, [
        r
    ]), a = new ge(`float sdf_cross(in vec2 p, in vec2 b, float r ) {
                p = abs(p); 
				p = (p.y > p.x) ? p.yx : p.xy;
                vec2  q = p - b;
                float k = max(q.y, q.x);
                vec2  w = (k > 0.0) ? q : vec2(b.y - p.x, -k);
                return sign(k) * length(max(w, 0.0)) + r;
            }
            
            // Avoid namespace conflicts 
            float xcross(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_cross(f, vec2(size, size * 0.25), smoothness));
            }`, [
        r
    ]), l = new ge(`float ndot(vec2 a, vec2 b) { 
                return a.x*b.x - a.y*b.y; 
            }
            
            float sdf_diamond(in vec2 p, in vec2 b) {
                p = abs(p);
                float h = clamp(ndot(b - 2.0 * p, b) / dot(b, b), -1.0, 1.0);
                float d = length(p - 0.5 * b * vec2(1.0 - h, 1.0 + h));
                return d * sign(p.x * b.y + p.y * b.x - b.x * b.y);
            }

            float diamond(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
	            return smoothstep(-smoothness, smoothness, sdf_diamond(f, vec2(size)));
            }`, [
        r
    ]), u = new ge(`float checkerboard(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                uv *= frequency;
                vec2 i = floor(uv);

                float offset = mod(i.y, 2.0);

                uv.x += offset + zigzag * offset;
                float x = floor(uv.x);
                
                return mod(x, 2.0);
            }`), c = new ge(`float line(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, 0.0, zigzag, rotation);
				
				// Different approach for variation param here
				float row = floor(uv * frequency).y;
				float rand = hashwithoutsine12(vec2(row));
				float s = mix(size, size * rand, variation);

				return smoothstep(
					s - smoothness, 
					s + smoothness, 
					abs(f.y)
				);
            }`, [
        r
    ]), d = new ge(`// Uses bisection 
            float udf_cos(in vec2 p, in float a, in float b, in float c, in float d) {
                // Convert all data to a primitive cosine wave
                p = c * (p - vec2(d, a));
                
                const float TWO_PI = PI * 2.0;

                // Reduce to principal half cycle
                p.x = mod(p.x, TWO_PI); 
                if (p.x > PI) {
                    p.x = TWO_PI - p.x;
                }
            
                // Find zero of derivative (minimize distance)
                float xa = 0.0;
                float xb = TWO_PI;

                // 24 bit precision
                for (int i = 0; i < 24; i++) {
                    float x = 0.5 * (xa + xb);
                    float y = x - p.x + b * c * sin(x) * (p.y - b * c * cos(x));
                    if (y < 0.0) xa = x; 
                    else xb = x;
                }
                float x = 0.5 * (xa + xb);
                
                // Compute distance    
                vec2 q = vec2(x, b * c * cos(x));
                return length(p - q) / c;
            }

            float wave(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                float repeat = frequency.x;
                uv *= repeat;
                vec2 i = floor(uv);
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = vec2(uv.x, fract(uv.y));

                // Generalized cosine: y(x) = a + b * cos(cx + d)
                const float amplitude = 0.125;
                float wave_frequency = frequency.y * 0.1;
                float distance_estimate = udf_cos(f, 0.50, amplitude, wave_frequency * (2.0 * PI), 0.0);

				// Different approach for variation param here
				float rand = hashwithoutsine12(vec2(i.y));
				float s = mix(size, size * rand, variation);

                return smoothstep(-smoothness, smoothness, distance_estimate - s * 0.5);
            }`);
    return {
        tileAndCenter: r,
        circle: i,
        ring: s,
        polygon: o,
        cross: a,
        diamond: l,
        checkerboard: u,
        line: c,
        wave: d
    };
}();
var OA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Rainbow";
        this.filmThickness = e, this.movement = r, this.wavelengths = i, this.noiseStrength = s, this.noiseScale = o, this.offset = a, this.isMask = u, this.alpha = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(OA.Nodes.rainbow), s = [];
            return s.push(this.filmThickness.build(e, "f")), s.push(this.movement.build(e, "f")), s.push(this.wavelengths.build(e, "v3")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.offset.build(e, "v3")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("RainbowNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Yh = OA;
Yh.Nodes = function() {
    let e = new ge(`vec3 attenuation(vec3 wavelengths, float filmThickness, float movement, float noiseStrength, float noiseScale, vec3 offset) {
                 vec3 st = position / noiseScale;
				 vec3 q = vec3(simplex3d(st),
							  simplex3d(st + vec3(1.0)),
							  simplex3d(st + vec3(1.0)));

				 vec3 r = vec3(simplex3d(st + vec3(1.4, 1.3, 1.0) * q + vec3(1.7, 9.2, 1.0)),
							  simplex3d(st + vec3(2.0, 1.2, 1.0) * q + vec3(8.3, 2.8, 1.0)),
							  simplex3d(st * q));

                 float noise = simplex3d(st + r);

                 return .5 + .5 * cos((((filmThickness + (noise * noiseStrength)) / (vec3(wavelengths.r * 1.0, wavelengths.g * 0.8, wavelengths.b * 0.6) + 1.0)) * dot(normalize(vWorldViewDir + (offset * -0.001)), normalize(vWNormal))) + movement);
             }`, [
        Ui.simplex
    ]);
    return {
        rainbow: new ge(`vec3 rainbow(float filmThickness, float movement, vec3 wavelengths, float noiseStrength, float noiseScale, vec3 offset, bool isMask, float mask, float alpha, out float calpha) {
				vec3 res = clamp(attenuation(wavelengths, filmThickness, movement, noiseStrength, noiseScale, offset), 0.0, 2.0);

				float rainbowContribution = clamp(res.r + res.g + res.b, 0.0, 1.0);

				float lalpha = alpha * rainbowContribution * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return res;
             }`, [
            e
        ])
    };
}();
var IA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d){
        super("v3");
        this.nodeType = "Toon";
        this.positioning = e, this.colors = r, this.steps = i, this.source = s, this.isWorldSpace = o, this.noiseStrength = a, this.noiseScale = l, this.shadowColor = u, this.offset = c, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("worldNormal"), e.require("worldPosition"), e.isShader("fragment")) {
            e.define("COLORS_MAX", 10), e.addFragmentVariable(this.calpha, "float");
            let i = e.include(IA.Nodes.toon), s = [];
            return s.push(this.positioning.build(e, "i")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.source.build(e, "v3")), s.push(this.isWorldSpace.build(e, "b")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.shadowColor.build(e, "v4")), s.push(this.offset.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("ToonNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Xh = IA;
Xh.Nodes = function() {
    let e = new ge(`float rand(float n) {
				return fract(sin(n) * 43758.5453123);
			}`), r = new ge(`float hash1(float p) { 
				p = fract(p * 0.011); 
				p *= p + 7.5; 
				p *= p + p; 
				return fract(p); 
			}`), i = new ge(`float valueNoise(vec3 x) {
				const vec3 step = vec3(110, 241, 171);
			
				vec3 i = floor(x);
				vec3 f = fract(x);
			 
				// For performance, compute the base input to a 1D hash from the integer part of the argument and the 
				// incremental change to the 1D based on the 3D -> 1D wrapping
				float n = dot(i, step);
			
				vec3 u = f * f * (3.0 - 2.0 * f);
				return mix(mix(mix( hash1(n + dot(step, vec3(0, 0, 0))), hash1(n + dot(step, vec3(1, 0, 0))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 0))), hash1(n + dot(step, vec3(1, 1, 0))), u.x), u.y),
						   mix(mix( hash1(n + dot(step, vec3(0, 0, 1))), hash1(n + dot(step, vec3(1, 0, 1))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 1))), hash1(n + dot(step, vec3(1, 1, 1))), u.x), u.y), u.z);
			}`, [
        r
    ]), s = new ge(`vec3 hash3(vec3 x) {
				x = vec3(dot(x,vec3(127.1, 311.7, 74.7)),
						 dot(x,vec3(269.5, 183.3, 246.1)),
						 dot(x,vec3(113.5, 271.9, 124.6)));
			
				return fract(sin(x)*43758.5453123);
			}`), o = new ge(`vec3 voronoiNoise(in vec3 x)
			{
				vec3 p = floor(x);
				vec3 f = fract(x);

				float id = 0.0;
				vec2 res = vec2(100.0);

				for(int k=-1; k<=1; k++)
				for(int j=-1; j<=1; j++)
				for(int i=-1; i<=1; i++)
				{
					vec3 b = vec3(float(i), float(j), float(k));

					// Comment out the "+ hash(p + b);" part below to get "square" cells
					vec3 r = vec3(b) - f + hash3(p + b);
					float d = dot(r, r);

					if (d < res.x)
					{
						id = dot(p + b, vec3(1.0, 57.0, 113.0));
						res = vec2(d, res.x);			
					}
					else if (d < res.y)
					{
						res.y = d;
					}
				}

				return vec3(sqrt(res), abs(id));
			}
			`, [
        s
    ]);
    return {
        toon: new ge(`vec3 toon(int positioning, vec4 colors[COLORS_MAX], float steps[COLORS_MAX], vec3 source, bool isWorldSpace, float noiseStrength, float noiseScale, vec4 shadowColor, vec3 offset, float mask, float alpha, out float calpha) {
				float t = 0.0;
				float shadow = 1.0;

				if (positioning == 0) {

					// Can't do this mode if lighting is "none"
					#if (defined(PHONG) || defined(LAMBERT) || defined(STANDARD))

						// Algorithm from Chapter 10 of Graphics Shaders
						const vec3 weights = vec3(0.2125, 0.7154, 0.0721);
						vec3 lpos;
						vec3 l;
						float dproduct;

						#if (NUM_POINT_LIGHTS > 0)

							#if defined(USE_SHADOWMAP) && (NUM_POINT_LIGHT_SHADOWS > 0)
								PointLightShadow pointLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_POINT_LIGHTS; i++) {
								// Light positions are in view-space for some reason?
								lpos = (inverse(viewMatrix) * vec4(pointLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								
								// TODO: we want to use "intensity" but it isn't available in the shader code
								//dproduct += dot(pointLights[UNROLLED_LOOP_INDEX].color, weights);

								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS)
									pointLightShadow = pointLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getPointShadow( 
											pointShadowMap[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowMapSize, 
											pointLightShadow.shadowBias, 
											pointLightShadow.shadowRadius,
											vPointShadowCoord[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowCameraNear, 
											pointLightShadow.shadowCameraFar);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_DIR_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_DIR_LIGHT_SHADOWS > 0)
								DirectionalLightShadow directionalLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_DIR_LIGHTS; i++) {
								// Use the direction vector for directional lights instead
								l = (inverse(viewMatrix) * vec4(directionalLights[UNROLLED_LOOP_INDEX].direction, 0.0)).xyz;
		
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS)
									directionalLightShadow = directionalLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow( 
										UNROLLED_LOOP_INDEX,
										directionalShadowMap[UNROLLED_LOOP_INDEX], 
										directionalLightShadow.shadowMapSize, 
										directionalLightShadow.shadowBias, 
										directionalLightShadow.shadowRadius, 
										vDirectionalShadowCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_SPOT_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_SPOT_LIGHT_SHADOWS > 0)
								SpotLightShadow spotLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_SPOT_LIGHTS; i++) {
								lpos = (inverse(viewMatrix) * vec4(spotLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS)
									spotLightShadow = spotLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow(
										UNROLLED_LOOP_INDEX,
										spotShadowMap[UNROLLED_LOOP_INDEX], 
										spotLightShadow.shadowMapSize, 
										spotLightShadow.shadowBias, 
										spotLightShadow.shadowRadius, 
										vSpotLightCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						t = clamp(t, 0.0, 1.0);
				
					#endif

				} else if (positioning == 1) {
					
					vec3 origin = mix(position, worldPosition, float(isWorldSpace));
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	

				} else {

					vec3 origin = worldPosition;
					vec3 source = cameraPosition - offset;
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	
					
				}

				if (noiseStrength > 0.0) {
					// Distort with noise
					vec3 st = position / noiseScale;
					
					// Voronoi "smooth" noise
					float noise = 1.0 - voronoiNoise(st).x;

					// Voronoi cellular noise
					//float noise = 1.0 - rand(voronoiNoise(st).z);

					// Position warp noise
					// vec3 offset = vec3(
					// 	simplex3d(st),
					// 	simplex3d(st + vec3(111.1, 143.89, 217.19)),
					// 	simplex3d(st + vec3(171.1, 247.89, 117.23))
					// );
					// st += offset;
					// float noise = valueNoise(st);

					t += noise * noiseStrength;
				}

				t = clamp(t, 0.0, 1.0);

				// Compute ramp color
				float p;
				vec4 color = colors[0];
				for (int i = 1; i < COLORS_MAX; i++) {
					p = clamp((t - steps[i-1]) / (steps[i] - steps[i-1]), 0.0, 1.0);
					color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
				}

				// Incorporate custom shadow color
				if (positioning == 0) {

					vec3 blendedShadow = mix(color.rgb, shadowColor.rgb, shadowColor.a);
					color.rgb = mix(blendedShadow, color.rgb, shadow);
				
				}

				// Accumulate alpha as usual
				float lalpha = alpha * color.a * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color.xyz;

            }`, [
            Ui.simplex,
            e,
            i,
            o
        ])
    };
}();
var BI = function() {
    return {
        textureBicubic: new ge(`float w0( float a ) {
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
        }
    
        float w1( float a ) {
            return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
        }
    
        float w2( float a ){
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
        }
    
        float w3( float a ) {
            return ( 1.0 / 6.0 ) * ( a * a * a );
        }
    
        // g0 and g1 are the two amplitude functions
        float g0( float a ) {
            return w0( a ) + w1( a );
        }
    
        float g1( float a ) {
            return w2( a ) + w3( a );
        }
    
        // h0 and h1 are the two offset functions
        float h0( float a ) {
            return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
        }
    
        float h1( float a ) {
            return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
        }
    
        vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
            uv = uv * texelSize.zw + 0.5;
    
            vec2 iuv = floor( uv );
            vec2 fuv = fract( uv );
    
            float g0x = g0( fuv.x );
            float g1x = g1( fuv.x );
            float h0x = h0( fuv.x );
            float h1x = h1( fuv.x );
            float h0y = h0( fuv.y );
            float h1y = h1( fuv.y );
    
            vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
            vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
    
            return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) + 
                   g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
        }

        vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
            vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
            vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
            vec2 fLodSizeInv = 1.0 / fLodSize;
            vec2 cLodSizeInv = 1.0 / cLodSize;
            vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
            vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
            return mix( fSample, cSample, fract( lod ) );
        }`)
    };
}();
function NI(n1, t) {
    return n1 >= t ? new N(t / n1, 1) : new N(1, n1 / t);
}
var RA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Transmission";
        this.thickness = e, this.ior = r, this.roughness = i, this.transmissionSamplerSize = s, this.transmissionSamplerMap = o, this.transmissionDepthMap = a, this.aspectRatio = l, this.alpha = u, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0, e.isShader("fragment")) {
            e.define("NUM_SAMPLES", 6), e.define("BLUR_SLOD", Math.pow(2, We.transmissionLod.value)), e.require("worldPosition"), e.requires.worldNormal = !0, e.requires.modelMatrix = !0, e.requires.projectionMatrix = !0, e.addFragmentVariable(this.calpha, "float");
            let i = e.include(RA.Nodes.transmission), s = [];
            return s.push(this.thickness.build(e, "f")), s.push(this.ior.build(e, "f")), s.push(this.roughness.build(e, "f")), s.push(this.transmissionSamplerSize.build(e, "v2")), s.push(this.transmissionSamplerMap.getTexture(e, "t")), s.push(this.transmissionDepthMap.getTexture(e, "t")), s.push(this.aspectRatio.build(e, "v2")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("TransmissionNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Qh = RA;
Qh.Nodes = function() {
    let e = new ge(`vec3 blur(sampler2D sp, vec2 U, vec2 scale, float lod, sampler2D dm, vec2 unrefractedU, vec2 aspectRatio) {
                // Slightly modified version of this:
                // https://www.shadertoy.com/view/ltScRG

				// Special case for blur == 0.0
				if (lod == 0.0) {
					#ifdef TEXTURE_LOD_EXT
					return texture2DLodEXT( sp, U, 0.0).rgb;
					#else
					return textureLod( sp, U, 0.0).rgb;
					#endif
				}
				
				vec2 texelSize = vec2(1.0) / resolution;
                vec2 halton = haltonSequence[frameIndex];
                float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
                float temporalAngle  = temporalOffset * PI2;
				vec3 res = vec3(0.0);
                vec2 uv = vec2(0.0);
                vec2 offset = vec2(0.0);
                vec2 vogelSample = vec2(0.0);
                for (int i = 0; i < NUM_SAMPLES; i++) {
                    vogelSample =  vogelDiskSample(i, NUM_SAMPLES, temporalAngle) * texelSize;
                    offset = vogelSample * scale * (lod * 10.0); // TODO: used to be hardcoded to 20
                    uv = U + offset;
                    float opaqueDepth = unpackRGBAToDepth(textureLod(dm, uv, lod));
                    if (opaqueDepth != 0.0 && opaqueDepth < gl_FragCoord.z) {
                        uv = unrefractedU;
                        lod = lod > 4.0 ? lod : lod / 2.0;
                    }
                    res += textureLod(sp, uv, lod).rgb;
                }
                return res / float(NUM_SAMPLES);
            }`), r = new ge(`vec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {
		        // Direction of refracted light.
		        vec3 refractionVector = refract( -v,  n, 1.0 / ior );
		        
				// Compute rotation-independant scaling of the model matrix.
		        vec3 modelScale;
		        modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		        modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		        modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );

		        // The thickness is specified in local space
		        return normalize( refractionVector ) * thickness * modelScale;
	        }`), i = new ge(`float applyIorToRoughness( float roughness, float ior ) {
				// Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
				// an IOR of 1.5 results in the default amount of microfacet refraction.
				return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
			}`), s = new ge(`vec3 getTransmissionSample( vec2 fragCoord, float roughness, float ior, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 unrefractedCoords, vec2 aspectRatio) {
				// Threejs exports do not pass a depth map to this shader, so we have to fallback to the "Threejs method of blurring" - see
				// also the code in convertTransmission.ts, which runs during export
				#ifdef IS_THREEJS_EXPORT
					float lod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness / 5.0, ior);
					return textureBicubic(transmissionSamplerMap, fragCoord.xy, lod).rgb;
				#else
					float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
					float lod = applyIorToRoughness(roughness, ior);
					return blur(transmissionSamplerMap, fragCoord, vec2(lod), min(framebufferLod / 5.5, 8.5), transmissionDepthMap, unrefractedCoords, aspectRatio);
				#endif
			}`, [
        BI.textureBicubic,
        i,
        e
    ]), o = new ge(`vec3 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;

				// Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
				vec4 ndcPos = projMatrix * viewMatrix *  vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;

				vec4 ndcPosUnrefracted = projMatrix * viewMatrix * vec4(position, 1.0 );
				vec2 unrefractedCoords = ndcPosUnrefracted.xy / ndcPosUnrefracted.w;
				unrefractedCoords += 1.0;
				unrefractedCoords /= 2.0;

				// Sample framebuffer to get pixel the refracted ray hits.
				return getTransmissionSample( refractionCoords, roughness, ior, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, unrefractedCoords, aspectRatio );
    		}`, [
        s,
        r
    ]);
    return {
        transmission: new ge(`vec3 transmission(float thickness, float ior, float roughness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio, vec3 normal, float mask, float alpha, out float calpha) {
                vec3 v = vec3(0.);
                if (isOrthographic) {
                    v = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
                } else {
                    v = normalize(vWPosition - cameraPosition);
                }
                vec3 transmission = getIBLVolumeRefraction(vWNormal, -v, roughness,  vWPosition, modelMatrix, viewMatrix, projectionMatrix, ior, thickness, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, aspectRatio );
                
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * alpha;

				return transmission;
            }`, [
            o
        ])
    };
}();
var LA = ((e)=>(e.NOISE = "noise", e.MAP = "map", e))(LA || {}), BA = class extends Xe {
    constructor(e, r, i, s, o, a, l, u, c, d, h){
        super("v3");
        this.displacementTypeIndex = new xt(0);
        this.nodeType = "VertexDisplacement";
        this.intensity = e, this.movementOrTexture = r, Object.values(LA)[this.displacementTypeIndex.value] === "map" && (this.mat = new Nh(this.movementOrTexture.value.matrix)), this.cropOrOffset = i, this.scale = d, this.noiseFunctionIndex = h, this.voronoiStyle = s, this.smoothness = o, this.seed = a, this.highCut = l, this.lowCut = u, this.quality = c;
    }
    generate(e, r) {
        if (e.isShader("vertex")) {
            e.define("USE_LAYER_DISPLACE");
            let i, s = [];
            switch(s.push("displaced_position"), s.push("displaced_normal"), Object.values(LA)[this.displacementTypeIndex.value]){
                case "map":
                    i = e.include(BA.Nodes.map), s.push(this.movementOrTexture.getTexture(e, "t")), s.push("uv"), s.push(this.cropOrOffset.build(e, "f")), this.mat && s.push(this.mat.build(e, "mat3"));
                    break;
                case "noise":
                    {
                        let a = Object.values(vm)[this.noiseFunctionIndex.value], l = new ge(`vec3 orthogonal(vec3 v) {
							return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
						}`), u = a == "voronoi" ? `
					float v = ${a}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1), voronoiStyle, smoothness, seed, quality);
					v = remap(v, lowCut, highCut, 0.0, 1.0);
					v = smax(v, 0.0, smoothness * 0.25);
					v = smin(v, 1.0, smoothness * 0.25);

					return p + n * v * intensity;
					` : `
					return p + n * ${a}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1)) * intensity;
					`, c = new ge(`vec3 distorted(vec3 p, vec3 n, float scale, float intensity, vec3 offset, float neighbour_offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality) {
							${u}
						}`, [
                            Ui.simplex,
                            Ui.simplexFractal,
                            Ui.simplexAshima,
                            Ui.fbm,
                            Ui.perlin,
                            Ui.voronoi
                        ]), d = new ge(`vec3 vertexDisplacementNoise(vec3 position, vec3 normal, float scale, vec3 offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality, float intensity, out vec3 displaced_normal) {
							vec3 displaced_position = distorted(position, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 tangent1 = orthogonal(normal);
							vec3 tangent2 = normalize(cross(normal, tangent1));

                            // TODO(Max): The distance to the neighbors was originally scaled by 0.1.
                            // This caused some small oval/circular visual artifacts in the lighting.
                            // For now, simply using neighbors further away betters the problem,
                            // but we should figure out the underlying cause when we have some time.
                            // Maybe its related to how we calculate the tangent and bitangent?
							vec3 nearby1 = position + tangent1;
							vec3 nearby2 = position + tangent2;
							vec3 distorted1 = distorted(nearby1, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 distorted2 = distorted(nearby2, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
							return displaced_position;
						}`, [
                            c,
                            l
                        ]);
                        i = e.include(d), s.push(this.scale.build(e, "f")), s.push(this.cropOrOffset.build(e, "v3")), s.push(this.movementOrTexture.build(e, "f")), s.push(this.voronoiStyle.build(e, "i")), s.push(this.smoothness.build(e, "f")), s.push(this.seed.build(e, "f")), s.push(this.highCut.build(e, "f")), s.push(this.lowCut.build(e, "f")), s.push(this.quality.build(e, "i"));
                        break;
                    }
            }
            return s.push(this.intensity.build(e, "f")), s.push("displaced_normal"), e.format(i + "(" + s.join(",") + ")", this.getType(e), r);
        } else return console.warn("VertexDisplacementNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Kh = BA;
Kh.Nodes = function() {
    let e = new ge(`vec3 orthogonal(vec3 v) {
				return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
			}`), r = new ge(`float displacementMapTexture(sampler2D tex, float crop, vec2 uv, mat3 mat, vec2 offset) {
				vec2 uvs = (mat * vec3(uv * 2.0 - 1.0, 1.0) / 2.0 + 0.5).xy + offset;
				vec4 tmp = texture2D(tex, uvs);
				vec3 col = tmp.rgb;
				if (crop > 0.5) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						return 0.0;
					}
				}
				return col.r;
			}`);
    return {
        map: new ge(`vec3 vertexDisplacementMap(vec3 position, vec3 normal, sampler2D tex, vec2 uv, float crop, mat3 mat, float intensity, out vec3 displaced_normal) {
				vec3 displaced_position = position + normal * displacementMapTexture(tex, crop, uv, mat, vec2(0.0)) * intensity;
				vec3 tangent1 = normalize(orthogonal(normal));
				vec3 tangent2 = normalize(cross(normal, tangent1));
				vec3 nearby1 = position + tangent1 * 0.1;
				vec3 nearby2 = position + tangent2 * 0.1;
				vec3 distorted1 = nearby1 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				vec3 distorted2 = nearby2 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
				return displaced_position;
			}`, [
            e,
            r
        ])
    };
}();
var We = {
    normalRenderTarget: new xn,
    normalRenderTargetDepth: new xn,
    transmissionRenderTarget: new xn,
    aspectRatio: new Lr,
    transmissionSize: new Lr(2048, 2048),
    transmissionRenderTargetDepth: new xn,
    aoRenderTarget: new xn,
    aoEnabled: new Vr,
    pixelRatioNode: new Ce(1),
    resolution: new Lr,
    penumbraSize: new qs(5, .5),
    frameIndex: new xt(0),
    transmissionLod: new xt(2)
};
for (let n1 of Object.values(We))n1.isRenderGlobal = !0;
var z0 = {
    skiaWasmUrl: "https://unpkg.com/@splinetool/ui-wasm@1.0.16/build/ui.wasm"
};
var Ma = class extends ki {
    constructor(){
        super("basic");
        this.nodeType = "Basic";
        this.color = new Yt(Xr), this.shadingAlpha = new Ce(1), this.shadingBlend = new xt(0), this.previousModelViewMatrix = new Qi, this.previouseProjectionMatrix = new Qi;
    }
    get category() {
        return "phong";
    }
    generate(e) {
        let r;
        if (e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                resolution: We.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ae.fog
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "	vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            this.color === void 0 && (this.color = new Yt(Xr)), this.color.analyze(e, {
                slot: "color"
            }), this.alpha && this.alpha.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            });
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.alpha ? this.alpha.flow(e, "f") : void 0, o = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, a = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0;
            e.requires.transparent = s !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "#include <fog_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "varying vec3 vViewPosition;",
                "#include <normal_pars_fragment>"
            ].join(`
`));
            let l = [
                "#include <normal_fragment_begin>",
                i.code
            ];
            s && l.push(s.code, "#ifdef ALPHATEST", " if ( " + s.result + " <= ALPHATEST ) discard;", "#endif"), a ? l.push(a.code, `vec3 outgoingLight = ${i.result};`, `vec3 finalColor = spe_blend(outgoingLight, ${a.result}, 1.0, SPE_BLENDING_NORMAL);`) : l.push(`vec3 finalColor = ${i.result};`);
            let u = "1.0";
            this.mask && (this.mask.analyze(e), u = `luminance(${this.mask.flow(e, "v3").result})`), s ? l.push(`gl_FragColor = vec4( finalColor, accumAlpha * ${s.result} * ${u} );`) : l.push("gl_FragColor = vec4(" + i.result + ", 1.0 );"), o && l.push(`gl_FragColor.a *= ${o.result};`), l.push("#include <fog_fragment>", "#include <dithering_fragment>"), r = l.join(`
`);
        }
        return r;
    }
};
var xm = class extends ki {
    constructor(){
        super("lambert");
        this.nodeType = "Lambert";
        this.color = new Yt(Xr), this.emissive = new Yt(0), this.emissiveIntensity = new Ce(1), this.previousModelViewMatrix = new Qi, this.previouseProjectionMatrix = new Qi, this.shadingAlpha = new Ce(1), this.shadingBlend = new xt(0), this.occlusion = new Vr(!0);
    }
    get category() {
        return "lambert";
    }
    build(e) {
        let r;
        if (e.define("LAMBERT"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                resolution: We.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ae.fog,
                Ae.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <color_pars_vertex>",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", `
					vec3 diffuse = vec3( 1.0 );
					GeometricContext geometry;
					geometry.position = mvPosition.xyz;
					geometry.normal = normalize( transformedNormal );
					geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );
				`), s.push(`
					GeometricContext backGeometry;
					backGeometry.position = geometry.position;
					backGeometry.normal = -geometry.normal;
					backGeometry.viewDir = geometry.viewDir;
					vLightFront = vec3( 0.0 );
					vIndirectFront = vec3( 0.0 );
					#ifdef DOUBLE_SIDED
						vLightBack = vec3( 0.0 );
						vIndirectBack = vec3( 0.0 );
					#endif
					IncidentLight directLight;
					float dotNL;
					vec3 directLightColor_Diffuse;
					vIndirectFront += getAmbientLightIrradiance( ambientLightColor );
					vIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );
					#ifdef DOUBLE_SIDED
						vIndirectBack += getAmbientLightIrradiance( ambientLightColor );
						vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );
					#endif
					#if NUM_POINT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
							getPointLightInfo( pointLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_SPOT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
							getSpotLightInfo( spotLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_DIR_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
							getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_HEMI_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
							vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
							#ifdef DOUBLE_SIDED
								vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );
							#endif
						}
						#pragma unroll_loop_end
					#endif
				`, "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: We.penumbraSize
            }), e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                aoMap: We.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: We.aoEnabled
            }), this.color === void 0 && (this.color = new Yt(Xr)), this.color.analyze(e, {
                slot: "color"
            }), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.emissive.flow(e, "c", {
                slot: "emissive"
            }), o = this.emissiveIntensity.flow(e, "f", {
                slot: "emissive"
            }), a = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            }), l = this.shadingAlpha.flow(e, "f"), u = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0, h = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#include <normal_pars_fragment>",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <fog_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <shadowmask_pars_fragment>",
                "#include <clipping_planes_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx, viewdy));
				bool isFrontFacing = (dot(normal, faceNormal) >= 0.0);
				`,
                "#include <clipping_planes_fragment>"
            ];
            f.push(i.code, "vec3 diffuseColor = " + i.result + ";", "ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );"), d && f.push(d.code, "#ifdef ALPHATEST", "if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), f.push("#ifdef DOUBLE_SIDED", "	reflectedLight.indirectDiffuse += ( isFrontFacing ) ? vIndirectFront : vIndirectBack;", "#else", "	reflectedLight.indirectDiffuse += vIndirectFront;", "#endif", "#include <lightmap_fragment>", "reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );", "#ifdef DOUBLE_SIDED", "	reflectedLight.directDiffuse = ( isFrontFacing ) ? vLightFront : vLightBack;", "#else", "	reflectedLight.directDiffuse = vLightFront;", "#endif", "reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();"), s && f.push(s.code, "reflectedLight.directDiffuse += " + s.result + " * " + o.result + ";"), f.push("vec3 ao = aoEnabled && " + a.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = (reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) ;");
            let p = "1.0";
            this.mask && (this.mask.analyze(e), p = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${p} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${p}, ${u.result} );

					outgoingLight *= ao;
				}
				`), c && f.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result} );`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h && f.push(`gl_FragColor.a *= ${h.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var Ca = function() {
    let n1 = new ge(`vec2 dHdxy(sampler2D bumpMap, vec2 bumpMapUv, float bumpScale) {

            // Gradient of UVs w.r.t. X coordinate (in screen-space)
            vec2 dSTdx = dFdx(bumpMapUv);

            // Gradient of UVs w.r.t. Y coordinate (in screen-space)
            vec2 dSTdy = dFdy(bumpMapUv);
            
            // Forward differencing
            float Hll = bumpScale * luminance(texture(bumpMap, bumpMapUv).rgb);
            float dBx = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdx).rgb) - Hll;
            float dBy = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdy).rgb) - Hll;
            
            return vec2( dBx, dBy );
        }`), t = new ge(`vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
            vec3 vSigmaX = dFdx( surf_pos.xyz );
            vec3 vSigmaY = dFdy( surf_pos.xyz );
            vec3 vN = surf_norm; // normalized
            
            vN = normalize(vN);

            vec3 R1 = cross( vSigmaY, vN );
            vec3 R2 = cross( vN, vSigmaX );

            R1 = normalize(R1);
            R2 = normalize(R2);
    
            float fDet = dot( vSigmaX, R1 ) * faceDirection;
    
            vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
            return normalize( abs( fDet ) * vN - vGrad );
        }`);
    return {
        dHdxy: n1,
        perturbNormalArb: t
    };
}();
var bm = class extends ki {
    constructor(){
        super("phong");
        this.nodeType = "Phong";
        this.color = new Yt(Xr), this.specular = new Yt(1118481), this.shininess = new Ce(30), this.previousModelViewMatrix = new Qi, this.previouseProjectionMatrix = new Qi, this.shadingAlpha = new Ce(1), this.shadingBlend = new xt(0), this.occlusion = new Vr(!0);
    }
    get category() {
        return "phong";
    }
    build(e) {
        let r;
        if (e.define("PHONG"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                resolution: We.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ae.fog,
                Ae.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif


				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: We.penumbraSize
            }), e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                aoMap: We.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: We.aoEnabled
            }), this.color === void 0 && (this.color = new Yt(Xr)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e);
            let i = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let s = this.color.flow(e, "c", {
                slot: "color"
            }), o = this.specular.flow(e, "c"), a = this.shininess.flow(e, "f"), l = this.shadingAlpha.flow(e, "f"), u = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0, h = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "uniform vec3 emissive;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_phong_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	BlinnPhongMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Ca.dHdxy), e.include(Ca.perturbNormalArb);
                let m = this.bumpMap.texture.flow(e, "t"), g = this.bumpMap.flow(e, "v3"), y = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", v = "";
                this.bumpMap.projection.value === 4 ? v = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${m.result}, uv0, ${y});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${m.result}, uv1, ${y});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${m.result}, uv2, ${y});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : v = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${m.result}, bumpMapCachedUv, ${y});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, f.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${g.result};
					${v}
					`);
            }
            f.push(s.code, "	vec3 diffuseColor = " + s.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", "	vec3 totalEmissiveRadiance = emissive;", o.code, "	vec3 specular = " + o.result + ";", a.code, "	float shininess = max( 0.0001, " + a.result + " );", "	float specularStrength = 1.0;"), d && f.push(d.code, "#ifdef ALPHATEST", "if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), f.push("material.diffuseColor = diffuseColor;"), f.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), f.push("vec3 ao = aoEnabled && " + i.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;");
            let p = "1.0";
            this.mask && (this.mask.analyze(e), p = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${p} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${p}, ${u.result} );
					
					outgoingLight *= ao;
				}
				`), c && f.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result});`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h && f.push(`gl_FragColor.a *= ${h.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var Sm = class extends ki {
    constructor(){
        super("standard");
        this.nodeType = "Standard";
        this.color = new Yt(Xr), this.roughness = new Ce(.3), this.metalness = new Ce(0), this.reflectivity = new Ce(.5), this.previousModelViewMatrix = new Qi, this.previouseProjectionMatrix = new Qi, this.shadingAlpha = new Ce(1), this.shadingBlend = new xt(0), this.occlusion = new Vr(!0);
    }
    get category() {
        return "physical";
    }
    build(e) {
        let r;
        if (e.define("STANDARD"), e.requires.lights = !0, e.extensions.derivatives = !0, e.extensions.shaderTextureLOD = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                resolution: We.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ae.fog,
                Ae.lights
            ])), Ae.LTC_1 && (e.uniforms.ltc_1 = {
                value: void 0
            }, e.uniforms.ltc_2 = {
                value: void 0
            }), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>", "#include <shadowmap_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: We.penumbraSize
            }), e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                aoMap: We.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: We.aoEnabled
            });
            let i = {
                gamma: !0
            };
            this.color === void 0 && (this.color = new Yt(Xr)), this.color.analyze(e, {
                slot: "color",
                context: i
            }), this.roughness.analyze(e), this.metalness.analyze(e);
            let s = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e), this.reflectivity && this.reflectivity.analyze(e);
            let o = this.color.flow(e, "c", {
                slot: "color",
                context: i
            }), a = this.roughness.flow(e, "f"), l = this.metalness.flow(e, "f"), u = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), d = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, f = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, p = this.reflectivity ? this.reflectivity.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_physical_pars_fragment>",
                "#include <shadowmap_pars_fragment>"
            ].join(`
`));
            let m = [
                "#include <clipping_planes_fragment>",
                "	#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	PhysicalMaterial material;",
                "	material.diffuseColor = vec3( 1.0 );"
            ];
            if (this.bumpMap) {
                e.include(Ca.dHdxy), e.include(Ca.perturbNormalArb);
                let y = this.bumpMap.texture.flow(e, "t"), v = this.bumpMap.flow(e, "v3"), x = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", S = "";
                this.bumpMap.projection.value === 4 ? S = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${y.result}, uv0, ${x});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${y.result}, uv1, ${x});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${y.result}, uv2, ${x});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : S = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${y.result}, bumpMapCachedUv, ${x});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, m.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${v.result};
					${S}
					`);
            }
            if (m.push(o.code, "	vec3 diffuseColor = " + o.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", l.code, "	float metalnessFactor = " + l.result + ";"), this.roughnessMap) {
                let y = this.roughnessMap.texture.flow(e, "t"), v = this.roughnessMap.flow(e, "v3"), x = "";
                this.roughnessMap.projection.value === 4 ? x = `
					float roughnessChange = 1.0;
					{
						vec2 uv0 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						float r0 = luminance(texture(${y.result}, uv0).rgb) * roughnessScale;
						float r1 = luminance(texture(${y.result}, uv1).rgb) * roughnessScale;
						float r2 = luminance(texture(${y.result}, uv2).rgb) * roughnessScale;

						roughnessChange = (r0 * weights.z + r1 * weights.x + r2 * weights.y);
					}
					float roughnessFactor = roughnessChange * ${a.result};
					` : x = `
					vec2 roughnessMapCachedUv = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs;

					vec4 vals = texture(${y.result},  roughnessMapCachedUv);
					float roughnessFactor = luminance(vals.rgb) * ${a.result};
					`, m.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${v.result};

					const float roughnessScale = 1.0;

					${x}
				`);
            } else m.push(a.code, "	float roughnessFactor = " + a.result + ";");
            h && m.push(h.code, "#ifdef ALPHATEST", "	if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), m.push("vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );"), m.push("material.diffuseColor = diffuseColor * ( 1.0 - metalnessFactor );", "material.roughness = max( roughnessFactor, 0.0525 );", "material.roughness += geometryRoughness;", "material.roughness = min( material.roughness, 1.0 );", "material.roughness = clamp( roughnessFactor, 0.04, 1.0 );"), p ? m.push(p.code, "material.specularColor = mix( vec3( 0.16 * pow2( " + p.result + " ) ), diffuseColor, metalnessFactor );") : m.push("material.specularColor = mix( vec3( 0.04 ), diffuseColor, metalnessFactor );"), m.push("#include <lights_fragment_begin>"), m.push("#include <lights_fragment_end>"), m.push("vec3 ao = aoEnabled && " + s.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular;");
            let g = "1.0";
            this.mask && (this.mask.analyze(e), g = `luminance(${this.mask.flow(e, "v3").result})`), m.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${u.result} * ${g} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${u.result} * ${g}, ${c.result} );
					
					outgoingLight *= ao;
				}
				`), d && m.push(d.code, `outgoingLight = spe_blend(outgoingLight, ${d.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? m.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result} );`) : m.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), f && m.push(`gl_FragColor.a *= ${f.result};`), m.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = m.join(`
`);
        }
        return r;
    }
};
var wm = class extends ki {
    constructor(){
        super("toon");
        this.nodeType = "Toon";
        this.color = new Yt(Xr), this.specular = new Yt(1118481), this.shininess = new Ce(30), this.previousModelViewMatrix = new Qi, this.previouseProjectionMatrix = new Qi, this.shadingAlpha = new Ce(1), this.shadingBlend = new xt(0);
    }
    get category() {
        return "toon";
    }
    build(e) {
        let r;
        if (e.define("TOON"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                resolution: We.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Ns.merge([
                Ae.fog,
                Ae.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <fog_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: We.penumbraSize
            }), e.mergeUniform({
                frameIndex: We.frameIndex
            }), e.mergeUniform({
                aoMap: We.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: We.aoEnabled
            }), this.color === void 0 && (this.color = new Yt(Xr)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.specular.flow(e, "c"), o = this.shininess.flow(e, "f"), a = this.shadingAlpha.flow(e, "f"), l = this.shadingBlend.flow(e, "i"), u = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, c = this.alpha ? this.alpha.flow(e, "f") : void 0, d = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = c !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vWPosition;",
                "#include <normal_pars_fragment>",
                "#include <gradientmap_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <dithering_pars_fragment>",
                `
					varying vec3 vViewPosition;
					struct ToonMaterial {
						vec3	diffuseColor;
						vec3	specularColor;
						float	specularShininess;
						float	specularStrength;
					};
					void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
			
						reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
						reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
					}
					void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
					}
					#define RE_Direct				RE_Direct_Toon
					#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
					#define Material_LightProbeLOD( material )	(0)
					`,
                "#include <shadowmap_pars_fragment>",
                "#include <bumpmap_pars_fragment>",
                "#include <normalmap_pars_fragment>"
            ].join(`
`));
            let h = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	ToonMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Ca.dHdxy), e.include(Ca.perturbNormalArb);
                let p = this.bumpMap.texture.flow(e, "t"), m = this.bumpMap.flow(e, "v3"), g = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", y = "";
                this.bumpMap.projection.value === 4 ? y = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${p.result}, uv0, ${g});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${p.result}, uv1, ${g});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${p.result}, uv2, ${g});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : y = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${p.result}, bumpMapCachedUv, ${g});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, h.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${m.result};
					${y}
					`);
            }
            h.push(i.code, "	vec3 diffuseColor = " + i.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", s.code, "	vec3 specular = " + s.result + ";", o.code, "	float shininess = max( 0.0001, " + o.result + " );", "	float specularStrength = 1.0;"), c && h.push(c.code, "#ifdef ALPHATEST", "if ( " + c.result + " <= ALPHATEST ) discard;", "#endif"), h.push("material.diffuseColor = diffuseColor;"), h.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), h.push("vec3 ao = aoEnabled ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) * ao) + reflectedLight.directSpecular;");
            let f = "1.0";
            this.mask && (this.mask.analyze(e), f = `luminance(${this.mask.flow(e, "v3").result})`), h.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${a.result} * ${f} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${a.result} * ${f}, ${l.result} );
				}
				`), u && h.push(u.code, `outgoingLight = spe_blend(outgoingLight, ${u.result}, 1.0, SPE_BLENDING_NORMAL);`), c ? h.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${c.result} );`) : h.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d && h.push(`gl_FragColor.a *= ${d.result};`), h.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = h.join(`
`);
        }
        return r;
    }
};
var V0 = class {
    constructor(t = 10000){
        this.timeout = t;
        this.cache = new Map;
        this.head = {
            data: null,
            time: 0,
            src: null,
            next: null,
            prev: null
        };
        this.tail = {
            data: null,
            time: 1 / 0,
            src: null,
            next: null,
            prev: null
        };
        this.hasClean = !1;
        this.head.next = this.tail, this.tail.prev = this.head;
    }
    log(...t) {}
    remove(t) {
        let e = this.cache.get(t);
        e && (this.dispose(t, e.data), this.cache.delete(t), e.prev.next = e.next, e.next.prev = e.prev);
    }
    scheduleCleanup() {
        this.hasClean || (this.log("scheduled cleanup"), this.hasClean = !0, setTimeout(()=>{
            this.hasClean = !1, this.log("cleaning");
            let t = Date.now(), e = this.head.next;
            for(; e.time < t - this.timeout;)this.dispose(e.src, e.data), this.cache.delete(e.src), e = e.next, e.prev = this.head, this.head.next = e;
            this.head.next !== this.tail ? this.scheduleCleanup() : this.log("no more cleanup");
        }, this.timeout + 1e3));
    }
    has(t) {
        return this.cache.get(t)?.data;
    }
    load(t) {
        let e = Date.now(), r = this.cache.get(t);
        return r === void 0 ? (r = {
            data: this.create(t),
            src: t,
            time: e,
            next: null,
            prev: null
        }, this.cache.set(t, r)) : (r.time = e, r.prev.next = r.next, r.next.prev = r.prev), r.prev = this.tail.prev, r.next = this.tail, this.tail.prev.next = r, this.tail.prev = r, this.scheduleCleanup(), r.data;
    }
};
var FA = class extends V0 {
    create(t) {
        return URL.createObjectURL(new Blob([
            t
        ]));
    }
    dispose(t, e) {
        URL.revokeObjectURL(e);
    }
}, NA;
function FI(n1) {
    return typeof n1 == "string" ? n1 : (NA || (NA = new FA), NA.load(n1));
}
var U0 = class {
    constructor(t, e){
        this.data = t;
        this.cache = e;
        this.refCount = 0;
    }
    deref() {
        this.refCount;
        this.refCount -= 1, this.refCount === 0 && (this.cache.remove(this), this.dispose());
    }
    dispose() {
        this.refCount;
    }
}, G0 = class {
    constructor(){
        this.cache = new Map;
    }
    remove(t) {
        this.cache.delete(t.data);
    }
    load(t) {
        let e = this.cache.get(t);
        return e === void 0 && (e = this.create(t), this.cache.set(t, e)), e.refCount += 1, e;
    }
};
var Zh = class extends U0 {
    constructor(e, r){
        super(e, r.imageHolderCache);
        this.data = e;
        this.shared = r;
        this.loaded = !1;
        this.isVideo = !1;
        this.isCanvas = !1;
        this.isVideo = e.type === "video", this.isCanvas = e.nodeName === "CANVAS", this.updateSrc(this.isCanvas ? e : e.data);
    }
    async updateSrc(e) {
        if (typeof document > "u") return;
        this.disposeTextures(), this.loaded = !1;
        let r = ()=>{
            this.loaded = !0;
            let s = [
                1e3,
                1001,
                1002
            ];
            for (let o of s){
                let a = this[o];
                a && (a.image = this.img, a.needsUpdate = !0);
            }
            this.shared.requestRender();
        };
        if (this.isCanvas) this.img = e, this.loaded = !0;
        else if (this.isVideo) {
            if (this.img = document.createElement("video"), this.img.preload = "auto", this.img.playsInline = !0, this.img.currentTime = .01, typeof e != "string") {
                var i = new FileReader;
                i.readAsDataURL(new Blob([
                    e
                ], {
                    type: "video/mp4"
                }));
                let s;
                await new Promise((o)=>{
                    i.onloadend = (a)=>{
                        s = a.target?.result, o(null);
                    };
                }), this.img.src = s;
            } else this.img.src = e;
            this.img.onloadeddata = ()=>{
                r();
            };
        } else this.img = new Image, this.img.src = FI(e), this.img.onload = r;
    }
    getTexture(e) {
        let r = this[e];
        if (r) return r;
        {
            let i;
            return this.isCanvas && (i = new dy(this.img, void 0, e, e)), this.isVideo ? i = new uy(this.img, void 0, e, e) : i = new qt(this.img, void 0, e, e), this.loaded && (i.needsUpdate = !0), this[e] = i, i;
        }
    }
    setNeedsUpdate(e) {
        let r = [
            1e3,
            1001,
            1002
        ];
        for (let i of r){
            let s = this[i];
            s && (s.needsUpdate = e);
        }
    }
    disposeTextures() {
        this[1e3]?.dispose(), this[1e3] = void 0, this[1001]?.dispose(), this[1001] = void 0, this[1002]?.dispose(), this[1002] = void 0;
    }
    dispose() {
        super.dispose(), this.disposeTextures();
    }
};
var Zn = class extends Zh {
};
function zA(n1, t) {
    var e = KY(t);
    return e.formatToParts ? XY(e, n1) : QY(e, n1);
}
var YY = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function XY(n1, t) {
    try {
        for(var e = n1.formatToParts(t), r = [], i = 0; i < e.length; i++){
            var s = YY[e[i].type];
            s >= 0 && (r[s] = parseInt(e[i].value, 10));
        }
        return r;
    } catch (o) {
        if (o instanceof RangeError) return [
            NaN
        ];
        throw o;
    }
}
function QY(n1, t) {
    var e = n1.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e);
    return [
        r[3],
        r[1],
        r[2],
        r[4],
        r[5],
        r[6]
    ];
}
var kA = {};
function KY(n1) {
    if (!kA[n1]) {
        var t = new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z")), e = t === "06/25/2014, 00:00:00" || t === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        kA[n1] = e ? new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return kA[n1];
}
function j0(n1, t, e, r, i, s, o) {
    var a = new Date(0);
    return a.setUTCFullYear(n1, t, e), a.setUTCHours(r, i, s, o), a;
}
var kI = 36e5, ZY = 6e4, VA = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Am(n1, t, e) {
    var r, i;
    if (!n1 || (r = VA.timezoneZ.exec(n1), r)) return 0;
    var s;
    if (r = VA.timezoneHH.exec(n1), r) return s = parseInt(r[1], 10), zI(s) ? -(s * kI) : NaN;
    if (r = VA.timezoneHHMM.exec(n1), r) {
        s = parseInt(r[1], 10);
        var o = parseInt(r[2], 10);
        return zI(s, o) ? (i = Math.abs(s) * kI + o * ZY, s > 0 ? -i : i) : NaN;
    }
    if (e7(n1)) {
        t = new Date(t || Date.now());
        var a = e ? t : JY(t), l = UA(a, n1), u = e ? l : $Y(t, l, n1);
        return -u;
    }
    return NaN;
}
function JY(n1) {
    return j0(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds());
}
function UA(n1, t) {
    var e = zA(n1, t), r = j0(e[0], e[1] - 1, e[2], e[3] % 24, e[4], e[5], 0).getTime(), i = n1.getTime(), s = i % 1e3;
    return i -= s >= 0 ? s : 1e3 + s, r - i;
}
function $Y(n1, t, e) {
    var r = n1.getTime(), i = r - t, s = UA(new Date(i), e);
    if (t === s) return t;
    i -= s - t;
    var o = UA(new Date(i), e);
    return s === o ? s : Math.max(s, o);
}
function zI(n1, t) {
    return -23 <= n1 && n1 <= 23 && (t == null || 0 <= t && t <= 59);
}
var VI = {};
function e7(n1) {
    if (VI[n1]) return !0;
    try {
        return new Intl.DateTimeFormat(void 0, {
            timeZone: n1
        }), VI[n1] = !0, !0;
    } catch  {
        return !1;
    }
}
var KI = Pi(GI(), 1), HA = Pi(HI(), 1);
var i7 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, WI = i7;
var GA = 36e5, qI = 6e4, n7 = 2, bn = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    timeZone: WI
};
function WA(n1, t) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (n1 === null) return new Date(NaN);
    var e = t || {}, r = e.additionalDigits == null ? n7 : (0, KI.default)(e.additionalDigits);
    if (r !== 2 && r !== 1 && r !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (n1 instanceof Date || typeof n1 == "object" && Object.prototype.toString.call(n1) === "[object Date]") return new Date(n1.getTime());
    if (typeof n1 == "number" || Object.prototype.toString.call(n1) === "[object Number]") return new Date(n1);
    if (!(typeof n1 == "string" || Object.prototype.toString.call(n1) === "[object String]")) return new Date(NaN);
    var i = s7(n1), s = o7(i.date, r), o = s.year, a = s.restDateString, l = a7(a, o);
    if (isNaN(l)) return new Date(NaN);
    if (l) {
        var u = l.getTime(), c = 0, d;
        if (i.time && (c = l7(i.time), isNaN(c))) return new Date(NaN);
        if (i.timeZone || e.timeZone) {
            if (d = Am(i.timeZone || e.timeZone, new Date(u + c)), isNaN(d)) return new Date(NaN);
        } else d = (0, HA.default)(new Date(u + c)), d = (0, HA.default)(new Date(u + c + d));
        return new Date(u + c + d);
    } else return new Date(NaN);
}
function s7(n1) {
    var t = {}, e = bn.dateTimePattern.exec(n1), r;
    if (e ? (t.date = e[1], r = e[3]) : (e = bn.datePattern.exec(n1), e ? (t.date = e[1], r = e[2]) : (t.date = null, r = n1)), r) {
        var i = bn.timeZone.exec(r);
        i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
    }
    return t;
}
function o7(n1, t) {
    var e = bn.YYY[t], r = bn.YYYYY[t], i;
    if (i = bn.YYYY.exec(n1) || r.exec(n1), i) {
        var s = i[1];
        return {
            year: parseInt(s, 10),
            restDateString: n1.slice(s.length)
        };
    }
    if (i = bn.YY.exec(n1) || e.exec(n1), i) {
        var o = i[1];
        return {
            year: parseInt(o, 10) * 100,
            restDateString: n1.slice(o.length)
        };
    }
    return {
        year: null
    };
}
function a7(n1, t) {
    if (t === null) return null;
    var e, r, i, s;
    if (n1.length === 0) return r = new Date(0), r.setUTCFullYear(t), r;
    if (e = bn.MM.exec(n1), e) return r = new Date(0), i = parseInt(e[1], 10) - 1, XI(t, i) ? (r.setUTCFullYear(t, i), r) : new Date(NaN);
    if (e = bn.DDD.exec(n1), e) {
        r = new Date(0);
        var o = parseInt(e[1], 10);
        return d7(t, o) ? (r.setUTCFullYear(t, 0, o), r) : new Date(NaN);
    }
    if (e = bn.MMDD.exec(n1), e) {
        r = new Date(0), i = parseInt(e[1], 10) - 1;
        var a = parseInt(e[2], 10);
        return XI(t, i, a) ? (r.setUTCFullYear(t, i, a), r) : new Date(NaN);
    }
    if (e = bn.Www.exec(n1), e) return s = parseInt(e[1], 10) - 1, QI(t, s) ? YI(t, s) : new Date(NaN);
    if (e = bn.WwwD.exec(n1), e) {
        s = parseInt(e[1], 10) - 1;
        var l = parseInt(e[2], 10) - 1;
        return QI(t, s, l) ? YI(t, s, l) : new Date(NaN);
    }
    return null;
}
function l7(n1) {
    var t, e, r;
    if (t = bn.HH.exec(n1), t) return e = parseFloat(t[1].replace(",", ".")), jA(e) ? e % 24 * GA : NaN;
    if (t = bn.HHMM.exec(n1), t) return e = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), jA(e, r) ? e % 24 * GA + r * qI : NaN;
    if (t = bn.HHMMSS.exec(n1), t) {
        e = parseInt(t[1], 10), r = parseInt(t[2], 10);
        var i = parseFloat(t[3].replace(",", "."));
        return jA(e, r, i) ? e % 24 * GA + r * qI + i * 1e3 : NaN;
    }
    return null;
}
function YI(n1, t, e) {
    t = t || 0, e = e || 0;
    var r = new Date(0);
    r.setUTCFullYear(n1, 0, 4);
    var i = r.getUTCDay() || 7, s = t * 7 + e + 1 - i;
    return r.setUTCDate(r.getUTCDate() + s), r;
}
var c7 = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], u7 = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function ZI(n1) {
    return n1 % 400 === 0 || n1 % 4 === 0 && n1 % 100 !== 0;
}
function XI(n1, t, e) {
    if (t < 0 || t > 11) return !1;
    if (e != null) {
        if (e < 1) return !1;
        var r = ZI(n1);
        if (r && e > u7[t] || !r && e > c7[t]) return !1;
    }
    return !0;
}
function d7(n1, t) {
    if (t < 1) return !1;
    var e = ZI(n1);
    return !(e && t > 366 || !e && t > 365);
}
function QI(n1, t, e) {
    return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function jA(n1, t, e) {
    return !(n1 != null && (n1 < 0 || n1 >= 25) || t != null && (t < 0 || t >= 60) || e != null && (e < 0 || e >= 60));
}
function q0(n1, t, e) {
    var r = WA(n1, e), i = Am(t, r, !0), s = new Date(r.getTime() - i), o = new Date(0);
    return o.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), o.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), o;
}
function Ki(n1, t) {
    return t.color(n1);
}
function qA(n1 = new Date, t) {
    let e = t.format, r = n1.getSeconds(), i = n1;
    t && t.timeZone !== null && (i = q0(new Date, t.timeZone));
    let s = i.getHours(), o = i.getMinutes(), a;
    t.format12h24h === "12ampm" && (a = s >= 12 ? "PM" : "AM");
    let l = s;
    t.format12h24h !== "24" && (l = s % 12, l === 0 && (l = 12));
    let u, c;
    switch(e){
        case "HH:mm:ss":
            u = [
                l,
                o,
                r
            ];
            break;
        case "HH:mm":
            u = [
                l,
                o
            ];
            break;
        case "HH":
            u = [
                l
            ], a = void 0;
            break;
        case "mm":
            u = [
                o
            ], a = void 0;
            break;
        case "ss":
            u = [
                r
            ], a = void 0;
            break;
        case "year":
            c = i.getFullYear();
            break;
        case "month":
            c = i.getMonth() + 1;
            break;
        case "dayOfYear":
            c = Math.floor((i.getTime() - new Date(i.getFullYear(), 0, 0).getTime()) / 864e5);
            break;
        case "dayOfMonth":
            c = i.getDate();
            break;
        case "secondOfDay":
            c = s * 3600 + o * 60 + r;
            break;
        default:
            console.error("Unknown time format", e), c = 0;
            break;
    }
    return u !== void 0 ? {
        textValue: u,
        suffix: a
    } : c;
}
function JI(n1, t) {
    switch(n1.type){
        case "fresnel":
            return p7(n1, t);
        case "gradient":
            return m7(n1, t);
        case "depth":
            return g7(n1, t);
        case "normal":
            return y7(n1, t);
        case "noise":
            return v7(n1, t);
        case "rainbow":
            return x7(n1, t);
        case "toon":
            return b7(n1, t);
        case "outline":
            return S7(n1, t);
        case "transmission":
            return w7(n1, t);
        case "color":
            return f7(n1, t);
        case "pattern":
            return A7(n1, t);
    }
}
function h7(n1) {
    return {
        type: n1.type
    };
}
function Xs(n1, t) {
    let { alpha: e, mode: r, isMask: i } = n1, s = typeof e == "string" ? (Number(t.getVariable(e)) ?? 100) / 100 : e;
    return {
        ...h7(n1),
        alpha: s,
        mode: r,
        isMask: i
    };
}
function f7(n1, t) {
    return {
        ...Xs(n1, t),
        color: Ki(n1.color, t)
    };
}
function p7(n1, t) {
    let { bias: e, scale: r, intensity: i, factor: s, color: o } = n1;
    return {
        ...Xs(n1, t),
        color: Ki(o, t),
        bias: e,
        scale: r,
        intensity: i,
        factor: s
    };
}
function m7(n1, t) {
    let { gradientType: e, smooth: r, colors: i, steps: s, angle: o, offset: a, morph: l } = n1;
    return {
        ...Xs(n1, t),
        gradientType: e,
        smooth: r,
        colors: i.map((u)=>new He(u[0], u[1], u[2], u[3])),
        num: i.length,
        steps: s,
        offset: new N(...a),
        morph: new N(...l),
        angle: o
    };
}
function g7(n1, t) {
    let { gradientType: e, near: r, far: i, isVector: s, isWorldSpace: o, origin: a, direction: l, colors: u, steps: c, smooth: d } = n1;
    return {
        ...Xs(n1, t),
        gradientType: e,
        near: r,
        far: i,
        isVector: s,
        isWorldSpace: o,
        origin: new _(...a),
        direction: l ? new _(...l) : new _(1, 0, 0),
        colors: u.map((h)=>h !== void 0 ? new He(h[0], h[1], h[2], h[3]) : new He(0, 0, 0, 0)),
        steps: c.slice(0, u.length),
        smooth: d
    };
}
function y7(n1, t) {
    let { cnormal: e } = n1;
    return {
        ...Xs(n1, t),
        cnormal: new _(e[0], e[1], e[2])
    };
}
function v7(n1, t) {
    return {
        ...Xs(n1, t),
        scale: n1.scale,
        move: n1.move,
        fA: new N(...n1.fA),
        fB: new N(...n1.fB),
        size: new _(...n1.size),
        distortion: new N(...n1.distortion),
        colorA: Ki(n1.colorA, t),
        colorB: Ki(n1.colorB, t),
        colorC: Ki(n1.colorC, t),
        colorD: Ki(n1.colorD, t),
        noiseType: n1.noiseType,
        voronoiStyle: n1.voronoiStyle,
        highCut: n1.highCut,
        lowCut: n1.lowCut,
        smoothness: n1.smoothness,
        seed: n1.seed,
        quality: n1.quality
    };
}
function x7(n1, t) {
    return {
        ...Xs(n1, t),
        filmThickness: n1.filmThickness,
        movement: n1.movement,
        wavelengths: new _(...n1.wavelengths),
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        offset: new _(...n1.offset)
    };
}
function b7(n1, t) {
    return {
        ...Xs(n1, t),
        positioning: n1.positioning,
        colors: n1.colors.map((e)=>new He(e[0], e[1], e[2], e[3])),
        num: n1.colors.length,
        steps: n1.steps,
        source: new _(...n1.source),
        isWorldSpace: n1.isWorldSpace,
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        shadowColor: Ki(n1.shadowColor, t),
        offset: new _(...n1.offset)
    };
}
function S7(n1, t) {
    return {
        ...Xs(n1, t),
        outlineColor: Ki(n1.outlineColor, t),
        contourColor: Ki(n1.contourColor, t),
        outlineWidth: n1.outlineWidth,
        contourWidth: n1.contourWidth,
        outlineThreshold: n1.outlineThreshold,
        contourThreshold: n1.contourThreshold,
        outlineSmoothing: n1.outlineSmoothing,
        contourFrequency: n1.contourFrequency,
        contourDirection: new _(...n1.contourDirection),
        positionalLines: n1.positionalLines,
        compensation: n1.compensation
    };
}
function w7(n1, t) {
    return {
        ...Xs(n1, t),
        thickness: n1.thickness,
        ior: n1.ior,
        roughness: n1.roughness
    };
}
function A7(n1, t) {
    return {
        ...Xs(n1, t),
        style: n1.style,
        projection: n1.projection,
        axis: n1.axis,
        blending: n1.blending,
        offset: new N(...n1.offset),
        colorA: Ki(n1.colorA, t),
        colorB: Ki(n1.colorB, t),
        frequency: new N(...n1.frequency),
        size: n1.size,
        variation: n1.variation,
        smoothness: n1.smoothness,
        zigzag: n1.zigzag,
        rotation: n1.rotation,
        vertical: new N(...n1.vertical),
        horizontal: new N(...n1.horizontal),
        sides: n1.sides
    };
}
var Bl = class extends cr {
};
var YA = {
    noise: [
        "noiseType"
    ],
    texture: [
        "projection",
        "axis",
        "side"
    ],
    video: [
        "projection",
        "axis",
        "side"
    ],
    displace: [
        "noiseType"
    ],
    light: [
        "roughnessMap",
        "bumpMap"
    ],
    depth: [
        "smooth",
        "isWorldSpace",
        "gradientType",
        "isVector"
    ],
    pattern: [
        "style",
        "projection",
        "axis"
    ]
}, XA = {
    depth: [
        "colors"
    ]
};
function _7(n1, t, e) {
    if (t === "isMask") return !0;
    let r = YA[n1.type], i = XA[n1.type];
    if (i !== void 0) {
        let s = n1.color;
        if (i.includes(t)) {
            let o = s[t]?.value?.length;
            if (o !== void 0 && o !== e.length) return !0;
        }
    }
    return r !== void 0 ? r.includes(t) : !1;
}
function QA(n1, t, e) {
    let r = e.uniforms[`f${e.id}_texture`];
    if (!r) return !1;
    let i = !1, s = n1;
    if ("image" in s) {
        let o = s.image, a = t.image(o), l = r;
        l.image instanceof Zn || l.image.deref(), l.image = a;
    }
    if ("video" in s) {
        let o = s.video, a = t.video(o), l = r;
        l.image instanceof Zn || l.image.deref(), l.image = a;
    }
    if ("wrapping" in s) {
        let o = r;
        o.wrap = s.wrapping;
    }
    if ("repeat" in s || "offset" in s) {
        let o = "mat", a = e.uniforms[`f${e.id}_${o}`];
        "repeat" in s && (a.repeat = s.repeat), "offset" in s && (a.offset = s.offset), a.updateMatrix();
    }
    return i;
}
function $I(n1, t, e, r) {
    let i = !1;
    for (let [s, o] of Object.entries(n1)){
        if (s === "bumpMap" || s === "roughnessMap") {
            i = !0;
            continue;
        }
        if (!s || o === void 0) continue;
        if (KA(s, e, r, t)) {
            s === "visible" && e.type === "light" && (i = !0);
            continue;
        }
        e.visible = r.visible;
        let a = e.uniforms[`f${e.id}_${s}`];
        if (!!a && !(a instanceof Rl)) switch(i = i || _7(e, s, o), a.constructor){
            case Yt:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof Bl ? a.value = new cr(l.r, l.g, l.b, l.a) : a.setRGBA(l);
                    break;
                }
            case On:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof Bl ? a.value = new cr(l.r, l.g, l.b, l.a) : a.value.setRGBA(l.r, l.g, l.b, l.a);
                    break;
                }
            case Lr:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]);
                    break;
                }
            case Xi:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]), a.value.setZ(l[2]);
                    break;
                }
            case xn:
                QA(o, t, e);
                break;
            case Ys:
                a.value = o.map((l)=>new He(...l));
                break;
            default:
                a.value = o;
                break;
        }
    }
    return i;
}
var Nl = (n1, t, e)=>Math.max(0, Math.min(1, Number(t.getVariable(typeof n1 == "number" ? n1 * 100 : n1, e) ?? 100) / 100)) ?? 1, Io = class {
    constructor(t, e, r, i, s){
        this.id = t;
        this.uuid = e;
        this.data = r;
        this.uniforms = {};
        for(let o in i)this.uniforms[`f${this.id}_${o}`] = i[o];
        for(let o in r)KA(o, this, r, s);
    }
    get type() {
        return this.data.type;
    }
    static create(t, e, r, i) {
        if (r.type === "light") return Sn.createLigherLayer(t, e, r, i);
        if (r.type === "texture" || r.type === "video") {
            let s = r.type === "texture" ? i.canvas(r.texture.image) ?? i.image(r.texture.image) : i.video(r.texture.video), o = new Vc(s, r.texture.wrapping), a = new F0(s), l = new k0(r.texture.repeat, r.texture.offset), u = new Ce(r.crop ? 1 : 0), c = new xt(r.projection ?? 0), d = new xt([
                "x",
                "y",
                "z"
            ].indexOf(r.axis) ?? 0), h = new xt(r.side ?? 0), f = new Lr(r.size ? new N(r.size[0], r.size[1]) : new N(100, 100)), p = new Ce(r.blending ?? 0), m = new Ce(Nl(r.alpha, i)), g = new xt(r.mode ?? 0), y = new Vr(r.isMask ?? !1), v = new Ll(o, a, u, c, d, h, f, p, l, m, g, y), x = new zt(v.calpha, "f");
            return new wr(t, e, r, {
                texture: o,
                textureSize: a,
                crop: u,
                projection: c,
                axis: d,
                side: h,
                size: f,
                blending: p,
                mat: l,
                alpha: m,
                mode: g,
                isMask: y
            }, v, g, x, y, i);
        } else if (r.type === "matcap") {
            let s = i.image(r.texture.image), o = new Vc(s, r.texture.wrapping), a = new Ce(Nl(r.alpha, i)), l = new xt(r.mode ?? 0), u = new Vr(r.isMask ?? !1), c = new jh(o, a, l, u), d = new zt(c.calpha, "f");
            return new wr(t, e, r, {
                texture: o,
                alpha: a,
                mode: l,
                isMask: u
            }, c, l, d, u, i);
        } else if (r.type === "displace") {
            if (r.displacementType === "noise") {
                let s = new Xi(new _(...r.offset)), o = new Ce(r.scale ?? 10), a = new Ce(r.intensity ?? 8), l = new Ce(r.movement ?? 1), u = new xt(r.noiseType ?? 0), c = new xt(r.voronoiStyle ?? 0), d = new Ce(r.smoothness ?? .5), h = new Ce(r.seed ?? 0), f = new Ce(r.highCut ?? 1), p = new Ce(r.lowCut ?? 0), m = new xt(r.quality ?? 1), g = new Kh(a, l, s, c, d, h, f, p, m, o, u);
                return new _m(t, e, r, {
                    offset: s,
                    scale: o,
                    intensity: a,
                    movement: l,
                    noiseType: u,
                    voronoiStyle: c,
                    smoothness: d,
                    seed: h,
                    highCut: f,
                    lowCut: p,
                    quality: m
                }, g, i);
            } else throw new Error;
        } else return M7(t, e, r, i);
    }
    updateByOp(t, e, r) {
        let i = t;
        if (i.path[0] === void 0) {
            if (i.type === 0) return "type" in i.props || "category" in i.props || "visible" in i.props ? (r.scene.markNeedsUpdateRendererDirty(), !0) : $I(i.props, r.shared, this, e);
        } else if (i.path[0] === "texture") return "texture" in e || "video" in e ? QA(i.props, r.shared, this) : !0;
        return !1;
    }
    dispose() {
        if (E7(this)) {
            let t = this.uniforms[`f${this.id}_texture`];
            if (!t) return !1;
            let e = t;
            e.image instanceof Zn || e.image.deref();
        }
    }
    hasValueByKey(t) {
        return this.uniforms[t] !== void 0;
    }
    hasValue(t) {
        return this.hasValueByKey(`f${this.id}_${t}`);
    }
    setValue(t, e) {
        let r = `f${this.id}_${t}`;
        this.hasValueByKey(r) && e !== void 0 && (this.uniforms[r].value = e);
    }
    getNode(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e];
    }
    getValue(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e].value;
    }
    getName(t) {
        let r = /f\d+_(.*)/.exec(t);
        if (r && r.length > 1) return r[1];
        console.log(`Layer.getName: error ${t}`);
    }
    getNames() {
        let t = [];
        for(let e in this.uniforms){
            let r = this.getName(e);
            r && t.push(r);
        }
        return t;
    }
}, wr = class extends Io {
    constructor(e, r, i, s, o, a, l, u, c){
        super(e, r, i, s, c);
        this.params = s;
        this.color = o;
        this.mode = a;
        this.alpha = l;
        this.isMask = u;
    }
}, _m = class extends Io {
    constructor(e, r, i, s, o, a){
        super(e, r, i, s, a);
        this.position = o;
    }
}, Sn = class extends Io {
    constructor(e, r, i, s, o, a){
        super(e, r, i, o, a);
        this.node = s;
    }
    static createLigherLayer(e, r, i, s) {
        let o, a = new Ce(Nl(i.alpha, s)), l = new xt(i.mode), u = new Ce(i.bumpMapIntensity), c = new Ce(Nl(i.alphaOverride, s)), d;
        if (!i.visible) o = new Ma, d = {};
        else if (i.category === "lambert") {
            o = new xm;
            let h = new Yt(s.color(i.emissive) ?? 0), f = new Vr(i.occlusion ?? !0);
            d = {
                emissive: h,
                occlusion: f
            }, o.emissive = h, o.occlusion = f;
        } else if (i.category === "toon") {
            o = new wm;
            let h = new Ce(i.shininess ?? 30), f = new Yt(s.color(i.specular) ?? 1118481);
            d = {
                shininess: h,
                specular: f
            }, o.shininess = h, o.specular = f;
        } else if (i.category === "physical") {
            o = new Sm;
            let h = new Ce(i.roughness ?? .3), f = new Ce(i.metalness ?? 0), p = new Ce(i.reflectivity ?? .5), m = new Vr(i.occlusion ?? !0);
            d = {
                roughness: h,
                metalness: f,
                reflectivity: p,
                occlusion: m
            }, o.roughness = h, o.metalness = f, o.reflectivity = p, o.occlusion = m;
        } else {
            o = new bm;
            let h = new Ce(i.shininess ?? 30), f = new Yt(i.specular !== void 0 ? s.color(i.specular) ?? 1118481 : 1118481), p = new Vr(i.occlusion ?? !0);
            d = {
                shininess: h,
                specular: f,
                occlusion: p
            }, o.shininess = h, o.specular = f, o.occlusion = p;
        }
        return o.alpha = new Ce(1), o.shadingAlpha = a, o.shadingBlend = l, o.bumpMapIntensity = u, o.alphaOverride = c, d.alpha = o.shadingAlpha, d.mode = o.shadingBlend, d.bumpMapIntensity = o.bumpMapIntensity, d.alphaOverride = o.alphaOverride, new Sn(e, r, i, o, d, s);
    }
    get category() {
        return this.node.category;
    }
};
function E7(n1) {
    let t = n1 instanceof Io ? n1.type : n1;
    return t === "texture" || t === "video" || t === "displace_map" || t === "matcap";
}
function ms(n1) {
    return {
        alpha: new Ce(n1.alpha ?? 1),
        mode: new xt(n1.mode ?? 0),
        isMask: new Vr(n1.isMask ?? !1)
    };
}
function T7(n1, t, e, r, i) {
    switch(n1.type){
        case "color":
            {
                let s = new Yt(r.color ?? Xr), o = ms(r), a = new Uc(s, o.alpha), l = new zt(a.calpha, "f");
                return new wr(t, e, n1, {
                    color: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "fresnel":
            {
                let s = new Yt(r.color ?? 16777215), o = new Ce(r.bias ?? .1), a = new Ce(r.scale ?? 1), l = new Ce(r.intensity ?? 2), u = new Ce(r.factor ?? 1), c = ms(r), d = new ym(s, o, a, l, u, c.alpha, c.mode, c.isMask), h = new zt(d.calpha, "f");
                return new wr(t, e, n1, {
                    color: s,
                    bias: o,
                    scale: a,
                    intensity: l,
                    factor: u,
                    ...c
                }, d, c.mode, h, c.isMask, i);
            }
        case "rainbow":
            {
                let s = new Ce(r.filmThickness ?? 30), o = new Ce(r.movement ?? 0), a = new Xi(r.wavelengths ?? new _(0, 0, 0)), l = new Ce(r.noiseStrength ?? 0), u = new Ce(r.noiseScale ?? 1), c = new Xi(r.offset ?? new _(0, 0, 0)), d = ms(r), h = new Yh(s, o, a, l, u, c, d.alpha, d.isMask), f = new zt(h.calpha, "f");
                return new wr(t, e, n1, {
                    filmThickness: s,
                    movement: o,
                    wavelengths: a,
                    noiseStrength: l,
                    noiseScale: u,
                    offset: c,
                    ...d
                }, h, d.mode, f, d.isMask, i);
            }
        case "transmission":
            {
                let s = new Ce(r.thickness ?? 10), o = new Ce(r.ior ?? 1.5), a = new Ce(r.roughness ?? .5), l = We.transmissionSize, u = We.transmissionRenderTarget, c = We.transmissionRenderTargetDepth, d = window.innerWidth, h = window.innerHeight, f = d >= h ? new Lr(h / d, 1) : new Lr(1, d / h), p = ms(r), m = new Qh(s, o, a, l, u, c, f, p.alpha), g = new zt(m.calpha, "f");
                return new wr(t, e, n1, {
                    thickness: s,
                    ior: o,
                    roughness: a,
                    aspectRatio: f,
                    ...p
                }, m, p.mode, g, p.isMask, i);
            }
        case "toon":
            {
                let s = new xt(r.positioning ?? 0), o;
                r.colors ? o = new Ys(r.colors.length, r.colors) : (o = new Ys(10, new He(0, 0, 0, 1)), o.value[1] = new He(1, 1, 1, 1));
                let a;
                r.steps ? a = new qs(r.steps.length, r.steps) : (a = new qs(10, 1), a.value[0] = 0);
                let l = new Xi(r.source ?? new _(0, 0, 0)), u = new Vr(r.isWorldSpace ?? !0), c = new Ce(r.noiseStrength ?? 0), d = new Ce(r.noiseScale ?? 1), h = new On(r.shadowColor), f = new Xi(r.offset ?? new _(0, 0, 0)), p = ms(r), m = new Xh(s, o, a, l, u, c, d, h, f, p.alpha), g = new zt(m.calpha, "f");
                return new wr(t, e, n1, {
                    positioning: s,
                    colors: o,
                    steps: a,
                    source: l,
                    isWorldSpace: u,
                    noiseStrength: c,
                    noiseScale: d,
                    shadowColor: h,
                    offset: f,
                    ...p
                }, m, p.mode, g, p.isMask, i);
            }
        case "outline":
            {
                let s = new Yt(r.outlineColor ?? 16777215), o = new Yt(r.contourColor ?? 16777215), a = new Ce(r.outlineWidth ?? .1), l = new Ce(r.contourWidth ?? .1), u = new Ce(r.outlineThreshold ?? .1), c = new Ce(r.contourThreshold ?? .1), d = new Ce(r.outlineSmoothing ?? .1), h = new Ce(r.contourFrequency ?? .1), f = new Xi(r.contourDirection ?? new _(0, 1, 0)), p = new Vr(r.positionalLines ?? !1), m = new Vr(r.compensation ?? !0), g = We.normalRenderTarget, y = We.normalRenderTargetDepth, v = We.pixelRatioNode, x = We.resolution, S = ms(r), w = new Wh(s, o, a, l, u, c, d, h, f, p, m, x, g, y, v, S.alpha), A = new zt(w.calpha, "f");
                return new wr(t, e, n1, {
                    outlineColor: s,
                    contourColor: o,
                    outlineWidth: a,
                    contourWidth: l,
                    outlineThreshold: u,
                    contourThreshold: c,
                    outlineSmoothing: d,
                    contourFrequency: h,
                    contourDirection: f,
                    positionalLines: p,
                    compensation: m,
                    ...S
                }, w, S.mode, A, S.isMask, i);
            }
        case "depth":
            {
                let s = new xt(r.gradientType ?? 0), o = new Vr(r.smooth ?? !1), a = new Ce(r.near ?? 50), l = new Ce(r.far ?? 200), u = new Ce(r.isVector ?? 1), c = new Ce(r.isWorldSpace ?? 0), d = new Xi(r.origin ?? new _), h = new Xi(r.direction ?? new _), f;
                r.colors ? f = new Ys(r.colors.length, r.colors) : (f = new Ys(2, new He(0, 0, 0, 1)), f.value[1] = new He(1, 1, 1, 1));
                let p;
                r.steps ? p = new qs(r.steps.length, r.steps) : (p = new qs(2, 1), p.value[0] = 0);
                let m = ms(r), g = new Uh(s, o, a, l, u, c, d, h, f, p, m.alpha, m.isMask), y = new zt(g.calpha, "f");
                return new wr(t, e, n1, {
                    gradientType: s,
                    smooth: o,
                    near: a,
                    far: l,
                    isVector: u,
                    isWorldSpace: c,
                    origin: d,
                    direction: h,
                    colors: f,
                    steps: p,
                    ...m
                }, g, m.mode, y, m.isMask, i);
            }
        case "noise":
            {
                let s = new Ce(r.scale ?? 1), o = new Xi(r.size ?? new _(100, 100, 100)), a = new Ce(r.move ?? 1), l = new Lr(r.fA ?? new N(1.7, 9.2)), u = new Lr(r.fB ?? new N(8.3, 2.8)), c = new Lr(r.distortion ?? new N(1, 1)), d = new On(r.colorA), h = new On(r.colorB), f = new On(r.colorC), p = new On(r.colorD), m = new xt(r.noiseType ?? 0), g = new xt(r.voronoiStyle ?? 0), y = new Ce(r.highCut ?? 1), v = new Ce(r.lowCut ?? 0), x = new Ce(r.smoothness ?? .5), S = new Ce(r.seed ?? .5), w = new xt(r.quality ?? 1), A = ms(r), E = new Hh(s, o, a, l, u, c, d, h, f, p, A.alpha, m, A.isMask, g, y, v, x, S, w), b = new zt(E.calpha, "f");
                return new wr(t, e, n1, {
                    scale: s,
                    size: o,
                    move: a,
                    fA: l,
                    fB: u,
                    distortion: c,
                    colorA: d,
                    colorB: h,
                    colorC: f,
                    colorD: p,
                    noiseType: m,
                    ...A,
                    voronoiStyle: g,
                    highCut: y,
                    lowCut: v,
                    smoothness: x,
                    seed: S,
                    quality: w
                }, E, A.mode, b, A.isMask, i);
            }
        case "normal":
            {
                let s = new Xi(r.cnormal ?? new _(1, 1, 1)), o = ms(r), a = new kh(s, o.alpha), l = new zt(a.calpha, "f");
                return new wr(t, e, n1, {
                    cnormal: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "gradient":
            {
                let s = new xt(r.gradientType ?? 0), o = new Vr(r.smooth ?? !1), a;
                r.colors ? a = new Ys(r.colors.length, r.colors) : (a = new Ys(10, new He(0, 0, 0, 1)), a.value[1] = new He(1, 1, 1, 1));
                let l;
                r.steps ? l = new qs(r.steps.length, r.steps) : (l = new qs(10, 1), l.value[0] = 0);
                let u = new Lr(r.offset ?? new N(0, 0)), c = new Lr(r.morph ?? new N(0, 0)), d = new Ce(r.angle ?? 0), h = ms(r), f = new Gh(s, o, a, l, u, c, d, h.alpha, h.isMask), p = new zt(f.calpha, "f");
                return new wr(t, e, n1, {
                    gradientType: s,
                    smooth: o,
                    colors: a,
                    steps: l,
                    offset: u,
                    morph: c,
                    angle: d,
                    ...h
                }, f, h.mode, p, h.isMask, i);
            }
        case "pattern":
            {
                let s = new xt(r.style ?? 0), o = new xt(r.projection ?? 0), a = new xt([
                    "x",
                    "y",
                    "z"
                ].indexOf(r.axis) ?? 0), l = new Ce(r.blending ?? 0), u = new Lr(r.offset ?? new N(0, 0)), c = new On(r.colorA), d = new On(r.colorB), h = new Lr(r.frequency ?? new N(10, 10)), f = new Ce(r.size ?? .5), p = new Ce(r.variation ?? 0), m = new Ce(r.smoothness ?? .5), g = new Ce(r.zigzag ?? 0), y = new Ce(r.rotation ?? 0), v = new Lr(r.vertical ?? new N(0, 1)), x = new Lr(r.horizontal ?? new N(0, 1)), S = new xt(r.sides ?? 6), w = ms(r), A = new qh(s, o, a, l, u, c, d, h, f, p, m, g, y, v, x, S, w.alpha, w.isMask), E = new zt(A.calpha, "f");
                return new wr(t, e, n1, {
                    style: s,
                    projection: o,
                    axis: a,
                    blending: l,
                    offset: u,
                    colorA: c,
                    colorB: d,
                    frequency: h,
                    size: f,
                    variation: p,
                    smoothness: m,
                    zigzag: g,
                    rotation: y,
                    vertical: v,
                    horizontal: x,
                    sides: S,
                    ...w
                }, A, w.mode, E, w.isMask, i);
            }
        default:
            {
                let s = new Yt(1, 0, 0, 1), o = ms(r), a = new Uc(s, o.alpha), l = new zt(a.calpha, "f");
                return new wr(t, e, n1, {
                    color: s,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
    }
}
function M7(n1, t, e, r) {
    let i = JI(e, r);
    return T7(e, n1, t, i, r);
}
function KA(n1, t, e, r) {
    if (e.type === "displace" && (n1 === "intensity" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_intensity`];
        return i ? (i.value = e.intensity * (e.visible ? 1 : 0), i) : void 0;
    }
    if (e.type !== "displace" && (n1 === "alpha" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_alpha`];
        if (!i) return;
        if (i.value = Nl(e.alpha, r) * (e.visible ? 1 : 0), e.type === "outline" && n1 === "visible") {
            let s = t.uniforms[`f${t.id}_compensation`];
            s && (s.value = e.compensation && e.visible);
        }
        return i;
    }
}
function jc(n1, t) {
    let e = 0, r = n1.layers.find((i)=>i.data.type === "light");
    if (r) {
        let i = r.data, s = Number(t.getVariable(i.alphaOverride));
        if ((typeof i.alphaOverride == "string" ? s / 100 : i.alphaOverride) < 1) return !0;
    }
    for (let i of n1.layers){
        if (i.data.type !== "displace" && i.data.isMask) return !0;
        if (i.data.type !== "displace" && "alpha" in i.data && i.data.type !== "light" && i.data.type !== "fresnel" && i.data.type !== "texture" && i.data.type !== "matcap" && i.data.type !== "rainbow" && i.data.type !== "outline" && i.data.type !== "pattern") {
            let s = i.data.visible ? i.data.alpha : 0;
            if (typeof s == "string" && (s = Math.max(0, Math.min(1, Number(t.getVariable(s) ?? 100) / 100))), s === 1 && i.data.type === "depth" || i.data.type === "gradient") {
                for (let o of i.data.colors)if (o[3] < 1) {
                    s = o[3];
                    break;
                }
            } else if (s === 1 && i.data.type === "noise") {
                let o = t.color(i.data.colorA).a, a = t.color(i.data.colorB).a, l = t.color(i.data.colorC).a, u = t.color(i.data.colorD).a, c = Math.min(o, Math.min(a, Math.min(l, u)));
                c < 1 && (s = c);
            }
            e += (1 - e) * s;
        }
    }
    return e < 1;
}
var Rn = class extends rt {
    constructor(){
        super(void 0);
        this.flatShading = !1;
        this.needsJitter = !0;
        this.cacheKey = "";
        this.fog = !0, this.dithering = !0, this.vertexColors = !0, this.transparent = !0;
    }
    customProgramCacheKey() {
        return this.cacheKey;
    }
}, Y0 = class extends Rn {
    constructor(e, r, i, s){
        super();
        this.flatShading = e;
        this.side = r;
        this.wireframe = i;
        this.root = s;
    }
    updateAfterBuild() {
        let e = this.root;
        this.lights = e.lights, this.vertexShader = e.vertexShader, this.fragmentShader = e.fragmentShader, this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.transparent = e.transparent, this.cacheKey = e.customProgramCacheKey() + "flat" + this.flatShading + this.side;
    }
    onBeforeCompile(e, r) {
        this.root.onBeforeCompile(e);
    }
    get data() {
        return this.root.data;
    }
    get category() {
        return this.root.category;
    }
    get hasAO() {
        return this.root.hasAO;
    }
    getFlavor(e, r, i) {
        return this.root.getFlavor(e, r, i);
    }
    get layers() {
        return this.root.layers;
    }
    get fragment() {
        return this.root.fragment;
    }
    getLayersOfType(e) {
        return this.root.getLayersOfType(e);
    }
    getLayerByUuid(e) {
        return this.root.getLayerByUuid(e);
    }
    updateByOp(e, r, i) {
        this.root.updateByOp(e, r, i);
    }
    nodeMaterialDispose() {
        this.root.nodeMaterialDispose();
    }
}, Pa = class extends Rn {
    constructor(e, r, i = !0){
        super();
        this.data = e;
        this.allowVariableSaves = i;
        this.layerIdGen = 0;
        this.flavors = [];
        this.masks = {};
        this.type = "NodeMaterial";
        this.updaters = [], this.reset0(e, r);
    }
    get nodeMaterial() {
        return this;
    }
    getFlavor(e, r, i) {
        let s = i ? 6 : (e ? 3 : 0) + r;
        if (s === 0) return this;
        this.flavors === void 0 && (this.flavors = []), s -= 1;
        let o = this.flavors[s];
        return o === void 0 && (o = new Y0(e, r, i, this), this.flavors[s] = o, o.flatShading = e, o.side = r, o.updateAfterBuild()), o;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    get category() {
        return this.lightLayer.category;
    }
    get hasAO() {
        return this.lightLayer.getNode("occlusion")?.value ?? !1;
    }
    reset(e, r, i = !1) {
        (this.data !== e || i) && this.reset0(e, r);
    }
    reset0(e, r) {
        this.data = e;
        let i = e.layers ?? Qr.defaultTwoLayerData("phong").layers;
        try {
            this.layers = i.map((s)=>Io.create(this.layerIdGen++, s.id, s.data, r.shared));
        } catch  {
            this.layers = [];
        }
        this.layers.reverse(), this.name = e.name ?? "Untitled Material", this.onUpdate(r.shared), this.transparent = jc(e, r.shared), this.saveVariableLocations(r);
    }
    onVariableUpdate(e, r, i) {
        if (e[0] === "alphaOverride") this.transparent = jc(this.data, i.shared), this.lightLayer.setValue("alphaOverride", Math.max(0, Math.min(Number(r) / 100, 1)));
        else if (e[0] === "layer") {
            let s = e[1], o = e[2];
            if (s && o) {
                let a = this.layers.find((l)=>l.uuid === s);
                a?.hasValue(o) && (o === "alpha" ? (this.transparent = jc(this.data, i.shared), a.setValue(o, Math.max(0, Math.min(Number(r) / 100, 1)))) : a.setValue(o, r));
            }
        }
    }
    saveVariableLocations(e) {
        if (!this.allowVariableSaves) return;
        let r = this.data.layers.find((i)=>i.data.type === "light");
        r && e.shared.getVariable(r.data.alphaOverride, [
            "material",
            this.uuid,
            "alphaOverride"
        ]), this.data.layers.forEach((i)=>{
            "alpha" in i.data && typeof i.data.alpha == "string" && e.shared.getVariable(i.data.alpha, [
                "material",
                this.uuid,
                "layer",
                i.id,
                "alpha"
            ]);
        });
    }
    getLayersOfType(e) {
        return this.layers.filter((r)=>r.type === e);
    }
    getLayerByUuid(e) {
        return this.layers.find((r)=>r.uuid === e);
    }
    onUpdate(e) {
        this.cacheKey = this.computeCacheKey(), this.lightLayer = this.layers.find((r)=>r instanceof Sn), this.lightLayer === void 0 && (this.lightLayer = new Sn(0, "", {
            ...Ir.defaultData("light", "phong"),
            visible: !1
        }, new Ma, {}, e)), this.dispose();
        for (let r of this.flavors)r && r.dispose();
        this.applyTextureMaps(), this.applyMasks(), this.blendColors(), this.blendAfterColors(), this.blendPositions();
    }
    applyTextureMaps() {
        let e = this.layers.find((o)=>o instanceof Sn);
        if (!e) return;
        let r = e.data, i = r.bumpMap, s = r.roughnessMap;
        e.node.bumpMap = void 0, e.node.roughnessMap = void 0;
        for(let o = 0; o < this.layers.length; ++o){
            let a = this.layers[o];
            a instanceof wr && a.color instanceof Ll && (a.uuid === i && (e.node.bumpMap = a.color), a.uuid === s && (e.node.roughnessMap = a.color));
        }
    }
    updateByOp(e, r, i) {
        if (r !== void 0 ? this.data = r : r = this.data, this.transparent = jc(r, i.shared), e.path[0] === "layers") {
            this.data = r;
            let s = i.shared, o = e.path[1];
            if (o === void 0) {
                if (this.layers.reverse(), e.type === 4) {
                    let a = Io.create(this.layerIdGen++, e.id, e.data, i.shared);
                    this.layers.splice(e.localIndex, 0, a), i.scene.markNeedsUpdateRendererDirty();
                } else if (e.type === 5) this.layers.splice(e.localIndex, 1)[0].dispose(), i.scene.markNeedsUpdateRendererDirty();
                else if (e.type === 6) {
                    let a = this.layers.findIndex((u)=>u.uuid === e.id), l = this.layers[a];
                    this.layers.splice(a, 1), this.layers.splice(e.localIndex, 0, l), i.scene.markNeedsUpdateRendererDirty();
                }
                this.layers.reverse(), this.onUpdate(i.shared);
            } else {
                e.type === 0 && e.props.occlusion !== void 0 && i.scene.markNeedsUpdateRendererDirty();
                let a = this.layers.find((l)=>l.uuid === o);
                if (a) {
                    let l = r.layers.data(o), u;
                    if (e.type === 0 && ("alpha" in e.props || "alphaOverride" in e.props) && ("alpha" in e.props ? u = {
                        ...e.props,
                        alpha: Nl(e.props.alpha, s, [
                            "material",
                            this.uuid,
                            "layer",
                            o,
                            "alpha"
                        ])
                    } : u = {
                        ...e.props,
                        alphaOverride: Nl(e.props.alphaOverride, s, [
                            "material",
                            this.uuid,
                            "alphaOverride"
                        ])
                    }), a.updateByOp({
                        ...e,
                        ...u ? {
                            props: u
                        } : {},
                        path: e.path.slice(2)
                    }, l, i)) {
                        let d = Io.create(this.layerIdGen++, o, l, s);
                        this.layers.splice(this.layers.findIndex((h)=>h.uuid === o), 1, d), this.onUpdate(i.shared);
                    }
                }
            }
        } else this.reset(r, i);
    }
    applyMasks() {
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            r instanceof wr ? r.color.mask = void 0 : r instanceof Sn && (r.node.mask = void 0);
        }
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            if (r instanceof wr && r.isMask.value && r.data.visible && e > 0) {
                let i = e - 1, s = this.layers[i];
                s instanceof Sn ? s.node.mask = new zi(r.color, r.alpha, zi.MUL) : s instanceof wr && (s.isMask.value || (s.color.mask = new zi(r.color, r.alpha, zi.MUL)));
            }
        }
    }
    blendColors() {
        let e = this.layers.findIndex((i)=>i instanceof wr), r = this.layers.findIndex((i)=>i instanceof Sn);
        if (e !== -1 && e < r) {
            let i = this.layers[e].color;
            for(let s = e + 1; s < r; ++s){
                let o = this.layers[s];
                if (o instanceof wr) {
                    if (o.isMask.value) continue;
                    i = new Fh(i, o.color, o.alpha, o.mode);
                }
            }
            this.fragment.color = i;
        } else this.fragment.color = void 0;
    }
    blendAfterColors() {
        let e = new zt("outgoingLight", "f"), r = this.layers.findIndex((i)=>i instanceof Sn);
        if (this.layers.length > r + 1) {
            for(let i = r + 1; i < this.layers.length; ++i){
                let s = this.layers[i];
                if (s instanceof wr) {
                    if (s.isMask.value) continue;
                    e = new Fh(e, s.color, s.alpha, s.mode);
                }
            }
            this.fragment.afterColor = e;
        } else this.fragment.afterColor = void 0;
    }
    blendPositions() {
        let e = this.layers.filter((r)=>r instanceof _m);
        if (e.length > 0) {
            let r = e[0].position;
            for(let i = 1; i < e.length; ++i)e[i] && (r = new zi(r, e[i].position, zi.ADD), r = new zi(r, new Ce(.5).setReadonly(!0), zi.MUL));
            this.fragment.position = r;
        } else this.fragment.position = void 0;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    onBeforeCompile(e) {
        this.build(), e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.extensionDerivatives = this.extensions.derivatives === !0, e.extensionFragDepth = this.extensions.fragDepth === !0, e.extensionDrawBuffers = this.extensions.drawBuffers === !0, e.extensionShaderTextureLOD = this.extensions.shaderTextureLOD === !0;
    }
    clampUniformsForPreview(e, r) {
        let i = (s, o, a)=>Math.min(Math.max(s, o), a);
        for (let s of this.layers)if (s.type === "displace") {
            let o = i(s.uniforms[`f${s.id}_intensity`].value, e, r);
            s.uniforms[`f${s.id}_intensity`].value = o;
        }
    }
    computeCacheKey() {
        let e = "[";
        for (let { data: r } of this.data.layers)if (r.type === "light") e += `"${r.visible ? r.category.toUpperCase() : "Basic"}"`;
        else {
            let i = (YA[r.type] ?? []).map((u)=>r[u]), s = (XA[r.type] ?? []).map((u)=>r[u]?.length ?? 0), o = [
                ...i,
                ...s
            ], a = "isMask" in r && r.isMask, l = `"${r.type}-${r.visible}-${a}"`;
            o.length ? e += `[${l}, "${o.join('","')}"],` : e += l;
        }
        return e = e.slice(0, -1) + "]", e;
    }
    updateFrame(e) {
        for(let r = 0; r < this.updaters.length; ++r)e.updateNode(this.updaters[r]);
    }
    build() {
        let e = new Bh;
        e.needsJitter = this.needsJitter, this.lights = this.lightLayer.data.visible, e.build(this.fragment, this.fragment), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.updaters = e.updaters;
        for (let r of this.flavors)r && r.updateAfterBuild();
        return this;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
        for (let e of this.flavors)e && e.dispose();
    }
    assetsLoaded() {
        for (let e of this.layers)if (e instanceof wr) {
            let r = e.params.texture;
            if (r instanceof Vc && !r.image.loaded) return !1;
        }
        return !0;
    }
    getHash() {
        let e = "{";
        return e += '"fragment":' + this.fragment.getHash(), e += "}", e;
    }
};
Object.defineProperties(Rn.prototype, {
    properties: {
        get: function() {
            return this.fragment.properties;
        }
    }
});
var Hc = class extends Pa {
    constructor(t, e, r){
        super(t, e, !1), this.uuid = r, this.allowVariableSaves = !0, this.saveVariableLocations(e);
    }
};
var iR = Pi(eR());
var tR = new Map;
function rR(n1) {
    if (typeof n1 == "string") return n1;
    let t = tR.get(n1);
    return t || (t = {
        url: URL.createObjectURL(new Blob([
            n1
        ]))
    }, tR.set(n1, t)), t.url;
}
var Da = class {
    constructor({ src: t, volume: e, delay: r, loop: i }){
        this._volume = 1;
        this.delay = 0;
        this._loop = 1;
        this.loopsRemaining = 0;
        this._status = "stopped";
        this.onEnd = ()=>{
            this.loopsRemaining === 1 / 0 ? this.replay() : this.loopsRemaining > 1 ? (this.replay(), this.loopsRemaining--) : (this._status = "stopped", this.loopsRemaining = this._loop);
        };
        let s;
        typeof t == "string" ? s = {
            src: t
        } : s = {
            src: rR(t),
            format: "wav"
        }, this.sound = new iR.Howl(s), this.sound.on("end", this.onEnd), this.src = t, e !== void 0 && (this.volume = e), r !== void 0 && (this.delay = r), i !== void 0 && (this.loop = i);
    }
    get status() {
        return this._status;
    }
    get volume() {
        return this._volume;
    }
    set volume(t) {
        this._volume = t, this.sound.volume(t);
    }
    get loop() {
        return this._loop;
    }
    set loop(t) {
        this._loop = t, this.loopsRemaining = t;
    }
    replay() {
        this.clearDelay(), this.delayTimerId = window.setTimeout(()=>{
            this.sound.play(), this.clearDelay();
        }, this.delay);
    }
    fade(t, e = 1e3) {
        t ? (this.sound.volume(this._volume), this.clearFade(), this.fadeTimerId = window.setTimeout(()=>{
            this.sound.fade(this._volume, 0, e), this.clearFade();
        }, t)) : this.sound.fade(this._volume, 0, e);
    }
    on(t, e, r) {
        this.sound.on(t, e, r);
    }
    off(t, e, r) {
        this.sound.off(t, e, r);
    }
    play() {
        this._status === "playing" || this.sound.playing() || (this._status === "paused" ? (this.sound.seek() === 0 ? this.replay() : this.sound.play(), this._status = "playing") : this._status === "stopped" && (this.replay(), this._status = "playing"));
    }
    pause() {
        this._status === "playing" && (this.sound.pause(), this.clearFade(), this.clearDelay(), this._status = "paused");
    }
    stop() {
        this.sound.stop(), this.loopsRemaining = this._loop, this.clearFade(), this.clearDelay(), this._status = "stopped";
    }
    clearFade() {
        this.fadeTimerId && (clearTimeout(this.fadeTimerId), delete this.fadeTimerId);
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    dispose(t = !1) {
        this.off(), this.stop(), this.clearFade(), this.clearDelay();
    }
};
var Q0 = class {
    constructor(){
        this.type = "ShapePath";
        this.color = new Le;
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(t, e) {
        return this.currentPath = new yc, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
    }
    lineTo(t, e) {
        return this.currentPath?.lineTo(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        return this.currentPath?.quadraticCurveTo(t, e, r, i), this;
    }
    bezierCurveTo(t, e, r, i, s, o) {
        return this.currentPath?.bezierCurveTo(t, e, r, i, s, o), this;
    }
    splineThru(t) {
        return this.currentPath?.splineThru(t), this;
    }
    toShapes() {
        let e = {
            ORIGIN: 0,
            DESTINATION: 1,
            BETWEEN: 2,
            LEFT: 3,
            RIGHT: 4,
            BEHIND: 5,
            BEYOND: 6
        }, r = {
            loc: e.ORIGIN,
            t: 0
        };
        function i(m, g, y, v) {
            let x = m.x, S = g.x, w = y.x, A = v.x, E = m.y, b = g.y, T = y.y, M = v.y, C = (A - w) * (E - T) - (M - T) * (x - w), P = (S - x) * (E - T) - (b - E) * (x - w), D = (M - T) * (S - x) - (A - w) * (b - E), O = C / D, I = P / D;
            if (D === 0 && C !== 0 || O <= 0 || O >= 1 || I < 0 || I > 1) return null;
            if (C === 0 && D === 0) {
                for(let z = 0; z < 2; z++)if (s(z === 0 ? y : v, m, g), r.loc === e.ORIGIN) {
                    let B = z === 0 ? y : v;
                    return {
                        x: B.x,
                        y: B.y,
                        t: r.t
                    };
                } else if (r.loc === e.BETWEEN) {
                    let B = +(x + r.t * (S - x)).toPrecision(10), V = +(E + r.t * (b - E)).toPrecision(10);
                    return {
                        x: B,
                        y: V,
                        t: r.t
                    };
                }
                return null;
            } else {
                for(let V = 0; V < 2; V++)if (s(V === 0 ? y : v, m, g), r.loc === e.ORIGIN) {
                    let U = V === 0 ? y : v;
                    return {
                        x: U.x,
                        y: U.y,
                        t: r.t
                    };
                }
                let z = +(x + O * (S - x)).toPrecision(10), B = +(E + O * (b - E)).toPrecision(10);
                return {
                    x: z,
                    y: B,
                    t: O
                };
            }
        }
        function s(m, g, y) {
            let v = y.x - g.x, x = y.y - g.y, S = m.x - g.x, w = m.y - g.y, A = v * w - S * x;
            if (m.x === g.x && m.y === g.y) {
                r.loc = e.ORIGIN, r.t = 0;
                return;
            }
            if (m.x === y.x && m.y === y.y) {
                r.loc = e.DESTINATION, r.t = 1;
                return;
            }
            if (A < -Number.EPSILON) {
                r.loc = e.LEFT;
                return;
            }
            if (A > Number.EPSILON) {
                r.loc = e.RIGHT;
                return;
            }
            if (v * S < 0 || x * w < 0) {
                r.loc = e.BEHIND;
                return;
            }
            if (Math.sqrt(v * v + x * x) < Math.sqrt(S * S + w * w)) {
                r.loc = e.BEYOND;
                return;
            }
            let E;
            v !== 0 ? E = S / v : E = w / x, r.loc = e.BETWEEN, r.t = E;
        }
        function o(m, g) {
            let y = [], v = [];
            for(let x = 1; x < m.length; x++){
                let S = m[x - 1], w = m[x];
                for(let A = 1; A < g.length; A++){
                    let E = g[A - 1], b = g[A], T = i(S, w, E, b);
                    T !== null && y.find((M)=>M.t <= T.t + Number.EPSILON && M.t >= T.t - Number.EPSILON) === void 0 && (y.push(T), v.push(new N(T.x, T.y)));
                }
            }
            return v;
        }
        function a(m, g, y) {
            let v = new N;
            g.getCenter(v);
            let x = [];
            return y.forEach((S)=>{
                S.boundingBox.containsPoint(v) && o(m, S.points).forEach((A)=>{
                    x.push({
                        identifier: S.identifier,
                        isCW: S.isCW,
                        point: A
                    });
                });
            }), x.sort((S, w)=>S.point.x - w.point.x), x;
        }
        function l(m, g, y, v, x) {
            (x == null || x === "") && (x = "nonzero");
            let S = new N;
            m.boundingBox.getCenter(S);
            let w = [
                new N(y, S.y),
                new N(v, S.y)
            ], A = a(w, m.boundingBox, g);
            A.sort((P, D)=>P.point.x - D.point.x);
            let E = [], b = [];
            A.forEach((P)=>{
                P.identifier === m.identifier ? E.push(P) : b.push(P);
            });
            let T = E[0].point.x, M = [], C = 0;
            for(; C < b.length && b[C].point.x < T;)M.length > 0 && M[M.length - 1] === b[C].identifier ? M.pop() : M.push(b[C].identifier), C++;
            if (M.push(m.identifier), x === "evenodd") {
                let P = M.length % 2 === 0, D = M[M.length - 2];
                return {
                    identifier: m.identifier,
                    isHole: P,
                    for: D
                };
            } else if (x === "nonzero") {
                let P = !0, D = null, O = null;
                for(let I = 0; I < M.length; I++){
                    let z = M[I];
                    g[z] && (P ? (O = g[z].isCW, P = !1, D = z) : O !== g[z].isCW && (O = g[z].isCW, P = !0));
                }
                return {
                    identifier: m.identifier,
                    isHole: P,
                    for: D
                };
            } else console.warn('fill-rule: "' + x + '" is currently not implemented.');
        }
        let u = 0, c = 999999999, d = -999999999, h = [];
        this.subPaths.forEach((m)=>{
            let g = m.getPoints(), y = -999999999, v = 999999999, x = -999999999, S = 999999999;
            for(let w = 0; w < g.length; w++){
                let A = g[w];
                A.y > y && (y = A.y), A.y < v && (v = A.y), A.x > x && (x = A.x), A.x < S && (S = A.x);
            }
            d <= x && (d = x + 1), c >= S && (c = S - 1), g.length && h.push({
                curves: m.curves,
                points: g,
                isCW: Fu.isClockWise(g),
                identifier: u++,
                boundingBox: new Xu(new N(S, v), new N(x, y))
            });
        });
        let f = h.map((m)=>l(m, h, c, d, this.userData?.style.fillRule)), p = [];
        return h.forEach((m)=>{
            let g = f[m.identifier];
            if (g && !g.isHole) {
                let y = new oa;
                y.curves = m.curves, f.filter((x)=>x?.isHole && x.for === m.identifier).forEach((x)=>{
                    if (x) {
                        let S = h[x.identifier], w = new yc;
                        w.curves = S.curves, y.holes.push(w);
                    }
                }), p.push(y);
            }
        }), p;
    }
};
var ZA = !1, sR, JA = new Promise((n1)=>{
    sR = n1;
}), nR = !1;
var K0;

function oR() {
    if (ZA = !0, nR) return;
    if (K0) return K0;
    async function n1() {
        let e = await (parcelRequire("14X3t"));
        sR(e), nR = !0;
    }
    return K0 = n1(), K0;
}
var Em = class {
    async load(t, e, r = ()=>{}) {
        let { load: i } = await JA;
        i(t, (s, o)=>{
            s || !o ? r(s ?? "Something went wrong") : e(o);
        });
    }
    async parse(t) {
        let { parse: e, Bidi: r } = await JA;
        try {
            let i = e(t), s = new r, o = (a)=>i.charToGlyphIndex(a.char);
            return s.registerModifier("glyphIndex", null, o), s.applyFeatures(i, i.defaultRenderOptions.features), {
                font: i,
                bidi: s
            };
        } catch (i) {
            console.error(i);
        }
    }
};
async function C7(n1) {
    return await (await fetch(n1)).arrayBuffer();
}
var P7 = new Em;
async function $A(n1) {
    let t, e, r = !1;
    if (n1.url ? (t = await C7(n1.url), e = n1.url, r = n1.url.startsWith("/")) : n1.data && (t = n1.data.buffer.slice(n1.data.byteOffset, n1.data.byteOffset + n1.data.byteLength)), t) {
        if (ZA) {
            let i = await P7.parse(t);
            if (i) return {
                font: i.font,
                url: e,
                intercepted: r,
                arr: t,
                bidi: i.bidi
            };
        } else return {
            font: void 0,
            url: e,
            intercepted: r,
            arr: t,
            bidi: null
        };
    }
}
function D7(n1, t) {
    return t.state.glyphIndex === n1 || t.state.fina === n1 || t.state.medi === n1 || t.state.init === n1;
}
var Z0 = class {
    constructor(t){
        this._arrayBuffer = new ArrayBuffer(1);
        this._isLoaded = !1;
        this._intercepted = !1;
        this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = $A(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    update(t) {
        this._isLoaded = !1, this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = $A(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    get url() {
        return this._url;
    }
    get intercepted() {
        return this._intercepted;
    }
    get isLoaded() {
        return this._isLoaded;
    }
    get loadingPromise() {
        return this._loadingPromise;
    }
    reverseLigaturesTable(t, e, r) {
        if (!this._bidi) return [];
        let i = this._bidi;
        i.getTextGlyphs(e);
        let s = i.tokenizer.tokens, o = [], a = 0, l = r.length === s.length;
        for(let u = 0; u < r.length; u++){
            let c = r[u].index, d = String.fromCharCode(r[u].unicode), h = s[a];
            if (D7(c, h) || l) o.push({
                char: d,
                index: c,
                replacements: [
                    h.state.glyphIndex
                ],
                replacementChars: [
                    h.char
                ]
            }), a++;
            else {
                let f = h.char, p = "", m = [
                    h.state.glyphIndex
                ], g = [], y = !1;
                for(; !y;)a++, p = e.charAt(a), f += p, m.push(t.charToGlyphIndex(p)), g = t.stringToGlyphs(f), g.length === 1 && g[0].index === c && (y = !0), a > e.length && (y = !0);
                o.push({
                    char: d,
                    index: c,
                    replacements: m,
                    replacementChars: Array.from(f)
                }), a++;
            }
        }
        return o;
    }
    generateShapes(t, e) {
        if (!this._isLoaded) return;
        let r = this.font, i = e.fontSize / this.unitsPerEm, s = e.fontSize * e.lineHeight, o = t.map((v)=>this.getTextWidth(v, e)), a = e.width, l = this.getCharWidth(`
`, e), u = e.horizontalAlign === 1 ? l : 0, c = this.computeSpaceWidthForLine(t, 0, e), d = this.getLineInitialOffsetX(o[0], a, e.horizontalAlign, t[0], l), h = this.getLineInitialOffsetY(s, t.length, e.height, i, e.verticalAlign), f = [], p = t.map((v)=>[]), m = t.map((v)=>[]), g;
        for(let v = 0; v < t.length; v++){
            let x = t[v], S = {
                features: {
                    liga: !0
                }
            }, w = [];
            try {
                w = r.stringToGlyphs(x, S);
            } catch (E) {
                console.warn(E);
            }
            d = this.getLineInitialOffsetX(o[v], a, e.horizontalAlign, x, l);
            let A = [];
            try {
                A = this.reverseLigaturesTable(r, x, w);
            } catch (E) {
                console.warn(E);
            }
            c = this.computeSpaceWidthForLine(t, v, e);
            for(let E = 0; E < w.length; E++){
                let b = w[E], T = b.index === 0 ? `
` : b.unicode ? String.fromCharCode(b.unicode) : void 0, M = A[E], C = 0, P = 0;
                E === 0 && e.horizontalAlign === 2 && b.leftSideBearing !== void 0 && (P = -b.leftSideBearing * i), g && (C = r.getKerningValue(b, g) * i), d += P + C;
                let D = 0;
                if (T === `
`) D = u;
                else if (T === " ") D = c;
                else {
                    let O = this.createPath(b, i, d, h, e);
                    O && (D = O.offsetX - (C + P), f.push(O.path));
                }
                if (M.replacements.length === 1) m[v].push([
                    d,
                    h
                ]), p[v].push(D);
                else {
                    let O = M.replacements.map((V)=>(r.glyphs.get(V).advanceWidth ?? 0) * i), I = O.reduce((V, U)=>V += U, 0), z = O.map((V)=>V / I), B = d;
                    for(let V = 0; V < z.length; V++){
                        let U = D * z[V];
                        m[v].push([
                            B,
                            h
                        ]), p[v].push(U), B += U;
                    }
                }
                d += D, g = b;
            }
            h -= s;
        }
        let y = [];
        for(let v = 0, x = f.length; v < x; v++)y.push(...f[v].toShapes());
        return {
            shapes: y,
            charWidths: p,
            lineWidths: o,
            charCoords: m
        };
    }
    get isUserFont() {
        return this._isUserFont;
    }
    get arrayBuffer() {
        return this._arrayBuffer;
    }
    get ascender() {
        return this.font?.ascender ?? 0;
    }
    get descender() {
        return this.font?.descender ?? 0;
    }
    get familyName() {
        return this.font?.names.fontFamily ?? "";
    }
    get subfamilyName() {
        return this.font?.names.fontSubfamily ?? "";
    }
    get unitsPerEm() {
        return this.font?.unitsPerEm ?? 1;
    }
    getLineInitialOffsetX(t, e, r, i, s) {
        return (r === 3 || r === 2) && i.indexOf(`
`) >= 0 && (t -= s), r === 3 ? e * .5 - t * .5 : r === 2 ? e - t : 0;
    }
    getLineInitialOffsetY(t, e, r, i, s) {
        let o = e * t, a = Math.abs(this.ascender - this.descender) * i, l = t - a, u = -this.ascender * i - l / 2;
        return s === 3 ? -(r - o - u) : s === 2 ? -(r * .5 - o * .5 - u) : u;
    }
    createPath(t, e, r, i, s) {
        let o = t.getPath(r, -i, s.fontSize, {
            kerning: !1,
            letterSpacing: s.letterSpacing
        });
        if (!o) {
            console.error('THREE.Font: character "' + t + '" does not exists in font family ' + this.familyName + ".");
            return;
        }
        let a = new Q0, l = (t.advanceWidth ?? 1) * e;
        if (t) for (let u of o.commands){
            let c = a.currentPath?.currentPoint;
            if (!(c && u.type !== "Z" && c.x === u.x && -c.y === u.y)) switch(u.type){
                case "M":
                    a.moveTo(u.x, -u.y);
                    break;
                case "L":
                    a.lineTo(u.x, -u.y);
                    break;
                case "Q":
                    a.quadraticCurveTo(u.x1, -u.y1, u.x, -u.y);
                    break;
                case "C":
                    a.bezierCurveTo(u.x1, -u.y1, u.x2, -u.y2, u.x, -u.y);
                    break;
            }
        }
        return a.subPaths.forEach((u)=>{
            let c = O7(u.curves);
            c !== void 0 && u.currentPoint.distanceTo(c) > 0 && u.lineTo(c.x, c.y);
        }), {
            offsetX: l + s.fontSize * s.letterSpacing,
            path: a
        };
    }
    getCharWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    getTextWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    computeSpaceWidthForLine(t, e, r) {
        let i = this.getCharWidth(" ", r), s = t[e];
        if (s) {
            let o = this.countSpaces(s.trimEnd());
            if (r.horizontalAlign === 4 && e < t.length - 1 && o) {
                let a = r.width, l = this.getTextWidth(s, r);
                return (a - (l - o * i)) / o;
            }
        }
        return i;
    }
    countSpaces(t) {
        return (t.match(/ /g) || []).length;
    }
};
function O7(n1) {
    if (n1.length) {
        let t = n1[0];
        if (t instanceof nn) return t.v1;
        if (t instanceof rn || t instanceof Wn) return t.v0;
    }
}
var e_ = class {
    constructor(){
        this.objects = new Map;
        this.unreachable = new Set;
    }
    getCached(t) {
        return this.objects.get(t);
    }
    get size() {
        return this.objects.size;
    }
    get(t, e, r) {
        let i = this.objects.get(t);
        return i === void 0 ? (i = this.createObject(t, e, r), this.objects.set(t, i)) : i.isShared = !0, i;
    }
    forceDelete(t) {
        let e = this.objects.get(t);
        e && (this.disposeObject(e), this.objects.delete(t));
    }
    mutateIfUnique(t, e) {
        let r = this.objects.get(t);
        if (r && r.isShared !== !0) return this.objects.delete(t), this.objects.set(e, r), r;
    }
    startGc() {
        this.unreachable = new Set(this.objects.keys());
    }
    markAsReachable(t, e) {
        let r = this.objects.get(t);
        e === r && this.unreachable.delete(t);
    }
    endGc() {
        this.unreachable.forEach((t)=>{
            this.disposeObject(this.objects.get(t)), this.objects.delete(t);
        }), this.unreachable.clear();
    }
    dispose() {
        this.objects.forEach((t)=>{
            this.disposeObject(t);
        }), this.objects.clear();
    }
}, Tm = class extends e_ {
    constructor(e){
        super();
        this.flatShading = e;
    }
    disposeObject(e) {
        e.dispose();
    }
    createObject(e, r, i) {
        let s = Ta(e, r, this.flatShading, i);
        return s.computeBoundingSphere(), s;
    }
};
var aR = {
    markNeedsUpdateRendererDirty: ()=>{}
};
var t_ = class extends G0 {
    constructor(e){
        super();
        this.shared = e;
    }
    create(e) {
        return new Zh(e, this.shared);
    }
}, Wc = class {
    constructor(t, e = {}){
        this.data = t;
        this.geometryCache = new Tm(!0);
        this.geometryCache2 = new Tm(!1);
        this.imageHolderCache = new t_(this);
        this.thisContext = {
            scene: aR,
            shared: this
        };
        this.deletedMaterial = new Hc(Qr.defaultTwoLayerData("phong"), this.thisContext, "");
        this.deletedImage = new Zn(Yd.emptyImage, this);
        this.deletedVideo = new Zn(kd.defaultVideo, this);
        this.materials = {};
        this.images = {};
        this.canvases = {};
        this.videos = {};
        this.colors = {};
        this.audios = {};
        this.particles = {};
        this.fonts = {};
        this.variables = {};
        this.mouseProperty = null;
        this.raycastProperty = null;
        this.requestRender = ()=>{
            this._requestRender && this._requestRender();
        };
        if (e.images) for (let [r, i] of Object.entries(e.images))this.addImage(r, i);
        if (e.videos) for (let [r, i] of Object.entries(e.videos))this.addVideo(r, i);
        if (e.audios) for (let [r, i] of Object.entries(e.audios))this.addAudio(r, i);
        if (e.particles) for (let [r, i] of Object.entries(e.particles))this.addParticle(r, i);
        this.reset(t);
    }
    setRequestRender(t) {
        this._requestRender = t;
    }
    setEntityOpContext(t) {
        this.entityOpContext = t;
    }
    reset(t, e = !1) {
        this.resetLib(t.lib);
        for (let { id: r, data: i } of t.variables)this.addVariableHolder(r, i), e && this.updateVariableHolder(r, i);
        for (let [r, i] of Object.entries(t.images))this.addImage(r, i);
        for (let [r, i] of Object.entries(t.videos))this.addVideo(r, i);
        for (let [r, i] of Object.entries(t.colors))this.addColor(r, i);
        for (let [r, i] of Object.entries(t.materials))this.addMaterial(r, i);
        for (let [r, i] of Object.entries(t.audios))this.addAudio(r, i);
        for (let [r, i] of Object.entries(t.particles))this.addParticle(r, i);
        for (let [r, i] of Object.entries(t.fonts))this.addFont(r, i);
    }
    addMaterial(t, e) {
        if (this.materials[t]) {
            let r = this.materials[t];
            r.reset(e, this.thisContext), r.dispose();
        } else {
            let r = new Hc(e, this.thisContext, t);
            this.materials[t] = r;
        }
    }
    deleteMaterial(t) {
        this.materials[t] && (this.materials[t].nodeMaterialDispose(), delete this.materials[t]);
    }
    getMaterial(t) {
        let e = this.materials[t];
        return e;
    }
    getMaterialOrDeletedPlaceholder(t) {
        return this.materials[t] ?? this.deletedMaterial;
    }
    material(t) {
        return typeof t == "string" ? this.getMaterialOrDeletedPlaceholder(t) : t == null ? (console.error("material is undefined or null"), this.deletedMaterial) : new Pa(t, this.thisContext);
    }
    getMaterials() {
        return this.materials;
    }
    addImage(t, e) {
        return this.images[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.images[t].updateSrc(e.data), !0) : (this.images[t] = new Zn(e, this), !1);
    }
    deleteImage(t) {
        let e = this.images[t];
        e && (e.dispose(), delete this.images[t]);
    }
    getDefaultImage() {
        return this.images.image_0;
    }
    getImage(t) {
        return this.images[t] ?? this.deletedImage;
    }
    image(t) {
        return typeof t == "string" ? this.getImage(t) : this.imageHolderCache.load(t);
    }
    addCanvas(t, e) {
        return this.canvases[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.canvases[t].updateSrc(e), !0) : (this.canvases[t] = new Zn(e, this), !1);
    }
    canvas(t) {
        return this.canvases[t];
    }
    addVideo(t, e) {
        return this.videos[t] ? (this.videos[t].updateSrc(e.data), !0) : (this.videos[t] = new Zn(e, this), !1);
    }
    deleteVideo(t) {
        let e = this.videos[t];
        e && (e.dispose(), delete this.videos[t]);
    }
    getVideo(t) {
        return this.videos[t] ?? this.deletedVideo;
    }
    video(t) {
        return typeof t == "string" ? this.getVideo(t) : this.imageHolderCache.load(t);
    }
    addColor(t, e) {
        return this.colors[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), "a" in e ? this.colors[t].setRGBA(e.r, e.g, e.b, e.a) : this.colors[t].setRGBA(e.r, e.g, e.b, 1), !0) : ("a" in e ? this.colors[t] = new Bl(e.r, e.g, e.b, e.a) : this.colors[t] = new Bl(e.r, e.g, e.b, 1), !1);
    }
    updateColor(t, e) {
        if (this.colors[t]) {
            this.onColorOrImageUpdate && this.onColorOrImageUpdate();
            let r = this.colors[t];
            return this.colors[t].r = e.r ?? r.r, this.colors[t].g = e.g ?? r.g, this.colors[t].b = e.b ?? r.b, this.colors[t].a = e.a ?? r.a, !0;
        }
        return !1;
    }
    deleteColor(t) {
        this.colors[t] && delete this.colors[t];
    }
    getColor(t) {
        return this.colors[t];
    }
    color(t) {
        let e;
        if (typeof t == "string") {
            let r = this.getColor(t);
            r ? e = r : (console.warn("Tried to create color layer params with a color key that does not exist in the assets manager"), e = new cr(0, 0, 0, 0));
        } else return "a" in t ? new cr(t.r, t.g, t.b, t.a) : new cr(t.r, t.g, t.b, 1);
        return e;
    }
    addAudio(t, e) {
        this.audios[t] = e;
    }
    getAudio(t) {
        let e = this.audios[t];
        if (e instanceof Da) return e;
        {
            let r = new Da({
                src: e.data
            });
            return this.audios[t] = r, r;
        }
    }
    addParticle(t, e) {
        this.particles[t] = e;
    }
    getParticle(t) {
        return this.particles[t];
    }
    deleteParticle(t) {
        this.particles[t] && delete this.particles[t];
    }
    deleteAudio(t) {
        let e = this.audios[t];
        e && (e instanceof Da && e.dispose(), delete this.audios[t]);
    }
    addFont(t, e) {
        this.fonts[t] = new Z0(e), this.fonts[t].loadingPromise.then(()=>this.requestRender());
    }
    getFont(t) {
        return this.fonts[t];
    }
    deleteFont(t) {
        this.fonts[t] && delete this.fonts[t];
    }
    dispose() {
        Object.keys(this.materials).forEach((e)=>this.deleteMaterial(e)), this._requestRender = void 0, Object.values(this.audios).forEach((e)=>{
            e instanceof Da && e.dispose();
        }), this.audios = {}, this.particles = {}, this.geometryCache.dispose(), this.geometryCache2.dispose();
    }
    addVariableHolder(t, e) {
        return this.variables[t] === void 0 ? (this.variables[t] = {
            value: e.value,
            locations: []
        }, "dynamicVariableType" in e && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0), !0) : (this.variables[t].value = e.value, !1);
    }
    resetDynamicVariablePlayState() {
        for(let t in this.variables)this.variables[t].dynamicVariablePlayState !== void 0 && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0);
    }
    updateVariableHolder(t, e) {
        this.updateVariable(t, e.value);
    }
    updateVariable(t, e) {
        if (this.variables[t] === void 0) return !1;
        this.variables[t].value = e;
        let r = e;
        for(; typeof r == "string";)r = this.variables[r].value;
        let i = this.entityOpContext.scene;
        for(let s = this.variables[t].locations.length - 1; s >= 0; s--){
            let o = this.variables[t].locations[s];
            if (o[0] === "material") {
                let a = o[1], l = r, u = {
                    scene: i,
                    shared: this
                }, c = o.slice(2);
                i.traverseMaterial((h)=>{
                    let f = h.root ?? h;
                    f.uuid === a && f.onVariableUpdate(c, l, u);
                });
                let d = this.materials[a];
                d && d.onVariableUpdate(c, l, u);
            } else {
                let a = i.find(o[0]);
                if (a === void 0) {
                    this.variables[t].locations.splice(s, 1);
                    continue;
                }
                if (o[1] !== "geometry" && o[1] !== "particles") {
                    for(let l = 1; l < o.length - 1; l++)a = a[o[l]];
                    o[1] === "rotation" ? a[o[o.length - 1]] = r * Se.DEG2RAD : a[o[o.length - 1]] = r;
                }
                if (a = i.find(o[0]), a.type === "ParticleEmitter" && a.updateVariableState(r, o), ut.is(a)) {
                    if (o[1] === "position" || o[1] === "rotation" || o[1] === "scale") a.onVariableUpdate();
                    else if (o[1] === "geometry") {
                        let l = a;
                        a.component && (l = a.component);
                        let u = l.dataPatched;
                        l.chooseGeoemtryCache(this).forceDelete(u.geometry), l.createGeometryDelayed(this.entityOpContext), l.onVariableUpdate(!0), l.instances.forEach((c)=>{
                            let d = c.dataPatched;
                            c.chooseGeoemtryCache(this).forceDelete(d.geometry), c.createGeometryDelayed(this.entityOpContext), c.onVariableUpdate(!0);
                        });
                    }
                }
            }
        }
        return !0;
    }
    deleteVariable(t) {
        this.variables[t] && delete this.variables[t];
    }
    getVariable(t, e) {
        if (Array.isArray(t)) {
            if (t[0] === "mouse") return this.mouseProperty?.[t[1]] ?? 0;
            if (t[0] === "raycast") return this.raycastProperty?.[t[1]] ?? 0;
            let r = this.entityOpContext.scene.find(t[0]);
            if (t[1] === "width" || t[1] === "height" || t[1] === "depth") return r.geometry.userData.parameters[t[1]];
            for(let i = 1; i < t.length; i++)r = r[t[i]];
            return t[1] === "rotation" && (r *= Se.RAD2DEG), r;
        }
        for(let r in this.variables){
            if (e === void 0) break;
            let i = this.variables[r], s = i.locations?.findIndex((o)=>Tr.equal(o, e));
            s !== void 0 && s !== -1 && i.locations.splice(s, 1);
        }
        if (typeof t == "string") {
            let r = t, i = t;
            do {
                if (i = r, this.variables[r] === void 0) break;
                r = this.variables[r].value;
            }while (typeof r == "string");
            return e && this.variables[i] !== void 0 && this.variables[i].locations.push(e), r;
        } else return t;
    }
    getVariables() {
        return this.variables;
    }
    getDynamicVariablePlayState(t) {
        return this.variables[t]?.dynamicVariablePlayState;
    }
    setDynamicVariablePlayState(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariablePlayState = e);
    }
    getDynamicVariableToggleIsForward(t) {
        return this.variables[t]?.dynamicVariableToggleIsForward;
    }
    setDynamicVariableToggleIsForward(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariableToggleIsForward = e);
    }
    resetLib(t) {
        for (let [e, r] of Object.entries(t.images))this.addImage(e, r.asset);
        for (let [e, r] of Object.entries(t.audios))this.addAudio(e, r.asset);
        for (let [e, r] of Object.entries(t.particles))this.addParticle(e, r.asset);
        for (let [e, r] of Object.entries(t.colors))this.addColor(e, r.asset);
        for (let [e, r] of Object.entries(t.fonts))this.addFont(e, r.asset);
        for (let [e, r] of Object.entries(t.materials))this.addMaterial(e, r.asset);
        for (let [e, r] of Object.entries(t.videos))this.addVideo(e, r.asset);
        for (let [e, r] of Object.entries(t.variables))this.addVariableHolder(e, r.asset);
    }
    updateLibByOp(t, e) {
        t.path[0] === "images" ? t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id) : t.path[0] === "videos" ? t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id) : t.path[0] === "audios" ? t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id) : t.path[0] === "particles" ? t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id) : t.path[0] === "colors" ? t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id) : t.path[0] === "materials" ? t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteMaterial(t.id) : t.path[0] === "fonts" ? t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id) : t.path[0] === "variables" ? t.path.length === 1 && t.type === 1 ? this.addVariableHolder(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVariable(t.id) : t.path[0] === "components" && e.updateByLibOp(t, this);
    }
    updateByOp(t, e, r) {
        this.data = e, t.path[0] === "images" ? t.path.length === 2 && t.type === 0 ? t.props.data && this.getImage(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id) : t.path[0] === "videos" ? t.path.length === 2 && t.type === 0 ? t.props.data && this.getVideo(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id) : t.path[0] === "audios" ? t.path.length === 2 && t.type === 0 ? t.props.data && this.addAudio(t.path[1], e.audios[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id) : t.path[0] === "particles" ? t.path.length === 2 && t.type === 0 ? t.props.data && this.addParticle(t.path[1], e.particles[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id) : t.path[0] === "colors" ? t.path.length === 2 && t.type === 0 ? this.updateColor(t.path[1], t.props) : t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id) : t.path[0] === "materials" ? t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data) : t.path.length === 1 && t.type === 2 ? this.deleteMaterial(t.id) : t.path.length > 1 && this.getMaterial(t.path[1]).updateByOp(Mr.drop(t, 2), e.materials[t.path[1]], {
            shared: this,
            scene: r
        }) : t.path[0] === "fonts" ? t.path.length === 2 && t.type === 0 ? this.updateFont(t.path[1], t, r) : t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id) : t.path[0] === "variables" ? t.path.length === 2 && t.type === 0 && "value" in t.props ? this.updateVariable(t.path[1], t.props.value) : t.path.length === 1 && t.type === 4 ? this.addVariableHolder(t.id, t.data) : t.path.length === 1 && t.type === 5 && this.deleteVariable(t.id) : t.path[0] === "lib" && this.updateLibByOp(Mr.drop(t, 1), r);
    }
    updateFont(t, e, r) {
        if (e.props.url) {
            let i = this.getFont(t), s = {
                ...this.data.fonts[t],
                url: e.props.url
            };
            i.update(s), i.loadingPromise.then(()=>this.requestRender()), r.updateFont(t, this);
        }
    }
}, nMe = new Wc(yn.emptyData());
var gs = class extends nr {
    updateByPatchedOp(e, r, i) {
        if (super.updateByPatchedOp(e, r, i), U2(e.path, [
            "materials"
        ]) !== null && e.type === 0 && Array.isArray(this.material)) for (let [s, o] of Object.entries(e.props)){
            let a = i.shared.material(o);
            this.material[Number(s)] = a;
        }
        else if (wt(e.path, [
            "material"
        ]) && this.material instanceof Rn) "material" in r && typeof r.material != "string" && this.material.updateByOp(Mr.drop(e, 1), r.material, i);
        else if (wt(e.path, [
            "materials",
            "*"
        ]) && Array.isArray(this.material)) {
            let s = e.path[1];
            if ("materials" in r && s < this.material.length) {
                let o = r.materials[s];
                typeof o != "string" && this.material[s].updateByOp(Mr.drop(e, 2), o, i);
            }
        }
    }
    get needsAO() {
        return this.material !== void 0 ? (Array.isArray(this.material) ? this.material[0] : this.material).hasAO : !1;
    }
    updateState(e, r) {
        super.updateState(e, r), e.castShadow !== void 0 && (this.castShadow = e.castShadow), e.receiveShadow !== void 0 && (this.receiveShadow = e.receiveShadow);
        let i = this.dataPatched;
        if (e.geometry?.type !== "NonParametricGeometry" && "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe), r.scene.markNeedsUpdateRendererDirty()), (e.geometry?.type === "NonParametricGeometry" || "materials" in e) && ("materials" in e && e.materials !== void 0 ? (this.disposeMaterial(), this.material = e.materials.map((s)=>r.shared.material(s).getFlavor(i.flatShading, i.side, i.wireframe)), r.scene.markNeedsUpdateRendererDirty()) : "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = [
            r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe)
        ], r.scene.markNeedsUpdateRendererDirty())), e.flatShading !== void 0 || e.wireframe !== void 0 || e.side !== void 0) {
            if (Array.isArray(this.material)) for(let s = 0; s < this.material.length; s++)this.material[s] = this.material[s].getFlavor(i.flatShading, i.side, i.wireframe);
            else this.material = this.material.getFlavor(i.flatShading, i.side, i.wireframe);
        }
    }
    disposeMaterial() {
        this.material && iv(this.material).forEach((e)=>{
            e instanceof Rn && (e instanceof Hc || e.nodeMaterialDispose());
        });
    }
    dispose() {
        this.disposeMaterial(), super.dispose();
    }
};
var lR = new _, cR = new He, uR = new He, R7 = new _, dR = new te, er = class extends gs {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.isSkinnedMesh = !1;
        this.localGeometry = void 0, r.bindMode && r.bindMatrix && (this.bindMode = r.bindMode, this.bindMatrix = new te().fromArray(r.bindMatrix), this.bindMatrixInverse = new te);
    }
    chooseGeoemtryCache(e) {
        return e.geometryCache;
    }
    markGeometryAsReachable(e) {
        this.geometryCreateDeleyed instanceof we && this.chooseGeoemtryCache(e).markAsReachable(this.dataPatched.geometry, this.geometryCreateDeleyed);
    }
    get geometry() {
        if (this.localGeometry !== void 0) return this.localGeometry;
        if (this.geometryCreateDeleyed instanceof Wc) {
            let e = this.geometryCreateDeleyed, r = this.chooseGeoemtryCache(e);
            this.geometryCreateDeleyed = r.get(this.dataPatched.geometry, e, this);
        }
        return this.geometryCreateDeleyed;
    }
    set geometry(e) {
        this.localGeometry = e;
    }
    get is2DAndNoDepth() {
        let e = this.dataPatched.geometry;
        return Wp.is2DParametricMesh(e.type) && e.depth === 0;
    }
    get is2DType() {
        return Wp.is2DParametricMesh(this.geometry.userData.type);
    }
    get isNonParametric() {
        return this.geometry.userData.type === "NonParametricGeometry";
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), wt(e.path, [
            "geometry"
        ]) && this.updateByPatchedOpGeometry(Mr.drop(e, 1), r.geometry, i);
    }
    removeInteractionGeometry(e) {
        this.localGeometry?.dispose(), this.localGeometry = void 0;
    }
    updateGeometryInteractions(e, r) {
        this.invalidateDownstreamBooleanData();
        let i = this.data.geometry.type;
        if (i === "NonParametricGeometry" || i === "SubdivGeometry") {
            let s = e;
            if (this.localGeometry === void 0) {
                let c = {
                    ...this.data.geometry,
                    ...s
                };
                this.localGeometry = Ta(c, r, this.data.flatShading, this);
            }
            let o, a, l;
            s.scaleBaked ? [o, a, l] = s.scaleBaked : { width: o, height: a, depth: l } = s;
            let u = this.localGeometry.userData;
            u.sxPrev !== void 0 && fm(this.localGeometry.attributes, o / u.sxPrev, a / u.syPrev, l / u.szPrev), u.sxPrev = o, u.syPrev = a, u.szPrev = l;
        } else {
            let s = {
                ...this.data.geometry,
                ...e
            };
            this.localGeometry?.dispose(), this.localGeometry = Ta(s, r, this.data.flatShading, this);
        }
    }
    refreshAttachedCloners(e) {
        for (let r of this.attachedSurfaceCloners)e.scene.addPendingUpdateCloner(r.object);
    }
    refreshAttachedPaths(e) {
        for (let r of this.attachedPaths)e.scene.addPendingCommand(()=>r.updateShape());
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.refreshAttachedCloners(e), this.refreshAttachedPaths(e);
    }
    updateByPatchedOpGeometry(e, r, i) {
        let s = !1;
        e.type === 0 && e.path.length === 0 && Object.keys(e.props).includes("scaleBaked") && this.geometryCreateDeleyed instanceof Kr && this.chooseGeoemtryCache(i.shared).mutateIfUnique(this.geometryCreateDeleyed.data, r) === this.geometryCreateDeleyed && (s = !0, this.geometryCreateDeleyed.mutateDirectlyScaleBaked(r, e.props.scaleBaked), this.refreshAttachedCloners(i), this.refreshAttachedPaths(i)), s || (i.scene?.markGeometryCacheDirty(), this.createGeometryDelayed(i)), this.resetBBoxNeedsUpdate(), this.invalidateDownstreamBooleanData();
    }
    updateGeometryOnStateUpdate(e, r) {
        this.createGeometryDelayed(r);
    }
    updateState(e, r) {
        e.geometry !== void 0 && this.updateGeometryOnStateUpdate(e.geometry, r), super.updateState(e, r);
    }
    updateGeometryGroupsIfNeeded() {
        Array.isArray(this.material) && this.geometry.groups.length === 0 && this.geometry.addGroup(0, Math.max(this.geometry.getIndex()?.count ?? 0, this.geometry.getAttribute("position").count), 0);
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        this.is2DType ? e.set(0, 0, i.depth * .5) : this.isNonParametric ? (e.setScalar(0), this.geometry.boundingSphere && e.copy(this.geometry.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5)) : e.setScalar(0), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.bindMode === "attached" ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === "detached" && this.bindMatrixInverse.copy(this.bindMatrix).invert();
    }
    bind(e, r) {
        this.skeleton = e, this.isSkinnedMesh = !0, r === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), r = this.matrixWorld), this.bindMatrix.copy(r), this.bindMatrixInverse.copy(r).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights(e) {
        let r = new He, i = this.geometry.attributes.skinWeight;
        for(let s = 0, o = i.count; s < o; s++){
            r.fromBufferAttribute(i, s);
            let a = 1 / r.manhattanLength();
            a !== 1 / 0 ? r.multiplyScalar(a) : r.set(1, 0, 0, 0), i.setXYZW(s, r.x, r.y, r.z, r.w);
        }
    }
    boneTransform(e, r) {
        let i = this.skeleton;
        if (i === void 0) return;
        let s = this.geometry;
        cR.fromBufferAttribute(s.attributes.skinIndex, e), uR.fromBufferAttribute(s.attributes.skinWeight, e), lR.copy(r).applyMatrix4(this.bindMatrix), r.set(0, 0, 0);
        for(let o = 0; o < 4; o++){
            let a = uR.getComponent(o);
            if (a !== 0) {
                let l = cR.getComponent(o);
                dR.multiplyMatrices(i.bones[l].matrixWorld, i.boneInverses[l]), r.addScaledVector(R7.copy(lR).applyMatrix4(dR), a);
            }
        }
        return r.applyMatrix4(this.bindMatrixInverse);
    }
};
function L7(n1) {
    if (n1.geometry.attributes.extrudeNormal || !n1.geometry.attributes.position || !n1.geometry.attributes.normal) return;
    let t = new Map, e = n1.geometry.attributes, r = e.position.array, i = e.normal.array, s = new Float32Array(r.length);
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = new _(i[o], i[o + 1], i[o + 2]);
        t.has(a) ? t.get(a)?.normals.push(l) : t.set(a, {
            normals: [
                l
            ],
            result: new _
        });
    }
    t.forEach((o, a)=>{
        for (let l of o.normals)o.result.add(l);
        o.result.divideScalar(o.normals.length);
    });
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = t.get(a)?.result;
        l && (s[o] = l.x, s[o + 1] = l.y, s[o + 2] = l.z);
    }
    n1.geometry.setAttribute("extrudeNormal", new be(s, 3));
}
function B7(n1) {
    if (n1.geometry.attributes.extrudeNormals || !n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = new _;
    for(let s = 0; s < e.length; s += 3)i.set(e[s], e[s + 1], e[s + 2]).normalize(), r[s] = i.x, r[s + 1] = i.y, r[s + 2] = i.z;
    n1.geometry.setAttribute("extrudeNormal", new be(r, 3));
}
function Jh(n1) {
    if (Array.isArray(n1.material)) {
        for (let t of n1.material)if (t.getLayersOfType("outline").length === 0) return;
    } else if (!(n1.material instanceof Rn) || n1.material.getLayersOfType("outline").length === 0) return;
    n1 instanceof er && n1.is2DAndNoDepth ? B7(n1) : L7(n1);
}
function $h(n1) {
    if (!n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = parseInt(n1.uuid.replace(/\D/g, "")), s = [
        Se.seededRandom(i),
        Se.seededRandom(i + 1e4),
        Se.seededRandom(i + 2e4)
    ];
    for(let o = 0; o < e.length; o++)r[o] = s[o % 3];
    n1.geometry.setAttribute("randomColor", new Ge(r, 3));
}
var Ro = new Bt, Mm = new _;
function hR(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "SubdivGeometry" && (t = !0);
    }), t;
}
var Qs = class extends er {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
        this.hiddenMatrixOld = new te;
        this.smoothShading = !0;
        this.skipReactionUpdate = !1;
    }
    chooseGeoemtryCache(e) {
        return this.dataPatched.flatShading ? e.geometryCache : e.geometryCache2;
    }
    get subdivPointerNew() {
        return this.localGeometry !== void 0 ? this.subdivPointer : this.geometry.ensureSubdivPointer();
    }
    get originalGeometryNew() {
        return this.localGeometry !== void 0 ? this.originalGeometry : this.geometry.originalGeometry;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        e.copy(this.originalGeometryNew.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    createGeometryByControls(e) {
        if (this.skipReactionUpdate === !0) return;
        let r = this.localGeometry?.uuid, { originalGeometry: i, subdividedGeometry: s, subdivPointer: o } = Kr.build(e, this.subdivPointer, this.smoothShading, this.hasNonUniformScale ? this.shearScale : void 0);
        this.subdivPointer = o, i !== void 0 && (this.originalGeometry?.dispose(), this.originalGeometry = i), s !== void 0 && (this.subdividedGeometry?.dispose(), this.subdividedGeometry = s ?? void 0), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry, Jh(this), $h(this), this.calcBoundingBox(), r && (this.localGeometry.uuid = r);
    }
    updateState(e, r) {
        if (super.updateState(e, r), e.flatShading !== void 0) {
            let i = this.material;
            this.material = Array.isArray(i) ? i.map((s)=>s.getFlavor(!1, s.side, s.wireframe)) : i.getFlavor(!1, i.side, i.wireframe), this.smoothShading = !e.flatShading, this.createGeometryDelayed(r);
        }
    }
    updateMesh(e = !1) {
        Kr.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1, this.originalGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0), this.subdividedGeometry && Kr.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1, this.subdividedGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0);
    }
    updateTopology() {
        this.originalGeometry.dispose(), this.originalGeometry = Kr.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1), this.subdividedGeometry && (this.subdividedGeometry.dispose(), this.subdividedGeometry = Kr.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1)), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry;
    }
    raycast(e, r) {
        let i = this.localGeometry;
        this.localGeometry = this.originalGeometryNew, nr.prototype.raycast.call(this, e, r), this.localGeometry = i;
    }
    activateSVDCompensation() {
        !this.hasNonUniformScale || (this.matrix.copy(this.matrixWorldRigid), this.hiddenMatrixOld.copy(this.hiddenMatrix), this.hiddenMatrix.copy(this.parent.matrixWorld).invert());
    }
    deactivateSVDCompensation() {
        !this.hasNonUniformScale || (this.updateMatrix(), this.hasNonUniformScale = void 0, this.hiddenMatrix.copy(this.hiddenMatrixOld));
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Er, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        Ro.setFromBufferAttribute(r), Ro.getCenter(i), e.boundingSphere.radius = i.distanceTo(Ro.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), Ro.getSize(Mm), this.hasNonUniformScale && Mm.divide(this.scale);
        let s = {
            width: Mm.x,
            height: Mm.y,
            depth: Mm.z
        };
        return this.geometry.userData.parameters = s, s;
    }
    updateBoundingSphere(e) {
        let r = this.originalGeometry;
        Ro.min.set(e[0], e[2], e[4]), Ro.max.set(e[1], e[3], e[5]), this.hasNonUniformScale && (Ro.min.applyMatrix4(this.shearScaleInv), Ro.max.applyMatrix4(this.shearScaleInv)), r.boundingSphere === null && (r.boundingSphere = new Er);
        let i = r.boundingSphere.center;
        Ro.getCenter(i), r.boundingSphere.radius = i.distanceTo(Ro.max);
    }
    freeSubdivPointer() {
        this.subdivPointer && (Kr.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0), this.localGeometry = void 0, this.originalGeometry?.dispose(), this.subdividedGeometry?.dispose();
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), this.localGeometry && this.createGeometryByControls(r);
    }
};
var fR = -1, N7 = 1, pR = {
    x: [
        1,
        0,
        0
    ],
    "-x": [
        -1,
        0,
        0
    ],
    y: [
        0,
        1,
        0
    ],
    "-y": [
        0,
        -1,
        0
    ],
    z: [
        0,
        0,
        1
    ],
    "-z": [
        0,
        0,
        -1
    ]
}, mR = {
    polygon_center: 0,
    edge: 1,
    vertex: 2
}, Cm = (n1, t)=>(e, r)=>!t || e === 0 || n1 === 0 ? 0 : n1 * r / 100, dt = (n1, t)=>{
    let e = Math.abs(t), r = e * -1;
    return (n1 - fR) * (e - r) / (N7 - fR) + r;
};
function gR(n1) {
    let t = [], e = {};
    for(var r = 0, i = n1.length; r < i; r++){
        var s = JSON.stringify(n1[r].pos.map((o)=>Math.round(o * 1e4) / 1e4));
        e[s] || (t.push(n1[r]), e[s] = !0);
    }
    return t;
}
var F7 = new _, J0 = new _, k7 = new _, z7 = new _;
function ef(n1, t) {
    let e = k7.fromArray(n1), r = z7.fromArray(t);
    J0.copy(r).sub(e);
    let i = J0.length();
    return J0.normalize().multiplyScalar(i * .5), F7.copy(e).add(J0).toArray();
}
var ys = new vr, $0 = new _, ex = new _, qc = new _;
function yR(n1) {
    let t = [];
    for(let e = 0; e <= n1.index.count; e++)if ($0.fromArray(n1.index.array, e * 3), ys.setFromAttributeAndIndices(n1.attributes.position, $0.x, $0.y, $0.z), ys.getNormal(ex), ys.getMidpoint(qc), !(isNaN(qc.x) || isNaN(qc.y) || isNaN(qc.z))) {
        let { a: r, b: i, c: s } = ys, o = r.toArray(), a = i.toArray(), l = s.toArray(), u = r.distanceTo(i), c = i.distanceTo(s), d = s.distanceTo(r), h = ef(o, a), f = ef(a, l), p = ef(l, o), m = [
            u,
            c,
            d
        ], g = Math.max(...m), y = m.filter((S)=>Math.round(S) === Math.round(g)).length > 1, v = [], x = ys.getMidpoint(qc).toArray();
        g === u && !y && (v = [
            f,
            p,
            p
        ], x = h), g === c && !y && (v = [
            h,
            p,
            p
        ], x = f), g === d && !y && (v = [
            h,
            f,
            f
        ], x = p), y && (v = [
            h,
            f,
            p
        ]), t.push({
            vertices: [
                o,
                a,
                l
            ],
            faceCenters: v,
            midpoint: x,
            norm: ys.getNormal(ex).toArray()
        });
    }
    return t;
}
function vR(n1) {
    let t = [], { position: e } = n1.attributes;
    for(let r = 0; r < e.count; r++){
        ys.setFromAttributeAndIndices(e, r * 3, r * 3 + 1, r * 3 + 2), ys.getNormal(ex), ys.getMidpoint(qc);
        let i = ys.a.toArray(), s = ys.b.toArray(), o = ys.c.toArray();
        t.push({
            vertices: [
                i,
                s,
                o
            ],
            faceCenters: [
                ef(i, s),
                ef(s, o),
                ef(o, i)
            ],
            midpoint: qc.toArray(),
            norm: ex.toArray()
        });
    }
    return t;
}
var V7 = 4, U7 = .5, r_ = (n1)=>.5 * (1 - Math.cos(n1 * Math.PI)), i_ = class {
    constructor(){
        this.perlin = new Array(4096);
    }
    noise(t, e = 0, r = 0) {
        if (this.perlin == null) {
            this.perlin = new Array(4096);
            for(let y = 0; y < 4096; y++)this.perlin[y] = Math.random();
        }
        t < 0 && (t = -t), e < 0 && (e = -e), r < 0 && (r = -r);
        let i = Math.floor(t), s = Math.floor(e), o = Math.floor(r), a = t - i, l = e - s, u = r - o, c, d, h = 0, f = .5, p, m, g;
        for(let y = 0; y < V7; y++){
            let v = i + (s << 4) + (o << 8);
            c = r_(a), d = r_(l), p = this.perlin[v & 4095], p += c * (this.perlin[v + 1 & 4095] - p), m = this.perlin[v + 16 & 4095], m += c * (this.perlin[v + 16 + 1 & 4095] - m), p += d * (m - p), v += 256, m = this.perlin[v & 4095], m += c * (this.perlin[v + 1 & 4095] - m), g = this.perlin[v + 16 & 4095], g += c * (this.perlin[v + 16 + 1 & 4095] - g), m += d * (g - m), p += r_(u) * (m - p), h += p * f, f *= U7, i <<= 1, a *= 2, s <<= 1, l *= 2, o <<= 1, u *= 2, a >= 1 && (i++, a--), l >= 1 && (s++, l--), u >= 1 && (o++, u--);
        }
        return h;
    }
    noiseSeed(t) {
        let e = (()=>{
            let o, a;
            return {
                setSeed (l) {
                    a = o = (l ?? Math.random() * 4294967296) >>> 0;
                },
                getSeed () {
                    return o;
                },
                rand () {
                    return a = (1664525 * a + 1013904223) % 4294967296, a / 4294967296;
                }
            };
        })();
        e.setSeed(t), this.perlin = new Array(4096);
        for(let r = 0; r < 4096; r++)this.perlin[r] = e.rand();
    }
}, xR = i_;
var bR = new _, SR = new te, wR = new Rs;
function n_(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "TextGeometry" && (t = !0);
    }), t;
}
var tf = class extends er {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
    }
    get textGeometry() {
        return this.geometry;
    }
    get charWidths() {
        return this.textGeometry.charWidths;
    }
    get charCoords() {
        return this.textGeometry.charCoords;
    }
    get wrappedText() {
        return this.textGeometry.wrappedText;
    }
    get font() {
        return this.textGeometry.font;
    }
    get initialOffsetY() {
        let e = this.dataPatched;
        return this.font?.getLineInitialOffsetY(this.lineHeight, this.wrappedText.length, e.geometry.height, this.fontScale, e.geometry.verticalAlign) ?? 0;
    }
    get fontScale() {
        let e = this.dataPatched;
        return this.font ? e.geometry.fontSize / this.font.unitsPerEm : 1;
    }
    get AD() {
        return Math.abs(this.ascender - this.descender);
    }
    get ascender() {
        return (this.font?.ascender ?? 1) * this.fontScale;
    }
    get descender() {
        return (this.font?.descender ?? 1) * this.fontScale;
    }
    get lineHeight() {
        let e = this.dataPatched;
        return e.geometry.fontSize * e.geometry.lineHeight;
    }
    raycast(e, r) {
        let { matrixWorld: i } = this;
        if (!(isNaN(e.ray.origin.x) || this.scale.x === 0 || this.scale.y === 0 || this.scale.z === 0) && (SR.copy(i).invert(), wR.copy(e.ray).applyMatrix4(SR), wR.intersectBox(this.singleBBox, bR))) {
            let s = bR.applyMatrix4(i), o = e.ray.origin.distanceTo(s);
            r.push({
                distance: o,
                point: s.clone(),
                object: this
            });
        }
    }
};
var wn = 1e-4, Lo, ER, TR, MR, AR = new _, _R = new _;
D0.then((n1)=>{
    Lo = n1, ER = [
        Lo.get_face_center,
        Lo.get_edge_midpoint,
        Lo.get_vertex_position
    ], TR = [
        Lo.get_face_normal,
        Lo.get_edge_normal,
        Lo.get_vertex_normal
    ], MR = [
        Lo.face_count,
        Lo.edge_count,
        Lo.vertex_count
    ];
});
var G7 = new te, j7 = new te, Fl = new _, Yc = new _, Pm = new _, s_ = new _, H7 = new _, W7 = new _;
var Oa = new xR, Gi = class extends hh(mt) {
    constructor(e, r){
        super();
        this.parameters = r;
        this.objectForSample = void 0;
        this._pendingMediaLoad = !1;
        this.object = e;
    }
    resetOnMove() {
        this.removeFromParent(), this.parent = null;
    }
    expandClones(e) {
        if (this.parent === null) this.updateState(this.parameters, e);
        else for (let r of this.children)r instanceof Pr && r.expand();
    }
    invalidateTransform(e) {
        this.matrixWorldNeedsUpdate = !0, this.traverse((r)=>{
            r instanceof Pr && r.object === e && (r.matrixWorldNeedsUpdate = !0);
        });
    }
    onObjUpdateMatrix() {
        this.parameters.type !== "toObject" && (this.matrixWorldNeedsUpdate = !0);
    }
    update() {
        switch(this._updateCount(), this.parameters.type){
            case "radial":
                this._updateRadial(this.parameters);
                break;
            case "linear":
                this._updateLinear(this.parameters);
                break;
            case "grid":
                this._updateGrid(this.parameters);
                break;
            case "toObject":
                this._updateToObject(this.parameters);
        }
        for (let e of this.children)e.updateMatrix(), e.hasNonUniformScale && (e.updateMatrixWorld(), e.updateMatrixWorldSVD());
    }
    _updateCount(e) {
        let r;
        if (e !== void 0 ? r = e : r = this.parameters.type === "grid" ? Math.round(this.parameters.grid.count[0]) * Math.round(this.parameters.grid.count[1]) * Math.round(this.parameters.grid.count[2]) : this.parameters.count, this.parameters.type === "toObject" && !this.parameters.toObject.object && (r = 0), this.parameters.type === "toObject" && this.objectForSample) {
            for(let s = 0, o = this.children.length; s < o; ++s)this.remove(this.children[0]);
            let i = this.children;
            if (i.length === r) return;
            if (i.length < r) for(let s = 0, o = r - i.length; s < o; ++s){
                let a = new Pr(this.object);
                a.expand(), this.add(a);
            }
            else for(let s = 0, o = i.length - r; s < o; ++s)this.remove(i[s]);
        } else {
            if (this.children.length === r) return;
            if (this.children.length < r) for(let i = 0, s = r - this.children.length; i < s; ++i){
                let o = new Pr(this.object);
                o.expand(), this.add(o);
            }
            else for(let i = 0, s = this.children.length - r; i < s; ++i)this.remove(this.children[0]);
        }
    }
    _updateRadial(e) {
        let r = e.radial, i = r.start * Se.DEG2RAD, s = r.end * Se.DEG2RAD, o = i - s, a = new Kt(r.rotation[0], r.rotation[1], r.rotation[2]), l;
        switch(r.axis){
            case "z":
                l = new _(0, 0, 1);
                break;
            case "y":
                l = new _(0, 1, 0);
                break;
            default:
            case "x":
                l = new _(1, 0, 0);
                break;
        }
        let u = e.randomnessObject ?? So.defaultData([
            1,
            1,
            1
        ]).randomnessObject, c = u.noiseType === "perlin";
        Oa.noiseSeed(u.seed);
        let d = d0((0, rf.default)(u.seed)), h = Cm(u.strength, this.parameters.randomness);
        for (let [f, p] of this.children.entries()){
            let m = f * (u.freqScale / 10) + u.movement, g = c ? Oa.noise(m) : d(m, m), y = f + 1;
            p.scale.x = r.scale[0] + h(y, dt(g, u.scale[0])) || wn, p.scale.y = r.scale[1] + h(y, dt(g, u.scale[1])) || wn, p.scale.z = r.scale[2] + h(y, dt(g, u.scale[2])) || wn, p.position.setScalar(0);
            let v = o / e.count * f - i;
            switch(r.axis){
                case "x":
                    p.rotation.set(0, v, 0);
                    break;
                case "y":
                    p.rotation.set(0, 0, v);
                    break;
                case "z":
                    p.rotation.set(v, 0, 0);
                    break;
            }
            p.translateOnAxis(l, r.radius), p.position.x += r.position[0] + h(y, dt(g, u.position[0])), p.position.y += r.position[1] + h(y, dt(g, u.position[1])), p.position.z += r.position[2] + h(y, dt(g, u.position[2]));
            let x = h(y, dt(g, u.rotation[0])), S = h(y, dt(g, u.rotation[1])), w = h(y, dt(g, u.rotation[2]));
            r.alignment === !0 ? (p.rotation.x += a.x + x, p.rotation.y += a.y + S, p.rotation.z += a.z + w) : p.rotation.set(a.x + x, a.y + S, a.z + w);
        }
    }
    _updateLinear(e) {
        if (e.type !== "linear") throw new Error;
        let r = e.linear, i = new Kt(r.rotation[0], r.rotation[1], r.rotation[2]), s = e.randomnessObject ?? So.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = s.noiseType === "perlin";
        Oa.noiseSeed(s.seed);
        let a = d0((0, rf.default)(s.seed)), l = Cm(s.strength, this.parameters.randomness);
        for (let [u, c] of this.children.entries()){
            let d = u * (s.freqScale / 10) + s.movement, h = o ? Oa.noise(d) : a(d, d), f = u + 1, p = l(f, dt(h, s.rotation[0])), m = l(f, dt(h, s.rotation[1])), g = l(f, dt(h, s.rotation[2]));
            c.scale.x = 1 + (r.scale[0] - 1) * u + l(f, dt(h, s.scale[0])) || wn, c.scale.y = 1 + (r.scale[1] - 1) * u + l(f, dt(h, s.scale[1])) || wn, c.scale.z = 1 + (r.scale[2] - 1) * u + l(f, dt(h, s.scale[2])) || wn, c.rotation.x = i.x * u + p, c.rotation.y = i.y * u + m, c.rotation.z = i.z * u + g, c.position.x = r.position[0] * u + l(f, dt(h, s.position[0])), c.position.y = r.position[1] * u + l(f, dt(h, s.position[1])), c.position.z = r.position[2] * u + l(f, dt(h, s.position[2]));
        }
    }
    _updateGrid(e) {
        let r = 0, i = e.grid, s = e.randomnessObject ?? So.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = Cm(s.strength, this.parameters.randomness), a = s.noiseType === "perlin";
        Oa.noiseSeed(s.seed);
        let l = hO((0, rf.default)(s.seed));
        if (i.useCenter === !0) {
            let u = {
                x: i.count[0] % 2 === 0 ? 2 : 1,
                y: i.count[1] % 2 === 0 ? 2 : 1,
                z: i.count[2] % 2 === 0 ? 2 : 1
            }, c = new _(i.size[0] * (i.count[0] - u.x) * .5, i.size[1] * (i.count[1] - u.y) * .5, i.size[2] * (i.count[2] - u.z) * .5);
            for(let d = 0; d < i.count[0]; d++)for(let h = 0; h < i.count[1]; h++)for(let f = 0; f < i.count[2]; f++){
                let p = [
                    (d + 1) * (s.freqScale / 10) + s.movement,
                    (h + 1) * (s.freqScale / 10) + s.movement,
                    (f + 1) * (s.freqScale / 10) + s.movement
                ], m = a ? Oa.noise(...p) : l(...p), g = this.children[r++];
                g.scale.x = 1 + o(r, dt(m, s.scale[0])) || wn, g.scale.y = 1 + o(r, dt(m, s.scale[1])) || wn, g.scale.z = 1 + o(r, dt(m, s.scale[2])) || wn;
                let y = o(r, dt(m, s.rotation[0])), v = o(r, dt(m, s.rotation[1])), x = o(r, dt(m, s.rotation[2]));
                g.rotation.set(y, v, x), g.position.x = i.size[0] * d - c.x + o(r, dt(m, s.position[0])), g.position.y = i.size[1] * h - c.y + o(r, dt(m, s.position[1])), g.position.z = i.size[2] * f - c.z + o(r, dt(m, s.position[2]));
            }
        } else for(let u = 0; u < i.count[0]; u++)for(let c = 0; c < i.count[1]; c++)for(let d = 0; d < i.count[2]; d++){
            let h = [
                (u + 1) * (s.freqScale / 10) + s.movement,
                (c + 1) * (s.freqScale / 10) + s.movement,
                (d + 1) * (s.freqScale / 10) + s.movement
            ], f = a ? Oa.noise(...h) : l(...h), p = this.children[r++];
            p.scale.x = 1 + o(r, dt(f, s.scale[0])) || wn, p.scale.y = 1 + o(r, dt(f, s.scale[1])) || wn, p.scale.z = 1 + o(r, dt(f, s.scale[2])) || wn;
            let m = o(r, dt(f, s.rotation[0])), g = o(r, dt(f, s.rotation[1])), y = o(r, dt(f, s.rotation[2]));
            p.rotation.set(m, g, y), p.position.x = i.size[0] * u + o(r, dt(f, s.position[0])), p.position.y = -i.size[1] * c + o(r, dt(f, s.position[1])), p.position.z = -i.size[2] * d + o(r, dt(f, s.position[2]));
        }
    }
    _updateToObject(e) {
        if (e.type !== "toObject") throw new Error;
        let { toObject: r } = e, i = new Kt(r.rotation[0], r.rotation[1], r.rotation[2]), s = e.randomnessObject ?? So.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = s.noiseType === "perlin";
        Oa.noiseSeed(s.seed);
        let a = d0((0, rf.default)(s.seed)), l = Cm(s.strength, this.parameters.randomness);
        if (!r.object) {
            for (let [, y] of this.children.entries())y.position.set(0, 0, 0), y.scale.setScalar(1), y.rotation.set(0, 0, 0);
            this.objectForSample = void 0;
            return;
        }
        if (!this.objectForSample) return;
        if (this.objectForSample instanceof tf) {
            if (!this.objectForSample.font?.isLoaded || this.objectForSample.geometry.attributes.position === void 0) {
                this._pendingMediaLoad = !0;
                return;
            } else this._pendingMediaLoad = !1;
        }
        if (this.objectForSample.geometry === void 0 && this.objectForSample.isAncestorOf(this.object.uuid)) {
            console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) seem to be a child/descendant of the object it's being cloned to. Please re-parent it so that they are siblings instead.`);
            return;
        }
        let u = this.getSubdivData(), c = [], d = (y)=>{
            let v = y.length, x = y.map((A)=>A[0]).reduce((A, E)=>A + E, 0), S = y.map((A)=>A[1]).reduce((A, E)=>A + E, 0), w = y.map((A)=>A[2]).reduce((A, E)=>A + E, 0);
            return [
                x / v,
                S / v,
                w / v
            ];
        }, h = (y)=>Math.round(y * 1e6) / 1e6;
        u.forEach((y)=>{
            let v = u.filter((x)=>h(y.pos[0]) === h(x.pos[0]) && h(y.pos[1]) === h(x.pos[1]) && h(y.pos[2]) === h(x.pos[2]));
            v.length > 1 ? c.push({
                pos: y.pos,
                norm: d(v.map((x)=>x.norm))
            }) : c.push(y);
        });
        let f = gR(c);
        if (f.length > 0) {
            let y = Math.round(f.length * r.count / 100);
            this._updateCount(y);
        } else {
            let y = this.objectForSample.geometry.getAttribute("position");
            if (!y || isNaN(y.count) || y.count === 0) {
                console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) cannot be cloned on the surface of "${this.objectForSample.name}" (${this.objectForSample.uuid}) because the latter does not have a valid geometry.`);
                return;
            }
        }
        this.objectForSample.updateMatrixWorld();
        let p = new h0(this.objectForSample).build(), m = pR[r.axis], g = this.children;
        p.setRandomGenerator((0, rf.default)(this.object.uuid + r.seed));
        for (let [y, v] of g.entries()){
            let x = y * (s.freqScale / 10) + s.movement, S = o ? Oa.noise(x) : a(x, x), w = y + 1, A = l(w, dt(S, s.rotation[0])), E = l(w, dt(S, s.rotation[1])), b = l(w, dt(S, s.rotation[2]));
            r.spreadType === "random" ? p.sample(Pm, s_) : (f.length && (Pm.fromArray(f[y].pos), s_.fromArray(f[y].norm)), this.objectForSample instanceof Qs && Pm.applyMatrix4(G7.copy(this.objectForSample.matrixWorld).invert())), Pm.applyMatrix4(this.object.hiddenMatrix.clone().invert()), v.position.copy(Pm), Fl.fromArray(m);
            let T = r.align === "normal" ? s_ : this.object.getWorldDirection(W7), M = Yc.fromArray(r.position);
            Yc.x += Yc.x + l(w, dt(S, s.position[0])), Yc.y += Yc.y + l(w, dt(S, s.position[1])), Yc.z += Yc.z + l(w, dt(S, s.position[2]));
            let C = Math.acos(T.dot(Fl)), P = H7.crossVectors(Fl, T).normalize(), D = j7.makeRotationAxis(P, C), O = T.clone().cross(this.object.up).normalize(), I = O.clone().cross(T).normalize(), z = new te().makeBasis(O, T, I), B = new _(Fl.y, Fl.z, Fl.x).normalize(), V = B.clone().cross(Fl).normalize(), U = new te().makeBasis(B, Fl, V).invert(), j = new te().multiplyMatrices(z, U);
            v.rotation.setFromRotationMatrix(j), M.applyMatrix4(D), v.position.add(M), v.rotation.x = v.rotation.x + i.x + A, v.rotation.y = v.rotation.y + i.y + E, v.rotation.z = v.rotation.z + i.z + b, v.scale.setScalar(1), v.scale.x = v.scale.x + r.scale[0] + l(w, dt(S, s.scale[0])) || wn, v.scale.y = v.scale.y + r.scale[1] + l(w, dt(S, s.scale[1])) || wn, v.scale.z = v.scale.z + r.scale[2] + l(w, dt(S, s.scale[2])) || wn, v.scale.multiply(this.object.scale), v.hiddenMatrix = this.object.hiddenMatrix;
        }
    }
    getSubdivData() {
        if (!this.objectForSample) return [];
        let e = this.parameters.toObject.spreadType;
        if (e === "random") return [];
        if (this.objectForSample instanceof Qs) {
            let r = this.objectForSample, i = mR[e], s = MR[i], o = ER[i], a = TR[i], l = [], u = s(r.subdivPointerNew);
            for(let c = 0; c <= u - 1; c++){
                let d = o(r.subdivPointerNew, c), h = a(r.subdivPointerNew, c);
                AR.fromArray(d).applyMatrix4(r.matrixWorld), _R.fromArray(h), l.push({
                    pos: AR.toArray(),
                    norm: _R.toArray()
                });
            }
            return l;
        } else return (this.objectForSample.geometry.index ? yR(this.objectForSample.geometry) : vR(this.objectForSample.geometry)).map((i, s)=>e === "polygon_center" ? {
                pos: i.midpoint,
                norm: i.norm
            } : e === "vertex" ? [
                {
                    pos: i.vertices[0],
                    norm: i.norm
                },
                {
                    pos: i.vertices[1],
                    norm: i.norm
                },
                {
                    pos: i.vertices[2],
                    norm: i.norm
                }
            ] : e === "edge" ? [
                {
                    pos: i.faceCenters[0],
                    norm: i.norm
                },
                {
                    pos: i.faceCenters[1],
                    norm: i.norm
                },
                {
                    pos: i.faceCenters[2],
                    norm: i.norm
                }
            ] : []).flat();
    }
    updateState(e, r) {
        if (this.parameters = ha(e), this.parameters.type !== "toObject") (this.parent === null || this.parent !== this.object) && (this.removeFromParent(), this.object.parent?.add(this), this.matrix = this.object.matrix, this.hiddenMatrix = this.object.hiddenMatrix, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1);
        else if (this.parent === null || this.parent.uuid !== this.parameters.toObject.object) {
            this.removeFromParent();
            let i = r.find(this.parameters.toObject.object);
            i instanceof nr ? this.objectForSample = i : this.objectForSample = void 0, this.matrix = new te, this.hiddenMatrix = new te, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1, i && i.add(this);
        }
        this.update();
    }
    get pendingMediaLoad() {
        return this._pendingMediaLoad;
    }
};
var Bo = (n1)=>{
    var t;
    return t = class extends n1 {
    }, t.geometryHelper = new li(30, 30, 30), t;
};
var tx = new Rs, o_ = new Er, CR = new te, No = (n1, t, e, r, i = !1)=>{
    let s = t, o = n1.matrixWorld;
    if (s.boundingSphere === null && s.computeBoundingSphere(), o_.copy(s.boundingSphere), o_.applyMatrix4(o), e.ray.intersectsSphere(o_) === !1 || (CR.copy(o).invert(), tx.copy(e.ray).applyMatrix4(CR), s.boundingBox !== null && tx.intersectsBox(s.boundingBox) === !1)) return;
    let a, l, u, c, d = s.index, h = s.attributes.position, f = s.drawRange, p, m;
    if (i === !1) {
        let y = Math.max(0, f.start), v = Math.min(d.count, f.start + f.count);
        for(p = y, m = v; p < m; p += 3)if (l = d.getX(p), u = d.getX(p + 1), c = d.getX(p + 2), a = g(n1, e, tx, h, l, u, c), a) {
            a.faceIndex = Math.floor(p / 3), r.push(a);
            return;
        }
    } else {
        let v = s.attributes.position, x = new _, S = new _, w = new _, A = new _, E = 2, T = 1 / ((n1.scale.x + n1.scale.y + n1.scale.z) / 3), M = T * T, C = Math.max(0, f.start), P = Math.min(v.count, f.start + f.count);
        for(let D = C, O = P - 1; D < O; D += E){
            if (x.fromBufferAttribute(v, D), S.fromBufferAttribute(v, D + 1), tx.distanceSqToSegment(x, S, A, w) > M) continue;
            A.applyMatrix4(n1.matrixWorld);
            let z = e.ray.origin.distanceTo(A);
            z < e.near || z > e.far || r.push({
                distance: z,
                point: w.clone().applyMatrix4(n1.matrixWorld),
                object: n1
            });
        }
    }
    function g(y, v, x, S, w, A, E) {
        let b = new _, T = new _, M = new _, C = new _, P = new _;
        if (b.fromBufferAttribute(S, w), T.fromBufferAttribute(S, A), M.fromBufferAttribute(S, E), x.intersectTriangle(b, T, M, !1, C) === null) return null;
        P.copy(C), P.applyMatrix4(y.matrixWorld);
        let O = v.ray.origin.distanceTo(P);
        return O < v.near || O > v.far ? null : {
            faceIndex: 1,
            distance: O,
            point: P.clone(),
            object: y
        };
    }
};
var rx = new _, vs = new Hn, a_ = class extends Ja {
    constructor(e){
        let r = new we, i = new ns({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), s = [], o = [], a = {}, l = new Le(15711266), u = new Le(15711266), c = new Le(2857471);
        d("n1", "n2", l), d("n2", "n4", l), d("n4", "n3", l), d("n3", "n1", l), d("f1", "f2", l), d("f2", "f4", l), d("f4", "f3", l), d("f3", "f1", l), d("n1", "f1", l), d("n2", "f2", l), d("n3", "f3", l), d("n4", "f4", l), d("p", "n1", u), d("p", "n2", u), d("p", "n3", u), d("p", "n4", u), d("u1", "u2", c), d("u2", "u3", c), d("u3", "u1", c);
        function d(f, p, m) {
            h(f, m), h(p, m);
        }
        function h(f, p) {
            s.push(0, 0, 0), o.push(p.r, p.g, p.b), a[f] === void 0 && (a[f] = []), a[f].push(s.length / 3 - 1);
        }
        r.setAttribute("position", new be(s, 3)), r.setAttribute("color", new be(o, 3));
        super(r, i);
        this.type = "CameraHelper", this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
    }
    update() {
        let e = this.geometry, r = this.pointMap, i = !0;
        vs.projectionMatrixInverse.elements = [
            .5112609807824982,
            -0,
            -0,
            -0,
            -0,
            .41421356237309503,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0.099999,
            -0,
            -0,
            -1.0000000000000002,
            .100001
        ];
        let s = 1, o = 1, a = i ? .8 : 1e-4;
        Ks("n1", r, e, vs, -s, -o, a), Ks("n2", r, e, vs, s, -o, a), Ks("n3", r, e, vs, -s, o, a), Ks("n4", r, e, vs, s, o, a);
        let l = a;
        Ks("f1", r, e, vs, -s, -o, l), Ks("f2", r, e, vs, s, -o, l), Ks("f3", r, e, vs, -s, o, l), Ks("f4", r, e, vs, s, o, l);
        let u = l, c = .5;
        Ks("u1", r, e, vs, s * .7 * c, o * 1.1, u), Ks("u2", r, e, vs, -s * .7 * c, o * 1.1, u), Ks("u3", r, e, vs, 0, o * (1.1 + .9 * c), u), e.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function Ks(n1, t, e, r, i, s, o) {
    rx.set(i, s, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let u = 0, c = a.length; u < c; u++)l.setXYZ(a[u], rx.x, rx.y, rx.z);
    }
}
var ix = class extends Bo(a_) {
    constructor(e){
        super(e);
        this.object = e;
        this.object = e, this.name = `CombinedCameraHelper: ${e.uuid}`;
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.updateTarget();
    }
    updateTarget() {
        let e = this.object.getTarget();
        this.updateWorldMatrix(!0, !1), this.worldToLocal(e);
    }
    raycast(e, r) {
        No(this.object, this.geometry, e, r, !0);
    }
};
var nx;
((t)=>t.is = (e)=>"objectHelper" in e)(nx || (nx = {}));
var xs = (n1, t)=>class extends ph(n1) {
        constructor(){
            super(...arguments);
            this.objectHelper = new t(this);
            this.gizmos = {};
        }
        get geometryHelper() {
            return t.geometryHelper;
        }
        raycast(i, s) {
            this.objectHelper.raycast(i, s);
        }
        showGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof sl && (s.visible = !0);
            }
        }
        updateEntityBoxSize(i, s) {
            this.objectHelper.visible && this.geometryHelper instanceof li ? (i.setScalar(0), s.set(this.geometryHelper.parameters.width, this.geometryHelper.parameters.height, this.geometryHelper.parameters.height).multiplyScalar(.5)) : super.updateEntityBoxSize(i, s);
        }
        hideGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof sl && (s.visible = !1);
            }
        }
    };
var sx = 790, nf = new _, l_ = new _, c_ = new je, u_ = new _, Dm = new _, d_ = new _, hr = class extends xs(Hn, ix) {
    constructor(e = "", r = {
        ...Dc.defaultData,
        name: ""
    }){
        super();
        this._cameraType = "OrthographicCamera";
        this.targetOffset = xl.DefaultTargetOffset;
        this.isUpVectorFlipped = !1;
        this.angleOffsetFromUp = 0;
        this.wasMovedByUser = !1;
        this.wasMovedBySwitchCameraAction = !1;
        this.super_Entity(e, r), this.previousProjectionMatrix = new te, this.matrixAutoUpdate = !0, this.width = window.innerWidth, this.height = window.innerHeight;
        let i = this.width, s = this.height;
        this.orthoCamera = new Ou(i * -0.5, i * .5, s * .5, s * -0.5, -50000, 1e4), this.perspCamera = new Wr(45, i / s, 50, 1e4), this.left = this.orthoCamera.left, this.right = this.orthoCamera.right, this.top = this.orthoCamera.top, this.bottom = this.orthoCamera.bottom, this.far = this.orthoCamera.far, this.view = this.orthoCamera.view, this.aspect = this.perspCamera.aspect, this.focus = this.perspCamera.focus, this.filmGauge = this.perspCamera.filmGauge, this.filmOffset = this.perspCamera.filmOffset, this.objectHelper.update();
    }
    get isPerspectiveCamera() {
        return this.cameraType === "PerspectiveCamera";
    }
    get isOrthographicCamera() {
        return !this.isPerspectiveCamera;
    }
    get cameraType() {
        return this._cameraType;
    }
    set fov(e) {
        this.perspCamera.fov = e;
    }
    get fov() {
        return this.perspCamera.fov;
    }
    setNear(e, r) {
        e === "PerspectiveCamera" ? this.perspCamera.near = r : this.orthoCamera.near = r;
    }
    setZoom(e, r) {
        r >= 0 && (e === "PerspectiveCamera" ? this.perspCamera.zoom = r : this.orthoCamera.zoom = r);
    }
    set cameraType(e) {
        e === "PerspectiveCamera" ? this.toPerspective() : e === "OrthographicCamera" && this.toOrthographic();
    }
    get near() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.near : this.orthoCamera.near;
    }
    set near(e) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.near = e : this.orthoCamera.near = e;
    }
    get zoom() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom : this.orthoCamera.zoom;
    }
    set zoom(e) {
        e >= 0 && (this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom = e : this.orthoCamera.zoom = e);
    }
    lookAt(e, r, i) {
        typeof e == "number" && (e = new _(e, r, i)), super.lookAt(e), this.getWorldPosition(nf), this.targetOffset = nf.distanceTo(e);
    }
    getTarget(e = new _) {
        return this.getWorldDirection(l_), this.getWorldPosition(nf), l_.multiplyScalar(this.targetOffset), e.copy(nf).add(l_), e;
    }
    getDistanceToTarget() {
        let e = this.getTarget();
        return this.getWorldPosition(nf), nf.distanceTo(e);
    }
    updateUp() {
        this.getWorldQuaternion(c_), u_.set(0, 0, 1).applyQuaternion(c_), Dm.copy(mt.DEFAULT_UP), this.isUpVectorFlipped && Dm.negate(), Dm.applyQuaternion(c_), d_.copy(mt.DEFAULT_UP).projectOnPlane(u_), this.angleOffsetFromUp = d_.angleTo(Dm), this.angleOffsetFromUp *= d_.cross(Dm).dot(u_) >= 0 ? 1 : -1;
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateUp(), i;
    }
    getViewFrontToObject(e) {
        let r = e.getWorldPosition(new _), s = e.getWorldDirection(new _).multiplyScalar(this.targetOffset);
        return {
            position: r.clone().add(s),
            target: r
        };
    }
    getViewToTarget(e) {
        let i = this.getWorldDirection(new _).multiplyScalar(this.targetOffset);
        return {
            position: e.clone().sub(i),
            target: e
        };
    }
    getViewToObject(e) {
        let r = new _, i = e.getWorldPosition(r);
        return this.getViewToTarget(r);
    }
    setViewplaneSize(e, r, i = !1) {
        if (this.aspect = e / r, i) {
            let s = e > r ? this.aspect : 1, o = e > r ? 1 : this.aspect;
            this.left = -sx * .5 * s, this.right = sx * .5 * s, this.top = sx * .5 * (1 / o), this.bottom = -sx * .5 * (1 / o);
        } else this.left = -e * .5, this.right = e * .5, this.top = r * .5, this.bottom = -r * .5;
        this.updateProjectionMatrix();
    }
    copyViewPlaneSize(e) {
        this.aspect = e.aspect, this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.updateProjectionMatrix();
    }
    toOrthographic() {
        this.orthoCamera.left = this.left, this.orthoCamera.right = this.right, this.orthoCamera.top = this.top, this.orthoCamera.bottom = this.bottom, this.orthoCamera.view = this.view, this.orthoCamera.far = this.far, this.orthoCamera.updateProjectionMatrix(), this.projectionMatrix = this.orthoCamera.projectionMatrix, this.projectionMatrixInverse = this.orthoCamera.projectionMatrixInverse, this._cameraType = "OrthographicCamera", this.objectHelper && this.objectHelper.update();
    }
    toPerspective() {
        this.perspCamera.aspect = this.aspect, this.perspCamera.fov = this.fov, this.perspCamera.view = this.view, this.perspCamera.far = this.far, this.perspCamera.updateProjectionMatrix(), this.projectionMatrix = this.perspCamera.projectionMatrix, this.projectionMatrixInverse = this.perspCamera.projectionMatrixInverse, this._cameraType = "PerspectiveCamera", this.objectHelper && this.objectHelper.update();
    }
    setFocalLength(e) {
        this.perspCamera.setFocalLength(e), this.toPerspective();
    }
    getFocalLength() {
        return this.perspCamera.getFocalLength();
    }
    getEffectiveFOV() {
        return this.perspCamera.getEffectiveFOV();
    }
    getFilmWidth() {
        return this.perspCamera.getFilmWidth();
    }
    getFilmHeight() {
        return this.perspCamera.getFilmHeight();
    }
    setViewOffset(e, r, i, s, o, a) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.setViewOffset(e, r, i, s, o, a) : this.orthoCamera.setViewOffset(e, r, i, s, o, a);
    }
    clearViewOffset() {
        this._cameraType === "PerspectiveCamera" ? (this.perspCamera.clearViewOffset(), this.toPerspective()) : (this.orthoCamera.clearViewOffset(), this.toOrthographic());
    }
    copyHistory() {
        this.previousProjectionMatrix && this.previousProjectionMatrix.copy(this.projectionMatrix);
    }
    updateProjectionMatrix() {
        this._cameraType === "PerspectiveCamera" ? this.toPerspective() : this._cameraType === "OrthographicCamera" && this.toOrthographic();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, r) {
        super.updateWorldMatrix(e, r), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    copy(e, r) {
        return super.copy(e, r), this.parent = e.parent, this.orthoCamera.copy(e.orthoCamera), this.perspCamera.copy(e.perspCamera), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.far = e.far, this.view = e.view === null ? null : Object.assign({}, e.view), this._cameraType = e._cameraType, this.aspect = e.aspect, this.fov = e.fov, this.focus = e.focus, this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this.targetOffset = e.targetOffset, this.updateProjectionMatrix(), this;
    }
    toCameraState(e = []) {
        let r = {
            type: this.cameraType,
            far: this.far,
            orthographic: {
                near: this.orthoCamera.near,
                zoom: this.orthoCamera.zoom
            },
            perspective: {
                near: this.perspCamera.near,
                fov: this.perspCamera.fov,
                zoom: this.perspCamera.zoom
            },
            up: this.up.toArray(),
            targetOffset: this.targetOffset,
            isUpVectorFlipped: this.isUpVectorFlipped
        };
        return Ed(r, e);
    }
    updateCameraSubtype(e, r) {
        let i = e === "perspective" ? "PerspectiveCamera" : "OrthographicCamera";
        r.zoom !== void 0 && this.setZoom(i, r.zoom), r.near !== void 0 && this.setNear(i, r.near), r.fov !== void 0 && i === "PerspectiveCamera" && (this.fov = r.fov);
    }
    updateState(e, r) {
        this.updateCameraState(e, r);
    }
    updateCameraState(e, r) {
        this.updateState_Entity(e, r), e.far !== void 0 && (this.far = e.far), e.orthographic !== void 0 && this.updateCameraSubtype("orthographic", e.orthographic), e.perspective !== void 0 && this.updateCameraSubtype("perspective", e.perspective), e.type !== void 0 && (this.cameraType = e.type), e.up !== void 0 && this.up.fromArray(e.up), e.targetOffset !== void 0 && (this.targetOffset = e.targetOffset), e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateProjectionMatrix();
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.type === 0 && this.updateCameraSubtype(e.path[0], e.props);
    }
    toState(e) {
        return {
            ...super.toState(e),
            ...this.toCameraState(e),
            type: this.cameraType
        };
    }
};
var sf = new te, Y7 = new te, ox = new te, PR = new _, DR = new _;
function h_(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.geometry?.type === "BooleanGeometry" && (t = !0);
    }), t;
}
var Ln = class extends gs {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.meshSetAddresses = [];
        this.needsTransformForDownstream = !1;
        this.geometry = new we;
        this.onAfterRender = (e, r, i, s, o, a)=>{
            super.onAfterRender(e, r, i, s, o, a), this.recomputeBoolean();
        };
        this.geometry.userData.parameters = {
            width: 0,
            height: 0,
            depth: 0
        };
    }
    get booleanOp() {
        return this.data.geometry.operation;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    get isLOD() {
        return this.recomputeBoolean(), !1;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.path[0] === "geometry" && e.type === 0 && e.props.operation !== void 0 && (this.freeBooleanPointer(), this.resetBBoxNeedsUpdate());
    }
    freeBooleanPointer() {
        super.freeBooleanPointer(), this.geometry.dispose();
    }
    recomputeBoolean(e, r = !0) {
        if (this.booleanMeshSetAddress !== -1 && !e) return;
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            o instanceof Ln && o.dataPatched.visible === !0 && o.recomputeBoolean(e === !0, r);
        }
        this.meshSetAddresses = [];
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            if (o instanceof nr && o.dataPatched.visible === !0 && o.geometry.attributes.position?.count > 0 && o.geometry.drawRange.count > 0 && o.booleanMeshSetAddress !== 0) {
                sf.multiplyMatrices(o.hiddenMatrix, o.matrix);
                try {
                    if (o.booleanMeshSetAddress === -1) {
                        if ((o.geometry.index ?? o.geometry.getAttribute("position")).count / 3 < 15e5 && (o.booleanMeshSetAddress = ps.getMeshSet(o.geometry, e === !0, r)), o.booleanMeshSetAddress === -1) return;
                        ps.transformMeshSet(o.booleanMeshSetAddress, sf), o.booleanMatrixInvOld.copy(sf).invert(), o.booleanWasTransformed = !1;
                    } else o instanceof Ln && o.needsTransformForDownstream === !0 ? (ps.transformMeshSet(o.booleanMeshSetAddress, sf), o.needsTransformForDownstream = !1) : o.booleanWasTransformed === !0 && (ps.transformMeshSet(o.booleanMeshSetAddress, Y7.multiplyMatrices(sf, o.booleanMatrixInvOld)), o.booleanMatrixInvOld.copy(sf).invert(), o.booleanWasTransformed = !1);
                } catch (a) {
                    console.error(a), o.booleanMeshSetAddress = 0, o.geometry.userData.booleanOperationDidFail = !0;
                    continue;
                }
                ps.hasOpenEdges(o.booleanMeshSetAddress) === !1 || s === this.children.length - 1 && this.booleanOp === 2 ? (this.meshSetAddresses.push(o.booleanMeshSetAddress), o.geometry.userData.booleanOperationDidFail = !1) : o.geometry.userData.booleanOperationDidFail = "openEdges";
            }
        }
        if (this.meshSetAddresses.length === 0) {
            this.geometry.setAttribute("position", new be([], 0)), this.geometry.setDrawRange(0, 0);
            return;
        }
        if (e === !0) return ps.calcBooleanTopological(this.meshSetAddresses, this.booleanOp);
        let i = this.geometry;
        i.dispose(), this.geometry = new we, this.geometry.userData = i.userData, this.geometry.boundingSphere = i.boundingSphere;
        try {
            this.booleanMeshSetAddress = ps.calcBoolean(this.meshSetAddresses, this.booleanOp, this.geometry, this.phongAngle);
        } catch (s) {
            this.booleanMeshSetAddress = 0, this.geometry.userData.booleanOperationDidFail = !0, console.error(s);
        }
        this.booleanMatrixInvOld.copy(this.matrix).invert(), this.needsTransformForDownstream = !0, Jh(this), $h(this);
    }
    dispose() {
        super.dispose(), this.geometry.dispose();
    }
    get recursiveBBox() {
        let e = super.recursiveBBox;
        return this.geometry.boundingSphere?.radius === -1 && (e.getCenter(this.geometry.boundingSphere.center), ox.copy(this.matrixWorld).invert(), this.geometry.boundingSphere.center.applyMatrix4(ox), PR.copy(e.max).applyMatrix4(ox), DR.copy(e.min).applyMatrix4(ox), this.geometry.boundingSphere.radius = PR.distanceTo(DR) / 2), e;
    }
};
var ax;
((t)=>{
    function n1(e) {
        return ut.is(e) && e instanceof il;
    }
    t.is = n1;
})(ax || (ax = {}));
var of = (n1, t)=>class extends xs(n1, t) {
        updateState_Light(r, i) {
            this.updateState_Entity(r, i), r.color !== void 0 && (this.color = i.shared.color(r.color)), r.intensity !== void 0 && (this.intensity = r.intensity), r.depth !== void 0 && (this.shadow.camera.far = r.depth, this.shadow.needsUpdate = !0), r.shadows !== void 0 && (this.castShadow = r.shadows);
        }
    };
var sn = (n1)=>n1 instanceof nr, An = (n1)=>n1 !== null && n1 instanceof Ln, OR = (n1)=>n1 instanceof hr, IR = (n1)=>ax.is(n1), Om = (n1)=>nx.is(n1);
var bs = class extends Bo(Ey) {
    constructor(e, r = 15){
        super(r);
        this.object = e;
        this.object.updateMatrixWorld(), this.name = `EmptyObjectHelper: ${e.uuid}`, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.object.isBone && (this.visible = !1);
    }
    raycast(e, r) {
        No(this.object, bs.geometryHelper, e, r);
    }
    update() {}
};
var Ss = class extends xs(ts, bs) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Entity(t, e), "buffer" in t && Object.keys(t).length === 1 && e.scene.reloadSplats();
    }
};
var Xc = class extends xs(ts, bs) {
    constructor(e, r, i){
        super();
        this.super_Entity(e, r), this.context = i, this.objectHelper.update();
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
};
var zR = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
var Im = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
var X7 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;
#if PASS == 1
uniform vec4 kernel64[32];
#else
uniform vec4 kernel16[8];
#endif
varying vec2 vUv;void main(){
#ifdef FOREGROUND
vec2 CoCNearFar=texture2D(cocBuffer,vUv).rg;float CoC=CoCNearFar.r*scale;
#else
float CoC=texture2D(cocBuffer,vUv).g*scale;
#endif
if(CoC==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{
#ifdef FOREGROUND
vec2 step=texelSize*max(CoC,CoCNearFar.g*scale);
#else
vec2 step=texelSize*CoC;
#endif
#if PASS == 1
vec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;
#else
vec4 maxValue=texture2D(inputBuffer,vUv);for(int i=0;i<8;++i){vec4 kernel=kernel16[i];vec2 uv=step*kernel.xy+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);uv=step*kernel.zw+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);}gl_FragColor=maxValue;
#endif
}}`, lx = class extends rt {
    constructor(n1 = !1, t = !1){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: n1 ? "2" : "1"
            },
            uniforms: {
                kernel64: new se(null),
                kernel16: new se(null),
                inputBuffer: new se(null),
                cocBuffer: new se(null),
                texelSize: new se(new N),
                scale: new se(1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: X7,
            vertexShader: Im
        }), this.toneMapped = !1, t && (this.defines.FOREGROUND = "1"), this.generateKernel();
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set cocBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    setCoCBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale(n1) {
        return this.uniforms.scale.value = n1;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    generateKernel() {
        let n1 = 2.39996323, t = new Float32Array(128), e = new Float32Array(32), r = 0, i = 0;
        for(let a = 0; a < 80; ++a){
            let l = a * n1, u = Math.sqrt(a) / Math.sqrt(80), c = u * Math.cos(l), d = u * Math.sin(l);
            a % 5 === 0 ? (e[i++] = c, e[i++] = d) : (t[r++] = c, t[r++] = d);
        }
        let s = [], o = [];
        for(let a = 0; a < 128;)s.push(new He(t[a++], t[a++], t[a++], t[a++]));
        for(let a = 0; a < 32;)o.push(new He(e[a++], e[a++], e[a++], e[a++]));
        this.uniforms.kernel64.value = s, this.uniforms.kernel16.value = o;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t);
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
};
function RR(n1, t, e) {
    return n1 * (t - e) - t;
}
function y_(n1, t, e) {
    return Math.min(Math.max((n1 + t) / (t - e), 0), 1);
}
var Q7 = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float focusDistance;uniform float focusRange;uniform float cameraNear;uniform float cameraFar;varying vec2 vUv;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}void main(){float depth=readDepth(vUv);
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
float signedDistance=linearDepth-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}`, K7 = class extends rt {
    constructor(n1){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new se(null),
                focusDistance: new se(0),
                focusRange: new se(0),
                cameraNear: new se(.3),
                cameraFar: new se(1e3)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: Q7,
            vertexShader: Im
        }), this.toneMapped = !1, this.uniforms.focalLength = this.uniforms.focusRange, this.adoptCameraSettings(n1);
    }
    get near() {
        return this.uniforms.cameraNear.value;
    }
    get far() {
        return this.uniforms.cameraFar.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Ii) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get worldFocusDistance() {
        return -RR(this.focusDistance, this.near, this.far);
    }
    set worldFocusDistance(n1) {
        this.focusDistance = y_(-n1, this.near, this.far);
    }
    getFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    setFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get focalLength() {
        return this.focusRange;
    }
    set focalLength(n1) {
        this.focusRange = n1;
    }
    get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(n1) {
        this.uniforms.focusRange.value = n1;
    }
    get worldFocusRange() {
        return -RR(this.focusRange, this.near, this.far);
    }
    set worldFocusRange(n1) {
        this.focusRange = y_(-n1, this.near, this.far);
    }
    getFocalLength(n1) {
        return this.focusRange;
    }
    setFocalLength(n1) {
        this.focusRange = n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof Wr ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
}, Z7 = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <encodings_fragment>
#include <dithering_fragment>
}`, J7 = "uniform vec2 texelSize;uniform vec2 halfTexelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize*vec2(kernel)+halfTexelSize)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}", LR = class extends rt {
    constructor(n1 = new N){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new se(null),
                texelSize: new se(new N),
                halfTexelSize: new se(new N),
                kernel: new se(0),
                scale: new se(1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: Z7,
            vertexShader: J7
        }), this.toneMapped = !1, this.setTexelSize(n1.x, n1.y);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.inputBuffer = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale() {
        return this.uniforms.scale.value;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    getKernel() {
        return null;
    }
    get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(n1) {
        this.uniforms.kernel.value = n1;
    }
    setKernel(n1) {
        this.kernel = n1;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t), this.uniforms.halfTexelSize.value.set(n1, t).multiplyScalar(.5);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.halfTexelSize.value.copy(e.texelSize.value).multiplyScalar(.5);
    }
}, $7 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <encodings_fragment>
}`, eX = class extends rt {
    constructor(){
        super({
            name: "CopyMaterial",
            uniforms: {
                inputBuffer: new se(null),
                opacity: new se(1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: $7,
            vertexShader: Im
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    getOpacity(n1) {
        return this.uniforms.opacity.value;
    }
    setOpacity(n1) {
        this.uniforms.opacity.value = n1;
    }
};
var tX = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`, rX = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`, af = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
}, iX = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
}, nX = class extends rt {
    constructor(n1 = new N, t = af.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: aa.replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new se(null),
                depthBuffer: new se(null),
                predicationBuffer: new se(null),
                texelSize: new se(n1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: tX,
            vertexShader: rX
        }), this.toneMapped = !1, this.edgeDetectionMode = t;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Ii) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(n1) {
        this.defines.EDGE_DETECTION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    setEdgeDetectionMode(n1) {
        this.edgeDetectionMode = n1;
    }
    get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(n1) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    setLocalContrastAdaptationFactor(n1) {
        this.localContrastAdaptationFactor = n1;
    }
    get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(n1) {
        this.defines.EDGE_THRESHOLD = n1.toFixed("6"), this.defines.DEPTH_THRESHOLD = (n1 * .1).toFixed("6"), this.needsUpdate = !0;
    }
    getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionThreshold = n1;
    }
    get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(n1) {
        this.defines.PREDICATION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getPredicationMode() {
        return this.predicationMode;
    }
    setPredicationMode(n1) {
        this.predicationMode = n1;
    }
    set predicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    setPredicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(n1) {
        this.defines.PREDICATION_THRESHOLD = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationThreshold() {
        return this.predicationThreshold;
    }
    setPredicationThreshold(n1) {
        this.predicationThreshold = n1;
    }
    get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(n1) {
        this.defines.PREDICATION_SCALE = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationScale() {
        return this.predicationScale;
    }
    setPredicationScale(n1) {
        this.predicationScale = n1;
    }
    get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(n1) {
        this.defines.PREDICATION_STRENGTH = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationStrength() {
        return this.predicationStrength;
    }
    setPredicationStrength(n1) {
        this.predicationStrength = n1;
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
}, sX = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if THREE_REVISION >= 137
vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}FRAGMENT_HEADvoid main(){FRAGMENT_MAIN_UVvec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGEgl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <encodings_fragment>
#endif
#include <dithering_fragment>
}`, oX = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEADvoid main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORTgl_Position=vec4(position.xy,1.0,1.0);}", Zs = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
}, v_ = class extends rt {
    constructor(n1, t, e, r, i = !1){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: aa.replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new se(null),
                depthBuffer: new se(null),
                resolution: new se(new N),
                texelSize: new se(new N),
                cameraNear: new se(.3),
                cameraFar: new se(1e3),
                aspect: new se(1),
                time: new se(0)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            dithering: i
        }), this.toneMapped = !1, n1 && this.setShaderParts(n1), t && this.setDefines(t), e && this.setUniforms(e), this.adoptCameraSettings(r);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = Ii) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    setShaderParts(n1) {
        return this.fragmentShader = sX.replace(Zs.FRAGMENT_HEAD, n1.get(Zs.FRAGMENT_HEAD)).replace(Zs.FRAGMENT_MAIN_UV, n1.get(Zs.FRAGMENT_MAIN_UV)).replace(Zs.FRAGMENT_MAIN_IMAGE, n1.get(Zs.FRAGMENT_MAIN_IMAGE)), this.vertexShader = oX.replace(Zs.VERTEX_HEAD, n1.get(Zs.VERTEX_HEAD)).replace(Zs.VERTEX_MAIN_SUPPORT, n1.get(Zs.VERTEX_MAIN_SUPPORT)), this.needsUpdate = !0, this;
    }
    setDefines(n1) {
        for (let t of n1.entries())this.defines[t[0]] = t[1];
        return this.needsUpdate = !0, this;
    }
    setUniforms(n1) {
        for (let t of n1.entries())this.uniforms[t[0]] = t[1];
        return this;
    }
    setExtensions(n1) {
        this.extensions = {};
        for (let t of n1)this.extensions[t] = !0;
        return this;
    }
    get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(n1) {
        this.encodeOutput !== n1 && (n1 ? this.defines.ENCODE_OUTPUT = "1" : delete this.defines.ENCODE_OUTPUT, this.needsUpdate = !0);
    }
    isOutputEncodingEnabled(n1) {
        return this.encodeOutput;
    }
    setOutputEncodingEnabled(n1) {
        this.encodeOutput = n1;
    }
    get time() {
        return this.uniforms.time.value;
    }
    set time(n1) {
        this.uniforms.time.value = n1;
    }
    setDeltaTime(n1) {
        this.uniforms.time.value += n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof Wr ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.resolution.value.set(n1, t), e.texelSize.value.set(1 / n1, 1 / t), e.aspect.value = n1 / t;
    }
    static get Section() {
        return Zs;
    }
};
var aX = `#include <common>
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l);
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*l,l);
#else
gl_FragColor=vec4(l);
#endif
}`, lX = class extends rt {
    constructor(n1 = !1, t = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: aa.replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new se(null),
                threshold: new se(0),
                smoothing: new se(1),
                range: new se(null)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: aX,
            vertexShader: Im
        }), this.toneMapped = !1, this.colorOutput = n1, this.luminanceRange = t;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(n1) {
        this.smoothing > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.threshold.value = n1;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(n1) {
        this.threshold = n1;
    }
    get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(n1) {
        this.threshold > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.smoothing.value = n1;
    }
    getSmoothingFactor() {
        return this.smoothing;
    }
    setSmoothingFactor(n1) {
        this.smoothing = n1;
    }
    get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(n1) {}
    get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(n1) {
        n1 ? this.defines.COLOR = "1" : delete this.defines.COLOR, this.needsUpdate = !0;
    }
    isColorOutputEnabled(n1) {
        return this.colorOutput;
    }
    setColorOutputEnabled(n1) {
        this.colorOutput = n1;
    }
    get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(n1) {
        this.luminanceRange = null;
    }
    get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(n1) {
        n1 !== null ? this.defines.RANGE = "1" : delete this.defines.RANGE, this.uniforms.range.value = n1, this.needsUpdate = !0;
    }
    getLuminanceRange() {
        return this.luminanceRange;
    }
    setLuminanceRange(n1) {
        this.luminanceRange = n1;
    }
}, cX = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef MASK_PRECISION_HIGH
uniform mediump sampler2D maskTexture;
#else
uniform lowp sampler2D maskTexture;
#endif
#if MASK_FUNCTION != 0
uniform float strength;
#endif
varying vec2 vUv;void main(){
#if COLOR_CHANNEL == 0
float mask=texture2D(maskTexture,vUv).r;
#elif COLOR_CHANNEL == 1
float mask=texture2D(maskTexture,vUv).g;
#elif COLOR_CHANNEL == 2
float mask=texture2D(maskTexture,vUv).b;
#else
float mask=texture2D(maskTexture,vUv).a;
#endif
#if MASK_FUNCTION == 0
#ifdef INVERTED
mask=step(mask,0.0);
#else
mask=1.0-step(mask,0.0);
#endif
#else
mask=clamp(mask*strength,0.0,1.0);
#ifdef INVERTED
mask=1.0-mask;
#endif
#endif
#if MASK_FUNCTION == 2
gl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);
#else
gl_FragColor=mask*texture2D(inputBuffer,vUv);
#endif
}`, VR = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2
}, uX = class extends rt {
    constructor(n1 = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new se(n1),
                inputBuffer: new se(null),
                strength: new se(1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: cX,
            vertexShader: Im
        }), this.toneMapped = !1, this.setColorChannel(zR.RED), this.setMaskFunction(VR.DISCARD);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set maskTexture(n1) {
        this.uniforms.maskTexture.value = n1, delete this.defines.MASK_PRECISION_HIGH, n1.type !== br && (this.defines.MASK_PRECISION_HIGH = "1"), this.needsUpdate = !0;
    }
    setMaskTexture(n1) {
        this.maskTexture = n1;
    }
    set colorChannel(n1) {
        this.defines.COLOR_CHANNEL = n1.toFixed(0), this.needsUpdate = !0;
    }
    setColorChannel(n1) {
        this.colorChannel = n1;
    }
    set maskFunction(n1) {
        this.defines.MASK_FUNCTION = n1.toFixed(0), this.needsUpdate = !0;
    }
    setMaskFunction(n1) {
        this.maskFunction = n1;
    }
    get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(n1) {
        this.inverted && !n1 ? delete this.defines.INVERTED : n1 && (this.defines.INVERTED = "1"), this.needsUpdate = !0;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    get strength() {
        return this.uniforms.strength.value;
    }
    set strength(n1) {
        this.uniforms.strength.value = n1;
    }
    getStrength() {
        return this.strength;
    }
    setStrength(n1) {
        this.strength = n1;
    }
};
var dX = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`, hX = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}", fX = class extends rt {
    constructor(n1 = new N, t = new N){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new se(null),
                searchTexture: new se(null),
                areaTexture: new se(null),
                resolution: new se(t),
                texelSize: new se(n1)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: dX,
            vertexShader: hX
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(n1) {
        this.uniforms.searchTexture.value = n1;
    }
    get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(n1) {
        this.uniforms.areaTexture.value = n1;
    }
    setLookupTextures(n1, t) {
        this.searchTexture = n1, this.areaTexture = t;
    }
    get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setOrthogonalSearchSteps(n1) {
        this.orthogonalSearchSteps = n1;
    }
    get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setDiagonalSearchSteps(n1) {
        this.diagonalSearchSteps = n1;
    }
    get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(n1) {
        n1 ? delete this.defines.DISABLE_DIAG_DETECTION : this.defines.DISABLE_DIAG_DETECTION = "1", this.needsUpdate = !0;
    }
    isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    setDiagonalDetectionEnabled(n1) {
        this.diagonalDetection = n1;
    }
    get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(n1) {
        let t = Math.min(Math.max(n1, 0), 100);
        this.defines.CORNER_ROUNDING = t.toFixed("4"), this.defines.CORNER_ROUNDING_NORM = (t / 100).toFixed("4"), this.needsUpdate = !0;
    }
    setCornerRounding(n1) {
        this.cornerRounding = n1;
    }
    get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(n1) {
        n1 ? delete this.defines.DISABLE_CORNER_DETECTION : this.defines.DISABLE_CORNER_DETECTION = "1", this.needsUpdate = !0;
    }
    isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    setCornerRoundingEnabled(n1) {
        this.cornerDetection = n1;
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.resolution.value.set(n1, t);
    }
};
var pX = new Hn, kl = null;
function mX() {
    if (kl === null) {
        let n1 = new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), t = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        kl = new we, kl.setAttribute !== void 0 ? (kl.setAttribute("position", new Ge(n1, 3)), kl.setAttribute("uv", new Ge(t, 2))) : (kl.addAttribute("position", new Ge(n1, 3)), kl.addAttribute("uv", new Ge(t, 2)));
    }
    return kl;
}
var hi = class {
    constructor(n1 = "Pass", t = new vi, e = pX){
        this.name = n1, this.renderer = null, this.scene = t, this.camera = e, this.screen = null, this.rtt = !0, this.needsSwap = !0, this.needsDepthTexture = !1, this.enabled = !0;
    }
    get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(n1) {
        if (this.rtt === n1) {
            let t = this.getFullscreenMaterial();
            t !== null && (t.needsUpdate = !0), this.rtt = !n1;
        }
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    isEnabled() {
        return this.enabled;
    }
    setEnabled(n1) {
        this.enabled = n1;
    }
    get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(n1) {
        let t = this.screen;
        t !== null ? t.material = n1 : (t = new rr(mX(), n1), t.frustumCulled = !1, this.scene === null && (this.scene = new vi), this.scene.add(t), this.screen = t);
    }
    getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    setFullscreenMaterial(n1) {
        this.fullscreenMaterial = n1;
    }
    getDepthTexture() {
        return null;
    }
    setDepthTexture(n1, t = Ii) {}
    render(n1, t, e, r, i) {
        throw new Error("Render method not implemented!");
    }
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t.dispose == "function") {
                if (t instanceof vi || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
}, Rm = class extends hi {
    constructor(n1, t = !0){
        super("CopyPass"), this.fullscreenMaterial = new eX, this.needsSwap = !1, this.renderTarget = n1, n1 === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "CopyPass.Target"), this.autoResize = t;
    }
    get resize() {
        return this.autoResize;
    }
    set resize(n1) {
        this.autoResize = n1;
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    setAutoResizeEnabled(n1) {
        this.autoResize = n1;
    }
    render(n1, t, e, r, i) {
        this.fullscreenMaterial.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        this.autoResize && this.renderTarget.setSize(n1, t);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTarget.texture.type = e, e !== br ? this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1" : n1.outputEncoding === tt && (this.renderTarget.texture.encoding = tt));
    }
};
var UR = class extends hi {
    constructor(){
        super("ClearMaskPass", null, null), this.needsSwap = !1;
    }
    render(n1, t, e, r, i) {
        let s = n1.state.buffers.stencil;
        s.setLocked(!1), s.setTest(!1);
    }
}, f_ = new Le, x_ = class extends hi {
    constructor(n1 = !0, t = !0, e = !1){
        super("ClearPass", null, null), this.needsSwap = !1, this.color = n1, this.depth = t, this.stencil = e, this.overrideClearColor = null, this.overrideClearAlpha = -1;
    }
    setClearFlags(n1, t, e) {
        this.color = n1, this.depth = t, this.stencil = e;
    }
    getOverrideClearColor() {
        return this.overrideClearColor;
    }
    setOverrideClearColor(n1) {
        this.overrideClearColor = n1;
    }
    getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    setOverrideClearAlpha(n1) {
        this.overrideClearAlpha = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.overrideClearColor, o = this.overrideClearAlpha, a = n1.getClearAlpha(), l = s !== null, u = o >= 0;
        l ? (f_.copy(n1.getClearColor(f_)), n1.setClearColor(s, u ? o : a)) : u && n1.setClearAlpha(o), n1.setRenderTarget(this.renderToScreen ? null : t), n1.clear(this.color, this.depth, this.stencil), l ? n1.setClearColor(f_, a) : u && n1.setClearAlpha(a);
    }
}, zl = -1, Nn = class extends ir {
    constructor(n1, t = zl, e = zl, r = 1){
        super(), this.resizable = n1, this.base = new N(1, 1), this.preferred = new N(t, e), this.target = this.preferred, this.s = r;
    }
    get width() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.width !== zl ? r = t.width : t.height !== zl ? r = Math.round(t.height * (n1.width / Math.max(n1.height, 1))) : r = Math.round(n1.width * e), r;
    }
    set width(n1) {
        this.preferredWidth = n1;
    }
    get height() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.height !== zl ? r = t.height : t.width !== zl ? r = Math.round(t.width / Math.max(n1.width / Math.max(n1.height, 1), 1)) : r = Math.round(n1.height * e), r;
    }
    set height(n1) {
        this.preferredHeight = n1;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    get scale() {
        return this.s;
    }
    set scale(n1) {
        this.s !== n1 && (this.s = n1, this.preferred.setScalar(zl), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getScale() {
        return this.scale;
    }
    setScale(n1) {
        this.scale = n1;
    }
    get baseWidth() {
        return this.base.width;
    }
    set baseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseWidth() {
        return this.base.width;
    }
    setBaseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get baseHeight() {
        return this.base.height;
    }
    set baseHeight(n1) {
        this.base.height !== n1 && (this.base.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseHeight() {
        return this.baseHeight;
    }
    setBaseHeight(n1) {
        this.baseHeight = n1;
    }
    setBaseSize(n1, t) {
        (this.base.width !== n1 || this.base.height !== t) && (this.base.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get preferredWidth() {
        return this.preferred.width;
    }
    set preferredWidth(n1) {
        this.preferred.width !== n1 && (this.preferred.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredWidth() {
        return this.preferredWidth;
    }
    setPreferredWidth(n1) {
        this.preferredWidth = n1;
    }
    get preferredHeight() {
        return this.preferred.height;
    }
    set preferredHeight(n1) {
        this.preferred.height !== n1 && (this.preferred.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredHeight() {
        return this.preferredHeight;
    }
    setPreferredHeight(n1) {
        this.preferredHeight = n1;
    }
    setPreferredSize(n1, t) {
        (this.preferred.width !== n1 || this.preferred.height !== t) && (this.preferred.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    copy(n1) {
        this.base.set(n1.getBaseWidth(), n1.getBaseHeight()), this.preferred.set(n1.getPreferredWidth(), n1.getPreferredHeight()), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height);
    }
    static get AUTO_SIZE() {
        return zl;
    }
}, p_ = !1, BR = class {
    constructor(n1 = null){
        this.originalMaterials = new Map, this.material = null, this.materials = null, this.materialsBackSide = null, this.materialsDoubleSide = null, this.materialsFlatShaded = null, this.materialsFlatShadedBackSide = null, this.materialsFlatShadedDoubleSide = null, this.setMaterial(n1), this.meshCount = 0, this.replaceMaterial = (t)=>{
            if (t.isMesh) {
                let e;
                if (t.material.flatShading) switch(t.material.side){
                    case qi:
                        e = this.materialsFlatShadedDoubleSide;
                        break;
                    case ai:
                        e = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        e = this.materialsFlatShaded;
                        break;
                }
                else switch(t.material.side){
                    case qi:
                        e = this.materialsDoubleSide;
                        break;
                    case ai:
                        e = this.materialsBackSide;
                        break;
                    default:
                        e = this.materials;
                        break;
                }
                this.originalMaterials.set(t, t.material), t.isSkinnedMesh ? t.material = e[2] : t.isInstancedMesh ? t.material = e[1] : t.material = e[0], ++this.meshCount;
            }
        };
    }
    setMaterial(n1) {
        if (this.disposeMaterials(), this.material = n1, n1 !== null) {
            let t = this.materials = [
                n1.clone(),
                n1.clone(),
                n1.clone()
            ];
            for (let e of t)e.uniforms = Object.assign({}, n1.uniforms), e.side = jn;
            t[2].skinning = !0, this.materialsBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = ai, r;
            }), this.materialsDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = qi, r;
            }), this.materialsFlatShaded = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r;
            }), this.materialsFlatShadedBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = ai, r;
            }), this.materialsFlatShadedDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = qi, r;
            });
        }
    }
    render(n1, t, e) {
        let r = n1.shadowMap.enabled;
        if (n1.shadowMap.enabled = !1, p_) {
            let i = this.originalMaterials;
            this.meshCount = 0, t.traverse(this.replaceMaterial), n1.render(t, e);
            for (let s of i)s[0].material = s[1];
            this.meshCount !== i.size && i.clear();
        } else {
            let i = t.overrideMaterial;
            t.overrideMaterial = this.material, n1.render(t, e), t.overrideMaterial = i;
        }
        n1.shadowMap.enabled = r;
    }
    disposeMaterials() {
        if (this.material !== null) {
            let n1 = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (let t of n1)t.dispose();
        }
    }
    dispose() {
        this.originalMaterials.clear(), this.disposeMaterials();
    }
    static get workaroundEnabled() {
        return p_;
    }
    static set workaroundEnabled(n1) {
        p_ = n1;
    }
}, gX = class extends hi {
    constructor(n1, t, e = null){
        super("RenderPass", n1, t), this.needsSwap = !1, this.clearPass = new x_, this.overrideMaterialManager = e === null ? null : new BR(e), this.ignoreBackground = !1, this.skipShadowMapUpdate = !1, this.selection = null;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(n1) {
        super.renderToScreen = n1, this.clearPass.renderToScreen = n1;
    }
    get overrideMaterial() {
        let n1 = this.overrideMaterialManager;
        return n1 !== null ? n1.material : null;
    }
    set overrideMaterial(n1) {
        let t = this.overrideMaterialManager;
        n1 !== null ? t !== null ? t.setMaterial(n1) : this.overrideMaterialManager = new BR(n1) : t !== null && (t.dispose(), this.overrideMaterialManager = null);
    }
    getOverrideMaterial() {
        return this.overrideMaterial;
    }
    setOverrideMaterial(n1) {
        this.overrideMaterial = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getSelection() {
        return this.selection;
    }
    setSelection(n1) {
        this.selection = n1;
    }
    isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    setBackgroundDisabled(n1) {
        this.ignoreBackground = n1;
    }
    isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    setShadowMapDisabled(n1) {
        this.skipShadowMapUpdate = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    render(n1, t, e, r, i) {
        let s = this.scene, o = this.camera, a = this.selection, l = o.layers.mask, u = s.background, c = n1.shadowMap.autoUpdate, d = this.renderToScreen ? null : t;
        a !== null && o.layers.set(a.getLayer()), this.skipShadowMapUpdate && (n1.shadowMap.autoUpdate = !1), (this.ignoreBackground || this.clearPass.overrideClearColor !== null) && (s.background = null), this.clearPass.enabled && this.clearPass.render(n1, t), n1.setRenderTarget(d), this.overrideMaterialManager !== null ? this.overrideMaterialManager.render(n1, s, o) : n1.render(s, o), o.layers.mask = l, s.background = u, n1.shadowMap.autoUpdate = c;
    }
}, b_ = class extends hi {
    constructor(n1, t, { resolutionScale: e = 1, width: r = Nn.AUTO_SIZE, height: i = Nn.AUTO_SIZE, renderTarget: s } = {}){
        super("DepthPass"), this.needsSwap = !1, this.renderPass = new gX(n1, t, new hp({
            depthPacking: lw
        }));
        let o = this.renderPass;
        o.skipShadowMapUpdate = !0, o.ignoreBackground = !0;
        let a = o.getClearPass();
        a.overrideClearColor = new Le(16777215), a.overrideClearAlpha = 1, this.renderTarget = s, this.renderTarget === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: Et,
            magFilter: Et,
            stencilBuffer: !1
        }), this.renderTarget.texture.name = "DepthPass.Target");
        let l = this.resolution = new Nn(this, r, i, e);
        l.addEventListener("change", (u)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(n1, s);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
};
var u2e = new Float32Array([
    255 / 256 / 256 ** 3,
    255 / 256 / 65536,
    255 / 256 / 256,
    255 / 256
]);
var yt = {
    SKIP: 0,
    ADD: 1,
    ALPHA: 2,
    AVERAGE: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    EXCLUSION: 8,
    LIGHTEN: 9,
    MULTIPLY: 10,
    DIVIDE: 11,
    NEGATION: 12,
    NORMAL: 13,
    OVERLAY: 14,
    REFLECT: 15,
    SCREEN: 16,
    SOFT_LIGHT: 17,
    SUBTRACT: 18
}, yX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x+y,1.0)*opacity+x*(1.0-opacity);}", vX = "vec3 blend(const in vec3 x,const in vec3 y,const in float opacity){return y*opacity+x*(1.0-opacity);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){float a=min(y.a,opacity);return vec4(blend(x.rgb,y.rgb,a),max(x.a,a));}", xX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y)*0.5*opacity+x*(1.0-opacity);}", bX = "float blend(const in float x,const in float y){return(y==0.0)?y:max(1.0-(1.0-x)/y,0.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", SX = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", wX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x,y)*opacity+x*(1.0-opacity);}", AX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return abs(x-y)*opacity+x*(1.0-opacity);}", _X = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y-2.0*x*y)*opacity+x*(1.0-opacity);}", EX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x,y)*opacity+x*(1.0-opacity);}", TX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return x*y*opacity+x*(1.0-opacity);}", MX = "float blend(const in float x,const in float y){return(y>0.0)?min(x/y,1.0):1.0;}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", CX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-abs(1.0-x-y))*opacity+x*(1.0-opacity);}", PX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y*opacity+x*(1.0-opacity);}", DX = "float blend(const in float x,const in float y){return(x<0.5)?(2.0*x*y):(1.0-2.0*(1.0-x)*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", OX = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x*x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", IX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-(1.0-x)*(1.0-y))*opacity+x*(1.0-opacity);}", RX = "float blend(const in float x,const in float y){return(y<0.5)?(2.0*x*y+x*x*(1.0-2.0*y)):(sqrt(x)*(2.0*y-1.0)+2.0*x*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", LX = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x+y-1.0,0.0)*opacity+x*(1.0-opacity);}", BX = new Map([
    [
        yt.SKIP,
        null
    ],
    [
        yt.ADD,
        yX
    ],
    [
        yt.ALPHA,
        vX
    ],
    [
        yt.AVERAGE,
        xX
    ],
    [
        yt.COLOR_BURN,
        bX
    ],
    [
        yt.COLOR_DODGE,
        SX
    ],
    [
        yt.DARKEN,
        wX
    ],
    [
        yt.DIFFERENCE,
        AX
    ],
    [
        yt.EXCLUSION,
        _X
    ],
    [
        yt.LIGHTEN,
        EX
    ],
    [
        yt.MULTIPLY,
        TX
    ],
    [
        yt.DIVIDE,
        MX
    ],
    [
        yt.NEGATION,
        CX
    ],
    [
        yt.NORMAL,
        PX
    ],
    [
        yt.OVERLAY,
        DX
    ],
    [
        yt.REFLECT,
        OX
    ],
    [
        yt.SCREEN,
        IX
    ],
    [
        yt.SOFT_LIGHT,
        RX
    ],
    [
        yt.SUBTRACT,
        LX
    ]
]), NX = class extends ir {
    constructor(n1, t = 1){
        super(), this.f = n1, this.opacity = new se(t);
    }
    getOpacity() {
        return this.opacity.value;
    }
    setOpacity(n1) {
        this.opacity.value = n1;
    }
    get blendFunction() {
        return this.f;
    }
    set blendFunction(n1) {
        this.f = n1, this.dispatchEvent({
            type: "change"
        });
    }
    getBlendFunction() {
        return this.blendFunction;
    }
    setBlendFunction(n1) {
        this.blendFunction = n1;
    }
    getShaderCode() {
        return BX.get(this.blendFunction);
    }
}, Fo = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
var ko = class extends ir {
    constructor(n1, t, { attributes: e = Fo.NONE, blendFunction: r = yt.SCREEN, defines: i = new Map, uniforms: s = new Map, extensions: o = null, vertexShader: a = null } = {}){
        super(), this.name = n1, this.renderer = null, this.attributes = e, this.fragmentShader = t, this.vertexShader = a, this.defines = i, this.uniforms = s, this.extensions = o, this.blendMode = new NX(r), this.blendMode.addEventListener("change", (l)=>this.setChanged());
    }
    getName() {
        return this.name;
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getExtensions() {
        return this.extensions;
    }
    getBlendMode() {
        return this.blendMode;
    }
    getAttributes() {
        return this.attributes;
    }
    setAttributes(n1) {
        this.attributes = n1, this.setChanged();
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    setFragmentShader(n1) {
        this.fragmentShader = n1, this.setChanged();
    }
    getVertexShader() {
        return this.vertexShader;
    }
    setVertexShader(n1) {
        this.vertexShader = n1, this.setChanged();
    }
    setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    setDepthTexture(n1, t = Ii) {}
    update(n1, t, e) {}
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t.dispose == "function") {
                if (t instanceof vi || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
};
function NR(n1, t, e) {
    for (let r of t){
        let i = "$1" + n1 + r.charAt(0).toUpperCase() + r.slice(1), s = new RegExp("([^\\.])(\\b" + r + "\\b)", "g");
        for (let o of e.entries())o[1] !== null && e.set(o[0], o[1].replace(s, i));
    }
}
function FX(n1, t, e, r, i, s, o) {
    let a = new Map([
        [
            "fragment",
            t.getFragmentShader()
        ],
        [
            "vertex",
            t.getVertexShader()
        ]
    ]), l = a.get("fragment") !== void 0 && /mainImage/.test(a.get("fragment")), u = a.get("fragment") !== void 0 && /mainUv/.test(a.get("fragment")), c = [], d = [], h = !1, f = !1;
    if (a.get("fragment") === void 0) console.error("Missing fragment shader", t);
    else if (u && (o & Fo.CONVOLUTION) !== 0) console.error("Effects that transform UV coordinates are incompatible with convolution effects", t);
    else if (!l && !u) console.error("The fragment shader contains neither a mainImage nor a mainUv function", t);
    else {
        let p = /(?:\w+\s+(\w+)\([\w\s,]*\)\s*{[^}]+})/g, m = v_.Section;
        if (u) {
            let y = `	${n1}MainUv(UV);
`;
            e.set(m.FRAGMENT_MAIN_UV, e.get(m.FRAGMENT_MAIN_UV) + y), h = !0;
        }
        if (a.get("vertex") !== null && /mainSupport/.test(a.get("vertex"))) {
            let y = `	${n1}MainSupport(`;
            y += /mainSupport *\([\w\s]*?uv\s*?\)/.test(a.get("vertex")) ? `vUv);
` : `);
`, e.set(m.VERTEX_MAIN_SUPPORT, e.get(m.VERTEX_MAIN_SUPPORT) + y), c = c.concat([
                ...a.get("vertex").matchAll(/(?:varying\s+\w+\s+(\w*))/g)
            ].map((v)=>v[1])), d = d.concat(c).concat([
                ...a.get("vertex").matchAll(p)
            ].map((v)=>v[1]));
        }
        d = d.concat([
            ...a.get("fragment").matchAll(p)
        ].map((y)=>y[1])), d = d.concat([
            ...t.defines.keys()
        ].map((y)=>y.replace(/\([\w\s,]*\)/g, ""))), d = d.concat([
            ...t.uniforms.keys()
        ]), t.uniforms.forEach((y, v)=>s.set(n1 + v.charAt(0).toUpperCase() + v.slice(1), y)), t.defines.forEach((y, v)=>i.set(n1 + v.charAt(0).toUpperCase() + v.slice(1), y)), NR(n1, d, i), NR(n1, d, a);
        let g = t.blendMode;
        if (r.set(g.blendFunction, g), l) {
            let y = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/, v = `${n1}MainImage(color0, UV, `;
            (o & Fo.DEPTH) !== 0 && y.test(a.get("fragment")) && (v += "depth, ", f = !0), v += `color1);
	`;
            let x = n1 + "BlendOpacity";
            s.set(x, g.opacity), v += `color0 = blend${g.blendFunction}(color0, color1, ${x});

	`, e.set(m.FRAGMENT_MAIN_IMAGE, e.get(m.FRAGMENT_MAIN_IMAGE) + v), v = `uniform float ${x};

`, e.set(m.FRAGMENT_HEAD, e.get(m.FRAGMENT_HEAD) + v);
        }
        e.set(m.FRAGMENT_HEAD, e.get(m.FRAGMENT_HEAD) + a.get("fragment") + `
`), a.get("vertex") !== null && e.set(m.VERTEX_HEAD, e.get(m.VERTEX_HEAD) + a.get("vertex") + `
`);
    }
    return {
        varyings: c,
        transformedUv: h,
        readDepth: f
    };
}
var Qc = class extends hi {
    constructor(n1, ...t){
        super("EffectPass"), this.fullscreenMaterial = new v_(null, null, null, n1), this.effects = t.sort((e, r)=>r.attributes - e.attributes), this.skipRendering = !1, this.uniformCount = 0, this.varyingCount = 0, this.minTime = 1, this.maxTime = Number.POSITIVE_INFINITY;
    }
    get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(n1) {
        this.fullscreenMaterial.encodeOutput = n1;
    }
    get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(n1) {
        let t = this.fullscreenMaterial;
        t.dithering = n1, t.needsUpdate = !0;
    }
    verifyResources() {
        let n1 = this.renderer.capabilities, t = Math.min(n1.maxFragmentUniforms, n1.maxVertexUniforms);
        this.uniformCount > t && console.warn("The current rendering context doesn't support more than " + t + " uniforms, but " + this.uniformCount + " were defined"), t = n1.maxVaryings, this.varyingCount > t && console.warn("The current rendering context doesn't support more than " + t + " varyings, but " + this.varyingCount + " were defined");
    }
    updateMaterial() {
        let n1 = v_.Section, t = new Map([
            [
                n1.FRAGMENT_HEAD,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_UV,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_IMAGE,
                ""
            ],
            [
                n1.VERTEX_HEAD,
                ""
            ],
            [
                n1.VERTEX_MAIN_SUPPORT,
                ""
            ]
        ]), e = new Map, r = new Map, i = new Map, s = new Set, o = 0, a = 0, l = 0, u = !1, c = !1;
        for (let h of this.effects)if (h.blendMode.blendFunction === yt.SKIP) l |= h.getAttributes() & Fo.DEPTH;
        else if ((l & h.getAttributes() & Fo.CONVOLUTION) !== 0) console.error("Convolution effects cannot be merged", h);
        else {
            l |= h.getAttributes();
            let f = "e" + o++, p = FX(f, h, t, e, r, i, l);
            if (a += p.varyings.length, u = u || p.transformedUv, c = c || p.readDepth, h.extensions !== null) for (let m of h.extensions)s.add(m);
        }
        let d = /\bblend\b/g;
        for (let h of e.values()){
            let f = h.getShaderCode().replace(d, `blend${h.blendFunction}`);
            t.set(n1.FRAGMENT_HEAD, t.get(n1.FRAGMENT_HEAD) + f + `
`);
        }
        if ((l & Fo.DEPTH) !== 0) {
            if (c) {
                let h = `float depth = readDepth(UV);

	`;
                t.set(n1.FRAGMENT_MAIN_IMAGE, h + t.get(n1.FRAGMENT_MAIN_IMAGE));
            }
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = !1;
        if (u) {
            let h = `vec2 transformedUv = vUv;
`;
            t.set(n1.FRAGMENT_MAIN_UV, h + t.get(n1.FRAGMENT_MAIN_UV)), r.set("UV", "transformedUv");
        } else r.set("UV", "vUv");
        t.forEach((h, f, p)=>p.set(f, h.trim().replace(/^#/, `
#`))), this.uniformCount = i.size, this.varyingCount = a, this.skipRendering = o === 0, this.needsSwap = !this.skipRendering, this.fullscreenMaterial.setShaderParts(t).setExtensions(s).setUniforms(i).setDefines(r);
    }
    recompile() {
        this.updateMaterial(), this.verifyResources();
    }
    getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    setDepthTexture(n1, t = Ii) {
        this.fullscreenMaterial.depthBuffer = n1, this.fullscreenMaterial.depthPacking = t;
        for (let e of this.effects)e.setDepthTexture(n1, t);
    }
    render(n1, t, e, r, i) {
        for (let s of this.effects)s.update(n1, t, r);
        if (!this.skipRendering || this.renderToScreen) {
            let s = this.fullscreenMaterial;
            s.inputBuffer = t.texture, s.time += r, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
        }
    }
    setSize(n1, t) {
        this.fullscreenMaterial.setSize(n1, t);
        for (let e of this.effects)e.setSize(n1, t);
    }
    initialize(n1, t, e) {
        this.renderer = n1;
        for (let r of this.effects)r.initialize(n1, t, e), r.addEventListener("change", (i)=>this.handleEvent(i));
        this.updateMaterial(), this.verifyResources(), e !== void 0 && e !== br && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
    dispose() {
        super.dispose();
        for (let n1 of this.effects)n1.dispose();
    }
    handleEvent(n1) {
        switch(n1.type){
            case "change":
                this.recompile();
                break;
        }
    }
}, kX = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
], ux = class extends hi {
    constructor({ resolutionScale: n1 = .5, width: t = Nn.AUTO_SIZE, height: e = Nn.AUTO_SIZE, kernelSize: r = Lm.LARGE } = {}){
        super("KawaseBlurPass"), this.renderTargetA = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetA.texture.name = "Blur.Target.A", this.renderTargetB = this.renderTargetA.clone(), this.renderTargetB.texture.name = "Blur.Target.B";
        let i = this.resolution = new Nn(this, t, e, n1);
        i.addEventListener("change", (s)=>this.setSize(i.baseWidth, i.baseHeight)), this.blurMaterial = new LR, this.ditheredBlurMaterial = new LR, this.ditheredBlurMaterial.uniforms.scale = this.blurMaterial.uniforms.scale, this.ditheredBlurMaterial.dithering = !0, this.dithering = !1, this.kernelSize = r;
    }
    getResolution() {
        return this.resolution;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get scale() {
        return this.blurMaterial.scale;
    }
    set scale(n1) {
        this.blurMaterial.scale = n1;
    }
    getScale() {
        return this.blurMaterial.scale;
    }
    setScale(n1) {
        this.blurMaterial.scale = n1;
    }
    getKernelSize() {
        return this.kernelSize;
    }
    setKernelSize(n1) {
        this.kernelSize = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s = this.scene, o = this.camera, a = this.renderTargetA, l = this.renderTargetB, u = kX[this.kernelSize], c = this.blurMaterial, d = t, h, f;
        for(this.fullscreenMaterial = c, h = 0, f = u.length - 1; h < f; ++h){
            let p = (h & 1) === 0 ? a : l;
            c.kernel = u[h], c.inputBuffer = d.texture, n1.setRenderTarget(p), n1.render(s, o), d = p;
        }
        this.dithering && (c = this.ditheredBlurMaterial, this.fullscreenMaterial = c), c.kernel = u[h], c.inputBuffer = d.texture, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(s, o);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height;
        this.renderTargetA.setSize(r, i), this.renderTargetB.setSize(r, i), this.blurMaterial.setSize(r, i), this.ditheredBlurMaterial.setSize(r, i);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTargetA.texture.type = e, this.renderTargetB.texture.type = e, e !== br ? (this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1", this.ditheredBlurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1") : n1.outputEncoding === tt && (this.renderTargetA.texture.encoding = tt, this.renderTargetB.texture.encoding = tt));
    }
    static get AUTO_SIZE() {
        return Nn.AUTO_SIZE;
    }
};
var zX = class extends hi {
    constructor({ width: n1 = Nn.AUTO_SIZE, height: t = Nn.AUTO_SIZE, renderTarget: e, luminanceRange: r, colorOutput: i } = {}){
        super("LuminancePass"), this.fullscreenMaterial = new lX(i, r), this.needsSwap = !1, this.renderTarget = e, this.renderTarget === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "LuminancePass.Target", this.renderTarget.texture.generateMipmaps = !1);
        let s = this.resolution = new Nn(this, n1, t);
        s.addEventListener("change", (o)=>this.setSize(s.baseWidth, s.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    render(n1, t, e, r, i) {
        let s = this.fullscreenMaterial;
        s.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== br && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, GR = class extends hi {
    constructor(n1, t){
        super("MaskPass", n1, t), this.needsSwap = !1, this.clearPass = new x_(!1, !1, !0), this.inverse = !1;
    }
    get inverted() {
        return this.inverse;
    }
    set inverted(n1) {
        this.inverse = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    render(n1, t, e, r, i) {
        let s = n1.getContext(), o = n1.state.buffers, a = this.scene, l = this.camera, u = this.clearPass, c = this.inverted ? 0 : 1, d = 1 - c;
        o.color.setMask(!1), o.depth.setMask(!1), o.color.setLocked(!0), o.depth.setLocked(!0), o.stencil.setTest(!0), o.stencil.setOp(s.REPLACE, s.REPLACE, s.REPLACE), o.stencil.setFunc(s.ALWAYS, c, 4294967295), o.stencil.setClear(d), o.stencil.setLocked(!0), this.clearPass.enabled && (this.renderToScreen ? u.render(n1, null) : (u.render(n1, t), u.render(n1, e))), this.renderToScreen ? (n1.setRenderTarget(null), n1.render(a, l)) : (n1.setRenderTarget(t), n1.render(a, l), n1.setRenderTarget(e), n1.render(a, l)), o.color.setLocked(!1), o.depth.setLocked(!1), o.stencil.setLocked(!1), o.stencil.setFunc(s.EQUAL, 1, 4294967295), o.stencil.setOp(s.KEEP, s.KEEP, s.KEEP), o.stencil.setLocked(!0);
    }
};
var Bn = class extends hi {
    constructor(n1, t = "inputBuffer"){
        super("ShaderPass"), this.fullscreenMaterial = n1, this.inputBufferUniform = null, this.setInput(t);
    }
    setInput(n1) {
        if (this.inputBufferUniform = null, this.fullscreenMaterial !== null) {
            let t = this.fullscreenMaterial.uniforms;
            t !== void 0 && t[n1] !== void 0 && (this.inputBufferUniform = t[n1]);
        }
    }
    render(n1, t, e, r, i) {
        this.inputBufferUniform !== null && t !== null && (this.inputBufferUniform.value = t.texture), n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== br && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, m_ = 0.001, VX = 1e3, jR = class {
    constructor(){
        this.previousTime = 0, this.currentTime = 0, this.delta = 0, this.fixedDelta = 1e3 / 60, this.elapsed = 0, this.timescale = 1, this.fixedDeltaEnabled = !1, this.autoReset = !1;
    }
    setFixedDeltaEnabled(n1) {
        return this.fixedDeltaEnabled = n1, this;
    }
    isAutoResetEnabled(n1) {
        return this.autoReset;
    }
    setAutoResetEnabled(n1) {
        return typeof document < "u" && document.hidden !== void 0 && (n1 ? document.addEventListener("visibilitychange", this) : document.removeEventListener("visibilitychange", this), this.autoReset = n1), this;
    }
    getDelta() {
        return this.delta * m_;
    }
    getFixedDelta() {
        return this.fixedDelta * m_;
    }
    setFixedDelta(n1) {
        return this.fixedDelta = n1 * VX, this;
    }
    getElapsed() {
        return this.elapsed * m_;
    }
    getTimescale() {
        return this.timescale;
    }
    setTimescale(n1) {
        return this.timescale = n1, this;
    }
    update(n1) {
        return this.fixedDeltaEnabled ? this.delta = this.fixedDelta : (this.previousTime = this.currentTime, this.currentTime = n1 !== void 0 ? n1 : performance.now(), this.delta = this.currentTime - this.previousTime), this.delta *= this.timescale, this.elapsed += this.delta, this;
    }
    reset() {
        return this.delta = 0, this.elapsed = 0, this.currentTime = performance.now(), this;
    }
    handleEvent(n1) {
        document.hidden || (this.currentTime = performance.now());
    }
    dispose() {
        this.setAutoResetEnabled(!1);
    }
};
var Lm = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
var UX = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=clamp(texture2D(map,uv)*intensity,0.0,1.0);}`, HR = class extends ko {
    constructor({ blendFunction: n1 = yt.SCREEN, luminanceThreshold: t = .9, luminanceSmoothing: e = .025, resolutionScale: r = .5, intensity: i = 1, width: s = Nn.AUTO_SIZE, height: o = Nn.AUTO_SIZE, kernelSize: a = Lm.LARGE } = {}){
        super("BloomEffect", UX, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "map",
                    new se(null)
                ],
                [
                    "intensity",
                    new se(i)
                ]
            ])
        }), this.renderTarget = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "Bloom.Target", this.renderTarget.texture.generateMipmaps = !1, this.uniforms.get("map").value = this.renderTarget.texture, this.luminancePass = new zX({
            renderTarget: this.renderTarget,
            colorOutput: !0
        }), this.luminanceMaterial.threshold = t, this.luminanceMaterial.smoothingFactor = e, this.blurPass = new ux({
            resolutionScale: r,
            width: s,
            height: o,
            kernelSize: a
        });
        let l = this.blurPass.getResolution();
        l.addEventListener("change", (u)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    get resolution() {
        return this.blurPass.resolution;
    }
    getResolution() {
        return this.blurPass.resolution;
    }
    getBlurPass() {
        return this.blurPass;
    }
    getLuminancePass() {
        return this.luminancePass;
    }
    get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(n1) {
        this.blurPass.dithering = n1;
    }
    get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(n1) {
        this.blurPass.kernelSize = n1;
    }
    get distinction() {
        return console.warn(this.name, "distinction was removed"), 1;
    }
    set distinction(n1) {
        console.warn(this.name, "distinction was removed");
    }
    get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(n1) {
        this.uniforms.get("intensity").value = n1;
    }
    getIntensity() {
        return this.intensity;
    }
    setIntensity(n1) {
        this.intensity = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    update(n1, t, e) {
        let r = this.renderTarget;
        this.luminancePass.enabled ? (this.luminancePass.render(n1, t, r), this.blurPass.render(n1, r, r)) : this.blurPass.render(n1, t, r);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height), this.luminancePass.resolution.copy(e);
    }
    initialize(n1, t, e) {
        this.blurPass.initialize(n1, t, e), e !== void 0 && (this.renderTarget.texture.type = e, n1.outputEncoding === tt && (this.renderTarget.texture.encoding = tt));
    }
};
var GX = "uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(min(color+vec3(0.5),1.0),inputColor.a);}", WR = class extends ko {
    constructor({ blendFunction: n1 = yt.NORMAL, brightness: t = 0, contrast: e = 0 } = {}){
        super("BrightnessContrastEffect", GX, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "brightness",
                    new se(t)
                ],
                [
                    "contrast",
                    new se(e)
                ]
            ])
        });
    }
    get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(n1) {
        this.uniforms.get("brightness").value = n1;
    }
    getBrightness(n1) {
        return this.brightness;
    }
    setBrightness(n1) {
        this.brightness = n1;
    }
    get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(n1) {
        this.uniforms.get("contrast").value = n1;
    }
    getContrast(n1) {
        return this.contrast;
    }
    setContrast(n1) {
        this.contrast = n1;
    }
}, jX = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}", qR = class extends ko {
    constructor(n1 = yt.NORMAL){
        super("ColorAverageEffect", jX, {
            blendFunction: n1
        });
    }
};
var HX = "varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=texture2D(inputBuffer,vUvR).ra;vec2 ba=texture2D(inputBuffer,vUvB).ba;outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}", WX = "uniform vec2 offset;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vUvR=uv+shift;vUvB=uv-shift;}", YR = class extends ko {
    constructor({ blendFunction: n1 = yt.NORMAL, offset: t = new N(.001, 5e-4) } = {}){
        super("ChromaticAberrationEffect", HX, {
            vertexShader: WX,
            blendFunction: n1,
            attributes: Fo.CONVOLUTION,
            uniforms: new Map([
                [
                    "offset",
                    new se(t)
                ]
            ])
        });
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
};
var qX = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;
#else
uniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;
#endif
uniform lowp sampler2D nearCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);float CoCNear=texture2D(nearCoCBuffer,uv).r;CoCNear=min(CoCNear*scale,1.0);vec4 result=inputColor*(1.0-colorFar.a)+colorFar;result=mix(result,colorNear,CoCNear);outputColor=result;}`, XR = class extends ko {
    constructor(n1, { blendFunction: t = yt.NORMAL, worldFocusDistance: e, worldFocusRange: r, focusDistance: i = 0, focalLength: s = .1, focusRange: o = s, bokehScale: a = 1, width: l = Nn.AUTO_SIZE, height: u = Nn.AUTO_SIZE } = {}){
        super("DepthOfFieldEffect", qX, {
            blendFunction: t,
            attributes: Fo.DEPTH,
            uniforms: new Map([
                [
                    "nearColorBuffer",
                    new se(null)
                ],
                [
                    "farColorBuffer",
                    new se(null)
                ],
                [
                    "nearCoCBuffer",
                    new se(null)
                ],
                [
                    "scale",
                    new se(1)
                ]
            ])
        }), this.camera = n1, this.renderTarget = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "DoF.Intermediate", this.renderTarget.texture.generateMipmaps = !1, this.renderTargetMasked = this.renderTarget.clone(), this.renderTargetMasked.texture.name = "DoF.Masked.Far", this.renderTargetNear = this.renderTarget.clone(), this.renderTargetNear.texture.name = "DoF.Bokeh.Near", this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture, this.renderTargetFar = this.renderTarget.clone(), this.renderTargetFar.texture.name = "DoF.Bokeh.Far", this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture, this.renderTargetCoC = this.renderTarget.clone(), this.renderTargetCoC.texture.name = "DoF.CoC", this.renderTargetCoCBlurred = this.renderTargetCoC.clone(), this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred", this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture, this.cocPass = new Bn(new K7(n1));
        let c = this.cocMaterial;
        c.focusDistance = i, c.focusRange = o, e !== void 0 && (c.worldFocusDistance = e), r !== void 0 && (c.worldFocusRange = r), this.blurPass = new ux({
            kernelSize: Lm.MEDIUM,
            width: l,
            height: u
        });
        let d = this.blurPass.getResolution();
        d.addEventListener("change", (f)=>this.setSize(d.getBaseWidth(), d.getBaseHeight())), this.maskPass = new Bn(new uX(this.renderTargetCoC.texture));
        let h = this.maskPass.fullscreenMaterial;
        h.maskFunction = VR.MULTIPLY, h.colorChannel = zR.GREEN, this.bokehNearBasePass = new Bn(new lx(!1, !0)), this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehNearFillPass = new Bn(new lx(!0, !0)), this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehFarBasePass = new Bn(new lx(!1, !1)), this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.bokehFarFillPass = new Bn(new lx(!0, !1)), this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.target = null, this.bokehScale = a;
    }
    get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    getCircleOfConfusionMaterial() {
        return this.circleOfConfusionMaterial;
    }
    getBlurPass() {
        return this.blurPass;
    }
    get resolution() {
        return this.blurPass.getResolution();
    }
    getResolution() {
        return this.blurPass.getResolution();
    }
    get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(n1) {
        let t = [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        for (let e of t)e.fullscreenMaterial.setScale(n1);
        this.maskPass.fullscreenMaterial.setStrength(n1), this.uniforms.get("scale").value = n1;
    }
    getBokehScale() {
        return this.bokehScale;
    }
    setBokehScale(n1) {
        this.bokehScale = n1;
    }
    getTarget() {
        return this.target;
    }
    setTarget(n1) {
        this.target = n1;
    }
    calculateFocusDistance(n1) {
        let t = this.camera, e = t.position.distanceTo(n1);
        return y_(-e, t.near, t.far);
    }
    setDepthTexture(n1, t = Ii) {
        this.circleOfConfusionMaterial.depthBuffer = n1, this.circleOfConfusionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        let r = this.renderTarget, i = this.renderTargetCoC, s = this.renderTargetCoCBlurred, o = this.renderTargetMasked;
        if (this.target !== null) {
            let a = this.calculateFocusDistance(this.target);
            this.circleOfConfusionMaterial.focusDistance = a;
        }
        this.cocPass.render(n1, null, i), this.blurPass.render(n1, i, s), this.maskPass.render(n1, t, o), this.bokehFarBasePass.render(n1, o, r), this.bokehFarFillPass.render(n1, r, this.renderTargetFar), this.bokehNearBasePass.render(n1, t, r), this.bokehNearFillPass.render(n1, r, this.renderTargetNear);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height, s = [
            this.cocPass,
            this.blurPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        s.push(this.renderTargetCoC, this.renderTargetMasked), s.forEach((a)=>a.setSize(n1, t)), s = [
            this.renderTarget,
            this.renderTargetNear,
            this.renderTargetFar,
            this.renderTargetCoCBlurred
        ], s.forEach((a)=>a.setSize(r, i)), [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((a)=>a.fullscreenMaterial.setSize(r, i));
    }
    initialize(n1, t, e) {
        [
            this.cocPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((i)=>i.initialize(n1, t, e)), this.blurPass.initialize(n1, t, br), e !== void 0 && (this.renderTarget.texture.type = e, this.renderTargetNear.texture.type = e, this.renderTargetFar.texture.type = e, this.renderTargetMasked.texture.type = e, n1.outputEncoding === tt && (this.renderTarget.texture.encoding = tt, this.renderTargetNear.texture.encoding = tt, this.renderTargetFar.texture.encoding = tt, this.renderTargetMasked.texture.encoding = tt));
    }
};
var w2e = new _, A2e = new te;
var YX = "uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}", QR = class extends ko {
    constructor({ blendFunction: n1 = yt.NORMAL, hue: t = 0, saturation: e = 0 } = {}){
        super("HueSaturationEffect", YX, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "hue",
                    new se(new _)
                ],
                [
                    "saturation",
                    new se(e)
                ]
            ])
        }), this.hue = t;
    }
    get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(n1) {
        this.uniforms.get("saturation").value = n1;
    }
    getSaturation() {
        return this.saturation;
    }
    setSaturation(n1) {
        this.saturation = n1;
    }
    get hue() {
        let n1 = this.uniforms.get("hue").value;
        return Math.acos((n1.x * 3 - 1) / 2);
    }
    set hue(n1) {
        let t = Math.sin(n1), e = Math.cos(n1);
        this.uniforms.get("hue").value.set((2 * e + 1) / 3, (-Math.sqrt(3) * t - e + 1) / 3, (Math.sqrt(3) * t - e + 1) / 3);
    }
    getHue() {
        return this.hue;
    }
    setHue(n1) {
        this.hue = n1;
    }
};
var T2e = new Le;
var XX = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*time));
#ifdef PREMULTIPLY
outputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);
#else
outputColor=vec4(noise,inputColor.a);
#endif
}`, KR = class extends ko {
    constructor({ blendFunction: n1 = yt.SCREEN, premultiply: t = !1 } = {}){
        super("NoiseEffect", XX, {
            blendFunction: n1
        }), this.premultiply = t;
    }
    get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(n1) {
        this.premultiply !== n1 && (n1 ? this.defines.set("PREMULTIPLY", "1") : this.defines.delete("PREMULTIPLY"), this.setChanged());
    }
    isPremultiplied() {
        return this.premultiply;
    }
    setPremultiplied(n1) {
        this.premultiply = n1;
    }
};
var QX = "uniform bool active;uniform vec2 d;void mainUv(inout vec2 uv){if(active){uv=vec2(d.x*(floor(uv.x/d.x)+0.5),d.y*(floor(uv.y/d.y)+0.5));}}", ZR = class extends ko {
    constructor(n1 = 30){
        super("PixelationEffect", QX, {
            uniforms: new Map([
                [
                    "active",
                    new se(!1)
                ],
                [
                    "d",
                    new se(new N)
                ]
            ])
        }), this.resolution = new N, this.d = 0, this.granularity = n1;
    }
    get granularity() {
        return this.d;
    }
    set granularity(n1) {
        let t = Math.floor(n1);
        t % 2 > 0 && (t += 1), this.d = t, this.uniforms.get("active").value = t > 0, this.setSize(this.resolution.width, this.resolution.height);
    }
    getGranularity() {
        return this.granularity;
    }
    setGranularity(n1) {
        this.granularity = n1;
    }
    setSize(n1, t) {
        this.resolution.set(n1, t), this.uniforms.get("d").value.setScalar(this.d).divide(this.resolution);
    }
};
var P2e = Math.PI * .5, D2e = new _, O2e = new _;
var FR = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC", kR = "data:image/png;base64,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", KX = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}", ZX = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}", Ia = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
}, dx = class extends ko {
    constructor({ preset: n1 = Ia.MEDIUM, edgeDetectionMode: t = af.COLOR, predicationMode: e = iX.DISABLED } = {}){
        super("SMAAEffect", KX, {
            vertexShader: ZX,
            blendFunction: yt.NORMAL,
            attributes: Fo.CONVOLUTION | Fo.DEPTH,
            uniforms: new Map([
                [
                    "weightMap",
                    new se(null)
                ]
            ])
        });
        let r, i;
        arguments.length > 1 && (r = arguments[0], i = arguments[1], arguments.length > 2 && (n1 = arguments[2]), arguments.length > 3 && (t = arguments[3])), this.renderTargetEdges = new at(1, 1, {
            minFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetEdges.texture.name = "SMAA.Edges", this.renderTargetWeights = this.renderTargetEdges.clone(), this.renderTargetWeights.texture.name = "SMAA.Weights", this.uniforms.get("weightMap").value = this.renderTargetWeights.texture, this.clearPass = new x_(!0, !1, !1), this.clearPass.overrideClearColor = new Le(0), this.clearPass.overrideClearAlpha = 1, this.edgeDetectionPass = new Bn(new nX), this.edgeDetectionMaterial.edgeDetectionMode = t, this.edgeDetectionMaterial.predicationMode = e, this.weightsPass = new Bn(new fX);
        let s = new xp;
        s.onLoad = ()=>{
            let o = new qt(r);
            o.name = "SMAA.Search", o.magFilter = Et, o.minFilter = Et, o.generateMipmaps = !1, o.needsUpdate = !0, o.flipY = !0, this.weightsMaterial.searchTexture = o;
            let a = new qt(i);
            a.name = "SMAA.Area", a.magFilter = Qe, a.minFilter = Qe, a.generateMipmaps = !1, a.needsUpdate = !0, a.flipY = !1, this.weightsMaterial.areaTexture = a, this.dispatchEvent({
                type: "load"
            });
        }, s.itemStart("search"), s.itemStart("area"), r !== void 0 && i !== void 0 ? (s.itemEnd("search"), s.itemEnd("area")) : typeof Image < "u" && (r = new Image, i = new Image, r.addEventListener("load", ()=>s.itemEnd("search")), i.addEventListener("load", ()=>s.itemEnd("area")), r.src = FR, i.src = kR), this.applyPreset(n1);
    }
    get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    getEdgesTexture() {
        return this.edgesTexture;
    }
    get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    getWeightsTexture() {
        return this.weightsTexture;
    }
    get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    getWeightsMaterial() {
        return this.weightsMaterial;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = n1;
    }
    setOrthogonalSearchSteps(n1) {
        this.weightsMaterial.orthogonalSearchSteps = n1;
    }
    applyPreset(n1) {
        let t = this.edgeDetectionMaterial, e = this.weightsMaterial;
        switch(n1){
            case Ia.LOW:
                t.edgeDetectionThreshold = .15, e.orthogonalSearchSteps = 4, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case Ia.MEDIUM:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 8, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case Ia.HIGH:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 16, e.diagonalSearchSteps = 8, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
            case Ia.ULTRA:
                t.edgeDetectionThreshold = .05, e.orthogonalSearchSteps = 32, e.diagonalSearchSteps = 16, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
        }
    }
    setDepthTexture(n1, t = Ii) {
        this.edgeDetectionMaterial.depthBuffer = n1, this.edgeDetectionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        this.clearPass.render(n1, this.renderTargetEdges), this.edgeDetectionPass.render(n1, t, this.renderTargetEdges), this.weightsPass.render(n1, this.renderTargetEdges, this.renderTargetWeights);
    }
    setSize(n1, t) {
        this.edgeDetectionMaterial.setSize(n1, t), this.weightsMaterial.setSize(n1, t), this.renderTargetEdges.setSize(n1, t), this.renderTargetWeights.setSize(n1, t);
    }
    dispose() {
        let { searchTexture: n1, areaTexture: t } = this.weightsMaterial;
        n1 !== null && t !== null && (n1.dispose(), t.dispose()), super.dispose();
    }
    static get searchImageDataURL() {
        return FR;
    }
    static get areaImageDataURL() {
        return kR;
    }
};
var JX = `uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;
#if VIGNETTE_TECHNIQUE == 0
float d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));
#else
vec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));
#endif
outputColor=vec4(color,inputColor.a);}`, cx = {
    DEFAULT: 0,
    ESKIL: 1
}, JR = class extends ko {
    constructor({ blendFunction: n1 = yt.NORMAL, technique: t = cx.DEFAULT, eskil: e = !1, offset: r = .5, darkness: i = .5 } = {}){
        super("VignetteEffect", JX, {
            blendFunction: n1,
            defines: new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    t.toFixed(0)
                ]
            ]),
            uniforms: new Map([
                [
                    "offset",
                    new se(r)
                ],
                [
                    "darkness",
                    new se(i)
                ]
            ])
        });
    }
    get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(n1) {
        this.technique !== n1 && (this.defines.set("VIGNETTE_TECHNIQUE", n1.toFixed(0)), this.setChanged());
    }
    get eskil() {
        return this.technique === cx.ESKIL;
    }
    set eskil(n1) {
        this.technique = n1 ? cx.ESKIL : cx.DEFAULT;
    }
    getTechnique() {
        return this.technique;
    }
    setTechnique(n1) {
        this.technique = n1;
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
    get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(n1) {
        this.uniforms.get("darkness").value = n1;
    }
    getDarkness() {
        return this.darkness;
    }
    setDarkness(n1) {
        this.darkness = n1;
    }
}, L2e = [
    new Float32Array(3),
    new Float32Array(3)
], B2e = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
], N2e = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
var F2e = [
    new Float32Array(2),
    new Float32Array(2)
];
var k2e = new Float32Array([
    0,
    -0.25,
    .25,
    -0.125,
    .125,
    -0.375,
    .375
]), z2e = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        .25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        .25
    ]),
    new Float32Array([
        .125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        .125
    ])
], V2e = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
], U2e = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
var G2e = new Map([
    [
        on(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        on(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        on(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        on(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        on(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        on(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        on(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        on(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        on(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        on(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        on(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        on(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        on(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        on(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        on(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        on(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function g_(n1, t, e) {
    return n1 + (t - n1) * e;
}
function on(n1, t, e, r) {
    let i = g_(n1, t, .75), s = g_(e, r, 0.75);
    return g_(i, s, 0.875);
}
var Zr = class {
    constructor(t, e){
        this.enabled = !1;
        this.effect = new t(e), Object.defineProperty(this, "opacity", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.opacity.value = r;
            },
            get () {
                return this.effect.blendMode.opacity.value;
            }
        }), Object.defineProperty(this, "blendFunction", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.setBlendFunction(Number(r));
            },
            get () {
                return this.effect.blendMode.blendFunction;
            }
        }), this.blendFunction = yt.NORMAL;
    }
};
var lf = class extends Zr {
    constructor(){
        super(HR), this.blendFunction = yt.SCREEN;
    }
    set intensity(t) {
        this.effect.intensity = t;
    }
    get intensity() {
        return this.effect.intensity;
    }
    set luminanceThreshold(t) {
        this.effect.luminanceMaterial.threshold = t;
    }
    get luminanceThreshold() {
        return this.effect.luminanceMaterial.threshold;
    }
    set luminanceSmoothing(t) {
        this.effect.luminanceMaterial.smoothing = t;
    }
    get luminanceSmoothing() {
        return this.effect.luminanceMaterial.smoothing;
    }
    set blurScale(t) {
        this.effect.blurPass.scale = t;
    }
    get blurScale() {
        return this.effect.blurPass.scale;
    }
    set kernelSize(t) {
        this.effect.blurPass.kernelSize = t;
    }
    get kernelSize() {
        return this.effect.blurPass.kernelSize;
    }
};
var cf = class extends Zr {
    constructor(){
        super(WR);
    }
    set contrast(t) {
        this.effect.uniforms.get("contrast").value = t;
    }
    get contrast() {
        return this.effect.uniforms.get("contrast").value;
    }
    set brightness(t) {
        this.effect.uniforms.get("brightness").value = t;
    }
    get brightness() {
        return this.effect.uniforms.get("brightness").value;
    }
};
var uf = class extends Zr {
    constructor(){
        super(YR), this.effect.offset = new N(.01, .01);
    }
    set offset(t) {
        this.effect.offset.set(t[0] / 1e3, t[1] / 1e3);
    }
    get offset() {
        return [
            this.effect.offset.x * 1e3,
            this.effect.offset.y * 1e3
        ];
    }
};
var df = class extends Zr {
    constructor(){
        super(qR);
    }
};
var hf = class extends Zr {
    constructor(){
        super(QR);
        this._hue = 0;
    }
    set hue(e) {
        this._hue = e, this.effect.setHue(e);
    }
    get hue() {
        return this._hue;
    }
    set saturation(e) {
        this.effect.uniforms.get("saturation").value = e;
    }
    get saturation() {
        return this.effect.uniforms.get("saturation").value;
    }
};
var ff = class extends Zr {
    constructor(){
        super(KR), this.blendFunction = yt.OVERLAY;
    }
};
var pf = class extends Zr {
    constructor(){
        super(JR);
    }
    get eskil() {
        return this.effect.eskil;
    }
    set eskil(t) {
        this.effect.eskil = t;
    }
    get darkness() {
        return this.effect.uniforms.get("darkness").value;
    }
    set darkness(t) {
        this.effect.uniforms.get("darkness").value = t;
    }
    get offset() {
        return this.effect.uniforms.get("offset").value;
    }
    set offset(t) {
        this.effect.uniforms.get("offset").value = t;
    }
};
var mf = class extends Zr {
    constructor(t){
        super(XR, t);
    }
    set focalLength(t) {
        this.effect.circleOfConfusionMaterial.uniforms.focalLength.value = t;
    }
    get focalLength() {
        return this.effect.circleOfConfusionMaterial.uniforms.focalLength.value;
    }
    set focusDistance(t) {
        this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value = t;
    }
    get focusDistance() {
        return this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value;
    }
    get bokehScale() {
        return this.effect.bokehScale;
    }
    set bokehScale(t) {
        this.effect.bokehScale = t;
    }
};
var gf = class extends Zr {
    constructor(){
        super(ZR);
    }
    get granularity() {
        return this.effect.getGranularity();
    }
    set granularity(t) {
        this.effect.setGranularity(t);
    }
};
var $R = `#define GLSLIFY 1
varying vec2 vUv;varying vec2 vTexCoords[9];uniform vec2 resolution;void main(){vUv=position.xy*0.5+0.5;vec2 texelSize=vec2(1.0)/resolution;vTexCoords[0]=vUv+vec2(-texelSize.x,-texelSize.y);vTexCoords[1]=vUv+vec2(0.0,-texelSize.y);vTexCoords[2]=vUv+vec2(texelSize.x,-texelSize.y);vTexCoords[3]=vUv+vec2(-texelSize.x,0.0);vTexCoords[4]=vUv+vec2(0.0,0.0);vTexCoords[5]=vUv+vec2(texelSize.x,0.0);vTexCoords[6]=vUv+vec2(-texelSize.x,texelSize.y);vTexCoords[7]=vUv+vec2(0.0,texelSize.y);vTexCoords[8]=vUv+vec2(texelSize.x,texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
var e3 = `#define GLSLIFY 1
#include <common>
varying vec2 vUv;varying vec2 vTexCoords[9];uniform sampler2D inputBuffer;uniform sampler2D historyBuffer;uniform sampler2D velocityBuffer;uniform sampler2D depthBuffer;uniform vec2 resolution;
#define USE_YCOCG
#define USE_CATMULL_ROM
const float feedback_min=0.5;const float feedback_max=0.95;vec3 RGB_YCoCg(vec3 c){return vec3(c.x/4.0+c.y/2.0+c.z/4.0,c.x/2.0-c.z/2.0,-c.x/4.0+c.y/2.0-c.z/4.0);}vec3 YCoCg_RGB(vec3 c){return clamp(vec3(c.x+c.y-c.z,c.x+c.z,c.x-c.y-c.z),vec3(0.0),vec3(1.0));}vec4 sample_color(sampler2D tex,vec2 uv){
#ifdef USE_YCOCG
vec4 c=texture(tex,uv);return vec4(RGB_YCoCg(c.rgb),c.a);
#else
return texture(tex,uv);
#endif
}vec4 sample_catmull_rom(sampler2D tex,vec2 uv,vec2 texSize){vec2 samplePos=uv*texSize;vec2 texPos1=floor(samplePos-0.5)+0.5;vec2 f=samplePos-texPos1;vec2 w0=f*(-0.5+f*(1.0-0.5*f));vec2 w1=1.0+f*f*(-2.5+1.5*f);vec2 w2=f*(0.5+f*(2.0-1.5*f));vec2 w3=f*f*(-0.5+0.5*f);vec2 w12=w1+w2;vec2 offset12=w2/(w1+w2);vec2 texPos0=texPos1-1.0;vec2 texPos3=texPos1+2.0;vec2 texPos12=texPos1+offset12;texPos0/=texSize;texPos3/=texSize;texPos12/=texSize;vec4 result=vec4(0.0);result+=texture2D(tex,vec2(texPos12.x,texPos0.y))*w12.x*w0.y;result+=texture2D(tex,vec2(texPos0.x,texPos12.y))*w0.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos12.y))*w12.x*w12.y;result+=texture2D(tex,vec2(texPos3.x,texPos12.y))*w3.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos3.y))*w12.x*w3.y;return result;}vec3 choose_motion_vector(){
#ifdef CHOOSE_LONGEST_MOTION_VECTOR
float longest=-1.0;vec3 v_choose=vec3(-1.0);for(int i=0;i<9;i++){vec3 v=texture2D(velocityBuffer,vTexCoords[i]).rgb;float l=length(v.xy);if(l>longest){longest=l;v_choose=v;}}return v_choose;
#else
float closest_depth=1000.0;vec2 closest_uv_offset=vec2(0.0);for(int i=0;i<9;i++){float neighbor_depth=texture2D(depthBuffer,vTexCoords[i]).r;if(neighbor_depth<closest_depth){closest_uv_offset=vTexCoords[i];closest_depth=neighbor_depth;}}return texture2D(velocityBuffer,closest_uv_offset).rgb;
#endif
}vec4 clipAabb(vec3 aabb_min,vec3 aabb_max,vec4 avg,vec4 input_texel){const float FLT_EPS=0.00000001;vec3 p_clip=0.5*(aabb_max+aabb_min);vec3 e_clip=0.5*(aabb_max-aabb_min)+FLT_EPS;vec4 v_clip=input_texel-vec4(p_clip,avg.w);vec3 v_unit=v_clip.xyz/e_clip;vec3 a_unit=abs(v_unit);float ma_unit=max(a_unit.x,max(a_unit.y,a_unit.z));if(ma_unit>1.0){return vec4(p_clip,avg.w)+v_clip/ma_unit;}else{return input_texel;}}vec3 clip_aabb_variance(in vec3 cOld,in vec3 cNew,in vec3 centre,in vec3 halfSize){if(all(lessThanEqual(abs(cOld-centre),halfSize))){return cOld;}vec3 dir=(cNew-cOld);vec3 near=centre-sign(dir)*halfSize;vec3 tAll=(near-cOld)/dir;float t=0.0001;for(int i=0;i<3;i++){if(tAll[i]>=0.0&&tAll[i]<t){t=tAll[i];}}if(t>=0.0001){return cOld;}return cOld+dir*t;}void main(){vec3 v=choose_motion_vector();vec2 velocity=v.rg;vec2 previousPixelPos=vUv-velocity;vec4 currentColor=sample_color(inputBuffer,vUv);
#ifdef USE_CATMULL_ROM
vec4 previousColor=sample_catmull_rom(historyBuffer,previousPixelPos,resolution);
#else
vec4 previousColor=sample_color(historyBuffer,previousPixelPos);
#endif
#ifdef USE_YCOCG
previousColor=vec4(RGB_YCoCg(previousColor.rgb),previousColor.a);
#endif
vec4 ctl=sample_color(inputBuffer,vTexCoords[0]);vec4 ctc=sample_color(inputBuffer,vTexCoords[1]);vec4 ctr=sample_color(inputBuffer,vTexCoords[2]);vec4 cml=sample_color(inputBuffer,vTexCoords[3]);vec4 cmc=sample_color(inputBuffer,vTexCoords[4]);vec4 cmr=sample_color(inputBuffer,vTexCoords[5]);vec4 cbl=sample_color(inputBuffer,vTexCoords[6]);vec4 cbc=sample_color(inputBuffer,vTexCoords[7]);vec4 cbr=sample_color(inputBuffer,vTexCoords[8]);vec4 cmin=min(ctl,min(ctc,min(ctr,min(cml,min(cmc,min(cmr,min(cbl,min(cbc,cbr))))))));vec4 cmax=max(ctl,max(ctc,max(ctr,max(cml,max(cmc,max(cmr,max(cbl,max(cbc,cbr))))))));vec4 cavg=(ctl+ctc+ctr+cml+cmc+cmr+cbl+cbc+cbr)/9.0;vec4 cmin5=min(ctc,min(cml,min(cmc,min(cmr,cbc))));vec4 cmax5=max(ctc,max(cml,max(cmc,max(cmr,cbc))));vec4 cavg5=(ctc+cml+cmc+cmr+cbc)/5.0;cmin=0.5*(cmin+cmin5);cmax=0.5*(cmax+cmax5);cavg=0.5*(cavg+cavg5);
#ifdef USE_YCOCG
vec2 chroma_extent=vec2(0.25*0.5*(cmax.r-cmin.r));vec2 chroma_center=currentColor.gb;cmin.yz=chroma_center-chroma_extent;cmax.yz=chroma_center+chroma_extent;cavg.yz=chroma_center;
#endif
vec4 previousColorClipped=clamp(previousColor,cmin,cmax);
#ifdef LUMINANCE_DIFFERENCES
#ifdef USE_YCOCG
float lum0=currentColor.r;float lum1=previousColorClipped.r;
#else
float lum0=luminance(currentColor.rgb);float lum1=luminance(previousColorClipped.rgb);
#endif
float unbiased_diff=abs(lum0-lum1)/max(lum0,max(lum1,0.2));float unbiased_weight=1.0-unbiased_diff;float unbiased_weight_sqr=unbiased_weight*unbiased_weight;float k_feedback=mix(feedback_min,feedback_max,unbiased_weight_sqr);vec4 result=mix(currentColor,previousColorClipped,vec4(k_feedback));
#else
const float alpha=0.1;vec4 result=mix(currentColor,previousColorClipped,1.0-alpha);
#endif
#ifdef USE_YCOCG
gl_FragColor=vec4(YCoCg_RGB(result.rgb).rgb,result.a);
#else
gl_FragColor=result;
#endif
}`;
var t3 = `#define GLSLIFY 1
varying vec2 vUv;void main(){gl_Position=vec4(position.xy,1.0,1.0);vUv=position.xy*0.5+0.5;}`;
var r3 = `#define GLSLIFY 1
layout(location=1)out vec4 gVelocity;varying vec2 vUv;uniform sampler2D inputBuffer;void main(){gl_FragColor=texture2D(inputBuffer,vUv);gVelocity=vec4(0.0);}`;
var yf = class extends rt {
    constructor(){
        super({
            name: "PassthroughMaterial",
            uniforms: {
                inputBuffer: new se(null)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: t3,
            fragmentShader: r3
        });
    }
    set inputBuffer(t) {
        this.uniforms.inputBuffer.value = t;
    }
}, hx = class extends hi {
    constructor(){
        super("TAAResolvePass");
        this.MRTCompatible = !0;
        this.needsSwap = !1, this.passThroughMaterial = new yf, this.resolutionVector = new N, this.resolveMaterial = new rt({
            name: "TAAResolveMaterial",
            uniforms: {
                inputBuffer: new se(null),
                historyBuffer: new se(null),
                velocityBuffer: new se(null),
                depthBuffer: new se(null),
                resolution: new se(new N)
            },
            blending: Wt,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: $R,
            fragmentShader: e3
        }), this.historyRenderTarget = new at(1024, 1024, {
            minFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.historyRenderTarget.texture.name = "TAA.History", this.resultRenderTarget = new at(1024, 1024, {
            minFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.resultRenderTarget.texture.name = "TAA.Output";
    }
    setSize(e, r) {
        this.historyRenderTarget.setSize(e, r), this.resultRenderTarget.setSize(e, r);
    }
    render(e, r) {
        this.fullscreenMaterial = this.resolveMaterial, this.resolveMaterial.uniforms.inputBuffer.value = r.texture[0], this.resolveMaterial.uniforms.velocityBuffer.value = r.texture[1], this.resolveMaterial.uniforms.depthBuffer.value = r.depthTexture, this.resolveMaterial.uniforms.historyBuffer.value = this.historyRenderTarget.texture, this.resolveMaterial.uniforms.resolution.value.set(r.width, r.height), e.setRenderTarget(this.resultRenderTarget), e.render(this.scene, this.camera), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(this.historyRenderTarget), e.render(this.scene, this.camera);
        let i = this.renderToScreen ? null : r;
        this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(i), e.render(this.scene, this.camera);
    }
    dispose() {
        this.resultRenderTarget.dispose(), this.historyRenderTarget.dispose(), this.resolveMaterial.dispose(), this.passThroughMaterial.dispose();
    }
};
var fx = class extends hi {
    constructor(e, r, i){
        super("TransmissionPass", void 0, r);
        this.MRTCompatible = !0;
        this.depthPass = new b_(e, r, {
            renderTarget: i.transmissionDepthTarget
        }), this.passThroughMaterial = new yf, this.splineScene = e, this.needsSwap = !1;
    }
    updatePasses(e) {
        this.passThroughMaterial = new yf, this.depthPass = new b_(this.splineScene, this.camera, {
            renderTarget: e.transmissionDepthTarget
        });
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, r, i) {
        let s = this.camera.layers.mask, o = e;
        o.setRenderTarget(o.transmissionRenderTarget), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = r.texture[0], o.clear(), o.render(this.scene, this.camera), this.camera.layers.disable(3), this.depthPass.render(e, r, i), o.shadowMap.needsUpdate = !1, o.shadowMap.autoUpdate = !1;
        let a = this.renderToScreen ? null : r;
        this.camera.layers.set(3), e.setRenderTarget(a), e.render(this.splineScene, this.camera), this.camera.layers.mask = s;
    }
};
var i3 = new vi, nQ = new rt({
    transparent: !0,
    vertexShader: `
        void main() {
            gl_Position = vec4(0.0);
        }
    `,
    fragmentShader: `
        layout(location = 1) out vec4 gVelocity;

        void main() {
            gl_FragColor = vec4(0.0);
			gVelocity = vec4(0.0);
        }
    `
}), Kc = class extends hi {
    constructor(e, r, i){
        super("OpaquePass", r ?? i3, i);
        this.MRTCompatible = !0;
        this.hasTransmissionPass = !1;
        this.clear = !0;
        this.clearColorOnly = !1;
        this.clearDepth = !1;
        this.needsSwap = !1, this.originalMaterials = new Map, this.MRTCompatible = e;
    }
    set splatViewer(e) {
        this._splatViewer = e;
    }
    get splatViewer() {
        return this._splatViewer;
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.scene = e ?? i3;
    }
    getScene() {
        return this.scene;
    }
    render(e, r) {
        this.camera.layers.enable(3), this.hasTransmissionPass && (this.originalMaterials.clear(), this.scene.traverse((s)=>{
            s.layers.isEnabled(3) && s instanceof nr && (this.originalMaterials.set(s.id, s.material), s.material = nQ);
        }), e.shadowMap.needsUpdate = !0, e.shadowMap.autoUpdate = !0), this.camera.layers.enable(8);
        let i = this.renderToScreen ? null : r;
        if (e.setRenderTarget(i), this.clearColorOnly && e.clear(!0, !1, !0), this.clear && e.clear(), this._splatViewer?.splatRenderingInitialized === !0) {
            let s = e.autoClear;
            e.autoClear = !1, e.render(this.scene, this.camera), this._splatViewer.update(), e.render(this._splatViewer.splatMesh, this.camera), e.autoClear = s;
        } else e.render(this.scene, this.camera);
        this.clearDepth && e.clear(!1, !0, !1), this.hasTransmissionPass && this.originalMaterials.forEach((s, o)=>{
            let a = this.scene.getObjectById(o);
            a && (a.material = s);
        });
    }
};
var px = class {
    constructor(t, { depthBuffer: e = !0, stencilBuffer: r = !1, multisampling: i = 0, frameBufferType: s = 0 } = {}){
        this.renderer = t;
        this.helperStartIndex = 0;
        this.copyPass = new Rm;
        this.depthTexture = null;
        this.timer = new jR;
        this._width = 1;
        this._height = 1;
        this.passes = [];
        this.helperPasses = [];
        this.autoRenderToScreen = !0;
        this.inputBuffer = this.createBuffer(e, r, s, i, !0, "input buffer mrt"), this.inputBufferSingle = this.createBuffer(e, r, s, i, !1, " input buffer single"), this.inputBufferSingle.texture.dispose(), this.inputBufferSingle.depthTexture.dispose(), this.inputBufferSingle.texture = this.inputBuffer.texture[0], this.inputBufferSingle.depthTexture = this.inputBuffer.depthTexture, this.outputBuffer = this.inputBuffer.clone(), this.outputBuffer.name = "output buffer mrt", this.outputBufferSingle = this.createBuffer(e, r, s, i, !1, "output buffer single"), this.outputBufferSingle.texture.dispose(), this.outputBufferSingle.depthTexture.dispose(), this.outputBufferSingle.texture = this.outputBuffer.texture[0], this.outputBufferSingle.depthTexture = this.outputBuffer.depthTexture, this.setRenderer(t);
    }
    get multisampling() {
        return this.inputBuffer.samples || 0;
    }
    set multisampling(t) {
        let e = this.inputBuffer, r = this.multisampling;
        r > 0 && t > 0 ? (this.inputBuffer.samples = t, this.outputBuffer.samples = t, this.inputBuffer.dispose(), this.outputBuffer.dispose()) : r !== t && (this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("creating new input buffer"), this.inputBuffer = this.createBuffer(e.depthBuffer, e.stencilBuffer, e.texture.type, t, !0, "new input buffer"), this.inputBuffer.depthTexture = this.depthTexture, this.outputBuffer = this.inputBuffer.clone());
    }
    getTimer() {
        return this.timer;
    }
    getRenderer() {
        return this.renderer;
    }
    setRenderer(t) {
        if (this.renderer = t, t !== null) {
            let e = t.getSize(new N), r = t.getContext().getContextAttributes()?.alpha ?? !1, i = this.inputBuffer.texture[0].type;
            i === br && t.outputEncoding === tt && (this.inputBuffer.texture[0].encoding = tt, this.outputBuffer.texture[0].encoding = tt, this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("doing some kinda dispose??")), t.autoClear = !1, this.setSize(e.width, e.height, !1);
            for (let s of this.passes)s.initialize(t, r, i);
        }
    }
    replaceRenderer(t, e = !0) {
        let r = this.renderer, i = r.domElement.parentNode;
        return this.setRenderer(t), e && i !== null && (i.removeChild(r.domElement), i.appendChild(t.domElement)), r;
    }
    createDepthTexture() {
        let t = this.depthTexture = new is(this._width, this._height);
        return this.inputBuffer.depthTexture = t, this.inputBuffer.dispose(), this.inputBuffer.stencilBuffer ? (t.format = Ka, t.type = Ya) : t.type = Ds, t;
    }
    deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose(), this.depthTexture = null, this.inputBuffer.depthTexture = null, this.inputBuffer.dispose();
            for (let t of this.passes)t.setDepthTexture(null);
        }
    }
    createBuffer(t, e, r, i, s, o) {
        let a = this.renderer, l = a === null ? new N : a.getDrawingBufferSize(new N), u = {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut,
            stencilBuffer: e,
            depthBuffer: t
        }, c;
        return i > 0 ? (c = new at(l.width, l.height, u), c.samples = i) : (s ? (c = new sy(l.width, l.height, 2, u), c.texture[1].type = sa) : c = new at(l.width, l.height, u), c.depthTexture = new is(2048, 2048), c.depthTexture.type = dr), r === br && a !== null && a.outputEncoding === tt && (Array.isArray(c.texture) ? c.texture.forEach((d)=>d.encoding = tt) : c.texture.encoding = tt), Array.isArray(c.texture) ? c.texture.forEach((d, h)=>{
            d.name = `EffectComposer.Buffer ${s} ${h}`, d.generateMipmaps = !1;
        }) : (c.texture.name = `EffectComposer.Buffer ${s}`, c.texture.generateMipmaps = !1), c.name = o, c;
    }
    addPass(t, e) {
        let r = this.passes, i = this.renderer, s = i.getDrawingBufferSize(new N), o = i.getContext().getContextAttributes()?.alpha ?? !1, a;
        if (t.MRTCompatible && (a = this.inputBuffer.texture[0].type), t.MRTCompatible || (a = this.inputBuffer.texture.type), t.setRenderer(i), t.setSize(s.width, s.height), t.initialize(i, o, a), this.autoRenderToScreen && (r.length > 0 && (r[r.length - 1].renderToScreen = !1), t.renderToScreen && (this.autoRenderToScreen = !1)), e !== void 0 ? r.splice(e, 0, t) : r.push(t), this.autoRenderToScreen && (r[r.length - 1].renderToScreen = !0), t.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                let l = this.createDepthTexture();
                for (t of r)t.setDepthTexture(l);
            } else t.setDepthTexture(this.depthTexture);
        }
    }
    setHelperStartIndex(t) {
        this.helperStartIndex = t;
    }
    removePass(t) {
        let e = this.passes, r = e.indexOf(t);
        if (r !== -1 && e.splice(r, 1).length > 0) {
            if (this.depthTexture !== null) {
                let o = (l, u)=>l || u.needsDepthTexture;
                e.reduce(o, !1) || (t.getDepthTexture() === this.depthTexture && t.setDepthTexture(null), this.deleteDepthTexture());
            }
            this.autoRenderToScreen && r === e.length && (t.renderToScreen = !1, e.length > 0 && (e[e.length - 1].renderToScreen = !0));
        }
    }
    removeAllPasses() {
        let t = this.passes;
        this.deleteDepthTexture(), t.length > 0 && (this.autoRenderToScreen && (t[t.length - 1].renderToScreen = !1), this.passes = []);
    }
    render(t) {
        let e = this.renderer, r = this.copyPass, i = this.inputBuffer, s = this.outputBuffer, o = this.inputBufferSingle, a = this.outputBufferSingle, l = !1, u, c, d, h;
        t === void 0 && (t = this.timer.update().getDelta());
        for (let f of this.passes)f.enabled && (f.MRTCompatible ? f.render(e, i, s, t, l) : f.render(e, o, a, t, l), f.needsSwap && (l && (r.renderToScreen = f.renderToScreen, u = e.getContext(), c = e.state.buffers.stencil, c.setFunc(u.NOTEQUAL, 1, 4294967295), r.render(e, i, s, t, l), c.setFunc(u.EQUAL, 1, 4294967295)), d = i, h = o, i = s, o = a, s = d, a = h), f instanceof GR ? l = !0 : f instanceof UR && (l = !1));
    }
    setSize(t, e, r) {
        let i = this.renderer;
        if (this._width = t, this._height = e, t === void 0 || e === void 0) {
            let o = i.getSize(new N);
            t = o.width, e = o.height;
        }
        i.setSize(t, e, r);
        let s = i.getDrawingBufferSize(new N);
        this.inputBuffer.setSize(s.width, s.height), this.outputBuffer.setSize(s.width, s.height), this.inputBufferSingle.setSize(s.width, s.height), this.outputBufferSingle.setSize(s.width, s.height);
        for (let o of this.passes)o.setSize(s.width, s.height);
    }
    reset() {
        let t = this.timer.isAutoResetEnabled();
        this.dispose(), this.autoRenderToScreen = !0, this.timer.setAutoResetEnabled(t);
    }
    dispose() {
        for (let t of this.passes)t.dispose();
        this.passes = [], this.inputBuffer !== null && this.inputBuffer.dispose(), this.outputBuffer !== null && this.outputBuffer.dispose(), this.inputBufferSingle !== null && this.inputBufferSingle.dispose(), this.outputBufferSingle !== null && this.outputBufferSingle.dispose(), this.deleteDepthTexture(), this.copyPass.dispose(), this.timer.dispose();
    }
};
var sQ = new rt({
    name: "CombineMaterial",
    uniforms: {
        inputBufferA: new se(null),
        inputBufferB: new se(null)
    },
    blending: Wt,
    depthWrite: !1,
    depthTest: !1,
    vertexShader: `
varying vec2 vUv;
void main() {
    gl_Position = vec4(position.xy, 1.0, 1.0);
    vUv = position.xy * 0.5 + 0.5;
}
`,
    fragmentShader: `
    varying vec2 vUv;
    uniform sampler2D inputBufferA;
    uniform sampler2D inputBufferB;

    // TODO: Why do we need these when postpro of framemode is enabled???
    layout(location = 1) out vec4 gVelocity;

    void main() {
	vec4 resA = texture2D(inputBufferA, vUv);
	vec4 resB = texture2D(inputBufferB, vUv);
    float a = resA.a + resB.a * ( 1.0 - resA.a );

	vec4 res;
	res.rgb =  resA.rgb + (resB.rgb * (1.0 - resA.a));
	res.a = resA.a + resB.a * (1.0 - resA.a);
	gl_FragColor = res;
    gVelocity = vec4(0.0);
    }
`
}), mx = class extends hi {
    constructor(e){
        super("HelperPass", void 0, e);
        this.MRTCompatible = !1;
        this.fullscreenMaterial = sQ, this.helperPass = new Kc(!1, void 0, this.camera), this.helperPass.hasTransmissionPass = !1, this.helperPass.clear = !1, this.helperPass.renderToScreen = !1, this.helperPassOnTop = new Kc(!1, void 0, this.camera), this.helperPassOnTop.hasTransmissionPass = !1, this.helperPassOnTop.clear = !1, this.helperPassOnTop.renderToScreen = !1;
        let r = new dx({
            preset: Ia.LOW,
            edgeDetectionMode: af.COLOR
        });
        this.effectPass = new Qc(this.camera, r), this.rt = new at(10, 10, {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut,
            depthBuffer: !0
        });
    }
    setSize(e, r) {
        this.rt.setSize(e, r), this.effectPass.setSize(e, r);
    }
    set sceneHelpers(e) {
        this.helperPass.setScene(e);
    }
    get sceneHelpers() {
        return this.helperPass.getScene();
    }
    set sceneHelpersOnTop(e) {
        this.helperPassOnTop.setScene(e);
    }
    get sceneHelpersOnTop() {
        return this.helperPassOnTop.getScene();
    }
    setCamera(e) {
        this.helperPass.setCamera(e), this.helperPassOnTop.setCamera(e);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    dispose() {
        super.dispose(), this.rt.dispose(), this.effectPass.dispose();
    }
    render(e, r, i) {
        this.rt.depthTexture = r.depthTexture;
        let s = e.getClearAlpha();
        e.setClearAlpha(0), this.helperPass.clearDepth = !0, this.helperPass.clearColorOnly = !0, this.helperPass.render(e, this.rt), this.helperPassOnTop.render(e, this.rt), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.rt, i), this.fullscreenMaterial.uniforms.inputBufferA.value = i.texture, this.fullscreenMaterial.uniforms.inputBufferB.value = r.texture, e.setClearAlpha(s), e.setRenderTarget(null), e.clear(), e.render(this.scene, this.camera);
    }
};
var n3 = `#define GLSLIFY 1
#include <skinning_pars_vertex>
out vec3 n;void main(){
#include <beginnormal_vertex>
#include <skinbase_vertex>
#include <skinnormal_vertex>
#include <defaultnormal_vertex>
#include <begin_vertex>
#include <skinning_vertex>
vec4 view_space=viewMatrix*modelMatrix*vec4(transformed,1.0);gl_Position=projectionMatrix*view_space;n=normalize(transformedNormal);}`;
var s3 = `#define GLSLIFY 1
in vec3 n;void main(){gl_FragColor=vec4(n,1.0);}`;
var o3 = `#define GLSLIFY 1
out vec2 v_uv;void main(){v_uv=uv;gl_Position=vec4(position.xy,1.0,1.0);}`;
var a3 = `#define GLSLIFY 1
in vec2 v_uv;const float pi=3.14159265;const float num_steps=4.0;const float num_directions=4.0;uniform float near;uniform float far;uniform float fov;uniform vec4 proj_info;uniform bool is_ortho;uniform vec2 resolution;uniform float radius_of_influence;uniform float radius_in_screen_space;uniform float exponent;uniform vec3 ao_color;uniform float bias;uniform sampler2D texture_depth;uniform sampler2D texture_normals;uniform sampler2D texture_blue_noise;uniform sampler2D texture_blue_noise_in_disk;uniform sampler2D texture_color_pass;uniform int frame_index;uniform bool fog_enabled;uniform float fog_near;uniform float fog_far;vec3 uv_to_view_space(vec2 uv,float eye_z){return vec3((uv*proj_info.xy+proj_info.zw)*(is_ortho ? 1.0 : eye_z),eye_z);}float linearize_depth(float depth_sampled){float z=is_ortho ? depth_sampled : depth_sampled*2.0-1.0;return mix((2.0*near*far)/(far+near-z*(far-near)),near+z*(far-near),float(is_ortho));}vec3 get_view_position(vec2 uv_coords){float linear_depth=linearize_depth(texture(texture_depth,uv_coords).x);return uv_to_view_space(uv_coords,linear_depth);}vec3 min_difference(vec3 p,vec3 right,vec3 left){vec3 v1=right-p;vec3 v2=p-left;return(dot(v1,v1)<dot(v2,v2))? v1 : v2;}vec3 rebuild_normal(in vec2 uv,in vec3 p){vec2 one_over_resolution=1.0/resolution;vec3 r=get_view_position(uv+vec2(one_over_resolution.x,0));vec3 l=get_view_position(uv+vec2(-one_over_resolution.x,0));vec3 t=get_view_position(uv+vec2(0,one_over_resolution.y));vec3 b=get_view_position(uv+vec2(0,-one_over_resolution.y));return normalize(cross(min_difference(p,r,l),min_difference(p,t,b)));}float falloff(float distance_squared){float neg_inv_r2=-1.0/(radius_of_influence*radius_of_influence);return distance_squared*neg_inv_r2+1.0;}float ao_contribution(vec3 P,vec3 N,vec3 S){vec3 to_sample=S-P;float norm_squared=dot(to_sample,to_sample);float norm=sqrt(norm_squared);float cos_theta=dot(N,to_sample)/norm;return clamp(cos_theta-bias,0.0,1.0)*clamp(falloff(norm_squared),0.0,1.0);}float compute_ambient_occlusion(vec2 uv,float radius_in_screen_space,vec3 pc,vec3 view_space_n){vec2 one_over_resolution=1.0/resolution;ivec2 noise_uv=ivec2(int(mod(gl_FragCoord.x,128.0)),int(mod(gl_FragCoord.y,128.0)));float noise=texelFetch(texture_blue_noise,noise_uv,0).r;noise=fract(noise+0.61803398875*float(frame_index));float theta=noise*2.0*3.1415;float ct=cos(theta);float st=sin(theta);float step_size=radius_in_screen_space/(num_steps+1.0);const float angle_step=2.0*pi/num_directions;float contribution=0.0;for(int i=0;i<int(num_directions);++i){float current_pixel=step_size+1.0;for(int j=0;j<int(num_steps);++j){int index=i*int(num_steps)+j;vec2 blue_noise_sample=texelFetch(texture_blue_noise_in_disk,ivec2(index,0),0).rg;vec2 disk_point;disk_point.x=blue_noise_sample.x*ct-blue_noise_sample.y*st;disk_point.y=blue_noise_sample.x*st+blue_noise_sample.y*ct;vec2 sample_direction=disk_point;vec2 snapped_uv=round(current_pixel*sample_direction)*one_over_resolution+uv;vec3 ps=get_view_position(snapped_uv);current_pixel+=step_size;contribution+=ao_contribution(pc,view_space_n,ps);}}float mult=1.0/(1.0-bias);contribution*=mult/(num_directions*num_steps);return clamp(1.0-contribution*2.0,0.0,1.0);}
#define USE_GBUFFER_NORMALS
void main(){vec3 view_space_p=get_view_position(v_uv);
#ifdef USE_GBUFFER_NORMALS
vec3 view_space_n=texture(texture_normals,v_uv).rgb;view_space_n.z*=-1.0;
#else
vec3 view_space_n=-rebuild_normal(v_uv,view_space_p);
#endif
float radius_ss=radius_in_screen_space/(is_ortho ? 1.0 : view_space_p.z);float ao=compute_ambient_occlusion(v_uv,radius_ss,view_space_p,view_space_n);float final=pow(ao,exponent);if(view_space_p.z>=far){final=1.0;}vec3 color=mix(ao_color,vec3(1.0),final);if(fog_enabled){float fog_factor=smoothstep(fog_near,fog_far,view_space_p.z);color=mix(color,vec3(1.0),fog_factor);}gl_FragColor=vec4(color,1.0);}`;
var l3 = `#define GLSLIFY 1
out vec2 v_uv;void main(){gl_Position=vec4(position.xy,1.0,1.0);v_uv=uv;}`;
var c3 = `#define GLSLIFY 1
in vec2 v_uv;uniform sampler2D texture_ao_lrez;uniform sampler2D texture_depth_lrez;uniform sampler2D texture_depth_hrez;uniform float near;uniform float far;float linearize_depth(float depth_sampled){float z=depth_sampled*2.0-1.0;return(2.0*near*far)/(far+near-z*(far-near));}vec2 nearest_depth_filter(in vec2 uv){vec2 resolution=vec2(textureSize(texture_depth_lrez,0));vec2 texel_size=1.0/resolution;vec2 offset=uv-0.5*texel_size;float d_hrez=texture(texture_depth_hrez,uv).r;float a=abs(d_hrez-texture(texture_depth_lrez,offset).r);float b=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,0.0)).r);float c=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(0.0,texel_size.y)).r);float d=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,texel_size.y)).r);float min_diff=min(a,min(b,min(c,d)));if(min_diff==a)return offset;if(min_diff==b)return offset+vec2(texel_size.x,0.0);if(min_diff==c)return offset+vec2(0.0,texel_size.y);if(min_diff==d)return offset+vec2(texel_size.x,texel_size.y);}void main(){
#ifdef DEBUG
float d_lrez=texture(texture_depth_lrez,v_uv).r;float d_hrez=texture(texture_depth_hrez,v_uv).r;float output_d=mix(linearize_depth(d_lrez)/far,linearize_depth(d_hrez)/far,step(0.5,v_uv.x));gl_FragColor=vec4(vec3(output_d),1.0);
#else
vec2 filtered_uv=nearest_depth_filter(v_uv);vec4 ao=texture(texture_ao_lrez,filtered_uv);gl_FragColor=vec4(ao.rgb,1.0);gl_FragColor=ao;
#endif
}`;
var vf = [
    [
        .478712,
        .875764
    ],
    [
        -0.337956,
        -0.793959
    ],
    [
        -0.955259,
        -0.028164
    ],
    [
        .864527,
        .325689
    ],
    [
        .209342,
        -0.395657
    ],
    [
        -0.106779,
        .672585
    ],
    [
        .156213,
        .235113
    ],
    [
        -0.413644,
        -0.082856
    ],
    [
        -0.415667,
        .323909
    ],
    [
        .141896,
        -0.93998
    ],
    [
        .954932,
        -0.182516
    ],
    [
        -0.766184,
        .410799
    ],
    [
        -0.434912,
        -0.458845
    ],
    [
        .415242,
        -0.078724
    ],
    [
        .728335,
        -0.491777
    ],
    [
        -0.058086,
        -0.066401
    ],
    [
        .20299,
        .686837
    ],
    [
        -0.808362,
        -0.556402
    ],
    [
        .507386,
        -0.640839
    ],
    [
        -0.723494,
        -0.22924
    ],
    [
        .48974,
        .317826
    ],
    [
        -0.622663,
        .765301
    ],
    [
        -0.01064,
        .929347
    ],
    [
        .663146,
        .647618
    ],
    [
        -0.096674,
        -0.413835
    ],
    [
        .525945,
        -0.321063
    ],
    [
        -0.122533,
        .366019
    ],
    [
        .195235,
        -0.687983
    ],
    [
        -0.563203,
        .098748
    ],
    [
        .418563,
        .561335
    ],
    [
        -0.378595,
        .800367
    ],
    [
        .826922,
        .001024
    ],
    [
        -0.085372,
        -0.766651
    ],
    [
        -0.92192,
        .183673
    ],
    [
        -0.590008,
        -0.721799
    ],
    [
        .167751,
        -0.164393
    ],
    [
        .032961,
        -0.56253
    ],
    [
        .6329,
        -0.107059
    ],
    [
        -0.46408,
        .569669
    ],
    [
        -0.173676,
        -0.958758
    ],
    [
        -0.242648,
        -0.234303
    ],
    [
        -0.275362,
        .157163
    ],
    [
        .382295,
        -0.795131
    ],
    [
        .562955,
        .115562
    ],
    [
        .190586,
        .470121
    ],
    [
        .770764,
        -0.297576
    ],
    [
        .237281,
        .93105
    ],
    [
        -0.666642,
        -0.455871
    ],
    [
        -0.905649,
        -0.298379
    ],
    [
        .33952,
        .157829
    ],
    [
        .701438,
        -0.7041
    ],
    [
        -0.062758,
        .160346
    ],
    [
        -0.220674,
        .957141
    ],
    [
        .642692,
        .432706
    ],
    [
        -0.77339,
        -0.015272
    ],
    [
        -0.671467,
        .24688
    ],
    [
        .158051,
        .062859
    ],
    [
        .806009,
        .527232
    ],
    [
        -0.05762,
        -0.247071
    ],
    [
        .333436,
        -0.51671
    ],
    [
        -0.550658,
        -0.315773
    ],
    [
        -0.652078,
        .589846
    ],
    [
        .008818,
        .530556
    ],
    [
        -0.210004,
        .519896
    ]
];
var hQ = new rt({
    vertexShader: n3,
    fragmentShader: s3
}), gx = new rt({
    vertexShader: l3,
    fragmentShader: c3,
    uniforms: {
        texture_ao_lrez: new se(null),
        texture_depth_lrez: new se(null),
        texture_depth_hrez: new se(null),
        near: new se(null),
        far: new se(null)
    }
}), yx = class extends hi {
    constructor(e, r){
        super("AmbientOcclusionPass", void 0, r);
        this.fogEnabled = !1;
        this.fogNear = 1;
        this.fogFar = 1e3;
        this.frameIndex = 0;
        this._runHalfRes = !0;
        this._width = 1;
        this._height = 1;
        let i = 1024, s = 1024;
        this.gBuffer = new at(i, s, {
            type: dr,
            depthTexture: new is(i, s),
            minFilter: Qe,
            magFilter: Qe
        }), this.depthBufferHighRes = new at(i, s, {
            depthTexture: new is(i, s)
        }), this.aoBuffer = new at(i, s, {
            minFilter: Qe,
            magFilter: Qe
        }), this.splineScene = e, this.splineCamera = r;
        let o = new Float32Array(vf.length * 2);
        for(let l = 0; l < vf.length; l++){
            let u = l * 2;
            o[u + 0] = vf[l][0], o[u + 1] = vf[l][1];
        }
        this.blueNoiseInDiskTexture = new ci(o, vf.length, 1, Ku, dr), this.blueNoiseInDiskTexture.wrapS = Is, this.blueNoiseInDiskTexture.wrapT = Is, this.blueNoiseInDiskTexture.needsUpdate = !0, this.hbaoMaterial = new rt({
            vertexShader: o3,
            fragmentShader: a3,
            uniforms: {
                near: new se(null),
                far: new se(null),
                fov: new se(null),
                proj_info: new se(new He),
                is_ortho: new se(!1),
                resolution: new se(new N),
                radius_of_influence: new se(8),
                radius_in_screen_space: new se(1),
                exponent: new se(1),
                ao_color: new se(new _),
                bias: new se(.5),
                texture_depth: new se(null),
                texture_normals: new se(null),
                texture_blue_noise: new se(null),
                texture_blue_noise_in_disk: new se(this.blueNoiseInDiskTexture),
                frame_index: new se(0),
                fog_enabled: new se(!1),
                fog_near: new se(1),
                fog_far: new se(1e3)
            }
        }), this.radius = 128, this.aoColor = {
            r: 0,
            g: 0,
            b: 0
        }, this.bias = .5, this.hbaoMaterial.uniforms.texture_depth.value = this.gBuffer.depthTexture, this.hbaoMaterial.uniforms.texture_normals.value = this.gBuffer.texture, this.needsSwap = !0, this.aaBuffer = new at(i, s, {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut,
            depthBuffer: !1,
            type: dr
        });
        let a = new dx({
            preset: Ia.ULTRA,
            edgeDetectionMode: af.COLOR
        });
        this.effectPass = new Qc(this.camera, a);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    setBlueNoiseTexture(e) {
        this.hbaoMaterial.uniforms.texture_blue_noise.value = e;
    }
    setSize(e, r) {
        this._width = e, this._height = r, this.depthBufferHighRes.setSize(e, r);
        let i = this._runHalfRes ? .5 : 1, s = e * i, o = r * i;
        this.gBuffer.setSize(s, o), this.aoBuffer.setSize(s, o), this.hbaoMaterial.uniforms.resolution.value.set(s, o), this.aaBuffer.setSize(s, o), this.effectPass.setSize(s, o);
    }
    get runHalfRes() {
        return this._runHalfRes;
    }
    set runHalfRes(e) {
        this._runHalfRes = e, this.setSize(this._width, this._height);
    }
    setCamera(e) {
        this.splineCamera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, r, i) {
        this.splineScene.overrideMaterial = hQ;
        let s = this.splineCamera.layers.mask;
        if (this.splineCamera.layers.set(5), e.setRenderTarget(this.gBuffer), e.clear(), e.render(this.splineScene, this.splineCamera), e.setRenderTarget(this.depthBufferHighRes), e.clear(), e.render(this.splineScene, this.splineCamera), this.splineScene.overrideMaterial = null, this.splineCamera.layers.mask = s, this.hbaoMaterial.uniforms.radius_of_influence.value = this.radius, this.hbaoMaterial.uniforms.ao_color.value.set(this.aoColor.r, this.aoColor.g, this.aoColor.b), this.hbaoMaterial.uniforms.bias.value = this.bias, this.hbaoMaterial.uniforms.fog_enabled.value = this.fogEnabled, this.hbaoMaterial.uniforms.fog_near.value = this.fogNear, this.hbaoMaterial.uniforms.fog_far.value = this.fogFar, this.hbaoMaterial.uniforms.frame_index.value = this.frameIndex, this.frameIndex++, this.splineCamera.isPerspectiveCamera) {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.perspCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.perspCamera.far;
            let o = this.splineCamera.perspCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], u = -(1 - o[8]) / o[0], c = -(1 + o[9]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, u, c);
            let h = this.splineCamera.perspCamera.fov * (Math.PI / 180), p = this.hbaoMaterial.uniforms.resolution.value.y / (Math.tan(h * .5) * 2), m = this.hbaoMaterial.uniforms.radius_of_influence.value * .5 * p;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = m, this.hbaoMaterial.uniforms.is_ortho.value = !1;
        } else {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.orthoCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.orthoCamera.far;
            let o = this.splineCamera.orthoCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], u = -(1 + o[12]) / o[0], c = -(1 - o[13]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, u, c);
            let h = .5 * (this.hbaoMaterial.uniforms.resolution.value.y / l), f = this.hbaoMaterial.uniforms.radius_of_influence.value * h;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = f, this.hbaoMaterial.uniforms.is_ortho.value = !0;
        }
        this.runHalfRes ? (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aoBuffer), e.clear(), e.render(this.scene, this.camera), this.fullscreenMaterial = gx, gx.uniforms.texture_ao_lrez.value = this.aoBuffer.texture, gx.uniforms.texture_depth_lrez.value = this.gBuffer.depthTexture, gx.uniforms.texture_depth_hrez.value = this.depthBufferHighRes.depthTexture, e.setRenderTarget(e.aoRenderTarget), e.clear(), e.render(this.scene, this.camera)) : (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aaBuffer), e.clear(), e.render(this.scene, this.camera), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.aaBuffer, e.aoRenderTarget));
    }
    dispose() {
        this.gBuffer.dispose(), this.depthBufferHighRes.dispose(), this.aoBuffer.dispose();
    }
};
var fQ = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, pQ = `
uniform sampler2D tInput;
uniform sampler2D tMap;
uniform vec2 resolution;
varying vec2 vUv;

uniform vec2 uResolution;
uniform vec2 uCoords;

// Draws a rectangle at center <st> with size <size>
float rectangle(vec2 st, vec2 size) {
    size = vec2(0.5) - size * 0.5;
    vec2 uv = vec2(step(size.x, st.x), step(size.y, st.y));
    uv *= vec2(step(size.x, 1.0 - st.x), step(size.y, 1.0 - st.y));

    return uv.x * uv.y;
}

uniform vec2 uSize;
uniform float uScale;
uniform float uDPR;
uniform float uCurrent;
uniform vec3 uSceneColor;

void main() {
    vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
    screenUv *= 1.0 / uDPR;

    vec2 center = vec2(0.5, -0.5);
    vec2 outsideUv = screenUv;
    outsideUv += center;
    outsideUv -= uCoords.xy / uResolution.xy;
    outsideUv = (outsideUv - 0.5) + 0.5;
    outsideUv -= center;
    vec2 s = (uSize / uResolution) * uScale;
    float isOutside = 1.0 - rectangle(outsideUv, s);
    
    vec2 mid = vec2(0.5);
    vec2 insideUv = (screenUv - mid + s * mid) / s;
    vec4 background = texture2D(tInput, screenUv);
    vec4 image = texture2D(tMap, insideUv);
    gl_FragColor = mix(image, background, isOutside);
}
`, vx = class extends Bn {
    constructor(){
        super(new rt({
            vertexShader: fQ,
            fragmentShader: pQ,
            uniforms: {
                tInput: new se(null),
                tMap: new se(null),
                uResolution: new se(new N),
                uSize: new se(new N),
                uCoords: new se(new N),
                uScale: new se(1),
                uSceneColor: new se(new Le(16711680)),
                uDPR: new se(1),
                uCurrent: new se(0)
            }
        }), "tInput"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tMap.value;
    }
    set texture(t) {
        this.uniforms.tMap.value = t;
    }
};
var mQ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, gQ = `
uniform sampler2D toScene;
uniform sampler2D fromScene;
uniform vec2 resolution;

uniform vec2 uResolution;
uniform float uDPR;

uniform float mixRatio;
uniform sampler2D tMixTexture;
uniform int useTexture;
uniform float threshold;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( fromScene, screenUv );
	vec4 texel2 = texture2D( toScene, screenUv );

	if (useTexture==1) {
		
		vec4 transitionTexel = texture2D( tMixTexture, screenUv );
		float r = mixRatio * (1.0 + threshold * 2.0) - threshold;
		float mixf=clamp((transitionTexel.r - r)*(1.0/threshold), 0.0, 1.0);
		
		gl_FragColor = mix( texel1, texel2, mixf );
	} else {
		
		gl_FragColor = mix( texel1, texel2, mixRatio );
		
	}
}
`, yQ = [], xx = class extends Bn {
    constructor(){
        super(new rt({
            vertexShader: mQ,
            fragmentShader: gQ,
            uniforms: {
                toScene: new se(null),
                fromScene: new se(null),
                uResolution: new se(new N),
                uDPR: new se(1),
                mixRatio: new se(0),
                threshold: new se(.1),
                useTexture: new se(0),
                tMixTexture: {
                    value: yQ[0]
                }
            }
        }), "toScene"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.fromScene.value;
    }
    set texture(t) {
        this.uniforms.fromScene.value = t;
    }
};
var vQ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, xQ = `
uniform sampler2D inputBuffer;
uniform sampler2D blurredInputBuffer;
uniform sampler2D overlay;
uniform float blurIntensity;

uniform vec2 uResolution;
uniform float uDPR;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( overlay, screenUv );
	vec4 texel2 = texture2D( inputBuffer, screenUv );
	vec4 texel3 = texture2D( blurredInputBuffer, screenUv );

	float blurMask2 = max(sign(texel1.a), 0.0) * blurIntensity;
    gl_FragColor = mix( mix(texel2, texel3, blurMask2), texel1, texel1.a );
	gl_FragColor.a = 1.0;
}
`, bx = class extends Bn {
    constructor(){
        super(new rt({
            vertexShader: vQ,
            fragmentShader: xQ,
            uniforms: {
                inputBuffer: new se(null),
                blurredInputBuffer: new se(null),
                overlay: new se(null),
                uResolution: new se(new N),
                uDPR: new se(1),
                blurIntensity: new se(0)
            }
        }));
        this._blurEnabled = !1;
        this.blurTarget = new at(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut
        }), this.blurPass = new ux({
            width: window.innerWidth,
            height: window.innerHeight,
            kernelSize: Lm.HUGE,
            resolutionScale: .25
        }), this.blurPass.renderToScreen = !1, this.uniforms.blurredInputBuffer.value = this.blurTarget.texture;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.overlay.value;
    }
    set texture(e) {
        this.uniforms.overlay.value = e;
    }
    setResolution(e, r, i = 1) {
        this.uniforms.uResolution.value.set(e, r).divideScalar(i), this.uniforms.uDPR.value = i, this.blurPass.setSize(e, r), this.blurTarget.setSize(e, r), this.blurPass.setSize(e, r);
    }
    get uiCanvas() {
        return this._uiCanvas;
    }
    set uiCanvas(e) {
        this._uiCanvas = e, e.texture && (this.uniforms.overlay.value = e.texture);
        let i = e.frame;
        if (i) {
            let s = i.data.backgroundBlur, o = s.radius;
            this._blurEnabled = s.enabled, this.uniforms.blurIntensity.value = this._blurEnabled ? 1 : 0, this.blurPass.scale = o / 3;
        }
    }
    render(e, r, i, s, o) {
        this._blurEnabled && (this.blurPass.setDepthTexture(this.getDepthTexture()), this.blurPass.render(e, r, this.blurTarget, s, o)), super.render(e, r, i, s, o);
    }
};
function d3(n1, t) {
    return t && t.enabled && n1.push(t.effect), n1;
}
var bQ = (n1)=>Object.values(yt).includes(n1) ? n1 : yt.NORMAL, Bm = class extends ir {
    constructor(e){
        super();
        this.postprocessingState = Ud.defaultData;
        this._scene = new vi;
        this._camera = new hr;
        this.effects = new Map;
        this.blueNoiseTexture = new ci;
        this._renderToScreen = !0;
        this._isUIOverlayEnabled = !1;
        this.clock = new by, this.renderer = e, this.debug = !1, this.effects.set("bloom", new lf), this.effects.set("chromaticAberration", new uf), this.effects.set("vignette", new pf), this.effects.set("noise", new ff), this.effects.set("colorAverage", new df), this.effects.set("hueSaturation", new hf), this.effects.set("brightnessContrast", new cf), this.effects.set("depthOfField", new mf), this.effects.set("pixelation", new gf), this.effectComposer = new px(this.renderer), this.effectComposer.autoRenderToScreen = !1, this.opaquePass = new Kc(!0, this.scene, this.camera), this.opaquePass.clear = !0, this.transmissionPass = new fx(this.scene, this.camera, this.renderer), this.aoPass = new yx(this.scene, this.camera), this.taaPass = new hx, this.taaPass.renderToScreen = !1, this.helperPass = new mx(this.camera), this.helperPass.renderToScreen = !1, this.stylesOverlayPass = new vx, this.stylesOverlayPass.enabled = !1, this.uiOverlayPass = new bx, this.uiOverlayPass.enabled = !1, this.sceneTransitionPass = new xx, this.sceneTransitionPass.enabled = !1, this._initCopyPass(), this._initPasses();
    }
    set overlayTexture(e) {
        e !== void 0 ? (this.stylesOverlayPass.texture = e, this.stylesOverlayPass.enabled = !0) : this.stylesOverlayPass.enabled = !1;
    }
    get overlayTexture() {
        return this.stylesOverlayPass.texture;
    }
    set sceneHelpers(e) {
        this.helperPass.sceneHelpers = e;
    }
    get sceneHelpers() {
        return this.helperPass.sceneHelpers;
    }
    set sceneHelpersOnTop(e) {
        this.helperPass.sceneHelpersOnTop = e;
    }
    get sceneHelpersOnTop() {
        return this.helperPass.sceneHelpersOnTop;
    }
    get scene() {
        return this._scene;
    }
    set scene(e) {
        this._scene = e, this.opaquePass.setScene(e), this.transmissionPass.setScene(e), this.aoPass.setScene(e);
    }
    get camera() {
        return this._camera;
    }
    set camera(e) {
        this._camera = e, this.opaquePass.setCamera(e), this.transmissionPass.setCamera(e), this.aoPass.setCamera(e), this.helperPass.setCamera(e);
    }
    updateRenderToScreen() {
        let e = !1;
        for(let r = this.effectComposer.passes.length - 1; r >= 0; r--){
            let i = this.effectComposer.passes[r];
            if (i.enabled === !0 && !e && this._renderToScreen) {
                i.renderToScreen = !0, e = !0;
                continue;
            }
            i.renderToScreen = !1;
        }
    }
    get isUIOverlayEnabled() {
        return this._isUIOverlayEnabled;
    }
    disableUIOverlay() {
        this._isUIOverlayEnabled = !1;
    }
    enableUIOverlay() {
        this._isUIOverlayEnabled = !0;
    }
    disableHelpers() {
        this.helperPass.enabled = !1, this.updateRenderToScreen();
    }
    enableHelpers() {
        this.helperPass.enabled = !0, this.updateRenderToScreen();
    }
    updateBlueNoiseTexture(e) {
        this.blueNoiseTexture = new ci(e, 128, 128), this.blueNoiseTexture.wrapS = Is, this.blueNoiseTexture.wrapT = Is, this.blueNoiseTexture.minFilter = Et, this.blueNoiseTexture.magFilter = Et, this.blueNoiseTexture.needsUpdate = !0;
    }
    setAmbientOcclusionParams(e, r, i, s, o, a, l, u) {
        this.aoPass.enabled = e, this.aoPass.radius = r, this.aoPass.bias = i, this.aoPass.aoColor = s, this.aoPass.fogEnabled = o, this.aoPass.fogNear = a, this.aoPass.fogFar = l, this.aoPass.runHalfRes !== !u && (this.aoPass.runHalfRes = !u);
    }
    setTransmissionPassEnabled(e) {
        this.transmissionPass.enabled = e, this.opaquePass.hasTransmissionPass = e;
    }
    _initPasses() {
        if (this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.removeAllPasses(), this.transmissionPass.updatePasses(this.renderer), this.effectComposer.addPass(this.aoPass), this.effectComposer.addPass(this.opaquePass), this.effectComposer.addPass(this.transmissionPass), this.effectComposer.addPass(this.taaPass), this.postprocessingState.enabled) {
            let e = [
                this.effects.get("pixelation")
            ].reduce(d3, []);
            e.length > 0 && (this.uvEffectPass = new Qc(this.camera, ...e), this.uvEffectPass.renderToScreen = !1, this.effectComposer.addPass(this.uvEffectPass));
            let r = [
                this.effects.get("chromaticAberration"),
                this.effects.get("bloom"),
                this.effects.get("colorAverage"),
                this.effects.get("hueSaturation"),
                this.effects.get("brightnessContrast"),
                this.effects.get("vignette"),
                this.effects.get("noise")
            ].reduce(d3, []);
            r.length > 0 && (this.effectPass = new Qc(this.camera, ...r), this.effectPass.renderToScreen = !1, this.effectComposer.addPass(this.effectPass));
        }
        this.effectComposer.addPass(this.stylesOverlayPass), this.effectComposer.addPass(this.uiOverlayPass), this.effectComposer.addPass(this.sceneTransitionPass), this.effectComposer.addPass(this.helperPass);
    }
    _initCopyPass() {
        if (this._savePass) return;
        let e = new N;
        this.renderer.getDrawingBufferSize(e), this._rt = new at(e.x, e.y, {
            depthBuffer: !1,
            stencilBuffer: !1,
            wrapS: Is,
            wrapT: Is
        }), this._rt.samples = 0, this._savePass = new Rm(this._rt, !1), this._savePass.renderToScreen = !1;
    }
    setCopyPass(e) {
        this._rt = e, this._savePass = new Rm(this._rt, !1), this.renderToScreen = !1;
    }
    get renderToScreen() {
        return this._renderToScreen;
    }
    set renderToScreen(e) {
        if (this._renderToScreen === e) return;
        let r = this.effectComposer;
        !r || (e === !0 ? r.removePass(this._savePass) : r.addPass(this._savePass), this._renderToScreen = e, this.updateRenderToScreen());
    }
    set sceneTransitionFromTexture(e) {
        e !== this.sceneTransitionPass.texture && (e !== null ? this.sceneTransitionPass.enabled = !0 : (this.sceneTransitionPass.enabled = !1, this.updateRenderToScreen()), this.sceneTransitionPass.texture = e);
    }
    get texture() {
        return this._rt && this._rt.texture;
    }
    get renderTarget() {
        return this._rt;
    }
    updatePostprocessing(e) {
        let { enabled: r, ...i } = e, s = !1;
        r !== this.postprocessingState.enabled && (s = !0);
        for (let o of Object.entries(i)){
            let a = o[1], l = this.effects.get(o[0]);
            if (l) {
                l.enabled !== a.enabled && (s = !0), l.enabled = a.enabled;
                for (let [u, c] of Object.entries(a))u === "blendFunction" ? l.blendFunction = bQ(c) : l[u] = c;
            }
        }
        this.postprocessingState = e, s && this._initPasses();
    }
    render() {
        this.effectComposer.render(this.clock.getDelta());
    }
    setScissor(e, r, i, s) {
        e instanceof He ? (this.effectComposer.inputBuffer.scissor.set(e.x, e.y, e.z, e.w), this.effectComposer.outputBuffer.scissor.set(e.x, e.y, e.z, e.w)) : (this.effectComposer.inputBuffer.scissor.set(e, r, i, s), this.effectComposer.outputBuffer.scissor.set(e, r, i, s));
        let o = this.renderer.getPixelRatio();
        this.effectComposer.inputBuffer.scissor.multiplyScalar(o), this.effectComposer.outputBuffer.scissor.multiplyScalar(o), this.renderer.setScissor(e, r, i, s);
    }
    setScissorTest(e) {
        this.effectComposer.inputBuffer.scissorTest = e, this.effectComposer.outputBuffer.scissorTest = e, this.renderer.setScissorTest(e);
    }
    setViewport(e, r, i, s) {
        e instanceof He ? (this.effectComposer.inputBuffer.viewport.copy(e), this.effectComposer.outputBuffer.viewport.copy(e)) : (this.effectComposer.inputBuffer.viewport.set(e, r, i, s), this.effectComposer.outputBuffer.viewport.set(e, r, i, s));
    }
    resize(e, r, i) {
        if (this.effectComposer.setSize(e, r, i), this._rt) {
            let s = this.renderer.getPixelRatio();
            this._rt.setSize(e * s, r * s);
        }
    }
    dispose() {
        this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.dispose();
    }
};
var SQ = (n1)=>`

// PCSS implementation based on:
// https://www.gamedev.net/articles/programming/graphics/contact-hardening-soft-shadows-made-fast-r4906/
// NOTE: This number affects how big the shadow blur can
// possibly get. Bigger number == bigger blur, but less precise results

const float  gPenumbraFilterSize = 80.0;
const int   gPenumbraSamples = ${n1};
const int gShadowSamples = ${n1};
const float gShadowSamplesRpc = 1.0f / float(gShadowSamples);

#ifdef USE_SHADOWMAP
    #if NUM_DIR_LIGHT_SHADOWS > 0

        uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
        varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

        struct DirectionalLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

    #endif

    #if NUM_SPOT_LIGHT_SHADOWS > 0

        uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
        varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_SHADOWS ];

        struct SpotLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

    #endif

    #if NUM_POINT_LIGHT_SHADOWS > 0

        uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
        varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

        struct PointLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
            float shadowCameraNear;
            float shadowCameraFar;
        };

        uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

    #endif

    /*
    #if NUM_RECT_AREA_LIGHTS > 0

        // TODO (abelnation): create uniforms for area light shadows

    #endif
    */

float computePenumbra(int index, sampler2D shadowMap, float temporalAngle, float texelSize, vec2 uv, float compare, float texelScalar, float shadowRadius)
{
    float penumbra = 1.0;
    float blockerDepthAvg = 0.0;
    float blockerCount = 0.0;

    #pragma unroll_loop_start
    for(int i = 0; i < gPenumbraSamples; i ++)
    {
        vec2 offset = (vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize) * texelScalar;
        float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) );

        if(depth < compare + 0.0001)
        {
            blockerDepthAvg += depth;
            blockerCount++;
        }
    }
    #pragma unroll_loop_end

    if (blockerCount > 0.0)
    {
        blockerDepthAvg /= blockerCount;

        // Compute penumbra
        penumbra = (compare - blockerDepthAvg) / (blockerDepthAvg);
        penumbra *= penumbra;
        penumbra *= 200.0 * penumbraSize[min(index, ${5} - 1)]; // Magic number that affects how quickly the penumbra grows

        return clamp(penumbra, 0.00, 1.0);
    }
    return 0.0;
}

float vogelShadow(int index, sampler2D shadowMap, vec2 uv, float texelSize, float compare, float shadowRadius)
{
    float shadow         = 0.0f;

    // NOTE: When using TAA, we should use screen space interleaved gradient noise
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    float texelScalar = (gPenumbraFilterSize) / (texelSize * 1024.);
    float penumbra = computePenumbra(index, shadowMap, temporalAngle, texelSize, uv, compare, texelScalar, shadowRadius);
    if (penumbra == -1.0) {
        return 1.0;
    }

    #pragma unroll_loop_start
    for (int i = 0; i < gShadowSamples; i++)
    {
        vec2 vogelSample =  vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;
        // Overall blurring offset
        vec2 offset = vogelSample * (shadowRadius * 2.);

        // Penumbra offset
        offset += vogelSample * (penumbra * texelScalar);

        shadow += step( compare, unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) ) );
    }
    #pragma unroll_loop_end

    return shadow * gShadowSamplesRpc;
}


    float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {

        return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );

    }

    vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {

        return unpackRGBATo2Half( texture2D( shadow, uv ) );

    }

    float VSMShadow (sampler2D shadow, vec2 uv, float compare ){

        float occlusion = 1.0;

        vec2 distribution = texture2DDistribution( shadow, uv );

        float hard_shadow = step( compare , distribution.x ); // Hard Shadow

        if (hard_shadow != 1.0 ) {

            float distance = compare - distribution.x ;
            float variance = max( 0.00000, distribution.y * distribution.y );
            float softness_probability = variance / (variance + distance * distance ); // Chebeyshevs inequality
            softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 ); // 0.3 reduces light bleed
            occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );

        }
        return occlusion;

    }

    float getShadow( int i, sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {

        float shadow = 1.0;

        shadowCoord.xyz /= shadowCoord.w;
        shadowCoord.z += shadowBias;

        // if ( something && something ) breaks ATI OpenGL shader compiler
        // if ( all( something, something ) ) using this instead

        bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
        bool inFrustum = all( inFrustumVec );

        bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );

        bool frustumTest = all( frustumTestVec );

        if ( frustumTest ) {

        #if defined( SHADOWMAP_TYPE_PCF )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            return vogelShadow(i, shadowMap, shadowCoord.xy, texelSize.x, shadowCoord.z, shadowRadius );

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            float dx = texelSize.x;
            float dy = texelSize.y;

            vec2 uv = shadowCoord.xy;
            vec2 f = fract( uv * shadowMapSize + 0.5 );
            uv -= f * texelSize;

            shadow = (
                texture2DCompare( shadowMap, uv, shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
                          f.x ),
                     mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
                          f.x ),
                     f.y )
            ) * ( 1.0 / 9.0 );

        #elif defined( SHADOWMAP_TYPE_VSM )

            shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );

        #else // no percentage-closer filtering:

            shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );

        #endif

        }

        return shadow;

    }

    // cubeToUV() maps a 3D direction vector suitable for cube texture mapping to a 2D
    // vector suitable for 2D texture mapping. This code uses the following layout for the
    // 2D texture:
    //
    // xzXZ
    //  y Y
    //
    // Y - Positive y direction
    // y - Negative y direction
    // X - Positive x direction
    // x - Negative x direction
    // Z - Positive z direction
    // z - Negative z direction
    //
    // Source and test bed:
    // https://gist.github.com/tschw/da10c43c467ce8afd0c4

    vec2 cubeToUV( vec3 v, float texelSizeY ) {

        // Number of texels to avoid at the edge of each square

        vec3 absV = abs( v );

        // Intersect unit cube

        float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
        absV *= scaleToCube;

        // Apply scale to avoid seams

        // two texels less per square (one texel will do for NEAREST)
        v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );

        // Unwrap

        // space: -1 ... 1 range for each square
        //
        // #X##         dim    := ( 4 , 2 )
        //  # #         center := ( 1 , 1 )

        vec2 planar = v.xy;

        float almostATexel = 1.5 * texelSizeY;
        float almostOne = 1.0 - almostATexel;

        if ( absV.z >= almostOne ) {

            if ( v.z > 0.0 )
                planar.x = 4.0 - v.x;

        } else if ( absV.x >= almostOne ) {

            float signX = sign( v.x );
            planar.x = v.z * signX + 2.0 * signX;

        } else if ( absV.y >= almostOne ) {

            float signY = sign( v.y );
            planar.x = v.x + 2.0 * signY + 2.0;
            planar.y = v.z * signY - 2.0;

        }

        // Transform to UV space

        // scale := 0.5 / dim
        // translate := ( center + 0.5 ) / dim
        return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );

    }

    float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {

        float shadow = 1.0;
        vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );

        // for point lights, the uniform @vShadowCoord is re-purposed to hold
        // the vector from the light to the world-space position of the fragment.
        vec3 lightToPosition = shadowCoord.xyz;

        // dp = normalized distance from light to fragment position
        float compare = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear ); // need to clamp?
        compare += shadowBias;

        // bd3D = base direction 3D
        vec3 bd3D = normalize( lightToPosition );

        vec2 halton = haltonSequence[frameIndex];
        float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
        float temporalAngle  = temporalOffset * PI2;

        #if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_VSM )
            for (int i = 0; i < gShadowSamples; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                // NOTE: Removed for now
                // Penumbra offset
                //offset += vec3(vogelSample.x, vogelSample.y, vogelSample.y)  * (penumbra * gPenumbraFilterSize);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * gShadowSamplesRpc;

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )
            for (int i = 0; i < 16; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * (1.0 / 16.0);
        #else // no percentage-closer filtering

            return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), compare );

        #endif

    }

#endif
`, wQ = ht.lights_fragment_begin, AQ = ht.shadowmask_pars_fragment, h3 = null, _Q = (n1)=>{
    switch(n1){
        case "low":
            return 8;
        case "medium":
            return 16;
        case "high":
            return 32;
        default:
            return 16;
    }
}, f3 = (n1 = "medium")=>{
    if (h3 === n1) return !1;
    h3 = n1;
    let t = _Q(n1);
    ht.shadowmap_pars_fragment = SQ(t);
    let e = wQ.slice();
    e = e.replace("getShadow( spotShadowMap[ i ]", `getShadow( UNROLLED_LOOP_INDEX + ${3}, spotShadowMap[ i ]`), e = e.replace("getShadow( directionalShadowMap[ i ]", "getShadow( UNROLLED_LOOP_INDEX, directionalShadowMap[ i ]"), ht.lights_fragment_begin = e;
    let r = AQ.slice();
    return r = r.replaceAll("getShadow(", "getShadow( UNROLLED_LOOP_INDEX, "), ht.shadowmask_pars_fragment = r, !0;
};
var EQ = `
attribute vec3 randomColor;
varying vec3 vNormal;
flat out vec3 vColor;

void main()
{
vNormal = normal;
vColor = randomColor;
gl_Position = projectionMatrix * (modelViewMatrix * vec4(position, 1.0));
}
`, TQ = `
uniform float depthContrast;
varying vec3 vNormal;
flat in vec3 vColor;
void main()
{
vec3 normal = (normalize(vNormal)).rgb;

float contrastDepth = (gl_FragCoord.z - 0.5) * depthContrast + 0.5;

vec3 resultColor = mix(mix(vColor, normal, 0.2), vec3(contrastDepth), 0.4);
gl_FragColor = vec4(resultColor, vColor.r);
gl_FragColor = vec4(resultColor, vColor.r);
}
`, Sx = new rt({
    vertexShader: EQ,
    fragmentShader: TQ,
    uniforms: {
        depthContrast: {
            value: 1
        }
    }
});
var p3 = new qt, wx = class extends dw {
    constructor(e){
        super(e);
        this._pixelRatio = this.getPixelRatio();
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.resolution = new N;
        this.pipeline = new Bm(this);
        this.dummyCamera = new hr;
        this.sceneTransitionDuration = 0;
        this.sceneTransitionTimeRemaining = -1;
        this.isXRCopyPassSet = !1;
        this.clear = (e = !0, r = !0, i = !0)=>{
            let s = this.getContext(), o = 0;
            e && (o |= s.COLOR_BUFFER_BIT), r && (o |= s.DEPTH_BUFFER_BIT), i && (o |= s.STENCIL_BUFFER_BIT), s.clear(o), s.clearBufferfv(s.COLOR, 1, [
                0,
                0,
                0,
                1
            ]);
        };
        this.autoClear = !1;
        let r = this.setPixelRatio.bind(this), i = this.setSize.bind(this);
        this.shadowMap.enabled = !0, this.shadowMap.type = Ty, this.dummyCamera.matrixAutoUpdate = !1;
        let s = this.getContext();
        if (s && "drawingBufferColorSpace" in s) try {
            s.drawingBufferColorSpace = "display-p3";
        } catch (o) {
            console.warn(o);
        }
        this.setPixelRatio = (o)=>{
            this._pixelRatio !== o && (this._pixelRatio = o, r(o));
        }, this.setSize = (o, a, l = !0)=>{
            (this.viewportWidth !== o || this.viewportHeight !== a) && (this.viewportWidth = o, this.viewportHeight = a, i(o, a, l), this.normalRenderTarget?.setSize(o * this._pixelRatio, a * this._pixelRatio), this._resizeTransmission(o, a), this.transmissionDepthTarget?.setSize(o * this._pixelRatio / 2, a * this._pixelRatio / 2), this.pipeline.resize(o, a, l));
        }, this._superDispose = this.dispose, this.dispose = this._currentDispose;
    }
    createAORenderTarget() {
        this.aoRenderTarget === void 0 && (this.aoRenderTarget = new at(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut,
            depthBuffer: !1
        }));
    }
    _resizeTransmission(e, r) {
        this.transmissionRenderTarget?.setSize(e * this._pixelRatio / (this.hdTransmission ? 1 : 2), r * this._pixelRatio / (this.hdTransmission ? 1 : 2)), this.aoRenderTarget?.setSize(e * this._pixelRatio / 1, r * this._pixelRatio / 1);
    }
    get hdTransmission() {
        return We.transmissionLod.value === 1;
    }
    set hdTransmission(e) {
        We.transmissionLod.value = e === !0 ? 1 : 2, this._resizeTransmission(this.viewportWidth, this.viewportHeight);
    }
    createTransmissionRenderTarget() {
        this.transmissionRenderTarget === void 0 && (this.transmissionRenderTarget = new at(this.viewportWidth * this._pixelRatio / (this.hdTransmission ? 1 : 2), this.viewportHeight * this._pixelRatio / (this.hdTransmission ? 1 : 2), {
            generateMipmaps: !0,
            minFilter: dc,
            magFilter: Qe,
            wrapS: Ut,
            wrapT: Ut,
            depthBuffer: !1
        }), this.transmissionDepthTarget = new at(this.viewportWidth * this._pixelRatio / 2, this.viewportHeight * this._pixelRatio / 2, {
            minFilter: Et,
            magFilter: Et,
            depthBuffer: !1
        }));
    }
    createNormalRenderTarget() {
        this.normalRenderTarget === void 0 && (this.normalRenderTarget = new at(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: Et,
            magFilter: Et,
            type: dr,
            depthTexture: new is(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio)
        }));
    }
    renderNormal(e, r, i) {
        this.normalRenderTarget && (this.setClearColor(0), i.layers.enable(8), i.layers.disable(0), i.layers.disable(3), r.traverseEntity((s)=>{
            s.layers.isEnabled(8) && (s.copyPreviousMatrix = !1);
        }), this.setRenderTarget(this.normalRenderTarget), this.clear(), i instanceof hr ? Sx.uniforms.depthContrast.value = (i.far - i.near) / 1e4 : Sx.uniforms.depthContrast.value = 1, r.overrideMaterial = Sx, this.render(r, i), this.setClearColor(r.bgColor, r.bgColor.a), this.setRenderTarget(null), r.overrideMaterial = e.wireframeState ? Ax : null, i.layers.enable(0), i.layers.enable(3), r.traverseEntity((s)=>{
            s.layers.isEnabled(8) && (s.copyPreviousMatrix = !0);
        }));
    }
    renderSplineSceneWithDummyCamera(e, r, i = 1) {
        this.dummyCamera.updateCameraState(r.dataPatched), this.dummyCamera.matrix.copy(r.matrixWorld);
        let s = r.height, o = r.width, a = this.viewportWidth / this.viewportHeight;
        o < s ? o = s * a : s = o / a, this.dummyCamera.setViewplaneSize(o, s);
        for(let l = 0; l < i; l++)this.renderSplineScene(e, this.dummyCamera);
    }
    renderSplineScene(e, r, { sceneHelpers: i, sceneHelpersOnTop: s, overrideTransmission: o, overrideNormal: a } = {}) {
        let l = e instanceof Vl ? e.activePage : e, u = l.visible;
        l.visible = !0;
        let c = l.scene;
        this.xr.enabled && (this.isXRCopyPassSet === !1 && this.getRenderTarget() !== null && (this.pipeline.setCopyPass(this.getRenderTarget()), this.isXRCopyPassSet = !0), this.xr.updateCamera(r)), this.setClearColor(l.bgColor, l.bgColor.a), l.penumbraSizeArray.forEach((p, m)=>{
            We.penumbraSize.value[m] = p;
        }), We.pixelRatioNode.value = this.getPixelRatio(), this.resolution.x !== 0 && this.resolution.y !== 0 ? We.resolution.value.set(this.resolution.x, this.resolution.y) : We.resolution.value.set(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio), a !== void 0 ? (We.normalRenderTarget.value = a, We.normalRenderTargetDepth.value = p3) : c.needsNormal() && (this.createNormalRenderTarget(), We.normalRenderTarget.value = this.normalRenderTarget.texture, We.normalRenderTargetDepth.value = this.normalRenderTarget.depthTexture, this.renderNormal(c, l, r));
        let d = l.data.ao, h = d.occlusion;
        h && (this.createAORenderTarget(), We.aoRenderTarget.value = this.aoRenderTarget.texture), We.aoEnabled.value = h, this.pipeline.setAmbientOcclusionParams(d.occlusion, d.radius, d.bias, l.aoColor, l.fog !== null, l.backupFog.near, l.backupFog.far, d.aoFullRes), this.pipeline.aoPass.setBlueNoiseTexture(this.pipeline.blueNoiseTexture), this.pipeline.isUIOverlayEnabled && l.uiCanvas?.enabled && l.uiCanvas.texture && l.uiCanvas.texture.image.width > 0 ? ((l.uiCanvas.width !== this.viewportWidth || l.uiCanvas.height !== this.viewportHeight) && l.uiCanvas.applySize({
            width: this.viewportWidth,
            height: this.viewportHeight
        }), l.uiCanvas.render(), this.pipeline.uiOverlayPass.uiCanvas = l.uiCanvas, this.pipeline.uiOverlayPass.enabled = !0, this.pipeline.uiOverlayPass.setResolution(this.domElement.width, this.domElement.height, window.devicePixelRatio), this.pipeline.updateRenderToScreen()) : (this.pipeline.uiOverlayPass.enabled = !1, this.pipeline.updateRenderToScreen());
        let f = !1;
        if (o !== void 0) We.transmissionRenderTarget.value = o, We.transmissionRenderTargetDepth.value = p3, this.pipeline.setTransmissionPassEnabled(!1);
        else {
            let p = c.needsTransmission();
            p && (this.transmissionRenderTarget === void 0 && (f = !0), this.createTransmissionRenderTarget(), We.transmissionRenderTarget.value = this.transmissionRenderTarget.texture, We.aspectRatio.value = NI(this.viewportWidth, this.viewportHeight), We.transmissionRenderTargetDepth.value = this.transmissionDepthTarget.texture), this.pipeline.setTransmissionPassEnabled(p);
        }
        r.layers.enable(3), r.layers.enable(8), this.pipeline.sceneHelpers = i, this.pipeline.sceneHelpersOnTop = s, this.pipeline.scene = l, this.pipeline.camera = r, f && this.pipeline.transmissionPass.updatePasses(this), this.pipeline.postprocessingState !== l.postprocessing && (this.pipeline.updatePostprocessing(l.postprocessing), !i && !s && this.pipeline.disableHelpers()), this.clearAlphaOverride !== void 0 && this.setClearAlpha(this.clearAlphaOverride), l.overrideMaterial = c.wireframeState ? Ax : null, this.pipeline.render(), We.frameIndex.value = (We.frameIndex.value + 1) % 16, r instanceof hr && r.copyHistory(), l.visible = u;
    }
    renderFromSceneForSceneTransitionPass(e, r, i) {
        this.pipeline.renderToScreen = !1, this.pipeline.renderTarget, this.renderSplineScene(e, r), this.pipeline.sceneTransitionFromTexture = this.pipeline.renderTarget.texture, this.sceneTransitionDuration = i, this.sceneTransitionTimeRemaining = i, this.pipeline.renderToScreen = !0;
        let s = this.pipeline.sceneTransitionPass.uniforms;
        s.uDPR.value = window.devicePixelRatio, s.uResolution.value.set(this.domElement.width, this.domElement.height).divideScalar(window.devicePixelRatio);
    }
    _currentDispose() {
        this._superDispose(), this.pipeline.dispose(), this.aoRenderTarget?.dispose(), this.transmissionRenderTarget?.dispose(), this.transmissionDepthTarget?.dispose(), this.normalRenderTarget?.dispose(), this.normalRenderTarget?.depthTexture?.dispose();
    }
};
var xf = class extends Bo(_y) {
    constructor(e, r = 15, i = 10066329){
        super(e, r, i);
        this.object = e;
        this.added = !1;
        this.name = `DirectionalLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        No(this.object, xf.geometryHelper, e, r);
    }
};
var bf = class extends Bo(Ay) {
    constructor(e, r = 15, i = 6710886){
        super(e, r, i);
        this.object = e;
        this.name = `PointLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        No(this.object, bf.geometryHelper, e, r);
    }
};
var _x = class extends Bo(wy) {
    constructor(e, r = 6710886){
        super(e, r);
        this.object = e;
        this.name = `SpotLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        No(this.object, _x.geometryHelper, e, r);
    }
    update() {
        if (this.object !== void 0) {
            let e = _x._vector, r = this.object.distance ? this.object.distance : 1e3, i = r * Math.tan(this.object.angle);
            this.cone.scale.set(i, i, r), e.setFromMatrixPosition(this.object.target.matrixWorld), this.cone.lookAt(e);
            let s = this.color !== void 0 ? this.color : this.light.color;
            if (this.cone.material instanceof Array) for(let o = 0, a = this.cone.material.length; o < a; o++)this.cone.material[o].color.set(s);
            else this.cone.material.color.set(s);
        }
    }
}, Nm = _x;
Nm._vector = new _;
function MQ(n1, t) {
    n1.shadow.camera.right = t / 2, n1.shadow.camera.left = -t / 2, n1.shadow.camera.top = t / 2, n1.shadow.camera.bottom = -t / 2, n1.shadow.needsUpdate = !0;
}
var Sf = class extends of(xy, xf) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 2048, this.shadow.mapSize.height = 2048, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.top = 1250, s.bottom = -1250, s.right = 1250, s.left = -1250, s.near = -10000, s.far = 2500;
        let o = new nl(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o;
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof nl && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e);
        let r = t.depth !== void 0 && t.depth !== this.shadow.camera.far || t.size !== void 0 && t.size / 2 !== this.shadow.camera.right;
        t.size !== void 0 && MQ(this, t.size), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null)), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), r && this.update();
    }
};
var m3 = new _, g3 = new _, y3 = new je, wf = class extends of(yy, Nm) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = Se.RAD2DEG * 2 * this.angle, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new nl(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o, this.update();
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof nl && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), g3.setFromMatrixPosition(this.matrixWorld), y3.setFromRotationMatrix(this.matrixWorld), m3.copy(this.up).applyQuaternion(y3).negate().multiplyScalar(this.distance), this.target.position.copy(g3).add(m3), this.target.updateMatrixWorld(), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.angle !== void 0 && (this.angle = t.angle), t.penumbra !== void 0 && (this.penumbra = t.penumbra), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var Ct;
((w)=>{
    function n1() {
        return [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    w.identity = n1;
    function t(A, E = w.identity()) {
        for(let b = 0, T = A.length; b < T; b++)E[b] = A[b];
        return E;
    }
    w.copy = t;
    function e(A, E, b, T, M, C) {
        return w.setAbcdef(w.identity(), A, E, b, T, M, C);
    }
    w.create = e;
    function r(A, E, b, T, M, C, P) {
        return A[0] = E, A[1] = T, A[2] = C, A[3] = b, A[4] = M, A[5] = P, A;
    }
    w.setAbcdef = r;
    function i(A, E) {
        let [b, T, M, C, P, D] = o(A), [O, I, z, B, V, U] = o(E), j = O * b + I * M, W = O * T + I * C, k = z * b + B * M, H = z * T + B * C, X = V * b + U * M + P, q = V * T + U * C + D;
        return w.create(j, W, k, H, X, q);
    }
    w.append = i;
    function s(A, E) {
        let [b, T, M, C, P, D] = o(A), [O, I, z, B, V, U] = o(E), j = b, W = T, k = M, H = C;
        (O !== 1 || I !== 0 || z !== 0 || B !== 1) && (j = b * O + T * z, W = b * I + T * B, k = M * O + C * z, H = M * I + C * B);
        let X = P * O + D * z + V, q = P * I + D * B + U;
        return w.create(j, W, k, H, X, q);
    }
    w.prepend = s;
    function o(A) {
        return [
            A[0],
            A[3],
            A[1],
            A[4],
            A[2],
            A[5]
        ];
    }
    w.getAbcdef = o;
    function a(A) {
        let [E, b, T, M, C, P] = w.getAbcdef(A), D = E * M - b * T, O = M / D, I = -b / D, z = -T / D, B = E / D, V = (T * P - M * C) / D, U = -(E * P - b * C) / D;
        return w.create(O, I, z, B, V, U);
    }
    w.invert = a;
    function l([A, E], b) {
        let [T, M, C, P, D, O] = w.getAbcdef(b);
        return [
            T * A + C * E + D,
            M * A + P * E + O
        ];
    }
    w.apply = l;
    function u(A, E) {
        let [b, T, M, C, P, D] = w.getAbcdef(E), O = 1 / (b * C + M * -T), [I, z] = A;
        return [
            C * O * I + -M * O * z + (D * M - P * C) * O,
            b * O * z + -T * O * I + (-D * b + P * T) * O
        ];
    }
    w.applyInverse = u;
    function c(A, E, b = E) {
        let [T, M, C, P, D, O] = w.getAbcdef(A);
        return w.setAbcdef(A, T * E, M * b, C * E, P * b, D * E, O * b), A;
    }
    w.scale = c;
    function d(A, E) {
        let b = Math.cos(E), T = Math.sin(E), [M, C, P, D, O, I] = w.getAbcdef(A);
        return w.setAbcdef(A, M * b - C * T, M * T + C * b, P * b - D * T, P * T + D * b, O * b - I * T, O * T + I * b), A;
    }
    w.rotate = d;
    function h(A, E, b) {
        let [T, M] = b, C = w.translate(A, -T, -M);
        return C = w.rotate(C, E), C = w.translate(C, T, M), C;
    }
    w.rotateAround = h;
    function f(A, E, b) {
        let [T, M, C, P, D, O] = w.getAbcdef(A);
        return w.setAbcdef(A, T, M, C, P, D + E, O + b), A;
    }
    w.translate = f;
    function p(A, E, b) {
        let [T, M, C, P] = w.getAbcdef(A);
        return w.setAbcdef(A, T, M, C, P, E, b), A;
    }
    w.setTranslate = p;
    function m(A, E, b) {
        let [T, M, C, P] = w.getAbcdef(A);
        return w.setAbcdef(A, T, M, C, P, E, b), A;
    }
    w.setPosition = m;
    function g(A) {
        let [E, b, T, M] = w.getAbcdef(A), C = Math.sqrt(E * E + b * b), P = Math.sqrt(T * T + M * M);
        return [
            C,
            P
        ];
    }
    w.getScale = g;
    function y(A) {
        let [, , , , E, b] = w.getAbcdef(A);
        return [
            E,
            b
        ];
    }
    w.getPosition = y;
    function v(A, E) {
        return w.decompose(A, E).rotation;
    }
    w.getRotation = v;
    function x(A, E) {
        let [b, T, M, C, P, D] = w.getAbcdef(A), O = -Math.atan2(-M, C), I = Math.atan2(T, b), z = Math.abs(O + I), B = 0, V = [
            0,
            0
        ];
        z < 1e-5 || Math.abs(Math.PI * 2 - z) < 1e-5 ? (B = I, V[0] = V[1] = 0) : (B = 0, V[0] = O, V[1] = I);
        let U = [
            Math.sqrt(b * b + T * T),
            Math.sqrt(M * M + C * C)
        ];
        return {
            position: [
                P + (E[0] * b + E[1] * M) - E[0],
                D + (E[0] * T + E[1] * C) - E[1]
            ],
            scale: U,
            rotation: B,
            skew: V,
            pivot: E
        };
    }
    w.decompose = x;
    function S(A, E, b, T, M = [
        0,
        0
    ]) {
        let [C, P] = A, [D, O] = E, [I, z] = T, [B, V] = M, U = Math.cos(b + V) * D, j = Math.sin(b + V) * D, W = -Math.sin(b - B) * O, k = Math.cos(b - B) * O, H = C - (I * U + z * W) + I, X = P - (I * j + z * k) + z;
        return w.create(U, j, W, k, H, X);
    }
    w.compose = S;
})(Ct || (Ct = {}));
var CQ = Math.PI / 180, XRe = 180 / Math.PI;
function v3(n1, t, e, r, i, s) {
    let o = n1 - e, a = t - r;
    return o * o / (i * i) + a * a / (s * s) <= 1;
}
function x3(n1) {
    return n1 * CQ;
}
function w_(n1) {
    return {
        all: n1 = n1 || new Map,
        on: function(t, e) {
            var r = n1.get(t);
            r ? r.push(e) : n1.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var r = n1.get(t);
            r && (e ? r.splice(r.indexOf(e) >>> 0, 1) : n1.set(t, []));
        },
        emit: function(t, e) {
            var r = n1.get(t);
            r && r.slice().map(function(i) {
                i(e);
            }), (r = n1.get("*")) && r.slice().map(function(i) {
                i(t, e);
            });
        }
    };
}
var jt = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.localMatrix = Ct.identity();
        this.worldMatrix = Ct.identity();
        this.ignoreCameraZoom = !1;
        this.visible = !0;
        this._singleBBox = new Ul;
        this._recursiveBBox = new Ul;
        this.singleBBoxNeedsUpdate = !0;
        this.recursiveBBoxNeedsUpdate = !0;
        this.stateSelection = null;
        this.prevState = null;
        this.currentState = null;
        this.reversibleToState = null;
        this.currentTransitionEvent = null;
        this.previousAction = null;
        this.name = "";
        this.position = [
            0,
            0
        ];
        this.scale = [
            1,
            1
        ];
        this.rotation = 0;
        this.emitter = w_();
        this.dpr = r.dpr ?? 1, this.dataPatched = e;
    }
    project(t, e) {
        let r = this.worldMatrix;
        return e && (r = Ct.append(e.worldMatrix, r)), Ct.applyInverse(t, r);
    }
    intersects(t, e, r) {
        return this.visible && !this.data.raycastLock && this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r));
    }
    intersectsInLocalSpace(t, e) {
        let { min: r, max: i } = this.singleBBox;
        return t >= r[0] && t <= i[0] && e >= r[1] && e <= i[1];
    }
    applyTransforms(t) {
        t.setTransform(this.worldMatrix, this.ignoreCameraZoom);
    }
    get singleBBox() {
        return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges()), this._singleBBox;
    }
    get recursiveBBox() {
        return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges()), this._recursiveBBox;
    }
    updateLocalMatrix() {
        this.localMatrix = Ct.compose(this.position, this.scale, x3(this.rotation), Aa.getPivot(this.dataPatched));
    }
    updateWorldMatrix(t, e, r) {
        let i = this.parent;
        e && i !== null && i !== void 0 && i.updateWorldMatrix(t, !0, !1), t && this.updateLocalMatrix(), this.parent ? this.worldMatrix = Ct.append(this.parent.worldMatrix, this.localMatrix) : this.worldMatrix = Ct.copy(this.localMatrix), this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    get pivot() {
        return Aa.getPivot(this.data);
    }
    getCenter() {
        return [
            0,
            0
        ];
    }
    getHalfSize() {
        return [
            0,
            0
        ];
    }
    get id() {
        return this.uuid;
    }
    resetBBoxNeedsUpdateSelf() {
        this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    resetBBoxNeedsUpdate() {
        this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((t)=>{
            t.resetBBoxNeedsUpdateSelf();
        });
    }
    updateTransformState(t) {
        let e = !1;
        t.position !== void 0 && (e = !0, this.position = t.position), t.rotation !== void 0 && (e = !0, this.rotation = t.rotation), t.scale !== void 0 && (e = !0, this.scale = t.scale), e && (this.updateWorldMatrix(!0, !1, !0), this.resetBBoxNeedsUpdate());
    }
    updateByOp(t, e, r) {
        t.type === 0 && t.props.visible !== void 0 && (this.visible = t.props.visible), this.data = e, this.data = e;
        let i = t, s = wt(t.path, [
            "states",
            "*"
        ]);
        if (s !== null) {
            if (t.type === 0) {
                let [o] = s;
                if (this?.stateSelection === o) {
                    let a = {
                        ...t.props
                    };
                    if (delete a.name, Object.values(t.props).some((l)=>l === void 0)) {
                        let l = this.data;
                        if (l !== void 0) {
                            let u = Tr.zoom(l, t.path.slice(2));
                            if (u) for(let c in t.props)t.props[c] === void 0 && c in u && (a[c] = u[c]);
                        }
                    }
                    i = {
                        ...t,
                        props: a,
                        path: t.path.slice(2)
                    };
                }
            }
        } else if (t.type === 0) {
            let o = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
            if (o !== void 0) {
                if (t.props.name !== void 0 && o.name) {
                    let { name: l, ...u } = o;
                    o = u;
                }
                let a = Tr.removeOverridden(t.path, t.props, o);
                i = {
                    ...t,
                    props: a
                };
            }
        }
        this.updateByPatchedOpBase(i, wa.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), r);
    }
    changeSelectedState(t, e, r = !1) {
        if (!(this.data.states.length === 0 && !r)) {
            for (let i of this.data.states)wa.toOps(this.data, i.data).forEach((o)=>{
                let a = Rd.replaceProps(o, this.data);
                this.dataPatched = this.data, this.updateByPatchedOp(a, this.data, e);
            });
            if (t !== null) {
                let i = this.data.states.data(t);
                i && (this.dataPatched = wa.patch(this.data, i), wa.toOps(this.data, i).forEach((o)=>{
                    this.updateByPatchedOp(o, this.dataPatched, e);
                }));
            }
            r && this.updateTransformState(this.dataPatched), this.stateSelection = t;
        }
    }
    updateState(t, e) {
        t.name !== void 0 && (this.name = t.name), t.visible !== void 0 && (this.visible = t.visible), this.updateTransformState(t);
    }
    updateByPatchedOpBase(t, e, r) {
        this.dataPatched = e, this.updateByPatchedOp(t, e, r);
    }
    updateByPatchedOp(t, e, r) {
        t.path.length === 0 && t.type === 0 && this.updateState(t.props, r), this.requestRender();
    }
    traverseFrameAncestors(t) {
        this.traverseAncestors((e)=>{
            e.data.type === "frame2d" && t(e);
        });
    }
    traverseAncestors(t) {
        let e = this.parent;
        for(; e;)t(e), e = e.parent;
    }
    requestRender() {
        this.traverseFrameAncestors((t)=>{
            t.requestRender();
        });
    }
    clone(t) {
        let e = new jt(this.uuid, this.data, t);
        return e.parent = void 0, e;
    }
    addEventListener(t, e) {
        this.emitter.on(t, e);
    }
    removeEventListener(t, e) {
        this.emitter.off(t, e);
    }
    dispatchEvent(t) {
        this.emitter.emit(t.type, {
            ...t,
            target: t.target ?? this
        });
    }
    traverseSortNextHelper() {
        let t = this.parent;
        if (t) {
            let e = t.children;
            if (e) {
                let r = e.indexOf(this) + 1;
                return e[r] ? e[r] : t.traverseSortNextHelper();
            }
        }
    }
    sortNext() {
        let t = this.children;
        return t && t.length > 0 && t[0] ? t[0] : this.traverseSortNextHelper();
    }
    isDescendantOf(t) {
        t instanceof jt && (t = t.uuid);
        let e = this;
        for(; e.parent;){
            if (e.parent.uuid === t) return !0;
            e = e.parent;
        }
        return !1;
    }
};
var an = class extends jt {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.context = i;
        this.children = [];
    }
    add(e) {
        e.parent && e.parent instanceof an && e.parent.remove(e), this.children.push(e), e.parent = this;
    }
    remove(e) {
        let r = this.children.indexOf(e);
        r >= 0 && (this.children.splice(r, 1), e.parent = void 0);
    }
    traverse(e) {
        let r = e(this);
        if (r !== !0) for (let i of this.children)i instanceof an ? i.traverse(e) : r = e(i);
    }
    intersectsChildren(e, r, i, s = !1, o = []) {
        for (let a of this.children)if (a instanceof an && a.intersectsChildren(e, r, i, s, o), a.intersects(e, r, i) && (o.push(a), s)) break;
        return o;
    }
    updateWorldMatrix(e, r, i) {
        if (super.updateWorldMatrix(e, r, i), i && this.children) for (let s of this.children)s.updateWorldMatrix(e, !1, !0);
    }
    find(e) {
        let r;
        return this.traverse((i)=>{
            i.uuid === e && (r = i);
        }), r;
    }
    innerDrawChildren(e) {
        for(let r = this.children.length - 1; r >= 0; r--)this.children[r].draw(e);
    }
    resetBBoxNeedsUpdate() {
        super.resetBBoxNeedsUpdate(), this.traverse((e)=>{
            e.resetBBoxNeedsUpdateSelf();
        });
    }
    clone(e) {
        let r = new an(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
}, Ra = class extends an {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.reset(r);
    }
    reset(e) {
        this.data = e;
    }
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.innerDrawChildren(e), e.restore());
    }
    clone(e) {
        let r = new Ra(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
function PQ(n1, t) {
    let [[e, r], [i, s]] = n1, [[o, a], [l, u]] = t, c = (e - i) * (a - u) - (r - s) * (o - l);
    if (c === 0) return !1;
    let d = ((e - o) * (a - u) - (r - a) * (o - l)) / c, h = -((e - i) * (r - a) - (r - s) * (e - o)) / c;
    return d >= 0 && d <= 1 && h >= 0 && h <= 1;
}
var S3 = [
    [
        -1,
        1
    ],
    [
        -1,
        -1
    ],
    [
        1,
        -1
    ],
    [
        1,
        1
    ]
], b3 = (n1, t, e)=>{
    let r = n1.getCenter(), i = n1.getHalfSize(), s = Ct.append(t, n1.worldMatrix);
    i[0] === 0 && i[1] === 0 ? e.push(Ct.apply(r, s)) : S3.forEach((o)=>{
        let a = [
            o[0] * i[0] + r[0],
            o[1] * i[1] + r[1]
        ];
        e.push(Ct.apply(a, s));
    });
}, Ul = class {
    constructor(){
        this.matrix = Ct.identity();
        this.min = [
            1 / 0,
            1 / 0
        ];
        this.max = [
            -1 / 0,
            -1 / 0
        ];
        this.vertices = [];
        this.edges = [];
    }
    setFromObjectSize(t, e = !1) {
        t.updateWorldMatrix(), this.makeEmpty(), Ct.copy(t.worldMatrix, this.matrix);
        let r = Ct.invert(t.worldMatrix);
        this.expandByObjectSize(t, r, e);
    }
    expandByObjectSize(t, e, r = !1) {
        let i = [];
        r === !0 && t instanceof an ? t.traverse((s)=>{
            s.visible && b3(s, e, i);
        }) : b3(t, e, i), this.setFromPoints(i);
    }
    getCenter() {
        let [t, e] = this.min, [r, i] = this.getHalfSize();
        return Ct.apply([
            t + r,
            e + i
        ], this.matrix);
    }
    getSize() {
        return [
            this.max[0] - this.min[0],
            this.max[1] - this.min[1]
        ];
    }
    getHalfSize() {
        return [
            (this.max[0] - this.min[0]) * .5,
            (this.max[1] - this.min[1]) * .5
        ];
    }
    makeEmpty() {
        this.min = [
            1 / 0,
            1 / 0
        ], this.max = [
            -1 / 0,
            -1 / 0
        ];
    }
    setFromPoints(t) {
        this.makeEmpty();
        for (let e of t)this.expandByPoint(e);
    }
    expandByPoint(t) {
        this.min = [
            Math.min(this.min[0], t[0]),
            Math.min(this.min[1], t[1])
        ], this.max = [
            Math.max(this.max[0], t[0]),
            Math.max(this.max[1], t[1])
        ];
    }
    computeVertices() {
        let [t, e] = this.getHalfSize(), r = this.getCenter(), [i, s, o, a] = Ct.getAbcdef(this.matrix), l = Ct.create(i, s, o, a, r[0], r[1]);
        this.vertices = S3.map(([u, c])=>Ct.apply([
                u * t,
                c * e
            ], l));
    }
    computeEdges() {
        this.edges = [];
        for(let t = 0, e = this.vertices.length; t < e; ++t)this.edges.push([
            this.vertices[t],
            this.vertices[(t + 1) % e]
        ]);
    }
    project(t, e) {
        let r = this.matrix;
        return e && (r = Ct.append(e.worldMatrix, r)), Ct.applyInverse(t, r);
    }
    intersects(t, e, r) {
        return this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r));
    }
    intersectsInLocalSpace(t, e) {
        let { min: r, max: i } = this;
        return t >= r[0] && t <= i[0] && e >= r[1] && e <= i[1];
    }
    containsPoint(t) {
        let [e, r] = t, [i, s] = this.min, [o, a] = this.max;
        return e >= i && e <= o && r >= s && r <= a;
    }
    intersectsBBox2D(t) {
        for(let e = 0, r = this.edges.length; e < r; e++){
            let i = this.edges[e];
            for(let s = 0, o = t.edges.length; s < o; s++){
                let a = t.edges[s];
                if (PQ(i, a)) return !0;
            }
        }
        for(let e = 0, r = t.vertices.length; e < r; e++){
            let i = t.vertices[e];
            if (this.containsPoint(i)) return !0;
        }
        return !1;
    }
    ensureMinMax() {
        let t = this.min, e = this.max;
        this.min = [
            Math.min(t[0], e[0]),
            Math.min(t[1], e[1])
        ], this.max = [
            Math.max(t[0], e[0]),
            Math.max(t[1], e[1])
        ];
    }
    copy(t) {
        this.min = [
            ...t.min
        ], this.max = [
            ...t.max
        ], Ct.copy(t.matrix, this.matrix), this.computeVertices(), this.computeEdges();
    }
    clone() {
        let t = new Ul;
        return t.copy(this), t;
    }
};
var A3, _3 = new Promise((n1)=>{
    A3 = n1;
}), w3 = !1;
var Ex;

function E3() {
    if (w3) return;
    if (Ex) return Ex;
    async function n1() {
        let e = await (parcelRequire("836Xp"));
        A3(e.default ?? e), w3 = !0;
    }
    return Ex = n1(), Ex;
}
function __(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        (r.type === "Mesh" && r.geometry.type === "UIGeometry" || r.type === "Page" && r.uiFrame !== void 0) && (t = !0);
    }), t;
}
var ct, A_;
async function DQ(n1) {
    let t = await _3;
    ct || (A_ || (A_ = t({
        locateFile: ()=>n1
    })), ct = await A_);
}
var T3 = Ct.identity(), Fm = class {
    constructor(t, e = 1){
        this.canvas = t;
        this.dpr = e;
        this._width = 0;
        this._height = 0;
        this._strokeMode = "inside";
        this._layerBlur = 0;
        this._backgroundBlur = 0;
        this._dropShadowBlur = 0;
        this._dropShadowOffsetX = 0;
        this._dropShadowOffsetY = 0;
        this._dropShadowColor = pt.transparent;
        this._innerShadowBlur = 0;
        this._innerShadowOffsetX = 0;
        this._innerShadowOffsetY = 0;
        this._innerShadowSpread = 0;
        this._innerShadowColor = pt.transparent;
        this._fonts = new Map;
        try {
            let r = t.getBoundingClientRect();
            t.width = r.width * e, t.height = r.height * e;
        } catch  {
            console.log(t.width, e);
        }
        this._currentM3Transform = T3, this._currentTransform = new Float32Array(T3);
    }
    async init() {
        if (!this.wasmURL) throw Error("Your must set the wasm binary url with renderer.wasmURL = ... before you can call renderer.init");
        await DQ(this.wasmURL), this._surface = ct.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas(), this._paint = new ct.Paint, this._paint.setAntiAlias(!0), this._paintFill = this._paint.copy(), this._paintFill.setStyle(ct.PaintStyle.Fill), this._paintStroke = this._paint.copy(), this._paintStroke.setStyle(ct.PaintStyle.Stroke), this.ctx?.scale(this.dpr, this.dpr);
    }
    get currentTransform() {
        return this._currentM3Transform;
    }
    get currentTransformBuffer() {
        return this._currentTransform;
    }
    set currentTransform(t) {
        this._currentM3Transform = t, this._currentTransform.set(t);
    }
    async loadFont(t, e) {
        let r = await (await fetch(t)).arrayBuffer();
        this.registerFont(r, e);
    }
    registerFont(t, e) {
        if (this._fonts.has(e)) return;
        let r = ct.FontMgr.FromData(t);
        if (r) this._fonts.set(e, r);
        else throw new Error("Invalid font data for " + e);
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    set strokeColor(t) {
        this._paintStroke && this._paintStroke.setColor(Tx(t), ct.ColorSpace.DISPLAY_P3);
    }
    set fillColor(t) {
        this._paintFill && this._paintFill.setColor(Tx(t), ct.ColorSpace.DISPLAY_P3);
    }
    set lineWidth(t) {
        this._paintStroke && this._paintStroke.setStrokeWidth(this._strokeMode === "center" ? t : t * 2);
    }
    set strokeMode(t) {
        this._strokeMode = t;
    }
    set dropShadowBlur(t) {
        this._dropShadowBlur = t;
    }
    set dropShadowColor(t) {
        this._dropShadowColor = t;
    }
    set dropShadowOffsetX(t) {
        this._dropShadowOffsetX = t;
    }
    set dropShadowOffsetY(t) {
        this._dropShadowOffsetY = t;
    }
    set innerShadowBlur(t) {
        this._innerShadowBlur = t;
    }
    set innerShadowColor(t) {
        this._innerShadowColor = t;
    }
    set innerShadowOffsetX(t) {
        this._innerShadowOffsetX = t;
    }
    set innerShadowOffsetY(t) {
        this._innerShadowOffsetY = t;
    }
    set innerShadowSpread(t) {
        this._innerShadowSpread = t;
    }
    set layerBlur(t) {
        this._layerBlur = t;
    }
    set backgroundBlur(t) {
        this._backgroundBlur = t;
    }
    clear() {
        this.ctx?.clear(ct.TRANSPARENT);
    }
    save() {
        this.ctx?.save();
    }
    restore() {
        this.ctx?.restore();
    }
    beginPath() {
        this._currentPath?.delete(), this._currentPath = new ct.Path;
    }
    closePath() {
        let t = this._currentPath;
        if (t) {
            if (t.isEmpty()) return;
            let e = t.getBounds();
            (e[3] - e[1] || e[2] - e[0]) && t.close();
        }
    }
    fill() {
        this._paintInner(this._paintFill, !0);
    }
    stroke() {
        this._paintInner(this._paintStroke, !1);
    }
    clipRect(t, e, r, i, s = 0, o = 0, a = 0, l = 0) {
        let u = ct.XYWHRect(t, e, r, i);
        if (s === 0 && o === 0 && l === 0 && a === 0) this.ctx?.clipRect(u, ct.ClipOp.Intersect, !0);
        else {
            let c = ct.RRectXY(u, s, s);
            c[4] = c[5] = s, c[6] = c[7] = o, c[8] = c[9] = a, c[10] = c[11] = l, this.ctx?.clipRRect(c, ct.ClipOp.Intersect, !0);
        }
    }
    _applyShadowOffsetMatrix() {
        if (this.ctx) {
            let t = Ct.invert(this.currentTransform);
            this.ctx.concat(t);
            let e = Ct.translate(Ct.identity(), this._dropShadowOffsetX, this._dropShadowOffsetY);
            this.ctx.concat(e), this.ctx.concat(this._currentTransform);
        }
    }
    _applyEffectsToPaint(t, e, r = !0) {
        if (this.ctx && this._currentPath) {
            let i, s = !1;
            if (r && this._hasDropShadow()) {
                let o = t.copy();
                o.setColor(Tx(this._dropShadowColor));
                let a;
                this._dropShadowBlur > 0 && (a = ct.MaskFilter.MakeBlur(ct.BlurStyle.Normal, this._dropShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a)), this.ctx.save(), this.ctx.clipPath(this._currentPath, ct.ClipOp.Difference, !0), this._applyShadowOffsetMatrix(), e(o), this.ctx.restore(), o.delete(), a?.delete();
            }
            if (this._backgroundBlur > 0 && r) {
                this.ctx.save(), this.ctx.clipPath(this._currentPath, ct.ClipOp.Intersect, !0);
                let o = ct.ImageFilter.MakeBlur(this._backgroundBlur, this._backgroundBlur, ct.TileMode.Clamp, null), a = t.copy();
                a.setImageFilter(o), a.setAlphaf(1);
                let l = this._currentPath.computeTightBounds();
                this.ctx.saveLayer(a, l, null, ct.SaveLayerInitWithPrevious), this.ctx.drawColor(t.getColor()), this.ctx.restore(), this.ctx.restore(), a.delete(), o.delete(), s = !0;
            }
            if (this._layerBlur > 0) {
                let o = t.copy();
                i = ct.MaskFilter.MakeBlur(ct.BlurStyle.Normal, this._layerBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(i), e(o), o.delete(), i.delete(), s = !0;
            }
            if (s || e(t), r && this._hasInnerShadow()) {
                let o = new ct.Paint;
                o.setAntiAlias(!0), o.setStyle(ct.PaintStyle.Fill), o.setColor(Tx(this._innerShadowColor));
                let a;
                this._innerShadowBlur > 0 && (a = ct.MaskFilter.MakeBlur(ct.BlurStyle.Normal, this._innerShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a));
                let l = this._currentPath.computeTightBounds(), [u, c, d, h] = l, f = d - u, p = h - c;
                this.ctx.save(), this.ctx.clipPath(this._currentPath, ct.ClipOp.Intersect, !0), this.ctx.saveLayer(o, l, null, ct.SaveLayerInitWithPrevious), this.ctx?.translate(this._innerShadowOffsetX, this._innerShadowOffsetY), this.ctx.drawRect(ct.XYWHRect(-1000 - this._innerShadowOffsetX, -1000 - this._innerShadowOffsetY, 2e3 + f + Math.abs(this._innerShadowOffsetX * 2), 2e3 + p + Math.abs(this._innerShadowOffsetY * 2)), o), o.setBlendMode(ct.BlendMode.Clear), this.ctx.drawPath(this._currentPath, o), this.ctx.restore(), this.ctx.restore(), o.delete(), a?.delete();
            }
        }
    }
    _paintInner(t, e = !0) {
        if (this.ctx && this._currentPath && t) {
            let r = this.ctx, i = this._currentPath;
            this._applyEffectsToPaint(t, (s)=>{
                let o = !1;
                !e && this._strokeMode !== "center" && (r.save(), r.clipPath(i, this._strokeMode === "outside" ? ct.ClipOp.Difference : ct.ClipOp.Intersect, !0), o = !0), r.drawPath(i, s), o && r.restore();
            }, e);
        }
    }
    _hasDropShadow() {
        return this._dropShadowColor?.a > 0;
    }
    _hasInnerShadow() {
        return this._innerShadowColor?.a > 0;
    }
    ellipse(t, e, r, i, s, o, a, l) {
        if (!M3([
            t,
            e,
            r,
            i
        ]) || !this._currentPath) return;
        if (r < 0 || i < 0) throw Error("radii cannot be negative");
        let u = ct.XYWHRect(t - r, e - i, r * 2, i * 2);
        this._currentPath?.addOval(u);
    }
    rect(t, e, r, i, s = 0, o = 0, a = 0, l = 0) {
        let u = ct.XYWHRect(t, e, r, i);
        if (!!M3(u)) {
            if (s === 0 && o === 0 && l === 0 && a === 0) this._currentPath?.addRect(u);
            else {
                let c = ct.RRectXY(u, s, s);
                c[4] = c[5] = s, c[6] = c[7] = o, c[8] = c[9] = a, c[10] = c[11] = l, this._currentPath?.addRRect(c);
            }
        }
    }
    getHorizontalAlign(t) {
        switch(t){
            case 2:
                return ct.TextAlign.Right;
            case 3:
                return ct.TextAlign.Center;
            case 4:
                return ct.TextAlign.Justify;
            case 1:
            default:
                return ct.TextAlign.Left;
        }
    }
    drawTextInner(t, e, r, [i, s, o, a], l, u, c = !0) {
        let d = 0, { ctx: h } = this;
        if (!h) return d;
        let f = u.copy(), p = u.copy();
        return p.setAlphaf(0), this._applyEffectsToPaint(f, (m)=>{
            e.pushPaintStyle(r, m, p), e.addText(t);
            let g = e.build();
            g.layout(o);
            let y = s;
            l === 2 ? y += (a - g.getHeight()) / 2 : l === 3 && (y += a - g.getHeight()), h.drawParagraph(g, i, y), d = g.getHeight(), e.reset(), g.delete();
        }, c), f.delete(), p.delete(), d;
    }
    drawText(t, e) {
        let r = 0, i = this._fonts.get(e.font), { ctx: s, _paintFill: o, _paintStroke: a } = this;
        if (i && s) {
            let l = new ct.TextStyle({
                fontFamilies: [
                    e.font
                ],
                fontSize: e.fontSize,
                heightMultiplier: e.lineHeight,
                letterSpacing: e.letterSpacing
            }), u = new ct.ParagraphStyle({
                textStyle: l,
                textAlign: this.getHorizontalAlign(e.horizontalAlign)
            }), c = ct.XYWHRect(e.x, e.y, e.width, e.height), d = ct.ParagraphBuilder.Make(u, i);
            o && (r = this.drawTextInner(t, d, l, c, e.verticalAlign, o, !0)), a && (r = this.drawTextInner(t, d, l, c, e.verticalAlign, a, !1)), d.delete();
        }
        return {
            height: r
        };
    }
    render() {
        this._surface?.flush();
    }
    moveTo(t, e) {
        this._currentPath?.moveTo(t, e);
    }
    lineTo(t, e) {
        this._currentPath?.lineTo(t, e);
    }
    bezierCurveTo(t, e, r, i, s, o) {
        this._currentPath?.cubicTo(t, e, r, i, s, o);
    }
    quadraticCurveTo(t, e, r, i) {
        this._currentPath?.quadTo(t, e, r, i);
    }
    setTransform(t, e = !1) {
        if (!this.ctx) return;
        let r = this.ctx.getTotalMatrix(), i = Ct.invert(r);
        if (i && this.ctx.concat(i), this.ctx?.scale(this.dpr, this.dpr), this.camera?.enabled && (this.ctx?.concat(this.camera.worldMatrix), e)) {
            let s = Ct.getScale(this.camera.worldMatrix);
            this.ctx?.scale(1 / s[0], 1 / s[1]);
        }
        this.ctx?.concat(t), this.currentTransform = t;
    }
    transform(t) {
        this.ctx?.concat(t);
    }
    setSize(t, e) {
        t === this._width && e === this._height || (this._width = t, this._height = e, this.canvas.style.width = t + "px", this.canvas.style.height = e + "px", this.canvas.width = t * this.dpr, this.canvas.height = e * this.dpr, this._surface && (this._surface = ct.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas()));
    }
};
function M3(n1) {
    for(let t = 0; t < n1.length; t++)if (n1[t] !== void 0 && !Number.isFinite(n1[t])) return !1;
    return !0;
}
function Tx({ r: n1, g: t, b: e, a: r }) {
    return ct.Color4f(n1, t, e, r);
}
var km = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = pt.transparent;
        this.blurRadius = 0;
        this.offset = [
            0,
            0
        ];
        this.spread = 0;
        this.update(e);
    }
    update(t) {
        t.color !== void 0 && (this.color = t.color), t.enabled !== void 0 && (this.enabled = t.enabled), t.blurRadius !== void 0 && (this.blurRadius = t.blurRadius), t.offset !== void 0 && (this.offset = t.offset), t.spread !== void 0 && (this.spread = t.spread);
    }
};
var zm = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.radius = 0;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.radius !== void 0 && (this.radius = t.radius);
    }
};
var Mx = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = pt.transparent;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color);
    }
};
var Cx = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = pt.transparent;
        this.thickness = 0;
        this.mode = "inside";
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color), t.thickness !== void 0 && (this.thickness = t.thickness), t.mode !== void 0 && (this.mode = t.mode);
    }
};
var Ar = class extends jt {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.fill = new Mx(e + "-fill", r.fill, i), this.stroke = new Cx(e + "-stroke", r.stroke, i), this.dropShadow = new km(e + "-dropShadow", r.dropShadow, i), this.innerShadow = new km(e + "-innerShadow", r.innerShadow, i), this.backgroundBlur = new zm(e + "-backgroundBlur", r.backgroundBlur, i), this.layerBlur = new zm(e + "-layerBlur", r.layerBlur, i);
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : pt.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : pt.transparent, e.strokeMode = this.stroke.mode, e.lineWidth = this.stroke.thickness;
    }
    applyFilters(e) {
        this.layerBlur.enabled ? e.layerBlur = this.layerBlur.radius * 5 : e.layerBlur = 0, this.backgroundBlur.enabled ? e.backgroundBlur = this.backgroundBlur.radius * 5 : e.backgroundBlur = 0, this.dropShadow.enabled ? (e.dropShadowBlur = this.dropShadow.blurRadius * 5, e.dropShadowColor = this.dropShadow.color, e.dropShadowOffsetX = this.dropShadow.offset[0], e.dropShadowOffsetY = this.dropShadow.offset[1]) : e.dropShadowColor = pt.transparent, this.innerShadow.enabled ? (e.innerShadowSpread = this.innerShadow.spread, e.innerShadowBlur = this.innerShadow.blurRadius * 5, e.innerShadowColor = this.innerShadow.color, e.innerShadowOffsetX = this.innerShadow.offset[0], e.innerShadowOffsetY = this.innerShadow.offset[1]) : e.innerShadowColor = pt.transparent;
    }
    innerDraw(e) {}
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.applyFilters(e), this.applyFillStroke(e), e.beginPath(), this.innerDraw(e), e.closePath(), this.fill.enabled && e.fill(), this.stroke.enabled && e.stroke(), e.restore());
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (wt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : wt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : wt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : wt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : wt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : wt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    updateState(e, r) {
        super.updateState(e, r), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur);
    }
    clone(e) {
        let r = new Ar(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Gl = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.ellipse(this.width * .5, this.height * .5, this.width * .5, this.height * .5, 0, 0, Math.PI * 2);
    }
    intersectsInLocalSpace(e, r) {
        return v3(e, r, this.width * .5, this.height * .5, this.width * .5, this.height * .5);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e);
    }
    clone(e) {
        let r = new Gl(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var ws = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.cornerRadius = [
            0,
            0,
            0,
            0
        ];
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.rect(0, 0, this.width, this.height, ...this.cornerRadius);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e);
    }
    clone(e) {
        let r = new ws(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var jl = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this._textHeight = 0;
        this._textHeightDirty = !0;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    get textHeight() {
        return this._textHeight;
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : pt.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : pt.transparent, e.strokeMode = "center", e.lineWidth = this.stroke.thickness;
    }
    innerDraw(e) {
        this._fontHolder?.arrayBuffer && this._fontHolder.arrayBuffer.byteLength > 1 && this.data.font && e.registerFont(this._fontHolder.arrayBuffer, this.data.font);
        let r = this.data.textTransform, i = this.data.text.textValue.toString(), s = r === 2 ? i.toUpperCase() : r === 3 ? i.toLowerCase() : i, { height: o } = e.drawText(s, {
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            fontSize: this.data.fontSize,
            lineHeight: this.data.lineHeight ?? 1,
            letterSpacing: this.data.letterSpacing ?? 0,
            horizontalAlign: this.data.horizontalAlign,
            verticalAlign: this.data.verticalAlign,
            font: this.data.font
        });
        this._textHeight = o;
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateFontState(e, { shared: r }) {
        e.font !== void 0 && (this._fontHolder = r.getFont(e.font), this._fontHolder && !this._fontHolder.isLoaded && this._fontHolder.loadingPromise.then(()=>{
            this.requestRender();
        }));
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateFontState(e, r);
    }
    clone(e) {
        let r = new jl(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Af = class extends Ar {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.curves = [];
        this.extremasBBox = {
            min: [
                0,
                0
            ],
            max: [
                0,
                0
            ]
        };
        this.updateState(r, i);
    }
    computeExtremas() {
        this.curves.length === 0 && this.computeCurves();
        let e = this.curves.map((s)=>Px.extremas(s)), r = [
            1 / 0,
            1 / 0
        ], i = [
            -1 / 0,
            -1 / 0
        ];
        for(let s = 0, o = e.length; s < o; s++){
            let a = e[s];
            a[0][0] < r[0] && (r[0] = a[0][0]), a[0][1] < r[1] && (r[1] = a[0][1]), a[1][0] > i[0] && (i[0] = a[1][0]), a[1][1] > i[1] && (i[1] = a[1][1]);
        }
        return this.extremasBBox.min = [
            r[0],
            r[1]
        ], this.extremasBBox.max = [
            i[0],
            i[1]
        ], this.extremasBBox;
    }
    computeCurves() {
        this.curves = [];
        for(let i = 1, s = this.data.points.length; i < s; i++){
            let o = this.data.points[i].data, a = this.data.points[i - 1].data, l = {
                start: a.position,
                cp1: a.controlNext.position,
                cp2: o.controlPrevious.position,
                end: o.position
            };
            this.curves.push(l);
        }
        let e = this.data.points[0].data, r = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let i = {
                start: r.position,
                cp1: r.controlNext.position,
                cp2: e.controlPrevious.position,
                end: e.position
            };
            this.curves.push(i);
        }
    }
    getCenter() {
        let [e, r] = this.extremasBBox.min, [i, s] = this.getHalfSize();
        return [
            e + i,
            r + s
        ];
    }
    getHalfSize() {
        let { min: e, max: r } = this.extremasBBox;
        return [
            (r[0] - e[0]) * .5,
            (r[1] - e[1]) * .5
        ];
    }
    innerDraw(e) {
        for(let s = 0, o = this.data.points.length; s < o; s++){
            let a = this.data.points[s].data;
            if (s === 0) {
                let [l, u] = a.position;
                e.moveTo(l, u);
            } else {
                let l = this.data.points[s - 1].data, [u, c] = l.controlNext.position, [d, h] = a.controlPrevious.position, [f, p] = a.position, m = {
                    start: l.position,
                    cp1: l.controlNext.position,
                    cp2: a.controlPrevious.position,
                    end: a.position
                };
                Px.derive(m), e.bezierCurveTo(u, c, d, h, f, p);
            }
        }
        let r = this.data.points[0].data, i = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let [s, o] = i.controlNext.position, [a, l] = r.controlPrevious.position, [u, c] = r.position;
            e.bezierCurveTo(s, o, a, l, u, c);
        }
    }
    updateState(e, r) {
        super.updateState(e, r), this.computeExtremas();
    }
    clone(e) {
        let r = new Af(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
}, Px;
((s)=>{
    function n1(o) {
        let a = o.start, l = o.cp1, u = o.cp2, c = o.end, d = [
            3 * (l[0] - a[0]),
            3 * (l[1] - a[1])
        ], h = [
            3 * (u[0] - l[0]),
            3 * (u[1] - l[1])
        ], f = [
            3 * (c[0] - u[0]),
            3 * (c[1] - u[1])
        ], p = {
            start: d,
            cp: h,
            end: f
        };
        return o.derivative = p, p.derivative = E_.derive(p), p;
    }
    s.derive = n1;
    function t(o, a, l, u = !1) {
        let c = o - 2 * a + l;
        if (c !== 0) {
            let d = -Math.sqrt(Math.abs(a * a - o * l)), h = -o + a, f = -(d + h) / c, p = -(-d + h) / c;
            return [
                f,
                p
            ];
        } else if (a !== l && c === 0) return [
            (2 * a - l) / (2 * (a - l))
        ];
        return [];
    }
    function e(o) {
        let a = o.derivative ?? s.derive(o), l = a.start, u = a.cp, c = a.end;
        return [
            t(l[0], u[0], c[0]),
            t(l[1], u[1], c[1])
        ];
    }
    s.droot = e;
    function r(o) {
        let [a, l] = s.droot(o), u = [
            o.start[0],
            o.end[0]
        ], c = [
            o.start[1],
            o.end[1]
        ];
        for (let d of a)u.push(s.compute(o, Math.min(1, Math.max(0, d)))[0]);
        for (let d of l)c.push(s.compute(o, Math.min(1, Math.max(0, d)))[1]);
        return u.sort((d, h)=>d - h), c.sort((d, h)=>d - h), [
            [
                u[0],
                c[0]
            ],
            [
                u[u.length - 1],
                c[c.length - 1]
            ]
        ];
    }
    s.extremas = r;
    function i(o, a) {
        if (a === 0) return [
            ...o.start
        ];
        if (a === 1) return [
            ...o.end
        ];
        let l = 1 - a, u = l * l, c = a * a, d = u * l, h = u * a * 3, f = l * c * 3, p = a * c;
        return [
            d * o.start[0] + h * o.cp1[0] + f * o.cp2[0] + p * o.end[0],
            d * o.start[1] + h * o.cp1[1] + f * o.cp2[1] + p * o.end[1]
        ];
    }
    s.compute = i;
})(Px || (Px = {}));
var E_;
((r)=>{
    function n1(i) {
        let s = i.start, o = i.cp, a = i.end, l = [
            2 * (o[0] - s[0]),
            2 * (o[1] - s[1])
        ], u = [
            2 * (a[0] - o[0]),
            2 * (a[1] - o[1])
        ], c = {
            start: l,
            end: u
        };
        return c.derivative = T_.derive(c), i.derivative = c, c;
    }
    r.derive = n1;
    function t(i) {
        let s = i.derivative ?? r.derive(i), o = s.start, a = s.end;
        return [
            o[0] !== a[0] ? o[0] / (o[0] - a[0]) : 0,
            o[1] !== a[1] ? o[1] / (o[1] - a[1]) : 0
        ];
    }
    r.droot = t;
    function e(i, s) {
        if (s === 0) return [
            ...i.start
        ];
        if (s === 1) return [
            ...i.end
        ];
        let o = 1 - s, a = o * o, l = s * s, u = a, c = o * s * 2, d = l;
        return [
            u * i.start[0] + c * i.cp[0] + d * i.end[0],
            u * i.start[1] + c * i.cp[1] + d * i.end[1]
        ];
    }
    r.compute = e;
})(E_ || (E_ = {}));
var T_;
((e)=>{
    function n1(r) {
        let i = r.start, s = r.end, o = [
            s[0] - i[0],
            s[1] - i[1]
        ];
        return r.derivative = o, r.derivative;
    }
    e.derive = n1;
    function t(r, i) {
        if (i === 0) return [
            ...r.start
        ];
        if (i === 1) return [
            ...r.end
        ];
        let s = r.start, o = r.end;
        return [
            s[0] + (o[0] - s[0]) * i,
            s[1] + (o[1] - s[1]) * i
        ];
    }
    e.compute = t;
})(T_ || (T_ = {}));
var Zi = class extends an {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.width = 0;
        this.height = 0;
        this.background = new ws(e + "-background", Zd.defaultData, i), this.background.parent = this, this.updateState(r, i);
    }
    get fill() {
        return this.background.fill;
    }
    get stroke() {
        return this.background.stroke;
    }
    get backgroundBlur() {
        return this.background.backgroundBlur;
    }
    get layerBlur() {
        return this.background.layerBlur;
    }
    get dropShadow() {
        return this.background.dropShadow;
    }
    get innerShadow() {
        return this.background.innerShadow;
    }
    get cornerRadius() {
        return this.background.cornerRadius;
    }
    set cornerRadius(e) {
        this.background.cornerRadius = e;
    }
    updateLocalMatrix() {
        super.updateLocalMatrix(), this.background?.updateLocalMatrix();
    }
    updateWorldMatrix(e, r, i) {
        super.updateWorldMatrix(e, r, i), this.background?.updateWorldMatrix(e, r, i);
    }
    draw(e) {
        if (!this.visible) return;
        e.save();
        let r = this.width, i = this.height;
        this.applyTransforms(e), this.background.width = r, this.background.height = i, this.background.draw(e), e.clipRect(0, 0, r, i, ...this.cornerRadius), this.innerDrawChildren(e), e.restore();
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur);
    }
    requestRender() {
        super.requestRender(), this.dispatchEvent({
            type: "render"
        });
    }
    dispose() {
        this.removeEventListener("render");
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (wt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : wt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : wt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : wt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : wt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : wt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    clone(e) {
        let r = new Zi(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
function C3(n1, t, e) {
    switch(t.type){
        case "ellipse2d":
            return new Gl(n1, t, e);
        case "rectangle2d":
            return new ws(n1, t, e);
        case "text2d":
            return new jl(n1, t, e);
        case "vector2d":
            return new Af(n1, t, e);
        case "frame2d":
            return new Zi(n1, t, e);
        case "group2d":
        default:
            return new Ra(n1, t, e);
    }
}
var M_ = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.group = new Ra(M_.GROUP_ID, {
            ...Xp.defaultData
        }, r), this.createChildrenObjects(e.objects, this.group, r);
    }
    createObject(t, e, r, i, s, o) {
        let a = C3(t, e, o);
        a && (i.add(a), i.children.splice(s, 0, i.children.pop()), a.updateWorldMatrix(), r.length > 0 && (a instanceof Ra || a instanceof Zi) && this.createChildrenObjects(r, a, o));
    }
    createChildrenObjects(t, e, r) {
        let i = 0;
        for (let s of t)this.createObject(s.id, s.data, s.children, e, i, r), i += 1;
    }
    draw(t) {
        this.group.draw(t);
    }
    updateEntityByOp(t, e, r, i) {
        let s = this.find(t);
        if (s) try {
            s.updateByOp(e, r, {
                shared: i
            });
        } catch (o) {
            console.error(o);
        }
    }
    updateTreeByOp(t, e) {
        if (t.path.length === 0 && t.type === 7) {
            let r = t.parent === null ? this.group : this.find(t.parent);
            r !== void 0 && r instanceof an && (this.createObject(t.id, t.data, t.children, r, t.localIndex, e), r.requestRender());
        } else if (t.path.length === 0 && t.type === 8) {
            let r = this.find(t.id);
            if (r !== void 0 && r.parent !== void 0 && r.parent instanceof an) {
                let i = r.parent;
                r.resetBBoxNeedsUpdate(), i?.remove(r), i?.requestRender();
            }
        } else if (t.path.length === 0 && t.type === 9) {
            let r = this.find(t.id);
            if (r !== void 0) {
                let i = r.parent, s = t.parent === null ? this : this.find(t.parent);
                if (s, s instanceof an || s === this) {
                    s.add(r);
                    let o = t.localIndex;
                    s.children.splice(o, 0, s.children.pop()), r.updateWorldMatrix(!0, !1, !0), i?.requestRender(), r.requestRender();
                }
                r.resetBBoxNeedsUpdate();
            }
        }
    }
    add(t) {
        this.group.add(t);
    }
    remove(t) {
        this.group.remove(t);
    }
    traverse(t) {
        this.group.traverse((e)=>{
            e !== this.group && t(e);
        });
    }
    intersectsChildren(t, e, r, i = !1, s = []) {
        return this.group.intersectsChildren(t, e, r, i, s);
    }
    find(t) {
        return this.group.find(t);
    }
    get children() {
        return this.group.children;
    }
    project(t, e) {
        return this.group.project(t, e);
    }
    getWithSortKey(t) {
        let e = this.find(t);
        if (e === void 0) return;
        let r = [], i = e;
        for(; i !== this.group;){
            let s = i;
            i = i.parent;
            let o = i.children.indexOf(s);
            r.splice(0, 0, o);
        }
        return {
            entity: e,
            sortKey: r
        };
    }
    getAllSorted(t) {
        let e = [];
        for (let r of t){
            let i = this.getWithSortKey(r.id);
            i !== void 0 && e.push(i);
        }
        return e.sort((r, i)=>nv(r.sortKey, i.sortKey)), e.map((r)=>r.entity);
    }
}, Jc = M_;
Jc.GROUP_ID = "scene2d";
function C_({ constraints: n1, newParentWidth: t, newParentHeight: e, initialParentWidth: r, initialParentHeight: i, objectInitialWidth: s, objectInitialHeight: o, objectInitialPosition: a }) {
    let { horizontalConstraint: l, verticalConstraint: u } = n1, c = t - r, d = e - i, h = s, f = o, p = a[0], m = a[1];
    if (l !== 0) {
        if (l === 1) p += c;
        else if (l === 3) p += c / 2;
        else if (l === 2) h = Math.max(1, h + c);
        else if (l === 4) {
            let g = t / r;
            h *= g, p *= g;
        }
    }
    if (u !== 0) {
        if (u === 1) m += d;
        else if (u === 3) m += d / 2;
        else if (u === 2) f = Math.max(1, f + d);
        else if (u === 4) {
            let g = e / i;
            f *= g, m *= g;
        }
    }
    return {
        width: h,
        height: f,
        position: [
            p,
            m
        ]
    };
}
var OQ = Ct.identity(), _f = class {
    constructor(t, e, r, i){
        this.uuid = t;
        this.width = e;
        this.height = r;
        this.context = i;
        this.enabled = !0;
        this.isScreenSpace = !1;
        this.isFrameDirty = !1;
        this.onRenderRequestedDownstream = ()=>{
            this.isFrameDirty = !0, this.context.shared.requestRender();
        };
        this.onFrameOverrideObjectEvent = (t)=>{
            if (t.target?.uuid !== void 0) {
                let e = this.frameRoot?.find(t.target.uuid);
                e && e.dispatchEvent({
                    ...t,
                    target: e
                });
            }
        };
        this.scene2d = new Jc(Se.generateUUID(), Jv.defaultData, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }), this.canvas = document.createElement("canvas"), this.renderer = new Fm(this.canvas), i.shared.addCanvas(this.uuid, this.canvas), this.textureHolder = i.shared.canvas(this.uuid), this.promise = this.init();
    }
    async init() {
        this.renderer instanceof Fm && (this.renderer.wasmURL = z0.skiaWasmUrl), await this.renderer.init();
    }
    render() {
        this.isFrameDirty && (this.renderer.clear(), this.frameOverride?.draw(this.renderer), this.renderer.render(), this.textureHolder?.setNeedsUpdate(!0), this.isFrameDirty = !1);
    }
    updateEntity2DByOp(t, e, r, i) {
        this.scene2d.updateEntityByOp(t, e, r, i), this.applySize();
    }
    updateTreeByOp(t, e) {
        this.scene2d.updateTreeByOp(t, e), this.applySize();
    }
    applyOverrides(t) {
        if (this.frameOverride && this.frameRoot) {
            this.frameOverride.position = [
                0,
                0
            ], this.frameOverride.rotation = 0;
            let e = t?.width ?? this.width, r = t?.height ?? this.height;
            this.frameOverride.width = e, this.frameOverride.height = r, this.frameOverride.localMatrix = OQ, this.isScreenSpace && (this.frameOverride.fill.color = pt.from0to1([
                0,
                0,
                0,
                0
            ])), this.frameOverride.data = {
                ...this.frameOverride.data,
                width: e,
                height: r
            }, P3({
                objectOverride: this.frameOverride,
                objectRoot: this.frameRoot,
                newParentWidth: this.frameOverride.width,
                newParentHeight: this.frameOverride.height,
                initialParentWidth: this.frameRoot.width,
                initialParentHeight: this.frameRoot.height
            }), this.frameOverride.updateWorldMatrix(!0, !1, !0);
        }
    }
    applySize(t) {
        let e = t?.width ?? this.width, r = t?.height ?? this.height;
        this.width = e, this.height = r, this.renderer.dpr = this.isScreenSpace ? window.devicePixelRatio : Math.floor(2048 / Math.max(e, r)), this.renderer.setSize(e, r), this.textureHolder?.dispose(), this.applyOverrides(t), this.frameOverride?.requestRender();
    }
    applyFrame(t) {
        let e = this.context.scene.find2D(t);
        if (!(!e || !(e instanceof Zi))) return this.disposeFrameOverride(), this.frameRoot = e, this.frameOverride = e.clone({
            dpr: this.renderer.dpr,
            shared: this.context.shared
        }), this.scene2d.add(this.frameOverride), this.applySize(), this.textureHolder?.dispose(), this.frame?.addEventListener("render", this.onRenderRequestedDownstream), this.frameOverride.traverse((r)=>{
            r.addEventListener("beginState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride.traverse((r)=>{
            r.addEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frame?.requestRender(), e;
    }
    get frame() {
        return this.frameOverride;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    find(t) {
        return this.scene2d.find(t);
    }
    get texture() {
        return this.textureHolder?.getTexture(1001);
    }
    disposeFrameOverride() {
        this.frameOverride?.removeEventListener("render", this.onRenderRequestedDownstream), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("beginStateChange", this.onFrameOverrideObjectEvent);
        }), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride && this.scene2d.remove(this.frameOverride);
    }
};
function P3({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s }) {
    if (n1 instanceof Zi && t instanceof Zi) for(let o = 0, a = n1.children.length; o < a; o++){
        let l = n1.children[o], u = t.children[o];
        l && u && l.uuid === u.uuid && IQ({
            objectOverride: l,
            objectRoot: u,
            newParentWidth: e,
            newParentHeight: r,
            initialParentWidth: i,
            initialParentHeight: s
        });
    }
}
function IQ({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s }) {
    let { width: o, height: a, position: l } = C_({
        constraints: n1.data,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s,
        objectInitialWidth: P_(t) ? t.width : 0,
        objectInitialHeight: P_(t) ? t.height : 0,
        objectInitialPosition: t.position
    });
    if (n1.position = l, n1.data = {
        ...n1.data,
        position: l
    }, n1.states) for(let u in n1.states)RQ({
        stateId: u,
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s
    });
    P_(n1) && (n1.width = o, n1.height = a, n1.data = {
        ...n1.data,
        width: o,
        height: a
    }, P3({
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: n1.width,
        newParentHeight: n1.height,
        initialParentWidth: t.width,
        initialParentHeight: t.height
    }));
}
function RQ({ stateId: n1, objectOverride: t, objectRoot: e, newParentWidth: r, newParentHeight: i, initialParentWidth: s, initialParentHeight: o }) {
    let a = t.states?.[n1], l = e.states?.[n1];
    if (a && l) {
        let { width: u, height: c, position: d } = C_({
            constraints: t.data,
            newParentWidth: r,
            newParentHeight: i,
            initialParentWidth: s,
            initialParentHeight: o,
            objectInitialWidth: Aa.isResizeable(l) ? l.width : 0,
            objectInitialHeight: Aa.isResizeable(l) ? l.height : 0,
            objectInitialPosition: l.position
        });
        Object.assign(t.states[n1], {
            position: d
        }), Aa.isResizeable(a) && Object.assign(t.states[n1], {
            width: u,
            height: c
        });
    }
}
function P_(n1) {
    return n1 instanceof ws || n1 instanceof Zi || n1 instanceof Gl || n1 instanceof jl;
}
var sr = class extends ph(vi) {
    constructor(e, r, i){
        super();
        this.data = r;
        this.bgColor = new cr(1, 1, 1, 1);
        this.fog = null;
        this.backupFog = new Iu(16777215, .1, 2e3);
        this.fogUseBGColor = !1;
        this.isActive = !1;
        this.aoColor = new Le;
        this.penumbraSizeArrayCache = null;
        this.super_Entity(e, r), this.personalCamera = new hr(us, {
            ...Dc.defaultData,
            ...r.camera,
            name: "Personal Camera"
        }), this.personalCamera.objectHelper.visible = !1, this.add(this.personalCamera), this.activeCamera = this.personalCamera, this.ambientLight = new gy(13882323, 8553090, .75), this.ambientLight.name = "Default Ambient Light", this.ambientLight.layers.enable(3), this.ambientLight.removeFromParent(), this.add(this.ambientLight), r.uiScene ? this.uiScene = new Jc((Array.isArray(e) ? e[0] : e) + "-ui", r.uiScene, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }) : r.uiFrame && this.createUICanvas(r.uiFrame, i);
    }
    get scene() {
        return this.parent;
    }
    get postprocessing() {
        return this.data.postprocessing;
    }
    get frameId() {
        return this.data.uiFrame;
    }
    get frame() {
        return this.uiCanvas?.frame;
    }
    createUICanvas(e, r) {
        this.uiCanvas = new _f(this.uuid + "-uiscreen", window.innerWidth, window.innerHeight, r), this.uiCanvas.isScreenSpace = !0, this.uiCanvas.promise.then(()=>{
            this.uiCanvas?.applyFrame(e), this.uiCanvas?.applySize();
        });
    }
    updateVisible() {}
    setBackgroundColor(e) {
        this.bgColor = e, this.fogUseBGColor === !0 && (this.backupFog.color = e);
    }
    entityChildrenCount() {
        return this.uiScene ? this.uiScene.children.length : super.entityChildrenCount();
    }
    updateAmbientLight(e, r) {
        e.color !== void 0 && (this.ambientLight.color = Ki(e.color, r)), e.intensity !== void 0 && (this.ambientLight.intensity = e.intensity), e.enabled !== void 0 && (e.enabled ? this.add(this.ambientLight) : this.remove(this.ambientLight));
    }
    onDeactive() {
        this.isActive = !1;
    }
    onActive(e) {
        this.isActive = !0, e.fog = this.fog, this.traverseEntity((r)=>{
            r instanceof Ln && r.recomputeBoolean();
        }), this.updateShadow(this.data.shadow);
    }
    forceMaterialsUpdate() {
        this.traverseEntity((e)=>{
            if (e instanceof gs) {
                if (Array.isArray(e.material)) for (let r of e.material)r.needsUpdate = !0;
                else e.material.needsUpdate = !0, e.material.dispose();
            }
        });
    }
    updateShadow(e) {
        e.softShadowQuality !== void 0 && this.isActive && f3(e.softShadowQuality) && this.forceMaterialsUpdate();
    }
    updateFog(e, r) {
        if (e.enabled ? this.fog = this.backupFog : this.fog = null, this.isActive) {
            let i = this.scene;
            i.fog = this.fog;
        }
        this.fogUseBGColor = e.useBackgroundColor, e.useBackgroundColor ? this.backupFog.color.set(this.bgColor) : this.backupFog.color = Ki(e.color, r), this.backupFog.near = e.near, this.backupFog.far = e.far;
    }
    updateAo(e, r) {
        e.aoColor !== void 0 && (this.aoColor = Ki(e.aoColor, r));
    }
    updateByOp(e, r, i, s) {
        let o = this.data.uiFrame;
        super.updateByOp(e, r, i, s);
        let a = r;
        wt(e.path, [
            "fog"
        ]) ? this.updateFog(a.fog, i.shared) : wt(e.path, [
            "ao"
        ]) ? this.updateAo(a.ao, i.shared) : wt(e.path, [
            "ambient"
        ]) ? this.updateAmbientLight(a.ambient, i.shared) : wt(e.path, [
            "shadow"
        ]) ? this.updateShadow(a.shadow) : e.type === 0 && e.path.length === 0 && (e.props.uiFrame !== void 0 || o !== a.uiFrame) && this.updateUIFrame(e.props.uiFrame, i);
    }
    updateUIFrame(e, r) {
        e ? (this.uiCanvas || this.createUICanvas(e, r), this.uiCanvas.enabled = !0, this.uiCanvas.applyFrame(e)) : this.uiCanvas && (this.uiCanvas.enabled = !1);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r), e.backgroundColor !== void 0 && this.setBackgroundColor(Ki(e.backgroundColor, r.shared)), e.fog !== void 0 && this.updateFog(e.fog, r.shared), e.ambient !== void 0 && this.updateAmbientLight(e.ambient, r.shared), e.ao !== void 0 && this.updateAo(e.ao, r.shared), e.shadow !== void 0 && this.updateShadow(e.shadow);
    }
    createFrame(e, r) {}
    raycast(e, r) {
        super.raycast(e, r);
    }
    switchActiveCamera(e) {
        e && e.isDescendantOf(this) && (this.activeCamera !== this.personalCamera && (this.activeCamera.objectHelper.visible = !0), this.activeCamera = e, e.objectHelper.visible = !1);
    }
    get playCamera() {
        return this.scene?.find(this.data.publish.playCamera) ?? this.personalCamera;
    }
    switchToPlayCamera() {
        this.switchActiveCamera(this.playCamera);
    }
    get penumbraSizeArray() {
        return this.penumbraSizeArrayCache === null && this.updatePenumbraSizeArray(), this.penumbraSizeArrayCache;
    }
    updatePenumbraSizeArray() {
        this.penumbraSizeArrayCache = new Array(5).fill(.5);
        let e = 0, r = 0;
        this.traverseEntity((i)=>{
            if (!i.visible) return !0;
            i instanceof Sf && i.visible && e < 3 && (this.penumbraSizeArrayCache[e] = i.data.penumbraSize, e += 1), i instanceof wf && i.visible && e < 2 && (this.penumbraSizeArrayCache[3 + r] = i.data.penumbraSize, r += 1);
        });
    }
    raycastWithClones(e) {
        let r = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                ut.is(o) && (o.visible || a?.object.data.visible) && ((sn(o) || Om(o) && this.scene.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Vm(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    updateEntity2DByOp(e, r, i, s) {
        this.uiCanvas?.updateEntity2DByOp(e, r, i, s);
    }
};
var Dx = class extends of(vy, bf) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = 90, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new _(-s.far + this.position.x, -s.far + this.position.y, -s.far + this.position.z), a = new _(s.far + this.position.x, s.far + this.position.y, s.far + this.position.z), l = new Bt(o, a), u = new sl(l, new Le(16755200));
        u.visible = !1, this.gizmos.shadowmap = u, this.update();
    }
    update() {
        if (this.shadow && (this.shadow.camera.updateProjectionMatrix(), this.gizmos)) for(let t in this.gizmos){
            let e = this.gizmos[t];
            if (e instanceof sl) {
                let r = this.shadow.camera, i = new _(-r.far + this.position.x, -r.far + this.position.y, -r.far + this.position.z), s = new _(r.far + this.position.x, r.far + this.position.y, r.far + this.position.z);
                e.box.set(i, s), e.updateMatrixWorld(!0);
            }
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var Ox = class extends er {
    get forceComputeSize() {
        return !0;
    }
    get shape() {
        return this.geometry.userData.shape;
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? pm(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var Hl = class extends er {
    constructor(e, r, i){
        super(e, r, i);
        this._shapeId = null;
        this._context = i;
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateShape();
    }
    updateShape() {
        let e = {
            ...this.data.geometry.extrusion.shape
        };
        for(let s in e)typeof e[s] == "string" && (e[s] = this._context.shared.getVariable(e[s], [
            this.uuid,
            "geometry",
            "extrusion",
            "shape",
            s
        ]));
        let r;
        if (e.type === "Custom") {
            let s = e.shapeId;
            if (s !== this._shapeId && this.detachShape(), s) {
                this._shapeId = s;
                let o = this._context.scene.find(s);
                o?.data && (o.attachedPaths.add(this), r = o.geometry.userData?.shape), r || this._context.scene.addPendingCommand(()=>this.updateShape());
            }
        } else {
            let s;
            switch(e.type){
                case "Rectangle":
                    s = Eh;
                    break;
                case "Ellipse":
                    s = wh;
                    break;
                case "Polygon":
                    s = T0;
                    break;
                case "Star":
                    s = M0;
                    break;
                default:
                    throw new Error(`Unknown shape type: ${e.type}`);
            }
            r = s.create({
                parameters: e
            }).userData.shape;
        }
        let i = this.geometry;
        r && i.inputs && (i.inputs.shapeData = r, i.build(), this.attachedSurfaceCloners.forEach((s)=>s.update()));
    }
    detachShape() {
        this._shapeId !== null && this._context.scene.find(this._shapeId)?.attachedPaths.delete(this);
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.updateShape(), this.refreshAttachedPaths(e);
    }
    updateTransformState(e, r) {
        return super.updateTransformState(e, r);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.updateShape();
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.getAttribute("position");
        i !== void 0 ? pm(i, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : i.count, e, r) : super.updateEntityBoxSize(e, r);
    }
};
var Js = class extends xs(ts, bs) {
    constructor(e, r, i){
        super();
        r.type === "Instance" && typeof e == "string" && (r = this.transformAssignData(r, i)), this.super_Entity(e, r), this.objectHelper.update();
    }
    get isComponentRoot() {
        return this.data.type === "Component" && typeof this.identity == "string";
    }
    get isInstanceRoot() {
        return this.data.type === "Instance" && typeof this.identity == "string";
    }
    transformAssignData(e, r) {
        let i = Wd.getComponentData({
            scene: r.scene.data,
            shared: r.shared.data
        }, e.component);
        if (i) {
            let s, o;
            for (let a of wo.rootOverrideProps)e[a] === void 0 ? (s === void 0 && (s = {
                ...e
            }), s[a] = i.data[a]) : (o === void 0 && (o = {}), o[a] = e[a], s === void 0 && (s = {
                ...e
            }), s[a] = po.apply(i.data[a], e[a]));
            return this.overrideData = o, s;
        } else return {
            ...wi.defaultData,
            ...e,
            ...Qn(wi.defaultData, wo.rootOverrideProps)
        };
    }
    updateByOp(e, r, i, s) {
        let o;
        if (this.isInstanceRoot && !s) {
            if (r = this.transformAssignData(r, i), e.type === 0 && e.path.length === 0 && this.component) for (let a of wo.rootOverrideProps)a in e.props && e.props[a] === void 0 && (o === void 0 && (o = {
                ...e,
                props: {
                    ...e.props
                }
            }), o.props[a] = this.component.data[a]);
            else if (e.type === 0 && e.path.length > 0 && wo.rootOverrideProps.includes(e.path[0])) {
                let a = e.path[0];
                o === void 0 && (o = {
                    ...e,
                    path: [],
                    props: {
                        [a]: r[a]
                    }
                });
            }
        }
        super.updateByOp(o ?? e, r, i, s);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
    expandInstanceChildren(e) {
        let r = this.data;
        if (this.component === void 0) {
            let i = e.scene.find(r.component) ?? null, s = !1;
            if (i !== this.oldComponent) {
                if (this.oldComponent) {
                    let o = 0;
                    for (let a of this.children)if (ut.is(a)) e.scene.disposeAndUnregisterEntityRecursivelyIfNotReregistered(a), Ix(a), o += 1;
                    else break;
                    this.children.splice(0, o);
                }
                s = !0;
            }
            if (i) {
                let o = {};
                O3(e, [
                    this.uuid
                ], r.overrides, this, i, i, 0, s, o);
                for (let a of this.children)if (ut.is(a)) {
                    let l = a.data;
                    l.type === "Empty" && l.animations && a.traverseEntity((u)=>{
                        if (u instanceof er && u.isSkinnedMesh) {
                            let c = u.dataPatched;
                            if (c.bones && c.boneInverses) {
                                let d = c.bones.map((p)=>e.scene.find(o[p])), h = c.boneInverses.map((p)=>new te().fromArray(p)), f = new Za(d, h);
                                u.bind(f, u.bindMatrix);
                            }
                        } else u.matrixAutoUpdate = !0;
                    });
                }
            }
            this.oldComponent = this.component;
        }
    }
};
function Ix(n1) {
    if (n1.component) {
        let t = n1.component.instances.indexOf(n1);
        t >= 0 && n1.component.instances.splice(t, 1);
        for (let e of n1.children)ut.is(e) && Ix(e);
    }
}
function D3(n1, t, e, r) {
    return n1.component === t && Rp(n1.identity, r) ? n1.overrideData === e ? 2 : 1 : 0;
}
function O3(n1, t, e, r, i, s, o, a, l) {
    if (o > 50) return !1;
    if (r.component !== i) {
        if (r.component) {
            let c = r.component.instances.indexOf(r);
            c >= 0 && r.component.instances.splice(c, 1);
        }
        i.instances.push(r), r.component = i;
    }
    i instanceof Js && i.isInstanceRoot && i.expandInstanceChildren(n1);
    let u = 0;
    for (let c of i.children)if (ut.is(c)) {
        let d = [
            ...t,
            ...typeof c.identity == "string" ? [
                c.identity
            ] : c.identity
        ], h = jd.resolve(e, d, 1);
        if (h != null && !(h instanceof lr)) Object.setPrototypeOf(h, lr.prototype), console.error("wrong prototype");
        let f = null, p;
        if (!a) {
            let m = r.children[u];
            if (f = ut.is(m) ? m : null, f !== null) {
                let g = D3(f, c, h, d);
                p = g >= 1 ? f.stateSelection : void 0, g !== 2 && (f = null);
            }
            if (f === null && (f = n1.scene.findInstance(d) ?? null, f !== null)) {
                let g = D3(f, c, h, d);
                if (p = g >= 1 ? f.stateSelection : void 0, g !== 2) f = null;
                else {
                    let y = f.parent.children.indexOf(f);
                    f.parent.children.splice(y, 1), r.children.splice(u, 0, f), f.parent === r ? y <= u && console.error("not possible") : (f.parent = r, f.matrixWorldNeedsUpdate = !0, f.resetBBoxNeedsUpdate(), f.updateVisible(), n1.pendingDeletes.delete(f));
                }
            }
        }
        if (f === null) {
            let m = h ? po.apply(c.data, h) : c.data;
            ks.is(m.type) && (m = {
                ...m,
                type: "Empty"
            }), f = Gs.createEntity(d, m, n1), f.overrideData = h, r.add(f), r.children.splice(r.children.length - 1, 1), r.children.splice(u, 0, f), f.updateState(f.data, n1), p && f.changeSelectedState(p, n1), n1.scene.registerInstanceAndSetUuid(f);
        }
        if (f.isBone) {
            let m = f.identity[f.identity.length - 1];
            l[m] = f.uuid;
        }
        u += 1, O3(n1, t, e, f, c, s, o + 1, a, l);
    }
    if (!a) {
        let c = u;
        for(;;){
            let d = r.children[u];
            if (ut.is(d)) n1.pendingDeletes.add(d);
            else break;
            u += 1;
        }
        r.children.splice(c, u - c);
    }
    return !0;
}
var Rx = class extends xs(fp, bs) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update(), this.matrixAutoUpdate = !0;
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
};
var fr = class extends er {
    constructor(e, r, i){
        super(e, r, i);
        this.onBeforeRender = ()=>{
            this.uiCanvas.render();
        };
        this.uiCanvas = new _f(e + "-canvas", r.geometry.width, r.geometry.height, i), this.uiCanvas.promise.then(()=>{
            this.applyFrame(this.dataPatched.geometry.frame, i.shared);
        });
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), e.type === 0 && (e.props.frame !== void 0 && this.applyFrame(e.props.frame, i.shared), (e.props.width !== void 0 || e.props.height !== void 0) && this.applySize(e.props, i.shared));
    }
    applySize(e, r) {
        let i = e?.width ?? this.dataPatched.geometry.width, s = e?.height ?? this.dataPatched.geometry.height;
        this.uiCanvas.applySize({
            width: i,
            height: s
        }), this.applyGeometryParametersFromFrame(r);
    }
    applyFrame(e, r) {
        this.uiCanvas.applyFrame(e), this.applyGeometryParametersFromFrame(r), this.applyMaterialParametersFromFrame({
            shared: r
        });
    }
    applyGeometryParametersFromFrame(e) {
        let r = this.frame;
        r && (Object.assign(this.data, {
            geometry: Object.assign(this.data.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), Object.assign(this.dataPatched, {
            geometry: Object.assign(this.dataPatched.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), this.localGeometry?.dispose(), this.localGeometry = Ta(this.dataPatched.geometry, e, this.data.flatShading, this));
    }
    applyMaterialParametersFromFrame(e) {
        let r = this.frame;
        if (r) {
            let i = r.data.backgroundBlur;
            Object.assign(this.data.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.data.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), Object.assign(this.dataPatched.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.dataPatched.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), this.material.reset(this.dataPatched.material, e, !0);
        }
    }
    updateEntity2DByOp(e, r, i, s) {
        this.uiCanvas.updateEntity2DByOp(e, r, i, s), e === this.frameId && r.type === 0 && (r.props.cornerRadius !== void 0 ? this.applyGeometryParametersFromFrame(s) : wt(r.path, [
            "backgroundBlur"
        ]) && this.applyMaterialParametersFromFrame({
            shared: s
        }));
    }
    get frame() {
        return this.uiCanvas.frame;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    removeInteractionGeometry(e) {
        super.removeInteractionGeometry(e), this.applySize({}, e);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.applySize({
            width: e.width,
            height: e.height
        }, r);
    }
};
var Lx = class {
    constructor(t, e, r){
        this.variables = [], this.currentTextureIndex = 0;
        let i = dr, s = new vi, o = new Hn;
        o.position.z = 1;
        let a = {
            passThruTexture: {
                value: null
            }
        }, l = d(f(), a), u = new rr(new hn(2, 2), l);
        s.add(u), this.setDataType = function(p) {
            return i = p, this;
        }, this.addVariable = function(p, m, g) {
            let y = this.createShaderMaterial(m), v = {
                name: p,
                initialValueTexture: g,
                material: y,
                dependencies: null,
                renderTargets: [],
                wrapS: null,
                wrapT: null,
                minFilter: Et,
                magFilter: Et
            };
            return this.variables.push(v), v;
        }, this.setVariableDependencies = function(p, m) {
            p.dependencies = m;
        }, this.init = function() {
            if (r.capabilities.isWebGL2 === !1 && r.extensions.has("OES_texture_float") === !1) return "No OES_texture_float support for float textures.";
            if (r.capabilities.maxVertexTextures === 0) return "No support for vertex shader textures.";
            for(let p = 0; p < this.variables.length; p++){
                let m = this.variables[p];
                m.renderTargets[0] = this.createRenderTarget(t, e, m.wrapS, m.wrapT, m.minFilter, m.magFilter), m.renderTargets[1] = this.createRenderTarget(t, e, m.wrapS, m.wrapT, m.minFilter, m.magFilter), this.renderTexture(m.initialValueTexture, m.renderTargets[0]), this.renderTexture(m.initialValueTexture, m.renderTargets[1]);
                let g = m.material, y = g.uniforms;
                if (m.dependencies !== null) for(let v = 0; v < m.dependencies.length; v++){
                    let x = m.dependencies[v];
                    if (x.name !== m.name) {
                        let S = !1;
                        for(let w = 0; w < this.variables.length; w++)if (x.name === this.variables[w].name) {
                            S = !0;
                            break;
                        }
                        if (!S) return "Variable dependency not found. Variable=" + m.name + ", dependency=" + x.name;
                    }
                    y[x.name] = {
                        value: null
                    }, g.fragmentShader = `
uniform sampler2D ` + x.name + `;
` + g.fragmentShader;
                }
            }
            return this.currentTextureIndex = 0, null;
        }, this.compute = function() {
            let p = this.currentTextureIndex, m = this.currentTextureIndex === 0 ? 1 : 0;
            for(let g = 0, y = this.variables.length; g < y; g++){
                let v = this.variables[g];
                if (v.dependencies !== null) {
                    let x = v.material.uniforms;
                    for(let S = 0, w = v.dependencies.length; S < w; S++){
                        let A = v.dependencies[S];
                        x[A.name].value = A.renderTargets[p].texture;
                    }
                }
                this.doRenderTarget(v.material, v.renderTargets[m]);
            }
            this.currentTextureIndex = m;
        }, this.getCurrentRenderTarget = function(p) {
            return p.renderTargets[this.currentTextureIndex];
        }, this.getAlternateRenderTarget = function(p) {
            return p.renderTargets[this.currentTextureIndex === 0 ? 1 : 0];
        }, this.dispose = function() {
            u.geometry.dispose(), u.material.dispose();
            let p = this.variables;
            for(let m = 0; m < p.length; m++){
                let g = p[m];
                g.initialValueTexture && g.initialValueTexture.dispose();
                let y = g.renderTargets;
                for(let v = 0; v < y.length; v++)y[v].dispose();
            }
        };
        function c(p) {
            p.defines.resolution = "vec2( " + t.toFixed(1) + ", " + e.toFixed(1) + " )";
        }
        this.addResolutionDefine = c;
        function d(p, m) {
            m = m || {};
            let g = new rt({
                uniforms: m,
                vertexShader: h(),
                fragmentShader: p
            });
            return c(g), g;
        }
        this.createShaderMaterial = d, this.createRenderTarget = function(p, m, g, y, v, x) {
            return p = p || t, m = m || e, g = g || Ut, y = y || Ut, v = v || Et, x = x || Et, new at(p, m, {
                wrapS: g,
                wrapT: y,
                minFilter: v,
                magFilter: x,
                format: Fr,
                type: i,
                depthBuffer: !1
            });
        }, this.createTexture = function() {
            let p = new Float32Array(t * e * 4), m = new ci(p, t, e, Fr, dr);
            return m.needsUpdate = !0, m;
        }, this.renderTexture = function(p, m) {
            a.passThruTexture.value = p, this.doRenderTarget(l, m), a.passThruTexture.value = null;
        }, this.doRenderTarget = function(p, m) {
            let g = r.getRenderTarget(), y = r.xr.enabled, v = r.shadowMap.autoUpdate, x = r.outputEncoding, S = r.toneMapping;
            r.xr.enabled = !1, r.shadowMap.autoUpdate = !1, r.outputEncoding = dn, r.toneMapping = Os, u.material = p, r.setRenderTarget(m), r.render(s, o), u.material = l, r.xr.enabled = y, r.shadowMap.autoUpdate = v, r.outputEncoding = x, r.toneMapping = S, r.setRenderTarget(g);
        };
        function h() {
            return `void main()	{

	gl_Position = vec4( position, 1.0 );

}
`;
        }
        function f() {
            return `uniform sampler2D passThruTexture;

void main() {

	vec2 uv = gl_FragCoord.xy / resolution.xy;

	gl_FragColor = texture2D( passThruTexture, uv );

}
`;
        }
    }
};
var Ji = new vr, Bx = new _, Nx = class {
    constructor(t){
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (console.warn("THREE.MeshSurfaceSampler: Converting geometry to non-indexed BufferGeometry."), e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.colorAttribute = this.geometry.getAttribute("color"), this.weightAttribute = null, this.distribution = null;
    }
    setWeightAttribute(t) {
        return this.weightAttribute = t ? this.geometry.getAttribute(t) : null, this;
    }
    build() {
        let t = this.positionAttribute, e = this.weightAttribute, r = new Float32Array(t.count / 3);
        for(let s = 0; s < t.count; s += 3){
            let o = 1;
            e && (o = e.getX(s) + e.getX(s + 1) + e.getX(s + 2)), Ji.a.fromBufferAttribute(t, s), Ji.b.fromBufferAttribute(t, s + 1), Ji.c.fromBufferAttribute(t, s + 2), o *= Ji.getArea(), r[s / 3] = o;
        }
        this.distribution = new Float32Array(t.count / 3);
        let i = 0;
        for(let s = 0; s < r.length; s++)i += r[s], this.distribution[s] = i;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e, r) {
        let i = this.distribution[this.distribution.length - 1], s = this.binarySearch(this.randomFunction() * i);
        return this.sampleFace(s, t, e, r);
    }
    binarySearch(t) {
        let e = this.distribution, r = 0, i = e.length - 1, s = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s;
    }
    sampleFace(t, e, r, i) {
        let s = this.randomFunction(), o = this.randomFunction();
        return s + o > 1 && (s = 1 - s, o = 1 - o), Ji.a.fromBufferAttribute(this.positionAttribute, t * 3), Ji.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), Ji.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(Ji.a, s).addScaledVector(Ji.b, o).addScaledVector(Ji.c, 1 - (s + o)), r !== void 0 && Ji.getNormal(r), i !== void 0 && this.colorAttribute !== void 0 && (Ji.a.fromBufferAttribute(this.colorAttribute, t * 3), Ji.b.fromBufferAttribute(this.colorAttribute, t * 3 + 1), Ji.c.fromBufferAttribute(this.colorAttribute, t * 3 + 2), Bx.set(0, 0, 0).addScaledVector(Ji.a, s).addScaledVector(Ji.b, o).addScaledVector(Ji.c, 1 - (s + o)), i.r = Bx.x, i.g = Bx.y, i.b = Bx.z), this;
    }
};
function I3(n1) {
    let t = new Float32Array(n1 * n1 * 2);
    for(let e = 0; e < n1; e++)for(let r = 0; r < n1; r++){
        let i = e * n1 + r;
        t[i * 2 + 0] = e / (n1 - 1), t[i * 2 + 1] = r / (n1 - 1);
    }
    return t;
}
function R3(n1) {
    let t = Math.ceil(Math.sqrt(n1));
    return Math.max(t, 1);
}
function L3(n1, t) {
    let e = [], r = [], i = new _, s = new _, o = new Nx(n1).build();
    for(let u = 0; u < t; u++)o.sample(i, s), e.push(i.x, i.y, i.z), r.push(s.x, s.y, s.z);
    let a = new Float32Array(e), l = new Float32Array(r);
    return {
        positions: a,
        normals: l
    };
}
function D_(n1, t) {
    let e = n1, r = new Float32Array(4 * t * t);
    for(let s = 0; s < t * t; s++)r[4 * s] = e[3 * s], r[4 * s + 1] = e[3 * s + 1], r[4 * s + 2] = e[3 * s + 2], r[4 * s + 3] = 0;
    let i = new ci(r, t, t, Fr, dr);
    return i.needsUpdate = !0, i;
}
function B3({ size: n1 }) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = r, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new ci(t, n1, n1, Fr, dr);
    return e.needsUpdate = !0, e;
}
function N3(n1) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = 0, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new ci(t, n1, n1, Fr, dr);
    return e.needsUpdate = !0, e;
}
var F3 = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform float uTime;
uniform float uSpeed;     // update speed of the particles
uniform vec3 uWorldOffset;    
uniform vec4 uWorldQuaternion;
uniform float uMaxLifeTime;
uniform vec3 uEmitterSize;
uniform float uFPSRatio;     // 1  for 60 FPS

float random (vec2 st) {
    return fract(sin(dot(st.xy,
        vec2(12.9898,78.233)))*
        43758.5453123);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
    vec3 acceleration = force / mass;
    
    return acceleration;
  }
  

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    float currentLife = texture2D( uCurrentPosition, vUv ).w;   // from 1 to 0
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).r;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;          // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;         // timeStart in seconds when the particle was emitted
    vec3 originalPosition = ((texture2D( uOriginalPosition, vUv ).xyz) * uEmitterSize);
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float collisionFlag = texture2D( uCurrentVelocity, vUv ).w;             // 1. = collided, 0. = not collided
    float lifeTime = uMaxLifeTime;

    // Calculate the position adjustment based on collision
    //     if (collisionFlag > .5) {  
    float isColliding = step(0.5, collisionFlag); // 1.0 if collisionFlag > 0.5, otherwise 0.0
    float bounceOffset = 3.0 * isColliding; // Becomes 3.0 if colliding, 0.0 otherwise
    vec3 collisionAdjustedVelocity = velocity * (1.0 + bounceOffset);

    // Update position based on collision or normal movement
    vec3 fpsVelocity = velocity * min(uFPSRatio, 5.0);
    position += mix(fpsVelocity, collisionAdjustedVelocity, isColliding);

    // EMISSION RATE - BIRTH
    // if (isSpawning == 1.0) {
    // Better Approach to avoid If statement
    vec3 newPosition = applyQuaternionToVector(uWorldQuaternion, originalPosition) + uWorldOffset;
    originalPosition = mix(originalPosition, newPosition, isSpawning);
    position = mix(position, originalPosition, isSpawning);;
    timeStart = mix(timeStart, uTime, isSpawning);

    // Calculate timeLeft for life normalization
    float timeLeft = max(lifeTime - (uTime - timeStart), 0.0);
    float life_Normalize = timeLeft / lifeTime;

    // Use isActive to blend between the calculated color and black
    vec4 activeColor = vec4(position, life_Normalize);
    // if (isActive == 1.0) {
    gl_FragColor = mix(vec4(0.0), activeColor, isActive);

}
`;
var k3 = `

    vec3 mod289(vec3 x) {
      return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 mod289(vec4 x) {
    return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 permute(vec4 x) {
        return mod289(((x*34.0)+1.0)*x);
    }
    
    vec4 taylorInvSqrt(vec4 r)
    {
    return 1.79284291400159 - 0.85373472095314 * r;
    }
    
    vec3 fade(vec3 t) {
  return t*t*t*(t*(t*6.0-15.0)+10.0);
}

    float snoise(vec3 v)
    {
    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
    vec3 i  = floor(v + dot(v, C.yyy) );
    vec3 x0 =   v - i + dot(i, C.xxx) ;
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min( g.xyz, l.zxy );
    vec3 i2 = max( g.xyz, l.zxy );
    vec3 x1 = x0 - i1 + C.xxx;
    vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
    vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y
    
    // Permutations
    i = mod289(i);
    vec4 p = permute( permute( permute(
                i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
              + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
              + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
    
    // Gradients: 7x7 points over a square, mapped onto an octahedron.
    // The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
    float n_ = 0.142857142857; // 1.0/7.0
    vec3  ns = n_ * D.wyz - D.xzx;
    
    vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)
    
    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
    
    vec4 x = x_ *ns.x + ns.yyyy;
    vec4 y = y_ *ns.x + ns.yyyy;
    vec4 h = 1.0 - abs(x) - abs(y);
    
    vec4 b0 = vec4( x.xy, y.xy );
    vec4 b1 = vec4( x.zw, y.zw );
    
    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));
    
    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
    
    vec3 p0 = vec3(a0.xy,h.x);
    vec3 p1 = vec3(a0.zw,h.y);
    vec3 p2 = vec3(a1.xy,h.z);
    vec3 p3 = vec3(a1.zw,h.w);
    
    //Normalise gradients
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;
    
    // Mix final noise value
    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                  dot(p2,x2), dot(p3,x3) ) );
    }
    
    vec3 snoiseVec3( vec3 x ){
    
      float s  = snoise(vec3( x ));
      float s1 = snoise(vec3( x.y - 19.1 , x.z + 33.4 , x.x + 47.2 ));
      float s2 = snoise(vec3( x.z + 74.2 , x.x - 124.5 , x.y + 99.4 ));
      vec3 c = vec3( s , s1 , s2 );
      return c;
    
    }
    
      
    vec3 curlNoise( vec3 p, float seed){
      p += seed;
      const float e = .1;
      vec3 dx = vec3( e   , 0.0 , 0.0 );
      vec3 dy = vec3( 0.0 , e   , 0.0 );
      vec3 dz = vec3( 0.0 , 0.0 , e   );
    
      vec3 p_x0 = snoiseVec3( p - dx );
      vec3 p_x1 = snoiseVec3( p + dx );
      vec3 p_y0 = snoiseVec3( p - dy );
      vec3 p_y1 = snoiseVec3( p + dy );
      vec3 p_z0 = snoiseVec3( p - dz );
      vec3 p_z1 = snoiseVec3( p + dz );
    
      float x = p_y1.z - p_y0.z - p_z1.y + p_z0.y;
      float y = p_z1.x - p_z0.x - p_x1.z + p_x0.z;
      float z = p_x1.y - p_x0.y - p_y1.x + p_y0.x;
    
      const float divisor = 1.0 / ( 2.0 * e );
      return normalize( vec3( x , y , z ) * divisor );
    
    }


// Classic Perlin noise
float cnoise(vec3 P)
{
  vec3 Pi0 = floor(P); // Integer part for indexing
  vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
  Pi0 = mod289(Pi0);
  Pi1 = mod289(Pi1);
  vec3 Pf0 = fract(P); // Fractional part for interpolation
  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
  vec4 iy = vec4(Pi0.yy, Pi1.yy);
  vec4 iz0 = Pi0.zzzz;
  vec4 iz1 = Pi1.zzzz;

  vec4 ixy = permute(permute(ix) + iy);
  vec4 ixy0 = permute(ixy + iz0);
  vec4 ixy1 = permute(ixy + iz1);

  vec4 gx0 = ixy0 * (1.0 / 7.0);
  vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
  gx0 = fract(gx0);
  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
  vec4 sz0 = step(gz0, vec4(0.0));
  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
  gy0 -= sz0 * (step(0.0, gy0) - 0.5);

  vec4 gx1 = ixy1 * (1.0 / 7.0);
  vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
  gx1 = fract(gx1);
  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
  vec4 sz1 = step(gz1, vec4(0.0));
  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
  gy1 -= sz1 * (step(0.0, gy1) - 0.5);

  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);

  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
  g000 *= norm0.x;
  g010 *= norm0.y;
  g100 *= norm0.z;
  g110 *= norm0.w;
  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
  g001 *= norm1.x;
  g011 *= norm1.y;
  g101 *= norm1.z;
  g111 *= norm1.w;

  float n000 = dot(g000, Pf0);
  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
  float n111 = dot(g111, Pf1);

  vec3 fade_xyz = fade(Pf0);
  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
  return 2.2 * n_xyz;
}


vec3 fbm_vec3(vec3 p, float frequency, float offset)
{
  return vec3(
    cnoise((p+vec3(offset))*frequency),
    cnoise((p+vec3(offset+20.0))*frequency),
    cnoise((p+vec3(offset-30.0))*frequency)
  );
}

`;
var z3 = `
  #ifdef USE_COLLIDER
    float restitution = max(uBounce * 2., .01); // Energy Loss
    // SPHERE COLLIDER
    // **************************************************************
    #ifdef USE_SPHERE_COLLIDER       
      // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
      vec3 radii = uColliderSize;
      // Adjust position relative to collider
      vec3 relPos = position - uColliderPos;
      // Apply rotation of the collider to the relative position
      relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
      // Scale relative position by radii (for ellipsoid collision detection)
      vec3 scaledPos = relPos / radii;
      // Calculate ellipsoidal distance
      float dist = length(scaledPos); // Distance in terms of ellipsoid
      
      // Check for collision
      if (dist <= 1. + particleSize / length(radii) && collisionFlag == 0.0) {
          // Compute the normal at the collision point, accounting for particle size
        vec3 adjustedPos = scaledPos * (1.0 + particleSize / length(radii));          
        // Compute the normal at the collision point
        vec3 normal = ellipsoidNormal(adjustedPos, radii);
        // Rotate the normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);
        // Reflect the velocity vector off the normal
        velocity = reflect(velocity, normal) * restitution;

        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif

    // BOX COLLIDER or PLANE COLLIDER 
    // **************************************************************
    #ifdef USE_BOX_COLLIDER
      // Box dimensions and repulsion variables
      vec3 boxHalfSize = uColliderSize / 2.0;
      // Convert world position to box's local space
      vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
      // Collision detection
      vec3 localDistance = abs(localPos) - boxHalfSize;
      float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));    

      // Collision Detected
      if (distToSurface <= particleSize * 0.5 && collisionFlag == 0.0) {      
        // Find the nearest face normal for bounce direction
        vec3 normal;
        if (localDistance.x > localDistance.y && localDistance.x > localDistance.z) {
            normal = vec3(sign(localPos.x), 0.0, 0.0);
        } else if (localDistance.y > localDistance.z) {
            normal = vec3(0.0, sign(localPos.y), 0.0);
        } else {
            normal = vec3(0.0, 0.0, sign(localPos.z));
        }            
        // Rotate normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);      
        // Reflect velocity and apply repulsion force
        velocity = reflect(velocity, normal) * restitution;
        
        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif      
  #endif      
  // END COLLIDER    
`;
var V3 = `
  #ifdef USE_ATTRACTOR

      #ifdef USE_SPHERE_COLLIDER      
        // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
        vec3 radii = uColliderSize;
        // Adjust position relative to collider
        vec3 relPos = position - uColliderPos;
        // Apply rotation of the collider to the relative position
        relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
        // Scale relative position by radii (for ellipsoid collision detection)
        vec3 scaledPos = relPos / radii;
        // Calculate ellipsoidal distance
        float distToSurface = length(scaledPos); // Distance in terms of ellipsoid
        float insideCheck = 1.0;

      #endif


      #ifdef USE_BOX_COLLIDER
        // Box dimensions
        vec3 boxHalfSize = uColliderSize / 2.0;
        // Convert world position to box's local space
        vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
        vec3 localDistance = abs(localPos) - boxHalfSize;
        float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));
        float insideCheck = particleSize;
      #endif      
  
      // Apply vortex force inside the Helper
      #ifdef USE_FORCE_LOCAL_SPACE
        if (distToSurface <= insideCheck ) {    
            // Define parameters for the attractor field
            #ifdef USE_SPHERE_COLLIDER      
              float attractorStrength = (1.0 - distToSurface ) * uForceIntensity; // Adjust as needed
            #endif

            #ifdef USE_BOX_COLLIDER
              float attractorStrength = max((1.0 - insideCheck / distToSurface), 0.) * uForceIntensity; // Adjust as needed
              #endif

            float attractorDamping = uForceDamping;  // Adjust as needed (higher values will attenuate velocity more)
          
            // Use the same radii calculation code as for the collider
            vec3 attractorRadii = uColliderSize;
            // Adjust position relative to attractor center
            vec3 relPos = position - uColliderPos;
            // Apply rotation of the collider to the relative position
            relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
            // Scale relative position by radii (for ellipsoid attraction)
            vec3 scaledPos = relPos / attractorRadii;

            // Calculate ellipsoidal distance as attractor radius
            float attractorRadius = length(scaledPos);
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * attractorStrength;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= attractorDamping;
        }

      #else 
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * uForceIntensity;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= uForceDamping;
      #endif

    
  #endif      
`;
var U3 = `
  #ifdef USE_VORTEX
    // Box dimensions
    vec3 boxHalfSize = uColliderSize / 2.0;
    // Convert world position to box's local space
    vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
    vec3 localDistance = abs(localPos) - boxHalfSize;
    float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));

    // Apply vortex force inside the box
    if (distToSurface <= particleSize) {
      float vortexStrength = uForceIntensity;
      vec3 localTopCenter = vec3(0.0, 0., 0.0);

      // Transform the local top center to the world space
      vec3 vortexCenter = uColliderPos + applyQuaternionToVector(uColliderQuaternion, localTopCenter);
      // Calculate the vector from particle to vortex center
      vec3 vortexVector = vortexCenter - position;

      // Calculate the rotation axis from the inverse of the collider's quaternion and the fixed up vector
      // Note: important to add a tiny z component to the up vector to avoid instability
      vec3 upVector = vec3(0.0, 1.0, 0.01);
      vec3 rotationAxis = cross(upVector, applyQuaternionToVector(uColliderQuaternion, vortexVector));
      rotationAxis = normalize(rotationAxis);

      // Add rotational component to velocity
      float rotationSpeed = length(vortexVector * vortexStrength * 3.0) ; 

      vec3 rotationVelocity = rotationAxis * rotationSpeed;
      // velocity += rotationVelocity * 0.005 ;
      velocity = rotationVelocity * 0.005 ;

      // Calculate vortex force
      // vec3 vortexForce = normalize(vortexVector) * uSpeed * .1 ;
      // Apply the vortex force to the particle
      vec3 originDirection = applyQuaternionToVector(uWorldQuaternion, directions);
      velocity += applyForce( originDirection * uSpeed * (1. - uForceDamping) , mass * .5);
    }
  #endif      
`;
var G3 = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform sampler2D uDirections;     
uniform vec3 uDirectionsAxis;
uniform vec4 uWorldQuaternion;
uniform vec3 uGravity;        
uniform float uNoiseStrength;     // Variation of the noise
uniform float uNoiseScale;        // Scale of the noise
uniform float uNoiseSeed;         // Seed of the noise
uniform float particleSize;
uniform float uSpeed;     // update speed of the particles
uniform float uRandomMassFactor;

// COLLIDER
uniform vec3 uColliderPos;                // Collider Position
uniform vec3 uColliderSize;               // Collider Dimension
uniform vec4 uColliderQuaternion;         // Collider Rotation
uniform vec4 uColliderQuaternionInvert;   // Collider Rotation
uniform float uBounce;                    // Bounce factor
uniform float uForceDamping;
uniform float uForceIntensity;


` + k3 + `
float rand(vec2 co){
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
 } 
vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
  
  return acceleration;
}

vec4 conjugate(vec4 q) {
  return vec4(q.w, -q.x, -q.y, -q.z);
}

// Function to compute the normal of the ellipsoid at a given point
vec3 ellipsoidNormal(vec3 p, vec3 radii) {
  return normalize(p / (radii * radii));
}

float friction = .3;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    vec3 originalPosition = texture2D( uOriginalPosition, vUv ).xyz;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    vec3 directions = texture2D( uDirections, vUv ).xyz;    
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float mass = rand(originalPosition.xy) * 0.5 + 0.5;
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).x;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).y;          // 1. = active, 0. = not active
    float collisionFlag =texture2D( uCurrentVelocity, vUv ).w;          // Indicate collision

    // Randomness Mass
    mass = (1.0 - (uRandomMassFactor * mass));
    
    if (isActive == 1.0) {
      // **************************************************************
      // FORCES NOISES
      // **************************************************************
      #ifdef USE_CURL_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = curlNoise(position * uNoiseScale * .002, uNoiseSeed) * ( uNoiseStrength + 1.0) * .05 * uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {
          velocity += curlNoise( position, uNoiseSeed)  * uNoiseStrength * 0.05 * uSpeed;
        }
      #endif
      // **************************************************************
      #ifdef USE_SIMPLEX_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = vec3(snoise(position * uNoiseScale * .001) * ( uNoiseStrength + 1.0) * .1);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0) {
          velocity += vec3(snoise(position * uNoiseStrength * .001) * .05 * uSpeed);
        }
      #endif
      // ************************************************************** 
      #ifdef USE_FBM_NOISE
        if (uNoiseScale > 0.0 ) {
          float offset = 0.0;
          velocity = fbm_vec3(position * uNoiseScale * .001, ( uNoiseStrength + 1.0), offset);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {      
          float offset = 0.0;
          velocity += fbm_vec3(position * uNoiseStrength * .001, ( uNoiseStrength + 1.0), uNoiseSeed) * .1 * uSpeed;
        }
      #endif

      // COLLIDER
      ${z3}
      // ATTRACTION
      ${V3}  
      // VORTEX
      ${U3}
    } 
    // End isActive

    // SPAWN BIRTH 
    // **************************************************************
    // if (isSpawning == 1.)
    #ifdef USE_NORMALS
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, directions) * uSpeed, isSpawning);
    #else
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, uDirectionsAxis) * uSpeed, isSpawning);    
    #endif
    
    // if (collisionFlag == 0.0)
    velocity += applyForce(uGravity, mass * .5) * (1.0 - collisionFlag);

    gl_FragColor = vec4(velocity, collisionFlag);
}
`;
var O_ = `

  // Linear Fade In
  float linearFadeIn(float t) {
    return t;
  }


  // linear fade out
  float linearFadeOut(float t) {
    return 1.0 - t;
  }
  
  float linearInOut(float t) {
    return t < 0.5 ? t :  (1.0 - t);  
  }

    // lerp
    float lerp(float a, float b, float t) {
      return a + (b - a) * t;
    }

  // Ease In Out Quart
  float exponentialInOut(float t) {
    return t < 0.4 ? lerp(0.0, 1.0, t / 0.4) :
    t > 0.6 ? lerp(1.0, 0.0, (t - 0.6) / 0.4) :
    1.0;
   }

  // constant
  float constant(float t) {
    return 1.0;
  } 
`;
var j3 = `

float rand(vec3 co){
  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
}

vec3 applyQuaternionToVector( vec4 q, vec3 v ){
  return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
    
  return acceleration;
}
`;
var H3 = `
vec3 rgb2xyz (in vec3 rgb) {
    float r = rgb.r;
	float g = rgb.g;
	float b = rgb.b;

	r = r > 0.04045 ? pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	float x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	float y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	float z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
    
    vec3 xyz = vec3(
        (r * 0.4124) + (g * 0.3576) + (b * 0.1805) * 100.0,
        (r * 0.2126) + (g * 0.7152) + (b * 0.0722) * 100.0,
        (r * 0.0193) + (g * 0.1192) + (b * 0.9505) * 100.0
    );
    return(xyz);
}

vec3 xyz2lab (in vec3 xyz) {
	float x = xyz.x / 95.047;
	float y = xyz.y / 100.0;
	float z = xyz.z / 108.883;

	x = x > 0.008856 ? pow(x, 1.0 / 3.0) : (7.787 * x) + (16.0 / 116.0);
	y = y > 0.008856 ? pow(y, 1.0 / 3.0) : (7.787 * y) + (16.0 / 116.0);
	z = z > 0.008856 ? pow(z, 1.0 / 3.0) : (7.787 * z) + (16.0 / 116.0);

    vec3 lab = vec3((116.0 * y) - 16.0, 500.0 * (x - y), 200.0 * (y - z));
    return(lab);
}

vec3 rgb2lab(in vec3 rgb) {
    vec3 xyz = rgb2xyz(rgb);
    vec3 lab = xyz2lab(xyz);
    return(lab);
}

vec3 xyz2rgb (in vec3 xyz) {
	float x = xyz.x / 100.0;
	float y = xyz.y / 100.0;
	float z = xyz.z / 100.0;
	
    
	float r = (x *  3.2406) + (y * -1.5372) + (z * -0.4986);
	float g = (x * -0.9689) + (y *  1.8758) + (z *  0.0415);
	float b = (x *  0.0557) + (y * -0.2040) + (z *  1.0570);

	r = r > 0.0031308 ? ((1.055 * pow(r, 1.0 / 2.4)) - 0.055) : r * 12.92;
	g = g > 0.0031308 ? ((1.055 * pow(g, 1.0 / 2.4)) - 0.055) : g * 12.92;
	b = b > 0.0031308 ? ((1.055 * pow(b, 1.0 / 2.4)) - 0.055) : b * 12.92;

	r = min(max(0.0, r), 1.0);
	g = min(max(0.0, g), 1.0);
	b = min(max(0.0, b), 1.0);

	return(vec3(r, g, b));
}

vec3 lab2xyz (in vec3 lab) {
    float l = lab.x;
	float a = lab.y;
	float b = lab.z;

  	float y = (l + 16.0) / 116.0;
	float x = a / 500.0 + y;
	float z = y - b / 200.0;

	float y2 = pow(y, 3.0);
	float x2 = pow(x, 3.0);
	float z2 = pow(z, 3.0);

  	y = y2 > 0.008856 ? y2 : (y - 16.0 / 116.0) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16.0 / 116.0) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16.0 / 116.0) / 7.787;

	x *= 95.047;
	y *= 100.0;
	z *= 108.883;

	return(vec3(x, y, z));
}
vec3 lab2rgb (in vec3 lab) {
    vec3 xyz = lab2xyz(lab);
    vec3 rgb = xyz2rgb(xyz);
    return(rgb);
}

`;
var W3 = `
  uniform sampler2D uPosition;
  uniform float uSize;
  uniform float uSizeEnd;
  uniform vec3 uWorldOffset;
  uniform vec4 uWorldQuaternion;
  // Billboard Behavior - Currently at Zero, but we can change that
  uniform float uRotation;
  uniform float uRotationEnd;
  uniform vec2 center;

  // Randomness
  uniform float uRandScaleFactor;
  uniform float uRandRotationFactor;

  attribute vec2 ref;

  varying float v_LifeLeft;    // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  ${j3}
  ${O_}
`, q3 = ({ easeSize: n1 = "linearFadeOut" })=>`
  vUv = uv;  
  vRef = ref;
  // Normalized LifeTime 1 to 0
  float lifeLeft = texture2D(uPosition, ref).w;
  v_LifeLeft = lifeLeft;
  // Position From DataTexture Simulation
  vec3 pos = texture2D(uPosition, ref).rgb - uWorldOffset;
  // Apply World Quaternion
  pos = applyQuaternionToVector(uWorldQuaternion, pos);  
            
  #ifdef  USE_SIZE_END
    // Scaled Over Time
    float t = 1. - lifeLeft;
    float currentSize = mix(uSize, uSizeEnd, t); // Linearly interpolate between uSize and uSizeEnd
    vec3 scaledPosition = position * vec3(currentSize);
  #else
    // Change Size Behavior over LifeTime
    float easeSize = ${n1}(1. - lifeLeft);
    // Scaled Over Time
    vec3 scaledPosition = position * vec3(uSize * easeSize);
  #endif

  // Billboard Behavior
  vec2 scale;
  scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
  scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );    
  // Randomness 
  float randRef = rand(ref);
  scale *= (1.0 - (uRandScaleFactor * randRef));
  // Rotation
  float randRotation =  2.0 * PI * ( uRandRotationFactor * randRef);
  float originalRotation = (1.0 - uRotation) * 2.0 * PI;
  float originalRotationEnd = (1.0 - uRotationEnd) * 2.0 * PI;
  // OverTime
  float finalRotation = mix(originalRotation + randRotation, originalRotationEnd + randRotation, lifeLeft);

  vec2 alignedPosition = ( scaledPosition.xy - ( center - vec2( 0.5 ) ) ) * scale;
  vec2 rotatedPosition;
  rotatedPosition.x = cos( finalRotation ) * alignedPosition.x - sin( finalRotation ) * alignedPosition.y;
  rotatedPosition.y = sin( finalRotation ) * alignedPosition.x + cos( finalRotation ) * alignedPosition.y;
  
  mat4 instanceMatrix = mat4(
    vec4(1.0, 0.0, 0.0, 0.0),
    vec4(0.0, 1.0, 0.0, 0.0),
    vec4(0.0, 0.0, 1.0, 0.0),
    vec4(pos.x, pos.y, pos.z, 1.0)
  );  

  mvPosition = modelViewMatrix * instanceMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
  mvPosition.xy += rotatedPosition;
  gl_Position = projectionMatrix  * mvPosition;   
`, Y3 = `
  uniform vec4 uColor;                // start color
  uniform vec4 uColor2;               // end color
  uniform sampler2D uTexture;         // texture
  varying float v_LifeLeft;   // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  float random(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
  }
  ` + O_ + `  
  ${H3}

`, X3 = ({ easeOpacity: n1 = "linearFadeOut" })=>`  
  // if Particle is dead, hide it
  if (v_LifeLeft <= 0.005 ) {
    discard;
  }

  #ifdef USE_RANDOM_COLORING
    float randVal = random(vRef); // Generate a random value based on the reference
    vec4 color = mix(uColor, uColor2, randVal); // Interpolate between the two colors
  #else
    vec4 color = mix(uColor, uColor2, 1. - v_LifeLeft);
  #endif

  // Opacity over Life Time
  float finalAlpha = ${n1}(1. - v_LifeLeft);  
  vec4 textureColor = texture2D(uTexture, vUv).rgba; 
  finalColor = textureColor.rgb * color.rgb;
  finalAlpha = color.a * textureColor.a * finalAlpha;
  
  gl_FragColor = vec4(finalColor, finalAlpha);     

`;
var Fx = class extends rt {
    constructor(e, r){
        super();
        this.needsJitter = !0;
        this.type = "ParticleMaterial";
        this.easeOpacity = "linearFadeIn";
        this.easeSize = "linearFadeIn";
        this.useSizeEnd = !1;
        this.isColoringRandom = !1;
        this.init(e, r), this.context = r;
    }
    reset() {}
    init(e, r) {
        this.transparent = !0, this.depthTest = !0, this.depthWrite = !1, this.easeOpacity = e.ease, this.easeSize = e.easeSize, this.layers = [], this.lightLayer = new Sn(0, "", {
            ...Ir.defaultData("light", "phong"),
            visible: !1
        }, new Ma, {}, r.shared), this.build();
    }
    updateState(e) {
        e.coloring !== void 0 && (this.isColoringRandom = e.coloring === "random"), e.color !== void 0 && (e.color instanceof Array ? this.uniforms.uColor.value = e.color : this.uniforms.uColor.value = this.context.shared.color(e.color)), e.color2 !== void 0 && (e.color2 instanceof Array ? this.uniforms.uColor2.value = e.color2 : this.uniforms.uColor2.value = this.context.shared.color(e.color2)), e.size !== void 0 && (this.uniforms.uSize.value = e.size[0], this.uniforms.uSizeEnd.value = e.size[1], e.size[0] !== e.size[1] ? this.useSizeEnd = !0 : this.useSizeEnd = !1), e.ease !== void 0 && (this.easeOpacity = e.ease, this.build()), e.easeSize !== void 0 && (this.easeSize = e.easeSize, this.build()), this.needsUpdate = !0;
    }
    onBeforeCompile(e) {
        this.build(), e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
    }
    build() {
        let e = new Bh;
        return e.needsJitter = this.needsJitter, e.addFragmentParsCode(OI), e.buildShader("vertex", this.fragment), e.buildShader("fragment", this.fragment), e.addFragmentFinalCode(II), this.isColoringRandom && e.define("USE_RANDOM_COLORING"), this.useSizeEnd && e.define("USE_SIZE_END"), e.addVertexParsCode(W3), e.addFragmentParsCode(Y3), e.addVertexFinalCode(q3({
            easeSize: this.easeSize
        })), e.addFragmentFinalCode(X3({
            easeOpacity: this.easeOpacity
        })), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = {
            ...e.uniforms,
            ...this.uniforms
        }, this.extensions = e.extensions, this;
    }
    get nodeMaterial() {
        return this;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    getDefines() {
        return this.defines;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
    }
};
var Ef = class {
    constructor(t, e, r, i){
        this.type = "SphereEmitterShape";
        this.targetMesh = void 0;
        this.size = t, this.type = r, this.textureSize = R3(e);
        let s = 1;
        this.targetMesh = i?.type === "Mesh" && i ? i : this.getMesh(r, s);
        let { positions: o, dataTexture: a, dataTextureNormals: l } = this.createPositions(this.textureSize, this.targetMesh ?? this.getMesh(r, s));
        this.positionsTexture = a, this.positionsAttribute = o, this.directionsTexture = l;
    }
    createPositions(t, e) {
        let { positions: r, normals: i } = L3(e, t * t), s = D_(r, t), o = D_(i, t);
        return {
            dataTexture: s,
            positions: r,
            dataTextureNormals: o
        };
    }
    getMesh(t, e) {
        let r = null;
        switch(t){
            case "SphereEmitterShape":
                r = new Bs(e * .5, 32, 32);
                break;
            case "TorusEmitterShape":
                r = new zu(e * .5, .3, 15, 40);
                break;
            case "ConeEmitterShape":
                r = new $a(e, e, 15);
                break;
            case "BoxEmitterShape":
                r = new li(e, e, e);
                break;
            case "PlaneEmitterShape":
                r = new hn(e, e), r.rotateX(-Math.PI / 2);
                break;
            case "MeshEmitterShape":
                r = new Bs(e, 32, 32);
                break;
            default:
                r = new Bs(e, 32, 32);
                break;
        }
        return new rr(r, new Ls({
            color: 16711680
        }));
    }
    applyToShader(t, e) {
        this.size = new _().fromArray(e.size), t.uEmitterSize.value = this.size;
    }
    dispose() {
        this.positionsTexture.dispose(), this.directionsTexture.dispose(), this.positionsAttribute = new Float32Array;
    }
};
function $c(n1) {
    let t = {
        ...n1
    }, e = Fd.defaultData;
    t.forceFieldObjectId && (t.colliderEntityId = t.forceFieldObjectId);
    let r = {
        ...e.shape,
        ...t.shape
    }, i = {
        ...e.renderMaterial,
        ...t.renderMaterial
    };
    return {
        ...e,
        ...t,
        shape: r,
        renderMaterial: i
    };
}
var Q3 = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU

uniform sampler2D uIndex; // Texture with corresponding index
uniform float uLastIndexEmitted; // Last emitted index
uniform float uParticlesToEmit; // Number of particles to emit on that frame
uniform float uTime;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    float particleIndex = texture(uIndex, vUv).x;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;    // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;


    // ********** Detect Colision to Create a flag and use it in position **********
    // We are doing this here, so

    // ********** Emit Particles **********
    // X = isSpawning 0.0 or 1.0
    // Y = isActive 0.0 or 1.0
    // Check if the vertex index is between the first value and the last value
    // if (particleIndex >= uLastIndexEmitted && particleIndex < uLastIndexEmitted + uParticlesToEmit) {
    //     // Emit a particle by writing 1 to the red channel of the color output
    //     // r: 1. == emit the particle
    //     // g: 1. == particle is now active
    //     timeStart = uTime;
    //     gl_FragColor = vec4(1.0, 1.0, timeStart, 1.0);
    // } else {
    //     // The Particle is either already emitted or not in the range of the particles to emit
    //     // Do not emit a particle by writing 0 to the red channel of the color output        
    //     gl_FragColor = vec4(0.0, isActive, timeStart, 1.0);
    // }
    // Determine if the particle is within the emission range
    float emitLowerBound = step(uLastIndexEmitted, particleIndex);
    float emitUpperBound = step(particleIndex, uLastIndexEmitted + uParticlesToEmit - 1.0);
    float emitParticle = emitLowerBound * emitUpperBound; // 1.0 if in range, 0.0 otherwise

    // Set timeStart and color
    timeStart = mix(timeStart, uTime, emitParticle);
    gl_FragColor = vec4(emitParticle, mix(isActive, 1.0, emitParticle), timeStart, 1.0);


}
`;
var I_ = 10, kx = class extends mt {
    constructor(e, r){
        super();
        this.type = "ParticleEmitter";
        this.debugMode = !1;
        this.worldSpace = !0;
        this.rootObject = null;
        this.gpuCompute = null;
        this.positionSimRT = null;
        this.velocitySimRT = null;
        this.emissionRateSimRT = null;
        this.emitterShape = void 0;
        this.isEmitting = !1;
        this.hasBeenReset = !1;
        this.emittedParticlesAmount = 0;
        this.lastEmitTime = 0;
        this.globalTime = 0;
        this.targetFPS = 60;
        this.previousRatio = 1;
        this.lerpFactor = .4;
        this.particlesAmount = 0;
        this.noiseStrength = 0;
        this.noiseScale = 0;
        this.isBillboardBased = !0;
        this.simFeaturesDefinition = {
            USE_COLLIDER: !1,
            USE_ATTRACTOR: !1,
            USE_VORTEX: !1,
            USE_SPHERE_COLLIDER: !1,
            USE_BOX_COLLIDER: !1,
            USE_FORCE_LOCAL_SPACE: !1,
            USE_NORMALS: !1,
            USE_CURL_NOISE: !0,
            USE_SIMPLEX_NOISE: !1,
            USE_FBM_NOISE: !1
        };
        this.textureLoader = new my;
        this.currentWorldPosition = new _;
        this.systemQuaternion = new je;
        this.worldGravity = new _(0, 0, 0);
        this.directionAxis = new _(0, 0, 0);
        this.colliderV3 = new _(0, 0, 0);
        this.colliderQuaternion = new je(0, 0, 0, 1);
        this.matrixAutoUpdate = !0, this.renderer = e, this.system = r, this.shared = r.context.shared;
        let i = r.data;
        this.material = new Fx(i.renderMaterial, r.context), this.material.uniforms = {
            uSize: {
                value: 0
            },
            uSizeEnd: {
                value: 0
            },
            uColor: {
                value: i.renderMaterial.color
            },
            uColor2: {
                value: i.renderMaterial.color2
            },
            uPosition: {
                value: new _(0, 0, 0)
            },
            uEmissionData: {
                value: new _(0, 0, 0)
            },
            uTexture: {
                value: this.defaultTexture
            },
            uWorldOffset: {
                value: new _(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new He(0, 0, 0, 1)
            },
            uRandScaleFactor: {
                value: i.randomScale ?? 0
            },
            uRandRotationFactor: {
                value: i.randomRotation ?? 0
            },
            uRotation: {
                value: i.renderMaterial.spriteRotation[0] ?? 0
            },
            uRotationEnd: {
                value: i.renderMaterial.spriteRotation[1] ?? 0
            }
        }, this.setTexture(this.material.uniforms, i.renderMaterial.texture), this.init(i);
    }
    setTexture(e, r) {
        let i = r.data;
        if (typeof r == "string") {
            let s = this.shared.image(r), o = new qt(s.img);
            o.needsUpdate = !0, e.uTexture.value = o;
            return;
        }
        if (typeof i != "string") {
            let s = new Image;
            s.onload = ()=>{
                let l = new qt(s);
                l.needsUpdate = !0, e.uTexture.value = l;
            };
            let o = new Blob([
                i
            ], {
                type: "image/*"
            }), a = URL.createObjectURL(o);
            s.src = a;
        }
    }
    updateGeometryAttributes(e, r) {
        let i = I3(r);
        !this.emitterShape?.positionsAttribute || e.geometry.setAttribute("ref", new uo(i, 2));
    }
    applyWorldSpace() {
        if (!this.system.started || !this.worldSpace || !this.positionSimRT || !this.velocitySimRT) return;
        let e = this.system;
        e.getWorldQuaternion(this.systemQuaternion), this.systemQuaternion.invert(), e.getWorldPosition(this.currentWorldPosition), this.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.positionSimRT.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.systemQuaternion.invert(), this.positionSimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.velocitySimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize());
    }
    update(e, r) {
        if (!this.gpuCompute || !this.positionSimRT || !this.velocitySimRT || !this.emissionRateSimRT || this.hasBeenReset) return;
        if (this.checkIfAllParticlesAreDead() && !this.hasBeenReset) {
            this.reset();
            return;
        }
        this.applyWorldSpace(), this.globalTime = e, this.positionSimRT.material.uniforms.uTime.value = e, this.emissionRateSimRT.material.uniforms.uTime.value = e;
        let i = 1e3 / r, s = this.targetFPS / i, o = this.previousRatio + (s - this.previousRatio) * this.lerpFactor;
        this.positionSimRT.material.uniforms.uFPSRatio.value = o, this.previousRatio = o;
        let a = this.isEmitting ? this.GoEmitSomeParticles(e, this.system.data.birthRatePerSec) : 0;
        this.emissionRateSimRT.material.uniforms.uLastIndexEmitted.value = this.emittedParticlesAmount, this.emissionRateSimRT.material.uniforms.uParticlesToEmit.value = a, this.material.uniforms.uPosition.value = this.gpuCompute.getCurrentRenderTarget(this.positionSimRT)?.texture, this.system.colliderEntities.length > 0 && this.renderColliders(), this.gpuCompute.compute();
    }
    renderColliders() {
        if (!this.velocitySimRT) return;
        let e = this.system.colliderEntities[0];
        if (!e) return;
        e.getWorldPosition(this.colliderV3), this.velocitySimRT.material.uniforms.uColliderPos.value.copy(this.colliderV3);
        let r = e.data.size;
        this.colliderV3.fromArray(r), this.velocitySimRT.material.uniforms.uColliderSize.value.copy(this.simFeaturesDefinition.USE_SPHERE_COLLIDER ? this.colliderV3.multiplyScalar(.5) : this.colliderV3), e.getWorldQuaternion(this.colliderQuaternion), this.velocitySimRT.material.uniforms.uColliderQuaternion.value.copy(this.colliderQuaternion.normalize()), this.velocitySimRT.material.uniforms.uColliderQuaternionInvert.value.copy(this.colliderQuaternion.normalize().invert());
    }
    updateState(e) {
        !this.velocitySimRT || !this.positionSimRT || (e.renderMaterial && this.updateMaterialState(e.renderMaterial), this.updateParticleState(e));
    }
    updateVariableState(e, r) {
        if (!this.velocitySimRT || !this.positionSimRT) return;
        r[2] === "size" && this.material.updateState({
            size: [
                e,
                this.material.uniforms.uSizeEnd.value
            ]
        }), r[2] === "sizeEnd" && this.material.updateState({
            size: [
                this.material.uniforms.uSize.value,
                e
            ]
        });
        let i = (s, o)=>{
            let a = [
                ...this.system.data.shape.size
            ];
            a[s] = o, this.updateParticleState({
                shape: {
                    ...this.system.data.shape,
                    size: a
                }
            });
        };
        r[2] === "shape_size_0" && i(0, e), r[2] === "shape_size_1" && i(1, e), r[2] === "shape_size_2" && i(2, e), r[2] === "speed" && (this.velocitySimRT.material.uniforms.uSpeed.value = e / I_), r[2] === "gravity" && this.worldGravity.set(0, e / 100, 0), r[2] === "noiseStrength" && (this.noiseStrength = e, this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), r[2] === "noiseScale" && (this.noiseScale = e, this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), r[2] === "direction_x" && (this.directionAxis = this.getDirectionAxis([
            Number(e),
            this.system.data.direction[1],
            this.system.data.direction[2]
        ])), r[2] === "direction_y" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            Number(e),
            this.system.data.direction[2]
        ])), r[2] === "direction_z" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            this.system.data.direction[1],
            Number(e)
        ]));
    }
    updateMaterialState(e) {
        this.material.updateState({
            ...e,
            size: e.size ? [
                Number(this.shared.getVariable(e.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ])),
                Number(this.shared.getVariable(e.size[1], [
                    this.uuid,
                    "particles",
                    "sizeEnd"
                ]))
            ] : [
                0,
                0
            ]
        }), e.texture && (this.setTexture(this.material.uniforms, e.texture), this.material.needsUpdate = !0);
    }
    updateParticleState(e) {
        if (!(!this.positionSimRT || !this.velocitySimRT)) {
            if (this.shouldReInitGPUCompute(e) && this.init($c(this.system.data)), e.life !== void 0 && (this.positionSimRT.material.uniforms.uMaxLifeTime.value = e.life), e.speed !== void 0 && (this.velocitySimRT.material.uniforms.uSpeed.value = Number(this.shared.getVariable(e.speed, [
                this.uuid,
                "particles",
                "speed"
            ])) / I_), e.collisionBounce !== void 0 && (this.velocitySimRT.material.uniforms.uBounce.value = e.collisionBounce), e.noiseStrength !== void 0 && (this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
                this.uuid,
                "particles",
                "noiseStrength"
            ])), this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), e.noiseScale !== void 0 && (this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
                this.uuid,
                "particles",
                "noiseScale"
            ])), this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), e.noiseSeed !== void 0 && (this.velocitySimRT.material.uniforms.uNoiseSeed.value = e.noiseSeed), e.randomMass !== void 0 && (this.velocitySimRT.material.uniforms.uRandomMassFactor.value = e.randomMass), e.renderMaterial?.size !== void 0) {
                let r = this.shared.getVariable(e.renderMaterial.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ]);
                this.velocitySimRT.material.uniforms.particleSize.value = Number(r);
            }
            if (e.renderMaterial?.spriteRotation !== void 0 && (this.material.uniforms.uRotation.value = e.renderMaterial.spriteRotation[0], this.material.uniforms.uRotationEnd.value = e.renderMaterial.spriteRotation[1]), e.shape !== void 0) {
                let r = e.shape.size ?? this.system.data.shape.size, i = [
                    Number(this.shared.getVariable(r[0], [
                        this.uuid,
                        "particles",
                        "shape_size_0"
                    ])),
                    Number(this.shared.getVariable(r[1], [
                        this.uuid,
                        "particles",
                        "shape_size_1"
                    ])),
                    Number(this.shared.getVariable(r[2], [
                        this.uuid,
                        "particles",
                        "shape_size_2"
                    ]))
                ], s = {
                    ...$c(this.system.data).shape,
                    size: i
                };
                this.emitterShape?.applyToShader(this.positionSimRT.material.uniforms, s);
            }
            if (e.gravity !== void 0 && (this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
                this.uuid,
                "particles",
                "gravity"
            ])) / 100, 0), this.velocitySimRT.material.uniforms.uGravity = {
                value: this.worldGravity
            }), e.direction !== void 0) {
                let r = this.getDirectionFromVariable(e.direction);
                this.directionAxis = this.getDirectionAxis(r), this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis;
            }
            e.randomRotation !== void 0 && (this.material.uniforms.uRandRotationFactor.value = e.randomRotation), e.randomScale !== void 0 && (this.material.uniforms.uRandScaleFactor.value = e.randomScale);
        }
    }
    updateForceFieldParameters(e) {
        !this.velocitySimRT || (e.forceIntensity !== void 0 && (this.velocitySimRT.material.uniforms.uForceIntensity.value = e.forceIntensity), e.forceDambing !== void 0 && (this.velocitySimRT.material.uniforms.uForceDamping.value = e.forceDambing));
    }
    getDirectionAxis(e) {
        let r = [
            Number(e[0]) * Se.DEG2RAD,
            Number(e[1]) * Se.DEG2RAD,
            Number(e[2]) * Se.DEG2RAD
        ], i = new Kt(r[0], r[1], r[2], "XYZ");
        return this.directionAxis.set(0, 1, 0).applyEuler(i).normalize(), this.velocitySimRT && (this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis), this.directionAxis;
    }
    shouldReInitGPUCompute(e) {
        let { birthRatePerSec: r, rootObjectType: i, colliderEntityId: s, shape: o, emitTimeDuration: a, emitTimeCycle: l, life: u, directionMode: c, noiseType: d } = e;
        return r !== void 0 || i !== void 0 || s || s === null || l !== void 0 || o !== void 0 || u !== void 0 || a !== void 0 || c !== void 0 || d !== void 0;
    }
    init(e) {
        this.dispose(), this.particlesAmount = this.getMaxParticlesAmount({
            birthRatePerSecond: e.birthRatePerSec,
            particleMaxLifeTime: e.life,
            loopDuration: e.emitTimeCycle === "infinity" ? 0 : e.emitTimeDuration
        }), this.particlesAmount > 1e5 && (console.warn(`The maximum number of particles is limited to ${1e5}.`), this.particlesAmount = 1e5), this.emitterShape = this.createShape(e.shape, this.particlesAmount);
        let r = setInterval(()=>{
            if (!!this.emitterShape) {
                if (isNaN(this.emitterShape.positionsTexture.source.data.data[0])) {
                    this.init(e);
                    return;
                } else clearInterval(r);
            }
        }, 100);
        if (!this.emitterShape) return;
        let i = new Lx(this.emitterShape.textureSize, this.emitterShape.textureSize, this.renderer), s = this.updateSimulationDefinition(e), o = i.addVariable("uCurrentPosition", s + F3, this.emitterShape.positionsTexture), a = i.addVariable("uCurrentVelocity", s + G3, this.emitterShape.directionsTexture), l = i.addVariable("uCurrentEmissionRate", Q3, N3(this.emitterShape.textureSize));
        i.setVariableDependencies(o, [
            o,
            a,
            l
        ]), i.setVariableDependencies(a, [
            o,
            a,
            l
        ]), i.setVariableDependencies(l, [
            o,
            a,
            l
        ]);
        let u = B3({
            size: this.emitterShape.textureSize
        }), c = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uWorldOffset: {
                value: new _(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new He(0, 0, 0, 1)
            },
            uTime: {
                value: 0
            },
            uFPSRatio: {
                value: 1
            },
            uMaxLifeTime: {
                value: e.life
            },
            uEmitterSize: {
                value: new _(Number(this.shared.getVariable(e.shape.size[0], [
                    this.uuid,
                    "particles",
                    "shape_size_0"
                ])), Number(this.shared.getVariable(e.shape.size[1], [
                    this.uuid,
                    "particles",
                    "shape_size_1"
                ])), Number(this.shared.getVariable(e.shape.size[2], [
                    this.uuid,
                    "particles",
                    "shape_size_2"
                ])))
            },
            particleSize: {
                value: 0
            }
        };
        o.material.uniforms = c;
        let d = this.getDirectionFromVariable(e.direction);
        this.directionAxis = this.getDirectionAxis(d), this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
            this.uuid,
            "particles",
            "gravity"
        ])) / 100, 0), this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
            this.uuid,
            "particles",
            "noiseStrength"
        ])), this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
            this.uuid,
            "particles",
            "noiseScale"
        ]));
        let h = e.colliderEntityId && this.system.getColliderData(e.colliderEntityId), f = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uDirections: {
                value: this.emitterShape.directionsTexture
            },
            uDirectionsAxis: {
                value: this.directionAxis
            },
            uWorldQuaternion: {
                value: new He(0, 0, 0, 1)
            },
            uColliderPos: {
                value: new _(0, 0, 0)
            },
            uColliderSize: {
                value: new _(0, 0, 0)
            },
            uForceIntensity: {
                value: h ? h.forceIntensity : 0
            },
            uForceDamping: {
                value: h ? h.forceDambing : 0
            },
            uColliderQuaternion: {
                value: new He(0, 0, 0, 1)
            },
            uColliderQuaternionInvert: {
                value: new He(0, 0, 0, 1)
            },
            particleSize: {
                value: 0
            },
            uGravity: {
                value: this.worldGravity
            },
            uNoiseStrength: {
                value: this.noiseStrength
            },
            uNoiseScale: {
                value: this.noiseScale
            },
            uNoiseSeed: {
                value: e.noiseSeed
            },
            uRandomMassFactor: {
                value: e.randomMass
            },
            uBounce: {
                value: e.collisionBounce
            },
            uSpeed: {
                value: Number(this.shared.getVariable(e.speed, [
                    this.uuid,
                    "particles",
                    "speed"
                ])) / I_
            }
        };
        a.material.uniforms = f;
        let p = {
            uIndex: {
                value: u
            },
            uTime: {
                value: 0
            },
            uLastIndexEmitted: {
                value: 0
            },
            uParticlesToEmit: {
                value: 0
            }
        };
        l.material.uniforms = p;
        let m = [
            Number(this.shared.getVariable(e.shape.size[0], [
                this.uuid,
                "particles",
                "shape_size_0"
            ])),
            Number(this.shared.getVariable(e.shape.size[1], [
                this.uuid,
                "particles",
                "shape_size_1"
            ])),
            Number(this.shared.getVariable(e.shape.size[2], [
                this.uuid,
                "particles",
                "shape_size_2"
            ]))
        ], g = {
            ...$c(this.system.data).shape,
            size: m
        };
        this.emitterShape.applyToShader(o.material.uniforms, g), i.init(), this.gpuCompute = i, this.positionSimRT = o, this.velocitySimRT = a, this.emissionRateSimRT = l, this.rootObject = this.createPrimaryEmitter(this.emitterShape.textureSize), this.add(this.rootObject), this.material.needsUpdate = !0;
    }
    getDirectionFromVariable(e) {
        let r = Number(this.shared.getVariable(e[0], [
            this.uuid,
            "particles",
            "direction_x"
        ])), i = Number(this.shared.getVariable(e[1], [
            this.uuid,
            "particles",
            "direction_y"
        ])), s = Number(this.shared.getVariable(e[2], [
            this.uuid,
            "particles",
            "direction_z"
        ]));
        return [
            r,
            i,
            s
        ];
    }
    updateSimulationDefinition(e) {
        if (this.simFeaturesDefinition.USE_COLLIDER = !1, this.simFeaturesDefinition.USE_ATTRACTOR = !1, this.simFeaturesDefinition.USE_VORTEX = !1, this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !1, this.simFeaturesDefinition.USE_BOX_COLLIDER = !1, this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !1, this.simFeaturesDefinition.USE_NORMALS = !1, this.simFeaturesDefinition.USE_CURL_NOISE = !1, this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !1, this.simFeaturesDefinition.USE_FBM_NOISE = !1, e.colliderEntityId && this.system.colliderEntities.length > 0) {
            let i = this.system.getColliderData(e.colliderEntityId);
            switch(i?.forceType){
                case "attractor":
                    this.simFeaturesDefinition.USE_ATTRACTOR = !0;
                    break;
                case "collider":
                    this.simFeaturesDefinition.USE_COLLIDER = !0;
                    break;
                case "vortex":
                    this.simFeaturesDefinition.USE_VORTEX = !0;
                    break;
            }
            let s = i?.colliderType;
            s === "sphere" && (this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !0), s === "box" && (this.simFeaturesDefinition.USE_BOX_COLLIDER = !0), i?.forceRange === "helper" && (this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !0);
        }
        e.directionMode === "normals" && (this.simFeaturesDefinition.USE_NORMALS = !0), e.noiseType === "curl" && (this.simFeaturesDefinition.USE_CURL_NOISE = !0), e.noiseType === "simplex" && (this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !0), e.noiseType === "fbm" && (this.simFeaturesDefinition.USE_FBM_NOISE = !0);
        let r = "";
        for (let [i, s] of Object.entries(this.simFeaturesDefinition))s && (r += `#define ${i}
`);
        return r;
    }
    createShape(e, r) {
        this.emitterShape && this.emitterShape.dispose();
        let i = new _(Number(this.shared.getVariable(e.size[0], [
            this.uuid,
            "particles",
            "shape_size_0"
        ])), Number(this.shared.getVariable(e.size[1], [
            this.uuid,
            "particles",
            "shape_size_1"
        ])), Number(this.shared.getVariable(e.size[2], [
            this.uuid,
            "particles",
            "shape_size_2"
        ])));
        if (e.type === "MeshEmitterShape") {
            let s = null;
            return this.system.context.scene.traverseEntity((o)=>{
                o.uuid === e.fromMeshId && (s = o);
            }), s ? new Ef(i, r, e.type, s) : new Ef(i, r, "SphereEmitterShape");
        } else return new Ef(i, r, e.type);
    }
    createPrimaryEmitter(e) {
        let r, i = e * e;
        return r = new cy(new hn(1, 1, 1), this.material, i), this.updateGeometryAttributes(r, e), this.material.needsUpdate = !0, r.onBeforeRender = ()=>{
            this.applyWorldSpace();
        }, r;
    }
    getMaxParticlesAmount({ birthRatePerSecond: e, particleMaxLifeTime: r, loopDuration: i = 0 }) {
        return Math.ceil(e * (r + i));
    }
    dispose() {
        !this.gpuCompute || (this.rootObject?.parent?.remove(this.rootObject), this.gpuCompute.dispose(), this.material.nodeMaterialDispose(), this.emitterShape?.dispose());
    }
    GoEmitSomeParticles(e, r) {
        let i = e - this.lastEmitTime, s = 1 / r;
        if (i >= s) {
            let o = Math.max(1, Math.floor(i / s));
            return this.lastEmitTime = e, this.emittedParticlesAmount + o > this.particlesAmount && (this.emittedParticlesAmount = 0), this.emittedParticlesAmount += o, o;
        }
        return 0;
    }
    checkIfAllParticlesAreDead() {
        return this.lastEmitTime + this.system.data.life + 1 < this.globalTime;
    }
    reset() {
        this.hasBeenReset = !0, this.lastEmitTime = 0, this.emittedParticlesAmount = 0, this.gpuCompute && this.init($c(this.system.data));
    }
    startEmitting() {
        this.isEmitting = !0, this.hasBeenReset = !1, this.lastEmitTime = this.globalTime;
    }
    stopEmitting() {
        this.isEmitting = !1;
    }
};
var eu = class extends nr {
    constructor(e, r, i){
        super(e, r);
        this.type = "ParticleSystem";
        this.geometry = new we;
        this.actualTime = 0;
        this.currentLoopTime = 0;
        this.started = !1;
        this.stopped = !1;
        this.isFrozen = !1;
        this.isIdle = !0;
        this.emitter = null;
        this.colliderEntities = [];
        this.renderer = null;
        this.isPreWarm = !1;
        this._hasOnAfterRenderBeenCalled = !1;
        this.onAfterRender = (e)=>{
            this._hasOnAfterRenderBeenCalled || (this._hasOnAfterRenderBeenCalled = !0, this.init(e));
        };
        this.context = i, this.data = {
            ...r,
            ...$c(r)
        }, this.geometry.setAttribute("position", new be([], 3)), this.frustumCulled = !1;
    }
    init(e) {
        this.renderer = e, this.emitter = new kx(e, this), this.add(this.emitter), this.updateParticleState(this.data);
    }
    update(e) {
        if (!this.isReady || !this.started || this.isFrozen || this.isIdle) return;
        this.actualTime += e, this.stopped || (this.currentLoopTime += e);
        let r = this.data.emitTimeCycle === "one_time";
        if ((this.data.emitTimeCycle === "loop" || r) && this.currentLoopTime > this.data.emitTimeDuration * 1e3 && (this.stopped || (this.stop(), r || this.start(this.data.emitTimeLoopDelayStart === "start" ? 0 : this.data.emitTimeDelay * 1e3))), this.emitter && this.started) {
            let s = this.actualTime / 1e3;
            this.emitter.update(s, e);
        }
        this.scale.set(1, 1, 1), this.updateMatrix();
    }
    isReady() {
        return !!this.emitter;
    }
    hasCollider(e) {
        return this.colliderEntities.some((r)=>r.identity === e);
    }
    getColliderData(e) {
        let r = this.colliderEntities.find((i)=>i.identity === e);
        return r ? r.data : null;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), wt(e.path, [
            "renderMaterial"
        ]) && this.updateParticleState({
            renderMaterial: {
                ...this.data.renderMaterial,
                ...Mr.drop(e, 1).props
            }
        }), wt(e.path, [
            "shape"
        ]) && this.updateParticleState({
            shape: {
                ...this.data.shape,
                ...Mr.drop(e, 1).props
            }
        });
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateParticleState(e);
    }
    updateParticleState(e) {
        if (!!this.emitter) {
            if (e.colliderEntityId !== void 0 && e.colliderEntityId !== null) {
                let r = this.context.scene.find(e.colliderEntityId);
                this.colliderEntities = r ? [
                    r
                ] : [];
            }
            e.colliderEntityId === null && (this.colliderEntities = []), this.emitter.updateState(e), e.emitTimeCycle && this.started && this.start();
        }
    }
    updateFromColliderEntity(e) {
        !this.emitter || (this.emitter.updateForceFieldParameters(e), this.stop(), this.start());
    }
    start(e = 0) {
        if (this.currentLoopTime = 0, e) {
            setTimeout(()=>{
                this.start(0);
            }, e);
            return;
        }
        this.started = !0, this.stopped = !1, this.isFrozen = !1, this.emitter?.startEmitting();
    }
    froze() {
        this.isFrozen = !0;
    }
    unFroze() {
        this.isFrozen = !1;
    }
    stop() {
        this.stopped = !0, this.currentLoopTime = 0, this.emitter?.stopEmitting();
    }
    reset() {
        this.started = !1, this.stopped = !1, this.emitter?.reset();
    }
    wakeUp() {
        this.isIdle = !1;
    }
    sleep() {
        this.isIdle = !0, this.reset();
    }
};
function LQ(n1, t, e) {
    let r;
    return t.geometry.type === "TextGeometry" ? new tf(n1, t, e) : (t.geometry.type === "SubdivGeometry" ? r = new Qs(n1, t, e) : t.geometry.type === "PathGeometry" ? r = new Hl(n1, t, e) : t.geometry.type === "VectorGeometry" ? r = new Ox(n1, t, e) : t.geometry.type === "BooleanGeometry" ? r = new Ln(n1, t, e) : t.geometry.type === "UIGeometry" ? r = new fr(n1, t, e) : r = new er(n1, t, e), r);
}
function zx(n1, t, e) {
    return console.assert(t.type !== void 0), t.type === "Mesh" ? LQ(n1, t, e) : t.type === "Empty" ? new Ss(n1, t) : t.type === "Particle" ? new eu(n1, t, e) : t.type === "ParticleCollider" ? new Xc(n1, t, e) : t.type === "Splat" ? new Ss(n1, t) : t.type === "Bone" ? new Rx(n1, t) : t.type === "Page" ? new sr(n1, t, e) : t.type === "PointLight" ? new Dx(n1, t, e) : t.type === "SpotLight" ? new wf(n1, t, e) : t.type === "DirectionalLight" ? new Sf(n1, t, e) : t.type === "Component" || t.type === "Instance" ? new Js(n1, t, e) : ks.is(t.type) ? new hr(n1, t) : (console.error(t), new Ss(n1, t));
}
Gs.createEntity = zx;
function BQ(n1, t, e) {
    let r = zx(n1.identity, t, e), i = n1.children, s = n1.attachedPaths, o = n1.parent, a = n1.component, l = n1.instances, u = n1.overrideData, c = n1.uuid, d = n1.stateSelection;
    n1.dispose();
    for (let h of Object.keys(n1))delete n1[h];
    Object.setPrototypeOf(n1, Object.getPrototypeOf(r));
    for (let h of Object.keys(r))n1[h] = r[h];
    n1.children = [
        ...n1.children,
        ...i
    ], n1.attachedPaths = s, n1.parent = o, n1.component = a, n1.instances = l, n1.uuid = c, n1.overrideData = u, n1.updateState(n1.data, e), d && n1.changeSelectedState(d, e), n1.resetBBoxNeedsUpdate();
}
Gs.changeEntityProptotype = BQ;
Gs.Cloner = Gi;
function Z3(n1, t, e, r) {
    n1.updateByOp(t, e, r, !1);
}
function J3(n1, t) {
    let e = !1, r = t.getLayersOfType("transmission"), i = t.getLayersOfType("outline");
    return i.length > 0 && (n1.layers.set(8), r.length > 0 && n1.layers.enable(3), e = !0, $h(n1), Jh(n1)), r.length === 0 && i.length === 0 && n1.layers.set(0), n1 instanceof gs && n1.needsAO && n1.layers.enable(5), e;
}
function $3(n1, t) {
    if (!t.layers) return !1;
    let e = !1, r = t.getLayersOfType("transmission").filter((s)=>s.data.visible), i = t.getLayersOfType("outline").filter((s)=>s.data.visible);
    return r.length > 0 && (n1.layers.set(3), i.length > 0 && n1.layers.enable(8), e = !0), r.length === 0 && i.length === 0 && n1.layers.set(0), n1.needsAO && n1.layers.enable(5), e;
}
function eL(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof gs) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)J3(e, e.material[r]) && (t = !0);
            else J3(e, e.material) && (t = !0);
        }
    }), t;
}
function tL(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof gs) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)$3(e, e.material[r]) && (t = !0);
            else $3(e, e.material) && (t = !0);
        }
    }), t;
}
var NQ = new Yu, FQ = new te, kQ = new Rs;
function Vm(n1, t, e, r = !1) {
    let i = n1.cloner;
    if (i) for (let s of i.children){
        let o = FQ.copy(s.matrixWorld).invert(), a = kQ.copy(t.ray).applyMatrix4(o), l = n1.matrixWorld;
        a.applyMatrix4(l);
        let u = NQ;
        u.set(a.origin, a.direction), u.near = t.near, u.far = t.far;
        let c = u.intersectObject(n1, !1);
        c.length > 0 && e.push({
            ...c[0],
            object: r ? s : n1
        });
    }
}
var Vx = class {
    constructor(){
        this._constraints = new Map;
    }
    setConstraint(t, e) {
        e === null ? this._constraints.delete(t) : this._constraints.set(t, e);
    }
    removeDependencies(t) {
        this._constraints.delete(t);
    }
    applyConstraints(t) {
        let e = new Set;
        this._constraints.forEach((r, i)=>{
            let s = [
                i,
                r
            ], o = r;
            for(; this._constraints.has(o);)o = this._constraints.get(o), e.has(o) || s.push(o);
            for(let a = s.length - 2; a >= 0; a--)if (!e.has(s[a])) {
                let l = t.find(s[a]);
                l ? l.applyPathSnapping(t) : console.warn(`missing entity ${s[a]}`), e.add(s[a]);
            }
        });
    }
    findDependency(t, e) {
        let r = t;
        for(; this._constraints.has(r);)if (r = this._constraints.get(r), r === e) return !0;
        return !1;
    }
};
var $s = Pi(Tf()), zo = Pi(Mf());
var Ur = Pi(Tf()), Ze = Pi(Mf()), Wl = class {
    constructor(t, e, r){
        this._dataNormalized = t, this._minD = e, this._maxD = r;
    }
    static createFromUnnormalized(t) {
        let e = Ze.sup(t), r = Ze.inf(t), i = (0, Ur.default)(new Float32Array(t.size), t.shape), s = e - r;
        return s < 1e-4 ? Ze.assigns(i, 0) : (Ze.subs(i, t, r), Ze.divs(i, i, s)), new Wl(i, r, e);
    }
    get data() {
        return this._dataNormalized;
    }
    get minD() {
        return this._minD;
    }
    get maxD() {
        return this._maxD;
    }
    denormalize() {
        let t = (0, Ur.default)(new Float32Array(this._dataNormalized.size), this._dataNormalized.shape);
        return Ze.muls(t, this._dataNormalized, this._maxD - this._minD), Ze.adds(t, t, this._minD), t;
    }
}, pr = class {
    constructor(t, e){
        this._quantized = t, this._method = e;
    }
    get quantized() {
        return this._quantized;
    }
    static maxIntBits(t) {
        return 2 ** t - 1;
    }
    static fromNormalized(t, e) {
        let r = t.data, i;
        if (e === "norm8x") {
            let s = pr.maxIntBits(8), o = (0, Ur.default)(new Float32Array(r.size), r.shape);
            Ze.muls(o, r, s), Ze.roundeq(o), i = (0, Ur.default)(new Uint8Array(o.data), r.shape);
        } else if (e === "norm565") {
            let s = (0, Ur.default)(new Float32Array(r.size), r.shape);
            Ze.assign(s, r), Ze.mulseq(s.pick(null, 0), pr.maxIntBits(5)), Ze.mulseq(s.pick(null, 1), pr.maxIntBits(6)), Ze.mulseq(s.pick(null, 2), pr.maxIntBits(5)), Ze.roundeq(s);
            let o = (0, Ur.default)(new Uint16Array(s.data), r.shape), a = (0, Ur.default)(new Uint16Array(r.shape[0]), [
                r.shape[0]
            ]), l = (0, Ur.default)(new Uint16Array(r.shape[0]), [
                r.shape[0]
            ]);
            Ze.lshifts(a, o.pick(null, 0), 11), Ze.lshifts(l, o.pick(null, 1), 5), Ze.boreq(a, l), Ze.boreq(a, o.pick(null, 2)), i = a;
        } else {
            let s = (0, Ur.default)(new Float32Array(r.size), r.shape);
            Ze.assign(s, r), Ze.mulseq(s.pick(null, 0), pr.maxIntBits(11)), Ze.mulseq(s.pick(null, 1), pr.maxIntBits(10)), Ze.mulseq(s.pick(null, 2), pr.maxIntBits(11)), Ze.roundeq(s);
            let o = (0, Ur.default)(new Uint32Array(s.data), r.shape), a = (0, Ur.default)(new Uint32Array(r.shape[0]), [
                r.shape[0]
            ]), l = (0, Ur.default)(new Uint32Array(r.shape[0]), [
                r.shape[0]
            ]);
            Ze.lshifts(a, o.pick(null, 0), 21), Ze.lshifts(l, o.pick(null, 1), 11), Ze.boreq(a, l), Ze.boreq(a, o.pick(null, 2)), i = a;
        }
        return new pr(i, e);
    }
    dequantize(t, e) {
        let r = this._method, i, s = this._quantized;
        if (r === "norm8x") {
            let o = pr.maxIntBits(8);
            i = (0, Ur.default)(new Float32Array(s.size), s.shape), Ze.muls(i, s, 1 / o);
        } else if (r === "norm565") {
            let o = (0, Ur.default)(new Uint8Array(s.shape[0]), [
                s.shape[0]
            ]), a = (0, Ur.default)(new Uint8Array(s.shape[0]), [
                s.shape[0]
            ]), l = (0, Ur.default)(new Uint8Array(s.shape[0]), [
                s.shape[0]
            ]);
            Ze.rrshifts(o, s, 11), Ze.rrshifts(a, s, 5), Ze.bandseq(a, pr.maxIntBits(6)), Ze.bands(l, s, pr.maxIntBits(5)), i = (0, Ur.default)(new Float32Array(s.shape[0] * 3), [
                s.shape[0],
                3
            ]), Ze.muls(i.pick(null, 0), o, 1 / pr.maxIntBits(5)), Ze.muls(i.pick(null, 1), a, 1 / pr.maxIntBits(6)), Ze.muls(i.pick(null, 2), l, 1 / pr.maxIntBits(5));
        } else {
            let o = (0, Ur.default)(new Uint16Array(s.shape[0]), [
                s.shape[0]
            ]), a = (0, Ur.default)(new Uint16Array(s.shape[0]), [
                s.shape[0]
            ]), l = (0, Ur.default)(new Uint16Array(s.shape[0]), [
                s.shape[0]
            ]);
            Ze.rrshifts(o, s, 21), Ze.rrshifts(a, s, 11), Ze.bandseq(a, pr.maxIntBits(10)), Ze.bands(l, s, pr.maxIntBits(11)), i = (0, Ur.default)(new Float32Array(s.shape[0] * 3), [
                s.shape[0],
                3
            ]), Ze.muls(i.pick(null, 0), o, 1 / pr.maxIntBits(11)), Ze.muls(i.pick(null, 1), a, 1 / pr.maxIntBits(10)), Ze.muls(i.pick(null, 2), l, 1 / pr.maxIntBits(11));
        }
        return new Wl(i, t, e);
    }
};
var mr = class {
    constructor(t, e, r, i, s, o = !1){
        this._quantized = t, this._minMaxMatrix = e, this._chunkSize = r, this._quantizationMethod = i, this._variableChunkSize = s, this._isDynamicChunks = o;
    }
    get length() {
        return this._quantized.shape[0];
    }
    get nchunks() {
        return this._minMaxMatrix.shape[0];
    }
    get quantized() {
        return this._quantized;
    }
    get method() {
        return this._quantizationMethod;
    }
    get minmaxMatrix() {
        return this._minMaxMatrix;
    }
    _createPrunedMinMax(t) {
        let e = t.length, r = this.minmaxMatrix.shape[0] - e, i = (0, $s.default)(new Float32Array(r * 2), [
            r,
            2
        ]), s = 0, o = r, a = 0, l = this.minmaxMatrix.shape[0];
        for(let u = 0; u < t.length; u++)l = t[u], o = l - a + s, o > s && zo.assign(i.hi(o, 2).lo(s, 0), this.minmaxMatrix.hi(l, 2).lo(a, 0)), s = o, a = l + 1;
        return s < r && zo.assign(i.lo(s, 0), this.minmaxMatrix.lo(a, 0)), i;
    }
    _createPrunedQuantized(t) {
        let e = t.length, r = this.quantized.shape[0] - e, i = this._quantizationMethod, s, o;
        if (i === "norm8x") {
            o = this._quantized.shape[1];
            let d = o ? r * o : r;
            s = (0, $s.default)(new Uint8Array(d), o ? [
                r,
                o
            ] : [
                r,
                1
            ]);
        } else i === "norm565" ? s = (0, $s.default)(new Uint16Array(r), [
            r
        ]) : s = (0, $s.default)(new Uint32Array(r), [
            r
        ]);
        let a = 0, l = r, u = 0, c = s.shape[0];
        for(let d = 0; d < t.length; d++)c = t[d], l = c - u + a, l > a && (o ? zo.assign(s.hi(l, o).lo(a, 0), this._quantized.hi(c, o).lo(u, 0)) : zo.assign(s.hi(l).lo(a), this._quantized.hi(c).lo(u))), a = l, u = c + 1;
        return a < r && (o ? zo.assign(s.lo(a, 0), this._quantized.lo(u, 0)) : zo.assign(s.lo(a), this._quantized.lo(u))), s;
    }
    pruneFeature(t, e, r) {
        let i = this._createPrunedQuantized(t), s = this._createPrunedMinMax(e);
        return new mr(i, s, this._chunkSize, this._quantizationMethod, r, !0);
    }
    static getRequiredNChunks(t, e) {
        return Math.floor(t / e);
    }
    static fromArray(t, e, r) {
        let i = t.shape[0], s = Math.floor(i / r), o = (0, $s.default)(new Float32Array(s * 2), [
            s,
            2
        ], [
            2,
            1
        ]), a;
        e === "norm8x" ? a = (0, $s.default)(new Uint8Array(t.size), t.shape) : e === "norm565" ? a = (0, $s.default)(new Uint16Array(t.shape[0]), [
            t.shape[0]
        ]) : a = (0, $s.default)(new Uint32Array(t.shape[0]), [
            t.shape[0]
        ]);
        for(let l = 0; l < s; l++){
            let u = l * r, c = l + 1 < s ? (l + 1) * r : i, d;
            t.shape.length > 1 ? d = Wl.createFromUnnormalized(t.hi(c, t.shape[1]).lo(u, 0)) : d = Wl.createFromUnnormalized(t.hi(c).lo(u)), o.set(l, 0, d.minD), o.set(l, 1, d.maxD), a.shape.length > 1 ? zo.assign(a.hi(c, a.shape[1]).lo(u, 0), pr.fromNormalized(d, e).quantized) : zo.assign(a.hi(c).lo(u), pr.fromNormalized(d, e).quantized);
        }
        return new mr(a, o, r, e);
    }
    denormDequant() {
        let t = this._minMaxMatrix.shape[0], e = this._quantized, r = e.shape[0], i = this._quantizationMethod, s = this._chunkSize, o;
        if (this._isDynamicChunks) {
            if (!this._variableChunkSize) throw new Error("variable chunk must exists if chunkSize isDynamic");
            o = this._variableChunkSize;
        }
        let a;
        i === "norm8x" ? a = (0, $s.default)(new Float32Array(e.size), e.shape) : a = (0, $s.default)(new Float32Array(r * 3), [
            r,
            3
        ]);
        let l = 0, u = s;
        for(let c = 0; c < t; c++){
            let [d, h] = [
                this._minMaxMatrix.get(c, 0),
                this._minMaxMatrix.get(c, 1)
            ];
            this._isDynamicChunks && (u = o[c]);
            let f = c + 1 < t ? l + u : r, p;
            e.shape.length > 1 ? p = new pr(e.hi(f, e.shape[1]).lo(l, 0), i) : p = new pr(e.hi(f).lo(l), i), zo.assign(a.hi(f, a.shape[1]).lo(l, 0), p.dequantize(d, h).denormalize()), l = f;
        }
        return a;
    }
    static async fetchArrayBuffer(t) {
        return await (await fetch(t, {
            mode: "cors"
        })).arrayBuffer();
    }
};
var La = Pi(Tf()), _t = Pi(Mf());
var AL = "http://127.0.0.1:8000";
var tu = Pi(Tf()), or = Pi(Mf());
var _L = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9
];
function EL(n1) {
    return n1 < 1e5 ? n1 < 100 ? n1 < 10 ? 0 : 1 : n1 < 1e4 ? n1 < 1e3 ? 2 : 3 : 4 : n1 < 1e7 ? n1 < 1e6 ? 5 : 6 : n1 < 1e9 ? n1 < 1e8 ? 7 : 8 : 9;
}
function TL(n1, t) {
    if (n1 === t) return 0;
    if (~~n1 === n1 && ~~t === t) {
        if (n1 === 0 || t === 0) return n1 < t ? -1 : 1;
        if (n1 < 0 || t < 0) {
            if (t >= 0) return -1;
            if (n1 >= 0) return 1;
            n1 = -n1, t = -t;
        }
        let i = EL(n1), s = EL(t), o = 0;
        return i < s ? (n1 *= _L[s - i - 1], t /= 10, o = -1) : i > s && (t *= _L[i - s - 1], n1 /= 10, o = 1), n1 === t ? o : n1 < t ? -1 : 1;
    }
    let e = String(n1), r = String(t);
    return e === r ? 0 : e < r ? -1 : 1;
}
function cK(n1) {
    let t = 0;
    for(; n1 >= 32;)t |= n1 & 1, n1 >>= 1;
    return n1 + t;
}
function ML(n1, t, e, r) {
    let i = t + 1;
    if (i === e) return 1;
    if (r(n1[i++], n1[t]) < 0) {
        for(; i < e && r(n1[i], n1[i - 1]) < 0;)i++;
        uK(n1, t, i);
    } else for(; i < e && r(n1[i], n1[i - 1]) >= 0;)i++;
    return i - t;
}
function uK(n1, t, e) {
    for(e--; t < e;){
        let r = n1[t];
        n1[t++] = n1[e], n1[e--] = r;
    }
}
function CL(n1, t, e, r, i) {
    for(r === t && r++; r < e; r++){
        let s = n1[r], o = t, a = r;
        for(; o < a;){
            let u = o + a >>> 1;
            i(s, n1[u]) < 0 ? a = u : o = u + 1;
        }
        let l = r - o;
        switch(l){
            case 3:
                n1[o + 3] = n1[o + 2];
            case 2:
                n1[o + 2] = n1[o + 1];
            case 1:
                n1[o + 1] = n1[o];
                break;
            default:
                for(; l > 0;)n1[o + l] = n1[o + l - 1], l--;
        }
        n1[o] = s;
    }
}
function B_(n1, t, e, r, i, s) {
    let o = 0, a = 0, l = 1;
    if (s(n1, t[e + i]) > 0) {
        for(a = r - i; l < a && s(n1, t[e + i + l]) > 0;)o = l, l = (l << 1) + 1, l <= 0 && (l = a);
        l > a && (l = a), o += i, l += i;
    } else {
        for(a = i + 1; l < a && s(n1, t[e + i - l]) <= 0;)o = l, l = (l << 1) + 1, l <= 0 && (l = a);
        l > a && (l = a);
        let u = o;
        o = i - l, l = i - u;
    }
    for(o++; o < l;){
        let u = o + (l - o >>> 1);
        s(n1, t[e + u]) > 0 ? o = u + 1 : l = u;
    }
    return l;
}
function N_(n1, t, e, r, i, s) {
    let o = 0, a = 0, l = 1;
    if (s(n1, t[e + i]) < 0) {
        for(a = i + 1; l < a && s(n1, t[e + i - l]) < 0;)o = l, l = (l << 1) + 1, l <= 0 && (l = a);
        l > a && (l = a);
        let u = o;
        o = i - l, l = i - u;
    } else {
        for(a = r - i; l < a && s(n1, t[e + i + l]) >= 0;)o = l, l = (l << 1) + 1, l <= 0 && (l = a);
        l > a && (l = a), o += i, l += i;
    }
    for(o++; o < l;){
        let u = o + (l - o >>> 1);
        s(n1, t[e + u]) < 0 ? l = u : o = u + 1;
    }
    return l;
}
var F_ = class {
    constructor(t, e){
        Di(this, "array", null);
        Di(this, "compare", null);
        Di(this, "minGallop", 7);
        Di(this, "length", 0);
        Di(this, "tmpStorageLength", 256);
        Di(this, "stackLength", 0);
        Di(this, "runStart", null);
        Di(this, "runLength", null);
        Di(this, "stackSize", 0);
        this.array = t, this.compare = e, this.length = t.length, this.length < 512 && (this.tmpStorageLength = this.length >>> 1), this.tmp = new Array(this.tmpStorageLength), this.stackLength = this.length < 120 ? 5 : this.length < 1542 ? 10 : this.length < 119151 ? 19 : 40, this.runStart = new Array(this.stackLength), this.runLength = new Array(this.stackLength);
    }
    pushRun(t, e) {
        this.runStart[this.stackSize] = t, this.runLength[this.stackSize] = e, this.stackSize += 1;
    }
    mergeRuns() {
        for(; this.stackSize > 1;){
            let t = this.stackSize - 2;
            if (t >= 1 && this.runLength[t - 1] <= this.runLength[t] + this.runLength[t + 1] || t >= 2 && this.runLength[t - 2] <= this.runLength[t] + this.runLength[t - 1]) this.runLength[t - 1] < this.runLength[t + 1] && t--;
            else if (this.runLength[t] > this.runLength[t + 1]) break;
            this.mergeAt(t);
        }
    }
    forceMergeRuns() {
        for(; this.stackSize > 1;){
            let t = this.stackSize - 2;
            t > 0 && this.runLength[t - 1] < this.runLength[t + 1] && t--, this.mergeAt(t);
        }
    }
    mergeAt(t) {
        let e = this.compare, r = this.array, i = this.runStart[t], s = this.runLength[t], o = this.runStart[t + 1], a = this.runLength[t + 1];
        this.runLength[t] = s + a, t === this.stackSize - 3 && (this.runStart[t + 1] = this.runStart[t + 2], this.runLength[t + 1] = this.runLength[t + 2]), this.stackSize--;
        let l = N_(r[o], r, i, s, 0, e);
        i += l, s -= l, s !== 0 && (a = B_(r[i + s - 1], r, o, a, a - 1, e), a !== 0 && (s <= a ? this.mergeLow(i, s, o, a) : this.mergeHigh(i, s, o, a)));
    }
    mergeLow(t, e, r, i) {
        let s = this.compare, o = this.array, a = this.tmp, l = 0;
        for(l = 0; l < e; l++)a[l] = o[t + l];
        let u = 0, c = r, d = t;
        if (o[d++] = o[c++], --i === 0) {
            for(l = 0; l < e; l++)o[d + l] = a[u + l];
            return;
        }
        if (e === 1) {
            for(l = 0; l < i; l++)o[d + l] = o[c + l];
            o[d + i] = a[u];
            return;
        }
        let h = this.minGallop;
        for(;;){
            let f = 0, p = 0, m = !1;
            do if (s(o[c], a[u]) < 0) {
                if (o[d++] = o[c++], p++, f = 0, --i === 0) {
                    m = !0;
                    break;
                }
            } else if (o[d++] = a[u++], f++, p = 0, --e === 1) {
                m = !0;
                break;
            }
            while ((f | p) < h);
            if (m) break;
            do {
                if (f = N_(o[c], a, u, e, 0, s), f !== 0) {
                    for(l = 0; l < f; l++)o[d + l] = a[u + l];
                    if (d += f, u += f, e -= f, e <= 1) {
                        m = !0;
                        break;
                    }
                }
                if (o[d++] = o[c++], --i === 0) {
                    m = !0;
                    break;
                }
                if (p = B_(a[u], o, c, i, 0, s), p !== 0) {
                    for(l = 0; l < p; l++)o[d + l] = o[c + l];
                    if (d += p, c += p, i -= p, i === 0) {
                        m = !0;
                        break;
                    }
                }
                if (o[d++] = a[u++], --e === 1) {
                    m = !0;
                    break;
                }
                h--;
            }while (f >= 7 || p >= 7);
            if (m) break;
            h < 0 && (h = 0), h += 2;
        }
        if (this.minGallop = h, h < 1 && (this.minGallop = 1), e === 1) {
            for(l = 0; l < i; l++)o[d + l] = o[c + l];
            o[d + i] = a[u];
        } else {
            if (e === 0) throw new Error("mergeLow preconditions were not respected");
            for(l = 0; l < e; l++)o[d + l] = a[u + l];
        }
    }
    mergeHigh(t, e, r, i) {
        let s = this.compare, o = this.array, a = this.tmp, l = 0;
        for(l = 0; l < i; l++)a[l] = o[r + l];
        let u = t + e - 1, c = i - 1, d = r + i - 1, h = 0, f = 0;
        if (o[d--] = o[u--], --e === 0) {
            for(h = d - (i - 1), l = 0; l < i; l++)o[h + l] = a[l];
            return;
        }
        if (i === 1) {
            for(d -= e, u -= e, f = d + 1, h = u + 1, l = e - 1; l >= 0; l--)o[f + l] = o[h + l];
            o[d] = a[c];
            return;
        }
        let p = this.minGallop;
        for(;;){
            let m = 0, g = 0, y = !1;
            do if (s(a[c], o[u]) < 0) {
                if (o[d--] = o[u--], m++, g = 0, --e === 0) {
                    y = !0;
                    break;
                }
            } else if (o[d--] = a[c--], g++, m = 0, --i === 1) {
                y = !0;
                break;
            }
            while ((m | g) < p);
            if (y) break;
            do {
                if (m = e - N_(a[c], o, t, e, e - 1, s), m !== 0) {
                    for(d -= m, u -= m, e -= m, f = d + 1, h = u + 1, l = m - 1; l >= 0; l--)o[f + l] = o[h + l];
                    if (e === 0) {
                        y = !0;
                        break;
                    }
                }
                if (o[d--] = a[c--], --i === 1) {
                    y = !0;
                    break;
                }
                if (g = i - B_(o[u], a, 0, i, i - 1, s), g !== 0) {
                    for(d -= g, c -= g, i -= g, f = d + 1, h = c + 1, l = 0; l < g; l++)o[f + l] = a[h + l];
                    if (i <= 1) {
                        y = !0;
                        break;
                    }
                }
                if (o[d--] = o[u--], --e === 0) {
                    y = !0;
                    break;
                }
                p--;
            }while (m >= 7 || g >= 7);
            if (y) break;
            p < 0 && (p = 0), p += 2;
        }
        if (this.minGallop = p, p < 1 && (this.minGallop = 1), i === 1) {
            for(d -= e, u -= e, f = d + 1, h = u + 1, l = e - 1; l >= 0; l--)o[f + l] = o[h + l];
            o[d] = a[c];
        } else {
            if (i === 0) throw new Error("mergeHigh preconditions were not respected");
            for(h = d - (i - 1), l = 0; l < i; l++)o[h + l] = a[l];
        }
    }
};
function PL(n1, t, e, r) {
    if (!Array.isArray(n1)) throw new TypeError("Can only sort arrays");
    t ? typeof t != "function" && (r = e, e = t, t = TL) : t = TL, e || (e = 0), r || (r = n1.length);
    let i = r - e;
    if (i < 2) return;
    let s = 0;
    if (i < 32) {
        s = ML(n1, e, r, t), CL(n1, e, r, e + s, t);
        return;
    }
    let o = new F_(n1, t), a = cK(i);
    do {
        if (s = ML(n1, e, r, t), s < a) {
            let l = i;
            l > a && (l = a), CL(n1, e, e + l, e + s, t), s = l;
        }
        o.pushRun(e, s), o.mergeRuns(), i -= s, e += s;
    }while (i !== 0);
    o.forceMergeRuns();
}
function k_(n1) {
    let t = (0, tu.default)(new Int32Array(n1.shape[0]), [
        n1.shape[0]
    ]), e = (0, tu.default)(new Int32Array(n1.shape[0]), [
        n1.shape[0]
    ]);
    return or.bands(t, n1, 1023), or.lshifts(e, t, 16), or.bxoreq(t, e), or.bandseq(t, 4278190335), or.lshifts(e, t, 8), or.bxoreq(t, e), or.bandseq(t, 50393103), or.lshifts(e, t, 4), or.bxoreq(t, e), or.bandseq(t, 51130563), or.lshifts(e, t, 2), or.bxoreq(t, e), or.bandseq(t, 153391689), t;
}
function dK(n1) {
    let t = k_(n1.pick(null, 0)), e = k_(n1.pick(null, 1));
    or.lshiftseq(e, 1);
    let r = k_(n1.pick(null, 2));
    return or.lshiftseq(r, 2), or.boreq(t, e), or.boreq(t, r), t;
}
function ql(n1, t) {
    if (n1.shape[0] !== t.shape[0]) throw new Error("wrong length");
    let e = (0, tu.default)(new Float32Array(n1.size), n1.shape, n1.stride, n1.offset);
    for(let r = 0; r < t.shape[0]; r++){
        let i = t.get(r);
        if (n1.shape.length > 1) for(let s = 0; s < n1.shape[1]; s++)e.set(r, s, n1.get(i, s));
        else e.set(r, n1.get(i));
    }
    return e;
}
function z_(n1) {
    let t = or.sup(n1), e = or.inf(n1), r = 1e3 / Math.min(1e3, t - e), i = (0, tu.default)(new Float32Array(n1.data), n1.shape);
    or.mulseq(i, r);
    let s = (0, tu.default)(new Int32Array(i.data), n1.shape), o = dK(s), l = Array.from(o.data).map((d, h)=>[
            d,
            h
        ]);
    PL(l, (d, h)=>d[0] - h[0]);
    let u = l.map(([d, h])=>h);
    return (0, tu.default)(Uint32Array.from(u));
}
var As = class {
    constructor(t, e, r, i, s, o, a, l, u, c){
        this.propertyDescs = t, this.format = e, this.nsplats = r, this.xyz = i, this.colors = s, this.harmonics = o, this.opacity = a, this.scaling = l, this.rotation = u, this.maxSHDegree = c;
    }
    getPlyBinary() {
        let t = As._generateHeaderString(this.propertyDescs, this.format, this.nsplats), e = new TextEncoder().encode(t), r = Object.keys(this.propertyDescs).length, i = (0, La.default)(new Float32Array(this.nsplats * r), [
            this.nsplats,
            r
        ]);
        if (_t.assign(i.pick(null, this.propertyDescs.x.index), this.xyz.pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs.y.index), this.xyz.pick(null, 1)), _t.assign(i.pick(null, this.propertyDescs.z.index), this.xyz.pick(null, 2)), _t.assign(i.pick(null, this.propertyDescs.f_dc_0.index), this.colors.pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs.f_dc_1.index), this.colors.pick(null, 1)), _t.assign(i.pick(null, this.propertyDescs.f_dc_2.index), this.colors.pick(null, 2)), _t.assign(i.pick(null, this.propertyDescs.opacity.index), this.opacity.pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs.scale_0.index), this.scaling.pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs.scale_1.index), this.scaling.pick(null, 1)), _t.assign(i.pick(null, this.propertyDescs.scale_2.index), this.scaling.pick(null, 2)), _t.assign(i.pick(null, this.propertyDescs.rot_0.index), this.rotation.pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs.rot_1.index), this.rotation.pick(null, 1)), _t.assign(i.pick(null, this.propertyDescs.rot_2.index), this.rotation.pick(null, 2)), _t.assign(i.pick(null, this.propertyDescs.rot_3.index), this.rotation.pick(null, 3)), this.harmonics && this.harmonics.length > 0) for(let a = 0; a < this.harmonics.length; a++){
            let l = a * 3;
            _t.assign(i.pick(null, this.propertyDescs[`f_rest_${l}`].index), this.harmonics[a].pick(null, 0)), _t.assign(i.pick(null, this.propertyDescs[`f_rest_${l + 1}`].index), this.harmonics[a].pick(null, 1)), _t.assign(i.pick(null, this.propertyDescs[`f_rest_${l + 2}`].index), this.harmonics[a].pick(null, 2));
        }
        let s = new Uint8Array(i.data.buffer), o = new Uint8Array(s.length + e.length);
        return o.set(e), o.set(s, e.length), o.buffer;
    }
    save(t, e) {
        let r = this.getPlyBinary(), i = new Blob([
            r
        ], {
            type: "application/octet-stream"
        }), s = new File([
            i
        ], t), o = new FormData;
        o.append("file", s), o.append("filename", t), o.append("basedir", e), fetch(`${AL}/push_file`, {
            method: "POST",
            body: o
        });
    }
    static async loadFile(t) {
        return await (await fetch(t)).arrayBuffer();
    }
    mortonPositionSplatsSort() {
        let t = z_(this.xyz), e = ql(this.xyz, t), r = ql(this.colors, t), i = ql(this.opacity, t), s = ql(this.scaling, t), o = ql(this.rotation, t), a = [];
        for(let l = 0; l < this.harmonics.length; l++)a.push(ql(this.harmonics[l], t));
        return new As(this.propertyDescs, this.format, this.nsplats, e, r, a, i, s, o, this.maxSHDegree);
    }
    static _generateHeaderString(t, e, r) {
        let i = `ply
format ${e.format} ${e.version}
element vertex ${r}`, s = Object.keys(t).length, o = Array(s);
        for(let a in t){
            let l = t[a];
            o[l.index] = {
                name: a,
                dtype: l.dtype
            };
        }
        for(let a = 0; a < o.length; a++)i = `${i}
property ${o[a].dtype} ${o[a].name}`;
        return `${i}
end_header
`;
    }
    static fromArrayBuffer(t, e = 3) {
        let { splatCount: r, vertexData: i, propertiesDesc: s, format: o } = As.decodeHeader(t), a = i.buffer.slice(i.byteOffset), l = Object.keys(s).length, u = (0, La.default)(new Float32Array(a), [
            r,
            l
        ]), c = 0, d = {}, h = {
            double: 8,
            int: 4,
            uint: 4,
            float: 4,
            short: 2,
            ushort: 2,
            uchar: 1
        };
        for(let w in s)if (s.hasOwnProperty(w)) {
            let A = s[w].dtype;
            d[w] = c, c += h[A];
        }
        let f = (0, La.default)(new Float32Array(r * 3), [
            r,
            3
        ]);
        _t.assign(f.pick(null, 0), u.pick(null, d.x / 4)), _t.assign(f.pick(null, 1), u.pick(null, d.y / 4)), _t.assign(f.pick(null, 2), u.pick(null, d.z / 4));
        let p = (0, La.default)(new Float32Array(r * 3), [
            r,
            3
        ]);
        _t.assign(p.pick(null, 0), u.pick(null, d.scale_0 / 4)), _t.assign(p.pick(null, 1), u.pick(null, d.scale_1 / 4)), _t.assign(p.pick(null, 2), u.pick(null, d.scale_2 / 4));
        let m = (0, La.default)(new Float32Array(r * 3), [
            r,
            3
        ]);
        _t.assign(m.pick(null, 0), u.pick(null, d.f_dc_0 / 4)), _t.assign(m.pick(null, 1), u.pick(null, d.f_dc_1 / 4)), _t.assign(m.pick(null, 2), u.pick(null, d.f_dc_2 / 4));
        let g = (0, La.default)(new Float32Array(r * 4), [
            r,
            4
        ]);
        _t.assign(g.pick(null, 0), u.pick(null, d.rot_1 / 4)), _t.assign(g.pick(null, 1), u.pick(null, d.rot_2 / 4)), _t.assign(g.pick(null, 2), u.pick(null, d.rot_3 / 4)), _t.assign(g.pick(null, 3), u.pick(null, d.rot_0 / 4));
        for(let w = 0; w < r; w++){
            let A = g.pick(w, null), E = Math.sqrt(A.get(0) ** 2 + A.get(1) ** 2 + A.get(2) ** 2 + A.get(3) ** 2);
            _t.divseq(A, E);
        }
        let y = (0, La.default)(new Float32Array(r * 1), [
            r,
            1
        ]);
        _t.assign(y.pick(null, 0), u.pick(null, d.opacity / 4));
        let x = (Math.min(Math.max(e, 0), 3) + 1) ** 2 - 1, S = [];
        for(let w = 0; w < x; w++){
            let A = (0, La.default)(new Float32Array(r * 3), [
                r,
                3
            ]), E = w * 3;
            _t.assign(A.pick(null, 0), u.pick(null, d[`f_rest_${E}`] / 4)), _t.assign(A.pick(null, 1), u.pick(null, d[`f_rest_${E + 1}`] / 4)), _t.assign(A.pick(null, 2), u.pick(null, d[`f_rest_${E + 2}`] / 4)), S.push(A);
        }
        return new As(s, o, r, f, m, S, y, p, g, e);
    }
    static async fromPLYFile(t, e = 3) {
        let r = await As.loadFile(t);
        return As.fromArrayBuffer(r, e);
    }
    static decodeHeader(t) {
        let e = new TextDecoder, r = 0, i = "", s = 100;
        for(;;){
            if (r + s >= t.byteLength) throw new Error("End of file reached while searching for end of header");
            let p = new Uint8Array(t, r, s);
            i += e.decode(p), r += s;
            let m = r - s * 2, g = new Uint8Array(t, Math.max(0, m), m > 0 ? s * 2 : s);
            if (e.decode(g).includes("end_header")) break;
        }
        let o = i.split(`
`), a = 0, l = {}, u = {}, c = 0, d;
        for(let p = 0; p < o.length; p++){
            let m = o[p].trim();
            if (m.startsWith("element vertex")) {
                let g = m.match(/\d+/);
                g && (a = parseInt(g[0]));
            } else if (m.startsWith("property")) {
                let g = m.match(/(\w+)\s+(\w+)\s+(\w+)/);
                if (g) {
                    let y = g[2], v = g[3];
                    l[v] = c, u[v] = {
                        dtype: y,
                        index: c
                    }, c++;
                }
            } else if (m.startsWith("format")) {
                let g = m.match(/(\w+)\s+(\w+)\s+(\d+\.?\d*)/);
                g && (d = {
                    format: g[2],
                    version: g[3]
                });
            } else if (m === "end_header") break;
        }
        let h = i.indexOf("end_header") + 10 + 1, f = new DataView(t, h);
        return {
            splatCount: a,
            vertexData: f,
            headerOffset: r,
            propertiesDesc: u,
            format: d
        };
    }
};
var ru = class {
    constructor(t, e, r, i, s, o, a, l){
        this.config = t, this.xyz = e, this.scaling = r, this.color = i, this.opacity = s, this.harmonics = a, this.quaternion = o, this.variableChunkSize = l;
    }
    get isDynamicChunks() {
        return this.variableChunkSize && this.variableChunkSize.length > 0;
    }
    get nchunks() {
        return this.xyz.nchunks;
    }
    get nsplats() {
        return this.xyz.length;
    }
    get chunkSize() {
        return this.config.chunkSize;
    }
    static compressFromGaussianData(t, e) {
        let r = mr.fromArray(t.xyz, e.xyz, e.chunkSize), i = mr.fromArray(t.scaling, e.scaling, e.chunkSize), s = mr.fromArray(t.colors, e.color, e.chunkSize), o = mr.fromArray(t.opacity, e.opacity, e.chunkSize), a = mr.fromArray(t.rotation, e.quaternion, e.chunkSize), l = t.harmonics, u = [];
        if (e.harmonics) for(let c = 0; c < l.length; c++){
            let d = mr.fromArray(l[c], e.harmonics, e.chunkSize);
            u.push(d);
        }
        return new ru(e, r, i, s, o, a, u);
    }
    _countIndexesInChunks(t) {
        let e = [], r = this.nchunks, i = this.chunkSize, s = this.nsplats, o = mr.getRequiredNChunks(s, i);
        if (r === o) for(let a = 0; a < t.length; a++){
            let l = t[a], u = Math.floor(l / this.chunkSize);
            u in e ? e[u].push(l) : e[u] = [
                l
            ];
        }
        else {
            let a = this.variableChunkSize, l = {}, u = 0;
            for(let c = 0; c < r; c++)l[c] = u, u += a[c];
            for(let c = 0; c < t.length; c++){
                let d = t[c], h = Math.min(Math.floor(d / i), r - 1);
                for(; d >= l[h] + a[h];)h++;
                h in e ? e[h].push(d) : e[h] = [
                    d
                ];
            }
        }
        return e;
    }
    pruneSplats(t) {
        let e = this._countIndexesInChunks(t), r, i = [];
        return e.length > 0 && (r = this.variableChunkSize ? [
            ...this.variableChunkSize
        ] : Array(this.nchunks).fill(this.chunkSize), e.forEach((s, o)=>{
            r[o] -= s.length, r[o] <= 0 && i.push(o);
        }), r = r.filter((s)=>s > 0)), new ru(this.config, this.xyz.pruneFeature(t, i, r), this.scaling.pruneFeature(t, i, r), this.color.pruneFeature(t, i, r), this.opacity.pruneFeature(t, i, r), this.quaternion.pruneFeature(t, i, r), this.harmonics ? this.harmonics.map((s)=>s.pruneFeature(t, i, this.variableChunkSize)) : void 0, r);
    }
    static async loadConfig(t) {
        return await (await fetch(t, {
            method: "GET",
            mode: "cors",
            headers: {
                Accept: "application/json"
            }
        })).json();
    }
    toGaussians() {
        let t = {
            format: "binary_little_endian",
            version: "1.0"
        }, e = {}, r = 0;
        if (e.x = {
            dtype: "float",
            index: r
        }, r++, e.y = {
            dtype: "float",
            index: r
        }, r++, e.z = {
            dtype: "float",
            index: r
        }, r++, e.f_dc_0 = {
            dtype: "float",
            index: r
        }, r++, e.f_dc_1 = {
            dtype: "float",
            index: r
        }, r++, e.f_dc_2 = {
            dtype: "float",
            index: r
        }, r++, this.harmonics && this.harmonics.length > 0) for(let o = 0; o < this.harmonics.length; o++)e[`f_rest_${o}`] = {
            dtype: "float",
            index: r
        }, r++, e[`f_rest_${o + 1}`] = {
            dtype: "float",
            index: r
        }, r++, e[`f_rest_${o + 2}`] = {
            dtype: "float",
            index: r
        }, r++;
        e.opacity = {
            dtype: "float",
            index: r
        }, r++, e.scale_0 = {
            dtype: "float",
            index: r
        }, r++, e.scale_1 = {
            dtype: "float",
            index: r
        }, r++, e.scale_2 = {
            dtype: "float",
            index: r
        }, r++, e.rot_0 = {
            dtype: "float",
            index: r
        }, r++, e.rot_1 = {
            dtype: "float",
            index: r
        }, r++, e.rot_2 = {
            dtype: "float",
            index: r
        }, r++, e.rot_3 = {
            dtype: "float",
            index: r
        }, r++;
        let i = this.harmonics?.map((o)=>o.denormDequant());
        return new As(e, t, this.xyz.length, this.xyz.denormDequant(), this.color.denormDequant(), i || [], this.opacity.denormDequant(), this.scaling.denormDequant(), this.quaternion.denormDequant(), 3);
    }
};
var iu = Pi(Tf()), fi = Pi(Mf());
var DL = {
    xyz: 3,
    color: 3,
    opacity: 1,
    scaling: 3,
    quaternion: 4,
    harmonics: 3
}, Yl = class {
    constructor(t){
        this._buffer = t;
    }
    get buffer() {
        return this._buffer;
    }
    get decoded() {
        return this._decoded || (this._decoded = this.decodeBuffer()), this._decoded;
    }
    get colorsA() {
        let t = .28209479177387814, e = this.decoded.color.denormDequant(), r = this.decoded.opacity.denormDequant(), i = (0, iu.default)(new Float32Array(e.shape[0] * 4), [
            e.shape[0],
            4
        ]);
        return fi.mulseq(e, t), fi.addseq(e, .5), fi.mulseq(e, 255), fi.maxseq(e, 0), fi.minseq(e, 255), fi.negeq(r), fi.expeq(r), fi.addseq(r, 1), fi.recipeq(r), fi.mulseq(r, 255), fi.assign(i.hi(e.shape[0], 3).lo(0, 0), e), fi.assign(i.hi(e.shape[0], 4).lo(0, 3), r), (0, iu.default)(new Uint8Array(i.data), [
            e.shape[0],
            4
        ]).data;
    }
    get nsplats() {
        return this.decoded.nsplats;
    }
    getSplatCount() {
        return this.decoded.nsplats;
    }
    get precomputedCovarianceBufferData() {
        return this._precomputedCovarianceBufferData;
    }
    decodeBuffer() {
        let { splatCount: t, chunkCount: e, chunkSize: r, typeChunks: i, vertexData: s, propertiesDesc: o } = this.decodeHeader(), a = {
            xyz: o.xyz.compressionMethod,
            color: o.color.compressionMethod,
            opacity: o.opacity.compressionMethod,
            scaling: o.scaling.compressionMethod,
            quaternion: o.quaternion.compressionMethod,
            chunkSize: r
        };
        o.harmonics_0 && (a.harmonics = o.harmonics_0.compressionMethod);
        let l = s.byteOffset, u = Array(Object.keys(o).length);
        for(let y in o)u[o[y].index] = {
            name: y,
            method: o[y].compressionMethod
        };
        let c = e * 8, d = l, h = i === "dynamic" ? e * 2 : 0, f, p = !1;
        if (h > 0) {
            let y = new Uint16Array(s.buffer.slice(d, d + h));
            d += h, f = Array.from(y), p = !0;
        }
        let m = {};
        for (let y of u){
            let v = 0, x = !0;
            if (y.method === "norm8x") v = t * 1 * DL[y.name];
            else if (y.method === "norm11") v = t * 4;
            else if (y.method === "norm565") v = t * 2;
            else throw x = !1, new Error(`Not Implemented format: ${y.method}`);
            let S;
            if (x) {
                let E = s.buffer.slice(d, d + c);
                S = (0, iu.default)(new Float32Array(E), [
                    e,
                    2
                ]), d += c;
            } else throw new Error("loading chunk byt hasnot minmax!");
            let w = s.buffer.slice(d, d + v);
            d += v;
            let A;
            if (y.method === "norm8x") A = (0, iu.default)(new Uint8Array(w), [
                t,
                DL[y.name]
            ]);
            else if (y.method === "norm11") A = (0, iu.default)(new Uint32Array(w));
            else if (y.method === "norm565") A = (0, iu.default)(new Uint16Array(w));
            else throw new Error(`Not Implemented format: ${y.method}`);
            m[y.name] = new mr(A, S, r, y.method, f, p);
        }
        let g = [];
        for(let y = 0; y < 15; y++){
            let v = m[`harmonics_${y}`];
            v && (g.push(v), delete m[`harmonics_${y}`]);
        }
        return g.length > 0 && (m.harmonics = g), new ru(a, m.xyz, m.scaling, m.color, m.opacity, m.quaternion, m.harmonics, f);
    }
    buildPreComputedBuffers() {
        let r = this.decoded, i = r.nsplats, s = new ArrayBuffer(24 * i), o = new Float32Array(s), a = r.scaling.denormDequant(), l = r.quaternion.denormDequant(), u = new je, c = new Qt, d = new Qt, h = new Qt, f = new te;
        for(let p = 0; p < i; p++){
            f.makeScale(Math.exp(a.get(p, 0)), Math.exp(a.get(p, 1)), Math.exp(a.get(p, 2))), d.setFromMatrix4(f), u.set(l.get(p, 0), l.get(p, 1), l.get(p, 2), l.get(p, 3)), f.makeRotationFromQuaternion(u), c.setFromMatrix4(f), h.copy(c).multiply(d);
            let m = h.elements;
            o[6 * p] = m[0] * m[0] + m[3] * m[3] + m[6] * m[6], o[6 * p + 1] = m[0] * m[1] + m[3] * m[4] + m[6] * m[7], o[6 * p + 2] = m[0] * m[2] + m[3] * m[5] + m[6] * m[8], o[6 * p + 3] = m[1] * m[1] + m[4] * m[4] + m[7] * m[7], o[6 * p + 4] = m[1] * m[2] + m[4] * m[5] + m[7] * m[8], o[6 * p + 5] = m[2] * m[2] + m[5] * m[5] + m[8] * m[8];
        }
        this._precomputedCovarianceBufferData = s;
    }
    decodeHeader() {
        let t = this._buffer, e = new TextDecoder, r = 0, i = "", s = 100;
        for(;;){
            if (r + s >= t.byteLength) throw new Error("End of file reached while searching for end of header");
            let m = new Uint8Array(t, r, s);
            i += e.decode(m), r += s;
            let g = r - s * 2, y = new Uint8Array(t, Math.max(0, g), g >= 0 ? s * 2 : s);
            if (e.decode(y).includes("end_header")) break;
        }
        let o = i.split(`
`), a = 0, l = 0, u = 0, c = 0, d = "", h = {};
        for(let m = 0; m < o.length; m++){
            let g = o[m].trim();
            if (g.startsWith("element vertex")) {
                let y = g.match(/\d+/);
                y && (a = parseInt(y[0]));
            } else if (g.startsWith("property")) {
                let y = g.match(/(\w+)\s+(\w+)\s+(\w+)/);
                if (y) {
                    let v = y[2], x = y[3];
                    h[v] = {
                        compressionMethod: x,
                        index: c
                    }, c++;
                }
            } else if (g.startsWith("element chunks")) {
                let y = g.match(/\d+/);
                y && (l = parseInt(y[0]));
            } else if (g.startsWith("element chunkSize")) {
                let y = g.match(/\d+/);
                y && (u = parseInt(y[0]));
            } else if (g.startsWith("element typeChunks")) {
                let y = g.match(/(\w+)\s+(\w+)\s+(\w+)/);
                y && (d = y[3]);
            } else if (g === "end_header") break;
        }
        let f = i.indexOf("end_header") + 10 + 1, p = new DataView(t, f);
        return {
            splatCount: a,
            chunkCount: l,
            chunkSize: u,
            typeChunks: d,
            vertexData: p,
            propertiesDesc: h
        };
    }
    pruneSplats(t) {
        let r = this.decodeBuffer().pruneSplats(t);
        return Yl.fromCompressedGaussianSplats(r);
    }
    static fromCompressedGaussianSplats(t) {
        let e = t.xyz.length, r = t.xyz.nchunks, i = `gspline
element vertex ${e}
element chunks ${r}
element chunkSize ${t.chunkSize}
element typeChunks ${t.isDynamicChunks ? "dynamic" : "static"}
property xyz ${t.xyz.method}
property color ${t.color.method}
property opacity ${t.opacity.method}
property scaling ${t.scaling.method}
property quaternion ${t.quaternion.method}`;
        if (t.harmonics && t.harmonics.length > 0) for(let T = 0; T < t.harmonics.length; T++)i = `${i}
property harmonics_${T} ${t.harmonics[T].method}`;
        i = `${i}
end_header
`;
        let o = new TextEncoder().encode(i), a = r * 8, l = t.xyz.quantized.data.buffer.byteLength, u = t.xyz instanceof mr ? a : 0, c = t.color.quantized.data.buffer.byteLength, d = t.color instanceof mr ? a : 0, h = t.opacity.quantized.data.buffer.byteLength, f = t.opacity instanceof mr ? a : 0, p = t.scaling.quantized.data.buffer.byteLength, m = t.scaling instanceof mr ? a : 0, g = t.quaternion.quantized.data.buffer.byteLength, y = t.quaternion instanceof mr ? a : 0, v = t.variableChunkSize ? Uint16Array.from(t.variableChunkSize) : void 0, x = v ? v.byteLength : 0, S = o.byteLength + x + l + u + c + d + h + f + p + m + g + y, w = 0, A = 0;
        if (t.harmonics && t.harmonics.length > 0) for(let T = 0; T < t.harmonics.length; T++)w += t.harmonics[T].quantized.data.buffer.byteLength, A += t.harmonics[T] instanceof mr ? a : 0;
        w = 0, A = 0, S += w + A;
        let E = new Uint8Array(S), b = 0;
        if (E.set(o, b), b += o.byteLength, x > 0 && (E.set(new Uint8Array(v.buffer), b), b += x), t.xyz instanceof mr && (E.set(new Uint8Array(t.xyz.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(t.xyz.quantized.data.buffer), b), b += l, t.color instanceof mr && (E.set(new Uint8Array(t.color.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(t.color.quantized.data.buffer), b), b += c, t.opacity instanceof mr && (E.set(new Uint8Array(t.opacity.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(t.opacity.quantized.data.buffer), b), b += h, t.scaling instanceof mr && (E.set(new Uint8Array(t.scaling.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(t.scaling.quantized.data.buffer), b), b += p, t.quaternion instanceof mr && (E.set(new Uint8Array(t.quaternion.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(t.quaternion.quantized.data.buffer), b), b += g, w > 0 && t.harmonics && t.harmonics.length > 0) for(let T = 0; T < t.harmonics.length; T++){
            let M = t.harmonics[T];
            M instanceof mr && (E.set(new Uint8Array(M.minmaxMatrix.data.buffer), b), b += a), E.set(new Uint8Array(M.quantized.data.buffer), b), b += M.quantized.data.byteLength;
        }
        return new Yl(E.buffer);
    }
};
var OL = "AGFzbQEAAAAADwhkeWxpbmsuMAEEAAAAAAETA2AAAGAIf39/f39/f38AYAABfwISAQNlbnYGbWVtb3J5AgMAgIAEAwQDAAECBzkDEV9fd2FzbV9jYWxsX2N0b3JzAAALc29ydEluZGV4ZXMAARNlbXNjcmlwdGVuX3Rsc19pbml0AAIK3gMDAwABC9IDAwF/BnwBfgJAIAdFDQAgAysDUCEMIAMrAzAhDSADKwMQIQ5BACEDRP///////+9/IQtEAAAAAAAAEAAhCgNAIAIgA0ECdGoCfyAOIAEgA0EMbGoiCCoCALuiIA0gCCoCBLuioCAMIAgqAgi7oqBEAAAAAAAAsECiIgmZRAAAAAAAAOBBYwRAIAmqDAELQYCAgIB4CzYCACAJIAsgCSALYxshCyAJIAogCSAKZBshCiADQQFqIgMgB0cNAAsgB0UNACAGuCAKIAuhoyEJQQAhAwNAAn8gCSACIANBAnRqIgEoAgC3IAuhoiIKmUQAAAAAAADgQWMEQCAKqgwBC0GAgICAeAshCCABIAg2AgAgBCAIQQJ0aiIBIAEoAgBBAWo2AgAgA0EBaiIDIAdHDQALCyAGQQJPBEAgBCgCACEIQQEhAwNAIAQgA0ECdGoiASABKAIAIAhqIgg2AgAgA0EBaiIDIAZHDQALCyAHQQFrIgGtIQ8DQCAEIAIgD6dBAnQiA2ooAgBBAnRqIgcgBygCAEEBayIHNgIAIAUgASAHa0ECdGogACADaigCADYCACAPUCEDIA9CAX0hDyADRQ0ACyAGBEAgBEEAIAZBAnT8CwALCwQAQQAL";
var Vo = class {
};
Di(Vo, "DepthMapRange", 65536), Di(Vo, "MemoryPageSize", 65536), Di(Vo, "BytesPerFloat", 4), Di(Vo, "BytesPerInt", 4);
function hK(n1) {
    let t, e, r, i, s, o, a, l, u, c, d, h, f, p, m, g;
    function y(C) {
        let P = new Float64Array(c, o, 16);
        for(let O = 0; O < 16; O++)P[O] = C[O];
        let D;
        if (r > 1) {
            t.exports.sortIndexes(i, s, u, o, a, l, h.DepthMapRange, r);
            let O = new Uint32Array(r);
            D = O.buffer, O.set(new Uint32Array(c, l, r));
        } else if (r === 1) {
            let O = new Uint32Array(r);
            O[0] = new Uint32Array(c, i, e)[0], D = O.buffer;
        } else D = new ArrayBuffer(0);
        n1.postMessage({
            sortDone: !0,
            indexesBuffer: D
        }, [
            D
        ]);
    }
    function v(C, P, D) {
        let O = new Float32Array(c, s, e * 3);
        r = 0;
        let I = new Uint32Array(c, i, e);
        for(let z = 0; z < D.length - 1; z++){
            let B = P[z], V = C[z].elements, U = B.filter((W)=>W.enabled && W.mode === "Include").map((W)=>W.type === "Box" ? A(W) : T(W)), j = B.filter((W)=>W.enabled && W.mode === "Exclude").map((W)=>W.type === "Box" ? A(W) : T(W));
            for(let W = D[z]; W < D[z + 1]; W++){
                let k = f[W * 3], H = f[W * 3 + 1], X = f[W * 3 + 2];
                if ((U.length === 0 || S(k, H, X, U)) && (j.length === 0 || !S(k, H, X, j))) {
                    let q = 1 / (V[3] * k + V[7] * H + V[11] * X + V[15]);
                    O[r * 3] = (V[0] * k + V[4] * H + V[8] * X + V[12]) * q, O[r * 3 + 1] = (V[1] * k + V[5] * H + V[9] * X + V[13]) * q, O[r * 3 + 2] = (V[2] * k + V[6] * H + V[10] * X + V[14]) * q, I[r] = W, r++;
                }
            }
        }
    }
    function x(C, P) {
        let D = [], O = P.filter((B)=>B.enabled && B.mode === "Include").map((B)=>B.type === "Box" ? A(B) : T(B)), I = P.filter((B)=>B.enabled && B.mode === "Exclude").map((B)=>B.type === "Box" ? A(B) : T(B)), z = C.length;
        for(let B = 0; B < z; B += 3){
            let V = C[B], U = C[B + 1], j = C[B + 2];
            (O.length === 0 || S(V, U, j, O)) && (I.length === 0 || !S(V, U, j, I)) || D.push(B / 3);
        }
        return console.log(D), D;
    }
    function S(C, P, D, O, I) {
        return O[I === "Intersect" ? "every" : "some"]((z)=>{
            let B = w(C, P, D, z.invRotationMatrix, z.cropCenter);
            return Array.isArray(z) ? b(B.x, B.y, B.z, z) : M(B.x, B.y, B.z, z);
        });
    }
    function w(C, P, D, O, I) {
        let z = C - I[0], B = P - I[1], V = D - I[2], U = 1 / (O[3] * z + O[7] * B + O[11] * V + O[15]);
        return {
            x: (O[0] * z + O[4] * B + O[8] * V + O[12]) * U + I[0],
            y: (O[1] * z + O[5] * B + O[9] * V + O[13]) * U + I[1],
            z: (O[2] * z + O[6] * B + O[10] * V + O[14]) * U + I[2]
        };
    }
    function A(C) {
        let P = C.cropSize[0] / 2, D = C.cropSize[1] / 2, O = C.cropSize[2] / 2, I = [
            C.cropCenter[0] - P,
            C.cropCenter[1] - D,
            C.cropCenter[2] - O,
            C.cropCenter[0] + P,
            C.cropCenter[1] + D,
            C.cropCenter[2] + O
        ], z = E(C.cropRotation);
        return Object.assign(I, {
            invRotationMatrix: z,
            cropCenter: C.cropCenter
        });
    }
    function E(C) {
        let P = [], D = C[0] * Math.PI / 180, O = C[1] * Math.PI / 180, I = C[2] * Math.PI / 180, z = Math.cos(D), B = Math.sin(D), V = Math.cos(O), U = Math.sin(O), j = Math.cos(I), W = Math.sin(I), k = z * j, H = z * W, X = B * j, q = B * W;
        return P[0] = V * j, P[1] = -V * W, P[2] = U, P[4] = H + X * U, P[5] = k - q * U, P[6] = -B * V, P[8] = q - k * U, P[9] = X + H * U, P[10] = z * V, P[12] = 0, P[13] = 0, P[14] = 0, P[3] = 0, P[7] = 0, P[11] = 0, P[15] = 1, P;
    }
    function b(C, P, D, O) {
        return C >= O[0] && C <= O[3] && P >= O[1] && P <= O[4] && D >= O[2] && D <= O[5];
    }
    function T(C) {
        let P = 2 / C.cropSize[0], D = 2 / C.cropSize[1], O = 2 / C.cropSize[2], I = E(C.cropRotation);
        return {
            invRadiusX: P,
            invRadiusY: D,
            invRadiusZ: O,
            cropCenter: C.cropCenter,
            invRotationMatrix: I
        };
    }
    function M(C, P, D, O) {
        let I = (C - O.cropCenter[0]) * O.invRadiusX, z = (P - O.cropCenter[1]) * O.invRadiusY, B = (D - O.cropCenter[2]) * O.invRadiusZ;
        return I * I + z * z + B * B <= 1;
    }
    n1.onmessage = (C)=>{
        if (C.data.getCroppedIndexes) {
            let P = new Uint32Array(x(new Float32Array(C.data.positions), C.data.crops)).buffer;
            n1.postMessage({
                outOfBoundsIndexes: P
            }, [
                P
            ]);
        } else if (C.data.positions) d = C.data.positions, f = new Float32Array(d), m = C.data.meshMatrixWorlds, g = C.data.cropsArray, p = C.data.meshIndexIntervals, v(m, g, p), n1.postMessage({
            sortSetupComplete: !0
        });
        else if (C.data.sort || C.data.newMatrixWorlds || C.data.newCropsArray) (C.data.newMatrixWorlds || C.data.newCropsArray) && (g = C.data.newCropsArray || g, m = C.data.newMatrixWorlds || m, v(m, g, p)), y(C.data.sort.view, C.data.sort.cameraPosition);
        else if (C.data.init) {
            h = C.data.init.Constants, e = C.data.init.splatCount;
            let P = h.BytesPerInt, D = h.BytesPerFloat * 3, O = new Uint8Array(C.data.init.sorterWasmBytes), I = P + D, z = e * I, B = e * h.BytesPerInt * 2 + h.DepthMapRange * h.BytesPerInt * 2, V = h.MemoryPageSize * 32, U = z + B + V, j = Math.floor(U / h.MemoryPageSize) + 1, W = {
                module: {},
                env: {
                    memory: new WebAssembly.Memory({
                        initial: j * 2,
                        maximum: j * 3,
                        shared: !0
                    })
                }
            };
            WebAssembly.compile(O).then((k)=>WebAssembly.instantiate(k, W)).then((k)=>{
                t = k, i = 0, s = e * P, o = s + e * D, u = o + 16 * h.BytesPerFloat * 2, a = u + e * h.BytesPerInt, l = a + h.DepthMapRange * h.BytesPerInt, c = W.env.memory.buffer, n1.postMessage({
                    sortSetupPhase1Complete: !0
                });
            });
        }
    };
}
function IL(n1) {
    let t = new Worker(URL.createObjectURL(new Blob([
        "(",
        hK.toString(),
        ")(self)"
    ], {
        type: "application/javascript"
    }))), e = atob(OL), r = new Uint8Array(e.length);
    for(let i = 0; i < e.length; i++)r[i] = e.charCodeAt(i);
    return t.postMessage({
        init: {
            sorterWasmBytes: r.buffer,
            splatCount: n1,
            Constants: {
                BytesPerFloat: Vo.BytesPerFloat,
                BytesPerInt: Vo.BytesPerInt,
                DepthMapRange: Vo.DepthMapRange,
                MemoryPageSize: Vo.MemoryPageSize
            }
        }
    }), t;
}
var jx = function() {
    let n1 = new Float32Array(1), t = new Int32Array(n1.buffer);
    return function(e) {
        return n1[0] = e, t[0];
    };
}(), RL = function(n1, t, e, r) {
    return n1 + (t << 8) + (e << 16) + (r << 24);
};
var Hx = new N, Xl = class extends rr {
    constructor(e, r, i, s, o = !1, a = 1, l, u){
        super(i, s);
        this.splatCount = r, this.meshIndexIntervals = l, this.meshMatrixWorlds = u, this.splatBuffers = e, this.geometry = i, this.material = s, this.splatDataTextures = null, this.halfPrecisionCovariancesOnGPU = o, this.devicePixelRatio = a, this.resetLocalSplatDataAndTexturesFromSplatBuffer();
    }
    static buildMesh(e, r, i = !1, s = 1, o, a) {
        let l = Xl.buildGeomtery(r), u = Xl.buildMaterial(o);
        return new Xl(e, r, l, u, i, s, o, a);
    }
    static buildMaterial(e) {
        let r = `
            precision highp float;
            #include <common>

            attribute uint splatIndex;

            uniform highp sampler2D covariancesTexture;
            uniform highp usampler2D centersColorsTexture;
            uniform vec2 focal;
            uniform vec2 viewport;
            uniform vec2 basisViewport;
            uniform vec2 covariancesTextureSize;
            uniform vec2 centersColorsTextureSize;
						uniform highp sampler2D meshMatrixWorldsTexture;
						uniform uint meshIndexIntervals[257];
						uniform float orthoZoom;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;

            const vec4 encodeNorm4 = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0);
            const uvec4 mask4 = uvec4(uint(0x000000FF), uint(0x0000FF00), uint(0x00FF0000), uint(0xFF000000));
            const uvec4 shift4 = uvec4(0, 8, 16, 24);
            vec4 uintToRGBAVec (uint u) {
               uvec4 urgba = mask4 & u;
               urgba = urgba >> shift4;
               vec4 rgba = vec4(urgba) * encodeNorm4;
               return rgba;
            }

            vec2 getDataUV(in int stride, in int offset, in vec2 dimensions) {
                vec2 samplerUV = vec2(0.0, 0.0);
                float d = float(splatIndex * uint(stride) + uint(offset)) / dimensions.x;
                samplerUV.y = float(floor(d)) / dimensions.y;
                samplerUV.x = fract(d);
                return samplerUV;
            }

            void main () {
                uvec4 sampledCenterColor = texture(centersColorsTexture, getDataUV(1, 0, centersColorsTextureSize));
                vec3 splatCenter = uintBitsToFloat(uvec3(sampledCenterColor.gba));
                vColor = uintToRGBAVec(sampledCenterColor.r);

                vPosition = position.xy * 2.0;

								uint meshIndex;
								for (int i = 1; i < 257; i++) {
									if (splatIndex < meshIndexIntervals[i]) {
										meshIndex = uint(i - 1);
										break;
									}
								}

								float strideMulmeshIndex = float(4u*meshIndex);
								float meshMatrixWorldsTextureLength = float(256*4);

								mat4 modelMat = mat4(
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+0.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+1.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+2.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+3.0)/meshMatrixWorldsTextureLength, 0))
								);
								mat4 modelViewMat = viewMatrix * modelMat;
								vec4 viewCenter = modelViewMat * vec4(splatCenter, 1.0); 
                vec4 clipCenter = projectionMatrix * viewCenter;

                vec2 sampledCovarianceA = texture(covariancesTexture, getDataUV(3, 0, covariancesTextureSize)).rg;
                vec2 sampledCovarianceB = texture(covariancesTexture, getDataUV(3, 1, covariancesTextureSize)).rg;
                vec2 sampledCovarianceC = texture(covariancesTexture, getDataUV(3, 2, covariancesTextureSize)).rg;

                vec3 cov3D_M11_M12_M13 = vec3(sampledCovarianceA.rg, sampledCovarianceB.r);
                vec3 cov3D_M22_M23_M33 = vec3(sampledCovarianceB.g, sampledCovarianceC.rg);

                // Compute the 2D covariance matrix from the upper-right portion of the 3D covariance matrix
                mat3 Vrk = mat3(
                    cov3D_M11_M12_M13.x, cov3D_M11_M12_M13.y, cov3D_M11_M12_M13.z,
                    cov3D_M11_M12_M13.y, cov3D_M22_M23_M33.x, cov3D_M22_M23_M33.y,
                    cov3D_M11_M12_M13.z, cov3D_M22_M23_M33.y, cov3D_M22_M23_M33.z
                );
                float s = 1.0 / (viewCenter.z * viewCenter.z);

                mat3 W = transpose(mat3(modelViewMat));
                mat3 T = orthoZoom > 0.0 ? W : W * mat3(
									focal.x / viewCenter.z, 0., -(focal.x * viewCenter.x) * s,
									0., focal.y / viewCenter.z, -(focal.y * viewCenter.y) * s,
									0., 0., 0.
								);
                mat3 cov2Dm = transpose(T) * Vrk * T;
                cov2Dm[0][0] += 0.3;
                cov2Dm[1][1] += 0.3;

                // We are interested in the upper-left 2x2 portion of the projected 3D covariance matrix because
                // we only care about the X and Y values. We want the X-diagonal, cov2Dm[0][0],
                // the Y-diagonal, cov2Dm[1][1], and the correlation between the two cov2Dm[0][1]. We don't
                // need cov2Dm[1][0] because it is a symetric matrix.
                vec3 cov2Dv = vec3(cov2Dm[0][0], cov2Dm[0][1], cov2Dm[1][1]);

                vec3 ndcCenter = clipCenter.xyz / clipCenter.w;

                // We now need to solve for the eigen-values and eigen vectors of the 2D covariance matrix
                // so that we can determine the 2D basis for the splat. This is done using the method described
                // here: https://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
                //
                // This is a different approach than in the original work at INRIA. In that work they compute the
                // max extents of the 2D covariance matrix in screen space to form an axis aligned bounding rectangle
                // which forms the geometry that is actually rasterized. They then use the inverse 2D covariance
                // matrix (called 'conic') to determine fragment opacity.
                float a = cov2Dv.x;
                float d = cov2Dv.z;
                float b = cov2Dv.y;
                float D = a * d - b * b;
                float trace = a + d;
                float traceOver2 = 0.5 * trace;
                float term2 = sqrt(trace * trace / 4.0 - D);
                float eigenValue1 = traceOver2 + term2;
								float eigenValue2 = max(traceOver2 - term2, 0.00); // prevent negative eigen value

                const float maxSplatSize = 1024.0;
                vec2 eigenVector1 = normalize(vec2(b, eigenValue1 - a));
                // since the eigen vectors are orthogonal, we derive the second one from the first
                vec2 eigenVector2 = vec2(eigenVector1.y, -eigenVector1.x);
                vec2 basisVector1 = eigenVector1 * min(sqrt(2.0 * eigenValue1), maxSplatSize);
                vec2 basisVector2 = eigenVector2 * min(sqrt(2.0 * eigenValue2), maxSplatSize);

                vec2 ndcOffset = vec2(vPosition.x * basisVector1 + vPosition.y * basisVector2) * basisViewport;

								if (orthoZoom > 0.0) {
									ndcOffset *= orthoZoom;
								}

                gl_Position = vec4(ndcCenter.xy + ndcOffset, ndcCenter.z, 1.0);
            }`, i = `
            precision highp float;
            #include <common>

            uniform vec3 debugColor;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;
						layout(location = 1) out vec4 gVelocity; 

            void main () {
                // compute the negative squared distance from the center of the splat to the
                // current fragment in the splat's local space.
                float A = -dot(vPosition, vPosition);
                if (A < -4.0) discard;
                vec3 color = vColor.rgb;
                A = exp(A) * vColor.a;
                gl_FragColor = vec4(color.rgb, A);
								gVelocity = vec4(0.0); // so it is ignored by TAA
            }`, s = {
            covariancesTexture: {
                type: "t",
                value: null
            },
            centersColorsTexture: {
                type: "t",
                value: null
            },
            meshIndexIntervals: {
                value: e
            },
            meshMatrixWorldsTexture: {
                type: "t",
                value: null
            },
            focal: {
                type: "v2",
                value: new N
            },
            viewport: {
                type: "v2",
                value: new N
            },
            basisViewport: {
                type: "v2",
                value: new N
            },
            debugColor: {
                type: "v3",
                value: new Le
            },
            covariancesTextureSize: {
                type: "v2",
                value: new N(1024, 1024)
            },
            centersColorsTextureSize: {
                type: "v2",
                value: new N(1024, 1024)
            },
            orthoZoom: {
                type: "f",
                value: -1
            }
        };
        return new rt({
            uniforms: s,
            vertexShader: r,
            fragmentShader: i,
            transparent: !0,
            alphaTest: 1,
            blending: qa,
            depthTest: !0,
            depthWrite: !1,
            side: qi
        });
    }
    static buildGeomtery(e) {
        let r = new we;
        r.setIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        let i = new Float32Array(12), s = new Ge(i, 3);
        r.setAttribute("position", s), s.setXYZ(0, -1, -1, 0), s.setXYZ(1, -1, 1, 0), s.setXYZ(2, 1, 1, 0), s.setXYZ(3, 1, -1, 0), s.needsUpdate = !0;
        let o = new Sp().copy(r), a = new Uint32Array(e), l = new uo(a, 1, !1);
        return l.setUsage(MM), o.setAttribute("splatIndex", l), o.instanceCount = e, o;
    }
    resetLocalSplatDataAndTexturesFromSplatBuffer() {
        this.updateLocalSplatDataFromSplatBuffer(), this.allocateAndStoreLocalSplatDataInTextures();
    }
    updateLocalSplatDataFromSplatBuffer() {
        this.splatBuffers.forEach((s)=>s.buildPreComputedBuffers()), this.covariances = new Float32Array(this.splatCount * 6), this.colors = new Uint8Array(this.splatCount * 4), this.centers = new Float32Array(this.splatCount * 3);
        let e = 0, r = 0, i = 0;
        for (let s of this.splatBuffers){
            let o = s.nsplats;
            this.colors.subarray(e, e + o * 4).set(s.colorsA), e += o * 4, this.centers.subarray(r, r + o * 3).set(s.decoded.xyz.denormDequant().data), r += o * 3, this.covariances.subarray(i, i + o * 6).set(new Float32Array(s.precomputedCovarianceBufferData)), i += o * 6;
        }
    }
    allocateAndStoreLocalSplatDataInTextures() {
        let i = this.splatCount, s = new N(4096, 1024);
        for(; s.x * s.y * 2 < i * 6;)s.y *= 2;
        let o = new N(4096, 1024);
        for(; o.x * o.y * 4 < i * 4;)o.y *= 2;
        let a, l;
        if (this.halfPrecisionCovariancesOnGPU) {
            l = new Uint16Array(s.x * s.y * 2);
            for(let p = 0; p < this.covariances.length; p++)l[p] = GM.toHalfFloat(this.covariances[p]);
            a = new ci(l, s.x, s.y, Ku, sa);
        } else l = new Float32Array(s.x * s.y * 2), l.set(this.covariances), a = new ci(l, s.x, s.y, Ku, dr);
        a.needsUpdate = !0, this.material.uniforms.covariancesTexture.value = a, this.material.uniforms.covariancesTextureSize.value.copy(s);
        let u = new Uint32Array(o.x * o.y * 4);
        for(let p = 0; p < i; p++){
            let m = p * 4, g = p * 3, y = p * 4;
            u[y] = RL(this.colors[m], this.colors[m + 1], this.colors[m + 2], this.colors[m + 3]), u[y + 1] = jx(this.centers[g]), u[y + 2] = jx(this.centers[g + 1]), u[y + 3] = jx(this.centers[g + 2]);
        }
        let c = new ci(u, o.x, o.y, nw, Ds);
        c.internalFormat = "RGBA32UI", c.needsUpdate = !0, this.material.uniforms.centersColorsTexture.value = c, this.material.uniforms.centersColorsTextureSize.value.copy(o);
        let d = 1024, h = new Float32Array(4096);
        for(let p = 0; p < this.meshMatrixWorlds.length; p++)h.set(this.meshMatrixWorlds[p].elements, p * 16);
        let f = new ci(h, d, 1, Fr, dr);
        f.needsUpdate = !0, this.material.uniforms.meshMatrixWorldsTexture.value = f, this.material.uniformsNeedUpdate = !0, this.splatDataTextures = {
            covariances: {
                data: l,
                texture: a,
                size: s
            },
            centerColors: {
                data: u,
                texture: c,
                size: o
            },
            meshMatrixWorlds: {
                data: h,
                texture: f
            }
        };
    }
    updateIndexes(e) {
        let r = this.geometry;
        r.attributes.splatIndex.set(e), r.attributes.splatIndex.needsUpdate = !0, r.instanceCount = e.length;
    }
    updateUniforms(e, r, i, s) {
        this.splatCount > 0 && (Hx.set(e.x * this.devicePixelRatio, e.y * this.devicePixelRatio), this.material.uniforms.viewport.value.copy(Hx), this.material.uniforms.basisViewport.value.set(2 / Hx.x, 2 / Hx.y), this.material.uniforms.focal.value.set(r, i), this.material.uniforms.orthoZoom.value = s, this.material.uniformsNeedUpdate = !0);
    }
    getSplatDataTextures() {
        return this.splatDataTextures;
    }
    getSplatCount() {
        return this.splatCount;
    }
    getCenters() {
        return this.centers;
    }
    getColors() {
        return this.colors;
    }
    getCovariances() {
        return this.covariances;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose(), this.splatDataTextures && (this.splatDataTextures.covariances.texture.dispose(), this.splatDataTextures.centerColors.texture.dispose(), this.splatDataTextures.meshMatrixWorlds.texture.dispose());
    }
};
var Um = class {
    constructor(t = {}){
        Di(this, "updateSplatMeshUniforms", function() {
            let t = new N;
            return function() {
                if (this.splatMesh === null) return;
                this.splatMesh.getSplatCount() > 0 && (this.renderer.getSize(t), this.cameraFocalLengthX = this.camera.projectionMatrix.elements[0] * this.devicePixelRatio * t.x * .45, this.cameraFocalLengthY = this.camera.projectionMatrix.elements[5] * this.devicePixelRatio * t.y * .45, this.splatMesh.updateUniforms(t, this.cameraFocalLengthX, this.cameraFocalLengthY, this.camera.isPerspectiveCamera ? -1 : this.camera.zoom * this.devicePixelRatio));
            };
        }());
        Di(this, "updateView", function() {
            let t = new te, e = [], r = new _(0, 0, -1), i = new _(0, 0, -1), s = new _, o = new _;
            return function(a = !1) {
                let l = this.updateMatrixWorldsInWorkerIfNeeded(), u = this.cropsChanged();
                if (!a) {
                    i.set(0, 0, -1).applyQuaternion(this.camera.quaternion);
                    let d = !1, h = !1;
                    if (i.dot(r) <= .95 && (d = !0), o.copy(this.camera.position).sub(s).length() >= 1 && (h = !0), !d && !h && !l && !u) return;
                }
                s.copy(this.camera.position), r.copy(i), t.copy(this.camera.matrixWorld).invert(), t.premultiply(this.camera.perspCamera.projectionMatrix), e[0] = this.camera.position.x, e[1] = this.camera.position.y, e[2] = this.camera.position.z;
                let c = {
                    sort: {
                        view: t.elements,
                        cameraPosition: e,
                        splatRenderCount: this.splatRenderCount,
                        splatSortCount: this.splatRenderCount
                    },
                    ...l ? {
                        newMatrixWorlds: this.meshMatrixWorlds
                    } : {},
                    ...u ? {
                        newCropsArray: this.cropsArray
                    } : {}
                };
                this.sortRunning ? this.queuedMessage = c : (this.queuedMessage = null, this.sortRunning = !0, this.sortWorker.postMessage(c));
            };
        }());
        this.scene = t.scene, this.currentPage = null, this.renderer = t.renderer, this.devicePixelRatio = window.devicePixelRatio, this.sortWorker = null, this.splatRenderCount = 0, this.splatSortCount = 0, this.splatMesh = null, this.sortRunning = !1, this.splatRenderingInitialized = !1, this.meshMatrixWorlds = null, this.meshMatrixWorldsOld = null, this.cropsArray = null, this.splatEntries = null, this.queuedMessage = null;
    }
    get camera() {
        return this.scene.activeCamera;
    }
    reloadSplats() {
        this.splatRenderingInitialized = !1;
        let t = this.loadSplat();
        this.renderer.pipeline.opaquePass.splatViewer = t ? this : null;
    }
    loadSplat(t = {}) {
        this.activePage = this.scene.activePage, t.position && (t.position = new _().fromArray(t.position)), t.orientation && (t.orientation = new je().fromArray(t.orientation)), t.halfPrecisionCovariances = !!t.halfPrecisionCovariances;
        let e = [];
        if (this.splatEntries = e, this.activePage.traverseEntity((o)=>{
            if (o.data.type === "Splat") {
                let a = o.visible;
                o.traverseAncestors((l)=>{
                    a && (a = l.visible);
                }), a && e.push(o);
            }
        }), this.splatMesh && this.splatMesh.dispose(), e.length === 0) return this.splatMesh = null, !1;
        this.meshMatrixWorlds = e.map((o)=>o.matrixWorld), this.meshMatrixWorldsOld = e.map((o)=>o.matrixWorld.clone()), this.cropsArray = e.map((o)=>o.data.crops.map((a)=>a.data));
        let r = e.map((o)=>new Yl(new Uint8Array(o.data.buffer).buffer)), i = 0, s = [
            0
        ];
        for (let o of r)i += o.getSplatCount(), s.push(i);
        return this.setupSplatMesh(r, i, t.position, t.orientation, t.halfPrecisionCovariances, this.devicePixelRatio, s, this.meshMatrixWorlds), this.setupSortWorker(i), !0;
    }
    updateMatrixWorldsInWorkerIfNeeded() {
        let t = this.splatDataTextures.meshMatrixWorlds.data;
        for(let e = 0; e < this.meshMatrixWorlds.length; e++)t.set(this.meshMatrixWorlds[e].elements, e * 16);
        return this.splatDataTextures.meshMatrixWorlds.texture.needsUpdate = !0, this.meshMatrixWorlds.every((e, r)=>e.equals(this.meshMatrixWorldsOld[r])) ? !1 : (this.meshMatrixWorldsOld = this.meshMatrixWorlds.map((e)=>e.clone()), !0);
    }
    cropsChanged() {
        let t = !1;
        return this.splatEntries.forEach((e, r)=>{
            e.data.crops.forEach((i, s)=>{
                this.cropsArray[r][s] === void 0 ? (t = !0, this.cropsArray[r][s] = i.data) : Object.entries(i.data).forEach(([o, a])=>{
                    Array.isArray(a) && a.some((l, u)=>l !== this.cropsArray[r][s][o][u]) ? (t = !0, this.cropsArray[r][s][o] = a) : a !== this.cropsArray[r][s]?.[o] && (t = !0, this.cropsArray[r][s][o] = a);
                });
            }), e.data.crops.length !== this.cropsArray[r]?.length && (this.cropsArray[r].length = e.data.crops.length, t = !0);
        }), t;
    }
    setupSplatMesh(t, e, r = new _, i = new je, s = !1, o = 1, a, l) {
        this.splatMesh = Xl.buildMesh(t, e, s, o, a, l), this.splatMesh.position.copy(r), this.splatMesh.quaternion.copy(i), this.splatMesh.frustumCulled = !1, this.splatMesh.renderOrder = 10, this.updateSplatMeshUniforms(), this.splatRenderCount = e;
    }
    setupSortWorker(t) {
        this.sortWorker = IL(t), this.sortWorker.onmessage = (e)=>{
            e.data.sortDone ? (this.sortRunning = !1, this.splatMesh?.updateIndexes(new Uint32Array(e.data.indexesBuffer)), this.lastSortTime = e.data.sortTime, this.queuedMessage && (this.sortWorker.postMessage(this.queuedMessage), this.queuedMessage = null)) : e.data.sortCanceled ? this.sortRunning = !1 : e.data.sortSetupPhase1Complete ? this.sortWorker.postMessage({
                positions: this.splatMesh.getCenters().buffer,
                meshMatrixWorlds: this.splatMesh.meshMatrixWorlds,
                meshIndexIntervals: this.splatMesh.meshIndexIntervals,
                cropsArray: this.cropsArray
            }) : e.data.sortSetupComplete && (this.splatDataTextures = this.splatMesh.getSplatDataTextures(), this.updateView(!0, !0), this.splatRenderingInitialized = !0);
        };
    }
    update() {
        this.splatRenderingInitialized !== !1 && (this.updateSplatMeshUniforms(), this.updateView());
    }
    getSplatMesh() {
        return this.splatMesh;
    }
};
var Ax = new Ls;
Ax.wireframe = !0;
var LL = new _, Vl = class extends vi {
    constructor(e, r){
        super();
        this.data = e;
        this.sharedAssets = r;
        this.enableHelpers = !1;
        this.wireframeState = !1;
        this.needsTransmissionDirty = !0;
        this.needsNormalDirty = !0;
        this._needsTransmission = !1;
        this._needsNormal = !1;
        this.geometryCacheChanged = !1;
        this.splatViewer = null;
        this.entityByUuid = {};
        this.entityIdentityToEntity = {};
        this.toExpandCloner = new Set;
        this.toUpdateCloner = new Set;
        this.pendingCommands = [];
        this.pathConstraints = new Vx;
        this.invisibleObjects = new Ss("jflkdsafjasdifjaslk", {
            ...Wv.defaultData,
            visible: !1,
            name: "buildin invisible"
        });
        this.needsRecomputeInstances = !1;
        this.init(e, r), this.matrixAutoUpdate = !1, this.errorPage = new sr("fdasfa", {
            ...ma.defaultData,
            name: ""
        }, {
            shared: r,
            scene: this
        });
    }
    markGeometryCacheDirty() {
        this.geometryCacheChanged = !0;
    }
    markNeedsUpdateRendererDirty() {
        this.needsTransmissionDirty = !0, this.needsNormalDirty = !0;
    }
    needsTransmission() {
        return this.needsTransmissionDirty && (this._needsTransmission = tL(this), this.needsTransmissionDirty = !1), this._needsTransmission;
    }
    needsNormal() {
        return this.needsNormalDirty && (this._needsNormal = eL(this), this.needsNormalDirty = !1), this._needsNormal;
    }
    registerInstanceAndSetUuid(e) {
        let r = e.identity.join("-"), i = this.entityIdentityToEntity[r];
        i && (e.uuid = i.uuid), this.entityIdentityToEntity[r] = e, this.entityByUuid[e.uuid] = e;
    }
    markPenumbraSizeDirty() {
        for (let e of this.children)e instanceof sr && (e.penumbraSizeArrayCache = null);
    }
    findInstance(e) {
        return this.entityIdentityToEntity[e.join("-")];
    }
    get bgColor() {
        return this.activePage.bgColor;
    }
    get postprocessing() {
        return this.activePage.data.postprocessing;
    }
    getWithSortKey(e) {
        let r = this.find(e);
        if (r === void 0) return;
        let i = [], s = r;
        for(; s !== this;){
            let o = s;
            s = s.parent;
            let a = s.children.indexOf(o);
            i.splice(0, 0, a);
        }
        return {
            entity: r,
            sortKey: i
        };
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && r.push(s);
        }
        return r.sort((i, s)=>nv(i.sortKey, s.sortKey)), r.map((i)=>i.entity);
    }
    nonExistOrDescendantOf(e, r) {
        let i = this.find(e);
        if (i === void 0) return !0;
        for(; i;){
            if (i.uuid === r) return !0;
            i = i.parent;
        }
        return !1;
    }
    find(e) {
        if (this.activePage && this.activePage.personalCamera.parent) {
            if (e === "f23858d0-4a3b-4bd8-8173-66ed0af7f6fb-personalCamera") return this.activePage.personalCamera;
            if (e === us) return this.activePage.personalCamera;
        }
        if (e === "" || e === void 0) return;
        let r = this.entityByUuid[e];
        return r === void 0 ? this.getObjectByProperty("uuid", e) : r;
    }
    find2D(e) {
        for (let r of this.children)if (r instanceof sr && r.uiScene) {
            let i = r.uiScene.find(e);
            if (i) return i;
        }
    }
    findScene2DfromObject2D(e) {
        for (let r of this.children)if (r instanceof sr && r.uiScene && r.uiScene.find(e)) return r.uiScene;
    }
    find2DInUIObjects(e) {
        let r;
        return this.traverseEntity((i)=>{
            r === void 0 && i instanceof fr && (r = i.uiCanvas.find(e));
        }), r;
    }
    traverse2D(e) {
        for (let r of this.children)r instanceof sr && r.uiScene && r.uiScene.traverse(e);
    }
    debugEnsureEntity(e) {
        let r = this.find(e);
        if (r) {
            if (Array.isArray(r.identity) && this.findInstance(r.identity) === void 0) {
                console.error("not found instance");
                debugger;
            }
        } else {
            console.error("not found");
            debugger;
        }
    }
    addPendingExpandCloner(e) {
        this.toExpandCloner.add(e);
    }
    addPendingUpdateCloner(e) {
        this.toUpdateCloner.add(e);
    }
    markToExpandCloner(e) {
        this.toExpandCloner.add(e), e.traverseEntityAncestors((r)=>{
            this.toExpandCloner.add(r);
        });
    }
    doPendingExpandCloner() {
        this.toExpandCloner.forEach((e)=>{
            e.expandCloner(this);
        }), this.toExpandCloner.clear();
    }
    doPendingUpdateCloner() {
        this.toUpdateCloner.forEach((e)=>{
            e.cloner?.update();
        }), this.toUpdateCloner.clear();
    }
    doPendingUpdates() {
        this.doPendingExpandCloner(), this.doPendingUpdateCloner(), this.applyPendingCommands();
    }
    addPendingCommand(e) {
        this.pendingCommands.push(e);
    }
    applyPendingCommands() {
        this.pendingCommands.forEach((e)=>e()), this.pendingCommands.length = 0;
    }
    updateByLibOp(e, r) {
        e.path.length === 1 && e.path[0] === "components" && e.type === 1 && this.createChildrenObjects([
            {
                ...e.data.asset,
                id: e.id
            }
        ], this.invisibleObjects, r);
    }
    updateTreeByOp(e, r) {
        if (e.path.length === 0 && e.type === 7) {
            let i = e.parent === null ? this : this.find(e.parent);
            if (i === void 0) throw new Error("unexpected");
            let s = this.createObject(e.id, e.data, e.children, i, e.localIndex, r);
            s.updateVisible(this), s.resetBBoxNeedsUpdate(), sn(s) && An(s.parent) && (s.invalidateUpstreamBooleanData(), s.parent.invalidateDownstreamBooleanData().recomputeBoolean()), this.markNeedsRecomputeInstancesForAncessors(i), this.markNeedsRecomputeInstancesForChildren(s), this.markToExpandCloner(s), this.markPenumbraSizeDirty(), s.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 8) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markToExpandCloner(i), i.resetBBoxNeedsUpdate(), this.unregisterObject(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), this.markNeedsRecomputeInstancesForChildren(i), this.markPenumbraSizeDirty(), i.parent.remove(i), An(i.parent) && (i.parent.invalidateUpstreamBooleanData(), i.parent.invalidateDownstreamBooleanData().recomputeBoolean()), sn(i) && (i.freeBooleanPointer(), s instanceof Ln && s.invalidateDownstreamBooleanData().recomputeBoolean()), i instanceof Hl && i.detachShape(), this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(i), this.pathConstraints.removeDependencies(i.uuid), i.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 9) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markNeedsRecomputeInstancesForChildren(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), i.cloner?.resetOnMove(), this.markToExpandCloner(i);
            let o = e.parent === null ? this : this.find(e.parent);
            if (o === void 0) throw new Error("unexpected");
            o.add(i), this.markNeedsRecomputeInstancesForAncessors(o), this.markToExpandCloner(i), i.invalidateClonerTransform(i), i.updateVisible(this), i.resetBBoxNeedsUpdate(), this.markPenumbraSizeDirty();
            let a = e.localIndex;
            o.children.splice(a, 0, o.children.pop()), sn(i) && (i.invalidateUpstreamBooleanData(), An(i.parent) ? i.parent.invalidateDownstreamBooleanData().recomputeBoolean() : s instanceof Ln && s.invalidateDownstreamBooleanData().recomputeBoolean()), i.updatePathSnapping();
        }
        this.markNeedsUpdateRendererDirty(), this.markGeometryCacheDirty();
    }
    get playPage() {
        return this.find(this.data.publish.playPage) ?? this.errorPage;
    }
    updatePage(e) {
        this.activePage && this.activePage.onDeactive(), this.activePage = this.errorPage;
        for (let r of this.children)r instanceof sr && (r.visible = r.uuid === e, r.visible && (this.activePage = r, this.activePage.onActive(this)));
        this.activePage !== this.splatViewer?.activePage && this.reloadSplats();
    }
    updateEntityByOp(e, r, i, s) {
        if (r.type === 0) {
            if (("overrides" in r.props || "component" in r.props) && this.markNeedsRecomputeInstances(), "visible" in r.props && this.markPenumbraSizeDirty(), r.path.includes("overrides") && "states" in r.props) {
                let { rest: a } = r.props;
                r = {
                    ...r,
                    props: a
                }, this.markNeedsRecomputeInstances();
            }
            r.path[0] === "pathSnapping" && r.props.pathId !== void 0 && this.pathConstraints.setConstraint(e, r.props.pathId);
        }
        let o = this.find(e);
        if (o) try {
            Z3(o, r, i, {
                scene: this,
                shared: s
            }), o instanceof er && o.updateGeometryGroupsIfNeeded();
        } catch (a) {
            console.error(a);
        }
    }
    updateEntity2DByOp(e, r, i, s, o, a = []) {
        e.updateEntityByOp(r, i, s, o), this.traverseEntity((l)=>{
            (l instanceof fr || l instanceof sr) && (a.includes(l.frameId ?? "") || l.frameId === r) && l.updateEntity2DByOp(r, i, s, o);
        });
    }
    get activeCamera() {
        return this.activePage.activeCamera;
    }
    switchActiveCamera(e) {
        this.activePage.switchActiveCamera(e);
    }
    isInvisibleObjects(e) {
        return e === this.invisibleObjects || e.hasAnccestor(this.invisibleObjects);
    }
    init(e, r) {
        let i = Object.entries(r.data.lib.components).map((s, o)=>({
                data: s[1].asset.data,
                children: s[1].asset.children,
                id: s[0],
                fi: o
            }));
        this.invisibleObjects.updateState(this.invisibleObjects.data, {
            scene: this,
            shared: r
        }), this.add(this.invisibleObjects), this.createChildrenObjects(i, this.invisibleObjects, r), this.createChildrenObjects(e.objects, this, r), this.updatePage(e.publish.playPage), this.activePage.switchToPlayCamera(), this.expandInstances(r, !0), this.traverseEntity((s)=>{
            s instanceof hr && s.updateUp();
        }), this.doPendingExpandCloner(), this.applyPendingCommands();
    }
    markNeedsRecomputeInstances() {
        this.needsRecomputeInstances = !0;
    }
    markNeedsRecomputeInstancesForChildren(e) {
        e.traverseEntity((r)=>{
            (r.data.type === "Component" || r.data.type === "Instance") && this.markNeedsRecomputeInstances();
        });
    }
    markNeedsRecomputeInstancesForAncessors(e) {
        ut.is(e) && (e.data.type === "Component" && this.markNeedsRecomputeInstances(), e.traverseAncestors((r)=>{
            ut.is(r) && r.data.type === "Component" && this.markNeedsRecomputeInstances();
        }));
    }
    relativeizeInner(e, r, i, s, o, a, l) {
        if (e) {
            let u = s.find(e);
            u && u !== s && o.forInstancesRec((c)=>{
                c.data = fl(c.data, (d)=>{
                    let h = d.events.data(l.id), f = c.goUp(a);
                    if (f) {
                        let p = [
                            ...iv(f.identity),
                            e
                        ].join("-"), m = this.entityIdentityToEntity[p];
                        if (m) {
                            let g = m.uuid, y = Tr.zoom(h, r);
                            y[i] = g;
                        } else console.warn("cannot find instance");
                    }
                }).data;
            });
        }
    }
    rewriteActions(e, r, i, s, o, a) {
        e.forEach((l)=>{
            l.data.type === "Transition" ? this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s, o, a) : l.data.type === "Animation" && this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s, o, a);
        });
    }
    rewriteEventsBeforeGoToPlayMode() {
        this.traverseEntity((e)=>{
            if (e instanceof Js && typeof e.identity == "string" && e.data.type === "Component") return e.traverseEntity((r, i)=>{
                r.data.events.forEach((s)=>{
                    if (s.data.type === "GameControl") {
                        let o = !1;
                        if (r.forInstancesRec((a)=>{
                            a.data = fl(a.data, (l)=>{
                                a.isInstanceRoot || (l.events.delete(s.id), o = !0);
                            }).data;
                        }), o === !1) for (let a of Xd.list)this.rewriteActions(s.data.gameActions[a], [
                            "gameActions",
                            a
                        ], e, r, i, s);
                    } else s.data.type === "Conditional" ? (s.data.condition.type === "Distance" ? (this.relativeizeInner(s.data.condition.fromObject, [
                        "condition"
                    ], "fromObject", e, r, i, s), this.relativeizeInner(s.data.condition.toObject, [
                        "condition"
                    ], "toObject", e, r, i, s)) : s.data.condition.type === "State" ? this.relativeizeInner(s.data.condition.object, [
                        "condition"
                    ], "object", e, r, i, s) : s.data.condition.type === "Comparison" && (s.data.condition.lOperand.type === "Property" && this.relativeizeInner(s.data.condition.lOperand.value[0], [
                        "condition",
                        "lOperand",
                        "value"
                    ], 0, e, r, i, s), s.data.condition.rOperand.type === "Property" && this.relativeizeInner(s.data.condition.rOperand.value[0], [
                        "condition",
                        "rOperand",
                        "value"
                    ], 0, e, r, i, s)), this.rewriteActions(s.data.inActions, [
                        "inActions"
                    ], e, r, i, s), this.rewriteActions(s.data.outActions, [
                        "outActions"
                    ], e, r, i, s)) : "actions" in s.data && this.rewriteActions(s.data.actions, [
                        "actions"
                    ], e, r, i, s);
                });
            }), !0;
        });
    }
    expandInstances(e, r, i) {
        let s = new Set;
        this.traverseEntity((o)=>{
            if (o instanceof Js && o.isInstanceRoot) return o.expandInstanceChildren({
                scene: this,
                shared: e,
                pendingDeletes: s
            }), r || o.resetBBoxNeedsUpdate(), i && o.traverseEntity((a)=>{
                i.addClip(a);
            }), !0;
        });
        for (let o of s)this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(o), Ix(o);
    }
    recomputeInstances(e, r) {
        this.needsRecomputeInstances && (this.needsRecomputeInstances = !1, this.traverseEntity((i)=>{
            i instanceof Js && i.isInstanceRoot && (i.component = void 0);
        }), this.expandInstances(e, !1, r));
    }
    disposeAndUnregisterEntityRecursivelyIfNotReregistered(e) {
        e.traverseEntity((r)=>{
            let i = typeof r.identity == "string" ? r.identity : r.identity.join("-");
            this.entityIdentityToEntity[i] === r && (delete this.entityByUuid[r.uuid], delete this.entityIdentityToEntity[i]), r.dispose();
        });
    }
    clearScene() {
        for (let e of this.children)ut.is(e) && e.disposeRecursively();
        this.children.length = 0;
    }
    resetAfterClear(e, r) {
        this.init(e, r);
    }
    raycast(e) {
        return this.raycast1(e, !1);
    }
    raycast1(e, r) {
        let i = [], s = (o)=>{
            for (let a of o.children){
                let l = a.cloner;
                if (ut.is(a) && !a.raycastLock && (a.visible || l?.object.data.visible)) {
                    if (r === !0 && a.isInstanceRoot) {
                        let u = [];
                        if (e.intersectObject(a, !0, u), u.length) {
                            let c = u[0];
                            c.object = a, c.point.applyMatrix4(c.object.matrixWorld);
                            let d = a.matrixWorld.clone().invert();
                            c.point.applyMatrix4(d), i.push(c);
                        }
                    } else (sn(a) || Om(a) && this.enableHelpers && a.objectHelper.visible) && (e.intersectObject(a, !1, i), Vm(a, e, i)), s(a);
                }
            }
        };
        return s(this.activePage), i;
    }
    raycastWithClones(e) {
        let r = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                ut.is(o) && (o.visible || a?.object.data.visible) && ((sn(o) || Om(o) && this.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Vm(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    forEachEntity(e) {
        for (let r of this.children)ut.is(r) && e(r);
    }
    traverseConcreteEntity(e) {
        for (let r of this.children)ut.is(r) && r.isConcreteEntity && r.traverseEntity(e);
    }
    traverseEntity(e) {
        for (let r of this.children)ut.is(r) && r.traverseEntity(e);
    }
    updateFont(e, r) {
        this.traverseEntity((i)=>{
            if (i instanceof er && i.data.type === "Mesh" && i.data.geometry.type === "TextGeometry" && i.data.geometry.font === e) {
                let s = i.geometry, o = i.data.geometry;
                s.updateFont(e, r).then(()=>{
                    s.update(o);
                    let a = i.invalidateDownstreamBooleanData();
                    An(a) && a.recomputeBoolean();
                });
            }
        });
    }
    traverseObject(e) {
        for (let r of this.children)dh.is(r) && r.traverseObject(e);
    }
    traverseVisibleEntity(e) {
        for (let r of this.children)ut.is(r) && r.visible && r.traverseVisibleEntity(e);
    }
    dispose() {
        this.clearScene();
    }
    createChildrenObjects(e, r, i) {
        let s = 0;
        for (let o of e)this.createObject(o.id, o.data, o.children, r, s, i), s += 1;
    }
    registerObjectCreatedInLegacy(e) {
        this.entityByUuid[e.uuid] = e;
    }
    unregisterObject(e) {
        delete this.entityByUuid[e.uuid];
        for (let r of e.children)this.unregisterObject(r);
    }
    createObject(e, r, i, s, o, a) {
        let l = {
            scene: this,
            shared: a
        }, u = zx(e, r, l);
        return u && (this.entityByUuid[e] = u, s.add(u), s.children.splice(o, 0, s.children.pop()), i.length > 0 && (u.isInstanceRoot ? console.error("instance should not have children!") : this.createChildrenObjects(i, u, a)), u.updateState(r, l), u instanceof er && u.updateGeometryGroupsIfNeeded(), u.updateVisible(this), u.cloner && this.toExpandCloner.add(u), r.pathSnapping?.pathId && this.pathConstraints.setConstraint(e, r.pathSnapping.pathId)), r.type === "Empty" && r.animations && u.traverseEntity((c)=>{
            let d = c.dataPatched;
            if (c instanceof er && d.bones && d.boneInverses) {
                let h = d.bones.map((m)=>this.find(m)), f = d.boneInverses.map((m)=>new te().fromArray(m)), p = new Za(h, f);
                c.bind(p, c.bindMatrix);
            } else c.matrixAutoUpdate = !0;
        }), u;
    }
    getCenter(e) {
        let r = [];
        for(let s = 0, o = e.length; s < o; ++s){
            let { id: a, recursive: l } = e[s], u = this.find(a), c = l ? u.recursiveBBox : u.singleBBox;
            r.push(...c.vertices);
        }
        let i = new Bt;
        return i.setFromPoints(r), i.getCenter(LL), LL;
    }
    copyMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e);
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    copyParentMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e)?.parent;
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    traverseMaterial(e) {
        this.traverseEntity((r)=>{
            if (r instanceof nr) {
                if (Array.isArray(r.material)) for(let i = 0; i < r.material.length; i++)r.material[i] instanceof Rn && e(r.material[i]);
                else r.material instanceof Rn && e(r.material);
            }
        });
    }
    updateViewPlaneSize(e, r, i = !1) {
        this.traverseConcreteEntity((s)=>{
            s instanceof hr && s.setViewplaneSize(e, r, i);
        });
    }
    initializeSplatViewer(e) {
        this.splatViewer = new Um({
            scene: this,
            renderer: e
        }), this.reloadSplats();
    }
    reloadSplats() {
        this.splatViewer?.reloadSplats();
    }
};
var Gm = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return Math.sqrt(e * e + r * r);
}, BL = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return fK(Math.atan2(r, e));
}, NL = (n1, t, e)=>{
    let r = {
        x: 0,
        y: 0
    };
    return e = Wx(e), r.x = n1.x - t * Math.cos(e), r.y = n1.y - t * Math.sin(e), r;
}, Wx = (n1)=>n1 * (Math.PI / 180), fK = (n1)=>n1 * (180 / Math.PI), FL = (n1)=>isNaN(n1.buttons) ? n1.pressure !== 0 : n1.buttons !== 0, V_ = new Map, U_ = (n1)=>{
    V_.has(n1) && clearTimeout(V_.get(n1)), V_.set(n1, setTimeout(n1, 100));
}, Cf = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s = 0; s < r.length; s += 1)i = r[s], n1.addEventListener ? n1.addEventListener(i, e, !1) : n1.attachEvent && n1.attachEvent(i, e);
}, G_ = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s = 0; s < r.length; s += 1)i = r[s], n1.removeEventListener ? n1.removeEventListener(i, e) : n1.detachEvent && n1.detachEvent(i, e);
};
var qx = (n1)=>(n1.preventDefault(), n1.type.match(/^touch/) ? n1.changedTouches : n1), j_ = ()=>{
    if (typeof window > "u") return;
    let n1 = window.pageXOffset !== void 0 ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft, t = window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    return {
        x: n1,
        y: t
    };
}, Yx = (n1, t)=>{
    t.top || t.right || t.bottom || t.left ? (n1.style.top = t.top, n1.style.right = t.right, n1.style.bottom = t.bottom, n1.style.left = t.left) : (n1.style.left = t.x + "px", n1.style.top = t.y + "px");
}, Xx = (n1, t, e)=>{
    let r = zL(n1);
    for(let i in r)if (r.hasOwnProperty(i)) {
        if (typeof t == "string") r[i] = t + " " + e;
        else {
            let s = "";
            for(let o = 0, a = t.length; o < a; o += 1)s += t[o] + " " + e + ", ";
            r[i] = s.slice(0, -2);
        }
    }
    return r;
}, kL = (n1, t)=>{
    let e = zL(n1);
    for(let r in e)e.hasOwnProperty(r) && (e[r] = t);
    return e;
}, zL = (n1)=>{
    let t = {};
    return t[n1] = "", [
        "webkit",
        "Moz",
        "o"
    ].forEach(function(r) {
        t[r + n1.charAt(0).toUpperCase() + n1.slice(1)] = "";
    }), t;
}, Qx = (n1, t)=>{
    for(let e in t)t.hasOwnProperty(e) && (n1[e] = t[e]);
    return n1;
}, VL = (n1, t)=>{
    let e = {};
    for(let r in n1)n1.hasOwnProperty(r) && t.hasOwnProperty(r) ? e[r] = t[r] : n1.hasOwnProperty(r) && (e[r] = n1[r]);
    return e;
}, jm = (n1, t)=>{
    if (n1.length) for(let e = 0, r = n1.length; e < r; e += 1)t(n1[e]);
    else t(n1);
}, UL = (n1, t, e)=>({
        x: Math.min(Math.max(n1.x, t.x - e), t.x + e),
        y: Math.min(Math.max(n1.y, t.y - e), t.y + e)
    });
typeof window < "u" && (GL = "ontouchstart" in window, jL = !!window.PointerEvent, HL = !!window.MSPointerEvent);
var GL, jL, HL, Hm = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend, touchcancel"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup"
    },
    pointer: {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup, pointercancel"
    },
    MSPointer: {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    }
}, Pf, Wm = {};
jL ? Pf = Hm.pointer : HL ? Pf = Hm.MSPointer : GL ? (Pf = Hm.touch, Wm = Hm.mouse) : Pf = Hm.mouse;
function nu() {}
nu.prototype.on = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < r.length; s += 1)i = r[s], e._handlers_[i] = e._handlers_[i] || [], e._handlers_[i].push(t);
    return e;
};
nu.prototype.off = function(n1, t) {
    var e = this;
    return e._handlers_ = e._handlers_ || {}, n1 === void 0 ? e._handlers_ = {} : t === void 0 ? e._handlers_[n1] = null : e._handlers_[n1] && e._handlers_[n1].indexOf(t) >= 0 && e._handlers_[n1].splice(e._handlers_[n1].indexOf(t), 1), e;
};
nu.prototype.trigger = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < r.length; s += 1)i = r[s], e._handlers_[i] && e._handlers_[i].length && e._handlers_[i].forEach(function(o) {
        o.call(e, {
            type: i,
            target: e
        }, t);
    });
};
nu.prototype.config = function(n1) {
    var t = this;
    t.options = t.defaults || {}, n1 && (t.options = VL(t.options, n1));
};
nu.prototype.bindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[t] = function() {
        typeof e["on" + t] == "function" ? e["on" + t].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + t + '" handler.');
    }, Cf(n1, Pf[t], e._domHandlers_[t]), Wm[t] && Cf(n1, Wm[t], e._domHandlers_[t]), e;
};
nu.prototype.unbindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, G_(n1, Pf[t], e._domHandlers_[t]), Wm[t] && G_(n1, Wm[t], e._domHandlers_[t]), delete e._domHandlers_[t], this;
};
var Df = nu;
function Ei(n1, t) {
    return this.identifier = t.identifier, this.position = t.position, this.frontPosition = t.frontPosition, this.collection = n1, this.defaults = {
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        mode: "dynamic",
        zone: document.body,
        lockX: !1,
        lockY: !1,
        shape: "circle"
    }, this.config(t), this.options.mode === "dynamic" && (this.options.restOpacity = 0), this.id = Ei.id, Ei.id += 1, this.buildEl().stylize(), this.instance = {
        el: this.ui.el,
        on: this.on.bind(this),
        off: this.off.bind(this),
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        add: this.addToDom.bind(this),
        remove: this.removeFromDom.bind(this),
        destroy: this.destroy.bind(this),
        setPosition: this.setPosition.bind(this),
        resetDirection: this.resetDirection.bind(this),
        computeDirection: this.computeDirection.bind(this),
        trigger: this.trigger.bind(this),
        position: this.position,
        frontPosition: this.frontPosition,
        ui: this.ui,
        identifier: this.identifier,
        id: this.id,
        options: this.options
    }, this.instance;
}
Ei.prototype = new Df;
Ei.constructor = Ei;
Ei.id = 0;
Ei.prototype.buildEl = function(n1) {
    return this.ui = {}, this.options.dataOnly ? this : (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front), this);
};
Ei.prototype.stylize = function() {
    if (this.options.dataOnly) return this;
    var n1 = this.options.fadeTime + "ms", t = kL("borderRadius", "50%"), e = Xx("transition", "opacity", n1), r = {};
    return r.el = {
        position: "absolute",
        opacity: this.options.restOpacity,
        display: "block",
        zIndex: 999
    }, r.back = {
        position: "absolute",
        display: "block",
        width: this.options.size + "px",
        height: this.options.size + "px",
        marginLeft: -this.options.size / 2 + "px",
        marginTop: -this.options.size / 2 + "px",
        background: "rgba(255, 255, 255, .4)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, r.front = {
        width: this.options.size / 2 + "px",
        height: this.options.size / 2 + "px",
        position: "absolute",
        display: "block",
        marginLeft: -this.options.size / 4 + "px",
        marginTop: -this.options.size / 4 + "px",
        background: "rgba(255, 255, 255, .8)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, Qx(r.el, e), this.options.shape === "circle" && Qx(r.back, t), Qx(r.front, t), this.applyStyles(r), this;
};
Ei.prototype.applyStyles = function(n1) {
    for(var t in this.ui)if (this.ui.hasOwnProperty(t)) for(var e in n1[t])this.ui[t].style[e] = n1[t][e];
    return this;
};
Ei.prototype.addToDom = function() {
    return this.options.dataOnly || document.body.contains(this.ui.el) ? this : (this.options.zone.appendChild(this.ui.el), this);
};
Ei.prototype.removeFromDom = function() {
    return this.options.dataOnly || !document.body.contains(this.ui.el) ? this : (this.options.zone.removeChild(this.ui.el), this);
};
Ei.prototype.destroy = function() {
    clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
};
Ei.prototype.show = function(n1) {
    var t = this;
    return t.options.dataOnly || (clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.addToDom(), t.restCallback(), setTimeout(function() {
        t.ui.el.style.opacity = 1;
    }, 0), t.showTimeout = setTimeout(function() {
        t.trigger("shown", t.instance), typeof n1 == "function" && n1.call(this);
    }, t.options.fadeTime)), t;
};
Ei.prototype.hide = function(n1) {
    var t = this;
    if (t.options.dataOnly) return t;
    if (t.ui.el.style.opacity = t.options.restOpacity, clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.removeTimeout = setTimeout(function() {
        var e = t.options.mode === "dynamic" ? "none" : "block";
        t.ui.el.style.display = e, typeof n1 == "function" && n1.call(t), t.trigger("hidden", t.instance);
    }, t.options.fadeTime), t.options.restJoystick) {
        let e = t.options.restJoystick, r = {};
        r.x = e === !0 || e.x !== !1 ? 0 : t.instance.frontPosition.x, r.y = e === !0 || e.y !== !1 ? 0 : t.instance.frontPosition.y, t.setPosition(n1, r);
    }
    return t;
};
Ei.prototype.setPosition = function(n1, t) {
    var e = this;
    e.frontPosition = {
        x: t.x,
        y: t.y
    };
    var r = e.options.fadeTime + "ms", i = {};
    i.front = Xx("transition", [
        "top",
        "left"
    ], r);
    var s = {
        front: {}
    };
    s.front = {
        left: e.frontPosition.x + "px",
        top: e.frontPosition.y + "px"
    }, e.applyStyles(i), e.applyStyles(s), e.restTimeout = setTimeout(function() {
        typeof n1 == "function" && n1.call(e), e.restCallback();
    }, e.options.fadeTime);
};
Ei.prototype.restCallback = function() {
    var n1 = this, t = {};
    t.front = Xx("transition", "none", ""), n1.applyStyles(t), n1.trigger("rested", n1.instance);
};
Ei.prototype.resetDirection = function() {
    this.direction = {
        x: !1,
        y: !1,
        angle: !1
    };
};
Ei.prototype.computeDirection = function(n1) {
    var t = n1.angle.radian, e = Math.PI / 4, r = Math.PI / 2, i, s, o;
    if (t > e && t < e * 3 && !n1.lockX ? i = "up" : t > -e && t <= e && !n1.lockY ? i = "left" : t > -e * 3 && t <= -e && !n1.lockX ? i = "down" : n1.lockY || (i = "right"), n1.lockY || (t > -r && t < r ? s = "left" : s = "right"), n1.lockX || (t > 0 ? o = "up" : o = "down"), n1.force > this.options.threshold) {
        var a = {}, l;
        for(l in this.direction)this.direction.hasOwnProperty(l) && (a[l] = this.direction[l]);
        var u = {};
        this.direction = {
            x: s,
            y: o,
            angle: i
        }, n1.direction = this.direction;
        for(l in a)a[l] === this.direction[l] && (u[l] = !0);
        if (u.x && u.y && u.angle) return n1;
        (!u.x || !u.y) && this.trigger("plain", n1), u.x || this.trigger("plain:" + s, n1), u.y || this.trigger("plain:" + o, n1), u.angle || this.trigger("dir dir:" + i, n1);
    } else this.resetDirection();
    return n1;
};
var WL = Ei;
function Jr(n1, t) {
    var e = this;
    e.nipples = [], e.idles = [], e.actives = [], e.ids = [], e.pressureIntervals = {}, e.manager = n1, e.id = Jr.id, Jr.id += 1, e.defaults = {
        zone: document.body,
        multitouch: !1,
        maxNumberOfNipples: 10,
        mode: "dynamic",
        position: {
            top: 0,
            left: 0
        },
        catchDistance: 200,
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        lockX: !1,
        lockY: !1,
        shape: "circle",
        dynamicPage: !1,
        follow: !1
    }, e.config(t), (e.options.mode === "static" || e.options.mode === "semi") && (e.options.multitouch = !1), e.options.multitouch || (e.options.maxNumberOfNipples = 1);
    let r = getComputedStyle(e.options.zone.parentElement);
    return r && r.display === "flex" && (e.parentIsFlex = !0), e.updateBox(), e.prepareNipples(), e.bindings(), e.begin(), e.nipples;
}
Jr.prototype = new Df;
Jr.constructor = Jr;
Jr.id = 0;
Jr.prototype.prepareNipples = function() {
    var n1 = this, t = n1.nipples;
    t.on = n1.on.bind(n1), t.off = n1.off.bind(n1), t.options = n1.options, t.destroy = n1.destroy.bind(n1), t.ids = n1.ids, t.id = n1.id, t.processOnMove = n1.processOnMove.bind(n1), t.processOnEnd = n1.processOnEnd.bind(n1), t.get = function(e) {
        if (e === void 0) return t[0];
        for(var r = 0, i = t.length; r < i; r += 1)if (t[r].identifier === e) return t[r];
        return !1;
    };
};
Jr.prototype.bindings = function() {
    var n1 = this;
    n1.bindEvt(n1.options.zone, "start"), n1.options.zone.style.touchAction = "none", n1.options.zone.style.msTouchAction = "none";
};
Jr.prototype.begin = function() {
    var n1 = this, t = n1.options;
    if (t.mode === "static") {
        var e = n1.createNipple(t.position, n1.manager.getIdentifier());
        e.add(), n1.idles.push(e);
    }
};
Jr.prototype.createNipple = function(n1, t) {
    var e = this, r = e.manager.scroll, i = {}, s = e.options, o = {
        x: e.parentIsFlex ? r.x : r.x + e.box.left,
        y: e.parentIsFlex ? r.y : r.y + e.box.top
    };
    if (n1.x && n1.y) i = {
        x: n1.x - o.x,
        y: n1.y - o.y
    };
    else if (n1.top || n1.right || n1.bottom || n1.left) {
        var a = document.createElement("DIV");
        a.style.display = "hidden", a.style.top = n1.top, a.style.right = n1.right, a.style.bottom = n1.bottom, a.style.left = n1.left, a.style.position = "absolute", s.zone.appendChild(a);
        var l = a.getBoundingClientRect();
        s.zone.removeChild(a), i = n1, n1 = {
            x: l.left + r.x,
            y: l.top + r.y
        };
    }
    var u = new WL(e, {
        color: s.color,
        size: s.size,
        threshold: s.threshold,
        fadeTime: s.fadeTime,
        dataOnly: s.dataOnly,
        restJoystick: s.restJoystick,
        restOpacity: s.restOpacity,
        mode: s.mode,
        identifier: t,
        position: n1,
        zone: s.zone,
        frontPosition: {
            x: 0,
            y: 0
        },
        shape: s.shape
    });
    return s.dataOnly || (Yx(u.ui.el, i), Yx(u.ui.front, u.frontPosition)), e.nipples.push(u), e.trigger("added " + u.identifier + ":added", u), e.manager.trigger("added " + u.identifier + ":added", u), e.bindNipple(u), u;
};
Jr.prototype.updateBox = function() {
    var n1 = this;
    n1.box = n1.options.zone.getBoundingClientRect();
};
Jr.prototype.bindNipple = function(n1) {
    var t = this, e, r = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
Jr.prototype.pressureFn = function(n1, t, e) {
    var r = this, i = 0;
    clearInterval(r.pressureIntervals[e]), r.pressureIntervals[e] = setInterval((function() {
        var s = n1.force || n1.pressure || n1.webkitForce || 0;
        s !== i && (t.trigger("pressure", s), r.trigger("pressure " + t.identifier + ":pressure", s), i = s);
    }).bind(r), 100);
};
Jr.prototype.onstart = function(n1) {
    var t = this, e = t.options, r = n1;
    n1 = qx(n1), t.updateBox();
    var i = function(s) {
        t.actives.length < e.maxNumberOfNipples ? t.processOnStart(s) : r.type.match(/^touch/) && (Object.keys(t.manager.ids).forEach(function(o) {
            if (Object.values(r.touches).findIndex(function(l) {
                return l.identifier === o;
            }) < 0) {
                var a = [
                    n1[0]
                ];
                a.identifier = o, t.processOnEnd(a);
            }
        }), t.actives.length < e.maxNumberOfNipples && t.processOnStart(s));
    };
    return jm(n1, i), t.manager.bindDocument(), !1;
};
Jr.prototype.processOnStart = function(n1) {
    var t = this, e = t.options, r, i = t.manager.getIdentifier(n1), s = n1.force || n1.pressure || n1.webkitForce || 0, o = {
        x: n1.pageX,
        y: n1.pageY
    }, a = t.getOrCreate(i, o);
    a.identifier !== i && t.manager.removeIdentifier(a.identifier), a.identifier = i;
    var l = function(c) {
        c.trigger("start", c), t.trigger("start " + c.id + ":start", c), c.show(), s > 0 && t.pressureFn(n1, c, c.identifier), t.processOnMove(n1);
    };
    if ((r = t.idles.indexOf(a)) >= 0 && t.idles.splice(r, 1), t.actives.push(a), t.ids.push(a.identifier), e.mode !== "semi") l(a);
    else {
        var u = Gm(o, a.position);
        if (u <= e.catchDistance) l(a);
        else {
            a.destroy(), t.processOnStart(n1);
            return;
        }
    }
    return a;
};
Jr.prototype.getOrCreate = function(n1, t) {
    var e = this, r = e.options, i;
    return /(semi|static)/.test(r.mode) ? (i = e.idles[0], i ? (e.idles.splice(0, 1), i) : r.mode === "semi" ? e.createNipple(t, n1) : (console.warn("Coudln't find the needed nipple."), !1)) : (i = e.createNipple(t, n1), i);
};
Jr.prototype.processOnMove = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s = t.manager.scroll;
    if (!FL(n1)) {
        this.processOnEnd(n1);
        return;
    }
    if (!i) {
        console.error("Found zombie joystick with ID " + r), t.manager.removeIdentifier(r);
        return;
    }
    if (e.dynamicPage) {
        var o = i.el.getBoundingClientRect();
        i.position = {
            x: s.x + o.left,
            y: s.y + o.top
        };
    }
    i.identifier = r;
    var a = i.options.size / 2, l = {
        x: n1.pageX,
        y: n1.pageY
    };
    e.lockX && (l.y = i.position.y), e.lockY && (l.x = i.position.x);
    var u = Gm(l, i.position), c = BL(l, i.position), d = Wx(c), h = u / a, f = {
        distance: u,
        position: l
    }, p, m;
    if (i.options.shape === "circle" ? (p = Math.min(u, a), m = NL(i.position, p, c)) : (m = UL(l, i.position, a), p = Gm(m, i.position)), e.follow) {
        if (u > a) {
            let x = l.x - m.x, S = l.y - m.y;
            i.position.x += x, i.position.y += S, i.el.style.top = i.position.y - (t.box.top + s.y) + "px", i.el.style.left = i.position.x - (t.box.left + s.x) + "px", u = Gm(l, i.position);
        }
    } else l = m, u = p;
    var g = l.x - i.position.x, y = l.y - i.position.y;
    i.frontPosition = {
        x: g,
        y: y
    }, e.dataOnly || Yx(i.ui.front, i.frontPosition);
    var v = {
        identifier: i.identifier,
        position: l,
        force: h,
        pressure: n1.force || n1.pressure || n1.webkitForce || 0,
        distance: u,
        angle: {
            radian: d,
            degree: c
        },
        vector: {
            x: g / a,
            y: -y / a
        },
        raw: f,
        instance: i,
        lockX: e.lockX,
        lockY: e.lockY
    };
    v = i.computeDirection(v), v.angle = {
        radian: Wx(180 - c),
        degree: 180 - c
    }, i.trigger("move", v), t.trigger("move " + i.id + ":move", v);
};
Jr.prototype.processOnEnd = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s = t.manager.removeIdentifier(i.identifier);
    !i || (e.dataOnly || i.hide(function() {
        e.mode === "dynamic" && (i.trigger("removed", i), t.trigger("removed " + i.id + ":removed", i), t.manager.trigger("removed " + i.id + ":removed", i), i.destroy());
    }), clearInterval(t.pressureIntervals[i.identifier]), i.resetDirection(), i.trigger("end", i), t.trigger("end " + i.id + ":end", i), t.ids.indexOf(i.identifier) >= 0 && t.ids.splice(t.ids.indexOf(i.identifier), 1), t.actives.indexOf(i) >= 0 && t.actives.splice(t.actives.indexOf(i), 1), /(semi|static)/.test(e.mode) ? t.idles.push(i) : t.nipples.indexOf(i) >= 0 && t.nipples.splice(t.nipples.indexOf(i), 1), t.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (t.manager.ids[s.id] = s.identifier));
};
Jr.prototype.onDestroyed = function(n1, t) {
    var e = this;
    e.nipples.indexOf(t) >= 0 && e.nipples.splice(e.nipples.indexOf(t), 1), e.actives.indexOf(t) >= 0 && e.actives.splice(e.actives.indexOf(t), 1), e.idles.indexOf(t) >= 0 && e.idles.splice(e.idles.indexOf(t), 1), e.ids.indexOf(t.identifier) >= 0 && e.ids.splice(e.ids.indexOf(t.identifier), 1), e.manager.removeIdentifier(t.identifier), e.manager.unbindDocument();
};
Jr.prototype.destroy = function() {
    var n1 = this;
    n1.unbindEvt(n1.options.zone, "start"), n1.nipples.forEach(function(e) {
        e.destroy();
    });
    for(var t in n1.pressureIntervals)n1.pressureIntervals.hasOwnProperty(t) && clearInterval(n1.pressureIntervals[t]);
    n1.trigger("destroyed", n1.nipples), n1.manager.unbindDocument(), n1.off();
};
var qL = Jr;
function ji(n1) {
    var t = this;
    t.ids = {}, t.index = 0, t.collections = [], t.scroll = j_(), t.config(n1), t.prepareCollections();
    var e = function() {
        var i;
        t.collections.forEach(function(s) {
            s.forEach(function(o) {
                i = o.el.getBoundingClientRect(), o.position = {
                    x: t.scroll.x + i.left,
                    y: t.scroll.y + i.top
                };
            });
        });
    };
    if (typeof window > "u") return t.collections;
    Cf(window, "resize", function() {
        U_(e);
    });
    var r = function() {
        t.scroll = j_();
    };
    return Cf(window, "scroll", function() {
        U_(r);
    }), t.collections;
}
ji.prototype = new Df;
ji.constructor = ji;
ji.prototype.prepareCollections = function() {
    var n1 = this;
    n1.collections.create = n1.create.bind(n1), n1.collections.on = n1.on.bind(n1), n1.collections.off = n1.off.bind(n1), n1.collections.destroy = n1.destroy.bind(n1), n1.collections.get = function(t) {
        var e;
        return n1.collections.every(function(r) {
            return e = r.get(t), !e;
        }), e;
    };
};
ji.prototype.create = function(n1) {
    return this.createCollection(n1);
};
ji.prototype.createCollection = function(n1) {
    var t = this, e = new qL(t, n1);
    return t.bindCollection(e), t.collections.push(e), e;
};
ji.prototype.bindCollection = function(n1) {
    var t = this, e, r = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
ji.prototype.bindDocument = function() {
    var n1 = this;
    n1.binded || (n1.bindEvt(document, "move").bindEvt(document, "end"), n1.binded = !0);
};
ji.prototype.unbindDocument = function(n1) {
    var t = this;
    (!Object.keys(t.ids).length || n1 === !0) && (t.unbindEvt(document, "move").unbindEvt(document, "end"), t.binded = !1);
};
ji.prototype.getIdentifier = function(n1) {
    var t;
    return n1 ? (t = n1.identifier === void 0 ? n1.pointerId : n1.identifier, t === void 0 && (t = this.latest || 0)) : t = this.index, this.ids[t] === void 0 && (this.ids[t] = this.index, this.index += 1), this.latest = t, this.ids[t];
};
ji.prototype.removeIdentifier = function(n1) {
    var t = {};
    for(var e in this.ids)if (this.ids[e] === n1) {
        t.id = e, t.identifier = this.ids[e], delete this.ids[e];
        break;
    }
    return t;
};
ji.prototype.onmove = function(n1) {
    var t = this;
    return t.onAny("move", n1), !1;
};
ji.prototype.onend = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
ji.prototype.oncancel = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
ji.prototype.onAny = function(n1, t) {
    var e = this, r, i = "processOn" + n1.charAt(0).toUpperCase() + n1.slice(1);
    t = qx(t);
    var s = function(a, l, u) {
        u.ids.indexOf(l) >= 0 && (u[i](a), a._found_ = !0);
    }, o = function(a) {
        r = e.getIdentifier(a), jm(e.collections, s.bind(null, a, r)), a._found_ || e.removeIdentifier(r);
    };
    return jm(t, o), !1;
};
ji.prototype.destroy = function() {
    var n1 = this;
    n1.unbindDocument(!0), n1.ids = {}, n1.index = 0, n1.collections.forEach(function(t) {
        t.destroy();
    }), n1.off();
};
ji.prototype.onDestroyed = function(n1, t) {
    var e = this;
    if (e.collections.indexOf(t) < 0) return !1;
    e.collections.splice(e.collections.indexOf(t), 1);
};
var YL = ji;
var XL = new YL, QL = {
    create: function(n1) {
        return XL.create(n1);
    },
    factory: XL
};
var KL = new Map, qm = new Map, Uo = class {
    constructor(t, e, r, i){
        this.data = e;
        let { audio: s, volume: o, delay: a, loop: l } = e;
        if (!s) throw new Error("Missing property");
        let u = typeof s == "string" ? i.getAudio(s).src : s.data;
        this.audioPlayer = new Da({
            src: u,
            volume: o,
            delay: a,
            loop: l
        }), qm.has(r.uuid) ? qm.get(r.uuid).push(this) : qm.set(r.uuid, [
            this
        ]), KL.set(t, this);
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.audioPlayer.status === "playing" ? this.audioPlayer.stop() : (this.audioPlayer.stop(), this.audioPlayer.play()) : this.data.toggle === "pause" ? this.audioPlayer.status === "playing" ? this.audioPlayer.pause() : this.audioPlayer.play() : (this.audioPlayer.stop(), this.audioPlayer.play());
    }
    dispose() {
        this.audioPlayer.stop();
    }
}, Of = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playAudio ? this.pauseAudio(this.data.playAudio) : this.data.object ? this.pauseAllAudiosFromObject(this.data.object) : this.pauseAllAudios();
    }
    pauseAudio(t) {
        let e = KL.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.audioPlayer[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e.audioPlayer[this.data.interaction]());
    }
    pauseAllAudiosFromObject(t) {
        let e = qm.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r.audioPlayer[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r.audioPlayer[this.data.interaction]()));
    }
    pauseAllAudios() {
        let t = [
            ...qm.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r.audioPlayer[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r.audioPlayer[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, Ym = class {
    constructor(t, e, r, i, s){
        this.data = e;
        this.shared = i;
        this.condition = s;
        if (e.interaction === "play") this.interaction = new Uo(t, e, r, i);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Of(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Uo ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Uo ? this.interaction.audioPlayer.play() : this.interaction.dispatch();
    }
    dispatchGameControl(t) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Uo && (t === "start" ? this.interaction.audioPlayer.play() : this.interaction.audioPlayer.stop());
    }
    dispose() {
        this.interaction.dispose();
    }
};
var Xm = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.delay = 0;
        this.emission = t.emission, t.delay !== void 0 && (this.delay = t.delay), this.particleSystem = this.page.scene.find(this.data.emitterObjectId);
    }
    toggleEmitting() {
        this.particleSystem.started && !this.particleSystem.stopped ? this.stop() : this.start(this.delay);
    }
    toggleFroze() {
        this.particleSystem.started && !this.particleSystem.isFrozen ? this.freeze() : this.unFreeze();
    }
    start(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.start(0), this.clearDelay();
            }, this.delay);
            return;
        }
        this.particleSystem.start();
    }
    stop() {
        this.particleSystem.stop(), this.clearDelay();
    }
    freeze() {
        this.particleSystem.froze(), this.clearDelay();
    }
    unFreeze() {
        this.particleSystem.unFroze(), this.clearDelay();
    }
    reset() {
        this.particleSystem.reset(), this.clearDelay();
    }
    reverseFromCurrent() {
        switch(this.emission){
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
        }
    }
    dispatchBasic() {
        if (Tt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.start(this.delay);
                break;
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pause":
                this.freeze();
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
            case "stop":
                this.stop();
                break;
            case "reset":
                this.reset();
                break;
            default:
                break;
        }
    }
    dispatchConditional() {
        if (Tt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.particleSystem.start();
                break;
            case "stop":
                this.particleSystem.stop();
                break;
            case "reset":
                this.particleSystem.reset();
                break;
            default:
                break;
        }
    }
    dispatchGameControl(t) {
        if (Tt(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        t === "start" ? this.particleSystem.start() : this.particleSystem.stop();
    }
    dispose() {
        !this.particleSystem || (this.particleSystem.reset(), this.clearDelay());
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
};
var pK = "text/plain", mK = "us-ascii", ZL = (n1, t)=>t.some((e)=>e instanceof RegExp ? e.test(n1) : e === n1), gK = (n1, { stripHash: t })=>{
    let e = /^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$/.exec(n1);
    if (!e) throw new Error(`Invalid URL: ${n1}`);
    let { type: r, data: i, hash: s } = e.groups, o = r.split(";");
    s = t ? "" : s;
    let a = !1;
    o[o.length - 1] === "base64" && (o.pop(), a = !0);
    let l = (o.shift() || "").toLowerCase(), c = [
        ...o.map((d)=>{
            let [h, f = ""] = d.split("=").map((p)=>p.trim());
            return h === "charset" && (f = f.toLowerCase(), f === mK) ? "" : `${h}${f ? `=${f}` : ""}`;
        }).filter(Boolean)
    ];
    return a && c.push("base64"), (c.length > 0 || l && l !== pK) && c.unshift(l), `data:${c.join(";")},${a ? i.trim() : i}${s ? `#${s}` : ""}`;
};
function H_(n1, t) {
    if (t = {
        defaultProtocol: "http:",
        normalizeProtocol: !0,
        forceHttp: !1,
        forceHttps: !1,
        stripAuthentication: !0,
        stripHash: !1,
        stripTextFragment: !0,
        stripWWW: !0,
        removeQueryParameters: [
            /^utm_\w+/i
        ],
        removeTrailingSlash: !0,
        removeSingleSlash: !0,
        removeDirectoryIndex: !1,
        sortQueryParameters: !0,
        ...t
    }, n1 = n1.trim(), /^data:/i.test(n1)) return gK(n1, t);
    if (/^view-source:/i.test(n1)) throw new Error("`view-source:` is not supported as it is a non-standard protocol");
    let e = n1.startsWith("//");
    !e && /^\.*\//.test(n1) || (n1 = n1.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, t.defaultProtocol));
    let i = new URL(n1);
    if (t.forceHttp && t.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (t.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), t.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), t.stripAuthentication && (i.username = "", i.password = ""), t.stripHash ? i.hash = "" : t.stripTextFragment && (i.hash = i.hash.replace(/#?:~:text.*?$/i, "")), i.pathname) {
        let o = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g, a = 0, l = "";
        for(;;){
            let c = o.exec(i.pathname);
            if (!c) break;
            let d = c[0], h = c.index, f = i.pathname.slice(a, h);
            l += f.replace(/\/{2,}/g, "/"), l += d, a = h + d.length;
        }
        let u = i.pathname.slice(a, i.pathname.length);
        l += u.replace(/\/{2,}/g, "/"), i.pathname = l;
    }
    if (i.pathname) try {
        i.pathname = decodeURI(i.pathname);
    } catch  {}
    if (t.removeDirectoryIndex === !0 && (t.removeDirectoryIndex = [
        /^index\.[a-z]+$/
    ]), Array.isArray(t.removeDirectoryIndex) && t.removeDirectoryIndex.length > 0) {
        let o = i.pathname.split("/"), a = o[o.length - 1];
        ZL(a, t.removeDirectoryIndex) && (o = o.slice(0, -1), i.pathname = o.slice(1).join("/") + "/");
    }
    if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), t.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(t.removeQueryParameters)) for (let o of [
        ...i.searchParams.keys()
    ])ZL(o, t.removeQueryParameters) && i.searchParams.delete(o);
    if (t.removeQueryParameters === !0 && (i.search = ""), t.sortQueryParameters) {
        i.searchParams.sort();
        try {
            i.search = decodeURIComponent(i.search);
        } catch  {}
    }
    t.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, ""));
    let s = n1;
    return n1 = i.toString(), !t.removeSingleSlash && i.pathname === "/" && !s.endsWith("/") && i.hash === "" && (n1 = n1.replace(/\/$/, "")), (t.removeTrailingSlash || i.pathname === "/") && i.hash === "" && t.removeSingleSlash && (n1 = n1.replace(/\/$/, "")), e && !t.normalizeProtocol && (n1 = n1.replace(/^http:\/\//, "//")), t.stripProtocol && (n1 = n1.replace(/^(?:https?:)?\/\//, "")), n1;
}
var Zx = class {
    constructor({ url: t, context: e }, r, i, s){
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        if (!t) throw new Error("Missing property");
        this.url = t.startsWith("mailto:") ? t : H_(t, {
            removeTrailingSlash: !1,
            removeSingleSlash: !1
        }), this.context = e ?? "tab";
    }
    dispatch() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        Md ? window.location.assign(this.url) : (this.context === "tab" ? window.open(this.url, "_blank") : this.context === "window" ? window.open(this.url, "_blank", `width=${window.innerWidth}, height=${window.innerHeight}`) : window.open(this.url, "_parent"), this.controlsManager.orbitControls?.onPointerUp(Ye[0]), w2());
    }
};
var Qm = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        this.timeoutIdQueue = [];
        this.dispatchInner = ()=>{
            this.objects.forEach(this.destroyCallback);
        };
        this.destroyCallback = (t)=>{
            this.timeoutIdQueue.shift();
            let e = this.page.scene.find(t);
            if (e === void 0) return;
            let r = this.controlsManager.sharedGameControlGlobals.rapierWorld, i = r ? e.dataPatched.physics?.fusedBody : !0;
            if (e.cloner) {
                for (let s of e.cloner.children)i ? (s.playModeVisible = !1, s.rigidBody && e.dataPatched.physics?.rigidBody === "positioned" && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s.rigidBody.collider(0).handle), r.removeRigidBody(s.rigidBody), s.rigidBody = void 0), s.bvhGeometry && (s.bvhGeometry = void 0)) : this.clone === void 0 || this.clone === s ? (s.playModeVisible = !1, s.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s.rigidBody.collider(0).handle), r.removeRigidBody(s.rigidBody), s.rigidBody = void 0)) : s.playModeVisible === void 0 && (s.playModeVisible = !0);
                (i || this.clone === void 0 || this.clone === !1) && (e.visible = !1, e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0));
            } else e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0), e.visible = !1;
            r === void 0 ? this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.bvhGeometry !== void 0) : this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.rigidBody !== void 0), e.destroyedInAction = !0, this.controlsManager.requestRender();
        };
        this.objects = [
            ...t.objects
        ];
    }
    dispatch(t) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.clone = t, this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
    }
    dispatchFromStart() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
    }
    dispose() {
        this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t));
    }
};
var Km = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.eventManager = i;
        this.condition = s;
        this.shared = r;
    }
    dispatch() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        clearTimeout(this.timeoutId), delete this.timeoutId, this.timeoutId = window.setTimeout(()=>{
            this.shared.reset(this.shared.data, !0), If(this.page, this.shared, !0), this.eventManager.reset(), this.eventManager.controlsManager.gameControl?.reset(!0), this.page.switchToPlayCamera(), this.eventManager.controlsManager.requestRender(), delete this.timeoutId;
        }, (this.data.delay ?? 0) * 1e3);
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
};
var iB = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    timelineChangeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0,
    rewind: !0
}, X_ = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    startOnceDelay: 0,
    pingPongDelayCorrection: 0,
    pingPongEndDelayCorrection: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, yK = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], $x = {
    CSS: {},
    springs: {}
};
function eo(n1, t, e) {
    return Math.min(Math.max(n1, t), e);
}
function Zm(n1, t) {
    return n1.indexOf(t) > -1;
}
function W_(n1, t) {
    return n1.apply(null, t);
}
var st = {
    arr: function(n1) {
        return Array.isArray(n1);
    },
    obj: function(n1) {
        return Zm(Object.prototype.toString.call(n1), "Object");
    },
    pth: function(n1) {
        return st.obj(n1) && n1.hasOwnProperty("totalLength");
    },
    svg: function(n1) {
        return n1 instanceof SVGElement;
    },
    inp: function(n1) {
        return n1 instanceof HTMLInputElement;
    },
    dom: function(n1) {
        return !("isNode" in n1) && (n1.nodeType || st.svg(n1));
    },
    str: function(n1) {
        return typeof n1 == "string";
    },
    fnc: function(n1) {
        return typeof n1 == "function";
    },
    und: function(n1) {
        return typeof n1 > "u";
    },
    hex: function(n1) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n1);
    },
    rgb: function(n1) {
        return /^rgb/.test(n1);
    },
    hsl: function(n1) {
        return /^hsl/.test(n1);
    },
    col: function(n1) {
        return st.hex(n1) || st.rgb(n1) || st.hsl(n1);
    },
    key: function(n1) {
        return !iB.hasOwnProperty(n1) && !X_.hasOwnProperty(n1) && n1 !== "targets" && n1 !== "keyframes";
    }
};
function nB(n1) {
    var t = /\(([^)]+)\)/.exec(n1);
    return t ? t[1].split(",").map(function(e) {
        return parseFloat(e);
    }) : [];
}
function sB(n1, t) {
    var e = nB(n1), r = eo(st.und(e[0]) ? 1 : e[0], .1, 100), i = eo(st.und(e[1]) ? 100 : e[1], .1, 100), s = eo(st.und(e[2]) ? 10 : e[2], .1, 100), o = eo(st.und(e[3]) ? 0 : e[3], .1, 100), a = Math.sqrt(i / r), l = s / (2 * Math.sqrt(i * r)), u = l < 1 ? a * Math.sqrt(1 - l * l) : 0, c = 1, d = l < 1 ? (l * a + -o) / u : -o + a;
    function h(p) {
        var m = t ? t * p / 1e3 : p;
        return l < 1 ? m = Math.exp(-m * l * a) * (c * Math.cos(u * m) + d * Math.sin(u * m)) : m = (c + d * m) * Math.exp(-m * a), p === 0 || p === 1 ? p : 1 - m;
    }
    function f() {
        var p = $x.springs[n1];
        if (p) return p;
        for(var m = 1 / 6, g = 0, y = 0;;)if (g += m, h(g) === 1) {
            if (y++, y >= 16) break;
        } else y = 0;
        var v = g * m * 1e3;
        return $x.springs[n1] = v, v;
    }
    return t ? h : f;
}
function vK(n1) {
    return n1 === void 0 && (n1 = 10), function(t) {
        return Math.ceil(eo(t, 1e-6, 1) * n1) * (1 / n1);
    };
}
var xK = function() {
    var n1 = 11, t = 1 / (n1 - 1);
    function e(c, d) {
        return 1 - 3 * d + 3 * c;
    }
    function r(c, d) {
        return 3 * d - 6 * c;
    }
    function i(c) {
        return 3 * c;
    }
    function s(c, d, h) {
        return ((e(d, h) * c + r(d, h)) * c + i(d)) * c;
    }
    function o(c, d, h) {
        return 3 * e(d, h) * c * c + 2 * r(d, h) * c + i(d);
    }
    function a(c, d, h, f, p) {
        var m, g, y = 0;
        do g = d + (h - d) / 2, m = s(g, f, p) - c, m > 0 ? h = g : d = g;
        while (Math.abs(m) > 1e-7 && ++y < 10);
        return g;
    }
    function l(c, d, h, f) {
        for(var p = 0; p < 4; ++p){
            var m = o(d, h, f);
            if (m === 0) return d;
            var g = s(d, h, f) - c;
            d -= g / m;
        }
        return d;
    }
    function u(c, d, h, f) {
        if (!(0 <= c && c <= 1 && 0 <= h && h <= 1)) return;
        var p = new Float32Array(n1);
        if (c !== d || h !== f) for(var m = 0; m < n1; ++m)p[m] = s(m * t, c, h);
        function g(y) {
            for(var v = 0, x = 1, S = n1 - 1; x !== S && p[x] <= y; ++x)v += t;
            --x;
            var w = (y - p[x]) / (p[x + 1] - p[x]), A = v + w * t, E = o(A, c, h);
            return E >= .001 ? l(y, A, c, h) : E === 0 ? A : a(y, v, v + t, c, h);
        }
        return function(y) {
            return c === d && h === f || y === 0 || y === 1 ? y : s(g(y), d, f);
        };
    }
    return u;
}(), oB = function() {
    var n1 = {
        linear: function() {
            return function(r) {
                return r;
            };
        }
    }, t = {
        Sine: function() {
            return function(r) {
                return 1 - Math.cos(r * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(r) {
                return 1 - Math.sqrt(1 - r * r);
            };
        },
        Back: function() {
            return function(r) {
                return r * r * (3 * r - 2);
            };
        },
        Bounce: function() {
            return function(r) {
                for(var i, s = 4; r < ((i = Math.pow(2, --s)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - s) - 7.5625 * Math.pow((i * 3 - 2) / 22 - r, 2);
            };
        },
        Elastic: function(r, i) {
            r === void 0 && (r = 1), i === void 0 && (i = .5);
            var s = eo(r, 1, 10), o = eo(i, .1, 2);
            return function(a) {
                return a === 0 || a === 1 ? a : -s * Math.pow(2, 10 * (a - 1)) * Math.sin((a - 1 - o / (Math.PI * 2) * Math.asin(1 / s)) * (Math.PI * 2) / o);
            };
        }
    }, e = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint",
        "Expo"
    ];
    return e.forEach(function(r, i) {
        t[r] = function() {
            return function(s) {
                return Math.pow(s, i + 2);
            };
        };
    }), Object.keys(t).forEach(function(r) {
        var i = t[r];
        n1["easeIn" + r] = i, n1["easeOut" + r] = function(s, o) {
            return function(a) {
                return 1 - i(s, o)(1 - a);
            };
        }, n1["easeInOut" + r] = function(s, o) {
            return function(a) {
                return a < .5 ? i(s, o)(a * 2) / 2 : 1 - i(s, o)(a * -2 + 2) / 2;
            };
        };
    }), n1;
}();
function Q_(n1, t) {
    if (st.fnc(n1)) return n1;
    var e = n1.split("(")[0], r = oB[e], i = nB(n1);
    switch(e){
        case "spring":
            return sB(n1, t);
        case "cubicBezier":
            return W_(xK, i);
        case "steps":
            return W_(vK, i);
        default:
            return W_(r, i);
    }
}
function aB(n1) {
    try {
        var t = document.querySelectorAll(n1);
        return t;
    } catch  {
        return;
    }
}
function eb(n1, t) {
    for(var e = n1.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], s = 0; s < e; s++)if (s in n1) {
        var o = n1[s];
        t.call(r, o, s, n1) && i.push(o);
    }
    return i;
}
function tb(n1) {
    return n1.reduce(function(t, e) {
        return t.concat(st.arr(e) ? tb(e) : e);
    }, []);
}
function JL(n1) {
    return st.arr(n1) ? n1 : (st.str(n1) && (n1 = aB(n1) || n1), n1 instanceof NodeList || n1 instanceof HTMLCollection ? [].slice.call(n1) : [
        n1
    ]);
}
function K_(n1, t) {
    return n1.some(function(e) {
        return e === t;
    });
}
function Z_(n1) {
    var t = {};
    for(var e in n1)t[e] = n1[e];
    return t;
}
function q_(n1, t) {
    var e = Z_(n1);
    for(var r in n1)e[r] = t.hasOwnProperty(r) ? t[r] : n1[r];
    return e;
}
function rb(n1, t) {
    var e = Z_(n1);
    for(var r in t)e[r] = st.und(n1[r]) ? t[r] : n1[r];
    return e;
}
function bK(n1) {
    var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n1);
    return t ? "rgba(" + t[1] + ",1)" : n1;
}
function SK(n1) {
    var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, e = n1.replace(t, function(a, l, u, c) {
        return l + l + u + u + c + c;
    }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), i = parseInt(r[1], 16), s = parseInt(r[2], 16), o = parseInt(r[3], 16);
    return "rgba(" + i + "," + s + "," + o + ",1)";
}
function wK(n1) {
    var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(n1) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(n1), e = parseInt(t[1], 10) / 360, r = parseInt(t[2], 10) / 100, i = parseInt(t[3], 10) / 100, s = t[4] || 1;
    function o(h, f, p) {
        return p < 0 && (p += 1), p > 1 && (p -= 1), p < 1 / 6 ? h + (f - h) * 6 * p : p < 0.5 ? f : p < 2 / 3 ? h + (f - h) * (2 / 3 - p) * 6 : h;
    }
    var a, l, u;
    if (r == 0) a = l = u = i;
    else {
        var c = i < .5 ? i * (1 + r) : i + r - i * r, d = 2 * i - c;
        a = o(d, c, e + 1 / 3), l = o(d, c, e), u = o(d, c, e - 1 / 3);
    }
    return "rgba(" + a * 255 + "," + l * 255 + "," + u * 255 + "," + s + ")";
}
function AK(n1) {
    if (st.rgb(n1)) return bK(n1);
    if (st.hex(n1)) return SK(n1);
    if (st.hsl(n1)) return wK(n1);
}
function Ba(n1) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(n1);
    if (t) return t[1];
}
function _K(n1) {
    if (Zm(n1, "translate") || n1 === "perspective") return "px";
    if (Zm(n1, "rotate") || Zm(n1, "skew")) return "deg";
}
function Y_(n1, t) {
    return st.fnc(n1) ? n1(t.target, t.id, t.total) : n1;
}
function Go(n1, t) {
    return n1.getAttribute(t);
}
function J_(n1, t, e) {
    var r = Ba(t);
    if (K_([
        e,
        "deg",
        "rad",
        "turn"
    ], r)) return t;
    var i = $x.CSS[t + e];
    if (!st.und(i)) return i;
    var s = 100, o = document.createElement(n1.tagName), a = n1.parentNode && n1.parentNode !== document ? n1.parentNode : document.body;
    a.appendChild(o), o.style.position = "absolute", o.style.width = s + e;
    var l = s / o.offsetWidth;
    a.removeChild(o);
    var u = l * parseFloat(t);
    return $x.CSS[t + e] = u, u;
}
function lB(n1, t, e) {
    if (t in n1.style) {
        var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = n1.style[t] || getComputedStyle(n1).getPropertyValue(r) || "0";
        return e ? J_(n1, i, e) : i;
    }
}
function $_(n1, t) {
    if (st.dom(n1) && !st.inp(n1) && (Go(n1, t) || st.svg(n1) && n1[t])) return "attribute";
    if (st.dom(n1) && K_(yK, t)) return "transform";
    if (st.dom(n1) && t !== "transform" && lB(n1, t)) return "css";
    if (n1[t] != null) return "object";
}
function cB(n1) {
    if (!!st.dom(n1)) {
        for(var t = n1.style.transform || "", e = /(\w+)\(([^)]*)\)/g, r = new Map, i; i = e.exec(t);)r.set(i[1], i[2]);
        return r;
    }
}
function EK(n1, t, e, r) {
    var i = Zm(t, "scale") ? 1 : 0 + _K(t), s = cB(n1).get(t) || i;
    return e && (e.transforms.list.set(t, s), e.transforms.last = t), r ? J_(n1, s, r) : s;
}
function eE(n1, t, e, r) {
    switch($_(n1, t)){
        case "transform":
            return EK(n1, t, r, e);
        case "css":
            return lB(n1, t, e);
        case "attribute":
            return Go(n1, t);
        default:
            return n1[t] || 0;
    }
}
function tE(n1, t) {
    var e = /^(\*=|\+=|-=)/.exec(n1);
    if (!e) return n1;
    var r = Ba(n1) || 0, i = parseFloat(t), s = parseFloat(n1.replace(e[0], ""));
    switch(e[0][0]){
        case "+":
            return i + s + r;
        case "-":
            return i - s + r;
        case "*":
            return i * s + r;
    }
}
function uB(n1, t) {
    if (st.col(n1)) return AK(n1);
    if (/\s/g.test(n1)) return n1;
    var e = Ba(n1), r = e ? n1.substr(0, n1.length - e.length) : n1;
    return t ? r + t : r;
}
function rE(n1, t) {
    return Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2));
}
function TK(n1) {
    return Math.PI * 2 * Go(n1, "r");
}
function MK(n1) {
    return Go(n1, "width") * 2 + Go(n1, "height") * 2;
}
function CK(n1) {
    return rE({
        x: Go(n1, "x1"),
        y: Go(n1, "y1")
    }, {
        x: Go(n1, "x2"),
        y: Go(n1, "y2")
    });
}
function dB(n1) {
    for(var t = n1.points, e = 0, r, i = 0; i < t.numberOfItems; i++){
        var s = t.getItem(i);
        i > 0 && (e += rE(r, s)), r = s;
    }
    return e;
}
function PK(n1) {
    var t = n1.points;
    return dB(n1) + rE(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function hB(n1) {
    if (n1.getTotalLength) return n1.getTotalLength();
    switch(n1.tagName.toLowerCase()){
        case "circle":
            return TK(n1);
        case "rect":
            return MK(n1);
        case "line":
            return CK(n1);
        case "polyline":
            return dB(n1);
        case "polygon":
            return PK(n1);
    }
}
function DK(n1) {
    var t = hB(n1);
    return n1.setAttribute("stroke-dasharray", t), t;
}
function OK(n1) {
    for(var t = n1.parentNode; st.svg(t) && st.svg(t.parentNode);)t = t.parentNode;
    return t;
}
function fB(n1, t) {
    var e = t || {}, r = e.el || OK(n1), i = r.getBoundingClientRect(), s = Go(r, "viewBox"), o = i.width, a = i.height, l = e.viewBox || (s ? s.split(" ") : [
        0,
        0,
        o,
        a
    ]);
    return {
        el: r,
        viewBox: l,
        x: l[0] / 1,
        y: l[1] / 1,
        w: o / l[2],
        h: a / l[3]
    };
}
function IK(n1, t) {
    var e = st.str(n1) ? aB(n1)[0] : n1, r = t || 100;
    return function(i) {
        return {
            property: i,
            el: e,
            svg: fB(e),
            totalLength: hB(e) * (r / 100)
        };
    };
}
function RK(n1, t) {
    function e(a) {
        a === void 0 && (a = 0);
        var l = t + a >= 1 ? t + a : 0;
        return n1.el.getPointAtLength(l);
    }
    var r = fB(n1.el, n1.svg), i = e(), s = e(-1), o = e(1);
    switch(n1.property){
        case "x":
            return (i.x - r.x) * r.w;
        case "y":
            return (i.y - r.y) * r.h;
        case "angle":
            return Math.atan2(o.y - s.y, o.x - s.x) * 180 / Math.PI;
    }
}
function $L(n1, t) {
    var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = uB(st.pth(n1) ? n1.totalLength : n1, t) + "";
    return {
        original: r,
        numbers: r.match(e) ? r.match(e).map(Number) : [
            0
        ],
        strings: st.str(n1) || t ? r.split(e) : []
    };
}
function pB(n1) {
    var t = n1 ? tb(st.arr(n1) ? n1.map(JL) : JL(n1)) : [];
    return eb(t, function(e, r, i) {
        return i.indexOf(e) === r;
    });
}
function mB(n1) {
    var t = pB(n1);
    return t.map(function(e, r) {
        return {
            target: e,
            id: r,
            total: t.length,
            transforms: {
                list: cB(e)
            }
        };
    });
}
function LK(n1, t) {
    var e = Z_(t);
    if (/^spring/.test(e.easing) && (e.duration = sB(e.easing)), st.arr(n1)) {
        var r = n1.length, i = r === 2 && !st.obj(n1[0]);
        i ? n1 = {
            value: n1
        } : st.fnc(t.duration) || (e.duration = t.duration / r);
    }
    var s = st.arr(n1) ? n1 : [
        n1
    ];
    return s.map(function(o, a) {
        var l = st.obj(o) && !st.pth(o) ? o : {
            value: o
        };
        return st.und(l.delay) && (l.delay = a ? 0 : t.delay), st.und(l.endDelay) && (l.endDelay = a === s.length - 1 ? t.endDelay : 0), l;
    }).map(function(o) {
        return rb(o, e);
    });
}
function BK(n1) {
    for(var t = eb(tb(n1.map(function(s) {
        return Object.keys(s);
    })), function(s) {
        return st.key(s);
    }).reduce(function(s, o) {
        return s.indexOf(o) < 0 && s.push(o), s;
    }, []), e = {}, r = function(s) {
        var o = t[s];
        e[o] = n1.map(function(a) {
            var l = {};
            for(var u in a)st.key(u) ? u == o && (l.value = a[u]) : l[u] = a[u];
            return l;
        });
    }, i = 0; i < t.length; i++)r(i);
    return e;
}
function NK(n1, t) {
    var e = [], r = t.keyframes;
    r && (t = rb(BK(r), t));
    for(var i in t)st.key(i) && e.push({
        name: i,
        tweens: LK(t[i], n1)
    });
    return e;
}
function FK(n1, t) {
    var e = {};
    for(var r in n1){
        var i = Y_(n1[r], t);
        st.arr(i) && (i = i.map(function(s) {
            return Y_(s, t);
        }), i.length === 1 && (i = i[0])), e[r] = i;
    }
    return e.duration = parseFloat(e.duration), e.delay = parseFloat(e.delay), e;
}
function kK(n1, t) {
    var e;
    return n1.tweens.map(function(r) {
        var i = FK(r, t), s = i.value, o = st.arr(s) ? s[1] : s, a = Ba(o), l = eE(t.target, n1.name, a, t), u = e ? e.to.original : l, c = st.arr(s) ? s[0] : u, d = Ba(c) || Ba(l), h = a || d;
        return st.und(o) && (o = u), i.from = $L(c, h), i.to = $L(tE(o, c), h), i.start = e ? e.end : 0, i.end = i.start + i.delay + i.duration + i.endDelay, i.easing = Q_(i.easing, i.duration), i.isPath = st.pth(s), i.isColor = st.col(i.from.original), i.isColor && (i.round = 1), e = i, i;
    });
}
var gB = {
    css: function(n1, t, e) {
        return n1.style[t] = e;
    },
    attribute: function(n1, t, e) {
        return n1.setAttribute(t, e);
    },
    object: function(n1, t, e) {
        return n1[t] = e;
    },
    transform: function(n1, t, e, r, i) {
        if (r.list.set(t, e), t === r.last || i) {
            var s = "";
            r.list.forEach(function(o, a) {
                s += a + "(" + o + ") ";
            }), n1.style.transform = s;
        }
    }
};
function yB(n1, t) {
    var e = mB(n1);
    e.forEach(function(r) {
        for(var i in t){
            var s = Y_(t[i], r), o = r.target, a = Ba(s), l = eE(o, i, a, r), u = a || Ba(l), c = tE(uB(s, u), l), d = $_(o, i);
            gB[d](o, i, c, r.transforms, !0);
        }
    });
}
function zK(n1, t) {
    var e = $_(n1.target, t.name);
    if (e) {
        var r = kK(t, n1), i = r[r.length - 1];
        return {
            type: e,
            property: t.name,
            animatable: n1,
            tweens: r,
            duration: i.end,
            delay: r[0].delay,
            endDelay: i.endDelay
        };
    }
}
function VK(n1, t) {
    return eb(tb(n1.map(function(e) {
        return t.map(function(r) {
            return zK(e, r);
        });
    })), function(e) {
        return !st.und(e);
    });
}
function vB(n1, t) {
    var e = n1.length, r = function(s) {
        return s.timelineOffset ? s.timelineOffset : 0;
    }, i = {};
    return i.duration = e ? Math.max.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return r(s) + o + a + l + s.duration * (s.loop ?? 1);
    })) : t.duration, i.delay = e ? Math.min.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0;
        return r(s) + o + a + s.delay;
    })) : t.delay, i.endDelay = e ? i.duration - Math.max.apply(Math, n1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return r(s) + o + a + s.duration * (s.loop ?? 1) - s.endDelay - l;
    })) : t.endDelay, i;
}
var eB = 0;
function UK(n1) {
    var t = q_(iB, n1), e = q_(X_, n1), r = NK(e, n1), i = mB(n1.targets), s = VK(i, r), o = vB(s, e), a = eB;
    return eB++, rb(t, {
        id: a,
        children: [],
        animatables: i,
        animations: s,
        duration: o.duration,
        delay: o.delay,
        endDelay: o.endDelay,
        startOnceDelay: e.startOnceDelay,
        pingPongDelayCorrection: e.pingPongDelayCorrection,
        pingPongEndDelayCorrection: e.pingPongEndDelayCorrection
    });
}
var _s = [], tB = [], Jx, GK = function() {
    function n1() {
        Jx = requestAnimationFrame(t);
    }
    function t(e) {
        var r = _s.length;
        if (r) {
            for(var i = 0; i < r;){
                var s = _s[i];
                s.paused ? (_s.splice(i, 1), r -= 1) : (s.tick(e), i++);
            }
            n1();
        } else Jx = cancelAnimationFrame(Jx);
    }
    return n1;
}();
function jK(n1) {
    document.hidden ? (_s.forEach(function(t) {
        return t.pause(n1.timeStamp);
    }), tB = _s.slice(0), $r.running = _s = []) : tB.forEach(function(t) {
        return t.play(n1.timeStamp);
    });
}
typeof document < "u" && document.addEventListener("visibilitychange", jK);
function $r(n1) {
    n1 === void 0 && (n1 = {});
    var t = 0, e = 0, r = 0, i, s, o = 0, a = null;
    function l(E) {
        var b = window.Promise && new Promise(function(T) {
            return a = T;
        });
        return E.finished = b, b;
    }
    var u = UK(n1), c = l(u);
    function d() {
        var E = u.direction;
        E !== "alternate" && (u.direction = E !== "normal" ? "normal" : "reverse"), u.reversed = !u.reversed, s.forEach(function(b) {
            (b.loop === 1 || b.loop % 2 === 0) && (b.reversed = u.reversed);
        });
    }
    function h() {
        u.direction = "normal", u.reversed = !1, s.forEach(function(E) {
            return E.reversed = !1;
        });
    }
    function f(E) {
        return u.reversed ? u.duration - E : E;
    }
    function p() {
        t = 0, e = f(u.currentTime) * (1 / $r.speed);
    }
    function m(E, b, T = !1) {
        b && (u.reversed ? b.seek(b.duration * b.loop - (E - b.timelineOffset - b.pingPongDelayCorrection), T) : b.seek(E - b.timelineOffset - b.startOnceDelay - b.pingPongDelayCorrection, T));
    }
    function g(E, b = !1) {
        if (u.reversed) for(var M = o; M--;)m(E, s[M], b);
        else for(var T = 0; T < o; T++)m(E, s[T], b);
    }
    function y(E) {
        var b = 0, T = u.animations, M = T.length;
        for(u.direction !== "alternate" && u.parent?.direction === "alternate" ? u.parent?.rewind === !1 && u.reversePlayback === !0 && u.rewind === !1 && (u.parent?.reversed && u.direction === "alternate" ? E = u.duration - u.delay + u.endDelay - E : E = u.duration + u.delay - u.endDelay - E) : w(!1, u.parent?.rewind, u.rewind, u.parent?.reversePlayback, u.reversePlayback) && (u.parent?.reversed && u.direction === "alternate" ? E = u.duration - u.delay + u.endDelay - E : E = u.duration + u.delay - u.endDelay - E); b < M;){
            var C = T[b], P = C.animatable, D = C.tweens, O = D.length - 1, I = D[O];
            O && (I = eb(D, function(Y) {
                return E < Y.end;
            })[0] || I);
            let K;
            u.parent?.reversed && u.direction === "alternate" ? K = eo(E - I.start - I.endDelay, 0, I.duration) / I.duration : K = eo(E - I.start - I.delay, 0, I.duration) / I.duration;
            for(var z = isNaN(K) ? 1 : I.easing(K), B = I.to.strings, V = I.round, U = [], j = I.to.numbers.length, W = void 0, k = 0; k < j; k++){
                var H = void 0;
                let Y, ye;
                u.direction !== "alternate" ? u.parent?.rewind === !1 && u.reversePlayback === !0 && u.rewind === !1 ? (Y = I.to.numbers[k], ye = I.from.numbers[k] || 0) : (ye = I.to.numbers[k], Y = I.from.numbers[k] || 0) : w(!0, u.parent?.rewind, u.rewind, u.parent?.reversePlayback, u.reversePlayback) ? (Y = I.to.numbers[k], ye = I.from.numbers[k] || 0) : (ye = I.to.numbers[k], Y = I.from.numbers[k] || 0), I.isPath ? H = RK(I.value, z * ye) : H = Y + z * (ye - Y), V && (I.isColor && k > 2 || (H = Math.round(H * V) / V)), U.push(H);
            }
            var X = B.length;
            if (!X) W = U[0];
            else {
                W = B[0];
                for(var q = 0; q < X; q++){
                    var G = B[q], J = B[q + 1], Z = U[q];
                    isNaN(Z) || (J ? W += Z + J : W += Z + " ");
                }
            }
            gB[C.type](P.target, C.property, W, P.transforms), C.currentValue = W, b++;
        }
    }
    function v(E) {
        u[E] && !u.passThrough && u[E](u);
    }
    function x() {
        u.remaining && u.remaining !== !0 && u.remaining--;
    }
    let S = {
        0: !1,
        1: !0,
        2: !1,
        3: !0,
        4: !1,
        5: !1,
        6: !1,
        7: !1,
        8: !1,
        9: !0,
        10: !0,
        11: !1,
        12: !1,
        13: !1,
        14: !0,
        15: !0,
        16: !1,
        17: !0,
        18: !0,
        19: !1,
        20: !1,
        21: !1,
        22: !0,
        23: !0,
        24: !1,
        25: !0,
        26: !1,
        27: !0,
        28: !1,
        29: !1,
        30: !1,
        31: !1
    };
    function w(E, b, T, M, C) {
        return S[E << 4 | b << 3 | T << 2 | M << 1 | C];
    }
    function A(E, b = !1) {
        var T = u.duration;
        let M = u.delay, C = T - u.endDelay;
        u.parent?.reversed && u.direction === "alternate" && (M = u.endDelay, C = T - u.delay);
        var P = f(E);
        if (u.progress = eo(P / T * 100, 0, 100), b || (u.reversePlayback = P < u.currentTime), o && g(P, b), !u.began && u.currentTime >= 0 && (u.began = !0, v("begin")), !u.loopBegan && u.currentTime > 0 && (u.loopBegan = !0, v("loopBegin")), (u.reversed || P >= 0) && P <= M && u.currentTime !== 0 && (y(0), v("change")), (P >= C && u.currentTime !== T + u.pingPongDelayCorrection || !T) && (y(T), v("change")), P > M && P < C ? (u.changeBegan || (u.changeBegan = !0, u.changeCompleted = !1, v("changeBegin")), y(P), v("change")) : u.changeBegan ? (u.changeCompleted = !0, u.changeBegan = !1, v("change"), o && v("timelineChangeComplete")) : u.began && P > C && v("changeComplete"), u.currentTime = eo(P, 0, T + u.pingPongDelayCorrection), u.began && v("update"), E >= T) {
            if (x(), !u.remaining) u.paused = !0, u.completed || (u.completed = !0, v("loopComplete"), v("complete"), !u.passThrough && "Promise" in window && (a(), c = l(u)));
            else {
                o ? t += u.duration / $r.speed : t += u.duration;
                for (let D of s)D.setStartTime(0), D.remaining = D.loop;
                v("loopComplete"), u.loopBegan = !1, u.direction === "alternate" ? d() : o && h();
            }
        }
    }
    return u.reset = function() {
        var E = u.direction;
        u.passThrough = !1, u.currentTime = 0, u.progress = 0, u.paused = !0, u.began = !1, u.loopBegan = !1, u.changeBegan = !1, u.completed = !1, u.changeCompleted = !1, u.reversePlayback = !1, u.reversed = E === "reverse", u.remaining = u.loop, s = u.children, o = s.length;
        for(var b = o; b--;)u.children[b].reset();
        y(u.reversed ? u.duration : 0);
    }, u.setStartTime = function(E) {
        t = E;
    }, u.set = function(E, b) {
        return yB(E, b), u;
    }, u.tick = function(E) {
        r = E, t || (t = r), A((r + (e - t)) * $r.speed);
    }, u.seek = function(E, b = !1) {
        A(E - t, b);
    }, u.pause = function(E) {
        u.paused = !0, o && (i = E ?? performance.now());
    }, u.play = function(E) {
        !u.paused || (u.completed && u.reset(), u.paused = !1, _s.push(u), o && i !== void 0 && (t += (E ?? performance.now()) - i), Jx || GK());
    }, u.reverse = function() {
        d(), u.completed = !u.reversed, p();
    }, u.restart = function() {
        u.reset(), u.play();
    }, u.reset(), u.autoplay && u.play(), u;
}
function rB(n1, t) {
    for(var e = t.length; e--;)K_(n1, t[e].animatable.target) && t.splice(e, 1);
}
function HK(n1) {
    for(var t = pB(n1), e = _s.length; e--;){
        var r = _s[e], i = r.animations, s = r.children;
        rB(t, i);
        for(var o = s.length; o--;){
            var a = s[o], l = a.animations;
            rB(t, l), !l.length && !a.children.length && s.splice(o, 1);
        }
        !i.length && !s.length && r.pause();
    }
}
function WK(n1, t) {
    t === void 0 && (t = {});
    var e = t.direction || "normal", r = t.easing ? Q_(t.easing) : null, i = t.grid, s = t.axis, o = t.from || 0, a = o === "first", l = o === "center", u = o === "last", c = st.arr(n1), d = parseFloat(c ? n1[0] : n1), h = c ? parseFloat(n1[1]) : 0, f = Ba(c ? n1[1] : n1) || 0, p = t.start || 0 + (c ? d : 0), m = [], g = 0;
    return function(y, v, x) {
        if (a && (o = 0), l && (o = (x - 1) / 2), u && (o = x - 1), !m.length) {
            for(var S = 0; S < x; S++){
                if (!i) m.push(Math.abs(o - S));
                else {
                    var w = l ? (i[0] - 1) / 2 : o % i[0], A = l ? (i[1] - 1) / 2 : Math.floor(o / i[0]), E = S % i[0], b = Math.floor(S / i[0]), T = w - E, M = A - b, C = Math.sqrt(T * T + M * M);
                    s === "x" && (C = -T), s === "y" && (C = -M), m.push(C);
                }
                g = Math.max.apply(Math, m);
            }
            r && (m = m.map(function(D) {
                return r(D / g) * g;
            })), e === "reverse" && (m = m.map(function(D) {
                return s ? D < 0 ? D * -1 : -D : Math.abs(g - D);
            }));
        }
        var P = c ? (h - d) / g : d;
        return p + P * (Math.round(m[v] * 100) / 100) + f;
    };
}
function qK(n1) {
    n1 === void 0 && (n1 = {});
    var t = $r(n1);
    return t.duration = 0, t.add = function(e, r) {
        var i = _s.indexOf(t), s = t.children;
        i > -1 && _s.splice(i, 1);
        function o(h) {
            h.passThrough = !0;
        }
        for(var a = 0; a < s.length; a++)o(s[a]);
        var l = rb(e, q_(X_, n1));
        l.targets = l.targets || n1.targets;
        var u = t.duration;
        l.autoplay = !1, l.timelineOffset = st.und(r) ? u : tE(r, u), o(t);
        var c = $r(l);
        o(c), s.push(c), c.parent = t;
        var d = vB(s, n1);
        return t.delay = d.delay, t.endDelay = d.endDelay, t.duration = d.duration, c.loop === !0 && (t.duration = 1 / 0), t.seek(0), t.reset(), t.autoplay && t.play(), t;
    }, t;
}
$r.version = "3.2.0";
$r.speed = 1;
$r.running = _s;
$r.remove = HK;
$r.get = eE;
$r.set = yB;
$r.convertPx = J_;
$r.path = IK;
$r.setDashoffset = DK;
$r.stagger = WK;
$r.timeline = qK;
$r.easing = Q_;
$r.penner = oB;
$r.random = function(n1, t) {
    return Math.floor(Math.random() * (t - n1 + 1)) + n1;
};
var ib = $r;
var xB = new _, bB = new _, SB = new je;
function AB(n1, t, e, r) {
    if (r === 0) return e.copy(n1);
    if (r === 1) return e.copy(t);
    let i = n1.w * t.w + n1.x * t.x + n1.y * t.y + n1.z * t.z;
    if (i >= 1) return e.copy(n1);
    let s = 1 - i * i;
    if (s <= Number.EPSILON) {
        let c = 1 - r;
        return e.w = c * n1.w + r * t.w, e.x = c * n1.x + r * t.x, e.y = c * n1.y + r * t.y, e.z = c * n1.z + r * t.z, e.normalize(), e;
    }
    let o = Math.sqrt(s), a = Math.atan2(o, i), l = Math.sin((1 - r) * a) / o, u = Math.sin(r * a) / o;
    return e.w = n1.w * l + t.w * u, e.x = n1.x * l + t.x * u, e.y = n1.y * l + t.y * u, e.z = n1.z * l + t.z * u, e;
}
function Gr(n1, t, e, r, i, s) {
    let o = e[n1] ? e[n1] : void 0, a = r[n1];
    if (a == null) return;
    let l = o != null ? typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o : t[n1], u = typeof a == "string" ? Number(i.getVariable(a) ?? 0) : a;
    if (l !== u) return {
        update: (c)=>{
            let d = Se.lerp(l, u, c);
            s ? t[n1] = Math.trunc(d) : t[n1] = d;
        },
        start: ()=>{
            t[n1] = l;
        },
        end: ()=>{
            t[n1] = u;
        }
    };
}
function $m(n1, t, e, r, i, s) {
    let o = e[n1] ? e[n1] : void 0, a = r[n1];
    if (!a) return;
    let l = t[n1], u = [
        ...o ?? l
    ].map((d)=>typeof d == "string" ? Number(i.getVariable(d) ?? 0) : d), c = [
        ...a
    ].map((d)=>typeof d == "string" ? Number(i.getVariable(d) ?? 0) : d);
    if (!(u.length !== c.length || Rp(u, c))) return {
        update: (d)=>{
            u.forEach((h, f)=>{
                let p = Se.lerp(h, c[f], d);
                t[n1][f] = s ? Math.trunc(p) : p;
            });
        },
        start: ()=>{
            Object.assign(t[n1], u);
        },
        end: ()=>{
            Object.assign(t[n1], c);
        }
    };
}
function Jm(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function iE(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s ? Jm(new _, s, i) : a.clone(), u = Jm(new _, o, i);
    if (!l.equals(u)) return {
        update: (c)=>{
            a.lerpVectors(l, u, c);
        },
        start: ()=>{
            a.copy(l);
        },
        end: ()=>{
            a.copy(u);
        }
    };
}
function wB(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function eg(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = !(a instanceof N), u = a instanceof N ? a : new N().fromArray(a), c = s ? wB(new N, s, i) : u.clone(), d = wB(new N, o, i);
    if (!c.equals(d)) return {
        update: (h)=>{
            u.lerpVectors(c, d, h), l && (t[n1] = u.toArray());
        },
        start: ()=>{
            u.copy(c), l && (t[n1] = u.toArray());
        },
        end: ()=>{
            u.copy(d), l && (t[n1] = u.toArray());
        }
    };
}
function _B(n1, t, e, r) {
    let i = e[n1] ? e[n1] : void 0, s = r[n1];
    if (!s) return;
    let o = t[n1], a = i ? new te().fromArray(i) : o.clone(), l = new _, u = new je, c = new _;
    a.decompose(l, u, c);
    let d = new te().fromArray(s), h = new _, f = new je, p = new _;
    if (d.decompose(h, f, p), !a.equals(d)) return {
        update: (m)=>{
            SB.slerpQuaternions(u, f, m), xB.lerpVectors(l, h, m), bB.lerpVectors(c, p, m), o.compose(xB, SB, bB);
        },
        start: ()=>{
            o.compose(l, u, c);
        },
        end: ()=>{
            o.compose(h, f, p);
        }
    };
}
function EB(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s ? typeof s == "string" ? i.getColor(s).clone() : new Le().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new Le().setRGB(o.r, o.g, o.b);
    if (l.equals(u)) return;
    let c = a.clone();
    return t[n1] = c, {
        update: (d)=>{
            c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function tg(n1, t, e, r, i) {
    let s = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = new cr(a.r, a.g, a.b, a.a), u = s ? typeof s == "string" ? i.getColor(s).clone() : new cr(s.r, s.g, s.b, s.a) : l.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new cr(o.r, o.g, o.b, o.a);
    if (!u.equals(c)) return {
        update: (d)=>{
            l.lerpColors(u, c, d);
            let h = Se.lerp(u.a, c.a, d);
            l.a = h, t[n1] = {
                r: l.r,
                g: l.g,
                b: l.b,
                a: l.a
            };
        },
        start: ()=>{
            l.copy(u);
        },
        end: ()=>{
            l.copy(c);
        }
    };
}
function jo(n1, t, e, r, i) {
    if (typeof t[n1] == "number") return Gr(n1, t, e ?? {}, r, i);
    if (Array.isArray(t[n1])) return $m(n1, t, e ?? {}, r, i);
}
function TB(n1, t, e, r) {
    let i = [], s = n1.cameraType === "OrthographicCamera" ? t.orthographic?.zoom : t.perspective?.zoom, o = n1.cameraType === "OrthographicCamera" ? e.orthographic?.zoom : e.perspective?.zoom;
    if (o !== void 0) {
        let a = s ?? n1.zoom, l = o;
        a !== l && i.push({
            update: (u)=>{
                n1.zoom = Se.lerp(a, l, u), n1.updateProjectionMatrix();
            },
            start: ()=>{
                n1.zoom = a, n1.updateProjectionMatrix();
            },
            end: ()=>{
                n1.zoom = l, n1.updateProjectionMatrix();
            }
        });
    }
    if (e.targetOffset !== void 0) {
        let a = Gr("targetOffset", n1, t, e, r);
        a && i.push(a);
    }
    return i;
}
function YK(n1, t, e, r) {
    if (e.scaleBaked === void 0) return;
    let i = (t.scaleBaked ?? n1.data.geometry.scaleBaked).map((a)=>typeof a == "string" ? Number(r.getVariable(a) ?? 0) : a), s = e.scaleBaked.map((a)=>typeof a == "string" ? Number(r.getVariable(a) ?? 0) : a);
    if (bo.isEqual(i, s)) return;
    let o = [];
    return o.push({
        update: (a)=>{
            n1.updateGeometryInteractions({
                scaleBaked: [
                    Se.lerp(i[0], s[0], a),
                    Se.lerp(i[1], s[1], a),
                    Se.lerp(i[2], s[2], a)
                ]
            }, r), n1.invalidateDownstreamBooleanData();
        },
        start: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: i
            }, r), n1.invalidateDownstreamBooleanData();
        },
        end: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: s
            }, r), n1.invalidateDownstreamBooleanData();
        }
    }), o;
}
function XK(n1, t, e, r) {
    if (!e.extrusion) return;
    let i = n1.extrusion, s = t.extrusion ?? {}, o = e.extrusion, a = [];
    return c1.forEach((l)=>{
        let u = jo(l, i, s, o, r);
        u && a.push(u);
    }), a;
}
function MB(n1, t, e, r) {
    let i = [];
    if (!("geometry" in e)) return i;
    let s = n1.geometry.userData.parameters, o = "geometry" in t ? t.geometry : {}, a = e.geometry;
    if (n1 instanceof Qs) {
        let l = YK(n1, o, a, r);
        l && i.push(...l);
    } else {
        let l = {};
        if (Object.assign(l, Qn(s, u1)), u1.forEach((u)=>{
            let c = jo(u, l, o, a, r);
            c && i.push(c);
        }), n1 instanceof Hl) {
            Object.assign(l, {
                extrusion: {
                    ...s.extrusion
                }
            });
            let u = XK(l, o, a, r);
            u && i.push(...u);
        }
        i.length && i.push({
            update: (u)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded();
            },
            start: (u)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded();
            },
            end: (u)=>{
                n1.updateGeometryInteractions(l, r), n1.updateGeometryGroupsIfNeeded();
            }
        });
    }
    return i;
}
function CB(n1, t, e, r) {
    let i = [];
    if (e.intensity !== void 0) {
        let s = Gr("intensity", n1, t, e, r);
        s && i.push(s);
    }
    if (e.color !== void 0) {
        let s = EB("color", n1, t, e, r);
        s && i.push(s);
    }
    return i;
}
function DB(n1, t, e, r) {
    let i = [];
    if (Array.isArray(n1.material)) {
        if (!("materials" in e && e.materials)) return i;
        let s = "materials" in t && t.materials ? t.materials : [], o = e.materials;
        n1.material.forEach((a, l)=>{
            if (!o[l]) return;
            let u = s[l] ?? {}, c = o[l];
            typeof u == "string" || typeof c == "string" || i.push(...PB(a, u, c, r));
        });
    } else {
        if (!("material" in e && e.material)) return i;
        let s = "material" in t && t.material ? t.material : {}, o = e.material;
        if (typeof s == "string" || typeof o == "string") return i;
        i.push(...PB(n1.material, s, o, r));
    }
    return i;
}
function PB(n1, t, e, r) {
    let i = [], s = jc(e, r) || !!t.layers && jc(t, r);
    i.push(iZ(n1, s));
    for (let o of n1.layers){
        let a = t.layers?.data(o.uuid), l = e.layers.data(o.uuid);
        if (!l || o.type !== "light" && (!(o.visible ?? !0) || !(l.visible ?? !0))) continue;
        let u = o.getNames().filter((c)=>!kv.some((d)=>c.includes(d)));
        for (let c of u)try {
            let d = o.getValue(c), h;
            if (c === "colors") h = tZ(o, a, l, c);
            else if (Array.isArray(d)) c === "steps" && (h = eZ(o, a, l, c));
            else if (typeof d == "number") h = QK(o, a, l, c, r);
            else {
                if (typeof d == "boolean") continue;
                d instanceof N ? h = KK(o, a, l, c) : d instanceof _ ? h = ZK(o, a, l, c, r) : d instanceof cr ? h = $K(o, a, l, c, r) : d instanceof Le ? h = JK(o, a, l, c, r) : "isTexture" in d && (h = rZ(o, a, l, c));
            }
            h && (Array.isArray(h) ? i.push(...h) : i.push(h));
        } catch (d) {
            console.error(`lerpMaterial: unexpected material layer for ${c}`, d);
        }
    }
    return i;
}
function QK(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : n1.getValue(r), o = e[r], a = typeof s == "string" ? Number(i.getVariable(s) ?? 0) : s, l = typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o;
    if (a !== l) return {
        update: (u)=>{
            n1.setValue(r, Se.lerp(a, l, u));
        },
        start: ()=>{
            n1.setValue(r, a);
        },
        end: ()=>{
            n1.setValue(r, l);
        }
    };
}
function KK(n1, t, e, r) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getValue(r), s = t ? new N().fromArray(t[r]) : i.clone(), o = new N().fromArray(e[r]);
    if (!s.equals(o)) return {
        update: (a)=>{
            i.lerpVectors(s, o, a);
        },
        start: ()=>{
            i.copy(s);
        },
        end: ()=>{
            i.copy(o);
        }
    };
}
function ZK(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = n1.getValue(r), o = t ? t[r] : void 0, a = e[r], l = o ? Jm(new _, o, i) : s.clone(), u = Jm(new _, a, i);
    if (!l.equals(u)) return {
        update: (c)=>{
            s.lerpVectors(l, u, c);
        },
        start: ()=>{
            s.copy(l);
        },
        end: ()=>{
            s.copy(u);
        }
    };
}
function JK(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s ? typeof s == "string" ? i.getColor(s).clone() : new Le().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new Le().setRGB(o.r, o.g, o.b);
    if (l.equals(u)) return;
    let c = a.clone();
    return {
        update: (d)=>{
            n1.getValue(r) !== c && n1.setValue(r, c), c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function $K(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s ? typeof s == "string" ? i.getColor(s).clone() : new Le().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new cr(o.r, o.g, o.b, o.a);
    if (l.equals(u)) return;
    let c = a.clone();
    return {
        update: (d)=>{
            n1.getValue(r) !== c && n1.setValue(r, c), c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function eZ(n1, t, e, r = "steps") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s = n1.getValue(r), o = t ? t[r] : s, a = e[r];
    for(let l = 0; l < s.length; ++l){
        let u = o[l], c = a[l];
        u !== c && i.push({
            update: (d)=>{
                s[l] = Se.lerp(u, c, d);
            },
            start: ()=>{
                s[l] = u;
            },
            end: ()=>{
                s[l] = c;
            }
        });
    }
    return i.length ? i : void 0;
}
function tZ(n1, t, e, r = "colors") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s = n1.getValue(r), o = t ? t[r] : s.map((l)=>l.toArray()), a = e[r];
    for(let l = 0; l < s.length; ++l){
        let u = [
            ...o[l]
        ], c = [
            ...a[l]
        ];
        Hp.isEqual(u, c) || i.push({
            update: (d)=>{
                s[l].fromArray(Hp.lerp(u, c, d));
            },
            start: ()=>{
                s[l].fromArray(u);
            },
            end: ()=>{
                s[l].fromArray(c);
            }
        });
    }
    return i.length ? i : void 0;
}
function rZ(n1, t, e, r = "texture") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getNode("mat");
    if (!i) return;
    let s = t ? t[r] : i, o = e[r], a = [
        ...s.repeat
    ], l = [
        ...s.offset
    ], u = [
        ...o.repeat
    ], c = [
        ...o.offset
    ];
    if (!xo.isEqual(a, u) || !xo.isEqual(l, c)) return {
        update: (d)=>{
            i.repeat = xo.lerp(a, u, d), i.offset = xo.lerp(l, c, d), i.updateMatrix();
        },
        start: ()=>{
            i.repeat = [
                ...a
            ], i.offset = [
                ...l
            ], i.updateMatrix();
        },
        end: ()=>{
            i.repeat = [
                ...u
            ], i.offset = [
                ...c
            ], i.updateMatrix();
        }
    };
}
function iZ(n1, t) {
    return {
        update: ()=>{
            n1.transparent = t;
        }
    };
}
var nE = new _, OB = new Kt;
function IB(n1, t, e, r, i) {
    let s = [], o, a, l, u, c, d, h;
    if (n1 instanceof jt ? (o = eg("position", n1, t, e, i), o && s.push(o), l = Gr("rotation", n1, t, e, i), l && s.push(l)) : (h = {
        slide: t.pathSnapping?.slide ?? n1.updatedPathSnapping?.slide ?? n1.dataPatched.pathSnapping?.slide ?? 0,
        offset: t.pathSnapping?.offset ?? n1.updatedPathSnapping?.offset ?? n1.dataPatched.pathSnapping?.offset ?? 0
    }, c = Gr("slide", h, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), c && s.push(c), d = Gr("offset", h, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), d && s.push(d), !c && !d && (o = iE("position", n1, t, e, i), o && s.push(o), a = iE("scale", n1, t, e, i), a && s.push(a), l = nZ(n1, t, e, r, i), l && s.push(l), u = _B("hiddenMatrix", n1, t, e), u && s.push(u))), o || a || l || u || c || d) {
        let f = n1 instanceof jt ? ()=>{
            n1.updateWorldMatrix(!0);
        } : ()=>{
            n1.updateMatrix(), n1.hasNonUniformScale && (n1.updateMatrixWorld(), n1.updateMatrixWorldSVD()), n1.parent?.matrixWorldFusedFalse && (n1.matrixWorld.multiplyMatrices(n1.parent.matrixWorldFusedFalse, n1.matrix), n1.matrixWorldNeedsUpdate = !1), sn(n1) && An(n1.parent) && n1.invalidateDownstreamBooleanData(!0), n1.updatePathSnapping(Object.assign({}, t.pathSnapping, h));
        };
        s.push({
            update: f,
            start: f,
            end: f
        });
    }
    return s;
}
function nZ(n1, t, e, r, i) {
    let s = t?.rotation ? t.rotation.map((c)=>(typeof c == "string" ? Number(i.getVariable(c) ?? 0) : c) * Se.DEG2RAD) : void 0, o = e.rotation?.map((c)=>(typeof c == "string" ? Number(i.getVariable(c) ?? 0) : c) * Se.DEG2RAD);
    if (!o) return;
    let a = s ? new _().fromArray(s) : new _().setFromEuler(n1.rotation), l = new _().fromArray(o);
    if (a.equals(l)) return;
    let u = nE.subVectors(l, a);
    if (r && u.toArray().every((c)=>Math.abs(c) < 2 * Math.PI)) {
        let c = new je().setFromEuler(OB.setFromVector3(a)), d = new je().setFromEuler(OB.setFromVector3(l));
        return {
            update: (h)=>{
                AB(c, d, n1.quaternion, h);
            },
            start: ()=>{
                n1.rotation.setFromVector3(a);
            },
            end: ()=>{
                n1.rotation.setFromVector3(l);
            }
        };
    } else return {
        update: (c)=>{
            nE.lerpVectors(a, l, c), n1.rotation.setFromVector3(nE);
        },
        start: ()=>{
            n1.rotation.setFromVector3(a);
        },
        end: ()=>{
            n1.rotation.setFromVector3(l);
        }
    };
}
function RB(n1, t, e, r) {
    let i = [];
    if (!("cloner" in e) || !n1.cloner) return i;
    let s = n1.cloner, o = "cloner" in t ? t.cloner : {}, a = e.cloner;
    e1.forEach((f)=>{
        let p;
        f === "count" ? p = Gr("count", s.parameters, o, a, r, !0) : p = jo(f, s.parameters, o ?? {}, a, r), p && i.push(p);
    });
    let l = sZ(s, o, a, r);
    l?.length && i.push(...l);
    let u = oZ(s, o, a, r);
    u?.length && i.push(...u);
    let c = aZ(s, o, a, r);
    c?.length && i.push(...c);
    let d = lZ(s, o, a, r);
    d?.length && i.push(...d);
    let h = cZ(s, o, a, r);
    return h?.length && i.push(...h), i.length && i.push({
        update: ()=>{
            s.update();
        }
    }), i;
}
function sZ(n1, t, e, r) {
    if (n1.parameters.type !== "radial") return;
    let i = t.radial, s = e.radial;
    if (!s) return;
    let o = n1.parameters.radial, a = [];
    return t1.forEach((l)=>{
        let u = jo(l, o, i ?? {}, s, r);
        u && a.push(u);
    }), a;
}
function oZ(n1, t, e, r) {
    if (n1.parameters.type !== "linear") return;
    let i = t.linear, s = e.linear;
    if (!s) return;
    let o = [], a = n1.parameters.linear;
    return r1.forEach((l)=>{
        let u = jo(l, a, i ?? {}, s, r);
        u && o.push(u);
    }), o;
}
function aZ(n1, t, e, r) {
    if (n1.parameters.type !== "grid") return;
    let i = t.grid, s = e.grid;
    if (!s) return;
    let o = [], a = n1.parameters.grid;
    return i1.forEach((l)=>{
        let u;
        l === "count" ? u = $m(l, a, i ?? {}, s, r, !0) : u = jo(l, a, i ?? {}, s, r), u && o.push(u);
    }), o;
}
function lZ(n2, t, e, r) {
    if (n2.parameters.type !== "toObject") return;
    let i = t.toObject, s = e.toObject;
    if (!s) return;
    let o = [], a = n2.parameters.toObject;
    return n1.forEach((l)=>{
        let u;
        l === "count" ? u = Gr(l, a, i ?? {}, s, r, !0) : u = jo(l, a, i ?? {}, s, r), u && o.push(u);
    }), o;
}
function cZ(n1, t, e, r) {
    if (!n1.parameters.randomness) return;
    let i = t.randomnessObject, s = e.randomnessObject;
    if (!s) return;
    let o = [], a = n1.parameters.randomnessObject;
    return s1.forEach((l)=>{
        let u = jo(l, a, i ?? {}, s, r);
        u && o.push(u);
    }), o;
}
function uZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.fill.enabled = t);
        }
    };
}
function dZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.stroke.enabled = t);
        }
    };
}
function hZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.dropShadow.enabled = t);
        }
    };
}
function fZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.innerShadow.enabled = t);
        }
    };
}
function pZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.backgroundBlur.enabled = t);
        }
    };
}
function mZ(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Ar && (n1.layerBlur.enabled = t);
        }
    };
}
function LB(n1, t, e, r, i) {
    let s = [], o, a, l, u, c, d, h, f, p, m, g, y, v, x, S;
    if ("width" in n1 && (o = Gr("width", n1, t, e, i), o && s.push(o)), "height" in n1 && (a = Gr("height", n1, t, e, i), a && s.push(a)), n1 instanceof Ar || n1 instanceof Zi) {
        let w = {
            ...t.fill
        }, A = {
            ...e.fill
        };
        w.enabled !== void 0 && w.enabled !== A.enabled && (s.push(uZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), l = tg("color", n1.fill, w, A, i), l && s.push(l);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.stroke
        }, A = {
            ...e.stroke
        };
        (w.enabled || A.enabled) && (s.push(dZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), u = tg("color", n1.stroke, w, A, i), u && s.push(u), c = Gr("thickness", n1.stroke, w, A, i), c && s.push(c);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.dropShadow
        }, A = {
            ...e.dropShadow
        };
        (w.enabled || A.enabled) && (s.push(hZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), d = tg("color", n1.dropShadow, w, A, i), d && s.push(d), h = Gr("blurRadius", n1.dropShadow, w, A, i), h && s.push(h), p = Gr("spread", n1.dropShadow, w, A, i), p && s.push(p), f = eg("offset", n1.dropShadow, w, A, i), f && s.push(f);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.innerShadow
        }, A = {
            ...e.innerShadow
        };
        (w.enabled || A.enabled) && (s.push(fZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), m = tg("color", n1.innerShadow, w, A, i), m && s.push(m), g = Gr("blurRadius", n1.innerShadow, w, A, i), g && s.push(g), v = Gr("spread", n1.innerShadow, w, A, i), v && s.push(v), y = eg("offset", n1.innerShadow, w, A, i), y && s.push(y);
    }
    if (n1 instanceof Ar || n1 instanceof Zi) {
        let w = {
            ...t.backgroundBlur
        }, A = {
            ...e.backgroundBlur
        };
        (w.enabled || A.enabled) && (s.push(pZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), x = Gr("radius", n1.backgroundBlur, w, A, i), x && s.push(x);
    }
    if (n1 instanceof Ar) {
        let w = {
            ...t.layerBlur
        }, A = {
            ...e.layerBlur
        };
        (w.enabled || A.enabled) && (s.push(mZ(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), S = Gr("radius", n1.layerBlur, w, A, i), S && s.push(S);
    }
    if (n1 instanceof Zi || n1 instanceof ws) {
        let w = $m("cornerRadius", n1, t, e, i);
        w && s.push(w);
    }
    return s;
}
function sE(n1, t, e, r, i) {
    let s = [];
    return n1.data.visible && s.push(...IB(n1, t, e, i, r)), n1 instanceof jt ? s.push(...LB(n1, t, e, i, r)) : (n1.data.visible && s.push(...RB(n1, t, e, r)), sn(n1) ? (n1 instanceof er && n1.data.visible && s.push(...MB(n1, t, e, r)), n1.data.visible && s.push(...DB(n1, t, e, r))) : IR(n1) ? n1.data.visible && s.push(...CB(n1, t, e, r)) : OR(n1) && s.push(...TB(n1, t, e, r))), s.length ? {
        update: (o)=>{
            s.forEach((a)=>a.update(o));
        },
        start: (o)=>{
            s.forEach((a)=>a.start?.(o));
        },
        end: (o)=>{
            s.forEach((a)=>a.end?.(o));
        }
    } : void 0;
}
var BB = new _;
function If(n1, t, e = !1) {
    let r = [], i = (s)=>{
        let o = s.data;
        delete s.states, s.currentState = null, s.reversibleToState = null, s.currentTransitionEvent = null;
        for (let a of o.states){
            let l = {
                ...a.data
            };
            s.states || (s.states = {}), s.states[a.id] = wa.patch(o, l);
        }
        FB(n1.scene, s, null, t, o.events.find((a)=>a.data.type === "Follow" || a.data.type === "LookAt") !== void 0), NB(n1);
    };
    n1.scene.traverse2D(i), n1.traverseChildren((s)=>{
        if (e && (s.rigidBody?.setTranslation(s.position0, !0), s.rigidBody?.setRotation(s.rotation0, !0), s.rigidBody?.setLinvel(BB, !0), s.rigidBody?.setAngvel(BB, !0)), !ut.is(s)) return;
        let o = s.uuid, a = s.data;
        if (delete s.states, s.uuid === us) return;
        let l = !1;
        r.some((u)=>n1.scene.find(o)?.isDescendantOf(u)) ? l = !0 : a.physics?.fusedBody === !0 && a.physics.rigidBody === "dynamic" && r.push(o), s.data = a, s.currentState = null, s.reversibleToState = null, s.currentTransitionEvent = null;
        for (let u of a.states){
            let c = {
                ...u.data
            };
            n1.data.globalPhysics.usePhysics === !0 && a.physics && (a.physics.rigidBody === "dynamic" || l) && (u.data.position !== void 0 && delete c.position, u.data.rotation !== void 0 && delete c.rotation, u.data.hiddenMatrix !== void 0 && delete c.hiddenMatrix), s.states || (s.states = {}), s.states[u.id] = ga.patch(a, c);
        }
        FB(n1.scene, s, null, t, a.events.find((u)=>u.data.type === "Follow" || u.data.type === "LookAt") !== void 0), NB(n1), s instanceof fr && s.frame && (s.frame.traverse((u)=>i(u)), s.uiCanvas?.applySize());
    }), n1.frame && (n1.frame.traverse((s)=>i(s)), n1.uiCanvas?.applySize());
}
function NB(n1) {
    n1.traverseEntity((t)=>{
        for (let e of t.data.events){
            let r = [];
            switch(e.data.type){
                case "Follow":
                case "MouseHover":
                case "Scroll":
                case "MouseDown":
                case "MouseUp":
                case "MousePress":
                case "KeyUp":
                case "KeyDown":
                case "KeyPress":
                case "Collision":
                    r.push(...e.data.actions);
                    break;
                case "GameControl":
                    for (let i of Object.values(e.data.gameActions))r.push(...i);
                    break;
                case "DragDrop":
                    r.push(...e.data.dragDropActions.drag, ...e.data.dragDropActions.drop);
                    break;
                case "Conditional":
                    r.push(...e.data.inActions, ...e.data.outActions);
                    break;
            }
            for (let i of r)if (i.data.type === "Create" && i.data.hideBase === "Yes") {
                let s = n1.scene.find(i.data.object);
                s && (s.visible = !1);
            }
        }
    });
}
function FB(n1, t, e, r, i = !1) {
    if (t instanceof er && t.removeInteractionGeometry(r), t instanceof jt ? t.changeSelectedState(e, {
        shared: r
    }, i) : t.changeSelectedState(e, {
        scene: n1,
        shared: r
    }, i), t instanceof er && t.updateGeometryGroupsIfNeeded(), t instanceof hr && t.updateCameraState(t.dataPatched, {
        scene: n1,
        shared: r
    }), !(t instanceof jt)) {
        if (t.cloner) for (let s of t.cloner.children)s.playModeVisible = void 0;
        t.updateVisible(n1);
    }
}
function aE(n1) {
    let t;
    if (n1.easing === 5) {
        let { control1: e, control2: r } = n1;
        t = `cubicBezier(
			${e[0]}, ${e[1]}, ${r[0]}, ${r[1]}
		)`;
    } else if (n1.easing === 6) {
        let { mass: e, stiffness: r, damping: i, velocity: s } = n1;
        t = `spring( ${e}, ${r}, ${i}, ${s} )`;
    } else {
        let e;
        switch(n1.easing){
            case 0:
                e = pa.linear;
                break;
            case 1:
                e = pa.ease;
                break;
            case 2:
                e = pa.easeIn;
                break;
            case 3:
                e = pa.easeOut;
                break;
            case 4:
                e = pa.easeInOut;
                break;
            default:
                e = pa.linear;
        }
        let [r, i, s, o] = e;
        t = `cubicBezier( ${r}, ${i}, ${s}, ${o} )`;
    }
    return {
        duration: n1.duration,
        easing: t
    };
}
function oE(n1) {
    let t = {
        delay: 0,
        loop: n1.repeat === -1 ? !0 : n1.repeat + 1
    };
    if (n1.repeat === 0) t.direction = "normal", t.rewind = !1;
    else switch(n1.direction){
        case "pingpong":
            t.direction = "alternate", t.rewind = !1;
            break;
        case "pingpong-rewind":
            t.direction = "alternate", t.rewind = !0;
            break;
        default:
            t.direction = "normal", t.rewind = !1;
            break;
    }
    switch(t.delay = 0, t.endDelay = 0, t.startOnceDelay = 0, t.pingPongDelayCorrection = 0, t.pingPongEndDelayCorrection = 0, n1.delayDirection){
        case "start-once":
            t.startOnceDelay = n1.delay;
            break;
        case "start":
            t.delay = n1.delay;
            break;
        case "end":
            t.endDelay = n1.delay;
            break;
        case "start-end":
        case void 0:
            t.delay = n1.delay, t.endDelay = n1.delay;
            break;
    }
    return t.direction === "alternate" && (t.delay /= 2, t.endDelay /= 2, n1.delayDirection === "start" ? (t.pingPongDelayCorrection = t.delay, typeof t.loop == "number" && t.loop % 2 === 0 && (t.pingPongEndDelayCorrection = t.delay)) : n1.delayDirection === "end" ? typeof t.loop == "number" && t.loop % 2 !== 0 && (t.pingPongEndDelayCorrection = t.endDelay) : n1.delayDirection === "start-end" && (t.pingPongDelayCorrection = t.delay, t.pingPongEndDelayCorrection = t.endDelay)), t;
}
var gZ = {
    type: "beginState"
}, yZ = {
    type: "completeState",
    isfromEntity: !1
}, sb = class {
    constructor(t, e, r, i, s, o){
        this.object = t;
        this.data = i;
        this.sharedAssets = s;
        this.allowSlerp = o;
        this.targets = {
            t: 0
        };
        this.firstLoop = !0;
        this._changeBegan = !1;
        this._changeCompleted = !0;
        this.onChange = ()=>{
            this.callback && (this.callback.update(this.targets.t), this.object.requestRender()), this.targets.t === 0 || this.targets.t === 1 ? this._changeCompleted || (this._changeCompleted = !0, this._changeBegan = !1, this.onChangeComplete()) : (this._changeCompleted && (this._changeCompleted = !1), this._changeBegan || (this._changeBegan = !0, this.onChangeBegin()));
        };
        this.onChangeBegin = ()=>{
            this.object.reversibleToState = this.to.id;
            let t = this.targets.t > .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "beginState",
                state: t
            }), this.object instanceof jt || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof hr && e.dispatchEvent(gZ);
            });
        };
        this.onChangeComplete = ()=>{
            this.firstLoop && (this.onFirstLoop(), this.firstLoop = !1), this.object.reversibleToState = this.to.id;
            let t = this.targets.t < .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "completeState",
                state: t
            }), this.object instanceof jt || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof hr && e.dispatchEvent(yZ);
            });
        };
        this.onFirstLoop = ()=>{
            this.useCurrentState && (this.callback = sE(this.object, this.from.data, this.to.data, this.sharedAssets, this.allowSlerp));
        };
        if (e === void 0) {
            let a = nb(this.object, this.object.currentState === r ? this.object.prevState : this.object.currentState);
            if (!a) throw new Error("Missing property");
            this.from = a;
        } else {
            let a = nb(this.object, e);
            if (!a) throw new Error("Missing property");
            this.from = a;
        }
        if (r === void 0) throw new Error("Missing property");
        {
            let a = nb(this.object, r);
            if (!a) throw new Error("Missing property");
            this.to = a;
        }
        this.useCurrentState = e === void 0 || r === void 0, this.params = {
            targets: this.targets,
            t: 1,
            autoplay: !1,
            ...oE(i),
            ...aE(i),
            change: this.onChange
        }, this.callback = sE(this.object, e === void 0 ? {} : this.from.data, r === void 0 ? {} : this.to.data, this.sharedAssets, this.allowSlerp);
    }
    get changeBegan() {
        return this._changeBegan;
    }
    get changeCompleted() {
        return this._changeCompleted;
    }
}, rg = class extends ir {
    constructor(e, r, i, s){
        super();
        this.data = e;
        this.page = r;
        this.shared = i;
        this.condition = s;
        this.toggleIsForward = !1;
        this.timelineNeedsRebuild = !1;
        this.useToggle = !1;
        this.onTimelineChangeComplete = ()=>{
            this.data.tweens[0].data.direction !== "normal" && (this.toggleIsForward = !this.toggleIsForward), this.timelineNeedsRebuild !== !1 && (this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward,
                needsRebuild: !1,
                isRebuild: !0
            }), this.timeline.play());
        };
        if (!e.object) throw new Error("Missing property");
        let o = this.page.scene.find(e.object) ?? this.page.uiCanvas?.find(e.object) ?? this.page.scene.find2DInUIObjects(e.object);
        if (!o) throw new Error("Missing property");
        if (!o.states) throw new Error("Missing property");
        if (this.object = o, e.tweens.length < 2) throw new Error("Missing property");
        this.tweens = Array(this.data.tweens.length - 1), this.startOnceDelay = e.tweens[0].data.delayDirection === "start-once" ? e.tweens[0].data.delay : 0, this.init();
    }
    get playing() {
        return this.timeline && this.timeline.paused === !1;
    }
    init() {
        this.initialCurrentState = nb(this.object, this.object.currentState).id, this.toggleIsForward = !1;
    }
    get currentState() {
        return this.useToggle ? this.initialCurrentState : this.object.currentState;
    }
    buildTimeline({ isForward: e = !0, needsRebuild: r = !1, isRebuild: i = !1 } = {}) {
        try {
            let s = oE(this.data.tweens[0].data);
            i && typeof s.loop == "number" && s.loop--, this.timeline?.pause(), this.timeline = ib.timeline({
                autoplay: !1,
                ...s,
                ...s.loop === !0 || s.loop > 1 ? {
                    timelineChangeComplete: this.onTimelineChangeComplete
                } : {}
            });
            let o = this.tweens.findIndex((a)=>a?.changeBegan);
            if (r === !0 && (this.timelineNeedsRebuild = !0), e) {
                let a = o === -1 ? 0 : o;
                for(let l = a; l < this.data.tweens.length - 1; l++){
                    let u = this.data.tweens[l], c = this.data.tweens[l + 1], d;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.playing === !0) ? (d = void 0, this.object instanceof hr && (this.object.wasMovedByUser = !1)) : d = u.data.state === void 0 ? this.currentState : u.data.state;
                    let h = new sb(this.object, d, c.data.state === void 0 ? this.currentState : c.data.state, c.data, this.shared, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(h.params, {
                        startOnceDelay: 0
                    }), this.tweens[l] = h, this.timeline.add(h.params, this.timeline.duration + (l === a ? s.delay : 0));
                }
                this.timeline.duration += s.endDelay;
            } else {
                let a = o === -1 ? this.data.tweens.length - 1 : o + 1;
                for(let l = a; l > 0; l--){
                    let u = this.data.tweens[l], c = this.data.tweens[l - 1], d;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.playing === !0) ? (d = void 0, this.object instanceof hr && (this.object.wasMovedByUser = !1)) : d = u.data.state === void 0 ? this.currentState : u.data.state;
                    let h = new sb(this.object, d, c.data.state === void 0 ? this.currentState : c.data.state, u.data, this.shared, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(h.params, {
                        startOnceDelay: 0
                    }), this.tweens[l - 1] = h, this.timeline.add(h.params, this.timeline.duration + (l === a ? s.endDelay : 0));
                }
                this.timeline.duration += s.delay;
            }
        } catch (s) {
            s instanceof Error && console.error(s.message);
        }
        this.object.previousAction?.playing === !0 && this.object.previousAction.pause(), this.object.previousAction = this;
    }
    play() {
        if (Tt(this.shared, this.condition) === !1 || this.playing) return !1;
        clearTimeout(this.timeoutId);
        let e = oE(this.data.tweens[0].data).pingPongDelayCorrection;
        this.timeoutId = window.setTimeout(()=>{
            try {
                this.buildTimeline(), this.timeline.play();
            } catch (r) {
                r instanceof Error && console.error(r.message);
            }
        }, this.startOnceDelay + e);
    }
    pause() {
        this.timeline?.pause(), clearTimeout(this.timeoutId), this.tweens = Array(this.data.tweens.length - 1), delete this.timeoutId;
    }
    stop() {
        this.pause();
        let e = this.data.tweens[0].data.state === void 0 ? this.initialCurrentState : this.data.tweens[0].data.state;
        this.object instanceof jt ? this.object.changeSelectedState(e, {
            shared: this.shared
        }) : this.object.changeSelectedState(e, {
            scene: this.page.scene,
            shared: this.shared
        }), this.object.currentState = e;
    }
    seek(e) {
        this.timeline === void 0 && this.buildTimeline(), this.timeline?.seek(e * this.timeline.duration, !0);
    }
    toggle(e) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.useToggle = !0, clearTimeout(this.timeoutId), this.toggleIsForward = e ?? !this.toggleIsForward, this.playing ? (this.timeline?.pause(), this.buildTimeline({
            isForward: this.toggleIsForward,
            needsRebuild: !0
        }), this.timeline.play()) : this.timeoutId = window.setTimeout(()=>{
            this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward
            }), this.timeline.play();
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause();
    }
};
function nb(n1, t) {
    let e, r;
    if (typeof t == "string" ? (e = t, r = n1.states?.[e]) : t === null && (e = null, r = n1.data), !(e === void 0 || r === void 0)) return {
        id: e,
        data: r
    };
}
var vZ = {
    type: "beginState"
}, kB = {
    type: "completeState",
    isfromEntity: !1
}, zB = {
    type: "requestRender"
}, ig = class extends ir {
    constructor(e, r, i, s){
        super();
        this.data = e;
        this.page = r;
        this.shared = i;
        this.condition = s;
        this.toggleIsForward = !1;
        this.useToggle = !1;
        this.posStart = new _;
        this.posEnd = new _;
        this.qStart = new je;
        this.qEnd = new je;
        this.zoomStart = 1;
        this.zoomEnd = 1;
    }
    init() {}
    get playing() {
        return this.animation && this.animation.began && !this.animation.completed;
    }
    buildAnimation(e = !1) {
        if (!this.data.animate) return;
        let r = this.page.scene.find(this.data.targetCamera);
        if (!r || !r.visible) throw new ReferenceError("Target camera not founded or not visible");
        let i = {
            t: 0
        };
        this.posStart.copy(this.page.activeCamera.position), this.qStart.copy(this.page.activeCamera.quaternion), this.zoomStart = this.page.activeCamera.zoom, this.animation = ib({
            targets: i,
            t: 1,
            ...aE(this.data),
            update: ()=>{
                i.t === 0 && (this.useToggle && !this.toggleIsForward ? (this.posEnd.copy(this.fromCamera.position), this.qEnd.copy(this.fromCamera.quaternion), this.zoomEnd = this.fromCamera.zoom, this.switchCamera(this.fromCamera.uuid)) : (this.posEnd.copy(r.position), this.qEnd.copy(r.quaternion), this.zoomEnd = r.zoom, this.fromCamera = this.page.activeCamera, this.switchCamera(r.uuid)), this.page.activeCamera.dispatchEvent(vZ));
                let s = this.page.activeCamera;
                s.position.lerpVectors(this.posStart, this.posEnd, i.t), s.quaternion.slerpQuaternions(this.qStart, this.qEnd, i.t), s.zoom = this.zoomStart + (this.zoomEnd - this.zoomStart) * i.t, s.wasMovedBySwitchCameraAction = !0, s.updateMatrix(), s.updateMatrixWorld(), s.updateProjectionMatrix(), s.dispatchEvent(zB), i.t === 1 && s.dispatchEvent(kB);
            }
        });
    }
    switchCamera(e) {
        let r = this.page.activeCamera, i = this.page.scene.find(e);
        if (!i || !i.visible) throw new ReferenceError("Target camera not founded or not visible");
        this.page.switchActiveCamera(i), r.dispatchEvent({
            type: "cameraChange",
            camera: i
        });
    }
    play() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        if (!this.playing && this.page.activeCamera.uuid !== this.data.targetCamera) try {
            clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
                delete this.timeoutId, this.data.animate ? (this.buildAnimation(), this.animation?.play()) : this.switchCamera(this.data.targetCamera);
            }, this.data.delay * 1e3);
        } catch  {}
    }
    pause() {
        this.animation?.pause(), clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    toggle(e) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.useToggle = !0, clearTimeout(this.timeoutId), this.toggleIsForward = e ?? !this.toggleIsForward;
        try {
            this.playing ? (this.animation?.pause(), this.buildAnimation(!0), this.animation?.play()) : this.timeoutId = window.setTimeout(()=>{
                delete this.timeoutId, this.data.animate ? (this.animation?.pause(), this.buildAnimation(), this.animation?.play()) : (this.toggleIsForward ? (this.fromCamera = this.page.activeCamera, this.switchCamera(this.data.targetCamera)) : this.switchCamera(this.fromCamera.uuid), this.page.activeCamera.dispatchEvent(kB), this.page.activeCamera.dispatchEvent(zB));
            }, this.data.delay * 1e3);
        } catch  {}
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause(), this.toggleIsForward = !1;
    }
};
var ng = class extends ir {
    constructor(e, r, i, s, o){
        super();
        this.page = r;
        this.animationControls = i;
        this.shared = s;
        this.condition = o;
        this.startOnceDelay = 0;
        this.toggleIsForward = !1;
        let a = e.object, l = r.scene.find(e.object);
        l && Array.isArray(l.identity) && (a = l.identity[0]), this.data = {
            ...e,
            object: a
        };
        let u = this.animationControls.clipIdToAction[e.clipId + "/" + a];
        this.duration = u?.getClip()?.duration ?? 1;
        let c = u?.getClip()?.tracks[0]?.times.length ?? 1 / 0;
        this.leftFrameTime = this.data.crop[0] / c * this.duration, this.rightFrameTime = this.data.crop[1] / c * this.duration, this.startOnceDelay = e.delay;
    }
    get playing() {
        return this.threeAnimAction?.isRunning() ?? !1;
    }
    play(e = !1) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), !this.threeAnimAction) return;
            this.threeAnimAction.reset(), this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime;
            let r = this.data.object;
            Object.entries(this.animationControls.clipIdToAction).forEach(([i, s])=>{
                let o = i.split("/")[1];
                this.threeAnimAction !== s && o === r && s.isRunning() && (e ? s.fadeOut(.2) : s.stop());
            }), e && this.threeAnimAction?.fadeIn(.2);
        }, this.startOnceDelay);
    }
    pause() {
        this.threeAnimAction && (this.threeAnimAction.paused = !0), window.clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    stop() {
        this.threeAnimAction?.fadeOut(.2);
    }
    seek(e) {
        this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction && (this.threeAnimAction.paused = !0, this.threeAnimAction.time = Se.clamp(this.threeAnimAction.time + 1 / 60 * e, this.leftFrameTime, this.rightFrameTime - 16e-5), this.animationControls.needsUpdate = !0, this.animationControls.requestRender());
    }
    toggle(e, r = !1) {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.toggleIsForward = e ?? !this.toggleIsForward, this.threeAnimAction && (this.threeAnimAction._loopCount = 0), this.playing ? this.threeAnimAction && (this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1, this.toggleIsForward ? (this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime)) : this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction) {
                this.toggleIsForward ? (this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction.time = this.rightFrameTime, this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime), this.threeAnimAction.paused = !1, this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1;
                let i = this.data.clipId.split("/")[1];
                Object.entries(this.animationControls.clipIdToAction).forEach(([s, o])=>{
                    let a = s.split("/")[1];
                    this.threeAnimAction !== o && a === i && o.isRunning() && (r ? o.fadeOut(.2) : o.stop());
                }), r && this.threeAnimAction?.fadeIn(.2);
            }
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        let e = this.animationControls.clipIdToAction[this.data.clipId + "/" + this.data.object]?.getClip();
        e && (e.duration = this.duration), this.pause();
    }
};
var sg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.eventManager = r;
        this.shared = i;
        this.condition = s;
        this.timeOutId = -1;
        this.scene = e.scene;
    }
    dispatch() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.data.target !== this.page.uuid && (window.clearTimeout(this.timeOutId), this.timeOutId = window.setTimeout(()=>{
            this.play();
        }, this.data.delay * 1e3));
    }
    dispose() {
        window.clearTimeout(this.timeOutId);
    }
    play() {
        if (this.scene.children.every((r)=>r.uuid !== this.data.target)) return;
        this.data.transition === "fade" && this.data.duration > 0 && this.eventManager.eventContext.renderer.renderFromSceneForSceneTransitionPass(this.scene, this.scene.activeCamera, this.data.duration * 1e3), this.eventManager.deactivate(), this.eventManager.controlsManager.deactivate();
        let t = this.scene.activeCamera;
        this.scene.updatePage(this.data.target), this.scene.activePage.switchToPlayCamera(), this.scene.activeCamera.copyViewPlaneSize(t), If(this.scene.activePage, this.shared), this.eventManager.activate(), this.eventManager.controlsManager.activate(this.eventManager);
    }
};
var og = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.evaluatedCondition = !1;
    }
    checkConditions() {
        this.evaluatedCondition = Tt(this.shared, this.condition);
    }
    dispatch() {
        if (this.evaluatedCondition === !1) return !1;
        let t = this.shared.getVariable(this.data.variableId), e = C0(this.data.expression, this.shared, Fi.typeOfVariable(t));
        e !== void 0 && this.shared.updateVariable(this.data.variableId, typeof e == "string" ? {
            textValue: e
        } : e);
    }
    dispose() {}
};
var ag = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.timeoutId = null;
    }
    dispatchInner() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        let t = this.shared.getDynamicVariablePlayState(this.data.variableId);
        if (this.data.mode === "PlayPause") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, t === "Playing" ? "Paused" : "Playing");
        else if (this.data.mode === "Play" && t !== "Playing") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing");
        else if (this.data.mode === "Stop" && t !== "Stopped") this.shared.setDynamicVariablePlayState(this.data.variableId, "Stopped");
        else if (this.data.mode === "Pause" && t !== "Paused") this.shared.setDynamicVariablePlayState(this.data.variableId, "Paused");
        else if (this.data.mode === "Restart") this.shared.setDynamicVariablePlayState(this.data.variableId, "Restarted");
        else if (this.data.mode === "Toggle") {
            let e = this.shared.getDynamicVariableToggleIsForward(this.data.variableId);
            t === "Playing" ? this.shared.setDynamicVariableToggleIsForward(this.data.variableId, e === void 0 ? !1 : !e) : (this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !e), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing"));
        }
    }
    dispatch() {
        let t = this.data.delay, e = this.shared.getDynamicVariablePlayState(this.data.variableId);
        this.data.mode === "PlayPause" && e === "Playing" && (t = this.data.pauseDelay), t !== 0 ? (this.timeoutId && window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            this.timeoutId = null, this.dispatchInner();
        }, t)) : this.dispatchInner();
    }
    dispose() {
        this.timeoutId && window.clearTimeout(this.timeoutId);
    }
};
function Tt(n1, t) {
    if (t === void 0) return !0;
    if (t.expression.length === 0) return !1;
    let e = C0(t.expression, n1, "boolean");
    return t.negate ? !e : !!e;
}
function gr(n1, t, e, r, i, s) {
    let o = {
        Audio: [],
        Video: [],
        Particles: [],
        Link: [],
        Destroy: [],
        Create: [],
        Reset: [],
        Transition: [],
        SwitchCamera: [],
        Animation: [],
        SceneTransition: [],
        SetVariable: [],
        DynamicVariablePlay: []
    }, a = (l)=>({ id: u, data: c })=>{
            try {
                c.type === "Audio" && !(s instanceof jt) ? gn[n1.type].includes("Audio") && o.Audio.push(new Ym(u, c, s, r, l)) : c.type === "Video" && !(s instanceof jt) ? gn[n1.type].includes("Video") && o.Video.push(new lg(u, c, s, r, l)) : c.type === "Particles" ? gn[n1.type].includes("Particles") && o.Particles.push(new Xm(c, e, r, l)) : c.type === "Link" ? gn[n1.type].includes("Link") && o.Link.push(new Zx(c, i.controlsManager, r, l)) : c.type === "Create" ? gn[n1.type].includes("Create") && o.Create.push(new cg(c, e, i.controlsManager, r, l)) : c.type === "Destroy" ? gn[n1.type].includes("Destroy") && o.Destroy.push(new Qm(c, e, i.controlsManager, r, l)) : c.type === "Reset" ? gn[n1.type].includes("Reset") && o.Reset.push(new Km(c, e, r, i, l)) : c.type === "Transition" ? gn[n1.type].includes("Transition") && o.Transition.push(new rg(c, e, r, l)) : c.type === "SwitchCamera" ? gn[n1.type].includes("SwitchCamera") && o.SwitchCamera.push(new ig(c, e, r, l)) : c.type === "SceneTransition" ? gn[n1.type].includes("SceneTransition") && o.SceneTransition.push(new sg(c, e, i, r, l)) : c.type === "Animation" ? gn[n1.type].includes("Animation") && o.Animation.push(new ng(c, e, i.animationControls, r, l)) : c.type === "SetVariable" ? gn[n1.type].includes("SetVariable") && o.SetVariable.push(new og(c, e, r, l)) : c.type === "DynamicVariablePlay" ? gn[n1.type].includes("DynamicVariablePlay") && o.DynamicVariablePlay.push(new ag(c, e, r, l)) : c.type === "Conditional" && gn[n1.type].includes("Conditional") && (c.ifActions.forEach(a({
                    expression: c.condition,
                    negate: !1
                })), c.elseActions.forEach(a({
                    expression: c.condition,
                    negate: !0
                })));
            } catch (d) {}
        };
    return t.forEach(a()), o;
}
function tr(n1) {
    Object.values(n1).forEach((t)=>{
        t.forEach((e)=>{
            (e instanceof Ym || e instanceof lg || e instanceof Xm || e instanceof ng || e instanceof rg || e instanceof cg || e instanceof Qm || e instanceof ig || e instanceof sg || e instanceof Km || e instanceof og || e instanceof ag) && e.dispose();
        });
    });
}
function VB(n1, t) {
    let e;
    if ("material" in n1) {
        let r = n1.material;
        Array.isArray(r) ? e = n1.material[0].layers.find((i)=>i.uuid === t) : e = n1.material.layers.find((i)=>i.uuid === t);
    }
    if (!!e) return e.color.texture.image.img instanceof HTMLVideoElement ? e.color.texture.image.img : void 0;
}
var UB = new Map, ug = new Map, Na = class {
    constructor(t, e, r){
        this.data = e;
        this.delay = 0;
        this.status = "stopped";
        let { layerId: i, loop: s, volume: o, delay: a } = e;
        if (this.object = r, i === void 0) throw new Error("Missing property");
        let l = VB(r, i);
        l && (this.videoElement = l, this.videoElement.loop = s === 1 / 0, Md && (this.videoElement.autoplay = !0), o !== void 0 && (this.videoElement.volume = o)), a !== void 0 && (this.delay = a), ug.has(r.uuid) ? ug.get(r.uuid).push(this) : ug.set(r.uuid, [
            this
        ]), UB.set(t, this), this.pause();
    }
    mute() {
        !this.videoElement || (this.videoElement.muted = !0);
    }
    unMute() {
        !this.videoElement || (this.videoElement.muted = !1);
    }
    play(t) {
        if (!this.videoElement) return;
        let e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        t ? (this.mute(), this.delay += 150) : e ? (this.mute(), window.setTimeout(()=>{
            this.unMute();
        }, 100)) : this.unMute(), this.delayTimerId = window.setTimeout(()=>{
            if (!this.videoElement) return;
            let r = this.videoElement.play();
            r !== void 0 && r.then((i)=>{}).catch((i)=>{
                this.play();
            }), this.clearDelay();
        }, this.delay), this.status = "playing";
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    pause() {
        !this.videoElement || (this.videoElement.pause(), this.status = "paused");
    }
    stop() {
        !this.videoElement || (this.videoElement.pause(), this.videoElement.currentTime = 0, this.status = "stopped", this.clearDelay());
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.status === "playing" ? this.stop() : (this.stop(), this.play()) : this.data.toggle === "pause" ? this.status === "playing" ? this.pause() : this.play() : (this.stop(), this.play());
    }
    dispose() {
        !this.videoElement || (this.stop(), this.videoElement.muted = !0);
    }
}, Rf = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playVideo ? this.pauseVideo(this.data.playVideo) : this.data.object ? this.pauseAllVideosFromObject(this.data.object) : this.pauseAllVideos();
    }
    pauseVideo(t) {
        let e = UB.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e[this.data.interaction]());
    }
    pauseAllVideosFromObject(t) {
        let e = ug.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r[this.data.interaction]()));
    }
    pauseAllVideos() {
        let t = [
            ...ug.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, lg = class {
    constructor(t, e, r, i, s){
        this.data = e;
        this.shared = i;
        this.condition = s;
        if (e.interaction === "play") this.interaction = new Na(t, e, r);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Rf(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Na ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (Tt(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof Na ? this.interaction.play() : this.interaction.dispatch();
    }
    dispose() {
        this.interaction.dispose();
    }
};
var GB = (()=>{
    let n1, t, e, r;
    function i(a) {
        !n1 && !jB() && t?.sharedGameControlGlobals.createdObjects.length > 0 && (n1 = requestAnimationFrame(s)), a && (t = a, r = a.requestRender);
    }
    function s(a) {
        let l = e ? a - e : 0, u = t.sharedGameControlGlobals.createdObjects, c = t.sharedGameControlGlobals.nCreatedPerAction, d = u.length, h = 0;
        for(; h < d;){
            let f = u[h];
            f.userData.createdTime === void 0 && (f.userData.createdTime = a), f.userData.lifetime === void 0 && f.userData.quantity === void 0 || f.userData.lifetime && a - f.userData.createdTime < f.userData.lifetime || f.userData.quantity && c[f.userData.actionId] <= f.userData.quantity ? (f.userData.velocity && (f.position.addScaledVector(f.userData.velocity, l / 1e3), f.updateMatrix(), r()), h++) : (c[f.userData.actionId] > f.userData.quantity && c[f.userData.actionId]--, u.splice(h, 1), f.removeFromParent(), t.sharedGameControlGlobals.rapierWorld && f.rigidBody ? (t.sharedGameControlGlobals.colliderToEntity.delete(f.rigidBody.collider(0).handle), t.sharedGameControlGlobals.rapierWorld.removeRigidBody(f.rigidBody)) : (f.bvhGeometry = void 0, t.sharedGameControlGlobals.entitiesWithTransformAnim = t.sharedGameControlGlobals.entitiesWithTransformAnim.filter((p)=>p.bvhGeometry !== void 0)), d--, r());
        }
        n1 = h > 0 ? requestAnimationFrame(s) : void 0, e = h > 0 ? a : void 0;
    }
    function o() {
        jB() ? n1 && (cancelAnimationFrame(n1), n1 = void 0, e = void 0) : i();
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", o), i;
})();
function jB() {
    return !!document && document.hidden;
}
var HB = new je, xZ = new _, bZ = new _, cg = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s;
        this.intervalId = null;
        this.timeoutIdQueue = [];
        this.uniqueId = Se.generateUUID();
        this.dispatch = ()=>{
            if (Tt(this.shared, this.condition) === !1) return !1;
            this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
        };
        this.dispatchFromStart = ()=>{
            if (Tt(this.shared, this.condition) === !1) return !1;
            this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
        };
        this.dispatchThrottled = Ow(this.dispatch, 1e3 / this.data.creationSpeed);
        this.dispatchStart = ()=>{
            this.intervalId === null && (this.intervalId = window.setInterval(this.dispatch, 1e3 / this.data.creationSpeed));
        };
        this.dispatchStop = ()=>{
            this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null);
        };
        this.dispatchInner = ()=>{
            this.timeoutIdQueue.shift();
            let t = new Pr(this.object);
            if (t.playModeVisible = !0, t.expand(), this.data.coordinateSystem !== "world") {
                let r = this.data.coordinateSystem, i = this.page.scene.find(r);
                i && (i.updateMatrixWorldSVD(), t.hiddenMatrix.copy(i.matrixWorldRigid));
            }
            t.position.fromArray(this.data.position), t.rotation.fromArray(this.data.rotation), t.updateMatrix(), this.page.add(t);
            let e = this.controlsManager.sharedGameControlGlobals;
            e.createdObjects.push(t), e.nCreatedPerAction[this.uniqueId] === void 0 ? e.nCreatedPerAction[this.uniqueId] = 1 : e.nCreatedPerAction[this.uniqueId]++, t.updateWorldMatrix(!0, !0), t.traverseObject(this.traverseObjectCB), GB(), this.controlsManager.requestRender();
        };
        this.traverseObjectCB = (t)=>{
            t.hasNonUniformScale && t.updateMatrixWorldSVD();
            let e;
            if (this.controlsManager.sharedGameControlGlobals.rapierWorld) {
                if (t instanceof Gi) {
                    if (t.objectForSample) {
                        if (t.objectForSample.dataPatched.physics.fusedBody) return;
                        e = t.object;
                    } else return t.object.dataPatched.physics.fusedBody === !0 && t.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (t instanceof Pr) e = t.object;
                else if (e = t, e.dataPatched.cloner?.hideBase) return !0;
            } else {
                if (t instanceof Gi) return;
                t instanceof Pr ? e = t.object : e = t;
            }
            this.data.destroy === "Time" ? t.userData.lifetime = this.data.lifetime * 1e3 : this.data.destroy === "Quantity" && (t.userData.quantity = this.data.destroyAfterQuantity, t.userData.actionId = this.uniqueId);
            let r = new _().fromArray(this.data.velocity), i = e.dataPatched;
            if (!(i.physics.enabled === "visibility" ? !i.visible : !i.physics.enabled) && (this.controlsManager.sharedGameControlGlobals.rapierWorld ? (this.controlsManager.addRigidBody(t, e, {
                fromCreate: !0,
                dynamic: this.data.dynamic
            }), this.data.destroy === "Collision" && (t.rigidBody?.collider(0).setActiveEvents(1), t.userData.hasCollisionDestroy = !0), t.matrixWorld.decompose(xZ, HB, bZ), r.applyQuaternion(HB), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && t.rigidBody?.setLinvel(r.divideScalar(this.controlsManager.pixelsPerMeter), !0)) : ("geometry" in t.object && this.controlsManager.addBoundsTree(t), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && (t.userData.velocity = r)), e.dataPatched.physics?.fusedBody === !0)) return !0;
        };
        let o = this.page.scene.find(this.data.object);
        if (!o) throw new Error("Missing Property");
        if (this.object = o, this.data.coordinateSystem !== "world" && !this.page.scene.find(this.data.coordinateSystem)) throw new Error("Missing Property");
        GB(r);
    }
    dispose() {
        this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null), this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t)), this.dispatchThrottled.cancel(), this.page.remove(...this.controlsManager.sharedGameControlGlobals.createdObjects), this.controlsManager.sharedGameControlGlobals.createdObjects = [];
    }
};
var dE = 200, lE = .02, cE = .3, SZ = 65, Lje = new _, WB = new _, qB = new _, wZ = new _, _n = new _, kn = new _, Ql = new _, uE = new te, YB = new te, AZ = new te, Bje = new te, to = new je, Fa = new je, Ho = new Kt(0, 0, 0, "YXZ"), _Z = new _(1, 0, 0), ro = new _(0, 1, 0), EZ = new _(0, 0, 1), XB = new _(1, 1, 1), Nje = new Er, TZ = 1, MZ = .025, CZ = 16e-6, QB = 12, PZ = 20, Hi = new xi, Es = new Bt, DZ = {
    type: "requestRender"
}, OZ = {
    type: "updateMatrix"
}, KB = Math.PI / 6, ob = class extends ir {
    constructor(e, r, i, s, o, a, l, u, c){
        super();
        this.object = e;
        this.domElement = r;
        this.data = i;
        this.gloabalPhysics = s;
        this.controlsManager = o;
        this.cameraFollow = a;
        this.camera = l;
        this.page = u;
        this.sharedAssets = c;
        this.enableDamping = !0;
        this.hiddenMatrix0 = new te;
        this.target0 = new _;
        this.zoom0 = 1;
        this.rotForce = 1;
        this.moveForce = 1;
        this.pixelsPerMeter = dE;
        this.euler0 = new Kt(0, 0, 0, "YXZ");
        this.position0Cam = new _;
        this.quat0Cam = new je;
        this.scale0Cam = new _;
        this.hiddenMatrix0Cam = new te;
        this.threshEndTranslate = .01;
        this.threshEndRotate = 1e-8;
        this.threshEndRotVel = .005;
        this.collider = {
            type: "capsule",
            radius: 40,
            segment: new xi(new _(0, -40, 0), new _(0, 40, 0)),
            matrix: new te,
            position: new _,
            rotation: new je
        };
        this.euler = new Kt(0, 0, 0, "YXZ");
        this.eulerDelta = new _;
        this.lastPosition = new _;
        this.lastCameraQuaternion = new je;
        this.lastCameraPosition = new _;
        this.PI_2 = Math.PI / 2;
        this.prevMouse = new N;
        this.velocityTarget = new _;
        this.velocity = new _;
        this.directionXZ = new _;
        this.rotVelocityStick = new _;
        this.rotVelocityTarget = new _;
        this.rotVelocity = new _;
        this.rotDirection = new _;
        this.nonColliderRotOffset = new te;
        this.nonColliderPosOffset = new te;
        this.firstPointerId = -1;
        this.rot = new _;
        this.path = [];
        this.movementState = {
            moveNegZ: 0,
            movePosZ: 0,
            moveNegX: 0,
            movePosX: 0,
            moveNegY: 0,
            movePosY: 0,
            rotPosX: 0,
            rotNegX: 0,
            rotPosY: 0,
            rotNegY: 0,
            jump: 0,
            run: 0
        };
        this.vrEulerYOffset = 0;
        this.onObject = !1;
        this.actionState = {};
        this.keyAssignments = [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "ArrowUp"
            ],
            [
                "rotPosY",
                "ArrowLeft"
            ],
            [
                "rotNegX",
                "ArrowDown"
            ],
            [
                "rotNegY",
                "ArrowRight"
            ],
            [
                "jump",
                " "
            ]
        ];
        this.collisionEnabled = !0;
        this.offsetMatrix = new te;
        this.objectToTarget = new _;
        this.objectToTarget0 = new _;
        this.objectToCamXZ = new _;
        this.objectToCamXZ0 = new _;
        this.targetToCamera = new _;
        this.targetToCamera0 = new _;
        this.cameraPolarAxis0 = new _;
        this.targetPos = new _;
        this.targetQuat = new je;
        this.lerpFactorPos = new _().setScalar(.3);
        this.lerpFactorPosStart = .3;
        this.lerpFactorPosEnd = .3;
        this.lerpFactorRotStart = .3;
        this.lerpFactorRotEnd = .3;
        this.lerpFactorPosCamera = .3;
        this.lerpFactorRotCamera = .3;
        this.objXZQuat = new je;
        this.objXZQuatInv = new je;
        this.objXZRotMat = new te;
        this.isFirstPerson = !1;
        this.didHit = !1;
        this.groundVelocity = new _;
        this.pushedVelocity = new _;
        this.groundYRotation = 0;
        this.objectRealQuat = new je;
        this.colliderWorldQuat = new je;
        this.groundNormal = new _;
        this.groundTilt = new je;
        this.groundTiltInv = new je;
        this.lastHitObj = null;
        this.isFirstFrame = !0;
        this.rotationAccumWhenOrientWithCamera = 0;
        this.navMeshPathDest = null;
        this.position = new _;
        this.quaternion = new je;
        this.scale = new _;
        this.initialAction = !0;
        this.onPointerDown = (e)=>{
            e.target !== this.domElement || this.firstPointerId !== -1 || (this.firstPointerId = e.pointerId, this.domElement.ownerDocument.addEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.addEventListener("pointerup", this.onPointerUp), this.rotBy !== "keys" && !Si && (!Iw || Rw >= 15.5) && this.domElement.requestPointerLock(), this.prevMouse.set(e.clientX, e.clientY));
        };
        this.onPointerUp = (e)=>{
            this.firstPointerId = -1, this.domElement.ownerDocument.removeEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this.onPointerUp), e.pointerType === "mouse" && this.domElement.ownerDocument.exitPointerLock();
        };
        this.onPointerMove = (e)=>{
            if (e.pointerId !== this.firstPointerId) return;
            let r = e.clientX - this.prevMouse.x, i = e.clientY - this.prevMouse.y;
            this.prevMouse.set(e.clientX, e.clientY), e.pointerType === "mouse" && this.rotBy !== "keys" && (Iw && Rw < 15.5 && !Si ? (this.eulerDelta.y = -r * this.mouseOrbitSensitivity, this.eulerDelta.x = -i * this.mouseOrbitSensitivity) : (this.eulerDelta.y = -e.movementX * this.mouseOrbitSensitivity, this.eulerDelta.x = -e.movementY * this.mouseOrbitSensitivity)), e.pointerType !== "mouse" && this.rotByTouch === "drag" && (this.eulerDelta.y = -r * this.mouseOrbitSensitivity * 5, this.eulerDelta.x = -i * this.mouseOrbitSensitivity * 5), this.controlsManager.requestRender();
        };
        this.onPointerlockChange = (e)=>{
            this.domElement.ownerDocument.pointerLockElement === this.domElement ? ob.isLocked = !0 : ob.isLocked = !1;
        };
        this.onPointerlockError = ()=>{
            console.error("SPE.GameControls: Unable to use Pointer Lock API");
        };
        this.handleVisibilityChange = ()=>{
            if (document?.hidden) for(let e in this.movementState)this.movementState[e] = 0;
        };
        this.onKeyDown = (e)=>{
            !(e.target instanceof HTMLInputElement) && (e.code === "ArrowLeft" || e.code === "ArrowUp" || e.code === "ArrowRight" || e.code === "ArrowDown" || e.code === "Space") && e.preventDefault();
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1]) {
                this.movementState[r[0]] = 1;
                break;
            }
            this.controlsManager.requestRender();
        };
        this.onKeyUp = (e)=>{
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1] || e.code.slice(3, e.code.length).toUpperCase() === r[1]) {
                this.movementState[r[0]] = 0;
                break;
            }
        };
        this.copyVRGamePadValues = (e, r)=>{
            for(let i = 2; i < 4; i++){
                let s = e.axes[i];
                r === 0 ? i === 2 ? this.movementState.movePosX = s : this.movementState.movePosZ = s : (e.buttons[3].pressed ? this.movementState.jump = 1 : this.movementState.jump = 0, i === 2 ? (Math.abs(this.movementState.rotPosY) < .3 && Math.abs(s) >= .3 && (this.vrEulerYOffset += s < 0 ? 1 : -1), this.movementState.rotPosY = s) : this.moveMode === "fly" && (this.movementState.moveNegY = s));
            }
        };
        this.sharedGameControlGlobals = o.sharedGameControlGlobals, e === l && (this.isFirstPerson = !0), this.hiddenMatrix0.copy(this.object.hiddenMatrix), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.euler0.setFromQuaternion(this.quaternion, "YXZ");
        let d = this.euler0.clone(), h = d.y;
        if (this.objectRealQuat.copy(this.quaternion), d.y = 0, this.quaternion.setFromEuler(d), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), d.set(0, h, 0), this.quaternion.setFromEuler(d), this.rot.setFromEuler(d), this.object.matrixAutoUpdate = !1, (this.isFirstPerson || this.cameraFollow === !0) && (this.target0.copy(this.camera.getTarget()), this.zoom0 = this.camera.zoom), this.cameraFollow === !0) {
            this.position0Cam.copy(this.camera.position), this.quat0Cam.copy(this.camera.quaternion), this.scale0Cam.copy(this.camera.scale), this.hiddenMatrix0Cam.copy(this.camera.hiddenMatrix), this.camera.parent ? (this.camera.hiddenMatrix.copy(this.camera?.parent.matrixWorld), this.camera.matrix.copy(this.camera.matrixWorld)) : this.camera.hiddenMatrix.identity(), this.camera.matrix.copy(this.camera.matrixWorld), this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale), this.camera.matrixAutoUpdate = !1, this.offsetMatrix.copy(this.object.matrix).invert().multiply(this.camera.matrix);
            let g = new _(0, 0, -1).applyQuaternion(this.camera.quaternion), y = new _().subVectors(this.position, this.camera.position);
            this.objectToCamXZ.copy(y), this.objectToCamXZ.y = 0, this.objectToCamXZ0.copy(this.objectToCamXZ);
            let v, x;
            Math.abs(g.y) < 1e-6 ? (y.y = 0, g.y = 0, x = y.projectOnVector(g)) : y.y / g.y > 0 ? x = g.multiplyScalar(y.y / g.y) : x = g.multiplyScalar(y.length()), this.targetToCamera0.copy(x).negate(), v = this.camera.position.clone().add(x), this.objectToTarget0.subVectors(v, this.position);
            let S = new Kt().setFromQuaternion(this.camera.quaternion, "YXZ");
            this.cameraPolarOffset = -S.x, S.x = 0, S.z = 0, S.y -= Math.PI / 2, this.cameraPolarAxis0.set(0, 0, -1).applyEuler(S);
        }
        if (this.object instanceof hr && (this.object.matrixAutoUpdate = !1), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.rotByTouch = i.rotByTouch ?? "joystick", this.rotBy = i.rotBy ?? "keys", this.rotationMode = i.rotationMode ?? "normal", this.moveMode = i.moveMode ?? "walk", this.collisionEnabled = i.collisionEnabled, this.speedTranslate = (i.speedTranslate ?? 250) * TZ, this.speedOrbit = (i.speedRotate ?? 100) * MZ, this.mouseOrbitSensitivity = (i.speedRotate ?? 100) * CZ, this.keyAssignments = i.keyAssignments.map((g)=>{
            let y = [
                g[0],
                g[1]
            ];
            return y[1] === "\u25B2" ? y[1] = "ArrowUp" : y[1] === "\u25C0" ? y[1] = "ArrowLeft" : y[1] === "\u25BC" ? y[1] = "ArrowDown" : y[1] === "\u25B6" ? y[1] = "ArrowRight" : y[1] === "\u21E7" ? y[1] = "Shift" : y[1] === "\u21B5" ? y[1] = "Enter" : y[1] === "Space" ? y[1] = " " : y[1] === "\u2318" ? y[1] = "Meta" : y[1] === "Ctrl" ? y[1] = "Control" : y[1] === "Esc" && (y[1] = "Escape"), y;
        }), i.rotBy === "mouse") {
            let g;
            g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosY"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegY"), g !== -1 && (this.keyAssignments[g][1] = "");
        }
        this.lerpFactorPosStart = 1 - .02 ** (1 / ((i.delayPos[0] ?? .3) * 60)), this.lerpFactorPosEnd = 1 - .02 ** (1 / ((i.delayPos[1] ?? .3) * 60)), this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.lerpFactorRotStart = 1 - .02 ** (1 / ((i.delayRot[0] ?? .3) * 60)), this.lerpFactorRotEnd = 1 - .02 ** (1 / ((i.delayRot[1] ?? .3) * 60)), this.lerpFactorPosCamera = 1 - .02 ** (1 / ((i.delayPosCamera ?? .3) * 60)), this.lerpFactorRotCamera = 1 - .02 ** (1 / ((i.delayRotCamera ?? .3) * 60)), this.gravity = (this.gloabalPhysics.gravity ?? wl.defaultData.gravity) * QB, this.usePhysics = this.gloabalPhysics.usePhysics ?? wl.defaultData.usePhysics, this.jumpPower = i.jumpPower * PZ, this.resetYPosition = this.position.y + Math.abs(i.resetYPosition) * (this.gravity > 0 ? 1 : -1), this.alignToGround = i.alignToGround ?? !1, this.orientMode = i.autoOrientMove ? i.orientMode : "none", this.orientWith = i.orientWith ?? Qd.defaultDataThirdPerson.orientWith, this.slopeThresh = SZ * Math.PI / 180, i.collider.type === "capsule" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = i.collider.height / 2 - i.collider.radius, this.collider.segment.end.y = -this.collider.segment.start.y, this.offset = i.collider.height * lE / this.pixelsPerMeter, this.stepThresh = i.collider.height * cE / this.pixelsPerMeter, this.colliderHeight = i.collider.height) : i.collider.type === "sphere" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = 0, this.collider.segment.end.y = 0, this.offset = 2 * i.collider.radius * lE / this.pixelsPerMeter, this.stepThresh = 2 * i.collider.radius * cE / this.pixelsPerMeter, this.colliderHeight = i.collider.radius * 2) : (this.offset = i.collider.height * lE / this.pixelsPerMeter, this.stepThresh = i.collider.height * cE / this.pixelsPerMeter, this.colliderHeight = i.collider.height), this.collider.type = i.collider.type;
        let f = new _().fromArray(i.collider.position), p = new je().setFromEuler(new Kt().fromArray([
            ...i.collider.rotation,
            "XYZ"
        ]));
        this.collider.position.copy(f).multiply(this.scale), this.collider.rotation.copy(p), this.collider.matrix.compose(f, p, XB), i.cameraXAxis !== void 0 && (this.cameraXAxis = i.cameraXAxis, this.cameraYAxis = i.cameraYAxis, this.minPolarAngle = i.cameraRotXLimits[0], this.maxPolarAngle = i.cameraRotXLimits[1], this.minAzimuthAngleRel = i.cameraRotYLimits[0], this.maxAzimuthAngleRel = i.cameraRotYLimits[1]), this.forwardDir = i.forwardDirection ?? "-z", this.runMultiplier = i.runMultiplier ?? 2;
        let m = i.navmesh.destinationHelperRadius * 2;
        if (m > 0) {
            let g = new Re;
            g.push({
                fi: 0,
                data: {
                    ...Ir.defaultData("light", "phong"),
                    alpha: 0
                },
                id: "layer1"
            }), g.push({
                fi: 0,
                data: {
                    ...Ir.defaultData("color"),
                    color: i.navmesh.destinationHelperColor,
                    alpha: i.navmesh.destinationHelperColor.a
                },
                id: "layer2"
            });
            let y = new Pa({
                layers: g
            }, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
            this.navMeshPathDest = new rr(m0.create({
                parameters: {
                    width: m,
                    height: m / 10,
                    hollow: .7
                }
            }), y), this.navMeshPathDest.material.userData.opacity0 = i.navmesh.destinationHelperColor.a;
        }
        this.activate();
    }
    reset(e = !1) {
        if (this.object.hiddenMatrix.copy(this.hiddenMatrix0), e) {
            this.object.updateMatrix(), this.object.updateMatrixWorld(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity();
            let r = new Kt().setFromQuaternion(this.quaternion, "YXZ"), i = r.y;
            this.objectRealQuat.copy(this.quaternion), r.y = 0, this.quaternion.setFromEuler(r), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), r.set(0, i, 0), this.quaternion.setFromEuler(r), this.rot.setFromEuler(r), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.velocityTarget.set(0, 0, 0), this.velocity.set(0, 0, 0);
        } else this.object instanceof hr ? this.object.matrixAutoUpdate = !0 : this.object.updateMatrix();
        this.cameraFollow === !0 && (this.camera.quaternion.copy(this.quat0Cam), this.camera.position.copy(this.position0Cam), this.camera.scale.copy(this.scale0Cam), this.camera.hiddenMatrix.copy(this.hiddenMatrix0Cam), this.camera.matrixAutoUpdate = !0), this.controlsManager.requestRender();
    }
    activate() {
        this.instantiateActions(), this.domElement.ownerDocument.addEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.addEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.addEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.addEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.addEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    deactivate() {
        this.disposeActions(), this.domElement.ownerDocument.removeEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.removeEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.removeEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.removeEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.removeEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    dispose() {
        this.deactivate(), this.navMeshPathDest?.parent && this.page.remove(this.navMeshPathDest);
    }
    instantiateActions() {
        let e = this.data, r = this.sharedAssets;
        e.gameActions !== void 0 && (this.actions = {}, Xd.list.forEach((i)=>{
            this.actions[i] = gr({
                ...e,
                disabled: !1,
                type: "GameControl"
            }, e.gameActions[i], this.page, r, this.controlsManager.eventManager, this.object);
        })), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"), this.initialAction && (this.initialAction = !1);
    }
    disposeActions() {
        this.initialAction = !1, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), tr(this.actions.idle), tr(this.actions.move), tr(this.actions.run), tr(this.actions.jump);
    }
    dispatchStartEvent(e) {
        this.actions[e] !== void 0 && (this.actionState[e] || (this.actionState[e] = !0, this.actions[e].Transition.forEach((r)=>{
            r.play();
        }), this.actions[e].Animation.forEach((r)=>{
            r.play(this.initialAction === !1);
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStart();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("start");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("start");
        })));
    }
    dispatchStopEvent(e) {
        this.actions[e] !== void 0 && (!this.actionState[e] || (this.actionState[e] = !1, this.actions[e].Transition.forEach((r)=>{
            r.stop(), r.object.currentState !== null && r.object.changeSelectedState(null, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStop();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("stop");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("stop");
        })));
    }
    get colliderWorldPosition() {
        return _n.copy(this.collider.position).applyQuaternion(this.objectRealQuat).add(this.position);
    }
    update(e, r, i) {
        if (this.gravity < 0 ? this.position.y < this.resetYPosition : this.position.y > this.resetYPosition) return this.reset(!0), !0;
        this.sharedGameControlGlobals.gamePads.forEach(this.copyVRGamePadValues);
        let s = (this.isFirstFrame ? 16.6 : e) / 1e3;
        this.isFirstFrame && (this.isFirstFrame = !1);
        let o = s * 60, a = !1;
        if (this.usePhysics && this.collisionEnabled) {
            let u = kn.set(0, (this.velocity.y === 0 ? this.pixelsPerMeter * Math.max(Math.abs(this.gravity) / (10 * QB), 1) * (this.gravity > 0 ? 1 : -1) : this.velocity.y) * s, 0).divideScalar(this.pixelsPerMeter), c = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter), this.colliderWorldQuat, u, this.object.rigidBody?.collider(0).shape, 1, !1, 16, void 0, void 0, this.object.rigidBody);
            if (c) {
                this.onObject = !0, this.groundNormal.set(c.normal2.x, c.normal2.y, c.normal2.z).applyQuaternion(this.colliderWorldQuat).negate(), this.alignToGround && this.groundTiltAdjustment(this.groundNormal), Math.acos(this.groundNormal.y) < this.slopeThresh && (a = !0), c.collider.parent()?.bodyType() === 0 && Math.acos(this.groundNormal.y) * (180 / Math.PI) > 45 && (this.onObject = !1);
                let d = c.collider.parent();
                this.groundYRotation = 0, this.groundVelocity.set(0, 0, 0);
                for (let h of this.sharedGameControlGlobals.entitiesWithTransformAnim)if (h.rigidBody === d && h.userData.isFollowingObj !== this.object.uuid) {
                    (h.hasNonUniformScale ? h.matrixWorldRigid : h.matrixWorld).decompose(_n, Fa, kn), this.groundVelocity.subVectors(_n, h.prevT), this.object.getWorldPosition(kn).add(this.collider.position).sub(_n), this.groundYRotation = Ho.setFromQuaternion(Fa).y - h.prevR.y, Ql.copy(kn).applyAxisAngle(ro, this.groundYRotation), this.groundVelocity.add(Ql.sub(kn)).divideScalar(s);
                    break;
                }
            } else this.onObject = !1;
        }
        if (this.moveMode === "walk" && this.collisionEnabled && (this.movementState.jump === 1 && this.onObject && (this.velocityTarget.y = this.jumpPower, this.movementState.jump = 0, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("jump"), this.onObject = !1), this.onObject ? this.velocityTarget.y /= 2 : this.velocityTarget.y += this.gravity * o), this.moveMode === "fly" && (this.velocityTarget.y = (this.movementState.movePosY - this.movementState.moveNegY) * this.speedTranslate), this.directionXZ.z = this.movementState.movePosZ - this.movementState.moveNegZ, this.directionXZ.x = this.movementState.movePosX - this.movementState.moveNegX, this.forwardDir === "+z" && this.directionXZ.multiplyScalar(-1), this.directionXZ.manhattanLength() > 0 && (this.path = []), this.navMeshPathDest) {
            let u = this.navMeshPathDest.material;
            if (this.moveMode === "walk" && this.path.length > 1) {
                this.navMeshPathDest.position.copy(this.path[this.path.length - 1]), this.navMeshPathDest.parent || this.page.add(this.navMeshPathDest);
                let c = _n.subVectors(this.path[1], this.position), d = kn.subVectors(this.path[1], this.path[0]);
                c.dot(d) < 0 ? this.path.shift() : (this.directionXZ.x = d.x, this.directionXZ.z = d.z), u.opacity = u.userData.opacity0;
            } else u.opacity -= .05 * u.userData.opacity0, this.navMeshPathDest.material.opacity <= 0 && this.navMeshPathDest.parent && this.page.remove(this.navMeshPathDest);
        }
        this.directionXZ.normalize(), this.movementState.run ? this.moveForce = this.runMultiplier : this.moveForce = 1, this.velocityTarget.z = this.directionXZ.z * this.speedTranslate * this.moveForce, this.velocityTarget.x = this.directionXZ.x * this.speedTranslate * this.moveForce, (this.moveMode === "walk" ? this.velocityTarget.x + this.velocityTarget.z === 0 : this.velocityTarget.manhattanLength() === 0) ? this.lerpFactorPos.setScalar(this.lerpFactorPosEnd) : this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.moveMode === "walk" && (this.lerpFactorPos.y = 1), this.didHit === !1 && this.pushedVelocity.manhattanLength() === 0 || this.usePhysics === !1 ? (this.velocity.x += (this.velocityTarget.x - this.velocity.x) * (1 - (1 - this.lerpFactorPos.x) ** o), this.velocity.y += (this.velocityTarget.y - this.velocity.y) * (1 - (1 - this.lerpFactorPos.y) ** o), this.velocity.z += (this.velocityTarget.z - this.velocity.z) * (1 - (1 - this.lerpFactorPos.z) ** o)) : this.velocity.copy(this.velocityTarget), (this.moveMode === "walk" ? this.velocity.x ** 2 + this.velocity.z ** 2 < this.speedTranslate : this.velocity.lengthSq() < this.speedTranslate) ? (this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.onObject && (this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"))) : (this.dispatchStopEvent("idle"), this.onObject && (this.dispatchStopEvent("jump"), this.movementState.run ? (this.dispatchStopEvent("move"), this.dispatchStartEvent("run")) : (this.dispatchStopEvent("run"), this.dispatchStartEvent("move"))));
        let l = wZ.copy(this.velocity);
        if (this.orientMode !== "none" && this.isFirstPerson === !1) {
            let u = kn.copy(l);
            u.y = 0, l.set(0, l.y, u.length() * (this.forwardDir === "+z" ? 1 : -1));
        }
        if (this.directionXZ.manhattanLength() > 0 && this.orientMode !== "none") {
            if (this.orientWith === "camera" && this.path.length <= 1) {
                let u = _n;
                this.camera.getWorldDirection(u);
                let c = Ql.copy(ro).multiplyScalar(u.dot(ro));
                u.sub(c);
                let d = kn.copy(this.directionXZ);
                d.x *= -1, this.rot.y = u.angleTo(d) * (u.cross(d).y > 0 ? -1 : 1) + this.rotationAccumWhenOrientWithCamera;
            } else this.rot.y = (this.path.length > 1 ? 0 : this.euler.y) + Math.atan2(-this.directionXZ.z, this.directionXZ.x) + Math.PI / 2 * (this.forwardDir === "+z" ? 1 : -1);
        }
        if (Ho.setFromVector3(this.rot), this.moveMode === "walk" && (Ho.x = 0), l.applyEuler(Ho), a && (Fa.setFromUnitVectors(ro, this.groundNormal), l.applyQuaternion(Fa)), i) {
            let u = Ho.set(0, this.vrEulerYOffset * KB, 0);
            i.applyEuler(u), l.x += i.x, l.z += i.z, this.nonColliderPosOffset.elements[13] += i.y * s;
        }
        if (this.usePhysics === !0) {
            let u = kn;
            this.pushedVelocity.set(0, 0, 0);
            for (let c of this.sharedGameControlGlobals.entitiesWithTransformAnim){
                let d = Ql.setFromMatrixPosition(c.matrixWorld).sub(c.prevT).divideScalar(s).divideScalar(this.pixelsPerMeter), h = c.rigidBody.collider(0).castCollider(d, this.object.rigidBody.collider(0), _n.copy(l).divideScalar(this.pixelsPerMeter), s, !1);
                d.multiplyScalar(this.pixelsPerMeter);
                let f = ut.is(c) ? c : c.object;
                if (h !== null && this.lastHitObj !== f) {
                    let p;
                    c instanceof Pr && (p = c);
                    let m = this.sharedGameControlGlobals.entityToCollisionEvents[f.uuid];
                    if (m) for (let g of m)g.data.target === "character" && (g.dispatch(p), f.dispatchEvent(ab));
                    this.lastHitObj = f;
                }
                if (h !== null) {
                    this.pushedVelocity.copy(d), u.copy(h.normal1).applyQuaternion(c.quaternion);
                    break;
                }
            }
            if (this.pushedVelocity.manhattanLength() !== 0) {
                let c = u.dot(l);
                c < 0 && l.addScaledVector(u, -c), l.add(this.pushedVelocity);
            } else l.add(this.groundVelocity);
        }
        if (this.rotDirection.y = Number(this.movementState.rotPosY) - Number(this.movementState.rotNegY), this.rotDirection.x = Number(this.movementState.rotPosX) - Number(this.movementState.rotNegX), this.rotDirection.normalize(), this.rotationMode === "normal" && (this.movementState.rotPosX || this.movementState.rotNegX) || this.rotationMode === "steer" && (this.movementState.rotPosX || this.movementState.rotNegX) && (this.movementState.movePosZ || this.movementState.moveNegZ || this.moveMode === "walk") ? this.rotVelocityStick.x = -this.rotDirection.x * this.speedOrbit * this.rotForce : this.rotVelocityStick.x = 0, this.rotationMode === "normal" && (this.movementState.rotPosY || this.movementState.rotNegY) || this.rotationMode === "steer" && (this.movementState.rotPosY || this.movementState.rotNegY) && (this.movementState.movePosZ || this.movementState.moveNegZ) ? this.rotVelocityStick.y = -this.rotDirection.y * this.speedOrbit * this.rotForce : this.rotVelocityStick.y = 0, this.rotVelocityTarget.subVectors(this.eulerDelta.divideScalar(s), this.rotVelocityStick), this.rotVelocityTarget.manhattanLength() === 0 ? this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotEnd) ** o) : this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotStart) ** o), this.euler.x += this.rotVelocity.x * s, this.euler.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y === 0 && this.directionXZ.manhattanLength() === 0 ? this.rotationAccumWhenOrientWithCamera = 0 : (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.rotationAccumWhenOrientWithCamera += this.rotVelocity.y * s), this.isFirstPerson === !1 && this.orientMode !== "none" && this.directionXZ.manhattanLength() > 0) {
            if (this.orientMode === "radial") {
                this.objectToCamXZ.copy(this.objectToCamXZ0).applyAxisAngle(ro, this.euler.y - this.euler0.y);
                let u = kn.copy(this.objectToCamXZ).normalize(), c = Ql.copy(l).multiplyScalar(s);
                c.y = 0;
                let d = c.sub(_n.copy(u).multiplyScalar(c.dot(u))).cross(u).y;
                this.euler.y -= Math.atan2(d, this.objectToCamXZ.length());
            }
        } else this.rot.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y !== 0 && (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.euler.y = this.rot.y);
        if (this.cameraFollow === !0 && (this.moveMode === "walk" ? this.cameraXAxis === "Limit" ? this.euler.x = Se.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : this.euler.x = Se.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset, this.PI_2 + this.cameraPolarOffset) : this.cameraXAxis === "Limit" && (this.euler.x = Se.clamp(this.euler.x, -this.PI_2, this.PI_2))), this.moveMode === "fly" ? this.rot.x = this.euler.x : this.isFirstPerson && (r ? (Ho.copy(r), Ho.y = 0) : (Ho.copy(this.euler), Ho.y = 0), this.nonColliderRotOffset.makeRotationFromEuler(Ho)), r && (this.moveMode === "walk" ? (this.rot.y = r.y, this.rot.x = 0, this.rot.z = 0) : this.rot.setFromEuler(r), this.rot.y += this.vrEulerYOffset * KB), to.setFromAxisAngle(_Z, this.rot.x), Fa.setFromAxisAngle(ro, this.rot.y), Fa.multiply(to), to.setFromAxisAngle(EZ, this.rot.z), Fa.multiply(to), this.quaternion.copy(Fa), this.objectRealQuat.multiplyQuaternions(this.quaternion, this.objXZQuat), this.objectRealQuat.multiply(this.objXZQuat), this.colliderWorldQuat.copy(this.objectRealQuat).multiply(this.collider.rotation), this.collisionEnabled) {
            if (this.usePhysics) {
                let u = kn.copy(l).multiplyScalar(s / this.pixelsPerMeter), c = null;
                this.didHit = !1;
                let d = new _;
                for(let h = 0; h < 5; h++){
                    let f = u.length(), p = Ql.copy(u).normalize();
                    if (c = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(d), this.colliderWorldQuat, p, this.object.rigidBody?.collider(0).shape, f, !1, 24, void 0, void 0, this.object.rigidBody), c !== null) {
                        this.didHit = !0;
                        let m = this.sharedGameControlGlobals.colliderToEntity.get(c.collider.handle);
                        if (m !== this.lastHitObj && h === 0) {
                            this.lastHitObj = m;
                            let x = this.sharedGameControlGlobals.entityToCollisionEvents[m?.uuid];
                            if (x) {
                                for (let S of x)if (S.data.target === "character") {
                                    let w = (this.sharedGameControlGlobals.rapierWorld?.getCollider(c.collider.handle))._parent, A;
                                    if (m.cloner) {
                                        for (let E of m.cloner.children)if (E.rigidBody === w) {
                                            A = E;
                                            break;
                                        }
                                    }
                                    S.dispatch(A), m.dispatchEvent(ab);
                                }
                            }
                        }
                        let g = WB.set(c.normal2.x, c.normal2.y, c.normal2.z).applyQuaternion(this.colliderWorldQuat), y = qB.copy(p).multiplyScalar(c.toi).dot(g), v = c.toi;
                        if (v === 0 && (this.position.y += this.offset * this.pixelsPerMeter), y > this.offset && (v = c.toi * (y - this.offset) / y, d.addScaledVector(p, v)), u.copy(p).multiplyScalar(f - v), Math.acos(-g.y) > this.slopeThresh) {
                            let x = this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(d), S = Ql.copy(c.witness2).applyQuaternion(this.colliderWorldQuat);
                            S.y = 0;
                            let w = x.add(S);
                            w.y += this.stepThresh;
                            let A = this.sharedGameControlGlobals.rapierWorld.castShape(w, this.colliderWorldQuat, u, this.object.rigidBody?.collider(0).shape, 1, !1, 24, void 0, void 0, this.object.rigidBody);
                            A !== null && A.toi === 0 && (g.y = 0, g.normalize());
                        }
                        u.addScaledVector(g, -u.dot(g));
                    } else {
                        h === 0 && this.directionXZ.manhattanLength() !== 0 && (this.lastHitObj = null), d.add(u);
                        break;
                    }
                }
                this.position.addScaledVector(d, this.pixelsPerMeter), this.object.rigidBody?.setTranslation(_n.copy(this.position).divideScalar(this.pixelsPerMeter), !0), this.object.rigidBody?.setRotation(to.copy(this.quaternion).premultiply(this.groundTilt).multiply(this.objXZQuat), !0);
            } else {
                let u = this.onObject ? 1 : 5, c = l.multiplyScalar(s / u);
                for(let d = 0; d < u; d++)this.position.add(c), this.collisionAdjustment(s / u);
            }
        } else this.position.addScaledVector(l, s);
        if (this.moveMode === "walk" && this.onObject && (this.velocityTarget.y = 0, this.velocity.y = 0), this.quaternion.premultiply(this.groundTilt).multiply(this.objXZQuat), this.object.matrix.compose(this.position, this.quaternion, this.scale), this.object.matrixWorldNeedsUpdate = !0, this.object.matrix.multiply(this.nonColliderPosOffset).multiply(this.nonColliderRotOffset), this.quaternion.premultiply(this.groundTiltInv).multiply(this.objXZQuatInv), this.cameraFollow === !0) {
            this.updateFollowArms();
            let u = this.objectToTarget.add(this.position), c = this.targetToCamera.add(u);
            uE.lookAt(c, u, ro).setPosition(c), uE.decompose(this.targetPos, this.targetQuat, _n), this.camera.quaternion.slerp(this.targetQuat, 1 - (1 - this.lerpFactorRotCamera) ** o), this.camera.position.lerp(this.targetPos, 1 - (1 - this.lerpFactorPosCamera) ** o), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.cameraYAxis === "Limit" && this.orientMode === "cartesian" && (this.euler.y = Se.clamp(this.euler.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel)), this.euler.x = Se.clamp(this.euler.x, -this.PI_2 + (this.cameraPolarOffset < 0 ? this.cameraPolarOffset : 0), this.PI_2 + (this.cameraPolarOffset > 0 ? this.cameraPolarOffset : 0));
        }
        return this.eulerDelta.set(0, 0, 0), this.object.dispatchEvent(OZ), this.path.length < 2 && this.lastPosition.distanceToSquared(this.position) < this.threshEndTranslate && Math.abs(this.rotVelocity.x) < this.threshEndRotVel && Math.abs(this.rotVelocity.y) < this.threshEndRotVel && (this.camera === void 0 || this.isFirstPerson || this.lastCameraPosition.distanceToSquared(this.camera.position) < this.threshEndTranslate && 8 * (1 - this.lastCameraQuaternion.dot(this.camera.quaternion)) < this.threshEndRotate) && (this.moveMode === "fly" || this.onObject === !0 || this.collisionEnabled === !1) && (this.navMeshPathDest === null || this.navMeshPathDest.material.opacity < -0.04 * this.navMeshPathDest?.material?.userData.opacity0) ? !1 : (this.camera && (this.lastCameraPosition.copy(this.camera.position), this.lastCameraQuaternion.copy(this.camera.quaternion)), this.lastPosition.copy(this.position), this.object.dispatchEvent(DZ), !0);
    }
    updateFollowArms() {
        this.objectToTarget.copy(this.objectToTarget0), this.targetToCamera.copy(this.targetToCamera0);
        let e = to.setFromAxisAngle(ro, this.cameraYAxis === "Limit" && this.orientMode !== "radial" ? Se.clamp(this.euler.y - this.euler0.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel) : this.euler.y - this.euler0.y);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && this.objectToTarget.applyQuaternion(e);
        let r;
        this.cameraXAxis === "Limit" ? r = Se.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : r = Se.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset + 1e-6, this.PI_2 + this.cameraPolarOffset - 1e-6);
        let i = _n.copy(this.cameraPolarAxis0);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && i.applyQuaternion(e);
        let s = Fa.setFromAxisAngle(i, r);
        this.cameraYAxis !== "Locked" && this.targetToCamera.applyQuaternion(e), this.cameraXAxis !== "Locked" && this.targetToCamera.applyQuaternion(s);
    }
    groundTiltAdjustment(e) {
        ro.angleTo(e) * 180 / Math.PI < 15 || ro.angleTo(e) * 180 / Math.PI > 85 ? to.identity() : to.setFromUnitVectors(ro, e), this.groundTilt.slerp(to, .06), this.groundTiltInv.copy(this.groundTilt).invert();
    }
    collisionAdjustment(e) {
        let r = qB.set(0, 0, 0);
        this.object.matrix.compose(this.position, this.quaternion, this.scale);
        let i = uE.multiplyMatrices(this.object.matrix, this.objXZRotMat).multiply(this.collider.matrix).decompose(_n, to, kn).compose(_n, to, XB);
        this.sharedGameControlGlobals.entitiesWithTransformAnim.forEach((o)=>{
            if (o === this.object || o.isDescendantOf(this.object)) return;
            Es.makeEmpty(), o.updateMatrixWorldSVD();
            let a = o.matrixWorldRigid, l = YB.copy(a).invert(), u = AZ.copy(YB).multiply(i);
            Hi.copy(this.collider.segment), Hi.start.applyMatrix4(u), Hi.end.applyMatrix4(u);
            let c = WB.copy(this.position).applyMatrix4(l);
            Es.expandByPoint(Hi.start), Es.expandByPoint(Hi.end), Es.min.addScalar(-this.collider.radius), Es.max.addScalar(this.collider.radius), o.bvhGeometry.boundsTree.shapecast({
                traverseBoundsOrder (d) {
                    return d.distanceToPoint(Hi.end);
                },
                intersectsBounds: (d)=>d.intersectsBox(Es),
                intersectsTriangle: (d)=>{
                    let h = _n, f = kn, p = d.closestPointToSegment(Hi, h, f);
                    if (p < this.collider.radius) {
                        let m = this.collider.radius - p, g = f.sub(h).normalize(), y = Ql.copy(c);
                        y.addScaledVector(g, m);
                        let v = y.applyMatrix4(a).sub(this.position);
                        r.add(v), Hi.start.addScaledVector(g, m), Hi.end.addScaledVector(g, m);
                    }
                }
            });
        }), Es.makeEmpty(), Hi.copy(this.collider.segment), Hi.start.applyMatrix4(i), Hi.end.applyMatrix4(i), Es.expandByPoint(Hi.start), Es.expandByPoint(Hi.end), Es.min.addScalar(-this.collider.radius), Es.max.addScalar(this.collider.radius), this.sharedGameControlGlobals.staticMeshBVH?.shapecast({
            traverseBoundsOrder (o) {
                return o.distanceToPoint(Hi.end);
            },
            intersectsBounds: (o)=>o.intersectsBox(Es),
            intersectsTriangle: (o)=>{
                let a = _n, l = kn, u = o.closestPointToSegment(Hi, a, l);
                if (u < this.collider.radius) {
                    let c = this.collider.radius - u, d = l.sub(a).normalize();
                    this.alignToGround && this.groundTiltAdjustment(d), r.addScaledVector(d, c), Hi.start.addScaledVector(d, c), Hi.end.addScaledVector(d, c);
                }
            }
        }), this.onObject = Math.abs(r.y) > Math.abs(e * this.velocity.y * .25), this.onObject && this.dispatchStopEvent("jump");
        let s = Math.max(0, r.length() - 1e-5);
        r.normalize().multiplyScalar(s), this.position.add(r);
    }
}, dg = ob;
dg.isLocked = !1;
var ZB = Pi(F1());
function io(n1, t) {
    let e = new we;
    if (!n1.getAttribute("position")) return e.setAttribute("position", new be([], 3)), e.setIndex([]), e;
    let { positions: r, triIndices: i } = Fc(n1.getAttribute("position"), n1.getIndex());
    return e.setAttribute("position", new be(r, 3)), e.setIndex(i), t && e.applyMatrix4(t), e;
}
var IZ = new te, RZ = new te, Wo = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
function hE(n1) {
    let t = n1.elements;
    Wo[0][0] = t[0], Wo[0][1] = t[4], Wo[0][2] = t[8], Wo[1][0] = t[1], Wo[1][1] = t[5], Wo[1][2] = t[9], Wo[2][0] = t[2], Wo[2][1] = t[6], Wo[2][2] = t[10];
    let { u: e, v: r } = (0, ZB.SVD)(Wo), i = IZ.set(e[0][0], e[0][1], e[0][2], 0, e[1][0], e[1][1], e[1][2], 0, e[2][0], e[2][1], e[2][2], 0, 0, 0, 0, 1), s = RZ.set(r[0][0], r[0][1], r[0][2], 0, r[1][0], r[1][1], r[1][2], 0, r[2][0], r[2][1], r[2][2], 0, 0, 0, 0, 1);
    return i.multiply(s.transpose());
}
var lb = class extends Yu {
    constructor(){
        super(), this.layers.enable(3), this.layers.enable(8);
    }
    setFromCamera(t, e) {
        e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : e.isPerspectiveCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : console.error("Raycaster: Unsupported camera type.");
    }
    intersectVisibleObjects(t, e = !0, r = []) {
        return t.forEach((i)=>{
            i.visible && this.intersectObject(i, e, r);
        }), r;
    }
    createRaycastLineHelper() {
        let t = new ns({
            color: 65280,
            linewidth: 10
        }), e = new _(this.ray.origin.x, this.ray.origin.y, this.ray.origin.z), r = new _(this.ray.direction.x, this.ray.direction.y, this.ray.direction.z), i = this.camera.far - this.camera.near, s = new _().addVectors(e, r.multiplyScalar(i)), o = new we;
        return o.setFromPoints([
            e,
            s
        ]), new pc(o, t);
    }
};
var JB = (n1)=>n1 instanceof Ss || n1 instanceof Js;
function LZ(n1, t) {
    return n1.distance - t.distance;
}
function $B(n1, t, e) {
    if (!(!Mo(t) || !t.visible)) {
        sn(t) && t.raycast(n1, e);
        for (let r of t.children)$B(n1, r, e);
    }
}
function Lf(n1, t, e, r = !1) {
    if (!r && !e.some((s)=>Bf(n1, s) !== void 0)) return [];
    let i = [];
    return t.children.forEach((s)=>$B(n1, s, i)), i.sort(LZ), i;
}
function hg(n1) {
    let t = [];
    if (n1.length) {
        let e = n1[0].object;
        Mo(e) && t.push(e);
        let r = e.parent;
        for(; r;)JB(r) && t.push(r), r = r.parent;
    }
    return t;
}
function no(n1, t, e, r) {
    let i = n1.frame;
    if (i) {
        let s = t[0] * i.width, o = (1 - t[1]) * i.height;
        for (let a of e){
            let l = a === i.uuid ? i : i.find(a);
            if (l?.intersects(s, o)) return r(l), !0;
        }
    }
    return !1;
}
function Bf(n1, t) {
    if (sn(t)) {
        if (t.visible) {
            let e = [];
            return t.raycast(n1, e), e.length ? e[0] : void 0;
        }
    } else if (JB(t)) return eN(n1, t);
}
function eN(n1, t) {
    if (!(!Mo(t) || !t.visible)) {
        if (sn(t)) {
            let e = [];
            if (t.raycast(n1, e), e.length) return e[0];
        }
        for (let e of t.children){
            let r = eN(n1, e);
            if (r) return r;
        }
    }
}
function BZ(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width * 2 - 1,
        y: -((t - (e.top + window.scrollY)) / e.height) * 2 + 1
    };
}
function NZ(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width,
        y: 1 - (t - (e.top + window.scrollY)) / e.height
    };
}
var cb = class {
    constructor(t, e, r, i, s, o, a, l){
        this.renderer = t;
        this.publish = e;
        this.scene = r;
        this.getCamera = i;
        this.sharedAssets = s;
        this.requestRender = o;
        this.isExport = a;
        this.frame = l;
        this.raycaster = new lb;
        this._useWindowEvents = !1;
        this.pointerWorld = {
            x: 0,
            y: 0
        };
        this.pointerScreen = {
            x: 0,
            y: 0
        };
        this._useWindowEvents = e.mouseEventTarget === "window", this.domElement = t.domElement, this.eventElement = this._useWindowEvents ? window : t.domElement, this._domRect = this.domElement.getBoundingClientRect();
    }
    get stopRaycast() {
        return this.publish.stopRaycast;
    }
    get page() {
        return this.scene.activePage;
    }
    set useWindowEvents(t) {
        this._useWindowEvents = t, this.eventElement = t ? window : this.renderer.domElement;
    }
    get useWindowEvents() {
        return this._useWindowEvents;
    }
    set domRect(t) {
        this._domRect = t;
    }
    get domRect() {
        return this._domRect;
    }
    updateRaycaster(t) {
        let { pageX: e, pageY: r } = t.touches?.length > 0 ? t.touches[0] : t;
        this.pointerWorld = BZ(e, r, this._domRect), this.pointerScreen = NZ(e, r, this._domRect), this.raycaster.setFromCamera(this.pointerWorld, this.getCamera());
    }
};
var Dr = class {
    constructor(t){
        this.eventContext = t;
        this.domEventsNeeded = new Set;
        this.hasVideoAction = !1;
    }
    connect() {}
    disconnect() {}
};
var fE = [
    [
        "start",
        "Start"
    ],
    [
        "keyDown",
        "KeyDown"
    ],
    [
        "keyUp",
        "KeyUp"
    ],
    [
        "mouseDown",
        "MouseDown"
    ],
    [
        "mouseUp",
        "MouseUp"
    ],
    [
        "mouseHover",
        "MouseHover"
    ],
    [
        "collision",
        "Collision"
    ],
    [
        "lookAt",
        "LookAt"
    ],
    [
        "follow",
        "Follow"
    ],
    [
        "scroll",
        "Scroll"
    ]
], tN = (n1)=>fE.find(([t, e])=>e === n1)?.[0], qo = (n1)=>fE.find(([t])=>t === n1)?.[1], FZ = (n1, t)=>{
    let e = tN(n1);
    if (e) {
        let r = new CustomEvent(e, {
            bubbles: !0
        });
        return Object.defineProperty(r, "target", {
            writable: !1,
            value: t
        }), r;
    }
}, ub = class extends Dr {
    constructor(e){
        super(e);
        this.objectsPerEvents = new Map;
        this.splineEvents = {};
        this.onBeginEvent = (e)=>{
            if (!e.eventName || !e.target || e.eventName === "Scroll") return;
            let r = this.splineEvents[tN(e.eventName)]?.[e.target.uuid];
            if (!r) return;
            e.eventName === "Scroll" && e.deltaY !== void 0 && Object.assign(r, {
                deltaY: e.deltaY
            });
            let { domElement: i } = this.eventContext;
            i.dispatchEvent(r);
        };
        let { page: r } = this.eventContext;
        r.traverseEntity((i)=>{
            if (!!i.data?.events.length) {
                for (let [s, o] of fE)if (i.data.events.some((a)=>a.data.type === o && !a.data.disabled)) {
                    this.objectsPerEvents.has(s) ? this.objectsPerEvents.get(s)?.push(i) : this.objectsPerEvents.set(s, [
                        i
                    ]);
                    let a = {
                        id: i.uuid,
                        name: i.name
                    }, l = FZ(o, a), u = this.splineEvents[s];
                    u ? u[i.uuid] = l : this.splineEvents[s] = {
                        [i.uuid]: l
                    };
                }
            }
        });
    }
    connect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((r)=>{
                r.addEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
    disconnect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((r)=>{
                r.removeEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
};
var pE = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        this.alreadyPlayedNonTogglingActions = new Set;
        if (this.useToggle = e.runMode === "Toggle", (e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress") && !e.key) throw new Error("Missing property");
        this.actions = gr(e, e.actions, i, s, o, r);
    }
    disconnect() {
        tr(this.actions);
    }
    dispatchHeld(t) {
        this.actions.Create.forEach((e)=>{
            t && e.dispatchThrottled.cancel(), e.dispatchThrottled();
        });
    }
    dispatch(t = !1) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this ? (e.object.currentTransitionEvent = this, e.init()) : this.data.runMode === "Once" && this.alreadyPlayedNonTogglingActions.add(e);
        }), this.useToggle ? (this.actions.Transition.forEach((e)=>{
            e.toggle();
        }), this.actions.Animation.forEach((e)=>{
            e.toggle();
        }), this.actions.SwitchCamera.forEach((e)=>{
            e.toggle();
        })) : this.data.type === "MousePress" || this.data.type === "KeyPress" ? this.entered || (this.entered = !0, this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatchStart())) : (this.actions.Transition.some((i)=>i.playing) || this.actions.Transition.forEach((i)=>{
            this.alreadyPlayedNonTogglingActions.has(i) === !1 && i.play();
        }), this.actions.SwitchCamera.some((i)=>i.playing) || this.actions.SwitchCamera.forEach((i)=>{
            i.play();
        }), this.actions.Animation.forEach((i)=>{
            i.play();
        })), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), t === !1 && this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
    dispatchRelease() {
        this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.Animation.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()), this.actions.Create.forEach((t)=>t.dispatchStop()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
}, db = class extends Dr {
    constructor(e, r, i){
        super(e);
        this.useForRaycastProperty = i;
        this.objectsPerTypes = {
            MouseDown: [],
            MouseUp: [],
            MousePress: [],
            KeyDown: [],
            KeyUp: [],
            KeyPress: []
        };
        this.canvasMouseEvents = [];
        this.eventsPerObjects = {
            MouseDown: {},
            MouseUp: {},
            MousePress: {},
            KeyDown: {},
            KeyUp: {},
            KeyPress: {}
        };
        this.heldKeys = {};
        this.heldKeysPress = {};
        this._prevObjects = [];
        this.sceneInterects = null;
        this.onCanvasRaycast = (e)=>{
            if (this.useForRaycastProperty === !0 && this.sceneInterects === null) {
                this.eventContext.updateRaycaster(e);
                let { raycaster: r, page: i } = this.eventContext, s = Lf(r, i, [], !0);
                this.sceneInterects = s, s.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: s[0].point.x,
                    y: s[0].point.y,
                    z: s[0].point.z,
                    objX: s[0].object.matrixWorld.elements[12],
                    objY: s[0].object.matrixWorld.elements[13],
                    objZ: s[0].object.matrixWorld.elements[14]
                });
            }
        };
        this.onCanvasMouseDown = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                (r.data.type === "MouseDown" || r.data.type === "MousePress") && (this.onCanvasRaycast(e), r.dispatch());
            });
        };
        this.onCanvasMouseUp = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                r.data.type === "MouseUp" ? (this.onCanvasRaycast(e), r.dispatch()) : r.data.type === "MousePress" && r.dispatchRelease();
            });
        };
        this.onMouseDown = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseDown"));
        };
        this.onMouseUp = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseUp"));
        };
        this.onMousePressDown = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent());
        };
        this.onMousePressRelease = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent(!0));
        };
        this.onKeyDown = (e)=>{
            this.heldKeys[e.key] || (this.handleKeyEvent(e, "KeyDown"), this.handleKeyEventHeld(e, "KeyDown", !0)), this.heldKeys[e.key] = !0;
        };
        this.onKeyUp = (e)=>{
            this.handleKeyEvent(e, "KeyUp"), this.handleKeyEventHeld(e, "KeyUp", !0);
        };
        this.onKeyPressDown = (e)=>{
            this.heldKeysPress[e.key] ? this.handleKeyEventHeld(e, "KeyPress") : (this.handleKeyEvent(e, "KeyPress"), this.handleKeyEventHeld(e, "KeyPress", !0)), this.heldKeysPress[e.key] = !0;
        };
        this.onKeyPressUp = (e)=>{
            this.handleKeyEvent(e, "KeyPress", !0);
        };
        this.releaseHeldKey = (e)=>{
            delete this.heldKeys[e.key];
        };
        this.releaseHeldKeyPress = (e)=>{
            delete this.heldKeysPress[e.key];
        };
        this._onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = qo(e);
            s && (s === "MouseDown" || s === "MouseUp" || s === "MousePress" ? (r.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent(i);
            })) : (s === "KeyDown" || s === "KeyUp" || s === "KeyPress") && (r.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent();
            })));
        };
        let { page: s, sharedAssets: o } = this.eventContext, a = (l, u)=>{
            if (!l.data?.events.length) return;
            let c = [
                "MouseDown",
                "MouseUp",
                "MousePress",
                "KeyDown",
                "KeyUp",
                "KeyPress"
            ];
            for (let d of c){
                let h = this.eventsPerObjects[d];
                l.data.events.filter(({ data: f })=>f.type === d && f.disabled !== !0).forEach(({ id: f, data: p })=>{
                    try {
                        let m = new pE(f, p, l, s, o, r);
                        m.actions.Video.length && (this.hasVideoAction = !0), (p.type === "MouseDown" || p.type === "MouseUp" || p.type === "MousePress") && (p.mode === "Canvas" || p.mode === "Window") ? this.canvasMouseEvents.push(m) : h[l.uuid] ? h[l.uuid].push(m) : h[l.uuid] = [
                            m
                        ];
                    } catch (m) {}
                }), h[l.uuid]?.length && this.objectsPerTypes[d].push(l instanceof jt && (d === "MouseDown" || d === "MouseUp" || d === "MousePress") ? u : l);
            }
        };
        s.traverseEntity((l)=>{
            (l instanceof fr || l instanceof sr) && l.frame?.traverse((u)=>{
                a(u, l);
            }), a(l);
        });
    }
    connect() {
        let { domElement: e } = this.eventContext;
        this.heldKeys = {}, this.heldKeysPress = {}, this.domEventsNeeded.clear(), e.addEventListener("pointerdown", this.onCanvasMouseDown), e.addEventListener("pointerup", this.onCanvasMouseUp), (this.objectsPerTypes.MouseDown?.length || this.useForRaycastProperty) && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseDown)), this.objectsPerTypes.MouseUp?.length && (this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMouseUp)), this.objectsPerTypes.MousePress?.length && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMousePressDown), this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMousePressRelease)), this.objectsPerTypes.KeyDown?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.releaseHeldKey)), this.objectsPerTypes.KeyUp?.length && (this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyUp)), this.objectsPerTypes.KeyPress?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyPressDown), document.addEventListener("keyup", this.releaseHeldKeyPress), this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyPressUp)), Object.entries(this.objectsPerTypes).forEach(([r, i])=>{
            i.forEach((s)=>{
                s.addEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    disconnect() {
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), this.heldKeys = {}, this.heldKeysPress = {}, e.removeEventListener("pointerdown", this.onCanvasMouseDown), e.removeEventListener("pointerup", this.onCanvasMouseUp), e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerdown", this.onMousePressDown), e.removeEventListener("pointerup", this.onMouseUp), e.removeEventListener("pointerup", this.onMousePressRelease), document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keydown", this.onKeyPressDown), document.removeEventListener("keyup", this.onKeyPressUp), document.removeEventListener("keyup", this.releaseHeldKey), Object.values(this.eventsPerObjects).forEach((r)=>{
            Object.values(r).forEach((i)=>{
                i.forEach((s)=>{
                    s.disconnect();
                });
            });
        }), this.canvasMouseEvents.forEach((r)=>{
            r.disconnect();
        }), Object.entries(this.objectsPerTypes).forEach(([r, i])=>{
            i.forEach((s)=>{
                s.removeEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    handleMouseEvent(e) {
        let { stopRaycast: r, raycaster: i, page: s, pointerScreen: o } = this.eventContext, a = this.objectsPerTypes[e], l = a.filter((u)=>!(u instanceof jt));
        if (!(!a.length && !this.useForRaycastProperty) && !(s.uiCanvas && no(s, [
            o.x,
            o.y
        ], Object.keys(this.eventsPerObjects[e]), (c)=>{
            this.handleObjectMouseEventDispatch(c, e);
        }))) {
            if (r || this.useForRaycastProperty) {
                let u;
                if (this.sceneInterects === null ? u = Lf(i, s, l, this.useForRaycastProperty) : (u = this.sceneInterects, this.sceneInterects = null), this.useForRaycastProperty && u.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: u[0].point.x,
                    y: u[0].point.y,
                    z: u[0].point.z,
                    objX: u[0].object.matrixWorld.elements[12],
                    objY: u[0].object.matrixWorld.elements[13],
                    objZ: u[0].object.matrixWorld.elements[14]
                }), r) {
                    let c = [
                        u[0]?.uv?.x ?? 0,
                        u[0]?.uv?.y ?? 0
                    ];
                    hg(u).forEach((d)=>{
                        d instanceof fr && no(d, c, Object.keys(this.eventsPerObjects[e]), (h)=>{
                            this.handleObjectMouseEventDispatch(h, e);
                        }), this.eventsPerObjects[e][d.uuid] && this.handleObjectMouseEventDispatch(d, e);
                    });
                }
            }
            r || l.forEach((u)=>{
                let c = Bf(i, u);
                c && (this.handleObjectMouseEventDispatch(u, e), u instanceof fr && no(u, [
                    c?.uv?.x ?? 0,
                    c?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects[e]), (d)=>{
                    this.handleObjectMouseEventDispatch(d, e);
                }));
            });
        }
    }
    handleMousePressEvent(e = !1) {
        let r = "MousePress", i = this.objectsPerTypes[r], s = i.filter((a)=>!(a instanceof jt)), o = [];
        if (!!i.length) {
            if (!e) {
                let { stopRaycast: a, raycaster: l, page: u, pointerScreen: c } = this.eventContext, d = !1;
                if (u.uiCanvas && (d = no(u, [
                    c.x,
                    c.y
                ], Object.keys(this.eventsPerObjects[r]), (h)=>{
                    o.push(h);
                })), a && !d) {
                    let h = Lf(l, u, s);
                    o = hg(h), h.forEach((f)=>{
                        f.object instanceof fr && no(f.object, [
                            f?.uv?.x ?? 0,
                            f?.uv?.y ?? 0
                        ], Object.keys(this.eventsPerObjects[r]), (p)=>{
                            o.push(p);
                        });
                    });
                } else s.forEach((h)=>{
                    let f = Bf(l, h);
                    f && (o.push(h), h instanceof fr && no(h, [
                        f?.uv?.x ?? 0,
                        f?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects[r]), (p)=>{
                        o.push(p);
                    }));
                });
            }
            this._prevObjects.length && this._prevObjects.forEach((a)=>{
                o.includes(a) || this.handleObjectMouseEventDispatchRelease(a, r);
            }), o.length && o.forEach((a)=>{
                this.handleObjectMouseEventDispatch(a, r);
            }), this._prevObjects = o;
        }
    }
    handleObjectMouseEventDispatch(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatch();
        });
    }
    handleObjectMouseEventDispatchRelease(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatchRelease();
        });
    }
    handleKeyEvent(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s)=>{
            let o = this.eventsPerObjects[r][s.uuid];
            o.some(({ data: a })=>"key" in a && a.key === e.key) && s.dispatchEvent({
                type: "beginEvent",
                eventName: r
            }), o.forEach((a)=>{
                "key" in a.data && a.data.key === e.key && (i ? a.dispatchRelease() : a.dispatch(!0));
            });
        });
    }
    handleKeyEventHeld(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s)=>{
            this.eventsPerObjects[r][s.uuid].forEach((a)=>{
                "key" in a.data && a.data.key === e.key && a.dispatchHeld(i);
            });
        });
    }
};
var kZ = new _, zZ = new _;
var hb = class {
    constructor(t, e, r, i, s){
        this.actionsIn = gr(t, t.inActions, r, i, s, e), this.actionsOut = gr(t, t.outActions, r, i, s, e);
    }
    disconnect() {
        tr(this.actionsIn), tr(this.actionsOut);
    }
};
var mE = class extends hb {
    constructor(e, r, i, s, o, a){
        super(r, i, s, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.stage = "out";
        this.objects = [];
        this.onUpdateMatrixWorld = ()=>{
            for (let s of this.objects)if (!s.visible) return;
            let e = kZ.setFromMatrixPosition(this.objects[0].matrixWorld), r = zZ.setFromMatrixPosition(this.objects[1].matrixWorld), i = e.distanceTo(r) <= this.distance ? "in" : "out";
            if (this.stage !== i) {
                this.stage = i;
                let s = i === "in" ? this.actionsIn : this.actionsOut;
                s.Audio.forEach((o)=>o.dispatchConditional()), s.Particles.forEach((o)=>o.dispatchConditional()), s.Video.forEach((o)=>o.dispatchConditional()), s.Link.forEach((o)=>o.dispatch()), s.Create.forEach((o)=>o.dispatch()), s.Destroy.forEach((o)=>o.dispatch()), s.Reset.forEach((o)=>o.dispatch()), s.Transition.forEach((o)=>{
                    o.object.currentTransitionEvent !== this && (o.object.currentTransitionEvent = this), o.init();
                }), s.Transition.forEach((o)=>o.play()), s.Animation.forEach((o)=>o.play()), s.SwitchCamera.forEach((o)=>o.play()), s.SceneTransition.forEach((o)=>o.dispatch()), s.SetVariable.forEach((o)=>o.checkConditions()), s.SetVariable.forEach((o)=>o.dispatch()), s.DynamicVariablePlay.forEach((o)=>o.dispatch());
            }
        };
        let { distance: l, fromObject: u, toObject: c } = r.condition;
        this.distance = l;
        for (let d of [
            u,
            c
        ]){
            if (!d) throw new Error("Missing property");
            let h = s.find(d);
            if (!h) throw new Error("Missing property");
            this.objects.push(h);
        }
    }
    connect() {
        window.setTimeout(()=>{
            this.objects.forEach((e)=>{
                e.addEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
            }), this.onUpdateMatrixWorld();
        }, 0);
    }
    disconnect() {
        super.disconnect(), this.stage = "out", this.objects.forEach((e)=>{
            e.removeEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
        });
    }
}, gE = class extends hb {
    constructor(e, r, i, s, o, a){
        super(r, i, s, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.onBegin = ({ target: e, state: r })=>{
            this.toState !== r && (this.actionsOut.Audio.forEach((i)=>i.dispatchConditional()), this.actionsOut.Particles.forEach((i)=>i.dispatchConditional()), this.actionsOut.Video.forEach((i)=>i.dispatchConditional()), this.actionsOut.Link.forEach((i)=>i.dispatch()), this.actionsOut.Create.forEach((i)=>i.dispatch()), this.actionsOut.Destroy.forEach((i)=>i.dispatch()), this.actionsOut.Reset.forEach((i)=>i.dispatch()), this.actionsIn.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsOut.Transition.forEach((i)=>i.play()), this.actionsOut.Animation.forEach((i)=>i.play()), this.actionsIn.SwitchCamera.forEach((i)=>i.pause()), this.actionsOut.SwitchCamera.forEach((i)=>i.play()), this.actionsOut.SceneTransition.forEach((i)=>i.dispatch()), this.actionsOut.SetVariable.forEach((i)=>i.checkConditions()), this.actionsOut.SetVariable.forEach((i)=>i.dispatch()), this.actionsOut.DynamicVariablePlay.forEach((i)=>i.dispatch()));
        };
        this.onComplete = ({ target: e, state: r })=>{
            this.toState === r && (this.actionsIn.Audio.forEach((i)=>i.dispatchConditional()), this.actionsIn.Particles.forEach((i)=>i.dispatchConditional()), this.actionsIn.Video.forEach((i)=>i.dispatchConditional()), this.actionsIn.Link.forEach((i)=>i.dispatch()), this.actionsIn.Create.forEach((i)=>i.dispatch()), this.actionsIn.Destroy.forEach((i)=>i.dispatch()), this.actionsIn.Reset.forEach((i)=>i.dispatch()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsIn.Transition.forEach((i)=>i.play()), this.actionsIn.Animation.forEach((i)=>i.play()), this.actionsOut.SwitchCamera.forEach((i)=>i.pause()), this.actionsIn.SwitchCamera.forEach((i)=>i.play()), this.actionsIn.SceneTransition.forEach((i)=>i.dispatch()), this.actionsIn.SetVariable.forEach((i)=>i.checkConditions()), this.actionsIn.SetVariable.forEach((i)=>i.dispatch()), this.actionsIn.DynamicVariablePlay.forEach((i)=>i.dispatch()));
        };
        let { condition: l } = r;
        if (!l.object) throw new Error("Missing property");
        let u = s.find(l.object) ?? s.scene.find2D(l.object);
        if (!u) throw new Error("Missing property");
        if (this.toObject = u, l.state && !this.toObject.states?.[l.state]) throw new Error("Missing property");
        this.toState = l.state;
    }
    connect() {
        as(this.actionsOut).forEach((e)=>{
            this.actionsOut[e]?.length && this.toObject.addEventListener("beginState", this.onBegin);
        }), as(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.addEventListener("completeState", this.onComplete);
        });
    }
    disconnect() {
        super.disconnect(), as(this.actionsOut).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("beginState", this.onBegin);
        }), as(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("completeState", this.onComplete);
        });
    }
}, fb = class extends Dr {
    constructor(e, r){
        super(e);
        this.eventsPerConditions = {
            Comparison: [],
            Distance: [],
            State: []
        };
        this.hasVideoAction = !1;
        let { page: i, sharedAssets: s } = this.eventContext;
        i.traverseEntity((o)=>{
            if (!!o.data?.events.length) {
                for (let { id: a, data: l } of o.data.events)if (!l.disabled && l.type === "Conditional") try {
                    let u;
                    l.condition.type === "Comparison" || (l.condition.type === "Distance" ? u = new mE(a, l, o, i, s, r) : l.condition.type === "State" && (u = new gE(a, l, o, i, s, r))), u && (this.eventsPerConditions[l.condition.type].push(u), (u.actionsIn.Video.length || u.actionsOut.Video.length) && (this.hasVideoAction = !0));
                } catch (u) {}
            }
        });
    }
    connect() {
        super.connect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((r)=>r.connect()));
    }
    disconnect() {
        super.disconnect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((r)=>r.disconnect()));
    }
};
var fg = new _, Kl = new _, ou = new _, rN = new qr, VZ = .01, Xt = new _, Ti = new _, iN = new _, au = new je, yE = new Kt, UZ = new te, vE = new Qt, Nf = new _, Yo = new _, Ff = .2;
function xE(n1, t) {
    !t || (t[0] < t[1] && (n1.x = Math.min(Math.max(n1.x, t[0]), t[1])), t[2] < t[3] && (n1.y = Math.min(Math.max(n1.y, t[2]), t[3])), t[4] < t[5] && (n1.z = Math.min(Math.max(n1.z, t[4]), t[5])));
}
var GZ = function() {
    let n1 = new te;
    return (t, e, r)=>{
        let i = t.obj;
        n1.copy(i.hiddenMatrix), i.parent !== null && n1.premultiply(i.parent.matrixWorld), n1.invert(), i.position.copy(e), t.reference === "global" && xE(i.position, t.limits), i.position.applyMatrix4(n1), t.reference === "parent" ? xE(i.position, t.limits) : t.reference === "local" && (au.copy(t.quat0).invert(), i.position.sub(t.position0), i.position.applyQuaternion(au), xE(i.position, t.limits), au.invert(), i.position.applyQuaternion(au), i.position.add(t.position0)), n1.multiply(r ?? i.matrixWorld).decompose(Xt, i.quaternion, Ti), i.updateMatrix(), i.hasNonUniformScale && (i.updateMatrixWorld(), i.updateMatrixWorldSVD()), i instanceof nr && An(i.parent) && i.invalidateDownstreamBooleanData(!0);
    };
}(), bE = class {
    constructor(t, e, r, i, s, o){
        this.object = t;
        this.data = e;
        this.dropDestIds = [];
        this.activeIdx = null;
        this.wasDragEventTriggered = !1;
        this.resetDampingFactor = this.data.resetSpeed === 0 ? 1 : 8 / this.data.resetSpeed + 1, this.snapDampingFactor = this.data.snapSpeed === 0 ? 1 : 8 / this.data.snapSpeed + 1, this.actionsDrag = gr(e, e.dragDropActions.drag, r, i, s, this.object), this.actionsDrop = gr(e, e.dragDropActions.drop, r, i, s, this.object);
        let a = [];
        this.data.objects.forEach((l)=>{
            let u = r.find(l);
            !u || u.data.visible !== !1 && (a.push(u), o[u.uuid] && o[u.uuid].forEach((c)=>{
                let d = r.find(c);
                !d || d.data.visible !== !1 && a.push(d);
            }));
        }), this.data.dropDestinations.forEach((l)=>{
            let u = r.find(l);
            !u || u.data.visible !== !1 && (this.dropDestIds.push(u.uuid), o[u.uuid] && o[u.uuid].forEach((c)=>{
                let d = r.find(c);
                !d || d.data.visible !== !1 && this.dropDestIds.push(d.uuid);
            }));
        }), this.dragItems = a.map((l)=>(this.data.planeMode === "locked" && (l.userData.lockedPlane = !0), l.userData.worldPosition0 = new _().setFromMatrixPosition(l.matrixWorld), {
                obj: l,
                fromPosition: new _().setFromMatrixPosition(l.matrixWorld),
                pointStart: new _,
                pointEnd: new _,
                paused: !0,
                currentDampingFactor: this.data.dampingFactor,
                reset: !1,
                position0: new _().copy(l.position),
                quat0: new je().copy(l.quaternion),
                snapped: !1,
                orientationMatrix: new te,
                limits: this.data.limits,
                reference: this.data.referenceFrame
            }));
    }
    get activeDragItem() {
        return this.activeIdx !== null ? this.dragItems[this.activeIdx] : null;
    }
    dispose() {
        tr(this.actionsDrag), tr(this.actionsDrop), this.dragItems.forEach((t)=>{
            t.fromPosition.copy(t.obj.userData.worldPosition0), t.pointStart.copy(t.fromPosition), t.pointEnd.copy(t.pointStart), t.obj.recursiveBBoxNeedsUpdate = !0, t.obj.userData.lockedPlane = void 0, t.obj.position.copy(t.position0), t.obj.quaternion.copy(t.quat0), t.obj.updateMatrix();
        });
    }
}, pb = class extends Dr {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.lastDropDestination = null;
        this.dragTimeout = null;
        this.onPointerDown = (e)=>{
            if (Ye.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s = i.raycastWithClones(r);
            if (this.lastDropDestination = null, s.length === 0) {
                this.activeEvent = null;
                return;
            }
            for (let o of this.events){
                let a = 0;
                for (let { obj: l, pointEnd: u, pointStart: c } of o.dragItems){
                    if (l === s[0].object || l === s[0].object.object || ut.is(l) && l.isAncestorOf(s[0].object.uuid)) {
                        if (o.activeIdx = a, o.activeDragItem.reset = !1, o.activeDragItem.currentDampingFactor = o.data.dampingFactor, o.activeDragItem.snapped = !1, o.data.cursor === "hand" && this.setCursor("grabbing"), this.eventManager.controlsManager.usePhysics) {
                            o.activeDragItem.obj.rigidBody && o.activeDragItem.obj.rigidBody.setBodyType(2, !0);
                            let d = o.activeDragItem.obj;
                            l.hasNonUniformScale && l.updateMatrixWorldSVD(), (d.hasNonUniformScale ? d.matrixWorldRigid : d.matrixWorld).decompose(Xt, au, Ti), yE.setFromQuaternion(au), d.prevR === void 0 ? (d.prevR = yE.clone(), d.prevT = Xt.clone()) : (d.prevR.copy(yE), d.prevT.copy(Xt)), this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.push(o.activeDragItem.obj);
                        }
                        this.calcPlaneIntersectPos(l, c, o.data.plane, o.data.referenceFrame), u.copy(c), (this.eventManager.controlsManager.usePhysics && l.data.physics?.rigidBody === "dynamic" || o.data.drop === !1 || o.data.resetOnSnapFail === !1) && o.activeDragItem.fromPosition.setFromMatrixPosition(o.activeDragItem.obj.matrixWorld), this.activeEvent = o, this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !1);
                        return;
                    }
                    a++;
                }
            }
            this.activeEvent = null;
        };
        this.onPointerMove = (e)=>{
            if (Ye.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s = i.raycastWithClones(r);
            if (Ye.length === 0) {
                let o = !1;
                for (let a of this.events){
                    for (let { obj: l } of a.dragItems)if (l === s[0]?.object || l === s[0]?.object?.object || ut.is(l) && l.isAncestorOf(s[0]?.object.uuid)) {
                        switch(o = !0, a.data.cursor){
                            case "hand":
                                this.setCursor("grab");
                                break;
                            case "move":
                                this.setCursor("move");
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    if (o) break;
                }
                o || this.setCursor("default");
                return;
            }
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                let o = this.activeEvent.activeDragItem;
                o.snapped = !1;
                let a;
                if (this.activeEvent.data.drop && (a = s.filter((l)=>o.obj !== l.object && !o.obj.isAncestorOf(l.object.uuid) && !(l.object instanceof Ss) && (this.activeEvent.data.dropOn === "all" || this.activeEvent.dropDestIds.some((u)=>u === l.object.uuid || i.scene.find(u).isAncestorOf(l.object.uuid))))[0]), a) {
                    let l = iN.copy(a.face.normal).applyMatrix3(vE.getNormalMatrix(a.object.matrixWorld));
                    if (this.activeEvent.data.snapTo === "center") o.fromPosition.setFromMatrixPosition(a.object.matrixWorld);
                    else if (this.activeEvent.data.snapTo === "surface") {
                        if (o.fromPosition.copy(a.point), this.activeEvent.data.snapSurfaceMode === "bbox") {
                            Xt.copy(l).applyMatrix3(vE.setFromMatrix4(o.obj.matrixWorld).transpose());
                            let u = o.obj;
                            Xt.x > Ff ? Ti.x = -u.recursiveBBox.min.x : Xt.x < -Ff && (Ti.x = -u.recursiveBBox.max.x), Xt.y > Ff ? Ti.y = -u.recursiveBBox.min.y : Xt.y < -Ff && (Ti.y = -u.recursiveBBox.max.y), Xt.z > Ff ? Ti.z = -u.recursiveBBox.min.z : Xt.z < -Ff && (Ti.z = -u.recursiveBBox.max.z), Ti.applyMatrix3(vE.invert());
                        } else Ti.copy(l).multiplyScalar(this.activeEvent.data.snapSurfaceOffset);
                        o.fromPosition.add(Ti);
                    }
                    this.activeEvent.data.autoOrient && (Xt.set(0, 1, 0).cross(l), Xt.length() < 1e-4 && Xt.set(-1, 0, 0).cross(l), Ti.crossVectors(iN, Xt), o.orientationMatrix.makeBasis(Xt, Ti, l)), o.pointStart.copy(o.fromPosition), o.pointEnd.copy(o.pointStart), o.currentDampingFactor = this.activeEvent.snapDampingFactor, o.snapped = !0, this.lastDropDestination !== a.object && (this.lastDropDestination = a.object, this.activeEvent.actionsDrop.Transition.forEach((u)=>{
                        u.play();
                    }), this.activeEvent.actionsDrop.Animation.forEach((u)=>{
                        u.play();
                    }), this.activeEvent.actionsDrop.Audio.forEach((u)=>{
                        u.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Particles.forEach((u)=>{
                        u.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Create.forEach((u)=>{
                        u.dispatchThrottled();
                    }));
                } else o.orientationMatrix.makeRotationFromQuaternion(o.quat0), this.lastDropDestination = null, o.currentDampingFactor = this.activeEvent.data.dampingFactor, this.calcPlaneIntersectPos(o.obj, o.pointEnd, this.activeEvent.data.plane, this.activeEvent.data.referenceFrame), this.activeEvent.actionsDrop.Transition.forEach((l)=>{
                    l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrop.Animation.forEach((l)=>{
                    l.stop();
                }), this.activeEvent.actionsDrop.Audio.forEach((l)=>{
                    l.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.Particles.forEach((l)=>{
                    l.dispatchGameControl("stop");
                });
                this.activeEvent.actionsDrag.Create.forEach((l)=>{
                    l.dispatchThrottled();
                }), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.checkConditions()), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.DynamicVariablePlay.forEach((l)=>l.dispatch()), this.activeEvent.wasDragEventTriggered === !1 && (this.activeEvent.wasDragEventTriggered = !0, this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                    l.dispatchGameControl("start");
                }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                    l.dispatchGameControl("start");
                })), this.dragTimeout && window.clearTimeout(this.dragTimeout), this.dragTimeout = window.setTimeout(()=>{
                    !this.activeEvent || (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                        l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                            scene: this.eventContext.page.scene,
                            shared: this.eventContext.sharedAssets
                        });
                    }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                        l.stop();
                    }));
                }, 500), this.updateDragItem(o), o.obj.dispatchEvent({
                    type: "requestRender"
                });
            }
        };
        this.onPointerUp = (e)=>{
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                this.activeEvent.data.cursor === "hand" && this.setCursor("grab");
                let r = this.activeEvent.activeDragItem.obj.data.physics?.rigidBody === "dynamic";
                this.activeEvent.activeDragItem.snapped === !1 && this.activeEvent.data.drop && this.activeEvent.data.resetOnSnapFail && (this.eventManager.controlsManager.usePhysics === !1 || !r) && (this.activeEvent.activeDragItem.reset = this.activeEvent.data.resetOnSnapFail, this.activeEvent.activeDragItem.paused = !1, this.activeEvent.activeDragItem.currentDampingFactor = this.activeEvent.resetDampingFactor), this.eventManager.controlsManager.usePhysics && r && (this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.pop(), this.activeEvent.activeDragItem.obj.rigidBody.setBodyType(0, !0), this.activeEvent.activeDragItem.paused = !0), this.activeEvent.wasDragEventTriggered === !0 && (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Transition.forEach((i)=>{
                    i.stop(), i.object.currentState !== null && i.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrag.Animation.forEach((i)=>{
                    i.stop();
                }), this.activeEvent.actionsDrag.Audio.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrag.Particles.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.checkConditions()), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.DynamicVariablePlay.forEach((i)=>i.dispatch())), this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !0);
            }
        };
        let i = {};
        e.page.traverseEntity((s)=>{
            s.component && (i[s.component.uuid] ? i[s.component.uuid].push(s.uuid) : i[s.component.uuid] = [
                s.uuid
            ]);
        }), e.page.traverseEntity((s)=>{
            s.data?.events.filter((o)=>o.data.type === "DragDrop" && !o.data.disabled).forEach((o)=>{
                this.events.push(new bE(s, o.data, e.page, e.sharedAssets, r, i));
            });
        });
    }
    connect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear(), this.domEventsNeeded.add("pointerdown");
        let e = this.eventContext.domElement;
        e.addEventListener("pointerdown", this.onPointerDown), e.addEventListener("pointermove", this.onPointerMove), e.addEventListener("pointerup", this.onPointerUp), this.domEventsNeeded.add("pointermove");
    }
    disconnect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear();
        let e = this.eventContext.domElement;
        e.removeEventListener("pointerdown", this.onPointerDown), e.removeEventListener("pointermove", this.onPointerMove), e.removeEventListener("pointerup", this.onPointerUp), this.events.forEach((r)=>r.dispose());
    }
    setCursor(e) {
        this.eventContext.domElement.style.cursor = e;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)for (let r of e.dragItems)r.paused || this.updateDragItem(r, !0);
    }
    calcPlaneIntersectPos(e, r, i, s) {
        let { getCamera: o, raycaster: a } = this.eventContext;
        o().getWorldDirection(Kl), Kl.negate();
        let l = au.identity();
        switch(s === "parent" ? UZ.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix).decompose(Xt, l, Ti) : s === "local" && e.matrixWorld.decompose(Xt, l, Ti), i){
            case "x":
                Xt.set(1, 0, 0).applyQuaternion(l), Nf.copy(Kl).cross(Xt), Yo.copy(Xt).cross(Nf);
                break;
            case "y":
                Xt.set(0, 1, 0).applyQuaternion(l), Nf.copy(Kl).cross(Xt), Yo.copy(Xt).cross(Nf);
                break;
            case "z":
                Xt.set(0, 0, 1).applyQuaternion(l), Nf.copy(Kl).cross(Xt), Yo.copy(Xt).cross(Nf);
                break;
            case "xy":
                Yo.set(0, 0, 1).applyQuaternion(l);
                break;
            case "yz":
                Yo.set(1, 0, 0).applyQuaternion(l);
                break;
            case "xz":
                Yo.set(0, 1, 0).applyQuaternion(l);
                break;
            case "adaptive":
                Kl.angleTo(Ti.set(0, 1, 0)) > Math.PI / 6 ? (Xt.crossVectors(Ti.set(0, 1, 0), Kl), Yo.crossVectors(Xt, Ti)) : Yo.set(0, 1, 0);
                break;
            default:
                Yo.copy(Kl);
                break;
        }
        ou.setFromMatrixPosition(e.matrixWorld);
        let u = e.userData.lockedPlane ? e.userData.worldPosition0 : ou;
        if (rN.setFromNormalAndCoplanarPoint(Yo, u), !!a.ray.intersectPlane(rN, r) && (i === "x" || i === "y" || i === "z")) {
            let c = Ti.subVectors(r, u).dot(Xt);
            r.copy(u).addScaledVector(Xt, c);
        }
    }
    updateDragItem(e, r = !1) {
        ou.setFromMatrixPosition(e.obj.matrixWorld), e.reset === "current" ? fg.subVectors(e.fromPosition, ou).divideScalar(e.currentDampingFactor) : e.reset === "original" ? (fg.subVectors(e.obj.userData.worldPosition0, ou).divideScalar(e.currentDampingFactor), e.fromPosition.copy(e.obj.userData.worldPosition0), e.pointStart.copy(e.fromPosition), e.pointEnd.copy(e.pointStart)) : fg.subVectors(e.pointEnd, e.pointStart).add(e.fromPosition).sub(ou).divideScalar(e.currentDampingFactor), e.paused = e.currentDampingFactor > 1 ? fg.length() < VZ : !0, (this.activeEvent && this.activeEvent.data.dampingFactor === 1 || r) && GZ(e, fg.add(ou), this.activeEvent?.data.drop && this.activeEvent?.data.autoOrient ? e.orientationMatrix : null), e.obj.dispatchEvent({
            type: "beginEvent",
            eventName: "DragDrop"
        }), this.eventManager.requestRender();
    }
};
var kf = new _, SE = new _, ka = new _, za = new _, nN = new qr, jZ = .01, HZ = {
    type: "requestRender"
}, WZ = function() {
    let n1 = new _, t = new _;
    return (e, r, i)=>i > 0 ? (n1.subVectors(e, r), n1.length() <= i ? e : t.copy(r).add(n1.normalize().multiplyScalar(i))) : r;
}(), sN = function() {
    let n1 = new te;
    return (t, e)=>{
        t.position.copy(e), t.parent !== null && (n1.copy(t.parent.matrixWorld).invert(), t.position.applyMatrix4(n1)), n1.copy(t.hiddenMatrix).invert(), t.position.applyMatrix4(n1), t.updateMatrix(), t.hasNonUniformScale && (t.updateMatrixWorld(), t.updateMatrixWorldSVD()), t instanceof nr && An(t.parent) && t.invalidateDownstreamBooleanData(!0);
    };
}(), wE = class {
    constructor(t, e, r, i, s){
        this.data = t;
        this.object = e;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.snapComplete = !1;
        this.isReset = !1;
        this.worldPosition0 = new _;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...Pv.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = r.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.resetDampingFactor = 80 / this.data.resetSpeed + 1, this.object.getWorldPosition(this.worldPosition0), this.actions = gr(t, t.actions, r, i, s, e);
    }
}, mb = class extends Dr {
    constructor(e, r){
        super(e);
        this.events = [];
        this.pairOfEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(Ye.length > 1)) {
                this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        let { page: i } = this.eventContext;
        i.traverseEntity((s)=>{
            let o = s.data?.events.find((a)=>a.data.type === "Follow" && !a.data.disabled);
            o && (!i.data.globalPhysics.usePhysics || s.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new wE(o.data, s, i, e.sharedAssets, r));
        });
    }
    connect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Si && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), r.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents || (e.addEventListener("pointerenter", this.onMouseEnter), e.addEventListener("pointerleave", this.onMouseLeave));
        for (let i of this.events)if (i.target !== void 0) {
            let s = i.target, o = this.onTargetChange(i);
            this.pairOfEventListeners.push([
                s,
                o
            ]), s.addEventListener("requestRender", o);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Si && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1, tr(i.actions);
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e, !0);
    }
    updateSingleEvent(e, r = !1) {
        this.events.forEach((l)=>{
            l.actions.Create.forEach((u)=>{
                u.dispatchThrottled();
            });
        });
        let { plane: i, limitDistance: s, limitDistanceEnabled: o } = e.data;
        if (e.object.getWorldPosition(ka), e.isReset) za.copy(e.worldPosition0);
        else if (e.target) e.target.getWorldPosition(za);
        else {
            let { getCamera: l, raycaster: u } = this.eventContext;
            if (i === "custom" ? (l().getWorldDirection(SE), SE.negate(), kf.copy(SE)) : i === "xy" ? kf.set(0, 0, 1) : i === "xz" ? kf.set(0, 1, 0) : i === "yz" && kf.set(1, 0, 0), nN.setFromNormalAndCoplanarPoint(kf, ka), !u.ray.intersectPlane(nN, za)) return;
        }
        if (!e.isReset) {
            if (za.distanceTo(e.worldPosition0) > s && o && e.target) {
                if (e.snapComplete = !1, e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) za.copy(e.worldPosition0), e.currentDampingFactor = e.resetDampingFactor;
                else return;
            } else if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
        }
        e.data.enabledTranslation[0] === !1 && (za.x = ka.x), e.data.enabledTranslation[1] === !1 && (za.y = ka.y), e.data.enabledTranslation[2] === !1 && (za.z = ka.z);
        let a = WZ(ka, za, e.wasOutside ? 0 : e.data.maxDelta);
        if (e.currentDampingFactor > 1) {
            let l = kf.subVectors(a, ka).divideScalar(e.currentDampingFactor);
            ka.add(l), r && sN(e.object, ka), e.paused = l.length() < jZ;
        } else sN(e.object, a), e.paused = !0;
        e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "Follow"
        }), e.object.dispatchEvent(HZ);
    }
};
var pg = new _, gb = new _, mg = new te, zf = new je, Zl = new je, gg = new _, yg = new _, lu = new _, Va = new _, AE = new qr, qZ = 1e-6, YZ = {
    type: "requestRender"
}, XZ = {
    type: "changeRotation"
}, oN = function() {
    let n1 = new te;
    return function(e, r) {
        e.parent !== null ? n1.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix) : n1.copy(e.hiddenMatrix), r.premultiply(hE(n1).invert()), e.rotation.setFromRotationMatrix(r), e.updateMatrix(), e instanceof nr && An(e.parent) && e.invalidateDownstreamBooleanData(!0);
    };
}(), _E = class {
    constructor(t, e, r){
        this.object = e;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.isReset = !1;
        this.worldQuaternion0 = new je;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...Dv.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = r.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.object.getWorldQuaternion(this.worldQuaternion0), this.resetDampingFactor = 80 / this.data.resetSpeed + 1;
    }
}, yb = class extends Dr {
    constructor(e){
        super(e);
        this.events = [];
        this.pairOfEventListeners = [];
        this.pairOfUserEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(Ye.length > 1)) {
                this._lastMouseEvent = e, this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onScroll = (e)=>{
            if (this._lastMouseEvent) {
                let r = new PointerEvent("pointermove", {
                    clientX: this._lastMouseEvent.clientX,
                    clientY: this._lastMouseEvent.clientY,
                    bubbles: !0,
                    cancelable: !0,
                    view: window
                });
                this.eventContext.eventElement.dispatchEvent(r);
            }
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        this.createUserEventListener = (e)=>({ eventName: r, target: i })=>{
                if (!r || !i) return;
                let s = qo(r);
                s && s === "LookAt" && this.updateSingleEvent(e);
            };
        let { page: r } = this.eventContext;
        r.traverseEntity((i)=>{
            let s = i.data?.events.find((o)=>o.data.type === "LookAt" && !o.data.disabled);
            s && (!r.data.globalPhysics.usePhysics || i.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new _E(s.data, i, r));
        });
    }
    connect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Si && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), r.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents ? r.addEventListener("scroll", this.onScroll) : (e.addEventListener("pointerenter", this.onMouseEnter), e.addEventListener("pointerleave", this.onMouseLeave));
        for (let i of this.events){
            if (i.target !== void 0) {
                let a = this.onTargetChange(i), l = i.target;
                this.pairOfEventListeners.push([
                    l,
                    a
                ]), l.addEventListener("requestRender", a);
            }
            let s = this.createUserEventListener(i), o = i.object;
            this.pairOfUserEventListeners.push([
                o,
                s
            ]), o.addEventListener("userEvent", s);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Si && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave), r.removeEventListener("scroll", this.onScroll);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let [i, s] of this.pairOfUserEventListeners)i.removeEventListener("userEvent", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e);
    }
    updateSingleEvent(e) {
        let { tilt: r, axis: i, distance: s, plane: o, limitDistance: a, enabledRotation: l, limitDistanceEnabled: u } = e.data, { getCamera: c, raycaster: d } = this.eventContext, { object: h, target: f } = e;
        if (h.getWorldPosition(gg), !e.isReset) {
            if (e.target) e.target.getWorldPosition(yg);
            else {
                if (o === "custom" ? (c().getWorldDirection(gb), gb.negate(), AE.setFromNormalAndCoplanarPoint(gb, gg)) : (o === "xy" ? pg.set(0, 0, 1) : o === "xz" ? pg.set(0, 1, 0) : o === "yz" && pg.set(1, 0, 0), AE.setFromNormalAndCoplanarPoint(pg, gg)), !d.ray.intersectPlane(AE, yg)) return;
                s > 0 && (o === "custom" || o === void 0) && yg.addScaledVector(gb, s);
            }
        }
        if (e.isReset || (f ? r === "target" ? lu.copy(f.up).applyMatrix4(mg.extractRotation(f.matrixWorld)).normalize() : l.some((p)=>p === !1) ? (i === "x" ? (Va.set(0, 0, 1), l[2] === !1 && Va.set(0, 1, 0)) : i === "y" ? (Va.set(1, 0, 0), l[0] === !1 && Va.set(0, 0, 1)) : (Va.set(0, 1, 0), l[1] === !1 && Va.set(1, 0, 0)), lu.copy(Va).applyQuaternion(e.worldQuaternion0).normalize()) : lu.set(0, 1, 0) : o === "custom" ? lu.set(0, 1, 0) : lu.copy(pg)), e.isReset) Zl.copy(e.worldQuaternion0);
        else if (gg.distanceTo(yg) > a && u && f) {
            if (e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) Zl.copy(e.worldQuaternion0), e.currentDampingFactor = e.resetDampingFactor;
            else return;
        } else {
            if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
            QZ(mg, yg, gg, lu, i, Va), Zl.setFromRotationMatrix(mg), zf.setFromUnitVectors(Va.applyQuaternion(Zl), lu), l.some((p)=>p === !1) && r !== "target" && Zl.premultiply(zf).normalize();
        }
        e.currentDampingFactor > 1 ? (h.updateWorldMatrix(!0, !1), zf.setFromRotationMatrix(hE(h.matrixWorld)), zf.slerp(Zl, 1 / e.currentDampingFactor), oN(h, mg.makeRotationFromQuaternion(zf)), e.paused = 8 * (1 - zf.dot(Zl)) < qZ) : (oN(h, mg.makeRotationFromQuaternion(Zl)), e.paused = !0), e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "LookAt"
        }), h.dispatchEvent(YZ), h.dispatchEvent(XZ);
    }
}, Ts = new _, Mi = new _, ei = new _;
function QZ(n1, t, e, r, i, s) {
    let o = n1.elements;
    ei.subVectors(t, e), ei.lengthSq() === 0 && (ei.z = 1), ei.normalize(), Mi.crossVectors(r, ei), Mi.lengthSq() === 0 && (Math.abs(r.z) === 1 ? ei.x += 1e-4 : ei.z += 1e-4, ei.normalize(), Mi.crossVectors(r, ei)), Mi.normalize(), Ts.crossVectors(ei, Mi), i === "x" ? s.z === 1 ? [Mi, Ts, ei] = [
        ei,
        Mi,
        Ts
    ] : (Mi.negate(), [Mi, ei] = [
        ei,
        Mi
    ]) : i === "y" ? s.x === 1 ? [Mi, Ts, ei] = [
        Ts,
        ei,
        Mi
    ] : (Mi.negate(), [Ts, ei] = [
        ei,
        Ts
    ]) : s.x === 1 && (Mi.negate(), [Mi, Ts] = [
        Ts,
        Mi
    ]), o[0] = Mi.x, o[4] = Ts.x, o[8] = ei.x, o[1] = Mi.y, o[5] = Ts.y, o[9] = ei.y, o[2] = Mi.z, o[6] = Ts.z, o[10] = ei.z;
}
var EE = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        this.actions = gr(e, e.actions, i, s, o, r);
    }
    disconnect() {
        tr(this.actions);
    }
    dispatchEnter() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered || (this.entered = !0, this.actions.Transition.forEach((t)=>t.playFromCurrent()), this.actions.Animation.forEach((t)=>t.play()), this.actions.Create.forEach((t)=>t.dispatch()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.SwitchCamera.forEach((t)=>t.playFromCurrent()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()));
    }
    dispatchLeave() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Particles.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatch()), this.actions.Particles.forEach((e)=>e.dispatchBasic()), this.actions.Destroy.forEach((e)=>e.dispatch()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
}, vb = class extends Dr {
    constructor(e, r){
        super(e);
        this.eventsPerObjects = {};
        this.objects = [];
        this.objects2D = [];
        this._prevObjects = [];
        this.onMouseDown = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onMouseUp = (e)=>{
            Ye.length > 1 || this.handleMouseHoverEvent(!0);
        };
        this.onMouseMove = (e)=>{
            Ye.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = qo(e);
            s && s === "MouseHover" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[r.uuid]?.forEach((o)=>o.dispatchUserEvent(i)));
        };
        let { page: i, sharedAssets: s } = this.eventContext, o = (a, l)=>{
            if (!(!a.visible || !a.data?.events.length)) {
                for (let { id: u, data: c } of a.data.events)if (!c.disabled && c.type === "MouseHover") try {
                    let d = new EE(u, c, a, i, s, r);
                    this.eventsPerObjects[a.uuid] ? this.eventsPerObjects[a.uuid].push(d) : this.eventsPerObjects[a.uuid] = [
                        d
                    ];
                } catch (d) {}
                this.eventsPerObjects[a.uuid]?.length && this.objects.push(a instanceof jt ? l : a);
            }
        };
        i.traverseEntity((a)=>{
            (a instanceof fr || a instanceof sr) && a.frame?.traverse((l)=>{
                o(l, a);
            }), o(a);
        });
    }
    connect() {
        if (!this.objects.length) return;
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), Si && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseDown), this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMouseUp)), this.domEventsNeeded.add("pointermove"), e.addEventListener("pointermove", this.onMouseMove), this.objects.forEach((r)=>{
            r.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if (!this.objects.length) return;
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), Si && (e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerup", this.onMouseUp)), e.removeEventListener("pointermove", this.onMouseMove), Object.values(this.eventsPerObjects).forEach((r)=>{
            r.forEach((i)=>{
                i.disconnect();
            });
        }), this.objects.forEach((r)=>{
            r.removeEventListener("userEvent", this.onUserEvent);
        });
    }
    handleMouseHoverEvent(e = !1) {
        let r = [];
        if (!e) {
            let { stopRaycast: i, raycaster: s, page: o, pointerScreen: a } = this.eventContext, l = !1;
            if (o.uiCanvas && (l = no(o, [
                a.x,
                a.y
            ], Object.keys(this.eventsPerObjects), (u)=>{
                r.push(u);
            })), i && !l) {
                let u = Lf(s, o, this.objects);
                r = hg(u), u.forEach((c)=>{
                    c.object instanceof fr && no(c.object, [
                        c?.uv?.x ?? 0,
                        c?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects), (d)=>{
                        r.push(d);
                    });
                });
            } else this.objects.forEach((u)=>{
                let c = Bf(s, u);
                c && (r.push(u), u instanceof fr && no(u, [
                    c?.uv?.x ?? 0,
                    c?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects), (d)=>{
                    r.push(d);
                }));
            });
        }
        this._prevObjects.length && this._prevObjects.forEach((i)=>{
            r.includes(i) || (i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchLeave()));
        }), r.length && r.forEach((i)=>{
            i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchEnter());
        }), this._prevObjects = r;
    }
};
var TE = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.scrollCounter = 0;
        this.actions = gr(e, e.actions, i, s, o, r);
    }
    connect() {
        this.scrollCounter = 0;
    }
    disconnect() {
        tr(this.actions);
    }
    dispatch(t) {
        this.actions.Transition.forEach((i)=>{
            i.object.currentTransitionEvent !== this && (i.object.currentTransitionEvent = this, i.init());
        });
        let e = t > 0 ? 1 : -1;
        this.scrollCounter += e, this.scrollCounter = Math.min(Math.max(this.scrollCounter, 0), this.data.steps);
        let r = this.scrollCounter / this.data.steps;
        this.actions.Transition.forEach((i)=>i.seek(r)), this.actions.Animation.forEach((i)=>i.seek(e)), this.actions.Create.forEach((i)=>i.dispatchThrottled()), this.actions.SetVariable.forEach((i)=>i.checkConditions()), this.actions.SetVariable.forEach((i)=>i.dispatch()), this.actions.DynamicVariablePlay.forEach((i)=>i.dispatch());
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
}, ME = class {
    constructor(t, e, r, i, s, o, a){
        this.id = t;
        this.data = e;
        this.object = r;
        this.domElement = o;
        this.eventManager = a;
        this.scrollStart = 0;
        this.scrollEnd = 0;
        this.actions = gr(e, e.actions, i, s, a, r);
    }
    computeScrollBounds() {
        let t = this.domElement.getBoundingClientRect(), e = document.body, r = document.documentElement, i = window.pageYOffset || r.scrollTop || e.scrollTop, s = r.clientTop || e.clientTop || 0, o = Math.round(t.top + i - s);
        if (this.data.startFrom === "enter") {
            let a = window.innerHeight, l = t.height, u = this.data.enterAnchor, c = u === "top" ? a : u === "bottom" ? a - l : a - l * .5;
            this.scrollStart = o - c;
        } else this.scrollStart = 0;
        this.scrollStart += this.data.startOffset ?? 0, this.scrollEnd = this.scrollStart + (this.data.endAfter ?? 400), this.box = t, this.computeScroll({
            x: window.scrollX,
            y: window.scrollY
        });
    }
    connect() {
        this.computeScrollBounds();
    }
    disconnect() {
        tr(this.actions);
    }
    handleResize() {
        this.computeScrollBounds();
    }
    get isInvalidBox() {
        return this.box === void 0 || this.box.width === 0 && this.box.height === 0 && this.box.top === 0 && this.box.bottom === 0;
    }
    computeScroll({ x: t, y: e }) {
        this.actions.Transition.forEach((s)=>{
            s.object.currentTransitionEvent !== this && (s.object.currentTransitionEvent = this, s.init());
        });
        let r = this.scrollEnd - this.scrollStart, i = Math.min(1, Math.max(0, (e - this.scrollStart) / r));
        this.actions.Transition.forEach((s)=>s.seek(i)), this.actions.Animation.forEach((s)=>s.seek(i)), this.actions.Create.forEach((s)=>s.dispatchThrottled()), this.actions.SetVariable.forEach((s)=>s.checkConditions()), this.actions.SetVariable.forEach((s)=>s.dispatch()), this.actions.DynamicVariablePlay.forEach((s)=>s.dispatch());
    }
    dispatch(t) {
        this.isInvalidBox && this.computeScrollBounds(), this.computeScroll(t);
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
}, xb = class extends Dr {
    constructor(e, r){
        super(e);
        this.wheelEventsPerObject = new Map;
        this.scrollEventsPerObject = new Map;
        this.isInview = !0;
        this.handleResize = ()=>{
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([e, r])=>{
                r.forEach((i)=>i.handleResize());
            });
        };
        this.onScroll = (e)=>{
            if (!this.isInview) return;
            let r = {
                y: window.scrollY,
                x: window.scrollX
            };
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([i, s])=>{
                i.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    scroll: r
                }), s.forEach((o)=>o.dispatch(r));
            });
        };
        this.onWheel = (e)=>{
            !this.isInview || e.ctrlKey || [
                ...this.wheelEventsPerObject.entries()
            ].forEach(([r, i])=>{
                r.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    deltaY: e.deltaY
                }), i.forEach((s)=>s.dispatch(e.deltaY));
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = qo(e);
            s && s === "Scroll" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "Scroll"
            }), this.wheelEventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
        let { page: i, sharedAssets: s, domElement: o, isExport: a } = this.eventContext, l = (u)=>{
            if (!!u.data?.events.length) {
                for (let { id: c, data: d } of u.data.events)if (!d.disabled && d.type === "Scroll") {
                    if (d.trigger === "load" || !a) {
                        let h = new TE(c, d, u, i, s, r);
                        this.wheelEventsPerObject.has(u) ? this.wheelEventsPerObject.get(u)?.push(h) : this.wheelEventsPerObject.set(u, [
                            h
                        ]);
                    } else {
                        let h = new ME(c, d, u, i, s, o, r);
                        this.scrollEventsPerObject.has(u) ? this.scrollEventsPerObject.get(u)?.push(h) : this.scrollEventsPerObject.set(u, [
                            h
                        ]);
                    }
                }
            }
        };
        i.traverseEntity((u)=>{
            (u instanceof fr || u instanceof sr) && u.frame?.traverse((c)=>{
                l(c);
            }), l(u);
        }), this.intersectionObserver = new IntersectionObserver((u)=>{
            let c = u[0];
            c && (this.isInview = c.isIntersecting);
        }, {
            root: null
        });
    }
    connect() {
        this.intersectionObserver.observe(this.eventContext.domElement), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.connect()), e.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.connect()), e.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.wheelEventsPerObject.values()
        ].some((e)=>e.length) && (this.domEventsNeeded.add("wheel"), window.addEventListener("wheel", this.onWheel)), [
            ...this.scrollEventsPerObject.values()
        ].some((e)=>e.length) && (this.domEventsNeeded.add("scroll"), window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.handleResize));
    }
    disconnect() {
        window.removeEventListener("wheel", this.onWheel), window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.handleResize), this.intersectionObserver.unobserve(this.eventContext.domElement), this.domEventsNeeded.clear(), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        });
    }
};
var CE = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = gr(e, e.actions, i, s, o, r);
    }
    disconnect() {
        tr(this.actions);
    }
    dispatch() {
        this.actions.Transition.forEach((t)=>{
            t.play();
        }), this.actions.Animation.forEach((t)=>{
            t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.play();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.Create.forEach((t)=>{
            t.dispatchFromStart();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatchFromStart();
        });
    }
    dispatchAfter(t) {
        this.actions.Audio.forEach((e)=>{
            (e.interaction.data.triggerAfter ?? "any") === t && (e.interaction instanceof Uo ? e.interaction.audioPlayer.play() : e.interaction instanceof Of && e.interaction.dispatch());
        }), this.actions.Video.forEach((e)=>{
            let r = e.interaction.data.triggerAfter ?? "autoplay";
            r === t && (e.interaction instanceof Na ? e.interaction.play(r === "autoplay") : e.interaction instanceof Rf && e.interaction.dispatch());
        }), this.actions.Particles.forEach((e)=>{
            (e.data.triggerAfter ?? "any") === t && e.dispatchBasic();
        });
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.Reset.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.interaction instanceof Uo ? e.interaction.audioPlayer.play() : e.interaction instanceof Of && e.interaction.dispatch();
        }), this.actions.Video.forEach((e)=>{
            e.interaction instanceof Na ? e.interaction.play() : e.interaction instanceof Rf && e.interaction.dispatch();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        });
    }
}, bb = class extends Dr {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerObject = new Map;
        this.eventsAfterPerObject = new Map;
        this.onMouseDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("mouseDown");
                });
            });
        };
        this.onKeyDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("keyDown");
                });
            });
        };
        this.onAny = ()=>{
            let { domElement: e, isExport: r } = this.eventContext;
            (r ? document : e).removeEventListener("pointerdown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), o.forEach((a)=>{
                    a.dispatchAfter("any");
                });
            });
        };
        this.onSceneTransitionAudioVideoPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.actions.Audio.forEach((s)=>{
                        s.interaction instanceof Uo && s.interaction.audioPlayer.play();
                    }), i.actions.Video.forEach((s)=>{
                        let o = s.interaction.data.triggerAfter ?? "autoplay";
                        s.interaction instanceof Na && s.interaction.play(o === "autoplay");
                    }), i.actions.Particles.forEach((s)=>{
                        s.dispatchBasic();
                    });
                });
            });
        };
        this.onPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("autoplay");
                });
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s = qo(e);
            s && s === "Start" && (r instanceof jt || r.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), this.eventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }), this.eventsAfterPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
    }
    connect() {
        let { sharedAssets: e, page: r } = this.eventContext, i = (s)=>{
            if (!!s.data?.events.length) for (let { id: o, data: a } of s.data.events){
                if (a.disabled || a.type !== "Start") continue;
                let l = new CE(o, a, s, r, e, this.eventManager);
                (l.actions.Transition.length || l.actions.Animation.length || l.actions.SwitchCamera.length || l.actions.Create.length || l.actions.Destroy.length || l.actions.SceneTransition.length || l.actions.Reset.length || l.actions.SetVariable.length || l.actions.DynamicVariablePlay.length) && (this.eventsPerObject.has(s) ? this.eventsPerObject.get(s)?.push(l) : this.eventsPerObject.set(s, [
                    l
                ])), l.actions.Audio.length && (this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ])), l.actions.Video.length && (this.hasVideoAction = !0, this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ])), l.actions.Particles.length && (this.eventsAfterPerObject.has(s) ? this.eventsAfterPerObject.get(s)?.push(l) : this.eventsAfterPerObject.set(s, [
                    l
                ]));
            }
        };
        if (r.traverseEntity((s)=>{
            (s instanceof fr || s instanceof sr) && s.frame?.traverse((o)=>{
                i(o);
            }), i(s);
        }), [
            ...this.eventsAfterPerObject.values()
        ].some((s)=>s.length)) {
            if (this.eventManager.activateCount === 0) {
                let { domElement: s, isExport: o } = this.eventContext, a = o ? document : s;
                a.addEventListener("pointerdown", this.onMouseDown, {
                    once: !0
                }), a.addEventListener("mousedown", this.onMouseDown, {
                    once: !0
                }), document.addEventListener("keydown", this.onKeyDown, {
                    once: !0
                }), a.addEventListener("pointerdown", this.onAny), a.addEventListener("mousedown", this.onAny), document.addEventListener("keydown", this.onAny), [
                    ...this.eventsAfterPerObject.entries()
                ].forEach(([l, u])=>{
                    l.addEventListener("userEvent", this.onUserEvent);
                });
            } else this.onSceneTransitionAudioVideoPlay();
            this.onPlay();
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([s, o])=>{
            s.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), o.forEach((a)=>a.dispatch()), s.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if ([
            ...this.eventsAfterPerObject.values()
        ].some((e)=>e.length)) {
            let { domElement: e, isExport: r } = this.eventContext, i = r ? document : e;
            i.removeEventListener("pointerdown", this.onMouseDown), i.removeEventListener("mousedown", this.onMouseDown), document.removeEventListener("keydown", this.onKeyDown), i.removeEventListener("pointerdown", this.onAny), i.removeEventListener("mousedown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.removeEventListener("userEvent", this.onUserEvent), o.forEach((a)=>a.disconnect());
            });
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([e, r])=>{
            e.removeEventListener("userEvent", this.onUserEvent), r.forEach((i)=>i.disconnect());
        }), this.eventsPerObject.clear(), this.eventsAfterPerObject.clear();
    }
};
var Sb = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.disabled = !1;
        this.alreadyPlayedNonTogglingActions = new Set;
        this.actions = gr(e, e.actions, i, s, o, r), this.target = e.target, this.useToggle = e.runMode === "Toggle";
    }
    disconnect() {
        tr(this.actions);
    }
    dispatch(t) {
        this.disabled || (this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this ? (e.object.currentTransitionEvent = this, e.init()) : this.data.runMode === "Once" && this.alreadyPlayedNonTogglingActions.add(e);
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Collision"
        }), this.useToggle ? (this.actions.Transition.forEach((e)=>{
            e.toggle();
        }), this.actions.Animation.forEach((e)=>{
            e.toggle();
        })) : (this.actions.Transition.forEach((e)=>{
            this.alreadyPlayedNonTogglingActions.has(e) === !1 && e.play();
        }), this.actions.Animation.forEach((e)=>{
            e.play();
        })), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch(t ?? !1);
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }));
    }
};
var wb = class extends Dr {
    constructor(e, r, i, s, o){
        super(e);
        this.sharedVariables = r;
        this.eventManager = i;
        this.needsMouse = s;
        this.needsRaycast = o;
        this.dynamicVars = [];
        this.variablesToWatch = [];
        this.prevMouseProperty = null;
        this.prevRaycastProperty = null;
        this.pauseTime = 0;
        this.events = [];
        this.onFrame = (e)=>{
            this.rafId = window.requestAnimationFrame(this.onFrame);
            let r = new Date, i = [], s = [];
            for(let l = 0; l < this.propertiesToWatch.length; l++){
                let { objectId: u, property: c, prevValue: d } = this.propertiesToWatch[l], h = this.eventContext.scene.find(u), f = Iv.propertyPaths[c];
                if (f[0] === "width" || f[0] === "height" || f[0] === "depth") h = h.geometry.userData.parameters[f[0]];
                else for(let p = 0; p < f.length; p++)h = h[f[p]];
                d === null ? this.propertiesToWatch[l].prevValue = h instanceof _ ? h.clone() : h : (h instanceof _ ? !h.equals(d) : d !== h) && (s.push({
                    objId: u,
                    property: c
                }), h instanceof _ ? this.propertiesToWatch[l].prevValue.copy(h) : this.propertiesToWatch[l].prevValue = h);
            }
            for(let l = 0; l < this.variablesToWatch.length; l++){
                let { id: u, prevValue: c } = this.variablesToWatch[l], d = this.shared.getVariable(u);
                d !== c && (i.push(u), this.variablesToWatch[l].prevValue = d);
            }
            for(let l = 0; l < this.dynamicVars.length; l++){
                let { id: u, expectedTime: c, last: d, data: h, timerSeconds: f, startValue: p } = this.dynamicVars[l], m = 1e3;
                if ((h.dynamicVariableType === "timer" || h.dynamicVariableType === "stopwatch") && h.format === "number3decimal" ? m = 1 : h.dynamicVariableType === "counter" ? m = h.updateInterval : h.dynamicVariableType === "random" && (m = h.isStatic ? 1 / 0 : h.updateInterval), c === -1) {
                    this.dynamicVars[l].last = e, this.dynamicVars[l].expectedTime = e + m;
                    continue;
                }
                if (!((this.shared.getDynamicVariablePlayState(u) === "Stopped" || this.shared.getDynamicVariablePlayState(u) === "Restarted") && (this.dynamicVars[l].last = e, this.dynamicVars[l].expectedTime = e + m, h.dynamicVariableType === "counter" && this.shared.getVariable(u) !== p && (this.shared.updateVariable(u, p), this.eventManager.requestRender()), (h.dynamicVariableType === "timer" || h.dynamicVariableType === "stopwatch") && this.dynamicVars[l].timerSeconds !== p && (this.dynamicVars[l].timerSeconds = p, this.shared.updateVariable(u, yn.getFormattedTimerTime(p, h)), this.eventManager.requestRender()), this.shared.getDynamicVariablePlayState(u) === "Restarted" && this.shared.setDynamicVariablePlayState(u, "Playing"), this.shared.getDynamicVariablePlayState(u) === "Stopped"))) {
                    if (this.shared.getDynamicVariablePlayState(u) === "Paused") {
                        this.dynamicVars[l].deltaToExpectedTime === void 0 && (this.dynamicVars[l].deltaToExpectedTime = Math.max(this.dynamicVars[l].expectedTime - e, 0)), this.dynamicVars[l].last = e - (m - this.dynamicVars[l].deltaToExpectedTime), this.dynamicVars[l].expectedTime = e + this.dynamicVars[l].deltaToExpectedTime;
                        continue;
                    } else this.dynamicVars[l].deltaToExpectedTime = void 0;
                    if (e >= c) {
                        if (this.dynamicVars[l].last = e, this.dynamicVars[l].expectedTime += m, h.dynamicVariableType === "random") {
                            let g = h.min + Math.random() * (h.max - h.min), y = h.decimals;
                            g = Math.round(g * Math.pow(10, y)) / Math.pow(10, y), this.shared.updateVariable(u, g), i.push(u), this.eventManager.requestRender();
                        } else if (h.dynamicVariableType === "counter") {
                            if (h.increment === 0) continue;
                            let g = this.shared.getVariable(u), y = this.shared.getDynamicVariableToggleIsForward(u) ?? !0, v = this.shared.getVariable(u) + h.increment * (y ? 1 : -1);
                            h.hasEnd && (v = h.increment > 0 ? Se.clamp(v, p, h.endValue) : Se.clamp(v, h.endValue, p), v === p && this.shared.setDynamicVariableToggleIsForward(u, void 0), h.repeat ? v === h.endValue && (v = p) : (v === p || v === h.endValue) && this.shared.setDynamicVariablePlayState(u, "Paused")), v !== g && (i.push(u), this.shared.updateVariable(u, v), this.eventManager.requestRender());
                        } else if (h.dynamicVariableType === "time") this.shared.updateVariable(u, qA(r, h)), i.push(u), this.eventManager.requestRender();
                        else {
                            let g = Fi.isTextValue(h.endValue) ? aN(h.endValue.textValue) : h.endValue, y = this.shared.getDynamicVariableToggleIsForward(u) ?? !0, v = f + (e - d) / 1e3 * (h.dynamicVariableType === "timer" ? -1 : 1) * (y ? 1 : -1);
                            v = Math.max(v, 0), h.hasEnd && (v = h.dynamicVariableType === "stopwatch" ? Se.clamp(v, p, g) : Se.clamp(v, g, p), v === p && this.shared.setDynamicVariableToggleIsForward(u, void 0), h.repeat ? Math.abs(v - g) < (h.format === "number3decimal" ? 1e-4 : .1) && (v = p) : (Math.abs(v - p) < (h.format === "number3decimal" ? 1e-4 : .1) || Math.abs(v - g) < (h.format === "number3decimal" ? 1e-4 : .1)) && this.shared.setDynamicVariablePlayState(u, "Paused")), v !== f && (i.push(u), this.dynamicVars[l].timerSeconds = v, this.shared.updateVariable(u, yn.getFormattedTimerTime(v, h)), this.eventManager.requestRender());
                        }
                    }
                }
            }
            this.needsMouse && this.shared.mouseProperty !== this.prevMouseProperty && (this.prevMouseProperty = this.shared.mouseProperty, this.events.forEach((l)=>{
                l.data.variableId === "mouseProperty" && (l.dispatch(), this.eventManager.requestRender());
            }));
            let o = !1;
            this.shared.mouseProperty !== this.prevMouseProperty && (this.prevMouseProperty = this.shared.mouseProperty, o = !0);
            let a = !1;
            this.shared.raycastProperty !== this.prevRaycastProperty && (this.prevRaycastProperty = this.shared.raycastProperty, a = !0), this.events.forEach((l)=>{
                (i.includes(l.data.variableId) || s.find((u)=>u.objId === l.data.objectId && u.property === l.data.property) || l.data.variableId === "mouseProperty" && o || l.data.variableId === "raycastProperty" && a) && (l.dispatch(), this.eventManager.requestRender());
            });
        };
        this.onBlur = ()=>{
            this.pause();
        };
        this.onFocus = ()=>{
            this.resume();
        };
        e.page.traverseEntity((a)=>{
            a.data?.events.filter((l)=>l.data.type === "VariableChange" && !l.data.disabled).forEach((l)=>{
                this.events.push(new PE(a.uuid, l.data, a, e.page, e.sharedAssets, i));
            });
        }), this.propertiesToWatch = this.events.filter((a)=>a.data.variableId === "objectProperty" && a.data.objectId !== null).map((a)=>({
                objectId: a.data.objectId,
                property: a.data.property,
                prevValue: null
            })), this.shared = e.sharedAssets, this.sharedVariables.forEach(({ id: a, data: l })=>{
            if (!("dynamicVariableType" in l)) {
                this.events.find((c)=>c.data.variableId === a) && this.variablesToWatch.push({
                    id: a,
                    prevValue: this.shared.getVariable(a)
                });
                return;
            }
            let u;
            if (l.dynamicVariableType === "timer" || l.dynamicVariableType === "stopwatch") {
                let c;
                if (Fi.isTextValue(l.value) && Array.isArray(l.value.textValue)) {
                    let d = l.value.textValue;
                    d.length === 3 ? c = d[2] + d[1] * 60 + d[0] * 3600 : c = d[1] + d[0] * 60;
                } else c = l.value;
                u = c, this.dynamicVars.push({
                    id: a,
                    last: -1,
                    expectedTime: -1,
                    data: l,
                    timerSeconds: c,
                    startValue: u
                });
            } else l.dynamicVariableType === "time" && this.shared.updateVariable(a, qA(new Date, l)), l.dynamicVariableType === "counter" && (u = Fi.isTextValue(l.value) ? aN(l.value.textValue) : l.value), this.dynamicVars.push({
                id: a,
                last: -1,
                expectedTime: -1,
                data: l,
                startValue: u
            });
        });
    }
    pause() {
        this.pauseTime = Date.now();
    }
    resume() {
        let e = Date.now() - this.pauseTime;
        for(let r = 0; r < this.dynamicVars.length; r++)this.dynamicVars[r].last += e, this.dynamicVars[r].expectedTime += e;
    }
    connect() {
        this.rafId = window.requestAnimationFrame(this.onFrame), window.addEventListener("blur", this.onBlur), window.addEventListener("focus", this.onFocus);
    }
    disconnect() {
        window.removeEventListener("blur", this.onBlur), window.removeEventListener("focus", this.onFocus), this.rafId && (window.cancelAnimationFrame(this.rafId), this.rafId = void 0), this.events.forEach((e)=>e.dispose());
    }
}, PE = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = gr(e, e.actions, i, s, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch());
    }
    dispose() {
        tr(this.actions);
    }
};
function aN(n1) {
    return n1.length === 3 ? n1[2] + n1[1] * 60 + n1[0] * 3600 : n1[1] + n1[0] * 60;
}
var cN = "https://unpkg.com/@splinetool/runtime@1.0.16/build/", KZ = "https://unpkg.com/@splinetool/navmesh-wasm@1.0.16/build/", ZZ = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import('${cN}' + 'navmesh.js'),
		fetch('${KZ}' + 'navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, JZ = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import(self.location.origin + '/_libraries/navmesh.js'),
		fetch(self.location.origin + '/_libraries/navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, $Z = `

onmessage = function(messageEvent) {
	const meshData = messageEvent.data;
	const positions = meshData[0];
	const offset = meshData[1];
	const indices = meshData[2];
	const indicesLength = meshData[3];
	const parameters = meshData[4];

	const module = self.module;
	const rc = new module.rcConfig();
	rc.cs = parameters.cs;
	rc.ch = parameters.ch;
	rc.borderSize = parameters.borderSize ? parameters.borderSize : 0;
	rc.tileSize = parameters.tileSize ? parameters.tileSize : 0;
	rc.walkableSlopeAngle = parameters.walkableSlopeAngle;
	rc.walkableHeight = parameters.walkableHeight;
	rc.walkableClimb = parameters.walkableClimb;
	rc.walkableRadius = parameters.walkableRadius;
	rc.maxEdgeLen = parameters.maxEdgeLen;
	rc.maxSimplificationError = parameters.maxSimplificationError;
	rc.minRegionArea = parameters.minRegionArea;
	rc.mergeRegionArea = parameters.mergeRegionArea;
	rc.maxVertsPerPoly = parameters.maxVertsPerPoly;
	rc.detailSampleDist = parameters.detailSampleDist;
	rc.detailSampleMaxError = parameters.detailSampleMaxError;

	if (!self.navMesh) {
		self.navMesh = new module.NavMesh();
	}
	self.navMesh.build(positions, offset, indices, indicesLength, rc);

	const navmeshData = navMesh.getNavmeshData();
	const arrView = new Uint8Array(module.HEAPU8.buffer, navmeshData.dataPointer, navmeshData.size);
	const ret = new Uint8Array(navmeshData.size);
	ret.set(arrView);
	navMesh.freeNavmeshData(navmeshData);

	postMessage(ret);
}
`, lN = .001, eJ = {
    cs: 6,
    ch: 2,
    walkableSlopeAngle: 90,
    walkableHeight: 20,
    walkableClimb: 5,
    walkableRadius: 0,
    maxEdgeLen: 12,
    maxSimplificationError: 1.3,
    minRegionArea: 8,
    mergeRegionArea: 20,
    maxVertsPerPoly: 6,
    detailSampleDist: 6,
    detailSampleMaxError: 1
}, uN, bt, $i;
C2.then((n1)=>{
    uN = n1, bt = new n1.Vec3, $i = new n1.Vec3;
});
var tJ = new _, Ab = class {
    constructor(t = !1, e = !1){
        this.usePhysics = t;
        this.isExport = e;
        this.onPointerDown = (t)=>{
            if (Ye.length !== 1) return;
            let { raycaster: e, page: r } = this.eventContext;
            this.eventContext.updateRaycaster(t);
            let i = r.raycastWithClones(e);
            if (i.length !== 0) {
                if (this.gameControl) {
                    let s = tJ.copy(this.gameControl.colliderWorldPosition);
                    s.y -= this.gameControl.colliderHeight / 2, this.gameControl.path = this.computePath(s, i[0].point);
                }
                this.eventContext.requestRender();
            }
        };
        this.traverseWithPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Gi) {
                    if (r.objectForSample) {
                        if (r.objectForSample.dataPatched.physics.fusedBody) return;
                        i = r.object;
                    } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (r instanceof Pr) i = r.object;
                else if (i = r, i.dataPatched.cloner?.disabled === !1 && i.dataPatched.cloner?.hideBase && i.dataPatched.physics?.fusedBody !== !0) return !0;
                if (e && !i.userData.navmesh) return;
                let s = i.dataPatched;
                if (!s.visible && s.physics?.enabled !== !0) return !0;
                r.updateMatrixWorldSVD();
                let o = vg(s), a = i.userData.hasDestroy, l = i.userData.hasDrag, u = !1, c = !1;
                for (let d of s.events)d.data.disabled !== !0 && (d.data.type === "GameControl" ? u = !0 : d.data.type === "Follow" && (c = !0));
                if (u || o || c || a || l) return !0;
                if (this.usePhysics && s.physics?.rigidBody === "dynamic") {
                    if (this.usePhysics && s.physics?.fusedBody) return !0;
                } else if ("geometry" in r && r.geometry && t.push(io(r.geometry, r.matrixWorld)), this.usePhysics && s.physics?.fusedBody) return r.traverseObject((d, h)=>{
                    if (h === 0) return;
                    let f;
                    if (d instanceof Gi) {
                        if (d.objectForSample) {
                            if (d.objectForSample.dataPatched.physics.fusedBody) return;
                            f = d.object;
                        } else return d.object.dataPatched.physics.fusedBody === !0 && d.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                    } else if (d instanceof Pr) f = d.object;
                    else if (f = d, d.dataPatched.cloner?.hideBase) return !0;
                    let p = f.dataPatched;
                    if (!p.visible && p.physics?.enabled !== !0) return !0;
                    "geometry" in d && d.geometry && t.push(io(d.geometry, d.matrixWorld));
                }), !0;
            };
        this.traverseNoPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Gi) return;
                r instanceof Pr ? i = r.object : i = r;
                let s = i.dataPatched;
                if (s.physics.enabled === "visibility" ? !s.visible : !s.physics.enabled) return !0;
                if (e && !i.userData.navmesh) return;
                let o = r.geometry, a = i.userData.hasDestroy === !0, l = i.userData.hasDrag === !0;
                if (vg(s) || a || l || i.dataPatched.events.some((u)=>u.data.disabled !== !0 && u.data.type === "GameControl")) return !0;
                o && t.push(io(o, r.matrixWorld));
            };
        this.navmeshWasm = uN, this.navMesh = new this.navmeshWasm.NavMesh, this._workerURL = URL.createObjectURL(new Blob([
            (e ? ZZ : JZ) + $Z
        ])), this._worker = new Worker(this._workerURL);
    }
    init(t, e, r) {
        this.gameControl = e, this.eventContext = r, this.resolution = t.ch, this.setDefaultQueryExtent(new _().setScalar(t.ch * t.walkableRadius * 1.2)), this._worker.onmessage = ()=>{
            this.createNavMesh(r.page, t, (i)=>{
                this.buildFromNavmeshData(i.data);
            });
        }, this.eventContext.renderer.domElement.addEventListener("pointerdown", this.onPointerDown);
    }
    createNavMesh(t, e, r) {
        e.objects.forEach((u)=>{
            let c = t.scene.find(u);
            c.traverseEntity((d)=>{
                d.userData.navmesh = !0;
            }), c.cloner?.traverseObject((d)=>{
                d.userData.navmesh = !0;
            });
        });
        let i = [], s = (this.usePhysics ? this.traverseWithPhysics : this.traverseNoPhysics)(i, e.zones === "custom");
        if (t.traverseChildren(s), e.objects.forEach((u)=>{
            let c = t.scene.find(u);
            c.traverseEntity((d)=>{
                d.userData.navmesh = void 0;
            }), c.cloner?.traverseObject((d)=>{
                d.userData.navmesh = void 0;
            });
        }), i.length === 0) return !1;
        let o = Vs(i), { positions: a, triIndices: l } = Fc(o.getAttribute("position"), o.getIndex());
        return this._worker.postMessage([
            a,
            a.length / 3,
            l,
            l.length,
            {
                ...eJ,
                ...e
            }
        ]), this._worker.onmessage = r, !0;
    }
    createDebugNavGeometry() {
        let t, e, r = this.navMesh.getDebugNavMesh(), i = r.getTriangleCount(), s = new Uint32Array(i * 3), o = new Float32Array(i * 9);
        for(t = 0; t < i * 3; t++)s[t] = t;
        for(t = 0; t < i; t++)for(e = 0; e < 3; e++){
            let l = r.getTriangle(t).getPoint(e);
            o[t * 9 + e * 3 + 0] = l.x, o[t * 9 + e * 3 + 1] = l.y, o[t * 9 + e * 3 + 2] = l.z;
        }
        let a = new we;
        return a.setIndex(new Ge(s, 1)), a.setAttribute("position", new Ge(o, 3)), a;
    }
    getClosestPoint(t) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, this.navMesh.getClosestPoint(bt);
    }
    getClosestPointToRef(t, e) {
        bt.x = t.x, bt.y = t.y, bt.z = t.z;
        let r = this.navMesh.getClosestPoint(bt);
        e.set(r.x, r.y, r.z);
    }
    getRandomPointAround(t, e) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, this.navMesh.getRandomPointAround(bt, e);
    }
    getRandomPointAroundToRef(t, e, r) {
        bt.x = t.x, bt.y = t.y, bt.z = t.z;
        let i = this.navMesh.getRandomPointAround(bt, e);
        r.set(i.x, i.y, i.z);
    }
    moveAlong(t, e) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, $i.x = e.x, $i.y = e.y, $i.z = e.z, this.navMesh.moveAlong(bt, $i);
    }
    moveAlongToRef(t, e, r) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, $i.x = e.x, $i.y = e.y, $i.z = e.z, this.navMesh.moveAlong(bt, $i);
    }
    computePath(t, e) {
        let r = this.getClosestPoint(e);
        $i.x = r.x, $i.y = r.y, $i.z = r.z, this.getClosestPoint(t);
        let i = this.navMesh.computePath(bt, $i), s = i.getPointCount(), o = [];
        for(let a = 0; a < s; a++){
            let l = i.getPoint(a);
            o.push(new _(l.x, l.y, l.z));
        }
        return o;
    }
    createCrowd(t, e) {
        return new DE(this, t, e);
    }
    setDefaultQueryExtent(t) {
        bt.x = t.x, bt.y = t.y, bt.z = t.z, this.navMesh.setDefaultQueryExtent(bt);
    }
    getDefaultQueryExtent() {
        return this.navMesh.getDefaultQueryExtent();
    }
    buildFromNavmeshData(t) {
        let e = t.length * t.BYTES_PER_ELEMENT, r = this.navmeshWasm._malloc(e), i = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, r, e);
        i.set(t);
        let s = new this.navmeshWasm.NavmeshData;
        s.dataPointer = i.byteOffset, s.size = t.length, this.navMesh.buildFromNavmeshData(s), this.navmeshWasm._free(i.byteOffset);
    }
    getNavmeshData() {
        let t = this.navMesh.getNavmeshData(), e = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, t.dataPointer, t.size), r = new Uint8Array(t.size);
        return r.set(e), this.navMesh.freeNavmeshData(t), r;
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.navMesh.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    dispose() {
        this.navMesh.destroy(), this._worker.terminate(), URL.revokeObjectURL(this._workerURL), this.eventContext?.renderer.domElement.removeEventListener("pointerdown", this.onPointerDown);
    }
    addCylinderObstacle(t, e, r) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, this.navMesh.addCylinderObstacle(bt, e, r);
    }
    addBoxObstacle(t, e, r) {
        return bt.x = t.x, bt.y = t.y, bt.z = t.z, $i.x = e.x, $i.y = e.y, $i.z = e.z, this.navMesh.addBoxObstacle(bt, $i, r);
    }
    removeObstacle(t) {
        this.navMesh.removeObstacle(t);
    }
    isSupported() {
        return this.navmeshWasm !== void 0;
    }
}, DE = class {
    constructor(t, e, r){
        this.navmeshWasmWrapper = t;
        this.transforms = [];
        this.agents = new Array;
        this.reachRadii = new Array;
        this._agentDestinationArmed = new Array;
        this._agentDestination = new Array;
        this.crowd = new this.navmeshWasmWrapper.navmeshWasm.Crowd(e, r, this.navmeshWasmWrapper.navMesh.getNavMesh());
    }
    onReachTarget(t, e) {}
    addAgent(t, e, r) {
        let i = new this.navmeshWasmWrapper.navmeshWasm.dtCrowdAgentParams;
        i.radius = e.radius, i.height = e.height, i.maxAcceleration = e.maxAcceleration, i.maxSpeed = e.maxSpeed, i.collisionQueryRange = e.collisionQueryRange, i.pathOptimizationRange = e.pathOptimizationRange, i.separationWeight = e.separationWeight, i.updateFlags = 7, i.obstacleAvoidanceType = 0, i.queryFilterType = 0, i.userData = 0;
        let s = this.crowd.addAgent(new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z), i);
        return this.transforms.push(r), this.agents.push(s), this.reachRadii.push(e.reachRadius ? e.reachRadius : e.radius), this._agentDestinationArmed.push(!1), this._agentDestination.push(new _(0, 0, 0)), s;
    }
    getAgentPosition(t) {
        return this.crowd.getAgentPosition(t);
    }
    getAgentPositionToRef(t, e) {
        let r = this.crowd.getAgentPosition(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentVelocity(t) {
        return this.crowd.getAgentVelocity(t);
    }
    getAgentVelocityToRef(t, e) {
        let r = this.crowd.getAgentVelocity(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentNextTargetPath(t) {
        return this.crowd.getAgentNextTargetPath(t);
    }
    getAgentNextTargetPathToRef(t, e) {
        let r = this.crowd.getAgentNextTargetPath(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentState(t) {
        return this.crowd.getAgentState(t);
    }
    overOffmeshConnection(t) {
        return this.crowd.overOffmeshConnection(t);
    }
    agentGoto(t, e) {
        this.crowd.agentGoto(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
        let r = this.agents.indexOf(t);
        r > -1 && (this._agentDestinationArmed[r] = !0, this._agentDestination[r].set(e.x, e.y, e.z));
    }
    agentTeleport(t, e) {
        this.crowd.agentTeleport(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
    }
    updateAgentParameters(t, e) {
        let r = this.crowd.getAgentParameters(t);
        e.radius !== void 0 && (r.radius = e.radius), e.height !== void 0 && (r.height = e.height), e.maxAcceleration !== void 0 && (r.maxAcceleration = e.maxAcceleration), e.maxSpeed !== void 0 && (r.maxSpeed = e.maxSpeed), e.collisionQueryRange !== void 0 && (r.collisionQueryRange = e.collisionQueryRange), e.pathOptimizationRange !== void 0 && (r.pathOptimizationRange = e.pathOptimizationRange), e.separationWeight !== void 0 && (r.separationWeight = e.separationWeight), this.crowd.setAgentParameters(t, r);
    }
    removeAgent(t) {
        this.crowd.removeAgent(t);
        let e = this.agents.indexOf(t);
        e > -1 && (this.agents.splice(e, 1), this.transforms.splice(e, 1), this.reachRadii.splice(e, 1), this._agentDestinationArmed.splice(e, 1), this._agentDestination.splice(e, 1));
    }
    getAgents() {
        return this.agents;
    }
    update(t) {
        if (this.navmeshWasmWrapper.navMesh.update(), t <= lN) return;
        let e = 1 / 60, r = 10;
        if (e <= lN) this.crowd.update(t);
        else {
            let i = Math.floor(t / e);
            r && i > r && (i = r), i < 1 && (i = 1);
            let s = t / i;
            for(let o = 0; o < i; o++)this.crowd.update(s);
        }
        for(let i = 0; i < this.agents.length; i++){
            let s = this.agents[i], o = this.getAgentPosition(s);
            if (this.transforms[i].copy(o), this._agentDestinationArmed[i]) {
                let a = o.x - this._agentDestination[i].x, l = o.z - this._agentDestination[i].z, u = this.reachRadii[i], c = this._agentDestination[i].y - this.reachRadii[i], d = this._agentDestination[i].y + this.reachRadii[i], h = a * a + l * l;
                o.y > c && o.y < d && h < u * u && (this.onReachTarget(s, this._agentDestination[i]), this._agentDestinationArmed[i] = !1);
            }
        }
    }
    setDefaultQueryExtent(t) {
        let e = new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z);
        this.crowd.setDefaultQueryExtent(e);
    }
    getDefaultQueryExtent() {
        return this.crowd.getDefaultQueryExtent();
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.crowd.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    getCorners(t) {
        let e, r = this.crowd.getCorners(t), i = r.getPointCount(), s = [];
        for(e = 0; e < i; e++){
            let o = r.getPoint(e);
            s.push(new _(o.x, o.y, o.z));
        }
        return s;
    }
    dispose() {
        this.crowd.destroy();
    }
};
function OE(n1) {
    let t = !1;
    return n1.scene.objects.forEach((e)=>{
        e.data.type === "Page" && !t && e.data.publish.gameControlObject && Al.traverseModuleInstances(n1, e.id, (i, s, o)=>{
            for (let a of o)a.data.type === "GameControl" && a.data.navmesh.enabled && (t = !0);
        });
    }), t;
}
var rJ = {
    type: "change"
}, dN = {
    type: "changeZoom"
}, iJ = {
    type: "changePan"
}, Vf = {
    type: "start"
}, Uf = {
    type: "end",
    changed: !0
}, nJ = {
    type: "end",
    changed: !1
}, IE = new je, hN = new N, sJ = 2 * Math.PI, oJ = 1e-8, aJ = .01, RE = new _, _b = new N, LE = new _, Eb = new je, fN = new te;
var lJ = {
    type: "requestRender"
}, Gf = class extends ir {
    constructor(e, r, i = {
        isPlayMode: !1,
        isExport: !1
    }){
        super();
        this.object = e;
        this.domElement = r;
        this.options = i;
        this.enabled = !0;
        this.useKeyEvents = !0;
        this.enableDamping = !1;
        this.enableZoom = !0;
        this.enableRotate = !0;
        this.enablePan = !0;
        this.autoRotate = !1;
        this.rotationLimitsMode = 0;
        this.panLimitsMode = 0;
        this.rotationSoftLimit = 2;
        this.panSoftLimit = 2;
        this.hoverRotatePanMode = 0;
        this.zoomLimitsEnabled = !1;
        this.mouseButtons = [
            0,
            5
        ];
        this.mouseButtonsPlay = [
            3,
            4,
            5
        ];
        this.touches = [
            null,
            qn.DOLLY_ROTATE,
            qn.PAN
        ];
        this.offset = new _;
        this.eye = new _;
        this.lastPosition = new _;
        this.lastQuaternion = new je;
        this.current = new N;
        this.overShoot = new N;
        this.overRatio = new N;
        this.spherical = new wp;
        this.sphericalDelta = new wp;
        this.panOffset = new _;
        this.panLeftV = new _;
        this.panUpV = new _;
        this.panV = new _;
        this.rotateStart = new N;
        this.rotateEnd = new N;
        this.rotateDelta = new N;
        this.panStart = new N;
        this.panEnd = new N;
        this.panDelta = new N;
        this.dollyStart = new N;
        this.dollyEnd = new N;
        this.dollyDelta = new N;
        this.rotationRangeFactor = new N;
        this.panRangeFactor = new N;
        this.state = -1;
        this.zoomChanged = !1;
        this.isPointerDown = !1;
        this.isThetaFlipped = !1;
        this.prevScale = 0;
        this.scale = 1;
        this.gesture = !1;
        this.timer = -1;
        this.timerHover = -1;
        this.minDistance = 0;
        this.maxDistance = 1 / 0;
        this.minZoom = 0;
        this.maxZoom = 1 / 0;
        this.minPhi = 0;
        this.maxPhi = Math.PI;
        this.minTheta = -1 / 0;
        this.maxTheta = 1 / 0;
        this.minH = 0;
        this.maxH = Math.PI;
        this.minV = -1 / 0;
        this.maxV = 1 / 0;
        this.autoRotateClockwise = !0;
        this.isPanOverShoot = !1;
        this.isRotateOverShoot = !1;
        this.resetHoverEffectOnPointerLeave = !1;
        this.hasChange = !1;
        this.useWindowEvents = !1;
        this.isTouchZoom = !0;
        this.autoRotateSpeed = 2;
        this.dampingFactor = .125;
        this.zoomSpeed = 2;
        this.rotateSpeed = 1;
        this.panSpeed = 1;
        this.hoverRotatePanStrength = .1;
        this.hoverRotateDamping = this.dampingFactor;
        this.thetaIsFree = !1;
        this.phiIsFree = !1;
        this.needsUpdate = !0;
        this.onCameraChange = (e)=>{
            this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange), this.object = e.camera, this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
        };
        this.update = ()=>{
            this.object.updateWorldMatrix(!0, !1), this.object.matrixWorld.decompose(LE, Eb, RE), this.offset.copy(LE).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.autoRotate && this.state === -1 && this.rotateLeft((this.autoRotateClockwise === !0 ? 1 : -1) * this.getAutoRotationAngle()), this.rotationLimitsMode !== 0 && this.applyLimits(this.sphericalDelta, this.rotationLimitsMode, this.rotationSoftLimit, this.maxTheta, this.minTheta, this.maxPhi, this.minPhi, this.rotationRangeFactor), this.rotationLimitsMode !== 2 && (this.spherical.phi += this.sphericalDelta.phi), (this.rotationLimitsMode !== 1 || this.autoRotate === !0) && (this.spherical.theta += this.sphericalDelta.theta), this.spherical.radius *= this.scale, this.zoomLimitsEnabled && (this.spherical.radius = Math.max(this.minDistance, Math.min(this.maxDistance, this.spherical.radius))), this.panLimitsMode !== 0 && (this.target.applyQuaternion(IE.copy(Eb).invert()), this.panOffset.applyQuaternion(IE), this.applyLimits(this.panOffset, this.panLimitsMode, this.panSoftLimit, this.maxH, this.minH, this.maxV, this.minV, this.panRangeFactor), this.target.applyQuaternion(Eb), this.panOffset.applyQuaternion(Eb)), this.panLimitsMode === 2 && (this.panOffset.y = 0), this.panLimitsMode === 1 && (this.panOffset.x = 0), this.state === -1 && !this.gesture ? (this.panOffset.multiplyScalar(1 - this.dampingFactor), this.target.add(this.panOffset)) : (this.target.add(this.panOffset), this.panOffset.set(0, 0, 0)), this.offset.setFromSpherical(this.spherical), LE.copy(this.target).add(this.offset), this.object.position.copy(this.target).add(this.offset), this.object.parent && (fN.copy(this.object.parent.matrixWorld).invert(), this.object.position.applyMatrix4(fN));
            let e = this.spherical.phi % sJ;
            if (this.eye.copy(this.offset).normalize(), this.object.up.copy(mt.DEFAULT_UP).applyAxisAngle(this.eye, this.object.angleOffsetFromUp), e > 0 && e > Math.PI || e < 0 && e > -Math.PI ? (this.object.up.negate(), this.object.lookAt(this.target), this.object.isUpVectorFlipped = !0) : (this.object.lookAt(this.target), this.object.isUpVectorFlipped = !1), this.state === -1 || this.enableDamping === !0) {
                let r = this.hoverRotatePanMode === 1 ? this.hoverRotateDamping : this.dampingFactor;
                this.sphericalDelta.theta *= 1 - r, this.sphericalDelta.phi *= 1 - r;
            } else this.sphericalDelta.set(0, 0, 0);
            return this.scale = 1, this.zoomChanged || this.lastPosition.distanceToSquared(this.object.position) > aJ || 8 * (1 - this.lastQuaternion.dot(this.object.quaternion)) > oJ ? (this.dispatchEvent(rJ), this.object.dispatchEvent(lJ), this.lastPosition.copy(this.object.position), this.lastQuaternion.copy(this.object.quaternion), this.zoomChanged = !1, !0) : (this.isPanOverShoot = !1, this.isRotateOverShoot = !1, this.object.wasMovedBySwitchCameraAction = !1, this.sphericalDelta.set(0, 0, 0), this.panOffset.set(0, 0, 0), !1);
        };
        this.onPointerDown = (e)=>{
            this.enabled !== !1 && (e.pointerType === "touch" || e.pointerType === "pen" && Si ? this.onPointerDownTouch(e) : this.onPointerDownMouse(e), this.state !== -1 && (this.isPointerDown = !0, this.dispatchEvent(Vf), this.domElement.addEventListener("pointermove", this.onPointerMove), this.domElement.addEventListener("pointerup", this.onPointerUp), e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Si || this.domElement.setPointerCapture(e.pointerId)));
        };
        this.onPointerLeave = (e)=>{
            this.resetHoverEffectOnPointerLeave && !this.useWindowEvents ? (this.hoverRotatePanMode === 1 ? (this.sphericalDelta.theta = -this.spherical.theta, this.sphericalDelta.phi = -this.spherical.phi, RE.subVectors(this.position0, this.target0), this.spherical.setFromVector3(RE), this.sphericalDelta.theta += this.spherical.theta, this.sphericalDelta.phi += this.spherical.phi, this.sphericalDelta.theta /= 8, this.sphericalDelta.phi /= 8) : this.hoverRotatePanMode === 2 && this.panOffset.subVectors(this.target0, this.target).divideScalar(8), this.update()) : this.pointerLeaveEvent = e;
        };
        this.onPointerEnter = (e)=>{
            this.resetHoverEffectOnPointerLeave || this.pointerLeaveEvent === void 0 ? _b.set(e.clientX - this.domElement.clientWidth / 2, e.clientY - this.domElement.clientHeight / 2) : _b.set(e.clientX - this.pointerLeaveEvent.clientX, e.clientY - this.pointerLeaveEvent.clientY), this.hoverRotatePanMode === 1 ? (this.rotateDelta.copy(_b).multiplyScalar(this.rotateSpeed * this.hoverRotatePanStrength).rotateAround(hN, -this.object.angleOffsetFromUp), this.rotateLeft(2 * Math.PI * this.rotateDelta.x / this.domElement.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / this.domElement.clientHeight), this.rotateStart.set(e.clientX, e.clientY)) : this.hoverRotatePanMode === 2 && (this.panDelta.copy(_b).multiplyScalar(this.panSpeed * this.hoverRotatePanStrength), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.set(e.clientX, e.clientY)), this.update();
        };
        this.onPointerMove = (e)=>{
            this.enabled !== !1 && (this.checkRaycastLock() || (e.pointerType === "touch" || e.pointerType === "pen" && Si ? this.onPointerMoveTouch(e) : this.onPointerMoveMouse(e), e.stopPropagation()));
        };
        this.onPointerUp = (e)=>{
            this.isPointerDown = !1, Ye.length === 0 && (this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp)), Ye.length > 1 && e.preventDefault(), this.hasChange ? this.dispatchEvent(Uf) : this.dispatchEvent(nJ), this.state = -1, e && (e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Si || this.domElement.releasePointerCapture(e.pointerId));
        };
        this.onPointerDownMouse = (e)=>{
            let r;
            switch(this.useKeyEvents ? r = this.mouseButtons[e.button] : r = this.mouseButtonsPlay[e.button], r){
                case 0:
                    if (e.altKey === !0 && !e.shiftKey && !Lp(e)) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else if (this.key === " ") {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleMouseDownPan(e), this.state = 2;
                    break;
                case 3:
                    if (Lp(e) || e.shiftKey) {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    } else {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    }
                    break;
                case 5:
                    if (Lp(e) || e.shiftKey) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveMouse = (e)=>{
            switch(this.state){
                case 0:
                    if (this.enableRotate === !1) return;
                    this.handleMouseMoveRotate(e);
                    break;
                case 1:
                    if (this.enableZoom === !1) return;
                    this.handleMouseMoveDolly(e);
                    break;
                case 2:
                    if (this.enablePan === !1) return;
                    this.handleMouseMovePan(e);
                    break;
            }
            this.object.wasMovedByUser = !0;
        };
        this.onPointerDownTouch = (e)=>{
            switch(Ye.length > 1 && e.preventDefault(), this.touches[Ye.length - 1]){
                case qn.ROTATE:
                    if (this.enableRotate === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartRotate(), this.state = 3;
                    break;
                case qn.PAN:
                    if (this.enablePan === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartPan(), this.state = 4;
                    break;
                case qn.DOLLY_PAN:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchStartDollyPan(), this.state = 5;
                    break;
                case qn.DOLLY_ROTATE:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchStartDollyRotate(), this.state = 6;
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveTouch = (e)=>{
            switch(Ye.length > 1 && e.preventDefault(), this.state){
                case 3:
                    if (this.enableRotate === !1) return;
                    this.handleTouchMoveRotate(e), this.update();
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleTouchMovePan(e), this.update();
                    break;
                case 5:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchMoveDollyPan(e), this.update();
                    break;
                case 6:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchMoveDollyRotate(e), this.update();
                    break;
                default:
                    this.state = -1;
            }
            this.object.wasMovedByUser = !0;
        };
        this.dispatchEndDebounced = Ec(()=>this.dispatchEvent(Uf), 33);
        this.onMouseWheel = (e)=>{
            this.enabled === !1 || this.enableZoom === !1 && this.enablePan === !1 || this.checkRaycastLock() || (!this.options.isExport && this.domElement.clientHeight === document.body.clientHeight && this.domElement.clientWidth === document.body.clientWidth && e.preventDefault(), this.dispatchEvent(Vf), this.handleMouseWheel(e), this.dispatchEndDebounced(), this.object.wasMovedByUser = !0);
        };
        this.onGesture = (e)=>{
            if (e.preventDefault(), this.enabled !== !1 && !this.checkRaycastLock() && !Md) {
                if (e.type === "gesturechange") {
                    if (this.enableZoom === !1 || this.isTouchZoom === !1) return;
                    this.dispatchEvent(Vf), e.scale > this.prevScale ? this.dollyIn(this.getZoomScale()) : e.scale < this.prevScale && this.dollyOut(this.getZoomScale()), this.prevScale = e.scale, this.update(), this.object.wasMovedByUser = !0;
                } else this.dispatchEvent(Uf);
            }
        };
        this.onContextMenu = (e)=>{
            e.preventDefault();
        };
        this.onTouchEnd = (e)=>{
            e.preventDefault();
        };
        this.onKeyDown = (e)=>{
            this.enabled !== !1 && (this.key = e.key, e.key === " " && this.dispatchEvent(Vf));
        };
        this.onKeyUp = (e)=>{
            this.enabled !== !1 && (this.key = void 0, this.state !== -1 && e.key === "Alt" && this.onPointerUp(Ye[0]), e.key === " " && this.dispatchEvent(Uf));
        };
        this.onPointerHover = (e)=>{
            e.pointerType !== "mouse" || this.enabled === !1 || this.state !== -1 || this.hoverRotatePanMode === 2 && this.isPanOverShoot || this.hoverRotatePanMode === 1 && this.isRotateOverShoot || (this.isPointerDown = !0, this.hoverRotatePanMode === 2 ? this.handleMouseMovePan(e, this.hoverRotatePanStrength) : this.hoverRotatePanMode === 1 && this.handleMouseMoveRotate(e, this.hoverRotatePanStrength));
        };
        this.onBeginState = ()=>{
            this.enabled = !1, this.needsUpdate = !1;
        };
        this.onCompleteState = (e)=>{
            e.isfromEntity && this.options.isPlayMode || (this.enabled = !0, this.needsUpdate = !0, this.object.updateUp(), this.object.getTarget(this.target));
        };
        this.target = this.object.getTarget(), this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this.quat0 = this.object.quaternion.clone(), this.isUpVectorFlipped0 = this.object.isUpVectorFlipped, this.offset.copy(this.object.position).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.addEventListenersToCamera();
    }
    dispatchEvent(e) {
        e.type === "start" ? this.hasChange = !1 : this.hasChange = !0, super.dispatchEvent(e);
    }
    addEventListenersToCamera() {
        this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
    }
    removeEventListenersFromCamera() {
        this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange);
    }
    updateUseWindowEvents(e) {
        if (window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("pointermove", this.onPointerHover), this.useWindowEvents = e, this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover)), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let r = this.useWindowEvents ? window : this.domElement;
            r.addEventListener("pointerleave", this.onPointerLeave), r.addEventListener("pointerenter", this.onPointerEnter);
        }
    }
    fromJSON(e, r) {
        this.setEnableDampingSpeed(e.enableDamping), this.enablePan = e.enablePan, this.enableZoom = e.enableZoom, this.enableRotate = e.enableRotate, this.rotationLimitsMode = e.rotationLimitsMode, this.thetaIsFree = e.rotationHorizontalOffset.min === e.rotationHorizontalOffset.max && e.rotationHorizontalOffset.min === Math.PI, this.phiIsFree = e.rotationVerticalOffset.min === e.rotationVerticalOffset.max && e.rotationVerticalOffset.min === Math.PI, this.panLimitsMode = e.panLimitsMode, this.panSoftLimit = e.panSoftLimit, this.rotationSoftLimit = e.rotationSoftLimit, this.hoverRotatePanMode = e.hoverRotatePanMode, this.hoverRotateDamping = e.hoverRotateDamping ?? this.dampingFactor, this.useWindowEvents = r === "window", this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover));
        let i = e.hoverRotatePanStrength / 100;
        this.hoverRotatePanStrength = i ** 2, this.zoomLimitsEnabled = e.zoomLimitsEnabled, this.minZoom = e.zoomLimits.min, this.maxZoom = Math.max(e.zoomLimits.min, e.zoomLimits.max), this.minDistance = 1e3 / e.zoomLimits.max, this.maxDistance = Math.max(this.minDistance, 1e3 / e.zoomLimits.min), this.autoRotate = e.autoRotate, this.autoRotateSpeed = e.autoRotateSpeed, this.autoRotateClockwise = e.autoRotateClockwise;
        let s = this.object.getTarget().applyQuaternion(IE.copy(this.object.quaternion).invert());
        this.minV = -e.panVerticalOffset.min + s.y, this.maxV = e.panVerticalOffset.max + s.y, this.minH = -e.panHorizontalOffset.min + s.x, this.maxH = e.panHorizontalOffset.max + s.x, this.panRangeFactor.set(this.maxH - this.minH, this.maxV - this.minV).divideScalar(2), this.rotationRangeFactor.setScalar(Math.PI).divideScalar(4), this.minPhi = Xo(this.spherical.phi - e.rotationVerticalOffset.min), this.maxPhi = Xo(this.spherical.phi + e.rotationVerticalOffset.max), this.minTheta = Xo(Xo(this.spherical.theta) - e.rotationHorizontalOffset.min), this.maxTheta = Xo(Xo(this.spherical.theta) + e.rotationHorizontalOffset.max), this.isThetaFlipped = this.minTheta > this.maxTheta, e.orbitTouches === 1 && (this.touches[0] = qn.ROTATE), e.panTouches === 1 && (this.touches[0] = qn.PAN), e.orbitTouches === 2 && (this.touches[1] = qn.DOLLY_ROTATE), e.panTouches === 2 && (this.touches[1] = qn.DOLLY_PAN), e.orbitTouches === 3 && (this.touches[2] = qn.ROTATE), e.panTouches === 3 && (this.touches[2] = qn.PAN), this.isTouchZoom = e.isTouchZoom, this.resetHoverEffectOnPointerLeave = e.resetHoverEffectOnPointerLeave ?? !1;
    }
    connect() {
        if (this.domElement.addEventListener("contextmenu", this.onContextMenu), this.domElement.addEventListener("pointerdown", this.onPointerDown), this.domElement.addEventListener("wheel", this.onMouseWheel), window.addEventListener("keydown", this.onKeyDown, !1), window.addEventListener("keyup", this.onKeyUp, !1), this.domElement.addEventListener("gesturestart", this.onGesture), this.domElement.addEventListener("gesturechange", this.onGesture), this.domElement.addEventListener("gestureend", this.onGesture), this.domElement.addEventListener("touchend", this.onTouchEnd), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let e = this.useWindowEvents ? window : this.domElement;
            e.addEventListener("pointerleave", this.onPointerLeave), e.addEventListener("pointerenter", this.onPointerEnter);
        }
        this.pointerLeaveEvent = void 0;
    }
    dispose() {
        this.removeEventListenersFromCamera(), this.domElement.removeEventListener("contextmenu", this.onContextMenu), this.domElement.removeEventListener("pointerdown", this.onPointerDown), this.domElement.removeEventListener("wheel", this.onMouseWheel), window.removeEventListener("keydown", this.onKeyDown, !1), window.removeEventListener("keyup", this.onKeyUp, !1), this.domElement.removeEventListener("pointermove", this.onPointerHover), window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("gesturestart", this.onGesture), this.domElement.removeEventListener("gesturechange", this.onGesture), this.domElement.removeEventListener("gestureend", this.onGesture), this.domElement.removeEventListener("touchend", this.onTouchEnd), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp);
    }
    applyLimits(e, r, i, s, o, a, l, u) {
        this.overShoot.set(0, 0);
        let c, d, h;
        e instanceof _ ? (c = e.x, d = e.y, this.current.set(this.target.x, this.target.y), h = !0) : (c = e.theta, d = e.phi, this.current.set(Xo(this.spherical.theta), Xo(this.spherical.phi)), h = !1), i === 0 && (this.current.x += c, this.current.y += d), (r === 3 || r === 2) && (!h && this.isThetaFlipped ? this.current.x > s && this.current.x < 0 ? this.overShoot.x = s - this.current.x : this.current.x < o && this.current.x > 0 && (this.overShoot.x = o - this.current.x) : this.current.x > s ? this.overShoot.x = s - this.current.x : this.current.x < o && (this.overShoot.x = o - this.current.x)), (r === 3 || r === 1) && (this.current.y > a ? this.overShoot.y = a - this.current.y : this.current.y < l && (this.overShoot.y = l - this.current.y)), h || (this.overShoot.x = Xo(this.overShoot.x), this.overShoot.y = Xo(this.overShoot.y)), i !== 0 ? (this.overRatio.copy(this.overShoot).divide(u), this.overRatio.x = Math.min(Math.abs(this.overRatio.x), 1), this.overRatio.y = Math.min(Math.abs(this.overRatio.y), 1), i === 1 && (this.overRatio.x = pN(Math.abs(this.overRatio.x)), this.overRatio.y = pN(Math.abs(this.overRatio.y))), this.isPointerDown || i === 1 ? i === 2 && (this.overRatio.x > .9 && !this.thetaIsFree || this.overRatio.y > .9 && !this.phiIsFree) ? this.isPointerDown = !1 : (c * this.overShoot.x < 0 && !this.thetaIsFree && (c *= 1 - this.overRatio.x), d * this.overShoot.y < 0 && !this.phiIsFree && (d *= 1 - this.overRatio.y)) : i === 2 && (!h && (this.overRatio.x > .002 && !this.thetaIsFree || this.overRatio.y > .002 && !this.phiIsFree) || h && (Math.abs(this.overShoot.x) > 2 || Math.abs(this.overShoot.y) > 2) ? (this.thetaIsFree || (c = this.overShoot.x * .05), this.phiIsFree || (d = this.overShoot.y * .05), h ? this.isPanOverShoot = !0 : this.isRotateOverShoot = !0) : h ? this.isPanOverShoot = !1 : this.isRotateOverShoot = !1)) : (c += this.overShoot.x, d += this.overShoot.y), e instanceof _ ? (e.x = c, e.y = d) : (this.thetaIsFree || (e.theta = c), this.phiIsFree || (e.phi = d));
    }
    setEnableDampingSpeed(e) {
        this.enableDamping = e, this.rotateSpeed = e === !0 ? .2 : 1;
    }
    stopDamping() {
        this.sphericalDelta.theta = 0, this.sphericalDelta.phi = 0;
    }
    getAutoRotationAngle() {
        return 2 * Math.PI / 60 / 60 * this.autoRotateSpeed;
    }
    getZoomScale() {
        return Math.pow(.95, this.zoomSpeed);
    }
    rotateLeft(e) {
        this.sphericalDelta.theta -= e;
    }
    rotateUp(e) {
        this.sphericalDelta.phi -= e;
    }
    panLeft(e, r) {
        this.panLeftV.setFromMatrixColumn(r, 0), this.panLeftV.multiplyScalar(-e), this.panOffset.add(this.panLeftV);
    }
    panUp(e, r) {
        this.panUpV.setFromMatrixColumn(r, 1), this.panUpV.multiplyScalar(e), this.panOffset.add(this.panUpV);
    }
    pan(e, r) {
        let i = this.domElement;
        if (i && this.object.isPerspectiveCamera) {
            let s = this.object.position;
            this.panV.copy(s).sub(this.target);
            let o = this.panV.length();
            o *= Math.tan(this.object.fov / 2 * Math.PI / 180), this.panLeft(2 * e * o / i.clientHeight, this.object.matrixWorld), this.panUp(2 * r * o / i.clientHeight, this.object.matrixWorld);
        } else i && this.object.isOrthographicCamera && (this.panLeft(e * (this.object.right - this.object.left) / this.object.zoom / i.clientWidth, this.object.matrixWorld), this.panUp(r * (this.object.top - this.object.bottom) / this.object.zoom / i.clientHeight, this.object.matrixWorld));
        this.dispatchEvent(iJ);
    }
    dollyOut(e) {
        this.object.isPerspectiveCamera ? this.scale /= e : this.object.isOrthographicCamera && (this.object.zoom *= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(dN);
    }
    dollyIn(e) {
        this.object.isPerspectiveCamera ? this.scale *= e : this.object.isOrthographicCamera && (this.object.zoom /= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(dN);
    }
    zoomOut(e = this.getZoomScale()) {
        this.dispatchEvent(Vf), this.dollyOut(e), this.dispatchEvent(Uf);
    }
    zoomIn(e = this.getZoomScale()) {
        this.dispatchEvent(Vf), this.dollyIn(e), this.dispatchEvent(Uf);
    }
    handleMouseDownRotate(e) {
        this.rotateStart.set(e.clientX, e.clientY);
    }
    handleMouseDownDolly(e) {
        this.dollyStart.set(e.clientX, e.clientY);
    }
    handleMouseDownPan(e) {
        this.panStart.set(e.clientX, e.clientY);
    }
    handleMouseMoveRotate(e, r = 1) {
        e.movementX !== void 0 ? this.rotateDelta.set(e.movementX, e.movementY) : (this.rotateEnd.set(e.clientX, e.clientY), this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart), this.rotateStart.copy(this.rotateEnd)), this.rotateDelta.multiplyScalar(this.rotateSpeed * r).rotateAround(hN, -this.object.angleOffsetFromUp);
        let i = this.domElement, s = this.useWindowEvents ? window.innerHeight : i.clientHeight, o = 2 * Math.PI * this.rotateDelta.x / s, a = 2 * Math.PI * this.rotateDelta.y / s;
        this.rotateLeft(o), this.rotateUp(a), this.update();
    }
    handleMouseMoveDolly(e) {
        this.dollyEnd.set(e.clientX, e.clientY), this.dollyDelta.subVectors(this.dollyEnd, this.dollyStart), this.dollyDelta.y > 0 ? this.dollyOut(this.getZoomScale()) : this.dollyDelta.y < 0 && this.dollyIn(this.getZoomScale()), this.dollyStart.copy(this.dollyEnd), this.update();
    }
    handleMouseMovePan(e, r = 1) {
        e.movementX !== void 0 ? this.panDelta.set(e.movementX, e.movementY) : (this.panEnd.set(e.clientX, e.clientY), this.panDelta.subVectors(this.panEnd, this.panStart), this.panStart.copy(this.panEnd)), this.panDelta.multiplyScalar(this.panSpeed * r), this.pan(this.panDelta.x, this.panDelta.y), this.update();
    }
    handleMouseWheel(e) {
        if (x2 === !1 && Lp(e) === !1 && b2(e) === !0) {
            if (this.enablePan === !1) return;
            this.gesture ? (this.panDelta.set(-e.deltaX, -e.deltaY).multiplyScalar(this.panSpeed), this.panDelta.x = Math.min(Math.abs(this.panDelta.x), 100) * (this.panDelta.x < 0 ? -1 : 1), this.panDelta.y = Math.min(Math.abs(this.panDelta.y), 100) * (this.panDelta.y < 0 ? -1 : 1), e.altKey ? this.pan(0, this.panDelta.y) : e.shiftKey ? this.pan(this.panDelta.x, 0) : this.pan(this.panDelta.x, this.panDelta.y), this.update()) : (this.gesture = !0, this.isPointerDown = !0), window.clearTimeout(this.timer), this.timer = window.setTimeout(()=>{
                this.gesture = !1, this.isPointerDown = !1;
            }, 30);
        } else {
            if (this.enableZoom === !1) return;
            e.deltaY === 0 ? e.deltaX < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaX > 0 && this.dollyOut(this.getZoomScale()) : e.deltaY < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaY > 0 && this.dollyOut(this.getZoomScale()), this.update(), this.gesture = !1, this.isPointerDown = !1;
        }
    }
    handleTouchStartRotate() {
        if (Ye.length === 2) {
            let e = .5 * (Ye[0].pageX + Ye[1].pageX), r = .5 * (Ye[0].pageY + Ye[1].pageY);
            this.rotateStart.set(e, r);
        } else this.rotateStart.set(Ye[0].pageX, Ye[0].pageY);
    }
    handleTouchStartPan() {
        if (Ye.length === 2) {
            let e = .5 * (Ye[0].pageX + Ye[1].pageX), r = .5 * (Ye[0].pageY + Ye[1].pageY);
            this.panStart.set(e, r);
        } else this.panStart.set(Ye[0].pageX, Ye[0].pageY);
    }
    handleTouchStartDolly() {
        let e = Ye[0].pageX - Ye[1].pageX, r = Ye[0].pageY - Ye[1].pageY, i = Math.sqrt(e * e + r * r);
        this.dollyStart.set(0, i);
    }
    handleTouchStartDollyPan() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enablePan && this.handleTouchStartPan();
    }
    handleTouchStartDollyRotate() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enableRotate && this.handleTouchStartRotate();
    }
    handleTouchMoveRotate(e) {
        if (Ye.length === 2) {
            let i = lv(e), s = .5 * (e.pageX + i.x), o = .5 * (e.pageY + i.y);
            this.rotateEnd.set(s, o);
        } else {
            if (e.pointerId !== Ye[0].pointerId) return;
            this.rotateEnd.set(e.pageX, e.pageY);
        }
        this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart).multiplyScalar(this.rotateSpeed);
        let r = this.domElement;
        r && (this.rotateLeft(2 * Math.PI * this.rotateDelta.x / r.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / r.clientHeight)), this.rotateStart.copy(this.rotateEnd);
    }
    handleTouchMovePan(e) {
        if (Ye.length === 2) {
            let r = lv(e), i = .5 * (e.pageX + r.x), s = .5 * (e.pageY + r.y);
            this.panEnd.set(i, s);
        } else {
            if (e.pointerId !== Ye[0].pointerId) return;
            this.panEnd.set(e.pageX, e.pageY);
        }
        this.panDelta.subVectors(this.panEnd, this.panStart).multiplyScalar(this.panSpeed), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.copy(this.panEnd);
    }
    handleTouchMoveDolly(e) {
        let r = lv(e), i = e.pageX - r.x, s = e.pageY - r.y, o = Math.sqrt(i * i + s * s);
        this.dollyEnd.set(0, o), this.dollyDelta.set(0, Math.pow(this.dollyEnd.y / this.dollyStart.y, this.zoomSpeed)), this.dollyOut(this.dollyDelta.y), this.dollyStart.copy(this.dollyEnd);
    }
    handleTouchMoveDollyPan(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enablePan && this.handleTouchMovePan(e);
    }
    handleTouchMoveDollyRotate(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enableRotate && this.handleTouchMoveRotate(e);
    }
    checkRaycastLock() {
        if (this.object.data.raycastLock) {
            if (this.options.isPlayMode) return !1;
            {
                let e = this.options?.showCameraLock;
                return e && e(), !0;
            }
        } else return !1;
    }
};
function Xo(n1) {
    let t = Math.PI * 2;
    for(; n1 <= -Math.PI;)n1 += t;
    for(; n1 > Math.PI;)n1 -= t;
    return n1;
}
function pN(n1) {
    return 1 - Math.pow(1 - n1, 4);
}
var xg = class {
    constructor(t, e, r, i, s, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.page = i;
        this.currentIntersectedObjects = [];
        this.disabled = !1;
        this.alreadyPlayedNonTogglingActions = new Set;
        this.actions = gr(e, e.actions, i, s, o, r), this.target = e.target, this.useToggle = e.runMode === "Toggle", this.triggeringObjects = e.triggeringObjects.map((a)=>i.scene.find(a));
    }
    isValidTriggeringObject(t) {
        return this.target === "all" ? !0 : this.triggeringObjects.some((e)=>e === t || e.isAncestorOf(t.uuid) || t.isAncestorOf(e.uuid));
    }
    disconnect() {
        tr(this.actions);
    }
    dispatch() {
        this.disabled || this.object.destroyedInAction || (this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this ? (t.object.currentTransitionEvent = this, t.init()) : this.data.runMode === "Once" && this.alreadyPlayedNonTogglingActions.add(t);
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Trigger"
        }), this.useToggle ? (this.actions.Transition.forEach((t)=>{
            t.toggle();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.toggle();
        })) : (this.actions.Transition.forEach((t)=>{
            this.alreadyPlayedNonTogglingActions.has(t) === !1 && t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.play();
        })), this.actions.Link.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>{
            t.dispatch();
        }), this.actions.Create.forEach((t)=>{
            t.dispatch();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatch(!1);
        }), this.actions.Audio.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Particles.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Video.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()));
    }
};
var Pt;
O2.then((n1)=>Pt = n1);
var pi = new _, so = new je, Jl = new _, BE = new Kt(0, 0, 0, "YXZ"), mN = new Kt(0, 0, 0, "XYZ"), oo = new _, NE = new _, FE = new _(1, 1, 1), jf = new je, Tb = new te, gN = new te, cJ = {
    type: "updateMatrix"
}, yN = new je, kE = new Er, ab = {
    type: "beginEvent",
    eventName: "Collision"
}, uJ = {
    type: "beginEvent",
    eventName: "Trigger"
};
function vN(n1) {
    if (Al.physicsEnabled(n1.scene.objects)) return !0;
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.events) {
            if (Array.isArray(r.events)) {
                for (let i of r.events)if (i.data.disabled !== !0 && i.data.type === "GameControl" && i.data.collisionEnabled) {
                    t = !0;
                    break;
                }
            } else for (let i of Object.values(r.events))if (i.disabled !== !0 && i.type === "GameControl" && i.collisionEnabled) {
                t = !0;
                break;
            }
        }
    }), t;
}
var vg = (n1)=>n1.states.some((t)=>t.data.position !== void 0 || t.data.rotation !== void 0 || t.data.hiddenMatrix !== void 0 || t.data.cloner !== void 0 || t.data.pathSnapping !== void 0), Mb = class {
    constructor(t){
        this.eventContext = t;
        this.isEnabled = !1;
        this.gameControl = null;
        this.joysticks = [];
        this.joystickToGameControls = [];
        this.sharedGameControlGlobals = {
            entitiesWithTransformAnim: [],
            entityToCollisionEvents: {},
            colliderToEntity: new Map,
            triggers: [],
            gamePads: [],
            createdObjects: [],
            nCreatedPerAction: {}
        };
        this.sensorToTriggerEvent = {};
        this.eventManager = void 0;
        this.needsCollisionDetection = !1;
        this.initializationCounter = -1;
        this.rigidBodyToMesh = new Map;
        this.nActiveRigidBodies = 0;
        this.collisionEvents = [];
        this.isExport = !1;
        this.processRigidBody = (t)=>{
            if (t.bodyType() !== Pt.RigidBodyType.Dynamic) return;
            t.isSleeping() || this.nActiveRigidBodies++;
            let [e, r, i] = this.rigidBodyToMesh.get(t.handle);
            if (pi.copy(t.translation()).multiplyScalar(this.pixelsPerMeter), so.copy(t.rotation()), e.matrixWorld.compose(pi, so, r), e.hasNonUniformScale && e.matrixWorld.multiply(e.shearScale), e.dispatchEvent(cJ), i) {
                let s = e.cloner;
                if (s && s.objectForSample === void 0) {
                    s.matrixWorld.copy(e.matrixWorld);
                    for (let o of s.children)o.updateMatrixWorld(!0);
                }
                for (let o of e.children)o.updateMatrixWorld(!0);
            }
        };
        this.accumulator = 0;
        this.handleCollisionEvents = (t, e, r)=>{
            if (r === !1) return;
            let i, s;
            if (this.sensorToTriggerEvent[t] ? (i = this.sensorToTriggerEvent[t], s = this.sharedGameControlGlobals.colliderToEntity.get(e)) : this.sensorToTriggerEvent[e] && (i = this.sensorToTriggerEvent[e], s = this.sharedGameControlGlobals.colliderToEntity.get(t)), i && s && i.isValidTriggeringObject(s)) {
                i.dispatch();
                return;
            }
            for(let o = this.sharedGameControlGlobals.createdObjects.length - 1; o >= 0; o--){
                let a = this.sharedGameControlGlobals.createdObjects[o];
                if (a.userData.hasCollisionDestroy && (a.rigidBody?.collider(0).handle === t || a.rigidBody?.collider(0).handle === e)) {
                    this.sharedGameControlGlobals.createdObjects.splice(o, 1), a.removeFromParent(), requestAnimationFrame(()=>this.sharedGameControlGlobals.rapierWorld?.removeRigidBody(a.rigidBody));
                    break;
                }
            }
            if (this.gameControl?.object === this.sharedGameControlGlobals.colliderToEntity.get(t)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(e), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, e);
            } else if (this.gameControl?.object === this.sharedGameControlGlobals.colliderToEntity.get(e)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, t);
            } else {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a !== void 0) for (let c of a)c.data.target === "scene" && this.dispatchCollisionEvent(c, o, t);
                let l = this.sharedGameControlGlobals.colliderToEntity.get(e), u = this.sharedGameControlGlobals.entityToCollisionEvents[l?.uuid];
                if (u !== void 0) for (let c of u)c.data.target === "scene" && this.dispatchCollisionEvent(c, l, e);
            }
        };
        this.isExport = t.isExport, this.sharedAssets = t.sharedAssets, this.renderer = t.renderer, this.requestRender = t.requestRender, this.domElement = this.renderer.domElement, this.pixelsPerMeter = dE, this.gravity = this.page.data.globalPhysics.gravity;
    }
    get page() {
        return this.eventContext.page;
    }
    attachVRControllers(t) {
        t.forEach((e)=>{
            e.addEventListener("connected", (r)=>{
                "gamepad" in r.data && "axes" in r.data.gamepad && this.sharedGameControlGlobals.gamePads.push(r.data.gamepad);
            });
        });
    }
    markIsDestroyTarget() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events){
                if (r.data.disabled === !0) continue;
                let i = r.data.actions?.find((s)=>s.data.type === "Destroy")?.data;
                if (i) for (let s of i.objects){
                    let o = this.page.scene.find(s);
                    o && (o.userData.hasDestroy = !0);
                }
            }
        });
    }
    markIsDragObject() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events)if (!(r.data.disabled === !0 || r.data.type !== "DragDrop")) for (let i of r.data.objects){
                let s = this.page.scene.find(i);
                s && (s.userData.hasDrag = !0);
            }
        });
    }
    initBVH() {
        let t = [];
        if (this.page.traverseChildren((e)=>{
            let r, i = e instanceof Xc, s = e instanceof eu;
            if (e instanceof Gi || i || s) return;
            e instanceof Pr ? r = e.object : r = e;
            let o = r.dataPatched;
            if (o.physics?.enabled === "visibility" ? !o.visible : !o.physics?.enabled) return !0;
            let a = e.geometry, l = r.userData.hasDestroy === !0, u = r.userData.hasDrag === !0;
            if (vg(o) || l || u || r.dataPatched.events.some((c)=>c.data.disabled !== !0 && c.data.type === "GameControl")) return e.updateMatrixWorldSVD(), this.addBoundsTree(e), !0;
            a && t.push(io(a, e.matrixWorld));
        }), t.length > 0) {
            let e = Vs(t, !1);
            this.sharedGameControlGlobals.staticMeshBVH = new Eo(e);
        }
    }
    addRigidBody(t, e, r) {
        let i = [], s = "geometry" in t ? t.geometry : void 0, o = e.dataPatched;
        if (s?.getAttribute("position") !== void 0 && i.push(io(s, t.shearScale)), o.physics.fusedBody) {
            let a = this.gatherChildrenGeom(t, i);
            t.traverseObject(a), t.children.forEach((u)=>u.updateMatrixWorld(!0));
            let l = t.cloner;
            l && l.objectForSample === void 0 && o.physics.rigidBody === "dynamic" && (l.traverseObject(a), l.children.forEach((u)=>u.updateMatrixWorld(!0)));
        }
        if (i.length > 0) {
            let a, l = !r.fromCreate && o.physics.rigidBody === "dynamic" || r.fromCreate && r.dynamic;
            l ? (a = Pt.RigidBodyDesc.dynamic(), a.setLinearDamping(o.physics.damping).setAngularDamping(o.physics.damping).setAdditionalMass(1e-9).setGravityScale(o.physics.gravityScale).enabledRotations(...o.physics.enabledRotation).enabledTranslations(...o.physics.enabledTranslation)) : (r.hasTransformAnim || r.hasFollow || r.hasDrag) && !r.fromCreate ? (a = Pt.RigidBodyDesc.kinematicPositionBased(), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t)) : a = Pt.RigidBodyDesc.fixed();
            let u = Vs(i);
            (t.hasNonUniformScale ? t.matrixWorldRigid : t.matrixWorld).decompose(pi, so, Jl), t.position0 = pi.clone().divideScalar(this.pixelsPerMeter), t.rotation0 = so.clone(), pi.divideScalar(this.pixelsPerMeter), a.setTranslation(pi.x, pi.y, pi.z).setRotation(so), s ? u?.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter) : u?.scale(Jl.x / this.pixelsPerMeter, Jl.y / this.pixelsPerMeter, Jl.z / this.pixelsPerMeter);
            let c = this.sharedGameControlGlobals.rapierWorld.createRigidBody(a);
            l && this.rigidBodyToMesh.set(c.handle, [
                t,
                Jl.clone(),
                o.physics.fusedBody
            ]);
            let d = !(o.geometry === void 0 || o.geometry.type === "SubdivGeometry" || o.geometry.type === "NonParametricGeometry" || o.geometry.type === "BooleanGeometry" || o.geometry.type === "VectorGeometry" || o.geometry.type === "StarGeometry" || o.geometry.type === "RectangleGeometry" || o.geometry.type === "EllipseGeometry" || o.geometry.type === "TriangleGeometry" || o.geometry.type === "TorusGeometry" || o.geometry.type === "HelixGeometry");
            try {
                this.addCollider(c, o.physics, u, e, d);
            } catch  {
                try {
                    this.addCollider(c, o.physics, u, e, !1);
                } catch (f) {
                    console.error(f);
                }
            }
            t.rigidBody = c;
        }
    }
    addBoundsTree(t) {
        let e = [];
        if (t.geometry?.getAttribute("position") !== void 0 && t.geometry?.getAttribute("position").count > 0 && e.push(io(t.geometry, t.shearScale)), t.traverseObject(this.gatherChildrenGeom(t, e)), t.children.forEach((r)=>r.updateMatrixWorld(!0)), e.length > 0) {
            let r = Vs(e, !1);
            t.bvhGeometry = r, t.bvhGeometry.boundsTree = new Eo(r), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t);
        }
    }
    addCollider(t, e, r, i, s = !0) {
        if (r?.getAttribute("position").count === 0 || r?.getIndex()?.count === 0) return;
        let o;
        r && (e.colliderType === "trimesh" ? o = Pt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array) : o = Pt.ColliderDesc.convexMesh(r.getAttribute("position").array, s ? r.getIndex().array : void 0)), o.setFrictionCombineRule(Pt.CoefficientCombineRule.Average).setRestitutionCombineRule(Pt.CoefficientCombineRule.Average).setDensity(e.density).setFriction(e.friction).setRestitution(e.restitution);
        let a = this.sharedGameControlGlobals.rapierWorld.createCollider(o, t);
        this.sharedGameControlGlobals.colliderToEntity.set(a.handle, i), this.sharedGameControlGlobals.entityToCollisionEvents[i.uuid]?.some((l)=>l.target === "scene") && a.setActiveEvents(Pt.ActiveEvents.COLLISION_EVENTS);
    }
    gatherChildrenGeom(t, e) {
        return (r, i)=>{
            if (i === 0) return;
            let s;
            if (r instanceof Gi) {
                if (r.objectForSample) {
                    if (r.objectForSample.dataPatched.physics.fusedBody) return;
                    s = r.object;
                } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (r instanceof Pr) s = r.object;
            else if (s = r, s.dataPatched.cloner?.hideBase) return !0;
            let o = s.dataPatched;
            if (o.physics.enabled === "visibility" ? !o.visible : !o.physics.enabled) return !0;
            i === 1 ? t.hasNonUniformScale ? r.matrixWorld.multiplyMatrices(t.shearScale, r.hiddenMatrix) : r.matrixWorld.copy(r.hiddenMatrix) : r.matrixWorld.multiplyMatrices(r.parent.matrixWorld, r.hiddenMatrix), r.matrixWorld.multiply(r.matrix);
            let a = r.geometry;
            a?.getAttribute("position") !== void 0 && e.push(io(a, r.matrixWorld));
        };
    }
    activate(t) {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.eventManager = t, this.usePhysics = this.page.data.globalPhysics.usePhysics;
        let e = this.page.playCamera, r = !1, i = 5, s = 8, o = 9, a = "drag", l = this.page.data.publish.gameControlObject, u = l !== null ? this.page.find(l) : null, c = null;
        if (u) for (let f of u.data.events){
            if (f.data.disabled || f.data.type !== "GameControl") break;
            let p = u;
            for(; this.usePhysics && (p = p.parent)?.parent !== null && !p.data.physics?.fusedBody;);
            f.data.collisionEnabled && (this.needsCollisionDetection = !0), c === null && (c = f.data);
        }
        if (this.page.traverseEntity((f)=>{
            for (let p of f.dataPatched.events)if (p.data.disabled === !1 && p.data.type === "Trigger") return this.needsCollisionDetection = !0, !0;
        }), u && c) {
            r = r || c.camera === e.uuid || u.uuid === e.uuid;
            let f = new dg(u, this.renderer.domElement, c, this.eventContext.page.data.globalPhysics, this, u.uuid !== e.uuid && c.camera === e.uuid, e, this.page, this.sharedAssets);
            this.gameControl = f, i = c.joystickPosLoc, s = c.joystickRotLoc, o = c.jumpTouchButtonLoc, a = c.rotByTouch, Si && c.touchControl && (this.joystickToGameControls[i] = "pos", c.moveMode === "walk" && (this.joystickToGameControls[o] = "jmp"), a === "joystick" && (this.joystickToGameControls[s] = "rot"));
        }
        if (this.gameControl && this.gameControl.data.navmesh.enabled) {
            let f = this.gameControl.data;
            if (!this.navigationMeshWrapper) {
                this.navigationMeshWrapper = new Ab(this.usePhysics, this.isExport);
                let p;
                f.collider.type === "sphere" ? p = f.collider.radius * 2 : p = f.collider.height, p = Math.floor(p / f.navmesh.ch - 1), this.navigationMeshWrapper.init({
                    ...f.navmesh,
                    walkableHeight: p
                }, this.gameControl, this.eventContext);
            }
        }
        if (r === !1) {
            let { enableRotate: f, enablePan: p, enableZoom: m, autoRotate: g, hoverRotatePanMode: y } = this.eventManager.publish.orbitControls;
            (f || p || m || g || y !== 0) && (this.orbitControls = new Gf(e, this.renderer.domElement, {
                isExport: this.isExport,
                isPlayMode: !0
            }), this.orbitControls.addEventListener("change", this.requestRender), this.orbitControls.addEventListener("end", this.requestRender), this.orbitControls.addEventListener("start", this.requestRender), this.orbitControls.fromJSON(this.eventManager.publish.orbitControls, this.eventManager.publish.mouseEventTarget), this.orbitControls.useKeyEvents = !1, this.orbitControls.addEventListenersToCamera(), this.orbitControls.connect(), this.orbitControls.update());
        }
        let d = this.renderer.domElement.width / this.renderer.getPixelRatio(), h = this.renderer.domElement.height / this.renderer.getPixelRatio();
        this.joystickToGameControls.forEach((f, p)=>{
            let m = document.body.appendChild(document.createElement("div")), [g, y, v] = this.eventManager.eventContext.publish.joystickSizeAndXYOffset[p], x = (d - 5 * g) / 4 + g, S = {}, w = f === "jmp", A = w ? 0 : g;
            p < 10 ? (p < 5 ? S.top = A / 2 : S.bottom = A / 2, S.left = A / 2 + p % 5 * x) : p === 10 ? (S.left = A / 2, S.top = h / 2) : (S.right = A / 2, S.top = h / 2), S.top ? S.top -= y[1] : S.bottom += y[1], S.left ? S.left += y[0] : S.right -= y[0];
            for(let T in S)S[T] += "px";
            if (w) {
                let T = m.appendChild(document.createElement("div"));
                Object.assign(T.style, S, {
                    position: "absolute",
                    width: g + "px",
                    height: g + "px",
                    backgroundColor: `rgba(255,255,255,${v === "show" ? .4 : 0})`,
                    zIndex: "9999",
                    borderRadius: g + "px",
                    border: v === "show" ? "solid 2px rgba(0, 0, 0, .1)" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    touchAction: "none"
                });
                let M = g / 16 * 6.4;
                v === "show" && (T.innerHTML = `
						<svg width="${M}" height="${g * .4}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2 10L8 4L14 10" stroke="black" stroke-opacity="40%" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					`), T.addEventListener("pointerdown", ()=>{
                    this.gameControl.movementState.jump = 1, this.requestRender();
                }), T.addEventListener("touchend", (C)=>C.preventDefault()), this.joysticks[p] = [
                    void 0,
                    m
                ];
                return;
            }
            let E = {
                zone: m,
                mode: "static",
                position: S,
                size: g
            };
            v === "hide" && (E.restOpacity = 0);
            let b = QL.create(E);
            b.on("move", (T, M)=>{
                let C = this.gameControl;
                f === "pos" ? M.force < .2 ? C.moveForce = 0 : (C.movementState.movePosZ = Math.sin(-M.angle.radian), C.movementState.movePosX = Math.cos(-M.angle.radian), M.force > 1.2 ? C.movementState.run = 1 : C.movementState.run = 0, M.force < .3 ? C.moveForce = (M.force - .2) / .1 : C.moveForce = 1) : f === "rot" && (M.force < .2 ? C.rotForce = 0 : (C.movementState.rotPosX = M.vector.y, C.movementState.rotPosY = -M.vector.x, M.force < .3 ? C.rotForce = (M.force - .2) / .1 : C.rotForce = 1)), this.requestRender();
            }), b.on("end", (T, M)=>{
                let C = this.gameControl;
                f === "pos" ? (C.movementState.movePosZ = 0, C.movementState.movePosX = 0, C.moveForce = 1) : f === "rot" && (C.movementState.rotPosX = 0, C.movementState.rotPosY = 0, C.rotForce = 1);
            }), this.joysticks[p] = [
                b,
                m
            ];
        }), this.markIsDestroyTarget(), this.markIsDragObject(), this.rebuildBVH(), this.initializationCounter++, window.setTimeout(()=>{
            this.collisionEvents.forEach((f)=>f.disabled = !1);
        }, 80);
    }
    initPhysics() {
        this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = new Pt.World(new Pt.Vector3(0, this.gravity, 0)), this.events = new Pt.EventQueue(!0);
        let t = [], e = [];
        if (this.page.traverseChildren((a)=>{
            let l;
            if (a instanceof Gi) {
                if (a.objectForSample) {
                    if (a.objectForSample.dataPatched.physics.fusedBody) return;
                    l = a.object;
                } else return a.object.dataPatched.physics.fusedBody === !0 && a.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (a instanceof Pr) l = a.object;
            else {
                if (a instanceof eu || a instanceof Xc) return;
                if (l = a, l.dataPatched.cloner?.disabled === !1 && l.dataPatched.cloner?.hideBase && l.dataPatched.physics?.fusedBody !== !0) return !0;
            }
            let u = l.dataPatched, c;
            for (let y of u.events)y.data.disabled !== !0 && y.data.type === "GameControl" && (c = y.data);
            if (!u.physics || (u.physics.enabled === "visibility" ? !u.visible : !u.physics.enabled)) return !0;
            a.updateMatrixWorldSVD();
            let d = vg(u), h = !1, f = l.userData.hasDestroy, p = l.userData.hasDrag, m = !1;
            for (let y of u.events)if (y.data.disabled !== !0) {
                if (y.data.type === "Collision") {
                    h = !0;
                    let v = new Sb(y.id, y.data, l, this.page, this.sharedAssets, this.eventManager);
                    v.disabled = !0, this.collisionEvents.push(v), this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] && this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].every((x)=>x.id !== y.id) ? this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].push(v) : this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] = [
                        v
                    ];
                } else if (y.data.type === "Follow") {
                    m = !0;
                    let v = y.data.target;
                    a.traverseVisible((x)=>{
                        x.userData.isFollowingObj = v;
                    });
                }
            }
            u.physics.rigidBody === "dynamic" && u.physics.fusedBody === !1 && (a.matrixWorldFusedFalse = a.matrixWorld.clone());
            let g = a.geometry;
            if (c !== void 0) {
                let y = Pt.RigidBodyDesc.kinematicPositionBased();
                (a.hasNonUniformScale ? a.matrixWorldRigid : a.matrixWorld).decompose(pi, so, Jl), a.position0 = pi.clone().divideScalar(this.pixelsPerMeter), a.rotation0 = so.clone(), pi.divideScalar(this.pixelsPerMeter), y.setTranslation(pi.x, pi.y, pi.z).setRotation(so);
                let v = this.sharedGameControlGlobals.rapierWorld.createRigidBody(y);
                a.rigidBody = v;
                let x;
                c.collider.type === "sphere" ? x = Pt.ColliderDesc.ball(c.collider.radius / this.pixelsPerMeter) : c.collider.type === "capsule" ? x = Pt.ColliderDesc.capsule((c.collider.height / 2 - c.collider.radius) / this.pixelsPerMeter, c.collider.radius / this.pixelsPerMeter) : x = Pt.ColliderDesc.cuboid(c.collider.width / this.pixelsPerMeter / 2, c.collider.height / this.pixelsPerMeter / 2, c.collider.depth / this.pixelsPerMeter / 2), x.setFrictionCombineRule(Pt.CoefficientCombineRule.Average).setRestitutionCombineRule(Pt.CoefficientCombineRule.Average).setDensity(u.physics.density).setFriction(u.physics.friction).setRestitution(u.physics.restitution);
                let S = this.sharedGameControlGlobals.rapierWorld.createCollider(x, v);
                this.sharedGameControlGlobals.colliderToEntity.set(S.handle, l), pi.fromArray(c.collider.position).multiply(Jl.setFromMatrixScale(l.matrixWorld)).divideScalar(this.pixelsPerMeter), S.setTranslationWrtParent(pi);
                let w = new je().setFromEuler(new Kt().setFromVector3(new _().fromArray(c.collider.rotation)));
                S.setRotationWrtParent(w), S.setActiveEvents(Pt.ActiveEvents.COLLISION_EVENTS), this.generateSensorColliderDescs(l, !0);
            } else u.physics.rigidBody === "dynamic" || d || m || f || p || h ? (this.addRigidBody(a, l, {
                hasFollow: m,
                hasTransformAnim: d,
                hasDrag: p
            }), this.generateSensorColliderDescs(l, u.physics.fusedBody)) : (g && t.push(io(g, a.matrixWorld)), u.physics.fusedBody && a.traverseObject((y, v)=>{
                if (v === 0) return;
                let x;
                if (y instanceof Gi) {
                    if (y.objectForSample) {
                        if (y.objectForSample.dataPatched.physics.fusedBody) return;
                        x = y.object;
                    } else return y.object.dataPatched.physics.fusedBody === !0 && y.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (y instanceof Pr) x = y.object;
                else if (x = y, x.dataPatched.cloner?.hideBase) return !0;
                let S = x.dataPatched;
                if (S.physics.enabled === "visibility" ? !S.visible : !S.physics.enabled) return !0;
                let w = y.geometry;
                w?.getAttribute("position") !== void 0 && t.push(io(w, y.matrixWorld));
            }), this.generateSensorColliderDescs(l, u.physics.fusedBody, e));
            if (u.physics?.fusedBody === !0 || c) return !0;
        }), t.length === 0) return;
        let r = Vs(t);
        r.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter);
        let i = Pt.RigidBodyDesc.fixed(), s = this.sharedGameControlGlobals.rapierWorld.createRigidBody(i), o = Pt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array).setFrictionCombineRule(Pt.CoefficientCombineRule.Multiply).setRestitutionCombineRule(Pt.CoefficientCombineRule.Multiply).setFriction(1).setRestitution(1);
        this.sharedGameControlGlobals.rapierWorld.createCollider(o, s);
        for (let [a, l] of e){
            let u = this.sharedGameControlGlobals.rapierWorld.createCollider(a, s);
            this.sensorToTriggerEvent[u.handle] = l;
        }
    }
    updatePositions() {
        return this.nActiveRigidBodies = 0, this.sharedGameControlGlobals.rapierWorld.forEachRigidBody(this.processRigidBody), this.nActiveRigidBodies > 0;
    }
    rebuildBVH() {
        this.usePhysics ? this.initPhysics() : (this.page.traverseEntity((t)=>{
            for (let e of t.dataPatched.events)if (e.data.type === "Trigger" && e.data.disabled !== !0) {
                let r = new xg(e.id, e.data, t, this.page, this.sharedAssets, this.eventManager), i = new te().compose(oo.fromArray(e.data.position), jf.setFromEuler(mN.fromArray(e.data.rotation)), FE);
                if (e.data.triggerZone === "box") {
                    let s = new Bt;
                    s.min.fromArray(e.data.size).multiplyScalar(-0.5), s.max.fromArray(e.data.size).multiplyScalar(.5), this.sharedGameControlGlobals.triggers.push([
                        s,
                        i,
                        t,
                        r
                    ]);
                } else this.sharedGameControlGlobals.triggers.push([
                    e.data.radius,
                    i,
                    t,
                    r
                ]);
            }
        }), this.needsCollisionDetection && this.initBVH());
    }
    disconnectEvents() {
        this.collisionEvents.forEach((t)=>t.disconnect()), this.sharedGameControlGlobals.triggers.forEach((t)=>t[3].disconnect()), this.sharedGameControlGlobals.triggers.length = 0;
    }
    deactivate() {
        if (!!this.isEnabled) {
            this.isEnabled = !1, this.page.traverse((t)=>{
                let e = t;
                e.matrixWorldFusedFalse && (e.matrixWorldFusedFalse = void 0), e.rigidBody && (e.rigidBody = void 0), e.position0 && (e.position0 = void 0), e.rotation0 && (e.rotation0 = void 0);
            }), this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = void 0, this.sharedGameControlGlobals.staticMeshBVH = void 0, this.accumulator = 0, this.sharedGameControlGlobals.entitiesWithTransformAnim = [], this.disconnectEvents(), this.gameControl?.reset(), this.gameControl?.dispose(), this.gameControl = null, this.initializationCounter = -1, this.joysticks.forEach(([t, e])=>{
                t?.destroy(), e.remove();
            }), this.joystickToGameControls = [], this.joysticks = [], this.orbitControls && (this.orbitControls.dispose(), this.orbitControls = void 0), this.navigationMeshWrapper?.dispose(), this.navigationMeshWrapper = void 0;
            for (let t of Object.values(this.sharedGameControlGlobals.entityToCollisionEvents))t.forEach((e)=>e.disconnect());
            this.sharedGameControlGlobals.entityToCollisionEvents = {}, this.page.updateMatrixWorld(!0);
        }
    }
    update(t, e, r) {
        if (!this.isEnabled) return !0;
        let i = !0;
        if (this.orbitControls !== void 0 && this.orbitControls.needsUpdate && (i = !this.orbitControls.update()), this.initializationCounter >= 0 && this.initializationCounter < 2 ? (this.initializationCounter++, i = !1) : this.initializationCounter === 2 && this.gameControl && (i = !this.gameControl.update(t, e, r) && i), this.usePhysics === !1 && this.checkTrigger(), this.usePhysics) {
            let s = .016666666666666666;
            if (t === 0) i = this.stepPhysics() && i;
            else {
                let o = t / 1e3;
                o < s && o > s * .55 && (o = s), this.accumulator += o;
                let a = performance.now(), l = 0, u = 6;
                for(; this.accumulator >= s && l < u && (i = this.stepPhysics() && i, this.accumulator -= s, l++, !(performance.now() - a > s * 1e3)););
                this.accumulator = this.accumulator % s;
            }
        }
        return i;
    }
    stepPhysics() {
        for (let e of this.sharedGameControlGlobals.entitiesWithTransformAnim){
            (e.hasNonUniformScale ? e.matrixWorldRigid : e.matrixWorld).decompose(pi, so, Jl), BE.setFromQuaternion(so);
            let r = e;
            r.prevR === void 0 ? (r.prevR = BE.clone(), r.prevT = pi.clone()) : (r.prevR.copy(BE), r.prevT.copy(pi)), e.rigidBody && (e.rigidBody.setNextKinematicTranslation(pi.divideScalar(this.pixelsPerMeter)), e.rigidBody.setNextKinematicRotation(so));
        }
        return this.sharedGameControlGlobals.rapierWorld.step(this.events), this.events?.drainCollisionEvents(this.handleCollisionEvents), !this.updatePositions();
    }
    dispatchCollisionEvent(t, e, r) {
        let i = (this.sharedGameControlGlobals.rapierWorld?.getCollider(r))._parent, s;
        if (e.cloner) {
            for (let o of e.cloner.children)if (o.rigidBody === i) {
                s = o;
                break;
            }
        }
        t.dispatch(s), e.dispatchEvent(ab);
    }
    updateUseWindowEvents(t) {
        this.orbitControls?.updateUseWindowEvents(t);
    }
    generateSensorColliderDescs(t, e, r) {
        let i = gN.copy(t.matrixWorld).invert();
        t.traverseEntity((s, o)=>{
            if (e === !1 && o === 1) return !0;
            for (let a of s.dataPatched.events)if (a.data.type === "Trigger" && a.data.disabled !== !0) {
                let l = new xg(a.id, a.data, s, this.page, this.sharedAssets, this.eventManager), u;
                if (a.data.triggerZone === "box" ? u = Pt.ColliderDesc.cuboid(...a.data.size.map((c)=>c / (2 * this.pixelsPerMeter))) : u = Pt.ColliderDesc.ball(a.data.radius / this.pixelsPerMeter), u.setDensity(0).setSensor(!0).setActiveEvents(Pt.ActiveEvents.COLLISION_EVENTS), oo.fromArray(a.data.position), jf.setFromEuler(mN.fromArray(a.data.rotation)), Tb.compose(oo, jf, FE).premultiply(s.matrixWorld), r ? (Tb.decompose(oo, jf, NE), u.setActiveCollisionTypes(Pt.ActiveCollisionTypes.KINEMATIC_FIXED | Pt.ActiveCollisionTypes.DYNAMIC_FIXED)) : (Tb.premultiply(i).decompose(oo, jf, NE), t.rigidBody.bodyType() === Pt.RigidBodyType.Dynamic || (t.rigidBody.bodyType() === Pt.RigidBodyType.Fixed ? u.setActiveCollisionTypes(Pt.ActiveCollisionTypes.KINEMATIC_FIXED | Pt.ActiveCollisionTypes.DYNAMIC_FIXED) : u.setActiveCollisionTypes(Pt.ActiveCollisionTypes.KINEMATIC_KINEMATIC | Pt.ActiveCollisionTypes.DYNAMIC_KINEMATIC))), oo.divideScalar(this.pixelsPerMeter), u.setTranslation(oo.x, oo.y, oo.z), u.setRotation(jf), r) r.push([
                    u,
                    l
                ]);
                else {
                    let c = this.sharedGameControlGlobals.rapierWorld.createCollider(u, t.rigidBody);
                    this.sensorToTriggerEvent[c.handle] = l;
                }
            }
        });
    }
    checkTrigger() {
        let t;
        for(let e = 0; e < this.sharedGameControlGlobals.triggers.length; e++){
            let [r, i, s, o] = this.sharedGameControlGlobals.triggers[e];
            for(let a = 0; a < this.sharedGameControlGlobals.entitiesWithTransformAnim.length; a++){
                let l = this.sharedGameControlGlobals.entitiesWithTransformAnim[a];
                if (s === l || o.isValidTriggeringObject(ut.is(l) ? l : l.object) === !1) continue;
                let u = gN.copy(s.matrixWorld).decompose(oo, yN, NE).compose(oo, yN, FE).multiply(i), c = Tb.copy(l.matrixWorld).invert().multiply(u);
                r instanceof Bt ? t = l.bvhGeometry.boundsTree.intersectsBox(r, c) : (kE.radius = r, kE.center.setFromMatrixPosition(c), t = l.bvhGeometry.boundsTree.intersectsSphere(kE)), t ? o.currentIntersectedObjects.indexOf(l) === -1 && (o.currentIntersectedObjects.push(l), o.dispatch(), s.dispatchEvent(uJ)) : o.currentIntersectedObjects = o.currentIntersectedObjects.filter((d)=>d !== l);
            }
        }
    }
};
function xN(n1) {
    let t = this._clip.duration, e = this._clip.start ?? 0, r = this.loop, i = this.time + n1, s = this._loopCount, o = r === Ap;
    if (n1 === 0) return s === -1 ? i : o && (s & 1) === 1 ? t - (i - e) : i;
    if (r === sw) {
        s === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
        e: {
            if (i >= t) i = t;
            else if (i < 0) i = 0;
            else {
                this.time = i;
                break e;
            }
            this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 < 0 ? -1 : 1
            });
        }
    } else {
        if (s === -1 && (n1 >= 0 ? (s = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= t || i < e) {
            let a = Math.floor((i - e) / (t - e));
            i -= (t - e) * a, s += Math.abs(a);
            let l = this.repetitions - s;
            if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, o || (i = n1 > 0 ? t : e, this.repetitions === 1 && (i = t)), this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 > 0 ? 1 : -1
            });
            else {
                if (l === 1) {
                    let u = n1 < 0;
                    this._setEndings(u, !u, o);
                } else this._setEndings(!1, !1, o);
                this._loopCount = s, this.time = i, this._mixer.dispatchEvent({
                    type: "loop",
                    action: this,
                    loopDelta: a
                });
            }
        } else this.time = i;
        if (o && (s & 1) === 1) return t - (i - e);
    }
    return i;
}
var bN = !1, Cb = class {
    constructor(t, e, r, i){
        this.scene = t;
        this.requestRender = e;
        this.updateDisplayProgress = r;
        this.animationInspectorState = i;
        this.clipIdToAction = {};
        this.activeClip = null;
        this.needsUpdate = !1;
        this.addClip = (t)=>{
            t.data.type === "Empty" && t.data.animations && t.data.animations.forEach((e, r)=>{
                let i = e[0] + "/";
                if (Array.isArray(t.identity) ? i += t.identity[0] : i += t.uuid, this.clipIdToAction[i]) return;
                let s = Hu.parse(JSON.parse(e[2]));
                t.animations[r] = s;
                let o = this.mixer.clipAction(s, t);
                bN === !1 && (Object.getPrototypeOf(o)._updateTime = xN, bN = !0), o.clampWhenFinished = !0, this.clipIdToAction[i] = o;
            });
        };
        this.mixer = new Sy(t), this.scene.traverseEntity(this.addClip);
    }
    deleteClip(t, e) {
        let r = this.scene.find(e);
        if (!r) return;
        let i = r.animations.find((o)=>o.uuid === t);
        if (!i) return;
        let s = this.clipIdToAction[t];
        !s || (s.stop(), this.mixer.uncacheClip(i), delete this.clipIdToAction[t], r.animations = r.animations.filter((o)=>o.uuid !== t));
    }
    get isPlaying() {
        return Object.values(this.clipIdToAction).some((t)=>t.isRunning());
    }
    playFromInspector(t) {
        this.mixer.stopAllAction();
        let e = this.clipIdToAction[t];
        !e || (e.play(), this.activeClip = e.getClip(), this.requestRender());
    }
    onExitPlayMode() {
        Object.values(this.clipIdToAction).forEach((t)=>{
            t.repetitions = 1 / 0, t.loop = ow;
        }), this.mixer.stopAllAction(), this.requestRender();
    }
    play(t) {
        let e = t.clipId + "/" + t.object, r = this.clipIdToAction[e];
        if (!!r) return t && (t.repeat >= 0 && (r.repetitions = t.repeat + 1), t.direction === "pingpong" && t.repeat !== 0 && (r.loop = Ap)), r.play(), r.paused = !1, this.requestRender(), r;
    }
    resumeFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.play(), e.paused = !1, this.requestRender());
    }
    pauseFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.paused = !0);
    }
    stop() {
        this.mixer.stopAllAction(), this.requestRender();
    }
    update(t) {
        if (this.needsUpdate) this.needsUpdate = !1;
        else if (this.isPlaying === !1 || this.animationInspectorState?.isScrubbing) return;
        this.mixer.update(t / 1e3), this.activeClip && this.updateDisplayProgress(Math.round(this.mixer.time / this.activeClip.duration * this.maxFrames % this.maxFrames)), this.requestRender();
    }
    get maxFrames() {
        return this.activeClip?.tracks[0]?.times.length ?? 0;
    }
    setProgressFromInspector(t, e) {
        if (!this.clipIdToAction[e]) return;
        this.activeClip !== this.clipIdToAction[e].getClip() && this.playFromInspector(e);
        let r = this.clipIdToAction[e].paused;
        this.clipIdToAction[e].paused = !1, this.mixer.setTime(Math.min(this.maxFrames ? t / this.maxFrames : 0, .9999) * this.activeClip.duration), this.requestRender(), r && (this.clipIdToAction[e].paused = !0);
    }
};
var zE = new WeakMap, Pb = class extends rl {
    constructor(t){
        super(t), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(t) {
        return this.decoderPath = t, this;
    }
    setDecoderConfig(t) {
        return this.decoderConfig = t, this;
    }
    setWorkerLimit(t) {
        return this.workerLimit = t, this;
    }
    load(t, e, r, i) {
        let s = new Wu(this.manager);
        s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, (o)=>{
            this.decodeDracoFile(o, e).catch(i);
        }, r, i);
    }
    decodeDracoFile(t, e, r, i) {
        let s = {
            attributeIDs: r || this.defaultAttributeIDs,
            attributeTypes: i || this.defaultAttributeTypes,
            useUniqueIDs: !!r
        };
        return this.decodeGeometry(t, s).then(e);
    }
    decodeGeometry(t, e) {
        let r = JSON.stringify(e);
        if (zE.has(t)) {
            let l = zE.get(t);
            if (l.key === r) return l.promise;
            if (t.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let i, s = this.workerNextTaskID++, o = t.byteLength, a = this._getWorker(s, o).then((l)=>(i = l, new Promise((u, c)=>{
                i._callbacks[s] = {
                    resolve: u,
                    reject: c
                }, i.postMessage({
                    type: "decode",
                    id: s,
                    taskConfig: e,
                    buffer: t
                }, [
                    t
                ]);
            }))).then((l)=>this._createGeometry(l.geometry));
        return a.catch(()=>!0).then(()=>{
            i && s && this._releaseTask(i, s);
        }), zE.set(t, {
            key: r,
            promise: a
        }), a;
    }
    _createGeometry(t) {
        let e = new we;
        t.index && e.setIndex(new Ge(t.index.array, 1));
        for(let r = 0; r < t.attributes.length; r++){
            let i = t.attributes[r], s = i.name, o = i.array, a = i.itemSize;
            e.setAttribute(s, new Ge(o, a));
        }
        return e;
    }
    _loadLibrary(t, e) {
        let r = new Wu(this.manager);
        return r.setPath(this.decoderPath), r.setResponseType(e), r.setWithCredentials(this.withCredentials), new Promise((i, s)=>{
            r.load(t, i, void 0, s);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        let t = typeof WebAssembly != "object" || this.decoderConfig.type === "js", e = [];
        return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then((r)=>{
            let i = r[0];
            t || (this.decoderConfig.wasmBinary = r[1]);
            let s = dJ.toString(), o = [
                "/* draco decoder */",
                i,
                "",
                "/* worker */",
                s.substring(s.indexOf("{") + 1, s.lastIndexOf("}"))
            ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([
                o
            ]));
        }), this.decoderPending;
    }
    _getWorker(t, e) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                let i = new Worker(this.workerSourceURL);
                i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), i.onmessage = function(s) {
                    let o = s.data;
                    switch(o.type){
                        case "decode":
                            i._callbacks[o.id].resolve(o);
                            break;
                        case "error":
                            i._callbacks[o.id].reject(o);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + o.type + '"');
                    }
                }, this.workerPool.push(i);
            } else this.workerPool.sort(function(i, s) {
                return i._taskLoad > s._taskLoad ? -1 : 1;
            });
            let r = this.workerPool[this.workerPool.length - 1];
            return r._taskCosts[t] = e, r._taskLoad += e, r;
        });
    }
    _releaseTask(t, e) {
        t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((t)=>t._taskLoad));
    }
    dispose() {
        for(let t = 0; t < this.workerPool.length; ++t)this.workerPool[t].terminate();
        return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
    }
};
function dJ() {
    let n1, t;
    onmessage = function(o) {
        let a = o.data;
        switch(a.type){
            case "init":
                n1 = a.decoderConfig, t = new Promise(function(c) {
                    n1.onModuleLoaded = function(d) {
                        c({
                            draco: d
                        });
                    }, DracoDecoderModule(n1);
                });
                break;
            case "decode":
                let l = a.buffer, u = a.taskConfig;
                t.then((c)=>{
                    let d = c.draco, h = new d.Decoder, f = new d.DecoderBuffer;
                    f.Init(new Int8Array(l), l.byteLength);
                    try {
                        let p = e(d, h, f, u), m = p.attributes.map((g)=>g.array.buffer);
                        p.index && m.push(p.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: a.id,
                            geometry: p
                        }, m);
                    } catch (p) {
                        console.error(p), self.postMessage({
                            type: "error",
                            id: a.id,
                            error: p.message
                        });
                    } finally{
                        d.destroy(f), d.destroy(h);
                    }
                });
                break;
        }
    };
    function e(o, a, l, u) {
        let c = u.attributeIDs, d = u.attributeTypes, h, f, p = a.GetEncodedGeometryType(l);
        if (p === o.TRIANGULAR_MESH) h = new o.Mesh, f = a.DecodeBufferToMesh(l, h);
        else if (p === o.POINT_CLOUD) h = new o.PointCloud, f = a.DecodeBufferToPointCloud(l, h);
        else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!f.ok() || h.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + f.error_msg());
        let m = {
            index: null,
            attributes: []
        };
        for(let g in c){
            let y = self[d[g]], v, x;
            if (u.useUniqueIDs) x = c[g], v = a.GetAttributeByUniqueId(h, x);
            else {
                if (x = a.GetAttributeId(h, o[c[g]]), x === -1) continue;
                v = a.GetAttribute(h, x);
            }
            m.attributes.push(i(o, a, h, g, y, v));
        }
        return p === o.TRIANGULAR_MESH && (m.index = r(o, a, h)), o.destroy(h), m;
    }
    function r(o, a, l) {
        let c = l.num_faces() * 3, d = c * 4, h = o._malloc(d);
        a.GetTrianglesUInt32Array(l, d, h);
        let f = new Uint32Array(o.HEAPF32.buffer, h, c).slice();
        return o._free(h), {
            array: f,
            itemSize: 1
        };
    }
    function i(o, a, l, u, c, d) {
        let h = d.num_components(), p = l.num_points() * h, m = p * c.BYTES_PER_ELEMENT, g = s(o, c), y = o._malloc(m);
        a.GetAttributeDataArrayForAllPoints(l, d, g, m, y);
        let v = new c(o.HEAPF32.buffer, y, p).slice();
        return o._free(y), {
            name: u,
            array: v,
            itemSize: h
        };
    }
    function s(o, a) {
        switch(a){
            case Float32Array:
                return o.DT_FLOAT32;
            case Int8Array:
                return o.DT_INT8;
            case Int16Array:
                return o.DT_INT16;
            case Int32Array:
                return o.DT_INT32;
            case Uint8Array:
                return o.DT_UINT8;
            case Uint16Array:
                return o.DT_UINT16;
            case Uint32Array:
                return o.DT_UINT32;
        }
    }
}
var $l;
function hJ() {
    return $l || ($l = new Pb, $l.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.2/").preload()), $l.decoderPending;
}
async function fJ(n1) {
    if ($l) {
        let t = {
            attributeIDs: $l.defaultAttributeIDs,
            attributeTypes: $l.defaultAttributeTypes,
            useUniqueIDs: !1
        }, e;
        try {
            e = await $l.decodeGeometry(new Int8Array(n1).buffer, t);
        } catch (r) {
            console.error(r);
        }
        if (e) return {
            index: e.index ? {
                array: e.index.array
            } : void 0,
            attributes: Object.entries(e.attributes).map(([r, i])=>({
                    name: r,
                    itemSize: i.itemSize,
                    array: i.array
                }))
        };
    }
    return null;
}
async function SN(n1, t) {
    let [e, r] = zw(Mv.deserialize(new Uint8Array(n1)));
    Xv(e);
    let i = [];
    e.scene.objects.traverse((s, o)=>{
        o.type === "Mesh" && o.geometry.type === "NonParametricGeometry" && o.geometry.data.draco !== void 0 && i.push(o);
    }), i.length && await hJ();
    for (let s of i){
        let o = await fJ(Cr(s.geometry.data.draco));
        if (o) {
            o.index && (s.geometry.data.index = {
                array: o.index.array,
                itemSize: 1,
                normalized: !1,
                type: "Uint32Array"
            });
            let a = {};
            o.attributes.forEach(({ name: l, array: u, itemSize: c })=>{
                a[l] = {
                    array: u,
                    itemSize: c,
                    type: "Float32Array",
                    normalized: !1
                };
            }), s.geometry.data.attributes = a, s.geometry.data.draco = void 0;
        }
    }
    return t && t(e), r.result().data;
}
var VE = class {
    constructor(t, e, r, i, s, o, a){
        this.id = t;
        this.data = e;
        this.dataEvent = r;
        this.object = i;
        this.stage = !1;
        this.actions = gr(r, e.actions, s, o, a, i);
    }
    disconnect() {
        tr(this.actions);
    }
    dispatchIn() {
        this.actions.Audio.forEach((t)=>t.dispatchBasic()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Video.forEach((t)=>t.dispatchBasic()), this.actions.Create.forEach((t)=>t.dispatch()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.Link.forEach((t)=>t.dispatch()), this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.actions.Transition.forEach((t)=>t.toggle()), this.actions.Animation.forEach((t)=>t.play()), this.actions.SwitchCamera.forEach((t)=>t.play()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch());
    }
    dispatchOut() {
        this.actions.Transition.forEach((t)=>{
            t.toggle();
        });
    }
}, Db = class extends Dr {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.breakpoints = [];
        this.resize = (e, r)=>{
            this.breakpoints.forEach((i)=>{
                let s = Ov.deviceToSize(i.data.size), o = i.dataEvent.orientation === "horizontal" ? e : r, a;
                switch(i.data.operator){
                    case "<":
                        a = o < s[0];
                        break;
                    case ">":
                        a = o > s[0];
                        break;
                    case "<>":
                        a = o > s[0] && o < s[1];
                        break;
                }
                i.stage !== a && (i.stage = a, i.stage ? i.dispatchIn() : i.dispatchOut());
            });
        };
        this.onResizeObserver = new ResizeObserver((e)=>{
            for (let r of e){
                let { width: i, height: s } = r.contentRect;
                this.resize(i, s);
            }
        });
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i } = this.eventContext;
        this.onResizeObserver.observe(i);
        let s = (o)=>{
            if (!(!o.visible || !o.data?.events.length)) for (let { data: a } of o.data.events)a.disabled || a.type === "Resize" && a.breakpoints.forEach(({ data: l, id: u })=>{
                try {
                    let c = new VE(u, l, a, o, e, r, this.eventManager);
                    this.breakpoints.push(c);
                } catch (c) {}
            });
        };
        e.traverseEntity((o)=>{
            (o instanceof fr || o instanceof sr) && o.frame?.traverse((a)=>{
                s(a);
            }), s(o);
        });
    }
    disconnect() {
        this.onResizeObserver.disconnect(), this.breakpoints.forEach((e)=>{
            e.disconnect();
        }), this.breakpoints = [];
    }
};
var Ob = class {
    constructor(t, e, r, i, s){
        this.publish = t;
        this.controlsManager = e;
        this.animationControls = r;
        this.eventContext = i;
        this.sharedVariables = s;
        this.isEnabled = !1;
        this.activateCount = 0;
        this.needsMouse = !1;
        this.needsRaycast = !1;
        this.onTouchMovePreventScroll = (t)=>{
            (t.touches.length > 1 || this.preventTouchScroll) && t.preventDefault();
        };
        this.onMouseWheelPreventScroll = (t)=>{
            this.preventScroll && t.preventDefault();
        };
        this.onMouseMove = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: t.buttons > 0
            };
        };
        this.onMouseDown = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !0
            };
        };
        this.onMouseUp = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !1
            };
        };
        this.getMousePosition = (t)=>{
            let { domRect: e } = this.eventContext, { pageX: r, pageY: i } = t.touches?.length > 0 ? t.touches[0] : t;
            return {
                x: r - (e.left + window.scrollX),
                y: i - (e.top + window.scrollY)
            };
        };
        this.stopRaycast = t.stopRaycast, this.preventScroll = t.preventScroll, this.preventTouchScroll = t.preventTouchScroll, this.hideCursor = t.hideCursor, this.requestRender = i.requestRender;
    }
    activate() {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.initializeActionsDependentStates(), this.needsMouse && (this.eventContext.domElement.addEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.addEventListener("pointerdown", this.onMouseDown)), this.handlers = {
            Spline: new ub(this.eventContext),
            DynamicVariable: new wb(this.eventContext, this.sharedVariables, this, this.needsMouse, this.needsRaycast),
            ["Conditional"]: new fb(this.eventContext, this),
            ["Start"]: new bb(this.eventContext, this),
            Basic: new db(this.eventContext, this, this.needsRaycast),
            ["MouseHover"]: new vb(this.eventContext, this),
            ["Scroll"]: new xb(this.eventContext, this),
            ["Follow"]: new mb(this.eventContext, this),
            ["DragDrop"]: new pb(this.eventContext, this),
            ["LookAt"]: new yb(this.eventContext),
            ["Resize"]: new Db(this.eventContext, this)
        };
        let { page: t, domElement: e } = this.eventContext;
        this.hideCursor && (e.style.cursor = "none"), t.traverseEntity((r)=>{
            r.addEventListener("requestRender", this.requestRender);
        }), Object.values(this.handlers).forEach((r)=>r.connect()), e.addEventListener("wheel", this.onMouseWheelPreventScroll), e.addEventListener("touchmove", this.onTouchMovePreventScroll), this.activateCount++;
    }
    deactivate() {
        if (!this.isEnabled) return;
        this.isEnabled = !1, this.eventContext.domElement.removeEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.removeEventListener("pointerdown", this.onMouseDown), this.eventContext.domElement.removeEventListener("pointerup", this.onMouseUp), this.eventContext.sharedAssets.mouseProperty = null, this.eventContext.sharedAssets.raycastProperty = null;
        let { page: t, domElement: e } = this.eventContext;
        e.style.cursor = "", Object.values(this.handlers).forEach((r)=>r.disconnect()), this.controlsManager.gameControl?.disposeActions(), this.controlsManager.disconnectEvents(), t.traverseEntity((r)=>{
            r.removeEventListener("requestRender", this.requestRender), r.destroyedInAction = !1;
        }), e.removeEventListener("touchmove", this.onTouchMovePreventScroll), e.removeEventListener("wheel", this.onMouseWheelPreventScroll), this.animationControls.onExitPlayMode();
    }
    get isPaused() {
        return this.isEnabled;
    }
    pause() {
        this.deactivate();
    }
    resume() {
        this.activate();
    }
    reset() {
        this.deactivate(), this.activate(), this.controlsManager.page.updateMatrixWorld(!0), this.controlsManager.rebuildBVH();
    }
    updateUseWindowEvents(t) {
        let e = this.isEnabled;
        e && this.deactivate(), this.eventContext.useWindowEvents = t, e && this.activate();
    }
    initializeActionsDependentStates() {
        let t = this.eventContext.sharedAssets;
        t.resetDynamicVariablePlayState();
        let e = (r)=>{
            if (r.data.type === "Conditional" && (r.data.ifActions.forEach(e), r.data.elseActions.forEach(e)), r.data.type === "Conditional" || r.data.type === "SetVariable") for (let i of r.data.type === "Conditional" ? r.data.condition : r.data.expression)"id" in i && Array.isArray(i.id) && (i.id[0] === "mouse" && (this.needsMouse = !0), i.id[0] === "raycast" && (this.needsRaycast = !0));
            r.data.type === "DynamicVariablePlay" && r.data.variableId !== "" && (r.data.mode === "Play" || r.data.mode === "PlayPause" || r.data.mode === "Toggle") && t.setDynamicVariablePlayState(r.data.variableId, "Stopped");
        };
        this.eventContext.page.traverseEntity((r)=>{
            if (!!r.data?.events.length) {
                for (let i of r.data.events)if (!i.data.disabled) {
                    if (i.data.type === "VariableChange" && (i.data.variableId === "mouseProperty" && (this.needsMouse = !0), i.data.variableId === "raycastProperty" && (this.needsRaycast = !0)), i.data.type === "Conditional") for (let s of [
                        "inActions",
                        "outActions"
                    ])i.data[s].forEach(e);
                    else if (i.data.type === "DragDrop") for (let s of [
                        "drag",
                        "drop"
                    ])i.data.dragDropActions[s].forEach(e);
                    else if (i.data.type === "GameControl") for (let s of [
                        "idle",
                        "move",
                        "jump",
                        "run"
                    ])i.data.gameActions[s].forEach(e);
                    else if (i.data.type === "Resize") for (let s of i.data.breakpoints)s.data.actions.forEach(e);
                    else i.data.type === "LookAt" || i.data.actions.forEach(e);
                }
            }
        });
    }
};
var Ib = class {
    constructor(t, e, r, i, s){
        this._aspect = 1;
        this.enableResponsive = !1;
        this._renderer = t, this._camera = e, this._frameSize = new N().copy(r), this._editorSize = new N().copy(i), this._aspect = e.aspect, this._fov = s ?? e.fov;
    }
    set frameSize(t) {
        this._frameSize.copy(t);
    }
    updateRenderer() {
        !this._renderer || this._renderer.setSize(this._frameSize.x, this._frameSize.y);
    }
    updateViewport() {
        if (!this._renderer || !this._camera || this._camera.cameraType !== "PerspectiveCamera") return;
        let t = this._frameSize.x, e = this._frameSize.y, r = this._editorSize.y;
        this._aspect = t / e, e <= r && (this._camera.zoom *= r / e), this._renderer.setViewport(0, 0, t, e);
    }
    updateCamera(t = !0) {
        if (!!this._camera) {
            if (this._camera.cameraType === "PerspectiveCamera") {
                let e = this._frameSize.y, r = this._editorSize.y, i = this._fov;
                if (t && e > r) {
                    let s = pJ(e, 1080, 2160, 1, 15) / 100;
                    i *= e / r, i *= 1 - s;
                }
                this._camera.aspect = this._aspect, this._camera.fov = i, this._camera.updateProjectionMatrix();
            } else this._camera.setViewplaneSize(this._frameSize.x, this._frameSize.y, this.enableResponsive);
        }
    }
    setCamera(t) {
        this._camera = t, this._aspect = t.aspect, this._fov = t.fov;
    }
    revert() {
        let t = window.innerWidth, e = window.innerHeight;
        this._renderer && (this._renderer.setViewport(0, 0, t, e), this._renderer.setSize(t, e)), this._camera && (this._camera.aspect = t / e, this._camera.fov = this._fov, this._camera.setViewplaneSize(t, e, this.enableResponsive), this._camera.updateProjectionMatrix());
    }
};
function pJ(n1, t, e, r, i) {
    return (n1 - t) / (e - t) * (i - r) + r;
}
var Rb = class {
    get sharedAssets() {
        return this.shared;
    }
    constructor(t, e = {}){
        this.shared = new Wc(t.shared, e), this.scene = new Vl(t.scene, this.sharedAssets), this.shared.setEntityOpContext({
            scene: this.scene,
            shared: this.shared
        });
    }
    reset(t, e) {
        this.scene.clearScene(), this.sharedAssets.reset(t.shared), this.scene.resetAfterClear(t.scene, this.sharedAssets);
    }
    resetPersonalCameraFromDocumentData() {
        for (let t of this.scene.children)t instanceof sr && !t.uiScene && t.personalCamera.updateState(t.data.camera, {
            scene: this.scene,
            shared: this.shared
        });
    }
    dispose() {
        this.scene.dispose(), this.shared.dispose();
    }
    gc() {
        this.shared.geometryCache.startGc(), this.shared.geometryCache2.startGc(), this.scene.traverseEntity((t)=>{
            t instanceof er && t.markGeometryAsReachable(this.shared);
        }), this.shared.geometryCache.endGc(), this.shared.geometryCache2.endGc();
    }
};
var Lb = class {
    constructor({ x: t = 10, y: e = 10 }){
        this._startTime = 0;
        let r = document.getElementById("spe-perfs");
        r ? this.element = r : (this.element = document.createElement("div"), document.body.appendChild(this.element), this.element.style.position = "absolute", this.element.style.zIndex = "10000", this.element.style.fontFamily = "monospace", this.element.style.background = "black", this.element.style.color = "white", this.element.style.padding = "10px", this.element.style.opacity = "0.5", this.element.style.fontSize = "11px", this.element.setAttribute("id", "spe-perfs")), this.element.style.left = `${t}px`, this.element.style.top = `${e}px`;
    }
    dispose() {
        this.element.parentElement?.removeChild(this.element);
    }
    start() {
        this._startTime = performance.now();
    }
    end() {
        let e = performance.now() - this._startTime;
        this.element.innerHTML = e.toFixed(3) + " ms";
    }
};
function mJ(n1) {
    let t;
    if (!!n1.index) for(let e = 0; e < n1.index.array.length; e += 3)t = n1.index.array[e], n1.index.array[e] = n1.index.array[e + 2], n1.index.array[e + 2] = t;
}
function bg(n1) {
    return n1 instanceof Qs ? "SubdivObject" : n1.geometry.type === "NonParametricGeometry" ? "NonParametric" : "Mesh";
}
function gJ(n1, t) {
    let e = {};
    return n1.traverseEntity((r)=>{
        if (!r.visible || !(r instanceof nr) || r.type !== "Mesh" || Array.isArray(r.material) || r.states && Object.keys(r.states).length) return;
        let i = r.parent;
        for(; i;){
            if (i instanceof nr && r.states && Object.keys(r.states).length) return;
            i = i.parent;
        }
        let s = r.material.uuid, o = t.shared.materials[s];
        if (o) {
            if (!Qr.isMergable(o)) return;
        } else {
            let u = t.scene.objects.get(r.uuid)?.data;
            if (u && "material" in u && typeof u.material != "string") {
                if (!Qr.isMergable(u.material)) return;
                s = Qr.getHash(u.material);
            }
        }
        e[s] || (e[s] = {});
        let l = e[s][bg(r)];
        if (l) {
            if (l.push(r), r.cloner) for (let u of r.cloner.children)l.push(u);
        } else if (e[s][bg(r)] = [
            r
        ], r.cloner) for (let u of r.cloner.children)e[s][bg(r)].push(u);
    }), e;
}
function yJ(n1) {
    let t = 0;
    return Object.values(n1).forEach((e)=>{
        Object.values(e).forEach((r)=>{
            let i = r.length;
            i > t && (t = i);
        });
    }), t;
}
function wN(n1, t) {
    let e = gJ(t, n1), r = yJ(e), i = new Array(r), s = 0, o = new Array(r), a = 0, l = new Array(r), u = 0, c = new Array(r), d = 0;
    for (let [h, f] of Object.entries(e))for (let p of Object.values(f)){
        if (a = 0, u = 0, p.forEach((g)=>{
            g instanceof nr && (o[a++] = g.geometry.clone(), l[u++] = g);
        }), u < 2) continue;
        for(let g = 0; g < u; g++)l[g].updateWorldMatrix(!0, !1), o[g].applyMatrix4(l[g].matrixWorld), l[g].matrixWorld.determinant() < 0 && mJ(o[g]);
        let m = Vs(o.slice(0, a), !1);
        if (m) {
            let g;
            switch(h){
                case "SubdivObject":
                    console.warn("Turning subdiv object into mesh"), g = new rr(m, l[0].material);
                    break;
                default:
                    g = new rr(m, l[0].material);
                    break;
            }
            g.castShadow = l[0].castShadow, g.receiveShadow = l[0].receiveShadow, t.add(g);
            let y = (v)=>{
                d = 0;
                for (let x of v)x.children && y(x.children), x instanceof nr && (Array.isArray(x.material) || e[x.material.uuid] && e[x.material.uuid][bg(x)] && e[x.material.uuid][bg(x)].length > 1 || (c[d++] = x));
                for(let x = 0; x < d; x++)t.attach(c[x]);
            };
            for(let v = 0; v < u; v++){
                let x = l[v];
                y(x.children), i[s++] = x;
            }
        }
    }
    for(let h = 0; h < s; h++)i[h].removeFromParent();
}
var TN = Pi(_N(), 1);
var xJ = new N;
function bJ(n1) {
    let t = "The Spline Runtime only accepts .splinecode files that are generated from Spline export panel.";
    n1.endsWith(".spline") ? console.warn(t + " The .spline files are only meant to be used by the Editor.") : n1.endsWith(".splinecode") || console.warn(t);
}
var EN = class {
    constructor(t, { renderOnDemand: e, renderMode: r = "auto" } = {}){
        this._viewportMode = 1;
        this._viewportWidth = window.innerWidth;
        this._viewportHeight = window.innerHeight;
        this._proxyObjectCache = new Map;
        this._variablesCache = new Map;
        this._isPaused = !1;
        this._renderRequested = !1;
        this._skipRender = !1;
        this.time = performance.now();
        this.dt = 0;
        this.currentTAAFrame = 0;
        this.disposed = !1;
        this._requestRenderAutoMode = ()=>{
            this._skipRender = !1;
        };
        this.requestRender = ()=>{
            this._renderRequested = !0;
        };
        this.render = (t)=>{
            if (this.time = t, this._lastTime && (this.dt = this.time - this._lastTime), this._lastTime = this.time, this._perfs?.start(), !this._renderer) {
                this._perfs?.end();
                return;
            }
            if (!this._isPaused && (this.renderMode === "manual" && !this._renderRequested || this.renderMode === "auto" && this._skipRender)) {
                this._perfs?.end();
                return;
            }
            if (this._renderRequested = !1, this._skipRender = !0, this._controls && (this._skipRender = this._controls.update(this.dt)), this._eventManager && (this._eventManager.handlers?.Start.hasVideoAction || this._eventManager.handlers?.Basic.hasVideoAction || this._eventManager.handlers?.Conditional.hasVideoAction) && (this._skipRender = !1), this._animationControls?.update(this.dt), this._skipRender ? (this.currentTAAFrame++, this.currentTAAFrame < 32 ? this._skipRender = !1 : this.currentTAAFrame = 0) : this.currentTAAFrame = 0, this._scene?.traverseVisibleEntity((e)=>{
                e.type === "ParticleSystem" && (e.update(this.dt), this._skipRender = !1);
            }), this._scene && this._scene.activeCamera !== this._camera && (this._camera = this._scene.activeCamera), this._eventManager?.isEnabled && ((this._eventManager.handlers?.Follow).onAnimationFrameDamping(), (this._eventManager.handlers?.LookAt).onAnimationFrameDamping(), (this._eventManager.handlers?.DragDrop).onAnimationFrameDamping()), this._scene && this._camera) {
                if (this._scene.pathConstraints.applyConstraints(this._scene), this._renderer.sceneTransitionTimeRemaining > 0) {
                    this._renderer.sceneTransitionTimeRemaining -= this.dt;
                    let e = 1 - this._renderer.sceneTransitionTimeRemaining / this._renderer.sceneTransitionDuration;
                    this._renderer.pipeline.sceneTransitionPass.uniforms.mixRatio.value = e, this._skipRender = !1;
                } else this._renderer.pipeline.sceneTransitionFromTexture = null;
                this._renderer.renderSplineScene(this._scene, this._camera);
            }
            this.canvas.dispatchEvent(this._renderedEvent), this._perfs?.end();
        };
        this._resize = ()=>{
            if (!!this._renderer) {
                if (this._viewportMode === 1 && this._frameView && (this._frameView.frameSize = xJ.set(this._viewportWidth, this._viewportHeight)), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._camera = this._scene?.activeCamera, this._scene?.updateViewPlaneSize(this._frameView?.frameSize?.x ?? this._viewportWidth, this._frameView?.frameSize?.y ?? this._viewportHeight, this._frameView?.enableResponsive ?? !1), this._camera) {
                    let t = Object.values(this._data?.frames ?? {})[0].preset ?? "fullscreen";
                    this._frameView?.setCamera(this._camera), this._frameView?.updateCamera(t !== "fullscreen"), this._camera.cameraType === "PerspectiveCamera" && (this._camera.aspect = this._viewportWidth / this._viewportHeight), this._camera.updateProjectionMatrix();
                }
                this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect()), this._requestRenderAutoMode();
            }
        };
        this._debouncedResize = Ec(this._resize, 10);
        this._onScroll = (t)=>{
            this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect());
        };
        this.canvas = t, this.renderMode = e ? "auto" : r, this._renderedEvent = new CustomEvent("rendered", {
            bubbles: !0
        }), Object.defineProperty(this._renderedEvent, "target", {
            writable: !1,
            value: this
        }), window.location.search.includes("perfs") && (this._perfs = new Lb({
            x: 10,
            y: 10
        })), E2(t);
    }
    async load(t, e, r) {
        bJ(t), this.disposed = !1;
        let s = await (await fetch(t, r)).arrayBuffer();
        await this.start(s, {
            variables: e
        });
    }
    async start(t, { interactive: e = !0, variables: r } = {}) {
        if (this.disposed) return;
        let i = await SN(t);
        this._data = i, i.version && (0, TN.default)(i.version, "1.0.16") > 0 && console.warn("Your .splinecode file is more recent than the library. Please upgrade @splinetool/runtime to the latest version."), await Promise.all([
            h_(i) && AI(),
            hR(i) && gI(),
            Al.physicsEnabled(i.scene.objects) && I2(),
            n_(i) && oR(),
            __(i) && E3(),
            OE(i) && P2()
        ].filter(Boolean)), this._eventManager?.deactivate(), this._controls?.deactivate(), this._scene?.dispose();
        let s = new Rb(i);
        if (s.resetPersonalCameraFromDocumentData(), this._scene = s.scene, this._sharedAssetsManager = s.sharedAssets, this._camera = this._scene.activeCamera, window.location.search.includes("merge-geometries")) {
            let l = performance.now();
            wN(i, s.scene);
            let u = performance.now();
            console.log("Merged geometries in ", u - l, " ms");
        }
        h_(i) && this._scene.traverse((l)=>{
            An(l) && l.recomputeBoolean();
        }), this._sharedAssetsManager.setRequestRender(()=>{
            this._requestRenderAutoMode(), this._scene?.traverse((l)=>{
                l instanceof Gi && l.pendingMediaLoad && l.update();
            });
        }), this._scene?.traverse((l)=>{
            l.type === "ParticleSystem" && (l.wakeUp(), l.data.autoPlay ? l.start() : l.stop());
        });
        let o = Object.keys(i.shared.fonts).map((l)=>this._sharedAssetsManager.getFont(l).loadingPromise);
        if (Promise.all(o).then(()=>{
            s.scene.markNeedsUpdateRendererDirty(), this._requestRenderAutoMode();
        }), n_(i) && vN(i) && await Promise.all(o), __(i)) {
            let l = [];
            this._scene.traverseEntity((u)=>{
                u instanceof fr && l.push(u);
            }), await Promise.all(l.map((u)=>u.uiCanvas.promise));
        }
        this._scene.rewriteEventsBeforeGoToPlayMode(), If(this._scene.activePage, this._sharedAssetsManager), this._renderer || (this._renderer = new wx({
            canvas: this.canvas,
            antialias: !1,
            alpha: !0,
            stencil: !1,
            depth: !1,
            powerPreference: "high-performance"
        }), this._renderer.hdTransmission = i.scene.publish.hdTransmission === !0, this._renderer.setPixelRatio(window.devicePixelRatio), this._renderer.pipeline.enableUIOverlay(), this._renderer.pipeline.addEventListener("smaaloaded", this._requestRenderAutoMode)), this._scene.initializeSplatViewer(this._renderer), i.scene.blueNoiseTextureData !== void 0 && this._renderer.pipeline.updateBlueNoiseTexture(i.scene.blueNoiseTextureData);
        let a = Object.values(i.frames)[0];
        if (this._frameView ? this._frameView.setCamera(this._camera) : (a.preset === "fullscreen" ? (this._viewportMode = 1, this.canvas.style.display = "block", this.canvas.parentElement && (this._viewportWidth = this.canvas.parentElement.clientWidth || 300, this.canvas.style.width = "100%"), this.canvas.parentElement && (this._viewportHeight = this.canvas.parentElement.clientHeight || 150, this.canvas.style.height = "100%")) : (this._viewportMode = 2, this._viewportWidth = a.size[0], this._viewportHeight = a.size[1], this.canvas.style.width = `${this._viewportWidth}px`, this.canvas.style.height = `${this._viewportHeight}px`), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._frameView = new Ib(this._renderer, this._camera, new N(this._viewportWidth, this._viewportHeight), new N(window.innerWidth, window.innerHeight)), this._frameView.enableResponsive = (a.allowResponsive ?? !1) && a.preset === "fullscreen"), e) {
            let l = new cb(this._renderer, this.data.scene.publish, this._scene, ()=>this._scene.activeCamera, this._sharedAssetsManager, this._requestRenderAutoMode, !0, a);
            this._scene.updateMatrixWorld(!0), this._controls = new Mb(l), this._animationControls = new Cb(this._scene, this._requestRenderAutoMode), this._eventManager = new Ob(i.scene.publish, this._controls, this._animationControls, l, i.shared.variables), this._eventManager.activate(), this._controls.activate(this._eventManager);
        }
        this._resize(), r !== void 0 && this.setVariables(r), this.dt === 0 && (this.render(performance.now()), setTimeout(()=>{
            this._renderer?.setAnimationLoop(this.render);
        }, 0)), this._resizeObserverTimeout = setTimeout(()=>{
            !this._resizeObserver && this.canvas.parentElement && (this._resizeObserver = new ResizeObserver(()=>{
                this._viewportWidth = this.canvas.clientWidth, this._viewportHeight = this.canvas.clientHeight, this._debouncedResize();
            }), this._resizeObserver.observe(this.canvas.parentElement));
        }, 300), document.addEventListener("scroll", this._onScroll);
    }
    setVariables(t) {
        if (this._data !== void 0) {
            let e = Object.entries(t);
            for (let [r, i] of e)this.setVariable(r, i);
        }
    }
    setVariable(t, e) {
        let r = this._getVariableByName(t);
        if (r && !("dynamicVariableType" in r.data)) {
            let i = e;
            typeof r.data.value == "number" ? i = typeof e == "number" ? e : typeof e == "boolean" ? e === !0 ? 1 : 0 : parseFloat(e) : typeof r.data.value == "boolean" ? i = typeof e == "number" ? !!e : typeof e == "boolean" ? e : e.toLocaleLowerCase() === "false" ? !1 : !!e : typeof r.data.value != "string" && r.data.value.textValue !== void 0 && (i = e.toString());
            let s = typeof i == "string" ? {
                textValue: i
            } : i;
            this._sharedAssetsManager?.updateVariable(r.id, s), this.requestRender(), this._requestRenderAutoMode();
        } else r === void 0 ? console.warn(`No variable named ${t} was found in your Spline file. Make sure to create it from Spline editor.`) : "dynamicVariableType" in r.data && console.warn(`Dynamic variables like ${t} cannot be updated from code.`);
    }
    getVariables() {
        let t = {};
        return this._data && this._data.shared.variables.forEach((e)=>{
            t[e.data.name] === void 0 && (t[e.data.name] = this._getVariableValue(this._sharedAssetsManager.getVariable(e.id)));
        }), t;
    }
    getVariable(t) {
        let e = this._getVariableByName(t);
        if (e) {
            let r = this._sharedAssetsManager.getVariable(e.id);
            return this._getVariableValue(r);
        }
    }
    _getVariableValue(t) {
        return typeof t != "string" && Fi.isTextValue(t) ? Fi.getDisplayedValue(t) : t;
    }
    _getVariableByName(t) {
        if (this._data) {
            if (this._variablesCache.has(t)) return this._variablesCache.get(t);
            let e = this._data.shared.variables.find((r)=>r.data.name === t);
            return e && this._variablesCache.set(t, e), e;
        }
    }
    findObjectById(t) {
        let e = this._scene?.getObjectByProperty("uuid", t);
        return this._createProxyObject(e);
    }
    findObjectByName(t) {
        let e = this._scene?.getObjectByName(t);
        return this._createProxyObject(e);
    }
    getAllObjects() {
        let t = [];
        return this._scene?.traverseEntity((e)=>{
            if (e.uuid !== us && !this._scene.isInvisibleObjects(e) && !(e instanceof sr)) {
                let r = this._createProxyObject(e);
                r && t.push(r);
            }
        }), t;
    }
    getSplineEvents() {
        return (this._eventManager?.handlers?.Spline).splineEvents;
    }
    emitEvent(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEvent(t);
    }
    emitEventReverse(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEventReverse(t);
    }
    addEventListener(t, e) {
        this.canvas.addEventListener(t, e);
    }
    removeEventListener(t, e) {
        this.canvas.removeEventListener(t, e);
    }
    setZoom(t) {
        this._controls?.orbitControls instanceof Gf && this._controls?.orbitControls.zoomOut(t);
    }
    get eventManager() {
        return this._eventManager;
    }
    get controls() {
        return this._controls;
    }
    setSize(t, e) {
        this._viewportWidth = t, this._viewportHeight = e, this._viewportMode = 2, this._resize();
    }
    setBackgroundColor(t) {
        let { r: e, g: r, b: i, a: s } = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, o = new cr(e, r, i, s);
        try {
            o.setStyle(t);
        } catch  {
            console.error("This is not a valid css color", t);
        }
        this._scene?.activePage.setBackgroundColor(o), this._requestRenderAutoMode();
    }
    dispose() {
        this.disposed = !0, this._eventManager?.deactivate(), this._scene?.dispose(), this._sharedAssetsManager?.dispose(), this._proxyObjectCache.forEach((t)=>{
            _w.unsubscribe(t);
        }), this._variablesCache.clear(), this._renderer?.setAnimationLoop(null), this._renderer?.dispose(), this._renderer = void 0, this._sharedAssetsManager?.dispose(), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = void 0), this._resizeObserverTimeout !== void 0 && clearTimeout(this._resizeObserverTimeout), this.canvas.style.width = "", this.canvas.style.height = "", this.canvas.removeAttribute("width"), this.canvas.removeAttribute("height"), this._frameView && (this._frameView = void 0), this._controls?.deactivate(), T2(this.canvas), document.removeEventListener("scroll", this._onScroll);
    }
    get isStopped() {
        return this._isPaused;
    }
    stop() {
        this._isPaused || (this._renderer?.setAnimationLoop(null), this._isPaused = !0, this._eventManager?.pause(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !1));
    }
    play() {
        !this._isPaused || (this._isPaused = !1, this._eventManager?.resume(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !0), this._renderer?.setAnimationLoop(this.render));
    }
    setGlobalEvents(t) {
        this._eventManager?.updateUseWindowEvents(t);
    }
    get data() {
        return this._data;
    }
    _createProxyObject(t) {
        if (t == null) return;
        if (this._proxyObjectCache.has(t.uuid)) return this._proxyObjectCache.get(t.uuid);
        let e;
        t.traverseAncestors((s)=>{
            s instanceof sr && (e = s.name);
        });
        let r = {
            name: t.name,
            uuid: t.uuid,
            visible: t.visible,
            intensity: t.intensity,
            position: t.position,
            rotation: t.rotation,
            scale: t.scale,
            type: t.data.type,
            page: e,
            parentUuid: t.parent instanceof sr || t instanceof Vl ? void 0 : t.parent?.uuid,
            emitEvent (s) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: s
                });
            },
            emitEventReverse (s) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: s,
                    reverse: !0
                });
            }
        }, i = _w(r, (s, o)=>{
            typeof t[s] != "object" && Object.getOwnPropertyDescriptor(t, s)?.writable && (t[s] = o), this._requestRenderAutoMode(), t.updateMatrix();
        });
        return this._proxyObjectCache.set(t.uuid, i), i;
    }
    setUIWasmUrl(t) {
        z0.skiaWasmUrl = t;
    }
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8b5hF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7ld7l").then(()=>parcelRequire("gRaTy"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("lUNnT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cxrcT").then(()=>parcelRequire("lxep3"));

});

parcelRegister("9CTrk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cM1YA").then(()=>parcelRequire("1eBiX"));

});

parcelRegister("1Jpra", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9WKx7").then(()=>parcelRequire("Aa6gW"));

});

parcelRegister("14X3t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dtqLr").then(()=>parcelRequire("lq4np"));

});

parcelRegister("836Xp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5fiVm").then(()=>parcelRequire("jRJKa"));

});



var $6THZ6 = parcelRequire("6THZ6");
// Initialize the Spline scene
const $9cdf42a8fe772b26$var$canvas = document.getElementById("spline-player");
const $9cdf42a8fe772b26$var$splineContainer = document.getElementById("spline-player-layout-container");
const $9cdf42a8fe772b26$var$iconCloseSplineViewer = document.getElementById("icon-close-spline-viewer");
const $9cdf42a8fe772b26$var$spline = new (0, $6THZ6.Application)($9cdf42a8fe772b26$var$canvas);
$9cdf42a8fe772b26$var$spline.load("https://prod.spline.design/Cde6bvV-naO70SC9/scene.splinecode");
// .then(() => {
// 	const obj = spline.findObjectById('390d1a22-e647-46ca-9625-e1432a6bcd1c');
//     obj.emitEvent('mouseHover');
//     console.log("working");
// });
const $9cdf42a8fe772b26$var$camera2trigger = document.getElementById("camera-2");
const $9cdf42a8fe772b26$var$camera3trigger = document.getElementById("camera-3");
const $9cdf42a8fe772b26$var$camera4trigger = document.getElementById("camera-4");
const $9cdf42a8fe772b26$var$camera5trigger = document.getElementById("camera-5");
const $9cdf42a8fe772b26$var$camera6trigger = document.getElementById("camera-6");
const $9cdf42a8fe772b26$var$splinePlayerLabelTitle = document.getElementById("spline-player-label-title");
const $9cdf42a8fe772b26$var$splinePlayerLabelData = document.getElementById("spline-player-label-data");
const $9cdf42a8fe772b26$var$defaultPlayerTitle = "Mt. Tamalpais";
const $9cdf42a8fe772b26$var$defaultPlayerData = "37.9236\xb0 N, 122.5965\xb0 W";
function $9cdf42a8fe772b26$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
// When having issues with below, don't forget to clear cache and refresh
$9cdf42a8fe772b26$var$camera2trigger.addEventListener("mouseover", ()=>{
    const trigger1 = $9cdf42a8fe772b26$var$spline.findObjectById("ac3d557c-b130-4fda-9b35-db68243811a0");
    trigger1.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = "Patreon Podcast Player";
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = "2023";
});
$9cdf42a8fe772b26$var$camera2trigger.addEventListener("click", ()=>{
    if ($9cdf42a8fe772b26$var$isTouchDevice()) {
        // don't need to add trigger here for event, bcause hover is trigger on click on mobile
        $9cdf42a8fe772b26$var$splineContainer.classList.add("spline-player-layout-container-visible");
        document.body.classList.add("no-scroll");
        document.addEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
            passive: false
        });
    }
});
if (!$9cdf42a8fe772b26$var$isTouchDevice()) $9cdf42a8fe772b26$var$camera2trigger.addEventListener("mouseout", ()=>{
    const phone1 = $9cdf42a8fe772b26$var$spline.findObjectById("64f0f8e6-288b-42e8-9a64-42231eae56c4");
    phone1.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = $9cdf42a8fe772b26$var$defaultPlayerTitle;
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = $9cdf42a8fe772b26$var$defaultPlayerData;
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
$9cdf42a8fe772b26$var$camera3trigger.addEventListener("mouseover", ()=>{
    const trigger2 = $9cdf42a8fe772b26$var$spline.findObjectById("8c6d2594-4bc9-4340-a81f-22208c4d67a6");
    trigger2.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = "Apple Tap to Pay";
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = "2022";
});
$9cdf42a8fe772b26$var$camera3trigger.addEventListener("click", ()=>{
    if ($9cdf42a8fe772b26$var$isTouchDevice()) {
        // don't need to add trigger here for event, bcause hover is trigger on click on mobile
        $9cdf42a8fe772b26$var$splineContainer.classList.add("spline-player-layout-container-visible");
        document.body.classList.add("no-scroll");
        document.addEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
            passive: false
        });
    }
});
if (!$9cdf42a8fe772b26$var$isTouchDevice()) $9cdf42a8fe772b26$var$camera3trigger.addEventListener("mouseout", ()=>{
    const phone2 = $9cdf42a8fe772b26$var$spline.findObjectById("81a48018-18ce-48c0-bf3a-7fc79a32134a");
    phone2.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = $9cdf42a8fe772b26$var$defaultPlayerTitle;
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = $9cdf42a8fe772b26$var$defaultPlayerData;
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
$9cdf42a8fe772b26$var$camera4trigger.addEventListener("mouseover", ()=>{
    const trigger3 = $9cdf42a8fe772b26$var$spline.findObjectById("69ef9026-2c2d-4d12-960d-15bf2d35be3b");
    trigger3.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = "Apple Savings";
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = "2022";
});
$9cdf42a8fe772b26$var$camera4trigger.addEventListener("click", ()=>{
    if ($9cdf42a8fe772b26$var$isTouchDevice()) {
        // don't need to add trigger here for event, bcause hover is trigger on click on mobile
        $9cdf42a8fe772b26$var$splineContainer.classList.add("spline-player-layout-container-visible");
        document.body.classList.add("no-scroll");
        document.addEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
            passive: false
        });
    }
});
if (!$9cdf42a8fe772b26$var$isTouchDevice()) $9cdf42a8fe772b26$var$camera4trigger.addEventListener("mouseout", ()=>{
    const phone3 = $9cdf42a8fe772b26$var$spline.findObjectById("cfa2db79-49df-4bee-a563-64250d0229cc");
    phone3.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = $9cdf42a8fe772b26$var$defaultPlayerTitle;
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = $9cdf42a8fe772b26$var$defaultPlayerData;
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
$9cdf42a8fe772b26$var$camera5trigger.addEventListener("mouseover", ()=>{
    const trigger4 = $9cdf42a8fe772b26$var$spline.findObjectById("5179ac24-cdf5-4d3a-a8c0-b54ad526341a");
    trigger4.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = "Found Mobile App";
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = "Ongoing";
});
$9cdf42a8fe772b26$var$camera5trigger.addEventListener("click", ()=>{
    if ($9cdf42a8fe772b26$var$isTouchDevice()) {
        // don't need to add trigger here for event, bcause hover is trigger on click on mobile
        $9cdf42a8fe772b26$var$splineContainer.classList.add("spline-player-layout-container-visible");
        document.body.classList.add("no-scroll");
        document.addEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
            passive: false
        });
    }
});
if (!$9cdf42a8fe772b26$var$isTouchDevice()) $9cdf42a8fe772b26$var$camera5trigger.addEventListener("mouseout", ()=>{
    const phone4 = $9cdf42a8fe772b26$var$spline.findObjectById("1797ff21-d009-4839-86dd-a5db4bcdad47");
    phone4.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = $9cdf42a8fe772b26$var$defaultPlayerTitle;
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = $9cdf42a8fe772b26$var$defaultPlayerData;
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
$9cdf42a8fe772b26$var$camera6trigger.addEventListener("mouseover", ()=>{
    // Right click on 'animation trigger #' object in spline and get development ID
    const trigger5 = $9cdf42a8fe772b26$var$spline.findObjectById("8f8ab77c-c43e-486b-b043-dcefa7aa95d7");
    trigger5.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = "Alma";
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = "Ongoing";
});
$9cdf42a8fe772b26$var$camera6trigger.addEventListener("click", ()=>{
    if ($9cdf42a8fe772b26$var$isTouchDevice()) {
        // don't need to add trigger here for event, because hover is trigger on click on mobile
        $9cdf42a8fe772b26$var$splineContainer.classList.add("spline-player-layout-container-visible");
        document.body.classList.add("no-scroll");
        document.addEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
            passive: false
        });
    }
});
if (!$9cdf42a8fe772b26$var$isTouchDevice()) $9cdf42a8fe772b26$var$camera6trigger.addEventListener("mouseout", ()=>{
    // Right click on 'phone #' object in spline and get development ID
    const phone5 = $9cdf42a8fe772b26$var$spline.findObjectById("ce360629-7c88-42f5-aa77-00690062299c");
    phone5.emitEvent("mouseDown");
    $9cdf42a8fe772b26$var$splinePlayerLabelTitle.textContent = $9cdf42a8fe772b26$var$defaultPlayerTitle;
    $9cdf42a8fe772b26$var$splinePlayerLabelData.textContent = $9cdf42a8fe772b26$var$defaultPlayerData;
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
$9cdf42a8fe772b26$var$iconCloseSplineViewer.addEventListener("click", ()=>{
    $9cdf42a8fe772b26$var$splineContainer.classList.remove("spline-player-layout-container-visible");
    const phone1 = $9cdf42a8fe772b26$var$spline.findObjectById("64f0f8e6-288b-42e8-9a64-42231eae56c4");
    phone1.emitEvent("mouseDown");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("touchmove", $9cdf42a8fe772b26$var$preventScrollOnBody, {
        passive: false
    });
});
function $9cdf42a8fe772b26$var$preventScrollOnBody(e) {
    e.preventDefault();
}


//# sourceMappingURL=index.cdf5dbca.js.map
